/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unicorn/template-indent */
/* eslint-disable padding-line-between-statements */
/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
/* @ts-nocheck eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: number; output: number; }
  bpchar: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  inet: { input: any; output: any; }
  interval: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  smallint: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type ChannelInfoResponse = {
  __typename?: 'ChannelInfoResponse';
  avatar: Scalars['String']['output'];
  category: Scalars['String']['output'];
  isClosed: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  totalMembers: Scalars['Int']['output'];
};

export type ChannelMemberInfo = {
  __typename?: 'ChannelMemberInfo';
  avatar: Scalars['String']['output'];
  isBlocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ChannelMembersResponse = {
  __typename?: 'ChannelMembersResponse';
  members: Array<ChannelMemberInfo>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CrateChannelResponse = {
  __typename?: 'CrateChannelResponse';
  channelId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DownloadFilePayload = {
  __typename?: 'DownloadFilePayload';
  downloadURL: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetCatApplicationDataResponse = {
  __typename?: 'GetCatApplicationDataResponse';
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetCatResultResponse = {
  __typename?: 'GetCatResultResponse';
  applicationId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InitiatePaymentPayload = {
  __typename?: 'InitiatePaymentPayload';
  options: Options;
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LeaderboardEntry = {
  __typename?: 'LeaderboardEntry';
  avatar: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type LiveQuizDomainsResponse = {
  __typename?: 'LiveQuizDomainsResponse';
  data: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  message: Scalars['String']['output'];
  role: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  blockUser: GenericResponse;
  changeRole: GenericResponse;
  createChannel: CrateChannelResponse;
  createMeeting: GenericResponse;
  createPoll: GenericResponse;
  createUser: GenericResponse;
  deleteChannel: GenericResponse;
  deleteFile: Scalars['Boolean']['output'];
  deleteFiles: Scalars['Boolean']['output'];
  deleteMessage: GenericResponse;
  /** delete data from the table: "account_emailaddress" */
  delete_account_emailaddress?: Maybe<Account_Emailaddress_Mutation_Response>;
  /** delete single row from the table: "account_emailaddress" */
  delete_account_emailaddress_by_pk?: Maybe<Account_Emailaddress>;
  /** delete data from the table: "account_emailconfirmation" */
  delete_account_emailconfirmation?: Maybe<Account_Emailconfirmation_Mutation_Response>;
  /** delete single row from the table: "account_emailconfirmation" */
  delete_account_emailconfirmation_by_pk?: Maybe<Account_Emailconfirmation>;
  /** delete data from the table: "accounts_catscores" */
  delete_accounts_catscores?: Maybe<Accounts_Catscores_Mutation_Response>;
  /** delete single row from the table: "accounts_catscores" */
  delete_accounts_catscores_by_pk?: Maybe<Accounts_Catscores>;
  /** delete data from the table: "accounts_loggedinuser" */
  delete_accounts_loggedinuser?: Maybe<Accounts_Loggedinuser_Mutation_Response>;
  /** delete single row from the table: "accounts_loggedinuser" */
  delete_accounts_loggedinuser_by_pk?: Maybe<Accounts_Loggedinuser>;
  /** delete data from the table: "activity_types" */
  delete_activity_types?: Maybe<Activity_Types_Mutation_Response>;
  /** delete single row from the table: "activity_types" */
  delete_activity_types_by_pk?: Maybe<Activity_Types>;
  /** delete data from the table: "admin_constants" */
  delete_admin_constants?: Maybe<Admin_Constants_Mutation_Response>;
  /** delete single row from the table: "admin_constants" */
  delete_admin_constants_by_pk?: Maybe<Admin_Constants>;
  /** delete data from the table: "admin_users" */
  delete_admin_users?: Maybe<Admin_Users_Mutation_Response>;
  /** delete single row from the table: "admin_users" */
  delete_admin_users_by_pk?: Maybe<Admin_Users>;
  /** delete data from the table: "advertisements" */
  delete_advertisements?: Maybe<Advertisements_Mutation_Response>;
  /** delete single row from the table: "advertisements" */
  delete_advertisements_by_pk?: Maybe<Advertisements>;
  /** delete data from the table: "andablog_entry" */
  delete_andablog_entry?: Maybe<Andablog_Entry_Mutation_Response>;
  /** delete single row from the table: "andablog_entry" */
  delete_andablog_entry_by_pk?: Maybe<Andablog_Entry>;
  /** delete data from the table: "andablog_entryimage" */
  delete_andablog_entryimage?: Maybe<Andablog_Entryimage_Mutation_Response>;
  /** delete single row from the table: "andablog_entryimage" */
  delete_andablog_entryimage_by_pk?: Maybe<Andablog_Entryimage>;
  /** delete data from the table: "andablog_news" */
  delete_andablog_news?: Maybe<Andablog_News_Mutation_Response>;
  /** delete single row from the table: "andablog_news" */
  delete_andablog_news_by_pk?: Maybe<Andablog_News>;
  /** delete data from the table: "andablog_pov" */
  delete_andablog_pov?: Maybe<Andablog_Pov_Mutation_Response>;
  /** delete single row from the table: "andablog_pov" */
  delete_andablog_pov_by_pk?: Maybe<Andablog_Pov>;
  /** delete data from the table: "andablog_userlessontrackrecord" */
  delete_andablog_userlessontrackrecord?: Maybe<Andablog_Userlessontrackrecord_Mutation_Response>;
  /** delete data from the table: "andablog_userlessontrackrecord_bookmarked_topics" */
  delete_andablog_userlessontrackrecord_bookmarked_topics?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Mutation_Response>;
  /** delete single row from the table: "andablog_userlessontrackrecord_bookmarked_topics" */
  delete_andablog_userlessontrackrecord_bookmarked_topics_by_pk?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** delete single row from the table: "andablog_userlessontrackrecord" */
  delete_andablog_userlessontrackrecord_by_pk?: Maybe<Andablog_Userlessontrackrecord>;
  /** delete data from the table: "andablog_userlessontrackrecord_which_topics" */
  delete_andablog_userlessontrackrecord_which_topics?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Mutation_Response>;
  /** delete single row from the table: "andablog_userlessontrackrecord_which_topics" */
  delete_andablog_userlessontrackrecord_which_topics_by_pk?: Maybe<Andablog_Userlessontrackrecord_Which_Topics>;
  /** delete data from the table: "andablog_video" */
  delete_andablog_video?: Maybe<Andablog_Video_Mutation_Response>;
  /** delete single row from the table: "andablog_video" */
  delete_andablog_video_by_pk?: Maybe<Andablog_Video>;
  /** delete data from the table: "auth.email_verifications" */
  delete_auth_email_verifications?: Maybe<Auth_Email_Verifications_Mutation_Response>;
  /** delete single row from the table: "auth.email_verifications" */
  delete_auth_email_verifications_by_pk?: Maybe<Auth_Email_Verifications>;
  /** delete data from the table: "auth_group" */
  delete_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** delete single row from the table: "auth_group" */
  delete_auth_group_by_pk?: Maybe<Auth_Group>;
  /** delete data from the table: "auth_group_permissions" */
  delete_auth_group_permissions?: Maybe<Auth_Group_Permissions_Mutation_Response>;
  /** delete single row from the table: "auth_group_permissions" */
  delete_auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** delete data from the table: "auth.password_reset_tokens" */
  delete_auth_password_reset_tokens?: Maybe<Auth_Password_Reset_Tokens_Mutation_Response>;
  /** delete single row from the table: "auth.password_reset_tokens" */
  delete_auth_password_reset_tokens_by_pk?: Maybe<Auth_Password_Reset_Tokens>;
  /** delete data from the table: "auth_permission" */
  delete_auth_permission?: Maybe<Auth_Permission_Mutation_Response>;
  /** delete single row from the table: "auth_permission" */
  delete_auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** delete data from the table: "auth.session" */
  delete_auth_session?: Maybe<Auth_Session_Mutation_Response>;
  /** delete single row from the table: "auth.session" */
  delete_auth_session_by_pk?: Maybe<Auth_Session>;
  /** delete data from the table: "bookmarked_learn_topics" */
  delete_bookmarked_learn_topics?: Maybe<Bookmarked_Learn_Topics_Mutation_Response>;
  /** delete single row from the table: "bookmarked_learn_topics" */
  delete_bookmarked_learn_topics_by_pk?: Maybe<Bookmarked_Learn_Topics>;
  /** delete data from the table: "cat_percentile_constant" */
  delete_cat_percentile_constant?: Maybe<Cat_Percentile_Constant_Mutation_Response>;
  /** delete single row from the table: "cat_percentile_constant" */
  delete_cat_percentile_constant_by_pk?: Maybe<Cat_Percentile_Constant>;
  /** delete data from the table: "cat_scores" */
  delete_cat_scores?: Maybe<Cat_Scores_Mutation_Response>;
  /** delete single row from the table: "cat_scores" */
  delete_cat_scores_by_pk?: Maybe<Cat_Scores>;
  /** delete data from the table: "channel_members" */
  delete_channel_members?: Maybe<Channel_Members_Mutation_Response>;
  /** delete single row from the table: "channel_members" */
  delete_channel_members_by_pk?: Maybe<Channel_Members>;
  /** delete data from the table: "channels" */
  delete_channels?: Maybe<Channels_Mutation_Response>;
  /** delete single row from the table: "channels" */
  delete_channels_by_pk?: Maybe<Channels>;
  /** delete data from the table: "coupons_allowed_users_rule_users" */
  delete_coupons_allowed_users_rule_users?: Maybe<Coupons_Allowed_Users_Rule_Users_Mutation_Response>;
  /** delete single row from the table: "coupons_allowed_users_rule_users" */
  delete_coupons_allowed_users_rule_users_by_pk?: Maybe<Coupons_Allowed_Users_Rule_Users>;
  /** delete data from the table: "coupons_allowedusersrule" */
  delete_coupons_allowedusersrule?: Maybe<Coupons_Allowedusersrule_Mutation_Response>;
  /** delete single row from the table: "coupons_allowedusersrule" */
  delete_coupons_allowedusersrule_by_pk?: Maybe<Coupons_Allowedusersrule>;
  /** delete data from the table: "coupons_allowedusersrule_users" */
  delete_coupons_allowedusersrule_users?: Maybe<Coupons_Allowedusersrule_Users_Mutation_Response>;
  /** delete single row from the table: "coupons_allowedusersrule_users" */
  delete_coupons_allowedusersrule_users_by_pk?: Maybe<Coupons_Allowedusersrule_Users>;
  /** delete data from the table: "coupons_coupon" */
  delete_coupons_coupon?: Maybe<Coupons_Coupon_Mutation_Response>;
  /** delete data from the table: "coupons_coupon_applicable_packages" */
  delete_coupons_coupon_applicable_packages?: Maybe<Coupons_Coupon_Applicable_Packages_Mutation_Response>;
  /** delete single row from the table: "coupons_coupon_applicable_packages" */
  delete_coupons_coupon_applicable_packages_by_pk?: Maybe<Coupons_Coupon_Applicable_Packages>;
  /** delete single row from the table: "coupons_coupon" */
  delete_coupons_coupon_by_pk?: Maybe<Coupons_Coupon>;
  /** delete data from the table: "coupons_couponuser" */
  delete_coupons_couponuser?: Maybe<Coupons_Couponuser_Mutation_Response>;
  /** delete single row from the table: "coupons_couponuser" */
  delete_coupons_couponuser_by_pk?: Maybe<Coupons_Couponuser>;
  /** delete data from the table: "coupons_discount" */
  delete_coupons_discount?: Maybe<Coupons_Discount_Mutation_Response>;
  /** delete single row from the table: "coupons_discount" */
  delete_coupons_discount_by_pk?: Maybe<Coupons_Discount>;
  /** delete data from the table: "coupons_maxusesrule" */
  delete_coupons_maxusesrule?: Maybe<Coupons_Maxusesrule_Mutation_Response>;
  /** delete single row from the table: "coupons_maxusesrule" */
  delete_coupons_maxusesrule_by_pk?: Maybe<Coupons_Maxusesrule>;
  /** delete data from the table: "coupons_ruleset" */
  delete_coupons_ruleset?: Maybe<Coupons_Ruleset_Mutation_Response>;
  /** delete single row from the table: "coupons_ruleset" */
  delete_coupons_ruleset_by_pk?: Maybe<Coupons_Ruleset>;
  /** delete data from the table: "coupons_validityrule" */
  delete_coupons_validityrule?: Maybe<Coupons_Validityrule_Mutation_Response>;
  /** delete single row from the table: "coupons_validityrule" */
  delete_coupons_validityrule_by_pk?: Maybe<Coupons_Validityrule>;
  /** delete data from the table: "django_admin_log" */
  delete_django_admin_log?: Maybe<Django_Admin_Log_Mutation_Response>;
  /** delete single row from the table: "django_admin_log" */
  delete_django_admin_log_by_pk?: Maybe<Django_Admin_Log>;
  /** delete data from the table: "django_content_type" */
  delete_django_content_type?: Maybe<Django_Content_Type_Mutation_Response>;
  /** delete single row from the table: "django_content_type" */
  delete_django_content_type_by_pk?: Maybe<Django_Content_Type>;
  /** delete data from the table: "django_migrations" */
  delete_django_migrations?: Maybe<Django_Migrations_Mutation_Response>;
  /** delete single row from the table: "django_migrations" */
  delete_django_migrations_by_pk?: Maybe<Django_Migrations>;
  /** delete data from the table: "django_session" */
  delete_django_session?: Maybe<Django_Session_Mutation_Response>;
  /** delete single row from the table: "django_session" */
  delete_django_session_by_pk?: Maybe<Django_Session>;
  /** delete data from the table: "django_site" */
  delete_django_site?: Maybe<Django_Site_Mutation_Response>;
  /** delete single row from the table: "django_site" */
  delete_django_site_by_pk?: Maybe<Django_Site>;
  /** delete data from the table: "djconfig_config" */
  delete_djconfig_config?: Maybe<Djconfig_Config_Mutation_Response>;
  /** delete single row from the table: "djconfig_config" */
  delete_djconfig_config_by_pk?: Maybe<Djconfig_Config>;
  /** delete data from the table: "group_category" */
  delete_group_category?: Maybe<Group_Category_Mutation_Response>;
  /** delete single row from the table: "group_category" */
  delete_group_category_by_pk?: Maybe<Group_Category>;
  /** delete data from the table: "group_discount_users" */
  delete_group_discount_users?: Maybe<Group_Discount_Users_Mutation_Response>;
  /** delete data from the table: "has_access" */
  delete_has_access?: Maybe<Has_Access_Mutation_Response>;
  /** delete data from the table: "infozone_category" */
  delete_infozone_category?: Maybe<Infozone_Category_Mutation_Response>;
  /** delete single row from the table: "infozone_category" */
  delete_infozone_category_by_pk?: Maybe<Infozone_Category>;
  /** delete data from the table: "infozone_infozone" */
  delete_infozone_infozone?: Maybe<Infozone_Infozone_Mutation_Response>;
  /** delete single row from the table: "infozone_infozone" */
  delete_infozone_infozone_by_pk?: Maybe<Infozone_Infozone>;
  /** delete data from the table: "infozone_staticpages" */
  delete_infozone_staticpages?: Maybe<Infozone_Staticpages_Mutation_Response>;
  /** delete single row from the table: "infozone_staticpages" */
  delete_infozone_staticpages_by_pk?: Maybe<Infozone_Staticpages>;
  /** delete data from the table: "live_quiz_leaderboard" */
  delete_live_quiz_leaderboard?: Maybe<Live_Quiz_Leaderboard_Mutation_Response>;
  /** delete single row from the table: "live_quiz_leaderboard" */
  delete_live_quiz_leaderboard_by_pk?: Maybe<Live_Quiz_Leaderboard>;
  /** delete data from the table: "live_quiz_question_positions" */
  delete_live_quiz_question_positions?: Maybe<Live_Quiz_Question_Positions_Mutation_Response>;
  /** delete single row from the table: "live_quiz_question_positions" */
  delete_live_quiz_question_positions_by_pk?: Maybe<Live_Quiz_Question_Positions>;
  /** delete data from the table: "live_quiz_question_summary" */
  delete_live_quiz_question_summary?: Maybe<Live_Quiz_Question_Summary_Mutation_Response>;
  /** delete single row from the table: "live_quiz_question_summary" */
  delete_live_quiz_question_summary_by_pk?: Maybe<Live_Quiz_Question_Summary>;
  /** delete data from the table: "live_quiz_summary" */
  delete_live_quiz_summary?: Maybe<Live_Quiz_Summary_Mutation_Response>;
  /** delete single row from the table: "live_quiz_summary" */
  delete_live_quiz_summary_by_pk?: Maybe<Live_Quiz_Summary>;
  /** delete data from the table: "marks_vs_percentile_dilr" */
  delete_marks_vs_percentile_dilr?: Maybe<Marks_Vs_Percentile_Dilr_Mutation_Response>;
  /** delete single row from the table: "marks_vs_percentile_dilr" */
  delete_marks_vs_percentile_dilr_by_pk?: Maybe<Marks_Vs_Percentile_Dilr>;
  /** delete data from the table: "marks_vs_percentile_quant" */
  delete_marks_vs_percentile_quant?: Maybe<Marks_Vs_Percentile_Quant_Mutation_Response>;
  /** delete single row from the table: "marks_vs_percentile_quant" */
  delete_marks_vs_percentile_quant_by_pk?: Maybe<Marks_Vs_Percentile_Quant>;
  /** delete data from the table: "marks_vs_percentile_total_raw" */
  delete_marks_vs_percentile_total_raw?: Maybe<Marks_Vs_Percentile_Total_Raw_Mutation_Response>;
  /** delete single row from the table: "marks_vs_percentile_total_raw" */
  delete_marks_vs_percentile_total_raw_by_pk?: Maybe<Marks_Vs_Percentile_Total_Raw>;
  /** delete data from the table: "marks_vs_percentile_varc" */
  delete_marks_vs_percentile_varc?: Maybe<Marks_Vs_Percentile_Varc_Mutation_Response>;
  /** delete single row from the table: "marks_vs_percentile_varc" */
  delete_marks_vs_percentile_varc_by_pk?: Maybe<Marks_Vs_Percentile_Varc>;
  /** delete data from the table: "marks_vs_scaled_percentile" */
  delete_marks_vs_scaled_percentile?: Maybe<Marks_Vs_Scaled_Percentile_Mutation_Response>;
  /** delete single row from the table: "marks_vs_scaled_percentile" */
  delete_marks_vs_scaled_percentile_by_pk?: Maybe<Marks_Vs_Scaled_Percentile>;
  /** delete data from the table: "meeting_members" */
  delete_meeting_members?: Maybe<Meeting_Members_Mutation_Response>;
  /** delete single row from the table: "meeting_members" */
  delete_meeting_members_by_pk?: Maybe<Meeting_Members>;
  /** delete data from the table: "meetings" */
  delete_meetings?: Maybe<Meetings_Mutation_Response>;
  /** delete single row from the table: "meetings" */
  delete_meetings_by_pk?: Maybe<Meetings>;
  /** delete data from the table: "message_reactions" */
  delete_message_reactions?: Maybe<Message_Reactions_Mutation_Response>;
  /** delete single row from the table: "message_reactions" */
  delete_message_reactions_by_pk?: Maybe<Message_Reactions>;
  /** delete data from the table: "messages" */
  delete_messages?: Maybe<Messages_Mutation_Response>;
  /** delete single row from the table: "messages" */
  delete_messages_by_pk?: Maybe<Messages>;
  /** delete data from the table: "messages_read" */
  delete_messages_read?: Maybe<Messages_Read_Mutation_Response>;
  /** delete single row from the table: "messages_read" */
  delete_messages_read_by_pk?: Maybe<Messages_Read>;
  /** delete data from the table: "offline_leads" */
  delete_offline_leads?: Maybe<Offline_Leads_Mutation_Response>;
  /** delete single row from the table: "offline_leads" */
  delete_offline_leads_by_pk?: Maybe<Offline_Leads>;
  /** delete data from the table: "package_content_discarded_quizzes" */
  delete_package_content_discarded_quizzes?: Maybe<Package_Content_Discarded_Quizzes_Mutation_Response>;
  /** delete single row from the table: "package_content_discarded_quizzes" */
  delete_package_content_discarded_quizzes_by_pk?: Maybe<Package_Content_Discarded_Quizzes>;
  /** delete data from the table: "packages_content" */
  delete_packages_content?: Maybe<Packages_Content_Mutation_Response>;
  /** delete single row from the table: "packages_content" */
  delete_packages_content_by_pk?: Maybe<Packages_Content>;
  /** delete data from the table: "packages_content_domains" */
  delete_packages_content_domains?: Maybe<Packages_Content_Domains_Mutation_Response>;
  /** delete single row from the table: "packages_content_domains" */
  delete_packages_content_domains_by_pk?: Maybe<Packages_Content_Domains>;
  /** delete data from the table: "packages_content_text_lesson" */
  delete_packages_content_text_lesson?: Maybe<Packages_Content_Text_Lesson_Mutation_Response>;
  /** delete single row from the table: "packages_content_text_lesson" */
  delete_packages_content_text_lesson_by_pk?: Maybe<Packages_Content_Text_Lesson>;
  /** delete data from the table: "packages_content_timed_test" */
  delete_packages_content_timed_test?: Maybe<Packages_Content_Timed_Test_Mutation_Response>;
  /** delete single row from the table: "packages_content_timed_test" */
  delete_packages_content_timed_test_by_pk?: Maybe<Packages_Content_Timed_Test>;
  /** delete data from the table: "packages_content_untimed_test" */
  delete_packages_content_untimed_test?: Maybe<Packages_Content_Untimed_Test_Mutation_Response>;
  /** delete single row from the table: "packages_content_untimed_test" */
  delete_packages_content_untimed_test_by_pk?: Maybe<Packages_Content_Untimed_Test>;
  /** delete data from the table: "packages_payment_transaction" */
  delete_packages_payment_transaction?: Maybe<Packages_Payment_Transaction_Mutation_Response>;
  /** delete single row from the table: "packages_payment_transaction" */
  delete_packages_payment_transaction_by_pk?: Maybe<Packages_Payment_Transaction>;
  /** delete data from the table: "packages_paymenttransaction" */
  delete_packages_paymenttransaction?: Maybe<Packages_Paymenttransaction_Mutation_Response>;
  /** delete single row from the table: "packages_paymenttransaction" */
  delete_packages_paymenttransaction_by_pk?: Maybe<Packages_Paymenttransaction>;
  /** delete data from the table: "poll" */
  delete_poll?: Maybe<Poll_Mutation_Response>;
  /** delete single row from the table: "poll" */
  delete_poll_by_pk?: Maybe<Poll>;
  /** delete data from the table: "poll_options" */
  delete_poll_options?: Maybe<Poll_Options_Mutation_Response>;
  /** delete single row from the table: "poll_options" */
  delete_poll_options_by_pk?: Maybe<Poll_Options>;
  /** delete data from the table: "poll_responses" */
  delete_poll_responses?: Maybe<Poll_Responses_Mutation_Response>;
  /** delete single row from the table: "poll_responses" */
  delete_poll_responses_by_pk?: Maybe<Poll_Responses>;
  /** delete data from the table: "question_reports" */
  delete_question_reports?: Maybe<Question_Reports_Mutation_Response>;
  /** delete single row from the table: "question_reports" */
  delete_question_reports_by_pk?: Maybe<Question_Reports>;
  /** delete data from the table: "quiz_answer" */
  delete_quiz_answer?: Maybe<Quiz_Answer_Mutation_Response>;
  /** delete single row from the table: "quiz_answer" */
  delete_quiz_answer_by_pk?: Maybe<Quiz_Answer>;
  /** delete data from the table: "quiz_category" */
  delete_quiz_category?: Maybe<Quiz_Category_Mutation_Response>;
  /** delete single row from the table: "quiz_category" */
  delete_quiz_category_by_pk?: Maybe<Quiz_Category>;
  /** delete data from the table: "quiz_domain" */
  delete_quiz_domain?: Maybe<Quiz_Domain_Mutation_Response>;
  /** delete single row from the table: "quiz_domain" */
  delete_quiz_domain_by_pk?: Maybe<Quiz_Domain>;
  /** delete data from the table: "quiz_markingsystem" */
  delete_quiz_markingsystem?: Maybe<Quiz_Markingsystem_Mutation_Response>;
  /** delete single row from the table: "quiz_markingsystem" */
  delete_quiz_markingsystem_by_pk?: Maybe<Quiz_Markingsystem>;
  /** delete data from the table: "quiz_option" */
  delete_quiz_option?: Maybe<Quiz_Option_Mutation_Response>;
  /** delete single row from the table: "quiz_option" */
  delete_quiz_option_by_pk?: Maybe<Quiz_Option>;
  /** delete data from the table: "quiz_paragraph" */
  delete_quiz_paragraph?: Maybe<Quiz_Paragraph_Mutation_Response>;
  /** delete single row from the table: "quiz_paragraph" */
  delete_quiz_paragraph_by_pk?: Maybe<Quiz_Paragraph>;
  /** delete data from the table: "quiz_question" */
  delete_quiz_question?: Maybe<Quiz_Question_Mutation_Response>;
  /** delete single row from the table: "quiz_question" */
  delete_quiz_question_by_pk?: Maybe<Quiz_Question>;
  /** delete data from the table: "quiz_quiz" */
  delete_quiz_quiz?: Maybe<Quiz_Quiz_Mutation_Response>;
  /** delete single row from the table: "quiz_quiz" */
  delete_quiz_quiz_by_pk?: Maybe<Quiz_Quiz>;
  /** delete data from the table: "quiz_quiz_questions" */
  delete_quiz_quiz_questions?: Maybe<Quiz_Quiz_Questions_Mutation_Response>;
  /** delete single row from the table: "quiz_quiz_questions" */
  delete_quiz_quiz_questions_by_pk?: Maybe<Quiz_Quiz_Questions>;
  /** delete data from the table: "quiz_quiz_sections" */
  delete_quiz_quiz_sections?: Maybe<Quiz_Quiz_Sections_Mutation_Response>;
  /** delete single row from the table: "quiz_quiz_sections" */
  delete_quiz_quiz_sections_by_pk?: Maybe<Quiz_Quiz_Sections>;
  /** delete data from the table: "quiz_section" */
  delete_quiz_section?: Maybe<Quiz_Section_Mutation_Response>;
  /** delete single row from the table: "quiz_section" */
  delete_quiz_section_by_pk?: Maybe<Quiz_Section>;
  /** delete data from the table: "quiz_section_questions" */
  delete_quiz_section_questions?: Maybe<Quiz_Section_Questions_Mutation_Response>;
  /** delete single row from the table: "quiz_section_questions" */
  delete_quiz_section_questions_by_pk?: Maybe<Quiz_Section_Questions>;
  /** delete data from the table: "quiz_section_subsections" */
  delete_quiz_section_subsections?: Maybe<Quiz_Section_Subsections_Mutation_Response>;
  /** delete single row from the table: "quiz_section_subsections" */
  delete_quiz_section_subsections_by_pk?: Maybe<Quiz_Section_Subsections>;
  /** delete data from the table: "quiz_superdomain" */
  delete_quiz_superdomain?: Maybe<Quiz_Superdomain_Mutation_Response>;
  /** delete single row from the table: "quiz_superdomain" */
  delete_quiz_superdomain_by_pk?: Maybe<Quiz_Superdomain>;
  /** delete data from the table: "random_question_ids" */
  delete_random_question_ids?: Maybe<Random_Question_Ids_Mutation_Response>;
  /** delete data from the table: "reaction_emojis" */
  delete_reaction_emojis?: Maybe<Reaction_Emojis_Mutation_Response>;
  /** delete single row from the table: "reaction_emojis" */
  delete_reaction_emojis_by_pk?: Maybe<Reaction_Emojis>;
  /** delete data from the table: "reported_message" */
  delete_reported_message?: Maybe<Reported_Message_Mutation_Response>;
  /** delete single row from the table: "reported_message" */
  delete_reported_message_by_pk?: Maybe<Reported_Message>;
  /** delete data from the table: "scaling_constant" */
  delete_scaling_constant?: Maybe<Scaling_Constant_Mutation_Response>;
  /** delete single row from the table: "scaling_constant" */
  delete_scaling_constant_by_pk?: Maybe<Scaling_Constant>;
  /** delete data from the table: "socialaccount_socialaccount" */
  delete_socialaccount_socialaccount?: Maybe<Socialaccount_Socialaccount_Mutation_Response>;
  /** delete single row from the table: "socialaccount_socialaccount" */
  delete_socialaccount_socialaccount_by_pk?: Maybe<Socialaccount_Socialaccount>;
  /** delete data from the table: "socialaccount_socialapp" */
  delete_socialaccount_socialapp?: Maybe<Socialaccount_Socialapp_Mutation_Response>;
  /** delete single row from the table: "socialaccount_socialapp" */
  delete_socialaccount_socialapp_by_pk?: Maybe<Socialaccount_Socialapp>;
  /** delete data from the table: "socialaccount_socialapp_sites" */
  delete_socialaccount_socialapp_sites?: Maybe<Socialaccount_Socialapp_Sites_Mutation_Response>;
  /** delete single row from the table: "socialaccount_socialapp_sites" */
  delete_socialaccount_socialapp_sites_by_pk?: Maybe<Socialaccount_Socialapp_Sites>;
  /** delete data from the table: "socialaccount_socialtoken" */
  delete_socialaccount_socialtoken?: Maybe<Socialaccount_Socialtoken_Mutation_Response>;
  /** delete single row from the table: "socialaccount_socialtoken" */
  delete_socialaccount_socialtoken_by_pk?: Maybe<Socialaccount_Socialtoken>;
  /** delete data from the table: "speed_test_category" */
  delete_speed_test_category?: Maybe<Speed_Test_Category_Mutation_Response>;
  /** delete single row from the table: "speed_test_category" */
  delete_speed_test_category_by_pk?: Maybe<Speed_Test_Category>;
  /** delete data from the table: "speed_tests" */
  delete_speed_tests?: Maybe<Speed_Tests_Mutation_Response>;
  /** delete single row from the table: "speed_tests" */
  delete_speed_tests_by_pk?: Maybe<Speed_Tests>;
  /** delete data from the table: "spirit_cache" */
  delete_spirit_cache?: Maybe<Spirit_Cache_Mutation_Response>;
  /** delete single row from the table: "spirit_cache" */
  delete_spirit_cache_by_pk?: Maybe<Spirit_Cache>;
  /** delete data from the table: "spirit_category_category" */
  delete_spirit_category_category?: Maybe<Spirit_Category_Category_Mutation_Response>;
  /** delete single row from the table: "spirit_category_category" */
  delete_spirit_category_category_by_pk?: Maybe<Spirit_Category_Category>;
  /** delete data from the table: "spirit_comment_bookmark_commentbookmark" */
  delete_spirit_comment_bookmark_commentbookmark?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Mutation_Response>;
  /** delete single row from the table: "spirit_comment_bookmark_commentbookmark" */
  delete_spirit_comment_bookmark_commentbookmark_by_pk?: Maybe<Spirit_Comment_Bookmark_Commentbookmark>;
  /** delete data from the table: "spirit_comment_comment" */
  delete_spirit_comment_comment?: Maybe<Spirit_Comment_Comment_Mutation_Response>;
  /** delete single row from the table: "spirit_comment_comment" */
  delete_spirit_comment_comment_by_pk?: Maybe<Spirit_Comment_Comment>;
  /** delete data from the table: "spirit_comment_flag_commentflag" */
  delete_spirit_comment_flag_commentflag?: Maybe<Spirit_Comment_Flag_Commentflag_Mutation_Response>;
  /** delete single row from the table: "spirit_comment_flag_commentflag" */
  delete_spirit_comment_flag_commentflag_by_pk?: Maybe<Spirit_Comment_Flag_Commentflag>;
  /** delete data from the table: "spirit_comment_flag_flag" */
  delete_spirit_comment_flag_flag?: Maybe<Spirit_Comment_Flag_Flag_Mutation_Response>;
  /** delete single row from the table: "spirit_comment_flag_flag" */
  delete_spirit_comment_flag_flag_by_pk?: Maybe<Spirit_Comment_Flag_Flag>;
  /** delete data from the table: "spirit_comment_history_commenthistory" */
  delete_spirit_comment_history_commenthistory?: Maybe<Spirit_Comment_History_Commenthistory_Mutation_Response>;
  /** delete single row from the table: "spirit_comment_history_commenthistory" */
  delete_spirit_comment_history_commenthistory_by_pk?: Maybe<Spirit_Comment_History_Commenthistory>;
  /** delete data from the table: "spirit_comment_like_commentlike" */
  delete_spirit_comment_like_commentlike?: Maybe<Spirit_Comment_Like_Commentlike_Mutation_Response>;
  /** delete single row from the table: "spirit_comment_like_commentlike" */
  delete_spirit_comment_like_commentlike_by_pk?: Maybe<Spirit_Comment_Like_Commentlike>;
  /** delete data from the table: "spirit_comment_poll_commentpoll" */
  delete_spirit_comment_poll_commentpoll?: Maybe<Spirit_Comment_Poll_Commentpoll_Mutation_Response>;
  /** delete single row from the table: "spirit_comment_poll_commentpoll" */
  delete_spirit_comment_poll_commentpoll_by_pk?: Maybe<Spirit_Comment_Poll_Commentpoll>;
  /** delete data from the table: "spirit_comment_poll_commentpollchoice" */
  delete_spirit_comment_poll_commentpollchoice?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Mutation_Response>;
  /** delete single row from the table: "spirit_comment_poll_commentpollchoice" */
  delete_spirit_comment_poll_commentpollchoice_by_pk?: Maybe<Spirit_Comment_Poll_Commentpollchoice>;
  /** delete data from the table: "spirit_comment_poll_commentpollvote" */
  delete_spirit_comment_poll_commentpollvote?: Maybe<Spirit_Comment_Poll_Commentpollvote_Mutation_Response>;
  /** delete single row from the table: "spirit_comment_poll_commentpollvote" */
  delete_spirit_comment_poll_commentpollvote_by_pk?: Maybe<Spirit_Comment_Poll_Commentpollvote>;
  /** delete data from the table: "spirit_rl_cache" */
  delete_spirit_rl_cache?: Maybe<Spirit_Rl_Cache_Mutation_Response>;
  /** delete single row from the table: "spirit_rl_cache" */
  delete_spirit_rl_cache_by_pk?: Maybe<Spirit_Rl_Cache>;
  /** delete data from the table: "spirit_topic_favorite_topicfavorite" */
  delete_spirit_topic_favorite_topicfavorite?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Mutation_Response>;
  /** delete single row from the table: "spirit_topic_favorite_topicfavorite" */
  delete_spirit_topic_favorite_topicfavorite_by_pk?: Maybe<Spirit_Topic_Favorite_Topicfavorite>;
  /** delete data from the table: "spirit_topic_notification_topicnotification" */
  delete_spirit_topic_notification_topicnotification?: Maybe<Spirit_Topic_Notification_Topicnotification_Mutation_Response>;
  /** delete single row from the table: "spirit_topic_notification_topicnotification" */
  delete_spirit_topic_notification_topicnotification_by_pk?: Maybe<Spirit_Topic_Notification_Topicnotification>;
  /** delete data from the table: "spirit_topic_private_topicprivate" */
  delete_spirit_topic_private_topicprivate?: Maybe<Spirit_Topic_Private_Topicprivate_Mutation_Response>;
  /** delete single row from the table: "spirit_topic_private_topicprivate" */
  delete_spirit_topic_private_topicprivate_by_pk?: Maybe<Spirit_Topic_Private_Topicprivate>;
  /** delete data from the table: "spirit_topic_topic" */
  delete_spirit_topic_topic?: Maybe<Spirit_Topic_Topic_Mutation_Response>;
  /** delete single row from the table: "spirit_topic_topic" */
  delete_spirit_topic_topic_by_pk?: Maybe<Spirit_Topic_Topic>;
  /** delete data from the table: "spirit_topic_unread_topicunread" */
  delete_spirit_topic_unread_topicunread?: Maybe<Spirit_Topic_Unread_Topicunread_Mutation_Response>;
  /** delete single row from the table: "spirit_topic_unread_topicunread" */
  delete_spirit_topic_unread_topicunread_by_pk?: Maybe<Spirit_Topic_Unread_Topicunread>;
  /** delete data from the table: "spirit_user_userprofile" */
  delete_spirit_user_userprofile?: Maybe<Spirit_User_Userprofile_Mutation_Response>;
  /** delete single row from the table: "spirit_user_userprofile" */
  delete_spirit_user_userprofile_by_pk?: Maybe<Spirit_User_Userprofile>;
  /** delete data from the table: "subscription_group_plan" */
  delete_subscription_group_plan?: Maybe<Subscription_Group_Plan_Mutation_Response>;
  /** delete single row from the table: "subscription_group_plan" */
  delete_subscription_group_plan_by_pk?: Maybe<Subscription_Group_Plan>;
  /** delete data from the table: "subscription_group_plan_groups" */
  delete_subscription_group_plan_groups?: Maybe<Subscription_Group_Plan_Groups_Mutation_Response>;
  /** delete single row from the table: "subscription_group_plan_groups" */
  delete_subscription_group_plan_groups_by_pk?: Maybe<Subscription_Group_Plan_Groups>;
  /** delete data from the table: "subscriptions_plancost" */
  delete_subscriptions_plancost?: Maybe<Subscriptions_Plancost_Mutation_Response>;
  /** delete single row from the table: "subscriptions_plancost" */
  delete_subscriptions_plancost_by_pk?: Maybe<Subscriptions_Plancost>;
  /** delete data from the table: "subscriptions_planlist" */
  delete_subscriptions_planlist?: Maybe<Subscriptions_Planlist_Mutation_Response>;
  /** delete single row from the table: "subscriptions_planlist" */
  delete_subscriptions_planlist_by_pk?: Maybe<Subscriptions_Planlist>;
  /** delete data from the table: "subscriptions_planlistdetail" */
  delete_subscriptions_planlistdetail?: Maybe<Subscriptions_Planlistdetail_Mutation_Response>;
  /** delete single row from the table: "subscriptions_planlistdetail" */
  delete_subscriptions_planlistdetail_by_pk?: Maybe<Subscriptions_Planlistdetail>;
  /** delete data from the table: "subscriptions_plantag" */
  delete_subscriptions_plantag?: Maybe<Subscriptions_Plantag_Mutation_Response>;
  /** delete single row from the table: "subscriptions_plantag" */
  delete_subscriptions_plantag_by_pk?: Maybe<Subscriptions_Plantag>;
  /** delete data from the table: "subscriptions_subscriptionplan" */
  delete_subscriptions_subscriptionplan?: Maybe<Subscriptions_Subscriptionplan_Mutation_Response>;
  /** delete single row from the table: "subscriptions_subscriptionplan" */
  delete_subscriptions_subscriptionplan_by_pk?: Maybe<Subscriptions_Subscriptionplan>;
  /** delete data from the table: "subscriptions_subscriptionplan_upgradable_plans" */
  delete_subscriptions_subscriptionplan_upgradable_plans?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Mutation_Response>;
  /** delete single row from the table: "subscriptions_subscriptionplan_upgradable_plans" */
  delete_subscriptions_subscriptionplan_upgradable_plans_by_pk?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** delete data from the table: "subscriptions_subscriptiontransaction" */
  delete_subscriptions_subscriptiontransaction?: Maybe<Subscriptions_Subscriptiontransaction_Mutation_Response>;
  /** delete single row from the table: "subscriptions_subscriptiontransaction" */
  delete_subscriptions_subscriptiontransaction_by_pk?: Maybe<Subscriptions_Subscriptiontransaction>;
  /** delete data from the table: "subscriptions_usersubscription" */
  delete_subscriptions_usersubscription?: Maybe<Subscriptions_Usersubscription_Mutation_Response>;
  /** delete single row from the table: "subscriptions_usersubscription" */
  delete_subscriptions_usersubscription_by_pk?: Maybe<Subscriptions_Usersubscription>;
  /** delete data from the table: "supertokens.all_auth_recipe_users" */
  delete_supertokens_all_auth_recipe_users?: Maybe<Supertokens_All_Auth_Recipe_Users_Mutation_Response>;
  /** delete single row from the table: "supertokens.all_auth_recipe_users" */
  delete_supertokens_all_auth_recipe_users_by_pk?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  /** delete data from the table: "supertokens.app_id_to_user_id" */
  delete_supertokens_app_id_to_user_id?: Maybe<Supertokens_App_Id_To_User_Id_Mutation_Response>;
  /** delete single row from the table: "supertokens.app_id_to_user_id" */
  delete_supertokens_app_id_to_user_id_by_pk?: Maybe<Supertokens_App_Id_To_User_Id>;
  /** delete data from the table: "supertokens.apps" */
  delete_supertokens_apps?: Maybe<Supertokens_Apps_Mutation_Response>;
  /** delete single row from the table: "supertokens.apps" */
  delete_supertokens_apps_by_pk?: Maybe<Supertokens_Apps>;
  /** delete data from the table: "supertokens.dashboard_user_sessions" */
  delete_supertokens_dashboard_user_sessions?: Maybe<Supertokens_Dashboard_User_Sessions_Mutation_Response>;
  /** delete single row from the table: "supertokens.dashboard_user_sessions" */
  delete_supertokens_dashboard_user_sessions_by_pk?: Maybe<Supertokens_Dashboard_User_Sessions>;
  /** delete data from the table: "supertokens.dashboard_users" */
  delete_supertokens_dashboard_users?: Maybe<Supertokens_Dashboard_Users_Mutation_Response>;
  /** delete single row from the table: "supertokens.dashboard_users" */
  delete_supertokens_dashboard_users_by_pk?: Maybe<Supertokens_Dashboard_Users>;
  /** delete data from the table: "supertokens.emailpassword_pswd_reset_tokens" */
  delete_supertokens_emailpassword_pswd_reset_tokens?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Mutation_Response>;
  /** delete single row from the table: "supertokens.emailpassword_pswd_reset_tokens" */
  delete_supertokens_emailpassword_pswd_reset_tokens_by_pk?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
  /** delete data from the table: "supertokens.emailpassword_user_to_tenant" */
  delete_supertokens_emailpassword_user_to_tenant?: Maybe<Supertokens_Emailpassword_User_To_Tenant_Mutation_Response>;
  /** delete single row from the table: "supertokens.emailpassword_user_to_tenant" */
  delete_supertokens_emailpassword_user_to_tenant_by_pk?: Maybe<Supertokens_Emailpassword_User_To_Tenant>;
  /** delete data from the table: "supertokens.emailpassword_users" */
  delete_supertokens_emailpassword_users?: Maybe<Supertokens_Emailpassword_Users_Mutation_Response>;
  /** delete single row from the table: "supertokens.emailpassword_users" */
  delete_supertokens_emailpassword_users_by_pk?: Maybe<Supertokens_Emailpassword_Users>;
  /** delete data from the table: "supertokens.emailverification_tokens" */
  delete_supertokens_emailverification_tokens?: Maybe<Supertokens_Emailverification_Tokens_Mutation_Response>;
  /** delete single row from the table: "supertokens.emailverification_tokens" */
  delete_supertokens_emailverification_tokens_by_pk?: Maybe<Supertokens_Emailverification_Tokens>;
  /** delete data from the table: "supertokens.emailverification_verified_emails" */
  delete_supertokens_emailverification_verified_emails?: Maybe<Supertokens_Emailverification_Verified_Emails_Mutation_Response>;
  /** delete single row from the table: "supertokens.emailverification_verified_emails" */
  delete_supertokens_emailverification_verified_emails_by_pk?: Maybe<Supertokens_Emailverification_Verified_Emails>;
  /** delete data from the table: "supertokens.jwt_signing_keys" */
  delete_supertokens_jwt_signing_keys?: Maybe<Supertokens_Jwt_Signing_Keys_Mutation_Response>;
  /** delete single row from the table: "supertokens.jwt_signing_keys" */
  delete_supertokens_jwt_signing_keys_by_pk?: Maybe<Supertokens_Jwt_Signing_Keys>;
  /** delete data from the table: "supertokens.key_value" */
  delete_supertokens_key_value?: Maybe<Supertokens_Key_Value_Mutation_Response>;
  /** delete single row from the table: "supertokens.key_value" */
  delete_supertokens_key_value_by_pk?: Maybe<Supertokens_Key_Value>;
  /** delete data from the table: "supertokens.passwordless_codes" */
  delete_supertokens_passwordless_codes?: Maybe<Supertokens_Passwordless_Codes_Mutation_Response>;
  /** delete single row from the table: "supertokens.passwordless_codes" */
  delete_supertokens_passwordless_codes_by_pk?: Maybe<Supertokens_Passwordless_Codes>;
  /** delete data from the table: "supertokens.passwordless_devices" */
  delete_supertokens_passwordless_devices?: Maybe<Supertokens_Passwordless_Devices_Mutation_Response>;
  /** delete single row from the table: "supertokens.passwordless_devices" */
  delete_supertokens_passwordless_devices_by_pk?: Maybe<Supertokens_Passwordless_Devices>;
  /** delete data from the table: "supertokens.passwordless_user_to_tenant" */
  delete_supertokens_passwordless_user_to_tenant?: Maybe<Supertokens_Passwordless_User_To_Tenant_Mutation_Response>;
  /** delete single row from the table: "supertokens.passwordless_user_to_tenant" */
  delete_supertokens_passwordless_user_to_tenant_by_pk?: Maybe<Supertokens_Passwordless_User_To_Tenant>;
  /** delete data from the table: "supertokens.passwordless_users" */
  delete_supertokens_passwordless_users?: Maybe<Supertokens_Passwordless_Users_Mutation_Response>;
  /** delete single row from the table: "supertokens.passwordless_users" */
  delete_supertokens_passwordless_users_by_pk?: Maybe<Supertokens_Passwordless_Users>;
  /** delete data from the table: "supertokens.role_permissions" */
  delete_supertokens_role_permissions?: Maybe<Supertokens_Role_Permissions_Mutation_Response>;
  /** delete single row from the table: "supertokens.role_permissions" */
  delete_supertokens_role_permissions_by_pk?: Maybe<Supertokens_Role_Permissions>;
  /** delete data from the table: "supertokens.roles" */
  delete_supertokens_roles?: Maybe<Supertokens_Roles_Mutation_Response>;
  /** delete single row from the table: "supertokens.roles" */
  delete_supertokens_roles_by_pk?: Maybe<Supertokens_Roles>;
  /** delete data from the table: "supertokens.session_access_token_signing_keys" */
  delete_supertokens_session_access_token_signing_keys?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Mutation_Response>;
  /** delete single row from the table: "supertokens.session_access_token_signing_keys" */
  delete_supertokens_session_access_token_signing_keys_by_pk?: Maybe<Supertokens_Session_Access_Token_Signing_Keys>;
  /** delete data from the table: "supertokens.session_info" */
  delete_supertokens_session_info?: Maybe<Supertokens_Session_Info_Mutation_Response>;
  /** delete single row from the table: "supertokens.session_info" */
  delete_supertokens_session_info_by_pk?: Maybe<Supertokens_Session_Info>;
  /** delete data from the table: "supertokens.tenant_configs" */
  delete_supertokens_tenant_configs?: Maybe<Supertokens_Tenant_Configs_Mutation_Response>;
  /** delete single row from the table: "supertokens.tenant_configs" */
  delete_supertokens_tenant_configs_by_pk?: Maybe<Supertokens_Tenant_Configs>;
  /** delete data from the table: "supertokens.tenant_thirdparty_provider_clients" */
  delete_supertokens_tenant_thirdparty_provider_clients?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Mutation_Response>;
  /** delete single row from the table: "supertokens.tenant_thirdparty_provider_clients" */
  delete_supertokens_tenant_thirdparty_provider_clients_by_pk?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients>;
  /** delete data from the table: "supertokens.tenant_thirdparty_providers" */
  delete_supertokens_tenant_thirdparty_providers?: Maybe<Supertokens_Tenant_Thirdparty_Providers_Mutation_Response>;
  /** delete single row from the table: "supertokens.tenant_thirdparty_providers" */
  delete_supertokens_tenant_thirdparty_providers_by_pk?: Maybe<Supertokens_Tenant_Thirdparty_Providers>;
  /** delete data from the table: "supertokens.tenants" */
  delete_supertokens_tenants?: Maybe<Supertokens_Tenants_Mutation_Response>;
  /** delete single row from the table: "supertokens.tenants" */
  delete_supertokens_tenants_by_pk?: Maybe<Supertokens_Tenants>;
  /** delete data from the table: "supertokens.thirdparty_user_to_tenant" */
  delete_supertokens_thirdparty_user_to_tenant?: Maybe<Supertokens_Thirdparty_User_To_Tenant_Mutation_Response>;
  /** delete single row from the table: "supertokens.thirdparty_user_to_tenant" */
  delete_supertokens_thirdparty_user_to_tenant_by_pk?: Maybe<Supertokens_Thirdparty_User_To_Tenant>;
  /** delete data from the table: "supertokens.thirdparty_users" */
  delete_supertokens_thirdparty_users?: Maybe<Supertokens_Thirdparty_Users_Mutation_Response>;
  /** delete single row from the table: "supertokens.thirdparty_users" */
  delete_supertokens_thirdparty_users_by_pk?: Maybe<Supertokens_Thirdparty_Users>;
  /** delete data from the table: "supertokens.user_additional_fields" */
  delete_supertokens_user_additional_fields?: Maybe<Supertokens_User_Additional_Fields_Mutation_Response>;
  /** delete single row from the table: "supertokens.user_additional_fields" */
  delete_supertokens_user_additional_fields_by_pk?: Maybe<Supertokens_User_Additional_Fields>;
  /** delete data from the table: "supertokens.user_last_active" */
  delete_supertokens_user_last_active?: Maybe<Supertokens_User_Last_Active_Mutation_Response>;
  /** delete single row from the table: "supertokens.user_last_active" */
  delete_supertokens_user_last_active_by_pk?: Maybe<Supertokens_User_Last_Active>;
  /** delete data from the table: "supertokens.user_metadata" */
  delete_supertokens_user_metadata?: Maybe<Supertokens_User_Metadata_Mutation_Response>;
  /** delete single row from the table: "supertokens.user_metadata" */
  delete_supertokens_user_metadata_by_pk?: Maybe<Supertokens_User_Metadata>;
  /** delete data from the table: "supertokens.user_public_fields" */
  delete_supertokens_user_public_fields?: Maybe<Supertokens_User_Public_Fields_Mutation_Response>;
  /** delete data from the table: "supertokens.user_roles" */
  delete_supertokens_user_roles?: Maybe<Supertokens_User_Roles_Mutation_Response>;
  /** delete single row from the table: "supertokens.user_roles" */
  delete_supertokens_user_roles_by_pk?: Maybe<Supertokens_User_Roles>;
  /** delete data from the table: "supertokens.userid_mapping" */
  delete_supertokens_userid_mapping?: Maybe<Supertokens_Userid_Mapping_Mutation_Response>;
  /** delete single row from the table: "supertokens.userid_mapping" */
  delete_supertokens_userid_mapping_by_pk?: Maybe<Supertokens_Userid_Mapping>;
  /** delete data from the table: "taggit_tag" */
  delete_taggit_tag?: Maybe<Taggit_Tag_Mutation_Response>;
  /** delete single row from the table: "taggit_tag" */
  delete_taggit_tag_by_pk?: Maybe<Taggit_Tag>;
  /** delete data from the table: "taggit_taggeditem" */
  delete_taggit_taggeditem?: Maybe<Taggit_Taggeditem_Mutation_Response>;
  /** delete single row from the table: "taggit_taggeditem" */
  delete_taggit_taggeditem_by_pk?: Maybe<Taggit_Taggeditem>;
  /** delete data from the table: "upcoming_live_classes" */
  delete_upcoming_live_classes?: Maybe<Upcoming_Live_Classes_Mutation_Response>;
  /** delete single row from the table: "upcoming_live_classes" */
  delete_upcoming_live_classes_by_pk?: Maybe<Upcoming_Live_Classes>;
  /** delete data from the table: "user_activities" */
  delete_user_activities?: Maybe<User_Activities_Mutation_Response>;
  /** delete single row from the table: "user_activities" */
  delete_user_activities_by_pk?: Maybe<User_Activities>;
  /** delete data from the table: "user_activity" */
  delete_user_activity?: Maybe<User_Activity_Mutation_Response>;
  /** delete single row from the table: "user_activity" */
  delete_user_activity_by_pk?: Maybe<User_Activity>;
  /** delete data from the table: "user_activity_lesson_entries" */
  delete_user_activity_lesson_entries?: Maybe<User_Activity_Lesson_Entries_Mutation_Response>;
  /** delete single row from the table: "user_activity_lesson_entries" */
  delete_user_activity_lesson_entries_by_pk?: Maybe<User_Activity_Lesson_Entries>;
  /** delete data from the table: "user_cat_registration_data" */
  delete_user_cat_registration_data?: Maybe<User_Cat_Registration_Data_Mutation_Response>;
  /** delete single row from the table: "user_cat_registration_data" */
  delete_user_cat_registration_data_by_pk?: Maybe<User_Cat_Registration_Data>;
  /** delete data from the table: "user_cat_response_sheet_data" */
  delete_user_cat_response_sheet_data?: Maybe<User_Cat_Response_Sheet_Data_Mutation_Response>;
  /** delete single row from the table: "user_cat_response_sheet_data" */
  delete_user_cat_response_sheet_data_by_pk?: Maybe<User_Cat_Response_Sheet_Data>;
  /** delete data from the table: "user_custom_planned_activities" */
  delete_user_custom_planned_activities?: Maybe<User_Custom_Planned_Activities_Mutation_Response>;
  /** delete single row from the table: "user_custom_planned_activities" */
  delete_user_custom_planned_activities_by_pk?: Maybe<User_Custom_Planned_Activities>;
  /** delete data from the table: "user_leaderboard_types" */
  delete_user_leaderboard_types?: Maybe<User_Leaderboard_Types_Mutation_Response>;
  /** delete single row from the table: "user_leaderboard_types" */
  delete_user_leaderboard_types_by_pk?: Maybe<User_Leaderboard_Types>;
  /** delete data from the table: "user_leaderboards" */
  delete_user_leaderboards?: Maybe<User_Leaderboards_Mutation_Response>;
  /** delete single row from the table: "user_leaderboards" */
  delete_user_leaderboards_by_pk?: Maybe<User_Leaderboards>;
  /** delete data from the table: "user_learn_activities" */
  delete_user_learn_activities?: Maybe<User_Learn_Activities_Mutation_Response>;
  /** delete single row from the table: "user_learn_activities" */
  delete_user_learn_activities_by_pk?: Maybe<User_Learn_Activities>;
  /** delete data from the table: "user_learn_category_progress" */
  delete_user_learn_category_progress?: Maybe<User_Learn_Category_Progress_Mutation_Response>;
  /** delete single row from the table: "user_learn_category_progress" */
  delete_user_learn_category_progress_by_pk?: Maybe<User_Learn_Category_Progress>;
  /** delete data from the table: "user_learn_completed_topics" */
  delete_user_learn_completed_topics?: Maybe<User_Learn_Completed_Topics_Mutation_Response>;
  /** delete single row from the table: "user_learn_completed_topics" */
  delete_user_learn_completed_topics_by_pk?: Maybe<User_Learn_Completed_Topics>;
  /** delete data from the table: "user_learn_modules_summary" */
  delete_user_learn_modules_summary?: Maybe<User_Learn_Modules_Summary_Mutation_Response>;
  /** delete single row from the table: "user_learn_modules_summary" */
  delete_user_learn_modules_summary_by_pk?: Maybe<User_Learn_Modules_Summary>;
  /** delete data from the table: "user_learn_track_record" */
  delete_user_learn_track_record?: Maybe<User_Learn_Track_Record_Mutation_Response>;
  /** delete data from the table: "user_learn_track_record_bookmarked_topics" */
  delete_user_learn_track_record_bookmarked_topics?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Mutation_Response>;
  /** delete single row from the table: "user_learn_track_record_bookmarked_topics" */
  delete_user_learn_track_record_bookmarked_topics_by_pk?: Maybe<User_Learn_Track_Record_Bookmarked_Topics>;
  /** delete single row from the table: "user_learn_track_record" */
  delete_user_learn_track_record_by_pk?: Maybe<User_Learn_Track_Record>;
  /** delete data from the table: "user_learn_track_record_which_topics" */
  delete_user_learn_track_record_which_topics?: Maybe<User_Learn_Track_Record_Which_Topics_Mutation_Response>;
  /** delete single row from the table: "user_learn_track_record_which_topics" */
  delete_user_learn_track_record_which_topics_by_pk?: Maybe<User_Learn_Track_Record_Which_Topics>;
  /** delete data from the table: "user_planned_activities" */
  delete_user_planned_activities?: Maybe<User_Planned_Activities_Mutation_Response>;
  /** delete single row from the table: "user_planned_activities" */
  delete_user_planned_activities_by_pk?: Maybe<User_Planned_Activities>;
  /** delete data from the table: "user_pov_summaries" */
  delete_user_pov_summaries?: Maybe<User_Pov_Summaries_Mutation_Response>;
  /** delete single row from the table: "user_pov_summaries" */
  delete_user_pov_summaries_by_pk?: Maybe<User_Pov_Summaries>;
  /** delete data from the table: "user_quiz_question_attempts" */
  delete_user_quiz_question_attempts?: Maybe<User_Quiz_Question_Attempts_Mutation_Response>;
  /** delete single row from the table: "user_quiz_question_attempts" */
  delete_user_quiz_question_attempts_by_pk?: Maybe<User_Quiz_Question_Attempts>;
  /** delete data from the table: "user_quiz_question_positions" */
  delete_user_quiz_question_positions?: Maybe<User_Quiz_Question_Positions_Mutation_Response>;
  /** delete single row from the table: "user_quiz_question_positions" */
  delete_user_quiz_question_positions_by_pk?: Maybe<User_Quiz_Question_Positions>;
  /** delete data from the table: "user_quiz_question_summaries" */
  delete_user_quiz_question_summaries?: Maybe<User_Quiz_Question_Summaries_Mutation_Response>;
  /** delete single row from the table: "user_quiz_question_summaries" */
  delete_user_quiz_question_summaries_by_pk?: Maybe<User_Quiz_Question_Summaries>;
  /** delete data from the table: "user_quiz_question_summaries_old" */
  delete_user_quiz_question_summaries_old?: Maybe<User_Quiz_Question_Summaries_Old_Mutation_Response>;
  /** delete single row from the table: "user_quiz_question_summaries_old" */
  delete_user_quiz_question_summaries_old_by_pk?: Maybe<User_Quiz_Question_Summaries_Old>;
  /** delete data from the table: "user_quiz_questions" */
  delete_user_quiz_questions?: Maybe<User_Quiz_Questions_Mutation_Response>;
  /** delete single row from the table: "user_quiz_questions" */
  delete_user_quiz_questions_by_pk?: Maybe<User_Quiz_Questions>;
  /** delete data from the table: "user_quiz_section_summaries" */
  delete_user_quiz_section_summaries?: Maybe<User_Quiz_Section_Summaries_Mutation_Response>;
  /** delete single row from the table: "user_quiz_section_summaries" */
  delete_user_quiz_section_summaries_by_pk?: Maybe<User_Quiz_Section_Summaries>;
  /** delete data from the table: "user_quiz_summaries" */
  delete_user_quiz_summaries?: Maybe<User_Quiz_Summaries_Mutation_Response>;
  /** delete single row from the table: "user_quiz_summaries" */
  delete_user_quiz_summaries_by_pk?: Maybe<User_Quiz_Summaries>;
  /** delete data from the table: "user_quiz_summaries_old" */
  delete_user_quiz_summaries_old?: Maybe<User_Quiz_Summaries_Old_Mutation_Response>;
  /** delete single row from the table: "user_quiz_summaries_old" */
  delete_user_quiz_summaries_old_by_pk?: Maybe<User_Quiz_Summaries_Old>;
  /** delete data from the table: "user_section_summaries" */
  delete_user_section_summaries?: Maybe<User_Section_Summaries_Mutation_Response>;
  /** delete single row from the table: "user_section_summaries" */
  delete_user_section_summaries_by_pk?: Maybe<User_Section_Summaries>;
  /** delete data from the table: "user_speed_test_questions_summaries" */
  delete_user_speed_test_questions_summaries?: Maybe<User_Speed_Test_Questions_Summaries_Mutation_Response>;
  /** delete single row from the table: "user_speed_test_questions_summaries" */
  delete_user_speed_test_questions_summaries_by_pk?: Maybe<User_Speed_Test_Questions_Summaries>;
  /** delete data from the table: "user_speed_tests_summaries" */
  delete_user_speed_tests_summaries?: Maybe<User_Speed_Tests_Summaries_Mutation_Response>;
  /** delete single row from the table: "user_speed_tests_summaries" */
  delete_user_speed_tests_summaries_by_pk?: Maybe<User_Speed_Tests_Summaries>;
  /** delete data from the table: "user_timed_quiz_summary" */
  delete_user_timed_quiz_summary?: Maybe<User_Timed_Quiz_Summary_Mutation_Response>;
  /** delete single row from the table: "user_timed_quiz_summary" */
  delete_user_timed_quiz_summary_by_pk?: Maybe<User_Timed_Quiz_Summary>;
  /** delete data from the table: "user_total_score" */
  delete_user_total_score?: Maybe<User_Total_Score_Mutation_Response>;
  /** delete single row from the table: "user_total_score" */
  delete_user_total_score_by_pk?: Maybe<User_Total_Score>;
  /** delete data from the table: "user_xp_transaction_summaries" */
  delete_user_xp_transaction_summaries?: Maybe<User_Xp_Transaction_Summaries_Mutation_Response>;
  /** delete single row from the table: "user_xp_transaction_summaries" */
  delete_user_xp_transaction_summaries_by_pk?: Maybe<User_Xp_Transaction_Summaries>;
  /** delete data from the table: "user_xp_transactions" */
  delete_user_xp_transactions?: Maybe<User_Xp_Transactions_Mutation_Response>;
  /** delete single row from the table: "user_xp_transactions" */
  delete_user_xp_transactions_by_pk?: Maybe<User_Xp_Transactions>;
  /** delete data from the table: "users_user" */
  delete_users_user?: Maybe<Users_User_Mutation_Response>;
  /** delete single row from the table: "users_user" */
  delete_users_user_by_pk?: Maybe<Users_User>;
  /** delete data from the table: "users_user_groups" */
  delete_users_user_groups?: Maybe<Users_User_Groups_Mutation_Response>;
  /** delete single row from the table: "users_user_groups" */
  delete_users_user_groups_by_pk?: Maybe<Users_User_Groups>;
  /** delete data from the table: "users_user_user_permissions" */
  delete_users_user_user_permissions?: Maybe<Users_User_User_Permissions_Mutation_Response>;
  /** delete single row from the table: "users_user_user_permissions" */
  delete_users_user_user_permissions_by_pk?: Maybe<Users_User_User_Permissions>;
  /** delete data from the table: "users_userquestionsummary" */
  delete_users_userquestionsummary?: Maybe<Users_Userquestionsummary_Mutation_Response>;
  /** delete single row from the table: "users_userquestionsummary" */
  delete_users_userquestionsummary_by_pk?: Maybe<Users_Userquestionsummary>;
  /** delete data from the table: "users_userquizsummary" */
  delete_users_userquizsummary?: Maybe<Users_Userquizsummary_Mutation_Response>;
  /** delete single row from the table: "users_userquizsummary" */
  delete_users_userquizsummary_by_pk?: Maybe<Users_Userquizsummary>;
  /** delete data from the table: "users_userquiztimesummary" */
  delete_users_userquiztimesummary?: Maybe<Users_Userquiztimesummary_Mutation_Response>;
  /** delete single row from the table: "users_userquiztimesummary" */
  delete_users_userquiztimesummary_by_pk?: Maybe<Users_Userquiztimesummary>;
  /** delete data from the table: "users_usersectionsummary" */
  delete_users_usersectionsummary?: Maybe<Users_Usersectionsummary_Mutation_Response>;
  /** delete single row from the table: "users_usersectionsummary" */
  delete_users_usersectionsummary_by_pk?: Maybe<Users_Usersectionsummary>;
  /** delete data from the table: "utils_configuration" */
  delete_utils_configuration?: Maybe<Utils_Configuration_Mutation_Response>;
  /** delete single row from the table: "utils_configuration" */
  delete_utils_configuration_by_pk?: Maybe<Utils_Configuration>;
  /** delete data from the table: "xp_transaction_types" */
  delete_xp_transaction_types?: Maybe<Xp_Transaction_Types_Mutation_Response>;
  /** delete single row from the table: "xp_transaction_types" */
  delete_xp_transaction_types_by_pk?: Maybe<Xp_Transaction_Types>;
  forgotPassword: GenericResponse;
  getCatResult: GetCatResultResponse;
  getDownloadURL: DownloadFilePayload;
  getOrderID: OrderIdPayload;
  getPresignedDownloadURL: DownloadFilePayload;
  getPresignedUploadURL: UploadFilePayload;
  getUploadFileUrl: UploadUrlResponse;
  initiatePayment: InitiatePaymentPayload;
  /** insert data into the table: "account_emailaddress" */
  insert_account_emailaddress?: Maybe<Account_Emailaddress_Mutation_Response>;
  /** insert a single row into the table: "account_emailaddress" */
  insert_account_emailaddress_one?: Maybe<Account_Emailaddress>;
  /** insert data into the table: "account_emailconfirmation" */
  insert_account_emailconfirmation?: Maybe<Account_Emailconfirmation_Mutation_Response>;
  /** insert a single row into the table: "account_emailconfirmation" */
  insert_account_emailconfirmation_one?: Maybe<Account_Emailconfirmation>;
  /** insert data into the table: "accounts_catscores" */
  insert_accounts_catscores?: Maybe<Accounts_Catscores_Mutation_Response>;
  /** insert a single row into the table: "accounts_catscores" */
  insert_accounts_catscores_one?: Maybe<Accounts_Catscores>;
  /** insert data into the table: "accounts_loggedinuser" */
  insert_accounts_loggedinuser?: Maybe<Accounts_Loggedinuser_Mutation_Response>;
  /** insert a single row into the table: "accounts_loggedinuser" */
  insert_accounts_loggedinuser_one?: Maybe<Accounts_Loggedinuser>;
  /** insert data into the table: "activity_types" */
  insert_activity_types?: Maybe<Activity_Types_Mutation_Response>;
  /** insert a single row into the table: "activity_types" */
  insert_activity_types_one?: Maybe<Activity_Types>;
  /** insert data into the table: "admin_constants" */
  insert_admin_constants?: Maybe<Admin_Constants_Mutation_Response>;
  /** insert a single row into the table: "admin_constants" */
  insert_admin_constants_one?: Maybe<Admin_Constants>;
  /** insert data into the table: "admin_users" */
  insert_admin_users?: Maybe<Admin_Users_Mutation_Response>;
  /** insert a single row into the table: "admin_users" */
  insert_admin_users_one?: Maybe<Admin_Users>;
  /** insert data into the table: "advertisements" */
  insert_advertisements?: Maybe<Advertisements_Mutation_Response>;
  /** insert a single row into the table: "advertisements" */
  insert_advertisements_one?: Maybe<Advertisements>;
  /** insert data into the table: "andablog_entry" */
  insert_andablog_entry?: Maybe<Andablog_Entry_Mutation_Response>;
  /** insert a single row into the table: "andablog_entry" */
  insert_andablog_entry_one?: Maybe<Andablog_Entry>;
  /** insert data into the table: "andablog_entryimage" */
  insert_andablog_entryimage?: Maybe<Andablog_Entryimage_Mutation_Response>;
  /** insert a single row into the table: "andablog_entryimage" */
  insert_andablog_entryimage_one?: Maybe<Andablog_Entryimage>;
  /** insert data into the table: "andablog_news" */
  insert_andablog_news?: Maybe<Andablog_News_Mutation_Response>;
  /** insert a single row into the table: "andablog_news" */
  insert_andablog_news_one?: Maybe<Andablog_News>;
  /** insert data into the table: "andablog_pov" */
  insert_andablog_pov?: Maybe<Andablog_Pov_Mutation_Response>;
  /** insert a single row into the table: "andablog_pov" */
  insert_andablog_pov_one?: Maybe<Andablog_Pov>;
  /** insert data into the table: "andablog_userlessontrackrecord" */
  insert_andablog_userlessontrackrecord?: Maybe<Andablog_Userlessontrackrecord_Mutation_Response>;
  /** insert data into the table: "andablog_userlessontrackrecord_bookmarked_topics" */
  insert_andablog_userlessontrackrecord_bookmarked_topics?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Mutation_Response>;
  /** insert a single row into the table: "andablog_userlessontrackrecord_bookmarked_topics" */
  insert_andablog_userlessontrackrecord_bookmarked_topics_one?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** insert a single row into the table: "andablog_userlessontrackrecord" */
  insert_andablog_userlessontrackrecord_one?: Maybe<Andablog_Userlessontrackrecord>;
  /** insert data into the table: "andablog_userlessontrackrecord_which_topics" */
  insert_andablog_userlessontrackrecord_which_topics?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Mutation_Response>;
  /** insert a single row into the table: "andablog_userlessontrackrecord_which_topics" */
  insert_andablog_userlessontrackrecord_which_topics_one?: Maybe<Andablog_Userlessontrackrecord_Which_Topics>;
  /** insert data into the table: "andablog_video" */
  insert_andablog_video?: Maybe<Andablog_Video_Mutation_Response>;
  /** insert a single row into the table: "andablog_video" */
  insert_andablog_video_one?: Maybe<Andablog_Video>;
  /** insert data into the table: "auth.email_verifications" */
  insert_auth_email_verifications?: Maybe<Auth_Email_Verifications_Mutation_Response>;
  /** insert a single row into the table: "auth.email_verifications" */
  insert_auth_email_verifications_one?: Maybe<Auth_Email_Verifications>;
  /** insert data into the table: "auth_group" */
  insert_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** insert a single row into the table: "auth_group" */
  insert_auth_group_one?: Maybe<Auth_Group>;
  /** insert data into the table: "auth_group_permissions" */
  insert_auth_group_permissions?: Maybe<Auth_Group_Permissions_Mutation_Response>;
  /** insert a single row into the table: "auth_group_permissions" */
  insert_auth_group_permissions_one?: Maybe<Auth_Group_Permissions>;
  /** insert data into the table: "auth.password_reset_tokens" */
  insert_auth_password_reset_tokens?: Maybe<Auth_Password_Reset_Tokens_Mutation_Response>;
  /** insert a single row into the table: "auth.password_reset_tokens" */
  insert_auth_password_reset_tokens_one?: Maybe<Auth_Password_Reset_Tokens>;
  /** insert data into the table: "auth_permission" */
  insert_auth_permission?: Maybe<Auth_Permission_Mutation_Response>;
  /** insert a single row into the table: "auth_permission" */
  insert_auth_permission_one?: Maybe<Auth_Permission>;
  /** insert data into the table: "auth.session" */
  insert_auth_session?: Maybe<Auth_Session_Mutation_Response>;
  /** insert a single row into the table: "auth.session" */
  insert_auth_session_one?: Maybe<Auth_Session>;
  /** insert data into the table: "bookmarked_learn_topics" */
  insert_bookmarked_learn_topics?: Maybe<Bookmarked_Learn_Topics_Mutation_Response>;
  /** insert a single row into the table: "bookmarked_learn_topics" */
  insert_bookmarked_learn_topics_one?: Maybe<Bookmarked_Learn_Topics>;
  /** insert data into the table: "cat_percentile_constant" */
  insert_cat_percentile_constant?: Maybe<Cat_Percentile_Constant_Mutation_Response>;
  /** insert a single row into the table: "cat_percentile_constant" */
  insert_cat_percentile_constant_one?: Maybe<Cat_Percentile_Constant>;
  /** insert data into the table: "cat_scores" */
  insert_cat_scores?: Maybe<Cat_Scores_Mutation_Response>;
  /** insert a single row into the table: "cat_scores" */
  insert_cat_scores_one?: Maybe<Cat_Scores>;
  /** insert data into the table: "channel_members" */
  insert_channel_members?: Maybe<Channel_Members_Mutation_Response>;
  /** insert a single row into the table: "channel_members" */
  insert_channel_members_one?: Maybe<Channel_Members>;
  /** insert data into the table: "channels" */
  insert_channels?: Maybe<Channels_Mutation_Response>;
  /** insert a single row into the table: "channels" */
  insert_channels_one?: Maybe<Channels>;
  /** insert data into the table: "coupons_allowed_users_rule_users" */
  insert_coupons_allowed_users_rule_users?: Maybe<Coupons_Allowed_Users_Rule_Users_Mutation_Response>;
  /** insert a single row into the table: "coupons_allowed_users_rule_users" */
  insert_coupons_allowed_users_rule_users_one?: Maybe<Coupons_Allowed_Users_Rule_Users>;
  /** insert data into the table: "coupons_allowedusersrule" */
  insert_coupons_allowedusersrule?: Maybe<Coupons_Allowedusersrule_Mutation_Response>;
  /** insert a single row into the table: "coupons_allowedusersrule" */
  insert_coupons_allowedusersrule_one?: Maybe<Coupons_Allowedusersrule>;
  /** insert data into the table: "coupons_allowedusersrule_users" */
  insert_coupons_allowedusersrule_users?: Maybe<Coupons_Allowedusersrule_Users_Mutation_Response>;
  /** insert a single row into the table: "coupons_allowedusersrule_users" */
  insert_coupons_allowedusersrule_users_one?: Maybe<Coupons_Allowedusersrule_Users>;
  /** insert data into the table: "coupons_coupon" */
  insert_coupons_coupon?: Maybe<Coupons_Coupon_Mutation_Response>;
  /** insert data into the table: "coupons_coupon_applicable_packages" */
  insert_coupons_coupon_applicable_packages?: Maybe<Coupons_Coupon_Applicable_Packages_Mutation_Response>;
  /** insert a single row into the table: "coupons_coupon_applicable_packages" */
  insert_coupons_coupon_applicable_packages_one?: Maybe<Coupons_Coupon_Applicable_Packages>;
  /** insert a single row into the table: "coupons_coupon" */
  insert_coupons_coupon_one?: Maybe<Coupons_Coupon>;
  /** insert data into the table: "coupons_couponuser" */
  insert_coupons_couponuser?: Maybe<Coupons_Couponuser_Mutation_Response>;
  /** insert a single row into the table: "coupons_couponuser" */
  insert_coupons_couponuser_one?: Maybe<Coupons_Couponuser>;
  /** insert data into the table: "coupons_discount" */
  insert_coupons_discount?: Maybe<Coupons_Discount_Mutation_Response>;
  /** insert a single row into the table: "coupons_discount" */
  insert_coupons_discount_one?: Maybe<Coupons_Discount>;
  /** insert data into the table: "coupons_maxusesrule" */
  insert_coupons_maxusesrule?: Maybe<Coupons_Maxusesrule_Mutation_Response>;
  /** insert a single row into the table: "coupons_maxusesrule" */
  insert_coupons_maxusesrule_one?: Maybe<Coupons_Maxusesrule>;
  /** insert data into the table: "coupons_ruleset" */
  insert_coupons_ruleset?: Maybe<Coupons_Ruleset_Mutation_Response>;
  /** insert a single row into the table: "coupons_ruleset" */
  insert_coupons_ruleset_one?: Maybe<Coupons_Ruleset>;
  /** insert data into the table: "coupons_validityrule" */
  insert_coupons_validityrule?: Maybe<Coupons_Validityrule_Mutation_Response>;
  /** insert a single row into the table: "coupons_validityrule" */
  insert_coupons_validityrule_one?: Maybe<Coupons_Validityrule>;
  /** insert data into the table: "django_admin_log" */
  insert_django_admin_log?: Maybe<Django_Admin_Log_Mutation_Response>;
  /** insert a single row into the table: "django_admin_log" */
  insert_django_admin_log_one?: Maybe<Django_Admin_Log>;
  /** insert data into the table: "django_content_type" */
  insert_django_content_type?: Maybe<Django_Content_Type_Mutation_Response>;
  /** insert a single row into the table: "django_content_type" */
  insert_django_content_type_one?: Maybe<Django_Content_Type>;
  /** insert data into the table: "django_migrations" */
  insert_django_migrations?: Maybe<Django_Migrations_Mutation_Response>;
  /** insert a single row into the table: "django_migrations" */
  insert_django_migrations_one?: Maybe<Django_Migrations>;
  /** insert data into the table: "django_session" */
  insert_django_session?: Maybe<Django_Session_Mutation_Response>;
  /** insert a single row into the table: "django_session" */
  insert_django_session_one?: Maybe<Django_Session>;
  /** insert data into the table: "django_site" */
  insert_django_site?: Maybe<Django_Site_Mutation_Response>;
  /** insert a single row into the table: "django_site" */
  insert_django_site_one?: Maybe<Django_Site>;
  /** insert data into the table: "djconfig_config" */
  insert_djconfig_config?: Maybe<Djconfig_Config_Mutation_Response>;
  /** insert a single row into the table: "djconfig_config" */
  insert_djconfig_config_one?: Maybe<Djconfig_Config>;
  /** insert data into the table: "group_category" */
  insert_group_category?: Maybe<Group_Category_Mutation_Response>;
  /** insert a single row into the table: "group_category" */
  insert_group_category_one?: Maybe<Group_Category>;
  /** insert data into the table: "group_discount_users" */
  insert_group_discount_users?: Maybe<Group_Discount_Users_Mutation_Response>;
  /** insert a single row into the table: "group_discount_users" */
  insert_group_discount_users_one?: Maybe<Group_Discount_Users>;
  /** insert data into the table: "has_access" */
  insert_has_access?: Maybe<Has_Access_Mutation_Response>;
  /** insert a single row into the table: "has_access" */
  insert_has_access_one?: Maybe<Has_Access>;
  /** insert data into the table: "infozone_category" */
  insert_infozone_category?: Maybe<Infozone_Category_Mutation_Response>;
  /** insert a single row into the table: "infozone_category" */
  insert_infozone_category_one?: Maybe<Infozone_Category>;
  /** insert data into the table: "infozone_infozone" */
  insert_infozone_infozone?: Maybe<Infozone_Infozone_Mutation_Response>;
  /** insert a single row into the table: "infozone_infozone" */
  insert_infozone_infozone_one?: Maybe<Infozone_Infozone>;
  /** insert data into the table: "infozone_staticpages" */
  insert_infozone_staticpages?: Maybe<Infozone_Staticpages_Mutation_Response>;
  /** insert a single row into the table: "infozone_staticpages" */
  insert_infozone_staticpages_one?: Maybe<Infozone_Staticpages>;
  /** insert data into the table: "live_quiz_leaderboard" */
  insert_live_quiz_leaderboard?: Maybe<Live_Quiz_Leaderboard_Mutation_Response>;
  /** insert a single row into the table: "live_quiz_leaderboard" */
  insert_live_quiz_leaderboard_one?: Maybe<Live_Quiz_Leaderboard>;
  /** insert data into the table: "live_quiz_question_positions" */
  insert_live_quiz_question_positions?: Maybe<Live_Quiz_Question_Positions_Mutation_Response>;
  /** insert a single row into the table: "live_quiz_question_positions" */
  insert_live_quiz_question_positions_one?: Maybe<Live_Quiz_Question_Positions>;
  /** insert data into the table: "live_quiz_question_summary" */
  insert_live_quiz_question_summary?: Maybe<Live_Quiz_Question_Summary_Mutation_Response>;
  /** insert a single row into the table: "live_quiz_question_summary" */
  insert_live_quiz_question_summary_one?: Maybe<Live_Quiz_Question_Summary>;
  /** insert data into the table: "live_quiz_summary" */
  insert_live_quiz_summary?: Maybe<Live_Quiz_Summary_Mutation_Response>;
  /** insert a single row into the table: "live_quiz_summary" */
  insert_live_quiz_summary_one?: Maybe<Live_Quiz_Summary>;
  /** insert data into the table: "marks_vs_percentile_dilr" */
  insert_marks_vs_percentile_dilr?: Maybe<Marks_Vs_Percentile_Dilr_Mutation_Response>;
  /** insert a single row into the table: "marks_vs_percentile_dilr" */
  insert_marks_vs_percentile_dilr_one?: Maybe<Marks_Vs_Percentile_Dilr>;
  /** insert data into the table: "marks_vs_percentile_quant" */
  insert_marks_vs_percentile_quant?: Maybe<Marks_Vs_Percentile_Quant_Mutation_Response>;
  /** insert a single row into the table: "marks_vs_percentile_quant" */
  insert_marks_vs_percentile_quant_one?: Maybe<Marks_Vs_Percentile_Quant>;
  /** insert data into the table: "marks_vs_percentile_total_raw" */
  insert_marks_vs_percentile_total_raw?: Maybe<Marks_Vs_Percentile_Total_Raw_Mutation_Response>;
  /** insert a single row into the table: "marks_vs_percentile_total_raw" */
  insert_marks_vs_percentile_total_raw_one?: Maybe<Marks_Vs_Percentile_Total_Raw>;
  /** insert data into the table: "marks_vs_percentile_varc" */
  insert_marks_vs_percentile_varc?: Maybe<Marks_Vs_Percentile_Varc_Mutation_Response>;
  /** insert a single row into the table: "marks_vs_percentile_varc" */
  insert_marks_vs_percentile_varc_one?: Maybe<Marks_Vs_Percentile_Varc>;
  /** insert data into the table: "marks_vs_scaled_percentile" */
  insert_marks_vs_scaled_percentile?: Maybe<Marks_Vs_Scaled_Percentile_Mutation_Response>;
  /** insert a single row into the table: "marks_vs_scaled_percentile" */
  insert_marks_vs_scaled_percentile_one?: Maybe<Marks_Vs_Scaled_Percentile>;
  /** insert data into the table: "meeting_members" */
  insert_meeting_members?: Maybe<Meeting_Members_Mutation_Response>;
  /** insert a single row into the table: "meeting_members" */
  insert_meeting_members_one?: Maybe<Meeting_Members>;
  /** insert data into the table: "meetings" */
  insert_meetings?: Maybe<Meetings_Mutation_Response>;
  /** insert a single row into the table: "meetings" */
  insert_meetings_one?: Maybe<Meetings>;
  /** insert data into the table: "message_reactions" */
  insert_message_reactions?: Maybe<Message_Reactions_Mutation_Response>;
  /** insert a single row into the table: "message_reactions" */
  insert_message_reactions_one?: Maybe<Message_Reactions>;
  /** insert data into the table: "messages" */
  insert_messages?: Maybe<Messages_Mutation_Response>;
  /** insert a single row into the table: "messages" */
  insert_messages_one?: Maybe<Messages>;
  /** insert data into the table: "messages_read" */
  insert_messages_read?: Maybe<Messages_Read_Mutation_Response>;
  /** insert a single row into the table: "messages_read" */
  insert_messages_read_one?: Maybe<Messages_Read>;
  /** insert data into the table: "offline_leads" */
  insert_offline_leads?: Maybe<Offline_Leads_Mutation_Response>;
  /** insert a single row into the table: "offline_leads" */
  insert_offline_leads_one?: Maybe<Offline_Leads>;
  /** insert data into the table: "package_content_discarded_quizzes" */
  insert_package_content_discarded_quizzes?: Maybe<Package_Content_Discarded_Quizzes_Mutation_Response>;
  /** insert a single row into the table: "package_content_discarded_quizzes" */
  insert_package_content_discarded_quizzes_one?: Maybe<Package_Content_Discarded_Quizzes>;
  /** insert data into the table: "packages_content" */
  insert_packages_content?: Maybe<Packages_Content_Mutation_Response>;
  /** insert data into the table: "packages_content_domains" */
  insert_packages_content_domains?: Maybe<Packages_Content_Domains_Mutation_Response>;
  /** insert a single row into the table: "packages_content_domains" */
  insert_packages_content_domains_one?: Maybe<Packages_Content_Domains>;
  /** insert a single row into the table: "packages_content" */
  insert_packages_content_one?: Maybe<Packages_Content>;
  /** insert data into the table: "packages_content_text_lesson" */
  insert_packages_content_text_lesson?: Maybe<Packages_Content_Text_Lesson_Mutation_Response>;
  /** insert a single row into the table: "packages_content_text_lesson" */
  insert_packages_content_text_lesson_one?: Maybe<Packages_Content_Text_Lesson>;
  /** insert data into the table: "packages_content_timed_test" */
  insert_packages_content_timed_test?: Maybe<Packages_Content_Timed_Test_Mutation_Response>;
  /** insert a single row into the table: "packages_content_timed_test" */
  insert_packages_content_timed_test_one?: Maybe<Packages_Content_Timed_Test>;
  /** insert data into the table: "packages_content_untimed_test" */
  insert_packages_content_untimed_test?: Maybe<Packages_Content_Untimed_Test_Mutation_Response>;
  /** insert a single row into the table: "packages_content_untimed_test" */
  insert_packages_content_untimed_test_one?: Maybe<Packages_Content_Untimed_Test>;
  /** insert data into the table: "packages_payment_transaction" */
  insert_packages_payment_transaction?: Maybe<Packages_Payment_Transaction_Mutation_Response>;
  /** insert a single row into the table: "packages_payment_transaction" */
  insert_packages_payment_transaction_one?: Maybe<Packages_Payment_Transaction>;
  /** insert data into the table: "packages_paymenttransaction" */
  insert_packages_paymenttransaction?: Maybe<Packages_Paymenttransaction_Mutation_Response>;
  /** insert a single row into the table: "packages_paymenttransaction" */
  insert_packages_paymenttransaction_one?: Maybe<Packages_Paymenttransaction>;
  /** insert data into the table: "poll" */
  insert_poll?: Maybe<Poll_Mutation_Response>;
  /** insert a single row into the table: "poll" */
  insert_poll_one?: Maybe<Poll>;
  /** insert data into the table: "poll_options" */
  insert_poll_options?: Maybe<Poll_Options_Mutation_Response>;
  /** insert a single row into the table: "poll_options" */
  insert_poll_options_one?: Maybe<Poll_Options>;
  /** insert data into the table: "poll_responses" */
  insert_poll_responses?: Maybe<Poll_Responses_Mutation_Response>;
  /** insert a single row into the table: "poll_responses" */
  insert_poll_responses_one?: Maybe<Poll_Responses>;
  /** insert data into the table: "question_reports" */
  insert_question_reports?: Maybe<Question_Reports_Mutation_Response>;
  /** insert a single row into the table: "question_reports" */
  insert_question_reports_one?: Maybe<Question_Reports>;
  /** insert data into the table: "quiz_answer" */
  insert_quiz_answer?: Maybe<Quiz_Answer_Mutation_Response>;
  /** insert a single row into the table: "quiz_answer" */
  insert_quiz_answer_one?: Maybe<Quiz_Answer>;
  /** insert data into the table: "quiz_category" */
  insert_quiz_category?: Maybe<Quiz_Category_Mutation_Response>;
  /** insert a single row into the table: "quiz_category" */
  insert_quiz_category_one?: Maybe<Quiz_Category>;
  /** insert data into the table: "quiz_domain" */
  insert_quiz_domain?: Maybe<Quiz_Domain_Mutation_Response>;
  /** insert a single row into the table: "quiz_domain" */
  insert_quiz_domain_one?: Maybe<Quiz_Domain>;
  /** insert data into the table: "quiz_markingsystem" */
  insert_quiz_markingsystem?: Maybe<Quiz_Markingsystem_Mutation_Response>;
  /** insert a single row into the table: "quiz_markingsystem" */
  insert_quiz_markingsystem_one?: Maybe<Quiz_Markingsystem>;
  /** insert data into the table: "quiz_option" */
  insert_quiz_option?: Maybe<Quiz_Option_Mutation_Response>;
  /** insert a single row into the table: "quiz_option" */
  insert_quiz_option_one?: Maybe<Quiz_Option>;
  /** insert data into the table: "quiz_paragraph" */
  insert_quiz_paragraph?: Maybe<Quiz_Paragraph_Mutation_Response>;
  /** insert a single row into the table: "quiz_paragraph" */
  insert_quiz_paragraph_one?: Maybe<Quiz_Paragraph>;
  /** insert data into the table: "quiz_question" */
  insert_quiz_question?: Maybe<Quiz_Question_Mutation_Response>;
  /** insert a single row into the table: "quiz_question" */
  insert_quiz_question_one?: Maybe<Quiz_Question>;
  /** insert data into the table: "quiz_quiz" */
  insert_quiz_quiz?: Maybe<Quiz_Quiz_Mutation_Response>;
  /** insert a single row into the table: "quiz_quiz" */
  insert_quiz_quiz_one?: Maybe<Quiz_Quiz>;
  /** insert data into the table: "quiz_quiz_questions" */
  insert_quiz_quiz_questions?: Maybe<Quiz_Quiz_Questions_Mutation_Response>;
  /** insert a single row into the table: "quiz_quiz_questions" */
  insert_quiz_quiz_questions_one?: Maybe<Quiz_Quiz_Questions>;
  /** insert data into the table: "quiz_quiz_sections" */
  insert_quiz_quiz_sections?: Maybe<Quiz_Quiz_Sections_Mutation_Response>;
  /** insert a single row into the table: "quiz_quiz_sections" */
  insert_quiz_quiz_sections_one?: Maybe<Quiz_Quiz_Sections>;
  /** insert data into the table: "quiz_section" */
  insert_quiz_section?: Maybe<Quiz_Section_Mutation_Response>;
  /** insert a single row into the table: "quiz_section" */
  insert_quiz_section_one?: Maybe<Quiz_Section>;
  /** insert data into the table: "quiz_section_questions" */
  insert_quiz_section_questions?: Maybe<Quiz_Section_Questions_Mutation_Response>;
  /** insert a single row into the table: "quiz_section_questions" */
  insert_quiz_section_questions_one?: Maybe<Quiz_Section_Questions>;
  /** insert data into the table: "quiz_section_subsections" */
  insert_quiz_section_subsections?: Maybe<Quiz_Section_Subsections_Mutation_Response>;
  /** insert a single row into the table: "quiz_section_subsections" */
  insert_quiz_section_subsections_one?: Maybe<Quiz_Section_Subsections>;
  /** insert data into the table: "quiz_superdomain" */
  insert_quiz_superdomain?: Maybe<Quiz_Superdomain_Mutation_Response>;
  /** insert a single row into the table: "quiz_superdomain" */
  insert_quiz_superdomain_one?: Maybe<Quiz_Superdomain>;
  /** insert data into the table: "random_question_ids" */
  insert_random_question_ids?: Maybe<Random_Question_Ids_Mutation_Response>;
  /** insert a single row into the table: "random_question_ids" */
  insert_random_question_ids_one?: Maybe<Random_Question_Ids>;
  /** insert data into the table: "reaction_emojis" */
  insert_reaction_emojis?: Maybe<Reaction_Emojis_Mutation_Response>;
  /** insert a single row into the table: "reaction_emojis" */
  insert_reaction_emojis_one?: Maybe<Reaction_Emojis>;
  /** insert data into the table: "reported_message" */
  insert_reported_message?: Maybe<Reported_Message_Mutation_Response>;
  /** insert a single row into the table: "reported_message" */
  insert_reported_message_one?: Maybe<Reported_Message>;
  /** insert data into the table: "scaling_constant" */
  insert_scaling_constant?: Maybe<Scaling_Constant_Mutation_Response>;
  /** insert a single row into the table: "scaling_constant" */
  insert_scaling_constant_one?: Maybe<Scaling_Constant>;
  /** insert data into the table: "socialaccount_socialaccount" */
  insert_socialaccount_socialaccount?: Maybe<Socialaccount_Socialaccount_Mutation_Response>;
  /** insert a single row into the table: "socialaccount_socialaccount" */
  insert_socialaccount_socialaccount_one?: Maybe<Socialaccount_Socialaccount>;
  /** insert data into the table: "socialaccount_socialapp" */
  insert_socialaccount_socialapp?: Maybe<Socialaccount_Socialapp_Mutation_Response>;
  /** insert a single row into the table: "socialaccount_socialapp" */
  insert_socialaccount_socialapp_one?: Maybe<Socialaccount_Socialapp>;
  /** insert data into the table: "socialaccount_socialapp_sites" */
  insert_socialaccount_socialapp_sites?: Maybe<Socialaccount_Socialapp_Sites_Mutation_Response>;
  /** insert a single row into the table: "socialaccount_socialapp_sites" */
  insert_socialaccount_socialapp_sites_one?: Maybe<Socialaccount_Socialapp_Sites>;
  /** insert data into the table: "socialaccount_socialtoken" */
  insert_socialaccount_socialtoken?: Maybe<Socialaccount_Socialtoken_Mutation_Response>;
  /** insert a single row into the table: "socialaccount_socialtoken" */
  insert_socialaccount_socialtoken_one?: Maybe<Socialaccount_Socialtoken>;
  /** insert data into the table: "speed_test_category" */
  insert_speed_test_category?: Maybe<Speed_Test_Category_Mutation_Response>;
  /** insert a single row into the table: "speed_test_category" */
  insert_speed_test_category_one?: Maybe<Speed_Test_Category>;
  /** insert data into the table: "speed_tests" */
  insert_speed_tests?: Maybe<Speed_Tests_Mutation_Response>;
  /** insert a single row into the table: "speed_tests" */
  insert_speed_tests_one?: Maybe<Speed_Tests>;
  /** insert data into the table: "spirit_cache" */
  insert_spirit_cache?: Maybe<Spirit_Cache_Mutation_Response>;
  /** insert a single row into the table: "spirit_cache" */
  insert_spirit_cache_one?: Maybe<Spirit_Cache>;
  /** insert data into the table: "spirit_category_category" */
  insert_spirit_category_category?: Maybe<Spirit_Category_Category_Mutation_Response>;
  /** insert a single row into the table: "spirit_category_category" */
  insert_spirit_category_category_one?: Maybe<Spirit_Category_Category>;
  /** insert data into the table: "spirit_comment_bookmark_commentbookmark" */
  insert_spirit_comment_bookmark_commentbookmark?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Mutation_Response>;
  /** insert a single row into the table: "spirit_comment_bookmark_commentbookmark" */
  insert_spirit_comment_bookmark_commentbookmark_one?: Maybe<Spirit_Comment_Bookmark_Commentbookmark>;
  /** insert data into the table: "spirit_comment_comment" */
  insert_spirit_comment_comment?: Maybe<Spirit_Comment_Comment_Mutation_Response>;
  /** insert a single row into the table: "spirit_comment_comment" */
  insert_spirit_comment_comment_one?: Maybe<Spirit_Comment_Comment>;
  /** insert data into the table: "spirit_comment_flag_commentflag" */
  insert_spirit_comment_flag_commentflag?: Maybe<Spirit_Comment_Flag_Commentflag_Mutation_Response>;
  /** insert a single row into the table: "spirit_comment_flag_commentflag" */
  insert_spirit_comment_flag_commentflag_one?: Maybe<Spirit_Comment_Flag_Commentflag>;
  /** insert data into the table: "spirit_comment_flag_flag" */
  insert_spirit_comment_flag_flag?: Maybe<Spirit_Comment_Flag_Flag_Mutation_Response>;
  /** insert a single row into the table: "spirit_comment_flag_flag" */
  insert_spirit_comment_flag_flag_one?: Maybe<Spirit_Comment_Flag_Flag>;
  /** insert data into the table: "spirit_comment_history_commenthistory" */
  insert_spirit_comment_history_commenthistory?: Maybe<Spirit_Comment_History_Commenthistory_Mutation_Response>;
  /** insert a single row into the table: "spirit_comment_history_commenthistory" */
  insert_spirit_comment_history_commenthistory_one?: Maybe<Spirit_Comment_History_Commenthistory>;
  /** insert data into the table: "spirit_comment_like_commentlike" */
  insert_spirit_comment_like_commentlike?: Maybe<Spirit_Comment_Like_Commentlike_Mutation_Response>;
  /** insert a single row into the table: "spirit_comment_like_commentlike" */
  insert_spirit_comment_like_commentlike_one?: Maybe<Spirit_Comment_Like_Commentlike>;
  /** insert data into the table: "spirit_comment_poll_commentpoll" */
  insert_spirit_comment_poll_commentpoll?: Maybe<Spirit_Comment_Poll_Commentpoll_Mutation_Response>;
  /** insert a single row into the table: "spirit_comment_poll_commentpoll" */
  insert_spirit_comment_poll_commentpoll_one?: Maybe<Spirit_Comment_Poll_Commentpoll>;
  /** insert data into the table: "spirit_comment_poll_commentpollchoice" */
  insert_spirit_comment_poll_commentpollchoice?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Mutation_Response>;
  /** insert a single row into the table: "spirit_comment_poll_commentpollchoice" */
  insert_spirit_comment_poll_commentpollchoice_one?: Maybe<Spirit_Comment_Poll_Commentpollchoice>;
  /** insert data into the table: "spirit_comment_poll_commentpollvote" */
  insert_spirit_comment_poll_commentpollvote?: Maybe<Spirit_Comment_Poll_Commentpollvote_Mutation_Response>;
  /** insert a single row into the table: "spirit_comment_poll_commentpollvote" */
  insert_spirit_comment_poll_commentpollvote_one?: Maybe<Spirit_Comment_Poll_Commentpollvote>;
  /** insert data into the table: "spirit_rl_cache" */
  insert_spirit_rl_cache?: Maybe<Spirit_Rl_Cache_Mutation_Response>;
  /** insert a single row into the table: "spirit_rl_cache" */
  insert_spirit_rl_cache_one?: Maybe<Spirit_Rl_Cache>;
  /** insert data into the table: "spirit_topic_favorite_topicfavorite" */
  insert_spirit_topic_favorite_topicfavorite?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Mutation_Response>;
  /** insert a single row into the table: "spirit_topic_favorite_topicfavorite" */
  insert_spirit_topic_favorite_topicfavorite_one?: Maybe<Spirit_Topic_Favorite_Topicfavorite>;
  /** insert data into the table: "spirit_topic_notification_topicnotification" */
  insert_spirit_topic_notification_topicnotification?: Maybe<Spirit_Topic_Notification_Topicnotification_Mutation_Response>;
  /** insert a single row into the table: "spirit_topic_notification_topicnotification" */
  insert_spirit_topic_notification_topicnotification_one?: Maybe<Spirit_Topic_Notification_Topicnotification>;
  /** insert data into the table: "spirit_topic_private_topicprivate" */
  insert_spirit_topic_private_topicprivate?: Maybe<Spirit_Topic_Private_Topicprivate_Mutation_Response>;
  /** insert a single row into the table: "spirit_topic_private_topicprivate" */
  insert_spirit_topic_private_topicprivate_one?: Maybe<Spirit_Topic_Private_Topicprivate>;
  /** insert data into the table: "spirit_topic_topic" */
  insert_spirit_topic_topic?: Maybe<Spirit_Topic_Topic_Mutation_Response>;
  /** insert a single row into the table: "spirit_topic_topic" */
  insert_spirit_topic_topic_one?: Maybe<Spirit_Topic_Topic>;
  /** insert data into the table: "spirit_topic_unread_topicunread" */
  insert_spirit_topic_unread_topicunread?: Maybe<Spirit_Topic_Unread_Topicunread_Mutation_Response>;
  /** insert a single row into the table: "spirit_topic_unread_topicunread" */
  insert_spirit_topic_unread_topicunread_one?: Maybe<Spirit_Topic_Unread_Topicunread>;
  /** insert data into the table: "spirit_user_userprofile" */
  insert_spirit_user_userprofile?: Maybe<Spirit_User_Userprofile_Mutation_Response>;
  /** insert a single row into the table: "spirit_user_userprofile" */
  insert_spirit_user_userprofile_one?: Maybe<Spirit_User_Userprofile>;
  /** insert data into the table: "subscription_group_plan" */
  insert_subscription_group_plan?: Maybe<Subscription_Group_Plan_Mutation_Response>;
  /** insert data into the table: "subscription_group_plan_groups" */
  insert_subscription_group_plan_groups?: Maybe<Subscription_Group_Plan_Groups_Mutation_Response>;
  /** insert a single row into the table: "subscription_group_plan_groups" */
  insert_subscription_group_plan_groups_one?: Maybe<Subscription_Group_Plan_Groups>;
  /** insert a single row into the table: "subscription_group_plan" */
  insert_subscription_group_plan_one?: Maybe<Subscription_Group_Plan>;
  /** insert data into the table: "subscriptions_plancost" */
  insert_subscriptions_plancost?: Maybe<Subscriptions_Plancost_Mutation_Response>;
  /** insert a single row into the table: "subscriptions_plancost" */
  insert_subscriptions_plancost_one?: Maybe<Subscriptions_Plancost>;
  /** insert data into the table: "subscriptions_planlist" */
  insert_subscriptions_planlist?: Maybe<Subscriptions_Planlist_Mutation_Response>;
  /** insert a single row into the table: "subscriptions_planlist" */
  insert_subscriptions_planlist_one?: Maybe<Subscriptions_Planlist>;
  /** insert data into the table: "subscriptions_planlistdetail" */
  insert_subscriptions_planlistdetail?: Maybe<Subscriptions_Planlistdetail_Mutation_Response>;
  /** insert a single row into the table: "subscriptions_planlistdetail" */
  insert_subscriptions_planlistdetail_one?: Maybe<Subscriptions_Planlistdetail>;
  /** insert data into the table: "subscriptions_plantag" */
  insert_subscriptions_plantag?: Maybe<Subscriptions_Plantag_Mutation_Response>;
  /** insert a single row into the table: "subscriptions_plantag" */
  insert_subscriptions_plantag_one?: Maybe<Subscriptions_Plantag>;
  /** insert data into the table: "subscriptions_subscriptionplan" */
  insert_subscriptions_subscriptionplan?: Maybe<Subscriptions_Subscriptionplan_Mutation_Response>;
  /** insert a single row into the table: "subscriptions_subscriptionplan" */
  insert_subscriptions_subscriptionplan_one?: Maybe<Subscriptions_Subscriptionplan>;
  /** insert data into the table: "subscriptions_subscriptionplan_upgradable_plans" */
  insert_subscriptions_subscriptionplan_upgradable_plans?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Mutation_Response>;
  /** insert a single row into the table: "subscriptions_subscriptionplan_upgradable_plans" */
  insert_subscriptions_subscriptionplan_upgradable_plans_one?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** insert data into the table: "subscriptions_subscriptiontransaction" */
  insert_subscriptions_subscriptiontransaction?: Maybe<Subscriptions_Subscriptiontransaction_Mutation_Response>;
  /** insert a single row into the table: "subscriptions_subscriptiontransaction" */
  insert_subscriptions_subscriptiontransaction_one?: Maybe<Subscriptions_Subscriptiontransaction>;
  /** insert data into the table: "subscriptions_usersubscription" */
  insert_subscriptions_usersubscription?: Maybe<Subscriptions_Usersubscription_Mutation_Response>;
  /** insert a single row into the table: "subscriptions_usersubscription" */
  insert_subscriptions_usersubscription_one?: Maybe<Subscriptions_Usersubscription>;
  /** insert data into the table: "supertokens.all_auth_recipe_users" */
  insert_supertokens_all_auth_recipe_users?: Maybe<Supertokens_All_Auth_Recipe_Users_Mutation_Response>;
  /** insert a single row into the table: "supertokens.all_auth_recipe_users" */
  insert_supertokens_all_auth_recipe_users_one?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  /** insert data into the table: "supertokens.app_id_to_user_id" */
  insert_supertokens_app_id_to_user_id?: Maybe<Supertokens_App_Id_To_User_Id_Mutation_Response>;
  /** insert a single row into the table: "supertokens.app_id_to_user_id" */
  insert_supertokens_app_id_to_user_id_one?: Maybe<Supertokens_App_Id_To_User_Id>;
  /** insert data into the table: "supertokens.apps" */
  insert_supertokens_apps?: Maybe<Supertokens_Apps_Mutation_Response>;
  /** insert a single row into the table: "supertokens.apps" */
  insert_supertokens_apps_one?: Maybe<Supertokens_Apps>;
  /** insert data into the table: "supertokens.dashboard_user_sessions" */
  insert_supertokens_dashboard_user_sessions?: Maybe<Supertokens_Dashboard_User_Sessions_Mutation_Response>;
  /** insert a single row into the table: "supertokens.dashboard_user_sessions" */
  insert_supertokens_dashboard_user_sessions_one?: Maybe<Supertokens_Dashboard_User_Sessions>;
  /** insert data into the table: "supertokens.dashboard_users" */
  insert_supertokens_dashboard_users?: Maybe<Supertokens_Dashboard_Users_Mutation_Response>;
  /** insert a single row into the table: "supertokens.dashboard_users" */
  insert_supertokens_dashboard_users_one?: Maybe<Supertokens_Dashboard_Users>;
  /** insert data into the table: "supertokens.emailpassword_pswd_reset_tokens" */
  insert_supertokens_emailpassword_pswd_reset_tokens?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Mutation_Response>;
  /** insert a single row into the table: "supertokens.emailpassword_pswd_reset_tokens" */
  insert_supertokens_emailpassword_pswd_reset_tokens_one?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
  /** insert data into the table: "supertokens.emailpassword_user_to_tenant" */
  insert_supertokens_emailpassword_user_to_tenant?: Maybe<Supertokens_Emailpassword_User_To_Tenant_Mutation_Response>;
  /** insert a single row into the table: "supertokens.emailpassword_user_to_tenant" */
  insert_supertokens_emailpassword_user_to_tenant_one?: Maybe<Supertokens_Emailpassword_User_To_Tenant>;
  /** insert data into the table: "supertokens.emailpassword_users" */
  insert_supertokens_emailpassword_users?: Maybe<Supertokens_Emailpassword_Users_Mutation_Response>;
  /** insert a single row into the table: "supertokens.emailpassword_users" */
  insert_supertokens_emailpassword_users_one?: Maybe<Supertokens_Emailpassword_Users>;
  /** insert data into the table: "supertokens.emailverification_tokens" */
  insert_supertokens_emailverification_tokens?: Maybe<Supertokens_Emailverification_Tokens_Mutation_Response>;
  /** insert a single row into the table: "supertokens.emailverification_tokens" */
  insert_supertokens_emailverification_tokens_one?: Maybe<Supertokens_Emailverification_Tokens>;
  /** insert data into the table: "supertokens.emailverification_verified_emails" */
  insert_supertokens_emailverification_verified_emails?: Maybe<Supertokens_Emailverification_Verified_Emails_Mutation_Response>;
  /** insert a single row into the table: "supertokens.emailverification_verified_emails" */
  insert_supertokens_emailverification_verified_emails_one?: Maybe<Supertokens_Emailverification_Verified_Emails>;
  /** insert data into the table: "supertokens.jwt_signing_keys" */
  insert_supertokens_jwt_signing_keys?: Maybe<Supertokens_Jwt_Signing_Keys_Mutation_Response>;
  /** insert a single row into the table: "supertokens.jwt_signing_keys" */
  insert_supertokens_jwt_signing_keys_one?: Maybe<Supertokens_Jwt_Signing_Keys>;
  /** insert data into the table: "supertokens.key_value" */
  insert_supertokens_key_value?: Maybe<Supertokens_Key_Value_Mutation_Response>;
  /** insert a single row into the table: "supertokens.key_value" */
  insert_supertokens_key_value_one?: Maybe<Supertokens_Key_Value>;
  /** insert data into the table: "supertokens.passwordless_codes" */
  insert_supertokens_passwordless_codes?: Maybe<Supertokens_Passwordless_Codes_Mutation_Response>;
  /** insert a single row into the table: "supertokens.passwordless_codes" */
  insert_supertokens_passwordless_codes_one?: Maybe<Supertokens_Passwordless_Codes>;
  /** insert data into the table: "supertokens.passwordless_devices" */
  insert_supertokens_passwordless_devices?: Maybe<Supertokens_Passwordless_Devices_Mutation_Response>;
  /** insert a single row into the table: "supertokens.passwordless_devices" */
  insert_supertokens_passwordless_devices_one?: Maybe<Supertokens_Passwordless_Devices>;
  /** insert data into the table: "supertokens.passwordless_user_to_tenant" */
  insert_supertokens_passwordless_user_to_tenant?: Maybe<Supertokens_Passwordless_User_To_Tenant_Mutation_Response>;
  /** insert a single row into the table: "supertokens.passwordless_user_to_tenant" */
  insert_supertokens_passwordless_user_to_tenant_one?: Maybe<Supertokens_Passwordless_User_To_Tenant>;
  /** insert data into the table: "supertokens.passwordless_users" */
  insert_supertokens_passwordless_users?: Maybe<Supertokens_Passwordless_Users_Mutation_Response>;
  /** insert a single row into the table: "supertokens.passwordless_users" */
  insert_supertokens_passwordless_users_one?: Maybe<Supertokens_Passwordless_Users>;
  /** insert data into the table: "supertokens.role_permissions" */
  insert_supertokens_role_permissions?: Maybe<Supertokens_Role_Permissions_Mutation_Response>;
  /** insert a single row into the table: "supertokens.role_permissions" */
  insert_supertokens_role_permissions_one?: Maybe<Supertokens_Role_Permissions>;
  /** insert data into the table: "supertokens.roles" */
  insert_supertokens_roles?: Maybe<Supertokens_Roles_Mutation_Response>;
  /** insert a single row into the table: "supertokens.roles" */
  insert_supertokens_roles_one?: Maybe<Supertokens_Roles>;
  /** insert data into the table: "supertokens.session_access_token_signing_keys" */
  insert_supertokens_session_access_token_signing_keys?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Mutation_Response>;
  /** insert a single row into the table: "supertokens.session_access_token_signing_keys" */
  insert_supertokens_session_access_token_signing_keys_one?: Maybe<Supertokens_Session_Access_Token_Signing_Keys>;
  /** insert data into the table: "supertokens.session_info" */
  insert_supertokens_session_info?: Maybe<Supertokens_Session_Info_Mutation_Response>;
  /** insert a single row into the table: "supertokens.session_info" */
  insert_supertokens_session_info_one?: Maybe<Supertokens_Session_Info>;
  /** insert data into the table: "supertokens.tenant_configs" */
  insert_supertokens_tenant_configs?: Maybe<Supertokens_Tenant_Configs_Mutation_Response>;
  /** insert a single row into the table: "supertokens.tenant_configs" */
  insert_supertokens_tenant_configs_one?: Maybe<Supertokens_Tenant_Configs>;
  /** insert data into the table: "supertokens.tenant_thirdparty_provider_clients" */
  insert_supertokens_tenant_thirdparty_provider_clients?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Mutation_Response>;
  /** insert a single row into the table: "supertokens.tenant_thirdparty_provider_clients" */
  insert_supertokens_tenant_thirdparty_provider_clients_one?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients>;
  /** insert data into the table: "supertokens.tenant_thirdparty_providers" */
  insert_supertokens_tenant_thirdparty_providers?: Maybe<Supertokens_Tenant_Thirdparty_Providers_Mutation_Response>;
  /** insert a single row into the table: "supertokens.tenant_thirdparty_providers" */
  insert_supertokens_tenant_thirdparty_providers_one?: Maybe<Supertokens_Tenant_Thirdparty_Providers>;
  /** insert data into the table: "supertokens.tenants" */
  insert_supertokens_tenants?: Maybe<Supertokens_Tenants_Mutation_Response>;
  /** insert a single row into the table: "supertokens.tenants" */
  insert_supertokens_tenants_one?: Maybe<Supertokens_Tenants>;
  /** insert data into the table: "supertokens.thirdparty_user_to_tenant" */
  insert_supertokens_thirdparty_user_to_tenant?: Maybe<Supertokens_Thirdparty_User_To_Tenant_Mutation_Response>;
  /** insert a single row into the table: "supertokens.thirdparty_user_to_tenant" */
  insert_supertokens_thirdparty_user_to_tenant_one?: Maybe<Supertokens_Thirdparty_User_To_Tenant>;
  /** insert data into the table: "supertokens.thirdparty_users" */
  insert_supertokens_thirdparty_users?: Maybe<Supertokens_Thirdparty_Users_Mutation_Response>;
  /** insert a single row into the table: "supertokens.thirdparty_users" */
  insert_supertokens_thirdparty_users_one?: Maybe<Supertokens_Thirdparty_Users>;
  /** insert data into the table: "supertokens.user_additional_fields" */
  insert_supertokens_user_additional_fields?: Maybe<Supertokens_User_Additional_Fields_Mutation_Response>;
  /** insert a single row into the table: "supertokens.user_additional_fields" */
  insert_supertokens_user_additional_fields_one?: Maybe<Supertokens_User_Additional_Fields>;
  /** insert data into the table: "supertokens.user_last_active" */
  insert_supertokens_user_last_active?: Maybe<Supertokens_User_Last_Active_Mutation_Response>;
  /** insert a single row into the table: "supertokens.user_last_active" */
  insert_supertokens_user_last_active_one?: Maybe<Supertokens_User_Last_Active>;
  /** insert data into the table: "supertokens.user_metadata" */
  insert_supertokens_user_metadata?: Maybe<Supertokens_User_Metadata_Mutation_Response>;
  /** insert a single row into the table: "supertokens.user_metadata" */
  insert_supertokens_user_metadata_one?: Maybe<Supertokens_User_Metadata>;
  /** insert data into the table: "supertokens.user_public_fields" */
  insert_supertokens_user_public_fields?: Maybe<Supertokens_User_Public_Fields_Mutation_Response>;
  /** insert a single row into the table: "supertokens.user_public_fields" */
  insert_supertokens_user_public_fields_one?: Maybe<Supertokens_User_Public_Fields>;
  /** insert data into the table: "supertokens.user_roles" */
  insert_supertokens_user_roles?: Maybe<Supertokens_User_Roles_Mutation_Response>;
  /** insert a single row into the table: "supertokens.user_roles" */
  insert_supertokens_user_roles_one?: Maybe<Supertokens_User_Roles>;
  /** insert data into the table: "supertokens.userid_mapping" */
  insert_supertokens_userid_mapping?: Maybe<Supertokens_Userid_Mapping_Mutation_Response>;
  /** insert a single row into the table: "supertokens.userid_mapping" */
  insert_supertokens_userid_mapping_one?: Maybe<Supertokens_Userid_Mapping>;
  /** insert data into the table: "taggit_tag" */
  insert_taggit_tag?: Maybe<Taggit_Tag_Mutation_Response>;
  /** insert a single row into the table: "taggit_tag" */
  insert_taggit_tag_one?: Maybe<Taggit_Tag>;
  /** insert data into the table: "taggit_taggeditem" */
  insert_taggit_taggeditem?: Maybe<Taggit_Taggeditem_Mutation_Response>;
  /** insert a single row into the table: "taggit_taggeditem" */
  insert_taggit_taggeditem_one?: Maybe<Taggit_Taggeditem>;
  /** insert data into the table: "upcoming_live_classes" */
  insert_upcoming_live_classes?: Maybe<Upcoming_Live_Classes_Mutation_Response>;
  /** insert a single row into the table: "upcoming_live_classes" */
  insert_upcoming_live_classes_one?: Maybe<Upcoming_Live_Classes>;
  /** insert data into the table: "user_activities" */
  insert_user_activities?: Maybe<User_Activities_Mutation_Response>;
  /** insert a single row into the table: "user_activities" */
  insert_user_activities_one?: Maybe<User_Activities>;
  /** insert data into the table: "user_activity" */
  insert_user_activity?: Maybe<User_Activity_Mutation_Response>;
  /** insert data into the table: "user_activity_lesson_entries" */
  insert_user_activity_lesson_entries?: Maybe<User_Activity_Lesson_Entries_Mutation_Response>;
  /** insert a single row into the table: "user_activity_lesson_entries" */
  insert_user_activity_lesson_entries_one?: Maybe<User_Activity_Lesson_Entries>;
  /** insert a single row into the table: "user_activity" */
  insert_user_activity_one?: Maybe<User_Activity>;
  /** insert data into the table: "user_cat_registration_data" */
  insert_user_cat_registration_data?: Maybe<User_Cat_Registration_Data_Mutation_Response>;
  /** insert a single row into the table: "user_cat_registration_data" */
  insert_user_cat_registration_data_one?: Maybe<User_Cat_Registration_Data>;
  /** insert data into the table: "user_cat_response_sheet_data" */
  insert_user_cat_response_sheet_data?: Maybe<User_Cat_Response_Sheet_Data_Mutation_Response>;
  /** insert a single row into the table: "user_cat_response_sheet_data" */
  insert_user_cat_response_sheet_data_one?: Maybe<User_Cat_Response_Sheet_Data>;
  /** insert data into the table: "user_custom_planned_activities" */
  insert_user_custom_planned_activities?: Maybe<User_Custom_Planned_Activities_Mutation_Response>;
  /** insert a single row into the table: "user_custom_planned_activities" */
  insert_user_custom_planned_activities_one?: Maybe<User_Custom_Planned_Activities>;
  /** insert data into the table: "user_leaderboard_types" */
  insert_user_leaderboard_types?: Maybe<User_Leaderboard_Types_Mutation_Response>;
  /** insert a single row into the table: "user_leaderboard_types" */
  insert_user_leaderboard_types_one?: Maybe<User_Leaderboard_Types>;
  /** insert data into the table: "user_leaderboards" */
  insert_user_leaderboards?: Maybe<User_Leaderboards_Mutation_Response>;
  /** insert a single row into the table: "user_leaderboards" */
  insert_user_leaderboards_one?: Maybe<User_Leaderboards>;
  /** insert data into the table: "user_learn_activities" */
  insert_user_learn_activities?: Maybe<User_Learn_Activities_Mutation_Response>;
  /** insert a single row into the table: "user_learn_activities" */
  insert_user_learn_activities_one?: Maybe<User_Learn_Activities>;
  /** insert data into the table: "user_learn_category_progress" */
  insert_user_learn_category_progress?: Maybe<User_Learn_Category_Progress_Mutation_Response>;
  /** insert a single row into the table: "user_learn_category_progress" */
  insert_user_learn_category_progress_one?: Maybe<User_Learn_Category_Progress>;
  /** insert data into the table: "user_learn_completed_topics" */
  insert_user_learn_completed_topics?: Maybe<User_Learn_Completed_Topics_Mutation_Response>;
  /** insert a single row into the table: "user_learn_completed_topics" */
  insert_user_learn_completed_topics_one?: Maybe<User_Learn_Completed_Topics>;
  /** insert data into the table: "user_learn_modules_summary" */
  insert_user_learn_modules_summary?: Maybe<User_Learn_Modules_Summary_Mutation_Response>;
  /** insert a single row into the table: "user_learn_modules_summary" */
  insert_user_learn_modules_summary_one?: Maybe<User_Learn_Modules_Summary>;
  /** insert data into the table: "user_learn_track_record" */
  insert_user_learn_track_record?: Maybe<User_Learn_Track_Record_Mutation_Response>;
  /** insert data into the table: "user_learn_track_record_bookmarked_topics" */
  insert_user_learn_track_record_bookmarked_topics?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Mutation_Response>;
  /** insert a single row into the table: "user_learn_track_record_bookmarked_topics" */
  insert_user_learn_track_record_bookmarked_topics_one?: Maybe<User_Learn_Track_Record_Bookmarked_Topics>;
  /** insert a single row into the table: "user_learn_track_record" */
  insert_user_learn_track_record_one?: Maybe<User_Learn_Track_Record>;
  /** insert data into the table: "user_learn_track_record_which_topics" */
  insert_user_learn_track_record_which_topics?: Maybe<User_Learn_Track_Record_Which_Topics_Mutation_Response>;
  /** insert a single row into the table: "user_learn_track_record_which_topics" */
  insert_user_learn_track_record_which_topics_one?: Maybe<User_Learn_Track_Record_Which_Topics>;
  /** insert data into the table: "user_planned_activities" */
  insert_user_planned_activities?: Maybe<User_Planned_Activities_Mutation_Response>;
  /** insert a single row into the table: "user_planned_activities" */
  insert_user_planned_activities_one?: Maybe<User_Planned_Activities>;
  /** insert data into the table: "user_pov_summaries" */
  insert_user_pov_summaries?: Maybe<User_Pov_Summaries_Mutation_Response>;
  /** insert a single row into the table: "user_pov_summaries" */
  insert_user_pov_summaries_one?: Maybe<User_Pov_Summaries>;
  /** insert data into the table: "user_quiz_question_attempts" */
  insert_user_quiz_question_attempts?: Maybe<User_Quiz_Question_Attempts_Mutation_Response>;
  /** insert a single row into the table: "user_quiz_question_attempts" */
  insert_user_quiz_question_attempts_one?: Maybe<User_Quiz_Question_Attempts>;
  /** insert data into the table: "user_quiz_question_positions" */
  insert_user_quiz_question_positions?: Maybe<User_Quiz_Question_Positions_Mutation_Response>;
  /** insert a single row into the table: "user_quiz_question_positions" */
  insert_user_quiz_question_positions_one?: Maybe<User_Quiz_Question_Positions>;
  /** insert data into the table: "user_quiz_question_summaries" */
  insert_user_quiz_question_summaries?: Maybe<User_Quiz_Question_Summaries_Mutation_Response>;
  /** insert data into the table: "user_quiz_question_summaries_old" */
  insert_user_quiz_question_summaries_old?: Maybe<User_Quiz_Question_Summaries_Old_Mutation_Response>;
  /** insert a single row into the table: "user_quiz_question_summaries_old" */
  insert_user_quiz_question_summaries_old_one?: Maybe<User_Quiz_Question_Summaries_Old>;
  /** insert a single row into the table: "user_quiz_question_summaries" */
  insert_user_quiz_question_summaries_one?: Maybe<User_Quiz_Question_Summaries>;
  /** insert data into the table: "user_quiz_questions" */
  insert_user_quiz_questions?: Maybe<User_Quiz_Questions_Mutation_Response>;
  /** insert a single row into the table: "user_quiz_questions" */
  insert_user_quiz_questions_one?: Maybe<User_Quiz_Questions>;
  /** insert data into the table: "user_quiz_section_summaries" */
  insert_user_quiz_section_summaries?: Maybe<User_Quiz_Section_Summaries_Mutation_Response>;
  /** insert a single row into the table: "user_quiz_section_summaries" */
  insert_user_quiz_section_summaries_one?: Maybe<User_Quiz_Section_Summaries>;
  /** insert data into the table: "user_quiz_summaries" */
  insert_user_quiz_summaries?: Maybe<User_Quiz_Summaries_Mutation_Response>;
  /** insert data into the table: "user_quiz_summaries_old" */
  insert_user_quiz_summaries_old?: Maybe<User_Quiz_Summaries_Old_Mutation_Response>;
  /** insert a single row into the table: "user_quiz_summaries_old" */
  insert_user_quiz_summaries_old_one?: Maybe<User_Quiz_Summaries_Old>;
  /** insert a single row into the table: "user_quiz_summaries" */
  insert_user_quiz_summaries_one?: Maybe<User_Quiz_Summaries>;
  /** insert data into the table: "user_section_summaries" */
  insert_user_section_summaries?: Maybe<User_Section_Summaries_Mutation_Response>;
  /** insert a single row into the table: "user_section_summaries" */
  insert_user_section_summaries_one?: Maybe<User_Section_Summaries>;
  /** insert data into the table: "user_speed_test_questions_summaries" */
  insert_user_speed_test_questions_summaries?: Maybe<User_Speed_Test_Questions_Summaries_Mutation_Response>;
  /** insert a single row into the table: "user_speed_test_questions_summaries" */
  insert_user_speed_test_questions_summaries_one?: Maybe<User_Speed_Test_Questions_Summaries>;
  /** insert data into the table: "user_speed_tests_summaries" */
  insert_user_speed_tests_summaries?: Maybe<User_Speed_Tests_Summaries_Mutation_Response>;
  /** insert a single row into the table: "user_speed_tests_summaries" */
  insert_user_speed_tests_summaries_one?: Maybe<User_Speed_Tests_Summaries>;
  /** insert data into the table: "user_timed_quiz_summary" */
  insert_user_timed_quiz_summary?: Maybe<User_Timed_Quiz_Summary_Mutation_Response>;
  /** insert a single row into the table: "user_timed_quiz_summary" */
  insert_user_timed_quiz_summary_one?: Maybe<User_Timed_Quiz_Summary>;
  /** insert data into the table: "user_total_score" */
  insert_user_total_score?: Maybe<User_Total_Score_Mutation_Response>;
  /** insert a single row into the table: "user_total_score" */
  insert_user_total_score_one?: Maybe<User_Total_Score>;
  /** insert data into the table: "user_xp_transaction_summaries" */
  insert_user_xp_transaction_summaries?: Maybe<User_Xp_Transaction_Summaries_Mutation_Response>;
  /** insert a single row into the table: "user_xp_transaction_summaries" */
  insert_user_xp_transaction_summaries_one?: Maybe<User_Xp_Transaction_Summaries>;
  /** insert data into the table: "user_xp_transactions" */
  insert_user_xp_transactions?: Maybe<User_Xp_Transactions_Mutation_Response>;
  /** insert a single row into the table: "user_xp_transactions" */
  insert_user_xp_transactions_one?: Maybe<User_Xp_Transactions>;
  /** insert data into the table: "users_user" */
  insert_users_user?: Maybe<Users_User_Mutation_Response>;
  /** insert data into the table: "users_user_groups" */
  insert_users_user_groups?: Maybe<Users_User_Groups_Mutation_Response>;
  /** insert a single row into the table: "users_user_groups" */
  insert_users_user_groups_one?: Maybe<Users_User_Groups>;
  /** insert a single row into the table: "users_user" */
  insert_users_user_one?: Maybe<Users_User>;
  /** insert data into the table: "users_user_user_permissions" */
  insert_users_user_user_permissions?: Maybe<Users_User_User_Permissions_Mutation_Response>;
  /** insert a single row into the table: "users_user_user_permissions" */
  insert_users_user_user_permissions_one?: Maybe<Users_User_User_Permissions>;
  /** insert data into the table: "users_userquestionsummary" */
  insert_users_userquestionsummary?: Maybe<Users_Userquestionsummary_Mutation_Response>;
  /** insert a single row into the table: "users_userquestionsummary" */
  insert_users_userquestionsummary_one?: Maybe<Users_Userquestionsummary>;
  /** insert data into the table: "users_userquizsummary" */
  insert_users_userquizsummary?: Maybe<Users_Userquizsummary_Mutation_Response>;
  /** insert a single row into the table: "users_userquizsummary" */
  insert_users_userquizsummary_one?: Maybe<Users_Userquizsummary>;
  /** insert data into the table: "users_userquiztimesummary" */
  insert_users_userquiztimesummary?: Maybe<Users_Userquiztimesummary_Mutation_Response>;
  /** insert a single row into the table: "users_userquiztimesummary" */
  insert_users_userquiztimesummary_one?: Maybe<Users_Userquiztimesummary>;
  /** insert data into the table: "users_usersectionsummary" */
  insert_users_usersectionsummary?: Maybe<Users_Usersectionsummary_Mutation_Response>;
  /** insert a single row into the table: "users_usersectionsummary" */
  insert_users_usersectionsummary_one?: Maybe<Users_Usersectionsummary>;
  /** insert data into the table: "utils_configuration" */
  insert_utils_configuration?: Maybe<Utils_Configuration_Mutation_Response>;
  /** insert a single row into the table: "utils_configuration" */
  insert_utils_configuration_one?: Maybe<Utils_Configuration>;
  /** insert data into the table: "xp_transaction_types" */
  insert_xp_transaction_types?: Maybe<Xp_Transaction_Types_Mutation_Response>;
  /** insert a single row into the table: "xp_transaction_types" */
  insert_xp_transaction_types_one?: Maybe<Xp_Transaction_Types>;
  joinMeeting: GenericResponse;
  kickUser: GenericResponse;
  leaveChannel: GenericResponse;
  login: LoginResponse;
  pinMessage: GenericResponse;
  ping: Scalars['String']['output'];
  resetPassword: GenericResponse;
  resetUserPassword: GenericResponse;
  saveLiveQuizResponse: GenericResponse;
  saveTimedTestResponse: GenericResponse;
  schedulePlanner: GenericResponse;
  sendOfflineLeadOtp: GenericResponse;
  sendVerificationEmail: GenericResponse;
  sendVerificationOtp: GenericResponse;
  signUp: GenericResponse;
  updateChannelStatus: GenericResponse;
  updateGroupProfile: GenericResponse;
  updateProfileData: GenericResponse;
  /** update data of the table: "account_emailaddress" */
  update_account_emailaddress?: Maybe<Account_Emailaddress_Mutation_Response>;
  /** update single row of the table: "account_emailaddress" */
  update_account_emailaddress_by_pk?: Maybe<Account_Emailaddress>;
  /** update multiples rows of table: "account_emailaddress" */
  update_account_emailaddress_many?: Maybe<Array<Maybe<Account_Emailaddress_Mutation_Response>>>;
  /** update data of the table: "account_emailconfirmation" */
  update_account_emailconfirmation?: Maybe<Account_Emailconfirmation_Mutation_Response>;
  /** update single row of the table: "account_emailconfirmation" */
  update_account_emailconfirmation_by_pk?: Maybe<Account_Emailconfirmation>;
  /** update multiples rows of table: "account_emailconfirmation" */
  update_account_emailconfirmation_many?: Maybe<Array<Maybe<Account_Emailconfirmation_Mutation_Response>>>;
  /** update data of the table: "accounts_catscores" */
  update_accounts_catscores?: Maybe<Accounts_Catscores_Mutation_Response>;
  /** update single row of the table: "accounts_catscores" */
  update_accounts_catscores_by_pk?: Maybe<Accounts_Catscores>;
  /** update multiples rows of table: "accounts_catscores" */
  update_accounts_catscores_many?: Maybe<Array<Maybe<Accounts_Catscores_Mutation_Response>>>;
  /** update data of the table: "accounts_loggedinuser" */
  update_accounts_loggedinuser?: Maybe<Accounts_Loggedinuser_Mutation_Response>;
  /** update single row of the table: "accounts_loggedinuser" */
  update_accounts_loggedinuser_by_pk?: Maybe<Accounts_Loggedinuser>;
  /** update multiples rows of table: "accounts_loggedinuser" */
  update_accounts_loggedinuser_many?: Maybe<Array<Maybe<Accounts_Loggedinuser_Mutation_Response>>>;
  /** update data of the table: "activity_types" */
  update_activity_types?: Maybe<Activity_Types_Mutation_Response>;
  /** update single row of the table: "activity_types" */
  update_activity_types_by_pk?: Maybe<Activity_Types>;
  /** update multiples rows of table: "activity_types" */
  update_activity_types_many?: Maybe<Array<Maybe<Activity_Types_Mutation_Response>>>;
  /** update data of the table: "admin_constants" */
  update_admin_constants?: Maybe<Admin_Constants_Mutation_Response>;
  /** update single row of the table: "admin_constants" */
  update_admin_constants_by_pk?: Maybe<Admin_Constants>;
  /** update multiples rows of table: "admin_constants" */
  update_admin_constants_many?: Maybe<Array<Maybe<Admin_Constants_Mutation_Response>>>;
  /** update data of the table: "admin_users" */
  update_admin_users?: Maybe<Admin_Users_Mutation_Response>;
  /** update single row of the table: "admin_users" */
  update_admin_users_by_pk?: Maybe<Admin_Users>;
  /** update multiples rows of table: "admin_users" */
  update_admin_users_many?: Maybe<Array<Maybe<Admin_Users_Mutation_Response>>>;
  /** update data of the table: "advertisements" */
  update_advertisements?: Maybe<Advertisements_Mutation_Response>;
  /** update single row of the table: "advertisements" */
  update_advertisements_by_pk?: Maybe<Advertisements>;
  /** update multiples rows of table: "advertisements" */
  update_advertisements_many?: Maybe<Array<Maybe<Advertisements_Mutation_Response>>>;
  /** update data of the table: "andablog_entry" */
  update_andablog_entry?: Maybe<Andablog_Entry_Mutation_Response>;
  /** update single row of the table: "andablog_entry" */
  update_andablog_entry_by_pk?: Maybe<Andablog_Entry>;
  /** update multiples rows of table: "andablog_entry" */
  update_andablog_entry_many?: Maybe<Array<Maybe<Andablog_Entry_Mutation_Response>>>;
  /** update data of the table: "andablog_entryimage" */
  update_andablog_entryimage?: Maybe<Andablog_Entryimage_Mutation_Response>;
  /** update single row of the table: "andablog_entryimage" */
  update_andablog_entryimage_by_pk?: Maybe<Andablog_Entryimage>;
  /** update multiples rows of table: "andablog_entryimage" */
  update_andablog_entryimage_many?: Maybe<Array<Maybe<Andablog_Entryimage_Mutation_Response>>>;
  /** update data of the table: "andablog_news" */
  update_andablog_news?: Maybe<Andablog_News_Mutation_Response>;
  /** update single row of the table: "andablog_news" */
  update_andablog_news_by_pk?: Maybe<Andablog_News>;
  /** update multiples rows of table: "andablog_news" */
  update_andablog_news_many?: Maybe<Array<Maybe<Andablog_News_Mutation_Response>>>;
  /** update data of the table: "andablog_pov" */
  update_andablog_pov?: Maybe<Andablog_Pov_Mutation_Response>;
  /** update single row of the table: "andablog_pov" */
  update_andablog_pov_by_pk?: Maybe<Andablog_Pov>;
  /** update multiples rows of table: "andablog_pov" */
  update_andablog_pov_many?: Maybe<Array<Maybe<Andablog_Pov_Mutation_Response>>>;
  /** update data of the table: "andablog_userlessontrackrecord" */
  update_andablog_userlessontrackrecord?: Maybe<Andablog_Userlessontrackrecord_Mutation_Response>;
  /** update data of the table: "andablog_userlessontrackrecord_bookmarked_topics" */
  update_andablog_userlessontrackrecord_bookmarked_topics?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Mutation_Response>;
  /** update single row of the table: "andablog_userlessontrackrecord_bookmarked_topics" */
  update_andablog_userlessontrackrecord_bookmarked_topics_by_pk?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** update multiples rows of table: "andablog_userlessontrackrecord_bookmarked_topics" */
  update_andablog_userlessontrackrecord_bookmarked_topics_many?: Maybe<Array<Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Mutation_Response>>>;
  /** update single row of the table: "andablog_userlessontrackrecord" */
  update_andablog_userlessontrackrecord_by_pk?: Maybe<Andablog_Userlessontrackrecord>;
  /** update multiples rows of table: "andablog_userlessontrackrecord" */
  update_andablog_userlessontrackrecord_many?: Maybe<Array<Maybe<Andablog_Userlessontrackrecord_Mutation_Response>>>;
  /** update data of the table: "andablog_userlessontrackrecord_which_topics" */
  update_andablog_userlessontrackrecord_which_topics?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Mutation_Response>;
  /** update single row of the table: "andablog_userlessontrackrecord_which_topics" */
  update_andablog_userlessontrackrecord_which_topics_by_pk?: Maybe<Andablog_Userlessontrackrecord_Which_Topics>;
  /** update multiples rows of table: "andablog_userlessontrackrecord_which_topics" */
  update_andablog_userlessontrackrecord_which_topics_many?: Maybe<Array<Maybe<Andablog_Userlessontrackrecord_Which_Topics_Mutation_Response>>>;
  /** update data of the table: "andablog_video" */
  update_andablog_video?: Maybe<Andablog_Video_Mutation_Response>;
  /** update single row of the table: "andablog_video" */
  update_andablog_video_by_pk?: Maybe<Andablog_Video>;
  /** update multiples rows of table: "andablog_video" */
  update_andablog_video_many?: Maybe<Array<Maybe<Andablog_Video_Mutation_Response>>>;
  /** update data of the table: "auth.email_verifications" */
  update_auth_email_verifications?: Maybe<Auth_Email_Verifications_Mutation_Response>;
  /** update single row of the table: "auth.email_verifications" */
  update_auth_email_verifications_by_pk?: Maybe<Auth_Email_Verifications>;
  /** update multiples rows of table: "auth.email_verifications" */
  update_auth_email_verifications_many?: Maybe<Array<Maybe<Auth_Email_Verifications_Mutation_Response>>>;
  /** update data of the table: "auth_group" */
  update_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** update single row of the table: "auth_group" */
  update_auth_group_by_pk?: Maybe<Auth_Group>;
  /** update multiples rows of table: "auth_group" */
  update_auth_group_many?: Maybe<Array<Maybe<Auth_Group_Mutation_Response>>>;
  /** update data of the table: "auth_group_permissions" */
  update_auth_group_permissions?: Maybe<Auth_Group_Permissions_Mutation_Response>;
  /** update single row of the table: "auth_group_permissions" */
  update_auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** update multiples rows of table: "auth_group_permissions" */
  update_auth_group_permissions_many?: Maybe<Array<Maybe<Auth_Group_Permissions_Mutation_Response>>>;
  /** update data of the table: "auth.password_reset_tokens" */
  update_auth_password_reset_tokens?: Maybe<Auth_Password_Reset_Tokens_Mutation_Response>;
  /** update single row of the table: "auth.password_reset_tokens" */
  update_auth_password_reset_tokens_by_pk?: Maybe<Auth_Password_Reset_Tokens>;
  /** update multiples rows of table: "auth.password_reset_tokens" */
  update_auth_password_reset_tokens_many?: Maybe<Array<Maybe<Auth_Password_Reset_Tokens_Mutation_Response>>>;
  /** update data of the table: "auth_permission" */
  update_auth_permission?: Maybe<Auth_Permission_Mutation_Response>;
  /** update single row of the table: "auth_permission" */
  update_auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** update multiples rows of table: "auth_permission" */
  update_auth_permission_many?: Maybe<Array<Maybe<Auth_Permission_Mutation_Response>>>;
  /** update data of the table: "auth.session" */
  update_auth_session?: Maybe<Auth_Session_Mutation_Response>;
  /** update single row of the table: "auth.session" */
  update_auth_session_by_pk?: Maybe<Auth_Session>;
  /** update multiples rows of table: "auth.session" */
  update_auth_session_many?: Maybe<Array<Maybe<Auth_Session_Mutation_Response>>>;
  /** update data of the table: "bookmarked_learn_topics" */
  update_bookmarked_learn_topics?: Maybe<Bookmarked_Learn_Topics_Mutation_Response>;
  /** update single row of the table: "bookmarked_learn_topics" */
  update_bookmarked_learn_topics_by_pk?: Maybe<Bookmarked_Learn_Topics>;
  /** update multiples rows of table: "bookmarked_learn_topics" */
  update_bookmarked_learn_topics_many?: Maybe<Array<Maybe<Bookmarked_Learn_Topics_Mutation_Response>>>;
  /** update data of the table: "cat_percentile_constant" */
  update_cat_percentile_constant?: Maybe<Cat_Percentile_Constant_Mutation_Response>;
  /** update single row of the table: "cat_percentile_constant" */
  update_cat_percentile_constant_by_pk?: Maybe<Cat_Percentile_Constant>;
  /** update multiples rows of table: "cat_percentile_constant" */
  update_cat_percentile_constant_many?: Maybe<Array<Maybe<Cat_Percentile_Constant_Mutation_Response>>>;
  /** update data of the table: "cat_scores" */
  update_cat_scores?: Maybe<Cat_Scores_Mutation_Response>;
  /** update single row of the table: "cat_scores" */
  update_cat_scores_by_pk?: Maybe<Cat_Scores>;
  /** update multiples rows of table: "cat_scores" */
  update_cat_scores_many?: Maybe<Array<Maybe<Cat_Scores_Mutation_Response>>>;
  /** update data of the table: "channel_members" */
  update_channel_members?: Maybe<Channel_Members_Mutation_Response>;
  /** update single row of the table: "channel_members" */
  update_channel_members_by_pk?: Maybe<Channel_Members>;
  /** update multiples rows of table: "channel_members" */
  update_channel_members_many?: Maybe<Array<Maybe<Channel_Members_Mutation_Response>>>;
  /** update data of the table: "channels" */
  update_channels?: Maybe<Channels_Mutation_Response>;
  /** update single row of the table: "channels" */
  update_channels_by_pk?: Maybe<Channels>;
  /** update multiples rows of table: "channels" */
  update_channels_many?: Maybe<Array<Maybe<Channels_Mutation_Response>>>;
  /** update data of the table: "coupons_allowed_users_rule_users" */
  update_coupons_allowed_users_rule_users?: Maybe<Coupons_Allowed_Users_Rule_Users_Mutation_Response>;
  /** update single row of the table: "coupons_allowed_users_rule_users" */
  update_coupons_allowed_users_rule_users_by_pk?: Maybe<Coupons_Allowed_Users_Rule_Users>;
  /** update multiples rows of table: "coupons_allowed_users_rule_users" */
  update_coupons_allowed_users_rule_users_many?: Maybe<Array<Maybe<Coupons_Allowed_Users_Rule_Users_Mutation_Response>>>;
  /** update data of the table: "coupons_allowedusersrule" */
  update_coupons_allowedusersrule?: Maybe<Coupons_Allowedusersrule_Mutation_Response>;
  /** update single row of the table: "coupons_allowedusersrule" */
  update_coupons_allowedusersrule_by_pk?: Maybe<Coupons_Allowedusersrule>;
  /** update multiples rows of table: "coupons_allowedusersrule" */
  update_coupons_allowedusersrule_many?: Maybe<Array<Maybe<Coupons_Allowedusersrule_Mutation_Response>>>;
  /** update data of the table: "coupons_allowedusersrule_users" */
  update_coupons_allowedusersrule_users?: Maybe<Coupons_Allowedusersrule_Users_Mutation_Response>;
  /** update single row of the table: "coupons_allowedusersrule_users" */
  update_coupons_allowedusersrule_users_by_pk?: Maybe<Coupons_Allowedusersrule_Users>;
  /** update multiples rows of table: "coupons_allowedusersrule_users" */
  update_coupons_allowedusersrule_users_many?: Maybe<Array<Maybe<Coupons_Allowedusersrule_Users_Mutation_Response>>>;
  /** update data of the table: "coupons_coupon" */
  update_coupons_coupon?: Maybe<Coupons_Coupon_Mutation_Response>;
  /** update data of the table: "coupons_coupon_applicable_packages" */
  update_coupons_coupon_applicable_packages?: Maybe<Coupons_Coupon_Applicable_Packages_Mutation_Response>;
  /** update single row of the table: "coupons_coupon_applicable_packages" */
  update_coupons_coupon_applicable_packages_by_pk?: Maybe<Coupons_Coupon_Applicable_Packages>;
  /** update multiples rows of table: "coupons_coupon_applicable_packages" */
  update_coupons_coupon_applicable_packages_many?: Maybe<Array<Maybe<Coupons_Coupon_Applicable_Packages_Mutation_Response>>>;
  /** update single row of the table: "coupons_coupon" */
  update_coupons_coupon_by_pk?: Maybe<Coupons_Coupon>;
  /** update multiples rows of table: "coupons_coupon" */
  update_coupons_coupon_many?: Maybe<Array<Maybe<Coupons_Coupon_Mutation_Response>>>;
  /** update data of the table: "coupons_couponuser" */
  update_coupons_couponuser?: Maybe<Coupons_Couponuser_Mutation_Response>;
  /** update single row of the table: "coupons_couponuser" */
  update_coupons_couponuser_by_pk?: Maybe<Coupons_Couponuser>;
  /** update multiples rows of table: "coupons_couponuser" */
  update_coupons_couponuser_many?: Maybe<Array<Maybe<Coupons_Couponuser_Mutation_Response>>>;
  /** update data of the table: "coupons_discount" */
  update_coupons_discount?: Maybe<Coupons_Discount_Mutation_Response>;
  /** update single row of the table: "coupons_discount" */
  update_coupons_discount_by_pk?: Maybe<Coupons_Discount>;
  /** update multiples rows of table: "coupons_discount" */
  update_coupons_discount_many?: Maybe<Array<Maybe<Coupons_Discount_Mutation_Response>>>;
  /** update data of the table: "coupons_maxusesrule" */
  update_coupons_maxusesrule?: Maybe<Coupons_Maxusesrule_Mutation_Response>;
  /** update single row of the table: "coupons_maxusesrule" */
  update_coupons_maxusesrule_by_pk?: Maybe<Coupons_Maxusesrule>;
  /** update multiples rows of table: "coupons_maxusesrule" */
  update_coupons_maxusesrule_many?: Maybe<Array<Maybe<Coupons_Maxusesrule_Mutation_Response>>>;
  /** update data of the table: "coupons_ruleset" */
  update_coupons_ruleset?: Maybe<Coupons_Ruleset_Mutation_Response>;
  /** update single row of the table: "coupons_ruleset" */
  update_coupons_ruleset_by_pk?: Maybe<Coupons_Ruleset>;
  /** update multiples rows of table: "coupons_ruleset" */
  update_coupons_ruleset_many?: Maybe<Array<Maybe<Coupons_Ruleset_Mutation_Response>>>;
  /** update data of the table: "coupons_validityrule" */
  update_coupons_validityrule?: Maybe<Coupons_Validityrule_Mutation_Response>;
  /** update single row of the table: "coupons_validityrule" */
  update_coupons_validityrule_by_pk?: Maybe<Coupons_Validityrule>;
  /** update multiples rows of table: "coupons_validityrule" */
  update_coupons_validityrule_many?: Maybe<Array<Maybe<Coupons_Validityrule_Mutation_Response>>>;
  /** update data of the table: "django_admin_log" */
  update_django_admin_log?: Maybe<Django_Admin_Log_Mutation_Response>;
  /** update single row of the table: "django_admin_log" */
  update_django_admin_log_by_pk?: Maybe<Django_Admin_Log>;
  /** update multiples rows of table: "django_admin_log" */
  update_django_admin_log_many?: Maybe<Array<Maybe<Django_Admin_Log_Mutation_Response>>>;
  /** update data of the table: "django_content_type" */
  update_django_content_type?: Maybe<Django_Content_Type_Mutation_Response>;
  /** update single row of the table: "django_content_type" */
  update_django_content_type_by_pk?: Maybe<Django_Content_Type>;
  /** update multiples rows of table: "django_content_type" */
  update_django_content_type_many?: Maybe<Array<Maybe<Django_Content_Type_Mutation_Response>>>;
  /** update data of the table: "django_migrations" */
  update_django_migrations?: Maybe<Django_Migrations_Mutation_Response>;
  /** update single row of the table: "django_migrations" */
  update_django_migrations_by_pk?: Maybe<Django_Migrations>;
  /** update multiples rows of table: "django_migrations" */
  update_django_migrations_many?: Maybe<Array<Maybe<Django_Migrations_Mutation_Response>>>;
  /** update data of the table: "django_session" */
  update_django_session?: Maybe<Django_Session_Mutation_Response>;
  /** update single row of the table: "django_session" */
  update_django_session_by_pk?: Maybe<Django_Session>;
  /** update multiples rows of table: "django_session" */
  update_django_session_many?: Maybe<Array<Maybe<Django_Session_Mutation_Response>>>;
  /** update data of the table: "django_site" */
  update_django_site?: Maybe<Django_Site_Mutation_Response>;
  /** update single row of the table: "django_site" */
  update_django_site_by_pk?: Maybe<Django_Site>;
  /** update multiples rows of table: "django_site" */
  update_django_site_many?: Maybe<Array<Maybe<Django_Site_Mutation_Response>>>;
  /** update data of the table: "djconfig_config" */
  update_djconfig_config?: Maybe<Djconfig_Config_Mutation_Response>;
  /** update single row of the table: "djconfig_config" */
  update_djconfig_config_by_pk?: Maybe<Djconfig_Config>;
  /** update multiples rows of table: "djconfig_config" */
  update_djconfig_config_many?: Maybe<Array<Maybe<Djconfig_Config_Mutation_Response>>>;
  /** update data of the table: "group_category" */
  update_group_category?: Maybe<Group_Category_Mutation_Response>;
  /** update single row of the table: "group_category" */
  update_group_category_by_pk?: Maybe<Group_Category>;
  /** update multiples rows of table: "group_category" */
  update_group_category_many?: Maybe<Array<Maybe<Group_Category_Mutation_Response>>>;
  /** update data of the table: "group_discount_users" */
  update_group_discount_users?: Maybe<Group_Discount_Users_Mutation_Response>;
  /** update multiples rows of table: "group_discount_users" */
  update_group_discount_users_many?: Maybe<Array<Maybe<Group_Discount_Users_Mutation_Response>>>;
  /** update data of the table: "has_access" */
  update_has_access?: Maybe<Has_Access_Mutation_Response>;
  /** update multiples rows of table: "has_access" */
  update_has_access_many?: Maybe<Array<Maybe<Has_Access_Mutation_Response>>>;
  /** update data of the table: "infozone_category" */
  update_infozone_category?: Maybe<Infozone_Category_Mutation_Response>;
  /** update single row of the table: "infozone_category" */
  update_infozone_category_by_pk?: Maybe<Infozone_Category>;
  /** update multiples rows of table: "infozone_category" */
  update_infozone_category_many?: Maybe<Array<Maybe<Infozone_Category_Mutation_Response>>>;
  /** update data of the table: "infozone_infozone" */
  update_infozone_infozone?: Maybe<Infozone_Infozone_Mutation_Response>;
  /** update single row of the table: "infozone_infozone" */
  update_infozone_infozone_by_pk?: Maybe<Infozone_Infozone>;
  /** update multiples rows of table: "infozone_infozone" */
  update_infozone_infozone_many?: Maybe<Array<Maybe<Infozone_Infozone_Mutation_Response>>>;
  /** update data of the table: "infozone_staticpages" */
  update_infozone_staticpages?: Maybe<Infozone_Staticpages_Mutation_Response>;
  /** update single row of the table: "infozone_staticpages" */
  update_infozone_staticpages_by_pk?: Maybe<Infozone_Staticpages>;
  /** update multiples rows of table: "infozone_staticpages" */
  update_infozone_staticpages_many?: Maybe<Array<Maybe<Infozone_Staticpages_Mutation_Response>>>;
  /** update data of the table: "live_quiz_leaderboard" */
  update_live_quiz_leaderboard?: Maybe<Live_Quiz_Leaderboard_Mutation_Response>;
  /** update single row of the table: "live_quiz_leaderboard" */
  update_live_quiz_leaderboard_by_pk?: Maybe<Live_Quiz_Leaderboard>;
  /** update multiples rows of table: "live_quiz_leaderboard" */
  update_live_quiz_leaderboard_many?: Maybe<Array<Maybe<Live_Quiz_Leaderboard_Mutation_Response>>>;
  /** update data of the table: "live_quiz_question_positions" */
  update_live_quiz_question_positions?: Maybe<Live_Quiz_Question_Positions_Mutation_Response>;
  /** update single row of the table: "live_quiz_question_positions" */
  update_live_quiz_question_positions_by_pk?: Maybe<Live_Quiz_Question_Positions>;
  /** update multiples rows of table: "live_quiz_question_positions" */
  update_live_quiz_question_positions_many?: Maybe<Array<Maybe<Live_Quiz_Question_Positions_Mutation_Response>>>;
  /** update data of the table: "live_quiz_question_summary" */
  update_live_quiz_question_summary?: Maybe<Live_Quiz_Question_Summary_Mutation_Response>;
  /** update single row of the table: "live_quiz_question_summary" */
  update_live_quiz_question_summary_by_pk?: Maybe<Live_Quiz_Question_Summary>;
  /** update multiples rows of table: "live_quiz_question_summary" */
  update_live_quiz_question_summary_many?: Maybe<Array<Maybe<Live_Quiz_Question_Summary_Mutation_Response>>>;
  /** update data of the table: "live_quiz_summary" */
  update_live_quiz_summary?: Maybe<Live_Quiz_Summary_Mutation_Response>;
  /** update single row of the table: "live_quiz_summary" */
  update_live_quiz_summary_by_pk?: Maybe<Live_Quiz_Summary>;
  /** update multiples rows of table: "live_quiz_summary" */
  update_live_quiz_summary_many?: Maybe<Array<Maybe<Live_Quiz_Summary_Mutation_Response>>>;
  /** update data of the table: "marks_vs_percentile_dilr" */
  update_marks_vs_percentile_dilr?: Maybe<Marks_Vs_Percentile_Dilr_Mutation_Response>;
  /** update single row of the table: "marks_vs_percentile_dilr" */
  update_marks_vs_percentile_dilr_by_pk?: Maybe<Marks_Vs_Percentile_Dilr>;
  /** update multiples rows of table: "marks_vs_percentile_dilr" */
  update_marks_vs_percentile_dilr_many?: Maybe<Array<Maybe<Marks_Vs_Percentile_Dilr_Mutation_Response>>>;
  /** update data of the table: "marks_vs_percentile_quant" */
  update_marks_vs_percentile_quant?: Maybe<Marks_Vs_Percentile_Quant_Mutation_Response>;
  /** update single row of the table: "marks_vs_percentile_quant" */
  update_marks_vs_percentile_quant_by_pk?: Maybe<Marks_Vs_Percentile_Quant>;
  /** update multiples rows of table: "marks_vs_percentile_quant" */
  update_marks_vs_percentile_quant_many?: Maybe<Array<Maybe<Marks_Vs_Percentile_Quant_Mutation_Response>>>;
  /** update data of the table: "marks_vs_percentile_total_raw" */
  update_marks_vs_percentile_total_raw?: Maybe<Marks_Vs_Percentile_Total_Raw_Mutation_Response>;
  /** update single row of the table: "marks_vs_percentile_total_raw" */
  update_marks_vs_percentile_total_raw_by_pk?: Maybe<Marks_Vs_Percentile_Total_Raw>;
  /** update multiples rows of table: "marks_vs_percentile_total_raw" */
  update_marks_vs_percentile_total_raw_many?: Maybe<Array<Maybe<Marks_Vs_Percentile_Total_Raw_Mutation_Response>>>;
  /** update data of the table: "marks_vs_percentile_varc" */
  update_marks_vs_percentile_varc?: Maybe<Marks_Vs_Percentile_Varc_Mutation_Response>;
  /** update single row of the table: "marks_vs_percentile_varc" */
  update_marks_vs_percentile_varc_by_pk?: Maybe<Marks_Vs_Percentile_Varc>;
  /** update multiples rows of table: "marks_vs_percentile_varc" */
  update_marks_vs_percentile_varc_many?: Maybe<Array<Maybe<Marks_Vs_Percentile_Varc_Mutation_Response>>>;
  /** update data of the table: "marks_vs_scaled_percentile" */
  update_marks_vs_scaled_percentile?: Maybe<Marks_Vs_Scaled_Percentile_Mutation_Response>;
  /** update single row of the table: "marks_vs_scaled_percentile" */
  update_marks_vs_scaled_percentile_by_pk?: Maybe<Marks_Vs_Scaled_Percentile>;
  /** update multiples rows of table: "marks_vs_scaled_percentile" */
  update_marks_vs_scaled_percentile_many?: Maybe<Array<Maybe<Marks_Vs_Scaled_Percentile_Mutation_Response>>>;
  /** update data of the table: "meeting_members" */
  update_meeting_members?: Maybe<Meeting_Members_Mutation_Response>;
  /** update single row of the table: "meeting_members" */
  update_meeting_members_by_pk?: Maybe<Meeting_Members>;
  /** update multiples rows of table: "meeting_members" */
  update_meeting_members_many?: Maybe<Array<Maybe<Meeting_Members_Mutation_Response>>>;
  /** update data of the table: "meetings" */
  update_meetings?: Maybe<Meetings_Mutation_Response>;
  /** update single row of the table: "meetings" */
  update_meetings_by_pk?: Maybe<Meetings>;
  /** update multiples rows of table: "meetings" */
  update_meetings_many?: Maybe<Array<Maybe<Meetings_Mutation_Response>>>;
  /** update data of the table: "message_reactions" */
  update_message_reactions?: Maybe<Message_Reactions_Mutation_Response>;
  /** update single row of the table: "message_reactions" */
  update_message_reactions_by_pk?: Maybe<Message_Reactions>;
  /** update multiples rows of table: "message_reactions" */
  update_message_reactions_many?: Maybe<Array<Maybe<Message_Reactions_Mutation_Response>>>;
  /** update data of the table: "messages" */
  update_messages?: Maybe<Messages_Mutation_Response>;
  /** update single row of the table: "messages" */
  update_messages_by_pk?: Maybe<Messages>;
  /** update multiples rows of table: "messages" */
  update_messages_many?: Maybe<Array<Maybe<Messages_Mutation_Response>>>;
  /** update data of the table: "messages_read" */
  update_messages_read?: Maybe<Messages_Read_Mutation_Response>;
  /** update single row of the table: "messages_read" */
  update_messages_read_by_pk?: Maybe<Messages_Read>;
  /** update multiples rows of table: "messages_read" */
  update_messages_read_many?: Maybe<Array<Maybe<Messages_Read_Mutation_Response>>>;
  /** update data of the table: "offline_leads" */
  update_offline_leads?: Maybe<Offline_Leads_Mutation_Response>;
  /** update single row of the table: "offline_leads" */
  update_offline_leads_by_pk?: Maybe<Offline_Leads>;
  /** update multiples rows of table: "offline_leads" */
  update_offline_leads_many?: Maybe<Array<Maybe<Offline_Leads_Mutation_Response>>>;
  /** update data of the table: "package_content_discarded_quizzes" */
  update_package_content_discarded_quizzes?: Maybe<Package_Content_Discarded_Quizzes_Mutation_Response>;
  /** update single row of the table: "package_content_discarded_quizzes" */
  update_package_content_discarded_quizzes_by_pk?: Maybe<Package_Content_Discarded_Quizzes>;
  /** update multiples rows of table: "package_content_discarded_quizzes" */
  update_package_content_discarded_quizzes_many?: Maybe<Array<Maybe<Package_Content_Discarded_Quizzes_Mutation_Response>>>;
  /** update data of the table: "packages_content" */
  update_packages_content?: Maybe<Packages_Content_Mutation_Response>;
  /** update single row of the table: "packages_content" */
  update_packages_content_by_pk?: Maybe<Packages_Content>;
  /** update data of the table: "packages_content_domains" */
  update_packages_content_domains?: Maybe<Packages_Content_Domains_Mutation_Response>;
  /** update single row of the table: "packages_content_domains" */
  update_packages_content_domains_by_pk?: Maybe<Packages_Content_Domains>;
  /** update multiples rows of table: "packages_content_domains" */
  update_packages_content_domains_many?: Maybe<Array<Maybe<Packages_Content_Domains_Mutation_Response>>>;
  /** update multiples rows of table: "packages_content" */
  update_packages_content_many?: Maybe<Array<Maybe<Packages_Content_Mutation_Response>>>;
  /** update data of the table: "packages_content_text_lesson" */
  update_packages_content_text_lesson?: Maybe<Packages_Content_Text_Lesson_Mutation_Response>;
  /** update single row of the table: "packages_content_text_lesson" */
  update_packages_content_text_lesson_by_pk?: Maybe<Packages_Content_Text_Lesson>;
  /** update multiples rows of table: "packages_content_text_lesson" */
  update_packages_content_text_lesson_many?: Maybe<Array<Maybe<Packages_Content_Text_Lesson_Mutation_Response>>>;
  /** update data of the table: "packages_content_timed_test" */
  update_packages_content_timed_test?: Maybe<Packages_Content_Timed_Test_Mutation_Response>;
  /** update single row of the table: "packages_content_timed_test" */
  update_packages_content_timed_test_by_pk?: Maybe<Packages_Content_Timed_Test>;
  /** update multiples rows of table: "packages_content_timed_test" */
  update_packages_content_timed_test_many?: Maybe<Array<Maybe<Packages_Content_Timed_Test_Mutation_Response>>>;
  /** update data of the table: "packages_content_untimed_test" */
  update_packages_content_untimed_test?: Maybe<Packages_Content_Untimed_Test_Mutation_Response>;
  /** update single row of the table: "packages_content_untimed_test" */
  update_packages_content_untimed_test_by_pk?: Maybe<Packages_Content_Untimed_Test>;
  /** update multiples rows of table: "packages_content_untimed_test" */
  update_packages_content_untimed_test_many?: Maybe<Array<Maybe<Packages_Content_Untimed_Test_Mutation_Response>>>;
  /** update data of the table: "packages_payment_transaction" */
  update_packages_payment_transaction?: Maybe<Packages_Payment_Transaction_Mutation_Response>;
  /** update single row of the table: "packages_payment_transaction" */
  update_packages_payment_transaction_by_pk?: Maybe<Packages_Payment_Transaction>;
  /** update multiples rows of table: "packages_payment_transaction" */
  update_packages_payment_transaction_many?: Maybe<Array<Maybe<Packages_Payment_Transaction_Mutation_Response>>>;
  /** update data of the table: "packages_paymenttransaction" */
  update_packages_paymenttransaction?: Maybe<Packages_Paymenttransaction_Mutation_Response>;
  /** update single row of the table: "packages_paymenttransaction" */
  update_packages_paymenttransaction_by_pk?: Maybe<Packages_Paymenttransaction>;
  /** update multiples rows of table: "packages_paymenttransaction" */
  update_packages_paymenttransaction_many?: Maybe<Array<Maybe<Packages_Paymenttransaction_Mutation_Response>>>;
  /** update data of the table: "poll" */
  update_poll?: Maybe<Poll_Mutation_Response>;
  /** update single row of the table: "poll" */
  update_poll_by_pk?: Maybe<Poll>;
  /** update multiples rows of table: "poll" */
  update_poll_many?: Maybe<Array<Maybe<Poll_Mutation_Response>>>;
  /** update data of the table: "poll_options" */
  update_poll_options?: Maybe<Poll_Options_Mutation_Response>;
  /** update single row of the table: "poll_options" */
  update_poll_options_by_pk?: Maybe<Poll_Options>;
  /** update multiples rows of table: "poll_options" */
  update_poll_options_many?: Maybe<Array<Maybe<Poll_Options_Mutation_Response>>>;
  /** update data of the table: "poll_responses" */
  update_poll_responses?: Maybe<Poll_Responses_Mutation_Response>;
  /** update single row of the table: "poll_responses" */
  update_poll_responses_by_pk?: Maybe<Poll_Responses>;
  /** update multiples rows of table: "poll_responses" */
  update_poll_responses_many?: Maybe<Array<Maybe<Poll_Responses_Mutation_Response>>>;
  /** update data of the table: "question_reports" */
  update_question_reports?: Maybe<Question_Reports_Mutation_Response>;
  /** update single row of the table: "question_reports" */
  update_question_reports_by_pk?: Maybe<Question_Reports>;
  /** update multiples rows of table: "question_reports" */
  update_question_reports_many?: Maybe<Array<Maybe<Question_Reports_Mutation_Response>>>;
  /** update data of the table: "quiz_answer" */
  update_quiz_answer?: Maybe<Quiz_Answer_Mutation_Response>;
  /** update single row of the table: "quiz_answer" */
  update_quiz_answer_by_pk?: Maybe<Quiz_Answer>;
  /** update multiples rows of table: "quiz_answer" */
  update_quiz_answer_many?: Maybe<Array<Maybe<Quiz_Answer_Mutation_Response>>>;
  /** update data of the table: "quiz_category" */
  update_quiz_category?: Maybe<Quiz_Category_Mutation_Response>;
  /** update single row of the table: "quiz_category" */
  update_quiz_category_by_pk?: Maybe<Quiz_Category>;
  /** update multiples rows of table: "quiz_category" */
  update_quiz_category_many?: Maybe<Array<Maybe<Quiz_Category_Mutation_Response>>>;
  /** update data of the table: "quiz_domain" */
  update_quiz_domain?: Maybe<Quiz_Domain_Mutation_Response>;
  /** update single row of the table: "quiz_domain" */
  update_quiz_domain_by_pk?: Maybe<Quiz_Domain>;
  /** update multiples rows of table: "quiz_domain" */
  update_quiz_domain_many?: Maybe<Array<Maybe<Quiz_Domain_Mutation_Response>>>;
  /** update data of the table: "quiz_markingsystem" */
  update_quiz_markingsystem?: Maybe<Quiz_Markingsystem_Mutation_Response>;
  /** update single row of the table: "quiz_markingsystem" */
  update_quiz_markingsystem_by_pk?: Maybe<Quiz_Markingsystem>;
  /** update multiples rows of table: "quiz_markingsystem" */
  update_quiz_markingsystem_many?: Maybe<Array<Maybe<Quiz_Markingsystem_Mutation_Response>>>;
  /** update data of the table: "quiz_option" */
  update_quiz_option?: Maybe<Quiz_Option_Mutation_Response>;
  /** update single row of the table: "quiz_option" */
  update_quiz_option_by_pk?: Maybe<Quiz_Option>;
  /** update multiples rows of table: "quiz_option" */
  update_quiz_option_many?: Maybe<Array<Maybe<Quiz_Option_Mutation_Response>>>;
  /** update data of the table: "quiz_paragraph" */
  update_quiz_paragraph?: Maybe<Quiz_Paragraph_Mutation_Response>;
  /** update single row of the table: "quiz_paragraph" */
  update_quiz_paragraph_by_pk?: Maybe<Quiz_Paragraph>;
  /** update multiples rows of table: "quiz_paragraph" */
  update_quiz_paragraph_many?: Maybe<Array<Maybe<Quiz_Paragraph_Mutation_Response>>>;
  /** update data of the table: "quiz_question" */
  update_quiz_question?: Maybe<Quiz_Question_Mutation_Response>;
  /** update single row of the table: "quiz_question" */
  update_quiz_question_by_pk?: Maybe<Quiz_Question>;
  /** update multiples rows of table: "quiz_question" */
  update_quiz_question_many?: Maybe<Array<Maybe<Quiz_Question_Mutation_Response>>>;
  /** update data of the table: "quiz_quiz" */
  update_quiz_quiz?: Maybe<Quiz_Quiz_Mutation_Response>;
  /** update single row of the table: "quiz_quiz" */
  update_quiz_quiz_by_pk?: Maybe<Quiz_Quiz>;
  /** update multiples rows of table: "quiz_quiz" */
  update_quiz_quiz_many?: Maybe<Array<Maybe<Quiz_Quiz_Mutation_Response>>>;
  /** update data of the table: "quiz_quiz_questions" */
  update_quiz_quiz_questions?: Maybe<Quiz_Quiz_Questions_Mutation_Response>;
  /** update single row of the table: "quiz_quiz_questions" */
  update_quiz_quiz_questions_by_pk?: Maybe<Quiz_Quiz_Questions>;
  /** update multiples rows of table: "quiz_quiz_questions" */
  update_quiz_quiz_questions_many?: Maybe<Array<Maybe<Quiz_Quiz_Questions_Mutation_Response>>>;
  /** update data of the table: "quiz_quiz_sections" */
  update_quiz_quiz_sections?: Maybe<Quiz_Quiz_Sections_Mutation_Response>;
  /** update single row of the table: "quiz_quiz_sections" */
  update_quiz_quiz_sections_by_pk?: Maybe<Quiz_Quiz_Sections>;
  /** update multiples rows of table: "quiz_quiz_sections" */
  update_quiz_quiz_sections_many?: Maybe<Array<Maybe<Quiz_Quiz_Sections_Mutation_Response>>>;
  /** update data of the table: "quiz_section" */
  update_quiz_section?: Maybe<Quiz_Section_Mutation_Response>;
  /** update single row of the table: "quiz_section" */
  update_quiz_section_by_pk?: Maybe<Quiz_Section>;
  /** update multiples rows of table: "quiz_section" */
  update_quiz_section_many?: Maybe<Array<Maybe<Quiz_Section_Mutation_Response>>>;
  /** update data of the table: "quiz_section_questions" */
  update_quiz_section_questions?: Maybe<Quiz_Section_Questions_Mutation_Response>;
  /** update single row of the table: "quiz_section_questions" */
  update_quiz_section_questions_by_pk?: Maybe<Quiz_Section_Questions>;
  /** update multiples rows of table: "quiz_section_questions" */
  update_quiz_section_questions_many?: Maybe<Array<Maybe<Quiz_Section_Questions_Mutation_Response>>>;
  /** update data of the table: "quiz_section_subsections" */
  update_quiz_section_subsections?: Maybe<Quiz_Section_Subsections_Mutation_Response>;
  /** update single row of the table: "quiz_section_subsections" */
  update_quiz_section_subsections_by_pk?: Maybe<Quiz_Section_Subsections>;
  /** update multiples rows of table: "quiz_section_subsections" */
  update_quiz_section_subsections_many?: Maybe<Array<Maybe<Quiz_Section_Subsections_Mutation_Response>>>;
  /** update data of the table: "quiz_superdomain" */
  update_quiz_superdomain?: Maybe<Quiz_Superdomain_Mutation_Response>;
  /** update single row of the table: "quiz_superdomain" */
  update_quiz_superdomain_by_pk?: Maybe<Quiz_Superdomain>;
  /** update multiples rows of table: "quiz_superdomain" */
  update_quiz_superdomain_many?: Maybe<Array<Maybe<Quiz_Superdomain_Mutation_Response>>>;
  /** update data of the table: "random_question_ids" */
  update_random_question_ids?: Maybe<Random_Question_Ids_Mutation_Response>;
  /** update multiples rows of table: "random_question_ids" */
  update_random_question_ids_many?: Maybe<Array<Maybe<Random_Question_Ids_Mutation_Response>>>;
  /** update data of the table: "reaction_emojis" */
  update_reaction_emojis?: Maybe<Reaction_Emojis_Mutation_Response>;
  /** update single row of the table: "reaction_emojis" */
  update_reaction_emojis_by_pk?: Maybe<Reaction_Emojis>;
  /** update multiples rows of table: "reaction_emojis" */
  update_reaction_emojis_many?: Maybe<Array<Maybe<Reaction_Emojis_Mutation_Response>>>;
  /** update data of the table: "reported_message" */
  update_reported_message?: Maybe<Reported_Message_Mutation_Response>;
  /** update single row of the table: "reported_message" */
  update_reported_message_by_pk?: Maybe<Reported_Message>;
  /** update multiples rows of table: "reported_message" */
  update_reported_message_many?: Maybe<Array<Maybe<Reported_Message_Mutation_Response>>>;
  /** update data of the table: "scaling_constant" */
  update_scaling_constant?: Maybe<Scaling_Constant_Mutation_Response>;
  /** update single row of the table: "scaling_constant" */
  update_scaling_constant_by_pk?: Maybe<Scaling_Constant>;
  /** update multiples rows of table: "scaling_constant" */
  update_scaling_constant_many?: Maybe<Array<Maybe<Scaling_Constant_Mutation_Response>>>;
  /** update data of the table: "socialaccount_socialaccount" */
  update_socialaccount_socialaccount?: Maybe<Socialaccount_Socialaccount_Mutation_Response>;
  /** update single row of the table: "socialaccount_socialaccount" */
  update_socialaccount_socialaccount_by_pk?: Maybe<Socialaccount_Socialaccount>;
  /** update multiples rows of table: "socialaccount_socialaccount" */
  update_socialaccount_socialaccount_many?: Maybe<Array<Maybe<Socialaccount_Socialaccount_Mutation_Response>>>;
  /** update data of the table: "socialaccount_socialapp" */
  update_socialaccount_socialapp?: Maybe<Socialaccount_Socialapp_Mutation_Response>;
  /** update single row of the table: "socialaccount_socialapp" */
  update_socialaccount_socialapp_by_pk?: Maybe<Socialaccount_Socialapp>;
  /** update multiples rows of table: "socialaccount_socialapp" */
  update_socialaccount_socialapp_many?: Maybe<Array<Maybe<Socialaccount_Socialapp_Mutation_Response>>>;
  /** update data of the table: "socialaccount_socialapp_sites" */
  update_socialaccount_socialapp_sites?: Maybe<Socialaccount_Socialapp_Sites_Mutation_Response>;
  /** update single row of the table: "socialaccount_socialapp_sites" */
  update_socialaccount_socialapp_sites_by_pk?: Maybe<Socialaccount_Socialapp_Sites>;
  /** update multiples rows of table: "socialaccount_socialapp_sites" */
  update_socialaccount_socialapp_sites_many?: Maybe<Array<Maybe<Socialaccount_Socialapp_Sites_Mutation_Response>>>;
  /** update data of the table: "socialaccount_socialtoken" */
  update_socialaccount_socialtoken?: Maybe<Socialaccount_Socialtoken_Mutation_Response>;
  /** update single row of the table: "socialaccount_socialtoken" */
  update_socialaccount_socialtoken_by_pk?: Maybe<Socialaccount_Socialtoken>;
  /** update multiples rows of table: "socialaccount_socialtoken" */
  update_socialaccount_socialtoken_many?: Maybe<Array<Maybe<Socialaccount_Socialtoken_Mutation_Response>>>;
  /** update data of the table: "speed_test_category" */
  update_speed_test_category?: Maybe<Speed_Test_Category_Mutation_Response>;
  /** update single row of the table: "speed_test_category" */
  update_speed_test_category_by_pk?: Maybe<Speed_Test_Category>;
  /** update multiples rows of table: "speed_test_category" */
  update_speed_test_category_many?: Maybe<Array<Maybe<Speed_Test_Category_Mutation_Response>>>;
  /** update data of the table: "speed_tests" */
  update_speed_tests?: Maybe<Speed_Tests_Mutation_Response>;
  /** update single row of the table: "speed_tests" */
  update_speed_tests_by_pk?: Maybe<Speed_Tests>;
  /** update multiples rows of table: "speed_tests" */
  update_speed_tests_many?: Maybe<Array<Maybe<Speed_Tests_Mutation_Response>>>;
  /** update data of the table: "spirit_cache" */
  update_spirit_cache?: Maybe<Spirit_Cache_Mutation_Response>;
  /** update single row of the table: "spirit_cache" */
  update_spirit_cache_by_pk?: Maybe<Spirit_Cache>;
  /** update multiples rows of table: "spirit_cache" */
  update_spirit_cache_many?: Maybe<Array<Maybe<Spirit_Cache_Mutation_Response>>>;
  /** update data of the table: "spirit_category_category" */
  update_spirit_category_category?: Maybe<Spirit_Category_Category_Mutation_Response>;
  /** update single row of the table: "spirit_category_category" */
  update_spirit_category_category_by_pk?: Maybe<Spirit_Category_Category>;
  /** update multiples rows of table: "spirit_category_category" */
  update_spirit_category_category_many?: Maybe<Array<Maybe<Spirit_Category_Category_Mutation_Response>>>;
  /** update data of the table: "spirit_comment_bookmark_commentbookmark" */
  update_spirit_comment_bookmark_commentbookmark?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Mutation_Response>;
  /** update single row of the table: "spirit_comment_bookmark_commentbookmark" */
  update_spirit_comment_bookmark_commentbookmark_by_pk?: Maybe<Spirit_Comment_Bookmark_Commentbookmark>;
  /** update multiples rows of table: "spirit_comment_bookmark_commentbookmark" */
  update_spirit_comment_bookmark_commentbookmark_many?: Maybe<Array<Maybe<Spirit_Comment_Bookmark_Commentbookmark_Mutation_Response>>>;
  /** update data of the table: "spirit_comment_comment" */
  update_spirit_comment_comment?: Maybe<Spirit_Comment_Comment_Mutation_Response>;
  /** update single row of the table: "spirit_comment_comment" */
  update_spirit_comment_comment_by_pk?: Maybe<Spirit_Comment_Comment>;
  /** update multiples rows of table: "spirit_comment_comment" */
  update_spirit_comment_comment_many?: Maybe<Array<Maybe<Spirit_Comment_Comment_Mutation_Response>>>;
  /** update data of the table: "spirit_comment_flag_commentflag" */
  update_spirit_comment_flag_commentflag?: Maybe<Spirit_Comment_Flag_Commentflag_Mutation_Response>;
  /** update single row of the table: "spirit_comment_flag_commentflag" */
  update_spirit_comment_flag_commentflag_by_pk?: Maybe<Spirit_Comment_Flag_Commentflag>;
  /** update multiples rows of table: "spirit_comment_flag_commentflag" */
  update_spirit_comment_flag_commentflag_many?: Maybe<Array<Maybe<Spirit_Comment_Flag_Commentflag_Mutation_Response>>>;
  /** update data of the table: "spirit_comment_flag_flag" */
  update_spirit_comment_flag_flag?: Maybe<Spirit_Comment_Flag_Flag_Mutation_Response>;
  /** update single row of the table: "spirit_comment_flag_flag" */
  update_spirit_comment_flag_flag_by_pk?: Maybe<Spirit_Comment_Flag_Flag>;
  /** update multiples rows of table: "spirit_comment_flag_flag" */
  update_spirit_comment_flag_flag_many?: Maybe<Array<Maybe<Spirit_Comment_Flag_Flag_Mutation_Response>>>;
  /** update data of the table: "spirit_comment_history_commenthistory" */
  update_spirit_comment_history_commenthistory?: Maybe<Spirit_Comment_History_Commenthistory_Mutation_Response>;
  /** update single row of the table: "spirit_comment_history_commenthistory" */
  update_spirit_comment_history_commenthistory_by_pk?: Maybe<Spirit_Comment_History_Commenthistory>;
  /** update multiples rows of table: "spirit_comment_history_commenthistory" */
  update_spirit_comment_history_commenthistory_many?: Maybe<Array<Maybe<Spirit_Comment_History_Commenthistory_Mutation_Response>>>;
  /** update data of the table: "spirit_comment_like_commentlike" */
  update_spirit_comment_like_commentlike?: Maybe<Spirit_Comment_Like_Commentlike_Mutation_Response>;
  /** update single row of the table: "spirit_comment_like_commentlike" */
  update_spirit_comment_like_commentlike_by_pk?: Maybe<Spirit_Comment_Like_Commentlike>;
  /** update multiples rows of table: "spirit_comment_like_commentlike" */
  update_spirit_comment_like_commentlike_many?: Maybe<Array<Maybe<Spirit_Comment_Like_Commentlike_Mutation_Response>>>;
  /** update data of the table: "spirit_comment_poll_commentpoll" */
  update_spirit_comment_poll_commentpoll?: Maybe<Spirit_Comment_Poll_Commentpoll_Mutation_Response>;
  /** update single row of the table: "spirit_comment_poll_commentpoll" */
  update_spirit_comment_poll_commentpoll_by_pk?: Maybe<Spirit_Comment_Poll_Commentpoll>;
  /** update multiples rows of table: "spirit_comment_poll_commentpoll" */
  update_spirit_comment_poll_commentpoll_many?: Maybe<Array<Maybe<Spirit_Comment_Poll_Commentpoll_Mutation_Response>>>;
  /** update data of the table: "spirit_comment_poll_commentpollchoice" */
  update_spirit_comment_poll_commentpollchoice?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Mutation_Response>;
  /** update single row of the table: "spirit_comment_poll_commentpollchoice" */
  update_spirit_comment_poll_commentpollchoice_by_pk?: Maybe<Spirit_Comment_Poll_Commentpollchoice>;
  /** update multiples rows of table: "spirit_comment_poll_commentpollchoice" */
  update_spirit_comment_poll_commentpollchoice_many?: Maybe<Array<Maybe<Spirit_Comment_Poll_Commentpollchoice_Mutation_Response>>>;
  /** update data of the table: "spirit_comment_poll_commentpollvote" */
  update_spirit_comment_poll_commentpollvote?: Maybe<Spirit_Comment_Poll_Commentpollvote_Mutation_Response>;
  /** update single row of the table: "spirit_comment_poll_commentpollvote" */
  update_spirit_comment_poll_commentpollvote_by_pk?: Maybe<Spirit_Comment_Poll_Commentpollvote>;
  /** update multiples rows of table: "spirit_comment_poll_commentpollvote" */
  update_spirit_comment_poll_commentpollvote_many?: Maybe<Array<Maybe<Spirit_Comment_Poll_Commentpollvote_Mutation_Response>>>;
  /** update data of the table: "spirit_rl_cache" */
  update_spirit_rl_cache?: Maybe<Spirit_Rl_Cache_Mutation_Response>;
  /** update single row of the table: "spirit_rl_cache" */
  update_spirit_rl_cache_by_pk?: Maybe<Spirit_Rl_Cache>;
  /** update multiples rows of table: "spirit_rl_cache" */
  update_spirit_rl_cache_many?: Maybe<Array<Maybe<Spirit_Rl_Cache_Mutation_Response>>>;
  /** update data of the table: "spirit_topic_favorite_topicfavorite" */
  update_spirit_topic_favorite_topicfavorite?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Mutation_Response>;
  /** update single row of the table: "spirit_topic_favorite_topicfavorite" */
  update_spirit_topic_favorite_topicfavorite_by_pk?: Maybe<Spirit_Topic_Favorite_Topicfavorite>;
  /** update multiples rows of table: "spirit_topic_favorite_topicfavorite" */
  update_spirit_topic_favorite_topicfavorite_many?: Maybe<Array<Maybe<Spirit_Topic_Favorite_Topicfavorite_Mutation_Response>>>;
  /** update data of the table: "spirit_topic_notification_topicnotification" */
  update_spirit_topic_notification_topicnotification?: Maybe<Spirit_Topic_Notification_Topicnotification_Mutation_Response>;
  /** update single row of the table: "spirit_topic_notification_topicnotification" */
  update_spirit_topic_notification_topicnotification_by_pk?: Maybe<Spirit_Topic_Notification_Topicnotification>;
  /** update multiples rows of table: "spirit_topic_notification_topicnotification" */
  update_spirit_topic_notification_topicnotification_many?: Maybe<Array<Maybe<Spirit_Topic_Notification_Topicnotification_Mutation_Response>>>;
  /** update data of the table: "spirit_topic_private_topicprivate" */
  update_spirit_topic_private_topicprivate?: Maybe<Spirit_Topic_Private_Topicprivate_Mutation_Response>;
  /** update single row of the table: "spirit_topic_private_topicprivate" */
  update_spirit_topic_private_topicprivate_by_pk?: Maybe<Spirit_Topic_Private_Topicprivate>;
  /** update multiples rows of table: "spirit_topic_private_topicprivate" */
  update_spirit_topic_private_topicprivate_many?: Maybe<Array<Maybe<Spirit_Topic_Private_Topicprivate_Mutation_Response>>>;
  /** update data of the table: "spirit_topic_topic" */
  update_spirit_topic_topic?: Maybe<Spirit_Topic_Topic_Mutation_Response>;
  /** update single row of the table: "spirit_topic_topic" */
  update_spirit_topic_topic_by_pk?: Maybe<Spirit_Topic_Topic>;
  /** update multiples rows of table: "spirit_topic_topic" */
  update_spirit_topic_topic_many?: Maybe<Array<Maybe<Spirit_Topic_Topic_Mutation_Response>>>;
  /** update data of the table: "spirit_topic_unread_topicunread" */
  update_spirit_topic_unread_topicunread?: Maybe<Spirit_Topic_Unread_Topicunread_Mutation_Response>;
  /** update single row of the table: "spirit_topic_unread_topicunread" */
  update_spirit_topic_unread_topicunread_by_pk?: Maybe<Spirit_Topic_Unread_Topicunread>;
  /** update multiples rows of table: "spirit_topic_unread_topicunread" */
  update_spirit_topic_unread_topicunread_many?: Maybe<Array<Maybe<Spirit_Topic_Unread_Topicunread_Mutation_Response>>>;
  /** update data of the table: "spirit_user_userprofile" */
  update_spirit_user_userprofile?: Maybe<Spirit_User_Userprofile_Mutation_Response>;
  /** update single row of the table: "spirit_user_userprofile" */
  update_spirit_user_userprofile_by_pk?: Maybe<Spirit_User_Userprofile>;
  /** update multiples rows of table: "spirit_user_userprofile" */
  update_spirit_user_userprofile_many?: Maybe<Array<Maybe<Spirit_User_Userprofile_Mutation_Response>>>;
  /** update data of the table: "subscription_group_plan" */
  update_subscription_group_plan?: Maybe<Subscription_Group_Plan_Mutation_Response>;
  /** update single row of the table: "subscription_group_plan" */
  update_subscription_group_plan_by_pk?: Maybe<Subscription_Group_Plan>;
  /** update data of the table: "subscription_group_plan_groups" */
  update_subscription_group_plan_groups?: Maybe<Subscription_Group_Plan_Groups_Mutation_Response>;
  /** update single row of the table: "subscription_group_plan_groups" */
  update_subscription_group_plan_groups_by_pk?: Maybe<Subscription_Group_Plan_Groups>;
  /** update multiples rows of table: "subscription_group_plan_groups" */
  update_subscription_group_plan_groups_many?: Maybe<Array<Maybe<Subscription_Group_Plan_Groups_Mutation_Response>>>;
  /** update multiples rows of table: "subscription_group_plan" */
  update_subscription_group_plan_many?: Maybe<Array<Maybe<Subscription_Group_Plan_Mutation_Response>>>;
  /** update data of the table: "subscriptions_plancost" */
  update_subscriptions_plancost?: Maybe<Subscriptions_Plancost_Mutation_Response>;
  /** update single row of the table: "subscriptions_plancost" */
  update_subscriptions_plancost_by_pk?: Maybe<Subscriptions_Plancost>;
  /** update multiples rows of table: "subscriptions_plancost" */
  update_subscriptions_plancost_many?: Maybe<Array<Maybe<Subscriptions_Plancost_Mutation_Response>>>;
  /** update data of the table: "subscriptions_planlist" */
  update_subscriptions_planlist?: Maybe<Subscriptions_Planlist_Mutation_Response>;
  /** update single row of the table: "subscriptions_planlist" */
  update_subscriptions_planlist_by_pk?: Maybe<Subscriptions_Planlist>;
  /** update multiples rows of table: "subscriptions_planlist" */
  update_subscriptions_planlist_many?: Maybe<Array<Maybe<Subscriptions_Planlist_Mutation_Response>>>;
  /** update data of the table: "subscriptions_planlistdetail" */
  update_subscriptions_planlistdetail?: Maybe<Subscriptions_Planlistdetail_Mutation_Response>;
  /** update single row of the table: "subscriptions_planlistdetail" */
  update_subscriptions_planlistdetail_by_pk?: Maybe<Subscriptions_Planlistdetail>;
  /** update multiples rows of table: "subscriptions_planlistdetail" */
  update_subscriptions_planlistdetail_many?: Maybe<Array<Maybe<Subscriptions_Planlistdetail_Mutation_Response>>>;
  /** update data of the table: "subscriptions_plantag" */
  update_subscriptions_plantag?: Maybe<Subscriptions_Plantag_Mutation_Response>;
  /** update single row of the table: "subscriptions_plantag" */
  update_subscriptions_plantag_by_pk?: Maybe<Subscriptions_Plantag>;
  /** update multiples rows of table: "subscriptions_plantag" */
  update_subscriptions_plantag_many?: Maybe<Array<Maybe<Subscriptions_Plantag_Mutation_Response>>>;
  /** update data of the table: "subscriptions_subscriptionplan" */
  update_subscriptions_subscriptionplan?: Maybe<Subscriptions_Subscriptionplan_Mutation_Response>;
  /** update single row of the table: "subscriptions_subscriptionplan" */
  update_subscriptions_subscriptionplan_by_pk?: Maybe<Subscriptions_Subscriptionplan>;
  /** update multiples rows of table: "subscriptions_subscriptionplan" */
  update_subscriptions_subscriptionplan_many?: Maybe<Array<Maybe<Subscriptions_Subscriptionplan_Mutation_Response>>>;
  /** update data of the table: "subscriptions_subscriptionplan_upgradable_plans" */
  update_subscriptions_subscriptionplan_upgradable_plans?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Mutation_Response>;
  /** update single row of the table: "subscriptions_subscriptionplan_upgradable_plans" */
  update_subscriptions_subscriptionplan_upgradable_plans_by_pk?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** update multiples rows of table: "subscriptions_subscriptionplan_upgradable_plans" */
  update_subscriptions_subscriptionplan_upgradable_plans_many?: Maybe<Array<Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Mutation_Response>>>;
  /** update data of the table: "subscriptions_subscriptiontransaction" */
  update_subscriptions_subscriptiontransaction?: Maybe<Subscriptions_Subscriptiontransaction_Mutation_Response>;
  /** update single row of the table: "subscriptions_subscriptiontransaction" */
  update_subscriptions_subscriptiontransaction_by_pk?: Maybe<Subscriptions_Subscriptiontransaction>;
  /** update multiples rows of table: "subscriptions_subscriptiontransaction" */
  update_subscriptions_subscriptiontransaction_many?: Maybe<Array<Maybe<Subscriptions_Subscriptiontransaction_Mutation_Response>>>;
  /** update data of the table: "subscriptions_usersubscription" */
  update_subscriptions_usersubscription?: Maybe<Subscriptions_Usersubscription_Mutation_Response>;
  /** update single row of the table: "subscriptions_usersubscription" */
  update_subscriptions_usersubscription_by_pk?: Maybe<Subscriptions_Usersubscription>;
  /** update multiples rows of table: "subscriptions_usersubscription" */
  update_subscriptions_usersubscription_many?: Maybe<Array<Maybe<Subscriptions_Usersubscription_Mutation_Response>>>;
  /** update data of the table: "supertokens.all_auth_recipe_users" */
  update_supertokens_all_auth_recipe_users?: Maybe<Supertokens_All_Auth_Recipe_Users_Mutation_Response>;
  /** update single row of the table: "supertokens.all_auth_recipe_users" */
  update_supertokens_all_auth_recipe_users_by_pk?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  /** update multiples rows of table: "supertokens.all_auth_recipe_users" */
  update_supertokens_all_auth_recipe_users_many?: Maybe<Array<Maybe<Supertokens_All_Auth_Recipe_Users_Mutation_Response>>>;
  /** update data of the table: "supertokens.app_id_to_user_id" */
  update_supertokens_app_id_to_user_id?: Maybe<Supertokens_App_Id_To_User_Id_Mutation_Response>;
  /** update single row of the table: "supertokens.app_id_to_user_id" */
  update_supertokens_app_id_to_user_id_by_pk?: Maybe<Supertokens_App_Id_To_User_Id>;
  /** update multiples rows of table: "supertokens.app_id_to_user_id" */
  update_supertokens_app_id_to_user_id_many?: Maybe<Array<Maybe<Supertokens_App_Id_To_User_Id_Mutation_Response>>>;
  /** update data of the table: "supertokens.apps" */
  update_supertokens_apps?: Maybe<Supertokens_Apps_Mutation_Response>;
  /** update single row of the table: "supertokens.apps" */
  update_supertokens_apps_by_pk?: Maybe<Supertokens_Apps>;
  /** update multiples rows of table: "supertokens.apps" */
  update_supertokens_apps_many?: Maybe<Array<Maybe<Supertokens_Apps_Mutation_Response>>>;
  /** update data of the table: "supertokens.dashboard_user_sessions" */
  update_supertokens_dashboard_user_sessions?: Maybe<Supertokens_Dashboard_User_Sessions_Mutation_Response>;
  /** update single row of the table: "supertokens.dashboard_user_sessions" */
  update_supertokens_dashboard_user_sessions_by_pk?: Maybe<Supertokens_Dashboard_User_Sessions>;
  /** update multiples rows of table: "supertokens.dashboard_user_sessions" */
  update_supertokens_dashboard_user_sessions_many?: Maybe<Array<Maybe<Supertokens_Dashboard_User_Sessions_Mutation_Response>>>;
  /** update data of the table: "supertokens.dashboard_users" */
  update_supertokens_dashboard_users?: Maybe<Supertokens_Dashboard_Users_Mutation_Response>;
  /** update single row of the table: "supertokens.dashboard_users" */
  update_supertokens_dashboard_users_by_pk?: Maybe<Supertokens_Dashboard_Users>;
  /** update multiples rows of table: "supertokens.dashboard_users" */
  update_supertokens_dashboard_users_many?: Maybe<Array<Maybe<Supertokens_Dashboard_Users_Mutation_Response>>>;
  /** update data of the table: "supertokens.emailpassword_pswd_reset_tokens" */
  update_supertokens_emailpassword_pswd_reset_tokens?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Mutation_Response>;
  /** update single row of the table: "supertokens.emailpassword_pswd_reset_tokens" */
  update_supertokens_emailpassword_pswd_reset_tokens_by_pk?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
  /** update multiples rows of table: "supertokens.emailpassword_pswd_reset_tokens" */
  update_supertokens_emailpassword_pswd_reset_tokens_many?: Maybe<Array<Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Mutation_Response>>>;
  /** update data of the table: "supertokens.emailpassword_user_to_tenant" */
  update_supertokens_emailpassword_user_to_tenant?: Maybe<Supertokens_Emailpassword_User_To_Tenant_Mutation_Response>;
  /** update single row of the table: "supertokens.emailpassword_user_to_tenant" */
  update_supertokens_emailpassword_user_to_tenant_by_pk?: Maybe<Supertokens_Emailpassword_User_To_Tenant>;
  /** update multiples rows of table: "supertokens.emailpassword_user_to_tenant" */
  update_supertokens_emailpassword_user_to_tenant_many?: Maybe<Array<Maybe<Supertokens_Emailpassword_User_To_Tenant_Mutation_Response>>>;
  /** update data of the table: "supertokens.emailpassword_users" */
  update_supertokens_emailpassword_users?: Maybe<Supertokens_Emailpassword_Users_Mutation_Response>;
  /** update single row of the table: "supertokens.emailpassword_users" */
  update_supertokens_emailpassword_users_by_pk?: Maybe<Supertokens_Emailpassword_Users>;
  /** update multiples rows of table: "supertokens.emailpassword_users" */
  update_supertokens_emailpassword_users_many?: Maybe<Array<Maybe<Supertokens_Emailpassword_Users_Mutation_Response>>>;
  /** update data of the table: "supertokens.emailverification_tokens" */
  update_supertokens_emailverification_tokens?: Maybe<Supertokens_Emailverification_Tokens_Mutation_Response>;
  /** update single row of the table: "supertokens.emailverification_tokens" */
  update_supertokens_emailverification_tokens_by_pk?: Maybe<Supertokens_Emailverification_Tokens>;
  /** update multiples rows of table: "supertokens.emailverification_tokens" */
  update_supertokens_emailverification_tokens_many?: Maybe<Array<Maybe<Supertokens_Emailverification_Tokens_Mutation_Response>>>;
  /** update data of the table: "supertokens.emailverification_verified_emails" */
  update_supertokens_emailverification_verified_emails?: Maybe<Supertokens_Emailverification_Verified_Emails_Mutation_Response>;
  /** update single row of the table: "supertokens.emailverification_verified_emails" */
  update_supertokens_emailverification_verified_emails_by_pk?: Maybe<Supertokens_Emailverification_Verified_Emails>;
  /** update multiples rows of table: "supertokens.emailverification_verified_emails" */
  update_supertokens_emailverification_verified_emails_many?: Maybe<Array<Maybe<Supertokens_Emailverification_Verified_Emails_Mutation_Response>>>;
  /** update data of the table: "supertokens.jwt_signing_keys" */
  update_supertokens_jwt_signing_keys?: Maybe<Supertokens_Jwt_Signing_Keys_Mutation_Response>;
  /** update single row of the table: "supertokens.jwt_signing_keys" */
  update_supertokens_jwt_signing_keys_by_pk?: Maybe<Supertokens_Jwt_Signing_Keys>;
  /** update multiples rows of table: "supertokens.jwt_signing_keys" */
  update_supertokens_jwt_signing_keys_many?: Maybe<Array<Maybe<Supertokens_Jwt_Signing_Keys_Mutation_Response>>>;
  /** update data of the table: "supertokens.key_value" */
  update_supertokens_key_value?: Maybe<Supertokens_Key_Value_Mutation_Response>;
  /** update single row of the table: "supertokens.key_value" */
  update_supertokens_key_value_by_pk?: Maybe<Supertokens_Key_Value>;
  /** update multiples rows of table: "supertokens.key_value" */
  update_supertokens_key_value_many?: Maybe<Array<Maybe<Supertokens_Key_Value_Mutation_Response>>>;
  /** update data of the table: "supertokens.passwordless_codes" */
  update_supertokens_passwordless_codes?: Maybe<Supertokens_Passwordless_Codes_Mutation_Response>;
  /** update single row of the table: "supertokens.passwordless_codes" */
  update_supertokens_passwordless_codes_by_pk?: Maybe<Supertokens_Passwordless_Codes>;
  /** update multiples rows of table: "supertokens.passwordless_codes" */
  update_supertokens_passwordless_codes_many?: Maybe<Array<Maybe<Supertokens_Passwordless_Codes_Mutation_Response>>>;
  /** update data of the table: "supertokens.passwordless_devices" */
  update_supertokens_passwordless_devices?: Maybe<Supertokens_Passwordless_Devices_Mutation_Response>;
  /** update single row of the table: "supertokens.passwordless_devices" */
  update_supertokens_passwordless_devices_by_pk?: Maybe<Supertokens_Passwordless_Devices>;
  /** update multiples rows of table: "supertokens.passwordless_devices" */
  update_supertokens_passwordless_devices_many?: Maybe<Array<Maybe<Supertokens_Passwordless_Devices_Mutation_Response>>>;
  /** update data of the table: "supertokens.passwordless_user_to_tenant" */
  update_supertokens_passwordless_user_to_tenant?: Maybe<Supertokens_Passwordless_User_To_Tenant_Mutation_Response>;
  /** update single row of the table: "supertokens.passwordless_user_to_tenant" */
  update_supertokens_passwordless_user_to_tenant_by_pk?: Maybe<Supertokens_Passwordless_User_To_Tenant>;
  /** update multiples rows of table: "supertokens.passwordless_user_to_tenant" */
  update_supertokens_passwordless_user_to_tenant_many?: Maybe<Array<Maybe<Supertokens_Passwordless_User_To_Tenant_Mutation_Response>>>;
  /** update data of the table: "supertokens.passwordless_users" */
  update_supertokens_passwordless_users?: Maybe<Supertokens_Passwordless_Users_Mutation_Response>;
  /** update single row of the table: "supertokens.passwordless_users" */
  update_supertokens_passwordless_users_by_pk?: Maybe<Supertokens_Passwordless_Users>;
  /** update multiples rows of table: "supertokens.passwordless_users" */
  update_supertokens_passwordless_users_many?: Maybe<Array<Maybe<Supertokens_Passwordless_Users_Mutation_Response>>>;
  /** update data of the table: "supertokens.role_permissions" */
  update_supertokens_role_permissions?: Maybe<Supertokens_Role_Permissions_Mutation_Response>;
  /** update single row of the table: "supertokens.role_permissions" */
  update_supertokens_role_permissions_by_pk?: Maybe<Supertokens_Role_Permissions>;
  /** update multiples rows of table: "supertokens.role_permissions" */
  update_supertokens_role_permissions_many?: Maybe<Array<Maybe<Supertokens_Role_Permissions_Mutation_Response>>>;
  /** update data of the table: "supertokens.roles" */
  update_supertokens_roles?: Maybe<Supertokens_Roles_Mutation_Response>;
  /** update single row of the table: "supertokens.roles" */
  update_supertokens_roles_by_pk?: Maybe<Supertokens_Roles>;
  /** update multiples rows of table: "supertokens.roles" */
  update_supertokens_roles_many?: Maybe<Array<Maybe<Supertokens_Roles_Mutation_Response>>>;
  /** update data of the table: "supertokens.session_access_token_signing_keys" */
  update_supertokens_session_access_token_signing_keys?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Mutation_Response>;
  /** update single row of the table: "supertokens.session_access_token_signing_keys" */
  update_supertokens_session_access_token_signing_keys_by_pk?: Maybe<Supertokens_Session_Access_Token_Signing_Keys>;
  /** update multiples rows of table: "supertokens.session_access_token_signing_keys" */
  update_supertokens_session_access_token_signing_keys_many?: Maybe<Array<Maybe<Supertokens_Session_Access_Token_Signing_Keys_Mutation_Response>>>;
  /** update data of the table: "supertokens.session_info" */
  update_supertokens_session_info?: Maybe<Supertokens_Session_Info_Mutation_Response>;
  /** update single row of the table: "supertokens.session_info" */
  update_supertokens_session_info_by_pk?: Maybe<Supertokens_Session_Info>;
  /** update multiples rows of table: "supertokens.session_info" */
  update_supertokens_session_info_many?: Maybe<Array<Maybe<Supertokens_Session_Info_Mutation_Response>>>;
  /** update data of the table: "supertokens.tenant_configs" */
  update_supertokens_tenant_configs?: Maybe<Supertokens_Tenant_Configs_Mutation_Response>;
  /** update single row of the table: "supertokens.tenant_configs" */
  update_supertokens_tenant_configs_by_pk?: Maybe<Supertokens_Tenant_Configs>;
  /** update multiples rows of table: "supertokens.tenant_configs" */
  update_supertokens_tenant_configs_many?: Maybe<Array<Maybe<Supertokens_Tenant_Configs_Mutation_Response>>>;
  /** update data of the table: "supertokens.tenant_thirdparty_provider_clients" */
  update_supertokens_tenant_thirdparty_provider_clients?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Mutation_Response>;
  /** update single row of the table: "supertokens.tenant_thirdparty_provider_clients" */
  update_supertokens_tenant_thirdparty_provider_clients_by_pk?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients>;
  /** update multiples rows of table: "supertokens.tenant_thirdparty_provider_clients" */
  update_supertokens_tenant_thirdparty_provider_clients_many?: Maybe<Array<Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Mutation_Response>>>;
  /** update data of the table: "supertokens.tenant_thirdparty_providers" */
  update_supertokens_tenant_thirdparty_providers?: Maybe<Supertokens_Tenant_Thirdparty_Providers_Mutation_Response>;
  /** update single row of the table: "supertokens.tenant_thirdparty_providers" */
  update_supertokens_tenant_thirdparty_providers_by_pk?: Maybe<Supertokens_Tenant_Thirdparty_Providers>;
  /** update multiples rows of table: "supertokens.tenant_thirdparty_providers" */
  update_supertokens_tenant_thirdparty_providers_many?: Maybe<Array<Maybe<Supertokens_Tenant_Thirdparty_Providers_Mutation_Response>>>;
  /** update data of the table: "supertokens.tenants" */
  update_supertokens_tenants?: Maybe<Supertokens_Tenants_Mutation_Response>;
  /** update single row of the table: "supertokens.tenants" */
  update_supertokens_tenants_by_pk?: Maybe<Supertokens_Tenants>;
  /** update multiples rows of table: "supertokens.tenants" */
  update_supertokens_tenants_many?: Maybe<Array<Maybe<Supertokens_Tenants_Mutation_Response>>>;
  /** update data of the table: "supertokens.thirdparty_user_to_tenant" */
  update_supertokens_thirdparty_user_to_tenant?: Maybe<Supertokens_Thirdparty_User_To_Tenant_Mutation_Response>;
  /** update single row of the table: "supertokens.thirdparty_user_to_tenant" */
  update_supertokens_thirdparty_user_to_tenant_by_pk?: Maybe<Supertokens_Thirdparty_User_To_Tenant>;
  /** update multiples rows of table: "supertokens.thirdparty_user_to_tenant" */
  update_supertokens_thirdparty_user_to_tenant_many?: Maybe<Array<Maybe<Supertokens_Thirdparty_User_To_Tenant_Mutation_Response>>>;
  /** update data of the table: "supertokens.thirdparty_users" */
  update_supertokens_thirdparty_users?: Maybe<Supertokens_Thirdparty_Users_Mutation_Response>;
  /** update single row of the table: "supertokens.thirdparty_users" */
  update_supertokens_thirdparty_users_by_pk?: Maybe<Supertokens_Thirdparty_Users>;
  /** update multiples rows of table: "supertokens.thirdparty_users" */
  update_supertokens_thirdparty_users_many?: Maybe<Array<Maybe<Supertokens_Thirdparty_Users_Mutation_Response>>>;
  /** update data of the table: "supertokens.user_additional_fields" */
  update_supertokens_user_additional_fields?: Maybe<Supertokens_User_Additional_Fields_Mutation_Response>;
  /** update single row of the table: "supertokens.user_additional_fields" */
  update_supertokens_user_additional_fields_by_pk?: Maybe<Supertokens_User_Additional_Fields>;
  /** update multiples rows of table: "supertokens.user_additional_fields" */
  update_supertokens_user_additional_fields_many?: Maybe<Array<Maybe<Supertokens_User_Additional_Fields_Mutation_Response>>>;
  /** update data of the table: "supertokens.user_last_active" */
  update_supertokens_user_last_active?: Maybe<Supertokens_User_Last_Active_Mutation_Response>;
  /** update single row of the table: "supertokens.user_last_active" */
  update_supertokens_user_last_active_by_pk?: Maybe<Supertokens_User_Last_Active>;
  /** update multiples rows of table: "supertokens.user_last_active" */
  update_supertokens_user_last_active_many?: Maybe<Array<Maybe<Supertokens_User_Last_Active_Mutation_Response>>>;
  /** update data of the table: "supertokens.user_metadata" */
  update_supertokens_user_metadata?: Maybe<Supertokens_User_Metadata_Mutation_Response>;
  /** update single row of the table: "supertokens.user_metadata" */
  update_supertokens_user_metadata_by_pk?: Maybe<Supertokens_User_Metadata>;
  /** update multiples rows of table: "supertokens.user_metadata" */
  update_supertokens_user_metadata_many?: Maybe<Array<Maybe<Supertokens_User_Metadata_Mutation_Response>>>;
  /** update data of the table: "supertokens.user_public_fields" */
  update_supertokens_user_public_fields?: Maybe<Supertokens_User_Public_Fields_Mutation_Response>;
  /** update multiples rows of table: "supertokens.user_public_fields" */
  update_supertokens_user_public_fields_many?: Maybe<Array<Maybe<Supertokens_User_Public_Fields_Mutation_Response>>>;
  /** update data of the table: "supertokens.user_roles" */
  update_supertokens_user_roles?: Maybe<Supertokens_User_Roles_Mutation_Response>;
  /** update single row of the table: "supertokens.user_roles" */
  update_supertokens_user_roles_by_pk?: Maybe<Supertokens_User_Roles>;
  /** update multiples rows of table: "supertokens.user_roles" */
  update_supertokens_user_roles_many?: Maybe<Array<Maybe<Supertokens_User_Roles_Mutation_Response>>>;
  /** update data of the table: "supertokens.userid_mapping" */
  update_supertokens_userid_mapping?: Maybe<Supertokens_Userid_Mapping_Mutation_Response>;
  /** update single row of the table: "supertokens.userid_mapping" */
  update_supertokens_userid_mapping_by_pk?: Maybe<Supertokens_Userid_Mapping>;
  /** update multiples rows of table: "supertokens.userid_mapping" */
  update_supertokens_userid_mapping_many?: Maybe<Array<Maybe<Supertokens_Userid_Mapping_Mutation_Response>>>;
  /** update data of the table: "taggit_tag" */
  update_taggit_tag?: Maybe<Taggit_Tag_Mutation_Response>;
  /** update single row of the table: "taggit_tag" */
  update_taggit_tag_by_pk?: Maybe<Taggit_Tag>;
  /** update multiples rows of table: "taggit_tag" */
  update_taggit_tag_many?: Maybe<Array<Maybe<Taggit_Tag_Mutation_Response>>>;
  /** update data of the table: "taggit_taggeditem" */
  update_taggit_taggeditem?: Maybe<Taggit_Taggeditem_Mutation_Response>;
  /** update single row of the table: "taggit_taggeditem" */
  update_taggit_taggeditem_by_pk?: Maybe<Taggit_Taggeditem>;
  /** update multiples rows of table: "taggit_taggeditem" */
  update_taggit_taggeditem_many?: Maybe<Array<Maybe<Taggit_Taggeditem_Mutation_Response>>>;
  /** update data of the table: "upcoming_live_classes" */
  update_upcoming_live_classes?: Maybe<Upcoming_Live_Classes_Mutation_Response>;
  /** update single row of the table: "upcoming_live_classes" */
  update_upcoming_live_classes_by_pk?: Maybe<Upcoming_Live_Classes>;
  /** update multiples rows of table: "upcoming_live_classes" */
  update_upcoming_live_classes_many?: Maybe<Array<Maybe<Upcoming_Live_Classes_Mutation_Response>>>;
  /** update data of the table: "user_activities" */
  update_user_activities?: Maybe<User_Activities_Mutation_Response>;
  /** update single row of the table: "user_activities" */
  update_user_activities_by_pk?: Maybe<User_Activities>;
  /** update multiples rows of table: "user_activities" */
  update_user_activities_many?: Maybe<Array<Maybe<User_Activities_Mutation_Response>>>;
  /** update data of the table: "user_activity" */
  update_user_activity?: Maybe<User_Activity_Mutation_Response>;
  /** update single row of the table: "user_activity" */
  update_user_activity_by_pk?: Maybe<User_Activity>;
  /** update data of the table: "user_activity_lesson_entries" */
  update_user_activity_lesson_entries?: Maybe<User_Activity_Lesson_Entries_Mutation_Response>;
  /** update single row of the table: "user_activity_lesson_entries" */
  update_user_activity_lesson_entries_by_pk?: Maybe<User_Activity_Lesson_Entries>;
  /** update multiples rows of table: "user_activity_lesson_entries" */
  update_user_activity_lesson_entries_many?: Maybe<Array<Maybe<User_Activity_Lesson_Entries_Mutation_Response>>>;
  /** update multiples rows of table: "user_activity" */
  update_user_activity_many?: Maybe<Array<Maybe<User_Activity_Mutation_Response>>>;
  /** update data of the table: "user_cat_registration_data" */
  update_user_cat_registration_data?: Maybe<User_Cat_Registration_Data_Mutation_Response>;
  /** update single row of the table: "user_cat_registration_data" */
  update_user_cat_registration_data_by_pk?: Maybe<User_Cat_Registration_Data>;
  /** update multiples rows of table: "user_cat_registration_data" */
  update_user_cat_registration_data_many?: Maybe<Array<Maybe<User_Cat_Registration_Data_Mutation_Response>>>;
  /** update data of the table: "user_cat_response_sheet_data" */
  update_user_cat_response_sheet_data?: Maybe<User_Cat_Response_Sheet_Data_Mutation_Response>;
  /** update single row of the table: "user_cat_response_sheet_data" */
  update_user_cat_response_sheet_data_by_pk?: Maybe<User_Cat_Response_Sheet_Data>;
  /** update multiples rows of table: "user_cat_response_sheet_data" */
  update_user_cat_response_sheet_data_many?: Maybe<Array<Maybe<User_Cat_Response_Sheet_Data_Mutation_Response>>>;
  /** update data of the table: "user_custom_planned_activities" */
  update_user_custom_planned_activities?: Maybe<User_Custom_Planned_Activities_Mutation_Response>;
  /** update single row of the table: "user_custom_planned_activities" */
  update_user_custom_planned_activities_by_pk?: Maybe<User_Custom_Planned_Activities>;
  /** update multiples rows of table: "user_custom_planned_activities" */
  update_user_custom_planned_activities_many?: Maybe<Array<Maybe<User_Custom_Planned_Activities_Mutation_Response>>>;
  /** update data of the table: "user_leaderboard_types" */
  update_user_leaderboard_types?: Maybe<User_Leaderboard_Types_Mutation_Response>;
  /** update single row of the table: "user_leaderboard_types" */
  update_user_leaderboard_types_by_pk?: Maybe<User_Leaderboard_Types>;
  /** update multiples rows of table: "user_leaderboard_types" */
  update_user_leaderboard_types_many?: Maybe<Array<Maybe<User_Leaderboard_Types_Mutation_Response>>>;
  /** update data of the table: "user_leaderboards" */
  update_user_leaderboards?: Maybe<User_Leaderboards_Mutation_Response>;
  /** update single row of the table: "user_leaderboards" */
  update_user_leaderboards_by_pk?: Maybe<User_Leaderboards>;
  /** update multiples rows of table: "user_leaderboards" */
  update_user_leaderboards_many?: Maybe<Array<Maybe<User_Leaderboards_Mutation_Response>>>;
  /** update data of the table: "user_learn_activities" */
  update_user_learn_activities?: Maybe<User_Learn_Activities_Mutation_Response>;
  /** update single row of the table: "user_learn_activities" */
  update_user_learn_activities_by_pk?: Maybe<User_Learn_Activities>;
  /** update multiples rows of table: "user_learn_activities" */
  update_user_learn_activities_many?: Maybe<Array<Maybe<User_Learn_Activities_Mutation_Response>>>;
  /** update data of the table: "user_learn_category_progress" */
  update_user_learn_category_progress?: Maybe<User_Learn_Category_Progress_Mutation_Response>;
  /** update single row of the table: "user_learn_category_progress" */
  update_user_learn_category_progress_by_pk?: Maybe<User_Learn_Category_Progress>;
  /** update multiples rows of table: "user_learn_category_progress" */
  update_user_learn_category_progress_many?: Maybe<Array<Maybe<User_Learn_Category_Progress_Mutation_Response>>>;
  /** update data of the table: "user_learn_completed_topics" */
  update_user_learn_completed_topics?: Maybe<User_Learn_Completed_Topics_Mutation_Response>;
  /** update single row of the table: "user_learn_completed_topics" */
  update_user_learn_completed_topics_by_pk?: Maybe<User_Learn_Completed_Topics>;
  /** update multiples rows of table: "user_learn_completed_topics" */
  update_user_learn_completed_topics_many?: Maybe<Array<Maybe<User_Learn_Completed_Topics_Mutation_Response>>>;
  /** update data of the table: "user_learn_modules_summary" */
  update_user_learn_modules_summary?: Maybe<User_Learn_Modules_Summary_Mutation_Response>;
  /** update single row of the table: "user_learn_modules_summary" */
  update_user_learn_modules_summary_by_pk?: Maybe<User_Learn_Modules_Summary>;
  /** update multiples rows of table: "user_learn_modules_summary" */
  update_user_learn_modules_summary_many?: Maybe<Array<Maybe<User_Learn_Modules_Summary_Mutation_Response>>>;
  /** update data of the table: "user_learn_track_record" */
  update_user_learn_track_record?: Maybe<User_Learn_Track_Record_Mutation_Response>;
  /** update data of the table: "user_learn_track_record_bookmarked_topics" */
  update_user_learn_track_record_bookmarked_topics?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Mutation_Response>;
  /** update single row of the table: "user_learn_track_record_bookmarked_topics" */
  update_user_learn_track_record_bookmarked_topics_by_pk?: Maybe<User_Learn_Track_Record_Bookmarked_Topics>;
  /** update multiples rows of table: "user_learn_track_record_bookmarked_topics" */
  update_user_learn_track_record_bookmarked_topics_many?: Maybe<Array<Maybe<User_Learn_Track_Record_Bookmarked_Topics_Mutation_Response>>>;
  /** update single row of the table: "user_learn_track_record" */
  update_user_learn_track_record_by_pk?: Maybe<User_Learn_Track_Record>;
  /** update multiples rows of table: "user_learn_track_record" */
  update_user_learn_track_record_many?: Maybe<Array<Maybe<User_Learn_Track_Record_Mutation_Response>>>;
  /** update data of the table: "user_learn_track_record_which_topics" */
  update_user_learn_track_record_which_topics?: Maybe<User_Learn_Track_Record_Which_Topics_Mutation_Response>;
  /** update single row of the table: "user_learn_track_record_which_topics" */
  update_user_learn_track_record_which_topics_by_pk?: Maybe<User_Learn_Track_Record_Which_Topics>;
  /** update multiples rows of table: "user_learn_track_record_which_topics" */
  update_user_learn_track_record_which_topics_many?: Maybe<Array<Maybe<User_Learn_Track_Record_Which_Topics_Mutation_Response>>>;
  /** update data of the table: "user_planned_activities" */
  update_user_planned_activities?: Maybe<User_Planned_Activities_Mutation_Response>;
  /** update single row of the table: "user_planned_activities" */
  update_user_planned_activities_by_pk?: Maybe<User_Planned_Activities>;
  /** update multiples rows of table: "user_planned_activities" */
  update_user_planned_activities_many?: Maybe<Array<Maybe<User_Planned_Activities_Mutation_Response>>>;
  /** update data of the table: "user_pov_summaries" */
  update_user_pov_summaries?: Maybe<User_Pov_Summaries_Mutation_Response>;
  /** update single row of the table: "user_pov_summaries" */
  update_user_pov_summaries_by_pk?: Maybe<User_Pov_Summaries>;
  /** update multiples rows of table: "user_pov_summaries" */
  update_user_pov_summaries_many?: Maybe<Array<Maybe<User_Pov_Summaries_Mutation_Response>>>;
  /** update data of the table: "user_quiz_question_attempts" */
  update_user_quiz_question_attempts?: Maybe<User_Quiz_Question_Attempts_Mutation_Response>;
  /** update single row of the table: "user_quiz_question_attempts" */
  update_user_quiz_question_attempts_by_pk?: Maybe<User_Quiz_Question_Attempts>;
  /** update multiples rows of table: "user_quiz_question_attempts" */
  update_user_quiz_question_attempts_many?: Maybe<Array<Maybe<User_Quiz_Question_Attempts_Mutation_Response>>>;
  /** update data of the table: "user_quiz_question_positions" */
  update_user_quiz_question_positions?: Maybe<User_Quiz_Question_Positions_Mutation_Response>;
  /** update single row of the table: "user_quiz_question_positions" */
  update_user_quiz_question_positions_by_pk?: Maybe<User_Quiz_Question_Positions>;
  /** update multiples rows of table: "user_quiz_question_positions" */
  update_user_quiz_question_positions_many?: Maybe<Array<Maybe<User_Quiz_Question_Positions_Mutation_Response>>>;
  /** update data of the table: "user_quiz_question_summaries" */
  update_user_quiz_question_summaries?: Maybe<User_Quiz_Question_Summaries_Mutation_Response>;
  /** update single row of the table: "user_quiz_question_summaries" */
  update_user_quiz_question_summaries_by_pk?: Maybe<User_Quiz_Question_Summaries>;
  /** update multiples rows of table: "user_quiz_question_summaries" */
  update_user_quiz_question_summaries_many?: Maybe<Array<Maybe<User_Quiz_Question_Summaries_Mutation_Response>>>;
  /** update data of the table: "user_quiz_question_summaries_old" */
  update_user_quiz_question_summaries_old?: Maybe<User_Quiz_Question_Summaries_Old_Mutation_Response>;
  /** update single row of the table: "user_quiz_question_summaries_old" */
  update_user_quiz_question_summaries_old_by_pk?: Maybe<User_Quiz_Question_Summaries_Old>;
  /** update multiples rows of table: "user_quiz_question_summaries_old" */
  update_user_quiz_question_summaries_old_many?: Maybe<Array<Maybe<User_Quiz_Question_Summaries_Old_Mutation_Response>>>;
  /** update data of the table: "user_quiz_questions" */
  update_user_quiz_questions?: Maybe<User_Quiz_Questions_Mutation_Response>;
  /** update single row of the table: "user_quiz_questions" */
  update_user_quiz_questions_by_pk?: Maybe<User_Quiz_Questions>;
  /** update multiples rows of table: "user_quiz_questions" */
  update_user_quiz_questions_many?: Maybe<Array<Maybe<User_Quiz_Questions_Mutation_Response>>>;
  /** update data of the table: "user_quiz_section_summaries" */
  update_user_quiz_section_summaries?: Maybe<User_Quiz_Section_Summaries_Mutation_Response>;
  /** update single row of the table: "user_quiz_section_summaries" */
  update_user_quiz_section_summaries_by_pk?: Maybe<User_Quiz_Section_Summaries>;
  /** update multiples rows of table: "user_quiz_section_summaries" */
  update_user_quiz_section_summaries_many?: Maybe<Array<Maybe<User_Quiz_Section_Summaries_Mutation_Response>>>;
  /** update data of the table: "user_quiz_summaries" */
  update_user_quiz_summaries?: Maybe<User_Quiz_Summaries_Mutation_Response>;
  /** update single row of the table: "user_quiz_summaries" */
  update_user_quiz_summaries_by_pk?: Maybe<User_Quiz_Summaries>;
  /** update multiples rows of table: "user_quiz_summaries" */
  update_user_quiz_summaries_many?: Maybe<Array<Maybe<User_Quiz_Summaries_Mutation_Response>>>;
  /** update data of the table: "user_quiz_summaries_old" */
  update_user_quiz_summaries_old?: Maybe<User_Quiz_Summaries_Old_Mutation_Response>;
  /** update single row of the table: "user_quiz_summaries_old" */
  update_user_quiz_summaries_old_by_pk?: Maybe<User_Quiz_Summaries_Old>;
  /** update multiples rows of table: "user_quiz_summaries_old" */
  update_user_quiz_summaries_old_many?: Maybe<Array<Maybe<User_Quiz_Summaries_Old_Mutation_Response>>>;
  /** update data of the table: "user_section_summaries" */
  update_user_section_summaries?: Maybe<User_Section_Summaries_Mutation_Response>;
  /** update single row of the table: "user_section_summaries" */
  update_user_section_summaries_by_pk?: Maybe<User_Section_Summaries>;
  /** update multiples rows of table: "user_section_summaries" */
  update_user_section_summaries_many?: Maybe<Array<Maybe<User_Section_Summaries_Mutation_Response>>>;
  /** update data of the table: "user_speed_test_questions_summaries" */
  update_user_speed_test_questions_summaries?: Maybe<User_Speed_Test_Questions_Summaries_Mutation_Response>;
  /** update single row of the table: "user_speed_test_questions_summaries" */
  update_user_speed_test_questions_summaries_by_pk?: Maybe<User_Speed_Test_Questions_Summaries>;
  /** update multiples rows of table: "user_speed_test_questions_summaries" */
  update_user_speed_test_questions_summaries_many?: Maybe<Array<Maybe<User_Speed_Test_Questions_Summaries_Mutation_Response>>>;
  /** update data of the table: "user_speed_tests_summaries" */
  update_user_speed_tests_summaries?: Maybe<User_Speed_Tests_Summaries_Mutation_Response>;
  /** update single row of the table: "user_speed_tests_summaries" */
  update_user_speed_tests_summaries_by_pk?: Maybe<User_Speed_Tests_Summaries>;
  /** update multiples rows of table: "user_speed_tests_summaries" */
  update_user_speed_tests_summaries_many?: Maybe<Array<Maybe<User_Speed_Tests_Summaries_Mutation_Response>>>;
  /** update data of the table: "user_timed_quiz_summary" */
  update_user_timed_quiz_summary?: Maybe<User_Timed_Quiz_Summary_Mutation_Response>;
  /** update single row of the table: "user_timed_quiz_summary" */
  update_user_timed_quiz_summary_by_pk?: Maybe<User_Timed_Quiz_Summary>;
  /** update multiples rows of table: "user_timed_quiz_summary" */
  update_user_timed_quiz_summary_many?: Maybe<Array<Maybe<User_Timed_Quiz_Summary_Mutation_Response>>>;
  /** update data of the table: "user_total_score" */
  update_user_total_score?: Maybe<User_Total_Score_Mutation_Response>;
  /** update single row of the table: "user_total_score" */
  update_user_total_score_by_pk?: Maybe<User_Total_Score>;
  /** update multiples rows of table: "user_total_score" */
  update_user_total_score_many?: Maybe<Array<Maybe<User_Total_Score_Mutation_Response>>>;
  /** update data of the table: "user_xp_transaction_summaries" */
  update_user_xp_transaction_summaries?: Maybe<User_Xp_Transaction_Summaries_Mutation_Response>;
  /** update single row of the table: "user_xp_transaction_summaries" */
  update_user_xp_transaction_summaries_by_pk?: Maybe<User_Xp_Transaction_Summaries>;
  /** update multiples rows of table: "user_xp_transaction_summaries" */
  update_user_xp_transaction_summaries_many?: Maybe<Array<Maybe<User_Xp_Transaction_Summaries_Mutation_Response>>>;
  /** update data of the table: "user_xp_transactions" */
  update_user_xp_transactions?: Maybe<User_Xp_Transactions_Mutation_Response>;
  /** update single row of the table: "user_xp_transactions" */
  update_user_xp_transactions_by_pk?: Maybe<User_Xp_Transactions>;
  /** update multiples rows of table: "user_xp_transactions" */
  update_user_xp_transactions_many?: Maybe<Array<Maybe<User_Xp_Transactions_Mutation_Response>>>;
  /** update data of the table: "users_user" */
  update_users_user?: Maybe<Users_User_Mutation_Response>;
  /** update single row of the table: "users_user" */
  update_users_user_by_pk?: Maybe<Users_User>;
  /** update data of the table: "users_user_groups" */
  update_users_user_groups?: Maybe<Users_User_Groups_Mutation_Response>;
  /** update single row of the table: "users_user_groups" */
  update_users_user_groups_by_pk?: Maybe<Users_User_Groups>;
  /** update multiples rows of table: "users_user_groups" */
  update_users_user_groups_many?: Maybe<Array<Maybe<Users_User_Groups_Mutation_Response>>>;
  /** update multiples rows of table: "users_user" */
  update_users_user_many?: Maybe<Array<Maybe<Users_User_Mutation_Response>>>;
  /** update data of the table: "users_user_user_permissions" */
  update_users_user_user_permissions?: Maybe<Users_User_User_Permissions_Mutation_Response>;
  /** update single row of the table: "users_user_user_permissions" */
  update_users_user_user_permissions_by_pk?: Maybe<Users_User_User_Permissions>;
  /** update multiples rows of table: "users_user_user_permissions" */
  update_users_user_user_permissions_many?: Maybe<Array<Maybe<Users_User_User_Permissions_Mutation_Response>>>;
  /** update data of the table: "users_userquestionsummary" */
  update_users_userquestionsummary?: Maybe<Users_Userquestionsummary_Mutation_Response>;
  /** update single row of the table: "users_userquestionsummary" */
  update_users_userquestionsummary_by_pk?: Maybe<Users_Userquestionsummary>;
  /** update multiples rows of table: "users_userquestionsummary" */
  update_users_userquestionsummary_many?: Maybe<Array<Maybe<Users_Userquestionsummary_Mutation_Response>>>;
  /** update data of the table: "users_userquizsummary" */
  update_users_userquizsummary?: Maybe<Users_Userquizsummary_Mutation_Response>;
  /** update single row of the table: "users_userquizsummary" */
  update_users_userquizsummary_by_pk?: Maybe<Users_Userquizsummary>;
  /** update multiples rows of table: "users_userquizsummary" */
  update_users_userquizsummary_many?: Maybe<Array<Maybe<Users_Userquizsummary_Mutation_Response>>>;
  /** update data of the table: "users_userquiztimesummary" */
  update_users_userquiztimesummary?: Maybe<Users_Userquiztimesummary_Mutation_Response>;
  /** update single row of the table: "users_userquiztimesummary" */
  update_users_userquiztimesummary_by_pk?: Maybe<Users_Userquiztimesummary>;
  /** update multiples rows of table: "users_userquiztimesummary" */
  update_users_userquiztimesummary_many?: Maybe<Array<Maybe<Users_Userquiztimesummary_Mutation_Response>>>;
  /** update data of the table: "users_usersectionsummary" */
  update_users_usersectionsummary?: Maybe<Users_Usersectionsummary_Mutation_Response>;
  /** update single row of the table: "users_usersectionsummary" */
  update_users_usersectionsummary_by_pk?: Maybe<Users_Usersectionsummary>;
  /** update multiples rows of table: "users_usersectionsummary" */
  update_users_usersectionsummary_many?: Maybe<Array<Maybe<Users_Usersectionsummary_Mutation_Response>>>;
  /** update data of the table: "utils_configuration" */
  update_utils_configuration?: Maybe<Utils_Configuration_Mutation_Response>;
  /** update single row of the table: "utils_configuration" */
  update_utils_configuration_by_pk?: Maybe<Utils_Configuration>;
  /** update multiples rows of table: "utils_configuration" */
  update_utils_configuration_many?: Maybe<Array<Maybe<Utils_Configuration_Mutation_Response>>>;
  /** update data of the table: "xp_transaction_types" */
  update_xp_transaction_types?: Maybe<Xp_Transaction_Types_Mutation_Response>;
  /** update single row of the table: "xp_transaction_types" */
  update_xp_transaction_types_by_pk?: Maybe<Xp_Transaction_Types>;
  /** update multiples rows of table: "xp_transaction_types" */
  update_xp_transaction_types_many?: Maybe<Array<Maybe<Xp_Transaction_Types_Mutation_Response>>>;
  validateGoogleLogin: GenericResponse;
  verifyEmail: GenericResponse;
  verifyOfflineLeadOtp: GenericResponse;
  verifyOtp: GenericResponse;
  verifyPayment: Scalars['Boolean']['output'];
  verifyResetPasswordToken: GenericResponse;
  votePoll: GenericResponse;
};


/** mutation root */
export type MutationBlockUserArgs = {
  channelId: Scalars['String']['input'];
  status: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type MutationChangeRoleArgs = {
  channelId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type MutationCreateChannelArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
};


/** mutation root */
export type MutationCreateMeetingArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** mutation root */
export type MutationCreatePollArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  options: Array<PollOption>;
  quizType?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** mutation root */
export type MutationCreateUserArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isVisualImpairment?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  mobileVerified?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type MutationDeleteChannelArgs = {
  channelId: Scalars['String']['input'];
};


/** mutation root */
export type MutationDeleteFileArgs = {
  filename: Scalars['String']['input'];
};


/** mutation root */
export type MutationDeleteFilesArgs = {
  regex: Scalars['String']['input'];
};


/** mutation root */
export type MutationDeleteMessageArgs = {
  channelId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Account_EmailaddressArgs = {
  where: Account_Emailaddress_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Account_Emailaddress_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Account_EmailconfirmationArgs = {
  where: Account_Emailconfirmation_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Account_Emailconfirmation_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Accounts_CatscoresArgs = {
  where: Accounts_Catscores_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Accounts_Catscores_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Accounts_LoggedinuserArgs = {
  where: Accounts_Loggedinuser_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Accounts_Loggedinuser_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Activity_TypesArgs = {
  where: Activity_Types_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Activity_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Admin_ConstantsArgs = {
  where: Admin_Constants_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Admin_Constants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Admin_UsersArgs = {
  where: Admin_Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Admin_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_AdvertisementsArgs = {
  where: Advertisements_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Advertisements_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Andablog_EntryArgs = {
  where: Andablog_Entry_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Andablog_Entry_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Andablog_EntryimageArgs = {
  where: Andablog_Entryimage_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Andablog_Entryimage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Andablog_NewsArgs = {
  where: Andablog_News_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Andablog_News_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Andablog_PovArgs = {
  where: Andablog_Pov_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Andablog_Pov_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Andablog_UserlessontrackrecordArgs = {
  where: Andablog_Userlessontrackrecord_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Andablog_Userlessontrackrecord_Bookmarked_TopicsArgs = {
  where: Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Andablog_Userlessontrackrecord_Bookmarked_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Andablog_Userlessontrackrecord_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Andablog_Userlessontrackrecord_Which_TopicsArgs = {
  where: Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Andablog_Userlessontrackrecord_Which_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Andablog_VideoArgs = {
  where: Andablog_Video_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Andablog_Video_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Auth_Email_VerificationsArgs = {
  where: Auth_Email_Verifications_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Auth_Email_Verifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Auth_GroupArgs = {
  where: Auth_Group_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Auth_Group_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Auth_Group_PermissionsArgs = {
  where: Auth_Group_Permissions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Auth_Group_Permissions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Auth_Password_Reset_TokensArgs = {
  where: Auth_Password_Reset_Tokens_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Auth_Password_Reset_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Auth_PermissionArgs = {
  where: Auth_Permission_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Auth_Permission_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Auth_SessionArgs = {
  where: Auth_Session_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Auth_Session_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Bookmarked_Learn_TopicsArgs = {
  where: Bookmarked_Learn_Topics_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Bookmarked_Learn_Topics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Cat_Percentile_ConstantArgs = {
  where: Cat_Percentile_Constant_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Cat_Percentile_Constant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Cat_ScoresArgs = {
  where: Cat_Scores_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Cat_Scores_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Channel_MembersArgs = {
  where: Channel_Members_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Channel_Members_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_ChannelsArgs = {
  where: Channels_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Channels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_Allowed_Users_Rule_UsersArgs = {
  where: Coupons_Allowed_Users_Rule_Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Allowed_Users_Rule_Users_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_AllowedusersruleArgs = {
  where: Coupons_Allowedusersrule_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Allowedusersrule_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_Allowedusersrule_UsersArgs = {
  where: Coupons_Allowedusersrule_Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Allowedusersrule_Users_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_CouponArgs = {
  where: Coupons_Coupon_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Coupon_Applicable_PackagesArgs = {
  where: Coupons_Coupon_Applicable_Packages_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Coupon_Applicable_Packages_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_Coupon_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_CouponuserArgs = {
  where: Coupons_Couponuser_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Couponuser_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_DiscountArgs = {
  where: Coupons_Discount_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Discount_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_MaxusesruleArgs = {
  where: Coupons_Maxusesrule_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Maxusesrule_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_RulesetArgs = {
  where: Coupons_Ruleset_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Ruleset_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Coupons_ValidityruleArgs = {
  where: Coupons_Validityrule_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Coupons_Validityrule_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Django_Admin_LogArgs = {
  where: Django_Admin_Log_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Django_Admin_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Django_Content_TypeArgs = {
  where: Django_Content_Type_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Django_Content_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Django_MigrationsArgs = {
  where: Django_Migrations_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Django_Migrations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Django_SessionArgs = {
  where: Django_Session_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Django_Session_By_PkArgs = {
  session_key: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Django_SiteArgs = {
  where: Django_Site_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Django_Site_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Djconfig_ConfigArgs = {
  where: Djconfig_Config_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Djconfig_Config_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Group_CategoryArgs = {
  where: Group_Category_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Group_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Group_Discount_UsersArgs = {
  where: Group_Discount_Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Has_AccessArgs = {
  where: Has_Access_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Infozone_CategoryArgs = {
  where: Infozone_Category_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Infozone_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Infozone_InfozoneArgs = {
  where: Infozone_Infozone_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Infozone_Infozone_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Infozone_StaticpagesArgs = {
  where: Infozone_Staticpages_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Infozone_Staticpages_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Live_Quiz_LeaderboardArgs = {
  where: Live_Quiz_Leaderboard_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Live_Quiz_Leaderboard_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Live_Quiz_Question_PositionsArgs = {
  where: Live_Quiz_Question_Positions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Live_Quiz_Question_Positions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Live_Quiz_Question_SummaryArgs = {
  where: Live_Quiz_Question_Summary_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Live_Quiz_Question_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Live_Quiz_SummaryArgs = {
  where: Live_Quiz_Summary_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Live_Quiz_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Marks_Vs_Percentile_DilrArgs = {
  where: Marks_Vs_Percentile_Dilr_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Marks_Vs_Percentile_Dilr_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Marks_Vs_Percentile_QuantArgs = {
  where: Marks_Vs_Percentile_Quant_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Marks_Vs_Percentile_Quant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Marks_Vs_Percentile_Total_RawArgs = {
  where: Marks_Vs_Percentile_Total_Raw_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Marks_Vs_Percentile_Total_Raw_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Marks_Vs_Percentile_VarcArgs = {
  where: Marks_Vs_Percentile_Varc_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Marks_Vs_Percentile_Varc_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Marks_Vs_Scaled_PercentileArgs = {
  where: Marks_Vs_Scaled_Percentile_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Marks_Vs_Scaled_Percentile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Meeting_MembersArgs = {
  where: Meeting_Members_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Meeting_Members_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_MeetingsArgs = {
  where: Meetings_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Meetings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Message_ReactionsArgs = {
  where: Message_Reactions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Message_Reactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_MessagesArgs = {
  where: Messages_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Messages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Messages_ReadArgs = {
  where: Messages_Read_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Messages_Read_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Offline_LeadsArgs = {
  where: Offline_Leads_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Offline_Leads_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Package_Content_Discarded_QuizzesArgs = {
  where: Package_Content_Discarded_Quizzes_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Package_Content_Discarded_Quizzes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Packages_ContentArgs = {
  where: Packages_Content_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Packages_Content_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Packages_Content_DomainsArgs = {
  where: Packages_Content_Domains_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Packages_Content_Domains_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Packages_Content_Text_LessonArgs = {
  where: Packages_Content_Text_Lesson_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Packages_Content_Text_Lesson_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Packages_Content_Timed_TestArgs = {
  where: Packages_Content_Timed_Test_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Packages_Content_Timed_Test_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Packages_Content_Untimed_TestArgs = {
  where: Packages_Content_Untimed_Test_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Packages_Content_Untimed_Test_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Packages_Payment_TransactionArgs = {
  where: Packages_Payment_Transaction_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Packages_Payment_Transaction_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Packages_PaymenttransactionArgs = {
  where: Packages_Paymenttransaction_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Packages_Paymenttransaction_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_PollArgs = {
  where: Poll_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Poll_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Poll_OptionsArgs = {
  where: Poll_Options_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Poll_Options_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Poll_ResponsesArgs = {
  where: Poll_Responses_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Poll_Responses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Question_ReportsArgs = {
  where: Question_Reports_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Question_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_AnswerArgs = {
  where: Quiz_Answer_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Answer_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_CategoryArgs = {
  where: Quiz_Category_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_DomainArgs = {
  where: Quiz_Domain_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Domain_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_MarkingsystemArgs = {
  where: Quiz_Markingsystem_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Markingsystem_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_OptionArgs = {
  where: Quiz_Option_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Option_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_ParagraphArgs = {
  where: Quiz_Paragraph_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Paragraph_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_QuestionArgs = {
  where: Quiz_Question_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Question_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_QuizArgs = {
  where: Quiz_Quiz_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Quiz_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_Quiz_QuestionsArgs = {
  where: Quiz_Quiz_Questions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Quiz_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_Quiz_SectionsArgs = {
  where: Quiz_Quiz_Sections_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Quiz_Sections_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_SectionArgs = {
  where: Quiz_Section_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Section_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_Section_QuestionsArgs = {
  where: Quiz_Section_Questions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Section_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_Section_SubsectionsArgs = {
  where: Quiz_Section_Subsections_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Section_Subsections_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Quiz_SuperdomainArgs = {
  where: Quiz_Superdomain_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Quiz_Superdomain_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Random_Question_IdsArgs = {
  where: Random_Question_Ids_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Reaction_EmojisArgs = {
  where: Reaction_Emojis_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Reaction_Emojis_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Reported_MessageArgs = {
  where: Reported_Message_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Reported_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Scaling_ConstantArgs = {
  where: Scaling_Constant_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Scaling_Constant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Socialaccount_SocialaccountArgs = {
  where: Socialaccount_Socialaccount_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Socialaccount_Socialaccount_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Socialaccount_SocialappArgs = {
  where: Socialaccount_Socialapp_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Socialaccount_Socialapp_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Socialaccount_Socialapp_SitesArgs = {
  where: Socialaccount_Socialapp_Sites_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Socialaccount_Socialapp_Sites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Socialaccount_SocialtokenArgs = {
  where: Socialaccount_Socialtoken_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Socialaccount_Socialtoken_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Speed_Test_CategoryArgs = {
  where: Speed_Test_Category_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Speed_Test_Category_By_PkArgs = {
  category: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Speed_TestsArgs = {
  where: Speed_Tests_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Speed_Tests_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_CacheArgs = {
  where: Spirit_Cache_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Cache_By_PkArgs = {
  cache_key: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Category_CategoryArgs = {
  where: Spirit_Category_Category_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Category_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Bookmark_CommentbookmarkArgs = {
  where: Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Bookmark_Commentbookmark_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Comment_CommentArgs = {
  where: Spirit_Comment_Comment_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Comment_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Flag_CommentflagArgs = {
  where: Spirit_Comment_Flag_Commentflag_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Flag_Commentflag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Flag_FlagArgs = {
  where: Spirit_Comment_Flag_Flag_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Flag_Flag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Comment_History_CommenthistoryArgs = {
  where: Spirit_Comment_History_Commenthistory_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Comment_History_Commenthistory_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Like_CommentlikeArgs = {
  where: Spirit_Comment_Like_Commentlike_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Like_Commentlike_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Poll_CommentpollArgs = {
  where: Spirit_Comment_Poll_Commentpoll_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Poll_Commentpoll_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Poll_CommentpollchoiceArgs = {
  where: Spirit_Comment_Poll_Commentpollchoice_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Poll_Commentpollchoice_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Poll_CommentpollvoteArgs = {
  where: Spirit_Comment_Poll_Commentpollvote_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Comment_Poll_Commentpollvote_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Rl_CacheArgs = {
  where: Spirit_Rl_Cache_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Rl_Cache_By_PkArgs = {
  cache_key: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Topic_Favorite_TopicfavoriteArgs = {
  where: Spirit_Topic_Favorite_Topicfavorite_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Topic_Favorite_Topicfavorite_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Topic_Notification_TopicnotificationArgs = {
  where: Spirit_Topic_Notification_Topicnotification_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Topic_Notification_Topicnotification_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Topic_Private_TopicprivateArgs = {
  where: Spirit_Topic_Private_Topicprivate_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Topic_Private_Topicprivate_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Topic_TopicArgs = {
  where: Spirit_Topic_Topic_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Topic_Topic_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_Topic_Unread_TopicunreadArgs = {
  where: Spirit_Topic_Unread_Topicunread_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_Topic_Unread_Topicunread_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Spirit_User_UserprofileArgs = {
  where: Spirit_User_Userprofile_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Spirit_User_Userprofile_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Subscription_Group_PlanArgs = {
  where: Subscription_Group_Plan_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscription_Group_Plan_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Subscription_Group_Plan_GroupsArgs = {
  where: Subscription_Group_Plan_Groups_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscription_Group_Plan_Groups_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Subscriptions_PlancostArgs = {
  where: Subscriptions_Plancost_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscriptions_Plancost_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Subscriptions_PlanlistArgs = {
  where: Subscriptions_Planlist_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscriptions_Planlist_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Subscriptions_PlanlistdetailArgs = {
  where: Subscriptions_Planlistdetail_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscriptions_Planlistdetail_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Subscriptions_PlantagArgs = {
  where: Subscriptions_Plantag_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscriptions_Plantag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Subscriptions_SubscriptionplanArgs = {
  where: Subscriptions_Subscriptionplan_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscriptions_Subscriptionplan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Subscriptions_Subscriptionplan_Upgradable_PlansArgs = {
  where: Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscriptions_Subscriptionplan_Upgradable_Plans_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Subscriptions_SubscriptiontransactionArgs = {
  where: Subscriptions_Subscriptiontransaction_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscriptions_Subscriptiontransaction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Subscriptions_UsersubscriptionArgs = {
  where: Subscriptions_Usersubscription_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Subscriptions_Usersubscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_All_Auth_Recipe_UsersArgs = {
  where: Supertokens_All_Auth_Recipe_Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_All_Auth_Recipe_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_App_Id_To_User_IdArgs = {
  where: Supertokens_App_Id_To_User_Id_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_App_Id_To_User_Id_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_AppsArgs = {
  where: Supertokens_Apps_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Apps_By_PkArgs = {
  app_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Dashboard_User_SessionsArgs = {
  where: Supertokens_Dashboard_User_Sessions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Dashboard_User_Sessions_By_PkArgs = {
  app_id: Scalars['String']['input'];
  session_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Dashboard_UsersArgs = {
  where: Supertokens_Dashboard_Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Dashboard_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Emailpassword_Pswd_Reset_TokensArgs = {
  where: Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Emailpassword_Pswd_Reset_Tokens_By_PkArgs = {
  app_id: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Emailpassword_User_To_TenantArgs = {
  where: Supertokens_Emailpassword_User_To_Tenant_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Emailpassword_User_To_Tenant_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Emailpassword_UsersArgs = {
  where: Supertokens_Emailpassword_Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Emailpassword_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Emailverification_TokensArgs = {
  where: Supertokens_Emailverification_Tokens_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Emailverification_Tokens_By_PkArgs = {
  app_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Emailverification_Verified_EmailsArgs = {
  where: Supertokens_Emailverification_Verified_Emails_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Emailverification_Verified_Emails_By_PkArgs = {
  app_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Jwt_Signing_KeysArgs = {
  where: Supertokens_Jwt_Signing_Keys_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Jwt_Signing_Keys_By_PkArgs = {
  app_id: Scalars['String']['input'];
  key_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Key_ValueArgs = {
  where: Supertokens_Key_Value_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Key_Value_By_PkArgs = {
  app_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Passwordless_CodesArgs = {
  where: Supertokens_Passwordless_Codes_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Passwordless_Codes_By_PkArgs = {
  app_id: Scalars['String']['input'];
  code_id: Scalars['bpchar']['input'];
  tenant_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Passwordless_DevicesArgs = {
  where: Supertokens_Passwordless_Devices_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Passwordless_Devices_By_PkArgs = {
  app_id: Scalars['String']['input'];
  device_id_hash: Scalars['bpchar']['input'];
  tenant_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Passwordless_User_To_TenantArgs = {
  where: Supertokens_Passwordless_User_To_Tenant_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Passwordless_User_To_Tenant_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Passwordless_UsersArgs = {
  where: Supertokens_Passwordless_Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Passwordless_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Role_PermissionsArgs = {
  where: Supertokens_Role_Permissions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Role_Permissions_By_PkArgs = {
  app_id: Scalars['String']['input'];
  permission: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_RolesArgs = {
  where: Supertokens_Roles_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Roles_By_PkArgs = {
  app_id: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Session_Access_Token_Signing_KeysArgs = {
  where: Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Session_Access_Token_Signing_Keys_By_PkArgs = {
  app_id: Scalars['String']['input'];
  created_at_time: Scalars['bigint']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Session_InfoArgs = {
  where: Supertokens_Session_Info_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Session_Info_By_PkArgs = {
  app_id: Scalars['String']['input'];
  session_handle: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Tenant_ConfigsArgs = {
  where: Supertokens_Tenant_Configs_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Tenant_Configs_By_PkArgs = {
  app_id: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Tenant_Thirdparty_Provider_ClientsArgs = {
  where: Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Tenant_Thirdparty_Provider_Clients_By_PkArgs = {
  app_id: Scalars['String']['input'];
  client_type: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  third_party_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Tenant_Thirdparty_ProvidersArgs = {
  where: Supertokens_Tenant_Thirdparty_Providers_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Tenant_Thirdparty_Providers_By_PkArgs = {
  app_id: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  third_party_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_TenantsArgs = {
  where: Supertokens_Tenants_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Tenants_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Thirdparty_User_To_TenantArgs = {
  where: Supertokens_Thirdparty_User_To_Tenant_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Thirdparty_User_To_Tenant_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Thirdparty_UsersArgs = {
  where: Supertokens_Thirdparty_Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Thirdparty_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_User_Additional_FieldsArgs = {
  where: Supertokens_User_Additional_Fields_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_User_Additional_Fields_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_User_Last_ActiveArgs = {
  where: Supertokens_User_Last_Active_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_User_Last_Active_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_User_MetadataArgs = {
  where: Supertokens_User_Metadata_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_User_Metadata_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_User_Public_FieldsArgs = {
  where: Supertokens_User_Public_Fields_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_User_RolesArgs = {
  where: Supertokens_User_Roles_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_User_Roles_By_PkArgs = {
  app_id: Scalars['String']['input'];
  role: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_Supertokens_Userid_MappingArgs = {
  where: Supertokens_Userid_Mapping_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Supertokens_Userid_Mapping_By_PkArgs = {
  app_id: Scalars['String']['input'];
  external_user_id: Scalars['String']['input'];
  supertokens_user_id: Scalars['bpchar']['input'];
};


/** mutation root */
export type MutationDelete_Taggit_TagArgs = {
  where: Taggit_Tag_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Taggit_Tag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Taggit_TaggeditemArgs = {
  where: Taggit_Taggeditem_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Taggit_Taggeditem_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Upcoming_Live_ClassesArgs = {
  where: Upcoming_Live_Classes_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Upcoming_Live_Classes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_ActivitiesArgs = {
  where: User_Activities_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_ActivityArgs = {
  where: User_Activity_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Activity_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Activity_Lesson_EntriesArgs = {
  where: User_Activity_Lesson_Entries_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Activity_Lesson_Entries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Cat_Registration_DataArgs = {
  where: User_Cat_Registration_Data_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Cat_Registration_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Cat_Response_Sheet_DataArgs = {
  where: User_Cat_Response_Sheet_Data_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Cat_Response_Sheet_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Custom_Planned_ActivitiesArgs = {
  where: User_Custom_Planned_Activities_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Custom_Planned_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Leaderboard_TypesArgs = {
  where: User_Leaderboard_Types_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Leaderboard_Types_By_PkArgs = {
  category: Scalars['String']['input'];
  sub_type: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** mutation root */
export type MutationDelete_User_LeaderboardsArgs = {
  where: User_Leaderboards_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Leaderboards_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Learn_ActivitiesArgs = {
  where: User_Learn_Activities_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Learn_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Learn_Category_ProgressArgs = {
  where: User_Learn_Category_Progress_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Learn_Category_Progress_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Learn_Completed_TopicsArgs = {
  where: User_Learn_Completed_Topics_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Learn_Completed_Topics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Learn_Modules_SummaryArgs = {
  where: User_Learn_Modules_Summary_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Learn_Modules_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Learn_Track_RecordArgs = {
  where: User_Learn_Track_Record_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Learn_Track_Record_Bookmarked_TopicsArgs = {
  where: User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Learn_Track_Record_Bookmarked_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Learn_Track_Record_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Learn_Track_Record_Which_TopicsArgs = {
  where: User_Learn_Track_Record_Which_Topics_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Learn_Track_Record_Which_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Planned_ActivitiesArgs = {
  where: User_Planned_Activities_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Planned_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Pov_SummariesArgs = {
  where: User_Pov_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Pov_Summaries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Quiz_Question_AttemptsArgs = {
  where: User_Quiz_Question_Attempts_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Quiz_Question_Attempts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Quiz_Question_PositionsArgs = {
  where: User_Quiz_Question_Positions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Quiz_Question_Positions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Quiz_Question_SummariesArgs = {
  where: User_Quiz_Question_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Quiz_Question_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Quiz_Question_Summaries_OldArgs = {
  where: User_Quiz_Question_Summaries_Old_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Quiz_Question_Summaries_Old_By_PkArgs = {
  question_id: Scalars['Int']['input'];
  quiz_summary_id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Quiz_QuestionsArgs = {
  where: User_Quiz_Questions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Quiz_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Quiz_Section_SummariesArgs = {
  where: User_Quiz_Section_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Quiz_Section_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Quiz_SummariesArgs = {
  where: User_Quiz_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Quiz_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Quiz_Summaries_OldArgs = {
  where: User_Quiz_Summaries_Old_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Quiz_Summaries_Old_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Section_SummariesArgs = {
  where: User_Section_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Section_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Speed_Test_Questions_SummariesArgs = {
  where: User_Speed_Test_Questions_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Speed_Test_Questions_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Speed_Tests_SummariesArgs = {
  where: User_Speed_Tests_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Speed_Tests_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Timed_Quiz_SummaryArgs = {
  where: User_Timed_Quiz_Summary_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Timed_Quiz_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_User_Total_ScoreArgs = {
  where: User_Total_Score_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Total_Score_By_PkArgs = {
  sum: Scalars['numeric']['input'];
};


/** mutation root */
export type MutationDelete_User_Xp_Transaction_SummariesArgs = {
  where: User_Xp_Transaction_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Xp_Transaction_Summaries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_User_Xp_TransactionsArgs = {
  where: User_Xp_Transactions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Xp_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationDelete_Users_UserArgs = {
  where: Users_User_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Users_User_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Users_User_GroupsArgs = {
  where: Users_User_Groups_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Users_User_Groups_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Users_User_User_PermissionsArgs = {
  where: Users_User_User_Permissions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Users_User_User_Permissions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Users_UserquestionsummaryArgs = {
  where: Users_Userquestionsummary_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Users_Userquestionsummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Users_UserquizsummaryArgs = {
  where: Users_Userquizsummary_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Users_Userquizsummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Users_UserquiztimesummaryArgs = {
  where: Users_Userquiztimesummary_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Users_Userquiztimesummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Users_UsersectionsummaryArgs = {
  where: Users_Usersectionsummary_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Users_Usersectionsummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Utils_ConfigurationArgs = {
  where: Utils_Configuration_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Utils_Configuration_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type MutationDelete_Xp_Transaction_TypesArgs = {
  where: Xp_Transaction_Types_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Xp_Transaction_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


/** mutation root */
export type MutationGetCatResultArgs = {
  input: GetCatResultInput;
};


/** mutation root */
export type MutationGetDownloadUrlArgs = {
  fileID: Scalars['String']['input'];
};


/** mutation root */
export type MutationGetOrderIdArgs = {
  amount: Scalars['String']['input'];
  receipt: Scalars['String']['input'];
};


/** mutation root */
export type MutationGetPresignedDownloadUrlArgs = {
  filename: Scalars['String']['input'];
};


/** mutation root */
export type MutationGetPresignedUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  path: Scalars['String']['input'];
  pathID: Scalars['String']['input'];
};


/** mutation root */
export type MutationGetUploadFileUrlArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  validFileType: Scalars['String']['input'];
};


/** mutation root */
export type MutationInitiatePaymentArgs = {
  couponID: Scalars['Int']['input'];
  groupID: Scalars['Int']['input'];
  planID: Scalars['String']['input'];
};


/** mutation root */
export type MutationInsert_Account_EmailaddressArgs = {
  objects: Array<Account_Emailaddress_Insert_Input>;
  on_conflict?: InputMaybe<Account_Emailaddress_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Account_Emailaddress_OneArgs = {
  object: Account_Emailaddress_Insert_Input;
  on_conflict?: InputMaybe<Account_Emailaddress_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Account_EmailconfirmationArgs = {
  objects: Array<Account_Emailconfirmation_Insert_Input>;
  on_conflict?: InputMaybe<Account_Emailconfirmation_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Account_Emailconfirmation_OneArgs = {
  object: Account_Emailconfirmation_Insert_Input;
  on_conflict?: InputMaybe<Account_Emailconfirmation_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Accounts_CatscoresArgs = {
  objects: Array<Accounts_Catscores_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_Catscores_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Accounts_Catscores_OneArgs = {
  object: Accounts_Catscores_Insert_Input;
  on_conflict?: InputMaybe<Accounts_Catscores_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Accounts_LoggedinuserArgs = {
  objects: Array<Accounts_Loggedinuser_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_Loggedinuser_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Accounts_Loggedinuser_OneArgs = {
  object: Accounts_Loggedinuser_Insert_Input;
  on_conflict?: InputMaybe<Accounts_Loggedinuser_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Activity_TypesArgs = {
  objects: Array<Activity_Types_Insert_Input>;
  on_conflict?: InputMaybe<Activity_Types_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Activity_Types_OneArgs = {
  object: Activity_Types_Insert_Input;
  on_conflict?: InputMaybe<Activity_Types_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Admin_ConstantsArgs = {
  objects: Array<Admin_Constants_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Constants_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Admin_Constants_OneArgs = {
  object: Admin_Constants_Insert_Input;
  on_conflict?: InputMaybe<Admin_Constants_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Admin_UsersArgs = {
  objects: Array<Admin_Users_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Admin_Users_OneArgs = {
  object: Admin_Users_Insert_Input;
  on_conflict?: InputMaybe<Admin_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_AdvertisementsArgs = {
  objects: Array<Advertisements_Insert_Input>;
  on_conflict?: InputMaybe<Advertisements_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Advertisements_OneArgs = {
  object: Advertisements_Insert_Input;
  on_conflict?: InputMaybe<Advertisements_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_EntryArgs = {
  objects: Array<Andablog_Entry_Insert_Input>;
  on_conflict?: InputMaybe<Andablog_Entry_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_Entry_OneArgs = {
  object: Andablog_Entry_Insert_Input;
  on_conflict?: InputMaybe<Andablog_Entry_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_EntryimageArgs = {
  objects: Array<Andablog_Entryimage_Insert_Input>;
  on_conflict?: InputMaybe<Andablog_Entryimage_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_Entryimage_OneArgs = {
  object: Andablog_Entryimage_Insert_Input;
  on_conflict?: InputMaybe<Andablog_Entryimage_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_NewsArgs = {
  objects: Array<Andablog_News_Insert_Input>;
  on_conflict?: InputMaybe<Andablog_News_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_News_OneArgs = {
  object: Andablog_News_Insert_Input;
  on_conflict?: InputMaybe<Andablog_News_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_PovArgs = {
  objects: Array<Andablog_Pov_Insert_Input>;
  on_conflict?: InputMaybe<Andablog_Pov_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_Pov_OneArgs = {
  object: Andablog_Pov_Insert_Input;
  on_conflict?: InputMaybe<Andablog_Pov_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_UserlessontrackrecordArgs = {
  objects: Array<Andablog_Userlessontrackrecord_Insert_Input>;
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_Userlessontrackrecord_Bookmarked_TopicsArgs = {
  objects: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Insert_Input>;
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_Userlessontrackrecord_Bookmarked_Topics_OneArgs = {
  object: Andablog_Userlessontrackrecord_Bookmarked_Topics_Insert_Input;
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_Userlessontrackrecord_OneArgs = {
  object: Andablog_Userlessontrackrecord_Insert_Input;
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_Userlessontrackrecord_Which_TopicsArgs = {
  objects: Array<Andablog_Userlessontrackrecord_Which_Topics_Insert_Input>;
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_Userlessontrackrecord_Which_Topics_OneArgs = {
  object: Andablog_Userlessontrackrecord_Which_Topics_Insert_Input;
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_VideoArgs = {
  objects: Array<Andablog_Video_Insert_Input>;
  on_conflict?: InputMaybe<Andablog_Video_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Andablog_Video_OneArgs = {
  object: Andablog_Video_Insert_Input;
  on_conflict?: InputMaybe<Andablog_Video_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_Email_VerificationsArgs = {
  objects: Array<Auth_Email_Verifications_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Email_Verifications_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_Email_Verifications_OneArgs = {
  object: Auth_Email_Verifications_Insert_Input;
  on_conflict?: InputMaybe<Auth_Email_Verifications_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_GroupArgs = {
  objects: Array<Auth_Group_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_Group_OneArgs = {
  object: Auth_Group_Insert_Input;
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_Group_PermissionsArgs = {
  objects: Array<Auth_Group_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Group_Permissions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_Group_Permissions_OneArgs = {
  object: Auth_Group_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Auth_Group_Permissions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_Password_Reset_TokensArgs = {
  objects: Array<Auth_Password_Reset_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Password_Reset_Tokens_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_Password_Reset_Tokens_OneArgs = {
  object: Auth_Password_Reset_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Auth_Password_Reset_Tokens_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_PermissionArgs = {
  objects: Array<Auth_Permission_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_Permission_OneArgs = {
  object: Auth_Permission_Insert_Input;
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_SessionArgs = {
  objects: Array<Auth_Session_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Session_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Auth_Session_OneArgs = {
  object: Auth_Session_Insert_Input;
  on_conflict?: InputMaybe<Auth_Session_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Bookmarked_Learn_TopicsArgs = {
  objects: Array<Bookmarked_Learn_Topics_Insert_Input>;
  on_conflict?: InputMaybe<Bookmarked_Learn_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Bookmarked_Learn_Topics_OneArgs = {
  object: Bookmarked_Learn_Topics_Insert_Input;
  on_conflict?: InputMaybe<Bookmarked_Learn_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Cat_Percentile_ConstantArgs = {
  objects: Array<Cat_Percentile_Constant_Insert_Input>;
  on_conflict?: InputMaybe<Cat_Percentile_Constant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Cat_Percentile_Constant_OneArgs = {
  object: Cat_Percentile_Constant_Insert_Input;
  on_conflict?: InputMaybe<Cat_Percentile_Constant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Cat_ScoresArgs = {
  objects: Array<Cat_Scores_Insert_Input>;
  on_conflict?: InputMaybe<Cat_Scores_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Cat_Scores_OneArgs = {
  object: Cat_Scores_Insert_Input;
  on_conflict?: InputMaybe<Cat_Scores_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Channel_MembersArgs = {
  objects: Array<Channel_Members_Insert_Input>;
  on_conflict?: InputMaybe<Channel_Members_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Channel_Members_OneArgs = {
  object: Channel_Members_Insert_Input;
  on_conflict?: InputMaybe<Channel_Members_On_Conflict>;
};


/** mutation root */
export type MutationInsert_ChannelsArgs = {
  objects: Array<Channels_Insert_Input>;
  on_conflict?: InputMaybe<Channels_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Channels_OneArgs = {
  object: Channels_Insert_Input;
  on_conflict?: InputMaybe<Channels_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Allowed_Users_Rule_UsersArgs = {
  objects: Array<Coupons_Allowed_Users_Rule_Users_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Allowed_Users_Rule_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Allowed_Users_Rule_Users_OneArgs = {
  object: Coupons_Allowed_Users_Rule_Users_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Allowed_Users_Rule_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_AllowedusersruleArgs = {
  objects: Array<Coupons_Allowedusersrule_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Allowedusersrule_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Allowedusersrule_OneArgs = {
  object: Coupons_Allowedusersrule_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Allowedusersrule_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Allowedusersrule_UsersArgs = {
  objects: Array<Coupons_Allowedusersrule_Users_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Allowedusersrule_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Allowedusersrule_Users_OneArgs = {
  object: Coupons_Allowedusersrule_Users_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Allowedusersrule_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_CouponArgs = {
  objects: Array<Coupons_Coupon_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Coupon_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Coupon_Applicable_PackagesArgs = {
  objects: Array<Coupons_Coupon_Applicable_Packages_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Coupon_Applicable_Packages_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Coupon_Applicable_Packages_OneArgs = {
  object: Coupons_Coupon_Applicable_Packages_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Coupon_Applicable_Packages_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Coupon_OneArgs = {
  object: Coupons_Coupon_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Coupon_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_CouponuserArgs = {
  objects: Array<Coupons_Couponuser_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Couponuser_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Couponuser_OneArgs = {
  object: Coupons_Couponuser_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Couponuser_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_DiscountArgs = {
  objects: Array<Coupons_Discount_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Discount_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Discount_OneArgs = {
  object: Coupons_Discount_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Discount_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_MaxusesruleArgs = {
  objects: Array<Coupons_Maxusesrule_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Maxusesrule_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Maxusesrule_OneArgs = {
  object: Coupons_Maxusesrule_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Maxusesrule_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_RulesetArgs = {
  objects: Array<Coupons_Ruleset_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Ruleset_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Ruleset_OneArgs = {
  object: Coupons_Ruleset_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Ruleset_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_ValidityruleArgs = {
  objects: Array<Coupons_Validityrule_Insert_Input>;
  on_conflict?: InputMaybe<Coupons_Validityrule_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Coupons_Validityrule_OneArgs = {
  object: Coupons_Validityrule_Insert_Input;
  on_conflict?: InputMaybe<Coupons_Validityrule_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_Admin_LogArgs = {
  objects: Array<Django_Admin_Log_Insert_Input>;
  on_conflict?: InputMaybe<Django_Admin_Log_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_Admin_Log_OneArgs = {
  object: Django_Admin_Log_Insert_Input;
  on_conflict?: InputMaybe<Django_Admin_Log_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_Content_TypeArgs = {
  objects: Array<Django_Content_Type_Insert_Input>;
  on_conflict?: InputMaybe<Django_Content_Type_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_Content_Type_OneArgs = {
  object: Django_Content_Type_Insert_Input;
  on_conflict?: InputMaybe<Django_Content_Type_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_MigrationsArgs = {
  objects: Array<Django_Migrations_Insert_Input>;
  on_conflict?: InputMaybe<Django_Migrations_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_Migrations_OneArgs = {
  object: Django_Migrations_Insert_Input;
  on_conflict?: InputMaybe<Django_Migrations_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_SessionArgs = {
  objects: Array<Django_Session_Insert_Input>;
  on_conflict?: InputMaybe<Django_Session_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_Session_OneArgs = {
  object: Django_Session_Insert_Input;
  on_conflict?: InputMaybe<Django_Session_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_SiteArgs = {
  objects: Array<Django_Site_Insert_Input>;
  on_conflict?: InputMaybe<Django_Site_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Django_Site_OneArgs = {
  object: Django_Site_Insert_Input;
  on_conflict?: InputMaybe<Django_Site_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Djconfig_ConfigArgs = {
  objects: Array<Djconfig_Config_Insert_Input>;
  on_conflict?: InputMaybe<Djconfig_Config_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Djconfig_Config_OneArgs = {
  object: Djconfig_Config_Insert_Input;
  on_conflict?: InputMaybe<Djconfig_Config_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Group_CategoryArgs = {
  objects: Array<Group_Category_Insert_Input>;
  on_conflict?: InputMaybe<Group_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Group_Category_OneArgs = {
  object: Group_Category_Insert_Input;
  on_conflict?: InputMaybe<Group_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Group_Discount_UsersArgs = {
  objects: Array<Group_Discount_Users_Insert_Input>;
};


/** mutation root */
export type MutationInsert_Group_Discount_Users_OneArgs = {
  object: Group_Discount_Users_Insert_Input;
};


/** mutation root */
export type MutationInsert_Has_AccessArgs = {
  objects: Array<Has_Access_Insert_Input>;
};


/** mutation root */
export type MutationInsert_Has_Access_OneArgs = {
  object: Has_Access_Insert_Input;
};


/** mutation root */
export type MutationInsert_Infozone_CategoryArgs = {
  objects: Array<Infozone_Category_Insert_Input>;
  on_conflict?: InputMaybe<Infozone_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Infozone_Category_OneArgs = {
  object: Infozone_Category_Insert_Input;
  on_conflict?: InputMaybe<Infozone_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Infozone_InfozoneArgs = {
  objects: Array<Infozone_Infozone_Insert_Input>;
  on_conflict?: InputMaybe<Infozone_Infozone_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Infozone_Infozone_OneArgs = {
  object: Infozone_Infozone_Insert_Input;
  on_conflict?: InputMaybe<Infozone_Infozone_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Infozone_StaticpagesArgs = {
  objects: Array<Infozone_Staticpages_Insert_Input>;
  on_conflict?: InputMaybe<Infozone_Staticpages_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Infozone_Staticpages_OneArgs = {
  object: Infozone_Staticpages_Insert_Input;
  on_conflict?: InputMaybe<Infozone_Staticpages_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Live_Quiz_LeaderboardArgs = {
  objects: Array<Live_Quiz_Leaderboard_Insert_Input>;
  on_conflict?: InputMaybe<Live_Quiz_Leaderboard_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Live_Quiz_Leaderboard_OneArgs = {
  object: Live_Quiz_Leaderboard_Insert_Input;
  on_conflict?: InputMaybe<Live_Quiz_Leaderboard_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Live_Quiz_Question_PositionsArgs = {
  objects: Array<Live_Quiz_Question_Positions_Insert_Input>;
  on_conflict?: InputMaybe<Live_Quiz_Question_Positions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Live_Quiz_Question_Positions_OneArgs = {
  object: Live_Quiz_Question_Positions_Insert_Input;
  on_conflict?: InputMaybe<Live_Quiz_Question_Positions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Live_Quiz_Question_SummaryArgs = {
  objects: Array<Live_Quiz_Question_Summary_Insert_Input>;
  on_conflict?: InputMaybe<Live_Quiz_Question_Summary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Live_Quiz_Question_Summary_OneArgs = {
  object: Live_Quiz_Question_Summary_Insert_Input;
  on_conflict?: InputMaybe<Live_Quiz_Question_Summary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Live_Quiz_SummaryArgs = {
  objects: Array<Live_Quiz_Summary_Insert_Input>;
  on_conflict?: InputMaybe<Live_Quiz_Summary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Live_Quiz_Summary_OneArgs = {
  object: Live_Quiz_Summary_Insert_Input;
  on_conflict?: InputMaybe<Live_Quiz_Summary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Percentile_DilrArgs = {
  objects: Array<Marks_Vs_Percentile_Dilr_Insert_Input>;
  on_conflict?: InputMaybe<Marks_Vs_Percentile_Dilr_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Percentile_Dilr_OneArgs = {
  object: Marks_Vs_Percentile_Dilr_Insert_Input;
  on_conflict?: InputMaybe<Marks_Vs_Percentile_Dilr_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Percentile_QuantArgs = {
  objects: Array<Marks_Vs_Percentile_Quant_Insert_Input>;
  on_conflict?: InputMaybe<Marks_Vs_Percentile_Quant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Percentile_Quant_OneArgs = {
  object: Marks_Vs_Percentile_Quant_Insert_Input;
  on_conflict?: InputMaybe<Marks_Vs_Percentile_Quant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Percentile_Total_RawArgs = {
  objects: Array<Marks_Vs_Percentile_Total_Raw_Insert_Input>;
  on_conflict?: InputMaybe<Marks_Vs_Percentile_Total_Raw_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Percentile_Total_Raw_OneArgs = {
  object: Marks_Vs_Percentile_Total_Raw_Insert_Input;
  on_conflict?: InputMaybe<Marks_Vs_Percentile_Total_Raw_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Percentile_VarcArgs = {
  objects: Array<Marks_Vs_Percentile_Varc_Insert_Input>;
  on_conflict?: InputMaybe<Marks_Vs_Percentile_Varc_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Percentile_Varc_OneArgs = {
  object: Marks_Vs_Percentile_Varc_Insert_Input;
  on_conflict?: InputMaybe<Marks_Vs_Percentile_Varc_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Scaled_PercentileArgs = {
  objects: Array<Marks_Vs_Scaled_Percentile_Insert_Input>;
  on_conflict?: InputMaybe<Marks_Vs_Scaled_Percentile_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Marks_Vs_Scaled_Percentile_OneArgs = {
  object: Marks_Vs_Scaled_Percentile_Insert_Input;
  on_conflict?: InputMaybe<Marks_Vs_Scaled_Percentile_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Meeting_MembersArgs = {
  objects: Array<Meeting_Members_Insert_Input>;
  on_conflict?: InputMaybe<Meeting_Members_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Meeting_Members_OneArgs = {
  object: Meeting_Members_Insert_Input;
  on_conflict?: InputMaybe<Meeting_Members_On_Conflict>;
};


/** mutation root */
export type MutationInsert_MeetingsArgs = {
  objects: Array<Meetings_Insert_Input>;
  on_conflict?: InputMaybe<Meetings_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Meetings_OneArgs = {
  object: Meetings_Insert_Input;
  on_conflict?: InputMaybe<Meetings_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Message_ReactionsArgs = {
  objects: Array<Message_Reactions_Insert_Input>;
  on_conflict?: InputMaybe<Message_Reactions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Message_Reactions_OneArgs = {
  object: Message_Reactions_Insert_Input;
  on_conflict?: InputMaybe<Message_Reactions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_MessagesArgs = {
  objects: Array<Messages_Insert_Input>;
  on_conflict?: InputMaybe<Messages_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Messages_OneArgs = {
  object: Messages_Insert_Input;
  on_conflict?: InputMaybe<Messages_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Messages_ReadArgs = {
  objects: Array<Messages_Read_Insert_Input>;
  on_conflict?: InputMaybe<Messages_Read_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Messages_Read_OneArgs = {
  object: Messages_Read_Insert_Input;
  on_conflict?: InputMaybe<Messages_Read_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Offline_LeadsArgs = {
  objects: Array<Offline_Leads_Insert_Input>;
  on_conflict?: InputMaybe<Offline_Leads_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Offline_Leads_OneArgs = {
  object: Offline_Leads_Insert_Input;
  on_conflict?: InputMaybe<Offline_Leads_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Package_Content_Discarded_QuizzesArgs = {
  objects: Array<Package_Content_Discarded_Quizzes_Insert_Input>;
  on_conflict?: InputMaybe<Package_Content_Discarded_Quizzes_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Package_Content_Discarded_Quizzes_OneArgs = {
  object: Package_Content_Discarded_Quizzes_Insert_Input;
  on_conflict?: InputMaybe<Package_Content_Discarded_Quizzes_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_ContentArgs = {
  objects: Array<Packages_Content_Insert_Input>;
  on_conflict?: InputMaybe<Packages_Content_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Content_DomainsArgs = {
  objects: Array<Packages_Content_Domains_Insert_Input>;
  on_conflict?: InputMaybe<Packages_Content_Domains_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Content_Domains_OneArgs = {
  object: Packages_Content_Domains_Insert_Input;
  on_conflict?: InputMaybe<Packages_Content_Domains_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Content_OneArgs = {
  object: Packages_Content_Insert_Input;
  on_conflict?: InputMaybe<Packages_Content_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Content_Text_LessonArgs = {
  objects: Array<Packages_Content_Text_Lesson_Insert_Input>;
  on_conflict?: InputMaybe<Packages_Content_Text_Lesson_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Content_Text_Lesson_OneArgs = {
  object: Packages_Content_Text_Lesson_Insert_Input;
  on_conflict?: InputMaybe<Packages_Content_Text_Lesson_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Content_Timed_TestArgs = {
  objects: Array<Packages_Content_Timed_Test_Insert_Input>;
  on_conflict?: InputMaybe<Packages_Content_Timed_Test_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Content_Timed_Test_OneArgs = {
  object: Packages_Content_Timed_Test_Insert_Input;
  on_conflict?: InputMaybe<Packages_Content_Timed_Test_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Content_Untimed_TestArgs = {
  objects: Array<Packages_Content_Untimed_Test_Insert_Input>;
  on_conflict?: InputMaybe<Packages_Content_Untimed_Test_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Content_Untimed_Test_OneArgs = {
  object: Packages_Content_Untimed_Test_Insert_Input;
  on_conflict?: InputMaybe<Packages_Content_Untimed_Test_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Payment_TransactionArgs = {
  objects: Array<Packages_Payment_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Packages_Payment_Transaction_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Payment_Transaction_OneArgs = {
  object: Packages_Payment_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Packages_Payment_Transaction_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_PaymenttransactionArgs = {
  objects: Array<Packages_Paymenttransaction_Insert_Input>;
  on_conflict?: InputMaybe<Packages_Paymenttransaction_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Packages_Paymenttransaction_OneArgs = {
  object: Packages_Paymenttransaction_Insert_Input;
  on_conflict?: InputMaybe<Packages_Paymenttransaction_On_Conflict>;
};


/** mutation root */
export type MutationInsert_PollArgs = {
  objects: Array<Poll_Insert_Input>;
  on_conflict?: InputMaybe<Poll_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Poll_OneArgs = {
  object: Poll_Insert_Input;
  on_conflict?: InputMaybe<Poll_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Poll_OptionsArgs = {
  objects: Array<Poll_Options_Insert_Input>;
  on_conflict?: InputMaybe<Poll_Options_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Poll_Options_OneArgs = {
  object: Poll_Options_Insert_Input;
  on_conflict?: InputMaybe<Poll_Options_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Poll_ResponsesArgs = {
  objects: Array<Poll_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Poll_Responses_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Poll_Responses_OneArgs = {
  object: Poll_Responses_Insert_Input;
  on_conflict?: InputMaybe<Poll_Responses_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Question_ReportsArgs = {
  objects: Array<Question_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Question_Reports_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Question_Reports_OneArgs = {
  object: Question_Reports_Insert_Input;
  on_conflict?: InputMaybe<Question_Reports_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_AnswerArgs = {
  objects: Array<Quiz_Answer_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Answer_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Answer_OneArgs = {
  object: Quiz_Answer_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Answer_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_CategoryArgs = {
  objects: Array<Quiz_Category_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Category_OneArgs = {
  object: Quiz_Category_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_DomainArgs = {
  objects: Array<Quiz_Domain_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Domain_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Domain_OneArgs = {
  object: Quiz_Domain_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Domain_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_MarkingsystemArgs = {
  objects: Array<Quiz_Markingsystem_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Markingsystem_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Markingsystem_OneArgs = {
  object: Quiz_Markingsystem_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Markingsystem_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_OptionArgs = {
  objects: Array<Quiz_Option_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Option_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Option_OneArgs = {
  object: Quiz_Option_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Option_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_ParagraphArgs = {
  objects: Array<Quiz_Paragraph_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Paragraph_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Paragraph_OneArgs = {
  object: Quiz_Paragraph_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Paragraph_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_QuestionArgs = {
  objects: Array<Quiz_Question_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Question_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Question_OneArgs = {
  object: Quiz_Question_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Question_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_QuizArgs = {
  objects: Array<Quiz_Quiz_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Quiz_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Quiz_OneArgs = {
  object: Quiz_Quiz_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Quiz_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Quiz_QuestionsArgs = {
  objects: Array<Quiz_Quiz_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Quiz_Questions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Quiz_Questions_OneArgs = {
  object: Quiz_Quiz_Questions_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Quiz_Questions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Quiz_SectionsArgs = {
  objects: Array<Quiz_Quiz_Sections_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Quiz_Sections_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Quiz_Sections_OneArgs = {
  object: Quiz_Quiz_Sections_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Quiz_Sections_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_SectionArgs = {
  objects: Array<Quiz_Section_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Section_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Section_OneArgs = {
  object: Quiz_Section_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Section_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Section_QuestionsArgs = {
  objects: Array<Quiz_Section_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Section_Questions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Section_Questions_OneArgs = {
  object: Quiz_Section_Questions_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Section_Questions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Section_SubsectionsArgs = {
  objects: Array<Quiz_Section_Subsections_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Section_Subsections_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Section_Subsections_OneArgs = {
  object: Quiz_Section_Subsections_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Section_Subsections_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_SuperdomainArgs = {
  objects: Array<Quiz_Superdomain_Insert_Input>;
  on_conflict?: InputMaybe<Quiz_Superdomain_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Quiz_Superdomain_OneArgs = {
  object: Quiz_Superdomain_Insert_Input;
  on_conflict?: InputMaybe<Quiz_Superdomain_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Random_Question_IdsArgs = {
  objects: Array<Random_Question_Ids_Insert_Input>;
};


/** mutation root */
export type MutationInsert_Random_Question_Ids_OneArgs = {
  object: Random_Question_Ids_Insert_Input;
};


/** mutation root */
export type MutationInsert_Reaction_EmojisArgs = {
  objects: Array<Reaction_Emojis_Insert_Input>;
  on_conflict?: InputMaybe<Reaction_Emojis_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Reaction_Emojis_OneArgs = {
  object: Reaction_Emojis_Insert_Input;
  on_conflict?: InputMaybe<Reaction_Emojis_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Reported_MessageArgs = {
  objects: Array<Reported_Message_Insert_Input>;
  on_conflict?: InputMaybe<Reported_Message_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Reported_Message_OneArgs = {
  object: Reported_Message_Insert_Input;
  on_conflict?: InputMaybe<Reported_Message_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Scaling_ConstantArgs = {
  objects: Array<Scaling_Constant_Insert_Input>;
  on_conflict?: InputMaybe<Scaling_Constant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Scaling_Constant_OneArgs = {
  object: Scaling_Constant_Insert_Input;
  on_conflict?: InputMaybe<Scaling_Constant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Socialaccount_SocialaccountArgs = {
  objects: Array<Socialaccount_Socialaccount_Insert_Input>;
  on_conflict?: InputMaybe<Socialaccount_Socialaccount_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Socialaccount_Socialaccount_OneArgs = {
  object: Socialaccount_Socialaccount_Insert_Input;
  on_conflict?: InputMaybe<Socialaccount_Socialaccount_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Socialaccount_SocialappArgs = {
  objects: Array<Socialaccount_Socialapp_Insert_Input>;
  on_conflict?: InputMaybe<Socialaccount_Socialapp_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Socialaccount_Socialapp_OneArgs = {
  object: Socialaccount_Socialapp_Insert_Input;
  on_conflict?: InputMaybe<Socialaccount_Socialapp_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Socialaccount_Socialapp_SitesArgs = {
  objects: Array<Socialaccount_Socialapp_Sites_Insert_Input>;
  on_conflict?: InputMaybe<Socialaccount_Socialapp_Sites_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Socialaccount_Socialapp_Sites_OneArgs = {
  object: Socialaccount_Socialapp_Sites_Insert_Input;
  on_conflict?: InputMaybe<Socialaccount_Socialapp_Sites_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Socialaccount_SocialtokenArgs = {
  objects: Array<Socialaccount_Socialtoken_Insert_Input>;
  on_conflict?: InputMaybe<Socialaccount_Socialtoken_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Socialaccount_Socialtoken_OneArgs = {
  object: Socialaccount_Socialtoken_Insert_Input;
  on_conflict?: InputMaybe<Socialaccount_Socialtoken_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Speed_Test_CategoryArgs = {
  objects: Array<Speed_Test_Category_Insert_Input>;
  on_conflict?: InputMaybe<Speed_Test_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Speed_Test_Category_OneArgs = {
  object: Speed_Test_Category_Insert_Input;
  on_conflict?: InputMaybe<Speed_Test_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Speed_TestsArgs = {
  objects: Array<Speed_Tests_Insert_Input>;
  on_conflict?: InputMaybe<Speed_Tests_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Speed_Tests_OneArgs = {
  object: Speed_Tests_Insert_Input;
  on_conflict?: InputMaybe<Speed_Tests_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_CacheArgs = {
  objects: Array<Spirit_Cache_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Cache_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Cache_OneArgs = {
  object: Spirit_Cache_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Cache_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Category_CategoryArgs = {
  objects: Array<Spirit_Category_Category_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Category_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Category_Category_OneArgs = {
  object: Spirit_Category_Category_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Category_Category_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Bookmark_CommentbookmarkArgs = {
  objects: Array<Spirit_Comment_Bookmark_Commentbookmark_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Bookmark_Commentbookmark_OneArgs = {
  object: Spirit_Comment_Bookmark_Commentbookmark_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_CommentArgs = {
  objects: Array<Spirit_Comment_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Comment_Comment_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Comment_OneArgs = {
  object: Spirit_Comment_Comment_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Comment_Comment_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Flag_CommentflagArgs = {
  objects: Array<Spirit_Comment_Flag_Commentflag_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Comment_Flag_Commentflag_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Flag_Commentflag_OneArgs = {
  object: Spirit_Comment_Flag_Commentflag_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Comment_Flag_Commentflag_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Flag_FlagArgs = {
  objects: Array<Spirit_Comment_Flag_Flag_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Comment_Flag_Flag_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Flag_Flag_OneArgs = {
  object: Spirit_Comment_Flag_Flag_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Comment_Flag_Flag_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_History_CommenthistoryArgs = {
  objects: Array<Spirit_Comment_History_Commenthistory_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Comment_History_Commenthistory_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_History_Commenthistory_OneArgs = {
  object: Spirit_Comment_History_Commenthistory_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Comment_History_Commenthistory_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Like_CommentlikeArgs = {
  objects: Array<Spirit_Comment_Like_Commentlike_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Comment_Like_Commentlike_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Like_Commentlike_OneArgs = {
  object: Spirit_Comment_Like_Commentlike_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Comment_Like_Commentlike_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Poll_CommentpollArgs = {
  objects: Array<Spirit_Comment_Poll_Commentpoll_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpoll_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Poll_Commentpoll_OneArgs = {
  object: Spirit_Comment_Poll_Commentpoll_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpoll_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Poll_CommentpollchoiceArgs = {
  objects: Array<Spirit_Comment_Poll_Commentpollchoice_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Poll_Commentpollchoice_OneArgs = {
  object: Spirit_Comment_Poll_Commentpollchoice_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Poll_CommentpollvoteArgs = {
  objects: Array<Spirit_Comment_Poll_Commentpollvote_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Comment_Poll_Commentpollvote_OneArgs = {
  object: Spirit_Comment_Poll_Commentpollvote_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Rl_CacheArgs = {
  objects: Array<Spirit_Rl_Cache_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Rl_Cache_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Rl_Cache_OneArgs = {
  object: Spirit_Rl_Cache_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Rl_Cache_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_Favorite_TopicfavoriteArgs = {
  objects: Array<Spirit_Topic_Favorite_Topicfavorite_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_Favorite_Topicfavorite_OneArgs = {
  object: Spirit_Topic_Favorite_Topicfavorite_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_Notification_TopicnotificationArgs = {
  objects: Array<Spirit_Topic_Notification_Topicnotification_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Topic_Notification_Topicnotification_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_Notification_Topicnotification_OneArgs = {
  object: Spirit_Topic_Notification_Topicnotification_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Topic_Notification_Topicnotification_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_Private_TopicprivateArgs = {
  objects: Array<Spirit_Topic_Private_Topicprivate_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Topic_Private_Topicprivate_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_Private_Topicprivate_OneArgs = {
  object: Spirit_Topic_Private_Topicprivate_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Topic_Private_Topicprivate_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_TopicArgs = {
  objects: Array<Spirit_Topic_Topic_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Topic_Topic_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_Topic_OneArgs = {
  object: Spirit_Topic_Topic_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Topic_Topic_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_Unread_TopicunreadArgs = {
  objects: Array<Spirit_Topic_Unread_Topicunread_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_Topic_Unread_Topicunread_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_Topic_Unread_Topicunread_OneArgs = {
  object: Spirit_Topic_Unread_Topicunread_Insert_Input;
  on_conflict?: InputMaybe<Spirit_Topic_Unread_Topicunread_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_User_UserprofileArgs = {
  objects: Array<Spirit_User_Userprofile_Insert_Input>;
  on_conflict?: InputMaybe<Spirit_User_Userprofile_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Spirit_User_Userprofile_OneArgs = {
  object: Spirit_User_Userprofile_Insert_Input;
  on_conflict?: InputMaybe<Spirit_User_Userprofile_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscription_Group_PlanArgs = {
  objects: Array<Subscription_Group_Plan_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Group_Plan_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscription_Group_Plan_GroupsArgs = {
  objects: Array<Subscription_Group_Plan_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Group_Plan_Groups_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscription_Group_Plan_Groups_OneArgs = {
  object: Subscription_Group_Plan_Groups_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Group_Plan_Groups_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscription_Group_Plan_OneArgs = {
  object: Subscription_Group_Plan_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Group_Plan_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_PlancostArgs = {
  objects: Array<Subscriptions_Plancost_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Plancost_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_Plancost_OneArgs = {
  object: Subscriptions_Plancost_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Plancost_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_PlanlistArgs = {
  objects: Array<Subscriptions_Planlist_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Planlist_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_Planlist_OneArgs = {
  object: Subscriptions_Planlist_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Planlist_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_PlanlistdetailArgs = {
  objects: Array<Subscriptions_Planlistdetail_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Planlistdetail_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_Planlistdetail_OneArgs = {
  object: Subscriptions_Planlistdetail_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Planlistdetail_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_PlantagArgs = {
  objects: Array<Subscriptions_Plantag_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Plantag_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_Plantag_OneArgs = {
  object: Subscriptions_Plantag_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Plantag_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_SubscriptionplanArgs = {
  objects: Array<Subscriptions_Subscriptionplan_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Subscriptionplan_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_Subscriptionplan_OneArgs = {
  object: Subscriptions_Subscriptionplan_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Subscriptionplan_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_Subscriptionplan_Upgradable_PlansArgs = {
  objects: Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_Subscriptionplan_Upgradable_Plans_OneArgs = {
  object: Subscriptions_Subscriptionplan_Upgradable_Plans_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_SubscriptiontransactionArgs = {
  objects: Array<Subscriptions_Subscriptiontransaction_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Subscriptiontransaction_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_Subscriptiontransaction_OneArgs = {
  object: Subscriptions_Subscriptiontransaction_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Subscriptiontransaction_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_UsersubscriptionArgs = {
  objects: Array<Subscriptions_Usersubscription_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Usersubscription_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Subscriptions_Usersubscription_OneArgs = {
  object: Subscriptions_Usersubscription_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Usersubscription_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_All_Auth_Recipe_UsersArgs = {
  objects: Array<Supertokens_All_Auth_Recipe_Users_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_All_Auth_Recipe_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_All_Auth_Recipe_Users_OneArgs = {
  object: Supertokens_All_Auth_Recipe_Users_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_All_Auth_Recipe_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_App_Id_To_User_IdArgs = {
  objects: Array<Supertokens_App_Id_To_User_Id_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_App_Id_To_User_Id_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_App_Id_To_User_Id_OneArgs = {
  object: Supertokens_App_Id_To_User_Id_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_App_Id_To_User_Id_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_AppsArgs = {
  objects: Array<Supertokens_Apps_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Apps_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Apps_OneArgs = {
  object: Supertokens_Apps_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Apps_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Dashboard_User_SessionsArgs = {
  objects: Array<Supertokens_Dashboard_User_Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Dashboard_User_Sessions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Dashboard_User_Sessions_OneArgs = {
  object: Supertokens_Dashboard_User_Sessions_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Dashboard_User_Sessions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Dashboard_UsersArgs = {
  objects: Array<Supertokens_Dashboard_Users_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Dashboard_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Dashboard_Users_OneArgs = {
  object: Supertokens_Dashboard_Users_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Dashboard_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailpassword_Pswd_Reset_TokensArgs = {
  objects: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailpassword_Pswd_Reset_Tokens_OneArgs = {
  object: Supertokens_Emailpassword_Pswd_Reset_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailpassword_User_To_TenantArgs = {
  objects: Array<Supertokens_Emailpassword_User_To_Tenant_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailpassword_User_To_Tenant_OneArgs = {
  object: Supertokens_Emailpassword_User_To_Tenant_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailpassword_UsersArgs = {
  objects: Array<Supertokens_Emailpassword_Users_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Emailpassword_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailpassword_Users_OneArgs = {
  object: Supertokens_Emailpassword_Users_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Emailpassword_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailverification_TokensArgs = {
  objects: Array<Supertokens_Emailverification_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Emailverification_Tokens_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailverification_Tokens_OneArgs = {
  object: Supertokens_Emailverification_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Emailverification_Tokens_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailverification_Verified_EmailsArgs = {
  objects: Array<Supertokens_Emailverification_Verified_Emails_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Emailverification_Verified_Emails_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Emailverification_Verified_Emails_OneArgs = {
  object: Supertokens_Emailverification_Verified_Emails_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Emailverification_Verified_Emails_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Jwt_Signing_KeysArgs = {
  objects: Array<Supertokens_Jwt_Signing_Keys_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Jwt_Signing_Keys_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Jwt_Signing_Keys_OneArgs = {
  object: Supertokens_Jwt_Signing_Keys_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Jwt_Signing_Keys_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Key_ValueArgs = {
  objects: Array<Supertokens_Key_Value_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Key_Value_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Key_Value_OneArgs = {
  object: Supertokens_Key_Value_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Key_Value_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Passwordless_CodesArgs = {
  objects: Array<Supertokens_Passwordless_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Passwordless_Codes_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Passwordless_Codes_OneArgs = {
  object: Supertokens_Passwordless_Codes_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Passwordless_Codes_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Passwordless_DevicesArgs = {
  objects: Array<Supertokens_Passwordless_Devices_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Passwordless_Devices_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Passwordless_Devices_OneArgs = {
  object: Supertokens_Passwordless_Devices_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Passwordless_Devices_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Passwordless_User_To_TenantArgs = {
  objects: Array<Supertokens_Passwordless_User_To_Tenant_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Passwordless_User_To_Tenant_OneArgs = {
  object: Supertokens_Passwordless_User_To_Tenant_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Passwordless_UsersArgs = {
  objects: Array<Supertokens_Passwordless_Users_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Passwordless_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Passwordless_Users_OneArgs = {
  object: Supertokens_Passwordless_Users_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Passwordless_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Role_PermissionsArgs = {
  objects: Array<Supertokens_Role_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Role_Permissions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Role_Permissions_OneArgs = {
  object: Supertokens_Role_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Role_Permissions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_RolesArgs = {
  objects: Array<Supertokens_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Roles_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Roles_OneArgs = {
  object: Supertokens_Roles_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Roles_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Session_Access_Token_Signing_KeysArgs = {
  objects: Array<Supertokens_Session_Access_Token_Signing_Keys_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Session_Access_Token_Signing_Keys_OneArgs = {
  object: Supertokens_Session_Access_Token_Signing_Keys_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Session_InfoArgs = {
  objects: Array<Supertokens_Session_Info_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Session_Info_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Session_Info_OneArgs = {
  object: Supertokens_Session_Info_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Session_Info_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Tenant_ConfigsArgs = {
  objects: Array<Supertokens_Tenant_Configs_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Tenant_Configs_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Tenant_Configs_OneArgs = {
  object: Supertokens_Tenant_Configs_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Tenant_Configs_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Tenant_Thirdparty_Provider_ClientsArgs = {
  objects: Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Tenant_Thirdparty_Provider_Clients_OneArgs = {
  object: Supertokens_Tenant_Thirdparty_Provider_Clients_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Tenant_Thirdparty_ProvidersArgs = {
  objects: Array<Supertokens_Tenant_Thirdparty_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Tenant_Thirdparty_Providers_OneArgs = {
  object: Supertokens_Tenant_Thirdparty_Providers_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_TenantsArgs = {
  objects: Array<Supertokens_Tenants_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Tenants_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Tenants_OneArgs = {
  object: Supertokens_Tenants_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Tenants_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Thirdparty_User_To_TenantArgs = {
  objects: Array<Supertokens_Thirdparty_User_To_Tenant_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Thirdparty_User_To_Tenant_OneArgs = {
  object: Supertokens_Thirdparty_User_To_Tenant_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Thirdparty_UsersArgs = {
  objects: Array<Supertokens_Thirdparty_Users_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Thirdparty_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Thirdparty_Users_OneArgs = {
  object: Supertokens_Thirdparty_Users_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Thirdparty_Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_User_Additional_FieldsArgs = {
  objects: Array<Supertokens_User_Additional_Fields_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_User_Additional_Fields_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_User_Additional_Fields_OneArgs = {
  object: Supertokens_User_Additional_Fields_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_User_Additional_Fields_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_User_Last_ActiveArgs = {
  objects: Array<Supertokens_User_Last_Active_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_User_Last_Active_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_User_Last_Active_OneArgs = {
  object: Supertokens_User_Last_Active_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_User_Last_Active_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_User_MetadataArgs = {
  objects: Array<Supertokens_User_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_User_Metadata_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_User_Metadata_OneArgs = {
  object: Supertokens_User_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_User_Metadata_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_User_Public_FieldsArgs = {
  objects: Array<Supertokens_User_Public_Fields_Insert_Input>;
};


/** mutation root */
export type MutationInsert_Supertokens_User_Public_Fields_OneArgs = {
  object: Supertokens_User_Public_Fields_Insert_Input;
};


/** mutation root */
export type MutationInsert_Supertokens_User_RolesArgs = {
  objects: Array<Supertokens_User_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_User_Roles_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_User_Roles_OneArgs = {
  object: Supertokens_User_Roles_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_User_Roles_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Userid_MappingArgs = {
  objects: Array<Supertokens_Userid_Mapping_Insert_Input>;
  on_conflict?: InputMaybe<Supertokens_Userid_Mapping_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Supertokens_Userid_Mapping_OneArgs = {
  object: Supertokens_Userid_Mapping_Insert_Input;
  on_conflict?: InputMaybe<Supertokens_Userid_Mapping_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Taggit_TagArgs = {
  objects: Array<Taggit_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Taggit_Tag_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Taggit_Tag_OneArgs = {
  object: Taggit_Tag_Insert_Input;
  on_conflict?: InputMaybe<Taggit_Tag_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Taggit_TaggeditemArgs = {
  objects: Array<Taggit_Taggeditem_Insert_Input>;
  on_conflict?: InputMaybe<Taggit_Taggeditem_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Taggit_Taggeditem_OneArgs = {
  object: Taggit_Taggeditem_Insert_Input;
  on_conflict?: InputMaybe<Taggit_Taggeditem_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Upcoming_Live_ClassesArgs = {
  objects: Array<Upcoming_Live_Classes_Insert_Input>;
  on_conflict?: InputMaybe<Upcoming_Live_Classes_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Upcoming_Live_Classes_OneArgs = {
  object: Upcoming_Live_Classes_Insert_Input;
  on_conflict?: InputMaybe<Upcoming_Live_Classes_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_ActivitiesArgs = {
  objects: Array<User_Activities_Insert_Input>;
  on_conflict?: InputMaybe<User_Activities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Activities_OneArgs = {
  object: User_Activities_Insert_Input;
  on_conflict?: InputMaybe<User_Activities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_ActivityArgs = {
  objects: Array<User_Activity_Insert_Input>;
  on_conflict?: InputMaybe<User_Activity_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Activity_Lesson_EntriesArgs = {
  objects: Array<User_Activity_Lesson_Entries_Insert_Input>;
  on_conflict?: InputMaybe<User_Activity_Lesson_Entries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Activity_Lesson_Entries_OneArgs = {
  object: User_Activity_Lesson_Entries_Insert_Input;
  on_conflict?: InputMaybe<User_Activity_Lesson_Entries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Activity_OneArgs = {
  object: User_Activity_Insert_Input;
  on_conflict?: InputMaybe<User_Activity_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Cat_Registration_DataArgs = {
  objects: Array<User_Cat_Registration_Data_Insert_Input>;
  on_conflict?: InputMaybe<User_Cat_Registration_Data_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Cat_Registration_Data_OneArgs = {
  object: User_Cat_Registration_Data_Insert_Input;
  on_conflict?: InputMaybe<User_Cat_Registration_Data_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Cat_Response_Sheet_DataArgs = {
  objects: Array<User_Cat_Response_Sheet_Data_Insert_Input>;
  on_conflict?: InputMaybe<User_Cat_Response_Sheet_Data_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Cat_Response_Sheet_Data_OneArgs = {
  object: User_Cat_Response_Sheet_Data_Insert_Input;
  on_conflict?: InputMaybe<User_Cat_Response_Sheet_Data_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Custom_Planned_ActivitiesArgs = {
  objects: Array<User_Custom_Planned_Activities_Insert_Input>;
  on_conflict?: InputMaybe<User_Custom_Planned_Activities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Custom_Planned_Activities_OneArgs = {
  object: User_Custom_Planned_Activities_Insert_Input;
  on_conflict?: InputMaybe<User_Custom_Planned_Activities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Leaderboard_TypesArgs = {
  objects: Array<User_Leaderboard_Types_Insert_Input>;
  on_conflict?: InputMaybe<User_Leaderboard_Types_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Leaderboard_Types_OneArgs = {
  object: User_Leaderboard_Types_Insert_Input;
  on_conflict?: InputMaybe<User_Leaderboard_Types_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_LeaderboardsArgs = {
  objects: Array<User_Leaderboards_Insert_Input>;
  on_conflict?: InputMaybe<User_Leaderboards_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Leaderboards_OneArgs = {
  object: User_Leaderboards_Insert_Input;
  on_conflict?: InputMaybe<User_Leaderboards_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_ActivitiesArgs = {
  objects: Array<User_Learn_Activities_Insert_Input>;
  on_conflict?: InputMaybe<User_Learn_Activities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Activities_OneArgs = {
  object: User_Learn_Activities_Insert_Input;
  on_conflict?: InputMaybe<User_Learn_Activities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Category_ProgressArgs = {
  objects: Array<User_Learn_Category_Progress_Insert_Input>;
  on_conflict?: InputMaybe<User_Learn_Category_Progress_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Category_Progress_OneArgs = {
  object: User_Learn_Category_Progress_Insert_Input;
  on_conflict?: InputMaybe<User_Learn_Category_Progress_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Completed_TopicsArgs = {
  objects: Array<User_Learn_Completed_Topics_Insert_Input>;
  on_conflict?: InputMaybe<User_Learn_Completed_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Completed_Topics_OneArgs = {
  object: User_Learn_Completed_Topics_Insert_Input;
  on_conflict?: InputMaybe<User_Learn_Completed_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Modules_SummaryArgs = {
  objects: Array<User_Learn_Modules_Summary_Insert_Input>;
  on_conflict?: InputMaybe<User_Learn_Modules_Summary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Modules_Summary_OneArgs = {
  object: User_Learn_Modules_Summary_Insert_Input;
  on_conflict?: InputMaybe<User_Learn_Modules_Summary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Track_RecordArgs = {
  objects: Array<User_Learn_Track_Record_Insert_Input>;
  on_conflict?: InputMaybe<User_Learn_Track_Record_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Track_Record_Bookmarked_TopicsArgs = {
  objects: Array<User_Learn_Track_Record_Bookmarked_Topics_Insert_Input>;
  on_conflict?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Track_Record_Bookmarked_Topics_OneArgs = {
  object: User_Learn_Track_Record_Bookmarked_Topics_Insert_Input;
  on_conflict?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Track_Record_OneArgs = {
  object: User_Learn_Track_Record_Insert_Input;
  on_conflict?: InputMaybe<User_Learn_Track_Record_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Track_Record_Which_TopicsArgs = {
  objects: Array<User_Learn_Track_Record_Which_Topics_Insert_Input>;
  on_conflict?: InputMaybe<User_Learn_Track_Record_Which_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Learn_Track_Record_Which_Topics_OneArgs = {
  object: User_Learn_Track_Record_Which_Topics_Insert_Input;
  on_conflict?: InputMaybe<User_Learn_Track_Record_Which_Topics_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Planned_ActivitiesArgs = {
  objects: Array<User_Planned_Activities_Insert_Input>;
  on_conflict?: InputMaybe<User_Planned_Activities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Planned_Activities_OneArgs = {
  object: User_Planned_Activities_Insert_Input;
  on_conflict?: InputMaybe<User_Planned_Activities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Pov_SummariesArgs = {
  objects: Array<User_Pov_Summaries_Insert_Input>;
  on_conflict?: InputMaybe<User_Pov_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Pov_Summaries_OneArgs = {
  object: User_Pov_Summaries_Insert_Input;
  on_conflict?: InputMaybe<User_Pov_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Question_AttemptsArgs = {
  objects: Array<User_Quiz_Question_Attempts_Insert_Input>;
  on_conflict?: InputMaybe<User_Quiz_Question_Attempts_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Question_Attempts_OneArgs = {
  object: User_Quiz_Question_Attempts_Insert_Input;
  on_conflict?: InputMaybe<User_Quiz_Question_Attempts_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Question_PositionsArgs = {
  objects: Array<User_Quiz_Question_Positions_Insert_Input>;
  on_conflict?: InputMaybe<User_Quiz_Question_Positions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Question_Positions_OneArgs = {
  object: User_Quiz_Question_Positions_Insert_Input;
  on_conflict?: InputMaybe<User_Quiz_Question_Positions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Question_SummariesArgs = {
  objects: Array<User_Quiz_Question_Summaries_Insert_Input>;
  on_conflict?: InputMaybe<User_Quiz_Question_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Question_Summaries_OldArgs = {
  objects: Array<User_Quiz_Question_Summaries_Old_Insert_Input>;
  on_conflict?: InputMaybe<User_Quiz_Question_Summaries_Old_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Question_Summaries_Old_OneArgs = {
  object: User_Quiz_Question_Summaries_Old_Insert_Input;
  on_conflict?: InputMaybe<User_Quiz_Question_Summaries_Old_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Question_Summaries_OneArgs = {
  object: User_Quiz_Question_Summaries_Insert_Input;
  on_conflict?: InputMaybe<User_Quiz_Question_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_QuestionsArgs = {
  objects: Array<User_Quiz_Questions_Insert_Input>;
  on_conflict?: InputMaybe<User_Quiz_Questions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Questions_OneArgs = {
  object: User_Quiz_Questions_Insert_Input;
  on_conflict?: InputMaybe<User_Quiz_Questions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Section_SummariesArgs = {
  objects: Array<User_Quiz_Section_Summaries_Insert_Input>;
  on_conflict?: InputMaybe<User_Quiz_Section_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Section_Summaries_OneArgs = {
  object: User_Quiz_Section_Summaries_Insert_Input;
  on_conflict?: InputMaybe<User_Quiz_Section_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_SummariesArgs = {
  objects: Array<User_Quiz_Summaries_Insert_Input>;
  on_conflict?: InputMaybe<User_Quiz_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Summaries_OldArgs = {
  objects: Array<User_Quiz_Summaries_Old_Insert_Input>;
  on_conflict?: InputMaybe<User_Quiz_Summaries_Old_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Summaries_Old_OneArgs = {
  object: User_Quiz_Summaries_Old_Insert_Input;
  on_conflict?: InputMaybe<User_Quiz_Summaries_Old_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Quiz_Summaries_OneArgs = {
  object: User_Quiz_Summaries_Insert_Input;
  on_conflict?: InputMaybe<User_Quiz_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Section_SummariesArgs = {
  objects: Array<User_Section_Summaries_Insert_Input>;
  on_conflict?: InputMaybe<User_Section_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Section_Summaries_OneArgs = {
  object: User_Section_Summaries_Insert_Input;
  on_conflict?: InputMaybe<User_Section_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Speed_Test_Questions_SummariesArgs = {
  objects: Array<User_Speed_Test_Questions_Summaries_Insert_Input>;
  on_conflict?: InputMaybe<User_Speed_Test_Questions_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Speed_Test_Questions_Summaries_OneArgs = {
  object: User_Speed_Test_Questions_Summaries_Insert_Input;
  on_conflict?: InputMaybe<User_Speed_Test_Questions_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Speed_Tests_SummariesArgs = {
  objects: Array<User_Speed_Tests_Summaries_Insert_Input>;
  on_conflict?: InputMaybe<User_Speed_Tests_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Speed_Tests_Summaries_OneArgs = {
  object: User_Speed_Tests_Summaries_Insert_Input;
  on_conflict?: InputMaybe<User_Speed_Tests_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Timed_Quiz_SummaryArgs = {
  objects: Array<User_Timed_Quiz_Summary_Insert_Input>;
  on_conflict?: InputMaybe<User_Timed_Quiz_Summary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Timed_Quiz_Summary_OneArgs = {
  object: User_Timed_Quiz_Summary_Insert_Input;
  on_conflict?: InputMaybe<User_Timed_Quiz_Summary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Total_ScoreArgs = {
  objects: Array<User_Total_Score_Insert_Input>;
  on_conflict?: InputMaybe<User_Total_Score_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Total_Score_OneArgs = {
  object: User_Total_Score_Insert_Input;
  on_conflict?: InputMaybe<User_Total_Score_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Xp_Transaction_SummariesArgs = {
  objects: Array<User_Xp_Transaction_Summaries_Insert_Input>;
  on_conflict?: InputMaybe<User_Xp_Transaction_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Xp_Transaction_Summaries_OneArgs = {
  object: User_Xp_Transaction_Summaries_Insert_Input;
  on_conflict?: InputMaybe<User_Xp_Transaction_Summaries_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Xp_TransactionsArgs = {
  objects: Array<User_Xp_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<User_Xp_Transactions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Xp_Transactions_OneArgs = {
  object: User_Xp_Transactions_Insert_Input;
  on_conflict?: InputMaybe<User_Xp_Transactions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_UserArgs = {
  objects: Array<Users_User_Insert_Input>;
  on_conflict?: InputMaybe<Users_User_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_User_GroupsArgs = {
  objects: Array<Users_User_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Users_User_Groups_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_User_Groups_OneArgs = {
  object: Users_User_Groups_Insert_Input;
  on_conflict?: InputMaybe<Users_User_Groups_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_User_OneArgs = {
  object: Users_User_Insert_Input;
  on_conflict?: InputMaybe<Users_User_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_User_User_PermissionsArgs = {
  objects: Array<Users_User_User_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Users_User_User_Permissions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_User_User_Permissions_OneArgs = {
  object: Users_User_User_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Users_User_User_Permissions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_UserquestionsummaryArgs = {
  objects: Array<Users_Userquestionsummary_Insert_Input>;
  on_conflict?: InputMaybe<Users_Userquestionsummary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_Userquestionsummary_OneArgs = {
  object: Users_Userquestionsummary_Insert_Input;
  on_conflict?: InputMaybe<Users_Userquestionsummary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_UserquizsummaryArgs = {
  objects: Array<Users_Userquizsummary_Insert_Input>;
  on_conflict?: InputMaybe<Users_Userquizsummary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_Userquizsummary_OneArgs = {
  object: Users_Userquizsummary_Insert_Input;
  on_conflict?: InputMaybe<Users_Userquizsummary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_UserquiztimesummaryArgs = {
  objects: Array<Users_Userquiztimesummary_Insert_Input>;
  on_conflict?: InputMaybe<Users_Userquiztimesummary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_Userquiztimesummary_OneArgs = {
  object: Users_Userquiztimesummary_Insert_Input;
  on_conflict?: InputMaybe<Users_Userquiztimesummary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_UsersectionsummaryArgs = {
  objects: Array<Users_Usersectionsummary_Insert_Input>;
  on_conflict?: InputMaybe<Users_Usersectionsummary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_Usersectionsummary_OneArgs = {
  object: Users_Usersectionsummary_Insert_Input;
  on_conflict?: InputMaybe<Users_Usersectionsummary_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Utils_ConfigurationArgs = {
  objects: Array<Utils_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<Utils_Configuration_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Utils_Configuration_OneArgs = {
  object: Utils_Configuration_Insert_Input;
  on_conflict?: InputMaybe<Utils_Configuration_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Xp_Transaction_TypesArgs = {
  objects: Array<Xp_Transaction_Types_Insert_Input>;
  on_conflict?: InputMaybe<Xp_Transaction_Types_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Xp_Transaction_Types_OneArgs = {
  object: Xp_Transaction_Types_Insert_Input;
  on_conflict?: InputMaybe<Xp_Transaction_Types_On_Conflict>;
};


/** mutation root */
export type MutationJoinMeetingArgs = {
  meetingId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** mutation root */
export type MutationKickUserArgs = {
  channelId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type MutationLeaveChannelArgs = {
  channelId: Scalars['String']['input'];
};


/** mutation root */
export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** mutation root */
export type MutationPinMessageArgs = {
  channelId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
};


/** mutation root */
export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


/** mutation root */
export type MutationResetUserPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


/** mutation root */
export type MutationSaveLiveQuizResponseArgs = {
  isAttempted: Scalars['Boolean']['input'];
  questionId: Scalars['Int']['input'];
  questionPosition: Scalars['Int']['input'];
  quizSummaryId: Scalars['String']['input'];
  response: Scalars['String']['input'];
  timeTaken: Scalars['String']['input'];
};


/** mutation root */
export type MutationSaveTimedTestResponseArgs = {
  data: Scalars['String']['input'];
};


/** mutation root */
export type MutationSchedulePlannerArgs = {
  days: Scalars['Int']['input'];
  domains: Array<Scalars['Int']['input']>;
  include: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type MutationSendOfflineLeadOtpArgs = {
  number: Scalars['String']['input'];
};


/** mutation root */
export type MutationSendVerificationEmailArgs = {
  email: Scalars['String']['input'];
};


/** mutation root */
export type MutationSendVerificationOtpArgs = {
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
};


/** mutation root */
export type MutationSignUpArgs = {
  city: Scalars['String']['input'];
  deviceType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  password: Scalars['String']['input'];
  state: Scalars['String']['input'];
  username: Scalars['String']['input'];
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type MutationUpdateChannelStatusArgs = {
  channelId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
};


/** mutation root */
export type MutationUpdateGroupProfileArgs = {
  avatar: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
};


/** mutation root */
export type MutationUpdateProfileDataArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type MutationUpdate_Account_EmailaddressArgs = {
  _inc?: InputMaybe<Account_Emailaddress_Inc_Input>;
  _set?: InputMaybe<Account_Emailaddress_Set_Input>;
  where: Account_Emailaddress_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Account_Emailaddress_By_PkArgs = {
  _inc?: InputMaybe<Account_Emailaddress_Inc_Input>;
  _set?: InputMaybe<Account_Emailaddress_Set_Input>;
  pk_columns: Account_Emailaddress_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Account_Emailaddress_ManyArgs = {
  updates: Array<Account_Emailaddress_Updates>;
};


/** mutation root */
export type MutationUpdate_Account_EmailconfirmationArgs = {
  _inc?: InputMaybe<Account_Emailconfirmation_Inc_Input>;
  _set?: InputMaybe<Account_Emailconfirmation_Set_Input>;
  where: Account_Emailconfirmation_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Account_Emailconfirmation_By_PkArgs = {
  _inc?: InputMaybe<Account_Emailconfirmation_Inc_Input>;
  _set?: InputMaybe<Account_Emailconfirmation_Set_Input>;
  pk_columns: Account_Emailconfirmation_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Account_Emailconfirmation_ManyArgs = {
  updates: Array<Account_Emailconfirmation_Updates>;
};


/** mutation root */
export type MutationUpdate_Accounts_CatscoresArgs = {
  _inc?: InputMaybe<Accounts_Catscores_Inc_Input>;
  _set?: InputMaybe<Accounts_Catscores_Set_Input>;
  where: Accounts_Catscores_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Accounts_Catscores_By_PkArgs = {
  _inc?: InputMaybe<Accounts_Catscores_Inc_Input>;
  _set?: InputMaybe<Accounts_Catscores_Set_Input>;
  pk_columns: Accounts_Catscores_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Accounts_Catscores_ManyArgs = {
  updates: Array<Accounts_Catscores_Updates>;
};


/** mutation root */
export type MutationUpdate_Accounts_LoggedinuserArgs = {
  _inc?: InputMaybe<Accounts_Loggedinuser_Inc_Input>;
  _set?: InputMaybe<Accounts_Loggedinuser_Set_Input>;
  where: Accounts_Loggedinuser_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Accounts_Loggedinuser_By_PkArgs = {
  _inc?: InputMaybe<Accounts_Loggedinuser_Inc_Input>;
  _set?: InputMaybe<Accounts_Loggedinuser_Set_Input>;
  pk_columns: Accounts_Loggedinuser_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Accounts_Loggedinuser_ManyArgs = {
  updates: Array<Accounts_Loggedinuser_Updates>;
};


/** mutation root */
export type MutationUpdate_Activity_TypesArgs = {
  _set?: InputMaybe<Activity_Types_Set_Input>;
  where: Activity_Types_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Activity_Types_By_PkArgs = {
  _set?: InputMaybe<Activity_Types_Set_Input>;
  pk_columns: Activity_Types_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Activity_Types_ManyArgs = {
  updates: Array<Activity_Types_Updates>;
};


/** mutation root */
export type MutationUpdate_Admin_ConstantsArgs = {
  _set?: InputMaybe<Admin_Constants_Set_Input>;
  where: Admin_Constants_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Admin_Constants_By_PkArgs = {
  _set?: InputMaybe<Admin_Constants_Set_Input>;
  pk_columns: Admin_Constants_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Admin_Constants_ManyArgs = {
  updates: Array<Admin_Constants_Updates>;
};


/** mutation root */
export type MutationUpdate_Admin_UsersArgs = {
  _set?: InputMaybe<Admin_Users_Set_Input>;
  where: Admin_Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Admin_Users_By_PkArgs = {
  _set?: InputMaybe<Admin_Users_Set_Input>;
  pk_columns: Admin_Users_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Admin_Users_ManyArgs = {
  updates: Array<Admin_Users_Updates>;
};


/** mutation root */
export type MutationUpdate_AdvertisementsArgs = {
  _set?: InputMaybe<Advertisements_Set_Input>;
  where: Advertisements_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Advertisements_By_PkArgs = {
  _set?: InputMaybe<Advertisements_Set_Input>;
  pk_columns: Advertisements_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Advertisements_ManyArgs = {
  updates: Array<Advertisements_Updates>;
};


/** mutation root */
export type MutationUpdate_Andablog_EntryArgs = {
  _inc?: InputMaybe<Andablog_Entry_Inc_Input>;
  _set?: InputMaybe<Andablog_Entry_Set_Input>;
  where: Andablog_Entry_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Andablog_Entry_By_PkArgs = {
  _inc?: InputMaybe<Andablog_Entry_Inc_Input>;
  _set?: InputMaybe<Andablog_Entry_Set_Input>;
  pk_columns: Andablog_Entry_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Andablog_Entry_ManyArgs = {
  updates: Array<Andablog_Entry_Updates>;
};


/** mutation root */
export type MutationUpdate_Andablog_EntryimageArgs = {
  _inc?: InputMaybe<Andablog_Entryimage_Inc_Input>;
  _set?: InputMaybe<Andablog_Entryimage_Set_Input>;
  where: Andablog_Entryimage_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Andablog_Entryimage_By_PkArgs = {
  _inc?: InputMaybe<Andablog_Entryimage_Inc_Input>;
  _set?: InputMaybe<Andablog_Entryimage_Set_Input>;
  pk_columns: Andablog_Entryimage_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Andablog_Entryimage_ManyArgs = {
  updates: Array<Andablog_Entryimage_Updates>;
};


/** mutation root */
export type MutationUpdate_Andablog_NewsArgs = {
  _inc?: InputMaybe<Andablog_News_Inc_Input>;
  _set?: InputMaybe<Andablog_News_Set_Input>;
  where: Andablog_News_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Andablog_News_By_PkArgs = {
  _inc?: InputMaybe<Andablog_News_Inc_Input>;
  _set?: InputMaybe<Andablog_News_Set_Input>;
  pk_columns: Andablog_News_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Andablog_News_ManyArgs = {
  updates: Array<Andablog_News_Updates>;
};


/** mutation root */
export type MutationUpdate_Andablog_PovArgs = {
  _inc?: InputMaybe<Andablog_Pov_Inc_Input>;
  _set?: InputMaybe<Andablog_Pov_Set_Input>;
  where: Andablog_Pov_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Andablog_Pov_By_PkArgs = {
  _inc?: InputMaybe<Andablog_Pov_Inc_Input>;
  _set?: InputMaybe<Andablog_Pov_Set_Input>;
  pk_columns: Andablog_Pov_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Andablog_Pov_ManyArgs = {
  updates: Array<Andablog_Pov_Updates>;
};


/** mutation root */
export type MutationUpdate_Andablog_UserlessontrackrecordArgs = {
  _inc?: InputMaybe<Andablog_Userlessontrackrecord_Inc_Input>;
  _set?: InputMaybe<Andablog_Userlessontrackrecord_Set_Input>;
  where: Andablog_Userlessontrackrecord_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Andablog_Userlessontrackrecord_Bookmarked_TopicsArgs = {
  _inc?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Inc_Input>;
  _set?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Set_Input>;
  where: Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Andablog_Userlessontrackrecord_Bookmarked_Topics_By_PkArgs = {
  _inc?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Inc_Input>;
  _set?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Set_Input>;
  pk_columns: Andablog_Userlessontrackrecord_Bookmarked_Topics_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Andablog_Userlessontrackrecord_Bookmarked_Topics_ManyArgs = {
  updates: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Updates>;
};


/** mutation root */
export type MutationUpdate_Andablog_Userlessontrackrecord_By_PkArgs = {
  _inc?: InputMaybe<Andablog_Userlessontrackrecord_Inc_Input>;
  _set?: InputMaybe<Andablog_Userlessontrackrecord_Set_Input>;
  pk_columns: Andablog_Userlessontrackrecord_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Andablog_Userlessontrackrecord_ManyArgs = {
  updates: Array<Andablog_Userlessontrackrecord_Updates>;
};


/** mutation root */
export type MutationUpdate_Andablog_Userlessontrackrecord_Which_TopicsArgs = {
  _inc?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Inc_Input>;
  _set?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Set_Input>;
  where: Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Andablog_Userlessontrackrecord_Which_Topics_By_PkArgs = {
  _inc?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Inc_Input>;
  _set?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Set_Input>;
  pk_columns: Andablog_Userlessontrackrecord_Which_Topics_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Andablog_Userlessontrackrecord_Which_Topics_ManyArgs = {
  updates: Array<Andablog_Userlessontrackrecord_Which_Topics_Updates>;
};


/** mutation root */
export type MutationUpdate_Andablog_VideoArgs = {
  _inc?: InputMaybe<Andablog_Video_Inc_Input>;
  _set?: InputMaybe<Andablog_Video_Set_Input>;
  where: Andablog_Video_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Andablog_Video_By_PkArgs = {
  _inc?: InputMaybe<Andablog_Video_Inc_Input>;
  _set?: InputMaybe<Andablog_Video_Set_Input>;
  pk_columns: Andablog_Video_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Andablog_Video_ManyArgs = {
  updates: Array<Andablog_Video_Updates>;
};


/** mutation root */
export type MutationUpdate_Auth_Email_VerificationsArgs = {
  _set?: InputMaybe<Auth_Email_Verifications_Set_Input>;
  where: Auth_Email_Verifications_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Auth_Email_Verifications_By_PkArgs = {
  _set?: InputMaybe<Auth_Email_Verifications_Set_Input>;
  pk_columns: Auth_Email_Verifications_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Auth_Email_Verifications_ManyArgs = {
  updates: Array<Auth_Email_Verifications_Updates>;
};


/** mutation root */
export type MutationUpdate_Auth_GroupArgs = {
  _inc?: InputMaybe<Auth_Group_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Set_Input>;
  where: Auth_Group_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Auth_Group_By_PkArgs = {
  _inc?: InputMaybe<Auth_Group_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Set_Input>;
  pk_columns: Auth_Group_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Auth_Group_ManyArgs = {
  updates: Array<Auth_Group_Updates>;
};


/** mutation root */
export type MutationUpdate_Auth_Group_PermissionsArgs = {
  _inc?: InputMaybe<Auth_Group_Permissions_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Permissions_Set_Input>;
  where: Auth_Group_Permissions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Auth_Group_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Auth_Group_Permissions_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Permissions_Set_Input>;
  pk_columns: Auth_Group_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Auth_Group_Permissions_ManyArgs = {
  updates: Array<Auth_Group_Permissions_Updates>;
};


/** mutation root */
export type MutationUpdate_Auth_Password_Reset_TokensArgs = {
  _set?: InputMaybe<Auth_Password_Reset_Tokens_Set_Input>;
  where: Auth_Password_Reset_Tokens_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Auth_Password_Reset_Tokens_By_PkArgs = {
  _set?: InputMaybe<Auth_Password_Reset_Tokens_Set_Input>;
  pk_columns: Auth_Password_Reset_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Auth_Password_Reset_Tokens_ManyArgs = {
  updates: Array<Auth_Password_Reset_Tokens_Updates>;
};


/** mutation root */
export type MutationUpdate_Auth_PermissionArgs = {
  _inc?: InputMaybe<Auth_Permission_Inc_Input>;
  _set?: InputMaybe<Auth_Permission_Set_Input>;
  where: Auth_Permission_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Auth_Permission_By_PkArgs = {
  _inc?: InputMaybe<Auth_Permission_Inc_Input>;
  _set?: InputMaybe<Auth_Permission_Set_Input>;
  pk_columns: Auth_Permission_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Auth_Permission_ManyArgs = {
  updates: Array<Auth_Permission_Updates>;
};


/** mutation root */
export type MutationUpdate_Auth_SessionArgs = {
  _set?: InputMaybe<Auth_Session_Set_Input>;
  where: Auth_Session_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Auth_Session_By_PkArgs = {
  _set?: InputMaybe<Auth_Session_Set_Input>;
  pk_columns: Auth_Session_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Auth_Session_ManyArgs = {
  updates: Array<Auth_Session_Updates>;
};


/** mutation root */
export type MutationUpdate_Bookmarked_Learn_TopicsArgs = {
  _inc?: InputMaybe<Bookmarked_Learn_Topics_Inc_Input>;
  _set?: InputMaybe<Bookmarked_Learn_Topics_Set_Input>;
  where: Bookmarked_Learn_Topics_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Bookmarked_Learn_Topics_By_PkArgs = {
  _inc?: InputMaybe<Bookmarked_Learn_Topics_Inc_Input>;
  _set?: InputMaybe<Bookmarked_Learn_Topics_Set_Input>;
  pk_columns: Bookmarked_Learn_Topics_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Bookmarked_Learn_Topics_ManyArgs = {
  updates: Array<Bookmarked_Learn_Topics_Updates>;
};


/** mutation root */
export type MutationUpdate_Cat_Percentile_ConstantArgs = {
  _set?: InputMaybe<Cat_Percentile_Constant_Set_Input>;
  where: Cat_Percentile_Constant_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Cat_Percentile_Constant_By_PkArgs = {
  _set?: InputMaybe<Cat_Percentile_Constant_Set_Input>;
  pk_columns: Cat_Percentile_Constant_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Cat_Percentile_Constant_ManyArgs = {
  updates: Array<Cat_Percentile_Constant_Updates>;
};


/** mutation root */
export type MutationUpdate_Cat_ScoresArgs = {
  _inc?: InputMaybe<Cat_Scores_Inc_Input>;
  _set?: InputMaybe<Cat_Scores_Set_Input>;
  where: Cat_Scores_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Cat_Scores_By_PkArgs = {
  _inc?: InputMaybe<Cat_Scores_Inc_Input>;
  _set?: InputMaybe<Cat_Scores_Set_Input>;
  pk_columns: Cat_Scores_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Cat_Scores_ManyArgs = {
  updates: Array<Cat_Scores_Updates>;
};


/** mutation root */
export type MutationUpdate_Channel_MembersArgs = {
  _set?: InputMaybe<Channel_Members_Set_Input>;
  where: Channel_Members_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Channel_Members_By_PkArgs = {
  _set?: InputMaybe<Channel_Members_Set_Input>;
  pk_columns: Channel_Members_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Channel_Members_ManyArgs = {
  updates: Array<Channel_Members_Updates>;
};


/** mutation root */
export type MutationUpdate_ChannelsArgs = {
  _set?: InputMaybe<Channels_Set_Input>;
  where: Channels_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Channels_By_PkArgs = {
  _set?: InputMaybe<Channels_Set_Input>;
  pk_columns: Channels_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Channels_ManyArgs = {
  updates: Array<Channels_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_Allowed_Users_Rule_UsersArgs = {
  _inc?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Inc_Input>;
  _set?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Set_Input>;
  where: Coupons_Allowed_Users_Rule_Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Allowed_Users_Rule_Users_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Inc_Input>;
  _set?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Set_Input>;
  pk_columns: Coupons_Allowed_Users_Rule_Users_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Allowed_Users_Rule_Users_ManyArgs = {
  updates: Array<Coupons_Allowed_Users_Rule_Users_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_AllowedusersruleArgs = {
  _inc?: InputMaybe<Coupons_Allowedusersrule_Inc_Input>;
  _set?: InputMaybe<Coupons_Allowedusersrule_Set_Input>;
  where: Coupons_Allowedusersrule_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Allowedusersrule_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Allowedusersrule_Inc_Input>;
  _set?: InputMaybe<Coupons_Allowedusersrule_Set_Input>;
  pk_columns: Coupons_Allowedusersrule_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Allowedusersrule_ManyArgs = {
  updates: Array<Coupons_Allowedusersrule_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_Allowedusersrule_UsersArgs = {
  _inc?: InputMaybe<Coupons_Allowedusersrule_Users_Inc_Input>;
  _set?: InputMaybe<Coupons_Allowedusersrule_Users_Set_Input>;
  where: Coupons_Allowedusersrule_Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Allowedusersrule_Users_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Allowedusersrule_Users_Inc_Input>;
  _set?: InputMaybe<Coupons_Allowedusersrule_Users_Set_Input>;
  pk_columns: Coupons_Allowedusersrule_Users_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Allowedusersrule_Users_ManyArgs = {
  updates: Array<Coupons_Allowedusersrule_Users_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_CouponArgs = {
  _inc?: InputMaybe<Coupons_Coupon_Inc_Input>;
  _set?: InputMaybe<Coupons_Coupon_Set_Input>;
  where: Coupons_Coupon_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Coupon_Applicable_PackagesArgs = {
  _inc?: InputMaybe<Coupons_Coupon_Applicable_Packages_Inc_Input>;
  _set?: InputMaybe<Coupons_Coupon_Applicable_Packages_Set_Input>;
  where: Coupons_Coupon_Applicable_Packages_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Coupon_Applicable_Packages_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Coupon_Applicable_Packages_Inc_Input>;
  _set?: InputMaybe<Coupons_Coupon_Applicable_Packages_Set_Input>;
  pk_columns: Coupons_Coupon_Applicable_Packages_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Coupon_Applicable_Packages_ManyArgs = {
  updates: Array<Coupons_Coupon_Applicable_Packages_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_Coupon_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Coupon_Inc_Input>;
  _set?: InputMaybe<Coupons_Coupon_Set_Input>;
  pk_columns: Coupons_Coupon_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Coupon_ManyArgs = {
  updates: Array<Coupons_Coupon_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_CouponuserArgs = {
  _inc?: InputMaybe<Coupons_Couponuser_Inc_Input>;
  _set?: InputMaybe<Coupons_Couponuser_Set_Input>;
  where: Coupons_Couponuser_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Couponuser_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Couponuser_Inc_Input>;
  _set?: InputMaybe<Coupons_Couponuser_Set_Input>;
  pk_columns: Coupons_Couponuser_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Couponuser_ManyArgs = {
  updates: Array<Coupons_Couponuser_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_DiscountArgs = {
  _inc?: InputMaybe<Coupons_Discount_Inc_Input>;
  _set?: InputMaybe<Coupons_Discount_Set_Input>;
  where: Coupons_Discount_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Discount_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Discount_Inc_Input>;
  _set?: InputMaybe<Coupons_Discount_Set_Input>;
  pk_columns: Coupons_Discount_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Discount_ManyArgs = {
  updates: Array<Coupons_Discount_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_MaxusesruleArgs = {
  _inc?: InputMaybe<Coupons_Maxusesrule_Inc_Input>;
  _set?: InputMaybe<Coupons_Maxusesrule_Set_Input>;
  where: Coupons_Maxusesrule_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Maxusesrule_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Maxusesrule_Inc_Input>;
  _set?: InputMaybe<Coupons_Maxusesrule_Set_Input>;
  pk_columns: Coupons_Maxusesrule_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Maxusesrule_ManyArgs = {
  updates: Array<Coupons_Maxusesrule_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_RulesetArgs = {
  _inc?: InputMaybe<Coupons_Ruleset_Inc_Input>;
  _set?: InputMaybe<Coupons_Ruleset_Set_Input>;
  where: Coupons_Ruleset_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Ruleset_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Ruleset_Inc_Input>;
  _set?: InputMaybe<Coupons_Ruleset_Set_Input>;
  pk_columns: Coupons_Ruleset_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Ruleset_ManyArgs = {
  updates: Array<Coupons_Ruleset_Updates>;
};


/** mutation root */
export type MutationUpdate_Coupons_ValidityruleArgs = {
  _inc?: InputMaybe<Coupons_Validityrule_Inc_Input>;
  _set?: InputMaybe<Coupons_Validityrule_Set_Input>;
  where: Coupons_Validityrule_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Coupons_Validityrule_By_PkArgs = {
  _inc?: InputMaybe<Coupons_Validityrule_Inc_Input>;
  _set?: InputMaybe<Coupons_Validityrule_Set_Input>;
  pk_columns: Coupons_Validityrule_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Coupons_Validityrule_ManyArgs = {
  updates: Array<Coupons_Validityrule_Updates>;
};


/** mutation root */
export type MutationUpdate_Django_Admin_LogArgs = {
  _inc?: InputMaybe<Django_Admin_Log_Inc_Input>;
  _set?: InputMaybe<Django_Admin_Log_Set_Input>;
  where: Django_Admin_Log_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Django_Admin_Log_By_PkArgs = {
  _inc?: InputMaybe<Django_Admin_Log_Inc_Input>;
  _set?: InputMaybe<Django_Admin_Log_Set_Input>;
  pk_columns: Django_Admin_Log_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Django_Admin_Log_ManyArgs = {
  updates: Array<Django_Admin_Log_Updates>;
};


/** mutation root */
export type MutationUpdate_Django_Content_TypeArgs = {
  _inc?: InputMaybe<Django_Content_Type_Inc_Input>;
  _set?: InputMaybe<Django_Content_Type_Set_Input>;
  where: Django_Content_Type_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Django_Content_Type_By_PkArgs = {
  _inc?: InputMaybe<Django_Content_Type_Inc_Input>;
  _set?: InputMaybe<Django_Content_Type_Set_Input>;
  pk_columns: Django_Content_Type_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Django_Content_Type_ManyArgs = {
  updates: Array<Django_Content_Type_Updates>;
};


/** mutation root */
export type MutationUpdate_Django_MigrationsArgs = {
  _inc?: InputMaybe<Django_Migrations_Inc_Input>;
  _set?: InputMaybe<Django_Migrations_Set_Input>;
  where: Django_Migrations_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Django_Migrations_By_PkArgs = {
  _inc?: InputMaybe<Django_Migrations_Inc_Input>;
  _set?: InputMaybe<Django_Migrations_Set_Input>;
  pk_columns: Django_Migrations_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Django_Migrations_ManyArgs = {
  updates: Array<Django_Migrations_Updates>;
};


/** mutation root */
export type MutationUpdate_Django_SessionArgs = {
  _set?: InputMaybe<Django_Session_Set_Input>;
  where: Django_Session_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Django_Session_By_PkArgs = {
  _set?: InputMaybe<Django_Session_Set_Input>;
  pk_columns: Django_Session_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Django_Session_ManyArgs = {
  updates: Array<Django_Session_Updates>;
};


/** mutation root */
export type MutationUpdate_Django_SiteArgs = {
  _inc?: InputMaybe<Django_Site_Inc_Input>;
  _set?: InputMaybe<Django_Site_Set_Input>;
  where: Django_Site_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Django_Site_By_PkArgs = {
  _inc?: InputMaybe<Django_Site_Inc_Input>;
  _set?: InputMaybe<Django_Site_Set_Input>;
  pk_columns: Django_Site_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Django_Site_ManyArgs = {
  updates: Array<Django_Site_Updates>;
};


/** mutation root */
export type MutationUpdate_Djconfig_ConfigArgs = {
  _inc?: InputMaybe<Djconfig_Config_Inc_Input>;
  _set?: InputMaybe<Djconfig_Config_Set_Input>;
  where: Djconfig_Config_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Djconfig_Config_By_PkArgs = {
  _inc?: InputMaybe<Djconfig_Config_Inc_Input>;
  _set?: InputMaybe<Djconfig_Config_Set_Input>;
  pk_columns: Djconfig_Config_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Djconfig_Config_ManyArgs = {
  updates: Array<Djconfig_Config_Updates>;
};


/** mutation root */
export type MutationUpdate_Group_CategoryArgs = {
  _set?: InputMaybe<Group_Category_Set_Input>;
  where: Group_Category_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Group_Category_By_PkArgs = {
  _set?: InputMaybe<Group_Category_Set_Input>;
  pk_columns: Group_Category_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Group_Category_ManyArgs = {
  updates: Array<Group_Category_Updates>;
};


/** mutation root */
export type MutationUpdate_Group_Discount_UsersArgs = {
  _inc?: InputMaybe<Group_Discount_Users_Inc_Input>;
  _set?: InputMaybe<Group_Discount_Users_Set_Input>;
  where: Group_Discount_Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Group_Discount_Users_ManyArgs = {
  updates: Array<Group_Discount_Users_Updates>;
};


/** mutation root */
export type MutationUpdate_Has_AccessArgs = {
  _set?: InputMaybe<Has_Access_Set_Input>;
  where: Has_Access_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Has_Access_ManyArgs = {
  updates: Array<Has_Access_Updates>;
};


/** mutation root */
export type MutationUpdate_Infozone_CategoryArgs = {
  _inc?: InputMaybe<Infozone_Category_Inc_Input>;
  _set?: InputMaybe<Infozone_Category_Set_Input>;
  where: Infozone_Category_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Infozone_Category_By_PkArgs = {
  _inc?: InputMaybe<Infozone_Category_Inc_Input>;
  _set?: InputMaybe<Infozone_Category_Set_Input>;
  pk_columns: Infozone_Category_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Infozone_Category_ManyArgs = {
  updates: Array<Infozone_Category_Updates>;
};


/** mutation root */
export type MutationUpdate_Infozone_InfozoneArgs = {
  _inc?: InputMaybe<Infozone_Infozone_Inc_Input>;
  _set?: InputMaybe<Infozone_Infozone_Set_Input>;
  where: Infozone_Infozone_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Infozone_Infozone_By_PkArgs = {
  _inc?: InputMaybe<Infozone_Infozone_Inc_Input>;
  _set?: InputMaybe<Infozone_Infozone_Set_Input>;
  pk_columns: Infozone_Infozone_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Infozone_Infozone_ManyArgs = {
  updates: Array<Infozone_Infozone_Updates>;
};


/** mutation root */
export type MutationUpdate_Infozone_StaticpagesArgs = {
  _inc?: InputMaybe<Infozone_Staticpages_Inc_Input>;
  _set?: InputMaybe<Infozone_Staticpages_Set_Input>;
  where: Infozone_Staticpages_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Infozone_Staticpages_By_PkArgs = {
  _inc?: InputMaybe<Infozone_Staticpages_Inc_Input>;
  _set?: InputMaybe<Infozone_Staticpages_Set_Input>;
  pk_columns: Infozone_Staticpages_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Infozone_Staticpages_ManyArgs = {
  updates: Array<Infozone_Staticpages_Updates>;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_LeaderboardArgs = {
  _inc?: InputMaybe<Live_Quiz_Leaderboard_Inc_Input>;
  _set?: InputMaybe<Live_Quiz_Leaderboard_Set_Input>;
  where: Live_Quiz_Leaderboard_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Leaderboard_By_PkArgs = {
  _inc?: InputMaybe<Live_Quiz_Leaderboard_Inc_Input>;
  _set?: InputMaybe<Live_Quiz_Leaderboard_Set_Input>;
  pk_columns: Live_Quiz_Leaderboard_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Leaderboard_ManyArgs = {
  updates: Array<Live_Quiz_Leaderboard_Updates>;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Question_PositionsArgs = {
  _inc?: InputMaybe<Live_Quiz_Question_Positions_Inc_Input>;
  _set?: InputMaybe<Live_Quiz_Question_Positions_Set_Input>;
  where: Live_Quiz_Question_Positions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Question_Positions_By_PkArgs = {
  _inc?: InputMaybe<Live_Quiz_Question_Positions_Inc_Input>;
  _set?: InputMaybe<Live_Quiz_Question_Positions_Set_Input>;
  pk_columns: Live_Quiz_Question_Positions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Question_Positions_ManyArgs = {
  updates: Array<Live_Quiz_Question_Positions_Updates>;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Question_SummaryArgs = {
  _inc?: InputMaybe<Live_Quiz_Question_Summary_Inc_Input>;
  _set?: InputMaybe<Live_Quiz_Question_Summary_Set_Input>;
  where: Live_Quiz_Question_Summary_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Question_Summary_By_PkArgs = {
  _inc?: InputMaybe<Live_Quiz_Question_Summary_Inc_Input>;
  _set?: InputMaybe<Live_Quiz_Question_Summary_Set_Input>;
  pk_columns: Live_Quiz_Question_Summary_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Question_Summary_ManyArgs = {
  updates: Array<Live_Quiz_Question_Summary_Updates>;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_SummaryArgs = {
  _inc?: InputMaybe<Live_Quiz_Summary_Inc_Input>;
  _set?: InputMaybe<Live_Quiz_Summary_Set_Input>;
  where: Live_Quiz_Summary_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Summary_By_PkArgs = {
  _inc?: InputMaybe<Live_Quiz_Summary_Inc_Input>;
  _set?: InputMaybe<Live_Quiz_Summary_Set_Input>;
  pk_columns: Live_Quiz_Summary_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Live_Quiz_Summary_ManyArgs = {
  updates: Array<Live_Quiz_Summary_Updates>;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_DilrArgs = {
  _inc?: InputMaybe<Marks_Vs_Percentile_Dilr_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Percentile_Dilr_Set_Input>;
  where: Marks_Vs_Percentile_Dilr_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_Dilr_By_PkArgs = {
  _inc?: InputMaybe<Marks_Vs_Percentile_Dilr_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Percentile_Dilr_Set_Input>;
  pk_columns: Marks_Vs_Percentile_Dilr_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_Dilr_ManyArgs = {
  updates: Array<Marks_Vs_Percentile_Dilr_Updates>;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_QuantArgs = {
  _inc?: InputMaybe<Marks_Vs_Percentile_Quant_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Percentile_Quant_Set_Input>;
  where: Marks_Vs_Percentile_Quant_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_Quant_By_PkArgs = {
  _inc?: InputMaybe<Marks_Vs_Percentile_Quant_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Percentile_Quant_Set_Input>;
  pk_columns: Marks_Vs_Percentile_Quant_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_Quant_ManyArgs = {
  updates: Array<Marks_Vs_Percentile_Quant_Updates>;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_Total_RawArgs = {
  _inc?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Set_Input>;
  where: Marks_Vs_Percentile_Total_Raw_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_Total_Raw_By_PkArgs = {
  _inc?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Set_Input>;
  pk_columns: Marks_Vs_Percentile_Total_Raw_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_Total_Raw_ManyArgs = {
  updates: Array<Marks_Vs_Percentile_Total_Raw_Updates>;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_VarcArgs = {
  _inc?: InputMaybe<Marks_Vs_Percentile_Varc_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Percentile_Varc_Set_Input>;
  where: Marks_Vs_Percentile_Varc_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_Varc_By_PkArgs = {
  _inc?: InputMaybe<Marks_Vs_Percentile_Varc_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Percentile_Varc_Set_Input>;
  pk_columns: Marks_Vs_Percentile_Varc_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Percentile_Varc_ManyArgs = {
  updates: Array<Marks_Vs_Percentile_Varc_Updates>;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Scaled_PercentileArgs = {
  _inc?: InputMaybe<Marks_Vs_Scaled_Percentile_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Scaled_Percentile_Set_Input>;
  where: Marks_Vs_Scaled_Percentile_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Scaled_Percentile_By_PkArgs = {
  _inc?: InputMaybe<Marks_Vs_Scaled_Percentile_Inc_Input>;
  _set?: InputMaybe<Marks_Vs_Scaled_Percentile_Set_Input>;
  pk_columns: Marks_Vs_Scaled_Percentile_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Marks_Vs_Scaled_Percentile_ManyArgs = {
  updates: Array<Marks_Vs_Scaled_Percentile_Updates>;
};


/** mutation root */
export type MutationUpdate_Meeting_MembersArgs = {
  _set?: InputMaybe<Meeting_Members_Set_Input>;
  where: Meeting_Members_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Meeting_Members_By_PkArgs = {
  _set?: InputMaybe<Meeting_Members_Set_Input>;
  pk_columns: Meeting_Members_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Meeting_Members_ManyArgs = {
  updates: Array<Meeting_Members_Updates>;
};


/** mutation root */
export type MutationUpdate_MeetingsArgs = {
  _set?: InputMaybe<Meetings_Set_Input>;
  where: Meetings_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Meetings_By_PkArgs = {
  _set?: InputMaybe<Meetings_Set_Input>;
  pk_columns: Meetings_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Meetings_ManyArgs = {
  updates: Array<Meetings_Updates>;
};


/** mutation root */
export type MutationUpdate_Message_ReactionsArgs = {
  _set?: InputMaybe<Message_Reactions_Set_Input>;
  where: Message_Reactions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Message_Reactions_By_PkArgs = {
  _set?: InputMaybe<Message_Reactions_Set_Input>;
  pk_columns: Message_Reactions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Message_Reactions_ManyArgs = {
  updates: Array<Message_Reactions_Updates>;
};


/** mutation root */
export type MutationUpdate_MessagesArgs = {
  _set?: InputMaybe<Messages_Set_Input>;
  where: Messages_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Messages_By_PkArgs = {
  _set?: InputMaybe<Messages_Set_Input>;
  pk_columns: Messages_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Messages_ManyArgs = {
  updates: Array<Messages_Updates>;
};


/** mutation root */
export type MutationUpdate_Messages_ReadArgs = {
  _set?: InputMaybe<Messages_Read_Set_Input>;
  where: Messages_Read_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Messages_Read_By_PkArgs = {
  _set?: InputMaybe<Messages_Read_Set_Input>;
  pk_columns: Messages_Read_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Messages_Read_ManyArgs = {
  updates: Array<Messages_Read_Updates>;
};


/** mutation root */
export type MutationUpdate_Offline_LeadsArgs = {
  _inc?: InputMaybe<Offline_Leads_Inc_Input>;
  _set?: InputMaybe<Offline_Leads_Set_Input>;
  where: Offline_Leads_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Offline_Leads_By_PkArgs = {
  _inc?: InputMaybe<Offline_Leads_Inc_Input>;
  _set?: InputMaybe<Offline_Leads_Set_Input>;
  pk_columns: Offline_Leads_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Offline_Leads_ManyArgs = {
  updates: Array<Offline_Leads_Updates>;
};


/** mutation root */
export type MutationUpdate_Package_Content_Discarded_QuizzesArgs = {
  _inc?: InputMaybe<Package_Content_Discarded_Quizzes_Inc_Input>;
  _set?: InputMaybe<Package_Content_Discarded_Quizzes_Set_Input>;
  where: Package_Content_Discarded_Quizzes_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Package_Content_Discarded_Quizzes_By_PkArgs = {
  _inc?: InputMaybe<Package_Content_Discarded_Quizzes_Inc_Input>;
  _set?: InputMaybe<Package_Content_Discarded_Quizzes_Set_Input>;
  pk_columns: Package_Content_Discarded_Quizzes_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Package_Content_Discarded_Quizzes_ManyArgs = {
  updates: Array<Package_Content_Discarded_Quizzes_Updates>;
};


/** mutation root */
export type MutationUpdate_Packages_ContentArgs = {
  _inc?: InputMaybe<Packages_Content_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Set_Input>;
  where: Packages_Content_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Packages_Content_By_PkArgs = {
  _inc?: InputMaybe<Packages_Content_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Set_Input>;
  pk_columns: Packages_Content_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Packages_Content_DomainsArgs = {
  _inc?: InputMaybe<Packages_Content_Domains_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Domains_Set_Input>;
  where: Packages_Content_Domains_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Domains_By_PkArgs = {
  _inc?: InputMaybe<Packages_Content_Domains_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Domains_Set_Input>;
  pk_columns: Packages_Content_Domains_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Domains_ManyArgs = {
  updates: Array<Packages_Content_Domains_Updates>;
};


/** mutation root */
export type MutationUpdate_Packages_Content_ManyArgs = {
  updates: Array<Packages_Content_Updates>;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Text_LessonArgs = {
  _inc?: InputMaybe<Packages_Content_Text_Lesson_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Text_Lesson_Set_Input>;
  where: Packages_Content_Text_Lesson_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Text_Lesson_By_PkArgs = {
  _inc?: InputMaybe<Packages_Content_Text_Lesson_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Text_Lesson_Set_Input>;
  pk_columns: Packages_Content_Text_Lesson_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Text_Lesson_ManyArgs = {
  updates: Array<Packages_Content_Text_Lesson_Updates>;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Timed_TestArgs = {
  _inc?: InputMaybe<Packages_Content_Timed_Test_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Timed_Test_Set_Input>;
  where: Packages_Content_Timed_Test_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Timed_Test_By_PkArgs = {
  _inc?: InputMaybe<Packages_Content_Timed_Test_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Timed_Test_Set_Input>;
  pk_columns: Packages_Content_Timed_Test_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Timed_Test_ManyArgs = {
  updates: Array<Packages_Content_Timed_Test_Updates>;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Untimed_TestArgs = {
  _inc?: InputMaybe<Packages_Content_Untimed_Test_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Untimed_Test_Set_Input>;
  where: Packages_Content_Untimed_Test_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Untimed_Test_By_PkArgs = {
  _inc?: InputMaybe<Packages_Content_Untimed_Test_Inc_Input>;
  _set?: InputMaybe<Packages_Content_Untimed_Test_Set_Input>;
  pk_columns: Packages_Content_Untimed_Test_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Packages_Content_Untimed_Test_ManyArgs = {
  updates: Array<Packages_Content_Untimed_Test_Updates>;
};


/** mutation root */
export type MutationUpdate_Packages_Payment_TransactionArgs = {
  _inc?: InputMaybe<Packages_Payment_Transaction_Inc_Input>;
  _set?: InputMaybe<Packages_Payment_Transaction_Set_Input>;
  where: Packages_Payment_Transaction_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Packages_Payment_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Packages_Payment_Transaction_Inc_Input>;
  _set?: InputMaybe<Packages_Payment_Transaction_Set_Input>;
  pk_columns: Packages_Payment_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Packages_Payment_Transaction_ManyArgs = {
  updates: Array<Packages_Payment_Transaction_Updates>;
};


/** mutation root */
export type MutationUpdate_Packages_PaymenttransactionArgs = {
  _inc?: InputMaybe<Packages_Paymenttransaction_Inc_Input>;
  _set?: InputMaybe<Packages_Paymenttransaction_Set_Input>;
  where: Packages_Paymenttransaction_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Packages_Paymenttransaction_By_PkArgs = {
  _inc?: InputMaybe<Packages_Paymenttransaction_Inc_Input>;
  _set?: InputMaybe<Packages_Paymenttransaction_Set_Input>;
  pk_columns: Packages_Paymenttransaction_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Packages_Paymenttransaction_ManyArgs = {
  updates: Array<Packages_Paymenttransaction_Updates>;
};


/** mutation root */
export type MutationUpdate_PollArgs = {
  _set?: InputMaybe<Poll_Set_Input>;
  where: Poll_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Poll_By_PkArgs = {
  _set?: InputMaybe<Poll_Set_Input>;
  pk_columns: Poll_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Poll_ManyArgs = {
  updates: Array<Poll_Updates>;
};


/** mutation root */
export type MutationUpdate_Poll_OptionsArgs = {
  _set?: InputMaybe<Poll_Options_Set_Input>;
  where: Poll_Options_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Poll_Options_By_PkArgs = {
  _set?: InputMaybe<Poll_Options_Set_Input>;
  pk_columns: Poll_Options_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Poll_Options_ManyArgs = {
  updates: Array<Poll_Options_Updates>;
};


/** mutation root */
export type MutationUpdate_Poll_ResponsesArgs = {
  _set?: InputMaybe<Poll_Responses_Set_Input>;
  where: Poll_Responses_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Poll_Responses_By_PkArgs = {
  _set?: InputMaybe<Poll_Responses_Set_Input>;
  pk_columns: Poll_Responses_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Poll_Responses_ManyArgs = {
  updates: Array<Poll_Responses_Updates>;
};


/** mutation root */
export type MutationUpdate_Question_ReportsArgs = {
  _inc?: InputMaybe<Question_Reports_Inc_Input>;
  _set?: InputMaybe<Question_Reports_Set_Input>;
  where: Question_Reports_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Question_Reports_By_PkArgs = {
  _inc?: InputMaybe<Question_Reports_Inc_Input>;
  _set?: InputMaybe<Question_Reports_Set_Input>;
  pk_columns: Question_Reports_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Question_Reports_ManyArgs = {
  updates: Array<Question_Reports_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_AnswerArgs = {
  _inc?: InputMaybe<Quiz_Answer_Inc_Input>;
  _set?: InputMaybe<Quiz_Answer_Set_Input>;
  where: Quiz_Answer_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Answer_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Answer_Inc_Input>;
  _set?: InputMaybe<Quiz_Answer_Set_Input>;
  pk_columns: Quiz_Answer_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Answer_ManyArgs = {
  updates: Array<Quiz_Answer_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_CategoryArgs = {
  _inc?: InputMaybe<Quiz_Category_Inc_Input>;
  _set?: InputMaybe<Quiz_Category_Set_Input>;
  where: Quiz_Category_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Category_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Category_Inc_Input>;
  _set?: InputMaybe<Quiz_Category_Set_Input>;
  pk_columns: Quiz_Category_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Category_ManyArgs = {
  updates: Array<Quiz_Category_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_DomainArgs = {
  _inc?: InputMaybe<Quiz_Domain_Inc_Input>;
  _set?: InputMaybe<Quiz_Domain_Set_Input>;
  where: Quiz_Domain_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Domain_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Domain_Inc_Input>;
  _set?: InputMaybe<Quiz_Domain_Set_Input>;
  pk_columns: Quiz_Domain_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Domain_ManyArgs = {
  updates: Array<Quiz_Domain_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_MarkingsystemArgs = {
  _inc?: InputMaybe<Quiz_Markingsystem_Inc_Input>;
  _set?: InputMaybe<Quiz_Markingsystem_Set_Input>;
  where: Quiz_Markingsystem_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Markingsystem_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Markingsystem_Inc_Input>;
  _set?: InputMaybe<Quiz_Markingsystem_Set_Input>;
  pk_columns: Quiz_Markingsystem_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Markingsystem_ManyArgs = {
  updates: Array<Quiz_Markingsystem_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_OptionArgs = {
  _inc?: InputMaybe<Quiz_Option_Inc_Input>;
  _set?: InputMaybe<Quiz_Option_Set_Input>;
  where: Quiz_Option_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Option_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Option_Inc_Input>;
  _set?: InputMaybe<Quiz_Option_Set_Input>;
  pk_columns: Quiz_Option_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Option_ManyArgs = {
  updates: Array<Quiz_Option_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_ParagraphArgs = {
  _inc?: InputMaybe<Quiz_Paragraph_Inc_Input>;
  _set?: InputMaybe<Quiz_Paragraph_Set_Input>;
  where: Quiz_Paragraph_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Paragraph_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Paragraph_Inc_Input>;
  _set?: InputMaybe<Quiz_Paragraph_Set_Input>;
  pk_columns: Quiz_Paragraph_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Paragraph_ManyArgs = {
  updates: Array<Quiz_Paragraph_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_QuestionArgs = {
  _inc?: InputMaybe<Quiz_Question_Inc_Input>;
  _set?: InputMaybe<Quiz_Question_Set_Input>;
  where: Quiz_Question_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Question_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Question_Inc_Input>;
  _set?: InputMaybe<Quiz_Question_Set_Input>;
  pk_columns: Quiz_Question_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Question_ManyArgs = {
  updates: Array<Quiz_Question_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_QuizArgs = {
  _inc?: InputMaybe<Quiz_Quiz_Inc_Input>;
  _set?: InputMaybe<Quiz_Quiz_Set_Input>;
  where: Quiz_Quiz_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Quiz_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Quiz_Inc_Input>;
  _set?: InputMaybe<Quiz_Quiz_Set_Input>;
  pk_columns: Quiz_Quiz_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Quiz_ManyArgs = {
  updates: Array<Quiz_Quiz_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_Quiz_QuestionsArgs = {
  _inc?: InputMaybe<Quiz_Quiz_Questions_Inc_Input>;
  _set?: InputMaybe<Quiz_Quiz_Questions_Set_Input>;
  where: Quiz_Quiz_Questions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Quiz_Questions_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Quiz_Questions_Inc_Input>;
  _set?: InputMaybe<Quiz_Quiz_Questions_Set_Input>;
  pk_columns: Quiz_Quiz_Questions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Quiz_Questions_ManyArgs = {
  updates: Array<Quiz_Quiz_Questions_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_Quiz_SectionsArgs = {
  _inc?: InputMaybe<Quiz_Quiz_Sections_Inc_Input>;
  _set?: InputMaybe<Quiz_Quiz_Sections_Set_Input>;
  where: Quiz_Quiz_Sections_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Quiz_Sections_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Quiz_Sections_Inc_Input>;
  _set?: InputMaybe<Quiz_Quiz_Sections_Set_Input>;
  pk_columns: Quiz_Quiz_Sections_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Quiz_Sections_ManyArgs = {
  updates: Array<Quiz_Quiz_Sections_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_SectionArgs = {
  _inc?: InputMaybe<Quiz_Section_Inc_Input>;
  _set?: InputMaybe<Quiz_Section_Set_Input>;
  where: Quiz_Section_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Section_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Section_Inc_Input>;
  _set?: InputMaybe<Quiz_Section_Set_Input>;
  pk_columns: Quiz_Section_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Section_ManyArgs = {
  updates: Array<Quiz_Section_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_Section_QuestionsArgs = {
  _inc?: InputMaybe<Quiz_Section_Questions_Inc_Input>;
  _set?: InputMaybe<Quiz_Section_Questions_Set_Input>;
  where: Quiz_Section_Questions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Section_Questions_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Section_Questions_Inc_Input>;
  _set?: InputMaybe<Quiz_Section_Questions_Set_Input>;
  pk_columns: Quiz_Section_Questions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Section_Questions_ManyArgs = {
  updates: Array<Quiz_Section_Questions_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_Section_SubsectionsArgs = {
  _inc?: InputMaybe<Quiz_Section_Subsections_Inc_Input>;
  _set?: InputMaybe<Quiz_Section_Subsections_Set_Input>;
  where: Quiz_Section_Subsections_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Section_Subsections_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Section_Subsections_Inc_Input>;
  _set?: InputMaybe<Quiz_Section_Subsections_Set_Input>;
  pk_columns: Quiz_Section_Subsections_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Section_Subsections_ManyArgs = {
  updates: Array<Quiz_Section_Subsections_Updates>;
};


/** mutation root */
export type MutationUpdate_Quiz_SuperdomainArgs = {
  _inc?: InputMaybe<Quiz_Superdomain_Inc_Input>;
  _set?: InputMaybe<Quiz_Superdomain_Set_Input>;
  where: Quiz_Superdomain_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Quiz_Superdomain_By_PkArgs = {
  _inc?: InputMaybe<Quiz_Superdomain_Inc_Input>;
  _set?: InputMaybe<Quiz_Superdomain_Set_Input>;
  pk_columns: Quiz_Superdomain_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Quiz_Superdomain_ManyArgs = {
  updates: Array<Quiz_Superdomain_Updates>;
};


/** mutation root */
export type MutationUpdate_Random_Question_IdsArgs = {
  _inc?: InputMaybe<Random_Question_Ids_Inc_Input>;
  _set?: InputMaybe<Random_Question_Ids_Set_Input>;
  where: Random_Question_Ids_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Random_Question_Ids_ManyArgs = {
  updates: Array<Random_Question_Ids_Updates>;
};


/** mutation root */
export type MutationUpdate_Reaction_EmojisArgs = {
  _set?: InputMaybe<Reaction_Emojis_Set_Input>;
  where: Reaction_Emojis_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Reaction_Emojis_By_PkArgs = {
  _set?: InputMaybe<Reaction_Emojis_Set_Input>;
  pk_columns: Reaction_Emojis_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Reaction_Emojis_ManyArgs = {
  updates: Array<Reaction_Emojis_Updates>;
};


/** mutation root */
export type MutationUpdate_Reported_MessageArgs = {
  _set?: InputMaybe<Reported_Message_Set_Input>;
  where: Reported_Message_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Reported_Message_By_PkArgs = {
  _set?: InputMaybe<Reported_Message_Set_Input>;
  pk_columns: Reported_Message_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Reported_Message_ManyArgs = {
  updates: Array<Reported_Message_Updates>;
};


/** mutation root */
export type MutationUpdate_Scaling_ConstantArgs = {
  _inc?: InputMaybe<Scaling_Constant_Inc_Input>;
  _set?: InputMaybe<Scaling_Constant_Set_Input>;
  where: Scaling_Constant_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Scaling_Constant_By_PkArgs = {
  _inc?: InputMaybe<Scaling_Constant_Inc_Input>;
  _set?: InputMaybe<Scaling_Constant_Set_Input>;
  pk_columns: Scaling_Constant_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Scaling_Constant_ManyArgs = {
  updates: Array<Scaling_Constant_Updates>;
};


/** mutation root */
export type MutationUpdate_Socialaccount_SocialaccountArgs = {
  _inc?: InputMaybe<Socialaccount_Socialaccount_Inc_Input>;
  _set?: InputMaybe<Socialaccount_Socialaccount_Set_Input>;
  where: Socialaccount_Socialaccount_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Socialaccount_Socialaccount_By_PkArgs = {
  _inc?: InputMaybe<Socialaccount_Socialaccount_Inc_Input>;
  _set?: InputMaybe<Socialaccount_Socialaccount_Set_Input>;
  pk_columns: Socialaccount_Socialaccount_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Socialaccount_Socialaccount_ManyArgs = {
  updates: Array<Socialaccount_Socialaccount_Updates>;
};


/** mutation root */
export type MutationUpdate_Socialaccount_SocialappArgs = {
  _inc?: InputMaybe<Socialaccount_Socialapp_Inc_Input>;
  _set?: InputMaybe<Socialaccount_Socialapp_Set_Input>;
  where: Socialaccount_Socialapp_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Socialaccount_Socialapp_By_PkArgs = {
  _inc?: InputMaybe<Socialaccount_Socialapp_Inc_Input>;
  _set?: InputMaybe<Socialaccount_Socialapp_Set_Input>;
  pk_columns: Socialaccount_Socialapp_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Socialaccount_Socialapp_ManyArgs = {
  updates: Array<Socialaccount_Socialapp_Updates>;
};


/** mutation root */
export type MutationUpdate_Socialaccount_Socialapp_SitesArgs = {
  _inc?: InputMaybe<Socialaccount_Socialapp_Sites_Inc_Input>;
  _set?: InputMaybe<Socialaccount_Socialapp_Sites_Set_Input>;
  where: Socialaccount_Socialapp_Sites_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Socialaccount_Socialapp_Sites_By_PkArgs = {
  _inc?: InputMaybe<Socialaccount_Socialapp_Sites_Inc_Input>;
  _set?: InputMaybe<Socialaccount_Socialapp_Sites_Set_Input>;
  pk_columns: Socialaccount_Socialapp_Sites_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Socialaccount_Socialapp_Sites_ManyArgs = {
  updates: Array<Socialaccount_Socialapp_Sites_Updates>;
};


/** mutation root */
export type MutationUpdate_Socialaccount_SocialtokenArgs = {
  _inc?: InputMaybe<Socialaccount_Socialtoken_Inc_Input>;
  _set?: InputMaybe<Socialaccount_Socialtoken_Set_Input>;
  where: Socialaccount_Socialtoken_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Socialaccount_Socialtoken_By_PkArgs = {
  _inc?: InputMaybe<Socialaccount_Socialtoken_Inc_Input>;
  _set?: InputMaybe<Socialaccount_Socialtoken_Set_Input>;
  pk_columns: Socialaccount_Socialtoken_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Socialaccount_Socialtoken_ManyArgs = {
  updates: Array<Socialaccount_Socialtoken_Updates>;
};


/** mutation root */
export type MutationUpdate_Speed_Test_CategoryArgs = {
  _set?: InputMaybe<Speed_Test_Category_Set_Input>;
  where: Speed_Test_Category_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Speed_Test_Category_By_PkArgs = {
  _set?: InputMaybe<Speed_Test_Category_Set_Input>;
  pk_columns: Speed_Test_Category_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Speed_Test_Category_ManyArgs = {
  updates: Array<Speed_Test_Category_Updates>;
};


/** mutation root */
export type MutationUpdate_Speed_TestsArgs = {
  _inc?: InputMaybe<Speed_Tests_Inc_Input>;
  _set?: InputMaybe<Speed_Tests_Set_Input>;
  where: Speed_Tests_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Speed_Tests_By_PkArgs = {
  _inc?: InputMaybe<Speed_Tests_Inc_Input>;
  _set?: InputMaybe<Speed_Tests_Set_Input>;
  pk_columns: Speed_Tests_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Speed_Tests_ManyArgs = {
  updates: Array<Speed_Tests_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_CacheArgs = {
  _set?: InputMaybe<Spirit_Cache_Set_Input>;
  where: Spirit_Cache_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Cache_By_PkArgs = {
  _set?: InputMaybe<Spirit_Cache_Set_Input>;
  pk_columns: Spirit_Cache_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Cache_ManyArgs = {
  updates: Array<Spirit_Cache_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Category_CategoryArgs = {
  _inc?: InputMaybe<Spirit_Category_Category_Inc_Input>;
  _set?: InputMaybe<Spirit_Category_Category_Set_Input>;
  where: Spirit_Category_Category_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Category_Category_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Category_Category_Inc_Input>;
  _set?: InputMaybe<Spirit_Category_Category_Set_Input>;
  pk_columns: Spirit_Category_Category_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Category_Category_ManyArgs = {
  updates: Array<Spirit_Category_Category_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Bookmark_CommentbookmarkArgs = {
  _inc?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Set_Input>;
  where: Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Bookmark_Commentbookmark_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Set_Input>;
  pk_columns: Spirit_Comment_Bookmark_Commentbookmark_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Bookmark_Commentbookmark_ManyArgs = {
  updates: Array<Spirit_Comment_Bookmark_Commentbookmark_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_CommentArgs = {
  _inc?: InputMaybe<Spirit_Comment_Comment_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Comment_Set_Input>;
  where: Spirit_Comment_Comment_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Comment_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Comment_Comment_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Comment_Set_Input>;
  pk_columns: Spirit_Comment_Comment_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Comment_ManyArgs = {
  updates: Array<Spirit_Comment_Comment_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Flag_CommentflagArgs = {
  _inc?: InputMaybe<Spirit_Comment_Flag_Commentflag_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Flag_Commentflag_Set_Input>;
  where: Spirit_Comment_Flag_Commentflag_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Flag_Commentflag_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Comment_Flag_Commentflag_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Flag_Commentflag_Set_Input>;
  pk_columns: Spirit_Comment_Flag_Commentflag_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Flag_Commentflag_ManyArgs = {
  updates: Array<Spirit_Comment_Flag_Commentflag_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Flag_FlagArgs = {
  _inc?: InputMaybe<Spirit_Comment_Flag_Flag_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Flag_Flag_Set_Input>;
  where: Spirit_Comment_Flag_Flag_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Flag_Flag_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Comment_Flag_Flag_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Flag_Flag_Set_Input>;
  pk_columns: Spirit_Comment_Flag_Flag_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Flag_Flag_ManyArgs = {
  updates: Array<Spirit_Comment_Flag_Flag_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_History_CommenthistoryArgs = {
  _inc?: InputMaybe<Spirit_Comment_History_Commenthistory_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_History_Commenthistory_Set_Input>;
  where: Spirit_Comment_History_Commenthistory_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_History_Commenthistory_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Comment_History_Commenthistory_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_History_Commenthistory_Set_Input>;
  pk_columns: Spirit_Comment_History_Commenthistory_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_History_Commenthistory_ManyArgs = {
  updates: Array<Spirit_Comment_History_Commenthistory_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Like_CommentlikeArgs = {
  _inc?: InputMaybe<Spirit_Comment_Like_Commentlike_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Like_Commentlike_Set_Input>;
  where: Spirit_Comment_Like_Commentlike_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Like_Commentlike_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Comment_Like_Commentlike_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Like_Commentlike_Set_Input>;
  pk_columns: Spirit_Comment_Like_Commentlike_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Like_Commentlike_ManyArgs = {
  updates: Array<Spirit_Comment_Like_Commentlike_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Poll_CommentpollArgs = {
  _inc?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Set_Input>;
  where: Spirit_Comment_Poll_Commentpoll_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Poll_Commentpoll_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Set_Input>;
  pk_columns: Spirit_Comment_Poll_Commentpoll_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Poll_Commentpoll_ManyArgs = {
  updates: Array<Spirit_Comment_Poll_Commentpoll_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Poll_CommentpollchoiceArgs = {
  _inc?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Set_Input>;
  where: Spirit_Comment_Poll_Commentpollchoice_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Poll_Commentpollchoice_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Set_Input>;
  pk_columns: Spirit_Comment_Poll_Commentpollchoice_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Poll_Commentpollchoice_ManyArgs = {
  updates: Array<Spirit_Comment_Poll_Commentpollchoice_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Poll_CommentpollvoteArgs = {
  _inc?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Set_Input>;
  where: Spirit_Comment_Poll_Commentpollvote_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Poll_Commentpollvote_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Inc_Input>;
  _set?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Set_Input>;
  pk_columns: Spirit_Comment_Poll_Commentpollvote_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Comment_Poll_Commentpollvote_ManyArgs = {
  updates: Array<Spirit_Comment_Poll_Commentpollvote_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Rl_CacheArgs = {
  _set?: InputMaybe<Spirit_Rl_Cache_Set_Input>;
  where: Spirit_Rl_Cache_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Rl_Cache_By_PkArgs = {
  _set?: InputMaybe<Spirit_Rl_Cache_Set_Input>;
  pk_columns: Spirit_Rl_Cache_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Rl_Cache_ManyArgs = {
  updates: Array<Spirit_Rl_Cache_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Favorite_TopicfavoriteArgs = {
  _inc?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Set_Input>;
  where: Spirit_Topic_Favorite_Topicfavorite_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Favorite_Topicfavorite_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Set_Input>;
  pk_columns: Spirit_Topic_Favorite_Topicfavorite_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Favorite_Topicfavorite_ManyArgs = {
  updates: Array<Spirit_Topic_Favorite_Topicfavorite_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Notification_TopicnotificationArgs = {
  _inc?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Set_Input>;
  where: Spirit_Topic_Notification_Topicnotification_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Notification_Topicnotification_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Set_Input>;
  pk_columns: Spirit_Topic_Notification_Topicnotification_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Notification_Topicnotification_ManyArgs = {
  updates: Array<Spirit_Topic_Notification_Topicnotification_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Private_TopicprivateArgs = {
  _inc?: InputMaybe<Spirit_Topic_Private_Topicprivate_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Private_Topicprivate_Set_Input>;
  where: Spirit_Topic_Private_Topicprivate_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Private_Topicprivate_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Topic_Private_Topicprivate_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Private_Topicprivate_Set_Input>;
  pk_columns: Spirit_Topic_Private_Topicprivate_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Private_Topicprivate_ManyArgs = {
  updates: Array<Spirit_Topic_Private_Topicprivate_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_TopicArgs = {
  _inc?: InputMaybe<Spirit_Topic_Topic_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Topic_Set_Input>;
  where: Spirit_Topic_Topic_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Topic_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Topic_Topic_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Topic_Set_Input>;
  pk_columns: Spirit_Topic_Topic_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Topic_ManyArgs = {
  updates: Array<Spirit_Topic_Topic_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Unread_TopicunreadArgs = {
  _inc?: InputMaybe<Spirit_Topic_Unread_Topicunread_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Unread_Topicunread_Set_Input>;
  where: Spirit_Topic_Unread_Topicunread_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Unread_Topicunread_By_PkArgs = {
  _inc?: InputMaybe<Spirit_Topic_Unread_Topicunread_Inc_Input>;
  _set?: InputMaybe<Spirit_Topic_Unread_Topicunread_Set_Input>;
  pk_columns: Spirit_Topic_Unread_Topicunread_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_Topic_Unread_Topicunread_ManyArgs = {
  updates: Array<Spirit_Topic_Unread_Topicunread_Updates>;
};


/** mutation root */
export type MutationUpdate_Spirit_User_UserprofileArgs = {
  _inc?: InputMaybe<Spirit_User_Userprofile_Inc_Input>;
  _set?: InputMaybe<Spirit_User_Userprofile_Set_Input>;
  where: Spirit_User_Userprofile_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Spirit_User_Userprofile_By_PkArgs = {
  _inc?: InputMaybe<Spirit_User_Userprofile_Inc_Input>;
  _set?: InputMaybe<Spirit_User_Userprofile_Set_Input>;
  pk_columns: Spirit_User_Userprofile_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Spirit_User_Userprofile_ManyArgs = {
  updates: Array<Spirit_User_Userprofile_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscription_Group_PlanArgs = {
  _inc?: InputMaybe<Subscription_Group_Plan_Inc_Input>;
  _set?: InputMaybe<Subscription_Group_Plan_Set_Input>;
  where: Subscription_Group_Plan_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscription_Group_Plan_By_PkArgs = {
  _inc?: InputMaybe<Subscription_Group_Plan_Inc_Input>;
  _set?: InputMaybe<Subscription_Group_Plan_Set_Input>;
  pk_columns: Subscription_Group_Plan_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscription_Group_Plan_GroupsArgs = {
  _inc?: InputMaybe<Subscription_Group_Plan_Groups_Inc_Input>;
  _set?: InputMaybe<Subscription_Group_Plan_Groups_Set_Input>;
  where: Subscription_Group_Plan_Groups_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscription_Group_Plan_Groups_By_PkArgs = {
  _inc?: InputMaybe<Subscription_Group_Plan_Groups_Inc_Input>;
  _set?: InputMaybe<Subscription_Group_Plan_Groups_Set_Input>;
  pk_columns: Subscription_Group_Plan_Groups_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscription_Group_Plan_Groups_ManyArgs = {
  updates: Array<Subscription_Group_Plan_Groups_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscription_Group_Plan_ManyArgs = {
  updates: Array<Subscription_Group_Plan_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscriptions_PlancostArgs = {
  _inc?: InputMaybe<Subscriptions_Plancost_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Plancost_Set_Input>;
  where: Subscriptions_Plancost_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Plancost_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Plancost_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Plancost_Set_Input>;
  pk_columns: Subscriptions_Plancost_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Plancost_ManyArgs = {
  updates: Array<Subscriptions_Plancost_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscriptions_PlanlistArgs = {
  _inc?: InputMaybe<Subscriptions_Planlist_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Planlist_Set_Input>;
  where: Subscriptions_Planlist_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Planlist_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Planlist_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Planlist_Set_Input>;
  pk_columns: Subscriptions_Planlist_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Planlist_ManyArgs = {
  updates: Array<Subscriptions_Planlist_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscriptions_PlanlistdetailArgs = {
  _inc?: InputMaybe<Subscriptions_Planlistdetail_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Planlistdetail_Set_Input>;
  where: Subscriptions_Planlistdetail_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Planlistdetail_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Planlistdetail_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Planlistdetail_Set_Input>;
  pk_columns: Subscriptions_Planlistdetail_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Planlistdetail_ManyArgs = {
  updates: Array<Subscriptions_Planlistdetail_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscriptions_PlantagArgs = {
  _inc?: InputMaybe<Subscriptions_Plantag_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Plantag_Set_Input>;
  where: Subscriptions_Plantag_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Plantag_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Plantag_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Plantag_Set_Input>;
  pk_columns: Subscriptions_Plantag_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Plantag_ManyArgs = {
  updates: Array<Subscriptions_Plantag_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscriptions_SubscriptionplanArgs = {
  _inc?: InputMaybe<Subscriptions_Subscriptionplan_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Subscriptionplan_Set_Input>;
  where: Subscriptions_Subscriptionplan_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Subscriptionplan_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Subscriptionplan_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Subscriptionplan_Set_Input>;
  pk_columns: Subscriptions_Subscriptionplan_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Subscriptionplan_ManyArgs = {
  updates: Array<Subscriptions_Subscriptionplan_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Subscriptionplan_Upgradable_PlansArgs = {
  _inc?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Set_Input>;
  where: Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Subscriptionplan_Upgradable_Plans_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Set_Input>;
  pk_columns: Subscriptions_Subscriptionplan_Upgradable_Plans_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Subscriptionplan_Upgradable_Plans_ManyArgs = {
  updates: Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscriptions_SubscriptiontransactionArgs = {
  _inc?: InputMaybe<Subscriptions_Subscriptiontransaction_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Subscriptiontransaction_Set_Input>;
  where: Subscriptions_Subscriptiontransaction_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Subscriptiontransaction_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Subscriptiontransaction_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Subscriptiontransaction_Set_Input>;
  pk_columns: Subscriptions_Subscriptiontransaction_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Subscriptiontransaction_ManyArgs = {
  updates: Array<Subscriptions_Subscriptiontransaction_Updates>;
};


/** mutation root */
export type MutationUpdate_Subscriptions_UsersubscriptionArgs = {
  _inc?: InputMaybe<Subscriptions_Usersubscription_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Usersubscription_Set_Input>;
  where: Subscriptions_Usersubscription_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Usersubscription_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Usersubscription_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Usersubscription_Set_Input>;
  pk_columns: Subscriptions_Usersubscription_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Subscriptions_Usersubscription_ManyArgs = {
  updates: Array<Subscriptions_Usersubscription_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_All_Auth_Recipe_UsersArgs = {
  _inc?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Set_Input>;
  where: Supertokens_All_Auth_Recipe_Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_All_Auth_Recipe_Users_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Set_Input>;
  pk_columns: Supertokens_All_Auth_Recipe_Users_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_All_Auth_Recipe_Users_ManyArgs = {
  updates: Array<Supertokens_All_Auth_Recipe_Users_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_App_Id_To_User_IdArgs = {
  _set?: InputMaybe<Supertokens_App_Id_To_User_Id_Set_Input>;
  where: Supertokens_App_Id_To_User_Id_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_App_Id_To_User_Id_By_PkArgs = {
  _set?: InputMaybe<Supertokens_App_Id_To_User_Id_Set_Input>;
  pk_columns: Supertokens_App_Id_To_User_Id_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_App_Id_To_User_Id_ManyArgs = {
  updates: Array<Supertokens_App_Id_To_User_Id_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_AppsArgs = {
  _inc?: InputMaybe<Supertokens_Apps_Inc_Input>;
  _set?: InputMaybe<Supertokens_Apps_Set_Input>;
  where: Supertokens_Apps_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Apps_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Apps_Inc_Input>;
  _set?: InputMaybe<Supertokens_Apps_Set_Input>;
  pk_columns: Supertokens_Apps_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Apps_ManyArgs = {
  updates: Array<Supertokens_Apps_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Dashboard_User_SessionsArgs = {
  _inc?: InputMaybe<Supertokens_Dashboard_User_Sessions_Inc_Input>;
  _set?: InputMaybe<Supertokens_Dashboard_User_Sessions_Set_Input>;
  where: Supertokens_Dashboard_User_Sessions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Dashboard_User_Sessions_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Dashboard_User_Sessions_Inc_Input>;
  _set?: InputMaybe<Supertokens_Dashboard_User_Sessions_Set_Input>;
  pk_columns: Supertokens_Dashboard_User_Sessions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Dashboard_User_Sessions_ManyArgs = {
  updates: Array<Supertokens_Dashboard_User_Sessions_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Dashboard_UsersArgs = {
  _inc?: InputMaybe<Supertokens_Dashboard_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_Dashboard_Users_Set_Input>;
  where: Supertokens_Dashboard_Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Dashboard_Users_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Dashboard_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_Dashboard_Users_Set_Input>;
  pk_columns: Supertokens_Dashboard_Users_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Dashboard_Users_ManyArgs = {
  updates: Array<Supertokens_Dashboard_Users_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailpassword_Pswd_Reset_TokensArgs = {
  _inc?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Inc_Input>;
  _set?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Set_Input>;
  where: Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailpassword_Pswd_Reset_Tokens_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Inc_Input>;
  _set?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Set_Input>;
  pk_columns: Supertokens_Emailpassword_Pswd_Reset_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailpassword_Pswd_Reset_Tokens_ManyArgs = {
  updates: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailpassword_User_To_TenantArgs = {
  _set?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Set_Input>;
  where: Supertokens_Emailpassword_User_To_Tenant_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailpassword_User_To_Tenant_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Set_Input>;
  pk_columns: Supertokens_Emailpassword_User_To_Tenant_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailpassword_User_To_Tenant_ManyArgs = {
  updates: Array<Supertokens_Emailpassword_User_To_Tenant_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailpassword_UsersArgs = {
  _inc?: InputMaybe<Supertokens_Emailpassword_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_Emailpassword_Users_Set_Input>;
  where: Supertokens_Emailpassword_Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailpassword_Users_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Emailpassword_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_Emailpassword_Users_Set_Input>;
  pk_columns: Supertokens_Emailpassword_Users_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailpassword_Users_ManyArgs = {
  updates: Array<Supertokens_Emailpassword_Users_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailverification_TokensArgs = {
  _inc?: InputMaybe<Supertokens_Emailverification_Tokens_Inc_Input>;
  _set?: InputMaybe<Supertokens_Emailverification_Tokens_Set_Input>;
  where: Supertokens_Emailverification_Tokens_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailverification_Tokens_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Emailverification_Tokens_Inc_Input>;
  _set?: InputMaybe<Supertokens_Emailverification_Tokens_Set_Input>;
  pk_columns: Supertokens_Emailverification_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailverification_Tokens_ManyArgs = {
  updates: Array<Supertokens_Emailverification_Tokens_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailverification_Verified_EmailsArgs = {
  _set?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Set_Input>;
  where: Supertokens_Emailverification_Verified_Emails_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailverification_Verified_Emails_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Set_Input>;
  pk_columns: Supertokens_Emailverification_Verified_Emails_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Emailverification_Verified_Emails_ManyArgs = {
  updates: Array<Supertokens_Emailverification_Verified_Emails_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Jwt_Signing_KeysArgs = {
  _inc?: InputMaybe<Supertokens_Jwt_Signing_Keys_Inc_Input>;
  _set?: InputMaybe<Supertokens_Jwt_Signing_Keys_Set_Input>;
  where: Supertokens_Jwt_Signing_Keys_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Jwt_Signing_Keys_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Jwt_Signing_Keys_Inc_Input>;
  _set?: InputMaybe<Supertokens_Jwt_Signing_Keys_Set_Input>;
  pk_columns: Supertokens_Jwt_Signing_Keys_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Jwt_Signing_Keys_ManyArgs = {
  updates: Array<Supertokens_Jwt_Signing_Keys_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Key_ValueArgs = {
  _inc?: InputMaybe<Supertokens_Key_Value_Inc_Input>;
  _set?: InputMaybe<Supertokens_Key_Value_Set_Input>;
  where: Supertokens_Key_Value_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Key_Value_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Key_Value_Inc_Input>;
  _set?: InputMaybe<Supertokens_Key_Value_Set_Input>;
  pk_columns: Supertokens_Key_Value_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Key_Value_ManyArgs = {
  updates: Array<Supertokens_Key_Value_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_CodesArgs = {
  _inc?: InputMaybe<Supertokens_Passwordless_Codes_Inc_Input>;
  _set?: InputMaybe<Supertokens_Passwordless_Codes_Set_Input>;
  where: Supertokens_Passwordless_Codes_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_Codes_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Passwordless_Codes_Inc_Input>;
  _set?: InputMaybe<Supertokens_Passwordless_Codes_Set_Input>;
  pk_columns: Supertokens_Passwordless_Codes_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_Codes_ManyArgs = {
  updates: Array<Supertokens_Passwordless_Codes_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_DevicesArgs = {
  _inc?: InputMaybe<Supertokens_Passwordless_Devices_Inc_Input>;
  _set?: InputMaybe<Supertokens_Passwordless_Devices_Set_Input>;
  where: Supertokens_Passwordless_Devices_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_Devices_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Passwordless_Devices_Inc_Input>;
  _set?: InputMaybe<Supertokens_Passwordless_Devices_Set_Input>;
  pk_columns: Supertokens_Passwordless_Devices_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_Devices_ManyArgs = {
  updates: Array<Supertokens_Passwordless_Devices_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_User_To_TenantArgs = {
  _set?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Set_Input>;
  where: Supertokens_Passwordless_User_To_Tenant_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_User_To_Tenant_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Set_Input>;
  pk_columns: Supertokens_Passwordless_User_To_Tenant_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_User_To_Tenant_ManyArgs = {
  updates: Array<Supertokens_Passwordless_User_To_Tenant_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_UsersArgs = {
  _inc?: InputMaybe<Supertokens_Passwordless_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_Passwordless_Users_Set_Input>;
  where: Supertokens_Passwordless_Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_Users_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Passwordless_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_Passwordless_Users_Set_Input>;
  pk_columns: Supertokens_Passwordless_Users_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Passwordless_Users_ManyArgs = {
  updates: Array<Supertokens_Passwordless_Users_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Role_PermissionsArgs = {
  _set?: InputMaybe<Supertokens_Role_Permissions_Set_Input>;
  where: Supertokens_Role_Permissions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Role_Permissions_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Role_Permissions_Set_Input>;
  pk_columns: Supertokens_Role_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Role_Permissions_ManyArgs = {
  updates: Array<Supertokens_Role_Permissions_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_RolesArgs = {
  _set?: InputMaybe<Supertokens_Roles_Set_Input>;
  where: Supertokens_Roles_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Roles_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Roles_Set_Input>;
  pk_columns: Supertokens_Roles_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Roles_ManyArgs = {
  updates: Array<Supertokens_Roles_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Session_Access_Token_Signing_KeysArgs = {
  _inc?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Inc_Input>;
  _set?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Set_Input>;
  where: Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Session_Access_Token_Signing_Keys_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Inc_Input>;
  _set?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Set_Input>;
  pk_columns: Supertokens_Session_Access_Token_Signing_Keys_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Session_Access_Token_Signing_Keys_ManyArgs = {
  updates: Array<Supertokens_Session_Access_Token_Signing_Keys_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Session_InfoArgs = {
  _inc?: InputMaybe<Supertokens_Session_Info_Inc_Input>;
  _set?: InputMaybe<Supertokens_Session_Info_Set_Input>;
  where: Supertokens_Session_Info_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Session_Info_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Session_Info_Inc_Input>;
  _set?: InputMaybe<Supertokens_Session_Info_Set_Input>;
  pk_columns: Supertokens_Session_Info_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Session_Info_ManyArgs = {
  updates: Array<Supertokens_Session_Info_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenant_ConfigsArgs = {
  _set?: InputMaybe<Supertokens_Tenant_Configs_Set_Input>;
  where: Supertokens_Tenant_Configs_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenant_Configs_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Tenant_Configs_Set_Input>;
  pk_columns: Supertokens_Tenant_Configs_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenant_Configs_ManyArgs = {
  updates: Array<Supertokens_Tenant_Configs_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenant_Thirdparty_Provider_ClientsArgs = {
  _set?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Set_Input>;
  where: Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenant_Thirdparty_Provider_Clients_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Set_Input>;
  pk_columns: Supertokens_Tenant_Thirdparty_Provider_Clients_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenant_Thirdparty_Provider_Clients_ManyArgs = {
  updates: Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenant_Thirdparty_ProvidersArgs = {
  _set?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Set_Input>;
  where: Supertokens_Tenant_Thirdparty_Providers_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenant_Thirdparty_Providers_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Set_Input>;
  pk_columns: Supertokens_Tenant_Thirdparty_Providers_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenant_Thirdparty_Providers_ManyArgs = {
  updates: Array<Supertokens_Tenant_Thirdparty_Providers_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_TenantsArgs = {
  _inc?: InputMaybe<Supertokens_Tenants_Inc_Input>;
  _set?: InputMaybe<Supertokens_Tenants_Set_Input>;
  where: Supertokens_Tenants_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenants_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Tenants_Inc_Input>;
  _set?: InputMaybe<Supertokens_Tenants_Set_Input>;
  pk_columns: Supertokens_Tenants_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Tenants_ManyArgs = {
  updates: Array<Supertokens_Tenants_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Thirdparty_User_To_TenantArgs = {
  _set?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Set_Input>;
  where: Supertokens_Thirdparty_User_To_Tenant_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Thirdparty_User_To_Tenant_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Set_Input>;
  pk_columns: Supertokens_Thirdparty_User_To_Tenant_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Thirdparty_User_To_Tenant_ManyArgs = {
  updates: Array<Supertokens_Thirdparty_User_To_Tenant_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Thirdparty_UsersArgs = {
  _inc?: InputMaybe<Supertokens_Thirdparty_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_Thirdparty_Users_Set_Input>;
  where: Supertokens_Thirdparty_Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Thirdparty_Users_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_Thirdparty_Users_Inc_Input>;
  _set?: InputMaybe<Supertokens_Thirdparty_Users_Set_Input>;
  pk_columns: Supertokens_Thirdparty_Users_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Thirdparty_Users_ManyArgs = {
  updates: Array<Supertokens_Thirdparty_Users_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Additional_FieldsArgs = {
  _inc?: InputMaybe<Supertokens_User_Additional_Fields_Inc_Input>;
  _set?: InputMaybe<Supertokens_User_Additional_Fields_Set_Input>;
  where: Supertokens_User_Additional_Fields_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Additional_Fields_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_User_Additional_Fields_Inc_Input>;
  _set?: InputMaybe<Supertokens_User_Additional_Fields_Set_Input>;
  pk_columns: Supertokens_User_Additional_Fields_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Additional_Fields_ManyArgs = {
  updates: Array<Supertokens_User_Additional_Fields_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Last_ActiveArgs = {
  _inc?: InputMaybe<Supertokens_User_Last_Active_Inc_Input>;
  _set?: InputMaybe<Supertokens_User_Last_Active_Set_Input>;
  where: Supertokens_User_Last_Active_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Last_Active_By_PkArgs = {
  _inc?: InputMaybe<Supertokens_User_Last_Active_Inc_Input>;
  _set?: InputMaybe<Supertokens_User_Last_Active_Set_Input>;
  pk_columns: Supertokens_User_Last_Active_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Last_Active_ManyArgs = {
  updates: Array<Supertokens_User_Last_Active_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_MetadataArgs = {
  _set?: InputMaybe<Supertokens_User_Metadata_Set_Input>;
  where: Supertokens_User_Metadata_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Metadata_By_PkArgs = {
  _set?: InputMaybe<Supertokens_User_Metadata_Set_Input>;
  pk_columns: Supertokens_User_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Metadata_ManyArgs = {
  updates: Array<Supertokens_User_Metadata_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Public_FieldsArgs = {
  _set?: InputMaybe<Supertokens_User_Public_Fields_Set_Input>;
  where: Supertokens_User_Public_Fields_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Public_Fields_ManyArgs = {
  updates: Array<Supertokens_User_Public_Fields_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_RolesArgs = {
  _set?: InputMaybe<Supertokens_User_Roles_Set_Input>;
  where: Supertokens_User_Roles_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Roles_By_PkArgs = {
  _set?: InputMaybe<Supertokens_User_Roles_Set_Input>;
  pk_columns: Supertokens_User_Roles_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_User_Roles_ManyArgs = {
  updates: Array<Supertokens_User_Roles_Updates>;
};


/** mutation root */
export type MutationUpdate_Supertokens_Userid_MappingArgs = {
  _set?: InputMaybe<Supertokens_Userid_Mapping_Set_Input>;
  where: Supertokens_Userid_Mapping_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Supertokens_Userid_Mapping_By_PkArgs = {
  _set?: InputMaybe<Supertokens_Userid_Mapping_Set_Input>;
  pk_columns: Supertokens_Userid_Mapping_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Supertokens_Userid_Mapping_ManyArgs = {
  updates: Array<Supertokens_Userid_Mapping_Updates>;
};


/** mutation root */
export type MutationUpdate_Taggit_TagArgs = {
  _inc?: InputMaybe<Taggit_Tag_Inc_Input>;
  _set?: InputMaybe<Taggit_Tag_Set_Input>;
  where: Taggit_Tag_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Taggit_Tag_By_PkArgs = {
  _inc?: InputMaybe<Taggit_Tag_Inc_Input>;
  _set?: InputMaybe<Taggit_Tag_Set_Input>;
  pk_columns: Taggit_Tag_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Taggit_Tag_ManyArgs = {
  updates: Array<Taggit_Tag_Updates>;
};


/** mutation root */
export type MutationUpdate_Taggit_TaggeditemArgs = {
  _inc?: InputMaybe<Taggit_Taggeditem_Inc_Input>;
  _set?: InputMaybe<Taggit_Taggeditem_Set_Input>;
  where: Taggit_Taggeditem_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Taggit_Taggeditem_By_PkArgs = {
  _inc?: InputMaybe<Taggit_Taggeditem_Inc_Input>;
  _set?: InputMaybe<Taggit_Taggeditem_Set_Input>;
  pk_columns: Taggit_Taggeditem_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Taggit_Taggeditem_ManyArgs = {
  updates: Array<Taggit_Taggeditem_Updates>;
};


/** mutation root */
export type MutationUpdate_Upcoming_Live_ClassesArgs = {
  _set?: InputMaybe<Upcoming_Live_Classes_Set_Input>;
  where: Upcoming_Live_Classes_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Upcoming_Live_Classes_By_PkArgs = {
  _set?: InputMaybe<Upcoming_Live_Classes_Set_Input>;
  pk_columns: Upcoming_Live_Classes_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Upcoming_Live_Classes_ManyArgs = {
  updates: Array<Upcoming_Live_Classes_Updates>;
};


/** mutation root */
export type MutationUpdate_User_ActivitiesArgs = {
  _inc?: InputMaybe<User_Activities_Inc_Input>;
  _set?: InputMaybe<User_Activities_Set_Input>;
  where: User_Activities_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Activities_By_PkArgs = {
  _inc?: InputMaybe<User_Activities_Inc_Input>;
  _set?: InputMaybe<User_Activities_Set_Input>;
  pk_columns: User_Activities_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Activities_ManyArgs = {
  updates: Array<User_Activities_Updates>;
};


/** mutation root */
export type MutationUpdate_User_ActivityArgs = {
  _inc?: InputMaybe<User_Activity_Inc_Input>;
  _set?: InputMaybe<User_Activity_Set_Input>;
  where: User_Activity_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Activity_By_PkArgs = {
  _inc?: InputMaybe<User_Activity_Inc_Input>;
  _set?: InputMaybe<User_Activity_Set_Input>;
  pk_columns: User_Activity_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Activity_Lesson_EntriesArgs = {
  _inc?: InputMaybe<User_Activity_Lesson_Entries_Inc_Input>;
  _set?: InputMaybe<User_Activity_Lesson_Entries_Set_Input>;
  where: User_Activity_Lesson_Entries_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Activity_Lesson_Entries_By_PkArgs = {
  _inc?: InputMaybe<User_Activity_Lesson_Entries_Inc_Input>;
  _set?: InputMaybe<User_Activity_Lesson_Entries_Set_Input>;
  pk_columns: User_Activity_Lesson_Entries_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Activity_Lesson_Entries_ManyArgs = {
  updates: Array<User_Activity_Lesson_Entries_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Activity_ManyArgs = {
  updates: Array<User_Activity_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Cat_Registration_DataArgs = {
  _set?: InputMaybe<User_Cat_Registration_Data_Set_Input>;
  where: User_Cat_Registration_Data_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Cat_Registration_Data_By_PkArgs = {
  _set?: InputMaybe<User_Cat_Registration_Data_Set_Input>;
  pk_columns: User_Cat_Registration_Data_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Cat_Registration_Data_ManyArgs = {
  updates: Array<User_Cat_Registration_Data_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Cat_Response_Sheet_DataArgs = {
  _inc?: InputMaybe<User_Cat_Response_Sheet_Data_Inc_Input>;
  _set?: InputMaybe<User_Cat_Response_Sheet_Data_Set_Input>;
  where: User_Cat_Response_Sheet_Data_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Cat_Response_Sheet_Data_By_PkArgs = {
  _inc?: InputMaybe<User_Cat_Response_Sheet_Data_Inc_Input>;
  _set?: InputMaybe<User_Cat_Response_Sheet_Data_Set_Input>;
  pk_columns: User_Cat_Response_Sheet_Data_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Cat_Response_Sheet_Data_ManyArgs = {
  updates: Array<User_Cat_Response_Sheet_Data_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Custom_Planned_ActivitiesArgs = {
  _set?: InputMaybe<User_Custom_Planned_Activities_Set_Input>;
  where: User_Custom_Planned_Activities_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Custom_Planned_Activities_By_PkArgs = {
  _set?: InputMaybe<User_Custom_Planned_Activities_Set_Input>;
  pk_columns: User_Custom_Planned_Activities_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Custom_Planned_Activities_ManyArgs = {
  updates: Array<User_Custom_Planned_Activities_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Leaderboard_TypesArgs = {
  _set?: InputMaybe<User_Leaderboard_Types_Set_Input>;
  where: User_Leaderboard_Types_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Leaderboard_Types_By_PkArgs = {
  _set?: InputMaybe<User_Leaderboard_Types_Set_Input>;
  pk_columns: User_Leaderboard_Types_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Leaderboard_Types_ManyArgs = {
  updates: Array<User_Leaderboard_Types_Updates>;
};


/** mutation root */
export type MutationUpdate_User_LeaderboardsArgs = {
  _inc?: InputMaybe<User_Leaderboards_Inc_Input>;
  _set?: InputMaybe<User_Leaderboards_Set_Input>;
  where: User_Leaderboards_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Leaderboards_By_PkArgs = {
  _inc?: InputMaybe<User_Leaderboards_Inc_Input>;
  _set?: InputMaybe<User_Leaderboards_Set_Input>;
  pk_columns: User_Leaderboards_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Leaderboards_ManyArgs = {
  updates: Array<User_Leaderboards_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Learn_ActivitiesArgs = {
  _set?: InputMaybe<User_Learn_Activities_Set_Input>;
  where: User_Learn_Activities_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Learn_Activities_By_PkArgs = {
  _set?: InputMaybe<User_Learn_Activities_Set_Input>;
  pk_columns: User_Learn_Activities_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Learn_Activities_ManyArgs = {
  updates: Array<User_Learn_Activities_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Learn_Category_ProgressArgs = {
  _inc?: InputMaybe<User_Learn_Category_Progress_Inc_Input>;
  _set?: InputMaybe<User_Learn_Category_Progress_Set_Input>;
  where: User_Learn_Category_Progress_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Learn_Category_Progress_By_PkArgs = {
  _inc?: InputMaybe<User_Learn_Category_Progress_Inc_Input>;
  _set?: InputMaybe<User_Learn_Category_Progress_Set_Input>;
  pk_columns: User_Learn_Category_Progress_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Learn_Category_Progress_ManyArgs = {
  updates: Array<User_Learn_Category_Progress_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Learn_Completed_TopicsArgs = {
  _inc?: InputMaybe<User_Learn_Completed_Topics_Inc_Input>;
  _set?: InputMaybe<User_Learn_Completed_Topics_Set_Input>;
  where: User_Learn_Completed_Topics_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Learn_Completed_Topics_By_PkArgs = {
  _inc?: InputMaybe<User_Learn_Completed_Topics_Inc_Input>;
  _set?: InputMaybe<User_Learn_Completed_Topics_Set_Input>;
  pk_columns: User_Learn_Completed_Topics_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Learn_Completed_Topics_ManyArgs = {
  updates: Array<User_Learn_Completed_Topics_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Learn_Modules_SummaryArgs = {
  _inc?: InputMaybe<User_Learn_Modules_Summary_Inc_Input>;
  _set?: InputMaybe<User_Learn_Modules_Summary_Set_Input>;
  where: User_Learn_Modules_Summary_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Learn_Modules_Summary_By_PkArgs = {
  _inc?: InputMaybe<User_Learn_Modules_Summary_Inc_Input>;
  _set?: InputMaybe<User_Learn_Modules_Summary_Set_Input>;
  pk_columns: User_Learn_Modules_Summary_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Learn_Modules_Summary_ManyArgs = {
  updates: Array<User_Learn_Modules_Summary_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Learn_Track_RecordArgs = {
  _inc?: InputMaybe<User_Learn_Track_Record_Inc_Input>;
  _set?: InputMaybe<User_Learn_Track_Record_Set_Input>;
  where: User_Learn_Track_Record_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Learn_Track_Record_Bookmarked_TopicsArgs = {
  _inc?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Inc_Input>;
  _set?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Set_Input>;
  where: User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Learn_Track_Record_Bookmarked_Topics_By_PkArgs = {
  _inc?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Inc_Input>;
  _set?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Set_Input>;
  pk_columns: User_Learn_Track_Record_Bookmarked_Topics_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Learn_Track_Record_Bookmarked_Topics_ManyArgs = {
  updates: Array<User_Learn_Track_Record_Bookmarked_Topics_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Learn_Track_Record_By_PkArgs = {
  _inc?: InputMaybe<User_Learn_Track_Record_Inc_Input>;
  _set?: InputMaybe<User_Learn_Track_Record_Set_Input>;
  pk_columns: User_Learn_Track_Record_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Learn_Track_Record_ManyArgs = {
  updates: Array<User_Learn_Track_Record_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Learn_Track_Record_Which_TopicsArgs = {
  _inc?: InputMaybe<User_Learn_Track_Record_Which_Topics_Inc_Input>;
  _set?: InputMaybe<User_Learn_Track_Record_Which_Topics_Set_Input>;
  where: User_Learn_Track_Record_Which_Topics_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Learn_Track_Record_Which_Topics_By_PkArgs = {
  _inc?: InputMaybe<User_Learn_Track_Record_Which_Topics_Inc_Input>;
  _set?: InputMaybe<User_Learn_Track_Record_Which_Topics_Set_Input>;
  pk_columns: User_Learn_Track_Record_Which_Topics_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Learn_Track_Record_Which_Topics_ManyArgs = {
  updates: Array<User_Learn_Track_Record_Which_Topics_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Planned_ActivitiesArgs = {
  _inc?: InputMaybe<User_Planned_Activities_Inc_Input>;
  _set?: InputMaybe<User_Planned_Activities_Set_Input>;
  where: User_Planned_Activities_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Planned_Activities_By_PkArgs = {
  _inc?: InputMaybe<User_Planned_Activities_Inc_Input>;
  _set?: InputMaybe<User_Planned_Activities_Set_Input>;
  pk_columns: User_Planned_Activities_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Planned_Activities_ManyArgs = {
  updates: Array<User_Planned_Activities_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Pov_SummariesArgs = {
  _inc?: InputMaybe<User_Pov_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Pov_Summaries_Set_Input>;
  where: User_Pov_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Pov_Summaries_By_PkArgs = {
  _inc?: InputMaybe<User_Pov_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Pov_Summaries_Set_Input>;
  pk_columns: User_Pov_Summaries_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Pov_Summaries_ManyArgs = {
  updates: Array<User_Pov_Summaries_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_AttemptsArgs = {
  _inc?: InputMaybe<User_Quiz_Question_Attempts_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Question_Attempts_Set_Input>;
  where: User_Quiz_Question_Attempts_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_Attempts_By_PkArgs = {
  _inc?: InputMaybe<User_Quiz_Question_Attempts_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Question_Attempts_Set_Input>;
  pk_columns: User_Quiz_Question_Attempts_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_Attempts_ManyArgs = {
  updates: Array<User_Quiz_Question_Attempts_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_PositionsArgs = {
  _inc?: InputMaybe<User_Quiz_Question_Positions_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Question_Positions_Set_Input>;
  where: User_Quiz_Question_Positions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_Positions_By_PkArgs = {
  _inc?: InputMaybe<User_Quiz_Question_Positions_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Question_Positions_Set_Input>;
  pk_columns: User_Quiz_Question_Positions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_Positions_ManyArgs = {
  updates: Array<User_Quiz_Question_Positions_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_SummariesArgs = {
  _append?: InputMaybe<User_Quiz_Question_Summaries_Append_Input>;
  _delete_at_path?: InputMaybe<User_Quiz_Question_Summaries_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Quiz_Question_Summaries_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Quiz_Question_Summaries_Delete_Key_Input>;
  _inc?: InputMaybe<User_Quiz_Question_Summaries_Inc_Input>;
  _prepend?: InputMaybe<User_Quiz_Question_Summaries_Prepend_Input>;
  _set?: InputMaybe<User_Quiz_Question_Summaries_Set_Input>;
  where: User_Quiz_Question_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_Summaries_By_PkArgs = {
  _append?: InputMaybe<User_Quiz_Question_Summaries_Append_Input>;
  _delete_at_path?: InputMaybe<User_Quiz_Question_Summaries_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Quiz_Question_Summaries_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Quiz_Question_Summaries_Delete_Key_Input>;
  _inc?: InputMaybe<User_Quiz_Question_Summaries_Inc_Input>;
  _prepend?: InputMaybe<User_Quiz_Question_Summaries_Prepend_Input>;
  _set?: InputMaybe<User_Quiz_Question_Summaries_Set_Input>;
  pk_columns: User_Quiz_Question_Summaries_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_Summaries_ManyArgs = {
  updates: Array<User_Quiz_Question_Summaries_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_Summaries_OldArgs = {
  _inc?: InputMaybe<User_Quiz_Question_Summaries_Old_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Question_Summaries_Old_Set_Input>;
  where: User_Quiz_Question_Summaries_Old_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_Summaries_Old_By_PkArgs = {
  _inc?: InputMaybe<User_Quiz_Question_Summaries_Old_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Question_Summaries_Old_Set_Input>;
  pk_columns: User_Quiz_Question_Summaries_Old_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Question_Summaries_Old_ManyArgs = {
  updates: Array<User_Quiz_Question_Summaries_Old_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Quiz_QuestionsArgs = {
  _inc?: InputMaybe<User_Quiz_Questions_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Questions_Set_Input>;
  where: User_Quiz_Questions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Questions_By_PkArgs = {
  _inc?: InputMaybe<User_Quiz_Questions_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Questions_Set_Input>;
  pk_columns: User_Quiz_Questions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Questions_ManyArgs = {
  updates: Array<User_Quiz_Questions_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Section_SummariesArgs = {
  _inc?: InputMaybe<User_Quiz_Section_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Section_Summaries_Set_Input>;
  where: User_Quiz_Section_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Section_Summaries_By_PkArgs = {
  _inc?: InputMaybe<User_Quiz_Section_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Quiz_Section_Summaries_Set_Input>;
  pk_columns: User_Quiz_Section_Summaries_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Section_Summaries_ManyArgs = {
  updates: Array<User_Quiz_Section_Summaries_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Quiz_SummariesArgs = {
  _append?: InputMaybe<User_Quiz_Summaries_Append_Input>;
  _delete_at_path?: InputMaybe<User_Quiz_Summaries_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Quiz_Summaries_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Quiz_Summaries_Delete_Key_Input>;
  _inc?: InputMaybe<User_Quiz_Summaries_Inc_Input>;
  _prepend?: InputMaybe<User_Quiz_Summaries_Prepend_Input>;
  _set?: InputMaybe<User_Quiz_Summaries_Set_Input>;
  where: User_Quiz_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Summaries_By_PkArgs = {
  _append?: InputMaybe<User_Quiz_Summaries_Append_Input>;
  _delete_at_path?: InputMaybe<User_Quiz_Summaries_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Quiz_Summaries_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Quiz_Summaries_Delete_Key_Input>;
  _inc?: InputMaybe<User_Quiz_Summaries_Inc_Input>;
  _prepend?: InputMaybe<User_Quiz_Summaries_Prepend_Input>;
  _set?: InputMaybe<User_Quiz_Summaries_Set_Input>;
  pk_columns: User_Quiz_Summaries_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Summaries_ManyArgs = {
  updates: Array<User_Quiz_Summaries_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Summaries_OldArgs = {
  _append?: InputMaybe<User_Quiz_Summaries_Old_Append_Input>;
  _delete_at_path?: InputMaybe<User_Quiz_Summaries_Old_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Quiz_Summaries_Old_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Quiz_Summaries_Old_Delete_Key_Input>;
  _inc?: InputMaybe<User_Quiz_Summaries_Old_Inc_Input>;
  _prepend?: InputMaybe<User_Quiz_Summaries_Old_Prepend_Input>;
  _set?: InputMaybe<User_Quiz_Summaries_Old_Set_Input>;
  where: User_Quiz_Summaries_Old_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Summaries_Old_By_PkArgs = {
  _append?: InputMaybe<User_Quiz_Summaries_Old_Append_Input>;
  _delete_at_path?: InputMaybe<User_Quiz_Summaries_Old_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Quiz_Summaries_Old_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Quiz_Summaries_Old_Delete_Key_Input>;
  _inc?: InputMaybe<User_Quiz_Summaries_Old_Inc_Input>;
  _prepend?: InputMaybe<User_Quiz_Summaries_Old_Prepend_Input>;
  _set?: InputMaybe<User_Quiz_Summaries_Old_Set_Input>;
  pk_columns: User_Quiz_Summaries_Old_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Quiz_Summaries_Old_ManyArgs = {
  updates: Array<User_Quiz_Summaries_Old_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Section_SummariesArgs = {
  _inc?: InputMaybe<User_Section_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Section_Summaries_Set_Input>;
  where: User_Section_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Section_Summaries_By_PkArgs = {
  _inc?: InputMaybe<User_Section_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Section_Summaries_Set_Input>;
  pk_columns: User_Section_Summaries_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Section_Summaries_ManyArgs = {
  updates: Array<User_Section_Summaries_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Speed_Test_Questions_SummariesArgs = {
  _inc?: InputMaybe<User_Speed_Test_Questions_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Speed_Test_Questions_Summaries_Set_Input>;
  where: User_Speed_Test_Questions_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Speed_Test_Questions_Summaries_By_PkArgs = {
  _inc?: InputMaybe<User_Speed_Test_Questions_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Speed_Test_Questions_Summaries_Set_Input>;
  pk_columns: User_Speed_Test_Questions_Summaries_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Speed_Test_Questions_Summaries_ManyArgs = {
  updates: Array<User_Speed_Test_Questions_Summaries_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Speed_Tests_SummariesArgs = {
  _inc?: InputMaybe<User_Speed_Tests_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Speed_Tests_Summaries_Set_Input>;
  where: User_Speed_Tests_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Speed_Tests_Summaries_By_PkArgs = {
  _inc?: InputMaybe<User_Speed_Tests_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Speed_Tests_Summaries_Set_Input>;
  pk_columns: User_Speed_Tests_Summaries_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Speed_Tests_Summaries_ManyArgs = {
  updates: Array<User_Speed_Tests_Summaries_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Timed_Quiz_SummaryArgs = {
  _inc?: InputMaybe<User_Timed_Quiz_Summary_Inc_Input>;
  _set?: InputMaybe<User_Timed_Quiz_Summary_Set_Input>;
  where: User_Timed_Quiz_Summary_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Timed_Quiz_Summary_By_PkArgs = {
  _inc?: InputMaybe<User_Timed_Quiz_Summary_Inc_Input>;
  _set?: InputMaybe<User_Timed_Quiz_Summary_Set_Input>;
  pk_columns: User_Timed_Quiz_Summary_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Timed_Quiz_Summary_ManyArgs = {
  updates: Array<User_Timed_Quiz_Summary_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Total_ScoreArgs = {
  _inc?: InputMaybe<User_Total_Score_Inc_Input>;
  _set?: InputMaybe<User_Total_Score_Set_Input>;
  where: User_Total_Score_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Total_Score_By_PkArgs = {
  _inc?: InputMaybe<User_Total_Score_Inc_Input>;
  _set?: InputMaybe<User_Total_Score_Set_Input>;
  pk_columns: User_Total_Score_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Total_Score_ManyArgs = {
  updates: Array<User_Total_Score_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Xp_Transaction_SummariesArgs = {
  _inc?: InputMaybe<User_Xp_Transaction_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Xp_Transaction_Summaries_Set_Input>;
  where: User_Xp_Transaction_Summaries_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Xp_Transaction_Summaries_By_PkArgs = {
  _inc?: InputMaybe<User_Xp_Transaction_Summaries_Inc_Input>;
  _set?: InputMaybe<User_Xp_Transaction_Summaries_Set_Input>;
  pk_columns: User_Xp_Transaction_Summaries_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Xp_Transaction_Summaries_ManyArgs = {
  updates: Array<User_Xp_Transaction_Summaries_Updates>;
};


/** mutation root */
export type MutationUpdate_User_Xp_TransactionsArgs = {
  _inc?: InputMaybe<User_Xp_Transactions_Inc_Input>;
  _set?: InputMaybe<User_Xp_Transactions_Set_Input>;
  where: User_Xp_Transactions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Xp_Transactions_By_PkArgs = {
  _inc?: InputMaybe<User_Xp_Transactions_Inc_Input>;
  _set?: InputMaybe<User_Xp_Transactions_Set_Input>;
  pk_columns: User_Xp_Transactions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Xp_Transactions_ManyArgs = {
  updates: Array<User_Xp_Transactions_Updates>;
};


/** mutation root */
export type MutationUpdate_Users_UserArgs = {
  _inc?: InputMaybe<Users_User_Inc_Input>;
  _set?: InputMaybe<Users_User_Set_Input>;
  where: Users_User_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Users_User_By_PkArgs = {
  _inc?: InputMaybe<Users_User_Inc_Input>;
  _set?: InputMaybe<Users_User_Set_Input>;
  pk_columns: Users_User_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Users_User_GroupsArgs = {
  _inc?: InputMaybe<Users_User_Groups_Inc_Input>;
  _set?: InputMaybe<Users_User_Groups_Set_Input>;
  where: Users_User_Groups_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Users_User_Groups_By_PkArgs = {
  _inc?: InputMaybe<Users_User_Groups_Inc_Input>;
  _set?: InputMaybe<Users_User_Groups_Set_Input>;
  pk_columns: Users_User_Groups_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Users_User_Groups_ManyArgs = {
  updates: Array<Users_User_Groups_Updates>;
};


/** mutation root */
export type MutationUpdate_Users_User_ManyArgs = {
  updates: Array<Users_User_Updates>;
};


/** mutation root */
export type MutationUpdate_Users_User_User_PermissionsArgs = {
  _inc?: InputMaybe<Users_User_User_Permissions_Inc_Input>;
  _set?: InputMaybe<Users_User_User_Permissions_Set_Input>;
  where: Users_User_User_Permissions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Users_User_User_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Users_User_User_Permissions_Inc_Input>;
  _set?: InputMaybe<Users_User_User_Permissions_Set_Input>;
  pk_columns: Users_User_User_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Users_User_User_Permissions_ManyArgs = {
  updates: Array<Users_User_User_Permissions_Updates>;
};


/** mutation root */
export type MutationUpdate_Users_UserquestionsummaryArgs = {
  _inc?: InputMaybe<Users_Userquestionsummary_Inc_Input>;
  _set?: InputMaybe<Users_Userquestionsummary_Set_Input>;
  where: Users_Userquestionsummary_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Users_Userquestionsummary_By_PkArgs = {
  _inc?: InputMaybe<Users_Userquestionsummary_Inc_Input>;
  _set?: InputMaybe<Users_Userquestionsummary_Set_Input>;
  pk_columns: Users_Userquestionsummary_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Users_Userquestionsummary_ManyArgs = {
  updates: Array<Users_Userquestionsummary_Updates>;
};


/** mutation root */
export type MutationUpdate_Users_UserquizsummaryArgs = {
  _append?: InputMaybe<Users_Userquizsummary_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Userquizsummary_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Userquizsummary_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Userquizsummary_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Userquizsummary_Inc_Input>;
  _prepend?: InputMaybe<Users_Userquizsummary_Prepend_Input>;
  _set?: InputMaybe<Users_Userquizsummary_Set_Input>;
  where: Users_Userquizsummary_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Users_Userquizsummary_By_PkArgs = {
  _append?: InputMaybe<Users_Userquizsummary_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Userquizsummary_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Userquizsummary_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Userquizsummary_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Userquizsummary_Inc_Input>;
  _prepend?: InputMaybe<Users_Userquizsummary_Prepend_Input>;
  _set?: InputMaybe<Users_Userquizsummary_Set_Input>;
  pk_columns: Users_Userquizsummary_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Users_Userquizsummary_ManyArgs = {
  updates: Array<Users_Userquizsummary_Updates>;
};


/** mutation root */
export type MutationUpdate_Users_UserquiztimesummaryArgs = {
  _inc?: InputMaybe<Users_Userquiztimesummary_Inc_Input>;
  _set?: InputMaybe<Users_Userquiztimesummary_Set_Input>;
  where: Users_Userquiztimesummary_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Users_Userquiztimesummary_By_PkArgs = {
  _inc?: InputMaybe<Users_Userquiztimesummary_Inc_Input>;
  _set?: InputMaybe<Users_Userquiztimesummary_Set_Input>;
  pk_columns: Users_Userquiztimesummary_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Users_Userquiztimesummary_ManyArgs = {
  updates: Array<Users_Userquiztimesummary_Updates>;
};


/** mutation root */
export type MutationUpdate_Users_UsersectionsummaryArgs = {
  _inc?: InputMaybe<Users_Usersectionsummary_Inc_Input>;
  _set?: InputMaybe<Users_Usersectionsummary_Set_Input>;
  where: Users_Usersectionsummary_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Users_Usersectionsummary_By_PkArgs = {
  _inc?: InputMaybe<Users_Usersectionsummary_Inc_Input>;
  _set?: InputMaybe<Users_Usersectionsummary_Set_Input>;
  pk_columns: Users_Usersectionsummary_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Users_Usersectionsummary_ManyArgs = {
  updates: Array<Users_Usersectionsummary_Updates>;
};


/** mutation root */
export type MutationUpdate_Utils_ConfigurationArgs = {
  _inc?: InputMaybe<Utils_Configuration_Inc_Input>;
  _set?: InputMaybe<Utils_Configuration_Set_Input>;
  where: Utils_Configuration_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Utils_Configuration_By_PkArgs = {
  _inc?: InputMaybe<Utils_Configuration_Inc_Input>;
  _set?: InputMaybe<Utils_Configuration_Set_Input>;
  pk_columns: Utils_Configuration_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Utils_Configuration_ManyArgs = {
  updates: Array<Utils_Configuration_Updates>;
};


/** mutation root */
export type MutationUpdate_Xp_Transaction_TypesArgs = {
  _set?: InputMaybe<Xp_Transaction_Types_Set_Input>;
  where: Xp_Transaction_Types_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Xp_Transaction_Types_By_PkArgs = {
  _set?: InputMaybe<Xp_Transaction_Types_Set_Input>;
  pk_columns: Xp_Transaction_Types_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Xp_Transaction_Types_ManyArgs = {
  updates: Array<Xp_Transaction_Types_Updates>;
};


/** mutation root */
export type MutationValidateGoogleLoginArgs = {
  code: Scalars['String']['input'];
  deviceType?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type MutationVerifyEmailArgs = {
  token: Scalars['String']['input'];
};


/** mutation root */
export type MutationVerifyOfflineLeadOtpArgs = {
  mobile: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};


/** mutation root */
export type MutationVerifyOtpArgs = {
  mobile: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};


/** mutation root */
export type MutationVerifyPaymentArgs = {
  orderID: Scalars['String']['input'];
  razorpayOrderID: Scalars['String']['input'];
  razorpayPaymentID: Scalars['String']['input'];
  razorpaySignature: Scalars['String']['input'];
};


/** mutation root */
export type MutationVerifyResetPasswordTokenArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** mutation root */
export type MutationVotePollArgs = {
  optionsId: Array<Scalars['String']['input']>;
  pollId: Scalars['String']['input'];
};

export type Options = {
  __typename?: 'Options';
  amount: Scalars['Int']['output'];
  initial_price: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  plan_name: Scalars['String']['output'];
  receiptId: Scalars['String']['output'];
};

export type OrderIdPayload = {
  __typename?: 'OrderIdPayload';
  order_id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PollOption = {
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  /** fetch data from the table: "account_emailaddress" */
  account_emailaddress: Array<Account_Emailaddress>;
  /** fetch aggregated fields from the table: "account_emailaddress" */
  account_emailaddress_aggregate: Account_Emailaddress_Aggregate;
  /** fetch data from the table: "account_emailaddress" using primary key columns */
  account_emailaddress_by_pk?: Maybe<Account_Emailaddress>;
  /** fetch data from the table: "account_emailconfirmation" */
  account_emailconfirmation: Array<Account_Emailconfirmation>;
  /** fetch aggregated fields from the table: "account_emailconfirmation" */
  account_emailconfirmation_aggregate: Account_Emailconfirmation_Aggregate;
  /** fetch data from the table: "account_emailconfirmation" using primary key columns */
  account_emailconfirmation_by_pk?: Maybe<Account_Emailconfirmation>;
  /** An array relationship */
  accounts_catscores: Array<Accounts_Catscores>;
  /** An aggregate relationship */
  accounts_catscores_aggregate: Accounts_Catscores_Aggregate;
  /** fetch data from the table: "accounts_catscores" using primary key columns */
  accounts_catscores_by_pk?: Maybe<Accounts_Catscores>;
  /** fetch data from the table: "accounts_loggedinuser" */
  accounts_loggedinuser: Array<Accounts_Loggedinuser>;
  /** fetch aggregated fields from the table: "accounts_loggedinuser" */
  accounts_loggedinuser_aggregate: Accounts_Loggedinuser_Aggregate;
  /** fetch data from the table: "accounts_loggedinuser" using primary key columns */
  accounts_loggedinuser_by_pk?: Maybe<Accounts_Loggedinuser>;
  /** fetch data from the table: "activity_types" */
  activity_types: Array<Activity_Types>;
  /** fetch aggregated fields from the table: "activity_types" */
  activity_types_aggregate: Activity_Types_Aggregate;
  /** fetch data from the table: "activity_types" using primary key columns */
  activity_types_by_pk?: Maybe<Activity_Types>;
  /** fetch data from the table: "admin_constants" */
  admin_constants: Array<Admin_Constants>;
  /** fetch aggregated fields from the table: "admin_constants" */
  admin_constants_aggregate: Admin_Constants_Aggregate;
  /** fetch data from the table: "admin_constants" using primary key columns */
  admin_constants_by_pk?: Maybe<Admin_Constants>;
  /** fetch data from the table: "admin_users" */
  admin_users: Array<Admin_Users>;
  /** fetch aggregated fields from the table: "admin_users" */
  admin_users_aggregate: Admin_Users_Aggregate;
  /** fetch data from the table: "admin_users" using primary key columns */
  admin_users_by_pk?: Maybe<Admin_Users>;
  /** An array relationship */
  advertisements: Array<Advertisements>;
  /** An aggregate relationship */
  advertisements_aggregate: Advertisements_Aggregate;
  /** fetch data from the table: "advertisements" using primary key columns */
  advertisements_by_pk?: Maybe<Advertisements>;
  /** fetch data from the table: "andablog_entry" */
  andablog_entry: Array<Andablog_Entry>;
  /** fetch aggregated fields from the table: "andablog_entry" */
  andablog_entry_aggregate: Andablog_Entry_Aggregate;
  /** fetch data from the table: "andablog_entry" using primary key columns */
  andablog_entry_by_pk?: Maybe<Andablog_Entry>;
  /** fetch data from the table: "andablog_entryimage" */
  andablog_entryimage: Array<Andablog_Entryimage>;
  /** fetch aggregated fields from the table: "andablog_entryimage" */
  andablog_entryimage_aggregate: Andablog_Entryimage_Aggregate;
  /** fetch data from the table: "andablog_entryimage" using primary key columns */
  andablog_entryimage_by_pk?: Maybe<Andablog_Entryimage>;
  /** fetch data from the table: "andablog_news" */
  andablog_news: Array<Andablog_News>;
  /** fetch aggregated fields from the table: "andablog_news" */
  andablog_news_aggregate: Andablog_News_Aggregate;
  /** fetch data from the table: "andablog_news" using primary key columns */
  andablog_news_by_pk?: Maybe<Andablog_News>;
  /** fetch data from the table: "andablog_pov" */
  andablog_pov: Array<Andablog_Pov>;
  /** fetch aggregated fields from the table: "andablog_pov" */
  andablog_pov_aggregate: Andablog_Pov_Aggregate;
  /** fetch data from the table: "andablog_pov" using primary key columns */
  andablog_pov_by_pk?: Maybe<Andablog_Pov>;
  /** fetch data from the table: "andablog_userlessontrackrecord" */
  andablog_userlessontrackrecord: Array<Andablog_Userlessontrackrecord>;
  /** fetch aggregated fields from the table: "andablog_userlessontrackrecord" */
  andablog_userlessontrackrecord_aggregate: Andablog_Userlessontrackrecord_Aggregate;
  /** An array relationship */
  andablog_userlessontrackrecord_bookmarked_topics: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** An aggregate relationship */
  andablog_userlessontrackrecord_bookmarked_topics_aggregate: Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate;
  /** fetch data from the table: "andablog_userlessontrackrecord_bookmarked_topics" using primary key columns */
  andablog_userlessontrackrecord_bookmarked_topics_by_pk?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** fetch data from the table: "andablog_userlessontrackrecord" using primary key columns */
  andablog_userlessontrackrecord_by_pk?: Maybe<Andablog_Userlessontrackrecord>;
  /** An array relationship */
  andablog_userlessontrackrecord_which_topics: Array<Andablog_Userlessontrackrecord_Which_Topics>;
  /** An aggregate relationship */
  andablog_userlessontrackrecord_which_topics_aggregate: Andablog_Userlessontrackrecord_Which_Topics_Aggregate;
  /** fetch data from the table: "andablog_userlessontrackrecord_which_topics" using primary key columns */
  andablog_userlessontrackrecord_which_topics_by_pk?: Maybe<Andablog_Userlessontrackrecord_Which_Topics>;
  /** fetch data from the table: "andablog_video" */
  andablog_video: Array<Andablog_Video>;
  /** fetch aggregated fields from the table: "andablog_video" */
  andablog_video_aggregate: Andablog_Video_Aggregate;
  /** fetch data from the table: "andablog_video" using primary key columns */
  andablog_video_by_pk?: Maybe<Andablog_Video>;
  /** fetch data from the table: "auth.email_verifications" */
  auth_email_verifications: Array<Auth_Email_Verifications>;
  /** fetch aggregated fields from the table: "auth.email_verifications" */
  auth_email_verifications_aggregate: Auth_Email_Verifications_Aggregate;
  /** fetch data from the table: "auth.email_verifications" using primary key columns */
  auth_email_verifications_by_pk?: Maybe<Auth_Email_Verifications>;
  /** fetch data from the table: "auth_group" */
  auth_group: Array<Auth_Group>;
  /** fetch aggregated fields from the table: "auth_group" */
  auth_group_aggregate: Auth_Group_Aggregate;
  /** fetch data from the table: "auth_group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** An array relationship */
  auth_group_permissions: Array<Auth_Group_Permissions>;
  /** An aggregate relationship */
  auth_group_permissions_aggregate: Auth_Group_Permissions_Aggregate;
  /** fetch data from the table: "auth_group_permissions" using primary key columns */
  auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** fetch data from the table: "auth.password_reset_tokens" */
  auth_password_reset_tokens: Array<Auth_Password_Reset_Tokens>;
  /** fetch aggregated fields from the table: "auth.password_reset_tokens" */
  auth_password_reset_tokens_aggregate: Auth_Password_Reset_Tokens_Aggregate;
  /** fetch data from the table: "auth.password_reset_tokens" using primary key columns */
  auth_password_reset_tokens_by_pk?: Maybe<Auth_Password_Reset_Tokens>;
  /** fetch data from the table: "auth_permission" */
  auth_permission: Array<Auth_Permission>;
  /** fetch aggregated fields from the table: "auth_permission" */
  auth_permission_aggregate: Auth_Permission_Aggregate;
  /** fetch data from the table: "auth_permission" using primary key columns */
  auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** fetch data from the table: "auth.session" */
  auth_session: Array<Auth_Session>;
  /** fetch aggregated fields from the table: "auth.session" */
  auth_session_aggregate: Auth_Session_Aggregate;
  /** fetch data from the table: "auth.session" using primary key columns */
  auth_session_by_pk?: Maybe<Auth_Session>;
  /** An array relationship */
  bookmarked_learn_topics: Array<Bookmarked_Learn_Topics>;
  /** An aggregate relationship */
  bookmarked_learn_topics_aggregate: Bookmarked_Learn_Topics_Aggregate;
  /** fetch data from the table: "bookmarked_learn_topics" using primary key columns */
  bookmarked_learn_topics_by_pk?: Maybe<Bookmarked_Learn_Topics>;
  /** fetch data from the table: "cat_percentile_constant" */
  cat_percentile_constant: Array<Cat_Percentile_Constant>;
  /** fetch aggregated fields from the table: "cat_percentile_constant" */
  cat_percentile_constant_aggregate: Cat_Percentile_Constant_Aggregate;
  /** fetch data from the table: "cat_percentile_constant" using primary key columns */
  cat_percentile_constant_by_pk?: Maybe<Cat_Percentile_Constant>;
  /** fetch data from the table: "cat_scores" */
  cat_scores: Array<Cat_Scores>;
  /** fetch aggregated fields from the table: "cat_scores" */
  cat_scores_aggregate: Cat_Scores_Aggregate;
  /** fetch data from the table: "cat_scores" using primary key columns */
  cat_scores_by_pk?: Maybe<Cat_Scores>;
  /** An array relationship */
  channel_members: Array<Channel_Members>;
  /** An aggregate relationship */
  channel_members_aggregate: Channel_Members_Aggregate;
  /** fetch data from the table: "channel_members" using primary key columns */
  channel_members_by_pk?: Maybe<Channel_Members>;
  /** fetch data from the table: "channels" */
  channels: Array<Channels>;
  /** fetch aggregated fields from the table: "channels" */
  channels_aggregate: Channels_Aggregate;
  /** fetch data from the table: "channels" using primary key columns */
  channels_by_pk?: Maybe<Channels>;
  /** An array relationship */
  coupons_allowed_users_rule_users: Array<Coupons_Allowed_Users_Rule_Users>;
  /** An aggregate relationship */
  coupons_allowed_users_rule_users_aggregate: Coupons_Allowed_Users_Rule_Users_Aggregate;
  /** fetch data from the table: "coupons_allowed_users_rule_users" using primary key columns */
  coupons_allowed_users_rule_users_by_pk?: Maybe<Coupons_Allowed_Users_Rule_Users>;
  /** fetch data from the table: "coupons_allowedusersrule" */
  coupons_allowedusersrule: Array<Coupons_Allowedusersrule>;
  /** fetch aggregated fields from the table: "coupons_allowedusersrule" */
  coupons_allowedusersrule_aggregate: Coupons_Allowedusersrule_Aggregate;
  /** fetch data from the table: "coupons_allowedusersrule" using primary key columns */
  coupons_allowedusersrule_by_pk?: Maybe<Coupons_Allowedusersrule>;
  /** An array relationship */
  coupons_allowedusersrule_users: Array<Coupons_Allowedusersrule_Users>;
  /** An aggregate relationship */
  coupons_allowedusersrule_users_aggregate: Coupons_Allowedusersrule_Users_Aggregate;
  /** fetch data from the table: "coupons_allowedusersrule_users" using primary key columns */
  coupons_allowedusersrule_users_by_pk?: Maybe<Coupons_Allowedusersrule_Users>;
  /** fetch data from the table: "coupons_coupon" */
  coupons_coupon: Array<Coupons_Coupon>;
  /** fetch aggregated fields from the table: "coupons_coupon" */
  coupons_coupon_aggregate: Coupons_Coupon_Aggregate;
  /** An array relationship */
  coupons_coupon_applicable_packages: Array<Coupons_Coupon_Applicable_Packages>;
  /** An aggregate relationship */
  coupons_coupon_applicable_packages_aggregate: Coupons_Coupon_Applicable_Packages_Aggregate;
  /** fetch data from the table: "coupons_coupon_applicable_packages" using primary key columns */
  coupons_coupon_applicable_packages_by_pk?: Maybe<Coupons_Coupon_Applicable_Packages>;
  /** fetch data from the table: "coupons_coupon" using primary key columns */
  coupons_coupon_by_pk?: Maybe<Coupons_Coupon>;
  /** fetch data from the table: "coupons_couponuser" */
  coupons_couponuser: Array<Coupons_Couponuser>;
  /** fetch aggregated fields from the table: "coupons_couponuser" */
  coupons_couponuser_aggregate: Coupons_Couponuser_Aggregate;
  /** fetch data from the table: "coupons_couponuser" using primary key columns */
  coupons_couponuser_by_pk?: Maybe<Coupons_Couponuser>;
  /** fetch data from the table: "coupons_discount" */
  coupons_discount: Array<Coupons_Discount>;
  /** fetch aggregated fields from the table: "coupons_discount" */
  coupons_discount_aggregate: Coupons_Discount_Aggregate;
  /** fetch data from the table: "coupons_discount" using primary key columns */
  coupons_discount_by_pk?: Maybe<Coupons_Discount>;
  /** fetch data from the table: "coupons_maxusesrule" */
  coupons_maxusesrule: Array<Coupons_Maxusesrule>;
  /** fetch aggregated fields from the table: "coupons_maxusesrule" */
  coupons_maxusesrule_aggregate: Coupons_Maxusesrule_Aggregate;
  /** fetch data from the table: "coupons_maxusesrule" using primary key columns */
  coupons_maxusesrule_by_pk?: Maybe<Coupons_Maxusesrule>;
  /** fetch data from the table: "coupons_ruleset" */
  coupons_ruleset: Array<Coupons_Ruleset>;
  /** fetch aggregated fields from the table: "coupons_ruleset" */
  coupons_ruleset_aggregate: Coupons_Ruleset_Aggregate;
  /** fetch data from the table: "coupons_ruleset" using primary key columns */
  coupons_ruleset_by_pk?: Maybe<Coupons_Ruleset>;
  /** fetch data from the table: "coupons_validityrule" */
  coupons_validityrule: Array<Coupons_Validityrule>;
  /** fetch aggregated fields from the table: "coupons_validityrule" */
  coupons_validityrule_aggregate: Coupons_Validityrule_Aggregate;
  /** fetch data from the table: "coupons_validityrule" using primary key columns */
  coupons_validityrule_by_pk?: Maybe<Coupons_Validityrule>;
  /** fetch data from the table: "django_admin_log" */
  django_admin_log: Array<Django_Admin_Log>;
  /** fetch aggregated fields from the table: "django_admin_log" */
  django_admin_log_aggregate: Django_Admin_Log_Aggregate;
  /** fetch data from the table: "django_admin_log" using primary key columns */
  django_admin_log_by_pk?: Maybe<Django_Admin_Log>;
  /** fetch data from the table: "django_content_type" */
  django_content_type: Array<Django_Content_Type>;
  /** fetch aggregated fields from the table: "django_content_type" */
  django_content_type_aggregate: Django_Content_Type_Aggregate;
  /** fetch data from the table: "django_content_type" using primary key columns */
  django_content_type_by_pk?: Maybe<Django_Content_Type>;
  /** fetch data from the table: "django_migrations" */
  django_migrations: Array<Django_Migrations>;
  /** fetch aggregated fields from the table: "django_migrations" */
  django_migrations_aggregate: Django_Migrations_Aggregate;
  /** fetch data from the table: "django_migrations" using primary key columns */
  django_migrations_by_pk?: Maybe<Django_Migrations>;
  /** fetch data from the table: "django_session" */
  django_session: Array<Django_Session>;
  /** fetch aggregated fields from the table: "django_session" */
  django_session_aggregate: Django_Session_Aggregate;
  /** fetch data from the table: "django_session" using primary key columns */
  django_session_by_pk?: Maybe<Django_Session>;
  /** fetch data from the table: "django_site" */
  django_site: Array<Django_Site>;
  /** fetch aggregated fields from the table: "django_site" */
  django_site_aggregate: Django_Site_Aggregate;
  /** fetch data from the table: "django_site" using primary key columns */
  django_site_by_pk?: Maybe<Django_Site>;
  /** fetch data from the table: "djconfig_config" */
  djconfig_config: Array<Djconfig_Config>;
  /** fetch aggregated fields from the table: "djconfig_config" */
  djconfig_config_aggregate: Djconfig_Config_Aggregate;
  /** fetch data from the table: "djconfig_config" using primary key columns */
  djconfig_config_by_pk?: Maybe<Djconfig_Config>;
  downloadUserQuizSummaries: GenericResponse;
  downloadUsersData: GenericResponse;
  getAllUsers?: Maybe<Array<Users>>;
  getCatApplicationData: GetCatApplicationDataResponse;
  getChannelInfo: ChannelInfoResponse;
  getChannelMembers: ChannelMembersResponse;
  getCompeteMarksVsPercentile: Array<TimedTestPercentile>;
  getCompeteTop10Scores: Array<TimedTestScore>;
  getLiveQuizDomains: LiveQuizDomainsResponse;
  getMe: UserResponse;
  getPlannerCompeteDomains: GenericResponse;
  getPlannerLessonDomains: GenericResponse;
  getPlannerPracticeDomains: GenericResponse;
  getPlannerSpeedConceptDomains: GenericResponse;
  getQuizLeaderboard: Array<LeaderboardEntry>;
  getTimedTestDetails: Scalars['String']['output'];
  getUserCustomEvents: GenericResponse;
  getUserPlannedActivities: GenericResponse;
  getVideoOTPForLesson: VideoCipherOtpPayload;
  getVideoOTPForQuestion: VideoCipherOtpPayload;
  getXpLeaderBoard: XpLeaderBoardResponse;
  /** execute function "get_random_question" which returns "quiz_quiz_questions" */
  get_random_question?: Maybe<Quiz_Quiz_Questions>;
  /** execute function "get_random_question" and query aggregates on result of table type "quiz_quiz_questions" */
  get_random_question_aggregate: Quiz_Quiz_Questions_Aggregate;
  /** execute function "get_speed_concepts_all_random_questions" which returns "quiz_quiz_questions" */
  get_speed_concepts_all_random_questions: Array<Quiz_Quiz_Questions>;
  /** execute function "get_speed_concepts_all_random_questions" and query aggregates on result of table type "quiz_quiz_questions" */
  get_speed_concepts_all_random_questions_aggregate: Quiz_Quiz_Questions_Aggregate;
  /** execute function "get_speed_concepts_random_question" which returns "quiz_quiz_questions" */
  get_speed_concepts_random_question?: Maybe<Quiz_Quiz_Questions>;
  /** execute function "get_speed_concepts_random_question" and query aggregates on result of table type "quiz_quiz_questions" */
  get_speed_concepts_random_question_aggregate: Quiz_Quiz_Questions_Aggregate;
  googleLogin: GenericResponse;
  /** fetch data from the table: "group_category" */
  group_category: Array<Group_Category>;
  /** fetch aggregated fields from the table: "group_category" */
  group_category_aggregate: Group_Category_Aggregate;
  /** fetch data from the table: "group_category" using primary key columns */
  group_category_by_pk?: Maybe<Group_Category>;
  /** fetch data from the table: "group_discount_users" */
  group_discount_users: Array<Group_Discount_Users>;
  /** fetch aggregated fields from the table: "group_discount_users" */
  group_discount_users_aggregate: Group_Discount_Users_Aggregate;
  /** fetch data from the table: "has_access" */
  has_access: Array<Has_Access>;
  /** fetch aggregated fields from the table: "has_access" */
  has_access_aggregate: Has_Access_Aggregate;
  /** fetch data from the table: "infozone_category" */
  infozone_category: Array<Infozone_Category>;
  /** fetch aggregated fields from the table: "infozone_category" */
  infozone_category_aggregate: Infozone_Category_Aggregate;
  /** fetch data from the table: "infozone_category" using primary key columns */
  infozone_category_by_pk?: Maybe<Infozone_Category>;
  /** fetch data from the table: "infozone_infozone" */
  infozone_infozone: Array<Infozone_Infozone>;
  /** fetch aggregated fields from the table: "infozone_infozone" */
  infozone_infozone_aggregate: Infozone_Infozone_Aggregate;
  /** fetch data from the table: "infozone_infozone" using primary key columns */
  infozone_infozone_by_pk?: Maybe<Infozone_Infozone>;
  /** fetch data from the table: "infozone_staticpages" */
  infozone_staticpages: Array<Infozone_Staticpages>;
  /** fetch aggregated fields from the table: "infozone_staticpages" */
  infozone_staticpages_aggregate: Infozone_Staticpages_Aggregate;
  /** fetch data from the table: "infozone_staticpages" using primary key columns */
  infozone_staticpages_by_pk?: Maybe<Infozone_Staticpages>;
  /** fetch data from the table: "live_quiz_leaderboard" */
  live_quiz_leaderboard: Array<Live_Quiz_Leaderboard>;
  /** fetch aggregated fields from the table: "live_quiz_leaderboard" */
  live_quiz_leaderboard_aggregate: Live_Quiz_Leaderboard_Aggregate;
  /** fetch data from the table: "live_quiz_leaderboard" using primary key columns */
  live_quiz_leaderboard_by_pk?: Maybe<Live_Quiz_Leaderboard>;
  /** An array relationship */
  live_quiz_question_positions: Array<Live_Quiz_Question_Positions>;
  /** An aggregate relationship */
  live_quiz_question_positions_aggregate: Live_Quiz_Question_Positions_Aggregate;
  /** fetch data from the table: "live_quiz_question_positions" using primary key columns */
  live_quiz_question_positions_by_pk?: Maybe<Live_Quiz_Question_Positions>;
  /** fetch data from the table: "live_quiz_question_summary" */
  live_quiz_question_summary: Array<Live_Quiz_Question_Summary>;
  /** fetch aggregated fields from the table: "live_quiz_question_summary" */
  live_quiz_question_summary_aggregate: Live_Quiz_Question_Summary_Aggregate;
  /** fetch data from the table: "live_quiz_question_summary" using primary key columns */
  live_quiz_question_summary_by_pk?: Maybe<Live_Quiz_Question_Summary>;
  /** fetch data from the table: "live_quiz_summary" */
  live_quiz_summary: Array<Live_Quiz_Summary>;
  /** fetch aggregated fields from the table: "live_quiz_summary" */
  live_quiz_summary_aggregate: Live_Quiz_Summary_Aggregate;
  /** fetch data from the table: "live_quiz_summary" using primary key columns */
  live_quiz_summary_by_pk?: Maybe<Live_Quiz_Summary>;
  logout: GenericResponse;
  /** fetch data from the table: "marks_vs_percentile_dilr" */
  marks_vs_percentile_dilr: Array<Marks_Vs_Percentile_Dilr>;
  /** fetch aggregated fields from the table: "marks_vs_percentile_dilr" */
  marks_vs_percentile_dilr_aggregate: Marks_Vs_Percentile_Dilr_Aggregate;
  /** fetch data from the table: "marks_vs_percentile_dilr" using primary key columns */
  marks_vs_percentile_dilr_by_pk?: Maybe<Marks_Vs_Percentile_Dilr>;
  /** fetch data from the table: "marks_vs_percentile_quant" */
  marks_vs_percentile_quant: Array<Marks_Vs_Percentile_Quant>;
  /** fetch aggregated fields from the table: "marks_vs_percentile_quant" */
  marks_vs_percentile_quant_aggregate: Marks_Vs_Percentile_Quant_Aggregate;
  /** fetch data from the table: "marks_vs_percentile_quant" using primary key columns */
  marks_vs_percentile_quant_by_pk?: Maybe<Marks_Vs_Percentile_Quant>;
  /** fetch data from the table: "marks_vs_percentile_total_raw" */
  marks_vs_percentile_total_raw: Array<Marks_Vs_Percentile_Total_Raw>;
  /** fetch aggregated fields from the table: "marks_vs_percentile_total_raw" */
  marks_vs_percentile_total_raw_aggregate: Marks_Vs_Percentile_Total_Raw_Aggregate;
  /** fetch data from the table: "marks_vs_percentile_total_raw" using primary key columns */
  marks_vs_percentile_total_raw_by_pk?: Maybe<Marks_Vs_Percentile_Total_Raw>;
  /** fetch data from the table: "marks_vs_percentile_varc" */
  marks_vs_percentile_varc: Array<Marks_Vs_Percentile_Varc>;
  /** fetch aggregated fields from the table: "marks_vs_percentile_varc" */
  marks_vs_percentile_varc_aggregate: Marks_Vs_Percentile_Varc_Aggregate;
  /** fetch data from the table: "marks_vs_percentile_varc" using primary key columns */
  marks_vs_percentile_varc_by_pk?: Maybe<Marks_Vs_Percentile_Varc>;
  /** fetch data from the table: "marks_vs_scaled_percentile" */
  marks_vs_scaled_percentile: Array<Marks_Vs_Scaled_Percentile>;
  /** fetch aggregated fields from the table: "marks_vs_scaled_percentile" */
  marks_vs_scaled_percentile_aggregate: Marks_Vs_Scaled_Percentile_Aggregate;
  /** fetch data from the table: "marks_vs_scaled_percentile" using primary key columns */
  marks_vs_scaled_percentile_by_pk?: Maybe<Marks_Vs_Scaled_Percentile>;
  me: Users;
  /** An array relationship */
  meeting_members: Array<Meeting_Members>;
  /** An aggregate relationship */
  meeting_members_aggregate: Meeting_Members_Aggregate;
  /** fetch data from the table: "meeting_members" using primary key columns */
  meeting_members_by_pk?: Maybe<Meeting_Members>;
  /** fetch data from the table: "meetings" */
  meetings: Array<Meetings>;
  /** fetch aggregated fields from the table: "meetings" */
  meetings_aggregate: Meetings_Aggregate;
  /** fetch data from the table: "meetings" using primary key columns */
  meetings_by_pk?: Maybe<Meetings>;
  /** fetch data from the table: "message_reactions" */
  message_reactions: Array<Message_Reactions>;
  /** fetch aggregated fields from the table: "message_reactions" */
  message_reactions_aggregate: Message_Reactions_Aggregate;
  /** fetch data from the table: "message_reactions" using primary key columns */
  message_reactions_by_pk?: Maybe<Message_Reactions>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  /** fetch data from the table: "messages_read" */
  messages_read: Array<Messages_Read>;
  /** fetch aggregated fields from the table: "messages_read" */
  messages_read_aggregate: Messages_Read_Aggregate;
  /** fetch data from the table: "messages_read" using primary key columns */
  messages_read_by_pk?: Maybe<Messages_Read>;
  /** fetch data from the table: "offline_leads" */
  offline_leads: Array<Offline_Leads>;
  /** fetch aggregated fields from the table: "offline_leads" */
  offline_leads_aggregate: Offline_Leads_Aggregate;
  /** fetch data from the table: "offline_leads" using primary key columns */
  offline_leads_by_pk?: Maybe<Offline_Leads>;
  /** An array relationship */
  package_content_discarded_quizzes: Array<Package_Content_Discarded_Quizzes>;
  /** An aggregate relationship */
  package_content_discarded_quizzes_aggregate: Package_Content_Discarded_Quizzes_Aggregate;
  /** fetch data from the table: "package_content_discarded_quizzes" using primary key columns */
  package_content_discarded_quizzes_by_pk?: Maybe<Package_Content_Discarded_Quizzes>;
  /** fetch data from the table: "packages_content" */
  packages_content: Array<Packages_Content>;
  /** fetch aggregated fields from the table: "packages_content" */
  packages_content_aggregate: Packages_Content_Aggregate;
  /** fetch data from the table: "packages_content" using primary key columns */
  packages_content_by_pk?: Maybe<Packages_Content>;
  /** An array relationship */
  packages_content_domains: Array<Packages_Content_Domains>;
  /** An aggregate relationship */
  packages_content_domains_aggregate: Packages_Content_Domains_Aggregate;
  /** fetch data from the table: "packages_content_domains" using primary key columns */
  packages_content_domains_by_pk?: Maybe<Packages_Content_Domains>;
  /** fetch data from the table: "packages_content_text_lesson" */
  packages_content_text_lesson: Array<Packages_Content_Text_Lesson>;
  /** fetch aggregated fields from the table: "packages_content_text_lesson" */
  packages_content_text_lesson_aggregate: Packages_Content_Text_Lesson_Aggregate;
  /** fetch data from the table: "packages_content_text_lesson" using primary key columns */
  packages_content_text_lesson_by_pk?: Maybe<Packages_Content_Text_Lesson>;
  /** fetch data from the table: "packages_content_timed_test" */
  packages_content_timed_test: Array<Packages_Content_Timed_Test>;
  /** fetch aggregated fields from the table: "packages_content_timed_test" */
  packages_content_timed_test_aggregate: Packages_Content_Timed_Test_Aggregate;
  /** fetch data from the table: "packages_content_timed_test" using primary key columns */
  packages_content_timed_test_by_pk?: Maybe<Packages_Content_Timed_Test>;
  /** fetch data from the table: "packages_content_untimed_test" */
  packages_content_untimed_test: Array<Packages_Content_Untimed_Test>;
  /** fetch aggregated fields from the table: "packages_content_untimed_test" */
  packages_content_untimed_test_aggregate: Packages_Content_Untimed_Test_Aggregate;
  /** fetch data from the table: "packages_content_untimed_test" using primary key columns */
  packages_content_untimed_test_by_pk?: Maybe<Packages_Content_Untimed_Test>;
  /** fetch data from the table: "packages_payment_transaction" */
  packages_payment_transaction: Array<Packages_Payment_Transaction>;
  /** fetch aggregated fields from the table: "packages_payment_transaction" */
  packages_payment_transaction_aggregate: Packages_Payment_Transaction_Aggregate;
  /** fetch data from the table: "packages_payment_transaction" using primary key columns */
  packages_payment_transaction_by_pk?: Maybe<Packages_Payment_Transaction>;
  /** fetch data from the table: "packages_paymenttransaction" */
  packages_paymenttransaction: Array<Packages_Paymenttransaction>;
  /** fetch aggregated fields from the table: "packages_paymenttransaction" */
  packages_paymenttransaction_aggregate: Packages_Paymenttransaction_Aggregate;
  /** fetch data from the table: "packages_paymenttransaction" using primary key columns */
  packages_paymenttransaction_by_pk?: Maybe<Packages_Paymenttransaction>;
  ping: Scalars['String']['output'];
  /** fetch data from the table: "poll" */
  poll: Array<Poll>;
  /** fetch aggregated fields from the table: "poll" */
  poll_aggregate: Poll_Aggregate;
  /** fetch data from the table: "poll" using primary key columns */
  poll_by_pk?: Maybe<Poll>;
  /** fetch data from the table: "poll_options" */
  poll_options: Array<Poll_Options>;
  /** fetch aggregated fields from the table: "poll_options" */
  poll_options_aggregate: Poll_Options_Aggregate;
  /** fetch data from the table: "poll_options" using primary key columns */
  poll_options_by_pk?: Maybe<Poll_Options>;
  /** An array relationship */
  poll_responses: Array<Poll_Responses>;
  /** An aggregate relationship */
  poll_responses_aggregate: Poll_Responses_Aggregate;
  /** fetch data from the table: "poll_responses" using primary key columns */
  poll_responses_by_pk?: Maybe<Poll_Responses>;
  /** An array relationship */
  question_reports: Array<Question_Reports>;
  /** An aggregate relationship */
  question_reports_aggregate: Question_Reports_Aggregate;
  /** fetch data from the table: "question_reports" using primary key columns */
  question_reports_by_pk?: Maybe<Question_Reports>;
  /** fetch data from the table: "quiz_answer" */
  quiz_answer: Array<Quiz_Answer>;
  /** fetch aggregated fields from the table: "quiz_answer" */
  quiz_answer_aggregate: Quiz_Answer_Aggregate;
  /** fetch data from the table: "quiz_answer" using primary key columns */
  quiz_answer_by_pk?: Maybe<Quiz_Answer>;
  /** fetch data from the table: "quiz_category" */
  quiz_category: Array<Quiz_Category>;
  /** fetch aggregated fields from the table: "quiz_category" */
  quiz_category_aggregate: Quiz_Category_Aggregate;
  /** fetch data from the table: "quiz_category" using primary key columns */
  quiz_category_by_pk?: Maybe<Quiz_Category>;
  /** fetch data from the table: "quiz_domain" */
  quiz_domain: Array<Quiz_Domain>;
  /** fetch aggregated fields from the table: "quiz_domain" */
  quiz_domain_aggregate: Quiz_Domain_Aggregate;
  /** fetch data from the table: "quiz_domain" using primary key columns */
  quiz_domain_by_pk?: Maybe<Quiz_Domain>;
  /** fetch data from the table: "quiz_markingsystem" */
  quiz_markingsystem: Array<Quiz_Markingsystem>;
  /** fetch aggregated fields from the table: "quiz_markingsystem" */
  quiz_markingsystem_aggregate: Quiz_Markingsystem_Aggregate;
  /** fetch data from the table: "quiz_markingsystem" using primary key columns */
  quiz_markingsystem_by_pk?: Maybe<Quiz_Markingsystem>;
  /** fetch data from the table: "quiz_option" */
  quiz_option: Array<Quiz_Option>;
  /** fetch aggregated fields from the table: "quiz_option" */
  quiz_option_aggregate: Quiz_Option_Aggregate;
  /** fetch data from the table: "quiz_option" using primary key columns */
  quiz_option_by_pk?: Maybe<Quiz_Option>;
  /** fetch data from the table: "quiz_paragraph" */
  quiz_paragraph: Array<Quiz_Paragraph>;
  /** fetch aggregated fields from the table: "quiz_paragraph" */
  quiz_paragraph_aggregate: Quiz_Paragraph_Aggregate;
  /** fetch data from the table: "quiz_paragraph" using primary key columns */
  quiz_paragraph_by_pk?: Maybe<Quiz_Paragraph>;
  /** fetch data from the table: "quiz_question" */
  quiz_question: Array<Quiz_Question>;
  /** fetch aggregated fields from the table: "quiz_question" */
  quiz_question_aggregate: Quiz_Question_Aggregate;
  /** fetch data from the table: "quiz_question" using primary key columns */
  quiz_question_by_pk?: Maybe<Quiz_Question>;
  /** fetch data from the table: "quiz_quiz" */
  quiz_quiz: Array<Quiz_Quiz>;
  /** fetch aggregated fields from the table: "quiz_quiz" */
  quiz_quiz_aggregate: Quiz_Quiz_Aggregate;
  /** fetch data from the table: "quiz_quiz" using primary key columns */
  quiz_quiz_by_pk?: Maybe<Quiz_Quiz>;
  /** An array relationship */
  quiz_quiz_questions: Array<Quiz_Quiz_Questions>;
  /** An aggregate relationship */
  quiz_quiz_questions_aggregate: Quiz_Quiz_Questions_Aggregate;
  /** fetch data from the table: "quiz_quiz_questions" using primary key columns */
  quiz_quiz_questions_by_pk?: Maybe<Quiz_Quiz_Questions>;
  /** An array relationship */
  quiz_quiz_sections: Array<Quiz_Quiz_Sections>;
  /** An aggregate relationship */
  quiz_quiz_sections_aggregate: Quiz_Quiz_Sections_Aggregate;
  /** fetch data from the table: "quiz_quiz_sections" using primary key columns */
  quiz_quiz_sections_by_pk?: Maybe<Quiz_Quiz_Sections>;
  /** fetch data from the table: "quiz_section" */
  quiz_section: Array<Quiz_Section>;
  /** fetch aggregated fields from the table: "quiz_section" */
  quiz_section_aggregate: Quiz_Section_Aggregate;
  /** fetch data from the table: "quiz_section" using primary key columns */
  quiz_section_by_pk?: Maybe<Quiz_Section>;
  /** An array relationship */
  quiz_section_questions: Array<Quiz_Section_Questions>;
  /** An aggregate relationship */
  quiz_section_questions_aggregate: Quiz_Section_Questions_Aggregate;
  /** fetch data from the table: "quiz_section_questions" using primary key columns */
  quiz_section_questions_by_pk?: Maybe<Quiz_Section_Questions>;
  /** An array relationship */
  quiz_section_subsections: Array<Quiz_Section_Subsections>;
  /** An aggregate relationship */
  quiz_section_subsections_aggregate: Quiz_Section_Subsections_Aggregate;
  /** fetch data from the table: "quiz_section_subsections" using primary key columns */
  quiz_section_subsections_by_pk?: Maybe<Quiz_Section_Subsections>;
  /** fetch data from the table: "quiz_superdomain" */
  quiz_superdomain: Array<Quiz_Superdomain>;
  /** fetch aggregated fields from the table: "quiz_superdomain" */
  quiz_superdomain_aggregate: Quiz_Superdomain_Aggregate;
  /** fetch data from the table: "quiz_superdomain" using primary key columns */
  quiz_superdomain_by_pk?: Maybe<Quiz_Superdomain>;
  /** fetch data from the table: "random_question_ids" */
  random_question_ids: Array<Random_Question_Ids>;
  /** fetch aggregated fields from the table: "random_question_ids" */
  random_question_ids_aggregate: Random_Question_Ids_Aggregate;
  /** fetch data from the table: "reaction_emojis" */
  reaction_emojis: Array<Reaction_Emojis>;
  /** fetch aggregated fields from the table: "reaction_emojis" */
  reaction_emojis_aggregate: Reaction_Emojis_Aggregate;
  /** fetch data from the table: "reaction_emojis" using primary key columns */
  reaction_emojis_by_pk?: Maybe<Reaction_Emojis>;
  /** fetch data from the table: "reported_message" */
  reported_message: Array<Reported_Message>;
  /** fetch aggregated fields from the table: "reported_message" */
  reported_message_aggregate: Reported_Message_Aggregate;
  /** fetch data from the table: "reported_message" using primary key columns */
  reported_message_by_pk?: Maybe<Reported_Message>;
  /** fetch data from the table: "scaling_constant" */
  scaling_constant: Array<Scaling_Constant>;
  /** fetch aggregated fields from the table: "scaling_constant" */
  scaling_constant_aggregate: Scaling_Constant_Aggregate;
  /** fetch data from the table: "scaling_constant" using primary key columns */
  scaling_constant_by_pk?: Maybe<Scaling_Constant>;
  /** fetch data from the table: "socialaccount_socialaccount" */
  socialaccount_socialaccount: Array<Socialaccount_Socialaccount>;
  /** fetch aggregated fields from the table: "socialaccount_socialaccount" */
  socialaccount_socialaccount_aggregate: Socialaccount_Socialaccount_Aggregate;
  /** fetch data from the table: "socialaccount_socialaccount" using primary key columns */
  socialaccount_socialaccount_by_pk?: Maybe<Socialaccount_Socialaccount>;
  /** fetch data from the table: "socialaccount_socialapp" */
  socialaccount_socialapp: Array<Socialaccount_Socialapp>;
  /** fetch aggregated fields from the table: "socialaccount_socialapp" */
  socialaccount_socialapp_aggregate: Socialaccount_Socialapp_Aggregate;
  /** fetch data from the table: "socialaccount_socialapp" using primary key columns */
  socialaccount_socialapp_by_pk?: Maybe<Socialaccount_Socialapp>;
  /** An array relationship */
  socialaccount_socialapp_sites: Array<Socialaccount_Socialapp_Sites>;
  /** An aggregate relationship */
  socialaccount_socialapp_sites_aggregate: Socialaccount_Socialapp_Sites_Aggregate;
  /** fetch data from the table: "socialaccount_socialapp_sites" using primary key columns */
  socialaccount_socialapp_sites_by_pk?: Maybe<Socialaccount_Socialapp_Sites>;
  /** fetch data from the table: "socialaccount_socialtoken" */
  socialaccount_socialtoken: Array<Socialaccount_Socialtoken>;
  /** fetch aggregated fields from the table: "socialaccount_socialtoken" */
  socialaccount_socialtoken_aggregate: Socialaccount_Socialtoken_Aggregate;
  /** fetch data from the table: "socialaccount_socialtoken" using primary key columns */
  socialaccount_socialtoken_by_pk?: Maybe<Socialaccount_Socialtoken>;
  /** fetch data from the table: "speed_test_category" */
  speed_test_category: Array<Speed_Test_Category>;
  /** fetch aggregated fields from the table: "speed_test_category" */
  speed_test_category_aggregate: Speed_Test_Category_Aggregate;
  /** fetch data from the table: "speed_test_category" using primary key columns */
  speed_test_category_by_pk?: Maybe<Speed_Test_Category>;
  /** An array relationship */
  speed_tests: Array<Speed_Tests>;
  /** An aggregate relationship */
  speed_tests_aggregate: Speed_Tests_Aggregate;
  /** fetch data from the table: "speed_tests" using primary key columns */
  speed_tests_by_pk?: Maybe<Speed_Tests>;
  /** fetch data from the table: "spirit_cache" */
  spirit_cache: Array<Spirit_Cache>;
  /** fetch aggregated fields from the table: "spirit_cache" */
  spirit_cache_aggregate: Spirit_Cache_Aggregate;
  /** fetch data from the table: "spirit_cache" using primary key columns */
  spirit_cache_by_pk?: Maybe<Spirit_Cache>;
  /** fetch data from the table: "spirit_category_category" */
  spirit_category_category: Array<Spirit_Category_Category>;
  /** fetch aggregated fields from the table: "spirit_category_category" */
  spirit_category_category_aggregate: Spirit_Category_Category_Aggregate;
  /** fetch data from the table: "spirit_category_category" using primary key columns */
  spirit_category_category_by_pk?: Maybe<Spirit_Category_Category>;
  /** fetch data from the table: "spirit_comment_bookmark_commentbookmark" */
  spirit_comment_bookmark_commentbookmark: Array<Spirit_Comment_Bookmark_Commentbookmark>;
  /** fetch aggregated fields from the table: "spirit_comment_bookmark_commentbookmark" */
  spirit_comment_bookmark_commentbookmark_aggregate: Spirit_Comment_Bookmark_Commentbookmark_Aggregate;
  /** fetch data from the table: "spirit_comment_bookmark_commentbookmark" using primary key columns */
  spirit_comment_bookmark_commentbookmark_by_pk?: Maybe<Spirit_Comment_Bookmark_Commentbookmark>;
  /** fetch data from the table: "spirit_comment_comment" */
  spirit_comment_comment: Array<Spirit_Comment_Comment>;
  /** fetch aggregated fields from the table: "spirit_comment_comment" */
  spirit_comment_comment_aggregate: Spirit_Comment_Comment_Aggregate;
  /** fetch data from the table: "spirit_comment_comment" using primary key columns */
  spirit_comment_comment_by_pk?: Maybe<Spirit_Comment_Comment>;
  /** fetch data from the table: "spirit_comment_flag_commentflag" */
  spirit_comment_flag_commentflag: Array<Spirit_Comment_Flag_Commentflag>;
  /** fetch aggregated fields from the table: "spirit_comment_flag_commentflag" */
  spirit_comment_flag_commentflag_aggregate: Spirit_Comment_Flag_Commentflag_Aggregate;
  /** fetch data from the table: "spirit_comment_flag_commentflag" using primary key columns */
  spirit_comment_flag_commentflag_by_pk?: Maybe<Spirit_Comment_Flag_Commentflag>;
  /** fetch data from the table: "spirit_comment_flag_flag" */
  spirit_comment_flag_flag: Array<Spirit_Comment_Flag_Flag>;
  /** fetch aggregated fields from the table: "spirit_comment_flag_flag" */
  spirit_comment_flag_flag_aggregate: Spirit_Comment_Flag_Flag_Aggregate;
  /** fetch data from the table: "spirit_comment_flag_flag" using primary key columns */
  spirit_comment_flag_flag_by_pk?: Maybe<Spirit_Comment_Flag_Flag>;
  /** fetch data from the table: "spirit_comment_history_commenthistory" */
  spirit_comment_history_commenthistory: Array<Spirit_Comment_History_Commenthistory>;
  /** fetch aggregated fields from the table: "spirit_comment_history_commenthistory" */
  spirit_comment_history_commenthistory_aggregate: Spirit_Comment_History_Commenthistory_Aggregate;
  /** fetch data from the table: "spirit_comment_history_commenthistory" using primary key columns */
  spirit_comment_history_commenthistory_by_pk?: Maybe<Spirit_Comment_History_Commenthistory>;
  /** fetch data from the table: "spirit_comment_like_commentlike" */
  spirit_comment_like_commentlike: Array<Spirit_Comment_Like_Commentlike>;
  /** fetch aggregated fields from the table: "spirit_comment_like_commentlike" */
  spirit_comment_like_commentlike_aggregate: Spirit_Comment_Like_Commentlike_Aggregate;
  /** fetch data from the table: "spirit_comment_like_commentlike" using primary key columns */
  spirit_comment_like_commentlike_by_pk?: Maybe<Spirit_Comment_Like_Commentlike>;
  /** fetch data from the table: "spirit_comment_poll_commentpoll" */
  spirit_comment_poll_commentpoll: Array<Spirit_Comment_Poll_Commentpoll>;
  /** fetch aggregated fields from the table: "spirit_comment_poll_commentpoll" */
  spirit_comment_poll_commentpoll_aggregate: Spirit_Comment_Poll_Commentpoll_Aggregate;
  /** fetch data from the table: "spirit_comment_poll_commentpoll" using primary key columns */
  spirit_comment_poll_commentpoll_by_pk?: Maybe<Spirit_Comment_Poll_Commentpoll>;
  /** fetch data from the table: "spirit_comment_poll_commentpollchoice" */
  spirit_comment_poll_commentpollchoice: Array<Spirit_Comment_Poll_Commentpollchoice>;
  /** fetch aggregated fields from the table: "spirit_comment_poll_commentpollchoice" */
  spirit_comment_poll_commentpollchoice_aggregate: Spirit_Comment_Poll_Commentpollchoice_Aggregate;
  /** fetch data from the table: "spirit_comment_poll_commentpollchoice" using primary key columns */
  spirit_comment_poll_commentpollchoice_by_pk?: Maybe<Spirit_Comment_Poll_Commentpollchoice>;
  /** fetch data from the table: "spirit_comment_poll_commentpollvote" */
  spirit_comment_poll_commentpollvote: Array<Spirit_Comment_Poll_Commentpollvote>;
  /** fetch aggregated fields from the table: "spirit_comment_poll_commentpollvote" */
  spirit_comment_poll_commentpollvote_aggregate: Spirit_Comment_Poll_Commentpollvote_Aggregate;
  /** fetch data from the table: "spirit_comment_poll_commentpollvote" using primary key columns */
  spirit_comment_poll_commentpollvote_by_pk?: Maybe<Spirit_Comment_Poll_Commentpollvote>;
  /** fetch data from the table: "spirit_rl_cache" */
  spirit_rl_cache: Array<Spirit_Rl_Cache>;
  /** fetch aggregated fields from the table: "spirit_rl_cache" */
  spirit_rl_cache_aggregate: Spirit_Rl_Cache_Aggregate;
  /** fetch data from the table: "spirit_rl_cache" using primary key columns */
  spirit_rl_cache_by_pk?: Maybe<Spirit_Rl_Cache>;
  /** fetch data from the table: "spirit_topic_favorite_topicfavorite" */
  spirit_topic_favorite_topicfavorite: Array<Spirit_Topic_Favorite_Topicfavorite>;
  /** fetch aggregated fields from the table: "spirit_topic_favorite_topicfavorite" */
  spirit_topic_favorite_topicfavorite_aggregate: Spirit_Topic_Favorite_Topicfavorite_Aggregate;
  /** fetch data from the table: "spirit_topic_favorite_topicfavorite" using primary key columns */
  spirit_topic_favorite_topicfavorite_by_pk?: Maybe<Spirit_Topic_Favorite_Topicfavorite>;
  /** fetch data from the table: "spirit_topic_notification_topicnotification" */
  spirit_topic_notification_topicnotification: Array<Spirit_Topic_Notification_Topicnotification>;
  /** fetch aggregated fields from the table: "spirit_topic_notification_topicnotification" */
  spirit_topic_notification_topicnotification_aggregate: Spirit_Topic_Notification_Topicnotification_Aggregate;
  /** fetch data from the table: "spirit_topic_notification_topicnotification" using primary key columns */
  spirit_topic_notification_topicnotification_by_pk?: Maybe<Spirit_Topic_Notification_Topicnotification>;
  /** fetch data from the table: "spirit_topic_private_topicprivate" */
  spirit_topic_private_topicprivate: Array<Spirit_Topic_Private_Topicprivate>;
  /** fetch aggregated fields from the table: "spirit_topic_private_topicprivate" */
  spirit_topic_private_topicprivate_aggregate: Spirit_Topic_Private_Topicprivate_Aggregate;
  /** fetch data from the table: "spirit_topic_private_topicprivate" using primary key columns */
  spirit_topic_private_topicprivate_by_pk?: Maybe<Spirit_Topic_Private_Topicprivate>;
  /** fetch data from the table: "spirit_topic_topic" */
  spirit_topic_topic: Array<Spirit_Topic_Topic>;
  /** fetch aggregated fields from the table: "spirit_topic_topic" */
  spirit_topic_topic_aggregate: Spirit_Topic_Topic_Aggregate;
  /** fetch data from the table: "spirit_topic_topic" using primary key columns */
  spirit_topic_topic_by_pk?: Maybe<Spirit_Topic_Topic>;
  /** fetch data from the table: "spirit_topic_unread_topicunread" */
  spirit_topic_unread_topicunread: Array<Spirit_Topic_Unread_Topicunread>;
  /** fetch aggregated fields from the table: "spirit_topic_unread_topicunread" */
  spirit_topic_unread_topicunread_aggregate: Spirit_Topic_Unread_Topicunread_Aggregate;
  /** fetch data from the table: "spirit_topic_unread_topicunread" using primary key columns */
  spirit_topic_unread_topicunread_by_pk?: Maybe<Spirit_Topic_Unread_Topicunread>;
  /** fetch data from the table: "spirit_user_userprofile" */
  spirit_user_userprofile: Array<Spirit_User_Userprofile>;
  /** fetch aggregated fields from the table: "spirit_user_userprofile" */
  spirit_user_userprofile_aggregate: Spirit_User_Userprofile_Aggregate;
  /** fetch data from the table: "spirit_user_userprofile" using primary key columns */
  spirit_user_userprofile_by_pk?: Maybe<Spirit_User_Userprofile>;
  /** fetch data from the table: "subscription_group_plan" */
  subscription_group_plan: Array<Subscription_Group_Plan>;
  /** fetch aggregated fields from the table: "subscription_group_plan" */
  subscription_group_plan_aggregate: Subscription_Group_Plan_Aggregate;
  /** fetch data from the table: "subscription_group_plan" using primary key columns */
  subscription_group_plan_by_pk?: Maybe<Subscription_Group_Plan>;
  /** An array relationship */
  subscription_group_plan_groups: Array<Subscription_Group_Plan_Groups>;
  /** An aggregate relationship */
  subscription_group_plan_groups_aggregate: Subscription_Group_Plan_Groups_Aggregate;
  /** fetch data from the table: "subscription_group_plan_groups" using primary key columns */
  subscription_group_plan_groups_by_pk?: Maybe<Subscription_Group_Plan_Groups>;
  /** fetch data from the table: "subscriptions_plancost" */
  subscriptions_plancost: Array<Subscriptions_Plancost>;
  /** fetch aggregated fields from the table: "subscriptions_plancost" */
  subscriptions_plancost_aggregate: Subscriptions_Plancost_Aggregate;
  /** fetch data from the table: "subscriptions_plancost" using primary key columns */
  subscriptions_plancost_by_pk?: Maybe<Subscriptions_Plancost>;
  /** fetch data from the table: "subscriptions_planlist" */
  subscriptions_planlist: Array<Subscriptions_Planlist>;
  /** fetch aggregated fields from the table: "subscriptions_planlist" */
  subscriptions_planlist_aggregate: Subscriptions_Planlist_Aggregate;
  /** fetch data from the table: "subscriptions_planlist" using primary key columns */
  subscriptions_planlist_by_pk?: Maybe<Subscriptions_Planlist>;
  /** fetch data from the table: "subscriptions_planlistdetail" */
  subscriptions_planlistdetail: Array<Subscriptions_Planlistdetail>;
  /** fetch aggregated fields from the table: "subscriptions_planlistdetail" */
  subscriptions_planlistdetail_aggregate: Subscriptions_Planlistdetail_Aggregate;
  /** fetch data from the table: "subscriptions_planlistdetail" using primary key columns */
  subscriptions_planlistdetail_by_pk?: Maybe<Subscriptions_Planlistdetail>;
  /** fetch data from the table: "subscriptions_plantag" */
  subscriptions_plantag: Array<Subscriptions_Plantag>;
  /** fetch aggregated fields from the table: "subscriptions_plantag" */
  subscriptions_plantag_aggregate: Subscriptions_Plantag_Aggregate;
  /** fetch data from the table: "subscriptions_plantag" using primary key columns */
  subscriptions_plantag_by_pk?: Maybe<Subscriptions_Plantag>;
  /** fetch data from the table: "subscriptions_subscriptionplan" */
  subscriptions_subscriptionplan: Array<Subscriptions_Subscriptionplan>;
  /** fetch aggregated fields from the table: "subscriptions_subscriptionplan" */
  subscriptions_subscriptionplan_aggregate: Subscriptions_Subscriptionplan_Aggregate;
  /** fetch data from the table: "subscriptions_subscriptionplan" using primary key columns */
  subscriptions_subscriptionplan_by_pk?: Maybe<Subscriptions_Subscriptionplan>;
  /** An array relationship */
  subscriptions_subscriptionplan_upgradable_plans: Array<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** An aggregate relationship */
  subscriptions_subscriptionplan_upgradable_plans_aggregate: Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate;
  /** fetch data from the table: "subscriptions_subscriptionplan_upgradable_plans" using primary key columns */
  subscriptions_subscriptionplan_upgradable_plans_by_pk?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** fetch data from the table: "subscriptions_subscriptiontransaction" */
  subscriptions_subscriptiontransaction: Array<Subscriptions_Subscriptiontransaction>;
  /** fetch aggregated fields from the table: "subscriptions_subscriptiontransaction" */
  subscriptions_subscriptiontransaction_aggregate: Subscriptions_Subscriptiontransaction_Aggregate;
  /** fetch data from the table: "subscriptions_subscriptiontransaction" using primary key columns */
  subscriptions_subscriptiontransaction_by_pk?: Maybe<Subscriptions_Subscriptiontransaction>;
  /** fetch data from the table: "subscriptions_usersubscription" */
  subscriptions_usersubscription: Array<Subscriptions_Usersubscription>;
  /** fetch aggregated fields from the table: "subscriptions_usersubscription" */
  subscriptions_usersubscription_aggregate: Subscriptions_Usersubscription_Aggregate;
  /** fetch data from the table: "subscriptions_usersubscription" using primary key columns */
  subscriptions_usersubscription_by_pk?: Maybe<Subscriptions_Usersubscription>;
  /** fetch data from the table: "supertokens.all_auth_recipe_users" */
  supertokens_all_auth_recipe_users: Array<Supertokens_All_Auth_Recipe_Users>;
  /** fetch aggregated fields from the table: "supertokens.all_auth_recipe_users" */
  supertokens_all_auth_recipe_users_aggregate: Supertokens_All_Auth_Recipe_Users_Aggregate;
  /** fetch data from the table: "supertokens.all_auth_recipe_users" using primary key columns */
  supertokens_all_auth_recipe_users_by_pk?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  /** fetch data from the table: "supertokens.app_id_to_user_id" */
  supertokens_app_id_to_user_id: Array<Supertokens_App_Id_To_User_Id>;
  /** fetch aggregated fields from the table: "supertokens.app_id_to_user_id" */
  supertokens_app_id_to_user_id_aggregate: Supertokens_App_Id_To_User_Id_Aggregate;
  /** fetch data from the table: "supertokens.app_id_to_user_id" using primary key columns */
  supertokens_app_id_to_user_id_by_pk?: Maybe<Supertokens_App_Id_To_User_Id>;
  /** fetch data from the table: "supertokens.apps" */
  supertokens_apps: Array<Supertokens_Apps>;
  /** fetch aggregated fields from the table: "supertokens.apps" */
  supertokens_apps_aggregate: Supertokens_Apps_Aggregate;
  /** fetch data from the table: "supertokens.apps" using primary key columns */
  supertokens_apps_by_pk?: Maybe<Supertokens_Apps>;
  /** fetch data from the table: "supertokens.dashboard_user_sessions" */
  supertokens_dashboard_user_sessions: Array<Supertokens_Dashboard_User_Sessions>;
  /** fetch aggregated fields from the table: "supertokens.dashboard_user_sessions" */
  supertokens_dashboard_user_sessions_aggregate: Supertokens_Dashboard_User_Sessions_Aggregate;
  /** fetch data from the table: "supertokens.dashboard_user_sessions" using primary key columns */
  supertokens_dashboard_user_sessions_by_pk?: Maybe<Supertokens_Dashboard_User_Sessions>;
  /** fetch data from the table: "supertokens.dashboard_users" */
  supertokens_dashboard_users: Array<Supertokens_Dashboard_Users>;
  /** fetch aggregated fields from the table: "supertokens.dashboard_users" */
  supertokens_dashboard_users_aggregate: Supertokens_Dashboard_Users_Aggregate;
  /** fetch data from the table: "supertokens.dashboard_users" using primary key columns */
  supertokens_dashboard_users_by_pk?: Maybe<Supertokens_Dashboard_Users>;
  /** fetch data from the table: "supertokens.emailpassword_pswd_reset_tokens" */
  supertokens_emailpassword_pswd_reset_tokens: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
  /** fetch aggregated fields from the table: "supertokens.emailpassword_pswd_reset_tokens" */
  supertokens_emailpassword_pswd_reset_tokens_aggregate: Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate;
  /** fetch data from the table: "supertokens.emailpassword_pswd_reset_tokens" using primary key columns */
  supertokens_emailpassword_pswd_reset_tokens_by_pk?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
  /** fetch data from the table: "supertokens.emailpassword_user_to_tenant" */
  supertokens_emailpassword_user_to_tenant: Array<Supertokens_Emailpassword_User_To_Tenant>;
  /** fetch aggregated fields from the table: "supertokens.emailpassword_user_to_tenant" */
  supertokens_emailpassword_user_to_tenant_aggregate: Supertokens_Emailpassword_User_To_Tenant_Aggregate;
  /** fetch data from the table: "supertokens.emailpassword_user_to_tenant" using primary key columns */
  supertokens_emailpassword_user_to_tenant_by_pk?: Maybe<Supertokens_Emailpassword_User_To_Tenant>;
  /** fetch data from the table: "supertokens.emailpassword_users" */
  supertokens_emailpassword_users: Array<Supertokens_Emailpassword_Users>;
  /** fetch aggregated fields from the table: "supertokens.emailpassword_users" */
  supertokens_emailpassword_users_aggregate: Supertokens_Emailpassword_Users_Aggregate;
  /** fetch data from the table: "supertokens.emailpassword_users" using primary key columns */
  supertokens_emailpassword_users_by_pk?: Maybe<Supertokens_Emailpassword_Users>;
  /** fetch data from the table: "supertokens.emailverification_tokens" */
  supertokens_emailverification_tokens: Array<Supertokens_Emailverification_Tokens>;
  /** fetch aggregated fields from the table: "supertokens.emailverification_tokens" */
  supertokens_emailverification_tokens_aggregate: Supertokens_Emailverification_Tokens_Aggregate;
  /** fetch data from the table: "supertokens.emailverification_tokens" using primary key columns */
  supertokens_emailverification_tokens_by_pk?: Maybe<Supertokens_Emailverification_Tokens>;
  /** fetch data from the table: "supertokens.emailverification_verified_emails" */
  supertokens_emailverification_verified_emails: Array<Supertokens_Emailverification_Verified_Emails>;
  /** fetch aggregated fields from the table: "supertokens.emailverification_verified_emails" */
  supertokens_emailverification_verified_emails_aggregate: Supertokens_Emailverification_Verified_Emails_Aggregate;
  /** fetch data from the table: "supertokens.emailverification_verified_emails" using primary key columns */
  supertokens_emailverification_verified_emails_by_pk?: Maybe<Supertokens_Emailverification_Verified_Emails>;
  /** fetch data from the table: "supertokens.jwt_signing_keys" */
  supertokens_jwt_signing_keys: Array<Supertokens_Jwt_Signing_Keys>;
  /** fetch aggregated fields from the table: "supertokens.jwt_signing_keys" */
  supertokens_jwt_signing_keys_aggregate: Supertokens_Jwt_Signing_Keys_Aggregate;
  /** fetch data from the table: "supertokens.jwt_signing_keys" using primary key columns */
  supertokens_jwt_signing_keys_by_pk?: Maybe<Supertokens_Jwt_Signing_Keys>;
  /** fetch data from the table: "supertokens.key_value" */
  supertokens_key_value: Array<Supertokens_Key_Value>;
  /** fetch aggregated fields from the table: "supertokens.key_value" */
  supertokens_key_value_aggregate: Supertokens_Key_Value_Aggregate;
  /** fetch data from the table: "supertokens.key_value" using primary key columns */
  supertokens_key_value_by_pk?: Maybe<Supertokens_Key_Value>;
  /** fetch data from the table: "supertokens.passwordless_codes" */
  supertokens_passwordless_codes: Array<Supertokens_Passwordless_Codes>;
  /** fetch aggregated fields from the table: "supertokens.passwordless_codes" */
  supertokens_passwordless_codes_aggregate: Supertokens_Passwordless_Codes_Aggregate;
  /** fetch data from the table: "supertokens.passwordless_codes" using primary key columns */
  supertokens_passwordless_codes_by_pk?: Maybe<Supertokens_Passwordless_Codes>;
  /** fetch data from the table: "supertokens.passwordless_devices" */
  supertokens_passwordless_devices: Array<Supertokens_Passwordless_Devices>;
  /** fetch aggregated fields from the table: "supertokens.passwordless_devices" */
  supertokens_passwordless_devices_aggregate: Supertokens_Passwordless_Devices_Aggregate;
  /** fetch data from the table: "supertokens.passwordless_devices" using primary key columns */
  supertokens_passwordless_devices_by_pk?: Maybe<Supertokens_Passwordless_Devices>;
  /** fetch data from the table: "supertokens.passwordless_user_to_tenant" */
  supertokens_passwordless_user_to_tenant: Array<Supertokens_Passwordless_User_To_Tenant>;
  /** fetch aggregated fields from the table: "supertokens.passwordless_user_to_tenant" */
  supertokens_passwordless_user_to_tenant_aggregate: Supertokens_Passwordless_User_To_Tenant_Aggregate;
  /** fetch data from the table: "supertokens.passwordless_user_to_tenant" using primary key columns */
  supertokens_passwordless_user_to_tenant_by_pk?: Maybe<Supertokens_Passwordless_User_To_Tenant>;
  /** fetch data from the table: "supertokens.passwordless_users" */
  supertokens_passwordless_users: Array<Supertokens_Passwordless_Users>;
  /** fetch aggregated fields from the table: "supertokens.passwordless_users" */
  supertokens_passwordless_users_aggregate: Supertokens_Passwordless_Users_Aggregate;
  /** fetch data from the table: "supertokens.passwordless_users" using primary key columns */
  supertokens_passwordless_users_by_pk?: Maybe<Supertokens_Passwordless_Users>;
  /** fetch data from the table: "supertokens.role_permissions" */
  supertokens_role_permissions: Array<Supertokens_Role_Permissions>;
  /** fetch aggregated fields from the table: "supertokens.role_permissions" */
  supertokens_role_permissions_aggregate: Supertokens_Role_Permissions_Aggregate;
  /** fetch data from the table: "supertokens.role_permissions" using primary key columns */
  supertokens_role_permissions_by_pk?: Maybe<Supertokens_Role_Permissions>;
  /** fetch data from the table: "supertokens.roles" */
  supertokens_roles: Array<Supertokens_Roles>;
  /** fetch aggregated fields from the table: "supertokens.roles" */
  supertokens_roles_aggregate: Supertokens_Roles_Aggregate;
  /** fetch data from the table: "supertokens.roles" using primary key columns */
  supertokens_roles_by_pk?: Maybe<Supertokens_Roles>;
  /** fetch data from the table: "supertokens.session_access_token_signing_keys" */
  supertokens_session_access_token_signing_keys: Array<Supertokens_Session_Access_Token_Signing_Keys>;
  /** fetch aggregated fields from the table: "supertokens.session_access_token_signing_keys" */
  supertokens_session_access_token_signing_keys_aggregate: Supertokens_Session_Access_Token_Signing_Keys_Aggregate;
  /** fetch data from the table: "supertokens.session_access_token_signing_keys" using primary key columns */
  supertokens_session_access_token_signing_keys_by_pk?: Maybe<Supertokens_Session_Access_Token_Signing_Keys>;
  /** fetch data from the table: "supertokens.session_info" */
  supertokens_session_info: Array<Supertokens_Session_Info>;
  /** fetch aggregated fields from the table: "supertokens.session_info" */
  supertokens_session_info_aggregate: Supertokens_Session_Info_Aggregate;
  /** fetch data from the table: "supertokens.session_info" using primary key columns */
  supertokens_session_info_by_pk?: Maybe<Supertokens_Session_Info>;
  /** fetch data from the table: "supertokens.tenant_configs" */
  supertokens_tenant_configs: Array<Supertokens_Tenant_Configs>;
  /** fetch aggregated fields from the table: "supertokens.tenant_configs" */
  supertokens_tenant_configs_aggregate: Supertokens_Tenant_Configs_Aggregate;
  /** fetch data from the table: "supertokens.tenant_configs" using primary key columns */
  supertokens_tenant_configs_by_pk?: Maybe<Supertokens_Tenant_Configs>;
  /** fetch data from the table: "supertokens.tenant_thirdparty_provider_clients" */
  supertokens_tenant_thirdparty_provider_clients: Array<Supertokens_Tenant_Thirdparty_Provider_Clients>;
  /** fetch aggregated fields from the table: "supertokens.tenant_thirdparty_provider_clients" */
  supertokens_tenant_thirdparty_provider_clients_aggregate: Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate;
  /** fetch data from the table: "supertokens.tenant_thirdparty_provider_clients" using primary key columns */
  supertokens_tenant_thirdparty_provider_clients_by_pk?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients>;
  /** fetch data from the table: "supertokens.tenant_thirdparty_providers" */
  supertokens_tenant_thirdparty_providers: Array<Supertokens_Tenant_Thirdparty_Providers>;
  /** fetch aggregated fields from the table: "supertokens.tenant_thirdparty_providers" */
  supertokens_tenant_thirdparty_providers_aggregate: Supertokens_Tenant_Thirdparty_Providers_Aggregate;
  /** fetch data from the table: "supertokens.tenant_thirdparty_providers" using primary key columns */
  supertokens_tenant_thirdparty_providers_by_pk?: Maybe<Supertokens_Tenant_Thirdparty_Providers>;
  /** fetch data from the table: "supertokens.tenants" */
  supertokens_tenants: Array<Supertokens_Tenants>;
  /** fetch aggregated fields from the table: "supertokens.tenants" */
  supertokens_tenants_aggregate: Supertokens_Tenants_Aggregate;
  /** fetch data from the table: "supertokens.tenants" using primary key columns */
  supertokens_tenants_by_pk?: Maybe<Supertokens_Tenants>;
  /** fetch data from the table: "supertokens.thirdparty_user_to_tenant" */
  supertokens_thirdparty_user_to_tenant: Array<Supertokens_Thirdparty_User_To_Tenant>;
  /** fetch aggregated fields from the table: "supertokens.thirdparty_user_to_tenant" */
  supertokens_thirdparty_user_to_tenant_aggregate: Supertokens_Thirdparty_User_To_Tenant_Aggregate;
  /** fetch data from the table: "supertokens.thirdparty_user_to_tenant" using primary key columns */
  supertokens_thirdparty_user_to_tenant_by_pk?: Maybe<Supertokens_Thirdparty_User_To_Tenant>;
  /** fetch data from the table: "supertokens.thirdparty_users" */
  supertokens_thirdparty_users: Array<Supertokens_Thirdparty_Users>;
  /** fetch aggregated fields from the table: "supertokens.thirdparty_users" */
  supertokens_thirdparty_users_aggregate: Supertokens_Thirdparty_Users_Aggregate;
  /** fetch data from the table: "supertokens.thirdparty_users" using primary key columns */
  supertokens_thirdparty_users_by_pk?: Maybe<Supertokens_Thirdparty_Users>;
  /** fetch data from the table: "supertokens.user_additional_fields" */
  supertokens_user_additional_fields: Array<Supertokens_User_Additional_Fields>;
  /** fetch aggregated fields from the table: "supertokens.user_additional_fields" */
  supertokens_user_additional_fields_aggregate: Supertokens_User_Additional_Fields_Aggregate;
  /** fetch data from the table: "supertokens.user_additional_fields" using primary key columns */
  supertokens_user_additional_fields_by_pk?: Maybe<Supertokens_User_Additional_Fields>;
  /** fetch data from the table: "supertokens.user_last_active" */
  supertokens_user_last_active: Array<Supertokens_User_Last_Active>;
  /** fetch aggregated fields from the table: "supertokens.user_last_active" */
  supertokens_user_last_active_aggregate: Supertokens_User_Last_Active_Aggregate;
  /** fetch data from the table: "supertokens.user_last_active" using primary key columns */
  supertokens_user_last_active_by_pk?: Maybe<Supertokens_User_Last_Active>;
  /** fetch data from the table: "supertokens.user_metadata" */
  supertokens_user_metadata: Array<Supertokens_User_Metadata>;
  /** fetch aggregated fields from the table: "supertokens.user_metadata" */
  supertokens_user_metadata_aggregate: Supertokens_User_Metadata_Aggregate;
  /** fetch data from the table: "supertokens.user_metadata" using primary key columns */
  supertokens_user_metadata_by_pk?: Maybe<Supertokens_User_Metadata>;
  /** fetch data from the table: "supertokens.user_public_fields" */
  supertokens_user_public_fields: Array<Supertokens_User_Public_Fields>;
  /** fetch aggregated fields from the table: "supertokens.user_public_fields" */
  supertokens_user_public_fields_aggregate: Supertokens_User_Public_Fields_Aggregate;
  /** fetch data from the table: "supertokens.user_roles" */
  supertokens_user_roles: Array<Supertokens_User_Roles>;
  /** fetch aggregated fields from the table: "supertokens.user_roles" */
  supertokens_user_roles_aggregate: Supertokens_User_Roles_Aggregate;
  /** fetch data from the table: "supertokens.user_roles" using primary key columns */
  supertokens_user_roles_by_pk?: Maybe<Supertokens_User_Roles>;
  /** fetch data from the table: "supertokens.userid_mapping" */
  supertokens_userid_mapping: Array<Supertokens_Userid_Mapping>;
  /** fetch aggregated fields from the table: "supertokens.userid_mapping" */
  supertokens_userid_mapping_aggregate: Supertokens_Userid_Mapping_Aggregate;
  /** fetch data from the table: "supertokens.userid_mapping" using primary key columns */
  supertokens_userid_mapping_by_pk?: Maybe<Supertokens_Userid_Mapping>;
  /** fetch data from the table: "taggit_tag" */
  taggit_tag: Array<Taggit_Tag>;
  /** fetch aggregated fields from the table: "taggit_tag" */
  taggit_tag_aggregate: Taggit_Tag_Aggregate;
  /** fetch data from the table: "taggit_tag" using primary key columns */
  taggit_tag_by_pk?: Maybe<Taggit_Tag>;
  /** fetch data from the table: "taggit_taggeditem" */
  taggit_taggeditem: Array<Taggit_Taggeditem>;
  /** fetch aggregated fields from the table: "taggit_taggeditem" */
  taggit_taggeditem_aggregate: Taggit_Taggeditem_Aggregate;
  /** fetch data from the table: "taggit_taggeditem" using primary key columns */
  taggit_taggeditem_by_pk?: Maybe<Taggit_Taggeditem>;
  /** fetch data from the table: "upcoming_live_classes" */
  upcoming_live_classes: Array<Upcoming_Live_Classes>;
  /** fetch aggregated fields from the table: "upcoming_live_classes" */
  upcoming_live_classes_aggregate: Upcoming_Live_Classes_Aggregate;
  /** fetch data from the table: "upcoming_live_classes" using primary key columns */
  upcoming_live_classes_by_pk?: Maybe<Upcoming_Live_Classes>;
  updateLastActive: GenericResponse;
  /** An array relationship */
  user_activities: Array<User_Activities>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activities_Aggregate;
  /** fetch data from the table: "user_activities" using primary key columns */
  user_activities_by_pk?: Maybe<User_Activities>;
  /** fetch data from the table: "user_activity" */
  user_activity: Array<User_Activity>;
  /** fetch aggregated fields from the table: "user_activity" */
  user_activity_aggregate: User_Activity_Aggregate;
  /** fetch data from the table: "user_activity" using primary key columns */
  user_activity_by_pk?: Maybe<User_Activity>;
  /** An array relationship */
  user_activity_lesson_entries: Array<User_Activity_Lesson_Entries>;
  /** An aggregate relationship */
  user_activity_lesson_entries_aggregate: User_Activity_Lesson_Entries_Aggregate;
  /** fetch data from the table: "user_activity_lesson_entries" using primary key columns */
  user_activity_lesson_entries_by_pk?: Maybe<User_Activity_Lesson_Entries>;
  /** An array relationship */
  user_cat_registration_data: Array<User_Cat_Registration_Data>;
  /** An aggregate relationship */
  user_cat_registration_data_aggregate: User_Cat_Registration_Data_Aggregate;
  /** fetch data from the table: "user_cat_registration_data" using primary key columns */
  user_cat_registration_data_by_pk?: Maybe<User_Cat_Registration_Data>;
  /** fetch data from the table: "user_cat_response_sheet_data" */
  user_cat_response_sheet_data: Array<User_Cat_Response_Sheet_Data>;
  /** fetch aggregated fields from the table: "user_cat_response_sheet_data" */
  user_cat_response_sheet_data_aggregate: User_Cat_Response_Sheet_Data_Aggregate;
  /** fetch data from the table: "user_cat_response_sheet_data" using primary key columns */
  user_cat_response_sheet_data_by_pk?: Maybe<User_Cat_Response_Sheet_Data>;
  /** fetch data from the table: "user_custom_planned_activities" */
  user_custom_planned_activities: Array<User_Custom_Planned_Activities>;
  /** fetch aggregated fields from the table: "user_custom_planned_activities" */
  user_custom_planned_activities_aggregate: User_Custom_Planned_Activities_Aggregate;
  /** fetch data from the table: "user_custom_planned_activities" using primary key columns */
  user_custom_planned_activities_by_pk?: Maybe<User_Custom_Planned_Activities>;
  /** fetch data from the table: "user_latest_payment_transaction" */
  user_latest_payment_transaction: Array<User_Latest_Payment_Transaction>;
  /** fetch aggregated fields from the table: "user_latest_payment_transaction" */
  user_latest_payment_transaction_aggregate: User_Latest_Payment_Transaction_Aggregate;
  /** fetch data from the table: "user_leaderboard_types" */
  user_leaderboard_types: Array<User_Leaderboard_Types>;
  /** fetch aggregated fields from the table: "user_leaderboard_types" */
  user_leaderboard_types_aggregate: User_Leaderboard_Types_Aggregate;
  /** fetch data from the table: "user_leaderboard_types" using primary key columns */
  user_leaderboard_types_by_pk?: Maybe<User_Leaderboard_Types>;
  /** An array relationship */
  user_leaderboards: Array<User_Leaderboards>;
  /** An aggregate relationship */
  user_leaderboards_aggregate: User_Leaderboards_Aggregate;
  /** fetch data from the table: "user_leaderboards" using primary key columns */
  user_leaderboards_by_pk?: Maybe<User_Leaderboards>;
  /** An array relationship */
  user_learn_activities: Array<User_Learn_Activities>;
  /** An aggregate relationship */
  user_learn_activities_aggregate: User_Learn_Activities_Aggregate;
  /** fetch data from the table: "user_learn_activities" using primary key columns */
  user_learn_activities_by_pk?: Maybe<User_Learn_Activities>;
  /** fetch data from the table: "user_learn_category_progress" */
  user_learn_category_progress: Array<User_Learn_Category_Progress>;
  /** fetch aggregated fields from the table: "user_learn_category_progress" */
  user_learn_category_progress_aggregate: User_Learn_Category_Progress_Aggregate;
  /** fetch data from the table: "user_learn_category_progress" using primary key columns */
  user_learn_category_progress_by_pk?: Maybe<User_Learn_Category_Progress>;
  /** An array relationship */
  user_learn_completed_topics: Array<User_Learn_Completed_Topics>;
  /** An aggregate relationship */
  user_learn_completed_topics_aggregate: User_Learn_Completed_Topics_Aggregate;
  /** fetch data from the table: "user_learn_completed_topics" using primary key columns */
  user_learn_completed_topics_by_pk?: Maybe<User_Learn_Completed_Topics>;
  /** fetch data from the table: "user_learn_modules_summary" */
  user_learn_modules_summary: Array<User_Learn_Modules_Summary>;
  /** fetch aggregated fields from the table: "user_learn_modules_summary" */
  user_learn_modules_summary_aggregate: User_Learn_Modules_Summary_Aggregate;
  /** fetch data from the table: "user_learn_modules_summary" using primary key columns */
  user_learn_modules_summary_by_pk?: Maybe<User_Learn_Modules_Summary>;
  /** fetch data from the table: "user_learn_track_record" */
  user_learn_track_record: Array<User_Learn_Track_Record>;
  /** fetch aggregated fields from the table: "user_learn_track_record" */
  user_learn_track_record_aggregate: User_Learn_Track_Record_Aggregate;
  /** An array relationship */
  user_learn_track_record_bookmarked_topics: Array<User_Learn_Track_Record_Bookmarked_Topics>;
  /** An aggregate relationship */
  user_learn_track_record_bookmarked_topics_aggregate: User_Learn_Track_Record_Bookmarked_Topics_Aggregate;
  /** fetch data from the table: "user_learn_track_record_bookmarked_topics" using primary key columns */
  user_learn_track_record_bookmarked_topics_by_pk?: Maybe<User_Learn_Track_Record_Bookmarked_Topics>;
  /** fetch data from the table: "user_learn_track_record" using primary key columns */
  user_learn_track_record_by_pk?: Maybe<User_Learn_Track_Record>;
  /** An array relationship */
  user_learn_track_record_which_topics: Array<User_Learn_Track_Record_Which_Topics>;
  /** An aggregate relationship */
  user_learn_track_record_which_topics_aggregate: User_Learn_Track_Record_Which_Topics_Aggregate;
  /** fetch data from the table: "user_learn_track_record_which_topics" using primary key columns */
  user_learn_track_record_which_topics_by_pk?: Maybe<User_Learn_Track_Record_Which_Topics>;
  /** fetch data from the table: "user_lesson_track_records" */
  user_lesson_track_records: Array<User_Lesson_Track_Records>;
  /** fetch aggregated fields from the table: "user_lesson_track_records" */
  user_lesson_track_records_aggregate: User_Lesson_Track_Records_Aggregate;
  /** An array relationship */
  user_planned_activities: Array<User_Planned_Activities>;
  /** An aggregate relationship */
  user_planned_activities_aggregate: User_Planned_Activities_Aggregate;
  /** fetch data from the table: "user_planned_activities" using primary key columns */
  user_planned_activities_by_pk?: Maybe<User_Planned_Activities>;
  /** An array relationship */
  user_pov_summaries: Array<User_Pov_Summaries>;
  /** An aggregate relationship */
  user_pov_summaries_aggregate: User_Pov_Summaries_Aggregate;
  /** fetch data from the table: "user_pov_summaries" using primary key columns */
  user_pov_summaries_by_pk?: Maybe<User_Pov_Summaries>;
  /** An array relationship */
  user_quiz_question_attempts: Array<User_Quiz_Question_Attempts>;
  /** An aggregate relationship */
  user_quiz_question_attempts_aggregate: User_Quiz_Question_Attempts_Aggregate;
  /** fetch data from the table: "user_quiz_question_attempts" using primary key columns */
  user_quiz_question_attempts_by_pk?: Maybe<User_Quiz_Question_Attempts>;
  /** An array relationship */
  user_quiz_question_positions: Array<User_Quiz_Question_Positions>;
  /** An aggregate relationship */
  user_quiz_question_positions_aggregate: User_Quiz_Question_Positions_Aggregate;
  /** fetch data from the table: "user_quiz_question_positions" using primary key columns */
  user_quiz_question_positions_by_pk?: Maybe<User_Quiz_Question_Positions>;
  /** An array relationship */
  user_quiz_question_summaries: Array<User_Quiz_Question_Summaries>;
  /** An aggregate relationship */
  user_quiz_question_summaries_aggregate: User_Quiz_Question_Summaries_Aggregate;
  /** fetch data from the table: "user_quiz_question_summaries" using primary key columns */
  user_quiz_question_summaries_by_pk?: Maybe<User_Quiz_Question_Summaries>;
  /** An array relationship */
  user_quiz_question_summaries_old: Array<User_Quiz_Question_Summaries_Old>;
  /** An aggregate relationship */
  user_quiz_question_summaries_old_aggregate: User_Quiz_Question_Summaries_Old_Aggregate;
  /** fetch data from the table: "user_quiz_question_summaries_old" using primary key columns */
  user_quiz_question_summaries_old_by_pk?: Maybe<User_Quiz_Question_Summaries_Old>;
  /** An array relationship */
  user_quiz_questions: Array<User_Quiz_Questions>;
  /** An aggregate relationship */
  user_quiz_questions_aggregate: User_Quiz_Questions_Aggregate;
  /** fetch data from the table: "user_quiz_questions" using primary key columns */
  user_quiz_questions_by_pk?: Maybe<User_Quiz_Questions>;
  /** An array relationship */
  user_quiz_section_summaries: Array<User_Quiz_Section_Summaries>;
  /** An aggregate relationship */
  user_quiz_section_summaries_aggregate: User_Quiz_Section_Summaries_Aggregate;
  /** fetch data from the table: "user_quiz_section_summaries" using primary key columns */
  user_quiz_section_summaries_by_pk?: Maybe<User_Quiz_Section_Summaries>;
  /** An array relationship */
  user_quiz_summaries: Array<User_Quiz_Summaries>;
  /** An aggregate relationship */
  user_quiz_summaries_aggregate: User_Quiz_Summaries_Aggregate;
  /** fetch data from the table: "user_quiz_summaries" using primary key columns */
  user_quiz_summaries_by_pk?: Maybe<User_Quiz_Summaries>;
  /** fetch data from the table: "user_quiz_summaries_old" */
  user_quiz_summaries_old: Array<User_Quiz_Summaries_Old>;
  /** fetch aggregated fields from the table: "user_quiz_summaries_old" */
  user_quiz_summaries_old_aggregate: User_Quiz_Summaries_Old_Aggregate;
  /** fetch data from the table: "user_quiz_summaries_old" using primary key columns */
  user_quiz_summaries_old_by_pk?: Maybe<User_Quiz_Summaries_Old>;
  /** fetch data from the table: "user_recent_lessons" */
  user_recent_lessons: Array<User_Recent_Lessons>;
  /** fetch aggregated fields from the table: "user_recent_lessons" */
  user_recent_lessons_aggregate: User_Recent_Lessons_Aggregate;
  /** An array relationship */
  user_section_summaries: Array<User_Section_Summaries>;
  /** An aggregate relationship */
  user_section_summaries_aggregate: User_Section_Summaries_Aggregate;
  /** fetch data from the table: "user_section_summaries" using primary key columns */
  user_section_summaries_by_pk?: Maybe<User_Section_Summaries>;
  /** An array relationship */
  user_speed_test_questions_summaries: Array<User_Speed_Test_Questions_Summaries>;
  /** An aggregate relationship */
  user_speed_test_questions_summaries_aggregate: User_Speed_Test_Questions_Summaries_Aggregate;
  /** fetch data from the table: "user_speed_test_questions_summaries" using primary key columns */
  user_speed_test_questions_summaries_by_pk?: Maybe<User_Speed_Test_Questions_Summaries>;
  /** An array relationship */
  user_speed_tests_summaries: Array<User_Speed_Tests_Summaries>;
  /** An aggregate relationship */
  user_speed_tests_summaries_aggregate: User_Speed_Tests_Summaries_Aggregate;
  /** fetch data from the table: "user_speed_tests_summaries" using primary key columns */
  user_speed_tests_summaries_by_pk?: Maybe<User_Speed_Tests_Summaries>;
  /** fetch data from the table: "user_timed_quiz_summary" */
  user_timed_quiz_summary: Array<User_Timed_Quiz_Summary>;
  /** fetch aggregated fields from the table: "user_timed_quiz_summary" */
  user_timed_quiz_summary_aggregate: User_Timed_Quiz_Summary_Aggregate;
  /** fetch data from the table: "user_timed_quiz_summary" using primary key columns */
  user_timed_quiz_summary_by_pk?: Maybe<User_Timed_Quiz_Summary>;
  /** fetch data from the table: "user_total_score" */
  user_total_score: Array<User_Total_Score>;
  /** fetch aggregated fields from the table: "user_total_score" */
  user_total_score_aggregate: User_Total_Score_Aggregate;
  /** fetch data from the table: "user_total_score" using primary key columns */
  user_total_score_by_pk?: Maybe<User_Total_Score>;
  /** fetch data from the table: "user_xp_transaction_summaries" */
  user_xp_transaction_summaries: Array<User_Xp_Transaction_Summaries>;
  /** fetch aggregated fields from the table: "user_xp_transaction_summaries" */
  user_xp_transaction_summaries_aggregate: User_Xp_Transaction_Summaries_Aggregate;
  /** fetch data from the table: "user_xp_transaction_summaries" using primary key columns */
  user_xp_transaction_summaries_by_pk?: Maybe<User_Xp_Transaction_Summaries>;
  /** An array relationship */
  user_xp_transactions: Array<User_Xp_Transactions>;
  /** An aggregate relationship */
  user_xp_transactions_aggregate: User_Xp_Transactions_Aggregate;
  /** fetch data from the table: "user_xp_transactions" using primary key columns */
  user_xp_transactions_by_pk?: Maybe<User_Xp_Transactions>;
  /** fetch data from the table: "users_user" */
  users_user: Array<Users_User>;
  /** fetch aggregated fields from the table: "users_user" */
  users_user_aggregate: Users_User_Aggregate;
  /** fetch data from the table: "users_user" using primary key columns */
  users_user_by_pk?: Maybe<Users_User>;
  /** An array relationship */
  users_user_groups: Array<Users_User_Groups>;
  /** An aggregate relationship */
  users_user_groups_aggregate: Users_User_Groups_Aggregate;
  /** fetch data from the table: "users_user_groups" using primary key columns */
  users_user_groups_by_pk?: Maybe<Users_User_Groups>;
  /** An array relationship */
  users_user_user_permissions: Array<Users_User_User_Permissions>;
  /** An aggregate relationship */
  users_user_user_permissions_aggregate: Users_User_User_Permissions_Aggregate;
  /** fetch data from the table: "users_user_user_permissions" using primary key columns */
  users_user_user_permissions_by_pk?: Maybe<Users_User_User_Permissions>;
  /** fetch data from the table: "users_userquestionsummary" */
  users_userquestionsummary: Array<Users_Userquestionsummary>;
  /** fetch aggregated fields from the table: "users_userquestionsummary" */
  users_userquestionsummary_aggregate: Users_Userquestionsummary_Aggregate;
  /** fetch data from the table: "users_userquestionsummary" using primary key columns */
  users_userquestionsummary_by_pk?: Maybe<Users_Userquestionsummary>;
  /** fetch data from the table: "users_userquizsummary" */
  users_userquizsummary: Array<Users_Userquizsummary>;
  /** fetch aggregated fields from the table: "users_userquizsummary" */
  users_userquizsummary_aggregate: Users_Userquizsummary_Aggregate;
  /** fetch data from the table: "users_userquizsummary" using primary key columns */
  users_userquizsummary_by_pk?: Maybe<Users_Userquizsummary>;
  /** fetch data from the table: "users_userquiztimesummary" */
  users_userquiztimesummary: Array<Users_Userquiztimesummary>;
  /** fetch aggregated fields from the table: "users_userquiztimesummary" */
  users_userquiztimesummary_aggregate: Users_Userquiztimesummary_Aggregate;
  /** fetch data from the table: "users_userquiztimesummary" using primary key columns */
  users_userquiztimesummary_by_pk?: Maybe<Users_Userquiztimesummary>;
  /** fetch data from the table: "users_usersectionsummary" */
  users_usersectionsummary: Array<Users_Usersectionsummary>;
  /** fetch aggregated fields from the table: "users_usersectionsummary" */
  users_usersectionsummary_aggregate: Users_Usersectionsummary_Aggregate;
  /** fetch data from the table: "users_usersectionsummary" using primary key columns */
  users_usersectionsummary_by_pk?: Maybe<Users_Usersectionsummary>;
  /** fetch data from the table: "utils_configuration" */
  utils_configuration: Array<Utils_Configuration>;
  /** fetch aggregated fields from the table: "utils_configuration" */
  utils_configuration_aggregate: Utils_Configuration_Aggregate;
  /** fetch data from the table: "utils_configuration" using primary key columns */
  utils_configuration_by_pk?: Maybe<Utils_Configuration>;
  validateSession: GenericResponse;
  /** fetch data from the table: "xp_transaction_types" */
  xp_transaction_types: Array<Xp_Transaction_Types>;
  /** fetch aggregated fields from the table: "xp_transaction_types" */
  xp_transaction_types_aggregate: Xp_Transaction_Types_Aggregate;
  /** fetch data from the table: "xp_transaction_types" using primary key columns */
  xp_transaction_types_by_pk?: Maybe<Xp_Transaction_Types>;
};


export type QueryAccount_EmailaddressArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailaddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailaddress_Order_By>>;
  where?: InputMaybe<Account_Emailaddress_Bool_Exp>;
};


export type QueryAccount_Emailaddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailaddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailaddress_Order_By>>;
  where?: InputMaybe<Account_Emailaddress_Bool_Exp>;
};


export type QueryAccount_Emailaddress_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccount_EmailconfirmationArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailconfirmation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailconfirmation_Order_By>>;
  where?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
};


export type QueryAccount_Emailconfirmation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailconfirmation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailconfirmation_Order_By>>;
  where?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
};


export type QueryAccount_Emailconfirmation_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccounts_CatscoresArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Catscores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Catscores_Order_By>>;
  where?: InputMaybe<Accounts_Catscores_Bool_Exp>;
};


export type QueryAccounts_Catscores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Catscores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Catscores_Order_By>>;
  where?: InputMaybe<Accounts_Catscores_Bool_Exp>;
};


export type QueryAccounts_Catscores_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccounts_LoggedinuserArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Loggedinuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Loggedinuser_Order_By>>;
  where?: InputMaybe<Accounts_Loggedinuser_Bool_Exp>;
};


export type QueryAccounts_Loggedinuser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Loggedinuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Loggedinuser_Order_By>>;
  where?: InputMaybe<Accounts_Loggedinuser_Bool_Exp>;
};


export type QueryAccounts_Loggedinuser_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryActivity_TypesArgs = {
  distinct_on?: InputMaybe<Array<Activity_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Types_Order_By>>;
  where?: InputMaybe<Activity_Types_Bool_Exp>;
};


export type QueryActivity_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Types_Order_By>>;
  where?: InputMaybe<Activity_Types_Bool_Exp>;
};


export type QueryActivity_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type QueryAdmin_ConstantsArgs = {
  distinct_on?: InputMaybe<Array<Admin_Constants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Constants_Order_By>>;
  where?: InputMaybe<Admin_Constants_Bool_Exp>;
};


export type QueryAdmin_Constants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Constants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Constants_Order_By>>;
  where?: InputMaybe<Admin_Constants_Bool_Exp>;
};


export type QueryAdmin_Constants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAdmin_UsersArgs = {
  distinct_on?: InputMaybe<Array<Admin_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Users_Order_By>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type QueryAdmin_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Users_Order_By>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type QueryAdmin_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAdvertisementsArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type QueryAdvertisements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type QueryAdvertisements_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAndablog_EntryArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entry_Order_By>>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};


export type QueryAndablog_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entry_Order_By>>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};


export type QueryAndablog_Entry_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAndablog_EntryimageArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entryimage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entryimage_Order_By>>;
  where?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
};


export type QueryAndablog_Entryimage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entryimage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entryimage_Order_By>>;
  where?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
};


export type QueryAndablog_Entryimage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAndablog_NewsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_News_Order_By>>;
  where?: InputMaybe<Andablog_News_Bool_Exp>;
};


export type QueryAndablog_News_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_News_Order_By>>;
  where?: InputMaybe<Andablog_News_Bool_Exp>;
};


export type QueryAndablog_News_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAndablog_PovArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Pov_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Pov_Order_By>>;
  where?: InputMaybe<Andablog_Pov_Bool_Exp>;
};


export type QueryAndablog_Pov_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Pov_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Pov_Order_By>>;
  where?: InputMaybe<Andablog_Pov_Bool_Exp>;
};


export type QueryAndablog_Pov_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAndablog_UserlessontrackrecordArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};


export type QueryAndablog_Userlessontrackrecord_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};


export type QueryAndablog_Userlessontrackrecord_Bookmarked_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};


export type QueryAndablog_Userlessontrackrecord_Bookmarked_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};


export type QueryAndablog_Userlessontrackrecord_Bookmarked_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAndablog_Userlessontrackrecord_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAndablog_Userlessontrackrecord_Which_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};


export type QueryAndablog_Userlessontrackrecord_Which_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};


export type QueryAndablog_Userlessontrackrecord_Which_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAndablog_VideoArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Video_Order_By>>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};


export type QueryAndablog_Video_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Video_Order_By>>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};


export type QueryAndablog_Video_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAuth_Email_VerificationsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Email_Verifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Email_Verifications_Order_By>>;
  where?: InputMaybe<Auth_Email_Verifications_Bool_Exp>;
};


export type QueryAuth_Email_Verifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Email_Verifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Email_Verifications_Order_By>>;
  where?: InputMaybe<Auth_Email_Verifications_Bool_Exp>;
};


export type QueryAuth_Email_Verifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type QueryAuth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type QueryAuth_Group_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAuth_Group_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type QueryAuth_Group_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type QueryAuth_Group_Permissions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAuth_Password_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Auth_Password_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Password_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Password_Reset_Tokens_Bool_Exp>;
};


export type QueryAuth_Password_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Password_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Password_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Password_Reset_Tokens_Bool_Exp>;
};


export type QueryAuth_Password_Reset_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAuth_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type QueryAuth_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type QueryAuth_Permission_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAuth_SessionArgs = {
  distinct_on?: InputMaybe<Array<Auth_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Session_Order_By>>;
  where?: InputMaybe<Auth_Session_Bool_Exp>;
};


export type QueryAuth_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Session_Order_By>>;
  where?: InputMaybe<Auth_Session_Bool_Exp>;
};


export type QueryAuth_Session_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type QueryBookmarked_Learn_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bookmarked_Learn_Topics_Order_By>>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};


export type QueryBookmarked_Learn_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bookmarked_Learn_Topics_Order_By>>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};


export type QueryBookmarked_Learn_Topics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryCat_Percentile_ConstantArgs = {
  distinct_on?: InputMaybe<Array<Cat_Percentile_Constant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cat_Percentile_Constant_Order_By>>;
  where?: InputMaybe<Cat_Percentile_Constant_Bool_Exp>;
};


export type QueryCat_Percentile_Constant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cat_Percentile_Constant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cat_Percentile_Constant_Order_By>>;
  where?: InputMaybe<Cat_Percentile_Constant_Bool_Exp>;
};


export type QueryCat_Percentile_Constant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryCat_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Cat_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cat_Scores_Order_By>>;
  where?: InputMaybe<Cat_Scores_Bool_Exp>;
};


export type QueryCat_Scores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cat_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cat_Scores_Order_By>>;
  where?: InputMaybe<Cat_Scores_Bool_Exp>;
};


export type QueryCat_Scores_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryChannel_MembersArgs = {
  distinct_on?: InputMaybe<Array<Channel_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Members_Order_By>>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};


export type QueryChannel_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Members_Order_By>>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};


export type QueryChannel_Members_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryChannelsArgs = {
  distinct_on?: InputMaybe<Array<Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channels_Order_By>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type QueryChannels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channels_Order_By>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type QueryChannels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryCoupons_Allowed_Users_Rule_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};


export type QueryCoupons_Allowed_Users_Rule_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};


export type QueryCoupons_Allowed_Users_Rule_Users_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCoupons_AllowedusersruleArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
};


export type QueryCoupons_Allowedusersrule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
};


export type QueryCoupons_Allowedusersrule_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCoupons_Allowedusersrule_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};


export type QueryCoupons_Allowedusersrule_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};


export type QueryCoupons_Allowedusersrule_Users_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCoupons_CouponArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};


export type QueryCoupons_Coupon_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};


export type QueryCoupons_Coupon_Applicable_PackagesArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};


export type QueryCoupons_Coupon_Applicable_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};


export type QueryCoupons_Coupon_Applicable_Packages_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCoupons_Coupon_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCoupons_CouponuserArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


export type QueryCoupons_Couponuser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


export type QueryCoupons_Couponuser_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCoupons_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Discount_Order_By>>;
  where?: InputMaybe<Coupons_Discount_Bool_Exp>;
};


export type QueryCoupons_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Discount_Order_By>>;
  where?: InputMaybe<Coupons_Discount_Bool_Exp>;
};


export type QueryCoupons_Discount_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCoupons_MaxusesruleArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Maxusesrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Maxusesrule_Order_By>>;
  where?: InputMaybe<Coupons_Maxusesrule_Bool_Exp>;
};


export type QueryCoupons_Maxusesrule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Maxusesrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Maxusesrule_Order_By>>;
  where?: InputMaybe<Coupons_Maxusesrule_Bool_Exp>;
};


export type QueryCoupons_Maxusesrule_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCoupons_RulesetArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};


export type QueryCoupons_Ruleset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};


export type QueryCoupons_Ruleset_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCoupons_ValidityruleArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Validityrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Validityrule_Order_By>>;
  where?: InputMaybe<Coupons_Validityrule_Bool_Exp>;
};


export type QueryCoupons_Validityrule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Validityrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Validityrule_Order_By>>;
  where?: InputMaybe<Coupons_Validityrule_Bool_Exp>;
};


export type QueryCoupons_Validityrule_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDjango_Admin_LogArgs = {
  distinct_on?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Admin_Log_Order_By>>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};


export type QueryDjango_Admin_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Admin_Log_Order_By>>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};


export type QueryDjango_Admin_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDjango_Content_TypeArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type QueryDjango_Content_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type QueryDjango_Content_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDjango_MigrationsArgs = {
  distinct_on?: InputMaybe<Array<Django_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Migrations_Order_By>>;
  where?: InputMaybe<Django_Migrations_Bool_Exp>;
};


export type QueryDjango_Migrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Migrations_Order_By>>;
  where?: InputMaybe<Django_Migrations_Bool_Exp>;
};


export type QueryDjango_Migrations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDjango_SessionArgs = {
  distinct_on?: InputMaybe<Array<Django_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Session_Order_By>>;
  where?: InputMaybe<Django_Session_Bool_Exp>;
};


export type QueryDjango_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Session_Order_By>>;
  where?: InputMaybe<Django_Session_Bool_Exp>;
};


export type QueryDjango_Session_By_PkArgs = {
  session_key: Scalars['String']['input'];
};


export type QueryDjango_SiteArgs = {
  distinct_on?: InputMaybe<Array<Django_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Site_Order_By>>;
  where?: InputMaybe<Django_Site_Bool_Exp>;
};


export type QueryDjango_Site_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Site_Order_By>>;
  where?: InputMaybe<Django_Site_Bool_Exp>;
};


export type QueryDjango_Site_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDjconfig_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Djconfig_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Djconfig_Config_Order_By>>;
  where?: InputMaybe<Djconfig_Config_Bool_Exp>;
};


export type QueryDjconfig_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Djconfig_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Djconfig_Config_Order_By>>;
  where?: InputMaybe<Djconfig_Config_Bool_Exp>;
};


export type QueryDjconfig_Config_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetCatApplicationDataArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGetChannelInfoArgs = {
  channelId: Scalars['String']['input'];
};


export type QueryGetChannelMembersArgs = {
  channelId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetCompeteMarksVsPercentileArgs = {
  quizID: Scalars['Int']['input'];
};


export type QueryGetCompeteTop10ScoresArgs = {
  quizID: Scalars['Int']['input'];
};


export type QueryGetLiveQuizDomainsArgs = {
  isFree: Scalars['Boolean']['input'];
};


export type QueryGetPlannerCompeteDomainsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlannerLessonDomainsArgs = {
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlannerPracticeDomainsArgs = {
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlannerSpeedConceptDomainsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuizLeaderboardArgs = {
  quizID: Scalars['Int']['input'];
};


export type QueryGetTimedTestDetailsArgs = {
  quizSlug: Scalars['String']['input'];
};


export type QueryGetUserCustomEventsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserPlannedActivitiesArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetVideoOtpForLessonArgs = {
  activeTopicID: Scalars['Int']['input'];
};


export type QueryGetVideoOtpForQuestionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetXpLeaderBoardArgs = {
  range?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGet_Random_QuestionArgs = {
  args: Get_Random_Question_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type QueryGet_Random_Question_AggregateArgs = {
  args: Get_Random_Question_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type QueryGet_Speed_Concepts_All_Random_QuestionsArgs = {
  args: Get_Speed_Concepts_All_Random_Questions_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type QueryGet_Speed_Concepts_All_Random_Questions_AggregateArgs = {
  args: Get_Speed_Concepts_All_Random_Questions_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type QueryGet_Speed_Concepts_Random_QuestionArgs = {
  args: Get_Speed_Concepts_Random_Question_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type QueryGet_Speed_Concepts_Random_Question_AggregateArgs = {
  args: Get_Speed_Concepts_Random_Question_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type QueryGroup_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Group_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Category_Order_By>>;
  where?: InputMaybe<Group_Category_Bool_Exp>;
};


export type QueryGroup_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Category_Order_By>>;
  where?: InputMaybe<Group_Category_Bool_Exp>;
};


export type QueryGroup_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryGroup_Discount_UsersArgs = {
  distinct_on?: InputMaybe<Array<Group_Discount_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Discount_Users_Order_By>>;
  where?: InputMaybe<Group_Discount_Users_Bool_Exp>;
};


export type QueryGroup_Discount_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Discount_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Discount_Users_Order_By>>;
  where?: InputMaybe<Group_Discount_Users_Bool_Exp>;
};


export type QueryHas_AccessArgs = {
  distinct_on?: InputMaybe<Array<Has_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Has_Access_Order_By>>;
  where?: InputMaybe<Has_Access_Bool_Exp>;
};


export type QueryHas_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Has_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Has_Access_Order_By>>;
  where?: InputMaybe<Has_Access_Bool_Exp>;
};


export type QueryInfozone_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Category_Order_By>>;
  where?: InputMaybe<Infozone_Category_Bool_Exp>;
};


export type QueryInfozone_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Category_Order_By>>;
  where?: InputMaybe<Infozone_Category_Bool_Exp>;
};


export type QueryInfozone_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInfozone_InfozoneArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Infozone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Infozone_Order_By>>;
  where?: InputMaybe<Infozone_Infozone_Bool_Exp>;
};


export type QueryInfozone_Infozone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Infozone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Infozone_Order_By>>;
  where?: InputMaybe<Infozone_Infozone_Bool_Exp>;
};


export type QueryInfozone_Infozone_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInfozone_StaticpagesArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Staticpages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Staticpages_Order_By>>;
  where?: InputMaybe<Infozone_Staticpages_Bool_Exp>;
};


export type QueryInfozone_Staticpages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Staticpages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Staticpages_Order_By>>;
  where?: InputMaybe<Infozone_Staticpages_Bool_Exp>;
};


export type QueryInfozone_Staticpages_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLive_Quiz_LeaderboardArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Leaderboard_Order_By>>;
  where?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
};


export type QueryLive_Quiz_Leaderboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Leaderboard_Order_By>>;
  where?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
};


export type QueryLive_Quiz_Leaderboard_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryLive_Quiz_Question_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};


export type QueryLive_Quiz_Question_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};


export type QueryLive_Quiz_Question_Positions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryLive_Quiz_Question_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};


export type QueryLive_Quiz_Question_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};


export type QueryLive_Quiz_Question_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryLive_Quiz_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
};


export type QueryLive_Quiz_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
};


export type QueryLive_Quiz_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMarks_Vs_Percentile_DilrArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Dilr_Bool_Exp>;
};


export type QueryMarks_Vs_Percentile_Dilr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Dilr_Bool_Exp>;
};


export type QueryMarks_Vs_Percentile_Dilr_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMarks_Vs_Percentile_QuantArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Quant_Bool_Exp>;
};


export type QueryMarks_Vs_Percentile_Quant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Quant_Bool_Exp>;
};


export type QueryMarks_Vs_Percentile_Quant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMarks_Vs_Percentile_Total_RawArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Bool_Exp>;
};


export type QueryMarks_Vs_Percentile_Total_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Bool_Exp>;
};


export type QueryMarks_Vs_Percentile_Total_Raw_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMarks_Vs_Percentile_VarcArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Varc_Bool_Exp>;
};


export type QueryMarks_Vs_Percentile_Varc_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Varc_Bool_Exp>;
};


export type QueryMarks_Vs_Percentile_Varc_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMarks_Vs_Scaled_PercentileArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Order_By>>;
  where?: InputMaybe<Marks_Vs_Scaled_Percentile_Bool_Exp>;
};


export type QueryMarks_Vs_Scaled_Percentile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Order_By>>;
  where?: InputMaybe<Marks_Vs_Scaled_Percentile_Bool_Exp>;
};


export type QueryMarks_Vs_Scaled_Percentile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMeeting_MembersArgs = {
  distinct_on?: InputMaybe<Array<Meeting_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meeting_Members_Order_By>>;
  where?: InputMaybe<Meeting_Members_Bool_Exp>;
};


export type QueryMeeting_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meeting_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meeting_Members_Order_By>>;
  where?: InputMaybe<Meeting_Members_Bool_Exp>;
};


export type QueryMeeting_Members_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMeetingsArgs = {
  distinct_on?: InputMaybe<Array<Meetings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meetings_Order_By>>;
  where?: InputMaybe<Meetings_Bool_Exp>;
};


export type QueryMeetings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meetings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meetings_Order_By>>;
  where?: InputMaybe<Meetings_Bool_Exp>;
};


export type QueryMeetings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMessage_ReactionsArgs = {
  distinct_on?: InputMaybe<Array<Message_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Message_Reactions_Order_By>>;
  where?: InputMaybe<Message_Reactions_Bool_Exp>;
};


export type QueryMessage_Reactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Message_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Message_Reactions_Order_By>>;
  where?: InputMaybe<Message_Reactions_Bool_Exp>;
};


export type QueryMessage_Reactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type QueryMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type QueryMessages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMessages_ReadArgs = {
  distinct_on?: InputMaybe<Array<Messages_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Read_Order_By>>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};


export type QueryMessages_Read_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Read_Order_By>>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};


export type QueryMessages_Read_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryOffline_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Offline_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offline_Leads_Order_By>>;
  where?: InputMaybe<Offline_Leads_Bool_Exp>;
};


export type QueryOffline_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offline_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offline_Leads_Order_By>>;
  where?: InputMaybe<Offline_Leads_Bool_Exp>;
};


export type QueryOffline_Leads_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPackage_Content_Discarded_QuizzesArgs = {
  distinct_on?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Order_By>>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};


export type QueryPackage_Content_Discarded_Quizzes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Order_By>>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};


export type QueryPackage_Content_Discarded_Quizzes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryPackages_ContentArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Order_By>>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};


export type QueryPackages_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Order_By>>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};


export type QueryPackages_Content_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPackages_Content_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Domains_Order_By>>;
  where?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
};


export type QueryPackages_Content_Domains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Domains_Order_By>>;
  where?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
};


export type QueryPackages_Content_Domains_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryPackages_Content_Text_LessonArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Text_Lesson_Order_By>>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};


export type QueryPackages_Content_Text_Lesson_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Text_Lesson_Order_By>>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};


export type QueryPackages_Content_Text_Lesson_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPackages_Content_Timed_TestArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Timed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};


export type QueryPackages_Content_Timed_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Timed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};


export type QueryPackages_Content_Timed_Test_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPackages_Content_Untimed_TestArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Untimed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};


export type QueryPackages_Content_Untimed_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Untimed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};


export type QueryPackages_Content_Untimed_Test_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPackages_Payment_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


export type QueryPackages_Payment_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


export type QueryPackages_Payment_Transaction_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPackages_PaymenttransactionArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


export type QueryPackages_Paymenttransaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


export type QueryPackages_Paymenttransaction_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPollArgs = {
  distinct_on?: InputMaybe<Array<Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Order_By>>;
  where?: InputMaybe<Poll_Bool_Exp>;
};


export type QueryPoll_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Order_By>>;
  where?: InputMaybe<Poll_Bool_Exp>;
};


export type QueryPoll_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryPoll_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Poll_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Options_Order_By>>;
  where?: InputMaybe<Poll_Options_Bool_Exp>;
};


export type QueryPoll_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Options_Order_By>>;
  where?: InputMaybe<Poll_Options_Bool_Exp>;
};


export type QueryPoll_Options_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryPoll_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Responses_Order_By>>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};


export type QueryPoll_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Responses_Order_By>>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};


export type QueryPoll_Responses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryQuestion_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Question_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Reports_Order_By>>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};


export type QueryQuestion_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Reports_Order_By>>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};


export type QueryQuestion_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryQuiz_AnswerArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Answer_Order_By>>;
  where?: InputMaybe<Quiz_Answer_Bool_Exp>;
};


export type QueryQuiz_Answer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Answer_Order_By>>;
  where?: InputMaybe<Quiz_Answer_Bool_Exp>;
};


export type QueryQuiz_Answer_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Category_Order_By>>;
  where?: InputMaybe<Quiz_Category_Bool_Exp>;
};


export type QueryQuiz_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Category_Order_By>>;
  where?: InputMaybe<Quiz_Category_Bool_Exp>;
};


export type QueryQuiz_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_DomainArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Domain_Order_By>>;
  where?: InputMaybe<Quiz_Domain_Bool_Exp>;
};


export type QueryQuiz_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Domain_Order_By>>;
  where?: InputMaybe<Quiz_Domain_Bool_Exp>;
};


export type QueryQuiz_Domain_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_MarkingsystemArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Markingsystem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Markingsystem_Order_By>>;
  where?: InputMaybe<Quiz_Markingsystem_Bool_Exp>;
};


export type QueryQuiz_Markingsystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Markingsystem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Markingsystem_Order_By>>;
  where?: InputMaybe<Quiz_Markingsystem_Bool_Exp>;
};


export type QueryQuiz_Markingsystem_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_OptionArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Option_Order_By>>;
  where?: InputMaybe<Quiz_Option_Bool_Exp>;
};


export type QueryQuiz_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Option_Order_By>>;
  where?: InputMaybe<Quiz_Option_Bool_Exp>;
};


export type QueryQuiz_Option_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_ParagraphArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Paragraph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Paragraph_Order_By>>;
  where?: InputMaybe<Quiz_Paragraph_Bool_Exp>;
};


export type QueryQuiz_Paragraph_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Paragraph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Paragraph_Order_By>>;
  where?: InputMaybe<Quiz_Paragraph_Bool_Exp>;
};


export type QueryQuiz_Paragraph_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Question_Order_By>>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};


export type QueryQuiz_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Question_Order_By>>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};


export type QueryQuiz_Question_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_QuizArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};


export type QueryQuiz_Quiz_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};


export type QueryQuiz_Quiz_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_Quiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type QueryQuiz_Quiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type QueryQuiz_Quiz_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_Quiz_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Sections_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};


export type QueryQuiz_Quiz_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Sections_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};


export type QueryQuiz_Quiz_Sections_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_SectionArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Order_By>>;
  where?: InputMaybe<Quiz_Section_Bool_Exp>;
};


export type QueryQuiz_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Order_By>>;
  where?: InputMaybe<Quiz_Section_Bool_Exp>;
};


export type QueryQuiz_Section_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_Section_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};


export type QueryQuiz_Section_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};


export type QueryQuiz_Section_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_Section_SubsectionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Subsections_Order_By>>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};


export type QueryQuiz_Section_Subsections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Subsections_Order_By>>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};


export type QueryQuiz_Section_Subsections_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuiz_SuperdomainArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Superdomain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Superdomain_Order_By>>;
  where?: InputMaybe<Quiz_Superdomain_Bool_Exp>;
};


export type QueryQuiz_Superdomain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Superdomain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Superdomain_Order_By>>;
  where?: InputMaybe<Quiz_Superdomain_Bool_Exp>;
};


export type QueryQuiz_Superdomain_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRandom_Question_IdsArgs = {
  distinct_on?: InputMaybe<Array<Random_Question_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Random_Question_Ids_Order_By>>;
  where?: InputMaybe<Random_Question_Ids_Bool_Exp>;
};


export type QueryRandom_Question_Ids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Random_Question_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Random_Question_Ids_Order_By>>;
  where?: InputMaybe<Random_Question_Ids_Bool_Exp>;
};


export type QueryReaction_EmojisArgs = {
  distinct_on?: InputMaybe<Array<Reaction_Emojis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reaction_Emojis_Order_By>>;
  where?: InputMaybe<Reaction_Emojis_Bool_Exp>;
};


export type QueryReaction_Emojis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reaction_Emojis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reaction_Emojis_Order_By>>;
  where?: InputMaybe<Reaction_Emojis_Bool_Exp>;
};


export type QueryReaction_Emojis_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryReported_MessageArgs = {
  distinct_on?: InputMaybe<Array<Reported_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reported_Message_Order_By>>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};


export type QueryReported_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reported_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reported_Message_Order_By>>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};


export type QueryReported_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryScaling_ConstantArgs = {
  distinct_on?: InputMaybe<Array<Scaling_Constant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scaling_Constant_Order_By>>;
  where?: InputMaybe<Scaling_Constant_Bool_Exp>;
};


export type QueryScaling_Constant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scaling_Constant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scaling_Constant_Order_By>>;
  where?: InputMaybe<Scaling_Constant_Bool_Exp>;
};


export type QueryScaling_Constant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerySocialaccount_SocialaccountArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialaccount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialaccount_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
};


export type QuerySocialaccount_Socialaccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialaccount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialaccount_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
};


export type QuerySocialaccount_Socialaccount_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySocialaccount_SocialappArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Bool_Exp>;
};


export type QuerySocialaccount_Socialapp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Bool_Exp>;
};


export type QuerySocialaccount_Socialapp_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySocialaccount_Socialapp_SitesArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};


export type QuerySocialaccount_Socialapp_Sites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};


export type QuerySocialaccount_Socialapp_Sites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySocialaccount_SocialtokenArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialtoken_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};


export type QuerySocialaccount_Socialtoken_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialtoken_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};


export type QuerySocialaccount_Socialtoken_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpeed_Test_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Speed_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Test_Category_Order_By>>;
  where?: InputMaybe<Speed_Test_Category_Bool_Exp>;
};


export type QuerySpeed_Test_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speed_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Test_Category_Order_By>>;
  where?: InputMaybe<Speed_Test_Category_Bool_Exp>;
};


export type QuerySpeed_Test_Category_By_PkArgs = {
  category: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QuerySpeed_TestsArgs = {
  distinct_on?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Tests_Order_By>>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};


export type QuerySpeed_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Tests_Order_By>>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};


export type QuerySpeed_Tests_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_CacheArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Cache_Order_By>>;
  where?: InputMaybe<Spirit_Cache_Bool_Exp>;
};


export type QuerySpirit_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Cache_Order_By>>;
  where?: InputMaybe<Spirit_Cache_Bool_Exp>;
};


export type QuerySpirit_Cache_By_PkArgs = {
  cache_key: Scalars['String']['input'];
};


export type QuerySpirit_Category_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Category_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Category_Category_Order_By>>;
  where?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
};


export type QuerySpirit_Category_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Category_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Category_Category_Order_By>>;
  where?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
};


export type QuerySpirit_Category_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Comment_Bookmark_CommentbookmarkArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};


export type QuerySpirit_Comment_Bookmark_Commentbookmark_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};


export type QuerySpirit_Comment_Bookmark_Commentbookmark_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Comment_CommentArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Comment_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};


export type QuerySpirit_Comment_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Comment_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};


export type QuerySpirit_Comment_Comment_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Comment_Flag_CommentflagArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
};


export type QuerySpirit_Comment_Flag_Commentflag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
};


export type QuerySpirit_Comment_Flag_Commentflag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Comment_Flag_FlagArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};


export type QuerySpirit_Comment_Flag_Flag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};


export type QuerySpirit_Comment_Flag_Flag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Comment_History_CommenthistoryArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Order_By>>;
  where?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
};


export type QuerySpirit_Comment_History_Commenthistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Order_By>>;
  where?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
};


export type QuerySpirit_Comment_History_Commenthistory_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Comment_Like_CommentlikeArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};


export type QuerySpirit_Comment_Like_Commentlike_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};


export type QuerySpirit_Comment_Like_Commentlike_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Comment_Poll_CommentpollArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
};


export type QuerySpirit_Comment_Poll_Commentpoll_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
};


export type QuerySpirit_Comment_Poll_Commentpoll_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Comment_Poll_CommentpollchoiceArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
};


export type QuerySpirit_Comment_Poll_Commentpollchoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
};


export type QuerySpirit_Comment_Poll_Commentpollchoice_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Comment_Poll_CommentpollvoteArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};


export type QuerySpirit_Comment_Poll_Commentpollvote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};


export type QuerySpirit_Comment_Poll_Commentpollvote_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Rl_CacheArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Rl_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Rl_Cache_Order_By>>;
  where?: InputMaybe<Spirit_Rl_Cache_Bool_Exp>;
};


export type QuerySpirit_Rl_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Rl_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Rl_Cache_Order_By>>;
  where?: InputMaybe<Spirit_Rl_Cache_Bool_Exp>;
};


export type QuerySpirit_Rl_Cache_By_PkArgs = {
  cache_key: Scalars['String']['input'];
};


export type QuerySpirit_Topic_Favorite_TopicfavoriteArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};


export type QuerySpirit_Topic_Favorite_Topicfavorite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};


export type QuerySpirit_Topic_Favorite_Topicfavorite_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Topic_Notification_TopicnotificationArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


export type QuerySpirit_Topic_Notification_Topicnotification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


export type QuerySpirit_Topic_Notification_Topicnotification_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Topic_Private_TopicprivateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};


export type QuerySpirit_Topic_Private_Topicprivate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};


export type QuerySpirit_Topic_Private_Topicprivate_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Topic_TopicArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Topic_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};


export type QuerySpirit_Topic_Topic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Topic_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};


export type QuerySpirit_Topic_Topic_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_Topic_Unread_TopicunreadArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};


export type QuerySpirit_Topic_Unread_Topicunread_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};


export type QuerySpirit_Topic_Unread_Topicunread_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySpirit_User_UserprofileArgs = {
  distinct_on?: InputMaybe<Array<Spirit_User_Userprofile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_User_Userprofile_Order_By>>;
  where?: InputMaybe<Spirit_User_Userprofile_Bool_Exp>;
};


export type QuerySpirit_User_Userprofile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_User_Userprofile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_User_Userprofile_Order_By>>;
  where?: InputMaybe<Spirit_User_Userprofile_Bool_Exp>;
};


export type QuerySpirit_User_Userprofile_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscription_Group_PlanArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
};


export type QuerySubscription_Group_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
};


export type QuerySubscription_Group_Plan_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscription_Group_Plan_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Groups_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
};


export type QuerySubscription_Group_Plan_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Groups_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
};


export type QuerySubscription_Group_Plan_Groups_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscriptions_PlancostArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plancost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plancost_Order_By>>;
  where?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
};


export type QuerySubscriptions_Plancost_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plancost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plancost_Order_By>>;
  where?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
};


export type QuerySubscriptions_Plancost_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerySubscriptions_PlanlistArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlist_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlist_Bool_Exp>;
};


export type QuerySubscriptions_Planlist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlist_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlist_Bool_Exp>;
};


export type QuerySubscriptions_Planlist_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscriptions_PlanlistdetailArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlistdetail_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};


export type QuerySubscriptions_Planlistdetail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlistdetail_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};


export type QuerySubscriptions_Planlistdetail_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscriptions_PlantagArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plantag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plantag_Order_By>>;
  where?: InputMaybe<Subscriptions_Plantag_Bool_Exp>;
};


export type QuerySubscriptions_Plantag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plantag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plantag_Order_By>>;
  where?: InputMaybe<Subscriptions_Plantag_Bool_Exp>;
};


export type QuerySubscriptions_Plantag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscriptions_SubscriptionplanArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
};


export type QuerySubscriptions_Subscriptionplan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
};


export type QuerySubscriptions_Subscriptionplan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerySubscriptions_Subscriptionplan_Upgradable_PlansArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};


export type QuerySubscriptions_Subscriptionplan_Upgradable_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};


export type QuerySubscriptions_Subscriptionplan_Upgradable_Plans_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscriptions_SubscriptiontransactionArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};


export type QuerySubscriptions_Subscriptiontransaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};


export type QuerySubscriptions_Subscriptiontransaction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerySubscriptions_UsersubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Usersubscription_Order_By>>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};


export type QuerySubscriptions_Usersubscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Usersubscription_Order_By>>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};


export type QuerySubscriptions_Usersubscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerySupertokens_All_Auth_Recipe_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Order_By>>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};


export type QuerySupertokens_All_Auth_Recipe_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Order_By>>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};


export type QuerySupertokens_All_Auth_Recipe_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_App_Id_To_User_IdArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Order_By>>;
  where?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
};


export type QuerySupertokens_App_Id_To_User_Id_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Order_By>>;
  where?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
};


export type QuerySupertokens_App_Id_To_User_Id_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_AppsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Apps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Apps_Order_By>>;
  where?: InputMaybe<Supertokens_Apps_Bool_Exp>;
};


export type QuerySupertokens_Apps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Apps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Apps_Order_By>>;
  where?: InputMaybe<Supertokens_Apps_Bool_Exp>;
};


export type QuerySupertokens_Apps_By_PkArgs = {
  app_id: Scalars['String']['input'];
};


export type QuerySupertokens_Dashboard_User_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
};


export type QuerySupertokens_Dashboard_User_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
};


export type QuerySupertokens_Dashboard_User_Sessions_By_PkArgs = {
  app_id: Scalars['String']['input'];
  session_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_Dashboard_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
};


export type QuerySupertokens_Dashboard_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
};


export type QuerySupertokens_Dashboard_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_Emailpassword_Pswd_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
};


export type QuerySupertokens_Emailpassword_Pswd_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
};


export type QuerySupertokens_Emailpassword_Pswd_Reset_Tokens_By_PkArgs = {
  app_id: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_Emailpassword_User_To_TenantArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>;
};


export type QuerySupertokens_Emailpassword_User_To_Tenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>;
};


export type QuerySupertokens_Emailpassword_User_To_Tenant_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_Emailpassword_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
};


export type QuerySupertokens_Emailpassword_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
};


export type QuerySupertokens_Emailpassword_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_Emailverification_TokensArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
};


export type QuerySupertokens_Emailverification_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
};


export type QuerySupertokens_Emailverification_Tokens_By_PkArgs = {
  app_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type QuerySupertokens_Emailverification_Verified_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
};


export type QuerySupertokens_Emailverification_Verified_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
};


export type QuerySupertokens_Emailverification_Verified_Emails_By_PkArgs = {
  app_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type QuerySupertokens_Jwt_Signing_KeysArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
};


export type QuerySupertokens_Jwt_Signing_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
};


export type QuerySupertokens_Jwt_Signing_Keys_By_PkArgs = {
  app_id: Scalars['String']['input'];
  key_id: Scalars['String']['input'];
};


export type QuerySupertokens_Key_ValueArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Key_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Key_Value_Order_By>>;
  where?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
};


export type QuerySupertokens_Key_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Key_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Key_Value_Order_By>>;
  where?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
};


export type QuerySupertokens_Key_Value_By_PkArgs = {
  app_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


export type QuerySupertokens_Passwordless_CodesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Codes_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
};


export type QuerySupertokens_Passwordless_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Codes_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
};


export type QuerySupertokens_Passwordless_Codes_By_PkArgs = {
  app_id: Scalars['String']['input'];
  code_id: Scalars['bpchar']['input'];
  tenant_id: Scalars['String']['input'];
};


export type QuerySupertokens_Passwordless_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Devices_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
};


export type QuerySupertokens_Passwordless_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Devices_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
};


export type QuerySupertokens_Passwordless_Devices_By_PkArgs = {
  app_id: Scalars['String']['input'];
  device_id_hash: Scalars['bpchar']['input'];
  tenant_id: Scalars['String']['input'];
};


export type QuerySupertokens_Passwordless_User_To_TenantArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>;
};


export type QuerySupertokens_Passwordless_User_To_Tenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>;
};


export type QuerySupertokens_Passwordless_User_To_Tenant_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_Passwordless_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Users_Bool_Exp>;
};


export type QuerySupertokens_Passwordless_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Users_Bool_Exp>;
};


export type QuerySupertokens_Passwordless_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_Role_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Role_Permissions_Order_By>>;
  where?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
};


export type QuerySupertokens_Role_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Role_Permissions_Order_By>>;
  where?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
};


export type QuerySupertokens_Role_Permissions_By_PkArgs = {
  app_id: Scalars['String']['input'];
  permission: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type QuerySupertokens_RolesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_Roles_Bool_Exp>;
};


export type QuerySupertokens_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_Roles_Bool_Exp>;
};


export type QuerySupertokens_Roles_By_PkArgs = {
  app_id: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type QuerySupertokens_Session_Access_Token_Signing_KeysArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
};


export type QuerySupertokens_Session_Access_Token_Signing_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
};


export type QuerySupertokens_Session_Access_Token_Signing_Keys_By_PkArgs = {
  app_id: Scalars['String']['input'];
  created_at_time: Scalars['bigint']['input'];
};


export type QuerySupertokens_Session_InfoArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Info_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
};


export type QuerySupertokens_Session_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Info_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
};


export type QuerySupertokens_Session_Info_By_PkArgs = {
  app_id: Scalars['String']['input'];
  session_handle: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


export type QuerySupertokens_Tenant_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Configs_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Configs_Bool_Exp>;
};


export type QuerySupertokens_Tenant_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Configs_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Configs_Bool_Exp>;
};


export type QuerySupertokens_Tenant_Configs_By_PkArgs = {
  app_id: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


export type QuerySupertokens_Tenant_Thirdparty_Provider_ClientsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
};


export type QuerySupertokens_Tenant_Thirdparty_Provider_Clients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
};


export type QuerySupertokens_Tenant_Thirdparty_Provider_Clients_By_PkArgs = {
  app_id: Scalars['String']['input'];
  client_type: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  third_party_id: Scalars['String']['input'];
};


export type QuerySupertokens_Tenant_Thirdparty_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
};


export type QuerySupertokens_Tenant_Thirdparty_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
};


export type QuerySupertokens_Tenant_Thirdparty_Providers_By_PkArgs = {
  app_id: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  third_party_id: Scalars['String']['input'];
};


export type QuerySupertokens_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenants_Order_By>>;
  where?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
};


export type QuerySupertokens_Tenants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenants_Order_By>>;
  where?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
};


export type QuerySupertokens_Tenants_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


export type QuerySupertokens_Thirdparty_User_To_TenantArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>;
};


export type QuerySupertokens_Thirdparty_User_To_Tenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>;
};


export type QuerySupertokens_Thirdparty_User_To_Tenant_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_Thirdparty_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Thirdparty_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Thirdparty_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Thirdparty_Users_Bool_Exp>;
};


export type QuerySupertokens_Thirdparty_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Thirdparty_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Thirdparty_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Thirdparty_Users_Bool_Exp>;
};


export type QuerySupertokens_Thirdparty_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type QuerySupertokens_User_Additional_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Additional_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Additional_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
};


export type QuerySupertokens_User_Additional_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Additional_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Additional_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
};


export type QuerySupertokens_User_Additional_Fields_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupertokens_User_Last_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Last_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Last_Active_Order_By>>;
  where?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
};


export type QuerySupertokens_User_Last_Active_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Last_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Last_Active_Order_By>>;
  where?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
};


export type QuerySupertokens_User_Last_Active_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type QuerySupertokens_User_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Metadata_Order_By>>;
  where?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
};


export type QuerySupertokens_User_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Metadata_Order_By>>;
  where?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
};


export type QuerySupertokens_User_Metadata_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type QuerySupertokens_User_Public_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Public_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Public_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
};


export type QuerySupertokens_User_Public_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Public_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Public_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
};


export type QuerySupertokens_User_RolesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};


export type QuerySupertokens_User_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};


export type QuerySupertokens_User_Roles_By_PkArgs = {
  app_id: Scalars['String']['input'];
  role: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type QuerySupertokens_Userid_MappingArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Userid_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Userid_Mapping_Order_By>>;
  where?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
};


export type QuerySupertokens_Userid_Mapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Userid_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Userid_Mapping_Order_By>>;
  where?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
};


export type QuerySupertokens_Userid_Mapping_By_PkArgs = {
  app_id: Scalars['String']['input'];
  external_user_id: Scalars['String']['input'];
  supertokens_user_id: Scalars['bpchar']['input'];
};


export type QueryTaggit_TagArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Tag_Order_By>>;
  where?: InputMaybe<Taggit_Tag_Bool_Exp>;
};


export type QueryTaggit_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Tag_Order_By>>;
  where?: InputMaybe<Taggit_Tag_Bool_Exp>;
};


export type QueryTaggit_Tag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTaggit_TaggeditemArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Taggeditem_Order_By>>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};


export type QueryTaggit_Taggeditem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Taggeditem_Order_By>>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};


export type QueryTaggit_Taggeditem_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUpcoming_Live_ClassesArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Live_Classes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Upcoming_Live_Classes_Order_By>>;
  where?: InputMaybe<Upcoming_Live_Classes_Bool_Exp>;
};


export type QueryUpcoming_Live_Classes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Live_Classes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Upcoming_Live_Classes_Order_By>>;
  where?: InputMaybe<Upcoming_Live_Classes_Bool_Exp>;
};


export type QueryUpcoming_Live_Classes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type QueryUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type QueryUser_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_ActivityArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type QueryUser_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type QueryUser_Activity_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUser_Activity_Lesson_EntriesArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Lesson_Entries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Lesson_Entries_Order_By>>;
  where?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
};


export type QueryUser_Activity_Lesson_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Lesson_Entries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Lesson_Entries_Order_By>>;
  where?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
};


export type QueryUser_Activity_Lesson_Entries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUser_Cat_Registration_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Registration_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Registration_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
};


export type QueryUser_Cat_Registration_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Registration_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Registration_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
};


export type QueryUser_Cat_Registration_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Cat_Response_Sheet_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Response_Sheet_Data_Bool_Exp>;
};


export type QueryUser_Cat_Response_Sheet_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Response_Sheet_Data_Bool_Exp>;
};


export type QueryUser_Cat_Response_Sheet_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Custom_Planned_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Custom_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Custom_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Custom_Planned_Activities_Bool_Exp>;
};


export type QueryUser_Custom_Planned_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Custom_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Custom_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Custom_Planned_Activities_Bool_Exp>;
};


export type QueryUser_Custom_Planned_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Latest_Payment_TransactionArgs = {
  distinct_on?: InputMaybe<Array<User_Latest_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Latest_Payment_Transaction_Order_By>>;
  where?: InputMaybe<User_Latest_Payment_Transaction_Bool_Exp>;
};


export type QueryUser_Latest_Payment_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Latest_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Latest_Payment_Transaction_Order_By>>;
  where?: InputMaybe<User_Latest_Payment_Transaction_Bool_Exp>;
};


export type QueryUser_Leaderboard_TypesArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboard_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboard_Types_Order_By>>;
  where?: InputMaybe<User_Leaderboard_Types_Bool_Exp>;
};


export type QueryUser_Leaderboard_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboard_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboard_Types_Order_By>>;
  where?: InputMaybe<User_Leaderboard_Types_Bool_Exp>;
};


export type QueryUser_Leaderboard_Types_By_PkArgs = {
  category: Scalars['String']['input'];
  sub_type: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryUser_LeaderboardsArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboards_Order_By>>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};


export type QueryUser_Leaderboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboards_Order_By>>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};


export type QueryUser_Leaderboards_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Learn_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Activities_Order_By>>;
  where?: InputMaybe<User_Learn_Activities_Bool_Exp>;
};


export type QueryUser_Learn_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Activities_Order_By>>;
  where?: InputMaybe<User_Learn_Activities_Bool_Exp>;
};


export type QueryUser_Learn_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Learn_Category_ProgressArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Category_Progress_Order_By>>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};


export type QueryUser_Learn_Category_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Category_Progress_Order_By>>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};


export type QueryUser_Learn_Category_Progress_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Learn_Completed_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Completed_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};


export type QueryUser_Learn_Completed_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Completed_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};


export type QueryUser_Learn_Completed_Topics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Learn_Modules_SummaryArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Modules_Summary_Order_By>>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};


export type QueryUser_Learn_Modules_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Modules_Summary_Order_By>>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};


export type QueryUser_Learn_Modules_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Learn_Track_RecordArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};


export type QueryUser_Learn_Track_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};


export type QueryUser_Learn_Track_Record_Bookmarked_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};


export type QueryUser_Learn_Track_Record_Bookmarked_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};


export type QueryUser_Learn_Track_Record_Bookmarked_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUser_Learn_Track_Record_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUser_Learn_Track_Record_Which_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};


export type QueryUser_Learn_Track_Record_Which_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};


export type QueryUser_Learn_Track_Record_Which_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUser_Lesson_Track_RecordsArgs = {
  distinct_on?: InputMaybe<Array<User_Lesson_Track_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Lesson_Track_Records_Order_By>>;
  where?: InputMaybe<User_Lesson_Track_Records_Bool_Exp>;
};


export type QueryUser_Lesson_Track_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Lesson_Track_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Lesson_Track_Records_Order_By>>;
  where?: InputMaybe<User_Lesson_Track_Records_Bool_Exp>;
};


export type QueryUser_Planned_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


export type QueryUser_Planned_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


export type QueryUser_Planned_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Pov_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Pov_Summaries_Order_By>>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};


export type QueryUser_Pov_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Pov_Summaries_Order_By>>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};


export type QueryUser_Pov_Summaries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUser_Quiz_Question_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Attempts_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};


export type QueryUser_Quiz_Question_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Attempts_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};


export type QueryUser_Quiz_Question_Attempts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Quiz_Question_PositionsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};


export type QueryUser_Quiz_Question_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};


export type QueryUser_Quiz_Question_Positions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Quiz_Question_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


export type QueryUser_Quiz_Question_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


export type QueryUser_Quiz_Question_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Quiz_Question_Summaries_OldArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


export type QueryUser_Quiz_Question_Summaries_Old_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


export type QueryUser_Quiz_Question_Summaries_Old_By_PkArgs = {
  question_id: Scalars['Int']['input'];
  quiz_summary_id: Scalars['Int']['input'];
};


export type QueryUser_Quiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Questions_Order_By>>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};


export type QueryUser_Quiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Questions_Order_By>>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};


export type QueryUser_Quiz_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUser_Quiz_Section_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};


export type QueryUser_Quiz_Section_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};


export type QueryUser_Quiz_Section_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Quiz_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


export type QueryUser_Quiz_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


export type QueryUser_Quiz_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Quiz_Summaries_OldArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};


export type QueryUser_Quiz_Summaries_Old_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};


export type QueryUser_Quiz_Summaries_Old_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUser_Recent_LessonsArgs = {
  distinct_on?: InputMaybe<Array<User_Recent_Lessons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Recent_Lessons_Order_By>>;
  where?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
};


export type QueryUser_Recent_Lessons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Recent_Lessons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Recent_Lessons_Order_By>>;
  where?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
};


export type QueryUser_Section_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


export type QueryUser_Section_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


export type QueryUser_Section_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Speed_Test_Questions_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};


export type QueryUser_Speed_Test_Questions_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};


export type QueryUser_Speed_Test_Questions_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Speed_Tests_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};


export type QueryUser_Speed_Tests_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};


export type QueryUser_Speed_Tests_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Timed_Quiz_SummaryArgs = {
  distinct_on?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Timed_Quiz_Summary_Order_By>>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};


export type QueryUser_Timed_Quiz_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Timed_Quiz_Summary_Order_By>>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};


export type QueryUser_Timed_Quiz_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUser_Total_ScoreArgs = {
  distinct_on?: InputMaybe<Array<User_Total_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Total_Score_Order_By>>;
  where?: InputMaybe<User_Total_Score_Bool_Exp>;
};


export type QueryUser_Total_Score_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Total_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Total_Score_Order_By>>;
  where?: InputMaybe<User_Total_Score_Bool_Exp>;
};


export type QueryUser_Total_Score_By_PkArgs = {
  sum: Scalars['numeric']['input'];
};


export type QueryUser_Xp_Transaction_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transaction_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transaction_Summaries_Order_By>>;
  where?: InputMaybe<User_Xp_Transaction_Summaries_Bool_Exp>;
};


export type QueryUser_Xp_Transaction_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transaction_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transaction_Summaries_Order_By>>;
  where?: InputMaybe<User_Xp_Transaction_Summaries_Bool_Exp>;
};


export type QueryUser_Xp_Transaction_Summaries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUser_Xp_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transactions_Order_By>>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};


export type QueryUser_Xp_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transactions_Order_By>>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};


export type QueryUser_Xp_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryUsers_UserArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Order_By>>;
  where?: InputMaybe<Users_User_Bool_Exp>;
};


export type QueryUsers_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Order_By>>;
  where?: InputMaybe<Users_User_Bool_Exp>;
};


export type QueryUsers_User_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsers_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Groups_Order_By>>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};


export type QueryUsers_User_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Groups_Order_By>>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};


export type QueryUsers_User_Groups_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsers_User_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};


export type QueryUsers_User_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};


export type QueryUsers_User_User_Permissions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsers_UserquestionsummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


export type QueryUsers_Userquestionsummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


export type QueryUsers_Userquestionsummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsers_UserquizsummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquizsummary_Order_By>>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};


export type QueryUsers_Userquizsummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquizsummary_Order_By>>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};


export type QueryUsers_Userquizsummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsers_UserquiztimesummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquiztimesummary_Order_By>>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};


export type QueryUsers_Userquiztimesummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquiztimesummary_Order_By>>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};


export type QueryUsers_Userquiztimesummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsers_UsersectionsummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};


export type QueryUsers_Usersectionsummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};


export type QueryUsers_Usersectionsummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUtils_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Utils_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utils_Configuration_Order_By>>;
  where?: InputMaybe<Utils_Configuration_Bool_Exp>;
};


export type QueryUtils_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utils_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utils_Configuration_Order_By>>;
  where?: InputMaybe<Utils_Configuration_Bool_Exp>;
};


export type QueryUtils_Configuration_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryXp_Transaction_TypesArgs = {
  distinct_on?: InputMaybe<Array<Xp_Transaction_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Xp_Transaction_Types_Order_By>>;
  where?: InputMaybe<Xp_Transaction_Types_Bool_Exp>;
};


export type QueryXp_Transaction_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xp_Transaction_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Xp_Transaction_Types_Order_By>>;
  where?: InputMaybe<Xp_Transaction_Types_Bool_Exp>;
};


export type QueryXp_Transaction_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};

export enum Role {
  Admin = 'ADMIN',
  Anonymous = 'ANONYMOUS',
  User = 'USER'
}

export type Sdl = {
  __typename?: 'SDL';
  sdl: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** fetch data from the table: "account_emailaddress" */
  account_emailaddress: Array<Account_Emailaddress>;
  /** fetch aggregated fields from the table: "account_emailaddress" */
  account_emailaddress_aggregate: Account_Emailaddress_Aggregate;
  /** fetch data from the table: "account_emailaddress" using primary key columns */
  account_emailaddress_by_pk?: Maybe<Account_Emailaddress>;
  /** fetch data from the table in a streaming manner: "account_emailaddress" */
  account_emailaddress_stream: Array<Account_Emailaddress>;
  /** fetch data from the table: "account_emailconfirmation" */
  account_emailconfirmation: Array<Account_Emailconfirmation>;
  /** fetch aggregated fields from the table: "account_emailconfirmation" */
  account_emailconfirmation_aggregate: Account_Emailconfirmation_Aggregate;
  /** fetch data from the table: "account_emailconfirmation" using primary key columns */
  account_emailconfirmation_by_pk?: Maybe<Account_Emailconfirmation>;
  /** fetch data from the table in a streaming manner: "account_emailconfirmation" */
  account_emailconfirmation_stream: Array<Account_Emailconfirmation>;
  /** An array relationship */
  accounts_catscores: Array<Accounts_Catscores>;
  /** An aggregate relationship */
  accounts_catscores_aggregate: Accounts_Catscores_Aggregate;
  /** fetch data from the table: "accounts_catscores" using primary key columns */
  accounts_catscores_by_pk?: Maybe<Accounts_Catscores>;
  /** fetch data from the table in a streaming manner: "accounts_catscores" */
  accounts_catscores_stream: Array<Accounts_Catscores>;
  /** fetch data from the table: "accounts_loggedinuser" */
  accounts_loggedinuser: Array<Accounts_Loggedinuser>;
  /** fetch aggregated fields from the table: "accounts_loggedinuser" */
  accounts_loggedinuser_aggregate: Accounts_Loggedinuser_Aggregate;
  /** fetch data from the table: "accounts_loggedinuser" using primary key columns */
  accounts_loggedinuser_by_pk?: Maybe<Accounts_Loggedinuser>;
  /** fetch data from the table in a streaming manner: "accounts_loggedinuser" */
  accounts_loggedinuser_stream: Array<Accounts_Loggedinuser>;
  /** fetch data from the table: "activity_types" */
  activity_types: Array<Activity_Types>;
  /** fetch aggregated fields from the table: "activity_types" */
  activity_types_aggregate: Activity_Types_Aggregate;
  /** fetch data from the table: "activity_types" using primary key columns */
  activity_types_by_pk?: Maybe<Activity_Types>;
  /** fetch data from the table in a streaming manner: "activity_types" */
  activity_types_stream: Array<Activity_Types>;
  /** fetch data from the table: "admin_constants" */
  admin_constants: Array<Admin_Constants>;
  /** fetch aggregated fields from the table: "admin_constants" */
  admin_constants_aggregate: Admin_Constants_Aggregate;
  /** fetch data from the table: "admin_constants" using primary key columns */
  admin_constants_by_pk?: Maybe<Admin_Constants>;
  /** fetch data from the table in a streaming manner: "admin_constants" */
  admin_constants_stream: Array<Admin_Constants>;
  /** fetch data from the table: "admin_users" */
  admin_users: Array<Admin_Users>;
  /** fetch aggregated fields from the table: "admin_users" */
  admin_users_aggregate: Admin_Users_Aggregate;
  /** fetch data from the table: "admin_users" using primary key columns */
  admin_users_by_pk?: Maybe<Admin_Users>;
  /** fetch data from the table in a streaming manner: "admin_users" */
  admin_users_stream: Array<Admin_Users>;
  /** An array relationship */
  advertisements: Array<Advertisements>;
  /** An aggregate relationship */
  advertisements_aggregate: Advertisements_Aggregate;
  /** fetch data from the table: "advertisements" using primary key columns */
  advertisements_by_pk?: Maybe<Advertisements>;
  /** fetch data from the table in a streaming manner: "advertisements" */
  advertisements_stream: Array<Advertisements>;
  /** fetch data from the table: "andablog_entry" */
  andablog_entry: Array<Andablog_Entry>;
  /** fetch aggregated fields from the table: "andablog_entry" */
  andablog_entry_aggregate: Andablog_Entry_Aggregate;
  /** fetch data from the table: "andablog_entry" using primary key columns */
  andablog_entry_by_pk?: Maybe<Andablog_Entry>;
  /** fetch data from the table in a streaming manner: "andablog_entry" */
  andablog_entry_stream: Array<Andablog_Entry>;
  /** fetch data from the table: "andablog_entryimage" */
  andablog_entryimage: Array<Andablog_Entryimage>;
  /** fetch aggregated fields from the table: "andablog_entryimage" */
  andablog_entryimage_aggregate: Andablog_Entryimage_Aggregate;
  /** fetch data from the table: "andablog_entryimage" using primary key columns */
  andablog_entryimage_by_pk?: Maybe<Andablog_Entryimage>;
  /** fetch data from the table in a streaming manner: "andablog_entryimage" */
  andablog_entryimage_stream: Array<Andablog_Entryimage>;
  /** fetch data from the table: "andablog_news" */
  andablog_news: Array<Andablog_News>;
  /** fetch aggregated fields from the table: "andablog_news" */
  andablog_news_aggregate: Andablog_News_Aggregate;
  /** fetch data from the table: "andablog_news" using primary key columns */
  andablog_news_by_pk?: Maybe<Andablog_News>;
  /** fetch data from the table in a streaming manner: "andablog_news" */
  andablog_news_stream: Array<Andablog_News>;
  /** fetch data from the table: "andablog_pov" */
  andablog_pov: Array<Andablog_Pov>;
  /** fetch aggregated fields from the table: "andablog_pov" */
  andablog_pov_aggregate: Andablog_Pov_Aggregate;
  /** fetch data from the table: "andablog_pov" using primary key columns */
  andablog_pov_by_pk?: Maybe<Andablog_Pov>;
  /** fetch data from the table in a streaming manner: "andablog_pov" */
  andablog_pov_stream: Array<Andablog_Pov>;
  /** fetch data from the table: "andablog_userlessontrackrecord" */
  andablog_userlessontrackrecord: Array<Andablog_Userlessontrackrecord>;
  /** fetch aggregated fields from the table: "andablog_userlessontrackrecord" */
  andablog_userlessontrackrecord_aggregate: Andablog_Userlessontrackrecord_Aggregate;
  /** An array relationship */
  andablog_userlessontrackrecord_bookmarked_topics: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** An aggregate relationship */
  andablog_userlessontrackrecord_bookmarked_topics_aggregate: Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate;
  /** fetch data from the table: "andablog_userlessontrackrecord_bookmarked_topics" using primary key columns */
  andablog_userlessontrackrecord_bookmarked_topics_by_pk?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** fetch data from the table in a streaming manner: "andablog_userlessontrackrecord_bookmarked_topics" */
  andablog_userlessontrackrecord_bookmarked_topics_stream: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** fetch data from the table: "andablog_userlessontrackrecord" using primary key columns */
  andablog_userlessontrackrecord_by_pk?: Maybe<Andablog_Userlessontrackrecord>;
  /** fetch data from the table in a streaming manner: "andablog_userlessontrackrecord" */
  andablog_userlessontrackrecord_stream: Array<Andablog_Userlessontrackrecord>;
  /** An array relationship */
  andablog_userlessontrackrecord_which_topics: Array<Andablog_Userlessontrackrecord_Which_Topics>;
  /** An aggregate relationship */
  andablog_userlessontrackrecord_which_topics_aggregate: Andablog_Userlessontrackrecord_Which_Topics_Aggregate;
  /** fetch data from the table: "andablog_userlessontrackrecord_which_topics" using primary key columns */
  andablog_userlessontrackrecord_which_topics_by_pk?: Maybe<Andablog_Userlessontrackrecord_Which_Topics>;
  /** fetch data from the table in a streaming manner: "andablog_userlessontrackrecord_which_topics" */
  andablog_userlessontrackrecord_which_topics_stream: Array<Andablog_Userlessontrackrecord_Which_Topics>;
  /** fetch data from the table: "andablog_video" */
  andablog_video: Array<Andablog_Video>;
  /** fetch aggregated fields from the table: "andablog_video" */
  andablog_video_aggregate: Andablog_Video_Aggregate;
  /** fetch data from the table: "andablog_video" using primary key columns */
  andablog_video_by_pk?: Maybe<Andablog_Video>;
  /** fetch data from the table in a streaming manner: "andablog_video" */
  andablog_video_stream: Array<Andablog_Video>;
  /** fetch data from the table: "auth.email_verifications" */
  auth_email_verifications: Array<Auth_Email_Verifications>;
  /** fetch aggregated fields from the table: "auth.email_verifications" */
  auth_email_verifications_aggregate: Auth_Email_Verifications_Aggregate;
  /** fetch data from the table: "auth.email_verifications" using primary key columns */
  auth_email_verifications_by_pk?: Maybe<Auth_Email_Verifications>;
  /** fetch data from the table in a streaming manner: "auth.email_verifications" */
  auth_email_verifications_stream: Array<Auth_Email_Verifications>;
  /** fetch data from the table: "auth_group" */
  auth_group: Array<Auth_Group>;
  /** fetch aggregated fields from the table: "auth_group" */
  auth_group_aggregate: Auth_Group_Aggregate;
  /** fetch data from the table: "auth_group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** An array relationship */
  auth_group_permissions: Array<Auth_Group_Permissions>;
  /** An aggregate relationship */
  auth_group_permissions_aggregate: Auth_Group_Permissions_Aggregate;
  /** fetch data from the table: "auth_group_permissions" using primary key columns */
  auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** fetch data from the table in a streaming manner: "auth_group_permissions" */
  auth_group_permissions_stream: Array<Auth_Group_Permissions>;
  /** fetch data from the table in a streaming manner: "auth_group" */
  auth_group_stream: Array<Auth_Group>;
  /** fetch data from the table: "auth.password_reset_tokens" */
  auth_password_reset_tokens: Array<Auth_Password_Reset_Tokens>;
  /** fetch aggregated fields from the table: "auth.password_reset_tokens" */
  auth_password_reset_tokens_aggregate: Auth_Password_Reset_Tokens_Aggregate;
  /** fetch data from the table: "auth.password_reset_tokens" using primary key columns */
  auth_password_reset_tokens_by_pk?: Maybe<Auth_Password_Reset_Tokens>;
  /** fetch data from the table in a streaming manner: "auth.password_reset_tokens" */
  auth_password_reset_tokens_stream: Array<Auth_Password_Reset_Tokens>;
  /** fetch data from the table: "auth_permission" */
  auth_permission: Array<Auth_Permission>;
  /** fetch aggregated fields from the table: "auth_permission" */
  auth_permission_aggregate: Auth_Permission_Aggregate;
  /** fetch data from the table: "auth_permission" using primary key columns */
  auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** fetch data from the table in a streaming manner: "auth_permission" */
  auth_permission_stream: Array<Auth_Permission>;
  /** fetch data from the table: "auth.session" */
  auth_session: Array<Auth_Session>;
  /** fetch aggregated fields from the table: "auth.session" */
  auth_session_aggregate: Auth_Session_Aggregate;
  /** fetch data from the table: "auth.session" using primary key columns */
  auth_session_by_pk?: Maybe<Auth_Session>;
  /** fetch data from the table in a streaming manner: "auth.session" */
  auth_session_stream: Array<Auth_Session>;
  /** An array relationship */
  bookmarked_learn_topics: Array<Bookmarked_Learn_Topics>;
  /** An aggregate relationship */
  bookmarked_learn_topics_aggregate: Bookmarked_Learn_Topics_Aggregate;
  /** fetch data from the table: "bookmarked_learn_topics" using primary key columns */
  bookmarked_learn_topics_by_pk?: Maybe<Bookmarked_Learn_Topics>;
  /** fetch data from the table in a streaming manner: "bookmarked_learn_topics" */
  bookmarked_learn_topics_stream: Array<Bookmarked_Learn_Topics>;
  /** fetch data from the table: "cat_percentile_constant" */
  cat_percentile_constant: Array<Cat_Percentile_Constant>;
  /** fetch aggregated fields from the table: "cat_percentile_constant" */
  cat_percentile_constant_aggregate: Cat_Percentile_Constant_Aggregate;
  /** fetch data from the table: "cat_percentile_constant" using primary key columns */
  cat_percentile_constant_by_pk?: Maybe<Cat_Percentile_Constant>;
  /** fetch data from the table in a streaming manner: "cat_percentile_constant" */
  cat_percentile_constant_stream: Array<Cat_Percentile_Constant>;
  /** fetch data from the table: "cat_scores" */
  cat_scores: Array<Cat_Scores>;
  /** fetch aggregated fields from the table: "cat_scores" */
  cat_scores_aggregate: Cat_Scores_Aggregate;
  /** fetch data from the table: "cat_scores" using primary key columns */
  cat_scores_by_pk?: Maybe<Cat_Scores>;
  /** fetch data from the table in a streaming manner: "cat_scores" */
  cat_scores_stream: Array<Cat_Scores>;
  /** An array relationship */
  channel_members: Array<Channel_Members>;
  /** An aggregate relationship */
  channel_members_aggregate: Channel_Members_Aggregate;
  /** fetch data from the table: "channel_members" using primary key columns */
  channel_members_by_pk?: Maybe<Channel_Members>;
  /** fetch data from the table in a streaming manner: "channel_members" */
  channel_members_stream: Array<Channel_Members>;
  /** fetch data from the table: "channels" */
  channels: Array<Channels>;
  /** fetch aggregated fields from the table: "channels" */
  channels_aggregate: Channels_Aggregate;
  /** fetch data from the table: "channels" using primary key columns */
  channels_by_pk?: Maybe<Channels>;
  /** fetch data from the table in a streaming manner: "channels" */
  channels_stream: Array<Channels>;
  /** An array relationship */
  coupons_allowed_users_rule_users: Array<Coupons_Allowed_Users_Rule_Users>;
  /** An aggregate relationship */
  coupons_allowed_users_rule_users_aggregate: Coupons_Allowed_Users_Rule_Users_Aggregate;
  /** fetch data from the table: "coupons_allowed_users_rule_users" using primary key columns */
  coupons_allowed_users_rule_users_by_pk?: Maybe<Coupons_Allowed_Users_Rule_Users>;
  /** fetch data from the table in a streaming manner: "coupons_allowed_users_rule_users" */
  coupons_allowed_users_rule_users_stream: Array<Coupons_Allowed_Users_Rule_Users>;
  /** fetch data from the table: "coupons_allowedusersrule" */
  coupons_allowedusersrule: Array<Coupons_Allowedusersrule>;
  /** fetch aggregated fields from the table: "coupons_allowedusersrule" */
  coupons_allowedusersrule_aggregate: Coupons_Allowedusersrule_Aggregate;
  /** fetch data from the table: "coupons_allowedusersrule" using primary key columns */
  coupons_allowedusersrule_by_pk?: Maybe<Coupons_Allowedusersrule>;
  /** fetch data from the table in a streaming manner: "coupons_allowedusersrule" */
  coupons_allowedusersrule_stream: Array<Coupons_Allowedusersrule>;
  /** An array relationship */
  coupons_allowedusersrule_users: Array<Coupons_Allowedusersrule_Users>;
  /** An aggregate relationship */
  coupons_allowedusersrule_users_aggregate: Coupons_Allowedusersrule_Users_Aggregate;
  /** fetch data from the table: "coupons_allowedusersrule_users" using primary key columns */
  coupons_allowedusersrule_users_by_pk?: Maybe<Coupons_Allowedusersrule_Users>;
  /** fetch data from the table in a streaming manner: "coupons_allowedusersrule_users" */
  coupons_allowedusersrule_users_stream: Array<Coupons_Allowedusersrule_Users>;
  /** fetch data from the table: "coupons_coupon" */
  coupons_coupon: Array<Coupons_Coupon>;
  /** fetch aggregated fields from the table: "coupons_coupon" */
  coupons_coupon_aggregate: Coupons_Coupon_Aggregate;
  /** An array relationship */
  coupons_coupon_applicable_packages: Array<Coupons_Coupon_Applicable_Packages>;
  /** An aggregate relationship */
  coupons_coupon_applicable_packages_aggregate: Coupons_Coupon_Applicable_Packages_Aggregate;
  /** fetch data from the table: "coupons_coupon_applicable_packages" using primary key columns */
  coupons_coupon_applicable_packages_by_pk?: Maybe<Coupons_Coupon_Applicable_Packages>;
  /** fetch data from the table in a streaming manner: "coupons_coupon_applicable_packages" */
  coupons_coupon_applicable_packages_stream: Array<Coupons_Coupon_Applicable_Packages>;
  /** fetch data from the table: "coupons_coupon" using primary key columns */
  coupons_coupon_by_pk?: Maybe<Coupons_Coupon>;
  /** fetch data from the table in a streaming manner: "coupons_coupon" */
  coupons_coupon_stream: Array<Coupons_Coupon>;
  /** fetch data from the table: "coupons_couponuser" */
  coupons_couponuser: Array<Coupons_Couponuser>;
  /** fetch aggregated fields from the table: "coupons_couponuser" */
  coupons_couponuser_aggregate: Coupons_Couponuser_Aggregate;
  /** fetch data from the table: "coupons_couponuser" using primary key columns */
  coupons_couponuser_by_pk?: Maybe<Coupons_Couponuser>;
  /** fetch data from the table in a streaming manner: "coupons_couponuser" */
  coupons_couponuser_stream: Array<Coupons_Couponuser>;
  /** fetch data from the table: "coupons_discount" */
  coupons_discount: Array<Coupons_Discount>;
  /** fetch aggregated fields from the table: "coupons_discount" */
  coupons_discount_aggregate: Coupons_Discount_Aggregate;
  /** fetch data from the table: "coupons_discount" using primary key columns */
  coupons_discount_by_pk?: Maybe<Coupons_Discount>;
  /** fetch data from the table in a streaming manner: "coupons_discount" */
  coupons_discount_stream: Array<Coupons_Discount>;
  /** fetch data from the table: "coupons_maxusesrule" */
  coupons_maxusesrule: Array<Coupons_Maxusesrule>;
  /** fetch aggregated fields from the table: "coupons_maxusesrule" */
  coupons_maxusesrule_aggregate: Coupons_Maxusesrule_Aggregate;
  /** fetch data from the table: "coupons_maxusesrule" using primary key columns */
  coupons_maxusesrule_by_pk?: Maybe<Coupons_Maxusesrule>;
  /** fetch data from the table in a streaming manner: "coupons_maxusesrule" */
  coupons_maxusesrule_stream: Array<Coupons_Maxusesrule>;
  /** fetch data from the table: "coupons_ruleset" */
  coupons_ruleset: Array<Coupons_Ruleset>;
  /** fetch aggregated fields from the table: "coupons_ruleset" */
  coupons_ruleset_aggregate: Coupons_Ruleset_Aggregate;
  /** fetch data from the table: "coupons_ruleset" using primary key columns */
  coupons_ruleset_by_pk?: Maybe<Coupons_Ruleset>;
  /** fetch data from the table in a streaming manner: "coupons_ruleset" */
  coupons_ruleset_stream: Array<Coupons_Ruleset>;
  /** fetch data from the table: "coupons_validityrule" */
  coupons_validityrule: Array<Coupons_Validityrule>;
  /** fetch aggregated fields from the table: "coupons_validityrule" */
  coupons_validityrule_aggregate: Coupons_Validityrule_Aggregate;
  /** fetch data from the table: "coupons_validityrule" using primary key columns */
  coupons_validityrule_by_pk?: Maybe<Coupons_Validityrule>;
  /** fetch data from the table in a streaming manner: "coupons_validityrule" */
  coupons_validityrule_stream: Array<Coupons_Validityrule>;
  /** fetch data from the table: "django_admin_log" */
  django_admin_log: Array<Django_Admin_Log>;
  /** fetch aggregated fields from the table: "django_admin_log" */
  django_admin_log_aggregate: Django_Admin_Log_Aggregate;
  /** fetch data from the table: "django_admin_log" using primary key columns */
  django_admin_log_by_pk?: Maybe<Django_Admin_Log>;
  /** fetch data from the table in a streaming manner: "django_admin_log" */
  django_admin_log_stream: Array<Django_Admin_Log>;
  /** fetch data from the table: "django_content_type" */
  django_content_type: Array<Django_Content_Type>;
  /** fetch aggregated fields from the table: "django_content_type" */
  django_content_type_aggregate: Django_Content_Type_Aggregate;
  /** fetch data from the table: "django_content_type" using primary key columns */
  django_content_type_by_pk?: Maybe<Django_Content_Type>;
  /** fetch data from the table in a streaming manner: "django_content_type" */
  django_content_type_stream: Array<Django_Content_Type>;
  /** fetch data from the table: "django_migrations" */
  django_migrations: Array<Django_Migrations>;
  /** fetch aggregated fields from the table: "django_migrations" */
  django_migrations_aggregate: Django_Migrations_Aggregate;
  /** fetch data from the table: "django_migrations" using primary key columns */
  django_migrations_by_pk?: Maybe<Django_Migrations>;
  /** fetch data from the table in a streaming manner: "django_migrations" */
  django_migrations_stream: Array<Django_Migrations>;
  /** fetch data from the table: "django_session" */
  django_session: Array<Django_Session>;
  /** fetch aggregated fields from the table: "django_session" */
  django_session_aggregate: Django_Session_Aggregate;
  /** fetch data from the table: "django_session" using primary key columns */
  django_session_by_pk?: Maybe<Django_Session>;
  /** fetch data from the table in a streaming manner: "django_session" */
  django_session_stream: Array<Django_Session>;
  /** fetch data from the table: "django_site" */
  django_site: Array<Django_Site>;
  /** fetch aggregated fields from the table: "django_site" */
  django_site_aggregate: Django_Site_Aggregate;
  /** fetch data from the table: "django_site" using primary key columns */
  django_site_by_pk?: Maybe<Django_Site>;
  /** fetch data from the table in a streaming manner: "django_site" */
  django_site_stream: Array<Django_Site>;
  /** fetch data from the table: "djconfig_config" */
  djconfig_config: Array<Djconfig_Config>;
  /** fetch aggregated fields from the table: "djconfig_config" */
  djconfig_config_aggregate: Djconfig_Config_Aggregate;
  /** fetch data from the table: "djconfig_config" using primary key columns */
  djconfig_config_by_pk?: Maybe<Djconfig_Config>;
  /** fetch data from the table in a streaming manner: "djconfig_config" */
  djconfig_config_stream: Array<Djconfig_Config>;
  /** execute function "get_random_question" which returns "quiz_quiz_questions" */
  get_random_question?: Maybe<Quiz_Quiz_Questions>;
  /** execute function "get_random_question" and query aggregates on result of table type "quiz_quiz_questions" */
  get_random_question_aggregate: Quiz_Quiz_Questions_Aggregate;
  /** execute function "get_speed_concepts_all_random_questions" which returns "quiz_quiz_questions" */
  get_speed_concepts_all_random_questions: Array<Quiz_Quiz_Questions>;
  /** execute function "get_speed_concepts_all_random_questions" and query aggregates on result of table type "quiz_quiz_questions" */
  get_speed_concepts_all_random_questions_aggregate: Quiz_Quiz_Questions_Aggregate;
  /** execute function "get_speed_concepts_random_question" which returns "quiz_quiz_questions" */
  get_speed_concepts_random_question?: Maybe<Quiz_Quiz_Questions>;
  /** execute function "get_speed_concepts_random_question" and query aggregates on result of table type "quiz_quiz_questions" */
  get_speed_concepts_random_question_aggregate: Quiz_Quiz_Questions_Aggregate;
  /** fetch data from the table: "group_category" */
  group_category: Array<Group_Category>;
  /** fetch aggregated fields from the table: "group_category" */
  group_category_aggregate: Group_Category_Aggregate;
  /** fetch data from the table: "group_category" using primary key columns */
  group_category_by_pk?: Maybe<Group_Category>;
  /** fetch data from the table in a streaming manner: "group_category" */
  group_category_stream: Array<Group_Category>;
  /** fetch data from the table: "group_discount_users" */
  group_discount_users: Array<Group_Discount_Users>;
  /** fetch aggregated fields from the table: "group_discount_users" */
  group_discount_users_aggregate: Group_Discount_Users_Aggregate;
  /** fetch data from the table in a streaming manner: "group_discount_users" */
  group_discount_users_stream: Array<Group_Discount_Users>;
  /** fetch data from the table: "has_access" */
  has_access: Array<Has_Access>;
  /** fetch aggregated fields from the table: "has_access" */
  has_access_aggregate: Has_Access_Aggregate;
  /** fetch data from the table in a streaming manner: "has_access" */
  has_access_stream: Array<Has_Access>;
  /** fetch data from the table: "infozone_category" */
  infozone_category: Array<Infozone_Category>;
  /** fetch aggregated fields from the table: "infozone_category" */
  infozone_category_aggregate: Infozone_Category_Aggregate;
  /** fetch data from the table: "infozone_category" using primary key columns */
  infozone_category_by_pk?: Maybe<Infozone_Category>;
  /** fetch data from the table in a streaming manner: "infozone_category" */
  infozone_category_stream: Array<Infozone_Category>;
  /** fetch data from the table: "infozone_infozone" */
  infozone_infozone: Array<Infozone_Infozone>;
  /** fetch aggregated fields from the table: "infozone_infozone" */
  infozone_infozone_aggregate: Infozone_Infozone_Aggregate;
  /** fetch data from the table: "infozone_infozone" using primary key columns */
  infozone_infozone_by_pk?: Maybe<Infozone_Infozone>;
  /** fetch data from the table in a streaming manner: "infozone_infozone" */
  infozone_infozone_stream: Array<Infozone_Infozone>;
  /** fetch data from the table: "infozone_staticpages" */
  infozone_staticpages: Array<Infozone_Staticpages>;
  /** fetch aggregated fields from the table: "infozone_staticpages" */
  infozone_staticpages_aggregate: Infozone_Staticpages_Aggregate;
  /** fetch data from the table: "infozone_staticpages" using primary key columns */
  infozone_staticpages_by_pk?: Maybe<Infozone_Staticpages>;
  /** fetch data from the table in a streaming manner: "infozone_staticpages" */
  infozone_staticpages_stream: Array<Infozone_Staticpages>;
  /** fetch data from the table: "live_quiz_leaderboard" */
  live_quiz_leaderboard: Array<Live_Quiz_Leaderboard>;
  /** fetch aggregated fields from the table: "live_quiz_leaderboard" */
  live_quiz_leaderboard_aggregate: Live_Quiz_Leaderboard_Aggregate;
  /** fetch data from the table: "live_quiz_leaderboard" using primary key columns */
  live_quiz_leaderboard_by_pk?: Maybe<Live_Quiz_Leaderboard>;
  /** fetch data from the table in a streaming manner: "live_quiz_leaderboard" */
  live_quiz_leaderboard_stream: Array<Live_Quiz_Leaderboard>;
  /** An array relationship */
  live_quiz_question_positions: Array<Live_Quiz_Question_Positions>;
  /** An aggregate relationship */
  live_quiz_question_positions_aggregate: Live_Quiz_Question_Positions_Aggregate;
  /** fetch data from the table: "live_quiz_question_positions" using primary key columns */
  live_quiz_question_positions_by_pk?: Maybe<Live_Quiz_Question_Positions>;
  /** fetch data from the table in a streaming manner: "live_quiz_question_positions" */
  live_quiz_question_positions_stream: Array<Live_Quiz_Question_Positions>;
  /** fetch data from the table: "live_quiz_question_summary" */
  live_quiz_question_summary: Array<Live_Quiz_Question_Summary>;
  /** fetch aggregated fields from the table: "live_quiz_question_summary" */
  live_quiz_question_summary_aggregate: Live_Quiz_Question_Summary_Aggregate;
  /** fetch data from the table: "live_quiz_question_summary" using primary key columns */
  live_quiz_question_summary_by_pk?: Maybe<Live_Quiz_Question_Summary>;
  /** fetch data from the table in a streaming manner: "live_quiz_question_summary" */
  live_quiz_question_summary_stream: Array<Live_Quiz_Question_Summary>;
  /** fetch data from the table: "live_quiz_summary" */
  live_quiz_summary: Array<Live_Quiz_Summary>;
  /** fetch aggregated fields from the table: "live_quiz_summary" */
  live_quiz_summary_aggregate: Live_Quiz_Summary_Aggregate;
  /** fetch data from the table: "live_quiz_summary" using primary key columns */
  live_quiz_summary_by_pk?: Maybe<Live_Quiz_Summary>;
  /** fetch data from the table in a streaming manner: "live_quiz_summary" */
  live_quiz_summary_stream: Array<Live_Quiz_Summary>;
  /** fetch data from the table: "marks_vs_percentile_dilr" */
  marks_vs_percentile_dilr: Array<Marks_Vs_Percentile_Dilr>;
  /** fetch aggregated fields from the table: "marks_vs_percentile_dilr" */
  marks_vs_percentile_dilr_aggregate: Marks_Vs_Percentile_Dilr_Aggregate;
  /** fetch data from the table: "marks_vs_percentile_dilr" using primary key columns */
  marks_vs_percentile_dilr_by_pk?: Maybe<Marks_Vs_Percentile_Dilr>;
  /** fetch data from the table in a streaming manner: "marks_vs_percentile_dilr" */
  marks_vs_percentile_dilr_stream: Array<Marks_Vs_Percentile_Dilr>;
  /** fetch data from the table: "marks_vs_percentile_quant" */
  marks_vs_percentile_quant: Array<Marks_Vs_Percentile_Quant>;
  /** fetch aggregated fields from the table: "marks_vs_percentile_quant" */
  marks_vs_percentile_quant_aggregate: Marks_Vs_Percentile_Quant_Aggregate;
  /** fetch data from the table: "marks_vs_percentile_quant" using primary key columns */
  marks_vs_percentile_quant_by_pk?: Maybe<Marks_Vs_Percentile_Quant>;
  /** fetch data from the table in a streaming manner: "marks_vs_percentile_quant" */
  marks_vs_percentile_quant_stream: Array<Marks_Vs_Percentile_Quant>;
  /** fetch data from the table: "marks_vs_percentile_total_raw" */
  marks_vs_percentile_total_raw: Array<Marks_Vs_Percentile_Total_Raw>;
  /** fetch aggregated fields from the table: "marks_vs_percentile_total_raw" */
  marks_vs_percentile_total_raw_aggregate: Marks_Vs_Percentile_Total_Raw_Aggregate;
  /** fetch data from the table: "marks_vs_percentile_total_raw" using primary key columns */
  marks_vs_percentile_total_raw_by_pk?: Maybe<Marks_Vs_Percentile_Total_Raw>;
  /** fetch data from the table in a streaming manner: "marks_vs_percentile_total_raw" */
  marks_vs_percentile_total_raw_stream: Array<Marks_Vs_Percentile_Total_Raw>;
  /** fetch data from the table: "marks_vs_percentile_varc" */
  marks_vs_percentile_varc: Array<Marks_Vs_Percentile_Varc>;
  /** fetch aggregated fields from the table: "marks_vs_percentile_varc" */
  marks_vs_percentile_varc_aggregate: Marks_Vs_Percentile_Varc_Aggregate;
  /** fetch data from the table: "marks_vs_percentile_varc" using primary key columns */
  marks_vs_percentile_varc_by_pk?: Maybe<Marks_Vs_Percentile_Varc>;
  /** fetch data from the table in a streaming manner: "marks_vs_percentile_varc" */
  marks_vs_percentile_varc_stream: Array<Marks_Vs_Percentile_Varc>;
  /** fetch data from the table: "marks_vs_scaled_percentile" */
  marks_vs_scaled_percentile: Array<Marks_Vs_Scaled_Percentile>;
  /** fetch aggregated fields from the table: "marks_vs_scaled_percentile" */
  marks_vs_scaled_percentile_aggregate: Marks_Vs_Scaled_Percentile_Aggregate;
  /** fetch data from the table: "marks_vs_scaled_percentile" using primary key columns */
  marks_vs_scaled_percentile_by_pk?: Maybe<Marks_Vs_Scaled_Percentile>;
  /** fetch data from the table in a streaming manner: "marks_vs_scaled_percentile" */
  marks_vs_scaled_percentile_stream: Array<Marks_Vs_Scaled_Percentile>;
  /** An array relationship */
  meeting_members: Array<Meeting_Members>;
  /** An aggregate relationship */
  meeting_members_aggregate: Meeting_Members_Aggregate;
  /** fetch data from the table: "meeting_members" using primary key columns */
  meeting_members_by_pk?: Maybe<Meeting_Members>;
  /** fetch data from the table in a streaming manner: "meeting_members" */
  meeting_members_stream: Array<Meeting_Members>;
  /** fetch data from the table: "meetings" */
  meetings: Array<Meetings>;
  /** fetch aggregated fields from the table: "meetings" */
  meetings_aggregate: Meetings_Aggregate;
  /** fetch data from the table: "meetings" using primary key columns */
  meetings_by_pk?: Maybe<Meetings>;
  /** fetch data from the table in a streaming manner: "meetings" */
  meetings_stream: Array<Meetings>;
  /** fetch data from the table: "message_reactions" */
  message_reactions: Array<Message_Reactions>;
  /** fetch aggregated fields from the table: "message_reactions" */
  message_reactions_aggregate: Message_Reactions_Aggregate;
  /** fetch data from the table: "message_reactions" using primary key columns */
  message_reactions_by_pk?: Maybe<Message_Reactions>;
  /** fetch data from the table in a streaming manner: "message_reactions" */
  message_reactions_stream: Array<Message_Reactions>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  /** fetch data from the table: "messages_read" */
  messages_read: Array<Messages_Read>;
  /** fetch aggregated fields from the table: "messages_read" */
  messages_read_aggregate: Messages_Read_Aggregate;
  /** fetch data from the table: "messages_read" using primary key columns */
  messages_read_by_pk?: Maybe<Messages_Read>;
  /** fetch data from the table in a streaming manner: "messages_read" */
  messages_read_stream: Array<Messages_Read>;
  /** fetch data from the table in a streaming manner: "messages" */
  messages_stream: Array<Messages>;
  /** fetch data from the table: "offline_leads" */
  offline_leads: Array<Offline_Leads>;
  /** fetch aggregated fields from the table: "offline_leads" */
  offline_leads_aggregate: Offline_Leads_Aggregate;
  /** fetch data from the table: "offline_leads" using primary key columns */
  offline_leads_by_pk?: Maybe<Offline_Leads>;
  /** fetch data from the table in a streaming manner: "offline_leads" */
  offline_leads_stream: Array<Offline_Leads>;
  /** An array relationship */
  package_content_discarded_quizzes: Array<Package_Content_Discarded_Quizzes>;
  /** An aggregate relationship */
  package_content_discarded_quizzes_aggregate: Package_Content_Discarded_Quizzes_Aggregate;
  /** fetch data from the table: "package_content_discarded_quizzes" using primary key columns */
  package_content_discarded_quizzes_by_pk?: Maybe<Package_Content_Discarded_Quizzes>;
  /** fetch data from the table in a streaming manner: "package_content_discarded_quizzes" */
  package_content_discarded_quizzes_stream: Array<Package_Content_Discarded_Quizzes>;
  /** fetch data from the table: "packages_content" */
  packages_content: Array<Packages_Content>;
  /** fetch aggregated fields from the table: "packages_content" */
  packages_content_aggregate: Packages_Content_Aggregate;
  /** fetch data from the table: "packages_content" using primary key columns */
  packages_content_by_pk?: Maybe<Packages_Content>;
  /** An array relationship */
  packages_content_domains: Array<Packages_Content_Domains>;
  /** An aggregate relationship */
  packages_content_domains_aggregate: Packages_Content_Domains_Aggregate;
  /** fetch data from the table: "packages_content_domains" using primary key columns */
  packages_content_domains_by_pk?: Maybe<Packages_Content_Domains>;
  /** fetch data from the table in a streaming manner: "packages_content_domains" */
  packages_content_domains_stream: Array<Packages_Content_Domains>;
  /** fetch data from the table in a streaming manner: "packages_content" */
  packages_content_stream: Array<Packages_Content>;
  /** fetch data from the table: "packages_content_text_lesson" */
  packages_content_text_lesson: Array<Packages_Content_Text_Lesson>;
  /** fetch aggregated fields from the table: "packages_content_text_lesson" */
  packages_content_text_lesson_aggregate: Packages_Content_Text_Lesson_Aggregate;
  /** fetch data from the table: "packages_content_text_lesson" using primary key columns */
  packages_content_text_lesson_by_pk?: Maybe<Packages_Content_Text_Lesson>;
  /** fetch data from the table in a streaming manner: "packages_content_text_lesson" */
  packages_content_text_lesson_stream: Array<Packages_Content_Text_Lesson>;
  /** fetch data from the table: "packages_content_timed_test" */
  packages_content_timed_test: Array<Packages_Content_Timed_Test>;
  /** fetch aggregated fields from the table: "packages_content_timed_test" */
  packages_content_timed_test_aggregate: Packages_Content_Timed_Test_Aggregate;
  /** fetch data from the table: "packages_content_timed_test" using primary key columns */
  packages_content_timed_test_by_pk?: Maybe<Packages_Content_Timed_Test>;
  /** fetch data from the table in a streaming manner: "packages_content_timed_test" */
  packages_content_timed_test_stream: Array<Packages_Content_Timed_Test>;
  /** fetch data from the table: "packages_content_untimed_test" */
  packages_content_untimed_test: Array<Packages_Content_Untimed_Test>;
  /** fetch aggregated fields from the table: "packages_content_untimed_test" */
  packages_content_untimed_test_aggregate: Packages_Content_Untimed_Test_Aggregate;
  /** fetch data from the table: "packages_content_untimed_test" using primary key columns */
  packages_content_untimed_test_by_pk?: Maybe<Packages_Content_Untimed_Test>;
  /** fetch data from the table in a streaming manner: "packages_content_untimed_test" */
  packages_content_untimed_test_stream: Array<Packages_Content_Untimed_Test>;
  /** fetch data from the table: "packages_payment_transaction" */
  packages_payment_transaction: Array<Packages_Payment_Transaction>;
  /** fetch aggregated fields from the table: "packages_payment_transaction" */
  packages_payment_transaction_aggregate: Packages_Payment_Transaction_Aggregate;
  /** fetch data from the table: "packages_payment_transaction" using primary key columns */
  packages_payment_transaction_by_pk?: Maybe<Packages_Payment_Transaction>;
  /** fetch data from the table in a streaming manner: "packages_payment_transaction" */
  packages_payment_transaction_stream: Array<Packages_Payment_Transaction>;
  /** fetch data from the table: "packages_paymenttransaction" */
  packages_paymenttransaction: Array<Packages_Paymenttransaction>;
  /** fetch aggregated fields from the table: "packages_paymenttransaction" */
  packages_paymenttransaction_aggregate: Packages_Paymenttransaction_Aggregate;
  /** fetch data from the table: "packages_paymenttransaction" using primary key columns */
  packages_paymenttransaction_by_pk?: Maybe<Packages_Paymenttransaction>;
  /** fetch data from the table in a streaming manner: "packages_paymenttransaction" */
  packages_paymenttransaction_stream: Array<Packages_Paymenttransaction>;
  ping: Scalars['String']['output'];
  /** fetch data from the table: "poll" */
  poll: Array<Poll>;
  /** fetch aggregated fields from the table: "poll" */
  poll_aggregate: Poll_Aggregate;
  /** fetch data from the table: "poll" using primary key columns */
  poll_by_pk?: Maybe<Poll>;
  /** fetch data from the table: "poll_options" */
  poll_options: Array<Poll_Options>;
  /** fetch aggregated fields from the table: "poll_options" */
  poll_options_aggregate: Poll_Options_Aggregate;
  /** fetch data from the table: "poll_options" using primary key columns */
  poll_options_by_pk?: Maybe<Poll_Options>;
  /** fetch data from the table in a streaming manner: "poll_options" */
  poll_options_stream: Array<Poll_Options>;
  /** An array relationship */
  poll_responses: Array<Poll_Responses>;
  /** An aggregate relationship */
  poll_responses_aggregate: Poll_Responses_Aggregate;
  /** fetch data from the table: "poll_responses" using primary key columns */
  poll_responses_by_pk?: Maybe<Poll_Responses>;
  /** fetch data from the table in a streaming manner: "poll_responses" */
  poll_responses_stream: Array<Poll_Responses>;
  /** fetch data from the table in a streaming manner: "poll" */
  poll_stream: Array<Poll>;
  /** An array relationship */
  question_reports: Array<Question_Reports>;
  /** An aggregate relationship */
  question_reports_aggregate: Question_Reports_Aggregate;
  /** fetch data from the table: "question_reports" using primary key columns */
  question_reports_by_pk?: Maybe<Question_Reports>;
  /** fetch data from the table in a streaming manner: "question_reports" */
  question_reports_stream: Array<Question_Reports>;
  /** fetch data from the table: "quiz_answer" */
  quiz_answer: Array<Quiz_Answer>;
  /** fetch aggregated fields from the table: "quiz_answer" */
  quiz_answer_aggregate: Quiz_Answer_Aggregate;
  /** fetch data from the table: "quiz_answer" using primary key columns */
  quiz_answer_by_pk?: Maybe<Quiz_Answer>;
  /** fetch data from the table in a streaming manner: "quiz_answer" */
  quiz_answer_stream: Array<Quiz_Answer>;
  /** fetch data from the table: "quiz_category" */
  quiz_category: Array<Quiz_Category>;
  /** fetch aggregated fields from the table: "quiz_category" */
  quiz_category_aggregate: Quiz_Category_Aggregate;
  /** fetch data from the table: "quiz_category" using primary key columns */
  quiz_category_by_pk?: Maybe<Quiz_Category>;
  /** fetch data from the table in a streaming manner: "quiz_category" */
  quiz_category_stream: Array<Quiz_Category>;
  /** fetch data from the table: "quiz_domain" */
  quiz_domain: Array<Quiz_Domain>;
  /** fetch aggregated fields from the table: "quiz_domain" */
  quiz_domain_aggregate: Quiz_Domain_Aggregate;
  /** fetch data from the table: "quiz_domain" using primary key columns */
  quiz_domain_by_pk?: Maybe<Quiz_Domain>;
  /** fetch data from the table in a streaming manner: "quiz_domain" */
  quiz_domain_stream: Array<Quiz_Domain>;
  /** fetch data from the table: "quiz_markingsystem" */
  quiz_markingsystem: Array<Quiz_Markingsystem>;
  /** fetch aggregated fields from the table: "quiz_markingsystem" */
  quiz_markingsystem_aggregate: Quiz_Markingsystem_Aggregate;
  /** fetch data from the table: "quiz_markingsystem" using primary key columns */
  quiz_markingsystem_by_pk?: Maybe<Quiz_Markingsystem>;
  /** fetch data from the table in a streaming manner: "quiz_markingsystem" */
  quiz_markingsystem_stream: Array<Quiz_Markingsystem>;
  /** fetch data from the table: "quiz_option" */
  quiz_option: Array<Quiz_Option>;
  /** fetch aggregated fields from the table: "quiz_option" */
  quiz_option_aggregate: Quiz_Option_Aggregate;
  /** fetch data from the table: "quiz_option" using primary key columns */
  quiz_option_by_pk?: Maybe<Quiz_Option>;
  /** fetch data from the table in a streaming manner: "quiz_option" */
  quiz_option_stream: Array<Quiz_Option>;
  /** fetch data from the table: "quiz_paragraph" */
  quiz_paragraph: Array<Quiz_Paragraph>;
  /** fetch aggregated fields from the table: "quiz_paragraph" */
  quiz_paragraph_aggregate: Quiz_Paragraph_Aggregate;
  /** fetch data from the table: "quiz_paragraph" using primary key columns */
  quiz_paragraph_by_pk?: Maybe<Quiz_Paragraph>;
  /** fetch data from the table in a streaming manner: "quiz_paragraph" */
  quiz_paragraph_stream: Array<Quiz_Paragraph>;
  /** fetch data from the table: "quiz_question" */
  quiz_question: Array<Quiz_Question>;
  /** fetch aggregated fields from the table: "quiz_question" */
  quiz_question_aggregate: Quiz_Question_Aggregate;
  /** fetch data from the table: "quiz_question" using primary key columns */
  quiz_question_by_pk?: Maybe<Quiz_Question>;
  /** fetch data from the table in a streaming manner: "quiz_question" */
  quiz_question_stream: Array<Quiz_Question>;
  /** fetch data from the table: "quiz_quiz" */
  quiz_quiz: Array<Quiz_Quiz>;
  /** fetch aggregated fields from the table: "quiz_quiz" */
  quiz_quiz_aggregate: Quiz_Quiz_Aggregate;
  /** fetch data from the table: "quiz_quiz" using primary key columns */
  quiz_quiz_by_pk?: Maybe<Quiz_Quiz>;
  /** An array relationship */
  quiz_quiz_questions: Array<Quiz_Quiz_Questions>;
  /** An aggregate relationship */
  quiz_quiz_questions_aggregate: Quiz_Quiz_Questions_Aggregate;
  /** fetch data from the table: "quiz_quiz_questions" using primary key columns */
  quiz_quiz_questions_by_pk?: Maybe<Quiz_Quiz_Questions>;
  /** fetch data from the table in a streaming manner: "quiz_quiz_questions" */
  quiz_quiz_questions_stream: Array<Quiz_Quiz_Questions>;
  /** An array relationship */
  quiz_quiz_sections: Array<Quiz_Quiz_Sections>;
  /** An aggregate relationship */
  quiz_quiz_sections_aggregate: Quiz_Quiz_Sections_Aggregate;
  /** fetch data from the table: "quiz_quiz_sections" using primary key columns */
  quiz_quiz_sections_by_pk?: Maybe<Quiz_Quiz_Sections>;
  /** fetch data from the table in a streaming manner: "quiz_quiz_sections" */
  quiz_quiz_sections_stream: Array<Quiz_Quiz_Sections>;
  /** fetch data from the table in a streaming manner: "quiz_quiz" */
  quiz_quiz_stream: Array<Quiz_Quiz>;
  /** fetch data from the table: "quiz_section" */
  quiz_section: Array<Quiz_Section>;
  /** fetch aggregated fields from the table: "quiz_section" */
  quiz_section_aggregate: Quiz_Section_Aggregate;
  /** fetch data from the table: "quiz_section" using primary key columns */
  quiz_section_by_pk?: Maybe<Quiz_Section>;
  /** An array relationship */
  quiz_section_questions: Array<Quiz_Section_Questions>;
  /** An aggregate relationship */
  quiz_section_questions_aggregate: Quiz_Section_Questions_Aggregate;
  /** fetch data from the table: "quiz_section_questions" using primary key columns */
  quiz_section_questions_by_pk?: Maybe<Quiz_Section_Questions>;
  /** fetch data from the table in a streaming manner: "quiz_section_questions" */
  quiz_section_questions_stream: Array<Quiz_Section_Questions>;
  /** fetch data from the table in a streaming manner: "quiz_section" */
  quiz_section_stream: Array<Quiz_Section>;
  /** An array relationship */
  quiz_section_subsections: Array<Quiz_Section_Subsections>;
  /** An aggregate relationship */
  quiz_section_subsections_aggregate: Quiz_Section_Subsections_Aggregate;
  /** fetch data from the table: "quiz_section_subsections" using primary key columns */
  quiz_section_subsections_by_pk?: Maybe<Quiz_Section_Subsections>;
  /** fetch data from the table in a streaming manner: "quiz_section_subsections" */
  quiz_section_subsections_stream: Array<Quiz_Section_Subsections>;
  /** fetch data from the table: "quiz_superdomain" */
  quiz_superdomain: Array<Quiz_Superdomain>;
  /** fetch aggregated fields from the table: "quiz_superdomain" */
  quiz_superdomain_aggregate: Quiz_Superdomain_Aggregate;
  /** fetch data from the table: "quiz_superdomain" using primary key columns */
  quiz_superdomain_by_pk?: Maybe<Quiz_Superdomain>;
  /** fetch data from the table in a streaming manner: "quiz_superdomain" */
  quiz_superdomain_stream: Array<Quiz_Superdomain>;
  /** fetch data from the table: "random_question_ids" */
  random_question_ids: Array<Random_Question_Ids>;
  /** fetch aggregated fields from the table: "random_question_ids" */
  random_question_ids_aggregate: Random_Question_Ids_Aggregate;
  /** fetch data from the table in a streaming manner: "random_question_ids" */
  random_question_ids_stream: Array<Random_Question_Ids>;
  /** fetch data from the table: "reaction_emojis" */
  reaction_emojis: Array<Reaction_Emojis>;
  /** fetch aggregated fields from the table: "reaction_emojis" */
  reaction_emojis_aggregate: Reaction_Emojis_Aggregate;
  /** fetch data from the table: "reaction_emojis" using primary key columns */
  reaction_emojis_by_pk?: Maybe<Reaction_Emojis>;
  /** fetch data from the table in a streaming manner: "reaction_emojis" */
  reaction_emojis_stream: Array<Reaction_Emojis>;
  /** fetch data from the table: "reported_message" */
  reported_message: Array<Reported_Message>;
  /** fetch aggregated fields from the table: "reported_message" */
  reported_message_aggregate: Reported_Message_Aggregate;
  /** fetch data from the table: "reported_message" using primary key columns */
  reported_message_by_pk?: Maybe<Reported_Message>;
  /** fetch data from the table in a streaming manner: "reported_message" */
  reported_message_stream: Array<Reported_Message>;
  /** fetch data from the table: "scaling_constant" */
  scaling_constant: Array<Scaling_Constant>;
  /** fetch aggregated fields from the table: "scaling_constant" */
  scaling_constant_aggregate: Scaling_Constant_Aggregate;
  /** fetch data from the table: "scaling_constant" using primary key columns */
  scaling_constant_by_pk?: Maybe<Scaling_Constant>;
  /** fetch data from the table in a streaming manner: "scaling_constant" */
  scaling_constant_stream: Array<Scaling_Constant>;
  /** fetch data from the table: "socialaccount_socialaccount" */
  socialaccount_socialaccount: Array<Socialaccount_Socialaccount>;
  /** fetch aggregated fields from the table: "socialaccount_socialaccount" */
  socialaccount_socialaccount_aggregate: Socialaccount_Socialaccount_Aggregate;
  /** fetch data from the table: "socialaccount_socialaccount" using primary key columns */
  socialaccount_socialaccount_by_pk?: Maybe<Socialaccount_Socialaccount>;
  /** fetch data from the table in a streaming manner: "socialaccount_socialaccount" */
  socialaccount_socialaccount_stream: Array<Socialaccount_Socialaccount>;
  /** fetch data from the table: "socialaccount_socialapp" */
  socialaccount_socialapp: Array<Socialaccount_Socialapp>;
  /** fetch aggregated fields from the table: "socialaccount_socialapp" */
  socialaccount_socialapp_aggregate: Socialaccount_Socialapp_Aggregate;
  /** fetch data from the table: "socialaccount_socialapp" using primary key columns */
  socialaccount_socialapp_by_pk?: Maybe<Socialaccount_Socialapp>;
  /** An array relationship */
  socialaccount_socialapp_sites: Array<Socialaccount_Socialapp_Sites>;
  /** An aggregate relationship */
  socialaccount_socialapp_sites_aggregate: Socialaccount_Socialapp_Sites_Aggregate;
  /** fetch data from the table: "socialaccount_socialapp_sites" using primary key columns */
  socialaccount_socialapp_sites_by_pk?: Maybe<Socialaccount_Socialapp_Sites>;
  /** fetch data from the table in a streaming manner: "socialaccount_socialapp_sites" */
  socialaccount_socialapp_sites_stream: Array<Socialaccount_Socialapp_Sites>;
  /** fetch data from the table in a streaming manner: "socialaccount_socialapp" */
  socialaccount_socialapp_stream: Array<Socialaccount_Socialapp>;
  /** fetch data from the table: "socialaccount_socialtoken" */
  socialaccount_socialtoken: Array<Socialaccount_Socialtoken>;
  /** fetch aggregated fields from the table: "socialaccount_socialtoken" */
  socialaccount_socialtoken_aggregate: Socialaccount_Socialtoken_Aggregate;
  /** fetch data from the table: "socialaccount_socialtoken" using primary key columns */
  socialaccount_socialtoken_by_pk?: Maybe<Socialaccount_Socialtoken>;
  /** fetch data from the table in a streaming manner: "socialaccount_socialtoken" */
  socialaccount_socialtoken_stream: Array<Socialaccount_Socialtoken>;
  /** fetch data from the table: "speed_test_category" */
  speed_test_category: Array<Speed_Test_Category>;
  /** fetch aggregated fields from the table: "speed_test_category" */
  speed_test_category_aggregate: Speed_Test_Category_Aggregate;
  /** fetch data from the table: "speed_test_category" using primary key columns */
  speed_test_category_by_pk?: Maybe<Speed_Test_Category>;
  /** fetch data from the table in a streaming manner: "speed_test_category" */
  speed_test_category_stream: Array<Speed_Test_Category>;
  /** An array relationship */
  speed_tests: Array<Speed_Tests>;
  /** An aggregate relationship */
  speed_tests_aggregate: Speed_Tests_Aggregate;
  /** fetch data from the table: "speed_tests" using primary key columns */
  speed_tests_by_pk?: Maybe<Speed_Tests>;
  /** fetch data from the table in a streaming manner: "speed_tests" */
  speed_tests_stream: Array<Speed_Tests>;
  /** fetch data from the table: "spirit_cache" */
  spirit_cache: Array<Spirit_Cache>;
  /** fetch aggregated fields from the table: "spirit_cache" */
  spirit_cache_aggregate: Spirit_Cache_Aggregate;
  /** fetch data from the table: "spirit_cache" using primary key columns */
  spirit_cache_by_pk?: Maybe<Spirit_Cache>;
  /** fetch data from the table in a streaming manner: "spirit_cache" */
  spirit_cache_stream: Array<Spirit_Cache>;
  /** fetch data from the table: "spirit_category_category" */
  spirit_category_category: Array<Spirit_Category_Category>;
  /** fetch aggregated fields from the table: "spirit_category_category" */
  spirit_category_category_aggregate: Spirit_Category_Category_Aggregate;
  /** fetch data from the table: "spirit_category_category" using primary key columns */
  spirit_category_category_by_pk?: Maybe<Spirit_Category_Category>;
  /** fetch data from the table in a streaming manner: "spirit_category_category" */
  spirit_category_category_stream: Array<Spirit_Category_Category>;
  /** fetch data from the table: "spirit_comment_bookmark_commentbookmark" */
  spirit_comment_bookmark_commentbookmark: Array<Spirit_Comment_Bookmark_Commentbookmark>;
  /** fetch aggregated fields from the table: "spirit_comment_bookmark_commentbookmark" */
  spirit_comment_bookmark_commentbookmark_aggregate: Spirit_Comment_Bookmark_Commentbookmark_Aggregate;
  /** fetch data from the table: "spirit_comment_bookmark_commentbookmark" using primary key columns */
  spirit_comment_bookmark_commentbookmark_by_pk?: Maybe<Spirit_Comment_Bookmark_Commentbookmark>;
  /** fetch data from the table in a streaming manner: "spirit_comment_bookmark_commentbookmark" */
  spirit_comment_bookmark_commentbookmark_stream: Array<Spirit_Comment_Bookmark_Commentbookmark>;
  /** fetch data from the table: "spirit_comment_comment" */
  spirit_comment_comment: Array<Spirit_Comment_Comment>;
  /** fetch aggregated fields from the table: "spirit_comment_comment" */
  spirit_comment_comment_aggregate: Spirit_Comment_Comment_Aggregate;
  /** fetch data from the table: "spirit_comment_comment" using primary key columns */
  spirit_comment_comment_by_pk?: Maybe<Spirit_Comment_Comment>;
  /** fetch data from the table in a streaming manner: "spirit_comment_comment" */
  spirit_comment_comment_stream: Array<Spirit_Comment_Comment>;
  /** fetch data from the table: "spirit_comment_flag_commentflag" */
  spirit_comment_flag_commentflag: Array<Spirit_Comment_Flag_Commentflag>;
  /** fetch aggregated fields from the table: "spirit_comment_flag_commentflag" */
  spirit_comment_flag_commentflag_aggregate: Spirit_Comment_Flag_Commentflag_Aggregate;
  /** fetch data from the table: "spirit_comment_flag_commentflag" using primary key columns */
  spirit_comment_flag_commentflag_by_pk?: Maybe<Spirit_Comment_Flag_Commentflag>;
  /** fetch data from the table in a streaming manner: "spirit_comment_flag_commentflag" */
  spirit_comment_flag_commentflag_stream: Array<Spirit_Comment_Flag_Commentflag>;
  /** fetch data from the table: "spirit_comment_flag_flag" */
  spirit_comment_flag_flag: Array<Spirit_Comment_Flag_Flag>;
  /** fetch aggregated fields from the table: "spirit_comment_flag_flag" */
  spirit_comment_flag_flag_aggregate: Spirit_Comment_Flag_Flag_Aggregate;
  /** fetch data from the table: "spirit_comment_flag_flag" using primary key columns */
  spirit_comment_flag_flag_by_pk?: Maybe<Spirit_Comment_Flag_Flag>;
  /** fetch data from the table in a streaming manner: "spirit_comment_flag_flag" */
  spirit_comment_flag_flag_stream: Array<Spirit_Comment_Flag_Flag>;
  /** fetch data from the table: "spirit_comment_history_commenthistory" */
  spirit_comment_history_commenthistory: Array<Spirit_Comment_History_Commenthistory>;
  /** fetch aggregated fields from the table: "spirit_comment_history_commenthistory" */
  spirit_comment_history_commenthistory_aggregate: Spirit_Comment_History_Commenthistory_Aggregate;
  /** fetch data from the table: "spirit_comment_history_commenthistory" using primary key columns */
  spirit_comment_history_commenthistory_by_pk?: Maybe<Spirit_Comment_History_Commenthistory>;
  /** fetch data from the table in a streaming manner: "spirit_comment_history_commenthistory" */
  spirit_comment_history_commenthistory_stream: Array<Spirit_Comment_History_Commenthistory>;
  /** fetch data from the table: "spirit_comment_like_commentlike" */
  spirit_comment_like_commentlike: Array<Spirit_Comment_Like_Commentlike>;
  /** fetch aggregated fields from the table: "spirit_comment_like_commentlike" */
  spirit_comment_like_commentlike_aggregate: Spirit_Comment_Like_Commentlike_Aggregate;
  /** fetch data from the table: "spirit_comment_like_commentlike" using primary key columns */
  spirit_comment_like_commentlike_by_pk?: Maybe<Spirit_Comment_Like_Commentlike>;
  /** fetch data from the table in a streaming manner: "spirit_comment_like_commentlike" */
  spirit_comment_like_commentlike_stream: Array<Spirit_Comment_Like_Commentlike>;
  /** fetch data from the table: "spirit_comment_poll_commentpoll" */
  spirit_comment_poll_commentpoll: Array<Spirit_Comment_Poll_Commentpoll>;
  /** fetch aggregated fields from the table: "spirit_comment_poll_commentpoll" */
  spirit_comment_poll_commentpoll_aggregate: Spirit_Comment_Poll_Commentpoll_Aggregate;
  /** fetch data from the table: "spirit_comment_poll_commentpoll" using primary key columns */
  spirit_comment_poll_commentpoll_by_pk?: Maybe<Spirit_Comment_Poll_Commentpoll>;
  /** fetch data from the table in a streaming manner: "spirit_comment_poll_commentpoll" */
  spirit_comment_poll_commentpoll_stream: Array<Spirit_Comment_Poll_Commentpoll>;
  /** fetch data from the table: "spirit_comment_poll_commentpollchoice" */
  spirit_comment_poll_commentpollchoice: Array<Spirit_Comment_Poll_Commentpollchoice>;
  /** fetch aggregated fields from the table: "spirit_comment_poll_commentpollchoice" */
  spirit_comment_poll_commentpollchoice_aggregate: Spirit_Comment_Poll_Commentpollchoice_Aggregate;
  /** fetch data from the table: "spirit_comment_poll_commentpollchoice" using primary key columns */
  spirit_comment_poll_commentpollchoice_by_pk?: Maybe<Spirit_Comment_Poll_Commentpollchoice>;
  /** fetch data from the table in a streaming manner: "spirit_comment_poll_commentpollchoice" */
  spirit_comment_poll_commentpollchoice_stream: Array<Spirit_Comment_Poll_Commentpollchoice>;
  /** fetch data from the table: "spirit_comment_poll_commentpollvote" */
  spirit_comment_poll_commentpollvote: Array<Spirit_Comment_Poll_Commentpollvote>;
  /** fetch aggregated fields from the table: "spirit_comment_poll_commentpollvote" */
  spirit_comment_poll_commentpollvote_aggregate: Spirit_Comment_Poll_Commentpollvote_Aggregate;
  /** fetch data from the table: "spirit_comment_poll_commentpollvote" using primary key columns */
  spirit_comment_poll_commentpollvote_by_pk?: Maybe<Spirit_Comment_Poll_Commentpollvote>;
  /** fetch data from the table in a streaming manner: "spirit_comment_poll_commentpollvote" */
  spirit_comment_poll_commentpollvote_stream: Array<Spirit_Comment_Poll_Commentpollvote>;
  /** fetch data from the table: "spirit_rl_cache" */
  spirit_rl_cache: Array<Spirit_Rl_Cache>;
  /** fetch aggregated fields from the table: "spirit_rl_cache" */
  spirit_rl_cache_aggregate: Spirit_Rl_Cache_Aggregate;
  /** fetch data from the table: "spirit_rl_cache" using primary key columns */
  spirit_rl_cache_by_pk?: Maybe<Spirit_Rl_Cache>;
  /** fetch data from the table in a streaming manner: "spirit_rl_cache" */
  spirit_rl_cache_stream: Array<Spirit_Rl_Cache>;
  /** fetch data from the table: "spirit_topic_favorite_topicfavorite" */
  spirit_topic_favorite_topicfavorite: Array<Spirit_Topic_Favorite_Topicfavorite>;
  /** fetch aggregated fields from the table: "spirit_topic_favorite_topicfavorite" */
  spirit_topic_favorite_topicfavorite_aggregate: Spirit_Topic_Favorite_Topicfavorite_Aggregate;
  /** fetch data from the table: "spirit_topic_favorite_topicfavorite" using primary key columns */
  spirit_topic_favorite_topicfavorite_by_pk?: Maybe<Spirit_Topic_Favorite_Topicfavorite>;
  /** fetch data from the table in a streaming manner: "spirit_topic_favorite_topicfavorite" */
  spirit_topic_favorite_topicfavorite_stream: Array<Spirit_Topic_Favorite_Topicfavorite>;
  /** fetch data from the table: "spirit_topic_notification_topicnotification" */
  spirit_topic_notification_topicnotification: Array<Spirit_Topic_Notification_Topicnotification>;
  /** fetch aggregated fields from the table: "spirit_topic_notification_topicnotification" */
  spirit_topic_notification_topicnotification_aggregate: Spirit_Topic_Notification_Topicnotification_Aggregate;
  /** fetch data from the table: "spirit_topic_notification_topicnotification" using primary key columns */
  spirit_topic_notification_topicnotification_by_pk?: Maybe<Spirit_Topic_Notification_Topicnotification>;
  /** fetch data from the table in a streaming manner: "spirit_topic_notification_topicnotification" */
  spirit_topic_notification_topicnotification_stream: Array<Spirit_Topic_Notification_Topicnotification>;
  /** fetch data from the table: "spirit_topic_private_topicprivate" */
  spirit_topic_private_topicprivate: Array<Spirit_Topic_Private_Topicprivate>;
  /** fetch aggregated fields from the table: "spirit_topic_private_topicprivate" */
  spirit_topic_private_topicprivate_aggregate: Spirit_Topic_Private_Topicprivate_Aggregate;
  /** fetch data from the table: "spirit_topic_private_topicprivate" using primary key columns */
  spirit_topic_private_topicprivate_by_pk?: Maybe<Spirit_Topic_Private_Topicprivate>;
  /** fetch data from the table in a streaming manner: "spirit_topic_private_topicprivate" */
  spirit_topic_private_topicprivate_stream: Array<Spirit_Topic_Private_Topicprivate>;
  /** fetch data from the table: "spirit_topic_topic" */
  spirit_topic_topic: Array<Spirit_Topic_Topic>;
  /** fetch aggregated fields from the table: "spirit_topic_topic" */
  spirit_topic_topic_aggregate: Spirit_Topic_Topic_Aggregate;
  /** fetch data from the table: "spirit_topic_topic" using primary key columns */
  spirit_topic_topic_by_pk?: Maybe<Spirit_Topic_Topic>;
  /** fetch data from the table in a streaming manner: "spirit_topic_topic" */
  spirit_topic_topic_stream: Array<Spirit_Topic_Topic>;
  /** fetch data from the table: "spirit_topic_unread_topicunread" */
  spirit_topic_unread_topicunread: Array<Spirit_Topic_Unread_Topicunread>;
  /** fetch aggregated fields from the table: "spirit_topic_unread_topicunread" */
  spirit_topic_unread_topicunread_aggregate: Spirit_Topic_Unread_Topicunread_Aggregate;
  /** fetch data from the table: "spirit_topic_unread_topicunread" using primary key columns */
  spirit_topic_unread_topicunread_by_pk?: Maybe<Spirit_Topic_Unread_Topicunread>;
  /** fetch data from the table in a streaming manner: "spirit_topic_unread_topicunread" */
  spirit_topic_unread_topicunread_stream: Array<Spirit_Topic_Unread_Topicunread>;
  /** fetch data from the table: "spirit_user_userprofile" */
  spirit_user_userprofile: Array<Spirit_User_Userprofile>;
  /** fetch aggregated fields from the table: "spirit_user_userprofile" */
  spirit_user_userprofile_aggregate: Spirit_User_Userprofile_Aggregate;
  /** fetch data from the table: "spirit_user_userprofile" using primary key columns */
  spirit_user_userprofile_by_pk?: Maybe<Spirit_User_Userprofile>;
  /** fetch data from the table in a streaming manner: "spirit_user_userprofile" */
  spirit_user_userprofile_stream: Array<Spirit_User_Userprofile>;
  /** fetch data from the table: "subscription_group_plan" */
  subscription_group_plan: Array<Subscription_Group_Plan>;
  /** fetch aggregated fields from the table: "subscription_group_plan" */
  subscription_group_plan_aggregate: Subscription_Group_Plan_Aggregate;
  /** fetch data from the table: "subscription_group_plan" using primary key columns */
  subscription_group_plan_by_pk?: Maybe<Subscription_Group_Plan>;
  /** An array relationship */
  subscription_group_plan_groups: Array<Subscription_Group_Plan_Groups>;
  /** An aggregate relationship */
  subscription_group_plan_groups_aggregate: Subscription_Group_Plan_Groups_Aggregate;
  /** fetch data from the table: "subscription_group_plan_groups" using primary key columns */
  subscription_group_plan_groups_by_pk?: Maybe<Subscription_Group_Plan_Groups>;
  /** fetch data from the table in a streaming manner: "subscription_group_plan_groups" */
  subscription_group_plan_groups_stream: Array<Subscription_Group_Plan_Groups>;
  /** fetch data from the table in a streaming manner: "subscription_group_plan" */
  subscription_group_plan_stream: Array<Subscription_Group_Plan>;
  /** fetch data from the table: "subscriptions_plancost" */
  subscriptions_plancost: Array<Subscriptions_Plancost>;
  /** fetch aggregated fields from the table: "subscriptions_plancost" */
  subscriptions_plancost_aggregate: Subscriptions_Plancost_Aggregate;
  /** fetch data from the table: "subscriptions_plancost" using primary key columns */
  subscriptions_plancost_by_pk?: Maybe<Subscriptions_Plancost>;
  /** fetch data from the table in a streaming manner: "subscriptions_plancost" */
  subscriptions_plancost_stream: Array<Subscriptions_Plancost>;
  /** fetch data from the table: "subscriptions_planlist" */
  subscriptions_planlist: Array<Subscriptions_Planlist>;
  /** fetch aggregated fields from the table: "subscriptions_planlist" */
  subscriptions_planlist_aggregate: Subscriptions_Planlist_Aggregate;
  /** fetch data from the table: "subscriptions_planlist" using primary key columns */
  subscriptions_planlist_by_pk?: Maybe<Subscriptions_Planlist>;
  /** fetch data from the table in a streaming manner: "subscriptions_planlist" */
  subscriptions_planlist_stream: Array<Subscriptions_Planlist>;
  /** fetch data from the table: "subscriptions_planlistdetail" */
  subscriptions_planlistdetail: Array<Subscriptions_Planlistdetail>;
  /** fetch aggregated fields from the table: "subscriptions_planlistdetail" */
  subscriptions_planlistdetail_aggregate: Subscriptions_Planlistdetail_Aggregate;
  /** fetch data from the table: "subscriptions_planlistdetail" using primary key columns */
  subscriptions_planlistdetail_by_pk?: Maybe<Subscriptions_Planlistdetail>;
  /** fetch data from the table in a streaming manner: "subscriptions_planlistdetail" */
  subscriptions_planlistdetail_stream: Array<Subscriptions_Planlistdetail>;
  /** fetch data from the table: "subscriptions_plantag" */
  subscriptions_plantag: Array<Subscriptions_Plantag>;
  /** fetch aggregated fields from the table: "subscriptions_plantag" */
  subscriptions_plantag_aggregate: Subscriptions_Plantag_Aggregate;
  /** fetch data from the table: "subscriptions_plantag" using primary key columns */
  subscriptions_plantag_by_pk?: Maybe<Subscriptions_Plantag>;
  /** fetch data from the table in a streaming manner: "subscriptions_plantag" */
  subscriptions_plantag_stream: Array<Subscriptions_Plantag>;
  /** fetch data from the table: "subscriptions_subscriptionplan" */
  subscriptions_subscriptionplan: Array<Subscriptions_Subscriptionplan>;
  /** fetch aggregated fields from the table: "subscriptions_subscriptionplan" */
  subscriptions_subscriptionplan_aggregate: Subscriptions_Subscriptionplan_Aggregate;
  /** fetch data from the table: "subscriptions_subscriptionplan" using primary key columns */
  subscriptions_subscriptionplan_by_pk?: Maybe<Subscriptions_Subscriptionplan>;
  /** fetch data from the table in a streaming manner: "subscriptions_subscriptionplan" */
  subscriptions_subscriptionplan_stream: Array<Subscriptions_Subscriptionplan>;
  /** An array relationship */
  subscriptions_subscriptionplan_upgradable_plans: Array<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** An aggregate relationship */
  subscriptions_subscriptionplan_upgradable_plans_aggregate: Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate;
  /** fetch data from the table: "subscriptions_subscriptionplan_upgradable_plans" using primary key columns */
  subscriptions_subscriptionplan_upgradable_plans_by_pk?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** fetch data from the table in a streaming manner: "subscriptions_subscriptionplan_upgradable_plans" */
  subscriptions_subscriptionplan_upgradable_plans_stream: Array<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** fetch data from the table: "subscriptions_subscriptiontransaction" */
  subscriptions_subscriptiontransaction: Array<Subscriptions_Subscriptiontransaction>;
  /** fetch aggregated fields from the table: "subscriptions_subscriptiontransaction" */
  subscriptions_subscriptiontransaction_aggregate: Subscriptions_Subscriptiontransaction_Aggregate;
  /** fetch data from the table: "subscriptions_subscriptiontransaction" using primary key columns */
  subscriptions_subscriptiontransaction_by_pk?: Maybe<Subscriptions_Subscriptiontransaction>;
  /** fetch data from the table in a streaming manner: "subscriptions_subscriptiontransaction" */
  subscriptions_subscriptiontransaction_stream: Array<Subscriptions_Subscriptiontransaction>;
  /** fetch data from the table: "subscriptions_usersubscription" */
  subscriptions_usersubscription: Array<Subscriptions_Usersubscription>;
  /** fetch aggregated fields from the table: "subscriptions_usersubscription" */
  subscriptions_usersubscription_aggregate: Subscriptions_Usersubscription_Aggregate;
  /** fetch data from the table: "subscriptions_usersubscription" using primary key columns */
  subscriptions_usersubscription_by_pk?: Maybe<Subscriptions_Usersubscription>;
  /** fetch data from the table in a streaming manner: "subscriptions_usersubscription" */
  subscriptions_usersubscription_stream: Array<Subscriptions_Usersubscription>;
  /** fetch data from the table: "supertokens.all_auth_recipe_users" */
  supertokens_all_auth_recipe_users: Array<Supertokens_All_Auth_Recipe_Users>;
  /** fetch aggregated fields from the table: "supertokens.all_auth_recipe_users" */
  supertokens_all_auth_recipe_users_aggregate: Supertokens_All_Auth_Recipe_Users_Aggregate;
  /** fetch data from the table: "supertokens.all_auth_recipe_users" using primary key columns */
  supertokens_all_auth_recipe_users_by_pk?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  /** fetch data from the table in a streaming manner: "supertokens.all_auth_recipe_users" */
  supertokens_all_auth_recipe_users_stream: Array<Supertokens_All_Auth_Recipe_Users>;
  /** fetch data from the table: "supertokens.app_id_to_user_id" */
  supertokens_app_id_to_user_id: Array<Supertokens_App_Id_To_User_Id>;
  /** fetch aggregated fields from the table: "supertokens.app_id_to_user_id" */
  supertokens_app_id_to_user_id_aggregate: Supertokens_App_Id_To_User_Id_Aggregate;
  /** fetch data from the table: "supertokens.app_id_to_user_id" using primary key columns */
  supertokens_app_id_to_user_id_by_pk?: Maybe<Supertokens_App_Id_To_User_Id>;
  /** fetch data from the table in a streaming manner: "supertokens.app_id_to_user_id" */
  supertokens_app_id_to_user_id_stream: Array<Supertokens_App_Id_To_User_Id>;
  /** fetch data from the table: "supertokens.apps" */
  supertokens_apps: Array<Supertokens_Apps>;
  /** fetch aggregated fields from the table: "supertokens.apps" */
  supertokens_apps_aggregate: Supertokens_Apps_Aggregate;
  /** fetch data from the table: "supertokens.apps" using primary key columns */
  supertokens_apps_by_pk?: Maybe<Supertokens_Apps>;
  /** fetch data from the table in a streaming manner: "supertokens.apps" */
  supertokens_apps_stream: Array<Supertokens_Apps>;
  /** fetch data from the table: "supertokens.dashboard_user_sessions" */
  supertokens_dashboard_user_sessions: Array<Supertokens_Dashboard_User_Sessions>;
  /** fetch aggregated fields from the table: "supertokens.dashboard_user_sessions" */
  supertokens_dashboard_user_sessions_aggregate: Supertokens_Dashboard_User_Sessions_Aggregate;
  /** fetch data from the table: "supertokens.dashboard_user_sessions" using primary key columns */
  supertokens_dashboard_user_sessions_by_pk?: Maybe<Supertokens_Dashboard_User_Sessions>;
  /** fetch data from the table in a streaming manner: "supertokens.dashboard_user_sessions" */
  supertokens_dashboard_user_sessions_stream: Array<Supertokens_Dashboard_User_Sessions>;
  /** fetch data from the table: "supertokens.dashboard_users" */
  supertokens_dashboard_users: Array<Supertokens_Dashboard_Users>;
  /** fetch aggregated fields from the table: "supertokens.dashboard_users" */
  supertokens_dashboard_users_aggregate: Supertokens_Dashboard_Users_Aggregate;
  /** fetch data from the table: "supertokens.dashboard_users" using primary key columns */
  supertokens_dashboard_users_by_pk?: Maybe<Supertokens_Dashboard_Users>;
  /** fetch data from the table in a streaming manner: "supertokens.dashboard_users" */
  supertokens_dashboard_users_stream: Array<Supertokens_Dashboard_Users>;
  /** fetch data from the table: "supertokens.emailpassword_pswd_reset_tokens" */
  supertokens_emailpassword_pswd_reset_tokens: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
  /** fetch aggregated fields from the table: "supertokens.emailpassword_pswd_reset_tokens" */
  supertokens_emailpassword_pswd_reset_tokens_aggregate: Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate;
  /** fetch data from the table: "supertokens.emailpassword_pswd_reset_tokens" using primary key columns */
  supertokens_emailpassword_pswd_reset_tokens_by_pk?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
  /** fetch data from the table in a streaming manner: "supertokens.emailpassword_pswd_reset_tokens" */
  supertokens_emailpassword_pswd_reset_tokens_stream: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
  /** fetch data from the table: "supertokens.emailpassword_user_to_tenant" */
  supertokens_emailpassword_user_to_tenant: Array<Supertokens_Emailpassword_User_To_Tenant>;
  /** fetch aggregated fields from the table: "supertokens.emailpassword_user_to_tenant" */
  supertokens_emailpassword_user_to_tenant_aggregate: Supertokens_Emailpassword_User_To_Tenant_Aggregate;
  /** fetch data from the table: "supertokens.emailpassword_user_to_tenant" using primary key columns */
  supertokens_emailpassword_user_to_tenant_by_pk?: Maybe<Supertokens_Emailpassword_User_To_Tenant>;
  /** fetch data from the table in a streaming manner: "supertokens.emailpassword_user_to_tenant" */
  supertokens_emailpassword_user_to_tenant_stream: Array<Supertokens_Emailpassword_User_To_Tenant>;
  /** fetch data from the table: "supertokens.emailpassword_users" */
  supertokens_emailpassword_users: Array<Supertokens_Emailpassword_Users>;
  /** fetch aggregated fields from the table: "supertokens.emailpassword_users" */
  supertokens_emailpassword_users_aggregate: Supertokens_Emailpassword_Users_Aggregate;
  /** fetch data from the table: "supertokens.emailpassword_users" using primary key columns */
  supertokens_emailpassword_users_by_pk?: Maybe<Supertokens_Emailpassword_Users>;
  /** fetch data from the table in a streaming manner: "supertokens.emailpassword_users" */
  supertokens_emailpassword_users_stream: Array<Supertokens_Emailpassword_Users>;
  /** fetch data from the table: "supertokens.emailverification_tokens" */
  supertokens_emailverification_tokens: Array<Supertokens_Emailverification_Tokens>;
  /** fetch aggregated fields from the table: "supertokens.emailverification_tokens" */
  supertokens_emailverification_tokens_aggregate: Supertokens_Emailverification_Tokens_Aggregate;
  /** fetch data from the table: "supertokens.emailverification_tokens" using primary key columns */
  supertokens_emailverification_tokens_by_pk?: Maybe<Supertokens_Emailverification_Tokens>;
  /** fetch data from the table in a streaming manner: "supertokens.emailverification_tokens" */
  supertokens_emailverification_tokens_stream: Array<Supertokens_Emailverification_Tokens>;
  /** fetch data from the table: "supertokens.emailverification_verified_emails" */
  supertokens_emailverification_verified_emails: Array<Supertokens_Emailverification_Verified_Emails>;
  /** fetch aggregated fields from the table: "supertokens.emailverification_verified_emails" */
  supertokens_emailverification_verified_emails_aggregate: Supertokens_Emailverification_Verified_Emails_Aggregate;
  /** fetch data from the table: "supertokens.emailverification_verified_emails" using primary key columns */
  supertokens_emailverification_verified_emails_by_pk?: Maybe<Supertokens_Emailverification_Verified_Emails>;
  /** fetch data from the table in a streaming manner: "supertokens.emailverification_verified_emails" */
  supertokens_emailverification_verified_emails_stream: Array<Supertokens_Emailverification_Verified_Emails>;
  /** fetch data from the table: "supertokens.jwt_signing_keys" */
  supertokens_jwt_signing_keys: Array<Supertokens_Jwt_Signing_Keys>;
  /** fetch aggregated fields from the table: "supertokens.jwt_signing_keys" */
  supertokens_jwt_signing_keys_aggregate: Supertokens_Jwt_Signing_Keys_Aggregate;
  /** fetch data from the table: "supertokens.jwt_signing_keys" using primary key columns */
  supertokens_jwt_signing_keys_by_pk?: Maybe<Supertokens_Jwt_Signing_Keys>;
  /** fetch data from the table in a streaming manner: "supertokens.jwt_signing_keys" */
  supertokens_jwt_signing_keys_stream: Array<Supertokens_Jwt_Signing_Keys>;
  /** fetch data from the table: "supertokens.key_value" */
  supertokens_key_value: Array<Supertokens_Key_Value>;
  /** fetch aggregated fields from the table: "supertokens.key_value" */
  supertokens_key_value_aggregate: Supertokens_Key_Value_Aggregate;
  /** fetch data from the table: "supertokens.key_value" using primary key columns */
  supertokens_key_value_by_pk?: Maybe<Supertokens_Key_Value>;
  /** fetch data from the table in a streaming manner: "supertokens.key_value" */
  supertokens_key_value_stream: Array<Supertokens_Key_Value>;
  /** fetch data from the table: "supertokens.passwordless_codes" */
  supertokens_passwordless_codes: Array<Supertokens_Passwordless_Codes>;
  /** fetch aggregated fields from the table: "supertokens.passwordless_codes" */
  supertokens_passwordless_codes_aggregate: Supertokens_Passwordless_Codes_Aggregate;
  /** fetch data from the table: "supertokens.passwordless_codes" using primary key columns */
  supertokens_passwordless_codes_by_pk?: Maybe<Supertokens_Passwordless_Codes>;
  /** fetch data from the table in a streaming manner: "supertokens.passwordless_codes" */
  supertokens_passwordless_codes_stream: Array<Supertokens_Passwordless_Codes>;
  /** fetch data from the table: "supertokens.passwordless_devices" */
  supertokens_passwordless_devices: Array<Supertokens_Passwordless_Devices>;
  /** fetch aggregated fields from the table: "supertokens.passwordless_devices" */
  supertokens_passwordless_devices_aggregate: Supertokens_Passwordless_Devices_Aggregate;
  /** fetch data from the table: "supertokens.passwordless_devices" using primary key columns */
  supertokens_passwordless_devices_by_pk?: Maybe<Supertokens_Passwordless_Devices>;
  /** fetch data from the table in a streaming manner: "supertokens.passwordless_devices" */
  supertokens_passwordless_devices_stream: Array<Supertokens_Passwordless_Devices>;
  /** fetch data from the table: "supertokens.passwordless_user_to_tenant" */
  supertokens_passwordless_user_to_tenant: Array<Supertokens_Passwordless_User_To_Tenant>;
  /** fetch aggregated fields from the table: "supertokens.passwordless_user_to_tenant" */
  supertokens_passwordless_user_to_tenant_aggregate: Supertokens_Passwordless_User_To_Tenant_Aggregate;
  /** fetch data from the table: "supertokens.passwordless_user_to_tenant" using primary key columns */
  supertokens_passwordless_user_to_tenant_by_pk?: Maybe<Supertokens_Passwordless_User_To_Tenant>;
  /** fetch data from the table in a streaming manner: "supertokens.passwordless_user_to_tenant" */
  supertokens_passwordless_user_to_tenant_stream: Array<Supertokens_Passwordless_User_To_Tenant>;
  /** fetch data from the table: "supertokens.passwordless_users" */
  supertokens_passwordless_users: Array<Supertokens_Passwordless_Users>;
  /** fetch aggregated fields from the table: "supertokens.passwordless_users" */
  supertokens_passwordless_users_aggregate: Supertokens_Passwordless_Users_Aggregate;
  /** fetch data from the table: "supertokens.passwordless_users" using primary key columns */
  supertokens_passwordless_users_by_pk?: Maybe<Supertokens_Passwordless_Users>;
  /** fetch data from the table in a streaming manner: "supertokens.passwordless_users" */
  supertokens_passwordless_users_stream: Array<Supertokens_Passwordless_Users>;
  /** fetch data from the table: "supertokens.role_permissions" */
  supertokens_role_permissions: Array<Supertokens_Role_Permissions>;
  /** fetch aggregated fields from the table: "supertokens.role_permissions" */
  supertokens_role_permissions_aggregate: Supertokens_Role_Permissions_Aggregate;
  /** fetch data from the table: "supertokens.role_permissions" using primary key columns */
  supertokens_role_permissions_by_pk?: Maybe<Supertokens_Role_Permissions>;
  /** fetch data from the table in a streaming manner: "supertokens.role_permissions" */
  supertokens_role_permissions_stream: Array<Supertokens_Role_Permissions>;
  /** fetch data from the table: "supertokens.roles" */
  supertokens_roles: Array<Supertokens_Roles>;
  /** fetch aggregated fields from the table: "supertokens.roles" */
  supertokens_roles_aggregate: Supertokens_Roles_Aggregate;
  /** fetch data from the table: "supertokens.roles" using primary key columns */
  supertokens_roles_by_pk?: Maybe<Supertokens_Roles>;
  /** fetch data from the table in a streaming manner: "supertokens.roles" */
  supertokens_roles_stream: Array<Supertokens_Roles>;
  /** fetch data from the table: "supertokens.session_access_token_signing_keys" */
  supertokens_session_access_token_signing_keys: Array<Supertokens_Session_Access_Token_Signing_Keys>;
  /** fetch aggregated fields from the table: "supertokens.session_access_token_signing_keys" */
  supertokens_session_access_token_signing_keys_aggregate: Supertokens_Session_Access_Token_Signing_Keys_Aggregate;
  /** fetch data from the table: "supertokens.session_access_token_signing_keys" using primary key columns */
  supertokens_session_access_token_signing_keys_by_pk?: Maybe<Supertokens_Session_Access_Token_Signing_Keys>;
  /** fetch data from the table in a streaming manner: "supertokens.session_access_token_signing_keys" */
  supertokens_session_access_token_signing_keys_stream: Array<Supertokens_Session_Access_Token_Signing_Keys>;
  /** fetch data from the table: "supertokens.session_info" */
  supertokens_session_info: Array<Supertokens_Session_Info>;
  /** fetch aggregated fields from the table: "supertokens.session_info" */
  supertokens_session_info_aggregate: Supertokens_Session_Info_Aggregate;
  /** fetch data from the table: "supertokens.session_info" using primary key columns */
  supertokens_session_info_by_pk?: Maybe<Supertokens_Session_Info>;
  /** fetch data from the table in a streaming manner: "supertokens.session_info" */
  supertokens_session_info_stream: Array<Supertokens_Session_Info>;
  /** fetch data from the table: "supertokens.tenant_configs" */
  supertokens_tenant_configs: Array<Supertokens_Tenant_Configs>;
  /** fetch aggregated fields from the table: "supertokens.tenant_configs" */
  supertokens_tenant_configs_aggregate: Supertokens_Tenant_Configs_Aggregate;
  /** fetch data from the table: "supertokens.tenant_configs" using primary key columns */
  supertokens_tenant_configs_by_pk?: Maybe<Supertokens_Tenant_Configs>;
  /** fetch data from the table in a streaming manner: "supertokens.tenant_configs" */
  supertokens_tenant_configs_stream: Array<Supertokens_Tenant_Configs>;
  /** fetch data from the table: "supertokens.tenant_thirdparty_provider_clients" */
  supertokens_tenant_thirdparty_provider_clients: Array<Supertokens_Tenant_Thirdparty_Provider_Clients>;
  /** fetch aggregated fields from the table: "supertokens.tenant_thirdparty_provider_clients" */
  supertokens_tenant_thirdparty_provider_clients_aggregate: Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate;
  /** fetch data from the table: "supertokens.tenant_thirdparty_provider_clients" using primary key columns */
  supertokens_tenant_thirdparty_provider_clients_by_pk?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients>;
  /** fetch data from the table in a streaming manner: "supertokens.tenant_thirdparty_provider_clients" */
  supertokens_tenant_thirdparty_provider_clients_stream: Array<Supertokens_Tenant_Thirdparty_Provider_Clients>;
  /** fetch data from the table: "supertokens.tenant_thirdparty_providers" */
  supertokens_tenant_thirdparty_providers: Array<Supertokens_Tenant_Thirdparty_Providers>;
  /** fetch aggregated fields from the table: "supertokens.tenant_thirdparty_providers" */
  supertokens_tenant_thirdparty_providers_aggregate: Supertokens_Tenant_Thirdparty_Providers_Aggregate;
  /** fetch data from the table: "supertokens.tenant_thirdparty_providers" using primary key columns */
  supertokens_tenant_thirdparty_providers_by_pk?: Maybe<Supertokens_Tenant_Thirdparty_Providers>;
  /** fetch data from the table in a streaming manner: "supertokens.tenant_thirdparty_providers" */
  supertokens_tenant_thirdparty_providers_stream: Array<Supertokens_Tenant_Thirdparty_Providers>;
  /** fetch data from the table: "supertokens.tenants" */
  supertokens_tenants: Array<Supertokens_Tenants>;
  /** fetch aggregated fields from the table: "supertokens.tenants" */
  supertokens_tenants_aggregate: Supertokens_Tenants_Aggregate;
  /** fetch data from the table: "supertokens.tenants" using primary key columns */
  supertokens_tenants_by_pk?: Maybe<Supertokens_Tenants>;
  /** fetch data from the table in a streaming manner: "supertokens.tenants" */
  supertokens_tenants_stream: Array<Supertokens_Tenants>;
  /** fetch data from the table: "supertokens.thirdparty_user_to_tenant" */
  supertokens_thirdparty_user_to_tenant: Array<Supertokens_Thirdparty_User_To_Tenant>;
  /** fetch aggregated fields from the table: "supertokens.thirdparty_user_to_tenant" */
  supertokens_thirdparty_user_to_tenant_aggregate: Supertokens_Thirdparty_User_To_Tenant_Aggregate;
  /** fetch data from the table: "supertokens.thirdparty_user_to_tenant" using primary key columns */
  supertokens_thirdparty_user_to_tenant_by_pk?: Maybe<Supertokens_Thirdparty_User_To_Tenant>;
  /** fetch data from the table in a streaming manner: "supertokens.thirdparty_user_to_tenant" */
  supertokens_thirdparty_user_to_tenant_stream: Array<Supertokens_Thirdparty_User_To_Tenant>;
  /** fetch data from the table: "supertokens.thirdparty_users" */
  supertokens_thirdparty_users: Array<Supertokens_Thirdparty_Users>;
  /** fetch aggregated fields from the table: "supertokens.thirdparty_users" */
  supertokens_thirdparty_users_aggregate: Supertokens_Thirdparty_Users_Aggregate;
  /** fetch data from the table: "supertokens.thirdparty_users" using primary key columns */
  supertokens_thirdparty_users_by_pk?: Maybe<Supertokens_Thirdparty_Users>;
  /** fetch data from the table in a streaming manner: "supertokens.thirdparty_users" */
  supertokens_thirdparty_users_stream: Array<Supertokens_Thirdparty_Users>;
  /** fetch data from the table: "supertokens.user_additional_fields" */
  supertokens_user_additional_fields: Array<Supertokens_User_Additional_Fields>;
  /** fetch aggregated fields from the table: "supertokens.user_additional_fields" */
  supertokens_user_additional_fields_aggregate: Supertokens_User_Additional_Fields_Aggregate;
  /** fetch data from the table: "supertokens.user_additional_fields" using primary key columns */
  supertokens_user_additional_fields_by_pk?: Maybe<Supertokens_User_Additional_Fields>;
  /** fetch data from the table in a streaming manner: "supertokens.user_additional_fields" */
  supertokens_user_additional_fields_stream: Array<Supertokens_User_Additional_Fields>;
  /** fetch data from the table: "supertokens.user_last_active" */
  supertokens_user_last_active: Array<Supertokens_User_Last_Active>;
  /** fetch aggregated fields from the table: "supertokens.user_last_active" */
  supertokens_user_last_active_aggregate: Supertokens_User_Last_Active_Aggregate;
  /** fetch data from the table: "supertokens.user_last_active" using primary key columns */
  supertokens_user_last_active_by_pk?: Maybe<Supertokens_User_Last_Active>;
  /** fetch data from the table in a streaming manner: "supertokens.user_last_active" */
  supertokens_user_last_active_stream: Array<Supertokens_User_Last_Active>;
  /** fetch data from the table: "supertokens.user_metadata" */
  supertokens_user_metadata: Array<Supertokens_User_Metadata>;
  /** fetch aggregated fields from the table: "supertokens.user_metadata" */
  supertokens_user_metadata_aggregate: Supertokens_User_Metadata_Aggregate;
  /** fetch data from the table: "supertokens.user_metadata" using primary key columns */
  supertokens_user_metadata_by_pk?: Maybe<Supertokens_User_Metadata>;
  /** fetch data from the table in a streaming manner: "supertokens.user_metadata" */
  supertokens_user_metadata_stream: Array<Supertokens_User_Metadata>;
  /** fetch data from the table: "supertokens.user_public_fields" */
  supertokens_user_public_fields: Array<Supertokens_User_Public_Fields>;
  /** fetch aggregated fields from the table: "supertokens.user_public_fields" */
  supertokens_user_public_fields_aggregate: Supertokens_User_Public_Fields_Aggregate;
  /** fetch data from the table in a streaming manner: "supertokens.user_public_fields" */
  supertokens_user_public_fields_stream: Array<Supertokens_User_Public_Fields>;
  /** fetch data from the table: "supertokens.user_roles" */
  supertokens_user_roles: Array<Supertokens_User_Roles>;
  /** fetch aggregated fields from the table: "supertokens.user_roles" */
  supertokens_user_roles_aggregate: Supertokens_User_Roles_Aggregate;
  /** fetch data from the table: "supertokens.user_roles" using primary key columns */
  supertokens_user_roles_by_pk?: Maybe<Supertokens_User_Roles>;
  /** fetch data from the table in a streaming manner: "supertokens.user_roles" */
  supertokens_user_roles_stream: Array<Supertokens_User_Roles>;
  /** fetch data from the table: "supertokens.userid_mapping" */
  supertokens_userid_mapping: Array<Supertokens_Userid_Mapping>;
  /** fetch aggregated fields from the table: "supertokens.userid_mapping" */
  supertokens_userid_mapping_aggregate: Supertokens_Userid_Mapping_Aggregate;
  /** fetch data from the table: "supertokens.userid_mapping" using primary key columns */
  supertokens_userid_mapping_by_pk?: Maybe<Supertokens_Userid_Mapping>;
  /** fetch data from the table in a streaming manner: "supertokens.userid_mapping" */
  supertokens_userid_mapping_stream: Array<Supertokens_Userid_Mapping>;
  /** fetch data from the table: "taggit_tag" */
  taggit_tag: Array<Taggit_Tag>;
  /** fetch aggregated fields from the table: "taggit_tag" */
  taggit_tag_aggregate: Taggit_Tag_Aggregate;
  /** fetch data from the table: "taggit_tag" using primary key columns */
  taggit_tag_by_pk?: Maybe<Taggit_Tag>;
  /** fetch data from the table in a streaming manner: "taggit_tag" */
  taggit_tag_stream: Array<Taggit_Tag>;
  /** fetch data from the table: "taggit_taggeditem" */
  taggit_taggeditem: Array<Taggit_Taggeditem>;
  /** fetch aggregated fields from the table: "taggit_taggeditem" */
  taggit_taggeditem_aggregate: Taggit_Taggeditem_Aggregate;
  /** fetch data from the table: "taggit_taggeditem" using primary key columns */
  taggit_taggeditem_by_pk?: Maybe<Taggit_Taggeditem>;
  /** fetch data from the table in a streaming manner: "taggit_taggeditem" */
  taggit_taggeditem_stream: Array<Taggit_Taggeditem>;
  /** fetch data from the table: "upcoming_live_classes" */
  upcoming_live_classes: Array<Upcoming_Live_Classes>;
  /** fetch aggregated fields from the table: "upcoming_live_classes" */
  upcoming_live_classes_aggregate: Upcoming_Live_Classes_Aggregate;
  /** fetch data from the table: "upcoming_live_classes" using primary key columns */
  upcoming_live_classes_by_pk?: Maybe<Upcoming_Live_Classes>;
  /** fetch data from the table in a streaming manner: "upcoming_live_classes" */
  upcoming_live_classes_stream: Array<Upcoming_Live_Classes>;
  /** An array relationship */
  user_activities: Array<User_Activities>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activities_Aggregate;
  /** fetch data from the table: "user_activities" using primary key columns */
  user_activities_by_pk?: Maybe<User_Activities>;
  /** fetch data from the table in a streaming manner: "user_activities" */
  user_activities_stream: Array<User_Activities>;
  /** fetch data from the table: "user_activity" */
  user_activity: Array<User_Activity>;
  /** fetch aggregated fields from the table: "user_activity" */
  user_activity_aggregate: User_Activity_Aggregate;
  /** fetch data from the table: "user_activity" using primary key columns */
  user_activity_by_pk?: Maybe<User_Activity>;
  /** An array relationship */
  user_activity_lesson_entries: Array<User_Activity_Lesson_Entries>;
  /** An aggregate relationship */
  user_activity_lesson_entries_aggregate: User_Activity_Lesson_Entries_Aggregate;
  /** fetch data from the table: "user_activity_lesson_entries" using primary key columns */
  user_activity_lesson_entries_by_pk?: Maybe<User_Activity_Lesson_Entries>;
  /** fetch data from the table in a streaming manner: "user_activity_lesson_entries" */
  user_activity_lesson_entries_stream: Array<User_Activity_Lesson_Entries>;
  /** fetch data from the table in a streaming manner: "user_activity" */
  user_activity_stream: Array<User_Activity>;
  /** An array relationship */
  user_cat_registration_data: Array<User_Cat_Registration_Data>;
  /** An aggregate relationship */
  user_cat_registration_data_aggregate: User_Cat_Registration_Data_Aggregate;
  /** fetch data from the table: "user_cat_registration_data" using primary key columns */
  user_cat_registration_data_by_pk?: Maybe<User_Cat_Registration_Data>;
  /** fetch data from the table in a streaming manner: "user_cat_registration_data" */
  user_cat_registration_data_stream: Array<User_Cat_Registration_Data>;
  /** fetch data from the table: "user_cat_response_sheet_data" */
  user_cat_response_sheet_data: Array<User_Cat_Response_Sheet_Data>;
  /** fetch aggregated fields from the table: "user_cat_response_sheet_data" */
  user_cat_response_sheet_data_aggregate: User_Cat_Response_Sheet_Data_Aggregate;
  /** fetch data from the table: "user_cat_response_sheet_data" using primary key columns */
  user_cat_response_sheet_data_by_pk?: Maybe<User_Cat_Response_Sheet_Data>;
  /** fetch data from the table in a streaming manner: "user_cat_response_sheet_data" */
  user_cat_response_sheet_data_stream: Array<User_Cat_Response_Sheet_Data>;
  /** fetch data from the table: "user_custom_planned_activities" */
  user_custom_planned_activities: Array<User_Custom_Planned_Activities>;
  /** fetch aggregated fields from the table: "user_custom_planned_activities" */
  user_custom_planned_activities_aggregate: User_Custom_Planned_Activities_Aggregate;
  /** fetch data from the table: "user_custom_planned_activities" using primary key columns */
  user_custom_planned_activities_by_pk?: Maybe<User_Custom_Planned_Activities>;
  /** fetch data from the table in a streaming manner: "user_custom_planned_activities" */
  user_custom_planned_activities_stream: Array<User_Custom_Planned_Activities>;
  /** fetch data from the table: "user_latest_payment_transaction" */
  user_latest_payment_transaction: Array<User_Latest_Payment_Transaction>;
  /** fetch aggregated fields from the table: "user_latest_payment_transaction" */
  user_latest_payment_transaction_aggregate: User_Latest_Payment_Transaction_Aggregate;
  /** fetch data from the table in a streaming manner: "user_latest_payment_transaction" */
  user_latest_payment_transaction_stream: Array<User_Latest_Payment_Transaction>;
  /** fetch data from the table: "user_leaderboard_types" */
  user_leaderboard_types: Array<User_Leaderboard_Types>;
  /** fetch aggregated fields from the table: "user_leaderboard_types" */
  user_leaderboard_types_aggregate: User_Leaderboard_Types_Aggregate;
  /** fetch data from the table: "user_leaderboard_types" using primary key columns */
  user_leaderboard_types_by_pk?: Maybe<User_Leaderboard_Types>;
  /** fetch data from the table in a streaming manner: "user_leaderboard_types" */
  user_leaderboard_types_stream: Array<User_Leaderboard_Types>;
  /** An array relationship */
  user_leaderboards: Array<User_Leaderboards>;
  /** An aggregate relationship */
  user_leaderboards_aggregate: User_Leaderboards_Aggregate;
  /** fetch data from the table: "user_leaderboards" using primary key columns */
  user_leaderboards_by_pk?: Maybe<User_Leaderboards>;
  /** fetch data from the table in a streaming manner: "user_leaderboards" */
  user_leaderboards_stream: Array<User_Leaderboards>;
  /** An array relationship */
  user_learn_activities: Array<User_Learn_Activities>;
  /** An aggregate relationship */
  user_learn_activities_aggregate: User_Learn_Activities_Aggregate;
  /** fetch data from the table: "user_learn_activities" using primary key columns */
  user_learn_activities_by_pk?: Maybe<User_Learn_Activities>;
  /** fetch data from the table in a streaming manner: "user_learn_activities" */
  user_learn_activities_stream: Array<User_Learn_Activities>;
  /** fetch data from the table: "user_learn_category_progress" */
  user_learn_category_progress: Array<User_Learn_Category_Progress>;
  /** fetch aggregated fields from the table: "user_learn_category_progress" */
  user_learn_category_progress_aggregate: User_Learn_Category_Progress_Aggregate;
  /** fetch data from the table: "user_learn_category_progress" using primary key columns */
  user_learn_category_progress_by_pk?: Maybe<User_Learn_Category_Progress>;
  /** fetch data from the table in a streaming manner: "user_learn_category_progress" */
  user_learn_category_progress_stream: Array<User_Learn_Category_Progress>;
  /** An array relationship */
  user_learn_completed_topics: Array<User_Learn_Completed_Topics>;
  /** An aggregate relationship */
  user_learn_completed_topics_aggregate: User_Learn_Completed_Topics_Aggregate;
  /** fetch data from the table: "user_learn_completed_topics" using primary key columns */
  user_learn_completed_topics_by_pk?: Maybe<User_Learn_Completed_Topics>;
  /** fetch data from the table in a streaming manner: "user_learn_completed_topics" */
  user_learn_completed_topics_stream: Array<User_Learn_Completed_Topics>;
  /** fetch data from the table: "user_learn_modules_summary" */
  user_learn_modules_summary: Array<User_Learn_Modules_Summary>;
  /** fetch aggregated fields from the table: "user_learn_modules_summary" */
  user_learn_modules_summary_aggregate: User_Learn_Modules_Summary_Aggregate;
  /** fetch data from the table: "user_learn_modules_summary" using primary key columns */
  user_learn_modules_summary_by_pk?: Maybe<User_Learn_Modules_Summary>;
  /** fetch data from the table in a streaming manner: "user_learn_modules_summary" */
  user_learn_modules_summary_stream: Array<User_Learn_Modules_Summary>;
  /** fetch data from the table: "user_learn_track_record" */
  user_learn_track_record: Array<User_Learn_Track_Record>;
  /** fetch aggregated fields from the table: "user_learn_track_record" */
  user_learn_track_record_aggregate: User_Learn_Track_Record_Aggregate;
  /** An array relationship */
  user_learn_track_record_bookmarked_topics: Array<User_Learn_Track_Record_Bookmarked_Topics>;
  /** An aggregate relationship */
  user_learn_track_record_bookmarked_topics_aggregate: User_Learn_Track_Record_Bookmarked_Topics_Aggregate;
  /** fetch data from the table: "user_learn_track_record_bookmarked_topics" using primary key columns */
  user_learn_track_record_bookmarked_topics_by_pk?: Maybe<User_Learn_Track_Record_Bookmarked_Topics>;
  /** fetch data from the table in a streaming manner: "user_learn_track_record_bookmarked_topics" */
  user_learn_track_record_bookmarked_topics_stream: Array<User_Learn_Track_Record_Bookmarked_Topics>;
  /** fetch data from the table: "user_learn_track_record" using primary key columns */
  user_learn_track_record_by_pk?: Maybe<User_Learn_Track_Record>;
  /** fetch data from the table in a streaming manner: "user_learn_track_record" */
  user_learn_track_record_stream: Array<User_Learn_Track_Record>;
  /** An array relationship */
  user_learn_track_record_which_topics: Array<User_Learn_Track_Record_Which_Topics>;
  /** An aggregate relationship */
  user_learn_track_record_which_topics_aggregate: User_Learn_Track_Record_Which_Topics_Aggregate;
  /** fetch data from the table: "user_learn_track_record_which_topics" using primary key columns */
  user_learn_track_record_which_topics_by_pk?: Maybe<User_Learn_Track_Record_Which_Topics>;
  /** fetch data from the table in a streaming manner: "user_learn_track_record_which_topics" */
  user_learn_track_record_which_topics_stream: Array<User_Learn_Track_Record_Which_Topics>;
  /** fetch data from the table: "user_lesson_track_records" */
  user_lesson_track_records: Array<User_Lesson_Track_Records>;
  /** fetch aggregated fields from the table: "user_lesson_track_records" */
  user_lesson_track_records_aggregate: User_Lesson_Track_Records_Aggregate;
  /** fetch data from the table in a streaming manner: "user_lesson_track_records" */
  user_lesson_track_records_stream: Array<User_Lesson_Track_Records>;
  /** An array relationship */
  user_planned_activities: Array<User_Planned_Activities>;
  /** An aggregate relationship */
  user_planned_activities_aggregate: User_Planned_Activities_Aggregate;
  /** fetch data from the table: "user_planned_activities" using primary key columns */
  user_planned_activities_by_pk?: Maybe<User_Planned_Activities>;
  /** fetch data from the table in a streaming manner: "user_planned_activities" */
  user_planned_activities_stream: Array<User_Planned_Activities>;
  /** An array relationship */
  user_pov_summaries: Array<User_Pov_Summaries>;
  /** An aggregate relationship */
  user_pov_summaries_aggregate: User_Pov_Summaries_Aggregate;
  /** fetch data from the table: "user_pov_summaries" using primary key columns */
  user_pov_summaries_by_pk?: Maybe<User_Pov_Summaries>;
  /** fetch data from the table in a streaming manner: "user_pov_summaries" */
  user_pov_summaries_stream: Array<User_Pov_Summaries>;
  /** An array relationship */
  user_quiz_question_attempts: Array<User_Quiz_Question_Attempts>;
  /** An aggregate relationship */
  user_quiz_question_attempts_aggregate: User_Quiz_Question_Attempts_Aggregate;
  /** fetch data from the table: "user_quiz_question_attempts" using primary key columns */
  user_quiz_question_attempts_by_pk?: Maybe<User_Quiz_Question_Attempts>;
  /** fetch data from the table in a streaming manner: "user_quiz_question_attempts" */
  user_quiz_question_attempts_stream: Array<User_Quiz_Question_Attempts>;
  /** An array relationship */
  user_quiz_question_positions: Array<User_Quiz_Question_Positions>;
  /** An aggregate relationship */
  user_quiz_question_positions_aggregate: User_Quiz_Question_Positions_Aggregate;
  /** fetch data from the table: "user_quiz_question_positions" using primary key columns */
  user_quiz_question_positions_by_pk?: Maybe<User_Quiz_Question_Positions>;
  /** fetch data from the table in a streaming manner: "user_quiz_question_positions" */
  user_quiz_question_positions_stream: Array<User_Quiz_Question_Positions>;
  /** An array relationship */
  user_quiz_question_summaries: Array<User_Quiz_Question_Summaries>;
  /** An aggregate relationship */
  user_quiz_question_summaries_aggregate: User_Quiz_Question_Summaries_Aggregate;
  /** fetch data from the table: "user_quiz_question_summaries" using primary key columns */
  user_quiz_question_summaries_by_pk?: Maybe<User_Quiz_Question_Summaries>;
  /** An array relationship */
  user_quiz_question_summaries_old: Array<User_Quiz_Question_Summaries_Old>;
  /** An aggregate relationship */
  user_quiz_question_summaries_old_aggregate: User_Quiz_Question_Summaries_Old_Aggregate;
  /** fetch data from the table: "user_quiz_question_summaries_old" using primary key columns */
  user_quiz_question_summaries_old_by_pk?: Maybe<User_Quiz_Question_Summaries_Old>;
  /** fetch data from the table in a streaming manner: "user_quiz_question_summaries_old" */
  user_quiz_question_summaries_old_stream: Array<User_Quiz_Question_Summaries_Old>;
  /** fetch data from the table in a streaming manner: "user_quiz_question_summaries" */
  user_quiz_question_summaries_stream: Array<User_Quiz_Question_Summaries>;
  /** An array relationship */
  user_quiz_questions: Array<User_Quiz_Questions>;
  /** An aggregate relationship */
  user_quiz_questions_aggregate: User_Quiz_Questions_Aggregate;
  /** fetch data from the table: "user_quiz_questions" using primary key columns */
  user_quiz_questions_by_pk?: Maybe<User_Quiz_Questions>;
  /** fetch data from the table in a streaming manner: "user_quiz_questions" */
  user_quiz_questions_stream: Array<User_Quiz_Questions>;
  /** An array relationship */
  user_quiz_section_summaries: Array<User_Quiz_Section_Summaries>;
  /** An aggregate relationship */
  user_quiz_section_summaries_aggregate: User_Quiz_Section_Summaries_Aggregate;
  /** fetch data from the table: "user_quiz_section_summaries" using primary key columns */
  user_quiz_section_summaries_by_pk?: Maybe<User_Quiz_Section_Summaries>;
  /** fetch data from the table in a streaming manner: "user_quiz_section_summaries" */
  user_quiz_section_summaries_stream: Array<User_Quiz_Section_Summaries>;
  /** An array relationship */
  user_quiz_summaries: Array<User_Quiz_Summaries>;
  /** An aggregate relationship */
  user_quiz_summaries_aggregate: User_Quiz_Summaries_Aggregate;
  /** fetch data from the table: "user_quiz_summaries" using primary key columns */
  user_quiz_summaries_by_pk?: Maybe<User_Quiz_Summaries>;
  /** fetch data from the table: "user_quiz_summaries_old" */
  user_quiz_summaries_old: Array<User_Quiz_Summaries_Old>;
  /** fetch aggregated fields from the table: "user_quiz_summaries_old" */
  user_quiz_summaries_old_aggregate: User_Quiz_Summaries_Old_Aggregate;
  /** fetch data from the table: "user_quiz_summaries_old" using primary key columns */
  user_quiz_summaries_old_by_pk?: Maybe<User_Quiz_Summaries_Old>;
  /** fetch data from the table in a streaming manner: "user_quiz_summaries_old" */
  user_quiz_summaries_old_stream: Array<User_Quiz_Summaries_Old>;
  /** fetch data from the table in a streaming manner: "user_quiz_summaries" */
  user_quiz_summaries_stream: Array<User_Quiz_Summaries>;
  /** fetch data from the table: "user_recent_lessons" */
  user_recent_lessons: Array<User_Recent_Lessons>;
  /** fetch aggregated fields from the table: "user_recent_lessons" */
  user_recent_lessons_aggregate: User_Recent_Lessons_Aggregate;
  /** fetch data from the table in a streaming manner: "user_recent_lessons" */
  user_recent_lessons_stream: Array<User_Recent_Lessons>;
  /** An array relationship */
  user_section_summaries: Array<User_Section_Summaries>;
  /** An aggregate relationship */
  user_section_summaries_aggregate: User_Section_Summaries_Aggregate;
  /** fetch data from the table: "user_section_summaries" using primary key columns */
  user_section_summaries_by_pk?: Maybe<User_Section_Summaries>;
  /** fetch data from the table in a streaming manner: "user_section_summaries" */
  user_section_summaries_stream: Array<User_Section_Summaries>;
  /** An array relationship */
  user_speed_test_questions_summaries: Array<User_Speed_Test_Questions_Summaries>;
  /** An aggregate relationship */
  user_speed_test_questions_summaries_aggregate: User_Speed_Test_Questions_Summaries_Aggregate;
  /** fetch data from the table: "user_speed_test_questions_summaries" using primary key columns */
  user_speed_test_questions_summaries_by_pk?: Maybe<User_Speed_Test_Questions_Summaries>;
  /** fetch data from the table in a streaming manner: "user_speed_test_questions_summaries" */
  user_speed_test_questions_summaries_stream: Array<User_Speed_Test_Questions_Summaries>;
  /** An array relationship */
  user_speed_tests_summaries: Array<User_Speed_Tests_Summaries>;
  /** An aggregate relationship */
  user_speed_tests_summaries_aggregate: User_Speed_Tests_Summaries_Aggregate;
  /** fetch data from the table: "user_speed_tests_summaries" using primary key columns */
  user_speed_tests_summaries_by_pk?: Maybe<User_Speed_Tests_Summaries>;
  /** fetch data from the table in a streaming manner: "user_speed_tests_summaries" */
  user_speed_tests_summaries_stream: Array<User_Speed_Tests_Summaries>;
  /** fetch data from the table: "user_timed_quiz_summary" */
  user_timed_quiz_summary: Array<User_Timed_Quiz_Summary>;
  /** fetch aggregated fields from the table: "user_timed_quiz_summary" */
  user_timed_quiz_summary_aggregate: User_Timed_Quiz_Summary_Aggregate;
  /** fetch data from the table: "user_timed_quiz_summary" using primary key columns */
  user_timed_quiz_summary_by_pk?: Maybe<User_Timed_Quiz_Summary>;
  /** fetch data from the table in a streaming manner: "user_timed_quiz_summary" */
  user_timed_quiz_summary_stream: Array<User_Timed_Quiz_Summary>;
  /** fetch data from the table: "user_total_score" */
  user_total_score: Array<User_Total_Score>;
  /** fetch aggregated fields from the table: "user_total_score" */
  user_total_score_aggregate: User_Total_Score_Aggregate;
  /** fetch data from the table: "user_total_score" using primary key columns */
  user_total_score_by_pk?: Maybe<User_Total_Score>;
  /** fetch data from the table in a streaming manner: "user_total_score" */
  user_total_score_stream: Array<User_Total_Score>;
  /** fetch data from the table: "user_xp_transaction_summaries" */
  user_xp_transaction_summaries: Array<User_Xp_Transaction_Summaries>;
  /** fetch aggregated fields from the table: "user_xp_transaction_summaries" */
  user_xp_transaction_summaries_aggregate: User_Xp_Transaction_Summaries_Aggregate;
  /** fetch data from the table: "user_xp_transaction_summaries" using primary key columns */
  user_xp_transaction_summaries_by_pk?: Maybe<User_Xp_Transaction_Summaries>;
  /** fetch data from the table in a streaming manner: "user_xp_transaction_summaries" */
  user_xp_transaction_summaries_stream: Array<User_Xp_Transaction_Summaries>;
  /** An array relationship */
  user_xp_transactions: Array<User_Xp_Transactions>;
  /** An aggregate relationship */
  user_xp_transactions_aggregate: User_Xp_Transactions_Aggregate;
  /** fetch data from the table: "user_xp_transactions" using primary key columns */
  user_xp_transactions_by_pk?: Maybe<User_Xp_Transactions>;
  /** fetch data from the table in a streaming manner: "user_xp_transactions" */
  user_xp_transactions_stream: Array<User_Xp_Transactions>;
  /** fetch data from the table: "users_user" */
  users_user: Array<Users_User>;
  /** fetch aggregated fields from the table: "users_user" */
  users_user_aggregate: Users_User_Aggregate;
  /** fetch data from the table: "users_user" using primary key columns */
  users_user_by_pk?: Maybe<Users_User>;
  /** An array relationship */
  users_user_groups: Array<Users_User_Groups>;
  /** An aggregate relationship */
  users_user_groups_aggregate: Users_User_Groups_Aggregate;
  /** fetch data from the table: "users_user_groups" using primary key columns */
  users_user_groups_by_pk?: Maybe<Users_User_Groups>;
  /** fetch data from the table in a streaming manner: "users_user_groups" */
  users_user_groups_stream: Array<Users_User_Groups>;
  /** fetch data from the table in a streaming manner: "users_user" */
  users_user_stream: Array<Users_User>;
  /** An array relationship */
  users_user_user_permissions: Array<Users_User_User_Permissions>;
  /** An aggregate relationship */
  users_user_user_permissions_aggregate: Users_User_User_Permissions_Aggregate;
  /** fetch data from the table: "users_user_user_permissions" using primary key columns */
  users_user_user_permissions_by_pk?: Maybe<Users_User_User_Permissions>;
  /** fetch data from the table in a streaming manner: "users_user_user_permissions" */
  users_user_user_permissions_stream: Array<Users_User_User_Permissions>;
  /** fetch data from the table: "users_userquestionsummary" */
  users_userquestionsummary: Array<Users_Userquestionsummary>;
  /** fetch aggregated fields from the table: "users_userquestionsummary" */
  users_userquestionsummary_aggregate: Users_Userquestionsummary_Aggregate;
  /** fetch data from the table: "users_userquestionsummary" using primary key columns */
  users_userquestionsummary_by_pk?: Maybe<Users_Userquestionsummary>;
  /** fetch data from the table in a streaming manner: "users_userquestionsummary" */
  users_userquestionsummary_stream: Array<Users_Userquestionsummary>;
  /** fetch data from the table: "users_userquizsummary" */
  users_userquizsummary: Array<Users_Userquizsummary>;
  /** fetch aggregated fields from the table: "users_userquizsummary" */
  users_userquizsummary_aggregate: Users_Userquizsummary_Aggregate;
  /** fetch data from the table: "users_userquizsummary" using primary key columns */
  users_userquizsummary_by_pk?: Maybe<Users_Userquizsummary>;
  /** fetch data from the table in a streaming manner: "users_userquizsummary" */
  users_userquizsummary_stream: Array<Users_Userquizsummary>;
  /** fetch data from the table: "users_userquiztimesummary" */
  users_userquiztimesummary: Array<Users_Userquiztimesummary>;
  /** fetch aggregated fields from the table: "users_userquiztimesummary" */
  users_userquiztimesummary_aggregate: Users_Userquiztimesummary_Aggregate;
  /** fetch data from the table: "users_userquiztimesummary" using primary key columns */
  users_userquiztimesummary_by_pk?: Maybe<Users_Userquiztimesummary>;
  /** fetch data from the table in a streaming manner: "users_userquiztimesummary" */
  users_userquiztimesummary_stream: Array<Users_Userquiztimesummary>;
  /** fetch data from the table: "users_usersectionsummary" */
  users_usersectionsummary: Array<Users_Usersectionsummary>;
  /** fetch aggregated fields from the table: "users_usersectionsummary" */
  users_usersectionsummary_aggregate: Users_Usersectionsummary_Aggregate;
  /** fetch data from the table: "users_usersectionsummary" using primary key columns */
  users_usersectionsummary_by_pk?: Maybe<Users_Usersectionsummary>;
  /** fetch data from the table in a streaming manner: "users_usersectionsummary" */
  users_usersectionsummary_stream: Array<Users_Usersectionsummary>;
  /** fetch data from the table: "utils_configuration" */
  utils_configuration: Array<Utils_Configuration>;
  /** fetch aggregated fields from the table: "utils_configuration" */
  utils_configuration_aggregate: Utils_Configuration_Aggregate;
  /** fetch data from the table: "utils_configuration" using primary key columns */
  utils_configuration_by_pk?: Maybe<Utils_Configuration>;
  /** fetch data from the table in a streaming manner: "utils_configuration" */
  utils_configuration_stream: Array<Utils_Configuration>;
  /** fetch data from the table: "xp_transaction_types" */
  xp_transaction_types: Array<Xp_Transaction_Types>;
  /** fetch aggregated fields from the table: "xp_transaction_types" */
  xp_transaction_types_aggregate: Xp_Transaction_Types_Aggregate;
  /** fetch data from the table: "xp_transaction_types" using primary key columns */
  xp_transaction_types_by_pk?: Maybe<Xp_Transaction_Types>;
  /** fetch data from the table in a streaming manner: "xp_transaction_types" */
  xp_transaction_types_stream: Array<Xp_Transaction_Types>;
};


export type SubscriptionAccount_EmailaddressArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailaddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailaddress_Order_By>>;
  where?: InputMaybe<Account_Emailaddress_Bool_Exp>;
};


export type SubscriptionAccount_Emailaddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailaddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailaddress_Order_By>>;
  where?: InputMaybe<Account_Emailaddress_Bool_Exp>;
};


export type SubscriptionAccount_Emailaddress_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAccount_Emailaddress_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_Emailaddress_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Emailaddress_Bool_Exp>;
};


export type SubscriptionAccount_EmailconfirmationArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailconfirmation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailconfirmation_Order_By>>;
  where?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
};


export type SubscriptionAccount_Emailconfirmation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailconfirmation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailconfirmation_Order_By>>;
  where?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
};


export type SubscriptionAccount_Emailconfirmation_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAccount_Emailconfirmation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_Emailconfirmation_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
};


export type SubscriptionAccounts_CatscoresArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Catscores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Catscores_Order_By>>;
  where?: InputMaybe<Accounts_Catscores_Bool_Exp>;
};


export type SubscriptionAccounts_Catscores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Catscores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Catscores_Order_By>>;
  where?: InputMaybe<Accounts_Catscores_Bool_Exp>;
};


export type SubscriptionAccounts_Catscores_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAccounts_Catscores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Accounts_Catscores_Stream_Cursor_Input>>;
  where?: InputMaybe<Accounts_Catscores_Bool_Exp>;
};


export type SubscriptionAccounts_LoggedinuserArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Loggedinuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Loggedinuser_Order_By>>;
  where?: InputMaybe<Accounts_Loggedinuser_Bool_Exp>;
};


export type SubscriptionAccounts_Loggedinuser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Loggedinuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Loggedinuser_Order_By>>;
  where?: InputMaybe<Accounts_Loggedinuser_Bool_Exp>;
};


export type SubscriptionAccounts_Loggedinuser_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAccounts_Loggedinuser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Accounts_Loggedinuser_Stream_Cursor_Input>>;
  where?: InputMaybe<Accounts_Loggedinuser_Bool_Exp>;
};


export type SubscriptionActivity_TypesArgs = {
  distinct_on?: InputMaybe<Array<Activity_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Types_Order_By>>;
  where?: InputMaybe<Activity_Types_Bool_Exp>;
};


export type SubscriptionActivity_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Types_Order_By>>;
  where?: InputMaybe<Activity_Types_Bool_Exp>;
};


export type SubscriptionActivity_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type SubscriptionActivity_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Types_Bool_Exp>;
};


export type SubscriptionAdmin_ConstantsArgs = {
  distinct_on?: InputMaybe<Array<Admin_Constants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Constants_Order_By>>;
  where?: InputMaybe<Admin_Constants_Bool_Exp>;
};


export type SubscriptionAdmin_Constants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Constants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Constants_Order_By>>;
  where?: InputMaybe<Admin_Constants_Bool_Exp>;
};


export type SubscriptionAdmin_Constants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionAdmin_Constants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Constants_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Constants_Bool_Exp>;
};


export type SubscriptionAdmin_UsersArgs = {
  distinct_on?: InputMaybe<Array<Admin_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Users_Order_By>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type SubscriptionAdmin_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Users_Order_By>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type SubscriptionAdmin_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionAdmin_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type SubscriptionAdvertisementsArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type SubscriptionAdvertisements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type SubscriptionAdvertisements_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionAdvertisements_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Advertisements_Stream_Cursor_Input>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type SubscriptionAndablog_EntryArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entry_Order_By>>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};


export type SubscriptionAndablog_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entry_Order_By>>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};


export type SubscriptionAndablog_Entry_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAndablog_Entry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Andablog_Entry_Stream_Cursor_Input>>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};


export type SubscriptionAndablog_EntryimageArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entryimage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entryimage_Order_By>>;
  where?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
};


export type SubscriptionAndablog_Entryimage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entryimage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entryimage_Order_By>>;
  where?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
};


export type SubscriptionAndablog_Entryimage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAndablog_Entryimage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Andablog_Entryimage_Stream_Cursor_Input>>;
  where?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
};


export type SubscriptionAndablog_NewsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_News_Order_By>>;
  where?: InputMaybe<Andablog_News_Bool_Exp>;
};


export type SubscriptionAndablog_News_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_News_Order_By>>;
  where?: InputMaybe<Andablog_News_Bool_Exp>;
};


export type SubscriptionAndablog_News_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAndablog_News_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Andablog_News_Stream_Cursor_Input>>;
  where?: InputMaybe<Andablog_News_Bool_Exp>;
};


export type SubscriptionAndablog_PovArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Pov_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Pov_Order_By>>;
  where?: InputMaybe<Andablog_Pov_Bool_Exp>;
};


export type SubscriptionAndablog_Pov_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Pov_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Pov_Order_By>>;
  where?: InputMaybe<Andablog_Pov_Bool_Exp>;
};


export type SubscriptionAndablog_Pov_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionAndablog_Pov_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Andablog_Pov_Stream_Cursor_Input>>;
  where?: InputMaybe<Andablog_Pov_Bool_Exp>;
};


export type SubscriptionAndablog_UserlessontrackrecordArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};


export type SubscriptionAndablog_Userlessontrackrecord_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};


export type SubscriptionAndablog_Userlessontrackrecord_Bookmarked_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};


export type SubscriptionAndablog_Userlessontrackrecord_Bookmarked_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};


export type SubscriptionAndablog_Userlessontrackrecord_Bookmarked_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAndablog_Userlessontrackrecord_Bookmarked_Topics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Stream_Cursor_Input>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};


export type SubscriptionAndablog_Userlessontrackrecord_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAndablog_Userlessontrackrecord_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Andablog_Userlessontrackrecord_Stream_Cursor_Input>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};


export type SubscriptionAndablog_Userlessontrackrecord_Which_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};


export type SubscriptionAndablog_Userlessontrackrecord_Which_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};


export type SubscriptionAndablog_Userlessontrackrecord_Which_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAndablog_Userlessontrackrecord_Which_Topics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Stream_Cursor_Input>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};


export type SubscriptionAndablog_VideoArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Video_Order_By>>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};


export type SubscriptionAndablog_Video_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Video_Order_By>>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};


export type SubscriptionAndablog_Video_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAndablog_Video_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Andablog_Video_Stream_Cursor_Input>>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};


export type SubscriptionAuth_Email_VerificationsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Email_Verifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Email_Verifications_Order_By>>;
  where?: InputMaybe<Auth_Email_Verifications_Bool_Exp>;
};


export type SubscriptionAuth_Email_Verifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Email_Verifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Email_Verifications_Order_By>>;
  where?: InputMaybe<Auth_Email_Verifications_Bool_Exp>;
};


export type SubscriptionAuth_Email_Verifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionAuth_Email_Verifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Email_Verifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Email_Verifications_Bool_Exp>;
};


export type SubscriptionAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type SubscriptionAuth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type SubscriptionAuth_Group_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAuth_Group_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type SubscriptionAuth_Group_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type SubscriptionAuth_Group_Permissions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAuth_Group_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Group_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type SubscriptionAuth_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type SubscriptionAuth_Password_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Auth_Password_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Password_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Password_Reset_Tokens_Bool_Exp>;
};


export type SubscriptionAuth_Password_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Password_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Password_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Password_Reset_Tokens_Bool_Exp>;
};


export type SubscriptionAuth_Password_Reset_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionAuth_Password_Reset_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Password_Reset_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Password_Reset_Tokens_Bool_Exp>;
};


export type SubscriptionAuth_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type SubscriptionAuth_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type SubscriptionAuth_Permission_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionAuth_Permission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type SubscriptionAuth_SessionArgs = {
  distinct_on?: InputMaybe<Array<Auth_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Session_Order_By>>;
  where?: InputMaybe<Auth_Session_Bool_Exp>;
};


export type SubscriptionAuth_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Session_Order_By>>;
  where?: InputMaybe<Auth_Session_Bool_Exp>;
};


export type SubscriptionAuth_Session_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionAuth_Session_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Session_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Session_Bool_Exp>;
};


export type SubscriptionBookmarked_Learn_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bookmarked_Learn_Topics_Order_By>>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};


export type SubscriptionBookmarked_Learn_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bookmarked_Learn_Topics_Order_By>>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};


export type SubscriptionBookmarked_Learn_Topics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionBookmarked_Learn_Topics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bookmarked_Learn_Topics_Stream_Cursor_Input>>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};


export type SubscriptionCat_Percentile_ConstantArgs = {
  distinct_on?: InputMaybe<Array<Cat_Percentile_Constant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cat_Percentile_Constant_Order_By>>;
  where?: InputMaybe<Cat_Percentile_Constant_Bool_Exp>;
};


export type SubscriptionCat_Percentile_Constant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cat_Percentile_Constant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cat_Percentile_Constant_Order_By>>;
  where?: InputMaybe<Cat_Percentile_Constant_Bool_Exp>;
};


export type SubscriptionCat_Percentile_Constant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionCat_Percentile_Constant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cat_Percentile_Constant_Stream_Cursor_Input>>;
  where?: InputMaybe<Cat_Percentile_Constant_Bool_Exp>;
};


export type SubscriptionCat_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Cat_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cat_Scores_Order_By>>;
  where?: InputMaybe<Cat_Scores_Bool_Exp>;
};


export type SubscriptionCat_Scores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cat_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cat_Scores_Order_By>>;
  where?: InputMaybe<Cat_Scores_Bool_Exp>;
};


export type SubscriptionCat_Scores_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionCat_Scores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cat_Scores_Stream_Cursor_Input>>;
  where?: InputMaybe<Cat_Scores_Bool_Exp>;
};


export type SubscriptionChannel_MembersArgs = {
  distinct_on?: InputMaybe<Array<Channel_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Members_Order_By>>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};


export type SubscriptionChannel_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Members_Order_By>>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};


export type SubscriptionChannel_Members_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionChannel_Members_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Channel_Members_Stream_Cursor_Input>>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};


export type SubscriptionChannelsArgs = {
  distinct_on?: InputMaybe<Array<Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channels_Order_By>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type SubscriptionChannels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channels_Order_By>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type SubscriptionChannels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionChannels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Channels_Stream_Cursor_Input>>;
  where?: InputMaybe<Channels_Bool_Exp>;
};


export type SubscriptionCoupons_Allowed_Users_Rule_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};


export type SubscriptionCoupons_Allowed_Users_Rule_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};


export type SubscriptionCoupons_Allowed_Users_Rule_Users_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Allowed_Users_Rule_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Allowed_Users_Rule_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};


export type SubscriptionCoupons_AllowedusersruleArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
};


export type SubscriptionCoupons_Allowedusersrule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
};


export type SubscriptionCoupons_Allowedusersrule_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Allowedusersrule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Allowedusersrule_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
};


export type SubscriptionCoupons_Allowedusersrule_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};


export type SubscriptionCoupons_Allowedusersrule_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};


export type SubscriptionCoupons_Allowedusersrule_Users_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Allowedusersrule_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Allowedusersrule_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};


export type SubscriptionCoupons_CouponArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};


export type SubscriptionCoupons_Coupon_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};


export type SubscriptionCoupons_Coupon_Applicable_PackagesArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};


export type SubscriptionCoupons_Coupon_Applicable_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};


export type SubscriptionCoupons_Coupon_Applicable_Packages_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Coupon_Applicable_Packages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Coupon_Applicable_Packages_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};


export type SubscriptionCoupons_Coupon_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Coupon_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Coupon_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};


export type SubscriptionCoupons_CouponuserArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


export type SubscriptionCoupons_Couponuser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


export type SubscriptionCoupons_Couponuser_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Couponuser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Couponuser_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


export type SubscriptionCoupons_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Discount_Order_By>>;
  where?: InputMaybe<Coupons_Discount_Bool_Exp>;
};


export type SubscriptionCoupons_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Discount_Order_By>>;
  where?: InputMaybe<Coupons_Discount_Bool_Exp>;
};


export type SubscriptionCoupons_Discount_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Discount_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Discount_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Discount_Bool_Exp>;
};


export type SubscriptionCoupons_MaxusesruleArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Maxusesrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Maxusesrule_Order_By>>;
  where?: InputMaybe<Coupons_Maxusesrule_Bool_Exp>;
};


export type SubscriptionCoupons_Maxusesrule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Maxusesrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Maxusesrule_Order_By>>;
  where?: InputMaybe<Coupons_Maxusesrule_Bool_Exp>;
};


export type SubscriptionCoupons_Maxusesrule_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Maxusesrule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Maxusesrule_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Maxusesrule_Bool_Exp>;
};


export type SubscriptionCoupons_RulesetArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};


export type SubscriptionCoupons_Ruleset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};


export type SubscriptionCoupons_Ruleset_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Ruleset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Ruleset_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};


export type SubscriptionCoupons_ValidityruleArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Validityrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Validityrule_Order_By>>;
  where?: InputMaybe<Coupons_Validityrule_Bool_Exp>;
};


export type SubscriptionCoupons_Validityrule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Validityrule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Validityrule_Order_By>>;
  where?: InputMaybe<Coupons_Validityrule_Bool_Exp>;
};


export type SubscriptionCoupons_Validityrule_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionCoupons_Validityrule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Coupons_Validityrule_Stream_Cursor_Input>>;
  where?: InputMaybe<Coupons_Validityrule_Bool_Exp>;
};


export type SubscriptionDjango_Admin_LogArgs = {
  distinct_on?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Admin_Log_Order_By>>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};


export type SubscriptionDjango_Admin_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Admin_Log_Order_By>>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};


export type SubscriptionDjango_Admin_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionDjango_Admin_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Django_Admin_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};


export type SubscriptionDjango_Content_TypeArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type SubscriptionDjango_Content_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type SubscriptionDjango_Content_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionDjango_Content_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Django_Content_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type SubscriptionDjango_MigrationsArgs = {
  distinct_on?: InputMaybe<Array<Django_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Migrations_Order_By>>;
  where?: InputMaybe<Django_Migrations_Bool_Exp>;
};


export type SubscriptionDjango_Migrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Migrations_Order_By>>;
  where?: InputMaybe<Django_Migrations_Bool_Exp>;
};


export type SubscriptionDjango_Migrations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionDjango_Migrations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Django_Migrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Django_Migrations_Bool_Exp>;
};


export type SubscriptionDjango_SessionArgs = {
  distinct_on?: InputMaybe<Array<Django_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Session_Order_By>>;
  where?: InputMaybe<Django_Session_Bool_Exp>;
};


export type SubscriptionDjango_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Session_Order_By>>;
  where?: InputMaybe<Django_Session_Bool_Exp>;
};


export type SubscriptionDjango_Session_By_PkArgs = {
  session_key: Scalars['String']['input'];
};


export type SubscriptionDjango_Session_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Django_Session_Stream_Cursor_Input>>;
  where?: InputMaybe<Django_Session_Bool_Exp>;
};


export type SubscriptionDjango_SiteArgs = {
  distinct_on?: InputMaybe<Array<Django_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Site_Order_By>>;
  where?: InputMaybe<Django_Site_Bool_Exp>;
};


export type SubscriptionDjango_Site_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Site_Order_By>>;
  where?: InputMaybe<Django_Site_Bool_Exp>;
};


export type SubscriptionDjango_Site_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionDjango_Site_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Django_Site_Stream_Cursor_Input>>;
  where?: InputMaybe<Django_Site_Bool_Exp>;
};


export type SubscriptionDjconfig_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Djconfig_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Djconfig_Config_Order_By>>;
  where?: InputMaybe<Djconfig_Config_Bool_Exp>;
};


export type SubscriptionDjconfig_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Djconfig_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Djconfig_Config_Order_By>>;
  where?: InputMaybe<Djconfig_Config_Bool_Exp>;
};


export type SubscriptionDjconfig_Config_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionDjconfig_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Djconfig_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Djconfig_Config_Bool_Exp>;
};


export type SubscriptionGet_Random_QuestionArgs = {
  args: Get_Random_Question_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionGet_Random_Question_AggregateArgs = {
  args: Get_Random_Question_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionGet_Speed_Concepts_All_Random_QuestionsArgs = {
  args: Get_Speed_Concepts_All_Random_Questions_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionGet_Speed_Concepts_All_Random_Questions_AggregateArgs = {
  args: Get_Speed_Concepts_All_Random_Questions_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionGet_Speed_Concepts_Random_QuestionArgs = {
  args: Get_Speed_Concepts_Random_Question_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionGet_Speed_Concepts_Random_Question_AggregateArgs = {
  args: Get_Speed_Concepts_Random_Question_Args;
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionGroup_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Group_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Category_Order_By>>;
  where?: InputMaybe<Group_Category_Bool_Exp>;
};


export type SubscriptionGroup_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Category_Order_By>>;
  where?: InputMaybe<Group_Category_Bool_Exp>;
};


export type SubscriptionGroup_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionGroup_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Group_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Group_Category_Bool_Exp>;
};


export type SubscriptionGroup_Discount_UsersArgs = {
  distinct_on?: InputMaybe<Array<Group_Discount_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Discount_Users_Order_By>>;
  where?: InputMaybe<Group_Discount_Users_Bool_Exp>;
};


export type SubscriptionGroup_Discount_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Discount_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Discount_Users_Order_By>>;
  where?: InputMaybe<Group_Discount_Users_Bool_Exp>;
};


export type SubscriptionGroup_Discount_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Group_Discount_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Group_Discount_Users_Bool_Exp>;
};


export type SubscriptionHas_AccessArgs = {
  distinct_on?: InputMaybe<Array<Has_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Has_Access_Order_By>>;
  where?: InputMaybe<Has_Access_Bool_Exp>;
};


export type SubscriptionHas_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Has_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Has_Access_Order_By>>;
  where?: InputMaybe<Has_Access_Bool_Exp>;
};


export type SubscriptionHas_Access_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Has_Access_Stream_Cursor_Input>>;
  where?: InputMaybe<Has_Access_Bool_Exp>;
};


export type SubscriptionInfozone_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Category_Order_By>>;
  where?: InputMaybe<Infozone_Category_Bool_Exp>;
};


export type SubscriptionInfozone_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Category_Order_By>>;
  where?: InputMaybe<Infozone_Category_Bool_Exp>;
};


export type SubscriptionInfozone_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionInfozone_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Infozone_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Infozone_Category_Bool_Exp>;
};


export type SubscriptionInfozone_InfozoneArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Infozone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Infozone_Order_By>>;
  where?: InputMaybe<Infozone_Infozone_Bool_Exp>;
};


export type SubscriptionInfozone_Infozone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Infozone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Infozone_Order_By>>;
  where?: InputMaybe<Infozone_Infozone_Bool_Exp>;
};


export type SubscriptionInfozone_Infozone_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionInfozone_Infozone_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Infozone_Infozone_Stream_Cursor_Input>>;
  where?: InputMaybe<Infozone_Infozone_Bool_Exp>;
};


export type SubscriptionInfozone_StaticpagesArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Staticpages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Staticpages_Order_By>>;
  where?: InputMaybe<Infozone_Staticpages_Bool_Exp>;
};


export type SubscriptionInfozone_Staticpages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Staticpages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Staticpages_Order_By>>;
  where?: InputMaybe<Infozone_Staticpages_Bool_Exp>;
};


export type SubscriptionInfozone_Staticpages_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionInfozone_Staticpages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Infozone_Staticpages_Stream_Cursor_Input>>;
  where?: InputMaybe<Infozone_Staticpages_Bool_Exp>;
};


export type SubscriptionLive_Quiz_LeaderboardArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Leaderboard_Order_By>>;
  where?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Leaderboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Leaderboard_Order_By>>;
  where?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Leaderboard_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionLive_Quiz_Leaderboard_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Live_Quiz_Leaderboard_Stream_Cursor_Input>>;
  where?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Question_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Question_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Question_Positions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionLive_Quiz_Question_Positions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Live_Quiz_Question_Positions_Stream_Cursor_Input>>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Question_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Question_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Question_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionLive_Quiz_Question_Summary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Live_Quiz_Question_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};


export type SubscriptionLive_Quiz_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
};


export type SubscriptionLive_Quiz_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionLive_Quiz_Summary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Live_Quiz_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_DilrArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Dilr_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_Dilr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Dilr_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_Dilr_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMarks_Vs_Percentile_Dilr_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marks_Vs_Percentile_Dilr_Stream_Cursor_Input>>;
  where?: InputMaybe<Marks_Vs_Percentile_Dilr_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_QuantArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Quant_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_Quant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Quant_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_Quant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMarks_Vs_Percentile_Quant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marks_Vs_Percentile_Quant_Stream_Cursor_Input>>;
  where?: InputMaybe<Marks_Vs_Percentile_Quant_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_Total_RawArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_Total_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_Total_Raw_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMarks_Vs_Percentile_Total_Raw_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marks_Vs_Percentile_Total_Raw_Stream_Cursor_Input>>;
  where?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_VarcArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Varc_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_Varc_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Order_By>>;
  where?: InputMaybe<Marks_Vs_Percentile_Varc_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Percentile_Varc_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMarks_Vs_Percentile_Varc_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marks_Vs_Percentile_Varc_Stream_Cursor_Input>>;
  where?: InputMaybe<Marks_Vs_Percentile_Varc_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Scaled_PercentileArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Order_By>>;
  where?: InputMaybe<Marks_Vs_Scaled_Percentile_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Scaled_Percentile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Order_By>>;
  where?: InputMaybe<Marks_Vs_Scaled_Percentile_Bool_Exp>;
};


export type SubscriptionMarks_Vs_Scaled_Percentile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMarks_Vs_Scaled_Percentile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marks_Vs_Scaled_Percentile_Stream_Cursor_Input>>;
  where?: InputMaybe<Marks_Vs_Scaled_Percentile_Bool_Exp>;
};


export type SubscriptionMeeting_MembersArgs = {
  distinct_on?: InputMaybe<Array<Meeting_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meeting_Members_Order_By>>;
  where?: InputMaybe<Meeting_Members_Bool_Exp>;
};


export type SubscriptionMeeting_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meeting_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meeting_Members_Order_By>>;
  where?: InputMaybe<Meeting_Members_Bool_Exp>;
};


export type SubscriptionMeeting_Members_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMeeting_Members_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Meeting_Members_Stream_Cursor_Input>>;
  where?: InputMaybe<Meeting_Members_Bool_Exp>;
};


export type SubscriptionMeetingsArgs = {
  distinct_on?: InputMaybe<Array<Meetings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meetings_Order_By>>;
  where?: InputMaybe<Meetings_Bool_Exp>;
};


export type SubscriptionMeetings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meetings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meetings_Order_By>>;
  where?: InputMaybe<Meetings_Bool_Exp>;
};


export type SubscriptionMeetings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMeetings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Meetings_Stream_Cursor_Input>>;
  where?: InputMaybe<Meetings_Bool_Exp>;
};


export type SubscriptionMessage_ReactionsArgs = {
  distinct_on?: InputMaybe<Array<Message_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Message_Reactions_Order_By>>;
  where?: InputMaybe<Message_Reactions_Bool_Exp>;
};


export type SubscriptionMessage_Reactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Message_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Message_Reactions_Order_By>>;
  where?: InputMaybe<Message_Reactions_Bool_Exp>;
};


export type SubscriptionMessage_Reactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMessage_Reactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Message_Reactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Message_Reactions_Bool_Exp>;
};


export type SubscriptionMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type SubscriptionMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type SubscriptionMessages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMessages_ReadArgs = {
  distinct_on?: InputMaybe<Array<Messages_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Read_Order_By>>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};


export type SubscriptionMessages_Read_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Read_Order_By>>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};


export type SubscriptionMessages_Read_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionMessages_Read_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Messages_Read_Stream_Cursor_Input>>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};


export type SubscriptionMessages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type SubscriptionOffline_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Offline_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offline_Leads_Order_By>>;
  where?: InputMaybe<Offline_Leads_Bool_Exp>;
};


export type SubscriptionOffline_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offline_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offline_Leads_Order_By>>;
  where?: InputMaybe<Offline_Leads_Bool_Exp>;
};


export type SubscriptionOffline_Leads_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionOffline_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Offline_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Offline_Leads_Bool_Exp>;
};


export type SubscriptionPackage_Content_Discarded_QuizzesArgs = {
  distinct_on?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Order_By>>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};


export type SubscriptionPackage_Content_Discarded_Quizzes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Order_By>>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};


export type SubscriptionPackage_Content_Discarded_Quizzes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionPackage_Content_Discarded_Quizzes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Package_Content_Discarded_Quizzes_Stream_Cursor_Input>>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};


export type SubscriptionPackages_ContentArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Order_By>>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};


export type SubscriptionPackages_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Order_By>>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};


export type SubscriptionPackages_Content_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionPackages_Content_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Domains_Order_By>>;
  where?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
};


export type SubscriptionPackages_Content_Domains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Domains_Order_By>>;
  where?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
};


export type SubscriptionPackages_Content_Domains_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionPackages_Content_Domains_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Packages_Content_Domains_Stream_Cursor_Input>>;
  where?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
};


export type SubscriptionPackages_Content_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Packages_Content_Stream_Cursor_Input>>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};


export type SubscriptionPackages_Content_Text_LessonArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Text_Lesson_Order_By>>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};


export type SubscriptionPackages_Content_Text_Lesson_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Text_Lesson_Order_By>>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};


export type SubscriptionPackages_Content_Text_Lesson_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionPackages_Content_Text_Lesson_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Packages_Content_Text_Lesson_Stream_Cursor_Input>>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};


export type SubscriptionPackages_Content_Timed_TestArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Timed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};


export type SubscriptionPackages_Content_Timed_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Timed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};


export type SubscriptionPackages_Content_Timed_Test_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionPackages_Content_Timed_Test_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Packages_Content_Timed_Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};


export type SubscriptionPackages_Content_Untimed_TestArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Untimed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};


export type SubscriptionPackages_Content_Untimed_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Untimed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};


export type SubscriptionPackages_Content_Untimed_Test_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionPackages_Content_Untimed_Test_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Packages_Content_Untimed_Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};


export type SubscriptionPackages_Payment_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


export type SubscriptionPackages_Payment_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


export type SubscriptionPackages_Payment_Transaction_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionPackages_Payment_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Packages_Payment_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


export type SubscriptionPackages_PaymenttransactionArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


export type SubscriptionPackages_Paymenttransaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


export type SubscriptionPackages_Paymenttransaction_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionPackages_Paymenttransaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Packages_Paymenttransaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


export type SubscriptionPollArgs = {
  distinct_on?: InputMaybe<Array<Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Order_By>>;
  where?: InputMaybe<Poll_Bool_Exp>;
};


export type SubscriptionPoll_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Order_By>>;
  where?: InputMaybe<Poll_Bool_Exp>;
};


export type SubscriptionPoll_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionPoll_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Poll_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Options_Order_By>>;
  where?: InputMaybe<Poll_Options_Bool_Exp>;
};


export type SubscriptionPoll_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Options_Order_By>>;
  where?: InputMaybe<Poll_Options_Bool_Exp>;
};


export type SubscriptionPoll_Options_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionPoll_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Poll_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Poll_Options_Bool_Exp>;
};


export type SubscriptionPoll_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Responses_Order_By>>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};


export type SubscriptionPoll_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Responses_Order_By>>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};


export type SubscriptionPoll_Responses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionPoll_Responses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Poll_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};


export type SubscriptionPoll_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Poll_Stream_Cursor_Input>>;
  where?: InputMaybe<Poll_Bool_Exp>;
};


export type SubscriptionQuestion_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Question_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Reports_Order_By>>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};


export type SubscriptionQuestion_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Reports_Order_By>>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};


export type SubscriptionQuestion_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionQuestion_Reports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Question_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};


export type SubscriptionQuiz_AnswerArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Answer_Order_By>>;
  where?: InputMaybe<Quiz_Answer_Bool_Exp>;
};


export type SubscriptionQuiz_Answer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Answer_Order_By>>;
  where?: InputMaybe<Quiz_Answer_Bool_Exp>;
};


export type SubscriptionQuiz_Answer_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Answer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Answer_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Answer_Bool_Exp>;
};


export type SubscriptionQuiz_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Category_Order_By>>;
  where?: InputMaybe<Quiz_Category_Bool_Exp>;
};


export type SubscriptionQuiz_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Category_Order_By>>;
  where?: InputMaybe<Quiz_Category_Bool_Exp>;
};


export type SubscriptionQuiz_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Category_Bool_Exp>;
};


export type SubscriptionQuiz_DomainArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Domain_Order_By>>;
  where?: InputMaybe<Quiz_Domain_Bool_Exp>;
};


export type SubscriptionQuiz_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Domain_Order_By>>;
  where?: InputMaybe<Quiz_Domain_Bool_Exp>;
};


export type SubscriptionQuiz_Domain_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Domain_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Domain_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Domain_Bool_Exp>;
};


export type SubscriptionQuiz_MarkingsystemArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Markingsystem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Markingsystem_Order_By>>;
  where?: InputMaybe<Quiz_Markingsystem_Bool_Exp>;
};


export type SubscriptionQuiz_Markingsystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Markingsystem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Markingsystem_Order_By>>;
  where?: InputMaybe<Quiz_Markingsystem_Bool_Exp>;
};


export type SubscriptionQuiz_Markingsystem_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Markingsystem_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Markingsystem_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Markingsystem_Bool_Exp>;
};


export type SubscriptionQuiz_OptionArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Option_Order_By>>;
  where?: InputMaybe<Quiz_Option_Bool_Exp>;
};


export type SubscriptionQuiz_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Option_Order_By>>;
  where?: InputMaybe<Quiz_Option_Bool_Exp>;
};


export type SubscriptionQuiz_Option_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Option_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Option_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Option_Bool_Exp>;
};


export type SubscriptionQuiz_ParagraphArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Paragraph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Paragraph_Order_By>>;
  where?: InputMaybe<Quiz_Paragraph_Bool_Exp>;
};


export type SubscriptionQuiz_Paragraph_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Paragraph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Paragraph_Order_By>>;
  where?: InputMaybe<Quiz_Paragraph_Bool_Exp>;
};


export type SubscriptionQuiz_Paragraph_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Paragraph_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Paragraph_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Paragraph_Bool_Exp>;
};


export type SubscriptionQuiz_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Question_Order_By>>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};


export type SubscriptionQuiz_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Question_Order_By>>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};


export type SubscriptionQuiz_Question_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Question_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Question_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};


export type SubscriptionQuiz_QuizArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};


export type SubscriptionQuiz_Quiz_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};


export type SubscriptionQuiz_Quiz_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Quiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionQuiz_Quiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionQuiz_Quiz_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Quiz_Questions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Quiz_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionQuiz_Quiz_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Sections_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};


export type SubscriptionQuiz_Quiz_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Sections_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};


export type SubscriptionQuiz_Quiz_Sections_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Quiz_Sections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Quiz_Sections_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};


export type SubscriptionQuiz_Quiz_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Quiz_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};


export type SubscriptionQuiz_SectionArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Order_By>>;
  where?: InputMaybe<Quiz_Section_Bool_Exp>;
};


export type SubscriptionQuiz_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Order_By>>;
  where?: InputMaybe<Quiz_Section_Bool_Exp>;
};


export type SubscriptionQuiz_Section_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Section_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};


export type SubscriptionQuiz_Section_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};


export type SubscriptionQuiz_Section_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Section_Questions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Section_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};


export type SubscriptionQuiz_Section_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Section_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Section_Bool_Exp>;
};


export type SubscriptionQuiz_Section_SubsectionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Subsections_Order_By>>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};


export type SubscriptionQuiz_Section_Subsections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Subsections_Order_By>>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};


export type SubscriptionQuiz_Section_Subsections_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Section_Subsections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Section_Subsections_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};


export type SubscriptionQuiz_SuperdomainArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Superdomain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Superdomain_Order_By>>;
  where?: InputMaybe<Quiz_Superdomain_Bool_Exp>;
};


export type SubscriptionQuiz_Superdomain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Superdomain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Superdomain_Order_By>>;
  where?: InputMaybe<Quiz_Superdomain_Bool_Exp>;
};


export type SubscriptionQuiz_Superdomain_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionQuiz_Superdomain_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quiz_Superdomain_Stream_Cursor_Input>>;
  where?: InputMaybe<Quiz_Superdomain_Bool_Exp>;
};


export type SubscriptionRandom_Question_IdsArgs = {
  distinct_on?: InputMaybe<Array<Random_Question_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Random_Question_Ids_Order_By>>;
  where?: InputMaybe<Random_Question_Ids_Bool_Exp>;
};


export type SubscriptionRandom_Question_Ids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Random_Question_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Random_Question_Ids_Order_By>>;
  where?: InputMaybe<Random_Question_Ids_Bool_Exp>;
};


export type SubscriptionRandom_Question_Ids_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Random_Question_Ids_Stream_Cursor_Input>>;
  where?: InputMaybe<Random_Question_Ids_Bool_Exp>;
};


export type SubscriptionReaction_EmojisArgs = {
  distinct_on?: InputMaybe<Array<Reaction_Emojis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reaction_Emojis_Order_By>>;
  where?: InputMaybe<Reaction_Emojis_Bool_Exp>;
};


export type SubscriptionReaction_Emojis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reaction_Emojis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reaction_Emojis_Order_By>>;
  where?: InputMaybe<Reaction_Emojis_Bool_Exp>;
};


export type SubscriptionReaction_Emojis_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionReaction_Emojis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reaction_Emojis_Stream_Cursor_Input>>;
  where?: InputMaybe<Reaction_Emojis_Bool_Exp>;
};


export type SubscriptionReported_MessageArgs = {
  distinct_on?: InputMaybe<Array<Reported_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reported_Message_Order_By>>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};


export type SubscriptionReported_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reported_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reported_Message_Order_By>>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};


export type SubscriptionReported_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionReported_Message_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reported_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};


export type SubscriptionScaling_ConstantArgs = {
  distinct_on?: InputMaybe<Array<Scaling_Constant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scaling_Constant_Order_By>>;
  where?: InputMaybe<Scaling_Constant_Bool_Exp>;
};


export type SubscriptionScaling_Constant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scaling_Constant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scaling_Constant_Order_By>>;
  where?: InputMaybe<Scaling_Constant_Bool_Exp>;
};


export type SubscriptionScaling_Constant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionScaling_Constant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scaling_Constant_Stream_Cursor_Input>>;
  where?: InputMaybe<Scaling_Constant_Bool_Exp>;
};


export type SubscriptionSocialaccount_SocialaccountArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialaccount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialaccount_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
};


export type SubscriptionSocialaccount_Socialaccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialaccount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialaccount_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
};


export type SubscriptionSocialaccount_Socialaccount_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSocialaccount_Socialaccount_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Socialaccount_Socialaccount_Stream_Cursor_Input>>;
  where?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
};


export type SubscriptionSocialaccount_SocialappArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Bool_Exp>;
};


export type SubscriptionSocialaccount_Socialapp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Bool_Exp>;
};


export type SubscriptionSocialaccount_Socialapp_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSocialaccount_Socialapp_SitesArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};


export type SubscriptionSocialaccount_Socialapp_Sites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};


export type SubscriptionSocialaccount_Socialapp_Sites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSocialaccount_Socialapp_Sites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Socialaccount_Socialapp_Sites_Stream_Cursor_Input>>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};


export type SubscriptionSocialaccount_Socialapp_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Socialaccount_Socialapp_Stream_Cursor_Input>>;
  where?: InputMaybe<Socialaccount_Socialapp_Bool_Exp>;
};


export type SubscriptionSocialaccount_SocialtokenArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialtoken_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};


export type SubscriptionSocialaccount_Socialtoken_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialtoken_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};


export type SubscriptionSocialaccount_Socialtoken_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSocialaccount_Socialtoken_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Socialaccount_Socialtoken_Stream_Cursor_Input>>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};


export type SubscriptionSpeed_Test_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Speed_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Test_Category_Order_By>>;
  where?: InputMaybe<Speed_Test_Category_Bool_Exp>;
};


export type SubscriptionSpeed_Test_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speed_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Test_Category_Order_By>>;
  where?: InputMaybe<Speed_Test_Category_Bool_Exp>;
};


export type SubscriptionSpeed_Test_Category_By_PkArgs = {
  category: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type SubscriptionSpeed_Test_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Speed_Test_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Speed_Test_Category_Bool_Exp>;
};


export type SubscriptionSpeed_TestsArgs = {
  distinct_on?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Tests_Order_By>>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};


export type SubscriptionSpeed_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Tests_Order_By>>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};


export type SubscriptionSpeed_Tests_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpeed_Tests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Speed_Tests_Stream_Cursor_Input>>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};


export type SubscriptionSpirit_CacheArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Cache_Order_By>>;
  where?: InputMaybe<Spirit_Cache_Bool_Exp>;
};


export type SubscriptionSpirit_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Cache_Order_By>>;
  where?: InputMaybe<Spirit_Cache_Bool_Exp>;
};


export type SubscriptionSpirit_Cache_By_PkArgs = {
  cache_key: Scalars['String']['input'];
};


export type SubscriptionSpirit_Cache_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Cache_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Cache_Bool_Exp>;
};


export type SubscriptionSpirit_Category_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Category_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Category_Category_Order_By>>;
  where?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
};


export type SubscriptionSpirit_Category_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Category_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Category_Category_Order_By>>;
  where?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
};


export type SubscriptionSpirit_Category_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Category_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Category_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Bookmark_CommentbookmarkArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Bookmark_Commentbookmark_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Bookmark_Commentbookmark_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Comment_Bookmark_Commentbookmark_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_CommentArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Comment_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Comment_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Comment_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Comment_Comment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Comment_Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Flag_CommentflagArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Flag_Commentflag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Flag_Commentflag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Comment_Flag_Commentflag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Comment_Flag_Commentflag_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Flag_FlagArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Flag_Flag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Flag_Flag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Comment_Flag_Flag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Comment_Flag_Flag_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_History_CommenthistoryArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Order_By>>;
  where?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_History_Commenthistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Order_By>>;
  where?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_History_Commenthistory_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Comment_History_Commenthistory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Comment_History_Commenthistory_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Like_CommentlikeArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Like_Commentlike_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Like_Commentlike_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Comment_Like_Commentlike_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Comment_Like_Commentlike_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Poll_CommentpollArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Poll_Commentpoll_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Poll_Commentpoll_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Comment_Poll_Commentpoll_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Comment_Poll_Commentpoll_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Poll_CommentpollchoiceArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Poll_Commentpollchoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Poll_Commentpollchoice_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Comment_Poll_Commentpollchoice_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Poll_CommentpollvoteArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Poll_Commentpollvote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};


export type SubscriptionSpirit_Comment_Poll_Commentpollvote_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Comment_Poll_Commentpollvote_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Comment_Poll_Commentpollvote_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};


export type SubscriptionSpirit_Rl_CacheArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Rl_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Rl_Cache_Order_By>>;
  where?: InputMaybe<Spirit_Rl_Cache_Bool_Exp>;
};


export type SubscriptionSpirit_Rl_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Rl_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Rl_Cache_Order_By>>;
  where?: InputMaybe<Spirit_Rl_Cache_Bool_Exp>;
};


export type SubscriptionSpirit_Rl_Cache_By_PkArgs = {
  cache_key: Scalars['String']['input'];
};


export type SubscriptionSpirit_Rl_Cache_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Rl_Cache_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Rl_Cache_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Favorite_TopicfavoriteArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Favorite_Topicfavorite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Favorite_Topicfavorite_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Topic_Favorite_Topicfavorite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Notification_TopicnotificationArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Notification_Topicnotification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Notification_Topicnotification_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Topic_Notification_Topicnotification_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Topic_Notification_Topicnotification_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Private_TopicprivateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Private_Topicprivate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Private_Topicprivate_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Topic_Private_Topicprivate_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Topic_Private_Topicprivate_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_TopicArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Topic_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Topic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Topic_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Topic_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Topic_Topic_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Topic_Topic_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Unread_TopicunreadArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Unread_Topicunread_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};


export type SubscriptionSpirit_Topic_Unread_Topicunread_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_Topic_Unread_Topicunread_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_Topic_Unread_Topicunread_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};


export type SubscriptionSpirit_User_UserprofileArgs = {
  distinct_on?: InputMaybe<Array<Spirit_User_Userprofile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_User_Userprofile_Order_By>>;
  where?: InputMaybe<Spirit_User_Userprofile_Bool_Exp>;
};


export type SubscriptionSpirit_User_Userprofile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_User_Userprofile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_User_Userprofile_Order_By>>;
  where?: InputMaybe<Spirit_User_Userprofile_Bool_Exp>;
};


export type SubscriptionSpirit_User_Userprofile_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSpirit_User_Userprofile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spirit_User_Userprofile_Stream_Cursor_Input>>;
  where?: InputMaybe<Spirit_User_Userprofile_Bool_Exp>;
};


export type SubscriptionSubscription_Group_PlanArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
};


export type SubscriptionSubscription_Group_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
};


export type SubscriptionSubscription_Group_Plan_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSubscription_Group_Plan_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Groups_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
};


export type SubscriptionSubscription_Group_Plan_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Groups_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
};


export type SubscriptionSubscription_Group_Plan_Groups_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSubscription_Group_Plan_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscription_Group_Plan_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
};


export type SubscriptionSubscription_Group_Plan_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscription_Group_Plan_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
};


export type SubscriptionSubscriptions_PlancostArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plancost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plancost_Order_By>>;
  where?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
};


export type SubscriptionSubscriptions_Plancost_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plancost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plancost_Order_By>>;
  where?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
};


export type SubscriptionSubscriptions_Plancost_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionSubscriptions_Plancost_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Plancost_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
};


export type SubscriptionSubscriptions_PlanlistArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlist_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlist_Bool_Exp>;
};


export type SubscriptionSubscriptions_Planlist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlist_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlist_Bool_Exp>;
};


export type SubscriptionSubscriptions_Planlist_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSubscriptions_Planlist_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Planlist_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Planlist_Bool_Exp>;
};


export type SubscriptionSubscriptions_PlanlistdetailArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlistdetail_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};


export type SubscriptionSubscriptions_Planlistdetail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlistdetail_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};


export type SubscriptionSubscriptions_Planlistdetail_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSubscriptions_Planlistdetail_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Planlistdetail_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};


export type SubscriptionSubscriptions_PlantagArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plantag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plantag_Order_By>>;
  where?: InputMaybe<Subscriptions_Plantag_Bool_Exp>;
};


export type SubscriptionSubscriptions_Plantag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plantag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plantag_Order_By>>;
  where?: InputMaybe<Subscriptions_Plantag_Bool_Exp>;
};


export type SubscriptionSubscriptions_Plantag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSubscriptions_Plantag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Plantag_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Plantag_Bool_Exp>;
};


export type SubscriptionSubscriptions_SubscriptionplanArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
};


export type SubscriptionSubscriptions_Subscriptionplan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
};


export type SubscriptionSubscriptions_Subscriptionplan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionSubscriptions_Subscriptionplan_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Subscriptionplan_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
};


export type SubscriptionSubscriptions_Subscriptionplan_Upgradable_PlansArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};


export type SubscriptionSubscriptions_Subscriptionplan_Upgradable_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};


export type SubscriptionSubscriptions_Subscriptionplan_Upgradable_Plans_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSubscriptions_Subscriptionplan_Upgradable_Plans_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};


export type SubscriptionSubscriptions_SubscriptiontransactionArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};


export type SubscriptionSubscriptions_Subscriptiontransaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};


export type SubscriptionSubscriptions_Subscriptiontransaction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionSubscriptions_Subscriptiontransaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Subscriptiontransaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};


export type SubscriptionSubscriptions_UsersubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Usersubscription_Order_By>>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};


export type SubscriptionSubscriptions_Usersubscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Usersubscription_Order_By>>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};


export type SubscriptionSubscriptions_Usersubscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionSubscriptions_Usersubscription_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Usersubscription_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};


export type SubscriptionSupertokens_All_Auth_Recipe_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Order_By>>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_All_Auth_Recipe_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Order_By>>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_All_Auth_Recipe_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_All_Auth_Recipe_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_All_Auth_Recipe_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_App_Id_To_User_IdArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Order_By>>;
  where?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
};


export type SubscriptionSupertokens_App_Id_To_User_Id_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Order_By>>;
  where?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
};


export type SubscriptionSupertokens_App_Id_To_User_Id_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_App_Id_To_User_Id_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_App_Id_To_User_Id_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
};


export type SubscriptionSupertokens_AppsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Apps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Apps_Order_By>>;
  where?: InputMaybe<Supertokens_Apps_Bool_Exp>;
};


export type SubscriptionSupertokens_Apps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Apps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Apps_Order_By>>;
  where?: InputMaybe<Supertokens_Apps_Bool_Exp>;
};


export type SubscriptionSupertokens_Apps_By_PkArgs = {
  app_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Apps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Apps_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Apps_Bool_Exp>;
};


export type SubscriptionSupertokens_Dashboard_User_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
};


export type SubscriptionSupertokens_Dashboard_User_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
};


export type SubscriptionSupertokens_Dashboard_User_Sessions_By_PkArgs = {
  app_id: Scalars['String']['input'];
  session_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Dashboard_User_Sessions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Dashboard_User_Sessions_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
};


export type SubscriptionSupertokens_Dashboard_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Dashboard_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Dashboard_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Dashboard_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Dashboard_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailpassword_Pswd_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailpassword_Pswd_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailpassword_Pswd_Reset_Tokens_By_PkArgs = {
  app_id: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Emailpassword_Pswd_Reset_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailpassword_User_To_TenantArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailpassword_User_To_Tenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailpassword_User_To_Tenant_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Emailpassword_User_To_Tenant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailpassword_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailpassword_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailpassword_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Emailpassword_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Emailpassword_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailverification_TokensArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailverification_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailverification_Tokens_By_PkArgs = {
  app_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Emailverification_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Emailverification_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailverification_Verified_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailverification_Verified_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
};


export type SubscriptionSupertokens_Emailverification_Verified_Emails_By_PkArgs = {
  app_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Emailverification_Verified_Emails_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Emailverification_Verified_Emails_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
};


export type SubscriptionSupertokens_Jwt_Signing_KeysArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
};


export type SubscriptionSupertokens_Jwt_Signing_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
};


export type SubscriptionSupertokens_Jwt_Signing_Keys_By_PkArgs = {
  app_id: Scalars['String']['input'];
  key_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Jwt_Signing_Keys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Jwt_Signing_Keys_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
};


export type SubscriptionSupertokens_Key_ValueArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Key_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Key_Value_Order_By>>;
  where?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
};


export type SubscriptionSupertokens_Key_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Key_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Key_Value_Order_By>>;
  where?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
};


export type SubscriptionSupertokens_Key_Value_By_PkArgs = {
  app_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Key_Value_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Key_Value_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_CodesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Codes_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Codes_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_Codes_By_PkArgs = {
  app_id: Scalars['String']['input'];
  code_id: Scalars['bpchar']['input'];
  tenant_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Passwordless_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Passwordless_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Devices_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Devices_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_Devices_By_PkArgs = {
  app_id: Scalars['String']['input'];
  device_id_hash: Scalars['bpchar']['input'];
  tenant_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Passwordless_Devices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Passwordless_Devices_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_User_To_TenantArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_User_To_Tenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_User_To_Tenant_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Passwordless_User_To_Tenant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Passwordless_User_To_Tenant_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Passwordless_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Passwordless_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Passwordless_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Passwordless_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Role_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Role_Permissions_Order_By>>;
  where?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
};


export type SubscriptionSupertokens_Role_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Role_Permissions_Order_By>>;
  where?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
};


export type SubscriptionSupertokens_Role_Permissions_By_PkArgs = {
  app_id: Scalars['String']['input'];
  permission: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Role_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Role_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
};


export type SubscriptionSupertokens_RolesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_Roles_Bool_Exp>;
};


export type SubscriptionSupertokens_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_Roles_Bool_Exp>;
};


export type SubscriptionSupertokens_Roles_By_PkArgs = {
  app_id: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Roles_Bool_Exp>;
};


export type SubscriptionSupertokens_Session_Access_Token_Signing_KeysArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
};


export type SubscriptionSupertokens_Session_Access_Token_Signing_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
};


export type SubscriptionSupertokens_Session_Access_Token_Signing_Keys_By_PkArgs = {
  app_id: Scalars['String']['input'];
  created_at_time: Scalars['bigint']['input'];
};


export type SubscriptionSupertokens_Session_Access_Token_Signing_Keys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
};


export type SubscriptionSupertokens_Session_InfoArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Info_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
};


export type SubscriptionSupertokens_Session_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Info_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
};


export type SubscriptionSupertokens_Session_Info_By_PkArgs = {
  app_id: Scalars['String']['input'];
  session_handle: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Session_Info_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Session_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenant_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Configs_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Configs_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenant_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Configs_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Configs_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenant_Configs_By_PkArgs = {
  app_id: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Tenant_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Tenant_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Tenant_Configs_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenant_Thirdparty_Provider_ClientsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenant_Thirdparty_Provider_Clients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenant_Thirdparty_Provider_Clients_By_PkArgs = {
  app_id: Scalars['String']['input'];
  client_type: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  third_party_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Tenant_Thirdparty_Provider_Clients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenant_Thirdparty_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenant_Thirdparty_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenant_Thirdparty_Providers_By_PkArgs = {
  app_id: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  third_party_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Tenant_Thirdparty_Providers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
};


export type SubscriptionSupertokens_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenants_Order_By>>;
  where?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenants_Order_By>>;
  where?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
};


export type SubscriptionSupertokens_Tenants_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_Tenants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
};


export type SubscriptionSupertokens_Thirdparty_User_To_TenantArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>;
};


export type SubscriptionSupertokens_Thirdparty_User_To_Tenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Order_By>>;
  where?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>;
};


export type SubscriptionSupertokens_Thirdparty_User_To_Tenant_By_PkArgs = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Thirdparty_User_To_Tenant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>;
};


export type SubscriptionSupertokens_Thirdparty_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Thirdparty_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Thirdparty_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Thirdparty_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Thirdparty_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Thirdparty_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Thirdparty_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Thirdparty_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_Thirdparty_Users_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Thirdparty_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Thirdparty_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Thirdparty_Users_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Additional_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Additional_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Additional_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Additional_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Additional_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Additional_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Additional_Fields_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionSupertokens_User_Additional_Fields_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_User_Additional_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Last_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Last_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Last_Active_Order_By>>;
  where?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Last_Active_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Last_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Last_Active_Order_By>>;
  where?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Last_Active_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_User_Last_Active_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_User_Last_Active_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
};


export type SubscriptionSupertokens_User_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Metadata_Order_By>>;
  where?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Metadata_Order_By>>;
  where?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Metadata_By_PkArgs = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_User_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_User_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Public_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Public_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Public_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Public_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Public_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Public_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Public_Fields_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_User_Public_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
};


export type SubscriptionSupertokens_User_RolesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};


export type SubscriptionSupertokens_User_Roles_By_PkArgs = {
  app_id: Scalars['String']['input'];
  role: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type SubscriptionSupertokens_User_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_User_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};


export type SubscriptionSupertokens_Userid_MappingArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Userid_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Userid_Mapping_Order_By>>;
  where?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
};


export type SubscriptionSupertokens_Userid_Mapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Userid_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Userid_Mapping_Order_By>>;
  where?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
};


export type SubscriptionSupertokens_Userid_Mapping_By_PkArgs = {
  app_id: Scalars['String']['input'];
  external_user_id: Scalars['String']['input'];
  supertokens_user_id: Scalars['bpchar']['input'];
};


export type SubscriptionSupertokens_Userid_Mapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supertokens_Userid_Mapping_Stream_Cursor_Input>>;
  where?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
};


export type SubscriptionTaggit_TagArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Tag_Order_By>>;
  where?: InputMaybe<Taggit_Tag_Bool_Exp>;
};


export type SubscriptionTaggit_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Tag_Order_By>>;
  where?: InputMaybe<Taggit_Tag_Bool_Exp>;
};


export type SubscriptionTaggit_Tag_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionTaggit_Tag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Taggit_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Taggit_Tag_Bool_Exp>;
};


export type SubscriptionTaggit_TaggeditemArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Taggeditem_Order_By>>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};


export type SubscriptionTaggit_Taggeditem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Taggeditem_Order_By>>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};


export type SubscriptionTaggit_Taggeditem_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionTaggit_Taggeditem_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Taggit_Taggeditem_Stream_Cursor_Input>>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};


export type SubscriptionUpcoming_Live_ClassesArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Live_Classes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Upcoming_Live_Classes_Order_By>>;
  where?: InputMaybe<Upcoming_Live_Classes_Bool_Exp>;
};


export type SubscriptionUpcoming_Live_Classes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Live_Classes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Upcoming_Live_Classes_Order_By>>;
  where?: InputMaybe<Upcoming_Live_Classes_Bool_Exp>;
};


export type SubscriptionUpcoming_Live_Classes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUpcoming_Live_Classes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Upcoming_Live_Classes_Stream_Cursor_Input>>;
  where?: InputMaybe<Upcoming_Live_Classes_Bool_Exp>;
};


export type SubscriptionUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type SubscriptionUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type SubscriptionUser_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Activities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type SubscriptionUser_ActivityArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type SubscriptionUser_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type SubscriptionUser_Activity_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUser_Activity_Lesson_EntriesArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Lesson_Entries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Lesson_Entries_Order_By>>;
  where?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
};


export type SubscriptionUser_Activity_Lesson_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Lesson_Entries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Lesson_Entries_Order_By>>;
  where?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
};


export type SubscriptionUser_Activity_Lesson_Entries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUser_Activity_Lesson_Entries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Activity_Lesson_Entries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
};


export type SubscriptionUser_Activity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


export type SubscriptionUser_Cat_Registration_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Registration_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Registration_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
};


export type SubscriptionUser_Cat_Registration_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Registration_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Registration_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
};


export type SubscriptionUser_Cat_Registration_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Cat_Registration_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Cat_Registration_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
};


export type SubscriptionUser_Cat_Response_Sheet_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Response_Sheet_Data_Bool_Exp>;
};


export type SubscriptionUser_Cat_Response_Sheet_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Response_Sheet_Data_Bool_Exp>;
};


export type SubscriptionUser_Cat_Response_Sheet_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Cat_Response_Sheet_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Cat_Response_Sheet_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Cat_Response_Sheet_Data_Bool_Exp>;
};


export type SubscriptionUser_Custom_Planned_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Custom_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Custom_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Custom_Planned_Activities_Bool_Exp>;
};


export type SubscriptionUser_Custom_Planned_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Custom_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Custom_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Custom_Planned_Activities_Bool_Exp>;
};


export type SubscriptionUser_Custom_Planned_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Custom_Planned_Activities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Custom_Planned_Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Custom_Planned_Activities_Bool_Exp>;
};


export type SubscriptionUser_Latest_Payment_TransactionArgs = {
  distinct_on?: InputMaybe<Array<User_Latest_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Latest_Payment_Transaction_Order_By>>;
  where?: InputMaybe<User_Latest_Payment_Transaction_Bool_Exp>;
};


export type SubscriptionUser_Latest_Payment_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Latest_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Latest_Payment_Transaction_Order_By>>;
  where?: InputMaybe<User_Latest_Payment_Transaction_Bool_Exp>;
};


export type SubscriptionUser_Latest_Payment_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Latest_Payment_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Latest_Payment_Transaction_Bool_Exp>;
};


export type SubscriptionUser_Leaderboard_TypesArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboard_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboard_Types_Order_By>>;
  where?: InputMaybe<User_Leaderboard_Types_Bool_Exp>;
};


export type SubscriptionUser_Leaderboard_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboard_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboard_Types_Order_By>>;
  where?: InputMaybe<User_Leaderboard_Types_Bool_Exp>;
};


export type SubscriptionUser_Leaderboard_Types_By_PkArgs = {
  category: Scalars['String']['input'];
  sub_type: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type SubscriptionUser_Leaderboard_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Leaderboard_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Leaderboard_Types_Bool_Exp>;
};


export type SubscriptionUser_LeaderboardsArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboards_Order_By>>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};


export type SubscriptionUser_Leaderboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboards_Order_By>>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};


export type SubscriptionUser_Leaderboards_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Leaderboards_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Leaderboards_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};


export type SubscriptionUser_Learn_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Activities_Order_By>>;
  where?: InputMaybe<User_Learn_Activities_Bool_Exp>;
};


export type SubscriptionUser_Learn_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Activities_Order_By>>;
  where?: InputMaybe<User_Learn_Activities_Bool_Exp>;
};


export type SubscriptionUser_Learn_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Learn_Activities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Learn_Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Learn_Activities_Bool_Exp>;
};


export type SubscriptionUser_Learn_Category_ProgressArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Category_Progress_Order_By>>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};


export type SubscriptionUser_Learn_Category_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Category_Progress_Order_By>>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};


export type SubscriptionUser_Learn_Category_Progress_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Learn_Category_Progress_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Learn_Category_Progress_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};


export type SubscriptionUser_Learn_Completed_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Completed_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};


export type SubscriptionUser_Learn_Completed_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Completed_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};


export type SubscriptionUser_Learn_Completed_Topics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Learn_Completed_Topics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Learn_Completed_Topics_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};


export type SubscriptionUser_Learn_Modules_SummaryArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Modules_Summary_Order_By>>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};


export type SubscriptionUser_Learn_Modules_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Modules_Summary_Order_By>>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};


export type SubscriptionUser_Learn_Modules_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Learn_Modules_Summary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Learn_Modules_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};


export type SubscriptionUser_Learn_Track_RecordArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};


export type SubscriptionUser_Learn_Track_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};


export type SubscriptionUser_Learn_Track_Record_Bookmarked_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};


export type SubscriptionUser_Learn_Track_Record_Bookmarked_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};


export type SubscriptionUser_Learn_Track_Record_Bookmarked_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUser_Learn_Track_Record_Bookmarked_Topics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};


export type SubscriptionUser_Learn_Track_Record_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUser_Learn_Track_Record_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Learn_Track_Record_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};


export type SubscriptionUser_Learn_Track_Record_Which_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};


export type SubscriptionUser_Learn_Track_Record_Which_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};


export type SubscriptionUser_Learn_Track_Record_Which_Topics_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUser_Learn_Track_Record_Which_Topics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Learn_Track_Record_Which_Topics_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};


export type SubscriptionUser_Lesson_Track_RecordsArgs = {
  distinct_on?: InputMaybe<Array<User_Lesson_Track_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Lesson_Track_Records_Order_By>>;
  where?: InputMaybe<User_Lesson_Track_Records_Bool_Exp>;
};


export type SubscriptionUser_Lesson_Track_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Lesson_Track_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Lesson_Track_Records_Order_By>>;
  where?: InputMaybe<User_Lesson_Track_Records_Bool_Exp>;
};


export type SubscriptionUser_Lesson_Track_Records_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Lesson_Track_Records_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Lesson_Track_Records_Bool_Exp>;
};


export type SubscriptionUser_Planned_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


export type SubscriptionUser_Planned_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


export type SubscriptionUser_Planned_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Planned_Activities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Planned_Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


export type SubscriptionUser_Pov_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Pov_Summaries_Order_By>>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Pov_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Pov_Summaries_Order_By>>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Pov_Summaries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUser_Pov_Summaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Pov_Summaries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Attempts_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Attempts_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_Attempts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Quiz_Question_Attempts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Quiz_Question_Attempts_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_PositionsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_Positions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Quiz_Question_Positions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Quiz_Question_Positions_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Quiz_Question_Summaries_OldArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_Summaries_Old_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_Summaries_Old_By_PkArgs = {
  question_id: Scalars['Int']['input'];
  quiz_summary_id: Scalars['Int']['input'];
};


export type SubscriptionUser_Quiz_Question_Summaries_Old_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Quiz_Question_Summaries_Old_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Question_Summaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Quiz_Question_Summaries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Quiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Questions_Order_By>>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Questions_Order_By>>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUser_Quiz_Questions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Quiz_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Section_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Section_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Section_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Quiz_Section_Summaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Quiz_Section_Summaries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Quiz_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Quiz_Summaries_OldArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Summaries_Old_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Summaries_Old_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUser_Quiz_Summaries_Old_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Quiz_Summaries_Old_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};


export type SubscriptionUser_Quiz_Summaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Quiz_Summaries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Recent_LessonsArgs = {
  distinct_on?: InputMaybe<Array<User_Recent_Lessons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Recent_Lessons_Order_By>>;
  where?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
};


export type SubscriptionUser_Recent_Lessons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Recent_Lessons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Recent_Lessons_Order_By>>;
  where?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
};


export type SubscriptionUser_Recent_Lessons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Recent_Lessons_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
};


export type SubscriptionUser_Section_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Section_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Section_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Section_Summaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Section_Summaries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Speed_Test_Questions_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Speed_Test_Questions_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Speed_Test_Questions_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Speed_Test_Questions_Summaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Speed_Test_Questions_Summaries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Speed_Tests_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Speed_Tests_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Speed_Tests_Summaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Speed_Tests_Summaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Speed_Tests_Summaries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Timed_Quiz_SummaryArgs = {
  distinct_on?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Timed_Quiz_Summary_Order_By>>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};


export type SubscriptionUser_Timed_Quiz_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Timed_Quiz_Summary_Order_By>>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};


export type SubscriptionUser_Timed_Quiz_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Timed_Quiz_Summary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Timed_Quiz_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};


export type SubscriptionUser_Total_ScoreArgs = {
  distinct_on?: InputMaybe<Array<User_Total_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Total_Score_Order_By>>;
  where?: InputMaybe<User_Total_Score_Bool_Exp>;
};


export type SubscriptionUser_Total_Score_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Total_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Total_Score_Order_By>>;
  where?: InputMaybe<User_Total_Score_Bool_Exp>;
};


export type SubscriptionUser_Total_Score_By_PkArgs = {
  sum: Scalars['numeric']['input'];
};


export type SubscriptionUser_Total_Score_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Total_Score_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Total_Score_Bool_Exp>;
};


export type SubscriptionUser_Xp_Transaction_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transaction_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transaction_Summaries_Order_By>>;
  where?: InputMaybe<User_Xp_Transaction_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Xp_Transaction_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transaction_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transaction_Summaries_Order_By>>;
  where?: InputMaybe<User_Xp_Transaction_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Xp_Transaction_Summaries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUser_Xp_Transaction_Summaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Xp_Transaction_Summaries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Xp_Transaction_Summaries_Bool_Exp>;
};


export type SubscriptionUser_Xp_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transactions_Order_By>>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};


export type SubscriptionUser_Xp_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transactions_Order_By>>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};


export type SubscriptionUser_Xp_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionUser_Xp_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Xp_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};


export type SubscriptionUsers_UserArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Order_By>>;
  where?: InputMaybe<Users_User_Bool_Exp>;
};


export type SubscriptionUsers_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Order_By>>;
  where?: InputMaybe<Users_User_Bool_Exp>;
};


export type SubscriptionUsers_User_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUsers_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Groups_Order_By>>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};


export type SubscriptionUsers_User_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Groups_Order_By>>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};


export type SubscriptionUsers_User_Groups_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUsers_User_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_User_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};


export type SubscriptionUsers_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_User_Bool_Exp>;
};


export type SubscriptionUsers_User_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};


export type SubscriptionUsers_User_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};


export type SubscriptionUsers_User_User_Permissions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUsers_User_User_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_User_User_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};


export type SubscriptionUsers_UserquestionsummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


export type SubscriptionUsers_Userquestionsummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


export type SubscriptionUsers_Userquestionsummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUsers_Userquestionsummary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Userquestionsummary_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


export type SubscriptionUsers_UserquizsummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquizsummary_Order_By>>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};


export type SubscriptionUsers_Userquizsummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquizsummary_Order_By>>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};


export type SubscriptionUsers_Userquizsummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUsers_Userquizsummary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Userquizsummary_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};


export type SubscriptionUsers_UserquiztimesummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquiztimesummary_Order_By>>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};


export type SubscriptionUsers_Userquiztimesummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquiztimesummary_Order_By>>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};


export type SubscriptionUsers_Userquiztimesummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUsers_Userquiztimesummary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Userquiztimesummary_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};


export type SubscriptionUsers_UsersectionsummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};


export type SubscriptionUsers_Usersectionsummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};


export type SubscriptionUsers_Usersectionsummary_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUsers_Usersectionsummary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Usersectionsummary_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};


export type SubscriptionUtils_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Utils_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utils_Configuration_Order_By>>;
  where?: InputMaybe<Utils_Configuration_Bool_Exp>;
};


export type SubscriptionUtils_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utils_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utils_Configuration_Order_By>>;
  where?: InputMaybe<Utils_Configuration_Bool_Exp>;
};


export type SubscriptionUtils_Configuration_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUtils_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utils_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Utils_Configuration_Bool_Exp>;
};


export type SubscriptionXp_Transaction_TypesArgs = {
  distinct_on?: InputMaybe<Array<Xp_Transaction_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Xp_Transaction_Types_Order_By>>;
  where?: InputMaybe<Xp_Transaction_Types_Bool_Exp>;
};


export type SubscriptionXp_Transaction_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xp_Transaction_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Xp_Transaction_Types_Order_By>>;
  where?: InputMaybe<Xp_Transaction_Types_Bool_Exp>;
};


export type SubscriptionXp_Transaction_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type SubscriptionXp_Transaction_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Xp_Transaction_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Xp_Transaction_Types_Bool_Exp>;
};

export type TimedTestPercentile = {
  __typename?: 'TimedTestPercentile';
  dilr?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  quant?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  varc?: Maybe<Scalars['Float']['output']>;
};

export type TimedTestScore = {
  __typename?: 'TimedTestScore';
  dilr: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  quant: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  varc: Scalars['Float']['output'];
};

export type UploadFilePayload = {
  __typename?: 'UploadFilePayload';
  downloadURL: Scalars['String']['output'];
  fileID: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  /** The upload is a JSON string with the following format: */
  uploadParams: Scalars['String']['output'];
};

export type UploadUrlResponse = {
  __typename?: 'UploadUrlResponse';
  contentType: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserInfoRes = {
  __typename?: 'UserInfoRes';
  avatar?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified: Scalars['Boolean']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  is_visually_impaired: Scalars['Boolean']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  mobile_verified: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['String']['output']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  success: Scalars['Boolean']['output'];
  user?: Maybe<UserInfoRes>;
};

export type VideoCipherOtpPayload = {
  __typename?: 'VideoCipherOTPPayload';
  message?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  playbackInfo?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type XpLeaderBoardData = {
  __typename?: 'XpLeaderBoardData';
  avatar: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  xp: Scalars['Int']['output'];
};

export type XpLeaderBoardResponse = {
  __typename?: 'XpLeaderBoardResponse';
  data?: Maybe<Array<Maybe<XpLeaderBoardData>>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** columns and relationships of "account_emailaddress" */
export type Account_Emailaddress = {
  __typename?: 'account_emailaddress';
  /** An array relationship */
  account_emailconfirmations: Array<Account_Emailconfirmation>;
  /** An aggregate relationship */
  account_emailconfirmations_aggregate: Account_Emailconfirmation_Aggregate;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  primary: Scalars['Boolean']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
  verified: Scalars['Boolean']['output'];
};


/** columns and relationships of "account_emailaddress" */
export type Account_EmailaddressAccount_EmailconfirmationsArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailconfirmation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailconfirmation_Order_By>>;
  where?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
};


/** columns and relationships of "account_emailaddress" */
export type Account_EmailaddressAccount_Emailconfirmations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailconfirmation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailconfirmation_Order_By>>;
  where?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
};

/** aggregated selection of "account_emailaddress" */
export type Account_Emailaddress_Aggregate = {
  __typename?: 'account_emailaddress_aggregate';
  aggregate?: Maybe<Account_Emailaddress_Aggregate_Fields>;
  nodes: Array<Account_Emailaddress>;
};

export type Account_Emailaddress_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Account_Emailaddress_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Account_Emailaddress_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Account_Emailaddress_Aggregate_Bool_Exp_Count>;
};

export type Account_Emailaddress_Aggregate_Bool_Exp_Bool_And = {
  arguments: Account_Emailaddress_Select_Column_Account_Emailaddress_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Emailaddress_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Emailaddress_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Account_Emailaddress_Select_Column_Account_Emailaddress_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Emailaddress_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Emailaddress_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Emailaddress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Emailaddress_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_emailaddress" */
export type Account_Emailaddress_Aggregate_Fields = {
  __typename?: 'account_emailaddress_aggregate_fields';
  avg?: Maybe<Account_Emailaddress_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Account_Emailaddress_Max_Fields>;
  min?: Maybe<Account_Emailaddress_Min_Fields>;
  stddev?: Maybe<Account_Emailaddress_Stddev_Fields>;
  stddev_pop?: Maybe<Account_Emailaddress_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_Emailaddress_Stddev_Samp_Fields>;
  sum?: Maybe<Account_Emailaddress_Sum_Fields>;
  var_pop?: Maybe<Account_Emailaddress_Var_Pop_Fields>;
  var_samp?: Maybe<Account_Emailaddress_Var_Samp_Fields>;
  variance?: Maybe<Account_Emailaddress_Variance_Fields>;
};


/** aggregate fields of "account_emailaddress" */
export type Account_Emailaddress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Emailaddress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "account_emailaddress" */
export type Account_Emailaddress_Aggregate_Order_By = {
  avg?: InputMaybe<Account_Emailaddress_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Emailaddress_Max_Order_By>;
  min?: InputMaybe<Account_Emailaddress_Min_Order_By>;
  stddev?: InputMaybe<Account_Emailaddress_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Account_Emailaddress_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Account_Emailaddress_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Account_Emailaddress_Sum_Order_By>;
  var_pop?: InputMaybe<Account_Emailaddress_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Account_Emailaddress_Var_Samp_Order_By>;
  variance?: InputMaybe<Account_Emailaddress_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "account_emailaddress" */
export type Account_Emailaddress_Arr_Rel_Insert_Input = {
  data: Array<Account_Emailaddress_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_Emailaddress_On_Conflict>;
};

/** aggregate avg on columns */
export type Account_Emailaddress_Avg_Fields = {
  __typename?: 'account_emailaddress_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account_emailaddress". All fields are combined with a logical 'AND'. */
export type Account_Emailaddress_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Emailaddress_Bool_Exp>>;
  _not?: InputMaybe<Account_Emailaddress_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Emailaddress_Bool_Exp>>;
  account_emailconfirmations?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
  account_emailconfirmations_aggregate?: InputMaybe<Account_Emailconfirmation_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  primary?: InputMaybe<Boolean_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_emailaddress" */
export enum Account_Emailaddress_Constraint {
  /** unique or primary key constraint on columns "email" */
  AccountEmailaddressEmailKey = 'account_emailaddress_email_key',
  /** unique or primary key constraint on columns "id" */
  AccountEmailaddressPkey = 'account_emailaddress_pkey'
}

/** input type for incrementing numeric columns in table "account_emailaddress" */
export type Account_Emailaddress_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "account_emailaddress" */
export type Account_Emailaddress_Insert_Input = {
  account_emailconfirmations?: InputMaybe<Account_Emailconfirmation_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Account_Emailaddress_Max_Fields = {
  __typename?: 'account_emailaddress_max_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Max_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Emailaddress_Min_Fields = {
  __typename?: 'account_emailaddress_min_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Min_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_emailaddress" */
export type Account_Emailaddress_Mutation_Response = {
  __typename?: 'account_emailaddress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_Emailaddress>;
};

/** input type for inserting object relation for remote table "account_emailaddress" */
export type Account_Emailaddress_Obj_Rel_Insert_Input = {
  data: Account_Emailaddress_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_Emailaddress_On_Conflict>;
};

/** on_conflict condition type for table "account_emailaddress" */
export type Account_Emailaddress_On_Conflict = {
  constraint: Account_Emailaddress_Constraint;
  update_columns?: Array<Account_Emailaddress_Update_Column>;
  where?: InputMaybe<Account_Emailaddress_Bool_Exp>;
};

/** Ordering options when selecting data from "account_emailaddress". */
export type Account_Emailaddress_Order_By = {
  account_emailconfirmations_aggregate?: InputMaybe<Account_Emailconfirmation_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_emailaddress */
export type Account_Emailaddress_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "account_emailaddress" */
export enum Account_Emailaddress_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Primary = 'primary',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

/** select "account_emailaddress_aggregate_bool_exp_bool_and_arguments_columns" columns of table "account_emailaddress" */
export enum Account_Emailaddress_Select_Column_Account_Emailaddress_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

/** select "account_emailaddress_aggregate_bool_exp_bool_or_arguments_columns" columns of table "account_emailaddress" */
export enum Account_Emailaddress_Select_Column_Account_Emailaddress_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "account_emailaddress" */
export type Account_Emailaddress_Set_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Account_Emailaddress_Stddev_Fields = {
  __typename?: 'account_emailaddress_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Account_Emailaddress_Stddev_Pop_Fields = {
  __typename?: 'account_emailaddress_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Account_Emailaddress_Stddev_Samp_Fields = {
  __typename?: 'account_emailaddress_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "account_emailaddress" */
export type Account_Emailaddress_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Emailaddress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Emailaddress_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Account_Emailaddress_Sum_Fields = {
  __typename?: 'account_emailaddress_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "account_emailaddress" */
export enum Account_Emailaddress_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Primary = 'primary',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export type Account_Emailaddress_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Emailaddress_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Emailaddress_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Emailaddress_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Emailaddress_Var_Pop_Fields = {
  __typename?: 'account_emailaddress_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Account_Emailaddress_Var_Samp_Fields = {
  __typename?: 'account_emailaddress_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Account_Emailaddress_Variance_Fields = {
  __typename?: 'account_emailaddress_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "account_emailaddress" */
export type Account_Emailaddress_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "account_emailconfirmation" */
export type Account_Emailconfirmation = {
  __typename?: 'account_emailconfirmation';
  /** An object relationship */
  account_emailaddress: Account_Emailaddress;
  created: Scalars['timestamptz']['output'];
  email_address_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  sent?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "account_emailconfirmation" */
export type Account_Emailconfirmation_Aggregate = {
  __typename?: 'account_emailconfirmation_aggregate';
  aggregate?: Maybe<Account_Emailconfirmation_Aggregate_Fields>;
  nodes: Array<Account_Emailconfirmation>;
};

export type Account_Emailconfirmation_Aggregate_Bool_Exp = {
  count?: InputMaybe<Account_Emailconfirmation_Aggregate_Bool_Exp_Count>;
};

export type Account_Emailconfirmation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Emailconfirmation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_emailconfirmation" */
export type Account_Emailconfirmation_Aggregate_Fields = {
  __typename?: 'account_emailconfirmation_aggregate_fields';
  avg?: Maybe<Account_Emailconfirmation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Account_Emailconfirmation_Max_Fields>;
  min?: Maybe<Account_Emailconfirmation_Min_Fields>;
  stddev?: Maybe<Account_Emailconfirmation_Stddev_Fields>;
  stddev_pop?: Maybe<Account_Emailconfirmation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_Emailconfirmation_Stddev_Samp_Fields>;
  sum?: Maybe<Account_Emailconfirmation_Sum_Fields>;
  var_pop?: Maybe<Account_Emailconfirmation_Var_Pop_Fields>;
  var_samp?: Maybe<Account_Emailconfirmation_Var_Samp_Fields>;
  variance?: Maybe<Account_Emailconfirmation_Variance_Fields>;
};


/** aggregate fields of "account_emailconfirmation" */
export type Account_Emailconfirmation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Emailconfirmation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Aggregate_Order_By = {
  avg?: InputMaybe<Account_Emailconfirmation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Emailconfirmation_Max_Order_By>;
  min?: InputMaybe<Account_Emailconfirmation_Min_Order_By>;
  stddev?: InputMaybe<Account_Emailconfirmation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Account_Emailconfirmation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Account_Emailconfirmation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Account_Emailconfirmation_Sum_Order_By>;
  var_pop?: InputMaybe<Account_Emailconfirmation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Account_Emailconfirmation_Var_Samp_Order_By>;
  variance?: InputMaybe<Account_Emailconfirmation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "account_emailconfirmation" */
export type Account_Emailconfirmation_Arr_Rel_Insert_Input = {
  data: Array<Account_Emailconfirmation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_Emailconfirmation_On_Conflict>;
};

/** aggregate avg on columns */
export type Account_Emailconfirmation_Avg_Fields = {
  __typename?: 'account_emailconfirmation_avg_fields';
  email_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Avg_Order_By = {
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account_emailconfirmation". All fields are combined with a logical 'AND'. */
export type Account_Emailconfirmation_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Emailconfirmation_Bool_Exp>>;
  _not?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Emailconfirmation_Bool_Exp>>;
  account_emailaddress?: InputMaybe<Account_Emailaddress_Bool_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_address_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  sent?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_emailconfirmation" */
export enum Account_Emailconfirmation_Constraint {
  /** unique or primary key constraint on columns "key" */
  AccountEmailconfirmationKeyKey = 'account_emailconfirmation_key_key',
  /** unique or primary key constraint on columns "id" */
  AccountEmailconfirmationPkey = 'account_emailconfirmation_pkey'
}

/** input type for incrementing numeric columns in table "account_emailconfirmation" */
export type Account_Emailconfirmation_Inc_Input = {
  email_address_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "account_emailconfirmation" */
export type Account_Emailconfirmation_Insert_Input = {
  account_emailaddress?: InputMaybe<Account_Emailaddress_Obj_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  sent?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Account_Emailconfirmation_Max_Fields = {
  __typename?: 'account_emailconfirmation_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email_address_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  sent?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  sent?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Emailconfirmation_Min_Fields = {
  __typename?: 'account_emailconfirmation_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email_address_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  sent?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  sent?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_emailconfirmation" */
export type Account_Emailconfirmation_Mutation_Response = {
  __typename?: 'account_emailconfirmation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_Emailconfirmation>;
};

/** on_conflict condition type for table "account_emailconfirmation" */
export type Account_Emailconfirmation_On_Conflict = {
  constraint: Account_Emailconfirmation_Constraint;
  update_columns?: Array<Account_Emailconfirmation_Update_Column>;
  where?: InputMaybe<Account_Emailconfirmation_Bool_Exp>;
};

/** Ordering options when selecting data from "account_emailconfirmation". */
export type Account_Emailconfirmation_Order_By = {
  account_emailaddress?: InputMaybe<Account_Emailaddress_Order_By>;
  created?: InputMaybe<Order_By>;
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  sent?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_emailconfirmation */
export type Account_Emailconfirmation_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "account_emailconfirmation" */
export enum Account_Emailconfirmation_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EmailAddressId = 'email_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Sent = 'sent'
}

/** input type for updating data in table "account_emailconfirmation" */
export type Account_Emailconfirmation_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  sent?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Account_Emailconfirmation_Stddev_Fields = {
  __typename?: 'account_emailconfirmation_stddev_fields';
  email_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Stddev_Order_By = {
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Account_Emailconfirmation_Stddev_Pop_Fields = {
  __typename?: 'account_emailconfirmation_stddev_pop_fields';
  email_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Stddev_Pop_Order_By = {
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Account_Emailconfirmation_Stddev_Samp_Fields = {
  __typename?: 'account_emailconfirmation_stddev_samp_fields';
  email_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Stddev_Samp_Order_By = {
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "account_emailconfirmation" */
export type Account_Emailconfirmation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Emailconfirmation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Emailconfirmation_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  sent?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Account_Emailconfirmation_Sum_Fields = {
  __typename?: 'account_emailconfirmation_sum_fields';
  email_address_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Sum_Order_By = {
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "account_emailconfirmation" */
export enum Account_Emailconfirmation_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EmailAddressId = 'email_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Sent = 'sent'
}

export type Account_Emailconfirmation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Emailconfirmation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Emailconfirmation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Emailconfirmation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Emailconfirmation_Var_Pop_Fields = {
  __typename?: 'account_emailconfirmation_var_pop_fields';
  email_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Var_Pop_Order_By = {
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Account_Emailconfirmation_Var_Samp_Fields = {
  __typename?: 'account_emailconfirmation_var_samp_fields';
  email_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Var_Samp_Order_By = {
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Account_Emailconfirmation_Variance_Fields = {
  __typename?: 'account_emailconfirmation_variance_fields';
  email_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "account_emailconfirmation" */
export type Account_Emailconfirmation_Variance_Order_By = {
  email_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "accounts_catscores" */
export type Accounts_Catscores = {
  __typename?: 'accounts_catscores';
  dilr_raw_marks: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  participant_id: Scalars['String']['output'];
  qa_raw_marks: Scalars['Int']['output'];
  shift_number: Scalars['String']['output'];
  test_center_name: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
  vacr_raw_marks: Scalars['Int']['output'];
};

/** aggregated selection of "accounts_catscores" */
export type Accounts_Catscores_Aggregate = {
  __typename?: 'accounts_catscores_aggregate';
  aggregate?: Maybe<Accounts_Catscores_Aggregate_Fields>;
  nodes: Array<Accounts_Catscores>;
};

export type Accounts_Catscores_Aggregate_Bool_Exp = {
  count?: InputMaybe<Accounts_Catscores_Aggregate_Bool_Exp_Count>;
};

export type Accounts_Catscores_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Accounts_Catscores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Accounts_Catscores_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "accounts_catscores" */
export type Accounts_Catscores_Aggregate_Fields = {
  __typename?: 'accounts_catscores_aggregate_fields';
  avg?: Maybe<Accounts_Catscores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Accounts_Catscores_Max_Fields>;
  min?: Maybe<Accounts_Catscores_Min_Fields>;
  stddev?: Maybe<Accounts_Catscores_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Catscores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Catscores_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Catscores_Sum_Fields>;
  var_pop?: Maybe<Accounts_Catscores_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Catscores_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Catscores_Variance_Fields>;
};


/** aggregate fields of "accounts_catscores" */
export type Accounts_Catscores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Catscores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "accounts_catscores" */
export type Accounts_Catscores_Aggregate_Order_By = {
  avg?: InputMaybe<Accounts_Catscores_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Accounts_Catscores_Max_Order_By>;
  min?: InputMaybe<Accounts_Catscores_Min_Order_By>;
  stddev?: InputMaybe<Accounts_Catscores_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Accounts_Catscores_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Accounts_Catscores_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Accounts_Catscores_Sum_Order_By>;
  var_pop?: InputMaybe<Accounts_Catscores_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Accounts_Catscores_Var_Samp_Order_By>;
  variance?: InputMaybe<Accounts_Catscores_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "accounts_catscores" */
export type Accounts_Catscores_Arr_Rel_Insert_Input = {
  data: Array<Accounts_Catscores_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_Catscores_On_Conflict>;
};

/** aggregate avg on columns */
export type Accounts_Catscores_Avg_Fields = {
  __typename?: 'accounts_catscores_avg_fields';
  dilr_raw_marks?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  qa_raw_marks?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Avg_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "accounts_catscores". All fields are combined with a logical 'AND'. */
export type Accounts_Catscores_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Catscores_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Catscores_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Catscores_Bool_Exp>>;
  dilr_raw_marks?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  participant_id?: InputMaybe<String_Comparison_Exp>;
  qa_raw_marks?: InputMaybe<Int_Comparison_Exp>;
  shift_number?: InputMaybe<String_Comparison_Exp>;
  test_center_name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
  vacr_raw_marks?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts_catscores" */
export enum Accounts_Catscores_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsCatscoresPkey = 'accounts_catscores_pkey'
}

/** input type for incrementing numeric columns in table "accounts_catscores" */
export type Accounts_Catscores_Inc_Input = {
  dilr_raw_marks?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  qa_raw_marks?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  vacr_raw_marks?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "accounts_catscores" */
export type Accounts_Catscores_Insert_Input = {
  dilr_raw_marks?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['String']['input']>;
  qa_raw_marks?: InputMaybe<Scalars['Int']['input']>;
  shift_number?: InputMaybe<Scalars['String']['input']>;
  test_center_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
  vacr_raw_marks?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Accounts_Catscores_Max_Fields = {
  __typename?: 'accounts_catscores_max_fields';
  dilr_raw_marks?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
  qa_raw_marks?: Maybe<Scalars['Int']['output']>;
  shift_number?: Maybe<Scalars['String']['output']>;
  test_center_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Max_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  shift_number?: InputMaybe<Order_By>;
  test_center_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Accounts_Catscores_Min_Fields = {
  __typename?: 'accounts_catscores_min_fields';
  dilr_raw_marks?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
  qa_raw_marks?: Maybe<Scalars['Int']['output']>;
  shift_number?: Maybe<Scalars['String']['output']>;
  test_center_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Min_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  shift_number?: InputMaybe<Order_By>;
  test_center_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accounts_catscores" */
export type Accounts_Catscores_Mutation_Response = {
  __typename?: 'accounts_catscores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts_Catscores>;
};

/** on_conflict condition type for table "accounts_catscores" */
export type Accounts_Catscores_On_Conflict = {
  constraint: Accounts_Catscores_Constraint;
  update_columns?: Array<Accounts_Catscores_Update_Column>;
  where?: InputMaybe<Accounts_Catscores_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts_catscores". */
export type Accounts_Catscores_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  shift_number?: InputMaybe<Order_By>;
  test_center_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts_catscores */
export type Accounts_Catscores_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "accounts_catscores" */
export enum Accounts_Catscores_Select_Column {
  /** column name */
  DilrRawMarks = 'dilr_raw_marks',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  QaRawMarks = 'qa_raw_marks',
  /** column name */
  ShiftNumber = 'shift_number',
  /** column name */
  TestCenterName = 'test_center_name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VacrRawMarks = 'vacr_raw_marks'
}

/** input type for updating data in table "accounts_catscores" */
export type Accounts_Catscores_Set_Input = {
  dilr_raw_marks?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['String']['input']>;
  qa_raw_marks?: InputMaybe<Scalars['Int']['input']>;
  shift_number?: InputMaybe<Scalars['String']['input']>;
  test_center_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  vacr_raw_marks?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Accounts_Catscores_Stddev_Fields = {
  __typename?: 'accounts_catscores_stddev_fields';
  dilr_raw_marks?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  qa_raw_marks?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Stddev_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Catscores_Stddev_Pop_Fields = {
  __typename?: 'accounts_catscores_stddev_pop_fields';
  dilr_raw_marks?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  qa_raw_marks?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Stddev_Pop_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Catscores_Stddev_Samp_Fields = {
  __typename?: 'accounts_catscores_stddev_samp_fields';
  dilr_raw_marks?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  qa_raw_marks?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Stddev_Samp_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "accounts_catscores" */
export type Accounts_Catscores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Accounts_Catscores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Accounts_Catscores_Stream_Cursor_Value_Input = {
  dilr_raw_marks?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['String']['input']>;
  qa_raw_marks?: InputMaybe<Scalars['Int']['input']>;
  shift_number?: InputMaybe<Scalars['String']['input']>;
  test_center_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  vacr_raw_marks?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Accounts_Catscores_Sum_Fields = {
  __typename?: 'accounts_catscores_sum_fields';
  dilr_raw_marks?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  qa_raw_marks?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Sum_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** update columns of table "accounts_catscores" */
export enum Accounts_Catscores_Update_Column {
  /** column name */
  DilrRawMarks = 'dilr_raw_marks',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  QaRawMarks = 'qa_raw_marks',
  /** column name */
  ShiftNumber = 'shift_number',
  /** column name */
  TestCenterName = 'test_center_name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VacrRawMarks = 'vacr_raw_marks'
}

export type Accounts_Catscores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Accounts_Catscores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Accounts_Catscores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Accounts_Catscores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Accounts_Catscores_Var_Pop_Fields = {
  __typename?: 'accounts_catscores_var_pop_fields';
  dilr_raw_marks?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  qa_raw_marks?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Var_Pop_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Accounts_Catscores_Var_Samp_Fields = {
  __typename?: 'accounts_catscores_var_samp_fields';
  dilr_raw_marks?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  qa_raw_marks?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Var_Samp_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Accounts_Catscores_Variance_Fields = {
  __typename?: 'accounts_catscores_variance_fields';
  dilr_raw_marks?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  qa_raw_marks?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vacr_raw_marks?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "accounts_catscores" */
export type Accounts_Catscores_Variance_Order_By = {
  dilr_raw_marks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qa_raw_marks?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vacr_raw_marks?: InputMaybe<Order_By>;
};

/** columns and relationships of "accounts_loggedinuser" */
export type Accounts_Loggedinuser = {
  __typename?: 'accounts_loggedinuser';
  id: Scalars['Int']['output'];
  session_key?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "accounts_loggedinuser" */
export type Accounts_Loggedinuser_Aggregate = {
  __typename?: 'accounts_loggedinuser_aggregate';
  aggregate?: Maybe<Accounts_Loggedinuser_Aggregate_Fields>;
  nodes: Array<Accounts_Loggedinuser>;
};

/** aggregate fields of "accounts_loggedinuser" */
export type Accounts_Loggedinuser_Aggregate_Fields = {
  __typename?: 'accounts_loggedinuser_aggregate_fields';
  avg?: Maybe<Accounts_Loggedinuser_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Accounts_Loggedinuser_Max_Fields>;
  min?: Maybe<Accounts_Loggedinuser_Min_Fields>;
  stddev?: Maybe<Accounts_Loggedinuser_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Loggedinuser_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Loggedinuser_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Loggedinuser_Sum_Fields>;
  var_pop?: Maybe<Accounts_Loggedinuser_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Loggedinuser_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Loggedinuser_Variance_Fields>;
};


/** aggregate fields of "accounts_loggedinuser" */
export type Accounts_Loggedinuser_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Loggedinuser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Accounts_Loggedinuser_Avg_Fields = {
  __typename?: 'accounts_loggedinuser_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "accounts_loggedinuser". All fields are combined with a logical 'AND'. */
export type Accounts_Loggedinuser_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Loggedinuser_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Loggedinuser_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Loggedinuser_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  session_key?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "accounts_loggedinuser" */
export enum Accounts_Loggedinuser_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsLoggedinuserPkey = 'accounts_loggedinuser_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AccountsLoggedinuserUserIdKey = 'accounts_loggedinuser_user_id_key'
}

/** input type for incrementing numeric columns in table "accounts_loggedinuser" */
export type Accounts_Loggedinuser_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "accounts_loggedinuser" */
export type Accounts_Loggedinuser_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  session_key?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Accounts_Loggedinuser_Max_Fields = {
  __typename?: 'accounts_loggedinuser_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  session_key?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Accounts_Loggedinuser_Min_Fields = {
  __typename?: 'accounts_loggedinuser_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  session_key?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "accounts_loggedinuser" */
export type Accounts_Loggedinuser_Mutation_Response = {
  __typename?: 'accounts_loggedinuser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts_Loggedinuser>;
};

/** input type for inserting object relation for remote table "accounts_loggedinuser" */
export type Accounts_Loggedinuser_Obj_Rel_Insert_Input = {
  data: Accounts_Loggedinuser_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_Loggedinuser_On_Conflict>;
};

/** on_conflict condition type for table "accounts_loggedinuser" */
export type Accounts_Loggedinuser_On_Conflict = {
  constraint: Accounts_Loggedinuser_Constraint;
  update_columns?: Array<Accounts_Loggedinuser_Update_Column>;
  where?: InputMaybe<Accounts_Loggedinuser_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts_loggedinuser". */
export type Accounts_Loggedinuser_Order_By = {
  id?: InputMaybe<Order_By>;
  session_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: accounts_loggedinuser */
export type Accounts_Loggedinuser_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "accounts_loggedinuser" */
export enum Accounts_Loggedinuser_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SessionKey = 'session_key',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "accounts_loggedinuser" */
export type Accounts_Loggedinuser_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  session_key?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Accounts_Loggedinuser_Stddev_Fields = {
  __typename?: 'accounts_loggedinuser_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Loggedinuser_Stddev_Pop_Fields = {
  __typename?: 'accounts_loggedinuser_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Loggedinuser_Stddev_Samp_Fields = {
  __typename?: 'accounts_loggedinuser_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "accounts_loggedinuser" */
export type Accounts_Loggedinuser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Accounts_Loggedinuser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Accounts_Loggedinuser_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  session_key?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Accounts_Loggedinuser_Sum_Fields = {
  __typename?: 'accounts_loggedinuser_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "accounts_loggedinuser" */
export enum Accounts_Loggedinuser_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SessionKey = 'session_key',
  /** column name */
  UserId = 'user_id'
}

export type Accounts_Loggedinuser_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Accounts_Loggedinuser_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Accounts_Loggedinuser_Set_Input>;
  /** filter the rows which have to be updated */
  where: Accounts_Loggedinuser_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Accounts_Loggedinuser_Var_Pop_Fields = {
  __typename?: 'accounts_loggedinuser_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Accounts_Loggedinuser_Var_Samp_Fields = {
  __typename?: 'accounts_loggedinuser_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Accounts_Loggedinuser_Variance_Fields = {
  __typename?: 'accounts_loggedinuser_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "activity_types" */
export type Activity_Types = {
  __typename?: 'activity_types';
  type: Scalars['String']['output'];
  /** An array relationship */
  user_activities: Array<User_Activities>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activities_Aggregate;
  /** An object relationship */
  user_activity?: Maybe<User_Activity>;
};


/** columns and relationships of "activity_types" */
export type Activity_TypesUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


/** columns and relationships of "activity_types" */
export type Activity_TypesUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};

/** aggregated selection of "activity_types" */
export type Activity_Types_Aggregate = {
  __typename?: 'activity_types_aggregate';
  aggregate?: Maybe<Activity_Types_Aggregate_Fields>;
  nodes: Array<Activity_Types>;
};

/** aggregate fields of "activity_types" */
export type Activity_Types_Aggregate_Fields = {
  __typename?: 'activity_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Types_Max_Fields>;
  min?: Maybe<Activity_Types_Min_Fields>;
};


/** aggregate fields of "activity_types" */
export type Activity_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "activity_types". All fields are combined with a logical 'AND'. */
export type Activity_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Types_Bool_Exp>>;
  _not?: InputMaybe<Activity_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Types_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_activities?: InputMaybe<User_Activities_Bool_Exp>;
  user_activities_aggregate?: InputMaybe<User_Activities_Aggregate_Bool_Exp>;
  user_activity?: InputMaybe<User_Activity_Bool_Exp>;
};

/** unique or primary key constraints on table "activity_types" */
export enum Activity_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  ActivitiesTypePkey = 'activities_type_pkey'
}

/** input type for inserting data into table "activity_types" */
export type Activity_Types_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
  user_activities?: InputMaybe<User_Activities_Arr_Rel_Insert_Input>;
  user_activity?: InputMaybe<User_Activity_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Activity_Types_Max_Fields = {
  __typename?: 'activity_types_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Activity_Types_Min_Fields = {
  __typename?: 'activity_types_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "activity_types" */
export type Activity_Types_Mutation_Response = {
  __typename?: 'activity_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity_Types>;
};

/** input type for inserting object relation for remote table "activity_types" */
export type Activity_Types_Obj_Rel_Insert_Input = {
  data: Activity_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_Types_On_Conflict>;
};

/** on_conflict condition type for table "activity_types" */
export type Activity_Types_On_Conflict = {
  constraint: Activity_Types_Constraint;
  update_columns?: Array<Activity_Types_Update_Column>;
  where?: InputMaybe<Activity_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "activity_types". */
export type Activity_Types_Order_By = {
  type?: InputMaybe<Order_By>;
  user_activities_aggregate?: InputMaybe<User_Activities_Aggregate_Order_By>;
  user_activity?: InputMaybe<User_Activity_Order_By>;
};

/** primary key columns input for table: activity_types */
export type Activity_Types_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "activity_types" */
export enum Activity_Types_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "activity_types" */
export type Activity_Types_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "activity_types" */
export type Activity_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Types_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "activity_types" */
export enum Activity_Types_Update_Column {
  /** column name */
  Type = 'type'
}

export type Activity_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Types_Bool_Exp;
};

/** columns and relationships of "admin_constants" */
export type Admin_Constants = {
  __typename?: 'admin_constants';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "admin_constants" */
export type Admin_Constants_Aggregate = {
  __typename?: 'admin_constants_aggregate';
  aggregate?: Maybe<Admin_Constants_Aggregate_Fields>;
  nodes: Array<Admin_Constants>;
};

/** aggregate fields of "admin_constants" */
export type Admin_Constants_Aggregate_Fields = {
  __typename?: 'admin_constants_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Constants_Max_Fields>;
  min?: Maybe<Admin_Constants_Min_Fields>;
};


/** aggregate fields of "admin_constants" */
export type Admin_Constants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Constants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "admin_constants". All fields are combined with a logical 'AND'. */
export type Admin_Constants_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Constants_Bool_Exp>>;
  _not?: InputMaybe<Admin_Constants_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Constants_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin_constants" */
export enum Admin_Constants_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdminConstantsPkey = 'admin_constants_pkey'
}

/** input type for inserting data into table "admin_constants" */
export type Admin_Constants_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Admin_Constants_Max_Fields = {
  __typename?: 'admin_constants_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Admin_Constants_Min_Fields = {
  __typename?: 'admin_constants_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "admin_constants" */
export type Admin_Constants_Mutation_Response = {
  __typename?: 'admin_constants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Constants>;
};

/** on_conflict condition type for table "admin_constants" */
export type Admin_Constants_On_Conflict = {
  constraint: Admin_Constants_Constraint;
  update_columns?: Array<Admin_Constants_Update_Column>;
  where?: InputMaybe<Admin_Constants_Bool_Exp>;
};

/** Ordering options when selecting data from "admin_constants". */
export type Admin_Constants_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin_constants */
export type Admin_Constants_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "admin_constants" */
export enum Admin_Constants_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "admin_constants" */
export type Admin_Constants_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "admin_constants" */
export type Admin_Constants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Constants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Constants_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "admin_constants" */
export enum Admin_Constants_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Admin_Constants_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Constants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Constants_Bool_Exp;
};

/** columns and relationships of "admin_users" */
export type Admin_Users = {
  __typename?: 'admin_users';
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "admin_users" */
export type Admin_Users_Aggregate = {
  __typename?: 'admin_users_aggregate';
  aggregate?: Maybe<Admin_Users_Aggregate_Fields>;
  nodes: Array<Admin_Users>;
};

/** aggregate fields of "admin_users" */
export type Admin_Users_Aggregate_Fields = {
  __typename?: 'admin_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Users_Max_Fields>;
  min?: Maybe<Admin_Users_Min_Fields>;
};


/** aggregate fields of "admin_users" */
export type Admin_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "admin_users". All fields are combined with a logical 'AND'. */
export type Admin_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Users_Bool_Exp>>;
  _not?: InputMaybe<Admin_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin_users" */
export enum Admin_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdminUsersPkey = 'admin_users_pkey'
}

/** input type for inserting data into table "admin_users" */
export type Admin_Users_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Admin_Users_Max_Fields = {
  __typename?: 'admin_users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Admin_Users_Min_Fields = {
  __typename?: 'admin_users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "admin_users" */
export type Admin_Users_Mutation_Response = {
  __typename?: 'admin_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Users>;
};

/** on_conflict condition type for table "admin_users" */
export type Admin_Users_On_Conflict = {
  constraint: Admin_Users_Constraint;
  update_columns?: Array<Admin_Users_Update_Column>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "admin_users". */
export type Admin_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin_users */
export type Admin_Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "admin_users" */
export enum Admin_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "admin_users" */
export type Admin_Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "admin_users" */
export type Admin_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "admin_users" */
export enum Admin_Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Admin_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Users_Bool_Exp;
};

/** columns and relationships of "advertisements" */
export type Advertisements = {
  __typename?: 'advertisements';
  /** An object relationship */
  advertisements_subscriptions_subscriptionplan?: Maybe<Subscriptions_Subscriptionplan>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  list_of_features: Scalars['String']['output'];
  plan_title: Scalars['String']['output'];
  related_plan?: Maybe<Scalars['uuid']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "advertisements" */
export type Advertisements_Aggregate = {
  __typename?: 'advertisements_aggregate';
  aggregate?: Maybe<Advertisements_Aggregate_Fields>;
  nodes: Array<Advertisements>;
};

export type Advertisements_Aggregate_Bool_Exp = {
  count?: InputMaybe<Advertisements_Aggregate_Bool_Exp_Count>;
};

export type Advertisements_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Advertisements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Advertisements_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "advertisements" */
export type Advertisements_Aggregate_Fields = {
  __typename?: 'advertisements_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Advertisements_Max_Fields>;
  min?: Maybe<Advertisements_Min_Fields>;
};


/** aggregate fields of "advertisements" */
export type Advertisements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advertisements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "advertisements" */
export type Advertisements_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Advertisements_Max_Order_By>;
  min?: InputMaybe<Advertisements_Min_Order_By>;
};

/** input type for inserting array relation for remote table "advertisements" */
export type Advertisements_Arr_Rel_Insert_Input = {
  data: Array<Advertisements_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Advertisements_On_Conflict>;
};

/** Boolean expression to filter rows from the table "advertisements". All fields are combined with a logical 'AND'. */
export type Advertisements_Bool_Exp = {
  _and?: InputMaybe<Array<Advertisements_Bool_Exp>>;
  _not?: InputMaybe<Advertisements_Bool_Exp>;
  _or?: InputMaybe<Array<Advertisements_Bool_Exp>>;
  advertisements_subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  list_of_features?: InputMaybe<String_Comparison_Exp>;
  plan_title?: InputMaybe<String_Comparison_Exp>;
  related_plan?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "advertisements" */
export enum Advertisements_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdvertismentPkey = 'advertisment_pkey'
}

/** input type for inserting data into table "advertisements" */
export type Advertisements_Insert_Input = {
  advertisements_subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  list_of_features?: InputMaybe<Scalars['String']['input']>;
  plan_title?: InputMaybe<Scalars['String']['input']>;
  related_plan?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Advertisements_Max_Fields = {
  __typename?: 'advertisements_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  list_of_features?: Maybe<Scalars['String']['output']>;
  plan_title?: Maybe<Scalars['String']['output']>;
  related_plan?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "advertisements" */
export type Advertisements_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  list_of_features?: InputMaybe<Order_By>;
  plan_title?: InputMaybe<Order_By>;
  related_plan?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Advertisements_Min_Fields = {
  __typename?: 'advertisements_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  list_of_features?: Maybe<Scalars['String']['output']>;
  plan_title?: Maybe<Scalars['String']['output']>;
  related_plan?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "advertisements" */
export type Advertisements_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  list_of_features?: InputMaybe<Order_By>;
  plan_title?: InputMaybe<Order_By>;
  related_plan?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "advertisements" */
export type Advertisements_Mutation_Response = {
  __typename?: 'advertisements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Advertisements>;
};

/** on_conflict condition type for table "advertisements" */
export type Advertisements_On_Conflict = {
  constraint: Advertisements_Constraint;
  update_columns?: Array<Advertisements_Update_Column>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};

/** Ordering options when selecting data from "advertisements". */
export type Advertisements_Order_By = {
  advertisements_subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  list_of_features?: InputMaybe<Order_By>;
  plan_title?: InputMaybe<Order_By>;
  related_plan?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advertisements */
export type Advertisements_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "advertisements" */
export enum Advertisements_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ListOfFeatures = 'list_of_features',
  /** column name */
  PlanTitle = 'plan_title',
  /** column name */
  RelatedPlan = 'related_plan',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "advertisements" */
export type Advertisements_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  list_of_features?: InputMaybe<Scalars['String']['input']>;
  plan_title?: InputMaybe<Scalars['String']['input']>;
  related_plan?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "advertisements" */
export type Advertisements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advertisements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advertisements_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  list_of_features?: InputMaybe<Scalars['String']['input']>;
  plan_title?: InputMaybe<Scalars['String']['input']>;
  related_plan?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "advertisements" */
export enum Advertisements_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ListOfFeatures = 'list_of_features',
  /** column name */
  PlanTitle = 'plan_title',
  /** column name */
  RelatedPlan = 'related_plan',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Advertisements_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advertisements_Set_Input>;
  /** filter the rows which have to be updated */
  where: Advertisements_Bool_Exp;
};

/** columns and relationships of "andablog_entry" */
export type Andablog_Entry = {
  __typename?: 'andablog_entry';
  _content_rendered: Scalars['String']['output'];
  _preview_content_rendered: Scalars['String']['output'];
  /** An array relationship */
  andablog_entryimages: Array<Andablog_Entryimage>;
  /** An aggregate relationship */
  andablog_entryimages_aggregate: Andablog_Entryimage_Aggregate;
  /** An array relationship */
  andablog_userlessontrackrecord_bookmarked_topics: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** An aggregate relationship */
  andablog_userlessontrackrecord_bookmarked_topics_aggregate: Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate;
  /** An array relationship */
  andablog_userlessontrackrecord_which_topics: Array<Andablog_Userlessontrackrecord_Which_Topics>;
  /** An aggregate relationship */
  andablog_userlessontrackrecord_which_topics_aggregate: Andablog_Userlessontrackrecord_Which_Topics_Aggregate;
  /** An array relationship */
  andablog_videos: Array<Andablog_Video>;
  /** An aggregate relationship */
  andablog_videos_aggregate: Andablog_Video_Aggregate;
  author_id?: Maybe<Scalars['Int']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  content: Scalars['String']['output'];
  content_markup_type: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  /** A computed field, executes function "andablog_entry_check_accessibility" */
  has_access?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  is_bookmarked: Array<Bookmarked_Learn_Topics>;
  /** An aggregate relationship */
  is_bookmarked_aggregate: Bookmarked_Learn_Topics_Aggregate;
  /** An array relationship */
  is_completed: Array<User_Learn_Completed_Topics>;
  /** An aggregate relationship */
  is_completed_aggregate: User_Learn_Completed_Topics_Aggregate;
  is_premium: Scalars['Boolean']['output'];
  is_published: Scalars['Boolean']['output'];
  is_text_lesson: Scalars['Boolean']['output'];
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keyword?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  modified: Scalars['timestamptz']['output'];
  old_entry_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  packages_content_text_lessons: Array<Packages_Content_Text_Lesson>;
  /** An aggregate relationship */
  packages_content_text_lessons_aggregate: Packages_Content_Text_Lesson_Aggregate;
  preview_content: Scalars['String']['output'];
  preview_content_markup_type: Scalars['String']['output'];
  preview_image: Scalars['String']['output'];
  published_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  quiz_category?: Maybe<Quiz_Category>;
  rank: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_learn_summaries: Array<User_Learn_Modules_Summary>;
  /** An aggregate relationship */
  user_learn_summaries_aggregate: User_Learn_Modules_Summary_Aggregate;
  /** An array relationship */
  user_learn_track_record_bookmarked_topics: Array<User_Learn_Track_Record_Bookmarked_Topics>;
  /** An aggregate relationship */
  user_learn_track_record_bookmarked_topics_aggregate: User_Learn_Track_Record_Bookmarked_Topics_Aggregate;
  /** An array relationship */
  user_learn_track_record_which_topics: Array<User_Learn_Track_Record_Which_Topics>;
  /** An aggregate relationship */
  user_learn_track_record_which_topics_aggregate: User_Learn_Track_Record_Which_Topics_Aggregate;
  /** An object relationship */
  users_user?: Maybe<Users_User>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryAndablog_EntryimagesArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entryimage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entryimage_Order_By>>;
  where?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryAndablog_Entryimages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entryimage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entryimage_Order_By>>;
  where?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryAndablog_Userlessontrackrecord_Bookmarked_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryAndablog_Userlessontrackrecord_Bookmarked_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryAndablog_Userlessontrackrecord_Which_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryAndablog_Userlessontrackrecord_Which_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryAndablog_VideosArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Video_Order_By>>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryAndablog_Videos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Video_Order_By>>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryIs_BookmarkedArgs = {
  distinct_on?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bookmarked_Learn_Topics_Order_By>>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryIs_Bookmarked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bookmarked_Learn_Topics_Order_By>>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryIs_CompletedArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Completed_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryIs_Completed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Completed_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryPackages_Content_Text_LessonsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Text_Lesson_Order_By>>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryPackages_Content_Text_Lessons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Text_Lesson_Order_By>>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryUser_Learn_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Modules_Summary_Order_By>>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryUser_Learn_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Modules_Summary_Order_By>>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryUser_Learn_Track_Record_Bookmarked_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryUser_Learn_Track_Record_Bookmarked_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryUser_Learn_Track_Record_Which_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_entry" */
export type Andablog_EntryUser_Learn_Track_Record_Which_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};

/** aggregated selection of "andablog_entry" */
export type Andablog_Entry_Aggregate = {
  __typename?: 'andablog_entry_aggregate';
  aggregate?: Maybe<Andablog_Entry_Aggregate_Fields>;
  nodes: Array<Andablog_Entry>;
};

export type Andablog_Entry_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Andablog_Entry_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Andablog_Entry_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Andablog_Entry_Aggregate_Bool_Exp_Count>;
};

export type Andablog_Entry_Aggregate_Bool_Exp_Bool_And = {
  arguments: Andablog_Entry_Select_Column_Andablog_Entry_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Entry_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Andablog_Entry_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Andablog_Entry_Select_Column_Andablog_Entry_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Entry_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Andablog_Entry_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Entry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "andablog_entry" */
export type Andablog_Entry_Aggregate_Fields = {
  __typename?: 'andablog_entry_aggregate_fields';
  avg?: Maybe<Andablog_Entry_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Andablog_Entry_Max_Fields>;
  min?: Maybe<Andablog_Entry_Min_Fields>;
  stddev?: Maybe<Andablog_Entry_Stddev_Fields>;
  stddev_pop?: Maybe<Andablog_Entry_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Andablog_Entry_Stddev_Samp_Fields>;
  sum?: Maybe<Andablog_Entry_Sum_Fields>;
  var_pop?: Maybe<Andablog_Entry_Var_Pop_Fields>;
  var_samp?: Maybe<Andablog_Entry_Var_Samp_Fields>;
  variance?: Maybe<Andablog_Entry_Variance_Fields>;
};


/** aggregate fields of "andablog_entry" */
export type Andablog_Entry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "andablog_entry" */
export type Andablog_Entry_Aggregate_Order_By = {
  avg?: InputMaybe<Andablog_Entry_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Andablog_Entry_Max_Order_By>;
  min?: InputMaybe<Andablog_Entry_Min_Order_By>;
  stddev?: InputMaybe<Andablog_Entry_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Andablog_Entry_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Andablog_Entry_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Andablog_Entry_Sum_Order_By>;
  var_pop?: InputMaybe<Andablog_Entry_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Andablog_Entry_Var_Samp_Order_By>;
  variance?: InputMaybe<Andablog_Entry_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "andablog_entry" */
export type Andablog_Entry_Arr_Rel_Insert_Input = {
  data: Array<Andablog_Entry_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Andablog_Entry_On_Conflict>;
};

/** aggregate avg on columns */
export type Andablog_Entry_Avg_Fields = {
  __typename?: 'andablog_entry_avg_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  old_entry_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "andablog_entry" */
export type Andablog_Entry_Avg_Order_By = {
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "andablog_entry". All fields are combined with a logical 'AND'. */
export type Andablog_Entry_Bool_Exp = {
  _and?: InputMaybe<Array<Andablog_Entry_Bool_Exp>>;
  _content_rendered?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Andablog_Entry_Bool_Exp>;
  _or?: InputMaybe<Array<Andablog_Entry_Bool_Exp>>;
  _preview_content_rendered?: InputMaybe<String_Comparison_Exp>;
  andablog_entryimages?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
  andablog_entryimages_aggregate?: InputMaybe<Andablog_Entryimage_Aggregate_Bool_Exp>;
  andablog_userlessontrackrecord_bookmarked_topics?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
  andablog_userlessontrackrecord_bookmarked_topics_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Bool_Exp>;
  andablog_userlessontrackrecord_which_topics?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
  andablog_userlessontrackrecord_which_topics_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Bool_Exp>;
  andablog_videos?: InputMaybe<Andablog_Video_Bool_Exp>;
  andablog_videos_aggregate?: InputMaybe<Andablog_Video_Aggregate_Bool_Exp>;
  author_id?: InputMaybe<Int_Comparison_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  content_markup_type?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  has_access?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_bookmarked?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
  is_bookmarked_aggregate?: InputMaybe<Bookmarked_Learn_Topics_Aggregate_Bool_Exp>;
  is_completed?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
  is_completed_aggregate?: InputMaybe<User_Learn_Completed_Topics_Aggregate_Bool_Exp>;
  is_premium?: InputMaybe<Boolean_Comparison_Exp>;
  is_published?: InputMaybe<Boolean_Comparison_Exp>;
  is_text_lesson?: InputMaybe<Boolean_Comparison_Exp>;
  meta_description?: InputMaybe<String_Comparison_Exp>;
  meta_keyword?: InputMaybe<String_Comparison_Exp>;
  meta_title?: InputMaybe<String_Comparison_Exp>;
  modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  old_entry_id?: InputMaybe<Int_Comparison_Exp>;
  packages_content_text_lessons?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
  packages_content_text_lessons_aggregate?: InputMaybe<Packages_Content_Text_Lesson_Aggregate_Bool_Exp>;
  preview_content?: InputMaybe<String_Comparison_Exp>;
  preview_content_markup_type?: InputMaybe<String_Comparison_Exp>;
  preview_image?: InputMaybe<String_Comparison_Exp>;
  published_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_learn_summaries?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
  user_learn_summaries_aggregate?: InputMaybe<User_Learn_Modules_Summary_Aggregate_Bool_Exp>;
  user_learn_track_record_bookmarked_topics?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
  user_learn_track_record_bookmarked_topics_aggregate?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Bool_Exp>;
  user_learn_track_record_which_topics?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
  user_learn_track_record_which_topics_aggregate?: InputMaybe<User_Learn_Track_Record_Which_Topics_Aggregate_Bool_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "andablog_entry" */
export enum Andablog_Entry_Constraint {
  /** unique or primary key constraint on columns "id" */
  AndablogEntryPkey = 'andablog_entry_pkey',
  /** unique or primary key constraint on columns "slug" */
  AndablogEntrySlugKey = 'andablog_entry_slug_key'
}

/** input type for incrementing numeric columns in table "andablog_entry" */
export type Andablog_Entry_Inc_Input = {
  author_id?: InputMaybe<Scalars['Int']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  old_entry_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "andablog_entry" */
export type Andablog_Entry_Insert_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  _preview_content_rendered?: InputMaybe<Scalars['String']['input']>;
  andablog_entryimages?: InputMaybe<Andablog_Entryimage_Arr_Rel_Insert_Input>;
  andablog_userlessontrackrecord_bookmarked_topics?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Arr_Rel_Insert_Input>;
  andablog_userlessontrackrecord_which_topics?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Arr_Rel_Insert_Input>;
  andablog_videos?: InputMaybe<Andablog_Video_Arr_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['Int']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_bookmarked?: InputMaybe<Bookmarked_Learn_Topics_Arr_Rel_Insert_Input>;
  is_completed?: InputMaybe<User_Learn_Completed_Topics_Arr_Rel_Insert_Input>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_text_lesson?: InputMaybe<Scalars['Boolean']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_keyword?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['timestamptz']['input']>;
  old_entry_id?: InputMaybe<Scalars['Int']['input']>;
  packages_content_text_lessons?: InputMaybe<Packages_Content_Text_Lesson_Arr_Rel_Insert_Input>;
  preview_content?: InputMaybe<Scalars['String']['input']>;
  preview_content_markup_type?: InputMaybe<Scalars['String']['input']>;
  preview_image?: InputMaybe<Scalars['String']['input']>;
  published_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_learn_summaries?: InputMaybe<User_Learn_Modules_Summary_Arr_Rel_Insert_Input>;
  user_learn_track_record_bookmarked_topics?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Arr_Rel_Insert_Input>;
  user_learn_track_record_which_topics?: InputMaybe<User_Learn_Track_Record_Which_Topics_Arr_Rel_Insert_Input>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Andablog_Entry_Max_Fields = {
  __typename?: 'andablog_entry_max_fields';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  _preview_content_rendered?: Maybe<Scalars['String']['output']>;
  author_id?: Maybe<Scalars['Int']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keyword?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['timestamptz']['output']>;
  old_entry_id?: Maybe<Scalars['Int']['output']>;
  preview_content?: Maybe<Scalars['String']['output']>;
  preview_content_markup_type?: Maybe<Scalars['String']['output']>;
  preview_image?: Maybe<Scalars['String']['output']>;
  published_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "andablog_entry" */
export type Andablog_Entry_Max_Order_By = {
  _content_rendered?: InputMaybe<Order_By>;
  _preview_content_rendered?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_markup_type?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_description?: InputMaybe<Order_By>;
  meta_keyword?: InputMaybe<Order_By>;
  meta_title?: InputMaybe<Order_By>;
  modified?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  preview_content?: InputMaybe<Order_By>;
  preview_content_markup_type?: InputMaybe<Order_By>;
  preview_image?: InputMaybe<Order_By>;
  published_timestamp?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Andablog_Entry_Min_Fields = {
  __typename?: 'andablog_entry_min_fields';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  _preview_content_rendered?: Maybe<Scalars['String']['output']>;
  author_id?: Maybe<Scalars['Int']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keyword?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['timestamptz']['output']>;
  old_entry_id?: Maybe<Scalars['Int']['output']>;
  preview_content?: Maybe<Scalars['String']['output']>;
  preview_content_markup_type?: Maybe<Scalars['String']['output']>;
  preview_image?: Maybe<Scalars['String']['output']>;
  published_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "andablog_entry" */
export type Andablog_Entry_Min_Order_By = {
  _content_rendered?: InputMaybe<Order_By>;
  _preview_content_rendered?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_markup_type?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_description?: InputMaybe<Order_By>;
  meta_keyword?: InputMaybe<Order_By>;
  meta_title?: InputMaybe<Order_By>;
  modified?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  preview_content?: InputMaybe<Order_By>;
  preview_content_markup_type?: InputMaybe<Order_By>;
  preview_image?: InputMaybe<Order_By>;
  published_timestamp?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "andablog_entry" */
export type Andablog_Entry_Mutation_Response = {
  __typename?: 'andablog_entry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Andablog_Entry>;
};

/** input type for inserting object relation for remote table "andablog_entry" */
export type Andablog_Entry_Obj_Rel_Insert_Input = {
  data: Andablog_Entry_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Andablog_Entry_On_Conflict>;
};

/** on_conflict condition type for table "andablog_entry" */
export type Andablog_Entry_On_Conflict = {
  constraint: Andablog_Entry_Constraint;
  update_columns?: Array<Andablog_Entry_Update_Column>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};

/** Ordering options when selecting data from "andablog_entry". */
export type Andablog_Entry_Order_By = {
  _content_rendered?: InputMaybe<Order_By>;
  _preview_content_rendered?: InputMaybe<Order_By>;
  andablog_entryimages_aggregate?: InputMaybe<Andablog_Entryimage_Aggregate_Order_By>;
  andablog_userlessontrackrecord_bookmarked_topics_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Order_By>;
  andablog_userlessontrackrecord_which_topics_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Order_By>;
  andablog_videos_aggregate?: InputMaybe<Andablog_Video_Aggregate_Order_By>;
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_markup_type?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  has_access?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_bookmarked_aggregate?: InputMaybe<Bookmarked_Learn_Topics_Aggregate_Order_By>;
  is_completed_aggregate?: InputMaybe<User_Learn_Completed_Topics_Aggregate_Order_By>;
  is_premium?: InputMaybe<Order_By>;
  is_published?: InputMaybe<Order_By>;
  is_text_lesson?: InputMaybe<Order_By>;
  meta_description?: InputMaybe<Order_By>;
  meta_keyword?: InputMaybe<Order_By>;
  meta_title?: InputMaybe<Order_By>;
  modified?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  packages_content_text_lessons_aggregate?: InputMaybe<Packages_Content_Text_Lesson_Aggregate_Order_By>;
  preview_content?: InputMaybe<Order_By>;
  preview_content_markup_type?: InputMaybe<Order_By>;
  preview_image?: InputMaybe<Order_By>;
  published_timestamp?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_learn_summaries_aggregate?: InputMaybe<User_Learn_Modules_Summary_Aggregate_Order_By>;
  user_learn_track_record_bookmarked_topics_aggregate?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Order_By>;
  user_learn_track_record_which_topics_aggregate?: InputMaybe<User_Learn_Track_Record_Which_Topics_Aggregate_Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: andablog_entry */
export type Andablog_Entry_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "andablog_entry" */
export enum Andablog_Entry_Select_Column {
  /** column name */
  ContentRendered = '_content_rendered',
  /** column name */
  PreviewContentRendered = '_preview_content_rendered',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Content = 'content',
  /** column name */
  ContentMarkupType = 'content_markup_type',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  IsTextLesson = 'is_text_lesson',
  /** column name */
  MetaDescription = 'meta_description',
  /** column name */
  MetaKeyword = 'meta_keyword',
  /** column name */
  MetaTitle = 'meta_title',
  /** column name */
  Modified = 'modified',
  /** column name */
  OldEntryId = 'old_entry_id',
  /** column name */
  PreviewContent = 'preview_content',
  /** column name */
  PreviewContentMarkupType = 'preview_content_markup_type',
  /** column name */
  PreviewImage = 'preview_image',
  /** column name */
  PublishedTimestamp = 'published_timestamp',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "andablog_entry_aggregate_bool_exp_bool_and_arguments_columns" columns of table "andablog_entry" */
export enum Andablog_Entry_Select_Column_Andablog_Entry_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  IsTextLesson = 'is_text_lesson'
}

/** select "andablog_entry_aggregate_bool_exp_bool_or_arguments_columns" columns of table "andablog_entry" */
export enum Andablog_Entry_Select_Column_Andablog_Entry_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  IsTextLesson = 'is_text_lesson'
}

/** input type for updating data in table "andablog_entry" */
export type Andablog_Entry_Set_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  _preview_content_rendered?: InputMaybe<Scalars['String']['input']>;
  author_id?: InputMaybe<Scalars['Int']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_text_lesson?: InputMaybe<Scalars['Boolean']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_keyword?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['timestamptz']['input']>;
  old_entry_id?: InputMaybe<Scalars['Int']['input']>;
  preview_content?: InputMaybe<Scalars['String']['input']>;
  preview_content_markup_type?: InputMaybe<Scalars['String']['input']>;
  preview_image?: InputMaybe<Scalars['String']['input']>;
  published_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Andablog_Entry_Stddev_Fields = {
  __typename?: 'andablog_entry_stddev_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  old_entry_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "andablog_entry" */
export type Andablog_Entry_Stddev_Order_By = {
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Andablog_Entry_Stddev_Pop_Fields = {
  __typename?: 'andablog_entry_stddev_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  old_entry_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "andablog_entry" */
export type Andablog_Entry_Stddev_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Andablog_Entry_Stddev_Samp_Fields = {
  __typename?: 'andablog_entry_stddev_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  old_entry_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "andablog_entry" */
export type Andablog_Entry_Stddev_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "andablog_entry" */
export type Andablog_Entry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Andablog_Entry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Andablog_Entry_Stream_Cursor_Value_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  _preview_content_rendered?: InputMaybe<Scalars['String']['input']>;
  author_id?: InputMaybe<Scalars['Int']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_text_lesson?: InputMaybe<Scalars['Boolean']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_keyword?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['timestamptz']['input']>;
  old_entry_id?: InputMaybe<Scalars['Int']['input']>;
  preview_content?: InputMaybe<Scalars['String']['input']>;
  preview_content_markup_type?: InputMaybe<Scalars['String']['input']>;
  preview_image?: InputMaybe<Scalars['String']['input']>;
  published_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Andablog_Entry_Sum_Fields = {
  __typename?: 'andablog_entry_sum_fields';
  author_id?: Maybe<Scalars['Int']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  old_entry_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "andablog_entry" */
export type Andablog_Entry_Sum_Order_By = {
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** update columns of table "andablog_entry" */
export enum Andablog_Entry_Update_Column {
  /** column name */
  ContentRendered = '_content_rendered',
  /** column name */
  PreviewContentRendered = '_preview_content_rendered',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Content = 'content',
  /** column name */
  ContentMarkupType = 'content_markup_type',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  IsTextLesson = 'is_text_lesson',
  /** column name */
  MetaDescription = 'meta_description',
  /** column name */
  MetaKeyword = 'meta_keyword',
  /** column name */
  MetaTitle = 'meta_title',
  /** column name */
  Modified = 'modified',
  /** column name */
  OldEntryId = 'old_entry_id',
  /** column name */
  PreviewContent = 'preview_content',
  /** column name */
  PreviewContentMarkupType = 'preview_content_markup_type',
  /** column name */
  PreviewImage = 'preview_image',
  /** column name */
  PublishedTimestamp = 'published_timestamp',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Andablog_Entry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Andablog_Entry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Andablog_Entry_Set_Input>;
  /** filter the rows which have to be updated */
  where: Andablog_Entry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Andablog_Entry_Var_Pop_Fields = {
  __typename?: 'andablog_entry_var_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  old_entry_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "andablog_entry" */
export type Andablog_Entry_Var_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Andablog_Entry_Var_Samp_Fields = {
  __typename?: 'andablog_entry_var_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  old_entry_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "andablog_entry" */
export type Andablog_Entry_Var_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Andablog_Entry_Variance_Fields = {
  __typename?: 'andablog_entry_variance_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  old_entry_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "andablog_entry" */
export type Andablog_Entry_Variance_Order_By = {
  author_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_entry_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** columns and relationships of "andablog_entryimage" */
export type Andablog_Entryimage = {
  __typename?: 'andablog_entryimage';
  /** An object relationship */
  andablog_entry: Andablog_Entry;
  created: Scalars['timestamptz']['output'];
  entry_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  modified: Scalars['timestamptz']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "andablog_entryimage" */
export type Andablog_Entryimage_Aggregate = {
  __typename?: 'andablog_entryimage_aggregate';
  aggregate?: Maybe<Andablog_Entryimage_Aggregate_Fields>;
  nodes: Array<Andablog_Entryimage>;
};

export type Andablog_Entryimage_Aggregate_Bool_Exp = {
  count?: InputMaybe<Andablog_Entryimage_Aggregate_Bool_Exp_Count>;
};

export type Andablog_Entryimage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Andablog_Entryimage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "andablog_entryimage" */
export type Andablog_Entryimage_Aggregate_Fields = {
  __typename?: 'andablog_entryimage_aggregate_fields';
  avg?: Maybe<Andablog_Entryimage_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Andablog_Entryimage_Max_Fields>;
  min?: Maybe<Andablog_Entryimage_Min_Fields>;
  stddev?: Maybe<Andablog_Entryimage_Stddev_Fields>;
  stddev_pop?: Maybe<Andablog_Entryimage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Andablog_Entryimage_Stddev_Samp_Fields>;
  sum?: Maybe<Andablog_Entryimage_Sum_Fields>;
  var_pop?: Maybe<Andablog_Entryimage_Var_Pop_Fields>;
  var_samp?: Maybe<Andablog_Entryimage_Var_Samp_Fields>;
  variance?: Maybe<Andablog_Entryimage_Variance_Fields>;
};


/** aggregate fields of "andablog_entryimage" */
export type Andablog_Entryimage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Andablog_Entryimage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "andablog_entryimage" */
export type Andablog_Entryimage_Aggregate_Order_By = {
  avg?: InputMaybe<Andablog_Entryimage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Andablog_Entryimage_Max_Order_By>;
  min?: InputMaybe<Andablog_Entryimage_Min_Order_By>;
  stddev?: InputMaybe<Andablog_Entryimage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Andablog_Entryimage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Andablog_Entryimage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Andablog_Entryimage_Sum_Order_By>;
  var_pop?: InputMaybe<Andablog_Entryimage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Andablog_Entryimage_Var_Samp_Order_By>;
  variance?: InputMaybe<Andablog_Entryimage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "andablog_entryimage" */
export type Andablog_Entryimage_Arr_Rel_Insert_Input = {
  data: Array<Andablog_Entryimage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Andablog_Entryimage_On_Conflict>;
};

/** aggregate avg on columns */
export type Andablog_Entryimage_Avg_Fields = {
  __typename?: 'andablog_entryimage_avg_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "andablog_entryimage". All fields are combined with a logical 'AND'. */
export type Andablog_Entryimage_Bool_Exp = {
  _and?: InputMaybe<Array<Andablog_Entryimage_Bool_Exp>>;
  _not?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
  _or?: InputMaybe<Array<Andablog_Entryimage_Bool_Exp>>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "andablog_entryimage" */
export enum Andablog_Entryimage_Constraint {
  /** unique or primary key constraint on columns "id" */
  AndablogEntryimagePkey = 'andablog_entryimage_pkey'
}

/** input type for incrementing numeric columns in table "andablog_entryimage" */
export type Andablog_Entryimage_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "andablog_entryimage" */
export type Andablog_Entryimage_Insert_Input = {
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Andablog_Entryimage_Max_Fields = {
  __typename?: 'andablog_entryimage_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  modified?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Andablog_Entryimage_Min_Fields = {
  __typename?: 'andablog_entryimage_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  modified?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "andablog_entryimage" */
export type Andablog_Entryimage_Mutation_Response = {
  __typename?: 'andablog_entryimage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Andablog_Entryimage>;
};

/** on_conflict condition type for table "andablog_entryimage" */
export type Andablog_Entryimage_On_Conflict = {
  constraint: Andablog_Entryimage_Constraint;
  update_columns?: Array<Andablog_Entryimage_Update_Column>;
  where?: InputMaybe<Andablog_Entryimage_Bool_Exp>;
};

/** Ordering options when selecting data from "andablog_entryimage". */
export type Andablog_Entryimage_Order_By = {
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  created?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  modified?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: andablog_entryimage */
export type Andablog_Entryimage_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "andablog_entryimage" */
export enum Andablog_Entryimage_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Modified = 'modified',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "andablog_entryimage" */
export type Andablog_Entryimage_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Andablog_Entryimage_Stddev_Fields = {
  __typename?: 'andablog_entryimage_stddev_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Andablog_Entryimage_Stddev_Pop_Fields = {
  __typename?: 'andablog_entryimage_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Andablog_Entryimage_Stddev_Samp_Fields = {
  __typename?: 'andablog_entryimage_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "andablog_entryimage" */
export type Andablog_Entryimage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Andablog_Entryimage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Andablog_Entryimage_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Andablog_Entryimage_Sum_Fields = {
  __typename?: 'andablog_entryimage_sum_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "andablog_entryimage" */
export enum Andablog_Entryimage_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Modified = 'modified',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Andablog_Entryimage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Andablog_Entryimage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Andablog_Entryimage_Set_Input>;
  /** filter the rows which have to be updated */
  where: Andablog_Entryimage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Andablog_Entryimage_Var_Pop_Fields = {
  __typename?: 'andablog_entryimage_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Andablog_Entryimage_Var_Samp_Fields = {
  __typename?: 'andablog_entryimage_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Andablog_Entryimage_Variance_Fields = {
  __typename?: 'andablog_entryimage_variance_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "andablog_entryimage" */
export type Andablog_Entryimage_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "andablog_news" */
export type Andablog_News = {
  __typename?: 'andablog_news';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  content_markup_type: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  created_date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  modified: Scalars['timestamptz']['output'];
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "andablog_news" */
export type Andablog_News_Aggregate = {
  __typename?: 'andablog_news_aggregate';
  aggregate?: Maybe<Andablog_News_Aggregate_Fields>;
  nodes: Array<Andablog_News>;
};

/** aggregate fields of "andablog_news" */
export type Andablog_News_Aggregate_Fields = {
  __typename?: 'andablog_news_aggregate_fields';
  avg?: Maybe<Andablog_News_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Andablog_News_Max_Fields>;
  min?: Maybe<Andablog_News_Min_Fields>;
  stddev?: Maybe<Andablog_News_Stddev_Fields>;
  stddev_pop?: Maybe<Andablog_News_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Andablog_News_Stddev_Samp_Fields>;
  sum?: Maybe<Andablog_News_Sum_Fields>;
  var_pop?: Maybe<Andablog_News_Var_Pop_Fields>;
  var_samp?: Maybe<Andablog_News_Var_Samp_Fields>;
  variance?: Maybe<Andablog_News_Variance_Fields>;
};


/** aggregate fields of "andablog_news" */
export type Andablog_News_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Andablog_News_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Andablog_News_Avg_Fields = {
  __typename?: 'andablog_news_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "andablog_news". All fields are combined with a logical 'AND'. */
export type Andablog_News_Bool_Exp = {
  _and?: InputMaybe<Array<Andablog_News_Bool_Exp>>;
  _content_rendered?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Andablog_News_Bool_Exp>;
  _or?: InputMaybe<Array<Andablog_News_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  content_markup_type?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "andablog_news" */
export enum Andablog_News_Constraint {
  /** unique or primary key constraint on columns "id" */
  AndablogNewsPkey = 'andablog_news_pkey'
}

/** input type for incrementing numeric columns in table "andablog_news" */
export type Andablog_News_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "andablog_news" */
export type Andablog_News_Insert_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Andablog_News_Max_Fields = {
  __typename?: 'andablog_news_max_fields';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['timestamptz']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Andablog_News_Min_Fields = {
  __typename?: 'andablog_news_min_fields';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['timestamptz']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "andablog_news" */
export type Andablog_News_Mutation_Response = {
  __typename?: 'andablog_news_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Andablog_News>;
};

/** on_conflict condition type for table "andablog_news" */
export type Andablog_News_On_Conflict = {
  constraint: Andablog_News_Constraint;
  update_columns?: Array<Andablog_News_Update_Column>;
  where?: InputMaybe<Andablog_News_Bool_Exp>;
};

/** Ordering options when selecting data from "andablog_news". */
export type Andablog_News_Order_By = {
  _content_rendered?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_markup_type?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: andablog_news */
export type Andablog_News_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "andablog_news" */
export enum Andablog_News_Select_Column {
  /** column name */
  ContentRendered = '_content_rendered',
  /** column name */
  Content = 'content',
  /** column name */
  ContentMarkupType = 'content_markup_type',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  Modified = 'modified',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "andablog_news" */
export type Andablog_News_Set_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Andablog_News_Stddev_Fields = {
  __typename?: 'andablog_news_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Andablog_News_Stddev_Pop_Fields = {
  __typename?: 'andablog_news_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Andablog_News_Stddev_Samp_Fields = {
  __typename?: 'andablog_news_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "andablog_news" */
export type Andablog_News_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Andablog_News_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Andablog_News_Stream_Cursor_Value_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Andablog_News_Sum_Fields = {
  __typename?: 'andablog_news_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "andablog_news" */
export enum Andablog_News_Update_Column {
  /** column name */
  ContentRendered = '_content_rendered',
  /** column name */
  Content = 'content',
  /** column name */
  ContentMarkupType = 'content_markup_type',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  Modified = 'modified',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Andablog_News_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Andablog_News_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Andablog_News_Set_Input>;
  /** filter the rows which have to be updated */
  where: Andablog_News_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Andablog_News_Var_Pop_Fields = {
  __typename?: 'andablog_news_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Andablog_News_Var_Samp_Fields = {
  __typename?: 'andablog_news_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Andablog_News_Variance_Fields = {
  __typename?: 'andablog_news_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "andablog_pov" */
export type Andablog_Pov = {
  __typename?: 'andablog_pov';
  brief_write_up: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  date: Scalars['date']['output'];
  external_url: Scalars['String']['output'];
  genre: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  image_url: Scalars['String']['output'];
  level: Scalars['String']['output'];
  pov: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  time: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_pov_summaries: Array<User_Pov_Summaries>;
  /** An aggregate relationship */
  user_pov_summaries_aggregate: User_Pov_Summaries_Aggregate;
};


/** columns and relationships of "andablog_pov" */
export type Andablog_PovUser_Pov_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Pov_Summaries_Order_By>>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};


/** columns and relationships of "andablog_pov" */
export type Andablog_PovUser_Pov_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Pov_Summaries_Order_By>>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};

/** aggregated selection of "andablog_pov" */
export type Andablog_Pov_Aggregate = {
  __typename?: 'andablog_pov_aggregate';
  aggregate?: Maybe<Andablog_Pov_Aggregate_Fields>;
  nodes: Array<Andablog_Pov>;
};

/** aggregate fields of "andablog_pov" */
export type Andablog_Pov_Aggregate_Fields = {
  __typename?: 'andablog_pov_aggregate_fields';
  avg?: Maybe<Andablog_Pov_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Andablog_Pov_Max_Fields>;
  min?: Maybe<Andablog_Pov_Min_Fields>;
  stddev?: Maybe<Andablog_Pov_Stddev_Fields>;
  stddev_pop?: Maybe<Andablog_Pov_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Andablog_Pov_Stddev_Samp_Fields>;
  sum?: Maybe<Andablog_Pov_Sum_Fields>;
  var_pop?: Maybe<Andablog_Pov_Var_Pop_Fields>;
  var_samp?: Maybe<Andablog_Pov_Var_Samp_Fields>;
  variance?: Maybe<Andablog_Pov_Variance_Fields>;
};


/** aggregate fields of "andablog_pov" */
export type Andablog_Pov_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Andablog_Pov_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Andablog_Pov_Avg_Fields = {
  __typename?: 'andablog_pov_avg_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "andablog_pov". All fields are combined with a logical 'AND'. */
export type Andablog_Pov_Bool_Exp = {
  _and?: InputMaybe<Array<Andablog_Pov_Bool_Exp>>;
  _not?: InputMaybe<Andablog_Pov_Bool_Exp>;
  _or?: InputMaybe<Array<Andablog_Pov_Bool_Exp>>;
  brief_write_up?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  external_url?: InputMaybe<String_Comparison_Exp>;
  genre?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  level?: InputMaybe<String_Comparison_Exp>;
  pov?: InputMaybe<String_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  time?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_pov_summaries?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
  user_pov_summaries_aggregate?: InputMaybe<User_Pov_Summaries_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "andablog_pov" */
export enum Andablog_Pov_Constraint {
  /** unique or primary key constraint on columns "id" */
  AndablogPovPkey = 'andablog_pov_pkey'
}

/** input type for incrementing numeric columns in table "andablog_pov" */
export type Andablog_Pov_Inc_Input = {
  rank?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "andablog_pov" */
export type Andablog_Pov_Insert_Input = {
  brief_write_up?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  external_url?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  pov?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_pov_summaries?: InputMaybe<User_Pov_Summaries_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Andablog_Pov_Max_Fields = {
  __typename?: 'andablog_pov_max_fields';
  brief_write_up?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  external_url?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  pov?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Andablog_Pov_Min_Fields = {
  __typename?: 'andablog_pov_min_fields';
  brief_write_up?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  external_url?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  pov?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "andablog_pov" */
export type Andablog_Pov_Mutation_Response = {
  __typename?: 'andablog_pov_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Andablog_Pov>;
};

/** input type for inserting object relation for remote table "andablog_pov" */
export type Andablog_Pov_Obj_Rel_Insert_Input = {
  data: Andablog_Pov_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Andablog_Pov_On_Conflict>;
};

/** on_conflict condition type for table "andablog_pov" */
export type Andablog_Pov_On_Conflict = {
  constraint: Andablog_Pov_Constraint;
  update_columns?: Array<Andablog_Pov_Update_Column>;
  where?: InputMaybe<Andablog_Pov_Bool_Exp>;
};

/** Ordering options when selecting data from "andablog_pov". */
export type Andablog_Pov_Order_By = {
  brief_write_up?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  external_url?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  pov?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_pov_summaries_aggregate?: InputMaybe<User_Pov_Summaries_Aggregate_Order_By>;
};

/** primary key columns input for table: andablog_pov */
export type Andablog_Pov_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "andablog_pov" */
export enum Andablog_Pov_Select_Column {
  /** column name */
  BriefWriteUp = 'brief_write_up',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  ExternalUrl = 'external_url',
  /** column name */
  Genre = 'genre',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Level = 'level',
  /** column name */
  Pov = 'pov',
  /** column name */
  Rank = 'rank',
  /** column name */
  Time = 'time',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "andablog_pov" */
export type Andablog_Pov_Set_Input = {
  brief_write_up?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  external_url?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  pov?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Andablog_Pov_Stddev_Fields = {
  __typename?: 'andablog_pov_stddev_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Andablog_Pov_Stddev_Pop_Fields = {
  __typename?: 'andablog_pov_stddev_pop_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Andablog_Pov_Stddev_Samp_Fields = {
  __typename?: 'andablog_pov_stddev_samp_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "andablog_pov" */
export type Andablog_Pov_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Andablog_Pov_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Andablog_Pov_Stream_Cursor_Value_Input = {
  brief_write_up?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  external_url?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  pov?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Andablog_Pov_Sum_Fields = {
  __typename?: 'andablog_pov_sum_fields';
  rank?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "andablog_pov" */
export enum Andablog_Pov_Update_Column {
  /** column name */
  BriefWriteUp = 'brief_write_up',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  ExternalUrl = 'external_url',
  /** column name */
  Genre = 'genre',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Level = 'level',
  /** column name */
  Pov = 'pov',
  /** column name */
  Rank = 'rank',
  /** column name */
  Time = 'time',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Andablog_Pov_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Andablog_Pov_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Andablog_Pov_Set_Input>;
  /** filter the rows which have to be updated */
  where: Andablog_Pov_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Andablog_Pov_Var_Pop_Fields = {
  __typename?: 'andablog_pov_var_pop_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Andablog_Pov_Var_Samp_Fields = {
  __typename?: 'andablog_pov_var_samp_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Andablog_Pov_Variance_Fields = {
  __typename?: 'andablog_pov_variance_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord = {
  __typename?: 'andablog_userlessontrackrecord';
  /** An array relationship */
  andablog_userlessontrackrecord_bookmarked_topics: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
  /** An aggregate relationship */
  andablog_userlessontrackrecord_bookmarked_topics_aggregate: Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate;
  /** An array relationship */
  andablog_userlessontrackrecord_which_topics: Array<Andablog_Userlessontrackrecord_Which_Topics>;
  /** An aggregate relationship */
  andablog_userlessontrackrecord_which_topics_aggregate: Andablog_Userlessontrackrecord_Which_Topics_Aggregate;
  category_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  is_completed: Scalars['Boolean']['output'];
  /** An object relationship */
  quiz_category: Quiz_Category;
  read_topics_count?: Maybe<Scalars['Int']['output']>;
  total_topics_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};


/** columns and relationships of "andablog_userlessontrackrecord" */
export type Andablog_UserlessontrackrecordAndablog_Userlessontrackrecord_Bookmarked_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_userlessontrackrecord" */
export type Andablog_UserlessontrackrecordAndablog_Userlessontrackrecord_Bookmarked_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_userlessontrackrecord" */
export type Andablog_UserlessontrackrecordAndablog_Userlessontrackrecord_Which_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};


/** columns and relationships of "andablog_userlessontrackrecord" */
export type Andablog_UserlessontrackrecordAndablog_Userlessontrackrecord_Which_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};

/** aggregated selection of "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Aggregate = {
  __typename?: 'andablog_userlessontrackrecord_aggregate';
  aggregate?: Maybe<Andablog_Userlessontrackrecord_Aggregate_Fields>;
  nodes: Array<Andablog_Userlessontrackrecord>;
};

export type Andablog_Userlessontrackrecord_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Count>;
};

export type Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Bool_And = {
  arguments: Andablog_Userlessontrackrecord_Select_Column_Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Andablog_Userlessontrackrecord_Select_Column_Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Aggregate_Fields = {
  __typename?: 'andablog_userlessontrackrecord_aggregate_fields';
  avg?: Maybe<Andablog_Userlessontrackrecord_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Andablog_Userlessontrackrecord_Max_Fields>;
  min?: Maybe<Andablog_Userlessontrackrecord_Min_Fields>;
  stddev?: Maybe<Andablog_Userlessontrackrecord_Stddev_Fields>;
  stddev_pop?: Maybe<Andablog_Userlessontrackrecord_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Andablog_Userlessontrackrecord_Stddev_Samp_Fields>;
  sum?: Maybe<Andablog_Userlessontrackrecord_Sum_Fields>;
  var_pop?: Maybe<Andablog_Userlessontrackrecord_Var_Pop_Fields>;
  var_samp?: Maybe<Andablog_Userlessontrackrecord_Var_Samp_Fields>;
  variance?: Maybe<Andablog_Userlessontrackrecord_Variance_Fields>;
};


/** aggregate fields of "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Aggregate_Order_By = {
  avg?: InputMaybe<Andablog_Userlessontrackrecord_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Andablog_Userlessontrackrecord_Max_Order_By>;
  min?: InputMaybe<Andablog_Userlessontrackrecord_Min_Order_By>;
  stddev?: InputMaybe<Andablog_Userlessontrackrecord_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Andablog_Userlessontrackrecord_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Andablog_Userlessontrackrecord_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Andablog_Userlessontrackrecord_Sum_Order_By>;
  var_pop?: InputMaybe<Andablog_Userlessontrackrecord_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Andablog_Userlessontrackrecord_Var_Samp_Order_By>;
  variance?: InputMaybe<Andablog_Userlessontrackrecord_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Arr_Rel_Insert_Input = {
  data: Array<Andablog_Userlessontrackrecord_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_On_Conflict>;
};

/** aggregate avg on columns */
export type Andablog_Userlessontrackrecord_Avg_Fields = {
  __typename?: 'andablog_userlessontrackrecord_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics';
  /** An object relationship */
  andablog_entry: Andablog_Entry;
  /** An object relationship */
  andablog_userlessontrackrecord: Andablog_Userlessontrackrecord;
  entry_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  userlessontrackrecord_id: Scalars['Int']['output'];
};

/** aggregated selection of "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_aggregate';
  aggregate?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Fields>;
  nodes: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
};

export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Bool_Exp = {
  count?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Bool_Exp_Count>;
};

export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_aggregate_fields';
  avg?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Max_Fields>;
  min?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Min_Fields>;
  stddev?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Fields>;
  stddev_pop?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Samp_Fields>;
  sum?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Sum_Fields>;
  var_pop?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Var_Pop_Fields>;
  var_samp?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Var_Samp_Fields>;
  variance?: Maybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Variance_Fields>;
};


/** aggregate fields of "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Order_By = {
  avg?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Max_Order_By>;
  min?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Min_Order_By>;
  stddev?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Sum_Order_By>;
  var_pop?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Var_Samp_Order_By>;
  variance?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Arr_Rel_Insert_Input = {
  data: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_On_Conflict>;
};

/** aggregate avg on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Avg_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_avg_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "andablog_userlessontrackrecord_bookmarked_topics". All fields are combined with a logical 'AND'. */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp = {
  _and?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>>;
  _not?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
  _or?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  andablog_userlessontrackrecord?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  userlessontrackrecord_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "andablog_userlessontrackrecord_bookmarked_topics" */
export enum Andablog_Userlessontrackrecord_Bookmarked_Topics_Constraint {
  /** unique or primary key constraint on columns "entry_id", "userlessontrackrecord_id" */
  AndablogUserlessontrackUserlessontrackrecordId_5bab5673Uniq = 'andablog_userlessontrack_userlessontrackrecord_id_5bab5673_uniq',
  /** unique or primary key constraint on columns "id" */
  AndablogUserlessontrackrecordBookmarkTopicsPkey = 'andablog_userlessontrackrecord_bookmark_topics_pkey'
}

/** input type for incrementing numeric columns in table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Insert_Input = {
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  andablog_userlessontrackrecord?: InputMaybe<Andablog_Userlessontrackrecord_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Max_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_max_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Max_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Min_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_min_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Min_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Mutation_Response = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics>;
};

/** on_conflict condition type for table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_On_Conflict = {
  constraint: Andablog_Userlessontrackrecord_Bookmarked_Topics_Constraint;
  update_columns?: Array<Andablog_Userlessontrackrecord_Bookmarked_Topics_Update_Column>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
};

/** Ordering options when selecting data from "andablog_userlessontrackrecord_bookmarked_topics". */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Order_By = {
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  andablog_userlessontrackrecord?: InputMaybe<Andablog_Userlessontrackrecord_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: andablog_userlessontrackrecord_bookmarked_topics */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export enum Andablog_Userlessontrackrecord_Bookmarked_Topics_Select_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserlessontrackrecordId = 'userlessontrackrecord_id'
}

/** input type for updating data in table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Set_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_stddev_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Pop_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Samp_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Andablog_Userlessontrackrecord_Bookmarked_Topics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Stream_Cursor_Value_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Sum_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_sum_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** update columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export enum Andablog_Userlessontrackrecord_Bookmarked_Topics_Update_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserlessontrackrecordId = 'userlessontrackrecord_id'
}

export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Set_Input>;
  /** filter the rows which have to be updated */
  where: Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Var_Pop_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Var_Samp_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Variance_Fields = {
  __typename?: 'andablog_userlessontrackrecord_bookmarked_topics_variance_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "andablog_userlessontrackrecord_bookmarked_topics" */
export type Andablog_Userlessontrackrecord_Bookmarked_Topics_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "andablog_userlessontrackrecord". All fields are combined with a logical 'AND'. */
export type Andablog_Userlessontrackrecord_Bool_Exp = {
  _and?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bool_Exp>>;
  _not?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
  _or?: InputMaybe<Array<Andablog_Userlessontrackrecord_Bool_Exp>>;
  andablog_userlessontrackrecord_bookmarked_topics?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Bool_Exp>;
  andablog_userlessontrackrecord_bookmarked_topics_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Bool_Exp>;
  andablog_userlessontrackrecord_which_topics?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
  andablog_userlessontrackrecord_which_topics_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Bool_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  read_topics_count?: InputMaybe<Int_Comparison_Exp>;
  total_topics_count?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "andablog_userlessontrackrecord" */
export enum Andablog_Userlessontrackrecord_Constraint {
  /** unique or primary key constraint on columns "id" */
  AndablogUserlessontrackrecordPkey = 'andablog_userlessontrackrecord_pkey'
}

/** input type for incrementing numeric columns in table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  read_topics_count?: InputMaybe<Scalars['Int']['input']>;
  total_topics_count?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Insert_Input = {
  andablog_userlessontrackrecord_bookmarked_topics?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Arr_Rel_Insert_Input>;
  andablog_userlessontrackrecord_which_topics?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Arr_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  read_topics_count?: InputMaybe<Scalars['Int']['input']>;
  total_topics_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Andablog_Userlessontrackrecord_Max_Fields = {
  __typename?: 'andablog_userlessontrackrecord_max_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  read_topics_count?: Maybe<Scalars['Int']['output']>;
  total_topics_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Andablog_Userlessontrackrecord_Min_Fields = {
  __typename?: 'andablog_userlessontrackrecord_min_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  read_topics_count?: Maybe<Scalars['Int']['output']>;
  total_topics_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Mutation_Response = {
  __typename?: 'andablog_userlessontrackrecord_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Andablog_Userlessontrackrecord>;
};

/** input type for inserting object relation for remote table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Obj_Rel_Insert_Input = {
  data: Andablog_Userlessontrackrecord_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_On_Conflict>;
};

/** on_conflict condition type for table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_On_Conflict = {
  constraint: Andablog_Userlessontrackrecord_Constraint;
  update_columns?: Array<Andablog_Userlessontrackrecord_Update_Column>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};

/** Ordering options when selecting data from "andablog_userlessontrackrecord". */
export type Andablog_Userlessontrackrecord_Order_By = {
  andablog_userlessontrackrecord_bookmarked_topics_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Bookmarked_Topics_Aggregate_Order_By>;
  andablog_userlessontrackrecord_which_topics_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: andablog_userlessontrackrecord */
export type Andablog_Userlessontrackrecord_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "andablog_userlessontrackrecord" */
export enum Andablog_Userlessontrackrecord_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  ReadTopicsCount = 'read_topics_count',
  /** column name */
  TotalTopicsCount = 'total_topics_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "andablog_userlessontrackrecord_aggregate_bool_exp_bool_and_arguments_columns" columns of table "andablog_userlessontrackrecord" */
export enum Andablog_Userlessontrackrecord_Select_Column_Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** select "andablog_userlessontrackrecord_aggregate_bool_exp_bool_or_arguments_columns" columns of table "andablog_userlessontrackrecord" */
export enum Andablog_Userlessontrackrecord_Select_Column_Andablog_Userlessontrackrecord_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** input type for updating data in table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  read_topics_count?: InputMaybe<Scalars['Int']['input']>;
  total_topics_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Andablog_Userlessontrackrecord_Stddev_Fields = {
  __typename?: 'andablog_userlessontrackrecord_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Andablog_Userlessontrackrecord_Stddev_Pop_Fields = {
  __typename?: 'andablog_userlessontrackrecord_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Andablog_Userlessontrackrecord_Stddev_Samp_Fields = {
  __typename?: 'andablog_userlessontrackrecord_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Andablog_Userlessontrackrecord_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Andablog_Userlessontrackrecord_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  read_topics_count?: InputMaybe<Scalars['Int']['input']>;
  total_topics_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Andablog_Userlessontrackrecord_Sum_Fields = {
  __typename?: 'andablog_userlessontrackrecord_sum_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  read_topics_count?: Maybe<Scalars['Int']['output']>;
  total_topics_count?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "andablog_userlessontrackrecord" */
export enum Andablog_Userlessontrackrecord_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  ReadTopicsCount = 'read_topics_count',
  /** column name */
  TotalTopicsCount = 'total_topics_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Andablog_Userlessontrackrecord_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Andablog_Userlessontrackrecord_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Andablog_Userlessontrackrecord_Set_Input>;
  /** filter the rows which have to be updated */
  where: Andablog_Userlessontrackrecord_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Andablog_Userlessontrackrecord_Var_Pop_Fields = {
  __typename?: 'andablog_userlessontrackrecord_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Andablog_Userlessontrackrecord_Var_Samp_Fields = {
  __typename?: 'andablog_userlessontrackrecord_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Andablog_Userlessontrackrecord_Variance_Fields = {
  __typename?: 'andablog_userlessontrackrecord_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "andablog_userlessontrackrecord" */
export type Andablog_Userlessontrackrecord_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics = {
  __typename?: 'andablog_userlessontrackrecord_which_topics';
  /** An object relationship */
  andablog_entry: Andablog_Entry;
  /** An object relationship */
  andablog_userlessontrackrecord: Andablog_Userlessontrackrecord;
  entry_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  userlessontrackrecord_id: Scalars['Int']['output'];
};

/** aggregated selection of "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Aggregate = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_aggregate';
  aggregate?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Fields>;
  nodes: Array<Andablog_Userlessontrackrecord_Which_Topics>;
};

export type Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Bool_Exp = {
  count?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Bool_Exp_Count>;
};

export type Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_aggregate_fields';
  avg?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Max_Fields>;
  min?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Min_Fields>;
  stddev?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Stddev_Fields>;
  stddev_pop?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Stddev_Samp_Fields>;
  sum?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Sum_Fields>;
  var_pop?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Var_Pop_Fields>;
  var_samp?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Var_Samp_Fields>;
  variance?: Maybe<Andablog_Userlessontrackrecord_Which_Topics_Variance_Fields>;
};


/** aggregate fields of "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Aggregate_Order_By = {
  avg?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Max_Order_By>;
  min?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Min_Order_By>;
  stddev?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Sum_Order_By>;
  var_pop?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Var_Samp_Order_By>;
  variance?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Arr_Rel_Insert_Input = {
  data: Array<Andablog_Userlessontrackrecord_Which_Topics_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_On_Conflict>;
};

/** aggregate avg on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Avg_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_avg_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "andablog_userlessontrackrecord_which_topics". All fields are combined with a logical 'AND'. */
export type Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp = {
  _and?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>>;
  _not?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
  _or?: InputMaybe<Array<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  andablog_userlessontrackrecord?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  userlessontrackrecord_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "andablog_userlessontrackrecord_which_topics" */
export enum Andablog_Userlessontrackrecord_Which_Topics_Constraint {
  /** unique or primary key constraint on columns "entry_id", "userlessontrackrecord_id" */
  AndablogUserlessontrackUserlessontrackrecordId_3fa56699Uniq = 'andablog_userlessontrack_userlessontrackrecord_id_3fa56699_uniq',
  /** unique or primary key constraint on columns "id" */
  AndablogUserlessontrackrecordWhichTopicsPkey = 'andablog_userlessontrackrecord_which_topics_pkey'
}

/** input type for incrementing numeric columns in table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Insert_Input = {
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  andablog_userlessontrackrecord?: InputMaybe<Andablog_Userlessontrackrecord_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Max_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_max_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Max_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Min_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_min_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Min_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Mutation_Response = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Andablog_Userlessontrackrecord_Which_Topics>;
};

/** on_conflict condition type for table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_On_Conflict = {
  constraint: Andablog_Userlessontrackrecord_Which_Topics_Constraint;
  update_columns?: Array<Andablog_Userlessontrackrecord_Which_Topics_Update_Column>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp>;
};

/** Ordering options when selecting data from "andablog_userlessontrackrecord_which_topics". */
export type Andablog_Userlessontrackrecord_Which_Topics_Order_By = {
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  andablog_userlessontrackrecord?: InputMaybe<Andablog_Userlessontrackrecord_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: andablog_userlessontrackrecord_which_topics */
export type Andablog_Userlessontrackrecord_Which_Topics_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "andablog_userlessontrackrecord_which_topics" */
export enum Andablog_Userlessontrackrecord_Which_Topics_Select_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserlessontrackrecordId = 'userlessontrackrecord_id'
}

/** input type for updating data in table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Set_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Stddev_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_stddev_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Stddev_Pop_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Stddev_Samp_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Andablog_Userlessontrackrecord_Which_Topics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Andablog_Userlessontrackrecord_Which_Topics_Stream_Cursor_Value_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Sum_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_sum_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** update columns of table "andablog_userlessontrackrecord_which_topics" */
export enum Andablog_Userlessontrackrecord_Which_Topics_Update_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserlessontrackrecordId = 'userlessontrackrecord_id'
}

export type Andablog_Userlessontrackrecord_Which_Topics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Andablog_Userlessontrackrecord_Which_Topics_Set_Input>;
  /** filter the rows which have to be updated */
  where: Andablog_Userlessontrackrecord_Which_Topics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Var_Pop_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Var_Samp_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Andablog_Userlessontrackrecord_Which_Topics_Variance_Fields = {
  __typename?: 'andablog_userlessontrackrecord_which_topics_variance_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "andablog_userlessontrackrecord_which_topics" */
export type Andablog_Userlessontrackrecord_Which_Topics_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userlessontrackrecord_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "andablog_video" */
export type Andablog_Video = {
  __typename?: 'andablog_video';
  /** An object relationship */
  andablog_entry?: Maybe<Andablog_Entry>;
  category_id?: Maybe<Scalars['Int']['output']>;
  category_topic_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  is_premium: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  quiz_category?: Maybe<Quiz_Category>;
  rank: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vdpcipher_id: Scalars['String']['output'];
  video_length_in_seconds: Scalars['Int']['output'];
};

/** aggregated selection of "andablog_video" */
export type Andablog_Video_Aggregate = {
  __typename?: 'andablog_video_aggregate';
  aggregate?: Maybe<Andablog_Video_Aggregate_Fields>;
  nodes: Array<Andablog_Video>;
};

export type Andablog_Video_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Andablog_Video_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Andablog_Video_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Andablog_Video_Aggregate_Bool_Exp_Count>;
};

export type Andablog_Video_Aggregate_Bool_Exp_Bool_And = {
  arguments: Andablog_Video_Select_Column_Andablog_Video_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Video_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Andablog_Video_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Andablog_Video_Select_Column_Andablog_Video_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Video_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Andablog_Video_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Andablog_Video_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "andablog_video" */
export type Andablog_Video_Aggregate_Fields = {
  __typename?: 'andablog_video_aggregate_fields';
  avg?: Maybe<Andablog_Video_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Andablog_Video_Max_Fields>;
  min?: Maybe<Andablog_Video_Min_Fields>;
  stddev?: Maybe<Andablog_Video_Stddev_Fields>;
  stddev_pop?: Maybe<Andablog_Video_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Andablog_Video_Stddev_Samp_Fields>;
  sum?: Maybe<Andablog_Video_Sum_Fields>;
  var_pop?: Maybe<Andablog_Video_Var_Pop_Fields>;
  var_samp?: Maybe<Andablog_Video_Var_Samp_Fields>;
  variance?: Maybe<Andablog_Video_Variance_Fields>;
};


/** aggregate fields of "andablog_video" */
export type Andablog_Video_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "andablog_video" */
export type Andablog_Video_Aggregate_Order_By = {
  avg?: InputMaybe<Andablog_Video_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Andablog_Video_Max_Order_By>;
  min?: InputMaybe<Andablog_Video_Min_Order_By>;
  stddev?: InputMaybe<Andablog_Video_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Andablog_Video_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Andablog_Video_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Andablog_Video_Sum_Order_By>;
  var_pop?: InputMaybe<Andablog_Video_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Andablog_Video_Var_Samp_Order_By>;
  variance?: InputMaybe<Andablog_Video_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "andablog_video" */
export type Andablog_Video_Arr_Rel_Insert_Input = {
  data: Array<Andablog_Video_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Andablog_Video_On_Conflict>;
};

/** aggregate avg on columns */
export type Andablog_Video_Avg_Fields = {
  __typename?: 'andablog_video_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  category_topic_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "andablog_video" */
export type Andablog_Video_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "andablog_video". All fields are combined with a logical 'AND'. */
export type Andablog_Video_Bool_Exp = {
  _and?: InputMaybe<Array<Andablog_Video_Bool_Exp>>;
  _not?: InputMaybe<Andablog_Video_Bool_Exp>;
  _or?: InputMaybe<Array<Andablog_Video_Bool_Exp>>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  category_topic_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_premium?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vdpcipher_id?: InputMaybe<String_Comparison_Exp>;
  video_length_in_seconds?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "andablog_video" */
export enum Andablog_Video_Constraint {
  /** unique or primary key constraint on columns "id" */
  AndablogVideoPkey = 'andablog_video_pkey'
}

/** input type for incrementing numeric columns in table "andablog_video" */
export type Andablog_Video_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  category_topic_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  video_length_in_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "andablog_video" */
export type Andablog_Video_Insert_Input = {
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  category_topic_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vdpcipher_id?: InputMaybe<Scalars['String']['input']>;
  video_length_in_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Andablog_Video_Max_Fields = {
  __typename?: 'andablog_video_max_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  category_topic_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vdpcipher_id?: Maybe<Scalars['String']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "andablog_video" */
export type Andablog_Video_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vdpcipher_id?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Andablog_Video_Min_Fields = {
  __typename?: 'andablog_video_min_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  category_topic_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vdpcipher_id?: Maybe<Scalars['String']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "andablog_video" */
export type Andablog_Video_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vdpcipher_id?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "andablog_video" */
export type Andablog_Video_Mutation_Response = {
  __typename?: 'andablog_video_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Andablog_Video>;
};

/** on_conflict condition type for table "andablog_video" */
export type Andablog_Video_On_Conflict = {
  constraint: Andablog_Video_Constraint;
  update_columns?: Array<Andablog_Video_Update_Column>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};

/** Ordering options when selecting data from "andablog_video". */
export type Andablog_Video_Order_By = {
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_premium?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vdpcipher_id?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: andablog_video */
export type Andablog_Video_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "andablog_video" */
export enum Andablog_Video_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CategoryTopicId = 'category_topic_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  Name = 'name',
  /** column name */
  Rank = 'rank',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VdpcipherId = 'vdpcipher_id',
  /** column name */
  VideoLengthInSeconds = 'video_length_in_seconds'
}

/** select "andablog_video_aggregate_bool_exp_bool_and_arguments_columns" columns of table "andablog_video" */
export enum Andablog_Video_Select_Column_Andablog_Video_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPremium = 'is_premium'
}

/** select "andablog_video_aggregate_bool_exp_bool_or_arguments_columns" columns of table "andablog_video" */
export enum Andablog_Video_Select_Column_Andablog_Video_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPremium = 'is_premium'
}

/** input type for updating data in table "andablog_video" */
export type Andablog_Video_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  category_topic_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vdpcipher_id?: InputMaybe<Scalars['String']['input']>;
  video_length_in_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Andablog_Video_Stddev_Fields = {
  __typename?: 'andablog_video_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  category_topic_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "andablog_video" */
export type Andablog_Video_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Andablog_Video_Stddev_Pop_Fields = {
  __typename?: 'andablog_video_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  category_topic_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "andablog_video" */
export type Andablog_Video_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Andablog_Video_Stddev_Samp_Fields = {
  __typename?: 'andablog_video_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  category_topic_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "andablog_video" */
export type Andablog_Video_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "andablog_video" */
export type Andablog_Video_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Andablog_Video_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Andablog_Video_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  category_topic_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vdpcipher_id?: InputMaybe<Scalars['String']['input']>;
  video_length_in_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Andablog_Video_Sum_Fields = {
  __typename?: 'andablog_video_sum_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  category_topic_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "andablog_video" */
export type Andablog_Video_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** update columns of table "andablog_video" */
export enum Andablog_Video_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CategoryTopicId = 'category_topic_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  Name = 'name',
  /** column name */
  Rank = 'rank',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VdpcipherId = 'vdpcipher_id',
  /** column name */
  VideoLengthInSeconds = 'video_length_in_seconds'
}

export type Andablog_Video_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Andablog_Video_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Andablog_Video_Set_Input>;
  /** filter the rows which have to be updated */
  where: Andablog_Video_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Andablog_Video_Var_Pop_Fields = {
  __typename?: 'andablog_video_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  category_topic_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "andablog_video" */
export type Andablog_Video_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Andablog_Video_Var_Samp_Fields = {
  __typename?: 'andablog_video_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  category_topic_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "andablog_video" */
export type Andablog_Video_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Andablog_Video_Variance_Fields = {
  __typename?: 'andablog_video_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  category_topic_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  video_length_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "andablog_video" */
export type Andablog_Video_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_topic_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  video_length_in_seconds?: InputMaybe<Order_By>;
};

/** columns and relationships of "auth.email_verifications" */
export type Auth_Email_Verifications = {
  __typename?: 'auth_email_verifications';
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  expires_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.email_verifications" */
export type Auth_Email_Verifications_Aggregate = {
  __typename?: 'auth_email_verifications_aggregate';
  aggregate?: Maybe<Auth_Email_Verifications_Aggregate_Fields>;
  nodes: Array<Auth_Email_Verifications>;
};

/** aggregate fields of "auth.email_verifications" */
export type Auth_Email_Verifications_Aggregate_Fields = {
  __typename?: 'auth_email_verifications_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Email_Verifications_Max_Fields>;
  min?: Maybe<Auth_Email_Verifications_Min_Fields>;
};


/** aggregate fields of "auth.email_verifications" */
export type Auth_Email_Verifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Email_Verifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.email_verifications". All fields are combined with a logical 'AND'. */
export type Auth_Email_Verifications_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Email_Verifications_Bool_Exp>>;
  _not?: InputMaybe<Auth_Email_Verifications_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Email_Verifications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.email_verifications" */
export enum Auth_Email_Verifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailVerificationTokensPkey = 'email_verification_tokens_pkey'
}

/** input type for inserting data into table "auth.email_verifications" */
export type Auth_Email_Verifications_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Auth_Email_Verifications_Max_Fields = {
  __typename?: 'auth_email_verifications_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Auth_Email_Verifications_Min_Fields = {
  __typename?: 'auth_email_verifications_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "auth.email_verifications" */
export type Auth_Email_Verifications_Mutation_Response = {
  __typename?: 'auth_email_verifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Email_Verifications>;
};

/** on_conflict condition type for table "auth.email_verifications" */
export type Auth_Email_Verifications_On_Conflict = {
  constraint: Auth_Email_Verifications_Constraint;
  update_columns?: Array<Auth_Email_Verifications_Update_Column>;
  where?: InputMaybe<Auth_Email_Verifications_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.email_verifications". */
export type Auth_Email_Verifications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.email_verifications */
export type Auth_Email_Verifications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.email_verifications" */
export enum Auth_Email_Verifications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "auth.email_verifications" */
export type Auth_Email_Verifications_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "auth_email_verifications" */
export type Auth_Email_Verifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Email_Verifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Email_Verifications_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.email_verifications" */
export enum Auth_Email_Verifications_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Auth_Email_Verifications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Email_Verifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Email_Verifications_Bool_Exp;
};

/** columns and relationships of "auth_group" */
export type Auth_Group = {
  __typename?: 'auth_group';
  /** An array relationship */
  auth_group_permissions: Array<Auth_Group_Permissions>;
  /** An aggregate relationship */
  auth_group_permissions_aggregate: Auth_Group_Permissions_Aggregate;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  users_user_groups: Array<Users_User_Groups>;
  /** An aggregate relationship */
  users_user_groups_aggregate: Users_User_Groups_Aggregate;
};


/** columns and relationships of "auth_group" */
export type Auth_GroupAuth_Group_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_group" */
export type Auth_GroupAuth_Group_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_group" */
export type Auth_GroupUsers_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Groups_Order_By>>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};


/** columns and relationships of "auth_group" */
export type Auth_GroupUsers_User_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Groups_Order_By>>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};

/** aggregated selection of "auth_group" */
export type Auth_Group_Aggregate = {
  __typename?: 'auth_group_aggregate';
  aggregate?: Maybe<Auth_Group_Aggregate_Fields>;
  nodes: Array<Auth_Group>;
};

/** aggregate fields of "auth_group" */
export type Auth_Group_Aggregate_Fields = {
  __typename?: 'auth_group_aggregate_fields';
  avg?: Maybe<Auth_Group_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Group_Max_Fields>;
  min?: Maybe<Auth_Group_Min_Fields>;
  stddev?: Maybe<Auth_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Group_Sum_Fields>;
  var_pop?: Maybe<Auth_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Group_Var_Samp_Fields>;
  variance?: Maybe<Auth_Group_Variance_Fields>;
};


/** aggregate fields of "auth_group" */
export type Auth_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Auth_Group_Avg_Fields = {
  __typename?: 'auth_group_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "auth_group". All fields are combined with a logical 'AND'. */
export type Auth_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  _not?: InputMaybe<Auth_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  auth_group_permissions?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
  auth_group_permissions_aggregate?: InputMaybe<Auth_Group_Permissions_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  users_user_groups?: InputMaybe<Users_User_Groups_Bool_Exp>;
  users_user_groups_aggregate?: InputMaybe<Users_User_Groups_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth_group" */
export enum Auth_Group_Constraint {
  /** unique or primary key constraint on columns "name" */
  AuthGroupNameKey = 'auth_group_name_key',
  /** unique or primary key constraint on columns "id" */
  AuthGroupPkey = 'auth_group_pkey'
}

/** input type for incrementing numeric columns in table "auth_group" */
export type Auth_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "auth_group" */
export type Auth_Group_Insert_Input = {
  auth_group_permissions?: InputMaybe<Auth_Group_Permissions_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  users_user_groups?: InputMaybe<Users_User_Groups_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Auth_Group_Max_Fields = {
  __typename?: 'auth_group_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Auth_Group_Min_Fields = {
  __typename?: 'auth_group_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth_group" */
export type Auth_Group_Mutation_Response = {
  __typename?: 'auth_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Group>;
};

/** input type for inserting object relation for remote table "auth_group" */
export type Auth_Group_Obj_Rel_Insert_Input = {
  data: Auth_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};

/** on_conflict condition type for table "auth_group" */
export type Auth_Group_On_Conflict = {
  constraint: Auth_Group_Constraint;
  update_columns?: Array<Auth_Group_Update_Column>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_group". */
export type Auth_Group_Order_By = {
  auth_group_permissions_aggregate?: InputMaybe<Auth_Group_Permissions_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  users_user_groups_aggregate?: InputMaybe<Users_User_Groups_Aggregate_Order_By>;
};

/** columns and relationships of "auth_group_permissions" */
export type Auth_Group_Permissions = {
  __typename?: 'auth_group_permissions';
  /** An object relationship */
  auth_group: Auth_Group;
  /** An object relationship */
  auth_permission: Auth_Permission;
  group_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  permission_id: Scalars['Int']['output'];
};

/** aggregated selection of "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate = {
  __typename?: 'auth_group_permissions_aggregate';
  aggregate?: Maybe<Auth_Group_Permissions_Aggregate_Fields>;
  nodes: Array<Auth_Group_Permissions>;
};

export type Auth_Group_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Auth_Group_Permissions_Aggregate_Bool_Exp_Count>;
};

export type Auth_Group_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate_Fields = {
  __typename?: 'auth_group_permissions_aggregate_fields';
  avg?: Maybe<Auth_Group_Permissions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Group_Permissions_Max_Fields>;
  min?: Maybe<Auth_Group_Permissions_Min_Fields>;
  stddev?: Maybe<Auth_Group_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Group_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Group_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Group_Permissions_Sum_Fields>;
  var_pop?: Maybe<Auth_Group_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Group_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Auth_Group_Permissions_Variance_Fields>;
};


/** aggregate fields of "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Auth_Group_Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Group_Permissions_Max_Order_By>;
  min?: InputMaybe<Auth_Group_Permissions_Min_Order_By>;
  stddev?: InputMaybe<Auth_Group_Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Auth_Group_Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Auth_Group_Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Auth_Group_Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Auth_Group_Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Auth_Group_Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Auth_Group_Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth_group_permissions" */
export type Auth_Group_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Auth_Group_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Group_Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Auth_Group_Permissions_Avg_Fields = {
  __typename?: 'auth_group_permissions_avg_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth_group_permissions". All fields are combined with a logical 'AND'. */
export type Auth_Group_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Group_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Group_Permissions_Bool_Exp>>;
  auth_group?: InputMaybe<Auth_Group_Bool_Exp>;
  auth_permission?: InputMaybe<Auth_Permission_Bool_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  permission_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth_group_permissions" */
export enum Auth_Group_Permissions_Constraint {
  /** unique or primary key constraint on columns "permission_id", "group_id" */
  AuthGroupPermissionsGroupIdPermissionId_0cd325b0Uniq = 'auth_group_permissions_group_id_permission_id_0cd325b0_uniq',
  /** unique or primary key constraint on columns "id" */
  AuthGroupPermissionsPkey = 'auth_group_permissions_pkey'
}

/** input type for incrementing numeric columns in table "auth_group_permissions" */
export type Auth_Group_Permissions_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  permission_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "auth_group_permissions" */
export type Auth_Group_Permissions_Insert_Input = {
  auth_group?: InputMaybe<Auth_Group_Obj_Rel_Insert_Input>;
  auth_permission?: InputMaybe<Auth_Permission_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  permission_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Auth_Group_Permissions_Max_Fields = {
  __typename?: 'auth_group_permissions_max_fields';
  group_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  permission_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Max_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Group_Permissions_Min_Fields = {
  __typename?: 'auth_group_permissions_min_fields';
  group_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  permission_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Min_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth_group_permissions" */
export type Auth_Group_Permissions_Mutation_Response = {
  __typename?: 'auth_group_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Group_Permissions>;
};

/** on_conflict condition type for table "auth_group_permissions" */
export type Auth_Group_Permissions_On_Conflict = {
  constraint: Auth_Group_Permissions_Constraint;
  update_columns?: Array<Auth_Group_Permissions_Update_Column>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_group_permissions". */
export type Auth_Group_Permissions_Order_By = {
  auth_group?: InputMaybe<Auth_Group_Order_By>;
  auth_permission?: InputMaybe<Auth_Permission_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth_group_permissions */
export type Auth_Group_Permissions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "auth_group_permissions" */
export enum Auth_Group_Permissions_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

/** input type for updating data in table "auth_group_permissions" */
export type Auth_Group_Permissions_Set_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  permission_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Auth_Group_Permissions_Stddev_Fields = {
  __typename?: 'auth_group_permissions_stddev_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Auth_Group_Permissions_Stddev_Pop_Fields = {
  __typename?: 'auth_group_permissions_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Auth_Group_Permissions_Stddev_Samp_Fields = {
  __typename?: 'auth_group_permissions_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "auth_group_permissions" */
export type Auth_Group_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Group_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Group_Permissions_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  permission_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Auth_Group_Permissions_Sum_Fields = {
  __typename?: 'auth_group_permissions_sum_fields';
  group_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  permission_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** update columns of table "auth_group_permissions" */
export enum Auth_Group_Permissions_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

export type Auth_Group_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Group_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Group_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Group_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Group_Permissions_Var_Pop_Fields = {
  __typename?: 'auth_group_permissions_var_pop_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Auth_Group_Permissions_Var_Samp_Fields = {
  __typename?: 'auth_group_permissions_var_samp_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Auth_Group_Permissions_Variance_Fields = {
  __typename?: 'auth_group_permissions_variance_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth_group */
export type Auth_Group_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "auth_group" */
export enum Auth_Group_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "auth_group" */
export type Auth_Group_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Auth_Group_Stddev_Fields = {
  __typename?: 'auth_group_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Auth_Group_Stddev_Pop_Fields = {
  __typename?: 'auth_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Auth_Group_Stddev_Samp_Fields = {
  __typename?: 'auth_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "auth_group" */
export type Auth_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Group_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Auth_Group_Sum_Fields = {
  __typename?: 'auth_group_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "auth_group" */
export enum Auth_Group_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Auth_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Group_Var_Pop_Fields = {
  __typename?: 'auth_group_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Auth_Group_Var_Samp_Fields = {
  __typename?: 'auth_group_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Auth_Group_Variance_Fields = {
  __typename?: 'auth_group_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "auth.password_reset_tokens" */
export type Auth_Password_Reset_Tokens = {
  __typename?: 'auth_password_reset_tokens';
  created_at: Scalars['timestamptz']['output'];
  expires_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.password_reset_tokens" */
export type Auth_Password_Reset_Tokens_Aggregate = {
  __typename?: 'auth_password_reset_tokens_aggregate';
  aggregate?: Maybe<Auth_Password_Reset_Tokens_Aggregate_Fields>;
  nodes: Array<Auth_Password_Reset_Tokens>;
};

/** aggregate fields of "auth.password_reset_tokens" */
export type Auth_Password_Reset_Tokens_Aggregate_Fields = {
  __typename?: 'auth_password_reset_tokens_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Password_Reset_Tokens_Max_Fields>;
  min?: Maybe<Auth_Password_Reset_Tokens_Min_Fields>;
};


/** aggregate fields of "auth.password_reset_tokens" */
export type Auth_Password_Reset_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Password_Reset_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.password_reset_tokens". All fields are combined with a logical 'AND'. */
export type Auth_Password_Reset_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Password_Reset_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Auth_Password_Reset_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Password_Reset_Tokens_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.password_reset_tokens" */
export enum Auth_Password_Reset_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  PasswordResetTokenPkey = 'password_reset_token_pkey'
}

/** input type for inserting data into table "auth.password_reset_tokens" */
export type Auth_Password_Reset_Tokens_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Auth_Password_Reset_Tokens_Max_Fields = {
  __typename?: 'auth_password_reset_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Auth_Password_Reset_Tokens_Min_Fields = {
  __typename?: 'auth_password_reset_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "auth.password_reset_tokens" */
export type Auth_Password_Reset_Tokens_Mutation_Response = {
  __typename?: 'auth_password_reset_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Password_Reset_Tokens>;
};

/** on_conflict condition type for table "auth.password_reset_tokens" */
export type Auth_Password_Reset_Tokens_On_Conflict = {
  constraint: Auth_Password_Reset_Tokens_Constraint;
  update_columns?: Array<Auth_Password_Reset_Tokens_Update_Column>;
  where?: InputMaybe<Auth_Password_Reset_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.password_reset_tokens". */
export type Auth_Password_Reset_Tokens_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.password_reset_tokens */
export type Auth_Password_Reset_Tokens_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.password_reset_tokens" */
export enum Auth_Password_Reset_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "auth.password_reset_tokens" */
export type Auth_Password_Reset_Tokens_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "auth_password_reset_tokens" */
export type Auth_Password_Reset_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Password_Reset_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Password_Reset_Tokens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.password_reset_tokens" */
export enum Auth_Password_Reset_Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Auth_Password_Reset_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Password_Reset_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Password_Reset_Tokens_Bool_Exp;
};

/** columns and relationships of "auth_permission" */
export type Auth_Permission = {
  __typename?: 'auth_permission';
  /** An array relationship */
  auth_group_permissions: Array<Auth_Group_Permissions>;
  /** An aggregate relationship */
  auth_group_permissions_aggregate: Auth_Group_Permissions_Aggregate;
  codename: Scalars['String']['output'];
  content_type_id: Scalars['Int']['output'];
  /** An object relationship */
  django_content_type: Django_Content_Type;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  users_user_user_permissions: Array<Users_User_User_Permissions>;
  /** An aggregate relationship */
  users_user_user_permissions_aggregate: Users_User_User_Permissions_Aggregate;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionAuth_Group_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionAuth_Group_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionUsers_User_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionUsers_User_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};

/** aggregated selection of "auth_permission" */
export type Auth_Permission_Aggregate = {
  __typename?: 'auth_permission_aggregate';
  aggregate?: Maybe<Auth_Permission_Aggregate_Fields>;
  nodes: Array<Auth_Permission>;
};

export type Auth_Permission_Aggregate_Bool_Exp = {
  count?: InputMaybe<Auth_Permission_Aggregate_Bool_Exp_Count>;
};

export type Auth_Permission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Permission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth_permission" */
export type Auth_Permission_Aggregate_Fields = {
  __typename?: 'auth_permission_aggregate_fields';
  avg?: Maybe<Auth_Permission_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Permission_Max_Fields>;
  min?: Maybe<Auth_Permission_Min_Fields>;
  stddev?: Maybe<Auth_Permission_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Permission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Permission_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Permission_Sum_Fields>;
  var_pop?: Maybe<Auth_Permission_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Permission_Var_Samp_Fields>;
  variance?: Maybe<Auth_Permission_Variance_Fields>;
};


/** aggregate fields of "auth_permission" */
export type Auth_Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth_permission" */
export type Auth_Permission_Aggregate_Order_By = {
  avg?: InputMaybe<Auth_Permission_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Permission_Max_Order_By>;
  min?: InputMaybe<Auth_Permission_Min_Order_By>;
  stddev?: InputMaybe<Auth_Permission_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Auth_Permission_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Auth_Permission_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Auth_Permission_Sum_Order_By>;
  var_pop?: InputMaybe<Auth_Permission_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Auth_Permission_Var_Samp_Order_By>;
  variance?: InputMaybe<Auth_Permission_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth_permission" */
export type Auth_Permission_Arr_Rel_Insert_Input = {
  data: Array<Auth_Permission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};

/** aggregate avg on columns */
export type Auth_Permission_Avg_Fields = {
  __typename?: 'auth_permission_avg_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "auth_permission" */
export type Auth_Permission_Avg_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth_permission". All fields are combined with a logical 'AND'. */
export type Auth_Permission_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Permission_Bool_Exp>>;
  _not?: InputMaybe<Auth_Permission_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Permission_Bool_Exp>>;
  auth_group_permissions?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
  auth_group_permissions_aggregate?: InputMaybe<Auth_Group_Permissions_Aggregate_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  django_content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  users_user_user_permissions?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
  users_user_user_permissions_aggregate?: InputMaybe<Users_User_User_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth_permission" */
export enum Auth_Permission_Constraint {
  /** unique or primary key constraint on columns "codename", "content_type_id" */
  AuthPermissionContentTypeIdCodename_01ab375aUniq = 'auth_permission_content_type_id_codename_01ab375a_uniq',
  /** unique or primary key constraint on columns "id" */
  AuthPermissionPkey = 'auth_permission_pkey'
}

/** input type for incrementing numeric columns in table "auth_permission" */
export type Auth_Permission_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "auth_permission" */
export type Auth_Permission_Insert_Input = {
  auth_group_permissions?: InputMaybe<Auth_Group_Permissions_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']['input']>;
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  django_content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  users_user_user_permissions?: InputMaybe<Users_User_User_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Auth_Permission_Max_Fields = {
  __typename?: 'auth_permission_max_fields';
  codename?: Maybe<Scalars['String']['output']>;
  content_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "auth_permission" */
export type Auth_Permission_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Permission_Min_Fields = {
  __typename?: 'auth_permission_min_fields';
  codename?: Maybe<Scalars['String']['output']>;
  content_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "auth_permission" */
export type Auth_Permission_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth_permission" */
export type Auth_Permission_Mutation_Response = {
  __typename?: 'auth_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Permission>;
};

/** input type for inserting object relation for remote table "auth_permission" */
export type Auth_Permission_Obj_Rel_Insert_Input = {
  data: Auth_Permission_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};

/** on_conflict condition type for table "auth_permission" */
export type Auth_Permission_On_Conflict = {
  constraint: Auth_Permission_Constraint;
  update_columns?: Array<Auth_Permission_Update_Column>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_permission". */
export type Auth_Permission_Order_By = {
  auth_group_permissions_aggregate?: InputMaybe<Auth_Group_Permissions_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  django_content_type?: InputMaybe<Django_Content_Type_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  users_user_user_permissions_aggregate?: InputMaybe<Users_User_User_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: auth_permission */
export type Auth_Permission_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "auth_permission" */
export enum Auth_Permission_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "auth_permission" */
export type Auth_Permission_Set_Input = {
  codename?: InputMaybe<Scalars['String']['input']>;
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Auth_Permission_Stddev_Fields = {
  __typename?: 'auth_permission_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "auth_permission" */
export type Auth_Permission_Stddev_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Auth_Permission_Stddev_Pop_Fields = {
  __typename?: 'auth_permission_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "auth_permission" */
export type Auth_Permission_Stddev_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Auth_Permission_Stddev_Samp_Fields = {
  __typename?: 'auth_permission_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "auth_permission" */
export type Auth_Permission_Stddev_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "auth_permission" */
export type Auth_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Permission_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']['input']>;
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Auth_Permission_Sum_Fields = {
  __typename?: 'auth_permission_sum_fields';
  content_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "auth_permission" */
export type Auth_Permission_Sum_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "auth_permission" */
export enum Auth_Permission_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Auth_Permission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Permission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Permission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Permission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Permission_Var_Pop_Fields = {
  __typename?: 'auth_permission_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "auth_permission" */
export type Auth_Permission_Var_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Auth_Permission_Var_Samp_Fields = {
  __typename?: 'auth_permission_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "auth_permission" */
export type Auth_Permission_Var_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Auth_Permission_Variance_Fields = {
  __typename?: 'auth_permission_variance_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "auth_permission" */
export type Auth_Permission_Variance_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "auth.session" */
export type Auth_Session = {
  __typename?: 'auth_session';
  created_at: Scalars['timestamptz']['output'];
  expires_at: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "auth.session" */
export type Auth_Session_Aggregate = {
  __typename?: 'auth_session_aggregate';
  aggregate?: Maybe<Auth_Session_Aggregate_Fields>;
  nodes: Array<Auth_Session>;
};

/** aggregate fields of "auth.session" */
export type Auth_Session_Aggregate_Fields = {
  __typename?: 'auth_session_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Session_Max_Fields>;
  min?: Maybe<Auth_Session_Min_Fields>;
};


/** aggregate fields of "auth.session" */
export type Auth_Session_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Session_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.session". All fields are combined with a logical 'AND'. */
export type Auth_Session_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Session_Bool_Exp>>;
  _not?: InputMaybe<Auth_Session_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Session_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.session" */
export enum Auth_Session_Constraint {
  /** unique or primary key constraint on columns "id" */
  SessionIdKey = 'session_id_key',
  /** unique or primary key constraint on columns "id" */
  SessionPkey = 'session_pkey'
}

/** input type for inserting data into table "auth.session" */
export type Auth_Session_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Auth_Session_Max_Fields = {
  __typename?: 'auth_session_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Auth_Session_Min_Fields = {
  __typename?: 'auth_session_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.session" */
export type Auth_Session_Mutation_Response = {
  __typename?: 'auth_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Session>;
};

/** on_conflict condition type for table "auth.session" */
export type Auth_Session_On_Conflict = {
  constraint: Auth_Session_Constraint;
  update_columns?: Array<Auth_Session_Update_Column>;
  where?: InputMaybe<Auth_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.session". */
export type Auth_Session_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.session */
export type Auth_Session_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.session" */
export enum Auth_Session_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "auth.session" */
export type Auth_Session_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_session" */
export type Auth_Session_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Session_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Session_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.session" */
export enum Auth_Session_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Auth_Session_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Session_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Session_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics = {
  __typename?: 'bookmarked_learn_topics';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  /** An object relationship */
  andablog_entry: Andablog_Entry;
  created_at: Scalars['timestamptz']['output'];
  entry_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Aggregate = {
  __typename?: 'bookmarked_learn_topics_aggregate';
  aggregate?: Maybe<Bookmarked_Learn_Topics_Aggregate_Fields>;
  nodes: Array<Bookmarked_Learn_Topics>;
};

export type Bookmarked_Learn_Topics_Aggregate_Bool_Exp = {
  count?: InputMaybe<Bookmarked_Learn_Topics_Aggregate_Bool_Exp_Count>;
};

export type Bookmarked_Learn_Topics_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Aggregate_Fields = {
  __typename?: 'bookmarked_learn_topics_aggregate_fields';
  avg?: Maybe<Bookmarked_Learn_Topics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Bookmarked_Learn_Topics_Max_Fields>;
  min?: Maybe<Bookmarked_Learn_Topics_Min_Fields>;
  stddev?: Maybe<Bookmarked_Learn_Topics_Stddev_Fields>;
  stddev_pop?: Maybe<Bookmarked_Learn_Topics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bookmarked_Learn_Topics_Stddev_Samp_Fields>;
  sum?: Maybe<Bookmarked_Learn_Topics_Sum_Fields>;
  var_pop?: Maybe<Bookmarked_Learn_Topics_Var_Pop_Fields>;
  var_samp?: Maybe<Bookmarked_Learn_Topics_Var_Samp_Fields>;
  variance?: Maybe<Bookmarked_Learn_Topics_Variance_Fields>;
};


/** aggregate fields of "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Aggregate_Order_By = {
  avg?: InputMaybe<Bookmarked_Learn_Topics_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bookmarked_Learn_Topics_Max_Order_By>;
  min?: InputMaybe<Bookmarked_Learn_Topics_Min_Order_By>;
  stddev?: InputMaybe<Bookmarked_Learn_Topics_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bookmarked_Learn_Topics_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bookmarked_Learn_Topics_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bookmarked_Learn_Topics_Sum_Order_By>;
  var_pop?: InputMaybe<Bookmarked_Learn_Topics_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bookmarked_Learn_Topics_Var_Samp_Order_By>;
  variance?: InputMaybe<Bookmarked_Learn_Topics_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Arr_Rel_Insert_Input = {
  data: Array<Bookmarked_Learn_Topics_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Bookmarked_Learn_Topics_On_Conflict>;
};

/** aggregate avg on columns */
export type Bookmarked_Learn_Topics_Avg_Fields = {
  __typename?: 'bookmarked_learn_topics_avg_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bookmarked_learn_topics". All fields are combined with a logical 'AND'. */
export type Bookmarked_Learn_Topics_Bool_Exp = {
  _and?: InputMaybe<Array<Bookmarked_Learn_Topics_Bool_Exp>>;
  _not?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
  _or?: InputMaybe<Array<Bookmarked_Learn_Topics_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bookmarked_learn_topics" */
export enum Bookmarked_Learn_Topics_Constraint {
  /** unique or primary key constraint on columns "id" */
  BookmarkedLessonsPkey = 'bookmarked_lessons_pkey'
}

/** input type for incrementing numeric columns in table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Bookmarked_Learn_Topics_Max_Fields = {
  __typename?: 'bookmarked_learn_topics_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Bookmarked_Learn_Topics_Min_Fields = {
  __typename?: 'bookmarked_learn_topics_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Mutation_Response = {
  __typename?: 'bookmarked_learn_topics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bookmarked_Learn_Topics>;
};

/** on_conflict condition type for table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_On_Conflict = {
  constraint: Bookmarked_Learn_Topics_Constraint;
  update_columns?: Array<Bookmarked_Learn_Topics_Update_Column>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};

/** Ordering options when selecting data from "bookmarked_learn_topics". */
export type Bookmarked_Learn_Topics_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bookmarked_learn_topics */
export type Bookmarked_Learn_Topics_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "bookmarked_learn_topics" */
export enum Bookmarked_Learn_Topics_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Bookmarked_Learn_Topics_Stddev_Fields = {
  __typename?: 'bookmarked_learn_topics_stddev_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bookmarked_Learn_Topics_Stddev_Pop_Fields = {
  __typename?: 'bookmarked_learn_topics_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bookmarked_Learn_Topics_Stddev_Samp_Fields = {
  __typename?: 'bookmarked_learn_topics_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bookmarked_Learn_Topics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bookmarked_Learn_Topics_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Bookmarked_Learn_Topics_Sum_Fields = {
  __typename?: 'bookmarked_learn_topics_sum_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** update columns of table "bookmarked_learn_topics" */
export enum Bookmarked_Learn_Topics_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Bookmarked_Learn_Topics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bookmarked_Learn_Topics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bookmarked_Learn_Topics_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bookmarked_Learn_Topics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bookmarked_Learn_Topics_Var_Pop_Fields = {
  __typename?: 'bookmarked_learn_topics_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bookmarked_Learn_Topics_Var_Samp_Fields = {
  __typename?: 'bookmarked_learn_topics_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Bookmarked_Learn_Topics_Variance_Fields = {
  __typename?: 'bookmarked_learn_topics_variance_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "bookmarked_learn_topics" */
export type Bookmarked_Learn_Topics_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

/** columns and relationships of "cat_percentile_constant" */
export type Cat_Percentile_Constant = {
  __typename?: 'cat_percentile_constant';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "cat_percentile_constant" */
export type Cat_Percentile_Constant_Aggregate = {
  __typename?: 'cat_percentile_constant_aggregate';
  aggregate?: Maybe<Cat_Percentile_Constant_Aggregate_Fields>;
  nodes: Array<Cat_Percentile_Constant>;
};

/** aggregate fields of "cat_percentile_constant" */
export type Cat_Percentile_Constant_Aggregate_Fields = {
  __typename?: 'cat_percentile_constant_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cat_Percentile_Constant_Max_Fields>;
  min?: Maybe<Cat_Percentile_Constant_Min_Fields>;
};


/** aggregate fields of "cat_percentile_constant" */
export type Cat_Percentile_Constant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cat_Percentile_Constant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "cat_percentile_constant". All fields are combined with a logical 'AND'. */
export type Cat_Percentile_Constant_Bool_Exp = {
  _and?: InputMaybe<Array<Cat_Percentile_Constant_Bool_Exp>>;
  _not?: InputMaybe<Cat_Percentile_Constant_Bool_Exp>;
  _or?: InputMaybe<Array<Cat_Percentile_Constant_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cat_percentile_constant" */
export enum Cat_Percentile_Constant_Constraint {
  /** unique or primary key constraint on columns "id" */
  CatPercentileConstantPkey = 'cat_percentile_constant_pkey'
}

/** input type for inserting data into table "cat_percentile_constant" */
export type Cat_Percentile_Constant_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Cat_Percentile_Constant_Max_Fields = {
  __typename?: 'cat_percentile_constant_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Cat_Percentile_Constant_Min_Fields = {
  __typename?: 'cat_percentile_constant_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "cat_percentile_constant" */
export type Cat_Percentile_Constant_Mutation_Response = {
  __typename?: 'cat_percentile_constant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cat_Percentile_Constant>;
};

/** on_conflict condition type for table "cat_percentile_constant" */
export type Cat_Percentile_Constant_On_Conflict = {
  constraint: Cat_Percentile_Constant_Constraint;
  update_columns?: Array<Cat_Percentile_Constant_Update_Column>;
  where?: InputMaybe<Cat_Percentile_Constant_Bool_Exp>;
};

/** Ordering options when selecting data from "cat_percentile_constant". */
export type Cat_Percentile_Constant_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cat_percentile_constant */
export type Cat_Percentile_Constant_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cat_percentile_constant" */
export enum Cat_Percentile_Constant_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "cat_percentile_constant" */
export type Cat_Percentile_Constant_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "cat_percentile_constant" */
export type Cat_Percentile_Constant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cat_Percentile_Constant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cat_Percentile_Constant_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "cat_percentile_constant" */
export enum Cat_Percentile_Constant_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Cat_Percentile_Constant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cat_Percentile_Constant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cat_Percentile_Constant_Bool_Exp;
};

/** columns and relationships of "cat_scores" */
export type Cat_Scores = {
  __typename?: 'cat_scores';
  created_at: Scalars['timestamptz']['output'];
  dilr: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  overall: Scalars['numeric']['output'];
  participantId: Scalars['String']['output'];
  qa: Scalars['numeric']['output'];
  shiftNumber: Scalars['String']['output'];
  testCenterName: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_additional_field: Supertokens_User_Additional_Fields;
  user_id: Scalars['String']['output'];
  varc: Scalars['numeric']['output'];
};

/** aggregated selection of "cat_scores" */
export type Cat_Scores_Aggregate = {
  __typename?: 'cat_scores_aggregate';
  aggregate?: Maybe<Cat_Scores_Aggregate_Fields>;
  nodes: Array<Cat_Scores>;
};

/** aggregate fields of "cat_scores" */
export type Cat_Scores_Aggregate_Fields = {
  __typename?: 'cat_scores_aggregate_fields';
  avg?: Maybe<Cat_Scores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cat_Scores_Max_Fields>;
  min?: Maybe<Cat_Scores_Min_Fields>;
  stddev?: Maybe<Cat_Scores_Stddev_Fields>;
  stddev_pop?: Maybe<Cat_Scores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cat_Scores_Stddev_Samp_Fields>;
  sum?: Maybe<Cat_Scores_Sum_Fields>;
  var_pop?: Maybe<Cat_Scores_Var_Pop_Fields>;
  var_samp?: Maybe<Cat_Scores_Var_Samp_Fields>;
  variance?: Maybe<Cat_Scores_Variance_Fields>;
};


/** aggregate fields of "cat_scores" */
export type Cat_Scores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cat_Scores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Cat_Scores_Avg_Fields = {
  __typename?: 'cat_scores_avg_fields';
  dilr?: Maybe<Scalars['Float']['output']>;
  overall?: Maybe<Scalars['Float']['output']>;
  qa?: Maybe<Scalars['Float']['output']>;
  varc?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cat_scores". All fields are combined with a logical 'AND'. */
export type Cat_Scores_Bool_Exp = {
  _and?: InputMaybe<Array<Cat_Scores_Bool_Exp>>;
  _not?: InputMaybe<Cat_Scores_Bool_Exp>;
  _or?: InputMaybe<Array<Cat_Scores_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dilr?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  overall?: InputMaybe<Numeric_Comparison_Exp>;
  participantId?: InputMaybe<String_Comparison_Exp>;
  qa?: InputMaybe<Numeric_Comparison_Exp>;
  shiftNumber?: InputMaybe<String_Comparison_Exp>;
  testCenterName?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_additional_field?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  varc?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "cat_scores" */
export enum Cat_Scores_Constraint {
  /** unique or primary key constraint on columns "id" */
  CatScoresPkey = 'cat_scores_pkey'
}

/** input type for incrementing numeric columns in table "cat_scores" */
export type Cat_Scores_Inc_Input = {
  dilr?: InputMaybe<Scalars['numeric']['input']>;
  overall?: InputMaybe<Scalars['numeric']['input']>;
  qa?: InputMaybe<Scalars['numeric']['input']>;
  varc?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "cat_scores" */
export type Cat_Scores_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dilr?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overall?: InputMaybe<Scalars['numeric']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  qa?: InputMaybe<Scalars['numeric']['input']>;
  shiftNumber?: InputMaybe<Scalars['String']['input']>;
  testCenterName?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_additional_field?: InputMaybe<Supertokens_User_Additional_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  varc?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Cat_Scores_Max_Fields = {
  __typename?: 'cat_scores_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dilr?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['numeric']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  qa?: Maybe<Scalars['numeric']['output']>;
  shiftNumber?: Maybe<Scalars['String']['output']>;
  testCenterName?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  varc?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Cat_Scores_Min_Fields = {
  __typename?: 'cat_scores_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dilr?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['numeric']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  qa?: Maybe<Scalars['numeric']['output']>;
  shiftNumber?: Maybe<Scalars['String']['output']>;
  testCenterName?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  varc?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "cat_scores" */
export type Cat_Scores_Mutation_Response = {
  __typename?: 'cat_scores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cat_Scores>;
};

/** on_conflict condition type for table "cat_scores" */
export type Cat_Scores_On_Conflict = {
  constraint: Cat_Scores_Constraint;
  update_columns?: Array<Cat_Scores_Update_Column>;
  where?: InputMaybe<Cat_Scores_Bool_Exp>;
};

/** Ordering options when selecting data from "cat_scores". */
export type Cat_Scores_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dilr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  overall?: InputMaybe<Order_By>;
  participantId?: InputMaybe<Order_By>;
  qa?: InputMaybe<Order_By>;
  shiftNumber?: InputMaybe<Order_By>;
  testCenterName?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_additional_field?: InputMaybe<Supertokens_User_Additional_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
  varc?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cat_scores */
export type Cat_Scores_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cat_scores" */
export enum Cat_Scores_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dilr = 'dilr',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Overall = 'overall',
  /** column name */
  ParticipantId = 'participantId',
  /** column name */
  Qa = 'qa',
  /** column name */
  ShiftNumber = 'shiftNumber',
  /** column name */
  TestCenterName = 'testCenterName',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Varc = 'varc'
}

/** input type for updating data in table "cat_scores" */
export type Cat_Scores_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dilr?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overall?: InputMaybe<Scalars['numeric']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  qa?: InputMaybe<Scalars['numeric']['input']>;
  shiftNumber?: InputMaybe<Scalars['String']['input']>;
  testCenterName?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  varc?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Cat_Scores_Stddev_Fields = {
  __typename?: 'cat_scores_stddev_fields';
  dilr?: Maybe<Scalars['Float']['output']>;
  overall?: Maybe<Scalars['Float']['output']>;
  qa?: Maybe<Scalars['Float']['output']>;
  varc?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Cat_Scores_Stddev_Pop_Fields = {
  __typename?: 'cat_scores_stddev_pop_fields';
  dilr?: Maybe<Scalars['Float']['output']>;
  overall?: Maybe<Scalars['Float']['output']>;
  qa?: Maybe<Scalars['Float']['output']>;
  varc?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Cat_Scores_Stddev_Samp_Fields = {
  __typename?: 'cat_scores_stddev_samp_fields';
  dilr?: Maybe<Scalars['Float']['output']>;
  overall?: Maybe<Scalars['Float']['output']>;
  qa?: Maybe<Scalars['Float']['output']>;
  varc?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "cat_scores" */
export type Cat_Scores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cat_Scores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cat_Scores_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dilr?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overall?: InputMaybe<Scalars['numeric']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  qa?: InputMaybe<Scalars['numeric']['input']>;
  shiftNumber?: InputMaybe<Scalars['String']['input']>;
  testCenterName?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  varc?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Cat_Scores_Sum_Fields = {
  __typename?: 'cat_scores_sum_fields';
  dilr?: Maybe<Scalars['numeric']['output']>;
  overall?: Maybe<Scalars['numeric']['output']>;
  qa?: Maybe<Scalars['numeric']['output']>;
  varc?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "cat_scores" */
export enum Cat_Scores_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dilr = 'dilr',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Overall = 'overall',
  /** column name */
  ParticipantId = 'participantId',
  /** column name */
  Qa = 'qa',
  /** column name */
  ShiftNumber = 'shiftNumber',
  /** column name */
  TestCenterName = 'testCenterName',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Varc = 'varc'
}

export type Cat_Scores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cat_Scores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cat_Scores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cat_Scores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cat_Scores_Var_Pop_Fields = {
  __typename?: 'cat_scores_var_pop_fields';
  dilr?: Maybe<Scalars['Float']['output']>;
  overall?: Maybe<Scalars['Float']['output']>;
  qa?: Maybe<Scalars['Float']['output']>;
  varc?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Cat_Scores_Var_Samp_Fields = {
  __typename?: 'cat_scores_var_samp_fields';
  dilr?: Maybe<Scalars['Float']['output']>;
  overall?: Maybe<Scalars['Float']['output']>;
  qa?: Maybe<Scalars['Float']['output']>;
  varc?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Cat_Scores_Variance_Fields = {
  __typename?: 'cat_scores_variance_fields';
  dilr?: Maybe<Scalars['Float']['output']>;
  overall?: Maybe<Scalars['Float']['output']>;
  qa?: Maybe<Scalars['Float']['output']>;
  varc?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "channel_members" */
export type Channel_Members = {
  __typename?: 'channel_members';
  /** An object relationship */
  channel: Channels;
  channel_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_blocked: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Supertokens_User_Additional_Fields>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregated selection of "channel_members" */
export type Channel_Members_Aggregate = {
  __typename?: 'channel_members_aggregate';
  aggregate?: Maybe<Channel_Members_Aggregate_Fields>;
  nodes: Array<Channel_Members>;
};

export type Channel_Members_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Channel_Members_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Channel_Members_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Channel_Members_Aggregate_Bool_Exp_Count>;
};

export type Channel_Members_Aggregate_Bool_Exp_Bool_And = {
  arguments: Channel_Members_Select_Column_Channel_Members_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Members_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Channel_Members_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Channel_Members_Select_Column_Channel_Members_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Members_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Channel_Members_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Channel_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Channel_Members_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "channel_members" */
export type Channel_Members_Aggregate_Fields = {
  __typename?: 'channel_members_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Channel_Members_Max_Fields>;
  min?: Maybe<Channel_Members_Min_Fields>;
};


/** aggregate fields of "channel_members" */
export type Channel_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channel_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "channel_members" */
export type Channel_Members_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Channel_Members_Max_Order_By>;
  min?: InputMaybe<Channel_Members_Min_Order_By>;
};

/** input type for inserting array relation for remote table "channel_members" */
export type Channel_Members_Arr_Rel_Insert_Input = {
  data: Array<Channel_Members_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Channel_Members_On_Conflict>;
};

/** Boolean expression to filter rows from the table "channel_members". All fields are combined with a logical 'AND'. */
export type Channel_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Channel_Members_Bool_Exp>>;
  _not?: InputMaybe<Channel_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Channel_Members_Bool_Exp>>;
  channel?: InputMaybe<Channels_Bool_Exp>;
  channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "channel_members" */
export enum Channel_Members_Constraint {
  /** unique or primary key constraint on columns "user_id", "channel_id" */
  ChannelMembersChannelIdUserIdKey = 'channel_members_channel_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  ChannelMembersPkey = 'channel_members_pkey'
}

/** input type for inserting data into table "channel_members" */
export type Channel_Members_Insert_Input = {
  channel?: InputMaybe<Channels_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Channel_Members_Max_Fields = {
  __typename?: 'channel_members_max_fields';
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "channel_members" */
export type Channel_Members_Max_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Channel_Members_Min_Fields = {
  __typename?: 'channel_members_min_fields';
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "channel_members" */
export type Channel_Members_Min_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "channel_members" */
export type Channel_Members_Mutation_Response = {
  __typename?: 'channel_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Channel_Members>;
};

/** on_conflict condition type for table "channel_members" */
export type Channel_Members_On_Conflict = {
  constraint: Channel_Members_Constraint;
  update_columns?: Array<Channel_Members_Update_Column>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "channel_members". */
export type Channel_Members_Order_By = {
  channel?: InputMaybe<Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_blocked?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: channel_members */
export type Channel_Members_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "channel_members" */
export enum Channel_Members_Select_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "channel_members_aggregate_bool_exp_bool_and_arguments_columns" columns of table "channel_members" */
export enum Channel_Members_Select_Column_Channel_Members_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsBlocked = 'is_blocked'
}

/** select "channel_members_aggregate_bool_exp_bool_or_arguments_columns" columns of table "channel_members" */
export enum Channel_Members_Select_Column_Channel_Members_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsBlocked = 'is_blocked'
}

/** input type for updating data in table "channel_members" */
export type Channel_Members_Set_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "channel_members" */
export type Channel_Members_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channel_Members_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channel_Members_Stream_Cursor_Value_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "channel_members" */
export enum Channel_Members_Update_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Channel_Members_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Channel_Members_Set_Input>;
  /** filter the rows which have to be updated */
  where: Channel_Members_Bool_Exp;
};

/** columns and relationships of "channels" */
export type Channels = {
  __typename?: 'channels';
  avatar: Scalars['String']['output'];
  /** An object relationship */
  category?: Maybe<Group_Category>;
  category_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  channel_members: Array<Channel_Members>;
  /** An aggregate relationship */
  channel_members_aggregate: Channel_Members_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_closed: Scalars['Boolean']['output'];
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  /** An array relationship */
  messages_reads: Array<Messages_Read>;
  /** An aggregate relationship */
  messages_reads_aggregate: Messages_Read_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  reported_messages: Array<Reported_Message>;
  /** An aggregate relationship */
  reported_messages_aggregate: Reported_Message_Aggregate;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "channels" */
export type ChannelsChannel_MembersArgs = {
  distinct_on?: InputMaybe<Array<Channel_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Members_Order_By>>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsChannel_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Members_Order_By>>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsMessages_ReadsArgs = {
  distinct_on?: InputMaybe<Array<Messages_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Read_Order_By>>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsMessages_Reads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Read_Order_By>>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsReported_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Reported_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reported_Message_Order_By>>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};


/** columns and relationships of "channels" */
export type ChannelsReported_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reported_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reported_Message_Order_By>>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};

/** aggregated selection of "channels" */
export type Channels_Aggregate = {
  __typename?: 'channels_aggregate';
  aggregate?: Maybe<Channels_Aggregate_Fields>;
  nodes: Array<Channels>;
};

/** aggregate fields of "channels" */
export type Channels_Aggregate_Fields = {
  __typename?: 'channels_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Channels_Max_Fields>;
  min?: Maybe<Channels_Min_Fields>;
};


/** aggregate fields of "channels" */
export type Channels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "channels". All fields are combined with a logical 'AND'. */
export type Channels_Bool_Exp = {
  _and?: InputMaybe<Array<Channels_Bool_Exp>>;
  _not?: InputMaybe<Channels_Bool_Exp>;
  _or?: InputMaybe<Array<Channels_Bool_Exp>>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<Group_Category_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  channel_members?: InputMaybe<Channel_Members_Bool_Exp>;
  channel_members_aggregate?: InputMaybe<Channel_Members_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_closed?: InputMaybe<Boolean_Comparison_Exp>;
  messages?: InputMaybe<Messages_Bool_Exp>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Bool_Exp>;
  messages_reads?: InputMaybe<Messages_Read_Bool_Exp>;
  messages_reads_aggregate?: InputMaybe<Messages_Read_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  reported_messages?: InputMaybe<Reported_Message_Bool_Exp>;
  reported_messages_aggregate?: InputMaybe<Reported_Message_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "channels" */
export enum Channels_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChannelIdPkey = 'channel_id_pkey',
  /** unique or primary key constraint on columns "slug" */
  ChannelsSlugKey = 'channels_slug_key'
}

/** input type for inserting data into table "channels" */
export type Channels_Insert_Input = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Group_Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  channel_members?: InputMaybe<Channel_Members_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<Messages_Arr_Rel_Insert_Input>;
  messages_reads?: InputMaybe<Messages_Read_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  reported_messages?: InputMaybe<Reported_Message_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Channels_Max_Fields = {
  __typename?: 'channels_max_fields';
  avatar?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Channels_Min_Fields = {
  __typename?: 'channels_min_fields';
  avatar?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "channels" */
export type Channels_Mutation_Response = {
  __typename?: 'channels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Channels>;
};

/** input type for inserting object relation for remote table "channels" */
export type Channels_Obj_Rel_Insert_Input = {
  data: Channels_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Channels_On_Conflict>;
};

/** on_conflict condition type for table "channels" */
export type Channels_On_Conflict = {
  constraint: Channels_Constraint;
  update_columns?: Array<Channels_Update_Column>;
  where?: InputMaybe<Channels_Bool_Exp>;
};

/** Ordering options when selecting data from "channels". */
export type Channels_Order_By = {
  avatar?: InputMaybe<Order_By>;
  category?: InputMaybe<Group_Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  channel_members_aggregate?: InputMaybe<Channel_Members_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_closed?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
  messages_reads_aggregate?: InputMaybe<Messages_Read_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  reported_messages_aggregate?: InputMaybe<Reported_Message_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: channels */
export type Channels_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "channels" */
export enum Channels_Select_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "channels" */
export type Channels_Set_Input = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "channels" */
export type Channels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channels_Stream_Cursor_Value_Input = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "channels" */
export enum Channels_Update_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Channels_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Channels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Channels_Bool_Exp;
};

/** columns and relationships of "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users = {
  __typename?: 'coupons_allowed_users_rule_users';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  allowedusersrule_id: Scalars['Int']['output'];
  /** An object relationship */
  coupons_allowedusersrule: Coupons_Allowedusersrule;
  id: Scalars['Int']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Aggregate = {
  __typename?: 'coupons_allowed_users_rule_users_aggregate';
  aggregate?: Maybe<Coupons_Allowed_Users_Rule_Users_Aggregate_Fields>;
  nodes: Array<Coupons_Allowed_Users_Rule_Users>;
};

export type Coupons_Allowed_Users_Rule_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Aggregate_Bool_Exp_Count>;
};

export type Coupons_Allowed_Users_Rule_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Aggregate_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_aggregate_fields';
  avg?: Maybe<Coupons_Allowed_Users_Rule_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Allowed_Users_Rule_Users_Max_Fields>;
  min?: Maybe<Coupons_Allowed_Users_Rule_Users_Min_Fields>;
  stddev?: Maybe<Coupons_Allowed_Users_Rule_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Allowed_Users_Rule_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Allowed_Users_Rule_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Allowed_Users_Rule_Users_Sum_Fields>;
  var_pop?: Maybe<Coupons_Allowed_Users_Rule_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Allowed_Users_Rule_Users_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Allowed_Users_Rule_Users_Variance_Fields>;
};


/** aggregate fields of "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Max_Order_By>;
  min?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Min_Order_By>;
  stddev?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Arr_Rel_Insert_Input = {
  data: Array<Coupons_Allowed_Users_Rule_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Allowed_Users_Rule_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Coupons_Allowed_Users_Rule_Users_Avg_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_avg_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Avg_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "coupons_allowed_users_rule_users". All fields are combined with a logical 'AND'. */
export type Coupons_Allowed_Users_Rule_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  allowedusersrule_id?: InputMaybe<Int_Comparison_Exp>;
  coupons_allowedusersrule?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "coupons_allowed_users_rule_users" */
export enum Coupons_Allowed_Users_Rule_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  CouponsAllowedUsersRuleUsersPkey = 'coupons_allowed_users_rule_users_pkey'
}

/** input type for incrementing numeric columns in table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Inc_Input = {
  allowedusersrule_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  allowedusersrule_id?: InputMaybe<Scalars['Int']['input']>;
  coupons_allowedusersrule?: InputMaybe<Coupons_Allowedusersrule_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Coupons_Allowed_Users_Rule_Users_Max_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_max_fields';
  allowedusersrule_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Max_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Coupons_Allowed_Users_Rule_Users_Min_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_min_fields';
  allowedusersrule_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Min_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Mutation_Response = {
  __typename?: 'coupons_allowed_users_rule_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Allowed_Users_Rule_Users>;
};

/** on_conflict condition type for table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_On_Conflict = {
  constraint: Coupons_Allowed_Users_Rule_Users_Constraint;
  update_columns?: Array<Coupons_Allowed_Users_Rule_Users_Update_Column>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_allowed_users_rule_users". */
export type Coupons_Allowed_Users_Rule_Users_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  allowedusersrule_id?: InputMaybe<Order_By>;
  coupons_allowedusersrule?: InputMaybe<Coupons_Allowedusersrule_Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: coupons_allowed_users_rule_users */
export type Coupons_Allowed_Users_Rule_Users_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_allowed_users_rule_users" */
export enum Coupons_Allowed_Users_Rule_Users_Select_Column {
  /** column name */
  AllowedusersruleId = 'allowedusersrule_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Set_Input = {
  allowedusersrule_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Allowed_Users_Rule_Users_Stddev_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_stddev_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Stddev_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Allowed_Users_Rule_Users_Stddev_Pop_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_stddev_pop_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Stddev_Pop_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Allowed_Users_Rule_Users_Stddev_Samp_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_stddev_samp_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Stddev_Samp_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Allowed_Users_Rule_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Allowed_Users_Rule_Users_Stream_Cursor_Value_Input = {
  allowedusersrule_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Allowed_Users_Rule_Users_Sum_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_sum_fields';
  allowedusersrule_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Sum_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "coupons_allowed_users_rule_users" */
export enum Coupons_Allowed_Users_Rule_Users_Update_Column {
  /** column name */
  AllowedusersruleId = 'allowedusersrule_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Coupons_Allowed_Users_Rule_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Allowed_Users_Rule_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coupons_Allowed_Users_Rule_Users_Var_Pop_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_var_pop_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Var_Pop_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Coupons_Allowed_Users_Rule_Users_Var_Samp_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_var_samp_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Var_Samp_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Coupons_Allowed_Users_Rule_Users_Variance_Fields = {
  __typename?: 'coupons_allowed_users_rule_users_variance_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "coupons_allowed_users_rule_users" */
export type Coupons_Allowed_Users_Rule_Users_Variance_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule = {
  __typename?: 'coupons_allowedusersrule';
  all_users: Scalars['Boolean']['output'];
  /** An array relationship */
  coupons_allowed_users_rule_users: Array<Coupons_Allowed_Users_Rule_Users>;
  /** An aggregate relationship */
  coupons_allowed_users_rule_users_aggregate: Coupons_Allowed_Users_Rule_Users_Aggregate;
  /** An array relationship */
  coupons_allowedusersrule_users: Array<Coupons_Allowedusersrule_Users>;
  /** An aggregate relationship */
  coupons_allowedusersrule_users_aggregate: Coupons_Allowedusersrule_Users_Aggregate;
  /** An array relationship */
  coupons_rulesets: Array<Coupons_Ruleset>;
  /** An aggregate relationship */
  coupons_rulesets_aggregate: Coupons_Ruleset_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "coupons_allowedusersrule" */
export type Coupons_AllowedusersruleCoupons_Allowed_Users_Rule_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};


/** columns and relationships of "coupons_allowedusersrule" */
export type Coupons_AllowedusersruleCoupons_Allowed_Users_Rule_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};


/** columns and relationships of "coupons_allowedusersrule" */
export type Coupons_AllowedusersruleCoupons_Allowedusersrule_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};


/** columns and relationships of "coupons_allowedusersrule" */
export type Coupons_AllowedusersruleCoupons_Allowedusersrule_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};


/** columns and relationships of "coupons_allowedusersrule" */
export type Coupons_AllowedusersruleCoupons_RulesetsArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};


/** columns and relationships of "coupons_allowedusersrule" */
export type Coupons_AllowedusersruleCoupons_Rulesets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};

/** aggregated selection of "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_Aggregate = {
  __typename?: 'coupons_allowedusersrule_aggregate';
  aggregate?: Maybe<Coupons_Allowedusersrule_Aggregate_Fields>;
  nodes: Array<Coupons_Allowedusersrule>;
};

/** aggregate fields of "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_Aggregate_Fields = {
  __typename?: 'coupons_allowedusersrule_aggregate_fields';
  avg?: Maybe<Coupons_Allowedusersrule_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Allowedusersrule_Max_Fields>;
  min?: Maybe<Coupons_Allowedusersrule_Min_Fields>;
  stddev?: Maybe<Coupons_Allowedusersrule_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Allowedusersrule_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Allowedusersrule_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Allowedusersrule_Sum_Fields>;
  var_pop?: Maybe<Coupons_Allowedusersrule_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Allowedusersrule_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Allowedusersrule_Variance_Fields>;
};


/** aggregate fields of "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Allowedusersrule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Coupons_Allowedusersrule_Avg_Fields = {
  __typename?: 'coupons_allowedusersrule_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "coupons_allowedusersrule". All fields are combined with a logical 'AND'. */
export type Coupons_Allowedusersrule_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Allowedusersrule_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Allowedusersrule_Bool_Exp>>;
  all_users?: InputMaybe<Boolean_Comparison_Exp>;
  coupons_allowed_users_rule_users?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
  coupons_allowed_users_rule_users_aggregate?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Aggregate_Bool_Exp>;
  coupons_allowedusersrule_users?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
  coupons_allowedusersrule_users_aggregate?: InputMaybe<Coupons_Allowedusersrule_Users_Aggregate_Bool_Exp>;
  coupons_rulesets?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
  coupons_rulesets_aggregate?: InputMaybe<Coupons_Ruleset_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "coupons_allowedusersrule" */
export enum Coupons_Allowedusersrule_Constraint {
  /** unique or primary key constraint on columns "id" */
  CouponsAllowedusersrulePkey = 'coupons_allowedusersrule_pkey'
}

/** input type for incrementing numeric columns in table "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_Insert_Input = {
  all_users?: InputMaybe<Scalars['Boolean']['input']>;
  coupons_allowed_users_rule_users?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Arr_Rel_Insert_Input>;
  coupons_allowedusersrule_users?: InputMaybe<Coupons_Allowedusersrule_Users_Arr_Rel_Insert_Input>;
  coupons_rulesets?: InputMaybe<Coupons_Ruleset_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Coupons_Allowedusersrule_Max_Fields = {
  __typename?: 'coupons_allowedusersrule_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Coupons_Allowedusersrule_Min_Fields = {
  __typename?: 'coupons_allowedusersrule_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_Mutation_Response = {
  __typename?: 'coupons_allowedusersrule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Allowedusersrule>;
};

/** input type for inserting object relation for remote table "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_Obj_Rel_Insert_Input = {
  data: Coupons_Allowedusersrule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Allowedusersrule_On_Conflict>;
};

/** on_conflict condition type for table "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_On_Conflict = {
  constraint: Coupons_Allowedusersrule_Constraint;
  update_columns?: Array<Coupons_Allowedusersrule_Update_Column>;
  where?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_allowedusersrule". */
export type Coupons_Allowedusersrule_Order_By = {
  all_users?: InputMaybe<Order_By>;
  coupons_allowed_users_rule_users_aggregate?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Aggregate_Order_By>;
  coupons_allowedusersrule_users_aggregate?: InputMaybe<Coupons_Allowedusersrule_Users_Aggregate_Order_By>;
  coupons_rulesets_aggregate?: InputMaybe<Coupons_Ruleset_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: coupons_allowedusersrule */
export type Coupons_Allowedusersrule_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_allowedusersrule" */
export enum Coupons_Allowedusersrule_Select_Column {
  /** column name */
  AllUsers = 'all_users',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_Set_Input = {
  all_users?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Allowedusersrule_Stddev_Fields = {
  __typename?: 'coupons_allowedusersrule_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Allowedusersrule_Stddev_Pop_Fields = {
  __typename?: 'coupons_allowedusersrule_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Allowedusersrule_Stddev_Samp_Fields = {
  __typename?: 'coupons_allowedusersrule_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "coupons_allowedusersrule" */
export type Coupons_Allowedusersrule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Allowedusersrule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Allowedusersrule_Stream_Cursor_Value_Input = {
  all_users?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Allowedusersrule_Sum_Fields = {
  __typename?: 'coupons_allowedusersrule_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "coupons_allowedusersrule" */
export enum Coupons_Allowedusersrule_Update_Column {
  /** column name */
  AllUsers = 'all_users',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coupons_Allowedusersrule_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Allowedusersrule_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Allowedusersrule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Allowedusersrule_Bool_Exp;
};

/** columns and relationships of "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users = {
  __typename?: 'coupons_allowedusersrule_users';
  allowedusersrule_id: Scalars['Int']['output'];
  /** An object relationship */
  coupons_allowedusersrule: Coupons_Allowedusersrule;
  id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Aggregate = {
  __typename?: 'coupons_allowedusersrule_users_aggregate';
  aggregate?: Maybe<Coupons_Allowedusersrule_Users_Aggregate_Fields>;
  nodes: Array<Coupons_Allowedusersrule_Users>;
};

export type Coupons_Allowedusersrule_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coupons_Allowedusersrule_Users_Aggregate_Bool_Exp_Count>;
};

export type Coupons_Allowedusersrule_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Aggregate_Fields = {
  __typename?: 'coupons_allowedusersrule_users_aggregate_fields';
  avg?: Maybe<Coupons_Allowedusersrule_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Allowedusersrule_Users_Max_Fields>;
  min?: Maybe<Coupons_Allowedusersrule_Users_Min_Fields>;
  stddev?: Maybe<Coupons_Allowedusersrule_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Allowedusersrule_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Allowedusersrule_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Allowedusersrule_Users_Sum_Fields>;
  var_pop?: Maybe<Coupons_Allowedusersrule_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Allowedusersrule_Users_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Allowedusersrule_Users_Variance_Fields>;
};


/** aggregate fields of "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Coupons_Allowedusersrule_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Coupons_Allowedusersrule_Users_Max_Order_By>;
  min?: InputMaybe<Coupons_Allowedusersrule_Users_Min_Order_By>;
  stddev?: InputMaybe<Coupons_Allowedusersrule_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Coupons_Allowedusersrule_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Coupons_Allowedusersrule_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Coupons_Allowedusersrule_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Coupons_Allowedusersrule_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Coupons_Allowedusersrule_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Coupons_Allowedusersrule_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Arr_Rel_Insert_Input = {
  data: Array<Coupons_Allowedusersrule_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Allowedusersrule_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Coupons_Allowedusersrule_Users_Avg_Fields = {
  __typename?: 'coupons_allowedusersrule_users_avg_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Avg_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "coupons_allowedusersrule_users". All fields are combined with a logical 'AND'. */
export type Coupons_Allowedusersrule_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Bool_Exp>>;
  allowedusersrule_id?: InputMaybe<Int_Comparison_Exp>;
  coupons_allowedusersrule?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "coupons_allowedusersrule_users" */
export enum Coupons_Allowedusersrule_Users_Constraint {
  /** unique or primary key constraint on columns "user_id", "allowedusersrule_id" */
  CouponsAllowedusersruleAllowedusersruleIdUser_7c75b674Uniq = 'coupons_allowedusersrule_allowedusersrule_id_user_7c75b674_uniq',
  /** unique or primary key constraint on columns "id" */
  CouponsAllowedusersruleUsersPkey = 'coupons_allowedusersrule_users_pkey'
}

/** input type for incrementing numeric columns in table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Inc_Input = {
  allowedusersrule_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Insert_Input = {
  allowedusersrule_id?: InputMaybe<Scalars['Int']['input']>;
  coupons_allowedusersrule?: InputMaybe<Coupons_Allowedusersrule_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Coupons_Allowedusersrule_Users_Max_Fields = {
  __typename?: 'coupons_allowedusersrule_users_max_fields';
  allowedusersrule_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Max_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Coupons_Allowedusersrule_Users_Min_Fields = {
  __typename?: 'coupons_allowedusersrule_users_min_fields';
  allowedusersrule_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Min_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Mutation_Response = {
  __typename?: 'coupons_allowedusersrule_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Allowedusersrule_Users>;
};

/** on_conflict condition type for table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_On_Conflict = {
  constraint: Coupons_Allowedusersrule_Users_Constraint;
  update_columns?: Array<Coupons_Allowedusersrule_Users_Update_Column>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_allowedusersrule_users". */
export type Coupons_Allowedusersrule_Users_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  coupons_allowedusersrule?: InputMaybe<Coupons_Allowedusersrule_Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: coupons_allowedusersrule_users */
export type Coupons_Allowedusersrule_Users_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_allowedusersrule_users" */
export enum Coupons_Allowedusersrule_Users_Select_Column {
  /** column name */
  AllowedusersruleId = 'allowedusersrule_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Set_Input = {
  allowedusersrule_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Allowedusersrule_Users_Stddev_Fields = {
  __typename?: 'coupons_allowedusersrule_users_stddev_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Stddev_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Allowedusersrule_Users_Stddev_Pop_Fields = {
  __typename?: 'coupons_allowedusersrule_users_stddev_pop_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Stddev_Pop_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Allowedusersrule_Users_Stddev_Samp_Fields = {
  __typename?: 'coupons_allowedusersrule_users_stddev_samp_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Stddev_Samp_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Allowedusersrule_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Allowedusersrule_Users_Stream_Cursor_Value_Input = {
  allowedusersrule_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Allowedusersrule_Users_Sum_Fields = {
  __typename?: 'coupons_allowedusersrule_users_sum_fields';
  allowedusersrule_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Sum_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "coupons_allowedusersrule_users" */
export enum Coupons_Allowedusersrule_Users_Update_Column {
  /** column name */
  AllowedusersruleId = 'allowedusersrule_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Coupons_Allowedusersrule_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Allowedusersrule_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Allowedusersrule_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Allowedusersrule_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coupons_Allowedusersrule_Users_Var_Pop_Fields = {
  __typename?: 'coupons_allowedusersrule_users_var_pop_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Var_Pop_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Coupons_Allowedusersrule_Users_Var_Samp_Fields = {
  __typename?: 'coupons_allowedusersrule_users_var_samp_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Var_Samp_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Coupons_Allowedusersrule_Users_Variance_Fields = {
  __typename?: 'coupons_allowedusersrule_users_variance_fields';
  allowedusersrule_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "coupons_allowedusersrule_users" */
export type Coupons_Allowedusersrule_Users_Variance_Order_By = {
  allowedusersrule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Coupons_Allowedusersrule_Var_Pop_Fields = {
  __typename?: 'coupons_allowedusersrule_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Coupons_Allowedusersrule_Var_Samp_Fields = {
  __typename?: 'coupons_allowedusersrule_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Coupons_Allowedusersrule_Variance_Fields = {
  __typename?: 'coupons_allowedusersrule_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "coupons_coupon" */
export type Coupons_Coupon = {
  __typename?: 'coupons_coupon';
  code: Scalars['String']['output'];
  coupon_for_upgrade: Scalars['Boolean']['output'];
  /** An array relationship */
  coupons_coupon_applicable_packages: Array<Coupons_Coupon_Applicable_Packages>;
  /** An aggregate relationship */
  coupons_coupon_applicable_packages_aggregate: Coupons_Coupon_Applicable_Packages_Aggregate;
  /** An array relationship */
  coupons_couponusers: Array<Coupons_Couponuser>;
  /** An aggregate relationship */
  coupons_couponusers_aggregate: Coupons_Couponuser_Aggregate;
  /** An object relationship */
  coupons_discount: Coupons_Discount;
  /** An object relationship */
  coupons_ruleset: Coupons_Ruleset;
  created: Scalars['timestamptz']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  discount_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  is_invisible: Scalars['Boolean']['output'];
  /** An array relationship */
  packages_payment_transactions: Array<Packages_Payment_Transaction>;
  /** An aggregate relationship */
  packages_payment_transactions_aggregate: Packages_Payment_Transaction_Aggregate;
  /** An array relationship */
  packages_paymenttransactions: Array<Packages_Paymenttransaction>;
  /** An aggregate relationship */
  packages_paymenttransactions_aggregate: Packages_Paymenttransaction_Aggregate;
  ruleset_id: Scalars['Int']['output'];
  times_used: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "coupons_coupon" */
export type Coupons_CouponCoupons_Coupon_Applicable_PackagesArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};


/** columns and relationships of "coupons_coupon" */
export type Coupons_CouponCoupons_Coupon_Applicable_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};


/** columns and relationships of "coupons_coupon" */
export type Coupons_CouponCoupons_CouponusersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


/** columns and relationships of "coupons_coupon" */
export type Coupons_CouponCoupons_Couponusers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


/** columns and relationships of "coupons_coupon" */
export type Coupons_CouponPackages_Payment_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


/** columns and relationships of "coupons_coupon" */
export type Coupons_CouponPackages_Payment_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


/** columns and relationships of "coupons_coupon" */
export type Coupons_CouponPackages_PaymenttransactionsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


/** columns and relationships of "coupons_coupon" */
export type Coupons_CouponPackages_Paymenttransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};

/** aggregated selection of "coupons_coupon" */
export type Coupons_Coupon_Aggregate = {
  __typename?: 'coupons_coupon_aggregate';
  aggregate?: Maybe<Coupons_Coupon_Aggregate_Fields>;
  nodes: Array<Coupons_Coupon>;
};

export type Coupons_Coupon_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Coupons_Coupon_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Coupons_Coupon_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Coupons_Coupon_Aggregate_Bool_Exp_Count>;
};

export type Coupons_Coupon_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coupons_Coupon_Select_Column_Coupons_Coupon_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Coupons_Coupon_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coupons_Coupon_Select_Column_Coupons_Coupon_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Coupons_Coupon_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "coupons_coupon" */
export type Coupons_Coupon_Aggregate_Fields = {
  __typename?: 'coupons_coupon_aggregate_fields';
  avg?: Maybe<Coupons_Coupon_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Coupon_Max_Fields>;
  min?: Maybe<Coupons_Coupon_Min_Fields>;
  stddev?: Maybe<Coupons_Coupon_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Coupon_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Coupon_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Coupon_Sum_Fields>;
  var_pop?: Maybe<Coupons_Coupon_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Coupon_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Coupon_Variance_Fields>;
};


/** aggregate fields of "coupons_coupon" */
export type Coupons_Coupon_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "coupons_coupon" */
export type Coupons_Coupon_Aggregate_Order_By = {
  avg?: InputMaybe<Coupons_Coupon_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Coupons_Coupon_Max_Order_By>;
  min?: InputMaybe<Coupons_Coupon_Min_Order_By>;
  stddev?: InputMaybe<Coupons_Coupon_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Coupons_Coupon_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Coupons_Coupon_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Coupons_Coupon_Sum_Order_By>;
  var_pop?: InputMaybe<Coupons_Coupon_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Coupons_Coupon_Var_Samp_Order_By>;
  variance?: InputMaybe<Coupons_Coupon_Variance_Order_By>;
};

/** columns and relationships of "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages = {
  __typename?: 'coupons_coupon_applicable_packages';
  coupon_id: Scalars['Int']['output'];
  /** An object relationship */
  coupons_coupon: Coupons_Coupon;
  id: Scalars['Int']['output'];
  subscriptionplan_id: Scalars['uuid']['output'];
  /** An object relationship */
  subscriptions_subscriptionplan: Subscriptions_Subscriptionplan;
};

/** aggregated selection of "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Aggregate = {
  __typename?: 'coupons_coupon_applicable_packages_aggregate';
  aggregate?: Maybe<Coupons_Coupon_Applicable_Packages_Aggregate_Fields>;
  nodes: Array<Coupons_Coupon_Applicable_Packages>;
};

export type Coupons_Coupon_Applicable_Packages_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coupons_Coupon_Applicable_Packages_Aggregate_Bool_Exp_Count>;
};

export type Coupons_Coupon_Applicable_Packages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Aggregate_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_aggregate_fields';
  avg?: Maybe<Coupons_Coupon_Applicable_Packages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Coupon_Applicable_Packages_Max_Fields>;
  min?: Maybe<Coupons_Coupon_Applicable_Packages_Min_Fields>;
  stddev?: Maybe<Coupons_Coupon_Applicable_Packages_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Coupon_Applicable_Packages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Coupon_Applicable_Packages_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Coupon_Applicable_Packages_Sum_Fields>;
  var_pop?: Maybe<Coupons_Coupon_Applicable_Packages_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Coupon_Applicable_Packages_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Coupon_Applicable_Packages_Variance_Fields>;
};


/** aggregate fields of "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Aggregate_Order_By = {
  avg?: InputMaybe<Coupons_Coupon_Applicable_Packages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Coupons_Coupon_Applicable_Packages_Max_Order_By>;
  min?: InputMaybe<Coupons_Coupon_Applicable_Packages_Min_Order_By>;
  stddev?: InputMaybe<Coupons_Coupon_Applicable_Packages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Coupons_Coupon_Applicable_Packages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Coupons_Coupon_Applicable_Packages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Coupons_Coupon_Applicable_Packages_Sum_Order_By>;
  var_pop?: InputMaybe<Coupons_Coupon_Applicable_Packages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Coupons_Coupon_Applicable_Packages_Var_Samp_Order_By>;
  variance?: InputMaybe<Coupons_Coupon_Applicable_Packages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Arr_Rel_Insert_Input = {
  data: Array<Coupons_Coupon_Applicable_Packages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Coupon_Applicable_Packages_On_Conflict>;
};

/** aggregate avg on columns */
export type Coupons_Coupon_Applicable_Packages_Avg_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_avg_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Avg_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "coupons_coupon_applicable_packages". All fields are combined with a logical 'AND'. */
export type Coupons_Coupon_Applicable_Packages_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Bool_Exp>>;
  coupon_id?: InputMaybe<Int_Comparison_Exp>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  subscriptionplan_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
};

/** unique or primary key constraints on table "coupons_coupon_applicable_packages" */
export enum Coupons_Coupon_Applicable_Packages_Constraint {
  /** unique or primary key constraint on columns "subscriptionplan_id", "coupon_id" */
  CouponsCouponApplicablCouponIdSubscriptionplDf7c67feUniq = 'coupons_coupon_applicabl_coupon_id_subscriptionpl_df7c67fe_uniq',
  /** unique or primary key constraint on columns "id" */
  CouponsCouponApplicablePackagesPkey = 'coupons_coupon_applicable_packages_pkey'
}

/** input type for incrementing numeric columns in table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Inc_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Insert_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscriptionplan_id?: InputMaybe<Scalars['uuid']['input']>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Coupons_Coupon_Applicable_Packages_Max_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_max_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  subscriptionplan_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Max_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscriptionplan_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Coupons_Coupon_Applicable_Packages_Min_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_min_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  subscriptionplan_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Min_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscriptionplan_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Mutation_Response = {
  __typename?: 'coupons_coupon_applicable_packages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Coupon_Applicable_Packages>;
};

/** on_conflict condition type for table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_On_Conflict = {
  constraint: Coupons_Coupon_Applicable_Packages_Constraint;
  update_columns?: Array<Coupons_Coupon_Applicable_Packages_Update_Column>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_coupon_applicable_packages". */
export type Coupons_Coupon_Applicable_Packages_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Order_By>;
  id?: InputMaybe<Order_By>;
  subscriptionplan_id?: InputMaybe<Order_By>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
};

/** primary key columns input for table: coupons_coupon_applicable_packages */
export type Coupons_Coupon_Applicable_Packages_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_coupon_applicable_packages" */
export enum Coupons_Coupon_Applicable_Packages_Select_Column {
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionplanId = 'subscriptionplan_id'
}

/** input type for updating data in table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Set_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscriptionplan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Coupon_Applicable_Packages_Stddev_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_stddev_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Stddev_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Coupon_Applicable_Packages_Stddev_Pop_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_stddev_pop_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Stddev_Pop_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Coupon_Applicable_Packages_Stddev_Samp_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_stddev_samp_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Stddev_Samp_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Coupon_Applicable_Packages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Coupon_Applicable_Packages_Stream_Cursor_Value_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscriptionplan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Coupon_Applicable_Packages_Sum_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_sum_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Sum_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "coupons_coupon_applicable_packages" */
export enum Coupons_Coupon_Applicable_Packages_Update_Column {
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionplanId = 'subscriptionplan_id'
}

export type Coupons_Coupon_Applicable_Packages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Coupon_Applicable_Packages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Coupon_Applicable_Packages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Coupon_Applicable_Packages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coupons_Coupon_Applicable_Packages_Var_Pop_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_var_pop_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Var_Pop_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Coupons_Coupon_Applicable_Packages_Var_Samp_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_var_samp_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Var_Samp_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Coupons_Coupon_Applicable_Packages_Variance_Fields = {
  __typename?: 'coupons_coupon_applicable_packages_variance_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "coupons_coupon_applicable_packages" */
export type Coupons_Coupon_Applicable_Packages_Variance_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for inserting array relation for remote table "coupons_coupon" */
export type Coupons_Coupon_Arr_Rel_Insert_Input = {
  data: Array<Coupons_Coupon_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Coupon_On_Conflict>;
};

/** aggregate avg on columns */
export type Coupons_Coupon_Avg_Fields = {
  __typename?: 'coupons_coupon_avg_fields';
  discount_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ruleset_id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Avg_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "coupons_coupon". All fields are combined with a logical 'AND'. */
export type Coupons_Coupon_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Coupon_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Coupon_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  coupon_for_upgrade?: InputMaybe<Boolean_Comparison_Exp>;
  coupons_coupon_applicable_packages?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
  coupons_coupon_applicable_packages_aggregate?: InputMaybe<Coupons_Coupon_Applicable_Packages_Aggregate_Bool_Exp>;
  coupons_couponusers?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
  coupons_couponusers_aggregate?: InputMaybe<Coupons_Couponuser_Aggregate_Bool_Exp>;
  coupons_discount?: InputMaybe<Coupons_Discount_Bool_Exp>;
  coupons_ruleset?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discount_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_invisible?: InputMaybe<Boolean_Comparison_Exp>;
  packages_payment_transactions?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
  packages_payment_transactions_aggregate?: InputMaybe<Packages_Payment_Transaction_Aggregate_Bool_Exp>;
  packages_paymenttransactions?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
  packages_paymenttransactions_aggregate?: InputMaybe<Packages_Paymenttransaction_Aggregate_Bool_Exp>;
  ruleset_id?: InputMaybe<Int_Comparison_Exp>;
  times_used?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "coupons_coupon" */
export enum Coupons_Coupon_Constraint {
  /** unique or primary key constraint on columns "code" */
  CouponsCouponCodeKey = 'coupons_coupon_code_key',
  /** unique or primary key constraint on columns "id" */
  CouponsCouponPkey = 'coupons_coupon_pkey'
}

/** input type for incrementing numeric columns in table "coupons_coupon" */
export type Coupons_Coupon_Inc_Input = {
  discount_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ruleset_id?: InputMaybe<Scalars['Int']['input']>;
  times_used?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_coupon" */
export type Coupons_Coupon_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  coupon_for_upgrade?: InputMaybe<Scalars['Boolean']['input']>;
  coupons_coupon_applicable_packages?: InputMaybe<Coupons_Coupon_Applicable_Packages_Arr_Rel_Insert_Input>;
  coupons_couponusers?: InputMaybe<Coupons_Couponuser_Arr_Rel_Insert_Input>;
  coupons_discount?: InputMaybe<Coupons_Discount_Obj_Rel_Insert_Input>;
  coupons_ruleset?: InputMaybe<Coupons_Ruleset_Obj_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  discount_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  packages_payment_transactions?: InputMaybe<Packages_Payment_Transaction_Arr_Rel_Insert_Input>;
  packages_paymenttransactions?: InputMaybe<Packages_Paymenttransaction_Arr_Rel_Insert_Input>;
  ruleset_id?: InputMaybe<Scalars['Int']['input']>;
  times_used?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Coupons_Coupon_Max_Fields = {
  __typename?: 'coupons_coupon_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  discount_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ruleset_id?: Maybe<Scalars['Int']['output']>;
  times_used?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Coupons_Coupon_Min_Fields = {
  __typename?: 'coupons_coupon_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  discount_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ruleset_id?: Maybe<Scalars['Int']['output']>;
  times_used?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "coupons_coupon" */
export type Coupons_Coupon_Mutation_Response = {
  __typename?: 'coupons_coupon_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Coupon>;
};

/** input type for inserting object relation for remote table "coupons_coupon" */
export type Coupons_Coupon_Obj_Rel_Insert_Input = {
  data: Coupons_Coupon_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Coupon_On_Conflict>;
};

/** on_conflict condition type for table "coupons_coupon" */
export type Coupons_Coupon_On_Conflict = {
  constraint: Coupons_Coupon_Constraint;
  update_columns?: Array<Coupons_Coupon_Update_Column>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_coupon". */
export type Coupons_Coupon_Order_By = {
  code?: InputMaybe<Order_By>;
  coupon_for_upgrade?: InputMaybe<Order_By>;
  coupons_coupon_applicable_packages_aggregate?: InputMaybe<Coupons_Coupon_Applicable_Packages_Aggregate_Order_By>;
  coupons_couponusers_aggregate?: InputMaybe<Coupons_Couponuser_Aggregate_Order_By>;
  coupons_discount?: InputMaybe<Coupons_Discount_Order_By>;
  coupons_ruleset?: InputMaybe<Coupons_Ruleset_Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_invisible?: InputMaybe<Order_By>;
  packages_payment_transactions_aggregate?: InputMaybe<Packages_Payment_Transaction_Aggregate_Order_By>;
  packages_paymenttransactions_aggregate?: InputMaybe<Packages_Paymenttransaction_Aggregate_Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: coupons_coupon */
export type Coupons_Coupon_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_coupon" */
export enum Coupons_Coupon_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CouponForUpgrade = 'coupon_for_upgrade',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountId = 'discount_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  RulesetId = 'ruleset_id',
  /** column name */
  TimesUsed = 'times_used',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "coupons_coupon_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coupons_coupon" */
export enum Coupons_Coupon_Select_Column_Coupons_Coupon_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CouponForUpgrade = 'coupon_for_upgrade',
  /** column name */
  IsInvisible = 'is_invisible'
}

/** select "coupons_coupon_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coupons_coupon" */
export enum Coupons_Coupon_Select_Column_Coupons_Coupon_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CouponForUpgrade = 'coupon_for_upgrade',
  /** column name */
  IsInvisible = 'is_invisible'
}

/** input type for updating data in table "coupons_coupon" */
export type Coupons_Coupon_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  coupon_for_upgrade?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  discount_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  ruleset_id?: InputMaybe<Scalars['Int']['input']>;
  times_used?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Coupon_Stddev_Fields = {
  __typename?: 'coupons_coupon_stddev_fields';
  discount_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ruleset_id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Stddev_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Coupon_Stddev_Pop_Fields = {
  __typename?: 'coupons_coupon_stddev_pop_fields';
  discount_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ruleset_id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Stddev_Pop_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Coupon_Stddev_Samp_Fields = {
  __typename?: 'coupons_coupon_stddev_samp_fields';
  discount_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ruleset_id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Stddev_Samp_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "coupons_coupon" */
export type Coupons_Coupon_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Coupon_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Coupon_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  coupon_for_upgrade?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  discount_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  ruleset_id?: InputMaybe<Scalars['Int']['input']>;
  times_used?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Coupon_Sum_Fields = {
  __typename?: 'coupons_coupon_sum_fields';
  discount_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ruleset_id?: Maybe<Scalars['Int']['output']>;
  times_used?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Sum_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
};

/** update columns of table "coupons_coupon" */
export enum Coupons_Coupon_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CouponForUpgrade = 'coupon_for_upgrade',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountId = 'discount_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  RulesetId = 'ruleset_id',
  /** column name */
  TimesUsed = 'times_used',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coupons_Coupon_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Coupon_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Coupon_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Coupon_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coupons_Coupon_Var_Pop_Fields = {
  __typename?: 'coupons_coupon_var_pop_fields';
  discount_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ruleset_id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Var_Pop_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Coupons_Coupon_Var_Samp_Fields = {
  __typename?: 'coupons_coupon_var_samp_fields';
  discount_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ruleset_id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Var_Samp_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Coupons_Coupon_Variance_Fields = {
  __typename?: 'coupons_coupon_variance_fields';
  discount_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ruleset_id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "coupons_coupon" */
export type Coupons_Coupon_Variance_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
};

/** columns and relationships of "coupons_couponuser" */
export type Coupons_Couponuser = {
  __typename?: 'coupons_couponuser';
  coupon_id: Scalars['Int']['output'];
  /** An object relationship */
  coupons_coupon: Coupons_Coupon;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_paid: Scalars['Boolean']['output'];
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  subscriptions_subscriptionplan?: Maybe<Subscriptions_Subscriptionplan>;
  times_used: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "coupons_couponuser" */
export type Coupons_Couponuser_Aggregate = {
  __typename?: 'coupons_couponuser_aggregate';
  aggregate?: Maybe<Coupons_Couponuser_Aggregate_Fields>;
  nodes: Array<Coupons_Couponuser>;
};

export type Coupons_Couponuser_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Coupons_Couponuser_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Coupons_Couponuser_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Coupons_Couponuser_Aggregate_Bool_Exp_Count>;
};

export type Coupons_Couponuser_Aggregate_Bool_Exp_Bool_And = {
  arguments: Coupons_Couponuser_Select_Column_Coupons_Couponuser_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Coupons_Couponuser_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Coupons_Couponuser_Select_Column_Coupons_Couponuser_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Coupons_Couponuser_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "coupons_couponuser" */
export type Coupons_Couponuser_Aggregate_Fields = {
  __typename?: 'coupons_couponuser_aggregate_fields';
  avg?: Maybe<Coupons_Couponuser_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Couponuser_Max_Fields>;
  min?: Maybe<Coupons_Couponuser_Min_Fields>;
  stddev?: Maybe<Coupons_Couponuser_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Couponuser_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Couponuser_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Couponuser_Sum_Fields>;
  var_pop?: Maybe<Coupons_Couponuser_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Couponuser_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Couponuser_Variance_Fields>;
};


/** aggregate fields of "coupons_couponuser" */
export type Coupons_Couponuser_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "coupons_couponuser" */
export type Coupons_Couponuser_Aggregate_Order_By = {
  avg?: InputMaybe<Coupons_Couponuser_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Coupons_Couponuser_Max_Order_By>;
  min?: InputMaybe<Coupons_Couponuser_Min_Order_By>;
  stddev?: InputMaybe<Coupons_Couponuser_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Coupons_Couponuser_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Coupons_Couponuser_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Coupons_Couponuser_Sum_Order_By>;
  var_pop?: InputMaybe<Coupons_Couponuser_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Coupons_Couponuser_Var_Samp_Order_By>;
  variance?: InputMaybe<Coupons_Couponuser_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coupons_couponuser" */
export type Coupons_Couponuser_Arr_Rel_Insert_Input = {
  data: Array<Coupons_Couponuser_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Couponuser_On_Conflict>;
};

/** aggregate avg on columns */
export type Coupons_Couponuser_Avg_Fields = {
  __typename?: 'coupons_couponuser_avg_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Avg_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "coupons_couponuser". All fields are combined with a logical 'AND'. */
export type Coupons_Couponuser_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Couponuser_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Couponuser_Bool_Exp>>;
  coupon_id?: InputMaybe<Int_Comparison_Exp>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_paid?: InputMaybe<Boolean_Comparison_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  times_used?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "coupons_couponuser" */
export enum Coupons_Couponuser_Constraint {
  /** unique or primary key constraint on columns "id" */
  CouponsCouponuserPkey = 'coupons_couponuser_pkey'
}

/** input type for incrementing numeric columns in table "coupons_couponuser" */
export type Coupons_Couponuser_Inc_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  times_used?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_couponuser" */
export type Coupons_Couponuser_Insert_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  times_used?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Coupons_Couponuser_Max_Fields = {
  __typename?: 'coupons_couponuser_max_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  times_used?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Max_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Coupons_Couponuser_Min_Fields = {
  __typename?: 'coupons_couponuser_min_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  times_used?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Min_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "coupons_couponuser" */
export type Coupons_Couponuser_Mutation_Response = {
  __typename?: 'coupons_couponuser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Couponuser>;
};

/** on_conflict condition type for table "coupons_couponuser" */
export type Coupons_Couponuser_On_Conflict = {
  constraint: Coupons_Couponuser_Constraint;
  update_columns?: Array<Coupons_Couponuser_Update_Column>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_couponuser". */
export type Coupons_Couponuser_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_paid?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  times_used?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: coupons_couponuser */
export type Coupons_Couponuser_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_couponuser" */
export enum Coupons_Couponuser_Select_Column {
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TimesUsed = 'times_used',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "coupons_couponuser_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coupons_couponuser" */
export enum Coupons_Couponuser_Select_Column_Coupons_Couponuser_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPaid = 'is_paid'
}

/** select "coupons_couponuser_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coupons_couponuser" */
export enum Coupons_Couponuser_Select_Column_Coupons_Couponuser_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPaid = 'is_paid'
}

/** input type for updating data in table "coupons_couponuser" */
export type Coupons_Couponuser_Set_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  times_used?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Couponuser_Stddev_Fields = {
  __typename?: 'coupons_couponuser_stddev_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Stddev_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Couponuser_Stddev_Pop_Fields = {
  __typename?: 'coupons_couponuser_stddev_pop_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Stddev_Pop_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Couponuser_Stddev_Samp_Fields = {
  __typename?: 'coupons_couponuser_stddev_samp_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Stddev_Samp_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "coupons_couponuser" */
export type Coupons_Couponuser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Couponuser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Couponuser_Stream_Cursor_Value_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  times_used?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Couponuser_Sum_Fields = {
  __typename?: 'coupons_couponuser_sum_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  times_used?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Sum_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "coupons_couponuser" */
export enum Coupons_Couponuser_Update_Column {
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TimesUsed = 'times_used',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Coupons_Couponuser_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Couponuser_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Couponuser_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Couponuser_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coupons_Couponuser_Var_Pop_Fields = {
  __typename?: 'coupons_couponuser_var_pop_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Var_Pop_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Coupons_Couponuser_Var_Samp_Fields = {
  __typename?: 'coupons_couponuser_var_samp_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Var_Samp_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Coupons_Couponuser_Variance_Fields = {
  __typename?: 'coupons_couponuser_variance_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  times_used?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "coupons_couponuser" */
export type Coupons_Couponuser_Variance_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  times_used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "coupons_discount" */
export type Coupons_Discount = {
  __typename?: 'coupons_discount';
  /** An array relationship */
  coupons_coupons: Array<Coupons_Coupon>;
  /** An aggregate relationship */
  coupons_coupons_aggregate: Coupons_Coupon_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  is_percentage: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value: Scalars['Int']['output'];
};


/** columns and relationships of "coupons_discount" */
export type Coupons_DiscountCoupons_CouponsArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};


/** columns and relationships of "coupons_discount" */
export type Coupons_DiscountCoupons_Coupons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};

/** aggregated selection of "coupons_discount" */
export type Coupons_Discount_Aggregate = {
  __typename?: 'coupons_discount_aggregate';
  aggregate?: Maybe<Coupons_Discount_Aggregate_Fields>;
  nodes: Array<Coupons_Discount>;
};

/** aggregate fields of "coupons_discount" */
export type Coupons_Discount_Aggregate_Fields = {
  __typename?: 'coupons_discount_aggregate_fields';
  avg?: Maybe<Coupons_Discount_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Discount_Max_Fields>;
  min?: Maybe<Coupons_Discount_Min_Fields>;
  stddev?: Maybe<Coupons_Discount_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Discount_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Discount_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Discount_Sum_Fields>;
  var_pop?: Maybe<Coupons_Discount_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Discount_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Discount_Variance_Fields>;
};


/** aggregate fields of "coupons_discount" */
export type Coupons_Discount_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Discount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Coupons_Discount_Avg_Fields = {
  __typename?: 'coupons_discount_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "coupons_discount". All fields are combined with a logical 'AND'. */
export type Coupons_Discount_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Discount_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Discount_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Discount_Bool_Exp>>;
  coupons_coupons?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  coupons_coupons_aggregate?: InputMaybe<Coupons_Coupon_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_percentage?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "coupons_discount" */
export enum Coupons_Discount_Constraint {
  /** unique or primary key constraint on columns "id" */
  CouponsDiscountPkey = 'coupons_discount_pkey'
}

/** input type for incrementing numeric columns in table "coupons_discount" */
export type Coupons_Discount_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_discount" */
export type Coupons_Discount_Insert_Input = {
  coupons_coupons?: InputMaybe<Coupons_Coupon_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_percentage?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Coupons_Discount_Max_Fields = {
  __typename?: 'coupons_discount_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Coupons_Discount_Min_Fields = {
  __typename?: 'coupons_discount_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "coupons_discount" */
export type Coupons_Discount_Mutation_Response = {
  __typename?: 'coupons_discount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Discount>;
};

/** input type for inserting object relation for remote table "coupons_discount" */
export type Coupons_Discount_Obj_Rel_Insert_Input = {
  data: Coupons_Discount_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Discount_On_Conflict>;
};

/** on_conflict condition type for table "coupons_discount" */
export type Coupons_Discount_On_Conflict = {
  constraint: Coupons_Discount_Constraint;
  update_columns?: Array<Coupons_Discount_Update_Column>;
  where?: InputMaybe<Coupons_Discount_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_discount". */
export type Coupons_Discount_Order_By = {
  coupons_coupons_aggregate?: InputMaybe<Coupons_Coupon_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_percentage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: coupons_discount */
export type Coupons_Discount_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_discount" */
export enum Coupons_Discount_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPercentage = 'is_percentage',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "coupons_discount" */
export type Coupons_Discount_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_percentage?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Discount_Stddev_Fields = {
  __typename?: 'coupons_discount_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Discount_Stddev_Pop_Fields = {
  __typename?: 'coupons_discount_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Discount_Stddev_Samp_Fields = {
  __typename?: 'coupons_discount_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "coupons_discount" */
export type Coupons_Discount_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Discount_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Discount_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_percentage?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Discount_Sum_Fields = {
  __typename?: 'coupons_discount_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "coupons_discount" */
export enum Coupons_Discount_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPercentage = 'is_percentage',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Coupons_Discount_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Discount_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Discount_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Discount_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coupons_Discount_Var_Pop_Fields = {
  __typename?: 'coupons_discount_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Coupons_Discount_Var_Samp_Fields = {
  __typename?: 'coupons_discount_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Coupons_Discount_Variance_Fields = {
  __typename?: 'coupons_discount_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "coupons_maxusesrule" */
export type Coupons_Maxusesrule = {
  __typename?: 'coupons_maxusesrule';
  /** An array relationship */
  coupons_rulesets: Array<Coupons_Ruleset>;
  /** An aggregate relationship */
  coupons_rulesets_aggregate: Coupons_Ruleset_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  is_infinite: Scalars['Boolean']['output'];
  max_uses: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uses_per_user: Scalars['Int']['output'];
};


/** columns and relationships of "coupons_maxusesrule" */
export type Coupons_MaxusesruleCoupons_RulesetsArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};


/** columns and relationships of "coupons_maxusesrule" */
export type Coupons_MaxusesruleCoupons_Rulesets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};

/** aggregated selection of "coupons_maxusesrule" */
export type Coupons_Maxusesrule_Aggregate = {
  __typename?: 'coupons_maxusesrule_aggregate';
  aggregate?: Maybe<Coupons_Maxusesrule_Aggregate_Fields>;
  nodes: Array<Coupons_Maxusesrule>;
};

/** aggregate fields of "coupons_maxusesrule" */
export type Coupons_Maxusesrule_Aggregate_Fields = {
  __typename?: 'coupons_maxusesrule_aggregate_fields';
  avg?: Maybe<Coupons_Maxusesrule_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Maxusesrule_Max_Fields>;
  min?: Maybe<Coupons_Maxusesrule_Min_Fields>;
  stddev?: Maybe<Coupons_Maxusesrule_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Maxusesrule_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Maxusesrule_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Maxusesrule_Sum_Fields>;
  var_pop?: Maybe<Coupons_Maxusesrule_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Maxusesrule_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Maxusesrule_Variance_Fields>;
};


/** aggregate fields of "coupons_maxusesrule" */
export type Coupons_Maxusesrule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Maxusesrule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Coupons_Maxusesrule_Avg_Fields = {
  __typename?: 'coupons_maxusesrule_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_uses?: Maybe<Scalars['Float']['output']>;
  uses_per_user?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "coupons_maxusesrule". All fields are combined with a logical 'AND'. */
export type Coupons_Maxusesrule_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Maxusesrule_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Maxusesrule_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Maxusesrule_Bool_Exp>>;
  coupons_rulesets?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
  coupons_rulesets_aggregate?: InputMaybe<Coupons_Ruleset_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_infinite?: InputMaybe<Boolean_Comparison_Exp>;
  max_uses?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uses_per_user?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "coupons_maxusesrule" */
export enum Coupons_Maxusesrule_Constraint {
  /** unique or primary key constraint on columns "id" */
  CouponsMaxusesrulePkey = 'coupons_maxusesrule_pkey'
}

/** input type for incrementing numeric columns in table "coupons_maxusesrule" */
export type Coupons_Maxusesrule_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  max_uses?: InputMaybe<Scalars['bigint']['input']>;
  uses_per_user?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_maxusesrule" */
export type Coupons_Maxusesrule_Insert_Input = {
  coupons_rulesets?: InputMaybe<Coupons_Ruleset_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_infinite?: InputMaybe<Scalars['Boolean']['input']>;
  max_uses?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uses_per_user?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Coupons_Maxusesrule_Max_Fields = {
  __typename?: 'coupons_maxusesrule_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  max_uses?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uses_per_user?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Coupons_Maxusesrule_Min_Fields = {
  __typename?: 'coupons_maxusesrule_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  max_uses?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uses_per_user?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "coupons_maxusesrule" */
export type Coupons_Maxusesrule_Mutation_Response = {
  __typename?: 'coupons_maxusesrule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Maxusesrule>;
};

/** input type for inserting object relation for remote table "coupons_maxusesrule" */
export type Coupons_Maxusesrule_Obj_Rel_Insert_Input = {
  data: Coupons_Maxusesrule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Maxusesrule_On_Conflict>;
};

/** on_conflict condition type for table "coupons_maxusesrule" */
export type Coupons_Maxusesrule_On_Conflict = {
  constraint: Coupons_Maxusesrule_Constraint;
  update_columns?: Array<Coupons_Maxusesrule_Update_Column>;
  where?: InputMaybe<Coupons_Maxusesrule_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_maxusesrule". */
export type Coupons_Maxusesrule_Order_By = {
  coupons_rulesets_aggregate?: InputMaybe<Coupons_Ruleset_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_infinite?: InputMaybe<Order_By>;
  max_uses?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uses_per_user?: InputMaybe<Order_By>;
};

/** primary key columns input for table: coupons_maxusesrule */
export type Coupons_Maxusesrule_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_maxusesrule" */
export enum Coupons_Maxusesrule_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsInfinite = 'is_infinite',
  /** column name */
  MaxUses = 'max_uses',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsesPerUser = 'uses_per_user'
}

/** input type for updating data in table "coupons_maxusesrule" */
export type Coupons_Maxusesrule_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_infinite?: InputMaybe<Scalars['Boolean']['input']>;
  max_uses?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uses_per_user?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Maxusesrule_Stddev_Fields = {
  __typename?: 'coupons_maxusesrule_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_uses?: Maybe<Scalars['Float']['output']>;
  uses_per_user?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Maxusesrule_Stddev_Pop_Fields = {
  __typename?: 'coupons_maxusesrule_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_uses?: Maybe<Scalars['Float']['output']>;
  uses_per_user?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Maxusesrule_Stddev_Samp_Fields = {
  __typename?: 'coupons_maxusesrule_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_uses?: Maybe<Scalars['Float']['output']>;
  uses_per_user?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "coupons_maxusesrule" */
export type Coupons_Maxusesrule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Maxusesrule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Maxusesrule_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_infinite?: InputMaybe<Scalars['Boolean']['input']>;
  max_uses?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uses_per_user?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Maxusesrule_Sum_Fields = {
  __typename?: 'coupons_maxusesrule_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  max_uses?: Maybe<Scalars['bigint']['output']>;
  uses_per_user?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "coupons_maxusesrule" */
export enum Coupons_Maxusesrule_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsInfinite = 'is_infinite',
  /** column name */
  MaxUses = 'max_uses',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsesPerUser = 'uses_per_user'
}

export type Coupons_Maxusesrule_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Maxusesrule_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Maxusesrule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Maxusesrule_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coupons_Maxusesrule_Var_Pop_Fields = {
  __typename?: 'coupons_maxusesrule_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_uses?: Maybe<Scalars['Float']['output']>;
  uses_per_user?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Coupons_Maxusesrule_Var_Samp_Fields = {
  __typename?: 'coupons_maxusesrule_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_uses?: Maybe<Scalars['Float']['output']>;
  uses_per_user?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Coupons_Maxusesrule_Variance_Fields = {
  __typename?: 'coupons_maxusesrule_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_uses?: Maybe<Scalars['Float']['output']>;
  uses_per_user?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "coupons_ruleset" */
export type Coupons_Ruleset = {
  __typename?: 'coupons_ruleset';
  allowed_users_id: Scalars['Int']['output'];
  /** An object relationship */
  coupons_allowedusersrule: Coupons_Allowedusersrule;
  /** An array relationship */
  coupons_coupons: Array<Coupons_Coupon>;
  /** An aggregate relationship */
  coupons_coupons_aggregate: Coupons_Coupon_Aggregate;
  /** An object relationship */
  coupons_maxusesrule: Coupons_Maxusesrule;
  /** An object relationship */
  coupons_validityrule: Coupons_Validityrule;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  max_uses_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  validity_id: Scalars['Int']['output'];
};


/** columns and relationships of "coupons_ruleset" */
export type Coupons_RulesetCoupons_CouponsArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};


/** columns and relationships of "coupons_ruleset" */
export type Coupons_RulesetCoupons_Coupons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Bool_Exp>;
};

/** aggregated selection of "coupons_ruleset" */
export type Coupons_Ruleset_Aggregate = {
  __typename?: 'coupons_ruleset_aggregate';
  aggregate?: Maybe<Coupons_Ruleset_Aggregate_Fields>;
  nodes: Array<Coupons_Ruleset>;
};

export type Coupons_Ruleset_Aggregate_Bool_Exp = {
  count?: InputMaybe<Coupons_Ruleset_Aggregate_Bool_Exp_Count>;
};

export type Coupons_Ruleset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "coupons_ruleset" */
export type Coupons_Ruleset_Aggregate_Fields = {
  __typename?: 'coupons_ruleset_aggregate_fields';
  avg?: Maybe<Coupons_Ruleset_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Ruleset_Max_Fields>;
  min?: Maybe<Coupons_Ruleset_Min_Fields>;
  stddev?: Maybe<Coupons_Ruleset_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Ruleset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Ruleset_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Ruleset_Sum_Fields>;
  var_pop?: Maybe<Coupons_Ruleset_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Ruleset_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Ruleset_Variance_Fields>;
};


/** aggregate fields of "coupons_ruleset" */
export type Coupons_Ruleset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "coupons_ruleset" */
export type Coupons_Ruleset_Aggregate_Order_By = {
  avg?: InputMaybe<Coupons_Ruleset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Coupons_Ruleset_Max_Order_By>;
  min?: InputMaybe<Coupons_Ruleset_Min_Order_By>;
  stddev?: InputMaybe<Coupons_Ruleset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Coupons_Ruleset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Coupons_Ruleset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Coupons_Ruleset_Sum_Order_By>;
  var_pop?: InputMaybe<Coupons_Ruleset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Coupons_Ruleset_Var_Samp_Order_By>;
  variance?: InputMaybe<Coupons_Ruleset_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coupons_ruleset" */
export type Coupons_Ruleset_Arr_Rel_Insert_Input = {
  data: Array<Coupons_Ruleset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Ruleset_On_Conflict>;
};

/** aggregate avg on columns */
export type Coupons_Ruleset_Avg_Fields = {
  __typename?: 'coupons_ruleset_avg_fields';
  allowed_users_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_uses_id?: Maybe<Scalars['Float']['output']>;
  validity_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Avg_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "coupons_ruleset". All fields are combined with a logical 'AND'. */
export type Coupons_Ruleset_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Ruleset_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Ruleset_Bool_Exp>>;
  allowed_users_id?: InputMaybe<Int_Comparison_Exp>;
  coupons_allowedusersrule?: InputMaybe<Coupons_Allowedusersrule_Bool_Exp>;
  coupons_coupons?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  coupons_coupons_aggregate?: InputMaybe<Coupons_Coupon_Aggregate_Bool_Exp>;
  coupons_maxusesrule?: InputMaybe<Coupons_Maxusesrule_Bool_Exp>;
  coupons_validityrule?: InputMaybe<Coupons_Validityrule_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  max_uses_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  validity_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "coupons_ruleset" */
export enum Coupons_Ruleset_Constraint {
  /** unique or primary key constraint on columns "id" */
  CouponsRulesetPkey = 'coupons_ruleset_pkey'
}

/** input type for incrementing numeric columns in table "coupons_ruleset" */
export type Coupons_Ruleset_Inc_Input = {
  allowed_users_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  max_uses_id?: InputMaybe<Scalars['Int']['input']>;
  validity_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_ruleset" */
export type Coupons_Ruleset_Insert_Input = {
  allowed_users_id?: InputMaybe<Scalars['Int']['input']>;
  coupons_allowedusersrule?: InputMaybe<Coupons_Allowedusersrule_Obj_Rel_Insert_Input>;
  coupons_coupons?: InputMaybe<Coupons_Coupon_Arr_Rel_Insert_Input>;
  coupons_maxusesrule?: InputMaybe<Coupons_Maxusesrule_Obj_Rel_Insert_Input>;
  coupons_validityrule?: InputMaybe<Coupons_Validityrule_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  max_uses_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  validity_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Coupons_Ruleset_Max_Fields = {
  __typename?: 'coupons_ruleset_max_fields';
  allowed_users_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  max_uses_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  validity_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Max_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Coupons_Ruleset_Min_Fields = {
  __typename?: 'coupons_ruleset_min_fields';
  allowed_users_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  max_uses_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  validity_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Min_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "coupons_ruleset" */
export type Coupons_Ruleset_Mutation_Response = {
  __typename?: 'coupons_ruleset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Ruleset>;
};

/** input type for inserting object relation for remote table "coupons_ruleset" */
export type Coupons_Ruleset_Obj_Rel_Insert_Input = {
  data: Coupons_Ruleset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Ruleset_On_Conflict>;
};

/** on_conflict condition type for table "coupons_ruleset" */
export type Coupons_Ruleset_On_Conflict = {
  constraint: Coupons_Ruleset_Constraint;
  update_columns?: Array<Coupons_Ruleset_Update_Column>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_ruleset". */
export type Coupons_Ruleset_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  coupons_allowedusersrule?: InputMaybe<Coupons_Allowedusersrule_Order_By>;
  coupons_coupons_aggregate?: InputMaybe<Coupons_Coupon_Aggregate_Order_By>;
  coupons_maxusesrule?: InputMaybe<Coupons_Maxusesrule_Order_By>;
  coupons_validityrule?: InputMaybe<Coupons_Validityrule_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: coupons_ruleset */
export type Coupons_Ruleset_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_ruleset" */
export enum Coupons_Ruleset_Select_Column {
  /** column name */
  AllowedUsersId = 'allowed_users_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUsesId = 'max_uses_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidityId = 'validity_id'
}

/** input type for updating data in table "coupons_ruleset" */
export type Coupons_Ruleset_Set_Input = {
  allowed_users_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  max_uses_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  validity_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Ruleset_Stddev_Fields = {
  __typename?: 'coupons_ruleset_stddev_fields';
  allowed_users_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_uses_id?: Maybe<Scalars['Float']['output']>;
  validity_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Stddev_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Ruleset_Stddev_Pop_Fields = {
  __typename?: 'coupons_ruleset_stddev_pop_fields';
  allowed_users_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_uses_id?: Maybe<Scalars['Float']['output']>;
  validity_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Stddev_Pop_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Ruleset_Stddev_Samp_Fields = {
  __typename?: 'coupons_ruleset_stddev_samp_fields';
  allowed_users_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_uses_id?: Maybe<Scalars['Float']['output']>;
  validity_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Stddev_Samp_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "coupons_ruleset" */
export type Coupons_Ruleset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Ruleset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Ruleset_Stream_Cursor_Value_Input = {
  allowed_users_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  max_uses_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  validity_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Ruleset_Sum_Fields = {
  __typename?: 'coupons_ruleset_sum_fields';
  allowed_users_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  max_uses_id?: Maybe<Scalars['Int']['output']>;
  validity_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Sum_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** update columns of table "coupons_ruleset" */
export enum Coupons_Ruleset_Update_Column {
  /** column name */
  AllowedUsersId = 'allowed_users_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUsesId = 'max_uses_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidityId = 'validity_id'
}

export type Coupons_Ruleset_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Ruleset_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Ruleset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Ruleset_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coupons_Ruleset_Var_Pop_Fields = {
  __typename?: 'coupons_ruleset_var_pop_fields';
  allowed_users_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_uses_id?: Maybe<Scalars['Float']['output']>;
  validity_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Var_Pop_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Coupons_Ruleset_Var_Samp_Fields = {
  __typename?: 'coupons_ruleset_var_samp_fields';
  allowed_users_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_uses_id?: Maybe<Scalars['Float']['output']>;
  validity_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Var_Samp_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Coupons_Ruleset_Variance_Fields = {
  __typename?: 'coupons_ruleset_variance_fields';
  allowed_users_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_uses_id?: Maybe<Scalars['Float']['output']>;
  validity_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "coupons_ruleset" */
export type Coupons_Ruleset_Variance_Order_By = {
  allowed_users_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_uses_id?: InputMaybe<Order_By>;
  validity_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "coupons_validityrule" */
export type Coupons_Validityrule = {
  __typename?: 'coupons_validityrule';
  /** An array relationship */
  coupons_rulesets: Array<Coupons_Ruleset>;
  /** An aggregate relationship */
  coupons_rulesets_aggregate: Coupons_Ruleset_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expiration_date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "coupons_validityrule" */
export type Coupons_ValidityruleCoupons_RulesetsArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};


/** columns and relationships of "coupons_validityrule" */
export type Coupons_ValidityruleCoupons_Rulesets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Ruleset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Ruleset_Order_By>>;
  where?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
};

/** aggregated selection of "coupons_validityrule" */
export type Coupons_Validityrule_Aggregate = {
  __typename?: 'coupons_validityrule_aggregate';
  aggregate?: Maybe<Coupons_Validityrule_Aggregate_Fields>;
  nodes: Array<Coupons_Validityrule>;
};

/** aggregate fields of "coupons_validityrule" */
export type Coupons_Validityrule_Aggregate_Fields = {
  __typename?: 'coupons_validityrule_aggregate_fields';
  avg?: Maybe<Coupons_Validityrule_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Coupons_Validityrule_Max_Fields>;
  min?: Maybe<Coupons_Validityrule_Min_Fields>;
  stddev?: Maybe<Coupons_Validityrule_Stddev_Fields>;
  stddev_pop?: Maybe<Coupons_Validityrule_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coupons_Validityrule_Stddev_Samp_Fields>;
  sum?: Maybe<Coupons_Validityrule_Sum_Fields>;
  var_pop?: Maybe<Coupons_Validityrule_Var_Pop_Fields>;
  var_samp?: Maybe<Coupons_Validityrule_Var_Samp_Fields>;
  variance?: Maybe<Coupons_Validityrule_Variance_Fields>;
};


/** aggregate fields of "coupons_validityrule" */
export type Coupons_Validityrule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coupons_Validityrule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Coupons_Validityrule_Avg_Fields = {
  __typename?: 'coupons_validityrule_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "coupons_validityrule". All fields are combined with a logical 'AND'. */
export type Coupons_Validityrule_Bool_Exp = {
  _and?: InputMaybe<Array<Coupons_Validityrule_Bool_Exp>>;
  _not?: InputMaybe<Coupons_Validityrule_Bool_Exp>;
  _or?: InputMaybe<Array<Coupons_Validityrule_Bool_Exp>>;
  coupons_rulesets?: InputMaybe<Coupons_Ruleset_Bool_Exp>;
  coupons_rulesets_aggregate?: InputMaybe<Coupons_Ruleset_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiration_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "coupons_validityrule" */
export enum Coupons_Validityrule_Constraint {
  /** unique or primary key constraint on columns "id" */
  CouponsValidityrulePkey = 'coupons_validityrule_pkey'
}

/** input type for incrementing numeric columns in table "coupons_validityrule" */
export type Coupons_Validityrule_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "coupons_validityrule" */
export type Coupons_Validityrule_Insert_Input = {
  coupons_rulesets?: InputMaybe<Coupons_Ruleset_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Coupons_Validityrule_Max_Fields = {
  __typename?: 'coupons_validityrule_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Coupons_Validityrule_Min_Fields = {
  __typename?: 'coupons_validityrule_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "coupons_validityrule" */
export type Coupons_Validityrule_Mutation_Response = {
  __typename?: 'coupons_validityrule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Coupons_Validityrule>;
};

/** input type for inserting object relation for remote table "coupons_validityrule" */
export type Coupons_Validityrule_Obj_Rel_Insert_Input = {
  data: Coupons_Validityrule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Coupons_Validityrule_On_Conflict>;
};

/** on_conflict condition type for table "coupons_validityrule" */
export type Coupons_Validityrule_On_Conflict = {
  constraint: Coupons_Validityrule_Constraint;
  update_columns?: Array<Coupons_Validityrule_Update_Column>;
  where?: InputMaybe<Coupons_Validityrule_Bool_Exp>;
};

/** Ordering options when selecting data from "coupons_validityrule". */
export type Coupons_Validityrule_Order_By = {
  coupons_rulesets_aggregate?: InputMaybe<Coupons_Ruleset_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: coupons_validityrule */
export type Coupons_Validityrule_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "coupons_validityrule" */
export enum Coupons_Validityrule_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "coupons_validityrule" */
export type Coupons_Validityrule_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Coupons_Validityrule_Stddev_Fields = {
  __typename?: 'coupons_validityrule_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Coupons_Validityrule_Stddev_Pop_Fields = {
  __typename?: 'coupons_validityrule_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Coupons_Validityrule_Stddev_Samp_Fields = {
  __typename?: 'coupons_validityrule_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "coupons_validityrule" */
export type Coupons_Validityrule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coupons_Validityrule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coupons_Validityrule_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Coupons_Validityrule_Sum_Fields = {
  __typename?: 'coupons_validityrule_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "coupons_validityrule" */
export enum Coupons_Validityrule_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Coupons_Validityrule_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coupons_Validityrule_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coupons_Validityrule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Coupons_Validityrule_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coupons_Validityrule_Var_Pop_Fields = {
  __typename?: 'coupons_validityrule_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Coupons_Validityrule_Var_Samp_Fields = {
  __typename?: 'coupons_validityrule_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Coupons_Validityrule_Variance_Fields = {
  __typename?: 'coupons_validityrule_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "django_admin_log" */
export type Django_Admin_Log = {
  __typename?: 'django_admin_log';
  action_flag: Scalars['smallint']['output'];
  action_time: Scalars['timestamptz']['output'];
  change_message: Scalars['String']['output'];
  content_type_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  django_content_type?: Maybe<Django_Content_Type>;
  id: Scalars['Int']['output'];
  object_id?: Maybe<Scalars['String']['output']>;
  object_repr: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "django_admin_log" */
export type Django_Admin_Log_Aggregate = {
  __typename?: 'django_admin_log_aggregate';
  aggregate?: Maybe<Django_Admin_Log_Aggregate_Fields>;
  nodes: Array<Django_Admin_Log>;
};

export type Django_Admin_Log_Aggregate_Bool_Exp = {
  count?: InputMaybe<Django_Admin_Log_Aggregate_Bool_Exp_Count>;
};

export type Django_Admin_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Django_Admin_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "django_admin_log" */
export type Django_Admin_Log_Aggregate_Fields = {
  __typename?: 'django_admin_log_aggregate_fields';
  avg?: Maybe<Django_Admin_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Django_Admin_Log_Max_Fields>;
  min?: Maybe<Django_Admin_Log_Min_Fields>;
  stddev?: Maybe<Django_Admin_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Django_Admin_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Django_Admin_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Django_Admin_Log_Sum_Fields>;
  var_pop?: Maybe<Django_Admin_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Django_Admin_Log_Var_Samp_Fields>;
  variance?: Maybe<Django_Admin_Log_Variance_Fields>;
};


/** aggregate fields of "django_admin_log" */
export type Django_Admin_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "django_admin_log" */
export type Django_Admin_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Django_Admin_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Django_Admin_Log_Max_Order_By>;
  min?: InputMaybe<Django_Admin_Log_Min_Order_By>;
  stddev?: InputMaybe<Django_Admin_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Django_Admin_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Django_Admin_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Django_Admin_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Django_Admin_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Django_Admin_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Django_Admin_Log_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "django_admin_log" */
export type Django_Admin_Log_Arr_Rel_Insert_Input = {
  data: Array<Django_Admin_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Django_Admin_Log_On_Conflict>;
};

/** aggregate avg on columns */
export type Django_Admin_Log_Avg_Fields = {
  __typename?: 'django_admin_log_avg_fields';
  action_flag?: Maybe<Scalars['Float']['output']>;
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "django_admin_log" */
export type Django_Admin_Log_Avg_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "django_admin_log". All fields are combined with a logical 'AND'. */
export type Django_Admin_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Django_Admin_Log_Bool_Exp>>;
  _not?: InputMaybe<Django_Admin_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Django_Admin_Log_Bool_Exp>>;
  action_flag?: InputMaybe<Smallint_Comparison_Exp>;
  action_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  change_message?: InputMaybe<String_Comparison_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  django_content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  object_id?: InputMaybe<String_Comparison_Exp>;
  object_repr?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "django_admin_log" */
export enum Django_Admin_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  DjangoAdminLogPkey = 'django_admin_log_pkey'
}

/** input type for incrementing numeric columns in table "django_admin_log" */
export type Django_Admin_Log_Inc_Input = {
  action_flag?: InputMaybe<Scalars['smallint']['input']>;
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "django_admin_log" */
export type Django_Admin_Log_Insert_Input = {
  action_flag?: InputMaybe<Scalars['smallint']['input']>;
  action_time?: InputMaybe<Scalars['timestamptz']['input']>;
  change_message?: InputMaybe<Scalars['String']['input']>;
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  django_content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Scalars['String']['input']>;
  object_repr?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Django_Admin_Log_Max_Fields = {
  __typename?: 'django_admin_log_max_fields';
  action_flag?: Maybe<Scalars['smallint']['output']>;
  action_time?: Maybe<Scalars['timestamptz']['output']>;
  change_message?: Maybe<Scalars['String']['output']>;
  content_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  object_id?: Maybe<Scalars['String']['output']>;
  object_repr?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "django_admin_log" */
export type Django_Admin_Log_Max_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  action_time?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  object_repr?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Django_Admin_Log_Min_Fields = {
  __typename?: 'django_admin_log_min_fields';
  action_flag?: Maybe<Scalars['smallint']['output']>;
  action_time?: Maybe<Scalars['timestamptz']['output']>;
  change_message?: Maybe<Scalars['String']['output']>;
  content_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  object_id?: Maybe<Scalars['String']['output']>;
  object_repr?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "django_admin_log" */
export type Django_Admin_Log_Min_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  action_time?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  object_repr?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "django_admin_log" */
export type Django_Admin_Log_Mutation_Response = {
  __typename?: 'django_admin_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Django_Admin_Log>;
};

/** on_conflict condition type for table "django_admin_log" */
export type Django_Admin_Log_On_Conflict = {
  constraint: Django_Admin_Log_Constraint;
  update_columns?: Array<Django_Admin_Log_Update_Column>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "django_admin_log". */
export type Django_Admin_Log_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  action_time?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  django_content_type?: InputMaybe<Django_Content_Type_Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  object_repr?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: django_admin_log */
export type Django_Admin_Log_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "django_admin_log" */
export enum Django_Admin_Log_Select_Column {
  /** column name */
  ActionFlag = 'action_flag',
  /** column name */
  ActionTime = 'action_time',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  ObjectRepr = 'object_repr',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "django_admin_log" */
export type Django_Admin_Log_Set_Input = {
  action_flag?: InputMaybe<Scalars['smallint']['input']>;
  action_time?: InputMaybe<Scalars['timestamptz']['input']>;
  change_message?: InputMaybe<Scalars['String']['input']>;
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Scalars['String']['input']>;
  object_repr?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Django_Admin_Log_Stddev_Fields = {
  __typename?: 'django_admin_log_stddev_fields';
  action_flag?: Maybe<Scalars['Float']['output']>;
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "django_admin_log" */
export type Django_Admin_Log_Stddev_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Django_Admin_Log_Stddev_Pop_Fields = {
  __typename?: 'django_admin_log_stddev_pop_fields';
  action_flag?: Maybe<Scalars['Float']['output']>;
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "django_admin_log" */
export type Django_Admin_Log_Stddev_Pop_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Django_Admin_Log_Stddev_Samp_Fields = {
  __typename?: 'django_admin_log_stddev_samp_fields';
  action_flag?: Maybe<Scalars['Float']['output']>;
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "django_admin_log" */
export type Django_Admin_Log_Stddev_Samp_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "django_admin_log" */
export type Django_Admin_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Django_Admin_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Django_Admin_Log_Stream_Cursor_Value_Input = {
  action_flag?: InputMaybe<Scalars['smallint']['input']>;
  action_time?: InputMaybe<Scalars['timestamptz']['input']>;
  change_message?: InputMaybe<Scalars['String']['input']>;
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Scalars['String']['input']>;
  object_repr?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Django_Admin_Log_Sum_Fields = {
  __typename?: 'django_admin_log_sum_fields';
  action_flag?: Maybe<Scalars['smallint']['output']>;
  content_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "django_admin_log" */
export type Django_Admin_Log_Sum_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "django_admin_log" */
export enum Django_Admin_Log_Update_Column {
  /** column name */
  ActionFlag = 'action_flag',
  /** column name */
  ActionTime = 'action_time',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  ObjectRepr = 'object_repr',
  /** column name */
  UserId = 'user_id'
}

export type Django_Admin_Log_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Django_Admin_Log_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Django_Admin_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Django_Admin_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Django_Admin_Log_Var_Pop_Fields = {
  __typename?: 'django_admin_log_var_pop_fields';
  action_flag?: Maybe<Scalars['Float']['output']>;
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "django_admin_log" */
export type Django_Admin_Log_Var_Pop_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Django_Admin_Log_Var_Samp_Fields = {
  __typename?: 'django_admin_log_var_samp_fields';
  action_flag?: Maybe<Scalars['Float']['output']>;
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "django_admin_log" */
export type Django_Admin_Log_Var_Samp_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Django_Admin_Log_Variance_Fields = {
  __typename?: 'django_admin_log_variance_fields';
  action_flag?: Maybe<Scalars['Float']['output']>;
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "django_admin_log" */
export type Django_Admin_Log_Variance_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "django_content_type" */
export type Django_Content_Type = {
  __typename?: 'django_content_type';
  app_label: Scalars['String']['output'];
  /** An array relationship */
  auth_permissions: Array<Auth_Permission>;
  /** An aggregate relationship */
  auth_permissions_aggregate: Auth_Permission_Aggregate;
  /** An array relationship */
  django_admin_logs: Array<Django_Admin_Log>;
  /** An aggregate relationship */
  django_admin_logs_aggregate: Django_Admin_Log_Aggregate;
  id: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  /** An array relationship */
  taggit_taggeditems: Array<Taggit_Taggeditem>;
  /** An aggregate relationship */
  taggit_taggeditems_aggregate: Taggit_Taggeditem_Aggregate;
};


/** columns and relationships of "django_content_type" */
export type Django_Content_TypeAuth_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


/** columns and relationships of "django_content_type" */
export type Django_Content_TypeAuth_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


/** columns and relationships of "django_content_type" */
export type Django_Content_TypeDjango_Admin_LogsArgs = {
  distinct_on?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Admin_Log_Order_By>>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};


/** columns and relationships of "django_content_type" */
export type Django_Content_TypeDjango_Admin_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Admin_Log_Order_By>>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};


/** columns and relationships of "django_content_type" */
export type Django_Content_TypeTaggit_TaggeditemsArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Taggeditem_Order_By>>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};


/** columns and relationships of "django_content_type" */
export type Django_Content_TypeTaggit_Taggeditems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Taggeditem_Order_By>>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};

/** aggregated selection of "django_content_type" */
export type Django_Content_Type_Aggregate = {
  __typename?: 'django_content_type_aggregate';
  aggregate?: Maybe<Django_Content_Type_Aggregate_Fields>;
  nodes: Array<Django_Content_Type>;
};

/** aggregate fields of "django_content_type" */
export type Django_Content_Type_Aggregate_Fields = {
  __typename?: 'django_content_type_aggregate_fields';
  avg?: Maybe<Django_Content_Type_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Django_Content_Type_Max_Fields>;
  min?: Maybe<Django_Content_Type_Min_Fields>;
  stddev?: Maybe<Django_Content_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Django_Content_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Django_Content_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Django_Content_Type_Sum_Fields>;
  var_pop?: Maybe<Django_Content_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Django_Content_Type_Var_Samp_Fields>;
  variance?: Maybe<Django_Content_Type_Variance_Fields>;
};


/** aggregate fields of "django_content_type" */
export type Django_Content_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Django_Content_Type_Avg_Fields = {
  __typename?: 'django_content_type_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "django_content_type". All fields are combined with a logical 'AND'. */
export type Django_Content_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Django_Content_Type_Bool_Exp>>;
  _not?: InputMaybe<Django_Content_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Django_Content_Type_Bool_Exp>>;
  app_label?: InputMaybe<String_Comparison_Exp>;
  auth_permissions?: InputMaybe<Auth_Permission_Bool_Exp>;
  auth_permissions_aggregate?: InputMaybe<Auth_Permission_Aggregate_Bool_Exp>;
  django_admin_logs?: InputMaybe<Django_Admin_Log_Bool_Exp>;
  django_admin_logs_aggregate?: InputMaybe<Django_Admin_Log_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  taggit_taggeditems?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
  taggit_taggeditems_aggregate?: InputMaybe<Taggit_Taggeditem_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "django_content_type" */
export enum Django_Content_Type_Constraint {
  /** unique or primary key constraint on columns "app_label", "model" */
  DjangoContentTypeAppLabelModel_76bd3d3bUniq = 'django_content_type_app_label_model_76bd3d3b_uniq',
  /** unique or primary key constraint on columns "id" */
  DjangoContentTypePkey = 'django_content_type_pkey'
}

/** input type for incrementing numeric columns in table "django_content_type" */
export type Django_Content_Type_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "django_content_type" */
export type Django_Content_Type_Insert_Input = {
  app_label?: InputMaybe<Scalars['String']['input']>;
  auth_permissions?: InputMaybe<Auth_Permission_Arr_Rel_Insert_Input>;
  django_admin_logs?: InputMaybe<Django_Admin_Log_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  taggit_taggeditems?: InputMaybe<Taggit_Taggeditem_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Django_Content_Type_Max_Fields = {
  __typename?: 'django_content_type_max_fields';
  app_label?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Django_Content_Type_Min_Fields = {
  __typename?: 'django_content_type_min_fields';
  app_label?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "django_content_type" */
export type Django_Content_Type_Mutation_Response = {
  __typename?: 'django_content_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Django_Content_Type>;
};

/** input type for inserting object relation for remote table "django_content_type" */
export type Django_Content_Type_Obj_Rel_Insert_Input = {
  data: Django_Content_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Django_Content_Type_On_Conflict>;
};

/** on_conflict condition type for table "django_content_type" */
export type Django_Content_Type_On_Conflict = {
  constraint: Django_Content_Type_Constraint;
  update_columns?: Array<Django_Content_Type_Update_Column>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "django_content_type". */
export type Django_Content_Type_Order_By = {
  app_label?: InputMaybe<Order_By>;
  auth_permissions_aggregate?: InputMaybe<Auth_Permission_Aggregate_Order_By>;
  django_admin_logs_aggregate?: InputMaybe<Django_Admin_Log_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  taggit_taggeditems_aggregate?: InputMaybe<Taggit_Taggeditem_Aggregate_Order_By>;
};

/** primary key columns input for table: django_content_type */
export type Django_Content_Type_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "django_content_type" */
export enum Django_Content_Type_Select_Column {
  /** column name */
  AppLabel = 'app_label',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model'
}

/** input type for updating data in table "django_content_type" */
export type Django_Content_Type_Set_Input = {
  app_label?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Django_Content_Type_Stddev_Fields = {
  __typename?: 'django_content_type_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Django_Content_Type_Stddev_Pop_Fields = {
  __typename?: 'django_content_type_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Django_Content_Type_Stddev_Samp_Fields = {
  __typename?: 'django_content_type_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "django_content_type" */
export type Django_Content_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Django_Content_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Django_Content_Type_Stream_Cursor_Value_Input = {
  app_label?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Django_Content_Type_Sum_Fields = {
  __typename?: 'django_content_type_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "django_content_type" */
export enum Django_Content_Type_Update_Column {
  /** column name */
  AppLabel = 'app_label',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model'
}

export type Django_Content_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Django_Content_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Django_Content_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Django_Content_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Django_Content_Type_Var_Pop_Fields = {
  __typename?: 'django_content_type_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Django_Content_Type_Var_Samp_Fields = {
  __typename?: 'django_content_type_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Django_Content_Type_Variance_Fields = {
  __typename?: 'django_content_type_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "django_migrations" */
export type Django_Migrations = {
  __typename?: 'django_migrations';
  app: Scalars['String']['output'];
  applied: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "django_migrations" */
export type Django_Migrations_Aggregate = {
  __typename?: 'django_migrations_aggregate';
  aggregate?: Maybe<Django_Migrations_Aggregate_Fields>;
  nodes: Array<Django_Migrations>;
};

/** aggregate fields of "django_migrations" */
export type Django_Migrations_Aggregate_Fields = {
  __typename?: 'django_migrations_aggregate_fields';
  avg?: Maybe<Django_Migrations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Django_Migrations_Max_Fields>;
  min?: Maybe<Django_Migrations_Min_Fields>;
  stddev?: Maybe<Django_Migrations_Stddev_Fields>;
  stddev_pop?: Maybe<Django_Migrations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Django_Migrations_Stddev_Samp_Fields>;
  sum?: Maybe<Django_Migrations_Sum_Fields>;
  var_pop?: Maybe<Django_Migrations_Var_Pop_Fields>;
  var_samp?: Maybe<Django_Migrations_Var_Samp_Fields>;
  variance?: Maybe<Django_Migrations_Variance_Fields>;
};


/** aggregate fields of "django_migrations" */
export type Django_Migrations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Django_Migrations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Django_Migrations_Avg_Fields = {
  __typename?: 'django_migrations_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "django_migrations". All fields are combined with a logical 'AND'. */
export type Django_Migrations_Bool_Exp = {
  _and?: InputMaybe<Array<Django_Migrations_Bool_Exp>>;
  _not?: InputMaybe<Django_Migrations_Bool_Exp>;
  _or?: InputMaybe<Array<Django_Migrations_Bool_Exp>>;
  app?: InputMaybe<String_Comparison_Exp>;
  applied?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "django_migrations" */
export enum Django_Migrations_Constraint {
  /** unique or primary key constraint on columns "id" */
  DjangoMigrationsPkey = 'django_migrations_pkey'
}

/** input type for incrementing numeric columns in table "django_migrations" */
export type Django_Migrations_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "django_migrations" */
export type Django_Migrations_Insert_Input = {
  app?: InputMaybe<Scalars['String']['input']>;
  applied?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Django_Migrations_Max_Fields = {
  __typename?: 'django_migrations_max_fields';
  app?: Maybe<Scalars['String']['output']>;
  applied?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Django_Migrations_Min_Fields = {
  __typename?: 'django_migrations_min_fields';
  app?: Maybe<Scalars['String']['output']>;
  applied?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "django_migrations" */
export type Django_Migrations_Mutation_Response = {
  __typename?: 'django_migrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Django_Migrations>;
};

/** on_conflict condition type for table "django_migrations" */
export type Django_Migrations_On_Conflict = {
  constraint: Django_Migrations_Constraint;
  update_columns?: Array<Django_Migrations_Update_Column>;
  where?: InputMaybe<Django_Migrations_Bool_Exp>;
};

/** Ordering options when selecting data from "django_migrations". */
export type Django_Migrations_Order_By = {
  app?: InputMaybe<Order_By>;
  applied?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: django_migrations */
export type Django_Migrations_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "django_migrations" */
export enum Django_Migrations_Select_Column {
  /** column name */
  App = 'app',
  /** column name */
  Applied = 'applied',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "django_migrations" */
export type Django_Migrations_Set_Input = {
  app?: InputMaybe<Scalars['String']['input']>;
  applied?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Django_Migrations_Stddev_Fields = {
  __typename?: 'django_migrations_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Django_Migrations_Stddev_Pop_Fields = {
  __typename?: 'django_migrations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Django_Migrations_Stddev_Samp_Fields = {
  __typename?: 'django_migrations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "django_migrations" */
export type Django_Migrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Django_Migrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Django_Migrations_Stream_Cursor_Value_Input = {
  app?: InputMaybe<Scalars['String']['input']>;
  applied?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Django_Migrations_Sum_Fields = {
  __typename?: 'django_migrations_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "django_migrations" */
export enum Django_Migrations_Update_Column {
  /** column name */
  App = 'app',
  /** column name */
  Applied = 'applied',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Django_Migrations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Django_Migrations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Django_Migrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Django_Migrations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Django_Migrations_Var_Pop_Fields = {
  __typename?: 'django_migrations_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Django_Migrations_Var_Samp_Fields = {
  __typename?: 'django_migrations_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Django_Migrations_Variance_Fields = {
  __typename?: 'django_migrations_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "django_session" */
export type Django_Session = {
  __typename?: 'django_session';
  expire_date: Scalars['timestamptz']['output'];
  session_data: Scalars['String']['output'];
  session_key: Scalars['String']['output'];
};

/** aggregated selection of "django_session" */
export type Django_Session_Aggregate = {
  __typename?: 'django_session_aggregate';
  aggregate?: Maybe<Django_Session_Aggregate_Fields>;
  nodes: Array<Django_Session>;
};

/** aggregate fields of "django_session" */
export type Django_Session_Aggregate_Fields = {
  __typename?: 'django_session_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Django_Session_Max_Fields>;
  min?: Maybe<Django_Session_Min_Fields>;
};


/** aggregate fields of "django_session" */
export type Django_Session_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Django_Session_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "django_session". All fields are combined with a logical 'AND'. */
export type Django_Session_Bool_Exp = {
  _and?: InputMaybe<Array<Django_Session_Bool_Exp>>;
  _not?: InputMaybe<Django_Session_Bool_Exp>;
  _or?: InputMaybe<Array<Django_Session_Bool_Exp>>;
  expire_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  session_data?: InputMaybe<String_Comparison_Exp>;
  session_key?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "django_session" */
export enum Django_Session_Constraint {
  /** unique or primary key constraint on columns "session_key" */
  DjangoSessionPkey = 'django_session_pkey'
}

/** input type for inserting data into table "django_session" */
export type Django_Session_Insert_Input = {
  expire_date?: InputMaybe<Scalars['timestamptz']['input']>;
  session_data?: InputMaybe<Scalars['String']['input']>;
  session_key?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Django_Session_Max_Fields = {
  __typename?: 'django_session_max_fields';
  expire_date?: Maybe<Scalars['timestamptz']['output']>;
  session_data?: Maybe<Scalars['String']['output']>;
  session_key?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Django_Session_Min_Fields = {
  __typename?: 'django_session_min_fields';
  expire_date?: Maybe<Scalars['timestamptz']['output']>;
  session_data?: Maybe<Scalars['String']['output']>;
  session_key?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "django_session" */
export type Django_Session_Mutation_Response = {
  __typename?: 'django_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Django_Session>;
};

/** on_conflict condition type for table "django_session" */
export type Django_Session_On_Conflict = {
  constraint: Django_Session_Constraint;
  update_columns?: Array<Django_Session_Update_Column>;
  where?: InputMaybe<Django_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "django_session". */
export type Django_Session_Order_By = {
  expire_date?: InputMaybe<Order_By>;
  session_data?: InputMaybe<Order_By>;
  session_key?: InputMaybe<Order_By>;
};

/** primary key columns input for table: django_session */
export type Django_Session_Pk_Columns_Input = {
  session_key: Scalars['String']['input'];
};

/** select columns of table "django_session" */
export enum Django_Session_Select_Column {
  /** column name */
  ExpireDate = 'expire_date',
  /** column name */
  SessionData = 'session_data',
  /** column name */
  SessionKey = 'session_key'
}

/** input type for updating data in table "django_session" */
export type Django_Session_Set_Input = {
  expire_date?: InputMaybe<Scalars['timestamptz']['input']>;
  session_data?: InputMaybe<Scalars['String']['input']>;
  session_key?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "django_session" */
export type Django_Session_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Django_Session_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Django_Session_Stream_Cursor_Value_Input = {
  expire_date?: InputMaybe<Scalars['timestamptz']['input']>;
  session_data?: InputMaybe<Scalars['String']['input']>;
  session_key?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "django_session" */
export enum Django_Session_Update_Column {
  /** column name */
  ExpireDate = 'expire_date',
  /** column name */
  SessionData = 'session_data',
  /** column name */
  SessionKey = 'session_key'
}

export type Django_Session_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Django_Session_Set_Input>;
  /** filter the rows which have to be updated */
  where: Django_Session_Bool_Exp;
};

/** columns and relationships of "django_site" */
export type Django_Site = {
  __typename?: 'django_site';
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  socialaccount_socialapp_sites: Array<Socialaccount_Socialapp_Sites>;
  /** An aggregate relationship */
  socialaccount_socialapp_sites_aggregate: Socialaccount_Socialapp_Sites_Aggregate;
};


/** columns and relationships of "django_site" */
export type Django_SiteSocialaccount_Socialapp_SitesArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};


/** columns and relationships of "django_site" */
export type Django_SiteSocialaccount_Socialapp_Sites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};

/** aggregated selection of "django_site" */
export type Django_Site_Aggregate = {
  __typename?: 'django_site_aggregate';
  aggregate?: Maybe<Django_Site_Aggregate_Fields>;
  nodes: Array<Django_Site>;
};

/** aggregate fields of "django_site" */
export type Django_Site_Aggregate_Fields = {
  __typename?: 'django_site_aggregate_fields';
  avg?: Maybe<Django_Site_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Django_Site_Max_Fields>;
  min?: Maybe<Django_Site_Min_Fields>;
  stddev?: Maybe<Django_Site_Stddev_Fields>;
  stddev_pop?: Maybe<Django_Site_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Django_Site_Stddev_Samp_Fields>;
  sum?: Maybe<Django_Site_Sum_Fields>;
  var_pop?: Maybe<Django_Site_Var_Pop_Fields>;
  var_samp?: Maybe<Django_Site_Var_Samp_Fields>;
  variance?: Maybe<Django_Site_Variance_Fields>;
};


/** aggregate fields of "django_site" */
export type Django_Site_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Django_Site_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Django_Site_Avg_Fields = {
  __typename?: 'django_site_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "django_site". All fields are combined with a logical 'AND'. */
export type Django_Site_Bool_Exp = {
  _and?: InputMaybe<Array<Django_Site_Bool_Exp>>;
  _not?: InputMaybe<Django_Site_Bool_Exp>;
  _or?: InputMaybe<Array<Django_Site_Bool_Exp>>;
  domain?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  socialaccount_socialapp_sites?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
  socialaccount_socialapp_sites_aggregate?: InputMaybe<Socialaccount_Socialapp_Sites_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "django_site" */
export enum Django_Site_Constraint {
  /** unique or primary key constraint on columns "domain" */
  DjangoSiteDomainA2e37b91Uniq = 'django_site_domain_a2e37b91_uniq',
  /** unique or primary key constraint on columns "id" */
  DjangoSitePkey = 'django_site_pkey'
}

/** input type for incrementing numeric columns in table "django_site" */
export type Django_Site_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "django_site" */
export type Django_Site_Insert_Input = {
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  socialaccount_socialapp_sites?: InputMaybe<Socialaccount_Socialapp_Sites_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Django_Site_Max_Fields = {
  __typename?: 'django_site_max_fields';
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Django_Site_Min_Fields = {
  __typename?: 'django_site_min_fields';
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "django_site" */
export type Django_Site_Mutation_Response = {
  __typename?: 'django_site_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Django_Site>;
};

/** input type for inserting object relation for remote table "django_site" */
export type Django_Site_Obj_Rel_Insert_Input = {
  data: Django_Site_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Django_Site_On_Conflict>;
};

/** on_conflict condition type for table "django_site" */
export type Django_Site_On_Conflict = {
  constraint: Django_Site_Constraint;
  update_columns?: Array<Django_Site_Update_Column>;
  where?: InputMaybe<Django_Site_Bool_Exp>;
};

/** Ordering options when selecting data from "django_site". */
export type Django_Site_Order_By = {
  domain?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  socialaccount_socialapp_sites_aggregate?: InputMaybe<Socialaccount_Socialapp_Sites_Aggregate_Order_By>;
};

/** primary key columns input for table: django_site */
export type Django_Site_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "django_site" */
export enum Django_Site_Select_Column {
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "django_site" */
export type Django_Site_Set_Input = {
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Django_Site_Stddev_Fields = {
  __typename?: 'django_site_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Django_Site_Stddev_Pop_Fields = {
  __typename?: 'django_site_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Django_Site_Stddev_Samp_Fields = {
  __typename?: 'django_site_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "django_site" */
export type Django_Site_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Django_Site_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Django_Site_Stream_Cursor_Value_Input = {
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Django_Site_Sum_Fields = {
  __typename?: 'django_site_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "django_site" */
export enum Django_Site_Update_Column {
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Django_Site_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Django_Site_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Django_Site_Set_Input>;
  /** filter the rows which have to be updated */
  where: Django_Site_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Django_Site_Var_Pop_Fields = {
  __typename?: 'django_site_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Django_Site_Var_Samp_Fields = {
  __typename?: 'django_site_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Django_Site_Variance_Fields = {
  __typename?: 'django_site_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "djconfig_config" */
export type Djconfig_Config = {
  __typename?: 'djconfig_config';
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "djconfig_config" */
export type Djconfig_Config_Aggregate = {
  __typename?: 'djconfig_config_aggregate';
  aggregate?: Maybe<Djconfig_Config_Aggregate_Fields>;
  nodes: Array<Djconfig_Config>;
};

/** aggregate fields of "djconfig_config" */
export type Djconfig_Config_Aggregate_Fields = {
  __typename?: 'djconfig_config_aggregate_fields';
  avg?: Maybe<Djconfig_Config_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Djconfig_Config_Max_Fields>;
  min?: Maybe<Djconfig_Config_Min_Fields>;
  stddev?: Maybe<Djconfig_Config_Stddev_Fields>;
  stddev_pop?: Maybe<Djconfig_Config_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Djconfig_Config_Stddev_Samp_Fields>;
  sum?: Maybe<Djconfig_Config_Sum_Fields>;
  var_pop?: Maybe<Djconfig_Config_Var_Pop_Fields>;
  var_samp?: Maybe<Djconfig_Config_Var_Samp_Fields>;
  variance?: Maybe<Djconfig_Config_Variance_Fields>;
};


/** aggregate fields of "djconfig_config" */
export type Djconfig_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Djconfig_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Djconfig_Config_Avg_Fields = {
  __typename?: 'djconfig_config_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "djconfig_config". All fields are combined with a logical 'AND'. */
export type Djconfig_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Djconfig_Config_Bool_Exp>>;
  _not?: InputMaybe<Djconfig_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Djconfig_Config_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "djconfig_config" */
export enum Djconfig_Config_Constraint {
  /** unique or primary key constraint on columns "key" */
  DjconfigConfigKeyKey = 'djconfig_config_key_key',
  /** unique or primary key constraint on columns "id" */
  DjconfigConfigPkey = 'djconfig_config_pkey'
}

/** input type for incrementing numeric columns in table "djconfig_config" */
export type Djconfig_Config_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "djconfig_config" */
export type Djconfig_Config_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Djconfig_Config_Max_Fields = {
  __typename?: 'djconfig_config_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Djconfig_Config_Min_Fields = {
  __typename?: 'djconfig_config_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "djconfig_config" */
export type Djconfig_Config_Mutation_Response = {
  __typename?: 'djconfig_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Djconfig_Config>;
};

/** on_conflict condition type for table "djconfig_config" */
export type Djconfig_Config_On_Conflict = {
  constraint: Djconfig_Config_Constraint;
  update_columns?: Array<Djconfig_Config_Update_Column>;
  where?: InputMaybe<Djconfig_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "djconfig_config". */
export type Djconfig_Config_Order_By = {
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: djconfig_config */
export type Djconfig_Config_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "djconfig_config" */
export enum Djconfig_Config_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "djconfig_config" */
export type Djconfig_Config_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Djconfig_Config_Stddev_Fields = {
  __typename?: 'djconfig_config_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Djconfig_Config_Stddev_Pop_Fields = {
  __typename?: 'djconfig_config_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Djconfig_Config_Stddev_Samp_Fields = {
  __typename?: 'djconfig_config_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "djconfig_config" */
export type Djconfig_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Djconfig_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Djconfig_Config_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Djconfig_Config_Sum_Fields = {
  __typename?: 'djconfig_config_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "djconfig_config" */
export enum Djconfig_Config_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

export type Djconfig_Config_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Djconfig_Config_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Djconfig_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: Djconfig_Config_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Djconfig_Config_Var_Pop_Fields = {
  __typename?: 'djconfig_config_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Djconfig_Config_Var_Samp_Fields = {
  __typename?: 'djconfig_config_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Djconfig_Config_Variance_Fields = {
  __typename?: 'djconfig_config_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type GetCatResultInput = {
  catLink?: InputMaybe<Scalars['String']['input']>;
  dilrScore?: InputMaybe<Scalars['String']['input']>;
  quantScore?: InputMaybe<Scalars['String']['input']>;
  shift?: InputMaybe<Scalars['String']['input']>;
  varcScore?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Random_Question_Args = {
  quiz_id_from_args?: InputMaybe<Scalars['Int']['input']>;
};

export type Get_Speed_Concepts_All_Random_Questions_Args = {
  user_speed_test_summary_id_args?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Speed_Concepts_Random_Question_Args = {
  user_speed_test_summary_id_args?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "group_category" */
export type Group_Category = {
  __typename?: 'group_category';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "group_category" */
export type Group_Category_Aggregate = {
  __typename?: 'group_category_aggregate';
  aggregate?: Maybe<Group_Category_Aggregate_Fields>;
  nodes: Array<Group_Category>;
};

/** aggregate fields of "group_category" */
export type Group_Category_Aggregate_Fields = {
  __typename?: 'group_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Group_Category_Max_Fields>;
  min?: Maybe<Group_Category_Min_Fields>;
};


/** aggregate fields of "group_category" */
export type Group_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Group_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "group_category". All fields are combined with a logical 'AND'. */
export type Group_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Group_Category_Bool_Exp>>;
  _not?: InputMaybe<Group_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Group_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "group_category" */
export enum Group_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  GroupCategoryPkey = 'group_category_pkey',
  /** unique or primary key constraint on columns "slug" */
  GroupCategorySlugKey = 'group_category_slug_key'
}

/** input type for inserting data into table "group_category" */
export type Group_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Group_Category_Max_Fields = {
  __typename?: 'group_category_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Group_Category_Min_Fields = {
  __typename?: 'group_category_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "group_category" */
export type Group_Category_Mutation_Response = {
  __typename?: 'group_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Group_Category>;
};

/** input type for inserting object relation for remote table "group_category" */
export type Group_Category_Obj_Rel_Insert_Input = {
  data: Group_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Group_Category_On_Conflict>;
};

/** on_conflict condition type for table "group_category" */
export type Group_Category_On_Conflict = {
  constraint: Group_Category_Constraint;
  update_columns?: Array<Group_Category_Update_Column>;
  where?: InputMaybe<Group_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "group_category". */
export type Group_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: group_category */
export type Group_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "group_category" */
export enum Group_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "group_category" */
export type Group_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "group_category" */
export type Group_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Group_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Group_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "group_category" */
export enum Group_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Group_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Group_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Group_Category_Bool_Exp;
};

/** columns and relationships of "group_discount_users" */
export type Group_Discount_Users = {
  __typename?: 'group_discount_users';
  group_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  group_plan?: Maybe<Subscription_Group_Plan_Groups>;
  id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  subscription?: Maybe<Subscriptions_Subscriptionplan>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Supertokens_User_Additional_Fields>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "group_discount_users" */
export type Group_Discount_Users_Aggregate = {
  __typename?: 'group_discount_users_aggregate';
  aggregate?: Maybe<Group_Discount_Users_Aggregate_Fields>;
  nodes: Array<Group_Discount_Users>;
};

export type Group_Discount_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Group_Discount_Users_Aggregate_Bool_Exp_Count>;
};

export type Group_Discount_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Group_Discount_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Group_Discount_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "group_discount_users" */
export type Group_Discount_Users_Aggregate_Fields = {
  __typename?: 'group_discount_users_aggregate_fields';
  avg?: Maybe<Group_Discount_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Group_Discount_Users_Max_Fields>;
  min?: Maybe<Group_Discount_Users_Min_Fields>;
  stddev?: Maybe<Group_Discount_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Group_Discount_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Group_Discount_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Group_Discount_Users_Sum_Fields>;
  var_pop?: Maybe<Group_Discount_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Group_Discount_Users_Var_Samp_Fields>;
  variance?: Maybe<Group_Discount_Users_Variance_Fields>;
};


/** aggregate fields of "group_discount_users" */
export type Group_Discount_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Group_Discount_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "group_discount_users" */
export type Group_Discount_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Group_Discount_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Group_Discount_Users_Max_Order_By>;
  min?: InputMaybe<Group_Discount_Users_Min_Order_By>;
  stddev?: InputMaybe<Group_Discount_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Group_Discount_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Group_Discount_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Group_Discount_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Group_Discount_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Group_Discount_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Group_Discount_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "group_discount_users" */
export type Group_Discount_Users_Arr_Rel_Insert_Input = {
  data: Array<Group_Discount_Users_Insert_Input>;
};

/** aggregate avg on columns */
export type Group_Discount_Users_Avg_Fields = {
  __typename?: 'group_discount_users_avg_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "group_discount_users" */
export type Group_Discount_Users_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "group_discount_users". All fields are combined with a logical 'AND'. */
export type Group_Discount_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Group_Discount_Users_Bool_Exp>>;
  _not?: InputMaybe<Group_Discount_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Group_Discount_Users_Bool_Exp>>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  group_plan?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "group_discount_users" */
export type Group_Discount_Users_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "group_discount_users" */
export type Group_Discount_Users_Insert_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  group_plan?: InputMaybe<Subscription_Group_Plan_Groups_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscription?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Group_Discount_Users_Max_Fields = {
  __typename?: 'group_discount_users_max_fields';
  group_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "group_discount_users" */
export type Group_Discount_Users_Max_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Group_Discount_Users_Min_Fields = {
  __typename?: 'group_discount_users_min_fields';
  group_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "group_discount_users" */
export type Group_Discount_Users_Min_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "group_discount_users" */
export type Group_Discount_Users_Mutation_Response = {
  __typename?: 'group_discount_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Group_Discount_Users>;
};

/** Ordering options when selecting data from "group_discount_users". */
export type Group_Discount_Users_Order_By = {
  group_id?: InputMaybe<Order_By>;
  group_plan?: InputMaybe<Subscription_Group_Plan_Groups_Order_By>;
  id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "group_discount_users" */
export enum Group_Discount_Users_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "group_discount_users" */
export type Group_Discount_Users_Set_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Group_Discount_Users_Stddev_Fields = {
  __typename?: 'group_discount_users_stddev_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "group_discount_users" */
export type Group_Discount_Users_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Group_Discount_Users_Stddev_Pop_Fields = {
  __typename?: 'group_discount_users_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "group_discount_users" */
export type Group_Discount_Users_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Group_Discount_Users_Stddev_Samp_Fields = {
  __typename?: 'group_discount_users_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "group_discount_users" */
export type Group_Discount_Users_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "group_discount_users" */
export type Group_Discount_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Group_Discount_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Group_Discount_Users_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Group_Discount_Users_Sum_Fields = {
  __typename?: 'group_discount_users_sum_fields';
  group_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "group_discount_users" */
export type Group_Discount_Users_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

export type Group_Discount_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Group_Discount_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Group_Discount_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Group_Discount_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Group_Discount_Users_Var_Pop_Fields = {
  __typename?: 'group_discount_users_var_pop_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "group_discount_users" */
export type Group_Discount_Users_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Group_Discount_Users_Var_Samp_Fields = {
  __typename?: 'group_discount_users_var_samp_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "group_discount_users" */
export type Group_Discount_Users_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Group_Discount_Users_Variance_Fields = {
  __typename?: 'group_discount_users_variance_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "group_discount_users" */
export type Group_Discount_Users_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "has_access" */
export type Has_Access = {
  __typename?: 'has_access';
  exists?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "has_access" */
export type Has_Access_Aggregate = {
  __typename?: 'has_access_aggregate';
  aggregate?: Maybe<Has_Access_Aggregate_Fields>;
  nodes: Array<Has_Access>;
};

/** aggregate fields of "has_access" */
export type Has_Access_Aggregate_Fields = {
  __typename?: 'has_access_aggregate_fields';
  count: Scalars['Int']['output'];
};


/** aggregate fields of "has_access" */
export type Has_Access_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Has_Access_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "has_access". All fields are combined with a logical 'AND'. */
export type Has_Access_Bool_Exp = {
  _and?: InputMaybe<Array<Has_Access_Bool_Exp>>;
  _not?: InputMaybe<Has_Access_Bool_Exp>;
  _or?: InputMaybe<Array<Has_Access_Bool_Exp>>;
  exists?: InputMaybe<Boolean_Comparison_Exp>;
};

/** input type for inserting data into table "has_access" */
export type Has_Access_Insert_Input = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** response of any mutation on the table "has_access" */
export type Has_Access_Mutation_Response = {
  __typename?: 'has_access_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Has_Access>;
};

/** Ordering options when selecting data from "has_access". */
export type Has_Access_Order_By = {
  exists?: InputMaybe<Order_By>;
};

/** select columns of table "has_access" */
export enum Has_Access_Select_Column {
  /** column name */
  Exists = 'exists'
}

/** input type for updating data in table "has_access" */
export type Has_Access_Set_Input = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "has_access" */
export type Has_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Has_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Has_Access_Stream_Cursor_Value_Input = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Has_Access_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Has_Access_Set_Input>;
  /** filter the rows which have to be updated */
  where: Has_Access_Bool_Exp;
};

/** Boolean expression to compare columns of type "inet". All fields are combined with logical 'AND'. */
export type Inet_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['inet']['input']>;
  _gt?: InputMaybe<Scalars['inet']['input']>;
  _gte?: InputMaybe<Scalars['inet']['input']>;
  _in?: InputMaybe<Array<Scalars['inet']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['inet']['input']>;
  _lte?: InputMaybe<Scalars['inet']['input']>;
  _neq?: InputMaybe<Scalars['inet']['input']>;
  _nin?: InputMaybe<Array<Scalars['inet']['input']>>;
};

/** columns and relationships of "infozone_category" */
export type Infozone_Category = {
  __typename?: 'infozone_category';
  category?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "infozone_category" */
export type Infozone_Category_Aggregate = {
  __typename?: 'infozone_category_aggregate';
  aggregate?: Maybe<Infozone_Category_Aggregate_Fields>;
  nodes: Array<Infozone_Category>;
};

/** aggregate fields of "infozone_category" */
export type Infozone_Category_Aggregate_Fields = {
  __typename?: 'infozone_category_aggregate_fields';
  avg?: Maybe<Infozone_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Infozone_Category_Max_Fields>;
  min?: Maybe<Infozone_Category_Min_Fields>;
  stddev?: Maybe<Infozone_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Infozone_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Infozone_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Infozone_Category_Sum_Fields>;
  var_pop?: Maybe<Infozone_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Infozone_Category_Var_Samp_Fields>;
  variance?: Maybe<Infozone_Category_Variance_Fields>;
};


/** aggregate fields of "infozone_category" */
export type Infozone_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Infozone_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Infozone_Category_Avg_Fields = {
  __typename?: 'infozone_category_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "infozone_category". All fields are combined with a logical 'AND'. */
export type Infozone_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Infozone_Category_Bool_Exp>>;
  _not?: InputMaybe<Infozone_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Infozone_Category_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "infozone_category" */
export enum Infozone_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  InfozoneCategoryPkey = 'infozone_category_pkey'
}

/** input type for incrementing numeric columns in table "infozone_category" */
export type Infozone_Category_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "infozone_category" */
export type Infozone_Category_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Infozone_Category_Max_Fields = {
  __typename?: 'infozone_category_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Infozone_Category_Min_Fields = {
  __typename?: 'infozone_category_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "infozone_category" */
export type Infozone_Category_Mutation_Response = {
  __typename?: 'infozone_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Infozone_Category>;
};

/** on_conflict condition type for table "infozone_category" */
export type Infozone_Category_On_Conflict = {
  constraint: Infozone_Category_Constraint;
  update_columns?: Array<Infozone_Category_Update_Column>;
  where?: InputMaybe<Infozone_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "infozone_category". */
export type Infozone_Category_Order_By = {
  category?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: infozone_category */
export type Infozone_Category_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "infozone_category" */
export enum Infozone_Category_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "infozone_category" */
export type Infozone_Category_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Infozone_Category_Stddev_Fields = {
  __typename?: 'infozone_category_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Infozone_Category_Stddev_Pop_Fields = {
  __typename?: 'infozone_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Infozone_Category_Stddev_Samp_Fields = {
  __typename?: 'infozone_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "infozone_category" */
export type Infozone_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Infozone_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Infozone_Category_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Infozone_Category_Sum_Fields = {
  __typename?: 'infozone_category_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "infozone_category" */
export enum Infozone_Category_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Infozone_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Infozone_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Infozone_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Infozone_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Infozone_Category_Var_Pop_Fields = {
  __typename?: 'infozone_category_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Infozone_Category_Var_Samp_Fields = {
  __typename?: 'infozone_category_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Infozone_Category_Variance_Fields = {
  __typename?: 'infozone_category_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "infozone_infozone" */
export type Infozone_Infozone = {
  __typename?: 'infozone_infozone';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  _preview_content_rendered?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  info_type: Scalars['String']['output'];
  /** A computed field, executes function "get_next_infozone_item" */
  next_item?: Maybe<Array<Infozone_Infozone>>;
  preview_content?: Maybe<Scalars['String']['output']>;
  preview_content_markup_type?: Maybe<Scalars['String']['output']>;
  preview_image?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_previous_infozone_item" */
  previous_item?: Maybe<Array<Infozone_Infozone>>;
  rank?: Maybe<Scalars['smallint']['output']>;
  remove_menu: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "infozone_infozone" */
export type Infozone_InfozoneNext_ItemArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Infozone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Infozone_Order_By>>;
  where?: InputMaybe<Infozone_Infozone_Bool_Exp>;
};


/** columns and relationships of "infozone_infozone" */
export type Infozone_InfozonePrevious_ItemArgs = {
  distinct_on?: InputMaybe<Array<Infozone_Infozone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infozone_Infozone_Order_By>>;
  where?: InputMaybe<Infozone_Infozone_Bool_Exp>;
};

/** aggregated selection of "infozone_infozone" */
export type Infozone_Infozone_Aggregate = {
  __typename?: 'infozone_infozone_aggregate';
  aggregate?: Maybe<Infozone_Infozone_Aggregate_Fields>;
  nodes: Array<Infozone_Infozone>;
};

/** aggregate fields of "infozone_infozone" */
export type Infozone_Infozone_Aggregate_Fields = {
  __typename?: 'infozone_infozone_aggregate_fields';
  avg?: Maybe<Infozone_Infozone_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Infozone_Infozone_Max_Fields>;
  min?: Maybe<Infozone_Infozone_Min_Fields>;
  stddev?: Maybe<Infozone_Infozone_Stddev_Fields>;
  stddev_pop?: Maybe<Infozone_Infozone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Infozone_Infozone_Stddev_Samp_Fields>;
  sum?: Maybe<Infozone_Infozone_Sum_Fields>;
  var_pop?: Maybe<Infozone_Infozone_Var_Pop_Fields>;
  var_samp?: Maybe<Infozone_Infozone_Var_Samp_Fields>;
  variance?: Maybe<Infozone_Infozone_Variance_Fields>;
};


/** aggregate fields of "infozone_infozone" */
export type Infozone_Infozone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Infozone_Infozone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "infozone_infozone" */
export type Infozone_Infozone_Aggregate_Order_By = {
  avg?: InputMaybe<Infozone_Infozone_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Infozone_Infozone_Max_Order_By>;
  min?: InputMaybe<Infozone_Infozone_Min_Order_By>;
  stddev?: InputMaybe<Infozone_Infozone_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Infozone_Infozone_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Infozone_Infozone_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Infozone_Infozone_Sum_Order_By>;
  var_pop?: InputMaybe<Infozone_Infozone_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Infozone_Infozone_Var_Samp_Order_By>;
  variance?: InputMaybe<Infozone_Infozone_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Infozone_Infozone_Avg_Fields = {
  __typename?: 'infozone_infozone_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "infozone_infozone". All fields are combined with a logical 'AND'. */
export type Infozone_Infozone_Bool_Exp = {
  _and?: InputMaybe<Array<Infozone_Infozone_Bool_Exp>>;
  _content_rendered?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Infozone_Infozone_Bool_Exp>;
  _or?: InputMaybe<Array<Infozone_Infozone_Bool_Exp>>;
  _preview_content_rendered?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  content_markup_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  info_type?: InputMaybe<String_Comparison_Exp>;
  next_item?: InputMaybe<Infozone_Infozone_Bool_Exp>;
  preview_content?: InputMaybe<String_Comparison_Exp>;
  preview_content_markup_type?: InputMaybe<String_Comparison_Exp>;
  preview_image?: InputMaybe<String_Comparison_Exp>;
  previous_item?: InputMaybe<Infozone_Infozone_Bool_Exp>;
  rank?: InputMaybe<Smallint_Comparison_Exp>;
  remove_menu?: InputMaybe<Boolean_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "infozone_infozone" */
export enum Infozone_Infozone_Constraint {
  /** unique or primary key constraint on columns "id" */
  InfozoneInfozonePkey = 'infozone_infozone_pkey',
  /** unique or primary key constraint on columns "slug" */
  InfozoneInfozoneSlugKey = 'infozone_infozone_slug_key'
}

/** input type for incrementing numeric columns in table "infozone_infozone" */
export type Infozone_Infozone_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "infozone_infozone" */
export type Infozone_Infozone_Insert_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  _preview_content_rendered?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info_type?: InputMaybe<Scalars['String']['input']>;
  preview_content?: InputMaybe<Scalars['String']['input']>;
  preview_content_markup_type?: InputMaybe<Scalars['String']['input']>;
  preview_image?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  remove_menu?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Infozone_Infozone_Max_Fields = {
  __typename?: 'infozone_infozone_max_fields';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  _preview_content_rendered?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  info_type?: Maybe<Scalars['String']['output']>;
  preview_content?: Maybe<Scalars['String']['output']>;
  preview_content_markup_type?: Maybe<Scalars['String']['output']>;
  preview_image?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Max_Order_By = {
  _content_rendered?: InputMaybe<Order_By>;
  _preview_content_rendered?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_markup_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info_type?: InputMaybe<Order_By>;
  preview_content?: InputMaybe<Order_By>;
  preview_content_markup_type?: InputMaybe<Order_By>;
  preview_image?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Infozone_Infozone_Min_Fields = {
  __typename?: 'infozone_infozone_min_fields';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  _preview_content_rendered?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  info_type?: Maybe<Scalars['String']['output']>;
  preview_content?: Maybe<Scalars['String']['output']>;
  preview_content_markup_type?: Maybe<Scalars['String']['output']>;
  preview_image?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Min_Order_By = {
  _content_rendered?: InputMaybe<Order_By>;
  _preview_content_rendered?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_markup_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info_type?: InputMaybe<Order_By>;
  preview_content?: InputMaybe<Order_By>;
  preview_content_markup_type?: InputMaybe<Order_By>;
  preview_image?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "infozone_infozone" */
export type Infozone_Infozone_Mutation_Response = {
  __typename?: 'infozone_infozone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Infozone_Infozone>;
};

/** on_conflict condition type for table "infozone_infozone" */
export type Infozone_Infozone_On_Conflict = {
  constraint: Infozone_Infozone_Constraint;
  update_columns?: Array<Infozone_Infozone_Update_Column>;
  where?: InputMaybe<Infozone_Infozone_Bool_Exp>;
};

/** Ordering options when selecting data from "infozone_infozone". */
export type Infozone_Infozone_Order_By = {
  _content_rendered?: InputMaybe<Order_By>;
  _preview_content_rendered?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_markup_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info_type?: InputMaybe<Order_By>;
  next_item_aggregate?: InputMaybe<Infozone_Infozone_Aggregate_Order_By>;
  preview_content?: InputMaybe<Order_By>;
  preview_content_markup_type?: InputMaybe<Order_By>;
  preview_image?: InputMaybe<Order_By>;
  previous_item_aggregate?: InputMaybe<Infozone_Infozone_Aggregate_Order_By>;
  rank?: InputMaybe<Order_By>;
  remove_menu?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: infozone_infozone */
export type Infozone_Infozone_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "infozone_infozone" */
export enum Infozone_Infozone_Select_Column {
  /** column name */
  ContentRendered = '_content_rendered',
  /** column name */
  PreviewContentRendered = '_preview_content_rendered',
  /** column name */
  Content = 'content',
  /** column name */
  ContentMarkupType = 'content_markup_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  InfoType = 'info_type',
  /** column name */
  PreviewContent = 'preview_content',
  /** column name */
  PreviewContentMarkupType = 'preview_content_markup_type',
  /** column name */
  PreviewImage = 'preview_image',
  /** column name */
  Rank = 'rank',
  /** column name */
  RemoveMenu = 'remove_menu',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "infozone_infozone" */
export type Infozone_Infozone_Set_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  _preview_content_rendered?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info_type?: InputMaybe<Scalars['String']['input']>;
  preview_content?: InputMaybe<Scalars['String']['input']>;
  preview_content_markup_type?: InputMaybe<Scalars['String']['input']>;
  preview_image?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  remove_menu?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Infozone_Infozone_Stddev_Fields = {
  __typename?: 'infozone_infozone_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Infozone_Infozone_Stddev_Pop_Fields = {
  __typename?: 'infozone_infozone_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Infozone_Infozone_Stddev_Samp_Fields = {
  __typename?: 'infozone_infozone_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "infozone_infozone" */
export type Infozone_Infozone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Infozone_Infozone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Infozone_Infozone_Stream_Cursor_Value_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  _preview_content_rendered?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info_type?: InputMaybe<Scalars['String']['input']>;
  preview_content?: InputMaybe<Scalars['String']['input']>;
  preview_content_markup_type?: InputMaybe<Scalars['String']['input']>;
  preview_image?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  remove_menu?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Infozone_Infozone_Sum_Fields = {
  __typename?: 'infozone_infozone_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** update columns of table "infozone_infozone" */
export enum Infozone_Infozone_Update_Column {
  /** column name */
  ContentRendered = '_content_rendered',
  /** column name */
  PreviewContentRendered = '_preview_content_rendered',
  /** column name */
  Content = 'content',
  /** column name */
  ContentMarkupType = 'content_markup_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  InfoType = 'info_type',
  /** column name */
  PreviewContent = 'preview_content',
  /** column name */
  PreviewContentMarkupType = 'preview_content_markup_type',
  /** column name */
  PreviewImage = 'preview_image',
  /** column name */
  Rank = 'rank',
  /** column name */
  RemoveMenu = 'remove_menu',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Infozone_Infozone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Infozone_Infozone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Infozone_Infozone_Set_Input>;
  /** filter the rows which have to be updated */
  where: Infozone_Infozone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Infozone_Infozone_Var_Pop_Fields = {
  __typename?: 'infozone_infozone_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Infozone_Infozone_Var_Samp_Fields = {
  __typename?: 'infozone_infozone_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Infozone_Infozone_Variance_Fields = {
  __typename?: 'infozone_infozone_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "infozone_infozone" */
export type Infozone_Infozone_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** columns and relationships of "infozone_staticpages" */
export type Infozone_Staticpages = {
  __typename?: 'infozone_staticpages';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type: Scalars['String']['output'];
  created_date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  remove_menu: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "infozone_staticpages" */
export type Infozone_Staticpages_Aggregate = {
  __typename?: 'infozone_staticpages_aggregate';
  aggregate?: Maybe<Infozone_Staticpages_Aggregate_Fields>;
  nodes: Array<Infozone_Staticpages>;
};

/** aggregate fields of "infozone_staticpages" */
export type Infozone_Staticpages_Aggregate_Fields = {
  __typename?: 'infozone_staticpages_aggregate_fields';
  avg?: Maybe<Infozone_Staticpages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Infozone_Staticpages_Max_Fields>;
  min?: Maybe<Infozone_Staticpages_Min_Fields>;
  stddev?: Maybe<Infozone_Staticpages_Stddev_Fields>;
  stddev_pop?: Maybe<Infozone_Staticpages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Infozone_Staticpages_Stddev_Samp_Fields>;
  sum?: Maybe<Infozone_Staticpages_Sum_Fields>;
  var_pop?: Maybe<Infozone_Staticpages_Var_Pop_Fields>;
  var_samp?: Maybe<Infozone_Staticpages_Var_Samp_Fields>;
  variance?: Maybe<Infozone_Staticpages_Variance_Fields>;
};


/** aggregate fields of "infozone_staticpages" */
export type Infozone_Staticpages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Infozone_Staticpages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Infozone_Staticpages_Avg_Fields = {
  __typename?: 'infozone_staticpages_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "infozone_staticpages". All fields are combined with a logical 'AND'. */
export type Infozone_Staticpages_Bool_Exp = {
  _and?: InputMaybe<Array<Infozone_Staticpages_Bool_Exp>>;
  _content_rendered?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Infozone_Staticpages_Bool_Exp>;
  _or?: InputMaybe<Array<Infozone_Staticpages_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  content_markup_type?: InputMaybe<String_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  remove_menu?: InputMaybe<Boolean_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "infozone_staticpages" */
export enum Infozone_Staticpages_Constraint {
  /** unique or primary key constraint on columns "id" */
  InfozoneStaticpagesPkey = 'infozone_staticpages_pkey',
  /** unique or primary key constraint on columns "slug" */
  InfozoneStaticpagesSlugKey = 'infozone_staticpages_slug_key'
}

/** input type for incrementing numeric columns in table "infozone_staticpages" */
export type Infozone_Staticpages_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "infozone_staticpages" */
export type Infozone_Staticpages_Insert_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  remove_menu?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Infozone_Staticpages_Max_Fields = {
  __typename?: 'infozone_staticpages_max_fields';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Infozone_Staticpages_Min_Fields = {
  __typename?: 'infozone_staticpages_min_fields';
  _content_rendered?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_markup_type?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "infozone_staticpages" */
export type Infozone_Staticpages_Mutation_Response = {
  __typename?: 'infozone_staticpages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Infozone_Staticpages>;
};

/** on_conflict condition type for table "infozone_staticpages" */
export type Infozone_Staticpages_On_Conflict = {
  constraint: Infozone_Staticpages_Constraint;
  update_columns?: Array<Infozone_Staticpages_Update_Column>;
  where?: InputMaybe<Infozone_Staticpages_Bool_Exp>;
};

/** Ordering options when selecting data from "infozone_staticpages". */
export type Infozone_Staticpages_Order_By = {
  _content_rendered?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_markup_type?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remove_menu?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: infozone_staticpages */
export type Infozone_Staticpages_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "infozone_staticpages" */
export enum Infozone_Staticpages_Select_Column {
  /** column name */
  ContentRendered = '_content_rendered',
  /** column name */
  Content = 'content',
  /** column name */
  ContentMarkupType = 'content_markup_type',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  RemoveMenu = 'remove_menu',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "infozone_staticpages" */
export type Infozone_Staticpages_Set_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  remove_menu?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Infozone_Staticpages_Stddev_Fields = {
  __typename?: 'infozone_staticpages_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Infozone_Staticpages_Stddev_Pop_Fields = {
  __typename?: 'infozone_staticpages_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Infozone_Staticpages_Stddev_Samp_Fields = {
  __typename?: 'infozone_staticpages_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "infozone_staticpages" */
export type Infozone_Staticpages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Infozone_Staticpages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Infozone_Staticpages_Stream_Cursor_Value_Input = {
  _content_rendered?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_markup_type?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  remove_menu?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Infozone_Staticpages_Sum_Fields = {
  __typename?: 'infozone_staticpages_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "infozone_staticpages" */
export enum Infozone_Staticpages_Update_Column {
  /** column name */
  ContentRendered = '_content_rendered',
  /** column name */
  Content = 'content',
  /** column name */
  ContentMarkupType = 'content_markup_type',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Id = 'id',
  /** column name */
  RemoveMenu = 'remove_menu',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Infozone_Staticpages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Infozone_Staticpages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Infozone_Staticpages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Infozone_Staticpages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Infozone_Staticpages_Var_Pop_Fields = {
  __typename?: 'infozone_staticpages_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Infozone_Staticpages_Var_Samp_Fields = {
  __typename?: 'infozone_staticpages_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Infozone_Staticpages_Variance_Fields = {
  __typename?: 'infozone_staticpages_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type Interval_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['interval']['input']>;
  _gt?: InputMaybe<Scalars['interval']['input']>;
  _gte?: InputMaybe<Scalars['interval']['input']>;
  _in?: InputMaybe<Array<Scalars['interval']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['interval']['input']>;
  _lte?: InputMaybe<Scalars['interval']['input']>;
  _neq?: InputMaybe<Scalars['interval']['input']>;
  _nin?: InputMaybe<Array<Scalars['interval']['input']>>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard = {
  __typename?: 'live_quiz_leaderboard';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  quiz_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_quiz: Quiz_Quiz;
  rank: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Supertokens_User_Public_Fields>;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Aggregate = {
  __typename?: 'live_quiz_leaderboard_aggregate';
  aggregate?: Maybe<Live_Quiz_Leaderboard_Aggregate_Fields>;
  nodes: Array<Live_Quiz_Leaderboard>;
};

export type Live_Quiz_Leaderboard_Aggregate_Bool_Exp = {
  count?: InputMaybe<Live_Quiz_Leaderboard_Aggregate_Bool_Exp_Count>;
};

export type Live_Quiz_Leaderboard_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Live_Quiz_Leaderboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Aggregate_Fields = {
  __typename?: 'live_quiz_leaderboard_aggregate_fields';
  avg?: Maybe<Live_Quiz_Leaderboard_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Live_Quiz_Leaderboard_Max_Fields>;
  min?: Maybe<Live_Quiz_Leaderboard_Min_Fields>;
  stddev?: Maybe<Live_Quiz_Leaderboard_Stddev_Fields>;
  stddev_pop?: Maybe<Live_Quiz_Leaderboard_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Live_Quiz_Leaderboard_Stddev_Samp_Fields>;
  sum?: Maybe<Live_Quiz_Leaderboard_Sum_Fields>;
  var_pop?: Maybe<Live_Quiz_Leaderboard_Var_Pop_Fields>;
  var_samp?: Maybe<Live_Quiz_Leaderboard_Var_Samp_Fields>;
  variance?: Maybe<Live_Quiz_Leaderboard_Variance_Fields>;
};


/** aggregate fields of "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Live_Quiz_Leaderboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Aggregate_Order_By = {
  avg?: InputMaybe<Live_Quiz_Leaderboard_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Live_Quiz_Leaderboard_Max_Order_By>;
  min?: InputMaybe<Live_Quiz_Leaderboard_Min_Order_By>;
  stddev?: InputMaybe<Live_Quiz_Leaderboard_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Live_Quiz_Leaderboard_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Live_Quiz_Leaderboard_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Live_Quiz_Leaderboard_Sum_Order_By>;
  var_pop?: InputMaybe<Live_Quiz_Leaderboard_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Live_Quiz_Leaderboard_Var_Samp_Order_By>;
  variance?: InputMaybe<Live_Quiz_Leaderboard_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Arr_Rel_Insert_Input = {
  data: Array<Live_Quiz_Leaderboard_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Live_Quiz_Leaderboard_On_Conflict>;
};

/** aggregate avg on columns */
export type Live_Quiz_Leaderboard_Avg_Fields = {
  __typename?: 'live_quiz_leaderboard_avg_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Avg_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "live_quiz_leaderboard". All fields are combined with a logical 'AND'. */
export type Live_Quiz_Leaderboard_Bool_Exp = {
  _and?: InputMaybe<Array<Live_Quiz_Leaderboard_Bool_Exp>>;
  _not?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
  _or?: InputMaybe<Array<Live_Quiz_Leaderboard_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "live_quiz_leaderboard" */
export enum Live_Quiz_Leaderboard_Constraint {
  /** unique or primary key constraint on columns "id" */
  LiveQuizLeaderboardPkey = 'live_quiz_leaderboard_pkey',
  /** unique or primary key constraint on columns "quiz_id", "user_id" */
  LiveQuizLeaderboardQuizIdUserIdKey = 'live_quiz_leaderboard_quiz_id_user_id_key'
}

/** input type for incrementing numeric columns in table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Inc_Input = {
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Live_Quiz_Leaderboard_Max_Fields = {
  __typename?: 'live_quiz_leaderboard_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Live_Quiz_Leaderboard_Min_Fields = {
  __typename?: 'live_quiz_leaderboard_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Mutation_Response = {
  __typename?: 'live_quiz_leaderboard_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Live_Quiz_Leaderboard>;
};

/** on_conflict condition type for table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_On_Conflict = {
  constraint: Live_Quiz_Leaderboard_Constraint;
  update_columns?: Array<Live_Quiz_Leaderboard_Update_Column>;
  where?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
};

/** Ordering options when selecting data from "live_quiz_leaderboard". */
export type Live_Quiz_Leaderboard_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: live_quiz_leaderboard */
export type Live_Quiz_Leaderboard_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "live_quiz_leaderboard" */
export enum Live_Quiz_Leaderboard_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Live_Quiz_Leaderboard_Stddev_Fields = {
  __typename?: 'live_quiz_leaderboard_stddev_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Stddev_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Live_Quiz_Leaderboard_Stddev_Pop_Fields = {
  __typename?: 'live_quiz_leaderboard_stddev_pop_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Stddev_Pop_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Live_Quiz_Leaderboard_Stddev_Samp_Fields = {
  __typename?: 'live_quiz_leaderboard_stddev_samp_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Stddev_Samp_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Live_Quiz_Leaderboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Quiz_Leaderboard_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Live_Quiz_Leaderboard_Sum_Fields = {
  __typename?: 'live_quiz_leaderboard_sum_fields';
  quiz_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Sum_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** update columns of table "live_quiz_leaderboard" */
export enum Live_Quiz_Leaderboard_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Live_Quiz_Leaderboard_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Live_Quiz_Leaderboard_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Live_Quiz_Leaderboard_Set_Input>;
  /** filter the rows which have to be updated */
  where: Live_Quiz_Leaderboard_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Live_Quiz_Leaderboard_Var_Pop_Fields = {
  __typename?: 'live_quiz_leaderboard_var_pop_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Var_Pop_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Live_Quiz_Leaderboard_Var_Samp_Fields = {
  __typename?: 'live_quiz_leaderboard_var_samp_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Var_Samp_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Live_Quiz_Leaderboard_Variance_Fields = {
  __typename?: 'live_quiz_leaderboard_variance_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "live_quiz_leaderboard" */
export type Live_Quiz_Leaderboard_Variance_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** columns and relationships of "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions = {
  __typename?: 'live_quiz_question_positions';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  live_quiz_question_summary?: Maybe<Live_Quiz_Question_Summary>;
  /** An object relationship */
  live_quiz_summary: Live_Quiz_Summary;
  live_quiz_summary_id: Scalars['uuid']['output'];
  position: Scalars['Int']['output'];
  question_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Aggregate = {
  __typename?: 'live_quiz_question_positions_aggregate';
  aggregate?: Maybe<Live_Quiz_Question_Positions_Aggregate_Fields>;
  nodes: Array<Live_Quiz_Question_Positions>;
};

export type Live_Quiz_Question_Positions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Live_Quiz_Question_Positions_Aggregate_Bool_Exp_Count>;
};

export type Live_Quiz_Question_Positions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Aggregate_Fields = {
  __typename?: 'live_quiz_question_positions_aggregate_fields';
  avg?: Maybe<Live_Quiz_Question_Positions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Live_Quiz_Question_Positions_Max_Fields>;
  min?: Maybe<Live_Quiz_Question_Positions_Min_Fields>;
  stddev?: Maybe<Live_Quiz_Question_Positions_Stddev_Fields>;
  stddev_pop?: Maybe<Live_Quiz_Question_Positions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Live_Quiz_Question_Positions_Stddev_Samp_Fields>;
  sum?: Maybe<Live_Quiz_Question_Positions_Sum_Fields>;
  var_pop?: Maybe<Live_Quiz_Question_Positions_Var_Pop_Fields>;
  var_samp?: Maybe<Live_Quiz_Question_Positions_Var_Samp_Fields>;
  variance?: Maybe<Live_Quiz_Question_Positions_Variance_Fields>;
};


/** aggregate fields of "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Aggregate_Order_By = {
  avg?: InputMaybe<Live_Quiz_Question_Positions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Live_Quiz_Question_Positions_Max_Order_By>;
  min?: InputMaybe<Live_Quiz_Question_Positions_Min_Order_By>;
  stddev?: InputMaybe<Live_Quiz_Question_Positions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Live_Quiz_Question_Positions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Live_Quiz_Question_Positions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Live_Quiz_Question_Positions_Sum_Order_By>;
  var_pop?: InputMaybe<Live_Quiz_Question_Positions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Live_Quiz_Question_Positions_Var_Samp_Order_By>;
  variance?: InputMaybe<Live_Quiz_Question_Positions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Arr_Rel_Insert_Input = {
  data: Array<Live_Quiz_Question_Positions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Live_Quiz_Question_Positions_On_Conflict>;
};

/** aggregate avg on columns */
export type Live_Quiz_Question_Positions_Avg_Fields = {
  __typename?: 'live_quiz_question_positions_avg_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Avg_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "live_quiz_question_positions". All fields are combined with a logical 'AND'. */
export type Live_Quiz_Question_Positions_Bool_Exp = {
  _and?: InputMaybe<Array<Live_Quiz_Question_Positions_Bool_Exp>>;
  _not?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
  _or?: InputMaybe<Array<Live_Quiz_Question_Positions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  live_quiz_question_summary?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
  live_quiz_summary?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
  live_quiz_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
  position?: InputMaybe<Int_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "live_quiz_question_positions" */
export enum Live_Quiz_Question_Positions_Constraint {
  /** unique or primary key constraint on columns "id" */
  LiveQuizQuestionPositionsPkey = 'live_quiz_question_positions_pkey'
}

/** input type for incrementing numeric columns in table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Inc_Input = {
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  live_quiz_question_summary?: InputMaybe<Live_Quiz_Question_Summary_Obj_Rel_Insert_Input>;
  live_quiz_summary?: InputMaybe<Live_Quiz_Summary_Obj_Rel_Insert_Input>;
  live_quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Live_Quiz_Question_Positions_Max_Fields = {
  __typename?: 'live_quiz_question_positions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  live_quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  live_quiz_summary_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Live_Quiz_Question_Positions_Min_Fields = {
  __typename?: 'live_quiz_question_positions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  live_quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  live_quiz_summary_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Mutation_Response = {
  __typename?: 'live_quiz_question_positions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Live_Quiz_Question_Positions>;
};

/** on_conflict condition type for table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_On_Conflict = {
  constraint: Live_Quiz_Question_Positions_Constraint;
  update_columns?: Array<Live_Quiz_Question_Positions_Update_Column>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};

/** Ordering options when selecting data from "live_quiz_question_positions". */
export type Live_Quiz_Question_Positions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  live_quiz_question_summary?: InputMaybe<Live_Quiz_Question_Summary_Order_By>;
  live_quiz_summary?: InputMaybe<Live_Quiz_Summary_Order_By>;
  live_quiz_summary_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: live_quiz_question_positions */
export type Live_Quiz_Question_Positions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "live_quiz_question_positions" */
export enum Live_Quiz_Question_Positions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LiveQuizSummaryId = 'live_quiz_summary_id',
  /** column name */
  Position = 'position',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  live_quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Live_Quiz_Question_Positions_Stddev_Fields = {
  __typename?: 'live_quiz_question_positions_stddev_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Stddev_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Live_Quiz_Question_Positions_Stddev_Pop_Fields = {
  __typename?: 'live_quiz_question_positions_stddev_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Stddev_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Live_Quiz_Question_Positions_Stddev_Samp_Fields = {
  __typename?: 'live_quiz_question_positions_stddev_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Stddev_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Live_Quiz_Question_Positions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Quiz_Question_Positions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  live_quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Live_Quiz_Question_Positions_Sum_Fields = {
  __typename?: 'live_quiz_question_positions_sum_fields';
  position?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Sum_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** update columns of table "live_quiz_question_positions" */
export enum Live_Quiz_Question_Positions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LiveQuizSummaryId = 'live_quiz_summary_id',
  /** column name */
  Position = 'position',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Live_Quiz_Question_Positions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Live_Quiz_Question_Positions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Live_Quiz_Question_Positions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Live_Quiz_Question_Positions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Live_Quiz_Question_Positions_Var_Pop_Fields = {
  __typename?: 'live_quiz_question_positions_var_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Var_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Live_Quiz_Question_Positions_Var_Samp_Fields = {
  __typename?: 'live_quiz_question_positions_var_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Var_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Live_Quiz_Question_Positions_Variance_Fields = {
  __typename?: 'live_quiz_question_positions_variance_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "live_quiz_question_positions" */
export type Live_Quiz_Question_Positions_Variance_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary = {
  __typename?: 'live_quiz_question_summary';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_attempted: Scalars['Boolean']['output'];
  is_correct: Scalars['Boolean']['output'];
  /** An object relationship */
  live_quiz_summary: Live_Quiz_Summary;
  marks: Scalars['numeric']['output'];
  question_id: Scalars['Int']['output'];
  question_position: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  quiz_summary_id: Scalars['uuid']['output'];
  response?: Maybe<Scalars['String']['output']>;
  time_taken: Scalars['interval']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Aggregate = {
  __typename?: 'live_quiz_question_summary_aggregate';
  aggregate?: Maybe<Live_Quiz_Question_Summary_Aggregate_Fields>;
  nodes: Array<Live_Quiz_Question_Summary>;
};

export type Live_Quiz_Question_Summary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Count>;
};

export type Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Bool_And = {
  arguments: Live_Quiz_Question_Summary_Select_Column_Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Live_Quiz_Question_Summary_Select_Column_Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Aggregate_Fields = {
  __typename?: 'live_quiz_question_summary_aggregate_fields';
  avg?: Maybe<Live_Quiz_Question_Summary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Live_Quiz_Question_Summary_Max_Fields>;
  min?: Maybe<Live_Quiz_Question_Summary_Min_Fields>;
  stddev?: Maybe<Live_Quiz_Question_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Live_Quiz_Question_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Live_Quiz_Question_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Live_Quiz_Question_Summary_Sum_Fields>;
  var_pop?: Maybe<Live_Quiz_Question_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Live_Quiz_Question_Summary_Var_Samp_Fields>;
  variance?: Maybe<Live_Quiz_Question_Summary_Variance_Fields>;
};


/** aggregate fields of "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Aggregate_Order_By = {
  avg?: InputMaybe<Live_Quiz_Question_Summary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Live_Quiz_Question_Summary_Max_Order_By>;
  min?: InputMaybe<Live_Quiz_Question_Summary_Min_Order_By>;
  stddev?: InputMaybe<Live_Quiz_Question_Summary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Live_Quiz_Question_Summary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Live_Quiz_Question_Summary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Live_Quiz_Question_Summary_Sum_Order_By>;
  var_pop?: InputMaybe<Live_Quiz_Question_Summary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Live_Quiz_Question_Summary_Var_Samp_Order_By>;
  variance?: InputMaybe<Live_Quiz_Question_Summary_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Arr_Rel_Insert_Input = {
  data: Array<Live_Quiz_Question_Summary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Live_Quiz_Question_Summary_On_Conflict>;
};

/** aggregate avg on columns */
export type Live_Quiz_Question_Summary_Avg_Fields = {
  __typename?: 'live_quiz_question_summary_avg_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Avg_Order_By = {
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "live_quiz_question_summary". All fields are combined with a logical 'AND'. */
export type Live_Quiz_Question_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Live_Quiz_Question_Summary_Bool_Exp>>;
  _not?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Live_Quiz_Question_Summary_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_attempted?: InputMaybe<Boolean_Comparison_Exp>;
  is_correct?: InputMaybe<Boolean_Comparison_Exp>;
  live_quiz_summary?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
  marks?: InputMaybe<Numeric_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  question_position?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
  response?: InputMaybe<String_Comparison_Exp>;
  time_taken?: InputMaybe<Interval_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "live_quiz_question_summary" */
export enum Live_Quiz_Question_Summary_Constraint {
  /** unique or primary key constraint on columns "id" */
  LiveQuizQuestionSummaryPkey = 'live_quiz_question_summary_pkey',
  /** unique or primary key constraint on columns "question_id", "quiz_summary_id" */
  LiveQuizQuestionSummaryQuizSummaryIdQuestionIdKey = 'live_quiz_question_summary_quiz_summary_id_question_id_key'
}

/** input type for incrementing numeric columns in table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Inc_Input = {
  marks?: InputMaybe<Scalars['numeric']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  question_position?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  live_quiz_summary?: InputMaybe<Live_Quiz_Summary_Obj_Rel_Insert_Input>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  question_position?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Live_Quiz_Question_Summary_Max_Fields = {
  __typename?: 'live_quiz_question_summary_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  question_position?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Live_Quiz_Question_Summary_Min_Fields = {
  __typename?: 'live_quiz_question_summary_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  question_position?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Mutation_Response = {
  __typename?: 'live_quiz_question_summary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Live_Quiz_Question_Summary>;
};

/** input type for inserting object relation for remote table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Obj_Rel_Insert_Input = {
  data: Live_Quiz_Question_Summary_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Live_Quiz_Question_Summary_On_Conflict>;
};

/** on_conflict condition type for table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_On_Conflict = {
  constraint: Live_Quiz_Question_Summary_Constraint;
  update_columns?: Array<Live_Quiz_Question_Summary_Update_Column>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};

/** Ordering options when selecting data from "live_quiz_question_summary". */
export type Live_Quiz_Question_Summary_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_attempted?: InputMaybe<Order_By>;
  is_correct?: InputMaybe<Order_By>;
  live_quiz_summary?: InputMaybe<Live_Quiz_Summary_Order_By>;
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: live_quiz_question_summary */
export type Live_Quiz_Question_Summary_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "live_quiz_question_summary" */
export enum Live_Quiz_Question_Summary_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  Marks = 'marks',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionPosition = 'question_position',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  Response = 'response',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "live_quiz_question_summary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "live_quiz_question_summary" */
export enum Live_Quiz_Question_Summary_Select_Column_Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsCorrect = 'is_correct'
}

/** select "live_quiz_question_summary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "live_quiz_question_summary" */
export enum Live_Quiz_Question_Summary_Select_Column_Live_Quiz_Question_Summary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsCorrect = 'is_correct'
}

/** input type for updating data in table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  question_position?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Live_Quiz_Question_Summary_Stddev_Fields = {
  __typename?: 'live_quiz_question_summary_stddev_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Stddev_Order_By = {
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Live_Quiz_Question_Summary_Stddev_Pop_Fields = {
  __typename?: 'live_quiz_question_summary_stddev_pop_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Stddev_Pop_Order_By = {
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Live_Quiz_Question_Summary_Stddev_Samp_Fields = {
  __typename?: 'live_quiz_question_summary_stddev_samp_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Stddev_Samp_Order_By = {
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Live_Quiz_Question_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Quiz_Question_Summary_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  question_position?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Live_Quiz_Question_Summary_Sum_Fields = {
  __typename?: 'live_quiz_question_summary_sum_fields';
  marks?: Maybe<Scalars['numeric']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  question_position?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Sum_Order_By = {
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
};

/** update columns of table "live_quiz_question_summary" */
export enum Live_Quiz_Question_Summary_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  Marks = 'marks',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionPosition = 'question_position',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  Response = 'response',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Live_Quiz_Question_Summary_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Live_Quiz_Question_Summary_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Live_Quiz_Question_Summary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Live_Quiz_Question_Summary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Live_Quiz_Question_Summary_Var_Pop_Fields = {
  __typename?: 'live_quiz_question_summary_var_pop_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Var_Pop_Order_By = {
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Live_Quiz_Question_Summary_Var_Samp_Fields = {
  __typename?: 'live_quiz_question_summary_var_samp_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Var_Samp_Order_By = {
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Live_Quiz_Question_Summary_Variance_Fields = {
  __typename?: 'live_quiz_question_summary_variance_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "live_quiz_question_summary" */
export type Live_Quiz_Question_Summary_Variance_Order_By = {
  marks?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
};

/** columns and relationships of "live_quiz_summary" */
export type Live_Quiz_Summary = {
  __typename?: 'live_quiz_summary';
  /** An object relationship */
  all_auth_recipe_user?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  created_at: Scalars['timestamptz']['output'];
  current_position: Scalars['Int']['output'];
  current_question?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  is_completed: Scalars['Boolean']['output'];
  /** An array relationship */
  live_quiz_question_positions: Array<Live_Quiz_Question_Positions>;
  /** An aggregate relationship */
  live_quiz_question_positions_aggregate: Live_Quiz_Question_Positions_Aggregate;
  /** An array relationship */
  live_quiz_question_summaries: Array<Live_Quiz_Question_Summary>;
  /** An aggregate relationship */
  live_quiz_question_summaries_aggregate: Live_Quiz_Question_Summary_Aggregate;
  quiz_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_quiz: Quiz_Quiz;
  /** A computed field, executes function "live_quiz_get_remaining_time" */
  remaining_time?: Maybe<Scalars['String']['output']>;
  score: Scalars['numeric']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "live_quiz_summary" */
export type Live_Quiz_SummaryLive_Quiz_Question_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};


/** columns and relationships of "live_quiz_summary" */
export type Live_Quiz_SummaryLive_Quiz_Question_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};


/** columns and relationships of "live_quiz_summary" */
export type Live_Quiz_SummaryLive_Quiz_Question_SummariesArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};


/** columns and relationships of "live_quiz_summary" */
export type Live_Quiz_SummaryLive_Quiz_Question_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};

/** aggregated selection of "live_quiz_summary" */
export type Live_Quiz_Summary_Aggregate = {
  __typename?: 'live_quiz_summary_aggregate';
  aggregate?: Maybe<Live_Quiz_Summary_Aggregate_Fields>;
  nodes: Array<Live_Quiz_Summary>;
};

export type Live_Quiz_Summary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Live_Quiz_Summary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Live_Quiz_Summary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Live_Quiz_Summary_Aggregate_Bool_Exp_Count>;
};

export type Live_Quiz_Summary_Aggregate_Bool_Exp_Bool_And = {
  arguments: Live_Quiz_Summary_Select_Column_Live_Quiz_Summary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Live_Quiz_Summary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Live_Quiz_Summary_Select_Column_Live_Quiz_Summary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Live_Quiz_Summary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Live_Quiz_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "live_quiz_summary" */
export type Live_Quiz_Summary_Aggregate_Fields = {
  __typename?: 'live_quiz_summary_aggregate_fields';
  avg?: Maybe<Live_Quiz_Summary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Live_Quiz_Summary_Max_Fields>;
  min?: Maybe<Live_Quiz_Summary_Min_Fields>;
  stddev?: Maybe<Live_Quiz_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Live_Quiz_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Live_Quiz_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Live_Quiz_Summary_Sum_Fields>;
  var_pop?: Maybe<Live_Quiz_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Live_Quiz_Summary_Var_Samp_Fields>;
  variance?: Maybe<Live_Quiz_Summary_Variance_Fields>;
};


/** aggregate fields of "live_quiz_summary" */
export type Live_Quiz_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Live_Quiz_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "live_quiz_summary" */
export type Live_Quiz_Summary_Aggregate_Order_By = {
  avg?: InputMaybe<Live_Quiz_Summary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Live_Quiz_Summary_Max_Order_By>;
  min?: InputMaybe<Live_Quiz_Summary_Min_Order_By>;
  stddev?: InputMaybe<Live_Quiz_Summary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Live_Quiz_Summary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Live_Quiz_Summary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Live_Quiz_Summary_Sum_Order_By>;
  var_pop?: InputMaybe<Live_Quiz_Summary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Live_Quiz_Summary_Var_Samp_Order_By>;
  variance?: InputMaybe<Live_Quiz_Summary_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "live_quiz_summary" */
export type Live_Quiz_Summary_Arr_Rel_Insert_Input = {
  data: Array<Live_Quiz_Summary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Live_Quiz_Summary_On_Conflict>;
};

/** aggregate avg on columns */
export type Live_Quiz_Summary_Avg_Fields = {
  __typename?: 'live_quiz_summary_avg_fields';
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Avg_Order_By = {
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "live_quiz_summary". All fields are combined with a logical 'AND'. */
export type Live_Quiz_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Live_Quiz_Summary_Bool_Exp>>;
  _not?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Live_Quiz_Summary_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_position?: InputMaybe<Int_Comparison_Exp>;
  current_question?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  live_quiz_question_positions?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
  live_quiz_question_positions_aggregate?: InputMaybe<Live_Quiz_Question_Positions_Aggregate_Bool_Exp>;
  live_quiz_question_summaries?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
  live_quiz_question_summaries_aggregate?: InputMaybe<Live_Quiz_Question_Summary_Aggregate_Bool_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  remaining_time?: InputMaybe<String_Comparison_Exp>;
  score?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "live_quiz_summary" */
export enum Live_Quiz_Summary_Constraint {
  /** unique or primary key constraint on columns "id" */
  LiveQuizSummaryPkey = 'live_quiz_summary_pkey'
}

/** input type for incrementing numeric columns in table "live_quiz_summary" */
export type Live_Quiz_Summary_Inc_Input = {
  current_position?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "live_quiz_summary" */
export type Live_Quiz_Summary_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_position?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  live_quiz_question_positions?: InputMaybe<Live_Quiz_Question_Positions_Arr_Rel_Insert_Input>;
  live_quiz_question_summaries?: InputMaybe<Live_Quiz_Question_Summary_Arr_Rel_Insert_Input>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Live_Quiz_Summary_Max_Fields = {
  __typename?: 'live_quiz_summary_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_position?: Maybe<Scalars['Int']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "live_quiz_get_remaining_time" */
  remaining_time?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Live_Quiz_Summary_Min_Fields = {
  __typename?: 'live_quiz_summary_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_position?: Maybe<Scalars['Int']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "live_quiz_get_remaining_time" */
  remaining_time?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "live_quiz_summary" */
export type Live_Quiz_Summary_Mutation_Response = {
  __typename?: 'live_quiz_summary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Live_Quiz_Summary>;
};

/** input type for inserting object relation for remote table "live_quiz_summary" */
export type Live_Quiz_Summary_Obj_Rel_Insert_Input = {
  data: Live_Quiz_Summary_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Live_Quiz_Summary_On_Conflict>;
};

/** on_conflict condition type for table "live_quiz_summary" */
export type Live_Quiz_Summary_On_Conflict = {
  constraint: Live_Quiz_Summary_Constraint;
  update_columns?: Array<Live_Quiz_Summary_Update_Column>;
  where?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
};

/** Ordering options when selecting data from "live_quiz_summary". */
export type Live_Quiz_Summary_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  live_quiz_question_positions_aggregate?: InputMaybe<Live_Quiz_Question_Positions_Aggregate_Order_By>;
  live_quiz_question_summaries_aggregate?: InputMaybe<Live_Quiz_Question_Summary_Aggregate_Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  remaining_time?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: live_quiz_summary */
export type Live_Quiz_Summary_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "live_quiz_summary" */
export enum Live_Quiz_Summary_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPosition = 'current_position',
  /** column name */
  CurrentQuestion = 'current_question',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "live_quiz_summary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "live_quiz_summary" */
export enum Live_Quiz_Summary_Select_Column_Live_Quiz_Summary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** select "live_quiz_summary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "live_quiz_summary" */
export enum Live_Quiz_Summary_Select_Column_Live_Quiz_Summary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** input type for updating data in table "live_quiz_summary" */
export type Live_Quiz_Summary_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_position?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Live_Quiz_Summary_Stddev_Fields = {
  __typename?: 'live_quiz_summary_stddev_fields';
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Stddev_Order_By = {
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Live_Quiz_Summary_Stddev_Pop_Fields = {
  __typename?: 'live_quiz_summary_stddev_pop_fields';
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Stddev_Pop_Order_By = {
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Live_Quiz_Summary_Stddev_Samp_Fields = {
  __typename?: 'live_quiz_summary_stddev_samp_fields';
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Stddev_Samp_Order_By = {
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "live_quiz_summary" */
export type Live_Quiz_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Live_Quiz_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Quiz_Summary_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_position?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Live_Quiz_Summary_Sum_Fields = {
  __typename?: 'live_quiz_summary_sum_fields';
  current_position?: Maybe<Scalars['Int']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Sum_Order_By = {
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** update columns of table "live_quiz_summary" */
export enum Live_Quiz_Summary_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPosition = 'current_position',
  /** column name */
  CurrentQuestion = 'current_question',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Live_Quiz_Summary_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Live_Quiz_Summary_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Live_Quiz_Summary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Live_Quiz_Summary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Live_Quiz_Summary_Var_Pop_Fields = {
  __typename?: 'live_quiz_summary_var_pop_fields';
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Var_Pop_Order_By = {
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Live_Quiz_Summary_Var_Samp_Fields = {
  __typename?: 'live_quiz_summary_var_samp_fields';
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Var_Samp_Order_By = {
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Live_Quiz_Summary_Variance_Fields = {
  __typename?: 'live_quiz_summary_variance_fields';
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "live_quiz_summary" */
export type Live_Quiz_Summary_Variance_Order_By = {
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** columns and relationships of "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr = {
  __typename?: 'marks_vs_percentile_dilr';
  autogen_percentile: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  manual_percentile: Scalars['numeric']['output'];
  marks: Scalars['numeric']['output'];
  shift: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr_Aggregate = {
  __typename?: 'marks_vs_percentile_dilr_aggregate';
  aggregate?: Maybe<Marks_Vs_Percentile_Dilr_Aggregate_Fields>;
  nodes: Array<Marks_Vs_Percentile_Dilr>;
};

/** aggregate fields of "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr_Aggregate_Fields = {
  __typename?: 'marks_vs_percentile_dilr_aggregate_fields';
  avg?: Maybe<Marks_Vs_Percentile_Dilr_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Marks_Vs_Percentile_Dilr_Max_Fields>;
  min?: Maybe<Marks_Vs_Percentile_Dilr_Min_Fields>;
  stddev?: Maybe<Marks_Vs_Percentile_Dilr_Stddev_Fields>;
  stddev_pop?: Maybe<Marks_Vs_Percentile_Dilr_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Marks_Vs_Percentile_Dilr_Stddev_Samp_Fields>;
  sum?: Maybe<Marks_Vs_Percentile_Dilr_Sum_Fields>;
  var_pop?: Maybe<Marks_Vs_Percentile_Dilr_Var_Pop_Fields>;
  var_samp?: Maybe<Marks_Vs_Percentile_Dilr_Var_Samp_Fields>;
  variance?: Maybe<Marks_Vs_Percentile_Dilr_Variance_Fields>;
};


/** aggregate fields of "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Marks_Vs_Percentile_Dilr_Avg_Fields = {
  __typename?: 'marks_vs_percentile_dilr_avg_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "marks_vs_percentile_dilr". All fields are combined with a logical 'AND'. */
export type Marks_Vs_Percentile_Dilr_Bool_Exp = {
  _and?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Bool_Exp>>;
  _not?: InputMaybe<Marks_Vs_Percentile_Dilr_Bool_Exp>;
  _or?: InputMaybe<Array<Marks_Vs_Percentile_Dilr_Bool_Exp>>;
  autogen_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manual_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  marks?: InputMaybe<Numeric_Comparison_Exp>;
  shift?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "marks_vs_percentile_dilr" */
export enum Marks_Vs_Percentile_Dilr_Constraint {
  /** unique or primary key constraint on columns "marks", "shift" */
  MarksVsPercentileDilrMarksShiftKey = 'marks_vs_percentile_dilr_marks_shift_key',
  /** unique or primary key constraint on columns "id" */
  MarksVsPercentileDilrPkey = 'marks_vs_percentile_dilr_pkey'
}

/** input type for incrementing numeric columns in table "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr_Inc_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr_Insert_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Marks_Vs_Percentile_Dilr_Max_Fields = {
  __typename?: 'marks_vs_percentile_dilr_max_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Marks_Vs_Percentile_Dilr_Min_Fields = {
  __typename?: 'marks_vs_percentile_dilr_min_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr_Mutation_Response = {
  __typename?: 'marks_vs_percentile_dilr_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Marks_Vs_Percentile_Dilr>;
};

/** on_conflict condition type for table "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr_On_Conflict = {
  constraint: Marks_Vs_Percentile_Dilr_Constraint;
  update_columns?: Array<Marks_Vs_Percentile_Dilr_Update_Column>;
  where?: InputMaybe<Marks_Vs_Percentile_Dilr_Bool_Exp>;
};

/** Ordering options when selecting data from "marks_vs_percentile_dilr". */
export type Marks_Vs_Percentile_Dilr_Order_By = {
  autogen_percentile?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manual_percentile?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  shift?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: marks_vs_percentile_dilr */
export type Marks_Vs_Percentile_Dilr_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "marks_vs_percentile_dilr" */
export enum Marks_Vs_Percentile_Dilr_Select_Column {
  /** column name */
  AutogenPercentile = 'autogen_percentile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManualPercentile = 'manual_percentile',
  /** column name */
  Marks = 'marks',
  /** column name */
  Shift = 'shift',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr_Set_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Marks_Vs_Percentile_Dilr_Stddev_Fields = {
  __typename?: 'marks_vs_percentile_dilr_stddev_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Marks_Vs_Percentile_Dilr_Stddev_Pop_Fields = {
  __typename?: 'marks_vs_percentile_dilr_stddev_pop_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Marks_Vs_Percentile_Dilr_Stddev_Samp_Fields = {
  __typename?: 'marks_vs_percentile_dilr_stddev_samp_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "marks_vs_percentile_dilr" */
export type Marks_Vs_Percentile_Dilr_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marks_Vs_Percentile_Dilr_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marks_Vs_Percentile_Dilr_Stream_Cursor_Value_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Marks_Vs_Percentile_Dilr_Sum_Fields = {
  __typename?: 'marks_vs_percentile_dilr_sum_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "marks_vs_percentile_dilr" */
export enum Marks_Vs_Percentile_Dilr_Update_Column {
  /** column name */
  AutogenPercentile = 'autogen_percentile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManualPercentile = 'manual_percentile',
  /** column name */
  Marks = 'marks',
  /** column name */
  Shift = 'shift',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Marks_Vs_Percentile_Dilr_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Marks_Vs_Percentile_Dilr_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Marks_Vs_Percentile_Dilr_Set_Input>;
  /** filter the rows which have to be updated */
  where: Marks_Vs_Percentile_Dilr_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Marks_Vs_Percentile_Dilr_Var_Pop_Fields = {
  __typename?: 'marks_vs_percentile_dilr_var_pop_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Marks_Vs_Percentile_Dilr_Var_Samp_Fields = {
  __typename?: 'marks_vs_percentile_dilr_var_samp_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Marks_Vs_Percentile_Dilr_Variance_Fields = {
  __typename?: 'marks_vs_percentile_dilr_variance_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant = {
  __typename?: 'marks_vs_percentile_quant';
  autogen_percentile: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  manual_percentile: Scalars['numeric']['output'];
  marks: Scalars['numeric']['output'];
  shift: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant_Aggregate = {
  __typename?: 'marks_vs_percentile_quant_aggregate';
  aggregate?: Maybe<Marks_Vs_Percentile_Quant_Aggregate_Fields>;
  nodes: Array<Marks_Vs_Percentile_Quant>;
};

/** aggregate fields of "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant_Aggregate_Fields = {
  __typename?: 'marks_vs_percentile_quant_aggregate_fields';
  avg?: Maybe<Marks_Vs_Percentile_Quant_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Marks_Vs_Percentile_Quant_Max_Fields>;
  min?: Maybe<Marks_Vs_Percentile_Quant_Min_Fields>;
  stddev?: Maybe<Marks_Vs_Percentile_Quant_Stddev_Fields>;
  stddev_pop?: Maybe<Marks_Vs_Percentile_Quant_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Marks_Vs_Percentile_Quant_Stddev_Samp_Fields>;
  sum?: Maybe<Marks_Vs_Percentile_Quant_Sum_Fields>;
  var_pop?: Maybe<Marks_Vs_Percentile_Quant_Var_Pop_Fields>;
  var_samp?: Maybe<Marks_Vs_Percentile_Quant_Var_Samp_Fields>;
  variance?: Maybe<Marks_Vs_Percentile_Quant_Variance_Fields>;
};


/** aggregate fields of "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Marks_Vs_Percentile_Quant_Avg_Fields = {
  __typename?: 'marks_vs_percentile_quant_avg_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "marks_vs_percentile_quant". All fields are combined with a logical 'AND'. */
export type Marks_Vs_Percentile_Quant_Bool_Exp = {
  _and?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Bool_Exp>>;
  _not?: InputMaybe<Marks_Vs_Percentile_Quant_Bool_Exp>;
  _or?: InputMaybe<Array<Marks_Vs_Percentile_Quant_Bool_Exp>>;
  autogen_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manual_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  marks?: InputMaybe<Numeric_Comparison_Exp>;
  shift?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "marks_vs_percentile_quant" */
export enum Marks_Vs_Percentile_Quant_Constraint {
  /** unique or primary key constraint on columns "marks", "shift" */
  MarksVsPercentileQuantMarksShiftKey = 'marks_vs_percentile_quant_marks_shift_key',
  /** unique or primary key constraint on columns "id" */
  MarksVsPercentileQuantPkey = 'marks_vs_percentile_quant_pkey'
}

/** input type for incrementing numeric columns in table "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant_Inc_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant_Insert_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Marks_Vs_Percentile_Quant_Max_Fields = {
  __typename?: 'marks_vs_percentile_quant_max_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Marks_Vs_Percentile_Quant_Min_Fields = {
  __typename?: 'marks_vs_percentile_quant_min_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant_Mutation_Response = {
  __typename?: 'marks_vs_percentile_quant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Marks_Vs_Percentile_Quant>;
};

/** on_conflict condition type for table "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant_On_Conflict = {
  constraint: Marks_Vs_Percentile_Quant_Constraint;
  update_columns?: Array<Marks_Vs_Percentile_Quant_Update_Column>;
  where?: InputMaybe<Marks_Vs_Percentile_Quant_Bool_Exp>;
};

/** Ordering options when selecting data from "marks_vs_percentile_quant". */
export type Marks_Vs_Percentile_Quant_Order_By = {
  autogen_percentile?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manual_percentile?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  shift?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: marks_vs_percentile_quant */
export type Marks_Vs_Percentile_Quant_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "marks_vs_percentile_quant" */
export enum Marks_Vs_Percentile_Quant_Select_Column {
  /** column name */
  AutogenPercentile = 'autogen_percentile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManualPercentile = 'manual_percentile',
  /** column name */
  Marks = 'marks',
  /** column name */
  Shift = 'shift',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant_Set_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Marks_Vs_Percentile_Quant_Stddev_Fields = {
  __typename?: 'marks_vs_percentile_quant_stddev_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Marks_Vs_Percentile_Quant_Stddev_Pop_Fields = {
  __typename?: 'marks_vs_percentile_quant_stddev_pop_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Marks_Vs_Percentile_Quant_Stddev_Samp_Fields = {
  __typename?: 'marks_vs_percentile_quant_stddev_samp_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "marks_vs_percentile_quant" */
export type Marks_Vs_Percentile_Quant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marks_Vs_Percentile_Quant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marks_Vs_Percentile_Quant_Stream_Cursor_Value_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Marks_Vs_Percentile_Quant_Sum_Fields = {
  __typename?: 'marks_vs_percentile_quant_sum_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "marks_vs_percentile_quant" */
export enum Marks_Vs_Percentile_Quant_Update_Column {
  /** column name */
  AutogenPercentile = 'autogen_percentile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManualPercentile = 'manual_percentile',
  /** column name */
  Marks = 'marks',
  /** column name */
  Shift = 'shift',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Marks_Vs_Percentile_Quant_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Marks_Vs_Percentile_Quant_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Marks_Vs_Percentile_Quant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Marks_Vs_Percentile_Quant_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Marks_Vs_Percentile_Quant_Var_Pop_Fields = {
  __typename?: 'marks_vs_percentile_quant_var_pop_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Marks_Vs_Percentile_Quant_Var_Samp_Fields = {
  __typename?: 'marks_vs_percentile_quant_var_samp_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Marks_Vs_Percentile_Quant_Variance_Fields = {
  __typename?: 'marks_vs_percentile_quant_variance_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw = {
  __typename?: 'marks_vs_percentile_total_raw';
  autogen_percentile: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  manual_percentile: Scalars['numeric']['output'];
  marks: Scalars['numeric']['output'];
  shift: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw_Aggregate = {
  __typename?: 'marks_vs_percentile_total_raw_aggregate';
  aggregate?: Maybe<Marks_Vs_Percentile_Total_Raw_Aggregate_Fields>;
  nodes: Array<Marks_Vs_Percentile_Total_Raw>;
};

/** aggregate fields of "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw_Aggregate_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_aggregate_fields';
  avg?: Maybe<Marks_Vs_Percentile_Total_Raw_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Marks_Vs_Percentile_Total_Raw_Max_Fields>;
  min?: Maybe<Marks_Vs_Percentile_Total_Raw_Min_Fields>;
  stddev?: Maybe<Marks_Vs_Percentile_Total_Raw_Stddev_Fields>;
  stddev_pop?: Maybe<Marks_Vs_Percentile_Total_Raw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Marks_Vs_Percentile_Total_Raw_Stddev_Samp_Fields>;
  sum?: Maybe<Marks_Vs_Percentile_Total_Raw_Sum_Fields>;
  var_pop?: Maybe<Marks_Vs_Percentile_Total_Raw_Var_Pop_Fields>;
  var_samp?: Maybe<Marks_Vs_Percentile_Total_Raw_Var_Samp_Fields>;
  variance?: Maybe<Marks_Vs_Percentile_Total_Raw_Variance_Fields>;
};


/** aggregate fields of "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Marks_Vs_Percentile_Total_Raw_Avg_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_avg_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "marks_vs_percentile_total_raw". All fields are combined with a logical 'AND'. */
export type Marks_Vs_Percentile_Total_Raw_Bool_Exp = {
  _and?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Bool_Exp>>;
  _not?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Bool_Exp>;
  _or?: InputMaybe<Array<Marks_Vs_Percentile_Total_Raw_Bool_Exp>>;
  autogen_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manual_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  marks?: InputMaybe<Numeric_Comparison_Exp>;
  shift?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "marks_vs_percentile_total_raw" */
export enum Marks_Vs_Percentile_Total_Raw_Constraint {
  /** unique or primary key constraint on columns "marks", "shift" */
  MarksVsPercentileTotalRawMarksShiftKey = 'marks_vs_percentile_total_raw_marks_shift_key',
  /** unique or primary key constraint on columns "id" */
  MarksVsPercentileTotalRawPkey = 'marks_vs_percentile_total_raw_pkey'
}

/** input type for incrementing numeric columns in table "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw_Inc_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw_Insert_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Marks_Vs_Percentile_Total_Raw_Max_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_max_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Marks_Vs_Percentile_Total_Raw_Min_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_min_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw_Mutation_Response = {
  __typename?: 'marks_vs_percentile_total_raw_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Marks_Vs_Percentile_Total_Raw>;
};

/** on_conflict condition type for table "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw_On_Conflict = {
  constraint: Marks_Vs_Percentile_Total_Raw_Constraint;
  update_columns?: Array<Marks_Vs_Percentile_Total_Raw_Update_Column>;
  where?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Bool_Exp>;
};

/** Ordering options when selecting data from "marks_vs_percentile_total_raw". */
export type Marks_Vs_Percentile_Total_Raw_Order_By = {
  autogen_percentile?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manual_percentile?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  shift?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: marks_vs_percentile_total_raw */
export type Marks_Vs_Percentile_Total_Raw_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "marks_vs_percentile_total_raw" */
export enum Marks_Vs_Percentile_Total_Raw_Select_Column {
  /** column name */
  AutogenPercentile = 'autogen_percentile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManualPercentile = 'manual_percentile',
  /** column name */
  Marks = 'marks',
  /** column name */
  Shift = 'shift',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw_Set_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Marks_Vs_Percentile_Total_Raw_Stddev_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_stddev_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Marks_Vs_Percentile_Total_Raw_Stddev_Pop_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_stddev_pop_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Marks_Vs_Percentile_Total_Raw_Stddev_Samp_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_stddev_samp_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "marks_vs_percentile_total_raw" */
export type Marks_Vs_Percentile_Total_Raw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marks_Vs_Percentile_Total_Raw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marks_Vs_Percentile_Total_Raw_Stream_Cursor_Value_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Marks_Vs_Percentile_Total_Raw_Sum_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_sum_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "marks_vs_percentile_total_raw" */
export enum Marks_Vs_Percentile_Total_Raw_Update_Column {
  /** column name */
  AutogenPercentile = 'autogen_percentile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManualPercentile = 'manual_percentile',
  /** column name */
  Marks = 'marks',
  /** column name */
  Shift = 'shift',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Marks_Vs_Percentile_Total_Raw_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Marks_Vs_Percentile_Total_Raw_Set_Input>;
  /** filter the rows which have to be updated */
  where: Marks_Vs_Percentile_Total_Raw_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Marks_Vs_Percentile_Total_Raw_Var_Pop_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_var_pop_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Marks_Vs_Percentile_Total_Raw_Var_Samp_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_var_samp_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Marks_Vs_Percentile_Total_Raw_Variance_Fields = {
  __typename?: 'marks_vs_percentile_total_raw_variance_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc = {
  __typename?: 'marks_vs_percentile_varc';
  autogen_percentile: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  manual_percentile: Scalars['numeric']['output'];
  marks: Scalars['numeric']['output'];
  shift: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc_Aggregate = {
  __typename?: 'marks_vs_percentile_varc_aggregate';
  aggregate?: Maybe<Marks_Vs_Percentile_Varc_Aggregate_Fields>;
  nodes: Array<Marks_Vs_Percentile_Varc>;
};

/** aggregate fields of "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc_Aggregate_Fields = {
  __typename?: 'marks_vs_percentile_varc_aggregate_fields';
  avg?: Maybe<Marks_Vs_Percentile_Varc_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Marks_Vs_Percentile_Varc_Max_Fields>;
  min?: Maybe<Marks_Vs_Percentile_Varc_Min_Fields>;
  stddev?: Maybe<Marks_Vs_Percentile_Varc_Stddev_Fields>;
  stddev_pop?: Maybe<Marks_Vs_Percentile_Varc_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Marks_Vs_Percentile_Varc_Stddev_Samp_Fields>;
  sum?: Maybe<Marks_Vs_Percentile_Varc_Sum_Fields>;
  var_pop?: Maybe<Marks_Vs_Percentile_Varc_Var_Pop_Fields>;
  var_samp?: Maybe<Marks_Vs_Percentile_Varc_Var_Samp_Fields>;
  variance?: Maybe<Marks_Vs_Percentile_Varc_Variance_Fields>;
};


/** aggregate fields of "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Marks_Vs_Percentile_Varc_Avg_Fields = {
  __typename?: 'marks_vs_percentile_varc_avg_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "marks_vs_percentile_varc". All fields are combined with a logical 'AND'. */
export type Marks_Vs_Percentile_Varc_Bool_Exp = {
  _and?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Bool_Exp>>;
  _not?: InputMaybe<Marks_Vs_Percentile_Varc_Bool_Exp>;
  _or?: InputMaybe<Array<Marks_Vs_Percentile_Varc_Bool_Exp>>;
  autogen_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manual_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  marks?: InputMaybe<Numeric_Comparison_Exp>;
  shift?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "marks_vs_percentile_varc" */
export enum Marks_Vs_Percentile_Varc_Constraint {
  /** unique or primary key constraint on columns "marks", "shift" */
  MarksVsPercentileVarcMarksShiftKey = 'marks_vs_percentile_varc_marks_shift_key',
  /** unique or primary key constraint on columns "id" */
  MarksVsPercentileVarcPkey = 'marks_vs_percentile_varc_pkey'
}

/** input type for incrementing numeric columns in table "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc_Inc_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc_Insert_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Marks_Vs_Percentile_Varc_Max_Fields = {
  __typename?: 'marks_vs_percentile_varc_max_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Marks_Vs_Percentile_Varc_Min_Fields = {
  __typename?: 'marks_vs_percentile_varc_min_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc_Mutation_Response = {
  __typename?: 'marks_vs_percentile_varc_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Marks_Vs_Percentile_Varc>;
};

/** on_conflict condition type for table "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc_On_Conflict = {
  constraint: Marks_Vs_Percentile_Varc_Constraint;
  update_columns?: Array<Marks_Vs_Percentile_Varc_Update_Column>;
  where?: InputMaybe<Marks_Vs_Percentile_Varc_Bool_Exp>;
};

/** Ordering options when selecting data from "marks_vs_percentile_varc". */
export type Marks_Vs_Percentile_Varc_Order_By = {
  autogen_percentile?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manual_percentile?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  shift?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: marks_vs_percentile_varc */
export type Marks_Vs_Percentile_Varc_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "marks_vs_percentile_varc" */
export enum Marks_Vs_Percentile_Varc_Select_Column {
  /** column name */
  AutogenPercentile = 'autogen_percentile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManualPercentile = 'manual_percentile',
  /** column name */
  Marks = 'marks',
  /** column name */
  Shift = 'shift',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc_Set_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Marks_Vs_Percentile_Varc_Stddev_Fields = {
  __typename?: 'marks_vs_percentile_varc_stddev_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Marks_Vs_Percentile_Varc_Stddev_Pop_Fields = {
  __typename?: 'marks_vs_percentile_varc_stddev_pop_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Marks_Vs_Percentile_Varc_Stddev_Samp_Fields = {
  __typename?: 'marks_vs_percentile_varc_stddev_samp_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "marks_vs_percentile_varc" */
export type Marks_Vs_Percentile_Varc_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marks_Vs_Percentile_Varc_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marks_Vs_Percentile_Varc_Stream_Cursor_Value_Input = {
  autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Marks_Vs_Percentile_Varc_Sum_Fields = {
  __typename?: 'marks_vs_percentile_varc_sum_fields';
  autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "marks_vs_percentile_varc" */
export enum Marks_Vs_Percentile_Varc_Update_Column {
  /** column name */
  AutogenPercentile = 'autogen_percentile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManualPercentile = 'manual_percentile',
  /** column name */
  Marks = 'marks',
  /** column name */
  Shift = 'shift',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Marks_Vs_Percentile_Varc_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Marks_Vs_Percentile_Varc_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Marks_Vs_Percentile_Varc_Set_Input>;
  /** filter the rows which have to be updated */
  where: Marks_Vs_Percentile_Varc_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Marks_Vs_Percentile_Varc_Var_Pop_Fields = {
  __typename?: 'marks_vs_percentile_varc_var_pop_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Marks_Vs_Percentile_Varc_Var_Samp_Fields = {
  __typename?: 'marks_vs_percentile_varc_var_samp_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Marks_Vs_Percentile_Varc_Variance_Fields = {
  __typename?: 'marks_vs_percentile_varc_variance_fields';
  autogen_percentile?: Maybe<Scalars['Float']['output']>;
  manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile = {
  __typename?: 'marks_vs_scaled_percentile';
  created_at: Scalars['timestamptz']['output'];
  dilr_autogen_percentile: Scalars['numeric']['output'];
  dilr_manual_percentile: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  marks: Scalars['numeric']['output'];
  quant_autogen_percentile: Scalars['numeric']['output'];
  quant_manual_percentile: Scalars['numeric']['output'];
  total_autogen_percentile: Scalars['numeric']['output'];
  total_manual_percentile: Scalars['numeric']['output'];
  updated_at: Scalars['timestamptz']['output'];
  varc_autogen_percentile: Scalars['numeric']['output'];
  varc_manual_percentile: Scalars['numeric']['output'];
};

/** aggregated selection of "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile_Aggregate = {
  __typename?: 'marks_vs_scaled_percentile_aggregate';
  aggregate?: Maybe<Marks_Vs_Scaled_Percentile_Aggregate_Fields>;
  nodes: Array<Marks_Vs_Scaled_Percentile>;
};

/** aggregate fields of "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile_Aggregate_Fields = {
  __typename?: 'marks_vs_scaled_percentile_aggregate_fields';
  avg?: Maybe<Marks_Vs_Scaled_Percentile_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Marks_Vs_Scaled_Percentile_Max_Fields>;
  min?: Maybe<Marks_Vs_Scaled_Percentile_Min_Fields>;
  stddev?: Maybe<Marks_Vs_Scaled_Percentile_Stddev_Fields>;
  stddev_pop?: Maybe<Marks_Vs_Scaled_Percentile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Marks_Vs_Scaled_Percentile_Stddev_Samp_Fields>;
  sum?: Maybe<Marks_Vs_Scaled_Percentile_Sum_Fields>;
  var_pop?: Maybe<Marks_Vs_Scaled_Percentile_Var_Pop_Fields>;
  var_samp?: Maybe<Marks_Vs_Scaled_Percentile_Var_Samp_Fields>;
  variance?: Maybe<Marks_Vs_Scaled_Percentile_Variance_Fields>;
};


/** aggregate fields of "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Marks_Vs_Scaled_Percentile_Avg_Fields = {
  __typename?: 'marks_vs_scaled_percentile_avg_fields';
  dilr_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  quant_manual_percentile?: Maybe<Scalars['Float']['output']>;
  total_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  total_manual_percentile?: Maybe<Scalars['Float']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  varc_manual_percentile?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "marks_vs_scaled_percentile". All fields are combined with a logical 'AND'. */
export type Marks_Vs_Scaled_Percentile_Bool_Exp = {
  _and?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Bool_Exp>>;
  _not?: InputMaybe<Marks_Vs_Scaled_Percentile_Bool_Exp>;
  _or?: InputMaybe<Array<Marks_Vs_Scaled_Percentile_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dilr_autogen_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  dilr_manual_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  marks?: InputMaybe<Numeric_Comparison_Exp>;
  quant_autogen_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  quant_manual_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  total_autogen_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  total_manual_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  varc_autogen_percentile?: InputMaybe<Numeric_Comparison_Exp>;
  varc_manual_percentile?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "marks_vs_scaled_percentile" */
export enum Marks_Vs_Scaled_Percentile_Constraint {
  /** unique or primary key constraint on columns "marks" */
  MarksVsScaledPercentileMarksKey = 'marks_vs_scaled_percentile_marks_key',
  /** unique or primary key constraint on columns "id" */
  MarksVsScaledPercentilePkey = 'marks_vs_scaled_percentile_pkey'
}

/** input type for incrementing numeric columns in table "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile_Inc_Input = {
  dilr_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  dilr_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  quant_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  quant_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  total_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  total_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  varc_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  varc_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dilr_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  dilr_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  quant_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  quant_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  total_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  total_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  varc_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  varc_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Marks_Vs_Scaled_Percentile_Max_Fields = {
  __typename?: 'marks_vs_scaled_percentile_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dilr_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  quant_manual_percentile?: Maybe<Scalars['numeric']['output']>;
  total_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  total_manual_percentile?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  varc_manual_percentile?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Marks_Vs_Scaled_Percentile_Min_Fields = {
  __typename?: 'marks_vs_scaled_percentile_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dilr_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  quant_manual_percentile?: Maybe<Scalars['numeric']['output']>;
  total_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  total_manual_percentile?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  varc_manual_percentile?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile_Mutation_Response = {
  __typename?: 'marks_vs_scaled_percentile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Marks_Vs_Scaled_Percentile>;
};

/** on_conflict condition type for table "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile_On_Conflict = {
  constraint: Marks_Vs_Scaled_Percentile_Constraint;
  update_columns?: Array<Marks_Vs_Scaled_Percentile_Update_Column>;
  where?: InputMaybe<Marks_Vs_Scaled_Percentile_Bool_Exp>;
};

/** Ordering options when selecting data from "marks_vs_scaled_percentile". */
export type Marks_Vs_Scaled_Percentile_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dilr_autogen_percentile?: InputMaybe<Order_By>;
  dilr_manual_percentile?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  quant_autogen_percentile?: InputMaybe<Order_By>;
  quant_manual_percentile?: InputMaybe<Order_By>;
  total_autogen_percentile?: InputMaybe<Order_By>;
  total_manual_percentile?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  varc_autogen_percentile?: InputMaybe<Order_By>;
  varc_manual_percentile?: InputMaybe<Order_By>;
};

/** primary key columns input for table: marks_vs_scaled_percentile */
export type Marks_Vs_Scaled_Percentile_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "marks_vs_scaled_percentile" */
export enum Marks_Vs_Scaled_Percentile_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DilrAutogenPercentile = 'dilr_autogen_percentile',
  /** column name */
  DilrManualPercentile = 'dilr_manual_percentile',
  /** column name */
  Id = 'id',
  /** column name */
  Marks = 'marks',
  /** column name */
  QuantAutogenPercentile = 'quant_autogen_percentile',
  /** column name */
  QuantManualPercentile = 'quant_manual_percentile',
  /** column name */
  TotalAutogenPercentile = 'total_autogen_percentile',
  /** column name */
  TotalManualPercentile = 'total_manual_percentile',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarcAutogenPercentile = 'varc_autogen_percentile',
  /** column name */
  VarcManualPercentile = 'varc_manual_percentile'
}

/** input type for updating data in table "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dilr_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  dilr_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  quant_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  quant_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  total_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  total_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  varc_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  varc_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Marks_Vs_Scaled_Percentile_Stddev_Fields = {
  __typename?: 'marks_vs_scaled_percentile_stddev_fields';
  dilr_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  quant_manual_percentile?: Maybe<Scalars['Float']['output']>;
  total_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  total_manual_percentile?: Maybe<Scalars['Float']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  varc_manual_percentile?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Marks_Vs_Scaled_Percentile_Stddev_Pop_Fields = {
  __typename?: 'marks_vs_scaled_percentile_stddev_pop_fields';
  dilr_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  quant_manual_percentile?: Maybe<Scalars['Float']['output']>;
  total_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  total_manual_percentile?: Maybe<Scalars['Float']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  varc_manual_percentile?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Marks_Vs_Scaled_Percentile_Stddev_Samp_Fields = {
  __typename?: 'marks_vs_scaled_percentile_stddev_samp_fields';
  dilr_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  quant_manual_percentile?: Maybe<Scalars['Float']['output']>;
  total_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  total_manual_percentile?: Maybe<Scalars['Float']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  varc_manual_percentile?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "marks_vs_scaled_percentile" */
export type Marks_Vs_Scaled_Percentile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marks_Vs_Scaled_Percentile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marks_Vs_Scaled_Percentile_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dilr_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  dilr_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  quant_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  quant_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  total_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  total_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  varc_autogen_percentile?: InputMaybe<Scalars['numeric']['input']>;
  varc_manual_percentile?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Marks_Vs_Scaled_Percentile_Sum_Fields = {
  __typename?: 'marks_vs_scaled_percentile_sum_fields';
  dilr_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['numeric']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  quant_manual_percentile?: Maybe<Scalars['numeric']['output']>;
  total_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  total_manual_percentile?: Maybe<Scalars['numeric']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['numeric']['output']>;
  varc_manual_percentile?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "marks_vs_scaled_percentile" */
export enum Marks_Vs_Scaled_Percentile_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DilrAutogenPercentile = 'dilr_autogen_percentile',
  /** column name */
  DilrManualPercentile = 'dilr_manual_percentile',
  /** column name */
  Id = 'id',
  /** column name */
  Marks = 'marks',
  /** column name */
  QuantAutogenPercentile = 'quant_autogen_percentile',
  /** column name */
  QuantManualPercentile = 'quant_manual_percentile',
  /** column name */
  TotalAutogenPercentile = 'total_autogen_percentile',
  /** column name */
  TotalManualPercentile = 'total_manual_percentile',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarcAutogenPercentile = 'varc_autogen_percentile',
  /** column name */
  VarcManualPercentile = 'varc_manual_percentile'
}

export type Marks_Vs_Scaled_Percentile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Marks_Vs_Scaled_Percentile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Marks_Vs_Scaled_Percentile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Marks_Vs_Scaled_Percentile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Marks_Vs_Scaled_Percentile_Var_Pop_Fields = {
  __typename?: 'marks_vs_scaled_percentile_var_pop_fields';
  dilr_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  quant_manual_percentile?: Maybe<Scalars['Float']['output']>;
  total_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  total_manual_percentile?: Maybe<Scalars['Float']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  varc_manual_percentile?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Marks_Vs_Scaled_Percentile_Var_Samp_Fields = {
  __typename?: 'marks_vs_scaled_percentile_var_samp_fields';
  dilr_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  quant_manual_percentile?: Maybe<Scalars['Float']['output']>;
  total_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  total_manual_percentile?: Maybe<Scalars['Float']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  varc_manual_percentile?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Marks_Vs_Scaled_Percentile_Variance_Fields = {
  __typename?: 'marks_vs_scaled_percentile_variance_fields';
  dilr_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  dilr_manual_percentile?: Maybe<Scalars['Float']['output']>;
  marks?: Maybe<Scalars['Float']['output']>;
  quant_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  quant_manual_percentile?: Maybe<Scalars['Float']['output']>;
  total_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  total_manual_percentile?: Maybe<Scalars['Float']['output']>;
  varc_autogen_percentile?: Maybe<Scalars['Float']['output']>;
  varc_manual_percentile?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "meeting_members" */
export type Meeting_Members = {
  __typename?: 'meeting_members';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  meeting: Meetings;
  meeting_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Supertokens_User_Public_Fields>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregated selection of "meeting_members" */
export type Meeting_Members_Aggregate = {
  __typename?: 'meeting_members_aggregate';
  aggregate?: Maybe<Meeting_Members_Aggregate_Fields>;
  nodes: Array<Meeting_Members>;
};

export type Meeting_Members_Aggregate_Bool_Exp = {
  count?: InputMaybe<Meeting_Members_Aggregate_Bool_Exp_Count>;
};

export type Meeting_Members_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Meeting_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Meeting_Members_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "meeting_members" */
export type Meeting_Members_Aggregate_Fields = {
  __typename?: 'meeting_members_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Meeting_Members_Max_Fields>;
  min?: Maybe<Meeting_Members_Min_Fields>;
};


/** aggregate fields of "meeting_members" */
export type Meeting_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meeting_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "meeting_members" */
export type Meeting_Members_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Meeting_Members_Max_Order_By>;
  min?: InputMaybe<Meeting_Members_Min_Order_By>;
};

/** input type for inserting array relation for remote table "meeting_members" */
export type Meeting_Members_Arr_Rel_Insert_Input = {
  data: Array<Meeting_Members_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Meeting_Members_On_Conflict>;
};

/** Boolean expression to filter rows from the table "meeting_members". All fields are combined with a logical 'AND'. */
export type Meeting_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Meeting_Members_Bool_Exp>>;
  _not?: InputMaybe<Meeting_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Meeting_Members_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  meeting?: InputMaybe<Meetings_Bool_Exp>;
  meeting_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "meeting_members" */
export enum Meeting_Members_Constraint {
  /** unique or primary key constraint on columns "user_id", "meeting_id" */
  MeetingMembersMeetingIdUserIdKey = 'meeting_members_meeting_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  MeetingMembersPkey = 'meeting_members_pkey'
}

/** input type for inserting data into table "meeting_members" */
export type Meeting_Members_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  meeting?: InputMaybe<Meetings_Obj_Rel_Insert_Input>;
  meeting_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Meeting_Members_Max_Fields = {
  __typename?: 'meeting_members_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  meeting_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "meeting_members" */
export type Meeting_Members_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meeting_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Meeting_Members_Min_Fields = {
  __typename?: 'meeting_members_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  meeting_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "meeting_members" */
export type Meeting_Members_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meeting_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "meeting_members" */
export type Meeting_Members_Mutation_Response = {
  __typename?: 'meeting_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Meeting_Members>;
};

/** on_conflict condition type for table "meeting_members" */
export type Meeting_Members_On_Conflict = {
  constraint: Meeting_Members_Constraint;
  update_columns?: Array<Meeting_Members_Update_Column>;
  where?: InputMaybe<Meeting_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "meeting_members". */
export type Meeting_Members_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meeting?: InputMaybe<Meetings_Order_By>;
  meeting_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: meeting_members */
export type Meeting_Members_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "meeting_members" */
export enum Meeting_Members_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MeetingId = 'meeting_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "meeting_members" */
export type Meeting_Members_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  meeting_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "meeting_members" */
export type Meeting_Members_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meeting_Members_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Meeting_Members_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  meeting_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "meeting_members" */
export enum Meeting_Members_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MeetingId = 'meeting_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Meeting_Members_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meeting_Members_Set_Input>;
  /** filter the rows which have to be updated */
  where: Meeting_Members_Bool_Exp;
};

/** columns and relationships of "meetings" */
export type Meetings = {
  __typename?: 'meetings';
  created_at: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  meeting_id: Scalars['String']['output'];
  /** An array relationship */
  meeting_members: Array<Meeting_Members>;
  /** An aggregate relationship */
  meeting_members_aggregate: Meeting_Members_Aggregate;
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "meetings" */
export type MeetingsMeeting_MembersArgs = {
  distinct_on?: InputMaybe<Array<Meeting_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meeting_Members_Order_By>>;
  where?: InputMaybe<Meeting_Members_Bool_Exp>;
};


/** columns and relationships of "meetings" */
export type MeetingsMeeting_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meeting_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meeting_Members_Order_By>>;
  where?: InputMaybe<Meeting_Members_Bool_Exp>;
};

/** aggregated selection of "meetings" */
export type Meetings_Aggregate = {
  __typename?: 'meetings_aggregate';
  aggregate?: Maybe<Meetings_Aggregate_Fields>;
  nodes: Array<Meetings>;
};

/** aggregate fields of "meetings" */
export type Meetings_Aggregate_Fields = {
  __typename?: 'meetings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Meetings_Max_Fields>;
  min?: Maybe<Meetings_Min_Fields>;
};


/** aggregate fields of "meetings" */
export type Meetings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meetings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "meetings". All fields are combined with a logical 'AND'. */
export type Meetings_Bool_Exp = {
  _and?: InputMaybe<Array<Meetings_Bool_Exp>>;
  _not?: InputMaybe<Meetings_Bool_Exp>;
  _or?: InputMaybe<Array<Meetings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  meeting_id?: InputMaybe<String_Comparison_Exp>;
  meeting_members?: InputMaybe<Meeting_Members_Bool_Exp>;
  meeting_members_aggregate?: InputMaybe<Meeting_Members_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "meetings" */
export enum Meetings_Constraint {
  /** unique or primary key constraint on columns "meeting_id" */
  MeetingsMeetingIdKey = 'meetings_meeting_id_key',
  /** unique or primary key constraint on columns "id" */
  MeetingsPkey = 'meetings_pkey'
}

/** input type for inserting data into table "meetings" */
export type Meetings_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  meeting_id?: InputMaybe<Scalars['String']['input']>;
  meeting_members?: InputMaybe<Meeting_Members_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Meetings_Max_Fields = {
  __typename?: 'meetings_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  meeting_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Meetings_Min_Fields = {
  __typename?: 'meetings_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  meeting_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "meetings" */
export type Meetings_Mutation_Response = {
  __typename?: 'meetings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Meetings>;
};

/** input type for inserting object relation for remote table "meetings" */
export type Meetings_Obj_Rel_Insert_Input = {
  data: Meetings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Meetings_On_Conflict>;
};

/** on_conflict condition type for table "meetings" */
export type Meetings_On_Conflict = {
  constraint: Meetings_Constraint;
  update_columns?: Array<Meetings_Update_Column>;
  where?: InputMaybe<Meetings_Bool_Exp>;
};

/** Ordering options when selecting data from "meetings". */
export type Meetings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meeting_id?: InputMaybe<Order_By>;
  meeting_members_aggregate?: InputMaybe<Meeting_Members_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: meetings */
export type Meetings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "meetings" */
export enum Meetings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MeetingId = 'meeting_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "meetings" */
export type Meetings_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  meeting_id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "meetings" */
export type Meetings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meetings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Meetings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  meeting_id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "meetings" */
export enum Meetings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MeetingId = 'meeting_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Meetings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meetings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Meetings_Bool_Exp;
};

/** columns and relationships of "message_reactions" */
export type Message_Reactions = {
  __typename?: 'message_reactions';
  created_at: Scalars['timestamptz']['output'];
  emoji: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregated selection of "message_reactions" */
export type Message_Reactions_Aggregate = {
  __typename?: 'message_reactions_aggregate';
  aggregate?: Maybe<Message_Reactions_Aggregate_Fields>;
  nodes: Array<Message_Reactions>;
};

export type Message_Reactions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Message_Reactions_Aggregate_Bool_Exp_Count>;
};

export type Message_Reactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Message_Reactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Reactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "message_reactions" */
export type Message_Reactions_Aggregate_Fields = {
  __typename?: 'message_reactions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Message_Reactions_Max_Fields>;
  min?: Maybe<Message_Reactions_Min_Fields>;
};


/** aggregate fields of "message_reactions" */
export type Message_Reactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Message_Reactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "message_reactions" */
export type Message_Reactions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Message_Reactions_Max_Order_By>;
  min?: InputMaybe<Message_Reactions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "message_reactions" */
export type Message_Reactions_Arr_Rel_Insert_Input = {
  data: Array<Message_Reactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Message_Reactions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "message_reactions". All fields are combined with a logical 'AND'. */
export type Message_Reactions_Bool_Exp = {
  _and?: InputMaybe<Array<Message_Reactions_Bool_Exp>>;
  _not?: InputMaybe<Message_Reactions_Bool_Exp>;
  _or?: InputMaybe<Array<Message_Reactions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  emoji?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<Messages_Bool_Exp>;
  message_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "message_reactions" */
export enum Message_Reactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessageReactionsPkey = 'message_reactions_pkey',
  /** unique or primary key constraint on columns "user_id", "message_id" */
  MessageReactionsUserIdMessageIdKey = 'message_reactions_user_id_message_id_key'
}

/** input type for inserting data into table "message_reactions" */
export type Message_Reactions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Messages_Obj_Rel_Insert_Input>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Message_Reactions_Max_Fields = {
  __typename?: 'message_reactions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "message_reactions" */
export type Message_Reactions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  emoji?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Message_Reactions_Min_Fields = {
  __typename?: 'message_reactions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "message_reactions" */
export type Message_Reactions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  emoji?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "message_reactions" */
export type Message_Reactions_Mutation_Response = {
  __typename?: 'message_reactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Message_Reactions>;
};

/** on_conflict condition type for table "message_reactions" */
export type Message_Reactions_On_Conflict = {
  constraint: Message_Reactions_Constraint;
  update_columns?: Array<Message_Reactions_Update_Column>;
  where?: InputMaybe<Message_Reactions_Bool_Exp>;
};

/** Ordering options when selecting data from "message_reactions". */
export type Message_Reactions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  emoji?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Messages_Order_By>;
  message_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: message_reactions */
export type Message_Reactions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "message_reactions" */
export enum Message_Reactions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Emoji = 'emoji',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "message_reactions" */
export type Message_Reactions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "message_reactions" */
export type Message_Reactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Message_Reactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Message_Reactions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "message_reactions" */
export enum Message_Reactions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Emoji = 'emoji',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Message_Reactions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Message_Reactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Message_Reactions_Bool_Exp;
};

/** columns and relationships of "messages" */
export type Messages = {
  __typename?: 'messages';
  /** An object relationship */
  all_auth_recipe_user?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  /** An object relationship */
  channel: Channels;
  channel_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  file_name?: Maybe<Scalars['String']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_pinned: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  messages_reads: Array<Messages_Read>;
  /** An aggregate relationship */
  messages_reads_aggregate: Messages_Read_Aggregate;
  /** An object relationship */
  poll?: Maybe<Poll>;
  /** An array relationship */
  polls: Array<Poll>;
  /** An aggregate relationship */
  polls_aggregate: Poll_Aggregate;
  /** An array relationship */
  reactions: Array<Message_Reactions>;
  /** An aggregate relationship */
  reactions_aggregate: Message_Reactions_Aggregate;
  replied_to_message_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  reported_messages: Array<Reported_Message>;
  /** An aggregate relationship */
  reported_messages_aggregate: Reported_Message_Aggregate;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Supertokens_User_Public_Fields>;
  user_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "messages" */
export type MessagesMessages_ReadsArgs = {
  distinct_on?: InputMaybe<Array<Messages_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Read_Order_By>>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesMessages_Reads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Read_Order_By>>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesPollsArgs = {
  distinct_on?: InputMaybe<Array<Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Order_By>>;
  where?: InputMaybe<Poll_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesPolls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Order_By>>;
  where?: InputMaybe<Poll_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesReactionsArgs = {
  distinct_on?: InputMaybe<Array<Message_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Message_Reactions_Order_By>>;
  where?: InputMaybe<Message_Reactions_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesReactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Message_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Message_Reactions_Order_By>>;
  where?: InputMaybe<Message_Reactions_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesReported_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Reported_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reported_Message_Order_By>>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesReported_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reported_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reported_Message_Order_By>>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};

/** aggregated selection of "messages" */
export type Messages_Aggregate = {
  __typename?: 'messages_aggregate';
  aggregate?: Maybe<Messages_Aggregate_Fields>;
  nodes: Array<Messages>;
};

export type Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Messages_Aggregate_Bool_Exp_Count>;
};

export type Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "messages" */
export type Messages_Aggregate_Fields = {
  __typename?: 'messages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Messages_Max_Fields>;
  min?: Maybe<Messages_Min_Fields>;
};


/** aggregate fields of "messages" */
export type Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messages" */
export type Messages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Messages_Max_Order_By>;
  min?: InputMaybe<Messages_Min_Order_By>;
};

/** input type for inserting array relation for remote table "messages" */
export type Messages_Arr_Rel_Insert_Input = {
  data: Array<Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Messages_On_Conflict>;
};

/** Boolean expression to filter rows from the table "messages". All fields are combined with a logical 'AND'. */
export type Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Messages_Bool_Exp>>;
  _not?: InputMaybe<Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Messages_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  channel?: InputMaybe<Channels_Bool_Exp>;
  channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_pinned?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  messages_reads?: InputMaybe<Messages_Read_Bool_Exp>;
  messages_reads_aggregate?: InputMaybe<Messages_Read_Aggregate_Bool_Exp>;
  poll?: InputMaybe<Poll_Bool_Exp>;
  polls?: InputMaybe<Poll_Bool_Exp>;
  polls_aggregate?: InputMaybe<Poll_Aggregate_Bool_Exp>;
  reactions?: InputMaybe<Message_Reactions_Bool_Exp>;
  reactions_aggregate?: InputMaybe<Message_Reactions_Aggregate_Bool_Exp>;
  replied_to_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  reported_messages?: InputMaybe<Reported_Message_Bool_Exp>;
  reported_messages_aggregate?: InputMaybe<Reported_Message_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "messages" */
export enum Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagesPkey = 'messages_pkey'
}

/** input type for inserting data into table "messages" */
export type Messages_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  channel?: InputMaybe<Channels_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messages_reads?: InputMaybe<Messages_Read_Arr_Rel_Insert_Input>;
  poll?: InputMaybe<Poll_Obj_Rel_Insert_Input>;
  polls?: InputMaybe<Poll_Arr_Rel_Insert_Input>;
  reactions?: InputMaybe<Message_Reactions_Arr_Rel_Insert_Input>;
  replied_to_message_id?: InputMaybe<Scalars['uuid']['input']>;
  reported_messages?: InputMaybe<Reported_Message_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Messages_Max_Fields = {
  __typename?: 'messages_max_fields';
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  replied_to_message_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "messages" */
export type Messages_Max_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  replied_to_message_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Messages_Min_Fields = {
  __typename?: 'messages_min_fields';
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  replied_to_message_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "messages" */
export type Messages_Min_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  replied_to_message_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "messages" */
export type Messages_Mutation_Response = {
  __typename?: 'messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Messages>;
};

/** input type for inserting object relation for remote table "messages" */
export type Messages_Obj_Rel_Insert_Input = {
  data: Messages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Messages_On_Conflict>;
};

/** on_conflict condition type for table "messages" */
export type Messages_On_Conflict = {
  constraint: Messages_Constraint;
  update_columns?: Array<Messages_Update_Column>;
  where?: InputMaybe<Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "messages". */
export type Messages_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  channel?: InputMaybe<Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_pinned?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  messages_reads_aggregate?: InputMaybe<Messages_Read_Aggregate_Order_By>;
  poll?: InputMaybe<Poll_Order_By>;
  polls_aggregate?: InputMaybe<Poll_Aggregate_Order_By>;
  reactions_aggregate?: InputMaybe<Message_Reactions_Aggregate_Order_By>;
  replied_to_message_id?: InputMaybe<Order_By>;
  reported_messages_aggregate?: InputMaybe<Reported_Message_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: messages */
export type Messages_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "messages_read" */
export type Messages_Read = {
  __typename?: 'messages_read';
  /** An object relationship */
  channel: Channels;
  channel_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregated selection of "messages_read" */
export type Messages_Read_Aggregate = {
  __typename?: 'messages_read_aggregate';
  aggregate?: Maybe<Messages_Read_Aggregate_Fields>;
  nodes: Array<Messages_Read>;
};

export type Messages_Read_Aggregate_Bool_Exp = {
  count?: InputMaybe<Messages_Read_Aggregate_Bool_Exp_Count>;
};

export type Messages_Read_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Messages_Read_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messages_Read_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "messages_read" */
export type Messages_Read_Aggregate_Fields = {
  __typename?: 'messages_read_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Messages_Read_Max_Fields>;
  min?: Maybe<Messages_Read_Min_Fields>;
};


/** aggregate fields of "messages_read" */
export type Messages_Read_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Messages_Read_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messages_read" */
export type Messages_Read_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Messages_Read_Max_Order_By>;
  min?: InputMaybe<Messages_Read_Min_Order_By>;
};

/** input type for inserting array relation for remote table "messages_read" */
export type Messages_Read_Arr_Rel_Insert_Input = {
  data: Array<Messages_Read_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Messages_Read_On_Conflict>;
};

/** Boolean expression to filter rows from the table "messages_read". All fields are combined with a logical 'AND'. */
export type Messages_Read_Bool_Exp = {
  _and?: InputMaybe<Array<Messages_Read_Bool_Exp>>;
  _not?: InputMaybe<Messages_Read_Bool_Exp>;
  _or?: InputMaybe<Array<Messages_Read_Bool_Exp>>;
  channel?: InputMaybe<Channels_Bool_Exp>;
  channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<Messages_Bool_Exp>;
  message_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "messages_read" */
export enum Messages_Read_Constraint {
  /** unique or primary key constraint on columns "user_id", "channel_id", "message_id" */
  MessagesReadMessageIdUserIdChannelIdKey = 'messages_read_message_id_user_id_channel_id_key',
  /** unique or primary key constraint on columns "id" */
  MessagesReadPkey = 'messages_read_pkey'
}

/** input type for inserting data into table "messages_read" */
export type Messages_Read_Insert_Input = {
  channel?: InputMaybe<Channels_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Messages_Obj_Rel_Insert_Input>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Messages_Read_Max_Fields = {
  __typename?: 'messages_read_max_fields';
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "messages_read" */
export type Messages_Read_Max_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Messages_Read_Min_Fields = {
  __typename?: 'messages_read_min_fields';
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "messages_read" */
export type Messages_Read_Min_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "messages_read" */
export type Messages_Read_Mutation_Response = {
  __typename?: 'messages_read_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Messages_Read>;
};

/** on_conflict condition type for table "messages_read" */
export type Messages_Read_On_Conflict = {
  constraint: Messages_Read_Constraint;
  update_columns?: Array<Messages_Read_Update_Column>;
  where?: InputMaybe<Messages_Read_Bool_Exp>;
};

/** Ordering options when selecting data from "messages_read". */
export type Messages_Read_Order_By = {
  channel?: InputMaybe<Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Messages_Order_By>;
  message_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: messages_read */
export type Messages_Read_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messages_read" */
export enum Messages_Read_Select_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "messages_read" */
export type Messages_Read_Set_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "messages_read" */
export type Messages_Read_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Messages_Read_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messages_Read_Stream_Cursor_Value_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "messages_read" */
export enum Messages_Read_Update_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Messages_Read_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Messages_Read_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messages_Read_Bool_Exp;
};

/** select columns of table "messages" */
export enum Messages_Select_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsPinned = 'is_pinned',
  /** column name */
  Message = 'message',
  /** column name */
  RepliedToMessageId = 'replied_to_message_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "messages" */
export enum Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPinned = 'is_pinned'
}

/** select "messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "messages" */
export enum Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPinned = 'is_pinned'
}

/** input type for updating data in table "messages" */
export type Messages_Set_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  replied_to_message_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "messages" */
export type Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messages_Stream_Cursor_Value_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  replied_to_message_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "messages" */
export enum Messages_Update_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsPinned = 'is_pinned',
  /** column name */
  Message = 'message',
  /** column name */
  RepliedToMessageId = 'replied_to_message_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Messages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messages_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "offline_leads" */
export type Offline_Leads = {
  __typename?: 'offline_leads';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_verified: Scalars['Boolean']['output'];
  lead_squared_id?: Maybe<Scalars['String']['output']>;
  lead_squared_is_created: Scalars['Boolean']['output'];
  lead_squared_related_id?: Maybe<Scalars['String']['output']>;
  mobile: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['numeric']['output']>;
  otp_expiry?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "offline_leads" */
export type Offline_Leads_Aggregate = {
  __typename?: 'offline_leads_aggregate';
  aggregate?: Maybe<Offline_Leads_Aggregate_Fields>;
  nodes: Array<Offline_Leads>;
};

/** aggregate fields of "offline_leads" */
export type Offline_Leads_Aggregate_Fields = {
  __typename?: 'offline_leads_aggregate_fields';
  avg?: Maybe<Offline_Leads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Offline_Leads_Max_Fields>;
  min?: Maybe<Offline_Leads_Min_Fields>;
  stddev?: Maybe<Offline_Leads_Stddev_Fields>;
  stddev_pop?: Maybe<Offline_Leads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offline_Leads_Stddev_Samp_Fields>;
  sum?: Maybe<Offline_Leads_Sum_Fields>;
  var_pop?: Maybe<Offline_Leads_Var_Pop_Fields>;
  var_samp?: Maybe<Offline_Leads_Var_Samp_Fields>;
  variance?: Maybe<Offline_Leads_Variance_Fields>;
};


/** aggregate fields of "offline_leads" */
export type Offline_Leads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offline_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Offline_Leads_Avg_Fields = {
  __typename?: 'offline_leads_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "offline_leads". All fields are combined with a logical 'AND'. */
export type Offline_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Offline_Leads_Bool_Exp>>;
  _not?: InputMaybe<Offline_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Offline_Leads_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  lead_squared_id?: InputMaybe<String_Comparison_Exp>;
  lead_squared_is_created?: InputMaybe<Boolean_Comparison_Exp>;
  lead_squared_related_id?: InputMaybe<String_Comparison_Exp>;
  mobile?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  otp?: InputMaybe<Numeric_Comparison_Exp>;
  otp_expiry?: InputMaybe<Timestamptz_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "offline_leads" */
export enum Offline_Leads_Constraint {
  /** unique or primary key constraint on columns "mobile" */
  OfflineLeadsMobileKey = 'offline_leads_mobile_key',
  /** unique or primary key constraint on columns "id" */
  OfflineLeadsPkey = 'offline_leads_pkey'
}

/** input type for incrementing numeric columns in table "offline_leads" */
export type Offline_Leads_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  otp?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "offline_leads" */
export type Offline_Leads_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  lead_squared_id?: InputMaybe<Scalars['String']['input']>;
  lead_squared_is_created?: InputMaybe<Scalars['Boolean']['input']>;
  lead_squared_related_id?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['numeric']['input']>;
  otp_expiry?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Offline_Leads_Max_Fields = {
  __typename?: 'offline_leads_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lead_squared_id?: Maybe<Scalars['String']['output']>;
  lead_squared_related_id?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['numeric']['output']>;
  otp_expiry?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Offline_Leads_Min_Fields = {
  __typename?: 'offline_leads_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lead_squared_id?: Maybe<Scalars['String']['output']>;
  lead_squared_related_id?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['numeric']['output']>;
  otp_expiry?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "offline_leads" */
export type Offline_Leads_Mutation_Response = {
  __typename?: 'offline_leads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Offline_Leads>;
};

/** on_conflict condition type for table "offline_leads" */
export type Offline_Leads_On_Conflict = {
  constraint: Offline_Leads_Constraint;
  update_columns?: Array<Offline_Leads_Update_Column>;
  where?: InputMaybe<Offline_Leads_Bool_Exp>;
};

/** Ordering options when selecting data from "offline_leads". */
export type Offline_Leads_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  lead_squared_id?: InputMaybe<Order_By>;
  lead_squared_is_created?: InputMaybe<Order_By>;
  lead_squared_related_id?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  otp_expiry?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: offline_leads */
export type Offline_Leads_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "offline_leads" */
export enum Offline_Leads_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LeadSquaredId = 'lead_squared_id',
  /** column name */
  LeadSquaredIsCreated = 'lead_squared_is_created',
  /** column name */
  LeadSquaredRelatedId = 'lead_squared_related_id',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  Name = 'name',
  /** column name */
  Otp = 'otp',
  /** column name */
  OtpExpiry = 'otp_expiry',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "offline_leads" */
export type Offline_Leads_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  lead_squared_id?: InputMaybe<Scalars['String']['input']>;
  lead_squared_is_created?: InputMaybe<Scalars['Boolean']['input']>;
  lead_squared_related_id?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['numeric']['input']>;
  otp_expiry?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Offline_Leads_Stddev_Fields = {
  __typename?: 'offline_leads_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Offline_Leads_Stddev_Pop_Fields = {
  __typename?: 'offline_leads_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Offline_Leads_Stddev_Samp_Fields = {
  __typename?: 'offline_leads_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "offline_leads" */
export type Offline_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offline_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offline_Leads_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  lead_squared_id?: InputMaybe<Scalars['String']['input']>;
  lead_squared_is_created?: InputMaybe<Scalars['Boolean']['input']>;
  lead_squared_related_id?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['numeric']['input']>;
  otp_expiry?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Offline_Leads_Sum_Fields = {
  __typename?: 'offline_leads_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  otp?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "offline_leads" */
export enum Offline_Leads_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LeadSquaredId = 'lead_squared_id',
  /** column name */
  LeadSquaredIsCreated = 'lead_squared_is_created',
  /** column name */
  LeadSquaredRelatedId = 'lead_squared_related_id',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  Name = 'name',
  /** column name */
  Otp = 'otp',
  /** column name */
  OtpExpiry = 'otp_expiry',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Offline_Leads_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Offline_Leads_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Offline_Leads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Offline_Leads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Offline_Leads_Var_Pop_Fields = {
  __typename?: 'offline_leads_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Offline_Leads_Var_Samp_Fields = {
  __typename?: 'offline_leads_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Offline_Leads_Variance_Fields = {
  __typename?: 'offline_leads_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes = {
  __typename?: 'package_content_discarded_quizzes';
  content_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  packages_content: Packages_Content;
  quiz_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_quiz: Quiz_Quiz;
};

/** aggregated selection of "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Aggregate = {
  __typename?: 'package_content_discarded_quizzes_aggregate';
  aggregate?: Maybe<Package_Content_Discarded_Quizzes_Aggregate_Fields>;
  nodes: Array<Package_Content_Discarded_Quizzes>;
};

export type Package_Content_Discarded_Quizzes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Package_Content_Discarded_Quizzes_Aggregate_Bool_Exp_Count>;
};

export type Package_Content_Discarded_Quizzes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Aggregate_Fields = {
  __typename?: 'package_content_discarded_quizzes_aggregate_fields';
  avg?: Maybe<Package_Content_Discarded_Quizzes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Package_Content_Discarded_Quizzes_Max_Fields>;
  min?: Maybe<Package_Content_Discarded_Quizzes_Min_Fields>;
  stddev?: Maybe<Package_Content_Discarded_Quizzes_Stddev_Fields>;
  stddev_pop?: Maybe<Package_Content_Discarded_Quizzes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Package_Content_Discarded_Quizzes_Stddev_Samp_Fields>;
  sum?: Maybe<Package_Content_Discarded_Quizzes_Sum_Fields>;
  var_pop?: Maybe<Package_Content_Discarded_Quizzes_Var_Pop_Fields>;
  var_samp?: Maybe<Package_Content_Discarded_Quizzes_Var_Samp_Fields>;
  variance?: Maybe<Package_Content_Discarded_Quizzes_Variance_Fields>;
};


/** aggregate fields of "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Aggregate_Order_By = {
  avg?: InputMaybe<Package_Content_Discarded_Quizzes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Package_Content_Discarded_Quizzes_Max_Order_By>;
  min?: InputMaybe<Package_Content_Discarded_Quizzes_Min_Order_By>;
  stddev?: InputMaybe<Package_Content_Discarded_Quizzes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Package_Content_Discarded_Quizzes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Package_Content_Discarded_Quizzes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Package_Content_Discarded_Quizzes_Sum_Order_By>;
  var_pop?: InputMaybe<Package_Content_Discarded_Quizzes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Package_Content_Discarded_Quizzes_Var_Samp_Order_By>;
  variance?: InputMaybe<Package_Content_Discarded_Quizzes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Arr_Rel_Insert_Input = {
  data: Array<Package_Content_Discarded_Quizzes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Package_Content_Discarded_Quizzes_On_Conflict>;
};

/** aggregate avg on columns */
export type Package_Content_Discarded_Quizzes_Avg_Fields = {
  __typename?: 'package_content_discarded_quizzes_avg_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Avg_Order_By = {
  content_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "package_content_discarded_quizzes". All fields are combined with a logical 'AND'. */
export type Package_Content_Discarded_Quizzes_Bool_Exp = {
  _and?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Bool_Exp>>;
  _not?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
  _or?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Bool_Exp>>;
  content_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  packages_content?: InputMaybe<Packages_Content_Bool_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};

/** unique or primary key constraints on table "package_content_discarded_quizzes" */
export enum Package_Content_Discarded_Quizzes_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackageContentDiscardedQuizzesPkey = 'package_content_discarded_quizzes_pkey'
}

/** input type for incrementing numeric columns in table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Inc_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Insert_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  packages_content?: InputMaybe<Packages_Content_Obj_Rel_Insert_Input>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Package_Content_Discarded_Quizzes_Max_Fields = {
  __typename?: 'package_content_discarded_quizzes_max_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Max_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Package_Content_Discarded_Quizzes_Min_Fields = {
  __typename?: 'package_content_discarded_quizzes_min_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Min_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Mutation_Response = {
  __typename?: 'package_content_discarded_quizzes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Package_Content_Discarded_Quizzes>;
};

/** on_conflict condition type for table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_On_Conflict = {
  constraint: Package_Content_Discarded_Quizzes_Constraint;
  update_columns?: Array<Package_Content_Discarded_Quizzes_Update_Column>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};

/** Ordering options when selecting data from "package_content_discarded_quizzes". */
export type Package_Content_Discarded_Quizzes_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packages_content?: InputMaybe<Packages_Content_Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
};

/** primary key columns input for table: package_content_discarded_quizzes */
export type Package_Content_Discarded_Quizzes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "package_content_discarded_quizzes" */
export enum Package_Content_Discarded_Quizzes_Select_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id'
}

/** input type for updating data in table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Set_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Package_Content_Discarded_Quizzes_Stddev_Fields = {
  __typename?: 'package_content_discarded_quizzes_stddev_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Stddev_Order_By = {
  content_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Package_Content_Discarded_Quizzes_Stddev_Pop_Fields = {
  __typename?: 'package_content_discarded_quizzes_stddev_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Stddev_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Package_Content_Discarded_Quizzes_Stddev_Samp_Fields = {
  __typename?: 'package_content_discarded_quizzes_stddev_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Stddev_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Package_Content_Discarded_Quizzes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Package_Content_Discarded_Quizzes_Stream_Cursor_Value_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Package_Content_Discarded_Quizzes_Sum_Fields = {
  __typename?: 'package_content_discarded_quizzes_sum_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Sum_Order_By = {
  content_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** update columns of table "package_content_discarded_quizzes" */
export enum Package_Content_Discarded_Quizzes_Update_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id'
}

export type Package_Content_Discarded_Quizzes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Package_Content_Discarded_Quizzes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Package_Content_Discarded_Quizzes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Package_Content_Discarded_Quizzes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Package_Content_Discarded_Quizzes_Var_Pop_Fields = {
  __typename?: 'package_content_discarded_quizzes_var_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Var_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Package_Content_Discarded_Quizzes_Var_Samp_Fields = {
  __typename?: 'package_content_discarded_quizzes_var_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Var_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Package_Content_Discarded_Quizzes_Variance_Fields = {
  __typename?: 'package_content_discarded_quizzes_variance_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "package_content_discarded_quizzes" */
export type Package_Content_Discarded_Quizzes_Variance_Order_By = {
  content_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "packages_content" */
export type Packages_Content = {
  __typename?: 'packages_content';
  breif?: Maybe<Scalars['String']['output']>;
  brief?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  disable_live_classes: Scalars['Boolean']['output'];
  expiry_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['Int']['output'];
  is_master?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  package_content_discarded_quizzes: Array<Package_Content_Discarded_Quizzes>;
  /** An aggregate relationship */
  package_content_discarded_quizzes_aggregate: Package_Content_Discarded_Quizzes_Aggregate;
  /** An array relationship */
  packages_content_domains: Array<Packages_Content_Domains>;
  /** An aggregate relationship */
  packages_content_domains_aggregate: Packages_Content_Domains_Aggregate;
  /** An array relationship */
  packages_content_text_lessons: Array<Packages_Content_Text_Lesson>;
  /** An aggregate relationship */
  packages_content_text_lessons_aggregate: Packages_Content_Text_Lesson_Aggregate;
  /** An array relationship */
  packages_content_timed_tests: Array<Packages_Content_Timed_Test>;
  /** An aggregate relationship */
  packages_content_timed_tests_aggregate: Packages_Content_Timed_Test_Aggregate;
  /** An array relationship */
  packages_content_untimed_tests: Array<Packages_Content_Untimed_Test>;
  /** An aggregate relationship */
  packages_content_untimed_tests_aggregate: Packages_Content_Untimed_Test_Aggregate;
  /** An object relationship */
  quiz_superdomain?: Maybe<Quiz_Superdomain>;
  rank?: Maybe<Scalars['Int']['output']>;
  subscription_plan_id: Scalars['uuid']['output'];
  /** An object relationship */
  subscriptions_subscriptionplan: Subscriptions_Subscriptionplan;
  super_domain_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackage_Content_Discarded_QuizzesArgs = {
  distinct_on?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Order_By>>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackage_Content_Discarded_Quizzes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Order_By>>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackages_Content_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Domains_Order_By>>;
  where?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackages_Content_Domains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Domains_Order_By>>;
  where?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackages_Content_Text_LessonsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Text_Lesson_Order_By>>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackages_Content_Text_Lessons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Text_Lesson_Order_By>>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackages_Content_Timed_TestsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Timed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackages_Content_Timed_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Timed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackages_Content_Untimed_TestsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Untimed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};


/** columns and relationships of "packages_content" */
export type Packages_ContentPackages_Content_Untimed_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Untimed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};

/** aggregated selection of "packages_content" */
export type Packages_Content_Aggregate = {
  __typename?: 'packages_content_aggregate';
  aggregate?: Maybe<Packages_Content_Aggregate_Fields>;
  nodes: Array<Packages_Content>;
};

export type Packages_Content_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Packages_Content_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Packages_Content_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Packages_Content_Aggregate_Bool_Exp_Count>;
};

export type Packages_Content_Aggregate_Bool_Exp_Bool_And = {
  arguments: Packages_Content_Select_Column_Packages_Content_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Content_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Packages_Content_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Packages_Content_Select_Column_Packages_Content_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Content_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Packages_Content_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Packages_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Content_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "packages_content" */
export type Packages_Content_Aggregate_Fields = {
  __typename?: 'packages_content_aggregate_fields';
  avg?: Maybe<Packages_Content_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Packages_Content_Max_Fields>;
  min?: Maybe<Packages_Content_Min_Fields>;
  stddev?: Maybe<Packages_Content_Stddev_Fields>;
  stddev_pop?: Maybe<Packages_Content_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packages_Content_Stddev_Samp_Fields>;
  sum?: Maybe<Packages_Content_Sum_Fields>;
  var_pop?: Maybe<Packages_Content_Var_Pop_Fields>;
  var_samp?: Maybe<Packages_Content_Var_Samp_Fields>;
  variance?: Maybe<Packages_Content_Variance_Fields>;
};


/** aggregate fields of "packages_content" */
export type Packages_Content_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packages_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "packages_content" */
export type Packages_Content_Aggregate_Order_By = {
  avg?: InputMaybe<Packages_Content_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packages_Content_Max_Order_By>;
  min?: InputMaybe<Packages_Content_Min_Order_By>;
  stddev?: InputMaybe<Packages_Content_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packages_Content_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packages_Content_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packages_Content_Sum_Order_By>;
  var_pop?: InputMaybe<Packages_Content_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packages_Content_Var_Samp_Order_By>;
  variance?: InputMaybe<Packages_Content_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "packages_content" */
export type Packages_Content_Arr_Rel_Insert_Input = {
  data: Array<Packages_Content_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packages_Content_On_Conflict>;
};

/** aggregate avg on columns */
export type Packages_Content_Avg_Fields = {
  __typename?: 'packages_content_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "packages_content" */
export type Packages_Content_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "packages_content". All fields are combined with a logical 'AND'. */
export type Packages_Content_Bool_Exp = {
  _and?: InputMaybe<Array<Packages_Content_Bool_Exp>>;
  _not?: InputMaybe<Packages_Content_Bool_Exp>;
  _or?: InputMaybe<Array<Packages_Content_Bool_Exp>>;
  breif?: InputMaybe<String_Comparison_Exp>;
  brief?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  disable_live_classes?: InputMaybe<Boolean_Comparison_Exp>;
  expiry_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_master?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  package_content_discarded_quizzes?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
  package_content_discarded_quizzes_aggregate?: InputMaybe<Package_Content_Discarded_Quizzes_Aggregate_Bool_Exp>;
  packages_content_domains?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
  packages_content_domains_aggregate?: InputMaybe<Packages_Content_Domains_Aggregate_Bool_Exp>;
  packages_content_text_lessons?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
  packages_content_text_lessons_aggregate?: InputMaybe<Packages_Content_Text_Lesson_Aggregate_Bool_Exp>;
  packages_content_timed_tests?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
  packages_content_timed_tests_aggregate?: InputMaybe<Packages_Content_Timed_Test_Aggregate_Bool_Exp>;
  packages_content_untimed_tests?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
  packages_content_untimed_tests_aggregate?: InputMaybe<Packages_Content_Untimed_Test_Aggregate_Bool_Exp>;
  quiz_superdomain?: InputMaybe<Quiz_Superdomain_Bool_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  subscription_plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  super_domain_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "packages_content" */
export enum Packages_Content_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackagesContentPkey = 'packages_content_pkey'
}

/** columns and relationships of "packages_content_domains" */
export type Packages_Content_Domains = {
  __typename?: 'packages_content_domains';
  content_id: Scalars['Int']['output'];
  domain_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  packages_content: Packages_Content;
  /** An object relationship */
  quiz_domain: Quiz_Domain;
};

/** aggregated selection of "packages_content_domains" */
export type Packages_Content_Domains_Aggregate = {
  __typename?: 'packages_content_domains_aggregate';
  aggregate?: Maybe<Packages_Content_Domains_Aggregate_Fields>;
  nodes: Array<Packages_Content_Domains>;
};

export type Packages_Content_Domains_Aggregate_Bool_Exp = {
  count?: InputMaybe<Packages_Content_Domains_Aggregate_Bool_Exp_Count>;
};

export type Packages_Content_Domains_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Packages_Content_Domains_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "packages_content_domains" */
export type Packages_Content_Domains_Aggregate_Fields = {
  __typename?: 'packages_content_domains_aggregate_fields';
  avg?: Maybe<Packages_Content_Domains_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Packages_Content_Domains_Max_Fields>;
  min?: Maybe<Packages_Content_Domains_Min_Fields>;
  stddev?: Maybe<Packages_Content_Domains_Stddev_Fields>;
  stddev_pop?: Maybe<Packages_Content_Domains_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packages_Content_Domains_Stddev_Samp_Fields>;
  sum?: Maybe<Packages_Content_Domains_Sum_Fields>;
  var_pop?: Maybe<Packages_Content_Domains_Var_Pop_Fields>;
  var_samp?: Maybe<Packages_Content_Domains_Var_Samp_Fields>;
  variance?: Maybe<Packages_Content_Domains_Variance_Fields>;
};


/** aggregate fields of "packages_content_domains" */
export type Packages_Content_Domains_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packages_Content_Domains_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "packages_content_domains" */
export type Packages_Content_Domains_Aggregate_Order_By = {
  avg?: InputMaybe<Packages_Content_Domains_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packages_Content_Domains_Max_Order_By>;
  min?: InputMaybe<Packages_Content_Domains_Min_Order_By>;
  stddev?: InputMaybe<Packages_Content_Domains_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packages_Content_Domains_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packages_Content_Domains_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packages_Content_Domains_Sum_Order_By>;
  var_pop?: InputMaybe<Packages_Content_Domains_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packages_Content_Domains_Var_Samp_Order_By>;
  variance?: InputMaybe<Packages_Content_Domains_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "packages_content_domains" */
export type Packages_Content_Domains_Arr_Rel_Insert_Input = {
  data: Array<Packages_Content_Domains_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packages_Content_Domains_On_Conflict>;
};

/** aggregate avg on columns */
export type Packages_Content_Domains_Avg_Fields = {
  __typename?: 'packages_content_domains_avg_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Avg_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "packages_content_domains". All fields are combined with a logical 'AND'. */
export type Packages_Content_Domains_Bool_Exp = {
  _and?: InputMaybe<Array<Packages_Content_Domains_Bool_Exp>>;
  _not?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
  _or?: InputMaybe<Array<Packages_Content_Domains_Bool_Exp>>;
  content_id?: InputMaybe<Int_Comparison_Exp>;
  domain_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  packages_content?: InputMaybe<Packages_Content_Bool_Exp>;
  quiz_domain?: InputMaybe<Quiz_Domain_Bool_Exp>;
};

/** unique or primary key constraints on table "packages_content_domains" */
export enum Packages_Content_Domains_Constraint {
  /** unique or primary key constraint on columns "content_id", "domain_id" */
  PackagesContentDomainsContentIdDomainIdKey = 'packages_content_domains_content_id_domain_id_key',
  /** unique or primary key constraint on columns "id" */
  PackagesContentDomainsPkey = 'packages_content_domains_pkey'
}

/** input type for incrementing numeric columns in table "packages_content_domains" */
export type Packages_Content_Domains_Inc_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  domain_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "packages_content_domains" */
export type Packages_Content_Domains_Insert_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  domain_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  packages_content?: InputMaybe<Packages_Content_Obj_Rel_Insert_Input>;
  quiz_domain?: InputMaybe<Quiz_Domain_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Packages_Content_Domains_Max_Fields = {
  __typename?: 'packages_content_domains_max_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  domain_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Max_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Packages_Content_Domains_Min_Fields = {
  __typename?: 'packages_content_domains_min_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  domain_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Min_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "packages_content_domains" */
export type Packages_Content_Domains_Mutation_Response = {
  __typename?: 'packages_content_domains_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Packages_Content_Domains>;
};

/** on_conflict condition type for table "packages_content_domains" */
export type Packages_Content_Domains_On_Conflict = {
  constraint: Packages_Content_Domains_Constraint;
  update_columns?: Array<Packages_Content_Domains_Update_Column>;
  where?: InputMaybe<Packages_Content_Domains_Bool_Exp>;
};

/** Ordering options when selecting data from "packages_content_domains". */
export type Packages_Content_Domains_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packages_content?: InputMaybe<Packages_Content_Order_By>;
  quiz_domain?: InputMaybe<Quiz_Domain_Order_By>;
};

/** primary key columns input for table: packages_content_domains */
export type Packages_Content_Domains_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "packages_content_domains" */
export enum Packages_Content_Domains_Select_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  DomainId = 'domain_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "packages_content_domains" */
export type Packages_Content_Domains_Set_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  domain_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Packages_Content_Domains_Stddev_Fields = {
  __typename?: 'packages_content_domains_stddev_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Stddev_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Packages_Content_Domains_Stddev_Pop_Fields = {
  __typename?: 'packages_content_domains_stddev_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Stddev_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Packages_Content_Domains_Stddev_Samp_Fields = {
  __typename?: 'packages_content_domains_stddev_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Stddev_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "packages_content_domains" */
export type Packages_Content_Domains_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packages_Content_Domains_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packages_Content_Domains_Stream_Cursor_Value_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  domain_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Packages_Content_Domains_Sum_Fields = {
  __typename?: 'packages_content_domains_sum_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  domain_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Sum_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
};

/** update columns of table "packages_content_domains" */
export enum Packages_Content_Domains_Update_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  DomainId = 'domain_id',
  /** column name */
  Id = 'id'
}

export type Packages_Content_Domains_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packages_Content_Domains_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packages_Content_Domains_Set_Input>;
  /** filter the rows which have to be updated */
  where: Packages_Content_Domains_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Packages_Content_Domains_Var_Pop_Fields = {
  __typename?: 'packages_content_domains_var_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Var_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Packages_Content_Domains_Var_Samp_Fields = {
  __typename?: 'packages_content_domains_var_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Var_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Packages_Content_Domains_Variance_Fields = {
  __typename?: 'packages_content_domains_variance_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "packages_content_domains" */
export type Packages_Content_Domains_Variance_Order_By = {
  content_id?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "packages_content" */
export type Packages_Content_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  super_domain_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "packages_content" */
export type Packages_Content_Insert_Input = {
  breif?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  disable_live_classes?: InputMaybe<Scalars['Boolean']['input']>;
  expiry_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_master?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  package_content_discarded_quizzes?: InputMaybe<Package_Content_Discarded_Quizzes_Arr_Rel_Insert_Input>;
  packages_content_domains?: InputMaybe<Packages_Content_Domains_Arr_Rel_Insert_Input>;
  packages_content_text_lessons?: InputMaybe<Packages_Content_Text_Lesson_Arr_Rel_Insert_Input>;
  packages_content_timed_tests?: InputMaybe<Packages_Content_Timed_Test_Arr_Rel_Insert_Input>;
  packages_content_untimed_tests?: InputMaybe<Packages_Content_Untimed_Test_Arr_Rel_Insert_Input>;
  quiz_superdomain?: InputMaybe<Quiz_Superdomain_Obj_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  subscription_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  super_domain_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Packages_Content_Max_Fields = {
  __typename?: 'packages_content_max_fields';
  breif?: Maybe<Scalars['String']['output']>;
  brief?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  subscription_plan_id?: Maybe<Scalars['uuid']['output']>;
  super_domain_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "packages_content" */
export type Packages_Content_Max_Order_By = {
  breif?: InputMaybe<Order_By>;
  brief?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  subscription_plan_id?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Packages_Content_Min_Fields = {
  __typename?: 'packages_content_min_fields';
  breif?: Maybe<Scalars['String']['output']>;
  brief?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  subscription_plan_id?: Maybe<Scalars['uuid']['output']>;
  super_domain_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "packages_content" */
export type Packages_Content_Min_Order_By = {
  breif?: InputMaybe<Order_By>;
  brief?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  subscription_plan_id?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "packages_content" */
export type Packages_Content_Mutation_Response = {
  __typename?: 'packages_content_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Packages_Content>;
};

/** input type for inserting object relation for remote table "packages_content" */
export type Packages_Content_Obj_Rel_Insert_Input = {
  data: Packages_Content_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Packages_Content_On_Conflict>;
};

/** on_conflict condition type for table "packages_content" */
export type Packages_Content_On_Conflict = {
  constraint: Packages_Content_Constraint;
  update_columns?: Array<Packages_Content_Update_Column>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};

/** Ordering options when selecting data from "packages_content". */
export type Packages_Content_Order_By = {
  breif?: InputMaybe<Order_By>;
  brief?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  disable_live_classes?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_master?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  package_content_discarded_quizzes_aggregate?: InputMaybe<Package_Content_Discarded_Quizzes_Aggregate_Order_By>;
  packages_content_domains_aggregate?: InputMaybe<Packages_Content_Domains_Aggregate_Order_By>;
  packages_content_text_lessons_aggregate?: InputMaybe<Packages_Content_Text_Lesson_Aggregate_Order_By>;
  packages_content_timed_tests_aggregate?: InputMaybe<Packages_Content_Timed_Test_Aggregate_Order_By>;
  packages_content_untimed_tests_aggregate?: InputMaybe<Packages_Content_Untimed_Test_Aggregate_Order_By>;
  quiz_superdomain?: InputMaybe<Quiz_Superdomain_Order_By>;
  rank?: InputMaybe<Order_By>;
  subscription_plan_id?: InputMaybe<Order_By>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: packages_content */
export type Packages_Content_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "packages_content" */
export enum Packages_Content_Select_Column {
  /** column name */
  Breif = 'breif',
  /** column name */
  Brief = 'brief',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisableLiveClasses = 'disable_live_classes',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsMaster = 'is_master',
  /** column name */
  Message = 'message',
  /** column name */
  Rank = 'rank',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id',
  /** column name */
  SuperDomainId = 'super_domain_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "packages_content_aggregate_bool_exp_bool_and_arguments_columns" columns of table "packages_content" */
export enum Packages_Content_Select_Column_Packages_Content_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DisableLiveClasses = 'disable_live_classes',
  /** column name */
  IsMaster = 'is_master'
}

/** select "packages_content_aggregate_bool_exp_bool_or_arguments_columns" columns of table "packages_content" */
export enum Packages_Content_Select_Column_Packages_Content_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DisableLiveClasses = 'disable_live_classes',
  /** column name */
  IsMaster = 'is_master'
}

/** input type for updating data in table "packages_content" */
export type Packages_Content_Set_Input = {
  breif?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  disable_live_classes?: InputMaybe<Scalars['Boolean']['input']>;
  expiry_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_master?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  subscription_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  super_domain_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Packages_Content_Stddev_Fields = {
  __typename?: 'packages_content_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "packages_content" */
export type Packages_Content_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Packages_Content_Stddev_Pop_Fields = {
  __typename?: 'packages_content_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "packages_content" */
export type Packages_Content_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Packages_Content_Stddev_Samp_Fields = {
  __typename?: 'packages_content_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "packages_content" */
export type Packages_Content_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "packages_content" */
export type Packages_Content_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packages_Content_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packages_Content_Stream_Cursor_Value_Input = {
  breif?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  disable_live_classes?: InputMaybe<Scalars['Boolean']['input']>;
  expiry_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_master?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  subscription_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  super_domain_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Packages_Content_Sum_Fields = {
  __typename?: 'packages_content_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  super_domain_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "packages_content" */
export type Packages_Content_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson = {
  __typename?: 'packages_content_text_lesson';
  /** An object relationship */
  andablog_entry: Andablog_Entry;
  content_id: Scalars['Int']['output'];
  entry_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  packages_content: Packages_Content;
};

/** aggregated selection of "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Aggregate = {
  __typename?: 'packages_content_text_lesson_aggregate';
  aggregate?: Maybe<Packages_Content_Text_Lesson_Aggregate_Fields>;
  nodes: Array<Packages_Content_Text_Lesson>;
};

export type Packages_Content_Text_Lesson_Aggregate_Bool_Exp = {
  count?: InputMaybe<Packages_Content_Text_Lesson_Aggregate_Bool_Exp_Count>;
};

export type Packages_Content_Text_Lesson_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Aggregate_Fields = {
  __typename?: 'packages_content_text_lesson_aggregate_fields';
  avg?: Maybe<Packages_Content_Text_Lesson_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Packages_Content_Text_Lesson_Max_Fields>;
  min?: Maybe<Packages_Content_Text_Lesson_Min_Fields>;
  stddev?: Maybe<Packages_Content_Text_Lesson_Stddev_Fields>;
  stddev_pop?: Maybe<Packages_Content_Text_Lesson_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packages_Content_Text_Lesson_Stddev_Samp_Fields>;
  sum?: Maybe<Packages_Content_Text_Lesson_Sum_Fields>;
  var_pop?: Maybe<Packages_Content_Text_Lesson_Var_Pop_Fields>;
  var_samp?: Maybe<Packages_Content_Text_Lesson_Var_Samp_Fields>;
  variance?: Maybe<Packages_Content_Text_Lesson_Variance_Fields>;
};


/** aggregate fields of "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packages_Content_Text_Lesson_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Aggregate_Order_By = {
  avg?: InputMaybe<Packages_Content_Text_Lesson_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packages_Content_Text_Lesson_Max_Order_By>;
  min?: InputMaybe<Packages_Content_Text_Lesson_Min_Order_By>;
  stddev?: InputMaybe<Packages_Content_Text_Lesson_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packages_Content_Text_Lesson_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packages_Content_Text_Lesson_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packages_Content_Text_Lesson_Sum_Order_By>;
  var_pop?: InputMaybe<Packages_Content_Text_Lesson_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packages_Content_Text_Lesson_Var_Samp_Order_By>;
  variance?: InputMaybe<Packages_Content_Text_Lesson_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Arr_Rel_Insert_Input = {
  data: Array<Packages_Content_Text_Lesson_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packages_Content_Text_Lesson_On_Conflict>;
};

/** aggregate avg on columns */
export type Packages_Content_Text_Lesson_Avg_Fields = {
  __typename?: 'packages_content_text_lesson_avg_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Avg_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "packages_content_text_lesson". All fields are combined with a logical 'AND'. */
export type Packages_Content_Text_Lesson_Bool_Exp = {
  _and?: InputMaybe<Array<Packages_Content_Text_Lesson_Bool_Exp>>;
  _not?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
  _or?: InputMaybe<Array<Packages_Content_Text_Lesson_Bool_Exp>>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  content_id?: InputMaybe<Int_Comparison_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  packages_content?: InputMaybe<Packages_Content_Bool_Exp>;
};

/** unique or primary key constraints on table "packages_content_text_lesson" */
export enum Packages_Content_Text_Lesson_Constraint {
  /** unique or primary key constraint on columns "content_id", "entry_id" */
  PackagesContentTextLessonContentIdEntryId_343b1ef1Uniq = 'packages_content_text_lesson_content_id_entry_id_343b1ef1_uniq',
  /** unique or primary key constraint on columns "id" */
  PackagesContentTextLessonPkey = 'packages_content_text_lesson_pkey'
}

/** input type for incrementing numeric columns in table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Inc_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Insert_Input = {
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  content_id?: InputMaybe<Scalars['Int']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  packages_content?: InputMaybe<Packages_Content_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Packages_Content_Text_Lesson_Max_Fields = {
  __typename?: 'packages_content_text_lesson_max_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Max_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Packages_Content_Text_Lesson_Min_Fields = {
  __typename?: 'packages_content_text_lesson_min_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Min_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Mutation_Response = {
  __typename?: 'packages_content_text_lesson_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Packages_Content_Text_Lesson>;
};

/** on_conflict condition type for table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_On_Conflict = {
  constraint: Packages_Content_Text_Lesson_Constraint;
  update_columns?: Array<Packages_Content_Text_Lesson_Update_Column>;
  where?: InputMaybe<Packages_Content_Text_Lesson_Bool_Exp>;
};

/** Ordering options when selecting data from "packages_content_text_lesson". */
export type Packages_Content_Text_Lesson_Order_By = {
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packages_content?: InputMaybe<Packages_Content_Order_By>;
};

/** primary key columns input for table: packages_content_text_lesson */
export type Packages_Content_Text_Lesson_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "packages_content_text_lesson" */
export enum Packages_Content_Text_Lesson_Select_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Set_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Packages_Content_Text_Lesson_Stddev_Fields = {
  __typename?: 'packages_content_text_lesson_stddev_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Stddev_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Packages_Content_Text_Lesson_Stddev_Pop_Fields = {
  __typename?: 'packages_content_text_lesson_stddev_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Stddev_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Packages_Content_Text_Lesson_Stddev_Samp_Fields = {
  __typename?: 'packages_content_text_lesson_stddev_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Stddev_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packages_Content_Text_Lesson_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packages_Content_Text_Lesson_Stream_Cursor_Value_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Packages_Content_Text_Lesson_Sum_Fields = {
  __typename?: 'packages_content_text_lesson_sum_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Sum_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "packages_content_text_lesson" */
export enum Packages_Content_Text_Lesson_Update_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id'
}

export type Packages_Content_Text_Lesson_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packages_Content_Text_Lesson_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packages_Content_Text_Lesson_Set_Input>;
  /** filter the rows which have to be updated */
  where: Packages_Content_Text_Lesson_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Packages_Content_Text_Lesson_Var_Pop_Fields = {
  __typename?: 'packages_content_text_lesson_var_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Var_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Packages_Content_Text_Lesson_Var_Samp_Fields = {
  __typename?: 'packages_content_text_lesson_var_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Var_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Packages_Content_Text_Lesson_Variance_Fields = {
  __typename?: 'packages_content_text_lesson_variance_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "packages_content_text_lesson" */
export type Packages_Content_Text_Lesson_Variance_Order_By = {
  content_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "packages_content_timed_test" */
export type Packages_Content_Timed_Test = {
  __typename?: 'packages_content_timed_test';
  content_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  packages_content: Packages_Content;
  quiz_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_quiz: Quiz_Quiz;
};

/** aggregated selection of "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Aggregate = {
  __typename?: 'packages_content_timed_test_aggregate';
  aggregate?: Maybe<Packages_Content_Timed_Test_Aggregate_Fields>;
  nodes: Array<Packages_Content_Timed_Test>;
};

export type Packages_Content_Timed_Test_Aggregate_Bool_Exp = {
  count?: InputMaybe<Packages_Content_Timed_Test_Aggregate_Bool_Exp_Count>;
};

export type Packages_Content_Timed_Test_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Aggregate_Fields = {
  __typename?: 'packages_content_timed_test_aggregate_fields';
  avg?: Maybe<Packages_Content_Timed_Test_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Packages_Content_Timed_Test_Max_Fields>;
  min?: Maybe<Packages_Content_Timed_Test_Min_Fields>;
  stddev?: Maybe<Packages_Content_Timed_Test_Stddev_Fields>;
  stddev_pop?: Maybe<Packages_Content_Timed_Test_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packages_Content_Timed_Test_Stddev_Samp_Fields>;
  sum?: Maybe<Packages_Content_Timed_Test_Sum_Fields>;
  var_pop?: Maybe<Packages_Content_Timed_Test_Var_Pop_Fields>;
  var_samp?: Maybe<Packages_Content_Timed_Test_Var_Samp_Fields>;
  variance?: Maybe<Packages_Content_Timed_Test_Variance_Fields>;
};


/** aggregate fields of "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Aggregate_Order_By = {
  avg?: InputMaybe<Packages_Content_Timed_Test_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packages_Content_Timed_Test_Max_Order_By>;
  min?: InputMaybe<Packages_Content_Timed_Test_Min_Order_By>;
  stddev?: InputMaybe<Packages_Content_Timed_Test_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packages_Content_Timed_Test_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packages_Content_Timed_Test_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packages_Content_Timed_Test_Sum_Order_By>;
  var_pop?: InputMaybe<Packages_Content_Timed_Test_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packages_Content_Timed_Test_Var_Samp_Order_By>;
  variance?: InputMaybe<Packages_Content_Timed_Test_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Arr_Rel_Insert_Input = {
  data: Array<Packages_Content_Timed_Test_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packages_Content_Timed_Test_On_Conflict>;
};

/** aggregate avg on columns */
export type Packages_Content_Timed_Test_Avg_Fields = {
  __typename?: 'packages_content_timed_test_avg_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Avg_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "packages_content_timed_test". All fields are combined with a logical 'AND'. */
export type Packages_Content_Timed_Test_Bool_Exp = {
  _and?: InputMaybe<Array<Packages_Content_Timed_Test_Bool_Exp>>;
  _not?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
  _or?: InputMaybe<Array<Packages_Content_Timed_Test_Bool_Exp>>;
  content_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  packages_content?: InputMaybe<Packages_Content_Bool_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};

/** unique or primary key constraints on table "packages_content_timed_test" */
export enum Packages_Content_Timed_Test_Constraint {
  /** unique or primary key constraint on columns "content_id", "quiz_id" */
  PackagesContentTimedTestContentIdQuizId_31463099Uniq = 'packages_content_timed_test_content_id_quiz_id_31463099_uniq',
  /** unique or primary key constraint on columns "id" */
  PackagesContentTimedTestPkey = 'packages_content_timed_test_pkey'
}

/** input type for incrementing numeric columns in table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Inc_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Insert_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  packages_content?: InputMaybe<Packages_Content_Obj_Rel_Insert_Input>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Packages_Content_Timed_Test_Max_Fields = {
  __typename?: 'packages_content_timed_test_max_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Max_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Packages_Content_Timed_Test_Min_Fields = {
  __typename?: 'packages_content_timed_test_min_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Min_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Mutation_Response = {
  __typename?: 'packages_content_timed_test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Packages_Content_Timed_Test>;
};

/** on_conflict condition type for table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_On_Conflict = {
  constraint: Packages_Content_Timed_Test_Constraint;
  update_columns?: Array<Packages_Content_Timed_Test_Update_Column>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};

/** Ordering options when selecting data from "packages_content_timed_test". */
export type Packages_Content_Timed_Test_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packages_content?: InputMaybe<Packages_Content_Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
};

/** primary key columns input for table: packages_content_timed_test */
export type Packages_Content_Timed_Test_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "packages_content_timed_test" */
export enum Packages_Content_Timed_Test_Select_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id'
}

/** input type for updating data in table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Set_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Packages_Content_Timed_Test_Stddev_Fields = {
  __typename?: 'packages_content_timed_test_stddev_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Stddev_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Packages_Content_Timed_Test_Stddev_Pop_Fields = {
  __typename?: 'packages_content_timed_test_stddev_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Stddev_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Packages_Content_Timed_Test_Stddev_Samp_Fields = {
  __typename?: 'packages_content_timed_test_stddev_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Stddev_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packages_Content_Timed_Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packages_Content_Timed_Test_Stream_Cursor_Value_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Packages_Content_Timed_Test_Sum_Fields = {
  __typename?: 'packages_content_timed_test_sum_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Sum_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** update columns of table "packages_content_timed_test" */
export enum Packages_Content_Timed_Test_Update_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id'
}

export type Packages_Content_Timed_Test_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packages_Content_Timed_Test_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packages_Content_Timed_Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Packages_Content_Timed_Test_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Packages_Content_Timed_Test_Var_Pop_Fields = {
  __typename?: 'packages_content_timed_test_var_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Var_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Packages_Content_Timed_Test_Var_Samp_Fields = {
  __typename?: 'packages_content_timed_test_var_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Var_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Packages_Content_Timed_Test_Variance_Fields = {
  __typename?: 'packages_content_timed_test_variance_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "packages_content_timed_test" */
export type Packages_Content_Timed_Test_Variance_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test = {
  __typename?: 'packages_content_untimed_test';
  content_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  packages_content: Packages_Content;
  quiz_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_quiz: Quiz_Quiz;
};

/** aggregated selection of "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Aggregate = {
  __typename?: 'packages_content_untimed_test_aggregate';
  aggregate?: Maybe<Packages_Content_Untimed_Test_Aggregate_Fields>;
  nodes: Array<Packages_Content_Untimed_Test>;
};

export type Packages_Content_Untimed_Test_Aggregate_Bool_Exp = {
  count?: InputMaybe<Packages_Content_Untimed_Test_Aggregate_Bool_Exp_Count>;
};

export type Packages_Content_Untimed_Test_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Aggregate_Fields = {
  __typename?: 'packages_content_untimed_test_aggregate_fields';
  avg?: Maybe<Packages_Content_Untimed_Test_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Packages_Content_Untimed_Test_Max_Fields>;
  min?: Maybe<Packages_Content_Untimed_Test_Min_Fields>;
  stddev?: Maybe<Packages_Content_Untimed_Test_Stddev_Fields>;
  stddev_pop?: Maybe<Packages_Content_Untimed_Test_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packages_Content_Untimed_Test_Stddev_Samp_Fields>;
  sum?: Maybe<Packages_Content_Untimed_Test_Sum_Fields>;
  var_pop?: Maybe<Packages_Content_Untimed_Test_Var_Pop_Fields>;
  var_samp?: Maybe<Packages_Content_Untimed_Test_Var_Samp_Fields>;
  variance?: Maybe<Packages_Content_Untimed_Test_Variance_Fields>;
};


/** aggregate fields of "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Aggregate_Order_By = {
  avg?: InputMaybe<Packages_Content_Untimed_Test_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packages_Content_Untimed_Test_Max_Order_By>;
  min?: InputMaybe<Packages_Content_Untimed_Test_Min_Order_By>;
  stddev?: InputMaybe<Packages_Content_Untimed_Test_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packages_Content_Untimed_Test_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packages_Content_Untimed_Test_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packages_Content_Untimed_Test_Sum_Order_By>;
  var_pop?: InputMaybe<Packages_Content_Untimed_Test_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packages_Content_Untimed_Test_Var_Samp_Order_By>;
  variance?: InputMaybe<Packages_Content_Untimed_Test_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Arr_Rel_Insert_Input = {
  data: Array<Packages_Content_Untimed_Test_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packages_Content_Untimed_Test_On_Conflict>;
};

/** aggregate avg on columns */
export type Packages_Content_Untimed_Test_Avg_Fields = {
  __typename?: 'packages_content_untimed_test_avg_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Avg_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "packages_content_untimed_test". All fields are combined with a logical 'AND'. */
export type Packages_Content_Untimed_Test_Bool_Exp = {
  _and?: InputMaybe<Array<Packages_Content_Untimed_Test_Bool_Exp>>;
  _not?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
  _or?: InputMaybe<Array<Packages_Content_Untimed_Test_Bool_Exp>>;
  content_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  packages_content?: InputMaybe<Packages_Content_Bool_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};

/** unique or primary key constraints on table "packages_content_untimed_test" */
export enum Packages_Content_Untimed_Test_Constraint {
  /** unique or primary key constraint on columns "content_id", "quiz_id" */
  PackagesContentUntimedTestContentIdQuizId_04ee2b2dUniq = 'packages_content_untimed_test_content_id_quiz_id_04ee2b2d_uniq',
  /** unique or primary key constraint on columns "id" */
  PackagesContentUntimedTestPkey = 'packages_content_untimed_test_pkey'
}

/** input type for incrementing numeric columns in table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Inc_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Insert_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  packages_content?: InputMaybe<Packages_Content_Obj_Rel_Insert_Input>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Packages_Content_Untimed_Test_Max_Fields = {
  __typename?: 'packages_content_untimed_test_max_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Max_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Packages_Content_Untimed_Test_Min_Fields = {
  __typename?: 'packages_content_untimed_test_min_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Min_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Mutation_Response = {
  __typename?: 'packages_content_untimed_test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Packages_Content_Untimed_Test>;
};

/** on_conflict condition type for table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_On_Conflict = {
  constraint: Packages_Content_Untimed_Test_Constraint;
  update_columns?: Array<Packages_Content_Untimed_Test_Update_Column>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};

/** Ordering options when selecting data from "packages_content_untimed_test". */
export type Packages_Content_Untimed_Test_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packages_content?: InputMaybe<Packages_Content_Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
};

/** primary key columns input for table: packages_content_untimed_test */
export type Packages_Content_Untimed_Test_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "packages_content_untimed_test" */
export enum Packages_Content_Untimed_Test_Select_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id'
}

/** input type for updating data in table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Set_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Packages_Content_Untimed_Test_Stddev_Fields = {
  __typename?: 'packages_content_untimed_test_stddev_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Stddev_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Packages_Content_Untimed_Test_Stddev_Pop_Fields = {
  __typename?: 'packages_content_untimed_test_stddev_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Stddev_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Packages_Content_Untimed_Test_Stddev_Samp_Fields = {
  __typename?: 'packages_content_untimed_test_stddev_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Stddev_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packages_Content_Untimed_Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packages_Content_Untimed_Test_Stream_Cursor_Value_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Packages_Content_Untimed_Test_Sum_Fields = {
  __typename?: 'packages_content_untimed_test_sum_fields';
  content_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Sum_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** update columns of table "packages_content_untimed_test" */
export enum Packages_Content_Untimed_Test_Update_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id'
}

export type Packages_Content_Untimed_Test_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packages_Content_Untimed_Test_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packages_Content_Untimed_Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Packages_Content_Untimed_Test_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Packages_Content_Untimed_Test_Var_Pop_Fields = {
  __typename?: 'packages_content_untimed_test_var_pop_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Var_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Packages_Content_Untimed_Test_Var_Samp_Fields = {
  __typename?: 'packages_content_untimed_test_var_samp_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Var_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Packages_Content_Untimed_Test_Variance_Fields = {
  __typename?: 'packages_content_untimed_test_variance_fields';
  content_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "packages_content_untimed_test" */
export type Packages_Content_Untimed_Test_Variance_Order_By = {
  content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** update columns of table "packages_content" */
export enum Packages_Content_Update_Column {
  /** column name */
  Breif = 'breif',
  /** column name */
  Brief = 'brief',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisableLiveClasses = 'disable_live_classes',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsMaster = 'is_master',
  /** column name */
  Message = 'message',
  /** column name */
  Rank = 'rank',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id',
  /** column name */
  SuperDomainId = 'super_domain_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Packages_Content_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packages_Content_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packages_Content_Set_Input>;
  /** filter the rows which have to be updated */
  where: Packages_Content_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Packages_Content_Var_Pop_Fields = {
  __typename?: 'packages_content_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "packages_content" */
export type Packages_Content_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Packages_Content_Var_Samp_Fields = {
  __typename?: 'packages_content_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "packages_content" */
export type Packages_Content_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Packages_Content_Variance_Fields = {
  __typename?: 'packages_content_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "packages_content" */
export type Packages_Content_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "packages_payment_transaction" */
export type Packages_Payment_Transaction = {
  __typename?: 'packages_payment_transaction';
  /** An object relationship */
  all_auth_recipe_user?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  coupon_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  coupons_coupon?: Maybe<Coupons_Coupon>;
  created_at: Scalars['timestamptz']['output'];
  group_id?: Maybe<Scalars['Int']['output']>;
  gst: Scalars['numeric']['output'];
  id: Scalars['Int']['output'];
  initial_price: Scalars['numeric']['output'];
  /** A computed field, executes function "check_is_latest_plan" */
  is_latest?: Maybe<Scalars['Boolean']['output']>;
  is_upgraded: Scalars['Boolean']['output'];
  order_id: Scalars['String']['output'];
  payment: Scalars['Boolean']['output'];
  payment_json?: Maybe<Scalars['String']['output']>;
  price: Scalars['numeric']['output'];
  receipt_id: Scalars['String']['output'];
  /** An object relationship */
  subscription_group_plan_group?: Maybe<Subscription_Group_Plan_Groups>;
  subscription_id: Scalars['uuid']['output'];
  /** An object relationship */
  subscriptions_subscriptionplan: Subscriptions_Subscriptionplan;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "packages_payment_transaction" */
export type Packages_Payment_Transaction_Aggregate = {
  __typename?: 'packages_payment_transaction_aggregate';
  aggregate?: Maybe<Packages_Payment_Transaction_Aggregate_Fields>;
  nodes: Array<Packages_Payment_Transaction>;
};

export type Packages_Payment_Transaction_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Packages_Payment_Transaction_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Packages_Payment_Transaction_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Packages_Payment_Transaction_Aggregate_Bool_Exp_Count>;
};

export type Packages_Payment_Transaction_Aggregate_Bool_Exp_Bool_And = {
  arguments: Packages_Payment_Transaction_Select_Column_Packages_Payment_Transaction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Packages_Payment_Transaction_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Packages_Payment_Transaction_Select_Column_Packages_Payment_Transaction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Packages_Payment_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "packages_payment_transaction" */
export type Packages_Payment_Transaction_Aggregate_Fields = {
  __typename?: 'packages_payment_transaction_aggregate_fields';
  avg?: Maybe<Packages_Payment_Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Packages_Payment_Transaction_Max_Fields>;
  min?: Maybe<Packages_Payment_Transaction_Min_Fields>;
  stddev?: Maybe<Packages_Payment_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Packages_Payment_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packages_Payment_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Packages_Payment_Transaction_Sum_Fields>;
  var_pop?: Maybe<Packages_Payment_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Packages_Payment_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Packages_Payment_Transaction_Variance_Fields>;
};


/** aggregate fields of "packages_payment_transaction" */
export type Packages_Payment_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Packages_Payment_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packages_Payment_Transaction_Max_Order_By>;
  min?: InputMaybe<Packages_Payment_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Packages_Payment_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packages_Payment_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packages_Payment_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packages_Payment_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Packages_Payment_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packages_Payment_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Packages_Payment_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Packages_Payment_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packages_Payment_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Packages_Payment_Transaction_Avg_Fields = {
  __typename?: 'packages_payment_transaction_avg_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  group_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Avg_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "packages_payment_transaction". All fields are combined with a logical 'AND'. */
export type Packages_Payment_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Packages_Payment_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Packages_Payment_Transaction_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  coupon_id?: InputMaybe<Int_Comparison_Exp>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  gst?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  initial_price?: InputMaybe<Numeric_Comparison_Exp>;
  is_latest?: InputMaybe<Boolean_Comparison_Exp>;
  is_upgraded?: InputMaybe<Boolean_Comparison_Exp>;
  order_id?: InputMaybe<String_Comparison_Exp>;
  payment?: InputMaybe<Boolean_Comparison_Exp>;
  payment_json?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  receipt_id?: InputMaybe<String_Comparison_Exp>;
  subscription_group_plan_group?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "packages_payment_transaction" */
export enum Packages_Payment_Transaction_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackagesPaymentTransactionPkey = 'packages_payment_transaction_pkey',
  /** unique or primary key constraint on columns "receipt_id" */
  PackagesPaymentTransactionReceiptIdKey = 'packages_payment_transaction_receipt_id_key'
}

/** input type for incrementing numeric columns in table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Inc_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  group_id?: InputMaybe<Scalars['Int']['input']>;
  gst?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initial_price?: InputMaybe<Scalars['numeric']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['Int']['input']>;
  gst?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initial_price?: InputMaybe<Scalars['numeric']['input']>;
  is_upgraded?: InputMaybe<Scalars['Boolean']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Scalars['Boolean']['input']>;
  payment_json?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  receipt_id?: InputMaybe<Scalars['String']['input']>;
  subscription_group_plan_group?: InputMaybe<Subscription_Group_Plan_Groups_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Packages_Payment_Transaction_Max_Fields = {
  __typename?: 'packages_payment_transaction_max_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_id?: Maybe<Scalars['Int']['output']>;
  gst?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial_price?: Maybe<Scalars['numeric']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  payment_json?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  receipt_id?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Max_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_json?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Packages_Payment_Transaction_Min_Fields = {
  __typename?: 'packages_payment_transaction_min_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_id?: Maybe<Scalars['Int']['output']>;
  gst?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial_price?: Maybe<Scalars['numeric']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  payment_json?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  receipt_id?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Min_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_json?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Mutation_Response = {
  __typename?: 'packages_payment_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Packages_Payment_Transaction>;
};

/** on_conflict condition type for table "packages_payment_transaction" */
export type Packages_Payment_Transaction_On_Conflict = {
  constraint: Packages_Payment_Transaction_Constraint;
  update_columns?: Array<Packages_Payment_Transaction_Update_Column>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "packages_payment_transaction". */
export type Packages_Payment_Transaction_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  coupon_id?: InputMaybe<Order_By>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  is_latest?: InputMaybe<Order_By>;
  is_upgraded?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_json?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  subscription_group_plan_group?: InputMaybe<Subscription_Group_Plan_Groups_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: packages_payment_transaction */
export type Packages_Payment_Transaction_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "packages_payment_transaction" */
export enum Packages_Payment_Transaction_Select_Column {
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Gst = 'gst',
  /** column name */
  Id = 'id',
  /** column name */
  InitialPrice = 'initial_price',
  /** column name */
  IsUpgraded = 'is_upgraded',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Payment = 'payment',
  /** column name */
  PaymentJson = 'payment_json',
  /** column name */
  Price = 'price',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "packages_payment_transaction_aggregate_bool_exp_bool_and_arguments_columns" columns of table "packages_payment_transaction" */
export enum Packages_Payment_Transaction_Select_Column_Packages_Payment_Transaction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUpgraded = 'is_upgraded',
  /** column name */
  Payment = 'payment'
}

/** select "packages_payment_transaction_aggregate_bool_exp_bool_or_arguments_columns" columns of table "packages_payment_transaction" */
export enum Packages_Payment_Transaction_Select_Column_Packages_Payment_Transaction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUpgraded = 'is_upgraded',
  /** column name */
  Payment = 'payment'
}

/** input type for updating data in table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Set_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['Int']['input']>;
  gst?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initial_price?: InputMaybe<Scalars['numeric']['input']>;
  is_upgraded?: InputMaybe<Scalars['Boolean']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Scalars['Boolean']['input']>;
  payment_json?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  receipt_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Packages_Payment_Transaction_Stddev_Fields = {
  __typename?: 'packages_payment_transaction_stddev_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  group_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Stddev_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Packages_Payment_Transaction_Stddev_Pop_Fields = {
  __typename?: 'packages_payment_transaction_stddev_pop_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  group_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Stddev_Pop_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Packages_Payment_Transaction_Stddev_Samp_Fields = {
  __typename?: 'packages_payment_transaction_stddev_samp_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  group_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Stddev_Samp_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packages_Payment_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packages_Payment_Transaction_Stream_Cursor_Value_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['Int']['input']>;
  gst?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initial_price?: InputMaybe<Scalars['numeric']['input']>;
  is_upgraded?: InputMaybe<Scalars['Boolean']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Scalars['Boolean']['input']>;
  payment_json?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  receipt_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Packages_Payment_Transaction_Sum_Fields = {
  __typename?: 'packages_payment_transaction_sum_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  group_id?: Maybe<Scalars['Int']['output']>;
  gst?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial_price?: Maybe<Scalars['numeric']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Sum_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** update columns of table "packages_payment_transaction" */
export enum Packages_Payment_Transaction_Update_Column {
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Gst = 'gst',
  /** column name */
  Id = 'id',
  /** column name */
  InitialPrice = 'initial_price',
  /** column name */
  IsUpgraded = 'is_upgraded',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Payment = 'payment',
  /** column name */
  PaymentJson = 'payment_json',
  /** column name */
  Price = 'price',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Packages_Payment_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packages_Payment_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packages_Payment_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Packages_Payment_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Packages_Payment_Transaction_Var_Pop_Fields = {
  __typename?: 'packages_payment_transaction_var_pop_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  group_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Var_Pop_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Packages_Payment_Transaction_Var_Samp_Fields = {
  __typename?: 'packages_payment_transaction_var_samp_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  group_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Var_Samp_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Packages_Payment_Transaction_Variance_Fields = {
  __typename?: 'packages_payment_transaction_variance_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  group_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "packages_payment_transaction" */
export type Packages_Payment_Transaction_Variance_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "packages_paymenttransaction" */
export type Packages_Paymenttransaction = {
  __typename?: 'packages_paymenttransaction';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  coupons_coupon?: Maybe<Coupons_Coupon>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gst: Scalars['numeric']['output'];
  id: Scalars['Int']['output'];
  initial_price: Scalars['numeric']['output'];
  order_id: Scalars['String']['output'];
  payment: Scalars['Boolean']['output'];
  payment_json?: Maybe<Scalars['String']['output']>;
  price: Scalars['numeric']['output'];
  receipt_id: Scalars['String']['output'];
  subscription_id: Scalars['uuid']['output'];
  /** An object relationship */
  subscriptions_subscriptionplan: Subscriptions_Subscriptionplan;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Aggregate = {
  __typename?: 'packages_paymenttransaction_aggregate';
  aggregate?: Maybe<Packages_Paymenttransaction_Aggregate_Fields>;
  nodes: Array<Packages_Paymenttransaction>;
};

export type Packages_Paymenttransaction_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Packages_Paymenttransaction_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Packages_Paymenttransaction_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Packages_Paymenttransaction_Aggregate_Bool_Exp_Count>;
};

export type Packages_Paymenttransaction_Aggregate_Bool_Exp_Bool_And = {
  arguments: Packages_Paymenttransaction_Select_Column_Packages_Paymenttransaction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Packages_Paymenttransaction_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Packages_Paymenttransaction_Select_Column_Packages_Paymenttransaction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Packages_Paymenttransaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Aggregate_Fields = {
  __typename?: 'packages_paymenttransaction_aggregate_fields';
  avg?: Maybe<Packages_Paymenttransaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Packages_Paymenttransaction_Max_Fields>;
  min?: Maybe<Packages_Paymenttransaction_Min_Fields>;
  stddev?: Maybe<Packages_Paymenttransaction_Stddev_Fields>;
  stddev_pop?: Maybe<Packages_Paymenttransaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packages_Paymenttransaction_Stddev_Samp_Fields>;
  sum?: Maybe<Packages_Paymenttransaction_Sum_Fields>;
  var_pop?: Maybe<Packages_Paymenttransaction_Var_Pop_Fields>;
  var_samp?: Maybe<Packages_Paymenttransaction_Var_Samp_Fields>;
  variance?: Maybe<Packages_Paymenttransaction_Variance_Fields>;
};


/** aggregate fields of "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Aggregate_Order_By = {
  avg?: InputMaybe<Packages_Paymenttransaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packages_Paymenttransaction_Max_Order_By>;
  min?: InputMaybe<Packages_Paymenttransaction_Min_Order_By>;
  stddev?: InputMaybe<Packages_Paymenttransaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packages_Paymenttransaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packages_Paymenttransaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packages_Paymenttransaction_Sum_Order_By>;
  var_pop?: InputMaybe<Packages_Paymenttransaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packages_Paymenttransaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Packages_Paymenttransaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Arr_Rel_Insert_Input = {
  data: Array<Packages_Paymenttransaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packages_Paymenttransaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Packages_Paymenttransaction_Avg_Fields = {
  __typename?: 'packages_paymenttransaction_avg_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Avg_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "packages_paymenttransaction". All fields are combined with a logical 'AND'. */
export type Packages_Paymenttransaction_Bool_Exp = {
  _and?: InputMaybe<Array<Packages_Paymenttransaction_Bool_Exp>>;
  _not?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
  _or?: InputMaybe<Array<Packages_Paymenttransaction_Bool_Exp>>;
  coupon_id?: InputMaybe<Int_Comparison_Exp>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gst?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  initial_price?: InputMaybe<Numeric_Comparison_Exp>;
  order_id?: InputMaybe<String_Comparison_Exp>;
  payment?: InputMaybe<Boolean_Comparison_Exp>;
  payment_json?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  receipt_id?: InputMaybe<String_Comparison_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "packages_paymenttransaction" */
export enum Packages_Paymenttransaction_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackagesPaymenttransactionPkey = 'packages_paymenttransaction_pkey',
  /** unique or primary key constraint on columns "receipt_id" */
  PackagesPaymenttransactionReceiptIdKey = 'packages_paymenttransaction_receipt_id_key'
}

/** input type for incrementing numeric columns in table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Inc_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  gst?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initial_price?: InputMaybe<Scalars['numeric']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Insert_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gst?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initial_price?: InputMaybe<Scalars['numeric']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Scalars['Boolean']['input']>;
  payment_json?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  receipt_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Packages_Paymenttransaction_Max_Fields = {
  __typename?: 'packages_paymenttransaction_max_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gst?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial_price?: Maybe<Scalars['numeric']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  payment_json?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  receipt_id?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Max_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_json?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Packages_Paymenttransaction_Min_Fields = {
  __typename?: 'packages_paymenttransaction_min_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gst?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial_price?: Maybe<Scalars['numeric']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  payment_json?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  receipt_id?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Min_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_json?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Mutation_Response = {
  __typename?: 'packages_paymenttransaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Packages_Paymenttransaction>;
};

/** on_conflict condition type for table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_On_Conflict = {
  constraint: Packages_Paymenttransaction_Constraint;
  update_columns?: Array<Packages_Paymenttransaction_Update_Column>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};

/** Ordering options when selecting data from "packages_paymenttransaction". */
export type Packages_Paymenttransaction_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  coupons_coupon?: InputMaybe<Coupons_Coupon_Order_By>;
  created_at?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_json?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: packages_paymenttransaction */
export type Packages_Paymenttransaction_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "packages_paymenttransaction" */
export enum Packages_Paymenttransaction_Select_Column {
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Gst = 'gst',
  /** column name */
  Id = 'id',
  /** column name */
  InitialPrice = 'initial_price',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Payment = 'payment',
  /** column name */
  PaymentJson = 'payment_json',
  /** column name */
  Price = 'price',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "packages_paymenttransaction_aggregate_bool_exp_bool_and_arguments_columns" columns of table "packages_paymenttransaction" */
export enum Packages_Paymenttransaction_Select_Column_Packages_Paymenttransaction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Payment = 'payment'
}

/** select "packages_paymenttransaction_aggregate_bool_exp_bool_or_arguments_columns" columns of table "packages_paymenttransaction" */
export enum Packages_Paymenttransaction_Select_Column_Packages_Paymenttransaction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Payment = 'payment'
}

/** input type for updating data in table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Set_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gst?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initial_price?: InputMaybe<Scalars['numeric']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Scalars['Boolean']['input']>;
  payment_json?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  receipt_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Packages_Paymenttransaction_Stddev_Fields = {
  __typename?: 'packages_paymenttransaction_stddev_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Stddev_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Packages_Paymenttransaction_Stddev_Pop_Fields = {
  __typename?: 'packages_paymenttransaction_stddev_pop_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Stddev_Pop_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Packages_Paymenttransaction_Stddev_Samp_Fields = {
  __typename?: 'packages_paymenttransaction_stddev_samp_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Stddev_Samp_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packages_Paymenttransaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packages_Paymenttransaction_Stream_Cursor_Value_Input = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gst?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initial_price?: InputMaybe<Scalars['numeric']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Scalars['Boolean']['input']>;
  payment_json?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  receipt_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Packages_Paymenttransaction_Sum_Fields = {
  __typename?: 'packages_paymenttransaction_sum_fields';
  coupon_id?: Maybe<Scalars['Int']['output']>;
  gst?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial_price?: Maybe<Scalars['numeric']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Sum_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "packages_paymenttransaction" */
export enum Packages_Paymenttransaction_Update_Column {
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Gst = 'gst',
  /** column name */
  Id = 'id',
  /** column name */
  InitialPrice = 'initial_price',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Payment = 'payment',
  /** column name */
  PaymentJson = 'payment_json',
  /** column name */
  Price = 'price',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Packages_Paymenttransaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packages_Paymenttransaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packages_Paymenttransaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Packages_Paymenttransaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Packages_Paymenttransaction_Var_Pop_Fields = {
  __typename?: 'packages_paymenttransaction_var_pop_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Var_Pop_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Packages_Paymenttransaction_Var_Samp_Fields = {
  __typename?: 'packages_paymenttransaction_var_samp_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Var_Samp_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Packages_Paymenttransaction_Variance_Fields = {
  __typename?: 'packages_paymenttransaction_variance_fields';
  coupon_id?: Maybe<Scalars['Float']['output']>;
  gst?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "packages_paymenttransaction" */
export type Packages_Paymenttransaction_Variance_Order_By = {
  coupon_id?: InputMaybe<Order_By>;
  gst?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_price?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "poll" */
export type Poll = {
  __typename?: 'poll';
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid']['output'];
  /** An array relationship */
  options: Array<Poll_Options>;
  /** An aggregate relationship */
  options_aggregate: Poll_Options_Aggregate;
  /** An array relationship */
  responses: Array<Poll_Responses>;
  /** An aggregate relationship */
  responses_aggregate: Poll_Responses_Aggregate;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "poll" */
export type PollOptionsArgs = {
  distinct_on?: InputMaybe<Array<Poll_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Options_Order_By>>;
  where?: InputMaybe<Poll_Options_Bool_Exp>;
};


/** columns and relationships of "poll" */
export type PollOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Options_Order_By>>;
  where?: InputMaybe<Poll_Options_Bool_Exp>;
};


/** columns and relationships of "poll" */
export type PollResponsesArgs = {
  distinct_on?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Responses_Order_By>>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};


/** columns and relationships of "poll" */
export type PollResponses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Responses_Order_By>>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};

/** aggregated selection of "poll" */
export type Poll_Aggregate = {
  __typename?: 'poll_aggregate';
  aggregate?: Maybe<Poll_Aggregate_Fields>;
  nodes: Array<Poll>;
};

export type Poll_Aggregate_Bool_Exp = {
  count?: InputMaybe<Poll_Aggregate_Bool_Exp_Count>;
};

export type Poll_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Poll_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Poll_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "poll" */
export type Poll_Aggregate_Fields = {
  __typename?: 'poll_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Poll_Max_Fields>;
  min?: Maybe<Poll_Min_Fields>;
};


/** aggregate fields of "poll" */
export type Poll_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Poll_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "poll" */
export type Poll_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Poll_Max_Order_By>;
  min?: InputMaybe<Poll_Min_Order_By>;
};

/** input type for inserting array relation for remote table "poll" */
export type Poll_Arr_Rel_Insert_Input = {
  data: Array<Poll_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Poll_On_Conflict>;
};

/** Boolean expression to filter rows from the table "poll". All fields are combined with a logical 'AND'. */
export type Poll_Bool_Exp = {
  _and?: InputMaybe<Array<Poll_Bool_Exp>>;
  _not?: InputMaybe<Poll_Bool_Exp>;
  _or?: InputMaybe<Array<Poll_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<Messages_Bool_Exp>;
  message_id?: InputMaybe<Uuid_Comparison_Exp>;
  options?: InputMaybe<Poll_Options_Bool_Exp>;
  options_aggregate?: InputMaybe<Poll_Options_Aggregate_Bool_Exp>;
  responses?: InputMaybe<Poll_Responses_Bool_Exp>;
  responses_aggregate?: InputMaybe<Poll_Responses_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "poll" */
export enum Poll_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollPkey = 'poll_pkey'
}

/** input type for inserting data into table "poll" */
export type Poll_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Messages_Obj_Rel_Insert_Input>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Poll_Options_Arr_Rel_Insert_Input>;
  responses?: InputMaybe<Poll_Responses_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Poll_Max_Fields = {
  __typename?: 'poll_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "poll" */
export type Poll_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Poll_Min_Fields = {
  __typename?: 'poll_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "poll" */
export type Poll_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "poll" */
export type Poll_Mutation_Response = {
  __typename?: 'poll_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Poll>;
};

/** input type for inserting object relation for remote table "poll" */
export type Poll_Obj_Rel_Insert_Input = {
  data: Poll_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Poll_On_Conflict>;
};

/** on_conflict condition type for table "poll" */
export type Poll_On_Conflict = {
  constraint: Poll_Constraint;
  update_columns?: Array<Poll_Update_Column>;
  where?: InputMaybe<Poll_Bool_Exp>;
};

/** columns and relationships of "poll_options" */
export type Poll_Options = {
  __typename?: 'poll_options';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_correct: Scalars['Boolean']['output'];
  /** An object relationship */
  poll: Poll;
  poll_id: Scalars['uuid']['output'];
  /** An array relationship */
  poll_responses: Array<Poll_Responses>;
  /** An aggregate relationship */
  poll_responses_aggregate: Poll_Responses_Aggregate;
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "poll_options" */
export type Poll_OptionsPoll_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Responses_Order_By>>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};


/** columns and relationships of "poll_options" */
export type Poll_OptionsPoll_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poll_Responses_Order_By>>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};

/** aggregated selection of "poll_options" */
export type Poll_Options_Aggregate = {
  __typename?: 'poll_options_aggregate';
  aggregate?: Maybe<Poll_Options_Aggregate_Fields>;
  nodes: Array<Poll_Options>;
};

export type Poll_Options_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Poll_Options_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Poll_Options_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Poll_Options_Aggregate_Bool_Exp_Count>;
};

export type Poll_Options_Aggregate_Bool_Exp_Bool_And = {
  arguments: Poll_Options_Select_Column_Poll_Options_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Poll_Options_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Poll_Options_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Poll_Options_Select_Column_Poll_Options_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Poll_Options_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Poll_Options_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Poll_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Poll_Options_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "poll_options" */
export type Poll_Options_Aggregate_Fields = {
  __typename?: 'poll_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Poll_Options_Max_Fields>;
  min?: Maybe<Poll_Options_Min_Fields>;
};


/** aggregate fields of "poll_options" */
export type Poll_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Poll_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "poll_options" */
export type Poll_Options_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Poll_Options_Max_Order_By>;
  min?: InputMaybe<Poll_Options_Min_Order_By>;
};

/** input type for inserting array relation for remote table "poll_options" */
export type Poll_Options_Arr_Rel_Insert_Input = {
  data: Array<Poll_Options_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Poll_Options_On_Conflict>;
};

/** Boolean expression to filter rows from the table "poll_options". All fields are combined with a logical 'AND'. */
export type Poll_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Poll_Options_Bool_Exp>>;
  _not?: InputMaybe<Poll_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Poll_Options_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_correct?: InputMaybe<Boolean_Comparison_Exp>;
  poll?: InputMaybe<Poll_Bool_Exp>;
  poll_id?: InputMaybe<Uuid_Comparison_Exp>;
  poll_responses?: InputMaybe<Poll_Responses_Bool_Exp>;
  poll_responses_aggregate?: InputMaybe<Poll_Responses_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "poll_options" */
export enum Poll_Options_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollOptionsPkey = 'poll_options_pkey'
}

/** input type for inserting data into table "poll_options" */
export type Poll_Options_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  poll?: InputMaybe<Poll_Obj_Rel_Insert_Input>;
  poll_id?: InputMaybe<Scalars['uuid']['input']>;
  poll_responses?: InputMaybe<Poll_Responses_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Poll_Options_Max_Fields = {
  __typename?: 'poll_options_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  poll_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "poll_options" */
export type Poll_Options_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Poll_Options_Min_Fields = {
  __typename?: 'poll_options_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  poll_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "poll_options" */
export type Poll_Options_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "poll_options" */
export type Poll_Options_Mutation_Response = {
  __typename?: 'poll_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Poll_Options>;
};

/** input type for inserting object relation for remote table "poll_options" */
export type Poll_Options_Obj_Rel_Insert_Input = {
  data: Poll_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Poll_Options_On_Conflict>;
};

/** on_conflict condition type for table "poll_options" */
export type Poll_Options_On_Conflict = {
  constraint: Poll_Options_Constraint;
  update_columns?: Array<Poll_Options_Update_Column>;
  where?: InputMaybe<Poll_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "poll_options". */
export type Poll_Options_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_correct?: InputMaybe<Order_By>;
  poll?: InputMaybe<Poll_Order_By>;
  poll_id?: InputMaybe<Order_By>;
  poll_responses_aggregate?: InputMaybe<Poll_Responses_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: poll_options */
export type Poll_Options_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "poll_options" */
export enum Poll_Options_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "poll_options_aggregate_bool_exp_bool_and_arguments_columns" columns of table "poll_options" */
export enum Poll_Options_Select_Column_Poll_Options_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCorrect = 'is_correct'
}

/** select "poll_options_aggregate_bool_exp_bool_or_arguments_columns" columns of table "poll_options" */
export enum Poll_Options_Select_Column_Poll_Options_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCorrect = 'is_correct'
}

/** input type for updating data in table "poll_options" */
export type Poll_Options_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  poll_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "poll_options" */
export type Poll_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Poll_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Poll_Options_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  poll_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "poll_options" */
export enum Poll_Options_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Poll_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Poll_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Poll_Options_Bool_Exp;
};

/** Ordering options when selecting data from "poll". */
export type Poll_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Messages_Order_By>;
  message_id?: InputMaybe<Order_By>;
  options_aggregate?: InputMaybe<Poll_Options_Aggregate_Order_By>;
  responses_aggregate?: InputMaybe<Poll_Responses_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: poll */
export type Poll_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "poll_responses" */
export type Poll_Responses = {
  __typename?: 'poll_responses';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  poll: Poll;
  poll_id: Scalars['uuid']['output'];
  /** An object relationship */
  poll_option: Poll_Options;
  selected_option: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Supertokens_User_Public_Fields>;
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "poll_responses" */
export type Poll_Responses_Aggregate = {
  __typename?: 'poll_responses_aggregate';
  aggregate?: Maybe<Poll_Responses_Aggregate_Fields>;
  nodes: Array<Poll_Responses>;
};

export type Poll_Responses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Poll_Responses_Aggregate_Bool_Exp_Count>;
};

export type Poll_Responses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Poll_Responses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "poll_responses" */
export type Poll_Responses_Aggregate_Fields = {
  __typename?: 'poll_responses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Poll_Responses_Max_Fields>;
  min?: Maybe<Poll_Responses_Min_Fields>;
};


/** aggregate fields of "poll_responses" */
export type Poll_Responses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Poll_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "poll_responses" */
export type Poll_Responses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Poll_Responses_Max_Order_By>;
  min?: InputMaybe<Poll_Responses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "poll_responses" */
export type Poll_Responses_Arr_Rel_Insert_Input = {
  data: Array<Poll_Responses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Poll_Responses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "poll_responses". All fields are combined with a logical 'AND'. */
export type Poll_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Poll_Responses_Bool_Exp>>;
  _not?: InputMaybe<Poll_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Poll_Responses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  poll?: InputMaybe<Poll_Bool_Exp>;
  poll_id?: InputMaybe<Uuid_Comparison_Exp>;
  poll_option?: InputMaybe<Poll_Options_Bool_Exp>;
  selected_option?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "poll_responses" */
export enum Poll_Responses_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollResponsesPkey = 'poll_responses_pkey'
}

/** input type for inserting data into table "poll_responses" */
export type Poll_Responses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  poll?: InputMaybe<Poll_Obj_Rel_Insert_Input>;
  poll_id?: InputMaybe<Scalars['uuid']['input']>;
  poll_option?: InputMaybe<Poll_Options_Obj_Rel_Insert_Input>;
  selected_option?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Poll_Responses_Max_Fields = {
  __typename?: 'poll_responses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  poll_id?: Maybe<Scalars['uuid']['output']>;
  selected_option?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "poll_responses" */
export type Poll_Responses_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  selected_option?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Poll_Responses_Min_Fields = {
  __typename?: 'poll_responses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  poll_id?: Maybe<Scalars['uuid']['output']>;
  selected_option?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "poll_responses" */
export type Poll_Responses_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  selected_option?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "poll_responses" */
export type Poll_Responses_Mutation_Response = {
  __typename?: 'poll_responses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Poll_Responses>;
};

/** on_conflict condition type for table "poll_responses" */
export type Poll_Responses_On_Conflict = {
  constraint: Poll_Responses_Constraint;
  update_columns?: Array<Poll_Responses_Update_Column>;
  where?: InputMaybe<Poll_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "poll_responses". */
export type Poll_Responses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll?: InputMaybe<Poll_Order_By>;
  poll_id?: InputMaybe<Order_By>;
  poll_option?: InputMaybe<Poll_Options_Order_By>;
  selected_option?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: poll_responses */
export type Poll_Responses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "poll_responses" */
export enum Poll_Responses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  SelectedOption = 'selected_option',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "poll_responses" */
export type Poll_Responses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  poll_id?: InputMaybe<Scalars['uuid']['input']>;
  selected_option?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "poll_responses" */
export type Poll_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Poll_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Poll_Responses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  poll_id?: InputMaybe<Scalars['uuid']['input']>;
  selected_option?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "poll_responses" */
export enum Poll_Responses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  SelectedOption = 'selected_option',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Poll_Responses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Poll_Responses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Poll_Responses_Bool_Exp;
};

/** select columns of table "poll" */
export enum Poll_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "poll" */
export type Poll_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "poll" */
export type Poll_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Poll_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Poll_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "poll" */
export enum Poll_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Poll_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Poll_Set_Input>;
  /** filter the rows which have to be updated */
  where: Poll_Bool_Exp;
};

/** columns and relationships of "question_reports" */
export type Question_Reports = {
  __typename?: 'question_reports';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  created_at: Scalars['timestamptz']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  question_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "question_reports" */
export type Question_Reports_Aggregate = {
  __typename?: 'question_reports_aggregate';
  aggregate?: Maybe<Question_Reports_Aggregate_Fields>;
  nodes: Array<Question_Reports>;
};

export type Question_Reports_Aggregate_Bool_Exp = {
  count?: InputMaybe<Question_Reports_Aggregate_Bool_Exp_Count>;
};

export type Question_Reports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Question_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Question_Reports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "question_reports" */
export type Question_Reports_Aggregate_Fields = {
  __typename?: 'question_reports_aggregate_fields';
  avg?: Maybe<Question_Reports_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Question_Reports_Max_Fields>;
  min?: Maybe<Question_Reports_Min_Fields>;
  stddev?: Maybe<Question_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Reports_Sum_Fields>;
  var_pop?: Maybe<Question_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Reports_Var_Samp_Fields>;
  variance?: Maybe<Question_Reports_Variance_Fields>;
};


/** aggregate fields of "question_reports" */
export type Question_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "question_reports" */
export type Question_Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Reports_Max_Order_By>;
  min?: InputMaybe<Question_Reports_Min_Order_By>;
  stddev?: InputMaybe<Question_Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Reports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_reports" */
export type Question_Reports_Arr_Rel_Insert_Input = {
  data: Array<Question_Reports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Reports_Avg_Fields = {
  __typename?: 'question_reports_avg_fields';
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "question_reports" */
export type Question_Reports_Avg_Order_By = {
  question_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_reports". All fields are combined with a logical 'AND'. */
export type Question_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Reports_Bool_Exp>>;
  _not?: InputMaybe<Question_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Reports_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  explanation?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_reports" */
export enum Question_Reports_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionReportsPkey = 'question_reports_pkey'
}

/** input type for incrementing numeric columns in table "question_reports" */
export type Question_Reports_Inc_Input = {
  question_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "question_reports" */
export type Question_Reports_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Question_Reports_Max_Fields = {
  __typename?: 'question_reports_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "question_reports" */
export type Question_Reports_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  explanation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Reports_Min_Fields = {
  __typename?: 'question_reports_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "question_reports" */
export type Question_Reports_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  explanation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_reports" */
export type Question_Reports_Mutation_Response = {
  __typename?: 'question_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Reports>;
};

/** on_conflict condition type for table "question_reports" */
export type Question_Reports_On_Conflict = {
  constraint: Question_Reports_Constraint;
  update_columns?: Array<Question_Reports_Update_Column>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "question_reports". */
export type Question_Reports_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  explanation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question_reports */
export type Question_Reports_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "question_reports" */
export enum Question_Reports_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Explanation = 'explanation',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "question_reports" */
export type Question_Reports_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Question_Reports_Stddev_Fields = {
  __typename?: 'question_reports_stddev_fields';
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "question_reports" */
export type Question_Reports_Stddev_Order_By = {
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Reports_Stddev_Pop_Fields = {
  __typename?: 'question_reports_stddev_pop_fields';
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "question_reports" */
export type Question_Reports_Stddev_Pop_Order_By = {
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Reports_Stddev_Samp_Fields = {
  __typename?: 'question_reports_stddev_samp_fields';
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "question_reports" */
export type Question_Reports_Stddev_Samp_Order_By = {
  question_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "question_reports" */
export type Question_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Reports_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Question_Reports_Sum_Fields = {
  __typename?: 'question_reports_sum_fields';
  question_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "question_reports" */
export type Question_Reports_Sum_Order_By = {
  question_id?: InputMaybe<Order_By>;
};

/** update columns of table "question_reports" */
export enum Question_Reports_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Explanation = 'explanation',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Question_Reports_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Question_Reports_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Question_Reports_Var_Pop_Fields = {
  __typename?: 'question_reports_var_pop_fields';
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "question_reports" */
export type Question_Reports_Var_Pop_Order_By = {
  question_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Reports_Var_Samp_Fields = {
  __typename?: 'question_reports_var_samp_fields';
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "question_reports" */
export type Question_Reports_Var_Samp_Order_By = {
  question_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Reports_Variance_Fields = {
  __typename?: 'question_reports_variance_fields';
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "question_reports" */
export type Question_Reports_Variance_Order_By = {
  question_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "quiz_answer" */
export type Quiz_Answer = {
  __typename?: 'quiz_answer';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  mcq_order?: Maybe<Scalars['String']['output']>;
  question_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  short_answer?: Maybe<Scalars['String']['output']>;
  solution: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "quiz_answer" */
export type Quiz_Answer_Aggregate = {
  __typename?: 'quiz_answer_aggregate';
  aggregate?: Maybe<Quiz_Answer_Aggregate_Fields>;
  nodes: Array<Quiz_Answer>;
};

export type Quiz_Answer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quiz_Answer_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Answer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Answer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Answer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_answer" */
export type Quiz_Answer_Aggregate_Fields = {
  __typename?: 'quiz_answer_aggregate_fields';
  avg?: Maybe<Quiz_Answer_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Answer_Max_Fields>;
  min?: Maybe<Quiz_Answer_Min_Fields>;
  stddev?: Maybe<Quiz_Answer_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Answer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Answer_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Answer_Sum_Fields>;
  var_pop?: Maybe<Quiz_Answer_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Answer_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Answer_Variance_Fields>;
};


/** aggregate fields of "quiz_answer" */
export type Quiz_Answer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Answer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_answer" */
export type Quiz_Answer_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Answer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Answer_Max_Order_By>;
  min?: InputMaybe<Quiz_Answer_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Answer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Answer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Answer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Answer_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Answer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Answer_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Answer_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_answer" */
export type Quiz_Answer_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Answer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Answer_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Answer_Avg_Fields = {
  __typename?: 'quiz_answer_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quiz_answer" */
export type Quiz_Answer_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_answer". All fields are combined with a logical 'AND'. */
export type Quiz_Answer_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Answer_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Answer_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Answer_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mcq_order?: InputMaybe<String_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  short_answer?: InputMaybe<String_Comparison_Exp>;
  solution?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_answer" */
export enum Quiz_Answer_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizAnswerPkey = 'quiz_answer_pkey'
}

/** input type for incrementing numeric columns in table "quiz_answer" */
export type Quiz_Answer_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_answer" */
export type Quiz_Answer_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mcq_order?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  short_answer?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quiz_Answer_Max_Fields = {
  __typename?: 'quiz_answer_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mcq_order?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  short_answer?: Maybe<Scalars['String']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "quiz_answer" */
export type Quiz_Answer_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mcq_order?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  short_answer?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Answer_Min_Fields = {
  __typename?: 'quiz_answer_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mcq_order?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  short_answer?: Maybe<Scalars['String']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "quiz_answer" */
export type Quiz_Answer_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mcq_order?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  short_answer?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_answer" */
export type Quiz_Answer_Mutation_Response = {
  __typename?: 'quiz_answer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Answer>;
};

/** on_conflict condition type for table "quiz_answer" */
export type Quiz_Answer_On_Conflict = {
  constraint: Quiz_Answer_Constraint;
  update_columns?: Array<Quiz_Answer_Update_Column>;
  where?: InputMaybe<Quiz_Answer_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_answer". */
export type Quiz_Answer_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mcq_order?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  short_answer?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_answer */
export type Quiz_Answer_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_answer" */
export enum Quiz_Answer_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  McqOrder = 'mcq_order',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  ShortAnswer = 'short_answer',
  /** column name */
  Solution = 'solution',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "quiz_answer" */
export type Quiz_Answer_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mcq_order?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  short_answer?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Answer_Stddev_Fields = {
  __typename?: 'quiz_answer_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quiz_answer" */
export type Quiz_Answer_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Answer_Stddev_Pop_Fields = {
  __typename?: 'quiz_answer_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_answer" */
export type Quiz_Answer_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Answer_Stddev_Samp_Fields = {
  __typename?: 'quiz_answer_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_answer" */
export type Quiz_Answer_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_answer" */
export type Quiz_Answer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Answer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Answer_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mcq_order?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  short_answer?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Answer_Sum_Fields = {
  __typename?: 'quiz_answer_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quiz_answer" */
export type Quiz_Answer_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_answer" */
export enum Quiz_Answer_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  McqOrder = 'mcq_order',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  ShortAnswer = 'short_answer',
  /** column name */
  Solution = 'solution',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quiz_Answer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Answer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Answer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Answer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Answer_Var_Pop_Fields = {
  __typename?: 'quiz_answer_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quiz_answer" */
export type Quiz_Answer_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Answer_Var_Samp_Fields = {
  __typename?: 'quiz_answer_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quiz_answer" */
export type Quiz_Answer_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Answer_Variance_Fields = {
  __typename?: 'quiz_answer_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quiz_answer" */
export type Quiz_Answer_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "quiz_category" */
export type Quiz_Category = {
  __typename?: 'quiz_category';
  /** An array relationship */
  andablog_entries: Array<Andablog_Entry>;
  /** An aggregate relationship */
  andablog_entries_aggregate: Andablog_Entry_Aggregate;
  /** An array relationship */
  andablog_userlessontrackrecords: Array<Andablog_Userlessontrackrecord>;
  /** An aggregate relationship */
  andablog_userlessontrackrecords_aggregate: Andablog_Userlessontrackrecord_Aggregate;
  /** An array relationship */
  andablog_videos: Array<Andablog_Video>;
  /** An aggregate relationship */
  andablog_videos_aggregate: Andablog_Video_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  do_not_include_in_planner: Scalars['Boolean']['output'];
  domain_id?: Maybe<Scalars['Int']['output']>;
  draft: Scalars['Boolean']['output'];
  free_learn: Scalars['Boolean']['output'];
  free_practice: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_lesson_category: Scalars['Boolean']['output'];
  lesson_credits: Scalars['numeric']['output'];
  name: Scalars['String']['output'];
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Int']['output']>;
  practice_level_1_credits: Scalars['numeric']['output'];
  practice_level_2_credits: Scalars['numeric']['output'];
  practice_level_3_credits: Scalars['numeric']['output'];
  /** An object relationship */
  quiz_domain?: Maybe<Quiz_Domain>;
  /** An array relationship */
  quiz_questions: Array<Quiz_Question>;
  /** An aggregate relationship */
  quiz_questions_aggregate: Quiz_Question_Aggregate;
  /** An array relationship */
  quiz_quizzes: Array<Quiz_Quiz>;
  /** An aggregate relationship */
  quiz_quizzes_aggregate: Quiz_Quiz_Aggregate;
  rank?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_activities: Array<User_Activity>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activity_Aggregate;
  /** An array relationship */
  user_learn_category_progresses: Array<User_Learn_Category_Progress>;
  /** An aggregate relationship */
  user_learn_category_progresses_aggregate: User_Learn_Category_Progress_Aggregate;
  /** An array relationship */
  user_learn_track_records: Array<User_Learn_Track_Record>;
  /** An aggregate relationship */
  user_learn_track_records_aggregate: User_Learn_Track_Record_Aggregate;
  /** An array relationship */
  user_planned_activities: Array<User_Planned_Activities>;
  /** An aggregate relationship */
  user_planned_activities_aggregate: User_Planned_Activities_Aggregate;
  /** A computed field, executes function "quiz_category_user_planned_date" */
  user_planned_date?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "quiz_category_user_planned_id" */
  user_planned_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_recent_lesson: Array<User_Recent_Lessons>;
  /** An aggregate relationship */
  user_recent_lesson_aggregate: User_Recent_Lessons_Aggregate;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryAndablog_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entry_Order_By>>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryAndablog_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entry_Order_By>>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryAndablog_UserlessontrackrecordsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryAndablog_Userlessontrackrecords_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryAndablog_VideosArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Video_Order_By>>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryAndablog_Videos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Video_Order_By>>;
  where?: InputMaybe<Andablog_Video_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryQuiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Question_Order_By>>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryQuiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Question_Order_By>>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryQuiz_QuizzesArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryQuiz_Quizzes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_Learn_Category_ProgressesArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Category_Progress_Order_By>>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_Learn_Category_Progresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Category_Progress_Order_By>>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_Learn_Track_RecordsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_Learn_Track_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_Planned_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_Planned_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_Recent_LessonArgs = {
  distinct_on?: InputMaybe<Array<User_Recent_Lessons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Recent_Lessons_Order_By>>;
  where?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
};


/** columns and relationships of "quiz_category" */
export type Quiz_CategoryUser_Recent_Lesson_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Recent_Lessons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Recent_Lessons_Order_By>>;
  where?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
};

/** aggregated selection of "quiz_category" */
export type Quiz_Category_Aggregate = {
  __typename?: 'quiz_category_aggregate';
  aggregate?: Maybe<Quiz_Category_Aggregate_Fields>;
  nodes: Array<Quiz_Category>;
};

export type Quiz_Category_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quiz_Category_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quiz_Category_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quiz_Category_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Category_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quiz_Category_Select_Column_Quiz_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Category_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quiz_Category_Select_Column_Quiz_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_category" */
export type Quiz_Category_Aggregate_Fields = {
  __typename?: 'quiz_category_aggregate_fields';
  avg?: Maybe<Quiz_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Category_Max_Fields>;
  min?: Maybe<Quiz_Category_Min_Fields>;
  stddev?: Maybe<Quiz_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Category_Sum_Fields>;
  var_pop?: Maybe<Quiz_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Category_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Category_Variance_Fields>;
};


/** aggregate fields of "quiz_category" */
export type Quiz_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_category" */
export type Quiz_Category_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Category_Max_Order_By>;
  min?: InputMaybe<Quiz_Category_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Category_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_category" */
export type Quiz_Category_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Category_Avg_Fields = {
  __typename?: 'quiz_category_avg_fields';
  domain_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lesson_credits?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Float']['output']>;
  practice_level_1_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_2_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_3_credits?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
};

/** order by avg() on columns of table "quiz_category" */
export type Quiz_Category_Avg_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_category". All fields are combined with a logical 'AND'. */
export type Quiz_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Category_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Category_Bool_Exp>>;
  andablog_entries?: InputMaybe<Andablog_Entry_Bool_Exp>;
  andablog_entries_aggregate?: InputMaybe<Andablog_Entry_Aggregate_Bool_Exp>;
  andablog_userlessontrackrecords?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
  andablog_userlessontrackrecords_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Aggregate_Bool_Exp>;
  andablog_videos?: InputMaybe<Andablog_Video_Bool_Exp>;
  andablog_videos_aggregate?: InputMaybe<Andablog_Video_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  do_not_include_in_planner?: InputMaybe<Boolean_Comparison_Exp>;
  domain_id?: InputMaybe<Int_Comparison_Exp>;
  draft?: InputMaybe<Boolean_Comparison_Exp>;
  free_learn?: InputMaybe<Boolean_Comparison_Exp>;
  free_practice?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_lesson_category?: InputMaybe<Boolean_Comparison_Exp>;
  lesson_credits?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number_of_completed_modules?: InputMaybe<Bigint_Comparison_Exp>;
  old_category_id?: InputMaybe<Int_Comparison_Exp>;
  practice_level_1_credits?: InputMaybe<Numeric_Comparison_Exp>;
  practice_level_2_credits?: InputMaybe<Numeric_Comparison_Exp>;
  practice_level_3_credits?: InputMaybe<Numeric_Comparison_Exp>;
  quiz_domain?: InputMaybe<Quiz_Domain_Bool_Exp>;
  quiz_questions?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_questions_aggregate?: InputMaybe<Quiz_Question_Aggregate_Bool_Exp>;
  quiz_quizzes?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  quiz_quizzes_aggregate?: InputMaybe<Quiz_Quiz_Aggregate_Bool_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  total_number_of_modules?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_activities?: InputMaybe<User_Activity_Bool_Exp>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Bool_Exp>;
  user_learn_category_progresses?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
  user_learn_category_progresses_aggregate?: InputMaybe<User_Learn_Category_Progress_Aggregate_Bool_Exp>;
  user_learn_track_records?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
  user_learn_track_records_aggregate?: InputMaybe<User_Learn_Track_Record_Aggregate_Bool_Exp>;
  user_planned_activities?: InputMaybe<User_Planned_Activities_Bool_Exp>;
  user_planned_activities_aggregate?: InputMaybe<User_Planned_Activities_Aggregate_Bool_Exp>;
  user_planned_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_planned_id?: InputMaybe<String_Comparison_Exp>;
  user_recent_lesson?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
  user_recent_lesson_aggregate?: InputMaybe<User_Recent_Lessons_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "quiz_category" */
export enum Quiz_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizCategoryPkey = 'quiz_category_pkey',
  /** unique or primary key constraint on columns "slug" */
  QuizCategorySlugKey = 'quiz_category_slug_key'
}

/** input type for incrementing numeric columns in table "quiz_category" */
export type Quiz_Category_Inc_Input = {
  domain_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lesson_credits?: InputMaybe<Scalars['numeric']['input']>;
  old_category_id?: InputMaybe<Scalars['Int']['input']>;
  practice_level_1_credits?: InputMaybe<Scalars['numeric']['input']>;
  practice_level_2_credits?: InputMaybe<Scalars['numeric']['input']>;
  practice_level_3_credits?: InputMaybe<Scalars['numeric']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_category" */
export type Quiz_Category_Insert_Input = {
  andablog_entries?: InputMaybe<Andablog_Entry_Arr_Rel_Insert_Input>;
  andablog_userlessontrackrecords?: InputMaybe<Andablog_Userlessontrackrecord_Arr_Rel_Insert_Input>;
  andablog_videos?: InputMaybe<Andablog_Video_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_include_in_planner?: InputMaybe<Scalars['Boolean']['input']>;
  domain_id?: InputMaybe<Scalars['Int']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  free_learn?: InputMaybe<Scalars['Boolean']['input']>;
  free_practice?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_lesson_category?: InputMaybe<Scalars['Boolean']['input']>;
  lesson_credits?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_category_id?: InputMaybe<Scalars['Int']['input']>;
  practice_level_1_credits?: InputMaybe<Scalars['numeric']['input']>;
  practice_level_2_credits?: InputMaybe<Scalars['numeric']['input']>;
  practice_level_3_credits?: InputMaybe<Scalars['numeric']['input']>;
  quiz_domain?: InputMaybe<Quiz_Domain_Obj_Rel_Insert_Input>;
  quiz_questions?: InputMaybe<Quiz_Question_Arr_Rel_Insert_Input>;
  quiz_quizzes?: InputMaybe<Quiz_Quiz_Arr_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_activities?: InputMaybe<User_Activity_Arr_Rel_Insert_Input>;
  user_learn_category_progresses?: InputMaybe<User_Learn_Category_Progress_Arr_Rel_Insert_Input>;
  user_learn_track_records?: InputMaybe<User_Learn_Track_Record_Arr_Rel_Insert_Input>;
  user_planned_activities?: InputMaybe<User_Planned_Activities_Arr_Rel_Insert_Input>;
  user_recent_lesson?: InputMaybe<User_Recent_Lessons_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Quiz_Category_Max_Fields = {
  __typename?: 'quiz_category_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  domain_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lesson_credits?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Int']['output']>;
  practice_level_1_credits?: Maybe<Scalars['numeric']['output']>;
  practice_level_2_credits?: Maybe<Scalars['numeric']['output']>;
  practice_level_3_credits?: Maybe<Scalars['numeric']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "quiz_category_user_planned_date" */
  user_planned_date?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "quiz_category_user_planned_id" */
  user_planned_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "quiz_category" */
export type Quiz_Category_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Category_Min_Fields = {
  __typename?: 'quiz_category_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  domain_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lesson_credits?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Int']['output']>;
  practice_level_1_credits?: Maybe<Scalars['numeric']['output']>;
  practice_level_2_credits?: Maybe<Scalars['numeric']['output']>;
  practice_level_3_credits?: Maybe<Scalars['numeric']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "quiz_category_user_planned_date" */
  user_planned_date?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "quiz_category_user_planned_id" */
  user_planned_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "quiz_category" */
export type Quiz_Category_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_category" */
export type Quiz_Category_Mutation_Response = {
  __typename?: 'quiz_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Category>;
};

/** input type for inserting object relation for remote table "quiz_category" */
export type Quiz_Category_Obj_Rel_Insert_Input = {
  data: Quiz_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Category_On_Conflict>;
};

/** on_conflict condition type for table "quiz_category" */
export type Quiz_Category_On_Conflict = {
  constraint: Quiz_Category_Constraint;
  update_columns?: Array<Quiz_Category_Update_Column>;
  where?: InputMaybe<Quiz_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_category". */
export type Quiz_Category_Order_By = {
  andablog_entries_aggregate?: InputMaybe<Andablog_Entry_Aggregate_Order_By>;
  andablog_userlessontrackrecords_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Aggregate_Order_By>;
  andablog_videos_aggregate?: InputMaybe<Andablog_Video_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  do_not_include_in_planner?: InputMaybe<Order_By>;
  domain_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  free_learn?: InputMaybe<Order_By>;
  free_practice?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_lesson_category?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number_of_completed_modules?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  quiz_domain?: InputMaybe<Quiz_Domain_Order_By>;
  quiz_questions_aggregate?: InputMaybe<Quiz_Question_Aggregate_Order_By>;
  quiz_quizzes_aggregate?: InputMaybe<Quiz_Quiz_Aggregate_Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  total_number_of_modules?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Order_By>;
  user_learn_category_progresses_aggregate?: InputMaybe<User_Learn_Category_Progress_Aggregate_Order_By>;
  user_learn_track_records_aggregate?: InputMaybe<User_Learn_Track_Record_Aggregate_Order_By>;
  user_planned_activities_aggregate?: InputMaybe<User_Planned_Activities_Aggregate_Order_By>;
  user_planned_date?: InputMaybe<Order_By>;
  user_planned_id?: InputMaybe<Order_By>;
  user_recent_lesson_aggregate?: InputMaybe<User_Recent_Lessons_Aggregate_Order_By>;
};

/** primary key columns input for table: quiz_category */
export type Quiz_Category_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_category" */
export enum Quiz_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  DomainId = 'domain_id',
  /** column name */
  Draft = 'draft',
  /** column name */
  FreeLearn = 'free_learn',
  /** column name */
  FreePractice = 'free_practice',
  /** column name */
  Id = 'id',
  /** column name */
  IsLessonCategory = 'is_lesson_category',
  /** column name */
  LessonCredits = 'lesson_credits',
  /** column name */
  Name = 'name',
  /** column name */
  OldCategoryId = 'old_category_id',
  /** column name */
  PracticeLevel_1Credits = 'practice_level_1_credits',
  /** column name */
  PracticeLevel_2Credits = 'practice_level_2_credits',
  /** column name */
  PracticeLevel_3Credits = 'practice_level_3_credits',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "quiz_category_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quiz_category" */
export enum Quiz_Category_Select_Column_Quiz_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  Draft = 'draft',
  /** column name */
  FreeLearn = 'free_learn',
  /** column name */
  FreePractice = 'free_practice',
  /** column name */
  IsLessonCategory = 'is_lesson_category'
}

/** select "quiz_category_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quiz_category" */
export enum Quiz_Category_Select_Column_Quiz_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  Draft = 'draft',
  /** column name */
  FreeLearn = 'free_learn',
  /** column name */
  FreePractice = 'free_practice',
  /** column name */
  IsLessonCategory = 'is_lesson_category'
}

/** input type for updating data in table "quiz_category" */
export type Quiz_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_include_in_planner?: InputMaybe<Scalars['Boolean']['input']>;
  domain_id?: InputMaybe<Scalars['Int']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  free_learn?: InputMaybe<Scalars['Boolean']['input']>;
  free_practice?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_lesson_category?: InputMaybe<Scalars['Boolean']['input']>;
  lesson_credits?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_category_id?: InputMaybe<Scalars['Int']['input']>;
  practice_level_1_credits?: InputMaybe<Scalars['numeric']['input']>;
  practice_level_2_credits?: InputMaybe<Scalars['numeric']['input']>;
  practice_level_3_credits?: InputMaybe<Scalars['numeric']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Category_Stddev_Fields = {
  __typename?: 'quiz_category_stddev_fields';
  domain_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lesson_credits?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Float']['output']>;
  practice_level_1_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_2_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_3_credits?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
};

/** order by stddev() on columns of table "quiz_category" */
export type Quiz_Category_Stddev_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Category_Stddev_Pop_Fields = {
  __typename?: 'quiz_category_stddev_pop_fields';
  domain_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lesson_credits?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Float']['output']>;
  practice_level_1_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_2_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_3_credits?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_category" */
export type Quiz_Category_Stddev_Pop_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Category_Stddev_Samp_Fields = {
  __typename?: 'quiz_category_stddev_samp_fields';
  domain_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lesson_credits?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Float']['output']>;
  practice_level_1_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_2_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_3_credits?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_category" */
export type Quiz_Category_Stddev_Samp_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_category" */
export type Quiz_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_include_in_planner?: InputMaybe<Scalars['Boolean']['input']>;
  domain_id?: InputMaybe<Scalars['Int']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  free_learn?: InputMaybe<Scalars['Boolean']['input']>;
  free_practice?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_lesson_category?: InputMaybe<Scalars['Boolean']['input']>;
  lesson_credits?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_category_id?: InputMaybe<Scalars['Int']['input']>;
  practice_level_1_credits?: InputMaybe<Scalars['numeric']['input']>;
  practice_level_2_credits?: InputMaybe<Scalars['numeric']['input']>;
  practice_level_3_credits?: InputMaybe<Scalars['numeric']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Category_Sum_Fields = {
  __typename?: 'quiz_category_sum_fields';
  domain_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lesson_credits?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Int']['output']>;
  practice_level_1_credits?: Maybe<Scalars['numeric']['output']>;
  practice_level_2_credits?: Maybe<Scalars['numeric']['output']>;
  practice_level_3_credits?: Maybe<Scalars['numeric']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "quiz_category" */
export type Quiz_Category_Sum_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_category" */
export enum Quiz_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  DomainId = 'domain_id',
  /** column name */
  Draft = 'draft',
  /** column name */
  FreeLearn = 'free_learn',
  /** column name */
  FreePractice = 'free_practice',
  /** column name */
  Id = 'id',
  /** column name */
  IsLessonCategory = 'is_lesson_category',
  /** column name */
  LessonCredits = 'lesson_credits',
  /** column name */
  Name = 'name',
  /** column name */
  OldCategoryId = 'old_category_id',
  /** column name */
  PracticeLevel_1Credits = 'practice_level_1_credits',
  /** column name */
  PracticeLevel_2Credits = 'practice_level_2_credits',
  /** column name */
  PracticeLevel_3Credits = 'practice_level_3_credits',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quiz_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Category_Var_Pop_Fields = {
  __typename?: 'quiz_category_var_pop_fields';
  domain_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lesson_credits?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Float']['output']>;
  practice_level_1_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_2_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_3_credits?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
};

/** order by var_pop() on columns of table "quiz_category" */
export type Quiz_Category_Var_Pop_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Category_Var_Samp_Fields = {
  __typename?: 'quiz_category_var_samp_fields';
  domain_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lesson_credits?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Float']['output']>;
  practice_level_1_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_2_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_3_credits?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
};

/** order by var_samp() on columns of table "quiz_category" */
export type Quiz_Category_Var_Samp_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Category_Variance_Fields = {
  __typename?: 'quiz_category_variance_fields';
  domain_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lesson_credits?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_number_of_completed_modules" */
  number_of_completed_modules?: Maybe<Scalars['bigint']['output']>;
  old_category_id?: Maybe<Scalars['Float']['output']>;
  practice_level_1_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_2_credits?: Maybe<Scalars['Float']['output']>;
  practice_level_3_credits?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_category_total_number_of_modules" */
  total_number_of_modules?: Maybe<Scalars['bigint']['output']>;
};

/** order by variance() on columns of table "quiz_category" */
export type Quiz_Category_Variance_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_credits?: InputMaybe<Order_By>;
  old_category_id?: InputMaybe<Order_By>;
  practice_level_1_credits?: InputMaybe<Order_By>;
  practice_level_2_credits?: InputMaybe<Order_By>;
  practice_level_3_credits?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** columns and relationships of "quiz_domain" */
export type Quiz_Domain = {
  __typename?: 'quiz_domain';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  do_not_include_in_planner?: Maybe<Scalars['Boolean']['output']>;
  has_tests: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_premium: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  old_domain_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  quiz_categories: Array<Quiz_Category>;
  /** An aggregate relationship */
  quiz_categories_aggregate: Quiz_Category_Aggregate;
  /** An object relationship */
  quiz_superdomain?: Maybe<Quiz_Superdomain>;
  rank?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  super_domain_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "quiz_domain" */
export type Quiz_DomainQuiz_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Category_Order_By>>;
  where?: InputMaybe<Quiz_Category_Bool_Exp>;
};


/** columns and relationships of "quiz_domain" */
export type Quiz_DomainQuiz_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Category_Order_By>>;
  where?: InputMaybe<Quiz_Category_Bool_Exp>;
};

/** aggregated selection of "quiz_domain" */
export type Quiz_Domain_Aggregate = {
  __typename?: 'quiz_domain_aggregate';
  aggregate?: Maybe<Quiz_Domain_Aggregate_Fields>;
  nodes: Array<Quiz_Domain>;
};

export type Quiz_Domain_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quiz_Domain_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quiz_Domain_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quiz_Domain_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Domain_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quiz_Domain_Select_Column_Quiz_Domain_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Domain_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Domain_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quiz_Domain_Select_Column_Quiz_Domain_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Domain_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Domain_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Domain_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_domain" */
export type Quiz_Domain_Aggregate_Fields = {
  __typename?: 'quiz_domain_aggregate_fields';
  avg?: Maybe<Quiz_Domain_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Domain_Max_Fields>;
  min?: Maybe<Quiz_Domain_Min_Fields>;
  stddev?: Maybe<Quiz_Domain_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Domain_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Domain_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Domain_Sum_Fields>;
  var_pop?: Maybe<Quiz_Domain_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Domain_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Domain_Variance_Fields>;
};


/** aggregate fields of "quiz_domain" */
export type Quiz_Domain_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_domain" */
export type Quiz_Domain_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Domain_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Domain_Max_Order_By>;
  min?: InputMaybe<Quiz_Domain_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Domain_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Domain_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Domain_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Domain_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Domain_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Domain_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Domain_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_domain" */
export type Quiz_Domain_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Domain_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Domain_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Domain_Avg_Fields = {
  __typename?: 'quiz_domain_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_domain_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quiz_domain" */
export type Quiz_Domain_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_domain". All fields are combined with a logical 'AND'. */
export type Quiz_Domain_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Domain_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Domain_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Domain_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  do_not_include_in_planner?: InputMaybe<Boolean_Comparison_Exp>;
  has_tests?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_premium?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  old_domain_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_categories?: InputMaybe<Quiz_Category_Bool_Exp>;
  quiz_categories_aggregate?: InputMaybe<Quiz_Category_Aggregate_Bool_Exp>;
  quiz_superdomain?: InputMaybe<Quiz_Superdomain_Bool_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  super_domain_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_domain" */
export enum Quiz_Domain_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizDomainPkey = 'quiz_domain_pkey',
  /** unique or primary key constraint on columns "slug" */
  QuizDomainSlugKey = 'quiz_domain_slug_key'
}

/** input type for incrementing numeric columns in table "quiz_domain" */
export type Quiz_Domain_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  old_domain_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  super_domain_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_domain" */
export type Quiz_Domain_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_include_in_planner?: InputMaybe<Scalars['Boolean']['input']>;
  has_tests?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_domain_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_categories?: InputMaybe<Quiz_Category_Arr_Rel_Insert_Input>;
  quiz_superdomain?: InputMaybe<Quiz_Superdomain_Obj_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  super_domain_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quiz_Domain_Max_Fields = {
  __typename?: 'quiz_domain_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  old_domain_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  super_domain_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "quiz_domain" */
export type Quiz_Domain_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Domain_Min_Fields = {
  __typename?: 'quiz_domain_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  old_domain_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  super_domain_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "quiz_domain" */
export type Quiz_Domain_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_domain" */
export type Quiz_Domain_Mutation_Response = {
  __typename?: 'quiz_domain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Domain>;
};

/** input type for inserting object relation for remote table "quiz_domain" */
export type Quiz_Domain_Obj_Rel_Insert_Input = {
  data: Quiz_Domain_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Domain_On_Conflict>;
};

/** on_conflict condition type for table "quiz_domain" */
export type Quiz_Domain_On_Conflict = {
  constraint: Quiz_Domain_Constraint;
  update_columns?: Array<Quiz_Domain_Update_Column>;
  where?: InputMaybe<Quiz_Domain_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_domain". */
export type Quiz_Domain_Order_By = {
  created_at?: InputMaybe<Order_By>;
  do_not_include_in_planner?: InputMaybe<Order_By>;
  has_tests?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_premium?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  quiz_categories_aggregate?: InputMaybe<Quiz_Category_Aggregate_Order_By>;
  quiz_superdomain?: InputMaybe<Quiz_Superdomain_Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_domain */
export type Quiz_Domain_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_domain" */
export enum Quiz_Domain_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  HasTests = 'has_tests',
  /** column name */
  Id = 'id',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  Name = 'name',
  /** column name */
  OldDomainId = 'old_domain_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  SuperDomainId = 'super_domain_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "quiz_domain_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quiz_domain" */
export enum Quiz_Domain_Select_Column_Quiz_Domain_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  HasTests = 'has_tests',
  /** column name */
  IsPremium = 'is_premium'
}

/** select "quiz_domain_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quiz_domain" */
export enum Quiz_Domain_Select_Column_Quiz_Domain_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  HasTests = 'has_tests',
  /** column name */
  IsPremium = 'is_premium'
}

/** input type for updating data in table "quiz_domain" */
export type Quiz_Domain_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_include_in_planner?: InputMaybe<Scalars['Boolean']['input']>;
  has_tests?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_domain_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  super_domain_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Domain_Stddev_Fields = {
  __typename?: 'quiz_domain_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_domain_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quiz_domain" */
export type Quiz_Domain_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Domain_Stddev_Pop_Fields = {
  __typename?: 'quiz_domain_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_domain_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_domain" */
export type Quiz_Domain_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Domain_Stddev_Samp_Fields = {
  __typename?: 'quiz_domain_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_domain_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_domain" */
export type Quiz_Domain_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_domain" */
export type Quiz_Domain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Domain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Domain_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_include_in_planner?: InputMaybe<Scalars['Boolean']['input']>;
  has_tests?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_domain_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  super_domain_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Domain_Sum_Fields = {
  __typename?: 'quiz_domain_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  old_domain_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  super_domain_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quiz_domain" */
export type Quiz_Domain_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_domain" */
export enum Quiz_Domain_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  HasTests = 'has_tests',
  /** column name */
  Id = 'id',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  Name = 'name',
  /** column name */
  OldDomainId = 'old_domain_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  SuperDomainId = 'super_domain_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quiz_Domain_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Domain_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Domain_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Domain_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Domain_Var_Pop_Fields = {
  __typename?: 'quiz_domain_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_domain_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quiz_domain" */
export type Quiz_Domain_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Domain_Var_Samp_Fields = {
  __typename?: 'quiz_domain_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_domain_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quiz_domain" */
export type Quiz_Domain_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Domain_Variance_Fields = {
  __typename?: 'quiz_domain_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_domain_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  super_domain_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quiz_domain" */
export type Quiz_Domain_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  old_domain_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  super_domain_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "quiz_markingsystem" */
export type Quiz_Markingsystem = {
  __typename?: 'quiz_markingsystem';
  correct_mcq: Scalars['numeric']['output'];
  correct_tita: Scalars['numeric']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  incorrect_mcq: Scalars['numeric']['output'];
  incorrect_tita: Scalars['numeric']['output'];
  /** An array relationship */
  quiz_quizzes: Array<Quiz_Quiz>;
  /** An aggregate relationship */
  quiz_quizzes_aggregate: Quiz_Quiz_Aggregate;
  /** A computed field, executes function "quiz_markingsystem_string_representation" */
  string_representation?: Maybe<Scalars['String']['output']>;
  unattempted: Scalars['numeric']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "quiz_markingsystem" */
export type Quiz_MarkingsystemQuiz_QuizzesArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};


/** columns and relationships of "quiz_markingsystem" */
export type Quiz_MarkingsystemQuiz_Quizzes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};

/** aggregated selection of "quiz_markingsystem" */
export type Quiz_Markingsystem_Aggregate = {
  __typename?: 'quiz_markingsystem_aggregate';
  aggregate?: Maybe<Quiz_Markingsystem_Aggregate_Fields>;
  nodes: Array<Quiz_Markingsystem>;
};

/** aggregate fields of "quiz_markingsystem" */
export type Quiz_Markingsystem_Aggregate_Fields = {
  __typename?: 'quiz_markingsystem_aggregate_fields';
  avg?: Maybe<Quiz_Markingsystem_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Markingsystem_Max_Fields>;
  min?: Maybe<Quiz_Markingsystem_Min_Fields>;
  stddev?: Maybe<Quiz_Markingsystem_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Markingsystem_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Markingsystem_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Markingsystem_Sum_Fields>;
  var_pop?: Maybe<Quiz_Markingsystem_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Markingsystem_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Markingsystem_Variance_Fields>;
};


/** aggregate fields of "quiz_markingsystem" */
export type Quiz_Markingsystem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Markingsystem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quiz_Markingsystem_Avg_Fields = {
  __typename?: 'quiz_markingsystem_avg_fields';
  correct_mcq?: Maybe<Scalars['Float']['output']>;
  correct_tita?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incorrect_mcq?: Maybe<Scalars['Float']['output']>;
  incorrect_tita?: Maybe<Scalars['Float']['output']>;
  unattempted?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quiz_markingsystem". All fields are combined with a logical 'AND'. */
export type Quiz_Markingsystem_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Markingsystem_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Markingsystem_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Markingsystem_Bool_Exp>>;
  correct_mcq?: InputMaybe<Numeric_Comparison_Exp>;
  correct_tita?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incorrect_mcq?: InputMaybe<Numeric_Comparison_Exp>;
  incorrect_tita?: InputMaybe<Numeric_Comparison_Exp>;
  quiz_quizzes?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  quiz_quizzes_aggregate?: InputMaybe<Quiz_Quiz_Aggregate_Bool_Exp>;
  string_representation?: InputMaybe<String_Comparison_Exp>;
  unattempted?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_markingsystem" */
export enum Quiz_Markingsystem_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizMarkingsystemPkey = 'quiz_markingsystem_pkey'
}

/** input type for incrementing numeric columns in table "quiz_markingsystem" */
export type Quiz_Markingsystem_Inc_Input = {
  correct_mcq?: InputMaybe<Scalars['numeric']['input']>;
  correct_tita?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incorrect_mcq?: InputMaybe<Scalars['numeric']['input']>;
  incorrect_tita?: InputMaybe<Scalars['numeric']['input']>;
  unattempted?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "quiz_markingsystem" */
export type Quiz_Markingsystem_Insert_Input = {
  correct_mcq?: InputMaybe<Scalars['numeric']['input']>;
  correct_tita?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incorrect_mcq?: InputMaybe<Scalars['numeric']['input']>;
  incorrect_tita?: InputMaybe<Scalars['numeric']['input']>;
  quiz_quizzes?: InputMaybe<Quiz_Quiz_Arr_Rel_Insert_Input>;
  unattempted?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quiz_Markingsystem_Max_Fields = {
  __typename?: 'quiz_markingsystem_max_fields';
  correct_mcq?: Maybe<Scalars['numeric']['output']>;
  correct_tita?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incorrect_mcq?: Maybe<Scalars['numeric']['output']>;
  incorrect_tita?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "quiz_markingsystem_string_representation" */
  string_representation?: Maybe<Scalars['String']['output']>;
  unattempted?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quiz_Markingsystem_Min_Fields = {
  __typename?: 'quiz_markingsystem_min_fields';
  correct_mcq?: Maybe<Scalars['numeric']['output']>;
  correct_tita?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incorrect_mcq?: Maybe<Scalars['numeric']['output']>;
  incorrect_tita?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "quiz_markingsystem_string_representation" */
  string_representation?: Maybe<Scalars['String']['output']>;
  unattempted?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quiz_markingsystem" */
export type Quiz_Markingsystem_Mutation_Response = {
  __typename?: 'quiz_markingsystem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Markingsystem>;
};

/** input type for inserting object relation for remote table "quiz_markingsystem" */
export type Quiz_Markingsystem_Obj_Rel_Insert_Input = {
  data: Quiz_Markingsystem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Markingsystem_On_Conflict>;
};

/** on_conflict condition type for table "quiz_markingsystem" */
export type Quiz_Markingsystem_On_Conflict = {
  constraint: Quiz_Markingsystem_Constraint;
  update_columns?: Array<Quiz_Markingsystem_Update_Column>;
  where?: InputMaybe<Quiz_Markingsystem_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_markingsystem". */
export type Quiz_Markingsystem_Order_By = {
  correct_mcq?: InputMaybe<Order_By>;
  correct_tita?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incorrect_mcq?: InputMaybe<Order_By>;
  incorrect_tita?: InputMaybe<Order_By>;
  quiz_quizzes_aggregate?: InputMaybe<Quiz_Quiz_Aggregate_Order_By>;
  string_representation?: InputMaybe<Order_By>;
  unattempted?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_markingsystem */
export type Quiz_Markingsystem_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_markingsystem" */
export enum Quiz_Markingsystem_Select_Column {
  /** column name */
  CorrectMcq = 'correct_mcq',
  /** column name */
  CorrectTita = 'correct_tita',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IncorrectMcq = 'incorrect_mcq',
  /** column name */
  IncorrectTita = 'incorrect_tita',
  /** column name */
  Unattempted = 'unattempted',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "quiz_markingsystem" */
export type Quiz_Markingsystem_Set_Input = {
  correct_mcq?: InputMaybe<Scalars['numeric']['input']>;
  correct_tita?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incorrect_mcq?: InputMaybe<Scalars['numeric']['input']>;
  incorrect_tita?: InputMaybe<Scalars['numeric']['input']>;
  unattempted?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Markingsystem_Stddev_Fields = {
  __typename?: 'quiz_markingsystem_stddev_fields';
  correct_mcq?: Maybe<Scalars['Float']['output']>;
  correct_tita?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incorrect_mcq?: Maybe<Scalars['Float']['output']>;
  incorrect_tita?: Maybe<Scalars['Float']['output']>;
  unattempted?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Markingsystem_Stddev_Pop_Fields = {
  __typename?: 'quiz_markingsystem_stddev_pop_fields';
  correct_mcq?: Maybe<Scalars['Float']['output']>;
  correct_tita?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incorrect_mcq?: Maybe<Scalars['Float']['output']>;
  incorrect_tita?: Maybe<Scalars['Float']['output']>;
  unattempted?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Markingsystem_Stddev_Samp_Fields = {
  __typename?: 'quiz_markingsystem_stddev_samp_fields';
  correct_mcq?: Maybe<Scalars['Float']['output']>;
  correct_tita?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incorrect_mcq?: Maybe<Scalars['Float']['output']>;
  incorrect_tita?: Maybe<Scalars['Float']['output']>;
  unattempted?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quiz_markingsystem" */
export type Quiz_Markingsystem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Markingsystem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Markingsystem_Stream_Cursor_Value_Input = {
  correct_mcq?: InputMaybe<Scalars['numeric']['input']>;
  correct_tita?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incorrect_mcq?: InputMaybe<Scalars['numeric']['input']>;
  incorrect_tita?: InputMaybe<Scalars['numeric']['input']>;
  unattempted?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Markingsystem_Sum_Fields = {
  __typename?: 'quiz_markingsystem_sum_fields';
  correct_mcq?: Maybe<Scalars['numeric']['output']>;
  correct_tita?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incorrect_mcq?: Maybe<Scalars['numeric']['output']>;
  incorrect_tita?: Maybe<Scalars['numeric']['output']>;
  unattempted?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "quiz_markingsystem" */
export enum Quiz_Markingsystem_Update_Column {
  /** column name */
  CorrectMcq = 'correct_mcq',
  /** column name */
  CorrectTita = 'correct_tita',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IncorrectMcq = 'incorrect_mcq',
  /** column name */
  IncorrectTita = 'incorrect_tita',
  /** column name */
  Unattempted = 'unattempted',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quiz_Markingsystem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Markingsystem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Markingsystem_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Markingsystem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Markingsystem_Var_Pop_Fields = {
  __typename?: 'quiz_markingsystem_var_pop_fields';
  correct_mcq?: Maybe<Scalars['Float']['output']>;
  correct_tita?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incorrect_mcq?: Maybe<Scalars['Float']['output']>;
  incorrect_tita?: Maybe<Scalars['Float']['output']>;
  unattempted?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quiz_Markingsystem_Var_Samp_Fields = {
  __typename?: 'quiz_markingsystem_var_samp_fields';
  correct_mcq?: Maybe<Scalars['Float']['output']>;
  correct_tita?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incorrect_mcq?: Maybe<Scalars['Float']['output']>;
  incorrect_tita?: Maybe<Scalars['Float']['output']>;
  unattempted?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quiz_Markingsystem_Variance_Fields = {
  __typename?: 'quiz_markingsystem_variance_fields';
  correct_mcq?: Maybe<Scalars['Float']['output']>;
  correct_tita?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incorrect_mcq?: Maybe<Scalars['Float']['output']>;
  incorrect_tita?: Maybe<Scalars['Float']['output']>;
  unattempted?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "quiz_option" */
export type Quiz_Option = {
  __typename?: 'quiz_option';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  is_correct: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  question_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  quiz_question?: Maybe<Quiz_Question>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "quiz_option" */
export type Quiz_Option_Aggregate = {
  __typename?: 'quiz_option_aggregate';
  aggregate?: Maybe<Quiz_Option_Aggregate_Fields>;
  nodes: Array<Quiz_Option>;
};

export type Quiz_Option_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quiz_Option_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quiz_Option_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quiz_Option_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Option_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quiz_Option_Select_Column_Quiz_Option_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Option_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Option_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quiz_Option_Select_Column_Quiz_Option_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Option_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Option_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Option_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_option" */
export type Quiz_Option_Aggregate_Fields = {
  __typename?: 'quiz_option_aggregate_fields';
  avg?: Maybe<Quiz_Option_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Option_Max_Fields>;
  min?: Maybe<Quiz_Option_Min_Fields>;
  stddev?: Maybe<Quiz_Option_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Option_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Option_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Option_Sum_Fields>;
  var_pop?: Maybe<Quiz_Option_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Option_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Option_Variance_Fields>;
};


/** aggregate fields of "quiz_option" */
export type Quiz_Option_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_option" */
export type Quiz_Option_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Option_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Option_Max_Order_By>;
  min?: InputMaybe<Quiz_Option_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Option_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Option_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Option_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Option_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Option_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Option_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Option_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_option" */
export type Quiz_Option_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Option_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Option_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Option_Avg_Fields = {
  __typename?: 'quiz_option_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quiz_option" */
export type Quiz_Option_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_option". All fields are combined with a logical 'AND'. */
export type Quiz_Option_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Option_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Option_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Option_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_correct?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_option" */
export enum Quiz_Option_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizOptionPkey = 'quiz_option_pkey'
}

/** input type for incrementing numeric columns in table "quiz_option" */
export type Quiz_Option_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_option" */
export type Quiz_Option_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quiz_Option_Max_Fields = {
  __typename?: 'quiz_option_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "quiz_option" */
export type Quiz_Option_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Option_Min_Fields = {
  __typename?: 'quiz_option_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "quiz_option" */
export type Quiz_Option_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_option" */
export type Quiz_Option_Mutation_Response = {
  __typename?: 'quiz_option_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Option>;
};

/** on_conflict condition type for table "quiz_option" */
export type Quiz_Option_On_Conflict = {
  constraint: Quiz_Option_Constraint;
  update_columns?: Array<Quiz_Option_Update_Column>;
  where?: InputMaybe<Quiz_Option_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_option". */
export type Quiz_Option_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_correct?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_option */
export type Quiz_Option_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_option" */
export enum Quiz_Option_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  Name = 'name',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "quiz_option_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quiz_option" */
export enum Quiz_Option_Select_Column_Quiz_Option_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCorrect = 'is_correct'
}

/** select "quiz_option_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quiz_option" */
export enum Quiz_Option_Select_Column_Quiz_Option_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCorrect = 'is_correct'
}

/** input type for updating data in table "quiz_option" */
export type Quiz_Option_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Option_Stddev_Fields = {
  __typename?: 'quiz_option_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quiz_option" */
export type Quiz_Option_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Option_Stddev_Pop_Fields = {
  __typename?: 'quiz_option_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_option" */
export type Quiz_Option_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Option_Stddev_Samp_Fields = {
  __typename?: 'quiz_option_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_option" */
export type Quiz_Option_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_option" */
export type Quiz_Option_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Option_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Option_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Option_Sum_Fields = {
  __typename?: 'quiz_option_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quiz_option" */
export type Quiz_Option_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_option" */
export enum Quiz_Option_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  Name = 'name',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quiz_Option_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Option_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Option_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Option_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Option_Var_Pop_Fields = {
  __typename?: 'quiz_option_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quiz_option" */
export type Quiz_Option_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Option_Var_Samp_Fields = {
  __typename?: 'quiz_option_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quiz_option" */
export type Quiz_Option_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Option_Variance_Fields = {
  __typename?: 'quiz_option_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quiz_option" */
export type Quiz_Option_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "quiz_paragraph" */
export type Quiz_Paragraph = {
  __typename?: 'quiz_paragraph';
  comprehension?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  old_paragraph_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  quiz_questions: Array<Quiz_Question>;
  /** An aggregate relationship */
  quiz_questions_aggregate: Quiz_Question_Aggregate;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "quiz_paragraph" */
export type Quiz_ParagraphQuiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Question_Order_By>>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};


/** columns and relationships of "quiz_paragraph" */
export type Quiz_ParagraphQuiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Question_Order_By>>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};

/** aggregated selection of "quiz_paragraph" */
export type Quiz_Paragraph_Aggregate = {
  __typename?: 'quiz_paragraph_aggregate';
  aggregate?: Maybe<Quiz_Paragraph_Aggregate_Fields>;
  nodes: Array<Quiz_Paragraph>;
};

/** aggregate fields of "quiz_paragraph" */
export type Quiz_Paragraph_Aggregate_Fields = {
  __typename?: 'quiz_paragraph_aggregate_fields';
  avg?: Maybe<Quiz_Paragraph_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Paragraph_Max_Fields>;
  min?: Maybe<Quiz_Paragraph_Min_Fields>;
  stddev?: Maybe<Quiz_Paragraph_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Paragraph_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Paragraph_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Paragraph_Sum_Fields>;
  var_pop?: Maybe<Quiz_Paragraph_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Paragraph_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Paragraph_Variance_Fields>;
};


/** aggregate fields of "quiz_paragraph" */
export type Quiz_Paragraph_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Paragraph_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quiz_Paragraph_Avg_Fields = {
  __typename?: 'quiz_paragraph_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_paragraph_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quiz_paragraph". All fields are combined with a logical 'AND'. */
export type Quiz_Paragraph_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Paragraph_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Paragraph_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Paragraph_Bool_Exp>>;
  comprehension?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  old_paragraph_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_questions?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_questions_aggregate?: InputMaybe<Quiz_Question_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_paragraph" */
export enum Quiz_Paragraph_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizParagraphPkey = 'quiz_paragraph_pkey'
}

/** input type for incrementing numeric columns in table "quiz_paragraph" */
export type Quiz_Paragraph_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  old_paragraph_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_paragraph" */
export type Quiz_Paragraph_Insert_Input = {
  comprehension?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  old_paragraph_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_questions?: InputMaybe<Quiz_Question_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quiz_Paragraph_Max_Fields = {
  __typename?: 'quiz_paragraph_max_fields';
  comprehension?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  old_paragraph_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quiz_Paragraph_Min_Fields = {
  __typename?: 'quiz_paragraph_min_fields';
  comprehension?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  old_paragraph_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quiz_paragraph" */
export type Quiz_Paragraph_Mutation_Response = {
  __typename?: 'quiz_paragraph_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Paragraph>;
};

/** input type for inserting object relation for remote table "quiz_paragraph" */
export type Quiz_Paragraph_Obj_Rel_Insert_Input = {
  data: Quiz_Paragraph_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Paragraph_On_Conflict>;
};

/** on_conflict condition type for table "quiz_paragraph" */
export type Quiz_Paragraph_On_Conflict = {
  constraint: Quiz_Paragraph_Constraint;
  update_columns?: Array<Quiz_Paragraph_Update_Column>;
  where?: InputMaybe<Quiz_Paragraph_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_paragraph". */
export type Quiz_Paragraph_Order_By = {
  comprehension?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_paragraph_id?: InputMaybe<Order_By>;
  quiz_questions_aggregate?: InputMaybe<Quiz_Question_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_paragraph */
export type Quiz_Paragraph_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_paragraph" */
export enum Quiz_Paragraph_Select_Column {
  /** column name */
  Comprehension = 'comprehension',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OldParagraphId = 'old_paragraph_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "quiz_paragraph" */
export type Quiz_Paragraph_Set_Input = {
  comprehension?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  old_paragraph_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Paragraph_Stddev_Fields = {
  __typename?: 'quiz_paragraph_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_paragraph_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Paragraph_Stddev_Pop_Fields = {
  __typename?: 'quiz_paragraph_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_paragraph_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Paragraph_Stddev_Samp_Fields = {
  __typename?: 'quiz_paragraph_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_paragraph_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quiz_paragraph" */
export type Quiz_Paragraph_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Paragraph_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Paragraph_Stream_Cursor_Value_Input = {
  comprehension?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  old_paragraph_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Paragraph_Sum_Fields = {
  __typename?: 'quiz_paragraph_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  old_paragraph_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "quiz_paragraph" */
export enum Quiz_Paragraph_Update_Column {
  /** column name */
  Comprehension = 'comprehension',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OldParagraphId = 'old_paragraph_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quiz_Paragraph_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Paragraph_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Paragraph_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Paragraph_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Paragraph_Var_Pop_Fields = {
  __typename?: 'quiz_paragraph_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_paragraph_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quiz_Paragraph_Var_Samp_Fields = {
  __typename?: 'quiz_paragraph_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_paragraph_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quiz_Paragraph_Variance_Fields = {
  __typename?: 'quiz_paragraph_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_paragraph_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "quiz_question" */
export type Quiz_Question = {
  __typename?: 'quiz_question';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  difficulty: Scalars['String']['output'];
  has_paragraph: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  live_quiz_question_positions: Array<Live_Quiz_Question_Positions>;
  /** An aggregate relationship */
  live_quiz_question_positions_aggregate: Live_Quiz_Question_Positions_Aggregate;
  /** An array relationship */
  live_quiz_question_summaries: Array<Live_Quiz_Question_Summary>;
  /** An aggregate relationship */
  live_quiz_question_summaries_aggregate: Live_Quiz_Question_Summary_Aggregate;
  name: Scalars['String']['output'];
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  options: Array<Quiz_Option>;
  /** An aggregate relationship */
  options_aggregate: Quiz_Option_Aggregate;
  paragraph_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  question_reports: Array<Question_Reports>;
  /** An aggregate relationship */
  question_reports_aggregate: Question_Reports_Aggregate;
  question_type: Scalars['String']['output'];
  /** An array relationship */
  quiz_answers: Array<Quiz_Answer>;
  /** An aggregate relationship */
  quiz_answers_aggregate: Quiz_Answer_Aggregate;
  /** An object relationship */
  quiz_category: Quiz_Category;
  /** An object relationship */
  quiz_paragraph?: Maybe<Quiz_Paragraph>;
  /** An array relationship */
  quiz_quiz_questions: Array<Quiz_Quiz_Questions>;
  /** An aggregate relationship */
  quiz_quiz_questions_aggregate: Quiz_Quiz_Questions_Aggregate;
  /** An array relationship */
  quiz_section_questions: Array<Quiz_Section_Questions>;
  /** An aggregate relationship */
  quiz_section_questions_aggregate: Quiz_Section_Questions_Aggregate;
  rank?: Maybe<Scalars['smallint']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  userQuizQuestionSummariesByQuestionId: Array<User_Quiz_Question_Summaries>;
  /** An aggregate relationship */
  userQuizQuestionSummariesByQuestionId_aggregate: User_Quiz_Question_Summaries_Aggregate;
  /** An array relationship */
  user_question_summaries: Array<Users_Userquestionsummary>;
  /** An aggregate relationship */
  user_question_summaries_aggregate: Users_Userquestionsummary_Aggregate;
  /** An array relationship */
  user_quiz_question_attempts: Array<User_Quiz_Question_Attempts>;
  /** An aggregate relationship */
  user_quiz_question_attempts_aggregate: User_Quiz_Question_Attempts_Aggregate;
  /** An array relationship */
  user_quiz_question_positions: Array<User_Quiz_Question_Positions>;
  /** An aggregate relationship */
  user_quiz_question_positions_aggregate: User_Quiz_Question_Positions_Aggregate;
  /** An array relationship */
  user_quiz_question_summaries: Array<User_Quiz_Question_Summaries>;
  /** An aggregate relationship */
  user_quiz_question_summaries_aggregate: User_Quiz_Question_Summaries_Aggregate;
  /** An array relationship */
  user_quiz_question_summaries_old: Array<User_Quiz_Question_Summaries_Old>;
  /** An aggregate relationship */
  user_quiz_question_summaries_old_aggregate: User_Quiz_Question_Summaries_Old_Aggregate;
  /** An array relationship */
  user_quiz_questions: Array<User_Quiz_Questions>;
  /** An aggregate relationship */
  user_quiz_questions_aggregate: User_Quiz_Questions_Aggregate;
  /** An array relationship */
  user_quiz_summaries: Array<User_Quiz_Summaries>;
  /** An aggregate relationship */
  user_quiz_summaries_aggregate: User_Quiz_Summaries_Aggregate;
  /** An array relationship */
  user_speed_test_questions_summaries: Array<User_Speed_Test_Questions_Summaries>;
  /** An aggregate relationship */
  user_speed_test_questions_summaries_aggregate: User_Speed_Test_Questions_Summaries_Aggregate;
  videocipher_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionLive_Quiz_Question_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionLive_Quiz_Question_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionLive_Quiz_Question_SummariesArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionLive_Quiz_Question_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Question_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Question_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionOptionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Option_Order_By>>;
  where?: InputMaybe<Quiz_Option_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Option_Order_By>>;
  where?: InputMaybe<Quiz_Option_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionQuestion_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Question_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Reports_Order_By>>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionQuestion_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Reports_Order_By>>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionQuiz_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Answer_Order_By>>;
  where?: InputMaybe<Quiz_Answer_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionQuiz_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Answer_Order_By>>;
  where?: InputMaybe<Quiz_Answer_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionQuiz_Quiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionQuiz_Quiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionQuiz_Section_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionQuiz_Section_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUserQuizQuestionSummariesByQuestionIdArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUserQuizQuestionSummariesByQuestionId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Question_SummariesArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Question_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Question_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Attempts_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Question_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Attempts_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Question_PositionsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Question_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Question_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Question_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Question_Summaries_OldArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Question_Summaries_Old_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Questions_Order_By>>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Questions_Order_By>>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Quiz_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Speed_Test_Questions_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_question" */
export type Quiz_QuestionUser_Speed_Test_Questions_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};

/** aggregated selection of "quiz_question" */
export type Quiz_Question_Aggregate = {
  __typename?: 'quiz_question_aggregate';
  aggregate?: Maybe<Quiz_Question_Aggregate_Fields>;
  nodes: Array<Quiz_Question>;
};

export type Quiz_Question_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quiz_Question_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quiz_Question_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quiz_Question_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Question_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quiz_Question_Select_Column_Quiz_Question_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Question_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Question_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quiz_Question_Select_Column_Quiz_Question_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Question_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Question_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Question_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_question" */
export type Quiz_Question_Aggregate_Fields = {
  __typename?: 'quiz_question_aggregate_fields';
  avg?: Maybe<Quiz_Question_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Question_Max_Fields>;
  min?: Maybe<Quiz_Question_Min_Fields>;
  stddev?: Maybe<Quiz_Question_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Question_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Question_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Question_Sum_Fields>;
  var_pop?: Maybe<Quiz_Question_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Question_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Question_Variance_Fields>;
};


/** aggregate fields of "quiz_question" */
export type Quiz_Question_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_question" */
export type Quiz_Question_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Question_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Question_Max_Order_By>;
  min?: InputMaybe<Quiz_Question_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Question_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Question_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Question_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Question_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Question_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Question_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Question_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_question" */
export type Quiz_Question_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Question_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Question_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Question_Avg_Fields = {
  __typename?: 'quiz_question_avg_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Float']['output']>;
  paragraph_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quiz_question" */
export type Quiz_Question_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_question". All fields are combined with a logical 'AND'. */
export type Quiz_Question_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Question_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Question_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Question_Bool_Exp>>;
  average_time_taken?: InputMaybe<Float8_Comparison_Exp>;
  average_time_taken_for_correct_attempts?: InputMaybe<Float8_Comparison_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  difficulty?: InputMaybe<String_Comparison_Exp>;
  has_paragraph?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  live_quiz_question_positions?: InputMaybe<Live_Quiz_Question_Positions_Bool_Exp>;
  live_quiz_question_positions_aggregate?: InputMaybe<Live_Quiz_Question_Positions_Aggregate_Bool_Exp>;
  live_quiz_question_summaries?: InputMaybe<Live_Quiz_Question_Summary_Bool_Exp>;
  live_quiz_question_summaries_aggregate?: InputMaybe<Live_Quiz_Question_Summary_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number_of_attempts?: InputMaybe<Int_Comparison_Exp>;
  number_of_correct_attempts?: InputMaybe<Int_Comparison_Exp>;
  old_question_id?: InputMaybe<Int_Comparison_Exp>;
  options?: InputMaybe<Quiz_Option_Bool_Exp>;
  options_aggregate?: InputMaybe<Quiz_Option_Aggregate_Bool_Exp>;
  paragraph_id?: InputMaybe<Int_Comparison_Exp>;
  question_reports?: InputMaybe<Question_Reports_Bool_Exp>;
  question_reports_aggregate?: InputMaybe<Question_Reports_Aggregate_Bool_Exp>;
  question_type?: InputMaybe<String_Comparison_Exp>;
  quiz_answers?: InputMaybe<Quiz_Answer_Bool_Exp>;
  quiz_answers_aggregate?: InputMaybe<Quiz_Answer_Aggregate_Bool_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  quiz_paragraph?: InputMaybe<Quiz_Paragraph_Bool_Exp>;
  quiz_quiz_questions?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
  quiz_quiz_questions_aggregate?: InputMaybe<Quiz_Quiz_Questions_Aggregate_Bool_Exp>;
  quiz_section_questions?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
  quiz_section_questions_aggregate?: InputMaybe<Quiz_Section_Questions_Aggregate_Bool_Exp>;
  rank?: InputMaybe<Smallint_Comparison_Exp>;
  solution?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userQuizQuestionSummariesByQuestionId?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
  userQuizQuestionSummariesByQuestionId_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Aggregate_Bool_Exp>;
  user_question_summaries?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
  user_question_summaries_aggregate?: InputMaybe<Users_Userquestionsummary_Aggregate_Bool_Exp>;
  user_quiz_question_attempts?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
  user_quiz_question_attempts_aggregate?: InputMaybe<User_Quiz_Question_Attempts_Aggregate_Bool_Exp>;
  user_quiz_question_positions?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
  user_quiz_question_positions_aggregate?: InputMaybe<User_Quiz_Question_Positions_Aggregate_Bool_Exp>;
  user_quiz_question_summaries?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
  user_quiz_question_summaries_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Aggregate_Bool_Exp>;
  user_quiz_question_summaries_old?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
  user_quiz_question_summaries_old_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp>;
  user_quiz_questions?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
  user_quiz_questions_aggregate?: InputMaybe<User_Quiz_Questions_Aggregate_Bool_Exp>;
  user_quiz_summaries?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  user_quiz_summaries_aggregate?: InputMaybe<User_Quiz_Summaries_Aggregate_Bool_Exp>;
  user_speed_test_questions_summaries?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
  user_speed_test_questions_summaries_aggregate?: InputMaybe<User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp>;
  videocipher_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_question" */
export enum Quiz_Question_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizQuestionPkey = 'quiz_question_pkey'
}

/** input type for incrementing numeric columns in table "quiz_question" */
export type Quiz_Question_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  old_question_id?: InputMaybe<Scalars['Int']['input']>;
  paragraph_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "quiz_question" */
export type Quiz_Question_Insert_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  has_paragraph?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  live_quiz_question_positions?: InputMaybe<Live_Quiz_Question_Positions_Arr_Rel_Insert_Input>;
  live_quiz_question_summaries?: InputMaybe<Live_Quiz_Question_Summary_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_question_id?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Quiz_Option_Arr_Rel_Insert_Input>;
  paragraph_id?: InputMaybe<Scalars['Int']['input']>;
  question_reports?: InputMaybe<Question_Reports_Arr_Rel_Insert_Input>;
  question_type?: InputMaybe<Scalars['String']['input']>;
  quiz_answers?: InputMaybe<Quiz_Answer_Arr_Rel_Insert_Input>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  quiz_paragraph?: InputMaybe<Quiz_Paragraph_Obj_Rel_Insert_Input>;
  quiz_quiz_questions?: InputMaybe<Quiz_Quiz_Questions_Arr_Rel_Insert_Input>;
  quiz_section_questions?: InputMaybe<Quiz_Section_Questions_Arr_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userQuizQuestionSummariesByQuestionId?: InputMaybe<User_Quiz_Question_Summaries_Arr_Rel_Insert_Input>;
  user_question_summaries?: InputMaybe<Users_Userquestionsummary_Arr_Rel_Insert_Input>;
  user_quiz_question_attempts?: InputMaybe<User_Quiz_Question_Attempts_Arr_Rel_Insert_Input>;
  user_quiz_question_positions?: InputMaybe<User_Quiz_Question_Positions_Arr_Rel_Insert_Input>;
  user_quiz_question_summaries?: InputMaybe<User_Quiz_Question_Summaries_Arr_Rel_Insert_Input>;
  user_quiz_question_summaries_old?: InputMaybe<User_Quiz_Question_Summaries_Old_Arr_Rel_Insert_Input>;
  user_quiz_questions?: InputMaybe<User_Quiz_Questions_Arr_Rel_Insert_Input>;
  user_quiz_summaries?: InputMaybe<User_Quiz_Summaries_Arr_Rel_Insert_Input>;
  user_speed_test_questions_summaries?: InputMaybe<User_Speed_Test_Questions_Summaries_Arr_Rel_Insert_Input>;
  videocipher_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quiz_Question_Max_Fields = {
  __typename?: 'quiz_question_max_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  difficulty?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Int']['output']>;
  paragraph_id?: Maybe<Scalars['Int']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  videocipher_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "quiz_question" */
export type Quiz_Question_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  difficulty?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  videocipher_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Question_Min_Fields = {
  __typename?: 'quiz_question_min_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  difficulty?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Int']['output']>;
  paragraph_id?: Maybe<Scalars['Int']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  videocipher_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "quiz_question" */
export type Quiz_Question_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  difficulty?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  videocipher_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_question" */
export type Quiz_Question_Mutation_Response = {
  __typename?: 'quiz_question_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Question>;
};

/** input type for inserting object relation for remote table "quiz_question" */
export type Quiz_Question_Obj_Rel_Insert_Input = {
  data: Quiz_Question_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Question_On_Conflict>;
};

/** on_conflict condition type for table "quiz_question" */
export type Quiz_Question_On_Conflict = {
  constraint: Quiz_Question_Constraint;
  update_columns?: Array<Quiz_Question_Update_Column>;
  where?: InputMaybe<Quiz_Question_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_question". */
export type Quiz_Question_Order_By = {
  average_time_taken?: InputMaybe<Order_By>;
  average_time_taken_for_correct_attempts?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  difficulty?: InputMaybe<Order_By>;
  has_paragraph?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  live_quiz_question_positions_aggregate?: InputMaybe<Live_Quiz_Question_Positions_Aggregate_Order_By>;
  live_quiz_question_summaries_aggregate?: InputMaybe<Live_Quiz_Question_Summary_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  number_of_attempts?: InputMaybe<Order_By>;
  number_of_correct_attempts?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  options_aggregate?: InputMaybe<Quiz_Option_Aggregate_Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  question_reports_aggregate?: InputMaybe<Question_Reports_Aggregate_Order_By>;
  question_type?: InputMaybe<Order_By>;
  quiz_answers_aggregate?: InputMaybe<Quiz_Answer_Aggregate_Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  quiz_paragraph?: InputMaybe<Quiz_Paragraph_Order_By>;
  quiz_quiz_questions_aggregate?: InputMaybe<Quiz_Quiz_Questions_Aggregate_Order_By>;
  quiz_section_questions_aggregate?: InputMaybe<Quiz_Section_Questions_Aggregate_Order_By>;
  rank?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userQuizQuestionSummariesByQuestionId_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Aggregate_Order_By>;
  user_question_summaries_aggregate?: InputMaybe<Users_Userquestionsummary_Aggregate_Order_By>;
  user_quiz_question_attempts_aggregate?: InputMaybe<User_Quiz_Question_Attempts_Aggregate_Order_By>;
  user_quiz_question_positions_aggregate?: InputMaybe<User_Quiz_Question_Positions_Aggregate_Order_By>;
  user_quiz_question_summaries_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Aggregate_Order_By>;
  user_quiz_question_summaries_old_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Old_Aggregate_Order_By>;
  user_quiz_questions_aggregate?: InputMaybe<User_Quiz_Questions_Aggregate_Order_By>;
  user_quiz_summaries_aggregate?: InputMaybe<User_Quiz_Summaries_Aggregate_Order_By>;
  user_speed_test_questions_summaries_aggregate?: InputMaybe<User_Speed_Test_Questions_Summaries_Aggregate_Order_By>;
  videocipher_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_question */
export type Quiz_Question_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_question" */
export enum Quiz_Question_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Difficulty = 'difficulty',
  /** column name */
  HasParagraph = 'has_paragraph',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OldQuestionId = 'old_question_id',
  /** column name */
  ParagraphId = 'paragraph_id',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  Rank = 'rank',
  /** column name */
  Solution = 'solution',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideocipherId = 'videocipher_id'
}

/** select "quiz_question_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quiz_question" */
export enum Quiz_Question_Select_Column_Quiz_Question_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasParagraph = 'has_paragraph'
}

/** select "quiz_question_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quiz_question" */
export enum Quiz_Question_Select_Column_Quiz_Question_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasParagraph = 'has_paragraph'
}

/** input type for updating data in table "quiz_question" */
export type Quiz_Question_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  has_paragraph?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_question_id?: InputMaybe<Scalars['Int']['input']>;
  paragraph_id?: InputMaybe<Scalars['Int']['input']>;
  question_type?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  videocipher_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Question_Stddev_Fields = {
  __typename?: 'quiz_question_stddev_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Float']['output']>;
  paragraph_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quiz_question" */
export type Quiz_Question_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Question_Stddev_Pop_Fields = {
  __typename?: 'quiz_question_stddev_pop_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Float']['output']>;
  paragraph_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_question" */
export type Quiz_Question_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Question_Stddev_Samp_Fields = {
  __typename?: 'quiz_question_stddev_samp_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Float']['output']>;
  paragraph_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_question" */
export type Quiz_Question_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_question" */
export type Quiz_Question_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Question_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Question_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  has_paragraph?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_question_id?: InputMaybe<Scalars['Int']['input']>;
  paragraph_id?: InputMaybe<Scalars['Int']['input']>;
  question_type?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  videocipher_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Question_Sum_Fields = {
  __typename?: 'quiz_question_sum_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Int']['output']>;
  paragraph_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "quiz_question" */
export type Quiz_Question_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_question" */
export enum Quiz_Question_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Difficulty = 'difficulty',
  /** column name */
  HasParagraph = 'has_paragraph',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OldQuestionId = 'old_question_id',
  /** column name */
  ParagraphId = 'paragraph_id',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  Rank = 'rank',
  /** column name */
  Solution = 'solution',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideocipherId = 'videocipher_id'
}

export type Quiz_Question_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Question_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Question_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Question_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Question_Var_Pop_Fields = {
  __typename?: 'quiz_question_var_pop_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Float']['output']>;
  paragraph_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quiz_question" */
export type Quiz_Question_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Question_Var_Samp_Fields = {
  __typename?: 'quiz_question_var_samp_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Float']['output']>;
  paragraph_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quiz_question" */
export type Quiz_Question_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Question_Variance_Fields = {
  __typename?: 'quiz_question_variance_fields';
  /** A computed field, executes function "quiz_question__average_time_taken" */
  average_time_taken?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "quiz_question__average_time_taken_for_correct_attempts" */
  average_time_taken_for_correct_attempts?: Maybe<Scalars['float8']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_question__number_of_attempts" */
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_question__number_of_correct_attempts" */
  number_of_correct_attempts?: Maybe<Scalars['Int']['output']>;
  old_question_id?: Maybe<Scalars['Float']['output']>;
  paragraph_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quiz_question" */
export type Quiz_Question_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_question_id?: InputMaybe<Order_By>;
  paragraph_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** columns and relationships of "quiz_quiz" */
export type Quiz_Quiz = {
  __typename?: 'quiz_quiz';
  allow_admins: Scalars['Boolean']['output'];
  available_on?: Maybe<Scalars['date']['output']>;
  category_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  disable_submit: Scalars['Boolean']['output'];
  draft: Scalars['Boolean']['output'];
  /** A computed field, executes function "check_accessibility_quiz_quiz" */
  has_access?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  instructions1: Scalars['String']['output'];
  instructions2: Scalars['String']['output'];
  /** A computed field, executes function "check_availability_quiz_quiz" */
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_invisible: Scalars['Boolean']['output'];
  is_live_quiz: Scalars['Boolean']['output'];
  is_premium: Scalars['Boolean']['output'];
  is_sections: Scalars['Boolean']['output'];
  is_timed: Scalars['Boolean']['output'];
  /** An array relationship */
  live_quiz_leaderboards: Array<Live_Quiz_Leaderboard>;
  /** An aggregate relationship */
  live_quiz_leaderboards_aggregate: Live_Quiz_Leaderboard_Aggregate;
  /** An array relationship */
  live_quiz_summaries: Array<Live_Quiz_Summary>;
  /** An aggregate relationship */
  live_quiz_summaries_aggregate: Live_Quiz_Summary_Aggregate;
  login_required: Scalars['Boolean']['output'];
  /** An object relationship */
  marks: Quiz_Markingsystem;
  marks_id: Scalars['Int']['output'];
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keyword?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  minimum_users: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  need_calc: Scalars['Boolean']['output'];
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Int']['output']>;
  overall_time: Scalars['Boolean']['output'];
  /** An array relationship */
  package_content_discarded_quizzes: Array<Package_Content_Discarded_Quizzes>;
  /** An aggregate relationship */
  package_content_discarded_quizzes_aggregate: Package_Content_Discarded_Quizzes_Aggregate;
  /** An array relationship */
  packages_content_timed_tests: Array<Packages_Content_Timed_Test>;
  /** An aggregate relationship */
  packages_content_timed_tests_aggregate: Packages_Content_Timed_Test_Aggregate;
  /** An array relationship */
  packages_content_untimed_tests: Array<Packages_Content_Untimed_Test>;
  /** An aggregate relationship */
  packages_content_untimed_tests_aggregate: Packages_Content_Untimed_Test_Aggregate;
  penalty: Scalars['Boolean']['output'];
  penalty_after?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  quiz_category: Quiz_Category;
  quiz_player: Scalars['String']['output'];
  /** An array relationship */
  quiz_quiz_questions: Array<Quiz_Quiz_Questions>;
  /** An aggregate relationship */
  quiz_quiz_questions_aggregate: Quiz_Quiz_Questions_Aggregate;
  /** An array relationship */
  quiz_quiz_sections: Array<Quiz_Quiz_Sections>;
  /** An aggregate relationship */
  quiz_quiz_sections_aggregate: Quiz_Quiz_Sections_Aggregate;
  rank?: Maybe<Scalars['smallint']['output']>;
  /** A computed field, executes function "should_show_percentile" */
  show_percentile?: Maybe<Scalars['Boolean']['output']>;
  single_attempt: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  time_limit?: Maybe<Scalars['interval']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_activities: Array<User_Activity>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activity_Aggregate;
  /** An array relationship */
  user_planned_activities: Array<User_Planned_Activities>;
  /** An aggregate relationship */
  user_planned_activities_aggregate: User_Planned_Activities_Aggregate;
  /** An array relationship */
  user_quiz_summaries: Array<User_Quiz_Summaries>;
  /** An aggregate relationship */
  user_quiz_summaries_aggregate: User_Quiz_Summaries_Aggregate;
  /** An array relationship */
  user_quiz_summaries_olds: Array<User_Quiz_Summaries_Old>;
  /** An aggregate relationship */
  user_quiz_summaries_olds_aggregate: User_Quiz_Summaries_Old_Aggregate;
  /** An array relationship */
  user_quiz_summary: Array<Users_Userquizsummary>;
  /** An aggregate relationship */
  user_quiz_summary_aggregate: Users_Userquizsummary_Aggregate;
  /** An array relationship */
  user_speed_tests_summaries: Array<User_Speed_Tests_Summaries>;
  /** An aggregate relationship */
  user_speed_tests_summaries_aggregate: User_Speed_Tests_Summaries_Aggregate;
  visually_impaired_time_duration?: Maybe<Scalars['interval']['output']>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizLive_Quiz_LeaderboardsArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Leaderboard_Order_By>>;
  where?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizLive_Quiz_Leaderboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Leaderboard_Order_By>>;
  where?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizLive_Quiz_SummariesArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizLive_Quiz_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Live_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Live_Quiz_Summary_Order_By>>;
  where?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizPackage_Content_Discarded_QuizzesArgs = {
  distinct_on?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Order_By>>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizPackage_Content_Discarded_Quizzes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Package_Content_Discarded_Quizzes_Order_By>>;
  where?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizPackages_Content_Timed_TestsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Timed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizPackages_Content_Timed_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Timed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Timed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizPackages_Content_Untimed_TestsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Untimed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizPackages_Content_Untimed_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Untimed_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Untimed_Test_Order_By>>;
  where?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizQuiz_Quiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizQuiz_Quiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizQuiz_Quiz_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Sections_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizQuiz_Quiz_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Sections_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Planned_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Planned_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Quiz_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Quiz_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Quiz_Summaries_OldsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Quiz_Summaries_Olds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Quiz_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquizsummary_Order_By>>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Quiz_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquizsummary_Order_By>>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Speed_Tests_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_quiz" */
export type Quiz_QuizUser_Speed_Tests_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};

/** aggregated selection of "quiz_quiz" */
export type Quiz_Quiz_Aggregate = {
  __typename?: 'quiz_quiz_aggregate';
  aggregate?: Maybe<Quiz_Quiz_Aggregate_Fields>;
  nodes: Array<Quiz_Quiz>;
};

export type Quiz_Quiz_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quiz_Quiz_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quiz_Quiz_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quiz_Quiz_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Quiz_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quiz_Quiz_Select_Column_Quiz_Quiz_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Quiz_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quiz_Quiz_Select_Column_Quiz_Quiz_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quiz_Quiz_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_quiz" */
export type Quiz_Quiz_Aggregate_Fields = {
  __typename?: 'quiz_quiz_aggregate_fields';
  avg?: Maybe<Quiz_Quiz_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Quiz_Max_Fields>;
  min?: Maybe<Quiz_Quiz_Min_Fields>;
  stddev?: Maybe<Quiz_Quiz_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Quiz_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Quiz_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Quiz_Sum_Fields>;
  var_pop?: Maybe<Quiz_Quiz_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Quiz_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Quiz_Variance_Fields>;
};


/** aggregate fields of "quiz_quiz" */
export type Quiz_Quiz_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Quiz_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_quiz" */
export type Quiz_Quiz_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Quiz_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Quiz_Max_Order_By>;
  min?: InputMaybe<Quiz_Quiz_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Quiz_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Quiz_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Quiz_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Quiz_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Quiz_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Quiz_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Quiz_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_quiz" */
export type Quiz_Quiz_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Quiz_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Quiz_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Quiz_Avg_Fields = {
  __typename?: 'quiz_quiz_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  marks_id?: Maybe<Scalars['Float']['output']>;
  minimum_users?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Float']['output']>;
  penalty_after?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
};

/** order by avg() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_quiz". All fields are combined with a logical 'AND'. */
export type Quiz_Quiz_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Quiz_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Quiz_Bool_Exp>>;
  allow_admins?: InputMaybe<Boolean_Comparison_Exp>;
  available_on?: InputMaybe<Date_Comparison_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  disable_submit?: InputMaybe<Boolean_Comparison_Exp>;
  draft?: InputMaybe<Boolean_Comparison_Exp>;
  has_access?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  instructions1?: InputMaybe<String_Comparison_Exp>;
  instructions2?: InputMaybe<String_Comparison_Exp>;
  is_hidden?: InputMaybe<Boolean_Comparison_Exp>;
  is_invisible?: InputMaybe<Boolean_Comparison_Exp>;
  is_live_quiz?: InputMaybe<Boolean_Comparison_Exp>;
  is_premium?: InputMaybe<Boolean_Comparison_Exp>;
  is_sections?: InputMaybe<Boolean_Comparison_Exp>;
  is_timed?: InputMaybe<Boolean_Comparison_Exp>;
  live_quiz_leaderboards?: InputMaybe<Live_Quiz_Leaderboard_Bool_Exp>;
  live_quiz_leaderboards_aggregate?: InputMaybe<Live_Quiz_Leaderboard_Aggregate_Bool_Exp>;
  live_quiz_summaries?: InputMaybe<Live_Quiz_Summary_Bool_Exp>;
  live_quiz_summaries_aggregate?: InputMaybe<Live_Quiz_Summary_Aggregate_Bool_Exp>;
  login_required?: InputMaybe<Boolean_Comparison_Exp>;
  marks?: InputMaybe<Quiz_Markingsystem_Bool_Exp>;
  marks_id?: InputMaybe<Int_Comparison_Exp>;
  meta_description?: InputMaybe<String_Comparison_Exp>;
  meta_keyword?: InputMaybe<String_Comparison_Exp>;
  meta_title?: InputMaybe<String_Comparison_Exp>;
  minimum_users?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  need_calc?: InputMaybe<Boolean_Comparison_Exp>;
  number_of_completed_questions?: InputMaybe<Bigint_Comparison_Exp>;
  old_quiz_id?: InputMaybe<Int_Comparison_Exp>;
  overall_time?: InputMaybe<Boolean_Comparison_Exp>;
  package_content_discarded_quizzes?: InputMaybe<Package_Content_Discarded_Quizzes_Bool_Exp>;
  package_content_discarded_quizzes_aggregate?: InputMaybe<Package_Content_Discarded_Quizzes_Aggregate_Bool_Exp>;
  packages_content_timed_tests?: InputMaybe<Packages_Content_Timed_Test_Bool_Exp>;
  packages_content_timed_tests_aggregate?: InputMaybe<Packages_Content_Timed_Test_Aggregate_Bool_Exp>;
  packages_content_untimed_tests?: InputMaybe<Packages_Content_Untimed_Test_Bool_Exp>;
  packages_content_untimed_tests_aggregate?: InputMaybe<Packages_Content_Untimed_Test_Aggregate_Bool_Exp>;
  penalty?: InputMaybe<Boolean_Comparison_Exp>;
  penalty_after?: InputMaybe<Int_Comparison_Exp>;
  percentile?: InputMaybe<Float8_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  quiz_player?: InputMaybe<String_Comparison_Exp>;
  quiz_quiz_questions?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
  quiz_quiz_questions_aggregate?: InputMaybe<Quiz_Quiz_Questions_Aggregate_Bool_Exp>;
  quiz_quiz_sections?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
  quiz_quiz_sections_aggregate?: InputMaybe<Quiz_Quiz_Sections_Aggregate_Bool_Exp>;
  rank?: InputMaybe<Smallint_Comparison_Exp>;
  show_percentile?: InputMaybe<Boolean_Comparison_Exp>;
  single_attempt?: InputMaybe<Boolean_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  time_limit?: InputMaybe<Interval_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  total_number_of_questions?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_activities?: InputMaybe<User_Activity_Bool_Exp>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Bool_Exp>;
  user_planned_activities?: InputMaybe<User_Planned_Activities_Bool_Exp>;
  user_planned_activities_aggregate?: InputMaybe<User_Planned_Activities_Aggregate_Bool_Exp>;
  user_quiz_summaries?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  user_quiz_summaries_aggregate?: InputMaybe<User_Quiz_Summaries_Aggregate_Bool_Exp>;
  user_quiz_summaries_olds?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
  user_quiz_summaries_olds_aggregate?: InputMaybe<User_Quiz_Summaries_Old_Aggregate_Bool_Exp>;
  user_quiz_summary?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
  user_quiz_summary_aggregate?: InputMaybe<Users_Userquizsummary_Aggregate_Bool_Exp>;
  user_speed_tests_summaries?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
  user_speed_tests_summaries_aggregate?: InputMaybe<User_Speed_Tests_Summaries_Aggregate_Bool_Exp>;
  visually_impaired_time_duration?: InputMaybe<Interval_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_quiz" */
export enum Quiz_Quiz_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizQuizPkey = 'quiz_quiz_pkey',
  /** unique or primary key constraint on columns "slug" */
  QuizQuizSlugKey = 'quiz_quiz_slug_key'
}

/** input type for incrementing numeric columns in table "quiz_quiz" */
export type Quiz_Quiz_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  marks_id?: InputMaybe<Scalars['Int']['input']>;
  minimum_users?: InputMaybe<Scalars['Int']['input']>;
  old_quiz_id?: InputMaybe<Scalars['Int']['input']>;
  penalty_after?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "quiz_quiz" */
export type Quiz_Quiz_Insert_Input = {
  allow_admins?: InputMaybe<Scalars['Boolean']['input']>;
  available_on?: InputMaybe<Scalars['date']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disable_submit?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instructions1?: InputMaybe<Scalars['String']['input']>;
  instructions2?: InputMaybe<Scalars['String']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  is_live_quiz?: InputMaybe<Scalars['Boolean']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  is_sections?: InputMaybe<Scalars['Boolean']['input']>;
  is_timed?: InputMaybe<Scalars['Boolean']['input']>;
  live_quiz_leaderboards?: InputMaybe<Live_Quiz_Leaderboard_Arr_Rel_Insert_Input>;
  live_quiz_summaries?: InputMaybe<Live_Quiz_Summary_Arr_Rel_Insert_Input>;
  login_required?: InputMaybe<Scalars['Boolean']['input']>;
  marks?: InputMaybe<Quiz_Markingsystem_Obj_Rel_Insert_Input>;
  marks_id?: InputMaybe<Scalars['Int']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_keyword?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  minimum_users?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  need_calc?: InputMaybe<Scalars['Boolean']['input']>;
  old_quiz_id?: InputMaybe<Scalars['Int']['input']>;
  overall_time?: InputMaybe<Scalars['Boolean']['input']>;
  package_content_discarded_quizzes?: InputMaybe<Package_Content_Discarded_Quizzes_Arr_Rel_Insert_Input>;
  packages_content_timed_tests?: InputMaybe<Packages_Content_Timed_Test_Arr_Rel_Insert_Input>;
  packages_content_untimed_tests?: InputMaybe<Packages_Content_Untimed_Test_Arr_Rel_Insert_Input>;
  penalty?: InputMaybe<Scalars['Boolean']['input']>;
  penalty_after?: InputMaybe<Scalars['Int']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  quiz_player?: InputMaybe<Scalars['String']['input']>;
  quiz_quiz_questions?: InputMaybe<Quiz_Quiz_Questions_Arr_Rel_Insert_Input>;
  quiz_quiz_sections?: InputMaybe<Quiz_Quiz_Sections_Arr_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  single_attempt?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  time_limit?: InputMaybe<Scalars['interval']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_activities?: InputMaybe<User_Activity_Arr_Rel_Insert_Input>;
  user_planned_activities?: InputMaybe<User_Planned_Activities_Arr_Rel_Insert_Input>;
  user_quiz_summaries?: InputMaybe<User_Quiz_Summaries_Arr_Rel_Insert_Input>;
  user_quiz_summaries_olds?: InputMaybe<User_Quiz_Summaries_Old_Arr_Rel_Insert_Input>;
  user_quiz_summary?: InputMaybe<Users_Userquizsummary_Arr_Rel_Insert_Input>;
  user_speed_tests_summaries?: InputMaybe<User_Speed_Tests_Summaries_Arr_Rel_Insert_Input>;
  visually_impaired_time_duration?: InputMaybe<Scalars['interval']['input']>;
};

/** aggregate max on columns */
export type Quiz_Quiz_Max_Fields = {
  __typename?: 'quiz_quiz_max_fields';
  available_on?: Maybe<Scalars['date']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  instructions1?: Maybe<Scalars['String']['output']>;
  instructions2?: Maybe<Scalars['String']['output']>;
  marks_id?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keyword?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  minimum_users?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Int']['output']>;
  penalty_after?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  quiz_player?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Max_Order_By = {
  available_on?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions1?: InputMaybe<Order_By>;
  instructions2?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  meta_description?: InputMaybe<Order_By>;
  meta_keyword?: InputMaybe<Order_By>;
  meta_title?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  quiz_player?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Quiz_Min_Fields = {
  __typename?: 'quiz_quiz_min_fields';
  available_on?: Maybe<Scalars['date']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  instructions1?: Maybe<Scalars['String']['output']>;
  instructions2?: Maybe<Scalars['String']['output']>;
  marks_id?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keyword?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  minimum_users?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Int']['output']>;
  penalty_after?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  quiz_player?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Min_Order_By = {
  available_on?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions1?: InputMaybe<Order_By>;
  instructions2?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  meta_description?: InputMaybe<Order_By>;
  meta_keyword?: InputMaybe<Order_By>;
  meta_title?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  quiz_player?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_quiz" */
export type Quiz_Quiz_Mutation_Response = {
  __typename?: 'quiz_quiz_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Quiz>;
};

/** input type for inserting object relation for remote table "quiz_quiz" */
export type Quiz_Quiz_Obj_Rel_Insert_Input = {
  data: Quiz_Quiz_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Quiz_On_Conflict>;
};

/** on_conflict condition type for table "quiz_quiz" */
export type Quiz_Quiz_On_Conflict = {
  constraint: Quiz_Quiz_Constraint;
  update_columns?: Array<Quiz_Quiz_Update_Column>;
  where?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_quiz". */
export type Quiz_Quiz_Order_By = {
  allow_admins?: InputMaybe<Order_By>;
  available_on?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disable_submit?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  has_access?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions1?: InputMaybe<Order_By>;
  instructions2?: InputMaybe<Order_By>;
  is_hidden?: InputMaybe<Order_By>;
  is_invisible?: InputMaybe<Order_By>;
  is_live_quiz?: InputMaybe<Order_By>;
  is_premium?: InputMaybe<Order_By>;
  is_sections?: InputMaybe<Order_By>;
  is_timed?: InputMaybe<Order_By>;
  live_quiz_leaderboards_aggregate?: InputMaybe<Live_Quiz_Leaderboard_Aggregate_Order_By>;
  live_quiz_summaries_aggregate?: InputMaybe<Live_Quiz_Summary_Aggregate_Order_By>;
  login_required?: InputMaybe<Order_By>;
  marks?: InputMaybe<Quiz_Markingsystem_Order_By>;
  marks_id?: InputMaybe<Order_By>;
  meta_description?: InputMaybe<Order_By>;
  meta_keyword?: InputMaybe<Order_By>;
  meta_title?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  need_calc?: InputMaybe<Order_By>;
  number_of_completed_questions?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  overall_time?: InputMaybe<Order_By>;
  package_content_discarded_quizzes_aggregate?: InputMaybe<Package_Content_Discarded_Quizzes_Aggregate_Order_By>;
  packages_content_timed_tests_aggregate?: InputMaybe<Packages_Content_Timed_Test_Aggregate_Order_By>;
  packages_content_untimed_tests_aggregate?: InputMaybe<Packages_Content_Untimed_Test_Aggregate_Order_By>;
  penalty?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  quiz_player?: InputMaybe<Order_By>;
  quiz_quiz_questions_aggregate?: InputMaybe<Quiz_Quiz_Questions_Aggregate_Order_By>;
  quiz_quiz_sections_aggregate?: InputMaybe<Quiz_Quiz_Sections_Aggregate_Order_By>;
  rank?: InputMaybe<Order_By>;
  show_percentile?: InputMaybe<Order_By>;
  single_attempt?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_number_of_questions?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Order_By>;
  user_planned_activities_aggregate?: InputMaybe<User_Planned_Activities_Aggregate_Order_By>;
  user_quiz_summaries_aggregate?: InputMaybe<User_Quiz_Summaries_Aggregate_Order_By>;
  user_quiz_summaries_olds_aggregate?: InputMaybe<User_Quiz_Summaries_Old_Aggregate_Order_By>;
  user_quiz_summary_aggregate?: InputMaybe<Users_Userquizsummary_Aggregate_Order_By>;
  user_speed_tests_summaries_aggregate?: InputMaybe<User_Speed_Tests_Summaries_Aggregate_Order_By>;
  visually_impaired_time_duration?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_quiz */
export type Quiz_Quiz_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** columns and relationships of "quiz_quiz_questions" */
export type Quiz_Quiz_Questions = {
  __typename?: 'quiz_quiz_questions';
  id: Scalars['Int']['output'];
  question_id: Scalars['Int']['output'];
  quiz_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  /** An object relationship */
  quiz_quiz: Quiz_Quiz;
};

/** aggregated selection of "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Aggregate = {
  __typename?: 'quiz_quiz_questions_aggregate';
  aggregate?: Maybe<Quiz_Quiz_Questions_Aggregate_Fields>;
  nodes: Array<Quiz_Quiz_Questions>;
};

export type Quiz_Quiz_Questions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quiz_Quiz_Questions_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Quiz_Questions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Aggregate_Fields = {
  __typename?: 'quiz_quiz_questions_aggregate_fields';
  avg?: Maybe<Quiz_Quiz_Questions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Quiz_Questions_Max_Fields>;
  min?: Maybe<Quiz_Quiz_Questions_Min_Fields>;
  stddev?: Maybe<Quiz_Quiz_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Quiz_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Quiz_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Quiz_Questions_Sum_Fields>;
  var_pop?: Maybe<Quiz_Quiz_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Quiz_Questions_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Quiz_Questions_Variance_Fields>;
};


/** aggregate fields of "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Quiz_Questions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Quiz_Questions_Max_Order_By>;
  min?: InputMaybe<Quiz_Quiz_Questions_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Quiz_Questions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Quiz_Questions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Quiz_Questions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Quiz_Questions_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Quiz_Questions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Quiz_Questions_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Quiz_Questions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Quiz_Questions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Quiz_Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Quiz_Questions_Avg_Fields = {
  __typename?: 'quiz_quiz_questions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_quiz_questions". All fields are combined with a logical 'AND'. */
export type Quiz_Quiz_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Quiz_Questions_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Quiz_Questions_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
};

/** unique or primary key constraints on table "quiz_quiz_questions" */
export enum Quiz_Quiz_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizQuizQuestionsPkey = 'quiz_quiz_questions_pkey',
  /** unique or primary key constraint on columns "quiz_id", "question_id" */
  QuizQuizQuestionsQuizIdQuestionId_4adfc7ecUniq = 'quiz_quiz_questions_quiz_id_question_id_4adfc7ec_uniq'
}

/** input type for incrementing numeric columns in table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Quiz_Quiz_Questions_Max_Fields = {
  __typename?: 'quiz_quiz_questions_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Quiz_Questions_Min_Fields = {
  __typename?: 'quiz_quiz_questions_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Mutation_Response = {
  __typename?: 'quiz_quiz_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Quiz_Questions>;
};

/** on_conflict condition type for table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_On_Conflict = {
  constraint: Quiz_Quiz_Questions_Constraint;
  update_columns?: Array<Quiz_Quiz_Questions_Update_Column>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_quiz_questions". */
export type Quiz_Quiz_Questions_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
};

/** primary key columns input for table: quiz_quiz_questions */
export type Quiz_Quiz_Questions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_quiz_questions" */
export enum Quiz_Quiz_Questions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuizId = 'quiz_id'
}

/** input type for updating data in table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Quiz_Questions_Stddev_Fields = {
  __typename?: 'quiz_quiz_questions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Quiz_Questions_Stddev_Pop_Fields = {
  __typename?: 'quiz_quiz_questions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Quiz_Questions_Stddev_Samp_Fields = {
  __typename?: 'quiz_quiz_questions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Quiz_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Quiz_Questions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Quiz_Questions_Sum_Fields = {
  __typename?: 'quiz_quiz_questions_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_quiz_questions" */
export enum Quiz_Quiz_Questions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuizId = 'quiz_id'
}

export type Quiz_Quiz_Questions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Quiz_Questions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Quiz_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Quiz_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Quiz_Questions_Var_Pop_Fields = {
  __typename?: 'quiz_quiz_questions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Quiz_Questions_Var_Samp_Fields = {
  __typename?: 'quiz_quiz_questions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Quiz_Questions_Variance_Fields = {
  __typename?: 'quiz_quiz_questions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quiz_quiz_questions" */
export type Quiz_Quiz_Questions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "quiz_quiz_sections" */
export type Quiz_Quiz_Sections = {
  __typename?: 'quiz_quiz_sections';
  id: Scalars['Int']['output'];
  quiz_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_quiz: Quiz_Quiz;
  /** An object relationship */
  quiz_section: Quiz_Section;
  section_id: Scalars['Int']['output'];
};

/** aggregated selection of "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Aggregate = {
  __typename?: 'quiz_quiz_sections_aggregate';
  aggregate?: Maybe<Quiz_Quiz_Sections_Aggregate_Fields>;
  nodes: Array<Quiz_Quiz_Sections>;
};

export type Quiz_Quiz_Sections_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quiz_Quiz_Sections_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Quiz_Sections_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Aggregate_Fields = {
  __typename?: 'quiz_quiz_sections_aggregate_fields';
  avg?: Maybe<Quiz_Quiz_Sections_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Quiz_Sections_Max_Fields>;
  min?: Maybe<Quiz_Quiz_Sections_Min_Fields>;
  stddev?: Maybe<Quiz_Quiz_Sections_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Quiz_Sections_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Quiz_Sections_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Quiz_Sections_Sum_Fields>;
  var_pop?: Maybe<Quiz_Quiz_Sections_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Quiz_Sections_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Quiz_Sections_Variance_Fields>;
};


/** aggregate fields of "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Quiz_Sections_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Quiz_Sections_Max_Order_By>;
  min?: InputMaybe<Quiz_Quiz_Sections_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Quiz_Sections_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Quiz_Sections_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Quiz_Sections_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Quiz_Sections_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Quiz_Sections_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Quiz_Sections_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Quiz_Sections_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Quiz_Sections_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Quiz_Sections_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Quiz_Sections_Avg_Fields = {
  __typename?: 'quiz_quiz_sections_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_quiz_sections". All fields are combined with a logical 'AND'. */
export type Quiz_Quiz_Sections_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Quiz_Sections_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Quiz_Sections_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  section_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_quiz_sections" */
export enum Quiz_Quiz_Sections_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizQuizSectionsPkey = 'quiz_quiz_sections_pkey',
  /** unique or primary key constraint on columns "quiz_id", "section_id" */
  QuizQuizSectionsQuizIdSectionId_6737a2dbUniq = 'quiz_quiz_sections_quiz_id_section_id_6737a2db_uniq'
}

/** input type for incrementing numeric columns in table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Quiz_Quiz_Sections_Max_Fields = {
  __typename?: 'quiz_quiz_sections_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Quiz_Sections_Min_Fields = {
  __typename?: 'quiz_quiz_sections_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Mutation_Response = {
  __typename?: 'quiz_quiz_sections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Quiz_Sections>;
};

/** on_conflict condition type for table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_On_Conflict = {
  constraint: Quiz_Quiz_Sections_Constraint;
  update_columns?: Array<Quiz_Quiz_Sections_Update_Column>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_quiz_sections". */
export type Quiz_Quiz_Sections_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_quiz_sections */
export type Quiz_Quiz_Sections_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_quiz_sections" */
export enum Quiz_Quiz_Sections_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  SectionId = 'section_id'
}

/** input type for updating data in table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Quiz_Sections_Stddev_Fields = {
  __typename?: 'quiz_quiz_sections_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Quiz_Sections_Stddev_Pop_Fields = {
  __typename?: 'quiz_quiz_sections_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Quiz_Sections_Stddev_Samp_Fields = {
  __typename?: 'quiz_quiz_sections_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Quiz_Sections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Quiz_Sections_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Quiz_Sections_Sum_Fields = {
  __typename?: 'quiz_quiz_sections_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_quiz_sections" */
export enum Quiz_Quiz_Sections_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  SectionId = 'section_id'
}

export type Quiz_Quiz_Sections_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Quiz_Sections_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Quiz_Sections_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Quiz_Sections_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Quiz_Sections_Var_Pop_Fields = {
  __typename?: 'quiz_quiz_sections_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Quiz_Sections_Var_Samp_Fields = {
  __typename?: 'quiz_quiz_sections_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Quiz_Sections_Variance_Fields = {
  __typename?: 'quiz_quiz_sections_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quiz_quiz_sections" */
export type Quiz_Quiz_Sections_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** select columns of table "quiz_quiz" */
export enum Quiz_Quiz_Select_Column {
  /** column name */
  AllowAdmins = 'allow_admins',
  /** column name */
  AvailableOn = 'available_on',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisableSubmit = 'disable_submit',
  /** column name */
  Draft = 'draft',
  /** column name */
  Id = 'id',
  /** column name */
  Instructions1 = 'instructions1',
  /** column name */
  Instructions2 = 'instructions2',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  IsLiveQuiz = 'is_live_quiz',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  IsSections = 'is_sections',
  /** column name */
  IsTimed = 'is_timed',
  /** column name */
  LoginRequired = 'login_required',
  /** column name */
  MarksId = 'marks_id',
  /** column name */
  MetaDescription = 'meta_description',
  /** column name */
  MetaKeyword = 'meta_keyword',
  /** column name */
  MetaTitle = 'meta_title',
  /** column name */
  MinimumUsers = 'minimum_users',
  /** column name */
  Name = 'name',
  /** column name */
  NeedCalc = 'need_calc',
  /** column name */
  OldQuizId = 'old_quiz_id',
  /** column name */
  OverallTime = 'overall_time',
  /** column name */
  Penalty = 'penalty',
  /** column name */
  PenaltyAfter = 'penalty_after',
  /** column name */
  QuizPlayer = 'quiz_player',
  /** column name */
  Rank = 'rank',
  /** column name */
  SingleAttempt = 'single_attempt',
  /** column name */
  Slug = 'slug',
  /** column name */
  TimeLimit = 'time_limit',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisuallyImpairedTimeDuration = 'visually_impaired_time_duration'
}

/** select "quiz_quiz_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quiz_quiz" */
export enum Quiz_Quiz_Select_Column_Quiz_Quiz_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowAdmins = 'allow_admins',
  /** column name */
  DisableSubmit = 'disable_submit',
  /** column name */
  Draft = 'draft',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  IsLiveQuiz = 'is_live_quiz',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  IsSections = 'is_sections',
  /** column name */
  IsTimed = 'is_timed',
  /** column name */
  LoginRequired = 'login_required',
  /** column name */
  NeedCalc = 'need_calc',
  /** column name */
  OverallTime = 'overall_time',
  /** column name */
  Penalty = 'penalty',
  /** column name */
  SingleAttempt = 'single_attempt'
}

/** select "quiz_quiz_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quiz_quiz" */
export enum Quiz_Quiz_Select_Column_Quiz_Quiz_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowAdmins = 'allow_admins',
  /** column name */
  DisableSubmit = 'disable_submit',
  /** column name */
  Draft = 'draft',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  IsLiveQuiz = 'is_live_quiz',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  IsSections = 'is_sections',
  /** column name */
  IsTimed = 'is_timed',
  /** column name */
  LoginRequired = 'login_required',
  /** column name */
  NeedCalc = 'need_calc',
  /** column name */
  OverallTime = 'overall_time',
  /** column name */
  Penalty = 'penalty',
  /** column name */
  SingleAttempt = 'single_attempt'
}

/** input type for updating data in table "quiz_quiz" */
export type Quiz_Quiz_Set_Input = {
  allow_admins?: InputMaybe<Scalars['Boolean']['input']>;
  available_on?: InputMaybe<Scalars['date']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disable_submit?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instructions1?: InputMaybe<Scalars['String']['input']>;
  instructions2?: InputMaybe<Scalars['String']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  is_live_quiz?: InputMaybe<Scalars['Boolean']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  is_sections?: InputMaybe<Scalars['Boolean']['input']>;
  is_timed?: InputMaybe<Scalars['Boolean']['input']>;
  login_required?: InputMaybe<Scalars['Boolean']['input']>;
  marks_id?: InputMaybe<Scalars['Int']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_keyword?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  minimum_users?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  need_calc?: InputMaybe<Scalars['Boolean']['input']>;
  old_quiz_id?: InputMaybe<Scalars['Int']['input']>;
  overall_time?: InputMaybe<Scalars['Boolean']['input']>;
  penalty?: InputMaybe<Scalars['Boolean']['input']>;
  penalty_after?: InputMaybe<Scalars['Int']['input']>;
  quiz_player?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  single_attempt?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  time_limit?: InputMaybe<Scalars['interval']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visually_impaired_time_duration?: InputMaybe<Scalars['interval']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Quiz_Stddev_Fields = {
  __typename?: 'quiz_quiz_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  marks_id?: Maybe<Scalars['Float']['output']>;
  minimum_users?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Float']['output']>;
  penalty_after?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
};

/** order by stddev() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Quiz_Stddev_Pop_Fields = {
  __typename?: 'quiz_quiz_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  marks_id?: Maybe<Scalars['Float']['output']>;
  minimum_users?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Float']['output']>;
  penalty_after?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Quiz_Stddev_Samp_Fields = {
  __typename?: 'quiz_quiz_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  marks_id?: Maybe<Scalars['Float']['output']>;
  minimum_users?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Float']['output']>;
  penalty_after?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_quiz" */
export type Quiz_Quiz_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Quiz_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Quiz_Stream_Cursor_Value_Input = {
  allow_admins?: InputMaybe<Scalars['Boolean']['input']>;
  available_on?: InputMaybe<Scalars['date']['input']>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disable_submit?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instructions1?: InputMaybe<Scalars['String']['input']>;
  instructions2?: InputMaybe<Scalars['String']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  is_live_quiz?: InputMaybe<Scalars['Boolean']['input']>;
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  is_sections?: InputMaybe<Scalars['Boolean']['input']>;
  is_timed?: InputMaybe<Scalars['Boolean']['input']>;
  login_required?: InputMaybe<Scalars['Boolean']['input']>;
  marks_id?: InputMaybe<Scalars['Int']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_keyword?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  minimum_users?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  need_calc?: InputMaybe<Scalars['Boolean']['input']>;
  old_quiz_id?: InputMaybe<Scalars['Int']['input']>;
  overall_time?: InputMaybe<Scalars['Boolean']['input']>;
  penalty?: InputMaybe<Scalars['Boolean']['input']>;
  penalty_after?: InputMaybe<Scalars['Int']['input']>;
  quiz_player?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  single_attempt?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  time_limit?: InputMaybe<Scalars['interval']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visually_impaired_time_duration?: InputMaybe<Scalars['interval']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Quiz_Sum_Fields = {
  __typename?: 'quiz_quiz_sum_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  marks_id?: Maybe<Scalars['Int']['output']>;
  minimum_users?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Int']['output']>;
  penalty_after?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_quiz" */
export enum Quiz_Quiz_Update_Column {
  /** column name */
  AllowAdmins = 'allow_admins',
  /** column name */
  AvailableOn = 'available_on',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisableSubmit = 'disable_submit',
  /** column name */
  Draft = 'draft',
  /** column name */
  Id = 'id',
  /** column name */
  Instructions1 = 'instructions1',
  /** column name */
  Instructions2 = 'instructions2',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  IsLiveQuiz = 'is_live_quiz',
  /** column name */
  IsPremium = 'is_premium',
  /** column name */
  IsSections = 'is_sections',
  /** column name */
  IsTimed = 'is_timed',
  /** column name */
  LoginRequired = 'login_required',
  /** column name */
  MarksId = 'marks_id',
  /** column name */
  MetaDescription = 'meta_description',
  /** column name */
  MetaKeyword = 'meta_keyword',
  /** column name */
  MetaTitle = 'meta_title',
  /** column name */
  MinimumUsers = 'minimum_users',
  /** column name */
  Name = 'name',
  /** column name */
  NeedCalc = 'need_calc',
  /** column name */
  OldQuizId = 'old_quiz_id',
  /** column name */
  OverallTime = 'overall_time',
  /** column name */
  Penalty = 'penalty',
  /** column name */
  PenaltyAfter = 'penalty_after',
  /** column name */
  QuizPlayer = 'quiz_player',
  /** column name */
  Rank = 'rank',
  /** column name */
  SingleAttempt = 'single_attempt',
  /** column name */
  Slug = 'slug',
  /** column name */
  TimeLimit = 'time_limit',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisuallyImpairedTimeDuration = 'visually_impaired_time_duration'
}

export type Quiz_Quiz_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Quiz_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Quiz_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Quiz_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Quiz_Var_Pop_Fields = {
  __typename?: 'quiz_quiz_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  marks_id?: Maybe<Scalars['Float']['output']>;
  minimum_users?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Float']['output']>;
  penalty_after?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
};

/** order by var_pop() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Quiz_Var_Samp_Fields = {
  __typename?: 'quiz_quiz_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  marks_id?: Maybe<Scalars['Float']['output']>;
  minimum_users?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Float']['output']>;
  penalty_after?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
};

/** order by var_samp() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Quiz_Variance_Fields = {
  __typename?: 'quiz_quiz_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  marks_id?: Maybe<Scalars['Float']['output']>;
  minimum_users?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz_number_of_completed_questions" */
  number_of_completed_questions?: Maybe<Scalars['bigint']['output']>;
  old_quiz_id?: Maybe<Scalars['Float']['output']>;
  penalty_after?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "quiz_quiz__user_percentile" */
  percentile?: Maybe<Scalars['float8']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "total_number_of_questions_in_quiz" */
  total_number_of_questions?: Maybe<Scalars['bigint']['output']>;
};

/** order by variance() on columns of table "quiz_quiz" */
export type Quiz_Quiz_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_id?: InputMaybe<Order_By>;
  minimum_users?: InputMaybe<Order_By>;
  old_quiz_id?: InputMaybe<Order_By>;
  penalty_after?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** columns and relationships of "quiz_section" */
export type Quiz_Section = {
  __typename?: 'quiz_section';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  has_subsections: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_subsection: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  old_section_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  quiz_quiz_sections: Array<Quiz_Quiz_Sections>;
  /** An aggregate relationship */
  quiz_quiz_sections_aggregate: Quiz_Quiz_Sections_Aggregate;
  /** An array relationship */
  quiz_section_questions: Array<Quiz_Section_Questions>;
  /** An aggregate relationship */
  quiz_section_questions_aggregate: Quiz_Section_Questions_Aggregate;
  /** An array relationship */
  quiz_section_subsections: Array<Quiz_Section_Subsections>;
  /** An aggregate relationship */
  quiz_section_subsections_aggregate: Quiz_Section_Subsections_Aggregate;
  rank?: Maybe<Scalars['smallint']['output']>;
  short_name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sub_sections: Array<Quiz_Section_Subsections>;
  /** An aggregate relationship */
  sub_sections_aggregate: Quiz_Section_Subsections_Aggregate;
  time_duration: Scalars['interval']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_quiz_question_summaries: Array<User_Quiz_Question_Summaries_Old>;
  /** An aggregate relationship */
  user_quiz_question_summaries_aggregate: User_Quiz_Question_Summaries_Old_Aggregate;
  /** An array relationship */
  user_quiz_section_summaries: Array<User_Quiz_Section_Summaries>;
  /** An aggregate relationship */
  user_quiz_section_summaries_aggregate: User_Quiz_Section_Summaries_Aggregate;
  /** An array relationship */
  user_quiz_summaries: Array<User_Quiz_Summaries>;
  /** An aggregate relationship */
  user_quiz_summaries_aggregate: User_Quiz_Summaries_Aggregate;
  /** An array relationship */
  user_section_summaries: Array<User_Section_Summaries>;
  /** An aggregate relationship */
  user_section_summaries_aggregate: User_Section_Summaries_Aggregate;
  /** An array relationship */
  user_timed_quiz_summaries: Array<User_Timed_Quiz_Summary>;
  /** An aggregate relationship */
  user_timed_quiz_summaries_aggregate: User_Timed_Quiz_Summary_Aggregate;
  /** An array relationship */
  users_userquestionsummaries: Array<Users_Userquestionsummary>;
  /** An aggregate relationship */
  users_userquestionsummaries_aggregate: Users_Userquestionsummary_Aggregate;
  /** An array relationship */
  users_userquiztimesummaries: Array<Users_Userquiztimesummary>;
  /** An aggregate relationship */
  users_userquiztimesummaries_aggregate: Users_Userquiztimesummary_Aggregate;
  /** An array relationship */
  users_usersectionsummaries: Array<Users_Usersectionsummary>;
  /** An aggregate relationship */
  users_usersectionsummaries_aggregate: Users_Usersectionsummary_Aggregate;
  visually_impaired_time_duration?: Maybe<Scalars['interval']['output']>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionQuiz_Quiz_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Sections_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionQuiz_Quiz_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Sections_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionQuiz_Section_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionQuiz_Section_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionQuiz_Section_SubsectionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Subsections_Order_By>>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionQuiz_Section_Subsections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Subsections_Order_By>>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionSub_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Subsections_Order_By>>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionSub_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Section_Subsections_Order_By>>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Quiz_Question_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Quiz_Question_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Quiz_Section_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Quiz_Section_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Quiz_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Quiz_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Section_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Section_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Timed_Quiz_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Timed_Quiz_Summary_Order_By>>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUser_Timed_Quiz_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Timed_Quiz_Summary_Order_By>>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUsers_UserquestionsummariesArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUsers_Userquestionsummaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUsers_UserquiztimesummariesArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquiztimesummary_Order_By>>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUsers_Userquiztimesummaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquiztimesummary_Order_By>>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUsers_UsersectionsummariesArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};


/** columns and relationships of "quiz_section" */
export type Quiz_SectionUsers_Usersectionsummaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};

/** aggregated selection of "quiz_section" */
export type Quiz_Section_Aggregate = {
  __typename?: 'quiz_section_aggregate';
  aggregate?: Maybe<Quiz_Section_Aggregate_Fields>;
  nodes: Array<Quiz_Section>;
};

/** aggregate fields of "quiz_section" */
export type Quiz_Section_Aggregate_Fields = {
  __typename?: 'quiz_section_aggregate_fields';
  avg?: Maybe<Quiz_Section_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Section_Max_Fields>;
  min?: Maybe<Quiz_Section_Min_Fields>;
  stddev?: Maybe<Quiz_Section_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Section_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Section_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Section_Sum_Fields>;
  var_pop?: Maybe<Quiz_Section_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Section_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Section_Variance_Fields>;
};


/** aggregate fields of "quiz_section" */
export type Quiz_Section_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Section_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quiz_Section_Avg_Fields = {
  __typename?: 'quiz_section_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_section_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quiz_section". All fields are combined with a logical 'AND'. */
export type Quiz_Section_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Section_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Section_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Section_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  has_subsections?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_subsection?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  old_section_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz_sections?: InputMaybe<Quiz_Quiz_Sections_Bool_Exp>;
  quiz_quiz_sections_aggregate?: InputMaybe<Quiz_Quiz_Sections_Aggregate_Bool_Exp>;
  quiz_section_questions?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
  quiz_section_questions_aggregate?: InputMaybe<Quiz_Section_Questions_Aggregate_Bool_Exp>;
  quiz_section_subsections?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
  quiz_section_subsections_aggregate?: InputMaybe<Quiz_Section_Subsections_Aggregate_Bool_Exp>;
  rank?: InputMaybe<Smallint_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  sub_sections?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
  sub_sections_aggregate?: InputMaybe<Quiz_Section_Subsections_Aggregate_Bool_Exp>;
  time_duration?: InputMaybe<Interval_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_quiz_question_summaries?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
  user_quiz_question_summaries_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp>;
  user_quiz_section_summaries?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
  user_quiz_section_summaries_aggregate?: InputMaybe<User_Quiz_Section_Summaries_Aggregate_Bool_Exp>;
  user_quiz_summaries?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  user_quiz_summaries_aggregate?: InputMaybe<User_Quiz_Summaries_Aggregate_Bool_Exp>;
  user_section_summaries?: InputMaybe<User_Section_Summaries_Bool_Exp>;
  user_section_summaries_aggregate?: InputMaybe<User_Section_Summaries_Aggregate_Bool_Exp>;
  user_timed_quiz_summaries?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
  user_timed_quiz_summaries_aggregate?: InputMaybe<User_Timed_Quiz_Summary_Aggregate_Bool_Exp>;
  users_userquestionsummaries?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
  users_userquestionsummaries_aggregate?: InputMaybe<Users_Userquestionsummary_Aggregate_Bool_Exp>;
  users_userquiztimesummaries?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
  users_userquiztimesummaries_aggregate?: InputMaybe<Users_Userquiztimesummary_Aggregate_Bool_Exp>;
  users_usersectionsummaries?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
  users_usersectionsummaries_aggregate?: InputMaybe<Users_Usersectionsummary_Aggregate_Bool_Exp>;
  visually_impaired_time_duration?: InputMaybe<Interval_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_section" */
export enum Quiz_Section_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizSectionPkey = 'quiz_section_pkey',
  /** unique or primary key constraint on columns "slug" */
  QuizSectionSlugKey = 'quiz_section_slug_key'
}

/** input type for incrementing numeric columns in table "quiz_section" */
export type Quiz_Section_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  old_section_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "quiz_section" */
export type Quiz_Section_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_subsections?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_subsection?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_section_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz_sections?: InputMaybe<Quiz_Quiz_Sections_Arr_Rel_Insert_Input>;
  quiz_section_questions?: InputMaybe<Quiz_Section_Questions_Arr_Rel_Insert_Input>;
  quiz_section_subsections?: InputMaybe<Quiz_Section_Subsections_Arr_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sub_sections?: InputMaybe<Quiz_Section_Subsections_Arr_Rel_Insert_Input>;
  time_duration?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_question_summaries?: InputMaybe<User_Quiz_Question_Summaries_Old_Arr_Rel_Insert_Input>;
  user_quiz_section_summaries?: InputMaybe<User_Quiz_Section_Summaries_Arr_Rel_Insert_Input>;
  user_quiz_summaries?: InputMaybe<User_Quiz_Summaries_Arr_Rel_Insert_Input>;
  user_section_summaries?: InputMaybe<User_Section_Summaries_Arr_Rel_Insert_Input>;
  user_timed_quiz_summaries?: InputMaybe<User_Timed_Quiz_Summary_Arr_Rel_Insert_Input>;
  users_userquestionsummaries?: InputMaybe<Users_Userquestionsummary_Arr_Rel_Insert_Input>;
  users_userquiztimesummaries?: InputMaybe<Users_Userquiztimesummary_Arr_Rel_Insert_Input>;
  users_usersectionsummaries?: InputMaybe<Users_Usersectionsummary_Arr_Rel_Insert_Input>;
  visually_impaired_time_duration?: InputMaybe<Scalars['interval']['input']>;
};

/** aggregate max on columns */
export type Quiz_Section_Max_Fields = {
  __typename?: 'quiz_section_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  old_section_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quiz_Section_Min_Fields = {
  __typename?: 'quiz_section_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  old_section_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quiz_section" */
export type Quiz_Section_Mutation_Response = {
  __typename?: 'quiz_section_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Section>;
};

/** input type for inserting object relation for remote table "quiz_section" */
export type Quiz_Section_Obj_Rel_Insert_Input = {
  data: Quiz_Section_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Section_On_Conflict>;
};

/** on_conflict condition type for table "quiz_section" */
export type Quiz_Section_On_Conflict = {
  constraint: Quiz_Section_Constraint;
  update_columns?: Array<Quiz_Section_Update_Column>;
  where?: InputMaybe<Quiz_Section_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_section". */
export type Quiz_Section_Order_By = {
  created_at?: InputMaybe<Order_By>;
  has_subsections?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_subsection?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_section_id?: InputMaybe<Order_By>;
  quiz_quiz_sections_aggregate?: InputMaybe<Quiz_Quiz_Sections_Aggregate_Order_By>;
  quiz_section_questions_aggregate?: InputMaybe<Quiz_Section_Questions_Aggregate_Order_By>;
  quiz_section_subsections_aggregate?: InputMaybe<Quiz_Section_Subsections_Aggregate_Order_By>;
  rank?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  sub_sections_aggregate?: InputMaybe<Quiz_Section_Subsections_Aggregate_Order_By>;
  time_duration?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_question_summaries_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Old_Aggregate_Order_By>;
  user_quiz_section_summaries_aggregate?: InputMaybe<User_Quiz_Section_Summaries_Aggregate_Order_By>;
  user_quiz_summaries_aggregate?: InputMaybe<User_Quiz_Summaries_Aggregate_Order_By>;
  user_section_summaries_aggregate?: InputMaybe<User_Section_Summaries_Aggregate_Order_By>;
  user_timed_quiz_summaries_aggregate?: InputMaybe<User_Timed_Quiz_Summary_Aggregate_Order_By>;
  users_userquestionsummaries_aggregate?: InputMaybe<Users_Userquestionsummary_Aggregate_Order_By>;
  users_userquiztimesummaries_aggregate?: InputMaybe<Users_Userquiztimesummary_Aggregate_Order_By>;
  users_usersectionsummaries_aggregate?: InputMaybe<Users_Usersectionsummary_Aggregate_Order_By>;
  visually_impaired_time_duration?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_section */
export type Quiz_Section_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** columns and relationships of "quiz_section_questions" */
export type Quiz_Section_Questions = {
  __typename?: 'quiz_section_questions';
  id: Scalars['Int']['output'];
  question_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  /** An object relationship */
  quiz_section: Quiz_Section;
  section_id: Scalars['Int']['output'];
};

/** aggregated selection of "quiz_section_questions" */
export type Quiz_Section_Questions_Aggregate = {
  __typename?: 'quiz_section_questions_aggregate';
  aggregate?: Maybe<Quiz_Section_Questions_Aggregate_Fields>;
  nodes: Array<Quiz_Section_Questions>;
};

export type Quiz_Section_Questions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quiz_Section_Questions_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Section_Questions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_section_questions" */
export type Quiz_Section_Questions_Aggregate_Fields = {
  __typename?: 'quiz_section_questions_aggregate_fields';
  avg?: Maybe<Quiz_Section_Questions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Section_Questions_Max_Fields>;
  min?: Maybe<Quiz_Section_Questions_Min_Fields>;
  stddev?: Maybe<Quiz_Section_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Section_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Section_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Section_Questions_Sum_Fields>;
  var_pop?: Maybe<Quiz_Section_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Section_Questions_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Section_Questions_Variance_Fields>;
};


/** aggregate fields of "quiz_section_questions" */
export type Quiz_Section_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Section_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_section_questions" */
export type Quiz_Section_Questions_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Section_Questions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Section_Questions_Max_Order_By>;
  min?: InputMaybe<Quiz_Section_Questions_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Section_Questions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Section_Questions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Section_Questions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Section_Questions_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Section_Questions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Section_Questions_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Section_Questions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_section_questions" */
export type Quiz_Section_Questions_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Section_Questions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Section_Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Section_Questions_Avg_Fields = {
  __typename?: 'quiz_section_questions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_section_questions". All fields are combined with a logical 'AND'. */
export type Quiz_Section_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Section_Questions_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Section_Questions_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  section_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_section_questions" */
export enum Quiz_Section_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizSectionQuestionsPkey = 'quiz_section_questions_pkey',
  /** unique or primary key constraint on columns "question_id", "section_id" */
  QuizSectionQuestionsSectionIdQuestionIdC6cbc5f5Uniq = 'quiz_section_questions_section_id_question_id_c6cbc5f5_uniq'
}

/** input type for incrementing numeric columns in table "quiz_section_questions" */
export type Quiz_Section_Questions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_section_questions" */
export type Quiz_Section_Questions_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Quiz_Section_Questions_Max_Fields = {
  __typename?: 'quiz_section_questions_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Section_Questions_Min_Fields = {
  __typename?: 'quiz_section_questions_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_section_questions" */
export type Quiz_Section_Questions_Mutation_Response = {
  __typename?: 'quiz_section_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Section_Questions>;
};

/** on_conflict condition type for table "quiz_section_questions" */
export type Quiz_Section_Questions_On_Conflict = {
  constraint: Quiz_Section_Questions_Constraint;
  update_columns?: Array<Quiz_Section_Questions_Update_Column>;
  where?: InputMaybe<Quiz_Section_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_section_questions". */
export type Quiz_Section_Questions_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_section_questions */
export type Quiz_Section_Questions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_section_questions" */
export enum Quiz_Section_Questions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  SectionId = 'section_id'
}

/** input type for updating data in table "quiz_section_questions" */
export type Quiz_Section_Questions_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Section_Questions_Stddev_Fields = {
  __typename?: 'quiz_section_questions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Section_Questions_Stddev_Pop_Fields = {
  __typename?: 'quiz_section_questions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Section_Questions_Stddev_Samp_Fields = {
  __typename?: 'quiz_section_questions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_section_questions" */
export type Quiz_Section_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Section_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Section_Questions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Section_Questions_Sum_Fields = {
  __typename?: 'quiz_section_questions_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_section_questions" */
export enum Quiz_Section_Questions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  SectionId = 'section_id'
}

export type Quiz_Section_Questions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Section_Questions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Section_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Section_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Section_Questions_Var_Pop_Fields = {
  __typename?: 'quiz_section_questions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Section_Questions_Var_Samp_Fields = {
  __typename?: 'quiz_section_questions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Section_Questions_Variance_Fields = {
  __typename?: 'quiz_section_questions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quiz_section_questions" */
export type Quiz_Section_Questions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** select columns of table "quiz_section" */
export enum Quiz_Section_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasSubsections = 'has_subsections',
  /** column name */
  Id = 'id',
  /** column name */
  IsSubsection = 'is_subsection',
  /** column name */
  Name = 'name',
  /** column name */
  OldSectionId = 'old_section_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Slug = 'slug',
  /** column name */
  TimeDuration = 'time_duration',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisuallyImpairedTimeDuration = 'visually_impaired_time_duration'
}

/** input type for updating data in table "quiz_section" */
export type Quiz_Section_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_subsections?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_subsection?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_section_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  time_duration?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visually_impaired_time_duration?: InputMaybe<Scalars['interval']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Section_Stddev_Fields = {
  __typename?: 'quiz_section_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_section_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Section_Stddev_Pop_Fields = {
  __typename?: 'quiz_section_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_section_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Section_Stddev_Samp_Fields = {
  __typename?: 'quiz_section_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_section_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quiz_section" */
export type Quiz_Section_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Section_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Section_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_subsections?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_subsection?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_section_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['smallint']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  time_duration?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visually_impaired_time_duration?: InputMaybe<Scalars['interval']['input']>;
};

/** columns and relationships of "quiz_section_subsections" */
export type Quiz_Section_Subsections = {
  __typename?: 'quiz_section_subsections';
  from_section_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  quizSectionByToSectionId: Quiz_Section;
  /** An object relationship */
  quiz_section: Quiz_Section;
  to_section_id: Scalars['Int']['output'];
};

/** aggregated selection of "quiz_section_subsections" */
export type Quiz_Section_Subsections_Aggregate = {
  __typename?: 'quiz_section_subsections_aggregate';
  aggregate?: Maybe<Quiz_Section_Subsections_Aggregate_Fields>;
  nodes: Array<Quiz_Section_Subsections>;
};

export type Quiz_Section_Subsections_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quiz_Section_Subsections_Aggregate_Bool_Exp_Count>;
};

export type Quiz_Section_Subsections_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quiz_section_subsections" */
export type Quiz_Section_Subsections_Aggregate_Fields = {
  __typename?: 'quiz_section_subsections_aggregate_fields';
  avg?: Maybe<Quiz_Section_Subsections_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Section_Subsections_Max_Fields>;
  min?: Maybe<Quiz_Section_Subsections_Min_Fields>;
  stddev?: Maybe<Quiz_Section_Subsections_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Section_Subsections_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Section_Subsections_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Section_Subsections_Sum_Fields>;
  var_pop?: Maybe<Quiz_Section_Subsections_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Section_Subsections_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Section_Subsections_Variance_Fields>;
};


/** aggregate fields of "quiz_section_subsections" */
export type Quiz_Section_Subsections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Section_Subsections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Aggregate_Order_By = {
  avg?: InputMaybe<Quiz_Section_Subsections_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quiz_Section_Subsections_Max_Order_By>;
  min?: InputMaybe<Quiz_Section_Subsections_Min_Order_By>;
  stddev?: InputMaybe<Quiz_Section_Subsections_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quiz_Section_Subsections_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quiz_Section_Subsections_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quiz_Section_Subsections_Sum_Order_By>;
  var_pop?: InputMaybe<Quiz_Section_Subsections_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quiz_Section_Subsections_Var_Samp_Order_By>;
  variance?: InputMaybe<Quiz_Section_Subsections_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Arr_Rel_Insert_Input = {
  data: Array<Quiz_Section_Subsections_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Section_Subsections_On_Conflict>;
};

/** aggregate avg on columns */
export type Quiz_Section_Subsections_Avg_Fields = {
  __typename?: 'quiz_section_subsections_avg_fields';
  from_section_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Avg_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quiz_section_subsections". All fields are combined with a logical 'AND'. */
export type Quiz_Section_Subsections_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Section_Subsections_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Section_Subsections_Bool_Exp>>;
  from_section_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  quizSectionByToSectionId?: InputMaybe<Quiz_Section_Bool_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  to_section_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_section_subsections" */
export enum Quiz_Section_Subsections_Constraint {
  /** unique or primary key constraint on columns "from_section_id", "to_section_id" */
  QuizSectionSubsectionsFromSectionIdToSecti_25449345Uniq = 'quiz_section_subsections_from_section_id_to_secti_25449345_uniq',
  /** unique or primary key constraint on columns "id" */
  QuizSectionSubsectionsPkey = 'quiz_section_subsections_pkey'
}

/** input type for incrementing numeric columns in table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Inc_Input = {
  from_section_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  to_section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Insert_Input = {
  from_section_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quizSectionByToSectionId?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  to_section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Quiz_Section_Subsections_Max_Fields = {
  __typename?: 'quiz_section_subsections_max_fields';
  from_section_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  to_section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Max_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quiz_Section_Subsections_Min_Fields = {
  __typename?: 'quiz_section_subsections_min_fields';
  from_section_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  to_section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Min_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Mutation_Response = {
  __typename?: 'quiz_section_subsections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Section_Subsections>;
};

/** on_conflict condition type for table "quiz_section_subsections" */
export type Quiz_Section_Subsections_On_Conflict = {
  constraint: Quiz_Section_Subsections_Constraint;
  update_columns?: Array<Quiz_Section_Subsections_Update_Column>;
  where?: InputMaybe<Quiz_Section_Subsections_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_section_subsections". */
export type Quiz_Section_Subsections_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quizSectionByToSectionId?: InputMaybe<Quiz_Section_Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_section_subsections */
export type Quiz_Section_Subsections_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_section_subsections" */
export enum Quiz_Section_Subsections_Select_Column {
  /** column name */
  FromSectionId = 'from_section_id',
  /** column name */
  Id = 'id',
  /** column name */
  ToSectionId = 'to_section_id'
}

/** input type for updating data in table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Set_Input = {
  from_section_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  to_section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Section_Subsections_Stddev_Fields = {
  __typename?: 'quiz_section_subsections_stddev_fields';
  from_section_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Stddev_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Section_Subsections_Stddev_Pop_Fields = {
  __typename?: 'quiz_section_subsections_stddev_pop_fields';
  from_section_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Stddev_Pop_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Section_Subsections_Stddev_Samp_Fields = {
  __typename?: 'quiz_section_subsections_stddev_samp_fields';
  from_section_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Stddev_Samp_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Section_Subsections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Section_Subsections_Stream_Cursor_Value_Input = {
  from_section_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  to_section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Section_Subsections_Sum_Fields = {
  __typename?: 'quiz_section_subsections_sum_fields';
  from_section_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  to_section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Sum_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** update columns of table "quiz_section_subsections" */
export enum Quiz_Section_Subsections_Update_Column {
  /** column name */
  FromSectionId = 'from_section_id',
  /** column name */
  Id = 'id',
  /** column name */
  ToSectionId = 'to_section_id'
}

export type Quiz_Section_Subsections_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Section_Subsections_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Section_Subsections_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Section_Subsections_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Section_Subsections_Var_Pop_Fields = {
  __typename?: 'quiz_section_subsections_var_pop_fields';
  from_section_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Var_Pop_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quiz_Section_Subsections_Var_Samp_Fields = {
  __typename?: 'quiz_section_subsections_var_samp_fields';
  from_section_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Var_Samp_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quiz_Section_Subsections_Variance_Fields = {
  __typename?: 'quiz_section_subsections_variance_fields';
  from_section_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quiz_section_subsections" */
export type Quiz_Section_Subsections_Variance_Order_By = {
  from_section_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_section_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Quiz_Section_Sum_Fields = {
  __typename?: 'quiz_section_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  old_section_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "quiz_section" */
export enum Quiz_Section_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasSubsections = 'has_subsections',
  /** column name */
  Id = 'id',
  /** column name */
  IsSubsection = 'is_subsection',
  /** column name */
  Name = 'name',
  /** column name */
  OldSectionId = 'old_section_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Slug = 'slug',
  /** column name */
  TimeDuration = 'time_duration',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisuallyImpairedTimeDuration = 'visually_impaired_time_duration'
}

export type Quiz_Section_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Section_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Section_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Section_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Section_Var_Pop_Fields = {
  __typename?: 'quiz_section_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_section_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quiz_Section_Var_Samp_Fields = {
  __typename?: 'quiz_section_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_section_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quiz_Section_Variance_Fields = {
  __typename?: 'quiz_section_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_section_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "quiz_superdomain" */
export type Quiz_Superdomain = {
  __typename?: 'quiz_superdomain';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  do_not_include_in_planner?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  invisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  packages_contents: Array<Packages_Content>;
  /** An aggregate relationship */
  packages_contents_aggregate: Packages_Content_Aggregate;
  /** An array relationship */
  quiz_domains: Array<Quiz_Domain>;
  /** An aggregate relationship */
  quiz_domains_aggregate: Quiz_Domain_Aggregate;
  rank?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "quiz_superdomain" */
export type Quiz_SuperdomainPackages_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Order_By>>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};


/** columns and relationships of "quiz_superdomain" */
export type Quiz_SuperdomainPackages_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Order_By>>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};


/** columns and relationships of "quiz_superdomain" */
export type Quiz_SuperdomainQuiz_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Domain_Order_By>>;
  where?: InputMaybe<Quiz_Domain_Bool_Exp>;
};


/** columns and relationships of "quiz_superdomain" */
export type Quiz_SuperdomainQuiz_Domains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Domain_Order_By>>;
  where?: InputMaybe<Quiz_Domain_Bool_Exp>;
};

/** aggregated selection of "quiz_superdomain" */
export type Quiz_Superdomain_Aggregate = {
  __typename?: 'quiz_superdomain_aggregate';
  aggregate?: Maybe<Quiz_Superdomain_Aggregate_Fields>;
  nodes: Array<Quiz_Superdomain>;
};

/** aggregate fields of "quiz_superdomain" */
export type Quiz_Superdomain_Aggregate_Fields = {
  __typename?: 'quiz_superdomain_aggregate_fields';
  avg?: Maybe<Quiz_Superdomain_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quiz_Superdomain_Max_Fields>;
  min?: Maybe<Quiz_Superdomain_Min_Fields>;
  stddev?: Maybe<Quiz_Superdomain_Stddev_Fields>;
  stddev_pop?: Maybe<Quiz_Superdomain_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quiz_Superdomain_Stddev_Samp_Fields>;
  sum?: Maybe<Quiz_Superdomain_Sum_Fields>;
  var_pop?: Maybe<Quiz_Superdomain_Var_Pop_Fields>;
  var_samp?: Maybe<Quiz_Superdomain_Var_Samp_Fields>;
  variance?: Maybe<Quiz_Superdomain_Variance_Fields>;
};


/** aggregate fields of "quiz_superdomain" */
export type Quiz_Superdomain_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quiz_Superdomain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quiz_Superdomain_Avg_Fields = {
  __typename?: 'quiz_superdomain_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quiz_superdomain". All fields are combined with a logical 'AND'. */
export type Quiz_Superdomain_Bool_Exp = {
  _and?: InputMaybe<Array<Quiz_Superdomain_Bool_Exp>>;
  _not?: InputMaybe<Quiz_Superdomain_Bool_Exp>;
  _or?: InputMaybe<Array<Quiz_Superdomain_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  do_not_include_in_planner?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invisible?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  packages_contents?: InputMaybe<Packages_Content_Bool_Exp>;
  packages_contents_aggregate?: InputMaybe<Packages_Content_Aggregate_Bool_Exp>;
  quiz_domains?: InputMaybe<Quiz_Domain_Bool_Exp>;
  quiz_domains_aggregate?: InputMaybe<Quiz_Domain_Aggregate_Bool_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quiz_superdomain" */
export enum Quiz_Superdomain_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuizSuperdomainPkey = 'quiz_superdomain_pkey',
  /** unique or primary key constraint on columns "rank" */
  QuizSuperdomainRankKey = 'quiz_superdomain_rank_key',
  /** unique or primary key constraint on columns "slug" */
  QuizSuperdomainSlugKey = 'quiz_superdomain_slug_key'
}

/** input type for incrementing numeric columns in table "quiz_superdomain" */
export type Quiz_Superdomain_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quiz_superdomain" */
export type Quiz_Superdomain_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_include_in_planner?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  packages_contents?: InputMaybe<Packages_Content_Arr_Rel_Insert_Input>;
  quiz_domains?: InputMaybe<Quiz_Domain_Arr_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quiz_Superdomain_Max_Fields = {
  __typename?: 'quiz_superdomain_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quiz_Superdomain_Min_Fields = {
  __typename?: 'quiz_superdomain_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quiz_superdomain" */
export type Quiz_Superdomain_Mutation_Response = {
  __typename?: 'quiz_superdomain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quiz_Superdomain>;
};

/** input type for inserting object relation for remote table "quiz_superdomain" */
export type Quiz_Superdomain_Obj_Rel_Insert_Input = {
  data: Quiz_Superdomain_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quiz_Superdomain_On_Conflict>;
};

/** on_conflict condition type for table "quiz_superdomain" */
export type Quiz_Superdomain_On_Conflict = {
  constraint: Quiz_Superdomain_Constraint;
  update_columns?: Array<Quiz_Superdomain_Update_Column>;
  where?: InputMaybe<Quiz_Superdomain_Bool_Exp>;
};

/** Ordering options when selecting data from "quiz_superdomain". */
export type Quiz_Superdomain_Order_By = {
  created_at?: InputMaybe<Order_By>;
  do_not_include_in_planner?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invisible?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  packages_contents_aggregate?: InputMaybe<Packages_Content_Aggregate_Order_By>;
  quiz_domains_aggregate?: InputMaybe<Quiz_Domain_Aggregate_Order_By>;
  rank?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quiz_superdomain */
export type Quiz_Superdomain_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "quiz_superdomain" */
export enum Quiz_Superdomain_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  Id = 'id',
  /** column name */
  Invisible = 'invisible',
  /** column name */
  Name = 'name',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "quiz_superdomain" */
export type Quiz_Superdomain_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_include_in_planner?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quiz_Superdomain_Stddev_Fields = {
  __typename?: 'quiz_superdomain_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quiz_Superdomain_Stddev_Pop_Fields = {
  __typename?: 'quiz_superdomain_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quiz_Superdomain_Stddev_Samp_Fields = {
  __typename?: 'quiz_superdomain_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quiz_superdomain" */
export type Quiz_Superdomain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quiz_Superdomain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quiz_Superdomain_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  do_not_include_in_planner?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quiz_Superdomain_Sum_Fields = {
  __typename?: 'quiz_superdomain_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "quiz_superdomain" */
export enum Quiz_Superdomain_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoNotIncludeInPlanner = 'do_not_include_in_planner',
  /** column name */
  Id = 'id',
  /** column name */
  Invisible = 'invisible',
  /** column name */
  Name = 'name',
  /** column name */
  Rank = 'rank',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quiz_Superdomain_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quiz_Superdomain_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quiz_Superdomain_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quiz_Superdomain_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quiz_Superdomain_Var_Pop_Fields = {
  __typename?: 'quiz_superdomain_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quiz_Superdomain_Var_Samp_Fields = {
  __typename?: 'quiz_superdomain_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quiz_Superdomain_Variance_Fields = {
  __typename?: 'quiz_superdomain_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "random_question_ids" */
export type Random_Question_Ids = {
  __typename?: 'random_question_ids';
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "random_question_ids" */
export type Random_Question_Ids_Aggregate = {
  __typename?: 'random_question_ids_aggregate';
  aggregate?: Maybe<Random_Question_Ids_Aggregate_Fields>;
  nodes: Array<Random_Question_Ids>;
};

/** aggregate fields of "random_question_ids" */
export type Random_Question_Ids_Aggregate_Fields = {
  __typename?: 'random_question_ids_aggregate_fields';
  avg?: Maybe<Random_Question_Ids_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Random_Question_Ids_Max_Fields>;
  min?: Maybe<Random_Question_Ids_Min_Fields>;
  stddev?: Maybe<Random_Question_Ids_Stddev_Fields>;
  stddev_pop?: Maybe<Random_Question_Ids_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Random_Question_Ids_Stddev_Samp_Fields>;
  sum?: Maybe<Random_Question_Ids_Sum_Fields>;
  var_pop?: Maybe<Random_Question_Ids_Var_Pop_Fields>;
  var_samp?: Maybe<Random_Question_Ids_Var_Samp_Fields>;
  variance?: Maybe<Random_Question_Ids_Variance_Fields>;
};


/** aggregate fields of "random_question_ids" */
export type Random_Question_Ids_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Random_Question_Ids_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Random_Question_Ids_Avg_Fields = {
  __typename?: 'random_question_ids_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "random_question_ids". All fields are combined with a logical 'AND'. */
export type Random_Question_Ids_Bool_Exp = {
  _and?: InputMaybe<Array<Random_Question_Ids_Bool_Exp>>;
  _not?: InputMaybe<Random_Question_Ids_Bool_Exp>;
  _or?: InputMaybe<Array<Random_Question_Ids_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "random_question_ids" */
export type Random_Question_Ids_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "random_question_ids" */
export type Random_Question_Ids_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Random_Question_Ids_Max_Fields = {
  __typename?: 'random_question_ids_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Random_Question_Ids_Min_Fields = {
  __typename?: 'random_question_ids_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "random_question_ids" */
export type Random_Question_Ids_Mutation_Response = {
  __typename?: 'random_question_ids_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Random_Question_Ids>;
};

/** Ordering options when selecting data from "random_question_ids". */
export type Random_Question_Ids_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** select columns of table "random_question_ids" */
export enum Random_Question_Ids_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "random_question_ids" */
export type Random_Question_Ids_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Random_Question_Ids_Stddev_Fields = {
  __typename?: 'random_question_ids_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Random_Question_Ids_Stddev_Pop_Fields = {
  __typename?: 'random_question_ids_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Random_Question_Ids_Stddev_Samp_Fields = {
  __typename?: 'random_question_ids_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "random_question_ids" */
export type Random_Question_Ids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Random_Question_Ids_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Random_Question_Ids_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Random_Question_Ids_Sum_Fields = {
  __typename?: 'random_question_ids_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

export type Random_Question_Ids_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Random_Question_Ids_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Random_Question_Ids_Set_Input>;
  /** filter the rows which have to be updated */
  where: Random_Question_Ids_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Random_Question_Ids_Var_Pop_Fields = {
  __typename?: 'random_question_ids_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Random_Question_Ids_Var_Samp_Fields = {
  __typename?: 'random_question_ids_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Random_Question_Ids_Variance_Fields = {
  __typename?: 'random_question_ids_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "reaction_emojis" */
export type Reaction_Emojis = {
  __typename?: 'reaction_emojis';
  created_at: Scalars['timestamptz']['output'];
  emoji: Scalars['String']['output'];
  emoji_url: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "reaction_emojis" */
export type Reaction_Emojis_Aggregate = {
  __typename?: 'reaction_emojis_aggregate';
  aggregate?: Maybe<Reaction_Emojis_Aggregate_Fields>;
  nodes: Array<Reaction_Emojis>;
};

/** aggregate fields of "reaction_emojis" */
export type Reaction_Emojis_Aggregate_Fields = {
  __typename?: 'reaction_emojis_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Reaction_Emojis_Max_Fields>;
  min?: Maybe<Reaction_Emojis_Min_Fields>;
};


/** aggregate fields of "reaction_emojis" */
export type Reaction_Emojis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reaction_Emojis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "reaction_emojis". All fields are combined with a logical 'AND'. */
export type Reaction_Emojis_Bool_Exp = {
  _and?: InputMaybe<Array<Reaction_Emojis_Bool_Exp>>;
  _not?: InputMaybe<Reaction_Emojis_Bool_Exp>;
  _or?: InputMaybe<Array<Reaction_Emojis_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  emoji?: InputMaybe<String_Comparison_Exp>;
  emoji_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "reaction_emojis" */
export enum Reaction_Emojis_Constraint {
  /** unique or primary key constraint on columns "emoji" */
  ReactionEmojisEmojiKey = 'reaction_emojis_emoji_key',
  /** unique or primary key constraint on columns "id" */
  ReactionEmojisPkey = 'reaction_emojis_pkey'
}

/** input type for inserting data into table "reaction_emojis" */
export type Reaction_Emojis_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  emoji_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Reaction_Emojis_Max_Fields = {
  __typename?: 'reaction_emojis_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  emoji_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Reaction_Emojis_Min_Fields = {
  __typename?: 'reaction_emojis_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  emoji_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "reaction_emojis" */
export type Reaction_Emojis_Mutation_Response = {
  __typename?: 'reaction_emojis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reaction_Emojis>;
};

/** on_conflict condition type for table "reaction_emojis" */
export type Reaction_Emojis_On_Conflict = {
  constraint: Reaction_Emojis_Constraint;
  update_columns?: Array<Reaction_Emojis_Update_Column>;
  where?: InputMaybe<Reaction_Emojis_Bool_Exp>;
};

/** Ordering options when selecting data from "reaction_emojis". */
export type Reaction_Emojis_Order_By = {
  created_at?: InputMaybe<Order_By>;
  emoji?: InputMaybe<Order_By>;
  emoji_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reaction_emojis */
export type Reaction_Emojis_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reaction_emojis" */
export enum Reaction_Emojis_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Emoji = 'emoji',
  /** column name */
  EmojiUrl = 'emoji_url',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "reaction_emojis" */
export type Reaction_Emojis_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  emoji_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "reaction_emojis" */
export type Reaction_Emojis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reaction_Emojis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reaction_Emojis_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  emoji_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "reaction_emojis" */
export enum Reaction_Emojis_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Emoji = 'emoji',
  /** column name */
  EmojiUrl = 'emoji_url',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Reaction_Emojis_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reaction_Emojis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reaction_Emojis_Bool_Exp;
};

/** columns and relationships of "reported_message" */
export type Reported_Message = {
  __typename?: 'reported_message';
  /** An object relationship */
  channel: Channels;
  channel_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid']['output'];
  reason: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Supertokens_User_Additional_Fields>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregated selection of "reported_message" */
export type Reported_Message_Aggregate = {
  __typename?: 'reported_message_aggregate';
  aggregate?: Maybe<Reported_Message_Aggregate_Fields>;
  nodes: Array<Reported_Message>;
};

export type Reported_Message_Aggregate_Bool_Exp = {
  count?: InputMaybe<Reported_Message_Aggregate_Bool_Exp_Count>;
};

export type Reported_Message_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reported_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reported_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reported_message" */
export type Reported_Message_Aggregate_Fields = {
  __typename?: 'reported_message_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Reported_Message_Max_Fields>;
  min?: Maybe<Reported_Message_Min_Fields>;
};


/** aggregate fields of "reported_message" */
export type Reported_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reported_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reported_message" */
export type Reported_Message_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reported_Message_Max_Order_By>;
  min?: InputMaybe<Reported_Message_Min_Order_By>;
};

/** input type for inserting array relation for remote table "reported_message" */
export type Reported_Message_Arr_Rel_Insert_Input = {
  data: Array<Reported_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reported_Message_On_Conflict>;
};

/** Boolean expression to filter rows from the table "reported_message". All fields are combined with a logical 'AND'. */
export type Reported_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Reported_Message_Bool_Exp>>;
  _not?: InputMaybe<Reported_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Reported_Message_Bool_Exp>>;
  channel?: InputMaybe<Channels_Bool_Exp>;
  channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<Messages_Bool_Exp>;
  message_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "reported_message" */
export enum Reported_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReportedMessagePkey = 'reported_message_pkey'
}

/** input type for inserting data into table "reported_message" */
export type Reported_Message_Insert_Input = {
  channel?: InputMaybe<Channels_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Messages_Obj_Rel_Insert_Input>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Reported_Message_Max_Fields = {
  __typename?: 'reported_message_max_fields';
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "reported_message" */
export type Reported_Message_Max_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reported_Message_Min_Fields = {
  __typename?: 'reported_message_min_fields';
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "reported_message" */
export type Reported_Message_Min_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reported_message" */
export type Reported_Message_Mutation_Response = {
  __typename?: 'reported_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reported_Message>;
};

/** on_conflict condition type for table "reported_message" */
export type Reported_Message_On_Conflict = {
  constraint: Reported_Message_Constraint;
  update_columns?: Array<Reported_Message_Update_Column>;
  where?: InputMaybe<Reported_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "reported_message". */
export type Reported_Message_Order_By = {
  channel?: InputMaybe<Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Messages_Order_By>;
  message_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reported_message */
export type Reported_Message_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reported_message" */
export enum Reported_Message_Select_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "reported_message" */
export type Reported_Message_Set_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "reported_message" */
export type Reported_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reported_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reported_Message_Stream_Cursor_Value_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "reported_message" */
export enum Reported_Message_Update_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Reported_Message_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reported_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reported_Message_Bool_Exp;
};

/** columns and relationships of "scaling_constant" */
export type Scaling_Constant = {
  __typename?: 'scaling_constant';
  c: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  m: Scalars['numeric']['output'];
  shift: Scalars['numeric']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "scaling_constant" */
export type Scaling_Constant_Aggregate = {
  __typename?: 'scaling_constant_aggregate';
  aggregate?: Maybe<Scaling_Constant_Aggregate_Fields>;
  nodes: Array<Scaling_Constant>;
};

/** aggregate fields of "scaling_constant" */
export type Scaling_Constant_Aggregate_Fields = {
  __typename?: 'scaling_constant_aggregate_fields';
  avg?: Maybe<Scaling_Constant_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scaling_Constant_Max_Fields>;
  min?: Maybe<Scaling_Constant_Min_Fields>;
  stddev?: Maybe<Scaling_Constant_Stddev_Fields>;
  stddev_pop?: Maybe<Scaling_Constant_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scaling_Constant_Stddev_Samp_Fields>;
  sum?: Maybe<Scaling_Constant_Sum_Fields>;
  var_pop?: Maybe<Scaling_Constant_Var_Pop_Fields>;
  var_samp?: Maybe<Scaling_Constant_Var_Samp_Fields>;
  variance?: Maybe<Scaling_Constant_Variance_Fields>;
};


/** aggregate fields of "scaling_constant" */
export type Scaling_Constant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scaling_Constant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Scaling_Constant_Avg_Fields = {
  __typename?: 'scaling_constant_avg_fields';
  c?: Maybe<Scalars['Float']['output']>;
  m?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "scaling_constant". All fields are combined with a logical 'AND'. */
export type Scaling_Constant_Bool_Exp = {
  _and?: InputMaybe<Array<Scaling_Constant_Bool_Exp>>;
  _not?: InputMaybe<Scaling_Constant_Bool_Exp>;
  _or?: InputMaybe<Array<Scaling_Constant_Bool_Exp>>;
  c?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  m?: InputMaybe<Numeric_Comparison_Exp>;
  shift?: InputMaybe<Numeric_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "scaling_constant" */
export enum Scaling_Constant_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScalingConstantPkey = 'scaling_constant_pkey'
}

/** input type for incrementing numeric columns in table "scaling_constant" */
export type Scaling_Constant_Inc_Input = {
  c?: InputMaybe<Scalars['numeric']['input']>;
  m?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "scaling_constant" */
export type Scaling_Constant_Insert_Input = {
  c?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  m?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['numeric']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scaling_Constant_Max_Fields = {
  __typename?: 'scaling_constant_max_fields';
  c?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  m?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['numeric']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Scaling_Constant_Min_Fields = {
  __typename?: 'scaling_constant_min_fields';
  c?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  m?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['numeric']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "scaling_constant" */
export type Scaling_Constant_Mutation_Response = {
  __typename?: 'scaling_constant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scaling_Constant>;
};

/** on_conflict condition type for table "scaling_constant" */
export type Scaling_Constant_On_Conflict = {
  constraint: Scaling_Constant_Constraint;
  update_columns?: Array<Scaling_Constant_Update_Column>;
  where?: InputMaybe<Scaling_Constant_Bool_Exp>;
};

/** Ordering options when selecting data from "scaling_constant". */
export type Scaling_Constant_Order_By = {
  c?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m?: InputMaybe<Order_By>;
  shift?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scaling_constant */
export type Scaling_Constant_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "scaling_constant" */
export enum Scaling_Constant_Select_Column {
  /** column name */
  C = 'c',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  M = 'm',
  /** column name */
  Shift = 'shift',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "scaling_constant" */
export type Scaling_Constant_Set_Input = {
  c?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  m?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['numeric']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Scaling_Constant_Stddev_Fields = {
  __typename?: 'scaling_constant_stddev_fields';
  c?: Maybe<Scalars['Float']['output']>;
  m?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Scaling_Constant_Stddev_Pop_Fields = {
  __typename?: 'scaling_constant_stddev_pop_fields';
  c?: Maybe<Scalars['Float']['output']>;
  m?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Scaling_Constant_Stddev_Samp_Fields = {
  __typename?: 'scaling_constant_stddev_samp_fields';
  c?: Maybe<Scalars['Float']['output']>;
  m?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "scaling_constant" */
export type Scaling_Constant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scaling_Constant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scaling_Constant_Stream_Cursor_Value_Input = {
  c?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  m?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['numeric']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Scaling_Constant_Sum_Fields = {
  __typename?: 'scaling_constant_sum_fields';
  c?: Maybe<Scalars['numeric']['output']>;
  m?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "scaling_constant" */
export enum Scaling_Constant_Update_Column {
  /** column name */
  C = 'c',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  M = 'm',
  /** column name */
  Shift = 'shift',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Scaling_Constant_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scaling_Constant_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scaling_Constant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scaling_Constant_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Scaling_Constant_Var_Pop_Fields = {
  __typename?: 'scaling_constant_var_pop_fields';
  c?: Maybe<Scalars['Float']['output']>;
  m?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Scaling_Constant_Var_Samp_Fields = {
  __typename?: 'scaling_constant_var_samp_fields';
  c?: Maybe<Scalars['Float']['output']>;
  m?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Scaling_Constant_Variance_Fields = {
  __typename?: 'scaling_constant_variance_fields';
  c?: Maybe<Scalars['Float']['output']>;
  m?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

/** columns and relationships of "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount = {
  __typename?: 'socialaccount_socialaccount';
  date_joined: Scalars['timestamptz']['output'];
  extra_data: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_login: Scalars['timestamptz']['output'];
  provider: Scalars['String']['output'];
  /** An array relationship */
  socialaccount_socialtokens: Array<Socialaccount_Socialtoken>;
  /** An aggregate relationship */
  socialaccount_socialtokens_aggregate: Socialaccount_Socialtoken_Aggregate;
  uid: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};


/** columns and relationships of "socialaccount_socialaccount" */
export type Socialaccount_SocialaccountSocialaccount_SocialtokensArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialtoken_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};


/** columns and relationships of "socialaccount_socialaccount" */
export type Socialaccount_SocialaccountSocialaccount_Socialtokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialtoken_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};

/** aggregated selection of "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Aggregate = {
  __typename?: 'socialaccount_socialaccount_aggregate';
  aggregate?: Maybe<Socialaccount_Socialaccount_Aggregate_Fields>;
  nodes: Array<Socialaccount_Socialaccount>;
};

export type Socialaccount_Socialaccount_Aggregate_Bool_Exp = {
  count?: InputMaybe<Socialaccount_Socialaccount_Aggregate_Bool_Exp_Count>;
};

export type Socialaccount_Socialaccount_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Socialaccount_Socialaccount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Aggregate_Fields = {
  __typename?: 'socialaccount_socialaccount_aggregate_fields';
  avg?: Maybe<Socialaccount_Socialaccount_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Socialaccount_Socialaccount_Max_Fields>;
  min?: Maybe<Socialaccount_Socialaccount_Min_Fields>;
  stddev?: Maybe<Socialaccount_Socialaccount_Stddev_Fields>;
  stddev_pop?: Maybe<Socialaccount_Socialaccount_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Socialaccount_Socialaccount_Stddev_Samp_Fields>;
  sum?: Maybe<Socialaccount_Socialaccount_Sum_Fields>;
  var_pop?: Maybe<Socialaccount_Socialaccount_Var_Pop_Fields>;
  var_samp?: Maybe<Socialaccount_Socialaccount_Var_Samp_Fields>;
  variance?: Maybe<Socialaccount_Socialaccount_Variance_Fields>;
};


/** aggregate fields of "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Socialaccount_Socialaccount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Aggregate_Order_By = {
  avg?: InputMaybe<Socialaccount_Socialaccount_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Socialaccount_Socialaccount_Max_Order_By>;
  min?: InputMaybe<Socialaccount_Socialaccount_Min_Order_By>;
  stddev?: InputMaybe<Socialaccount_Socialaccount_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Socialaccount_Socialaccount_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Socialaccount_Socialaccount_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Socialaccount_Socialaccount_Sum_Order_By>;
  var_pop?: InputMaybe<Socialaccount_Socialaccount_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Socialaccount_Socialaccount_Var_Samp_Order_By>;
  variance?: InputMaybe<Socialaccount_Socialaccount_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Arr_Rel_Insert_Input = {
  data: Array<Socialaccount_Socialaccount_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Socialaccount_Socialaccount_On_Conflict>;
};

/** aggregate avg on columns */
export type Socialaccount_Socialaccount_Avg_Fields = {
  __typename?: 'socialaccount_socialaccount_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "socialaccount_socialaccount". All fields are combined with a logical 'AND'. */
export type Socialaccount_Socialaccount_Bool_Exp = {
  _and?: InputMaybe<Array<Socialaccount_Socialaccount_Bool_Exp>>;
  _not?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
  _or?: InputMaybe<Array<Socialaccount_Socialaccount_Bool_Exp>>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  extra_data?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  socialaccount_socialtokens?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
  socialaccount_socialtokens_aggregate?: InputMaybe<Socialaccount_Socialtoken_Aggregate_Bool_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "socialaccount_socialaccount" */
export enum Socialaccount_Socialaccount_Constraint {
  /** unique or primary key constraint on columns "id" */
  SocialaccountSocialaccountPkey = 'socialaccount_socialaccount_pkey',
  /** unique or primary key constraint on columns "provider", "uid" */
  SocialaccountSocialaccountProviderUidFc810c6eUniq = 'socialaccount_socialaccount_provider_uid_fc810c6e_uniq'
}

/** input type for incrementing numeric columns in table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Insert_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']['input']>;
  extra_data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  socialaccount_socialtokens?: InputMaybe<Socialaccount_Socialtoken_Arr_Rel_Insert_Input>;
  uid?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Socialaccount_Socialaccount_Max_Fields = {
  __typename?: 'socialaccount_socialaccount_max_fields';
  date_joined?: Maybe<Scalars['timestamptz']['output']>;
  extra_data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Max_Order_By = {
  date_joined?: InputMaybe<Order_By>;
  extra_data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Socialaccount_Socialaccount_Min_Fields = {
  __typename?: 'socialaccount_socialaccount_min_fields';
  date_joined?: Maybe<Scalars['timestamptz']['output']>;
  extra_data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Min_Order_By = {
  date_joined?: InputMaybe<Order_By>;
  extra_data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Mutation_Response = {
  __typename?: 'socialaccount_socialaccount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Socialaccount_Socialaccount>;
};

/** input type for inserting object relation for remote table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Obj_Rel_Insert_Input = {
  data: Socialaccount_Socialaccount_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Socialaccount_Socialaccount_On_Conflict>;
};

/** on_conflict condition type for table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_On_Conflict = {
  constraint: Socialaccount_Socialaccount_Constraint;
  update_columns?: Array<Socialaccount_Socialaccount_Update_Column>;
  where?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
};

/** Ordering options when selecting data from "socialaccount_socialaccount". */
export type Socialaccount_Socialaccount_Order_By = {
  date_joined?: InputMaybe<Order_By>;
  extra_data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  socialaccount_socialtokens_aggregate?: InputMaybe<Socialaccount_Socialtoken_Aggregate_Order_By>;
  uid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: socialaccount_socialaccount */
export type Socialaccount_Socialaccount_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "socialaccount_socialaccount" */
export enum Socialaccount_Socialaccount_Select_Column {
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  Id = 'id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  Provider = 'provider',
  /** column name */
  Uid = 'uid',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Set_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']['input']>;
  extra_data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Socialaccount_Socialaccount_Stddev_Fields = {
  __typename?: 'socialaccount_socialaccount_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Socialaccount_Socialaccount_Stddev_Pop_Fields = {
  __typename?: 'socialaccount_socialaccount_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Socialaccount_Socialaccount_Stddev_Samp_Fields = {
  __typename?: 'socialaccount_socialaccount_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Socialaccount_Socialaccount_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Socialaccount_Socialaccount_Stream_Cursor_Value_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']['input']>;
  extra_data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Socialaccount_Socialaccount_Sum_Fields = {
  __typename?: 'socialaccount_socialaccount_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "socialaccount_socialaccount" */
export enum Socialaccount_Socialaccount_Update_Column {
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  Id = 'id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  Provider = 'provider',
  /** column name */
  Uid = 'uid',
  /** column name */
  UserId = 'user_id'
}

export type Socialaccount_Socialaccount_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Socialaccount_Socialaccount_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Socialaccount_Socialaccount_Set_Input>;
  /** filter the rows which have to be updated */
  where: Socialaccount_Socialaccount_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Socialaccount_Socialaccount_Var_Pop_Fields = {
  __typename?: 'socialaccount_socialaccount_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Socialaccount_Socialaccount_Var_Samp_Fields = {
  __typename?: 'socialaccount_socialaccount_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Socialaccount_Socialaccount_Variance_Fields = {
  __typename?: 'socialaccount_socialaccount_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "socialaccount_socialaccount" */
export type Socialaccount_Socialaccount_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "socialaccount_socialapp" */
export type Socialaccount_Socialapp = {
  __typename?: 'socialaccount_socialapp';
  client_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  /** An array relationship */
  socialaccount_socialapp_sites: Array<Socialaccount_Socialapp_Sites>;
  /** An aggregate relationship */
  socialaccount_socialapp_sites_aggregate: Socialaccount_Socialapp_Sites_Aggregate;
  /** An array relationship */
  socialaccount_socialtokens: Array<Socialaccount_Socialtoken>;
  /** An aggregate relationship */
  socialaccount_socialtokens_aggregate: Socialaccount_Socialtoken_Aggregate;
};


/** columns and relationships of "socialaccount_socialapp" */
export type Socialaccount_SocialappSocialaccount_Socialapp_SitesArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};


/** columns and relationships of "socialaccount_socialapp" */
export type Socialaccount_SocialappSocialaccount_Socialapp_Sites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};


/** columns and relationships of "socialaccount_socialapp" */
export type Socialaccount_SocialappSocialaccount_SocialtokensArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialtoken_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};


/** columns and relationships of "socialaccount_socialapp" */
export type Socialaccount_SocialappSocialaccount_Socialtokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialtoken_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};

/** aggregated selection of "socialaccount_socialapp" */
export type Socialaccount_Socialapp_Aggregate = {
  __typename?: 'socialaccount_socialapp_aggregate';
  aggregate?: Maybe<Socialaccount_Socialapp_Aggregate_Fields>;
  nodes: Array<Socialaccount_Socialapp>;
};

/** aggregate fields of "socialaccount_socialapp" */
export type Socialaccount_Socialapp_Aggregate_Fields = {
  __typename?: 'socialaccount_socialapp_aggregate_fields';
  avg?: Maybe<Socialaccount_Socialapp_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Socialaccount_Socialapp_Max_Fields>;
  min?: Maybe<Socialaccount_Socialapp_Min_Fields>;
  stddev?: Maybe<Socialaccount_Socialapp_Stddev_Fields>;
  stddev_pop?: Maybe<Socialaccount_Socialapp_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Socialaccount_Socialapp_Stddev_Samp_Fields>;
  sum?: Maybe<Socialaccount_Socialapp_Sum_Fields>;
  var_pop?: Maybe<Socialaccount_Socialapp_Var_Pop_Fields>;
  var_samp?: Maybe<Socialaccount_Socialapp_Var_Samp_Fields>;
  variance?: Maybe<Socialaccount_Socialapp_Variance_Fields>;
};


/** aggregate fields of "socialaccount_socialapp" */
export type Socialaccount_Socialapp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Socialaccount_Socialapp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Socialaccount_Socialapp_Avg_Fields = {
  __typename?: 'socialaccount_socialapp_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "socialaccount_socialapp". All fields are combined with a logical 'AND'. */
export type Socialaccount_Socialapp_Bool_Exp = {
  _and?: InputMaybe<Array<Socialaccount_Socialapp_Bool_Exp>>;
  _not?: InputMaybe<Socialaccount_Socialapp_Bool_Exp>;
  _or?: InputMaybe<Array<Socialaccount_Socialapp_Bool_Exp>>;
  client_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  secret?: InputMaybe<String_Comparison_Exp>;
  socialaccount_socialapp_sites?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
  socialaccount_socialapp_sites_aggregate?: InputMaybe<Socialaccount_Socialapp_Sites_Aggregate_Bool_Exp>;
  socialaccount_socialtokens?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
  socialaccount_socialtokens_aggregate?: InputMaybe<Socialaccount_Socialtoken_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "socialaccount_socialapp" */
export enum Socialaccount_Socialapp_Constraint {
  /** unique or primary key constraint on columns "id" */
  SocialaccountSocialappPkey = 'socialaccount_socialapp_pkey'
}

/** input type for incrementing numeric columns in table "socialaccount_socialapp" */
export type Socialaccount_Socialapp_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "socialaccount_socialapp" */
export type Socialaccount_Socialapp_Insert_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  socialaccount_socialapp_sites?: InputMaybe<Socialaccount_Socialapp_Sites_Arr_Rel_Insert_Input>;
  socialaccount_socialtokens?: InputMaybe<Socialaccount_Socialtoken_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Socialaccount_Socialapp_Max_Fields = {
  __typename?: 'socialaccount_socialapp_max_fields';
  client_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Socialaccount_Socialapp_Min_Fields = {
  __typename?: 'socialaccount_socialapp_min_fields';
  client_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "socialaccount_socialapp" */
export type Socialaccount_Socialapp_Mutation_Response = {
  __typename?: 'socialaccount_socialapp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Socialaccount_Socialapp>;
};

/** input type for inserting object relation for remote table "socialaccount_socialapp" */
export type Socialaccount_Socialapp_Obj_Rel_Insert_Input = {
  data: Socialaccount_Socialapp_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Socialaccount_Socialapp_On_Conflict>;
};

/** on_conflict condition type for table "socialaccount_socialapp" */
export type Socialaccount_Socialapp_On_Conflict = {
  constraint: Socialaccount_Socialapp_Constraint;
  update_columns?: Array<Socialaccount_Socialapp_Update_Column>;
  where?: InputMaybe<Socialaccount_Socialapp_Bool_Exp>;
};

/** Ordering options when selecting data from "socialaccount_socialapp". */
export type Socialaccount_Socialapp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  secret?: InputMaybe<Order_By>;
  socialaccount_socialapp_sites_aggregate?: InputMaybe<Socialaccount_Socialapp_Sites_Aggregate_Order_By>;
  socialaccount_socialtokens_aggregate?: InputMaybe<Socialaccount_Socialtoken_Aggregate_Order_By>;
};

/** primary key columns input for table: socialaccount_socialapp */
export type Socialaccount_Socialapp_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "socialaccount_socialapp" */
export enum Socialaccount_Socialapp_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Provider = 'provider',
  /** column name */
  Secret = 'secret'
}

/** input type for updating data in table "socialaccount_socialapp" */
export type Socialaccount_Socialapp_Set_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites = {
  __typename?: 'socialaccount_socialapp_sites';
  /** An object relationship */
  django_site: Django_Site;
  id: Scalars['Int']['output'];
  site_id: Scalars['Int']['output'];
  /** An object relationship */
  socialaccount_socialapp: Socialaccount_Socialapp;
  socialapp_id: Scalars['Int']['output'];
};

/** aggregated selection of "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Aggregate = {
  __typename?: 'socialaccount_socialapp_sites_aggregate';
  aggregate?: Maybe<Socialaccount_Socialapp_Sites_Aggregate_Fields>;
  nodes: Array<Socialaccount_Socialapp_Sites>;
};

export type Socialaccount_Socialapp_Sites_Aggregate_Bool_Exp = {
  count?: InputMaybe<Socialaccount_Socialapp_Sites_Aggregate_Bool_Exp_Count>;
};

export type Socialaccount_Socialapp_Sites_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Aggregate_Fields = {
  __typename?: 'socialaccount_socialapp_sites_aggregate_fields';
  avg?: Maybe<Socialaccount_Socialapp_Sites_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Socialaccount_Socialapp_Sites_Max_Fields>;
  min?: Maybe<Socialaccount_Socialapp_Sites_Min_Fields>;
  stddev?: Maybe<Socialaccount_Socialapp_Sites_Stddev_Fields>;
  stddev_pop?: Maybe<Socialaccount_Socialapp_Sites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Socialaccount_Socialapp_Sites_Stddev_Samp_Fields>;
  sum?: Maybe<Socialaccount_Socialapp_Sites_Sum_Fields>;
  var_pop?: Maybe<Socialaccount_Socialapp_Sites_Var_Pop_Fields>;
  var_samp?: Maybe<Socialaccount_Socialapp_Sites_Var_Samp_Fields>;
  variance?: Maybe<Socialaccount_Socialapp_Sites_Variance_Fields>;
};


/** aggregate fields of "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Aggregate_Order_By = {
  avg?: InputMaybe<Socialaccount_Socialapp_Sites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Socialaccount_Socialapp_Sites_Max_Order_By>;
  min?: InputMaybe<Socialaccount_Socialapp_Sites_Min_Order_By>;
  stddev?: InputMaybe<Socialaccount_Socialapp_Sites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Socialaccount_Socialapp_Sites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Socialaccount_Socialapp_Sites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Socialaccount_Socialapp_Sites_Sum_Order_By>;
  var_pop?: InputMaybe<Socialaccount_Socialapp_Sites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Socialaccount_Socialapp_Sites_Var_Samp_Order_By>;
  variance?: InputMaybe<Socialaccount_Socialapp_Sites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Arr_Rel_Insert_Input = {
  data: Array<Socialaccount_Socialapp_Sites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Socialaccount_Socialapp_Sites_On_Conflict>;
};

/** aggregate avg on columns */
export type Socialaccount_Socialapp_Sites_Avg_Fields = {
  __typename?: 'socialaccount_socialapp_sites_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  socialapp_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "socialaccount_socialapp_sites". All fields are combined with a logical 'AND'. */
export type Socialaccount_Socialapp_Sites_Bool_Exp = {
  _and?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Bool_Exp>>;
  _not?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
  _or?: InputMaybe<Array<Socialaccount_Socialapp_Sites_Bool_Exp>>;
  django_site?: InputMaybe<Django_Site_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  site_id?: InputMaybe<Int_Comparison_Exp>;
  socialaccount_socialapp?: InputMaybe<Socialaccount_Socialapp_Bool_Exp>;
  socialapp_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "socialaccount_socialapp_sites" */
export enum Socialaccount_Socialapp_Sites_Constraint {
  /** unique or primary key constraint on columns "socialapp_id", "site_id" */
  SocialaccountSocialappSocialappIdSiteId_71a9a768Uniq = 'socialaccount_socialapp__socialapp_id_site_id_71a9a768_uniq',
  /** unique or primary key constraint on columns "id" */
  SocialaccountSocialappSitesPkey = 'socialaccount_socialapp_sites_pkey'
}

/** input type for incrementing numeric columns in table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  socialapp_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Insert_Input = {
  django_site?: InputMaybe<Django_Site_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  socialaccount_socialapp?: InputMaybe<Socialaccount_Socialapp_Obj_Rel_Insert_Input>;
  socialapp_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Socialaccount_Socialapp_Sites_Max_Fields = {
  __typename?: 'socialaccount_socialapp_sites_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  socialapp_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Socialaccount_Socialapp_Sites_Min_Fields = {
  __typename?: 'socialaccount_socialapp_sites_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  socialapp_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Mutation_Response = {
  __typename?: 'socialaccount_socialapp_sites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Socialaccount_Socialapp_Sites>;
};

/** on_conflict condition type for table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_On_Conflict = {
  constraint: Socialaccount_Socialapp_Sites_Constraint;
  update_columns?: Array<Socialaccount_Socialapp_Sites_Update_Column>;
  where?: InputMaybe<Socialaccount_Socialapp_Sites_Bool_Exp>;
};

/** Ordering options when selecting data from "socialaccount_socialapp_sites". */
export type Socialaccount_Socialapp_Sites_Order_By = {
  django_site?: InputMaybe<Django_Site_Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialaccount_socialapp?: InputMaybe<Socialaccount_Socialapp_Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: socialaccount_socialapp_sites */
export type Socialaccount_Socialapp_Sites_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "socialaccount_socialapp_sites" */
export enum Socialaccount_Socialapp_Sites_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SiteId = 'site_id',
  /** column name */
  SocialappId = 'socialapp_id'
}

/** input type for updating data in table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  socialapp_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Socialaccount_Socialapp_Sites_Stddev_Fields = {
  __typename?: 'socialaccount_socialapp_sites_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  socialapp_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Socialaccount_Socialapp_Sites_Stddev_Pop_Fields = {
  __typename?: 'socialaccount_socialapp_sites_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  socialapp_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Socialaccount_Socialapp_Sites_Stddev_Samp_Fields = {
  __typename?: 'socialaccount_socialapp_sites_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  socialapp_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Socialaccount_Socialapp_Sites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Socialaccount_Socialapp_Sites_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  socialapp_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Socialaccount_Socialapp_Sites_Sum_Fields = {
  __typename?: 'socialaccount_socialapp_sites_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  socialapp_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** update columns of table "socialaccount_socialapp_sites" */
export enum Socialaccount_Socialapp_Sites_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SiteId = 'site_id',
  /** column name */
  SocialappId = 'socialapp_id'
}

export type Socialaccount_Socialapp_Sites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Socialaccount_Socialapp_Sites_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Socialaccount_Socialapp_Sites_Set_Input>;
  /** filter the rows which have to be updated */
  where: Socialaccount_Socialapp_Sites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Socialaccount_Socialapp_Sites_Var_Pop_Fields = {
  __typename?: 'socialaccount_socialapp_sites_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  socialapp_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Socialaccount_Socialapp_Sites_Var_Samp_Fields = {
  __typename?: 'socialaccount_socialapp_sites_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  socialapp_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Socialaccount_Socialapp_Sites_Variance_Fields = {
  __typename?: 'socialaccount_socialapp_sites_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  socialapp_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "socialaccount_socialapp_sites" */
export type Socialaccount_Socialapp_Sites_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  socialapp_id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Socialaccount_Socialapp_Stddev_Fields = {
  __typename?: 'socialaccount_socialapp_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Socialaccount_Socialapp_Stddev_Pop_Fields = {
  __typename?: 'socialaccount_socialapp_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Socialaccount_Socialapp_Stddev_Samp_Fields = {
  __typename?: 'socialaccount_socialapp_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "socialaccount_socialapp" */
export type Socialaccount_Socialapp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Socialaccount_Socialapp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Socialaccount_Socialapp_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Socialaccount_Socialapp_Sum_Fields = {
  __typename?: 'socialaccount_socialapp_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "socialaccount_socialapp" */
export enum Socialaccount_Socialapp_Update_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Provider = 'provider',
  /** column name */
  Secret = 'secret'
}

export type Socialaccount_Socialapp_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Socialaccount_Socialapp_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Socialaccount_Socialapp_Set_Input>;
  /** filter the rows which have to be updated */
  where: Socialaccount_Socialapp_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Socialaccount_Socialapp_Var_Pop_Fields = {
  __typename?: 'socialaccount_socialapp_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Socialaccount_Socialapp_Var_Samp_Fields = {
  __typename?: 'socialaccount_socialapp_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Socialaccount_Socialapp_Variance_Fields = {
  __typename?: 'socialaccount_socialapp_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken = {
  __typename?: 'socialaccount_socialtoken';
  account_id: Scalars['Int']['output'];
  app_id: Scalars['Int']['output'];
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  socialaccount_socialaccount: Socialaccount_Socialaccount;
  /** An object relationship */
  socialaccount_socialapp: Socialaccount_Socialapp;
  token: Scalars['String']['output'];
  token_secret: Scalars['String']['output'];
};

/** aggregated selection of "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Aggregate = {
  __typename?: 'socialaccount_socialtoken_aggregate';
  aggregate?: Maybe<Socialaccount_Socialtoken_Aggregate_Fields>;
  nodes: Array<Socialaccount_Socialtoken>;
};

export type Socialaccount_Socialtoken_Aggregate_Bool_Exp = {
  count?: InputMaybe<Socialaccount_Socialtoken_Aggregate_Bool_Exp_Count>;
};

export type Socialaccount_Socialtoken_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Aggregate_Fields = {
  __typename?: 'socialaccount_socialtoken_aggregate_fields';
  avg?: Maybe<Socialaccount_Socialtoken_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Socialaccount_Socialtoken_Max_Fields>;
  min?: Maybe<Socialaccount_Socialtoken_Min_Fields>;
  stddev?: Maybe<Socialaccount_Socialtoken_Stddev_Fields>;
  stddev_pop?: Maybe<Socialaccount_Socialtoken_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Socialaccount_Socialtoken_Stddev_Samp_Fields>;
  sum?: Maybe<Socialaccount_Socialtoken_Sum_Fields>;
  var_pop?: Maybe<Socialaccount_Socialtoken_Var_Pop_Fields>;
  var_samp?: Maybe<Socialaccount_Socialtoken_Var_Samp_Fields>;
  variance?: Maybe<Socialaccount_Socialtoken_Variance_Fields>;
};


/** aggregate fields of "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Socialaccount_Socialtoken_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Aggregate_Order_By = {
  avg?: InputMaybe<Socialaccount_Socialtoken_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Socialaccount_Socialtoken_Max_Order_By>;
  min?: InputMaybe<Socialaccount_Socialtoken_Min_Order_By>;
  stddev?: InputMaybe<Socialaccount_Socialtoken_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Socialaccount_Socialtoken_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Socialaccount_Socialtoken_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Socialaccount_Socialtoken_Sum_Order_By>;
  var_pop?: InputMaybe<Socialaccount_Socialtoken_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Socialaccount_Socialtoken_Var_Samp_Order_By>;
  variance?: InputMaybe<Socialaccount_Socialtoken_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Arr_Rel_Insert_Input = {
  data: Array<Socialaccount_Socialtoken_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Socialaccount_Socialtoken_On_Conflict>;
};

/** aggregate avg on columns */
export type Socialaccount_Socialtoken_Avg_Fields = {
  __typename?: 'socialaccount_socialtoken_avg_fields';
  account_id?: Maybe<Scalars['Float']['output']>;
  app_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Avg_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "socialaccount_socialtoken". All fields are combined with a logical 'AND'. */
export type Socialaccount_Socialtoken_Bool_Exp = {
  _and?: InputMaybe<Array<Socialaccount_Socialtoken_Bool_Exp>>;
  _not?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
  _or?: InputMaybe<Array<Socialaccount_Socialtoken_Bool_Exp>>;
  account_id?: InputMaybe<Int_Comparison_Exp>;
  app_id?: InputMaybe<Int_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  socialaccount_socialaccount?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
  socialaccount_socialapp?: InputMaybe<Socialaccount_Socialapp_Bool_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  token_secret?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "socialaccount_socialtoken" */
export enum Socialaccount_Socialtoken_Constraint {
  /** unique or primary key constraint on columns "account_id", "app_id" */
  SocialaccountSocialtokenAppIdAccountIdFca4e0acUniq = 'socialaccount_socialtoken_app_id_account_id_fca4e0ac_uniq',
  /** unique or primary key constraint on columns "id" */
  SocialaccountSocialtokenPkey = 'socialaccount_socialtoken_pkey'
}

/** input type for incrementing numeric columns in table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Inc_Input = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  app_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Insert_Input = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  app_id?: InputMaybe<Scalars['Int']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  socialaccount_socialaccount?: InputMaybe<Socialaccount_Socialaccount_Obj_Rel_Insert_Input>;
  socialaccount_socialapp?: InputMaybe<Socialaccount_Socialapp_Obj_Rel_Insert_Input>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_secret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Socialaccount_Socialtoken_Max_Fields = {
  __typename?: 'socialaccount_socialtoken_max_fields';
  account_id?: Maybe<Scalars['Int']['output']>;
  app_id?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_secret?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_secret?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Socialaccount_Socialtoken_Min_Fields = {
  __typename?: 'socialaccount_socialtoken_min_fields';
  account_id?: Maybe<Scalars['Int']['output']>;
  app_id?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_secret?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_secret?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Mutation_Response = {
  __typename?: 'socialaccount_socialtoken_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Socialaccount_Socialtoken>;
};

/** on_conflict condition type for table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_On_Conflict = {
  constraint: Socialaccount_Socialtoken_Constraint;
  update_columns?: Array<Socialaccount_Socialtoken_Update_Column>;
  where?: InputMaybe<Socialaccount_Socialtoken_Bool_Exp>;
};

/** Ordering options when selecting data from "socialaccount_socialtoken". */
export type Socialaccount_Socialtoken_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  socialaccount_socialaccount?: InputMaybe<Socialaccount_Socialaccount_Order_By>;
  socialaccount_socialapp?: InputMaybe<Socialaccount_Socialapp_Order_By>;
  token?: InputMaybe<Order_By>;
  token_secret?: InputMaybe<Order_By>;
};

/** primary key columns input for table: socialaccount_socialtoken */
export type Socialaccount_Socialtoken_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "socialaccount_socialtoken" */
export enum Socialaccount_Socialtoken_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AppId = 'app_id',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  TokenSecret = 'token_secret'
}

/** input type for updating data in table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Set_Input = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  app_id?: InputMaybe<Scalars['Int']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_secret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Socialaccount_Socialtoken_Stddev_Fields = {
  __typename?: 'socialaccount_socialtoken_stddev_fields';
  account_id?: Maybe<Scalars['Float']['output']>;
  app_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Stddev_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Socialaccount_Socialtoken_Stddev_Pop_Fields = {
  __typename?: 'socialaccount_socialtoken_stddev_pop_fields';
  account_id?: Maybe<Scalars['Float']['output']>;
  app_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Stddev_Pop_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Socialaccount_Socialtoken_Stddev_Samp_Fields = {
  __typename?: 'socialaccount_socialtoken_stddev_samp_fields';
  account_id?: Maybe<Scalars['Float']['output']>;
  app_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Stddev_Samp_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Socialaccount_Socialtoken_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Socialaccount_Socialtoken_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  app_id?: InputMaybe<Scalars['Int']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_secret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Socialaccount_Socialtoken_Sum_Fields = {
  __typename?: 'socialaccount_socialtoken_sum_fields';
  account_id?: Maybe<Scalars['Int']['output']>;
  app_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Sum_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "socialaccount_socialtoken" */
export enum Socialaccount_Socialtoken_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AppId = 'app_id',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  TokenSecret = 'token_secret'
}

export type Socialaccount_Socialtoken_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Socialaccount_Socialtoken_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Socialaccount_Socialtoken_Set_Input>;
  /** filter the rows which have to be updated */
  where: Socialaccount_Socialtoken_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Socialaccount_Socialtoken_Var_Pop_Fields = {
  __typename?: 'socialaccount_socialtoken_var_pop_fields';
  account_id?: Maybe<Scalars['Float']['output']>;
  app_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Var_Pop_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Socialaccount_Socialtoken_Var_Samp_Fields = {
  __typename?: 'socialaccount_socialtoken_var_samp_fields';
  account_id?: Maybe<Scalars['Float']['output']>;
  app_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Var_Samp_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Socialaccount_Socialtoken_Variance_Fields = {
  __typename?: 'socialaccount_socialtoken_variance_fields';
  account_id?: Maybe<Scalars['Float']['output']>;
  app_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "socialaccount_socialtoken" */
export type Socialaccount_Socialtoken_Variance_Order_By = {
  account_id?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "speed_test_category" */
export type Speed_Test_Category = {
  __typename?: 'speed_test_category';
  category: Scalars['String']['output'];
  /** An array relationship */
  speed_tests: Array<Speed_Tests>;
  /** An aggregate relationship */
  speed_tests_aggregate: Speed_Tests_Aggregate;
  type: Scalars['String']['output'];
  /** An array relationship */
  user_speed_tests_summaries: Array<User_Speed_Tests_Summaries>;
  /** An aggregate relationship */
  user_speed_tests_summaries_aggregate: User_Speed_Tests_Summaries_Aggregate;
};


/** columns and relationships of "speed_test_category" */
export type Speed_Test_CategorySpeed_TestsArgs = {
  distinct_on?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Tests_Order_By>>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};


/** columns and relationships of "speed_test_category" */
export type Speed_Test_CategorySpeed_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Tests_Order_By>>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};


/** columns and relationships of "speed_test_category" */
export type Speed_Test_CategoryUser_Speed_Tests_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};


/** columns and relationships of "speed_test_category" */
export type Speed_Test_CategoryUser_Speed_Tests_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};

/** aggregated selection of "speed_test_category" */
export type Speed_Test_Category_Aggregate = {
  __typename?: 'speed_test_category_aggregate';
  aggregate?: Maybe<Speed_Test_Category_Aggregate_Fields>;
  nodes: Array<Speed_Test_Category>;
};

/** aggregate fields of "speed_test_category" */
export type Speed_Test_Category_Aggregate_Fields = {
  __typename?: 'speed_test_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Speed_Test_Category_Max_Fields>;
  min?: Maybe<Speed_Test_Category_Min_Fields>;
};


/** aggregate fields of "speed_test_category" */
export type Speed_Test_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Speed_Test_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "speed_test_category". All fields are combined with a logical 'AND'. */
export type Speed_Test_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Speed_Test_Category_Bool_Exp>>;
  _not?: InputMaybe<Speed_Test_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Speed_Test_Category_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  speed_tests?: InputMaybe<Speed_Tests_Bool_Exp>;
  speed_tests_aggregate?: InputMaybe<Speed_Tests_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_speed_tests_summaries?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
  user_speed_tests_summaries_aggregate?: InputMaybe<User_Speed_Tests_Summaries_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "speed_test_category" */
export enum Speed_Test_Category_Constraint {
  /** unique or primary key constraint on columns "type", "category" */
  SpeedTestCategoryPkey = 'speed_test_category_pkey'
}

/** input type for inserting data into table "speed_test_category" */
export type Speed_Test_Category_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  speed_tests?: InputMaybe<Speed_Tests_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_speed_tests_summaries?: InputMaybe<User_Speed_Tests_Summaries_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Speed_Test_Category_Max_Fields = {
  __typename?: 'speed_test_category_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Speed_Test_Category_Min_Fields = {
  __typename?: 'speed_test_category_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "speed_test_category" */
export type Speed_Test_Category_Mutation_Response = {
  __typename?: 'speed_test_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Speed_Test_Category>;
};

/** input type for inserting object relation for remote table "speed_test_category" */
export type Speed_Test_Category_Obj_Rel_Insert_Input = {
  data: Speed_Test_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Speed_Test_Category_On_Conflict>;
};

/** on_conflict condition type for table "speed_test_category" */
export type Speed_Test_Category_On_Conflict = {
  constraint: Speed_Test_Category_Constraint;
  update_columns?: Array<Speed_Test_Category_Update_Column>;
  where?: InputMaybe<Speed_Test_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "speed_test_category". */
export type Speed_Test_Category_Order_By = {
  category?: InputMaybe<Order_By>;
  speed_tests_aggregate?: InputMaybe<Speed_Tests_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  user_speed_tests_summaries_aggregate?: InputMaybe<User_Speed_Tests_Summaries_Aggregate_Order_By>;
};

/** primary key columns input for table: speed_test_category */
export type Speed_Test_Category_Pk_Columns_Input = {
  category: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** select columns of table "speed_test_category" */
export enum Speed_Test_Category_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "speed_test_category" */
export type Speed_Test_Category_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "speed_test_category" */
export type Speed_Test_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Speed_Test_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Speed_Test_Category_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "speed_test_category" */
export enum Speed_Test_Category_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Type = 'type'
}

export type Speed_Test_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Speed_Test_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Speed_Test_Category_Bool_Exp;
};

/** columns and relationships of "speed_tests" */
export type Speed_Tests = {
  __typename?: 'speed_tests';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  latest_test_score: Scalars['numeric']['output'];
  /** An object relationship */
  speed_test_category?: Maybe<Speed_Test_Category>;
  test_attempt_number: Scalars['Int']['output'];
  test_category: Scalars['String']['output'];
  test_time: Scalars['Int']['output'];
  test_type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Supertokens_All_Auth_Recipe_Users;
  user_id: Scalars['String']['output'];
  xp: Scalars['numeric']['output'];
};

/** aggregated selection of "speed_tests" */
export type Speed_Tests_Aggregate = {
  __typename?: 'speed_tests_aggregate';
  aggregate?: Maybe<Speed_Tests_Aggregate_Fields>;
  nodes: Array<Speed_Tests>;
};

export type Speed_Tests_Aggregate_Bool_Exp = {
  count?: InputMaybe<Speed_Tests_Aggregate_Bool_Exp_Count>;
};

export type Speed_Tests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Speed_Tests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "speed_tests" */
export type Speed_Tests_Aggregate_Fields = {
  __typename?: 'speed_tests_aggregate_fields';
  avg?: Maybe<Speed_Tests_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Speed_Tests_Max_Fields>;
  min?: Maybe<Speed_Tests_Min_Fields>;
  stddev?: Maybe<Speed_Tests_Stddev_Fields>;
  stddev_pop?: Maybe<Speed_Tests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Speed_Tests_Stddev_Samp_Fields>;
  sum?: Maybe<Speed_Tests_Sum_Fields>;
  var_pop?: Maybe<Speed_Tests_Var_Pop_Fields>;
  var_samp?: Maybe<Speed_Tests_Var_Samp_Fields>;
  variance?: Maybe<Speed_Tests_Variance_Fields>;
};


/** aggregate fields of "speed_tests" */
export type Speed_Tests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "speed_tests" */
export type Speed_Tests_Aggregate_Order_By = {
  avg?: InputMaybe<Speed_Tests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Speed_Tests_Max_Order_By>;
  min?: InputMaybe<Speed_Tests_Min_Order_By>;
  stddev?: InputMaybe<Speed_Tests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Speed_Tests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Speed_Tests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Speed_Tests_Sum_Order_By>;
  var_pop?: InputMaybe<Speed_Tests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Speed_Tests_Var_Samp_Order_By>;
  variance?: InputMaybe<Speed_Tests_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "speed_tests" */
export type Speed_Tests_Arr_Rel_Insert_Input = {
  data: Array<Speed_Tests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Speed_Tests_On_Conflict>;
};

/** aggregate avg on columns */
export type Speed_Tests_Avg_Fields = {
  __typename?: 'speed_tests_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latest_test_score?: Maybe<Scalars['Float']['output']>;
  test_attempt_number?: Maybe<Scalars['Float']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "speed_tests" */
export type Speed_Tests_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "speed_tests". All fields are combined with a logical 'AND'. */
export type Speed_Tests_Bool_Exp = {
  _and?: InputMaybe<Array<Speed_Tests_Bool_Exp>>;
  _not?: InputMaybe<Speed_Tests_Bool_Exp>;
  _or?: InputMaybe<Array<Speed_Tests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  latest_test_score?: InputMaybe<Numeric_Comparison_Exp>;
  speed_test_category?: InputMaybe<Speed_Test_Category_Bool_Exp>;
  test_attempt_number?: InputMaybe<Int_Comparison_Exp>;
  test_category?: InputMaybe<String_Comparison_Exp>;
  test_time?: InputMaybe<Int_Comparison_Exp>;
  test_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  xp?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "speed_tests" */
export enum Speed_Tests_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpeedTestsPkey = 'speed_tests_pkey'
}

/** input type for incrementing numeric columns in table "speed_tests" */
export type Speed_Tests_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  latest_test_score?: InputMaybe<Scalars['numeric']['input']>;
  test_attempt_number?: InputMaybe<Scalars['Int']['input']>;
  test_time?: InputMaybe<Scalars['Int']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "speed_tests" */
export type Speed_Tests_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latest_test_score?: InputMaybe<Scalars['numeric']['input']>;
  speed_test_category?: InputMaybe<Speed_Test_Category_Obj_Rel_Insert_Input>;
  test_attempt_number?: InputMaybe<Scalars['Int']['input']>;
  test_category?: InputMaybe<Scalars['String']['input']>;
  test_time?: InputMaybe<Scalars['Int']['input']>;
  test_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Speed_Tests_Max_Fields = {
  __typename?: 'speed_tests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latest_test_score?: Maybe<Scalars['numeric']['output']>;
  test_attempt_number?: Maybe<Scalars['Int']['output']>;
  test_category?: Maybe<Scalars['String']['output']>;
  test_time?: Maybe<Scalars['Int']['output']>;
  test_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "speed_tests" */
export type Speed_Tests_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_category?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Speed_Tests_Min_Fields = {
  __typename?: 'speed_tests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latest_test_score?: Maybe<Scalars['numeric']['output']>;
  test_attempt_number?: Maybe<Scalars['Int']['output']>;
  test_category?: Maybe<Scalars['String']['output']>;
  test_time?: Maybe<Scalars['Int']['output']>;
  test_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "speed_tests" */
export type Speed_Tests_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_category?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "speed_tests" */
export type Speed_Tests_Mutation_Response = {
  __typename?: 'speed_tests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Speed_Tests>;
};

/** on_conflict condition type for table "speed_tests" */
export type Speed_Tests_On_Conflict = {
  constraint: Speed_Tests_Constraint;
  update_columns?: Array<Speed_Tests_Update_Column>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};

/** Ordering options when selecting data from "speed_tests". */
export type Speed_Tests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  speed_test_category?: InputMaybe<Speed_Test_Category_Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_category?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: speed_tests */
export type Speed_Tests_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "speed_tests" */
export enum Speed_Tests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LatestTestScore = 'latest_test_score',
  /** column name */
  TestAttemptNumber = 'test_attempt_number',
  /** column name */
  TestCategory = 'test_category',
  /** column name */
  TestTime = 'test_time',
  /** column name */
  TestType = 'test_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

/** input type for updating data in table "speed_tests" */
export type Speed_Tests_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latest_test_score?: InputMaybe<Scalars['numeric']['input']>;
  test_attempt_number?: InputMaybe<Scalars['Int']['input']>;
  test_category?: InputMaybe<Scalars['String']['input']>;
  test_time?: InputMaybe<Scalars['Int']['input']>;
  test_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Speed_Tests_Stddev_Fields = {
  __typename?: 'speed_tests_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latest_test_score?: Maybe<Scalars['Float']['output']>;
  test_attempt_number?: Maybe<Scalars['Float']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "speed_tests" */
export type Speed_Tests_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Speed_Tests_Stddev_Pop_Fields = {
  __typename?: 'speed_tests_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latest_test_score?: Maybe<Scalars['Float']['output']>;
  test_attempt_number?: Maybe<Scalars['Float']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "speed_tests" */
export type Speed_Tests_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Speed_Tests_Stddev_Samp_Fields = {
  __typename?: 'speed_tests_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latest_test_score?: Maybe<Scalars['Float']['output']>;
  test_attempt_number?: Maybe<Scalars['Float']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "speed_tests" */
export type Speed_Tests_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "speed_tests" */
export type Speed_Tests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Speed_Tests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Speed_Tests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latest_test_score?: InputMaybe<Scalars['numeric']['input']>;
  test_attempt_number?: InputMaybe<Scalars['Int']['input']>;
  test_category?: InputMaybe<Scalars['String']['input']>;
  test_time?: InputMaybe<Scalars['Int']['input']>;
  test_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Speed_Tests_Sum_Fields = {
  __typename?: 'speed_tests_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  latest_test_score?: Maybe<Scalars['numeric']['output']>;
  test_attempt_number?: Maybe<Scalars['Int']['output']>;
  test_time?: Maybe<Scalars['Int']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "speed_tests" */
export type Speed_Tests_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** update columns of table "speed_tests" */
export enum Speed_Tests_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LatestTestScore = 'latest_test_score',
  /** column name */
  TestAttemptNumber = 'test_attempt_number',
  /** column name */
  TestCategory = 'test_category',
  /** column name */
  TestTime = 'test_time',
  /** column name */
  TestType = 'test_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

export type Speed_Tests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Speed_Tests_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Speed_Tests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Speed_Tests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Speed_Tests_Var_Pop_Fields = {
  __typename?: 'speed_tests_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latest_test_score?: Maybe<Scalars['Float']['output']>;
  test_attempt_number?: Maybe<Scalars['Float']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "speed_tests" */
export type Speed_Tests_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Speed_Tests_Var_Samp_Fields = {
  __typename?: 'speed_tests_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latest_test_score?: Maybe<Scalars['Float']['output']>;
  test_attempt_number?: Maybe<Scalars['Float']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "speed_tests" */
export type Speed_Tests_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Speed_Tests_Variance_Fields = {
  __typename?: 'speed_tests_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latest_test_score?: Maybe<Scalars['Float']['output']>;
  test_attempt_number?: Maybe<Scalars['Float']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "speed_tests" */
export type Speed_Tests_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_test_score?: InputMaybe<Order_By>;
  test_attempt_number?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_cache" */
export type Spirit_Cache = {
  __typename?: 'spirit_cache';
  cache_key: Scalars['String']['output'];
  expires: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "spirit_cache" */
export type Spirit_Cache_Aggregate = {
  __typename?: 'spirit_cache_aggregate';
  aggregate?: Maybe<Spirit_Cache_Aggregate_Fields>;
  nodes: Array<Spirit_Cache>;
};

/** aggregate fields of "spirit_cache" */
export type Spirit_Cache_Aggregate_Fields = {
  __typename?: 'spirit_cache_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Cache_Max_Fields>;
  min?: Maybe<Spirit_Cache_Min_Fields>;
};


/** aggregate fields of "spirit_cache" */
export type Spirit_Cache_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Cache_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "spirit_cache". All fields are combined with a logical 'AND'. */
export type Spirit_Cache_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Cache_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Cache_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Cache_Bool_Exp>>;
  cache_key?: InputMaybe<String_Comparison_Exp>;
  expires?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spirit_cache" */
export enum Spirit_Cache_Constraint {
  /** unique or primary key constraint on columns "cache_key" */
  SpiritCachePkey = 'spirit_cache_pkey'
}

/** input type for inserting data into table "spirit_cache" */
export type Spirit_Cache_Insert_Input = {
  cache_key?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Spirit_Cache_Max_Fields = {
  __typename?: 'spirit_cache_max_fields';
  cache_key?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Spirit_Cache_Min_Fields = {
  __typename?: 'spirit_cache_min_fields';
  cache_key?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "spirit_cache" */
export type Spirit_Cache_Mutation_Response = {
  __typename?: 'spirit_cache_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Cache>;
};

/** on_conflict condition type for table "spirit_cache" */
export type Spirit_Cache_On_Conflict = {
  constraint: Spirit_Cache_Constraint;
  update_columns?: Array<Spirit_Cache_Update_Column>;
  where?: InputMaybe<Spirit_Cache_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_cache". */
export type Spirit_Cache_Order_By = {
  cache_key?: InputMaybe<Order_By>;
  expires?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spirit_cache */
export type Spirit_Cache_Pk_Columns_Input = {
  cache_key: Scalars['String']['input'];
};

/** select columns of table "spirit_cache" */
export enum Spirit_Cache_Select_Column {
  /** column name */
  CacheKey = 'cache_key',
  /** column name */
  Expires = 'expires',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "spirit_cache" */
export type Spirit_Cache_Set_Input = {
  cache_key?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "spirit_cache" */
export type Spirit_Cache_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Cache_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Cache_Stream_Cursor_Value_Input = {
  cache_key?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "spirit_cache" */
export enum Spirit_Cache_Update_Column {
  /** column name */
  CacheKey = 'cache_key',
  /** column name */
  Expires = 'expires',
  /** column name */
  Value = 'value'
}

export type Spirit_Cache_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Cache_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Cache_Bool_Exp;
};

/** columns and relationships of "spirit_category_category" */
export type Spirit_Category_Category = {
  __typename?: 'spirit_category_category';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_closed: Scalars['Boolean']['output'];
  is_global: Scalars['Boolean']['output'];
  is_private: Scalars['Boolean']['output'];
  is_removed: Scalars['Boolean']['output'];
  parent_id?: Maybe<Scalars['Int']['output']>;
  reindex_at: Scalars['timestamptz']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  /** An array relationship */
  spirit_category_categories: Array<Spirit_Category_Category>;
  /** An aggregate relationship */
  spirit_category_categories_aggregate: Spirit_Category_Category_Aggregate;
  /** An object relationship */
  spirit_category_category?: Maybe<Spirit_Category_Category>;
  /** An array relationship */
  spirit_topic_topics: Array<Spirit_Topic_Topic>;
  /** An aggregate relationship */
  spirit_topic_topics_aggregate: Spirit_Topic_Topic_Aggregate;
  title: Scalars['String']['output'];
};


/** columns and relationships of "spirit_category_category" */
export type Spirit_Category_CategorySpirit_Category_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Category_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Category_Category_Order_By>>;
  where?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
};


/** columns and relationships of "spirit_category_category" */
export type Spirit_Category_CategorySpirit_Category_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Category_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Category_Category_Order_By>>;
  where?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
};


/** columns and relationships of "spirit_category_category" */
export type Spirit_Category_CategorySpirit_Topic_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Topic_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};


/** columns and relationships of "spirit_category_category" */
export type Spirit_Category_CategorySpirit_Topic_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Topic_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};

/** aggregated selection of "spirit_category_category" */
export type Spirit_Category_Category_Aggregate = {
  __typename?: 'spirit_category_category_aggregate';
  aggregate?: Maybe<Spirit_Category_Category_Aggregate_Fields>;
  nodes: Array<Spirit_Category_Category>;
};

export type Spirit_Category_Category_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spirit_Category_Category_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spirit_Category_Category_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spirit_Category_Category_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Category_Category_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spirit_Category_Category_Select_Column_Spirit_Category_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Category_Category_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spirit_Category_Category_Select_Column_Spirit_Category_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Category_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Category_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_category_category" */
export type Spirit_Category_Category_Aggregate_Fields = {
  __typename?: 'spirit_category_category_aggregate_fields';
  avg?: Maybe<Spirit_Category_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Category_Category_Max_Fields>;
  min?: Maybe<Spirit_Category_Category_Min_Fields>;
  stddev?: Maybe<Spirit_Category_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Category_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Category_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Category_Category_Sum_Fields>;
  var_pop?: Maybe<Spirit_Category_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Category_Category_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Category_Category_Variance_Fields>;
};


/** aggregate fields of "spirit_category_category" */
export type Spirit_Category_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Category_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_category_category" */
export type Spirit_Category_Category_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Category_Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Category_Category_Max_Order_By>;
  min?: InputMaybe<Spirit_Category_Category_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Category_Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Category_Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Category_Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Category_Category_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Category_Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Category_Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Category_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_category_category" */
export type Spirit_Category_Category_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Category_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Category_Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Category_Category_Avg_Fields = {
  __typename?: 'spirit_category_category_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_category_category". All fields are combined with a logical 'AND'. */
export type Spirit_Category_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Category_Category_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Category_Category_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_closed?: InputMaybe<Boolean_Comparison_Exp>;
  is_global?: InputMaybe<Boolean_Comparison_Exp>;
  is_private?: InputMaybe<Boolean_Comparison_Exp>;
  is_removed?: InputMaybe<Boolean_Comparison_Exp>;
  parent_id?: InputMaybe<Int_Comparison_Exp>;
  reindex_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  sort?: InputMaybe<Int_Comparison_Exp>;
  spirit_category_categories?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
  spirit_category_categories_aggregate?: InputMaybe<Spirit_Category_Category_Aggregate_Bool_Exp>;
  spirit_category_category?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
  spirit_topic_topics?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  spirit_topic_topics_aggregate?: InputMaybe<Spirit_Topic_Topic_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spirit_category_category" */
export enum Spirit_Category_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpiritCategoryCategoryPkey = 'spirit_category_category_pkey'
}

/** input type for incrementing numeric columns in table "spirit_category_category" */
export type Spirit_Category_Category_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_category_category" */
export type Spirit_Category_Category_Insert_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  is_global?: InputMaybe<Scalars['Boolean']['input']>;
  is_private?: InputMaybe<Scalars['Boolean']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  reindex_at?: InputMaybe<Scalars['timestamptz']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  spirit_category_categories?: InputMaybe<Spirit_Category_Category_Arr_Rel_Insert_Input>;
  spirit_category_category?: InputMaybe<Spirit_Category_Category_Obj_Rel_Insert_Input>;
  spirit_topic_topics?: InputMaybe<Spirit_Topic_Topic_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Spirit_Category_Category_Max_Fields = {
  __typename?: 'spirit_category_category_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  reindex_at?: Maybe<Scalars['timestamptz']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reindex_at?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Category_Category_Min_Fields = {
  __typename?: 'spirit_category_category_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  reindex_at?: Maybe<Scalars['timestamptz']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reindex_at?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_category_category" */
export type Spirit_Category_Category_Mutation_Response = {
  __typename?: 'spirit_category_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Category_Category>;
};

/** input type for inserting object relation for remote table "spirit_category_category" */
export type Spirit_Category_Category_Obj_Rel_Insert_Input = {
  data: Spirit_Category_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Category_Category_On_Conflict>;
};

/** on_conflict condition type for table "spirit_category_category" */
export type Spirit_Category_Category_On_Conflict = {
  constraint: Spirit_Category_Category_Constraint;
  update_columns?: Array<Spirit_Category_Category_Update_Column>;
  where?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_category_category". */
export type Spirit_Category_Category_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_closed?: InputMaybe<Order_By>;
  is_global?: InputMaybe<Order_By>;
  is_private?: InputMaybe<Order_By>;
  is_removed?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reindex_at?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  spirit_category_categories_aggregate?: InputMaybe<Spirit_Category_Category_Aggregate_Order_By>;
  spirit_category_category?: InputMaybe<Spirit_Category_Category_Order_By>;
  spirit_topic_topics_aggregate?: InputMaybe<Spirit_Topic_Topic_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spirit_category_category */
export type Spirit_Category_Category_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_category_category" */
export enum Spirit_Category_Category_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsGlobal = 'is_global',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ReindexAt = 'reindex_at',
  /** column name */
  Slug = 'slug',
  /** column name */
  Sort = 'sort',
  /** column name */
  Title = 'title'
}

/** select "spirit_category_category_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spirit_category_category" */
export enum Spirit_Category_Category_Select_Column_Spirit_Category_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsGlobal = 'is_global',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  IsRemoved = 'is_removed'
}

/** select "spirit_category_category_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spirit_category_category" */
export enum Spirit_Category_Category_Select_Column_Spirit_Category_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsGlobal = 'is_global',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  IsRemoved = 'is_removed'
}

/** input type for updating data in table "spirit_category_category" */
export type Spirit_Category_Category_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  is_global?: InputMaybe<Scalars['Boolean']['input']>;
  is_private?: InputMaybe<Scalars['Boolean']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  reindex_at?: InputMaybe<Scalars['timestamptz']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Category_Category_Stddev_Fields = {
  __typename?: 'spirit_category_category_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Category_Category_Stddev_Pop_Fields = {
  __typename?: 'spirit_category_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Category_Category_Stddev_Samp_Fields = {
  __typename?: 'spirit_category_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_category_category" */
export type Spirit_Category_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Category_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Category_Category_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  is_global?: InputMaybe<Scalars['Boolean']['input']>;
  is_private?: InputMaybe<Scalars['Boolean']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  reindex_at?: InputMaybe<Scalars['timestamptz']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Category_Category_Sum_Fields = {
  __typename?: 'spirit_category_category_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_category_category" */
export enum Spirit_Category_Category_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsGlobal = 'is_global',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ReindexAt = 'reindex_at',
  /** column name */
  Slug = 'slug',
  /** column name */
  Sort = 'sort',
  /** column name */
  Title = 'title'
}

export type Spirit_Category_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Category_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Category_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Category_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Category_Category_Var_Pop_Fields = {
  __typename?: 'spirit_category_category_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Category_Category_Var_Samp_Fields = {
  __typename?: 'spirit_category_category_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Category_Category_Variance_Fields = {
  __typename?: 'spirit_category_category_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_category_category" */
export type Spirit_Category_Category_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark = {
  __typename?: 'spirit_comment_bookmark_commentbookmark';
  comment_number: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  spirit_topic_topic: Spirit_Topic_Topic;
  topic_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Aggregate = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_aggregate';
  aggregate?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Fields>;
  nodes: Array<Spirit_Comment_Bookmark_Commentbookmark>;
};

export type Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Bool_Exp = {
  count?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_aggregate_fields';
  avg?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Max_Fields>;
  min?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Min_Fields>;
  stddev?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Sum_Fields>;
  var_pop?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Comment_Bookmark_Commentbookmark_Variance_Fields>;
};


/** aggregate fields of "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Max_Order_By>;
  min?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Comment_Bookmark_Commentbookmark_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Avg_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_avg_fields';
  comment_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Avg_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_comment_bookmark_commentbookmark". All fields are combined with a logical 'AND'. */
export type Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>>;
  comment_number?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  topic_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_comment_bookmark_commentbookmark" */
export enum Spirit_Comment_Bookmark_Commentbookmark_Constraint {
  /** unique or primary key constraint on columns "user_id", "topic_id" */
  SpiritCommentBookmarkUserIdTopicId_5ad0da74Uniq = 'spirit_comment_bookmark__user_id_topic_id_5ad0da74_uniq',
  /** unique or primary key constraint on columns "id" */
  SpiritCommentBookmarkCommentbookmarkPkey = 'spirit_comment_bookmark_commentbookmark_pkey'
}

/** input type for incrementing numeric columns in table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Inc_Input = {
  comment_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Insert_Input = {
  comment_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Obj_Rel_Insert_Input>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Max_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_max_fields';
  comment_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Max_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Min_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_min_fields';
  comment_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Min_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Mutation_Response = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Comment_Bookmark_Commentbookmark>;
};

/** on_conflict condition type for table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_On_Conflict = {
  constraint: Spirit_Comment_Bookmark_Commentbookmark_Constraint;
  update_columns?: Array<Spirit_Comment_Bookmark_Commentbookmark_Update_Column>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_comment_bookmark_commentbookmark". */
export type Spirit_Comment_Bookmark_Commentbookmark_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_comment_bookmark_commentbookmark */
export type Spirit_Comment_Bookmark_Commentbookmark_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_comment_bookmark_commentbookmark" */
export enum Spirit_Comment_Bookmark_Commentbookmark_Select_Column {
  /** column name */
  CommentNumber = 'comment_number',
  /** column name */
  Id = 'id',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Set_Input = {
  comment_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Stddev_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_stddev_fields';
  comment_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Stddev_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Stddev_Pop_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_stddev_pop_fields';
  comment_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Stddev_Pop_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Stddev_Samp_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_stddev_samp_fields';
  comment_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Stddev_Samp_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Comment_Bookmark_Commentbookmark_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Comment_Bookmark_Commentbookmark_Stream_Cursor_Value_Input = {
  comment_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Sum_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_sum_fields';
  comment_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Sum_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_comment_bookmark_commentbookmark" */
export enum Spirit_Comment_Bookmark_Commentbookmark_Update_Column {
  /** column name */
  CommentNumber = 'comment_number',
  /** column name */
  Id = 'id',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

export type Spirit_Comment_Bookmark_Commentbookmark_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Var_Pop_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_var_pop_fields';
  comment_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Var_Pop_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Var_Samp_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_var_samp_fields';
  comment_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Var_Samp_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Comment_Bookmark_Commentbookmark_Variance_Fields = {
  __typename?: 'spirit_comment_bookmark_commentbookmark_variance_fields';
  comment_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_comment_bookmark_commentbookmark" */
export type Spirit_Comment_Bookmark_Commentbookmark_Variance_Order_By = {
  comment_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_Comment = {
  __typename?: 'spirit_comment_comment';
  action: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  comment_html: Scalars['String']['output'];
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  ip_address?: Maybe<Scalars['inet']['output']>;
  is_modified: Scalars['Boolean']['output'];
  is_removed: Scalars['Boolean']['output'];
  likes_count: Scalars['Int']['output'];
  modified_count: Scalars['Int']['output'];
  /** An object relationship */
  spirit_comment_flag_commentflag?: Maybe<Spirit_Comment_Flag_Commentflag>;
  /** An array relationship */
  spirit_comment_flag_flags: Array<Spirit_Comment_Flag_Flag>;
  /** An aggregate relationship */
  spirit_comment_flag_flags_aggregate: Spirit_Comment_Flag_Flag_Aggregate;
  /** An array relationship */
  spirit_comment_history_commenthistories: Array<Spirit_Comment_History_Commenthistory>;
  /** An aggregate relationship */
  spirit_comment_history_commenthistories_aggregate: Spirit_Comment_History_Commenthistory_Aggregate;
  /** An array relationship */
  spirit_comment_like_commentlikes: Array<Spirit_Comment_Like_Commentlike>;
  /** An aggregate relationship */
  spirit_comment_like_commentlikes_aggregate: Spirit_Comment_Like_Commentlike_Aggregate;
  /** An array relationship */
  spirit_comment_poll_commentpolls: Array<Spirit_Comment_Poll_Commentpoll>;
  /** An aggregate relationship */
  spirit_comment_poll_commentpolls_aggregate: Spirit_Comment_Poll_Commentpoll_Aggregate;
  /** An array relationship */
  spirit_topic_notification_topicnotifications: Array<Spirit_Topic_Notification_Topicnotification>;
  /** An aggregate relationship */
  spirit_topic_notification_topicnotifications_aggregate: Spirit_Topic_Notification_Topicnotification_Aggregate;
  /** An object relationship */
  spirit_topic_topic: Spirit_Topic_Topic;
  topic_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Comment_Flag_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Comment_Flag_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Comment_History_CommenthistoriesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Order_By>>;
  where?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Comment_History_Commenthistories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Order_By>>;
  where?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Comment_Like_CommentlikesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Comment_Like_Commentlikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Comment_Poll_CommentpollsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Comment_Poll_Commentpolls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Topic_Notification_TopicnotificationsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_comment" */
export type Spirit_Comment_CommentSpirit_Topic_Notification_Topicnotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};

/** aggregated selection of "spirit_comment_comment" */
export type Spirit_Comment_Comment_Aggregate = {
  __typename?: 'spirit_comment_comment_aggregate';
  aggregate?: Maybe<Spirit_Comment_Comment_Aggregate_Fields>;
  nodes: Array<Spirit_Comment_Comment>;
};

export type Spirit_Comment_Comment_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spirit_Comment_Comment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spirit_Comment_Comment_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spirit_Comment_Comment_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Comment_Comment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spirit_Comment_Comment_Select_Column_Spirit_Comment_Comment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Comment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spirit_Comment_Comment_Select_Column_Spirit_Comment_Comment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Comment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_comment_comment" */
export type Spirit_Comment_Comment_Aggregate_Fields = {
  __typename?: 'spirit_comment_comment_aggregate_fields';
  avg?: Maybe<Spirit_Comment_Comment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Comment_Comment_Max_Fields>;
  min?: Maybe<Spirit_Comment_Comment_Min_Fields>;
  stddev?: Maybe<Spirit_Comment_Comment_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Comment_Comment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Comment_Comment_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Comment_Comment_Sum_Fields>;
  var_pop?: Maybe<Spirit_Comment_Comment_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Comment_Comment_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Comment_Comment_Variance_Fields>;
};


/** aggregate fields of "spirit_comment_comment" */
export type Spirit_Comment_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Comment_Comment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Comment_Comment_Max_Order_By>;
  min?: InputMaybe<Spirit_Comment_Comment_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Comment_Comment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Comment_Comment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Comment_Comment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Comment_Comment_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Comment_Comment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Comment_Comment_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Comment_Comment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Comment_Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Comment_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Comment_Comment_Avg_Fields = {
  __typename?: 'spirit_comment_comment_avg_fields';
  action?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  likes_count?: Maybe<Scalars['Float']['output']>;
  modified_count?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Avg_Order_By = {
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_comment_comment". All fields are combined with a logical 'AND'. */
export type Spirit_Comment_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Comment_Comment_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Comment_Comment_Bool_Exp>>;
  action?: InputMaybe<Int_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  comment_html?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ip_address?: InputMaybe<Inet_Comparison_Exp>;
  is_modified?: InputMaybe<Boolean_Comparison_Exp>;
  is_removed?: InputMaybe<Boolean_Comparison_Exp>;
  likes_count?: InputMaybe<Int_Comparison_Exp>;
  modified_count?: InputMaybe<Int_Comparison_Exp>;
  spirit_comment_flag_commentflag?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
  spirit_comment_flag_flags?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
  spirit_comment_flag_flags_aggregate?: InputMaybe<Spirit_Comment_Flag_Flag_Aggregate_Bool_Exp>;
  spirit_comment_history_commenthistories?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
  spirit_comment_history_commenthistories_aggregate?: InputMaybe<Spirit_Comment_History_Commenthistory_Aggregate_Bool_Exp>;
  spirit_comment_like_commentlikes?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
  spirit_comment_like_commentlikes_aggregate?: InputMaybe<Spirit_Comment_Like_Commentlike_Aggregate_Bool_Exp>;
  spirit_comment_poll_commentpolls?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
  spirit_comment_poll_commentpolls_aggregate?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp>;
  spirit_topic_notification_topicnotifications?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
  spirit_topic_notification_topicnotifications_aggregate?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  topic_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_comment_comment" */
export enum Spirit_Comment_Comment_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpiritCommentCommentPkey = 'spirit_comment_comment_pkey'
}

/** input type for incrementing numeric columns in table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Inc_Input = {
  action?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  likes_count?: InputMaybe<Scalars['Int']['input']>;
  modified_count?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Insert_Input = {
  action?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_html?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip_address?: InputMaybe<Scalars['inet']['input']>;
  is_modified?: InputMaybe<Scalars['Boolean']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  likes_count?: InputMaybe<Scalars['Int']['input']>;
  modified_count?: InputMaybe<Scalars['Int']['input']>;
  spirit_comment_flag_commentflag?: InputMaybe<Spirit_Comment_Flag_Commentflag_Obj_Rel_Insert_Input>;
  spirit_comment_flag_flags?: InputMaybe<Spirit_Comment_Flag_Flag_Arr_Rel_Insert_Input>;
  spirit_comment_history_commenthistories?: InputMaybe<Spirit_Comment_History_Commenthistory_Arr_Rel_Insert_Input>;
  spirit_comment_like_commentlikes?: InputMaybe<Spirit_Comment_Like_Commentlike_Arr_Rel_Insert_Input>;
  spirit_comment_poll_commentpolls?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Arr_Rel_Insert_Input>;
  spirit_topic_notification_topicnotifications?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Arr_Rel_Insert_Input>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Obj_Rel_Insert_Input>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Comment_Comment_Max_Fields = {
  __typename?: 'spirit_comment_comment_max_fields';
  action?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  comment_html?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  likes_count?: Maybe<Scalars['Int']['output']>;
  modified_count?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Max_Order_By = {
  action?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  comment_html?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Comment_Comment_Min_Fields = {
  __typename?: 'spirit_comment_comment_min_fields';
  action?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  comment_html?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  likes_count?: Maybe<Scalars['Int']['output']>;
  modified_count?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Min_Order_By = {
  action?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  comment_html?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Mutation_Response = {
  __typename?: 'spirit_comment_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Comment_Comment>;
};

/** input type for inserting object relation for remote table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Obj_Rel_Insert_Input = {
  data: Spirit_Comment_Comment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Comment_On_Conflict>;
};

/** on_conflict condition type for table "spirit_comment_comment" */
export type Spirit_Comment_Comment_On_Conflict = {
  constraint: Spirit_Comment_Comment_Constraint;
  update_columns?: Array<Spirit_Comment_Comment_Update_Column>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_comment_comment". */
export type Spirit_Comment_Comment_Order_By = {
  action?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  comment_html?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  is_modified?: InputMaybe<Order_By>;
  is_removed?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  spirit_comment_flag_commentflag?: InputMaybe<Spirit_Comment_Flag_Commentflag_Order_By>;
  spirit_comment_flag_flags_aggregate?: InputMaybe<Spirit_Comment_Flag_Flag_Aggregate_Order_By>;
  spirit_comment_history_commenthistories_aggregate?: InputMaybe<Spirit_Comment_History_Commenthistory_Aggregate_Order_By>;
  spirit_comment_like_commentlikes_aggregate?: InputMaybe<Spirit_Comment_Like_Commentlike_Aggregate_Order_By>;
  spirit_comment_poll_commentpolls_aggregate?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Aggregate_Order_By>;
  spirit_topic_notification_topicnotifications_aggregate?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Order_By>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_comment_comment */
export type Spirit_Comment_Comment_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_comment_comment" */
export enum Spirit_Comment_Comment_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Comment = 'comment',
  /** column name */
  CommentHtml = 'comment_html',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  IsModified = 'is_modified',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  LikesCount = 'likes_count',
  /** column name */
  ModifiedCount = 'modified_count',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

/** select "spirit_comment_comment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spirit_comment_comment" */
export enum Spirit_Comment_Comment_Select_Column_Spirit_Comment_Comment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsModified = 'is_modified',
  /** column name */
  IsRemoved = 'is_removed'
}

/** select "spirit_comment_comment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spirit_comment_comment" */
export enum Spirit_Comment_Comment_Select_Column_Spirit_Comment_Comment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsModified = 'is_modified',
  /** column name */
  IsRemoved = 'is_removed'
}

/** input type for updating data in table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Set_Input = {
  action?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_html?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip_address?: InputMaybe<Scalars['inet']['input']>;
  is_modified?: InputMaybe<Scalars['Boolean']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  likes_count?: InputMaybe<Scalars['Int']['input']>;
  modified_count?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Comment_Comment_Stddev_Fields = {
  __typename?: 'spirit_comment_comment_stddev_fields';
  action?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  likes_count?: Maybe<Scalars['Float']['output']>;
  modified_count?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Stddev_Order_By = {
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Comment_Comment_Stddev_Pop_Fields = {
  __typename?: 'spirit_comment_comment_stddev_pop_fields';
  action?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  likes_count?: Maybe<Scalars['Float']['output']>;
  modified_count?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Stddev_Pop_Order_By = {
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Comment_Comment_Stddev_Samp_Fields = {
  __typename?: 'spirit_comment_comment_stddev_samp_fields';
  action?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  likes_count?: Maybe<Scalars['Float']['output']>;
  modified_count?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Stddev_Samp_Order_By = {
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Comment_Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Comment_Comment_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_html?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip_address?: InputMaybe<Scalars['inet']['input']>;
  is_modified?: InputMaybe<Scalars['Boolean']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  likes_count?: InputMaybe<Scalars['Int']['input']>;
  modified_count?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Comment_Comment_Sum_Fields = {
  __typename?: 'spirit_comment_comment_sum_fields';
  action?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  likes_count?: Maybe<Scalars['Int']['output']>;
  modified_count?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Sum_Order_By = {
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_comment_comment" */
export enum Spirit_Comment_Comment_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Comment = 'comment',
  /** column name */
  CommentHtml = 'comment_html',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  IsModified = 'is_modified',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  LikesCount = 'likes_count',
  /** column name */
  ModifiedCount = 'modified_count',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

export type Spirit_Comment_Comment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Comment_Comment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Comment_Comment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Comment_Comment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Comment_Comment_Var_Pop_Fields = {
  __typename?: 'spirit_comment_comment_var_pop_fields';
  action?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  likes_count?: Maybe<Scalars['Float']['output']>;
  modified_count?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Var_Pop_Order_By = {
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Comment_Comment_Var_Samp_Fields = {
  __typename?: 'spirit_comment_comment_var_samp_fields';
  action?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  likes_count?: Maybe<Scalars['Float']['output']>;
  modified_count?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Var_Samp_Order_By = {
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Comment_Comment_Variance_Fields = {
  __typename?: 'spirit_comment_comment_variance_fields';
  action?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  likes_count?: Maybe<Scalars['Float']['output']>;
  modified_count?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_comment_comment" */
export type Spirit_Comment_Comment_Variance_Order_By = {
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  modified_count?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag = {
  __typename?: 'spirit_comment_flag_commentflag';
  comment_id: Scalars['Int']['output'];
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_closed: Scalars['Boolean']['output'];
  moderator_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  spirit_comment_comment: Spirit_Comment_Comment;
  /** An object relationship */
  users_user?: Maybe<Users_User>;
};

/** aggregated selection of "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Aggregate = {
  __typename?: 'spirit_comment_flag_commentflag_aggregate';
  aggregate?: Maybe<Spirit_Comment_Flag_Commentflag_Aggregate_Fields>;
  nodes: Array<Spirit_Comment_Flag_Commentflag>;
};

export type Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spirit_Comment_Flag_Commentflag_Select_Column_Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spirit_Comment_Flag_Commentflag_Select_Column_Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Aggregate_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_aggregate_fields';
  avg?: Maybe<Spirit_Comment_Flag_Commentflag_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Comment_Flag_Commentflag_Max_Fields>;
  min?: Maybe<Spirit_Comment_Flag_Commentflag_Min_Fields>;
  stddev?: Maybe<Spirit_Comment_Flag_Commentflag_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Comment_Flag_Commentflag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Comment_Flag_Commentflag_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Comment_Flag_Commentflag_Sum_Fields>;
  var_pop?: Maybe<Spirit_Comment_Flag_Commentflag_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Comment_Flag_Commentflag_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Comment_Flag_Commentflag_Variance_Fields>;
};


/** aggregate fields of "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Comment_Flag_Commentflag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Comment_Flag_Commentflag_Max_Order_By>;
  min?: InputMaybe<Spirit_Comment_Flag_Commentflag_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Comment_Flag_Commentflag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Comment_Flag_Commentflag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Comment_Flag_Commentflag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Comment_Flag_Commentflag_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Comment_Flag_Commentflag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Comment_Flag_Commentflag_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Comment_Flag_Commentflag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Comment_Flag_Commentflag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Flag_Commentflag_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Comment_Flag_Commentflag_Avg_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_avg_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Avg_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_comment_flag_commentflag". All fields are combined with a logical 'AND'. */
export type Spirit_Comment_Flag_Commentflag_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Bool_Exp>>;
  comment_id?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_closed?: InputMaybe<Boolean_Comparison_Exp>;
  moderator_id?: InputMaybe<Int_Comparison_Exp>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_comment_flag_commentflag" */
export enum Spirit_Comment_Flag_Commentflag_Constraint {
  /** unique or primary key constraint on columns "comment_id" */
  SpiritCommentFlagCommentflagCommentIdKey = 'spirit_comment_flag_commentflag_comment_id_key',
  /** unique or primary key constraint on columns "id" */
  SpiritCommentFlagCommentflagPkey = 'spirit_comment_flag_commentflag_pkey'
}

/** input type for incrementing numeric columns in table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Inc_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  moderator_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Insert_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  moderator_id?: InputMaybe<Scalars['Int']['input']>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Obj_Rel_Insert_Input>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Comment_Flag_Commentflag_Max_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_max_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  moderator_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Max_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Comment_Flag_Commentflag_Min_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_min_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  moderator_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Min_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Mutation_Response = {
  __typename?: 'spirit_comment_flag_commentflag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Comment_Flag_Commentflag>;
};

/** input type for inserting object relation for remote table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Obj_Rel_Insert_Input = {
  data: Spirit_Comment_Flag_Commentflag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Flag_Commentflag_On_Conflict>;
};

/** on_conflict condition type for table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_On_Conflict = {
  constraint: Spirit_Comment_Flag_Commentflag_Constraint;
  update_columns?: Array<Spirit_Comment_Flag_Commentflag_Update_Column>;
  where?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_comment_flag_commentflag". */
export type Spirit_Comment_Flag_Commentflag_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_closed?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_comment_flag_commentflag */
export type Spirit_Comment_Flag_Commentflag_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_comment_flag_commentflag" */
export enum Spirit_Comment_Flag_Commentflag_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  ModeratorId = 'moderator_id'
}

/** select "spirit_comment_flag_commentflag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spirit_comment_flag_commentflag" */
export enum Spirit_Comment_Flag_Commentflag_Select_Column_Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed'
}

/** select "spirit_comment_flag_commentflag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spirit_comment_flag_commentflag" */
export enum Spirit_Comment_Flag_Commentflag_Select_Column_Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed'
}

/** input type for updating data in table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Set_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  moderator_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Comment_Flag_Commentflag_Stddev_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_stddev_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Stddev_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Comment_Flag_Commentflag_Stddev_Pop_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_stddev_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Stddev_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Comment_Flag_Commentflag_Stddev_Samp_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_stddev_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Stddev_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Comment_Flag_Commentflag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Comment_Flag_Commentflag_Stream_Cursor_Value_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  moderator_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Comment_Flag_Commentflag_Sum_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_sum_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  moderator_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Sum_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_comment_flag_commentflag" */
export enum Spirit_Comment_Flag_Commentflag_Update_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  ModeratorId = 'moderator_id'
}

export type Spirit_Comment_Flag_Commentflag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Comment_Flag_Commentflag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Comment_Flag_Commentflag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Comment_Flag_Commentflag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Comment_Flag_Commentflag_Var_Pop_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_var_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Var_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Comment_Flag_Commentflag_Var_Samp_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_var_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Var_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Comment_Flag_Commentflag_Variance_Fields = {
  __typename?: 'spirit_comment_flag_commentflag_variance_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_comment_flag_commentflag" */
export type Spirit_Comment_Flag_Commentflag_Variance_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag = {
  __typename?: 'spirit_comment_flag_flag';
  body: Scalars['String']['output'];
  comment_id: Scalars['Int']['output'];
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
  /** An object relationship */
  spirit_comment_comment: Spirit_Comment_Comment;
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Aggregate = {
  __typename?: 'spirit_comment_flag_flag_aggregate';
  aggregate?: Maybe<Spirit_Comment_Flag_Flag_Aggregate_Fields>;
  nodes: Array<Spirit_Comment_Flag_Flag>;
};

export type Spirit_Comment_Flag_Flag_Aggregate_Bool_Exp = {
  count?: InputMaybe<Spirit_Comment_Flag_Flag_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Comment_Flag_Flag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Aggregate_Fields = {
  __typename?: 'spirit_comment_flag_flag_aggregate_fields';
  avg?: Maybe<Spirit_Comment_Flag_Flag_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Comment_Flag_Flag_Max_Fields>;
  min?: Maybe<Spirit_Comment_Flag_Flag_Min_Fields>;
  stddev?: Maybe<Spirit_Comment_Flag_Flag_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Comment_Flag_Flag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Comment_Flag_Flag_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Comment_Flag_Flag_Sum_Fields>;
  var_pop?: Maybe<Spirit_Comment_Flag_Flag_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Comment_Flag_Flag_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Comment_Flag_Flag_Variance_Fields>;
};


/** aggregate fields of "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Comment_Flag_Flag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Comment_Flag_Flag_Max_Order_By>;
  min?: InputMaybe<Spirit_Comment_Flag_Flag_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Comment_Flag_Flag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Comment_Flag_Flag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Comment_Flag_Flag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Comment_Flag_Flag_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Comment_Flag_Flag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Comment_Flag_Flag_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Comment_Flag_Flag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Comment_Flag_Flag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Flag_Flag_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Comment_Flag_Flag_Avg_Fields = {
  __typename?: 'spirit_comment_flag_flag_avg_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Avg_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_comment_flag_flag". All fields are combined with a logical 'AND'. */
export type Spirit_Comment_Flag_Flag_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  comment_id?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  reason?: InputMaybe<Int_Comparison_Exp>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_comment_flag_flag" */
export enum Spirit_Comment_Flag_Flag_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpiritCommentFlagFlagPkey = 'spirit_comment_flag_flag_pkey',
  /** unique or primary key constraint on columns "comment_id", "user_id" */
  SpiritCommentFlagFlagUserIdCommentId_900c59f8Uniq = 'spirit_comment_flag_flag_user_id_comment_id_900c59f8_uniq'
}

/** input type for incrementing numeric columns in table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Inc_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['Int']['input']>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Comment_Flag_Flag_Max_Fields = {
  __typename?: 'spirit_comment_flag_flag_max_fields';
  body?: Maybe<Scalars['String']['output']>;
  comment_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Comment_Flag_Flag_Min_Fields = {
  __typename?: 'spirit_comment_flag_flag_min_fields';
  body?: Maybe<Scalars['String']['output']>;
  comment_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Mutation_Response = {
  __typename?: 'spirit_comment_flag_flag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Comment_Flag_Flag>;
};

/** on_conflict condition type for table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_On_Conflict = {
  constraint: Spirit_Comment_Flag_Flag_Constraint;
  update_columns?: Array<Spirit_Comment_Flag_Flag_Update_Column>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_comment_flag_flag". */
export type Spirit_Comment_Flag_Flag_Order_By = {
  body?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_comment_flag_flag */
export type Spirit_Comment_Flag_Flag_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_comment_flag_flag" */
export enum Spirit_Comment_Flag_Flag_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Comment_Flag_Flag_Stddev_Fields = {
  __typename?: 'spirit_comment_flag_flag_stddev_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Stddev_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Comment_Flag_Flag_Stddev_Pop_Fields = {
  __typename?: 'spirit_comment_flag_flag_stddev_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Stddev_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Comment_Flag_Flag_Stddev_Samp_Fields = {
  __typename?: 'spirit_comment_flag_flag_stddev_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Stddev_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Comment_Flag_Flag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Comment_Flag_Flag_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Comment_Flag_Flag_Sum_Fields = {
  __typename?: 'spirit_comment_flag_flag_sum_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Sum_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_comment_flag_flag" */
export enum Spirit_Comment_Flag_Flag_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  UserId = 'user_id'
}

export type Spirit_Comment_Flag_Flag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Comment_Flag_Flag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Comment_Flag_Flag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Comment_Flag_Flag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Comment_Flag_Flag_Var_Pop_Fields = {
  __typename?: 'spirit_comment_flag_flag_var_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Var_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Comment_Flag_Flag_Var_Samp_Fields = {
  __typename?: 'spirit_comment_flag_flag_var_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Var_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Comment_Flag_Flag_Variance_Fields = {
  __typename?: 'spirit_comment_flag_flag_variance_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_comment_flag_flag" */
export type Spirit_Comment_Flag_Flag_Variance_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory = {
  __typename?: 'spirit_comment_history_commenthistory';
  comment_fk_id: Scalars['Int']['output'];
  comment_html: Scalars['String']['output'];
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  spirit_comment_comment: Spirit_Comment_Comment;
};

/** aggregated selection of "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Aggregate = {
  __typename?: 'spirit_comment_history_commenthistory_aggregate';
  aggregate?: Maybe<Spirit_Comment_History_Commenthistory_Aggregate_Fields>;
  nodes: Array<Spirit_Comment_History_Commenthistory>;
};

export type Spirit_Comment_History_Commenthistory_Aggregate_Bool_Exp = {
  count?: InputMaybe<Spirit_Comment_History_Commenthistory_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Comment_History_Commenthistory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Aggregate_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_aggregate_fields';
  avg?: Maybe<Spirit_Comment_History_Commenthistory_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Comment_History_Commenthistory_Max_Fields>;
  min?: Maybe<Spirit_Comment_History_Commenthistory_Min_Fields>;
  stddev?: Maybe<Spirit_Comment_History_Commenthistory_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Comment_History_Commenthistory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Comment_History_Commenthistory_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Comment_History_Commenthistory_Sum_Fields>;
  var_pop?: Maybe<Spirit_Comment_History_Commenthistory_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Comment_History_Commenthistory_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Comment_History_Commenthistory_Variance_Fields>;
};


/** aggregate fields of "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Comment_History_Commenthistory_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Comment_History_Commenthistory_Max_Order_By>;
  min?: InputMaybe<Spirit_Comment_History_Commenthistory_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Comment_History_Commenthistory_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Comment_History_Commenthistory_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Comment_History_Commenthistory_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Comment_History_Commenthistory_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Comment_History_Commenthistory_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Comment_History_Commenthistory_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Comment_History_Commenthistory_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Comment_History_Commenthistory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_History_Commenthistory_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Comment_History_Commenthistory_Avg_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_avg_fields';
  comment_fk_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Avg_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_comment_history_commenthistory". All fields are combined with a logical 'AND'. */
export type Spirit_Comment_History_Commenthistory_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Comment_History_Commenthistory_Bool_Exp>>;
  comment_fk_id?: InputMaybe<Int_Comparison_Exp>;
  comment_html?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_comment_history_commenthistory" */
export enum Spirit_Comment_History_Commenthistory_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpiritCommentHistoryCommenthistoryPkey = 'spirit_comment_history_commenthistory_pkey'
}

/** input type for incrementing numeric columns in table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Inc_Input = {
  comment_fk_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Insert_Input = {
  comment_fk_id?: InputMaybe<Scalars['Int']['input']>;
  comment_html?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Comment_History_Commenthistory_Max_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_max_fields';
  comment_fk_id?: Maybe<Scalars['Int']['output']>;
  comment_html?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Max_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  comment_html?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Comment_History_Commenthistory_Min_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_min_fields';
  comment_fk_id?: Maybe<Scalars['Int']['output']>;
  comment_html?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Min_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  comment_html?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Mutation_Response = {
  __typename?: 'spirit_comment_history_commenthistory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Comment_History_Commenthistory>;
};

/** on_conflict condition type for table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_On_Conflict = {
  constraint: Spirit_Comment_History_Commenthistory_Constraint;
  update_columns?: Array<Spirit_Comment_History_Commenthistory_Update_Column>;
  where?: InputMaybe<Spirit_Comment_History_Commenthistory_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_comment_history_commenthistory". */
export type Spirit_Comment_History_Commenthistory_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  comment_html?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Order_By>;
};

/** primary key columns input for table: spirit_comment_history_commenthistory */
export type Spirit_Comment_History_Commenthistory_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_comment_history_commenthistory" */
export enum Spirit_Comment_History_Commenthistory_Select_Column {
  /** column name */
  CommentFkId = 'comment_fk_id',
  /** column name */
  CommentHtml = 'comment_html',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Set_Input = {
  comment_fk_id?: InputMaybe<Scalars['Int']['input']>;
  comment_html?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Comment_History_Commenthistory_Stddev_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_stddev_fields';
  comment_fk_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Stddev_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Comment_History_Commenthistory_Stddev_Pop_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_stddev_pop_fields';
  comment_fk_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Stddev_Pop_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Comment_History_Commenthistory_Stddev_Samp_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_stddev_samp_fields';
  comment_fk_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Stddev_Samp_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Comment_History_Commenthistory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Comment_History_Commenthistory_Stream_Cursor_Value_Input = {
  comment_fk_id?: InputMaybe<Scalars['Int']['input']>;
  comment_html?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Comment_History_Commenthistory_Sum_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_sum_fields';
  comment_fk_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Sum_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_comment_history_commenthistory" */
export enum Spirit_Comment_History_Commenthistory_Update_Column {
  /** column name */
  CommentFkId = 'comment_fk_id',
  /** column name */
  CommentHtml = 'comment_html',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id'
}

export type Spirit_Comment_History_Commenthistory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Comment_History_Commenthistory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Comment_History_Commenthistory_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Comment_History_Commenthistory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Comment_History_Commenthistory_Var_Pop_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_var_pop_fields';
  comment_fk_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Var_Pop_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Comment_History_Commenthistory_Var_Samp_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_var_samp_fields';
  comment_fk_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Var_Samp_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Comment_History_Commenthistory_Variance_Fields = {
  __typename?: 'spirit_comment_history_commenthistory_variance_fields';
  comment_fk_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_comment_history_commenthistory" */
export type Spirit_Comment_History_Commenthistory_Variance_Order_By = {
  comment_fk_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike = {
  __typename?: 'spirit_comment_like_commentlike';
  comment_id: Scalars['Int']['output'];
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  spirit_comment_comment: Spirit_Comment_Comment;
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Aggregate = {
  __typename?: 'spirit_comment_like_commentlike_aggregate';
  aggregate?: Maybe<Spirit_Comment_Like_Commentlike_Aggregate_Fields>;
  nodes: Array<Spirit_Comment_Like_Commentlike>;
};

export type Spirit_Comment_Like_Commentlike_Aggregate_Bool_Exp = {
  count?: InputMaybe<Spirit_Comment_Like_Commentlike_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Comment_Like_Commentlike_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Aggregate_Fields = {
  __typename?: 'spirit_comment_like_commentlike_aggregate_fields';
  avg?: Maybe<Spirit_Comment_Like_Commentlike_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Comment_Like_Commentlike_Max_Fields>;
  min?: Maybe<Spirit_Comment_Like_Commentlike_Min_Fields>;
  stddev?: Maybe<Spirit_Comment_Like_Commentlike_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Comment_Like_Commentlike_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Comment_Like_Commentlike_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Comment_Like_Commentlike_Sum_Fields>;
  var_pop?: Maybe<Spirit_Comment_Like_Commentlike_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Comment_Like_Commentlike_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Comment_Like_Commentlike_Variance_Fields>;
};


/** aggregate fields of "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Comment_Like_Commentlike_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Comment_Like_Commentlike_Max_Order_By>;
  min?: InputMaybe<Spirit_Comment_Like_Commentlike_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Comment_Like_Commentlike_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Comment_Like_Commentlike_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Comment_Like_Commentlike_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Comment_Like_Commentlike_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Comment_Like_Commentlike_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Comment_Like_Commentlike_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Comment_Like_Commentlike_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Comment_Like_Commentlike_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Like_Commentlike_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Comment_Like_Commentlike_Avg_Fields = {
  __typename?: 'spirit_comment_like_commentlike_avg_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Avg_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_comment_like_commentlike". All fields are combined with a logical 'AND'. */
export type Spirit_Comment_Like_Commentlike_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Bool_Exp>>;
  comment_id?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_comment_like_commentlike" */
export enum Spirit_Comment_Like_Commentlike_Constraint {
  /** unique or primary key constraint on columns "comment_id", "user_id" */
  SpiritCommentLikeCommUserIdCommentId_32b1f85fUniq = 'spirit_comment_like_comm_user_id_comment_id_32b1f85f_uniq',
  /** unique or primary key constraint on columns "id" */
  SpiritCommentLikeCommentlikePkey = 'spirit_comment_like_commentlike_pkey'
}

/** input type for incrementing numeric columns in table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Inc_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Insert_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Comment_Like_Commentlike_Max_Fields = {
  __typename?: 'spirit_comment_like_commentlike_max_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Max_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Comment_Like_Commentlike_Min_Fields = {
  __typename?: 'spirit_comment_like_commentlike_min_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Min_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Mutation_Response = {
  __typename?: 'spirit_comment_like_commentlike_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Comment_Like_Commentlike>;
};

/** on_conflict condition type for table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_On_Conflict = {
  constraint: Spirit_Comment_Like_Commentlike_Constraint;
  update_columns?: Array<Spirit_Comment_Like_Commentlike_Update_Column>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_comment_like_commentlike". */
export type Spirit_Comment_Like_Commentlike_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_comment_like_commentlike */
export type Spirit_Comment_Like_Commentlike_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_comment_like_commentlike" */
export enum Spirit_Comment_Like_Commentlike_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Set_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Comment_Like_Commentlike_Stddev_Fields = {
  __typename?: 'spirit_comment_like_commentlike_stddev_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Stddev_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Comment_Like_Commentlike_Stddev_Pop_Fields = {
  __typename?: 'spirit_comment_like_commentlike_stddev_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Stddev_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Comment_Like_Commentlike_Stddev_Samp_Fields = {
  __typename?: 'spirit_comment_like_commentlike_stddev_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Stddev_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Comment_Like_Commentlike_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Comment_Like_Commentlike_Stream_Cursor_Value_Input = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Comment_Like_Commentlike_Sum_Fields = {
  __typename?: 'spirit_comment_like_commentlike_sum_fields';
  comment_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Sum_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_comment_like_commentlike" */
export enum Spirit_Comment_Like_Commentlike_Update_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Spirit_Comment_Like_Commentlike_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Comment_Like_Commentlike_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Comment_Like_Commentlike_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Comment_Like_Commentlike_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Comment_Like_Commentlike_Var_Pop_Fields = {
  __typename?: 'spirit_comment_like_commentlike_var_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Var_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Comment_Like_Commentlike_Var_Samp_Fields = {
  __typename?: 'spirit_comment_like_commentlike_var_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Var_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Comment_Like_Commentlike_Variance_Fields = {
  __typename?: 'spirit_comment_like_commentlike_variance_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_comment_like_commentlike" */
export type Spirit_Comment_Like_Commentlike_Variance_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll = {
  __typename?: 'spirit_comment_poll_commentpoll';
  choice_max: Scalars['Int']['output'];
  choice_min: Scalars['Int']['output'];
  close_at?: Maybe<Scalars['timestamptz']['output']>;
  comment_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_removed: Scalars['Boolean']['output'];
  mode: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  spirit_comment_comment: Spirit_Comment_Comment;
  /** An array relationship */
  spirit_comment_poll_commentpollchoices: Array<Spirit_Comment_Poll_Commentpollchoice>;
  /** An aggregate relationship */
  spirit_comment_poll_commentpollchoices_aggregate: Spirit_Comment_Poll_Commentpollchoice_Aggregate;
  title: Scalars['String']['output'];
};


/** columns and relationships of "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_CommentpollSpirit_Comment_Poll_CommentpollchoicesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_CommentpollSpirit_Comment_Poll_Commentpollchoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
};

/** aggregated selection of "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Aggregate = {
  __typename?: 'spirit_comment_poll_commentpoll_aggregate';
  aggregate?: Maybe<Spirit_Comment_Poll_Commentpoll_Aggregate_Fields>;
  nodes: Array<Spirit_Comment_Poll_Commentpoll>;
};

export type Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spirit_Comment_Poll_Commentpoll_Select_Column_Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spirit_Comment_Poll_Commentpoll_Select_Column_Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Aggregate_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_aggregate_fields';
  avg?: Maybe<Spirit_Comment_Poll_Commentpoll_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Comment_Poll_Commentpoll_Max_Fields>;
  min?: Maybe<Spirit_Comment_Poll_Commentpoll_Min_Fields>;
  stddev?: Maybe<Spirit_Comment_Poll_Commentpoll_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Comment_Poll_Commentpoll_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Comment_Poll_Commentpoll_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Comment_Poll_Commentpoll_Sum_Fields>;
  var_pop?: Maybe<Spirit_Comment_Poll_Commentpoll_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Comment_Poll_Commentpoll_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Comment_Poll_Commentpoll_Variance_Fields>;
};


/** aggregate fields of "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Max_Order_By>;
  min?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Comment_Poll_Commentpoll_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpoll_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Comment_Poll_Commentpoll_Avg_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_avg_fields';
  choice_max?: Maybe<Scalars['Float']['output']>;
  choice_min?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Avg_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_comment_poll_commentpoll". All fields are combined with a logical 'AND'. */
export type Spirit_Comment_Poll_Commentpoll_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Comment_Poll_Commentpoll_Bool_Exp>>;
  choice_max?: InputMaybe<Int_Comparison_Exp>;
  choice_min?: InputMaybe<Int_Comparison_Exp>;
  close_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  comment_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_removed?: InputMaybe<Boolean_Comparison_Exp>;
  mode?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  spirit_comment_poll_commentpollchoices?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
  spirit_comment_poll_commentpollchoices_aggregate?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spirit_comment_poll_commentpoll" */
export enum Spirit_Comment_Poll_Commentpoll_Constraint {
  /** unique or primary key constraint on columns "comment_id", "name" */
  SpiritCommentPollCommentpollCommentIdNameB54ee48aUniq = 'spirit_comment_poll_commentpoll_comment_id_name_b54ee48a_uniq',
  /** unique or primary key constraint on columns "id" */
  SpiritCommentPollCommentpollPkey = 'spirit_comment_poll_commentpoll_pkey'
}

/** input type for incrementing numeric columns in table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Inc_Input = {
  choice_max?: InputMaybe<Scalars['Int']['input']>;
  choice_min?: InputMaybe<Scalars['Int']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Insert_Input = {
  choice_max?: InputMaybe<Scalars['Int']['input']>;
  choice_min?: InputMaybe<Scalars['Int']['input']>;
  close_at?: InputMaybe<Scalars['timestamptz']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Obj_Rel_Insert_Input>;
  spirit_comment_poll_commentpollchoices?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Spirit_Comment_Poll_Commentpoll_Max_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_max_fields';
  choice_max?: Maybe<Scalars['Int']['output']>;
  choice_min?: Maybe<Scalars['Int']['output']>;
  close_at?: Maybe<Scalars['timestamptz']['output']>;
  comment_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Max_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  close_at?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Comment_Poll_Commentpoll_Min_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_min_fields';
  choice_max?: Maybe<Scalars['Int']['output']>;
  choice_min?: Maybe<Scalars['Int']['output']>;
  close_at?: Maybe<Scalars['timestamptz']['output']>;
  comment_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Min_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  close_at?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Mutation_Response = {
  __typename?: 'spirit_comment_poll_commentpoll_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Comment_Poll_Commentpoll>;
};

/** input type for inserting object relation for remote table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Obj_Rel_Insert_Input = {
  data: Spirit_Comment_Poll_Commentpoll_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpoll_On_Conflict>;
};

/** on_conflict condition type for table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_On_Conflict = {
  constraint: Spirit_Comment_Poll_Commentpoll_Constraint;
  update_columns?: Array<Spirit_Comment_Poll_Commentpoll_Update_Column>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_comment_poll_commentpoll". */
export type Spirit_Comment_Poll_Commentpoll_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  close_at?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_removed?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Order_By>;
  spirit_comment_poll_commentpollchoices_aggregate?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spirit_comment_poll_commentpoll */
export type Spirit_Comment_Poll_Commentpoll_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_comment_poll_commentpoll" */
export enum Spirit_Comment_Poll_Commentpoll_Select_Column {
  /** column name */
  ChoiceMax = 'choice_max',
  /** column name */
  ChoiceMin = 'choice_min',
  /** column name */
  CloseAt = 'close_at',
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  Mode = 'mode',
  /** column name */
  Name = 'name',
  /** column name */
  Title = 'title'
}

/** select "spirit_comment_poll_commentpoll_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spirit_comment_poll_commentpoll" */
export enum Spirit_Comment_Poll_Commentpoll_Select_Column_Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRemoved = 'is_removed'
}

/** select "spirit_comment_poll_commentpoll_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spirit_comment_poll_commentpoll" */
export enum Spirit_Comment_Poll_Commentpoll_Select_Column_Spirit_Comment_Poll_Commentpoll_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRemoved = 'is_removed'
}

/** input type for updating data in table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Set_Input = {
  choice_max?: InputMaybe<Scalars['Int']['input']>;
  choice_min?: InputMaybe<Scalars['Int']['input']>;
  close_at?: InputMaybe<Scalars['timestamptz']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Comment_Poll_Commentpoll_Stddev_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_stddev_fields';
  choice_max?: Maybe<Scalars['Float']['output']>;
  choice_min?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Stddev_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Comment_Poll_Commentpoll_Stddev_Pop_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_stddev_pop_fields';
  choice_max?: Maybe<Scalars['Float']['output']>;
  choice_min?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Stddev_Pop_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Comment_Poll_Commentpoll_Stddev_Samp_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_stddev_samp_fields';
  choice_max?: Maybe<Scalars['Float']['output']>;
  choice_min?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Stddev_Samp_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Comment_Poll_Commentpoll_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Comment_Poll_Commentpoll_Stream_Cursor_Value_Input = {
  choice_max?: InputMaybe<Scalars['Int']['input']>;
  choice_min?: InputMaybe<Scalars['Int']['input']>;
  close_at?: InputMaybe<Scalars['timestamptz']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Comment_Poll_Commentpoll_Sum_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_sum_fields';
  choice_max?: Maybe<Scalars['Int']['output']>;
  choice_min?: Maybe<Scalars['Int']['output']>;
  comment_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Sum_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_comment_poll_commentpoll" */
export enum Spirit_Comment_Poll_Commentpoll_Update_Column {
  /** column name */
  ChoiceMax = 'choice_max',
  /** column name */
  ChoiceMin = 'choice_min',
  /** column name */
  CloseAt = 'close_at',
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  Mode = 'mode',
  /** column name */
  Name = 'name',
  /** column name */
  Title = 'title'
}

export type Spirit_Comment_Poll_Commentpoll_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Comment_Poll_Commentpoll_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Comment_Poll_Commentpoll_Var_Pop_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_var_pop_fields';
  choice_max?: Maybe<Scalars['Float']['output']>;
  choice_min?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Var_Pop_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Comment_Poll_Commentpoll_Var_Samp_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_var_samp_fields';
  choice_max?: Maybe<Scalars['Float']['output']>;
  choice_min?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Var_Samp_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Comment_Poll_Commentpoll_Variance_Fields = {
  __typename?: 'spirit_comment_poll_commentpoll_variance_fields';
  choice_max?: Maybe<Scalars['Float']['output']>;
  choice_min?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_comment_poll_commentpoll" */
export type Spirit_Comment_Poll_Commentpoll_Variance_Order_By = {
  choice_max?: InputMaybe<Order_By>;
  choice_min?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice = {
  __typename?: 'spirit_comment_poll_commentpollchoice';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_removed: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  poll_id: Scalars['Int']['output'];
  /** An object relationship */
  spirit_comment_poll_commentpoll: Spirit_Comment_Poll_Commentpoll;
  /** An array relationship */
  spirit_comment_poll_commentpollvotes: Array<Spirit_Comment_Poll_Commentpollvote>;
  /** An aggregate relationship */
  spirit_comment_poll_commentpollvotes_aggregate: Spirit_Comment_Poll_Commentpollvote_Aggregate;
  vote_count: Scalars['Int']['output'];
};


/** columns and relationships of "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_CommentpollchoiceSpirit_Comment_Poll_CommentpollvotesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};


/** columns and relationships of "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_CommentpollchoiceSpirit_Comment_Poll_Commentpollvotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};

/** aggregated selection of "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Aggregate = {
  __typename?: 'spirit_comment_poll_commentpollchoice_aggregate';
  aggregate?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Aggregate_Fields>;
  nodes: Array<Spirit_Comment_Poll_Commentpollchoice>;
};

export type Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spirit_Comment_Poll_Commentpollchoice_Select_Column_Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spirit_Comment_Poll_Commentpollchoice_Select_Column_Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Aggregate_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_aggregate_fields';
  avg?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Max_Fields>;
  min?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Min_Fields>;
  stddev?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Sum_Fields>;
  var_pop?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Comment_Poll_Commentpollchoice_Variance_Fields>;
};


/** aggregate fields of "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Max_Order_By>;
  min?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Comment_Poll_Commentpollchoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Avg_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  poll_id?: Maybe<Scalars['Float']['output']>;
  vote_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_comment_poll_commentpollchoice". All fields are combined with a logical 'AND'. */
export type Spirit_Comment_Poll_Commentpollchoice_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_removed?: InputMaybe<Boolean_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
  spirit_comment_poll_commentpoll?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Bool_Exp>;
  spirit_comment_poll_commentpollvotes?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
  spirit_comment_poll_commentpollvotes_aggregate?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp>;
  vote_count?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "spirit_comment_poll_commentpollchoice" */
export enum Spirit_Comment_Poll_Commentpollchoice_Constraint {
  /** unique or primary key constraint on columns "poll_id", "number" */
  SpiritCommentPollCommPollIdNumber_36ccebb7Uniq = 'spirit_comment_poll_comm_poll_id_number_36ccebb7_uniq',
  /** unique or primary key constraint on columns "id" */
  SpiritCommentPollCommentpollchoicePkey = 'spirit_comment_poll_commentpollchoice_pkey'
}

/** input type for incrementing numeric columns in table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  poll_id?: InputMaybe<Scalars['Int']['input']>;
  vote_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  poll_id?: InputMaybe<Scalars['Int']['input']>;
  spirit_comment_poll_commentpoll?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Obj_Rel_Insert_Input>;
  spirit_comment_poll_commentpollvotes?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Arr_Rel_Insert_Input>;
  vote_count?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Max_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  poll_id?: Maybe<Scalars['Int']['output']>;
  vote_count?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Min_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  poll_id?: Maybe<Scalars['Int']['output']>;
  vote_count?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Mutation_Response = {
  __typename?: 'spirit_comment_poll_commentpollchoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Comment_Poll_Commentpollchoice>;
};

/** input type for inserting object relation for remote table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Obj_Rel_Insert_Input = {
  data: Spirit_Comment_Poll_Commentpollchoice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_On_Conflict>;
};

/** on_conflict condition type for table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_On_Conflict = {
  constraint: Spirit_Comment_Poll_Commentpollchoice_Constraint;
  update_columns?: Array<Spirit_Comment_Poll_Commentpollchoice_Update_Column>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_comment_poll_commentpollchoice". */
export type Spirit_Comment_Poll_Commentpollchoice_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_removed?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  spirit_comment_poll_commentpoll?: InputMaybe<Spirit_Comment_Poll_Commentpoll_Order_By>;
  spirit_comment_poll_commentpollvotes_aggregate?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Aggregate_Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spirit_comment_poll_commentpollchoice */
export type Spirit_Comment_Poll_Commentpollchoice_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_comment_poll_commentpollchoice" */
export enum Spirit_Comment_Poll_Commentpollchoice_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  Number = 'number',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  VoteCount = 'vote_count'
}

/** select "spirit_comment_poll_commentpollchoice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spirit_comment_poll_commentpollchoice" */
export enum Spirit_Comment_Poll_Commentpollchoice_Select_Column_Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRemoved = 'is_removed'
}

/** select "spirit_comment_poll_commentpollchoice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spirit_comment_poll_commentpollchoice" */
export enum Spirit_Comment_Poll_Commentpollchoice_Select_Column_Spirit_Comment_Poll_Commentpollchoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRemoved = 'is_removed'
}

/** input type for updating data in table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  poll_id?: InputMaybe<Scalars['Int']['input']>;
  vote_count?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Stddev_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  poll_id?: Maybe<Scalars['Float']['output']>;
  vote_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Stddev_Pop_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  poll_id?: Maybe<Scalars['Float']['output']>;
  vote_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Stddev_Samp_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  poll_id?: Maybe<Scalars['Float']['output']>;
  vote_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Comment_Poll_Commentpollchoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Comment_Poll_Commentpollchoice_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  poll_id?: InputMaybe<Scalars['Int']['input']>;
  vote_count?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Sum_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  poll_id?: Maybe<Scalars['Int']['output']>;
  vote_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_comment_poll_commentpollchoice" */
export enum Spirit_Comment_Poll_Commentpollchoice_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  Number = 'number',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  VoteCount = 'vote_count'
}

export type Spirit_Comment_Poll_Commentpollchoice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Comment_Poll_Commentpollchoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Var_Pop_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  poll_id?: Maybe<Scalars['Float']['output']>;
  vote_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Var_Samp_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  poll_id?: Maybe<Scalars['Float']['output']>;
  vote_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Comment_Poll_Commentpollchoice_Variance_Fields = {
  __typename?: 'spirit_comment_poll_commentpollchoice_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  poll_id?: Maybe<Scalars['Float']['output']>;
  vote_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_comment_poll_commentpollchoice" */
export type Spirit_Comment_Poll_Commentpollchoice_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  vote_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote = {
  __typename?: 'spirit_comment_poll_commentpollvote';
  choice_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_removed: Scalars['Boolean']['output'];
  /** An object relationship */
  spirit_comment_poll_commentpollchoice: Spirit_Comment_Poll_Commentpollchoice;
  /** An object relationship */
  users_user: Users_User;
  voter_id: Scalars['Int']['output'];
};

/** aggregated selection of "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Aggregate = {
  __typename?: 'spirit_comment_poll_commentpollvote_aggregate';
  aggregate?: Maybe<Spirit_Comment_Poll_Commentpollvote_Aggregate_Fields>;
  nodes: Array<Spirit_Comment_Poll_Commentpollvote>;
};

export type Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spirit_Comment_Poll_Commentpollvote_Select_Column_Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spirit_Comment_Poll_Commentpollvote_Select_Column_Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Aggregate_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_aggregate_fields';
  avg?: Maybe<Spirit_Comment_Poll_Commentpollvote_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Comment_Poll_Commentpollvote_Max_Fields>;
  min?: Maybe<Spirit_Comment_Poll_Commentpollvote_Min_Fields>;
  stddev?: Maybe<Spirit_Comment_Poll_Commentpollvote_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Comment_Poll_Commentpollvote_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Comment_Poll_Commentpollvote_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Comment_Poll_Commentpollvote_Sum_Fields>;
  var_pop?: Maybe<Spirit_Comment_Poll_Commentpollvote_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Comment_Poll_Commentpollvote_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Comment_Poll_Commentpollvote_Variance_Fields>;
};


/** aggregate fields of "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Max_Order_By>;
  min?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Comment_Poll_Commentpollvote_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Comment_Poll_Commentpollvote_Avg_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_avg_fields';
  choice_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Avg_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_comment_poll_commentpollvote". All fields are combined with a logical 'AND'. */
export type Spirit_Comment_Poll_Commentpollvote_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>>;
  choice_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_removed?: InputMaybe<Boolean_Comparison_Exp>;
  spirit_comment_poll_commentpollchoice?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Bool_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
  voter_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "spirit_comment_poll_commentpollvote" */
export enum Spirit_Comment_Poll_Commentpollvote_Constraint {
  /** unique or primary key constraint on columns "voter_id", "choice_id" */
  SpiritCommentPollCommVoterIdChoiceIdB2b15b1fUniq = 'spirit_comment_poll_comm_voter_id_choice_id_b2b15b1f_uniq',
  /** unique or primary key constraint on columns "id" */
  SpiritCommentPollCommentpollvotePkey = 'spirit_comment_poll_commentpollvote_pkey'
}

/** input type for incrementing numeric columns in table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Inc_Input = {
  choice_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  voter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Insert_Input = {
  choice_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  spirit_comment_poll_commentpollchoice?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Obj_Rel_Insert_Input>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
  voter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Spirit_Comment_Poll_Commentpollvote_Max_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_max_fields';
  choice_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  voter_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Max_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Comment_Poll_Commentpollvote_Min_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_min_fields';
  choice_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  voter_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Min_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Mutation_Response = {
  __typename?: 'spirit_comment_poll_commentpollvote_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Comment_Poll_Commentpollvote>;
};

/** on_conflict condition type for table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_On_Conflict = {
  constraint: Spirit_Comment_Poll_Commentpollvote_Constraint;
  update_columns?: Array<Spirit_Comment_Poll_Commentpollvote_Update_Column>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_comment_poll_commentpollvote". */
export type Spirit_Comment_Poll_Commentpollvote_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_removed?: InputMaybe<Order_By>;
  spirit_comment_poll_commentpollchoice?: InputMaybe<Spirit_Comment_Poll_Commentpollchoice_Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spirit_comment_poll_commentpollvote */
export type Spirit_Comment_Poll_Commentpollvote_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_comment_poll_commentpollvote" */
export enum Spirit_Comment_Poll_Commentpollvote_Select_Column {
  /** column name */
  ChoiceId = 'choice_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  VoterId = 'voter_id'
}

/** select "spirit_comment_poll_commentpollvote_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spirit_comment_poll_commentpollvote" */
export enum Spirit_Comment_Poll_Commentpollvote_Select_Column_Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRemoved = 'is_removed'
}

/** select "spirit_comment_poll_commentpollvote_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spirit_comment_poll_commentpollvote" */
export enum Spirit_Comment_Poll_Commentpollvote_Select_Column_Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRemoved = 'is_removed'
}

/** input type for updating data in table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Set_Input = {
  choice_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  voter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Comment_Poll_Commentpollvote_Stddev_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_stddev_fields';
  choice_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Stddev_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Comment_Poll_Commentpollvote_Stddev_Pop_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_stddev_pop_fields';
  choice_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Stddev_Pop_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Comment_Poll_Commentpollvote_Stddev_Samp_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_stddev_samp_fields';
  choice_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Stddev_Samp_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Comment_Poll_Commentpollvote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Comment_Poll_Commentpollvote_Stream_Cursor_Value_Input = {
  choice_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  voter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Comment_Poll_Commentpollvote_Sum_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_sum_fields';
  choice_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  voter_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Sum_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_comment_poll_commentpollvote" */
export enum Spirit_Comment_Poll_Commentpollvote_Update_Column {
  /** column name */
  ChoiceId = 'choice_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  VoterId = 'voter_id'
}

export type Spirit_Comment_Poll_Commentpollvote_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Comment_Poll_Commentpollvote_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Comment_Poll_Commentpollvote_Var_Pop_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_var_pop_fields';
  choice_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Var_Pop_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Comment_Poll_Commentpollvote_Var_Samp_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_var_samp_fields';
  choice_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Var_Samp_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Comment_Poll_Commentpollvote_Variance_Fields = {
  __typename?: 'spirit_comment_poll_commentpollvote_variance_fields';
  choice_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_comment_poll_commentpollvote" */
export type Spirit_Comment_Poll_Commentpollvote_Variance_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_rl_cache" */
export type Spirit_Rl_Cache = {
  __typename?: 'spirit_rl_cache';
  cache_key: Scalars['String']['output'];
  expires: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "spirit_rl_cache" */
export type Spirit_Rl_Cache_Aggregate = {
  __typename?: 'spirit_rl_cache_aggregate';
  aggregate?: Maybe<Spirit_Rl_Cache_Aggregate_Fields>;
  nodes: Array<Spirit_Rl_Cache>;
};

/** aggregate fields of "spirit_rl_cache" */
export type Spirit_Rl_Cache_Aggregate_Fields = {
  __typename?: 'spirit_rl_cache_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Rl_Cache_Max_Fields>;
  min?: Maybe<Spirit_Rl_Cache_Min_Fields>;
};


/** aggregate fields of "spirit_rl_cache" */
export type Spirit_Rl_Cache_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Rl_Cache_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "spirit_rl_cache". All fields are combined with a logical 'AND'. */
export type Spirit_Rl_Cache_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Rl_Cache_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Rl_Cache_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Rl_Cache_Bool_Exp>>;
  cache_key?: InputMaybe<String_Comparison_Exp>;
  expires?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spirit_rl_cache" */
export enum Spirit_Rl_Cache_Constraint {
  /** unique or primary key constraint on columns "cache_key" */
  SpiritRlCachePkey = 'spirit_rl_cache_pkey'
}

/** input type for inserting data into table "spirit_rl_cache" */
export type Spirit_Rl_Cache_Insert_Input = {
  cache_key?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Spirit_Rl_Cache_Max_Fields = {
  __typename?: 'spirit_rl_cache_max_fields';
  cache_key?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Spirit_Rl_Cache_Min_Fields = {
  __typename?: 'spirit_rl_cache_min_fields';
  cache_key?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "spirit_rl_cache" */
export type Spirit_Rl_Cache_Mutation_Response = {
  __typename?: 'spirit_rl_cache_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Rl_Cache>;
};

/** on_conflict condition type for table "spirit_rl_cache" */
export type Spirit_Rl_Cache_On_Conflict = {
  constraint: Spirit_Rl_Cache_Constraint;
  update_columns?: Array<Spirit_Rl_Cache_Update_Column>;
  where?: InputMaybe<Spirit_Rl_Cache_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_rl_cache". */
export type Spirit_Rl_Cache_Order_By = {
  cache_key?: InputMaybe<Order_By>;
  expires?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spirit_rl_cache */
export type Spirit_Rl_Cache_Pk_Columns_Input = {
  cache_key: Scalars['String']['input'];
};

/** select columns of table "spirit_rl_cache" */
export enum Spirit_Rl_Cache_Select_Column {
  /** column name */
  CacheKey = 'cache_key',
  /** column name */
  Expires = 'expires',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "spirit_rl_cache" */
export type Spirit_Rl_Cache_Set_Input = {
  cache_key?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "spirit_rl_cache" */
export type Spirit_Rl_Cache_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Rl_Cache_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Rl_Cache_Stream_Cursor_Value_Input = {
  cache_key?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "spirit_rl_cache" */
export enum Spirit_Rl_Cache_Update_Column {
  /** column name */
  CacheKey = 'cache_key',
  /** column name */
  Expires = 'expires',
  /** column name */
  Value = 'value'
}

export type Spirit_Rl_Cache_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Rl_Cache_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Rl_Cache_Bool_Exp;
};

/** columns and relationships of "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite = {
  __typename?: 'spirit_topic_favorite_topicfavorite';
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  spirit_topic_topic: Spirit_Topic_Topic;
  topic_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Aggregate = {
  __typename?: 'spirit_topic_favorite_topicfavorite_aggregate';
  aggregate?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Aggregate_Fields>;
  nodes: Array<Spirit_Topic_Favorite_Topicfavorite>;
};

export type Spirit_Topic_Favorite_Topicfavorite_Aggregate_Bool_Exp = {
  count?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Topic_Favorite_Topicfavorite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Aggregate_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_aggregate_fields';
  avg?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Max_Fields>;
  min?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Min_Fields>;
  stddev?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Sum_Fields>;
  var_pop?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Topic_Favorite_Topicfavorite_Variance_Fields>;
};


/** aggregate fields of "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Max_Order_By>;
  min?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Topic_Favorite_Topicfavorite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Avg_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_topic_favorite_topicfavorite". All fields are combined with a logical 'AND'. */
export type Spirit_Topic_Favorite_Topicfavorite_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  topic_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_topic_favorite_topicfavorite" */
export enum Spirit_Topic_Favorite_Topicfavorite_Constraint {
  /** unique or primary key constraint on columns "user_id", "topic_id" */
  SpiritTopicFavoriteToUserIdTopicId_167416f4Uniq = 'spirit_topic_favorite_to_user_id_topic_id_167416f4_uniq',
  /** unique or primary key constraint on columns "id" */
  SpiritTopicFavoriteTopicfavoritePkey = 'spirit_topic_favorite_topicfavorite_pkey'
}

/** input type for incrementing numeric columns in table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Insert_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Obj_Rel_Insert_Input>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Max_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_max_fields';
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Min_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_min_fields';
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Mutation_Response = {
  __typename?: 'spirit_topic_favorite_topicfavorite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Topic_Favorite_Topicfavorite>;
};

/** on_conflict condition type for table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_On_Conflict = {
  constraint: Spirit_Topic_Favorite_Topicfavorite_Constraint;
  update_columns?: Array<Spirit_Topic_Favorite_Topicfavorite_Update_Column>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_topic_favorite_topicfavorite". */
export type Spirit_Topic_Favorite_Topicfavorite_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_topic_favorite_topicfavorite */
export type Spirit_Topic_Favorite_Topicfavorite_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_topic_favorite_topicfavorite" */
export enum Spirit_Topic_Favorite_Topicfavorite_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Set_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Stddev_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Stddev_Pop_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Stddev_Samp_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Topic_Favorite_Topicfavorite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Topic_Favorite_Topicfavorite_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Sum_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_topic_favorite_topicfavorite" */
export enum Spirit_Topic_Favorite_Topicfavorite_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

export type Spirit_Topic_Favorite_Topicfavorite_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Topic_Favorite_Topicfavorite_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Var_Pop_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Var_Samp_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Topic_Favorite_Topicfavorite_Variance_Fields = {
  __typename?: 'spirit_topic_favorite_topicfavorite_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_topic_favorite_topicfavorite" */
export type Spirit_Topic_Favorite_Topicfavorite_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification = {
  __typename?: 'spirit_topic_notification_topicnotification';
  action: Scalars['Int']['output'];
  comment_id: Scalars['Int']['output'];
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  is_read: Scalars['Boolean']['output'];
  /** An object relationship */
  spirit_comment_comment: Spirit_Comment_Comment;
  /** An object relationship */
  spirit_topic_topic: Spirit_Topic_Topic;
  topic_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Aggregate = {
  __typename?: 'spirit_topic_notification_topicnotification_aggregate';
  aggregate?: Maybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Fields>;
  nodes: Array<Spirit_Topic_Notification_Topicnotification>;
};

export type Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spirit_Topic_Notification_Topicnotification_Select_Column_Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spirit_Topic_Notification_Topicnotification_Select_Column_Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Aggregate_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_aggregate_fields';
  avg?: Maybe<Spirit_Topic_Notification_Topicnotification_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Topic_Notification_Topicnotification_Max_Fields>;
  min?: Maybe<Spirit_Topic_Notification_Topicnotification_Min_Fields>;
  stddev?: Maybe<Spirit_Topic_Notification_Topicnotification_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Topic_Notification_Topicnotification_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Topic_Notification_Topicnotification_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Topic_Notification_Topicnotification_Sum_Fields>;
  var_pop?: Maybe<Spirit_Topic_Notification_Topicnotification_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Topic_Notification_Topicnotification_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Topic_Notification_Topicnotification_Variance_Fields>;
};


/** aggregate fields of "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Max_Order_By>;
  min?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Topic_Notification_Topicnotification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Topic_Notification_Topicnotification_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Topic_Notification_Topicnotification_Avg_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_avg_fields';
  action?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Avg_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_topic_notification_topicnotification". All fields are combined with a logical 'AND'. */
export type Spirit_Topic_Notification_Topicnotification_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Bool_Exp>>;
  action?: InputMaybe<Int_Comparison_Exp>;
  comment_id?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_read?: InputMaybe<Boolean_Comparison_Exp>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  topic_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_topic_notification_topicnotification" */
export enum Spirit_Topic_Notification_Topicnotification_Constraint {
  /** unique or primary key constraint on columns "user_id", "topic_id" */
  SpiritTopicNotificatioUserIdTopicId_1f927541Uniq = 'spirit_topic_notificatio_user_id_topic_id_1f927541_uniq',
  /** unique or primary key constraint on columns "id" */
  SpiritTopicNotificationTopicnotificationPkey = 'spirit_topic_notification_topicnotification_pkey'
}

/** input type for incrementing numeric columns in table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Inc_Input = {
  action?: InputMaybe<Scalars['Int']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Insert_Input = {
  action?: InputMaybe<Scalars['Int']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Obj_Rel_Insert_Input>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Obj_Rel_Insert_Input>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Topic_Notification_Topicnotification_Max_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_max_fields';
  action?: Maybe<Scalars['Int']['output']>;
  comment_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Max_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Topic_Notification_Topicnotification_Min_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_min_fields';
  action?: Maybe<Scalars['Int']['output']>;
  comment_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Min_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Mutation_Response = {
  __typename?: 'spirit_topic_notification_topicnotification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Topic_Notification_Topicnotification>;
};

/** on_conflict condition type for table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_On_Conflict = {
  constraint: Spirit_Topic_Notification_Topicnotification_Constraint;
  update_columns?: Array<Spirit_Topic_Notification_Topicnotification_Update_Column>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_topic_notification_topicnotification". */
export type Spirit_Topic_Notification_Topicnotification_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_read?: InputMaybe<Order_By>;
  spirit_comment_comment?: InputMaybe<Spirit_Comment_Comment_Order_By>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_topic_notification_topicnotification */
export type Spirit_Topic_Notification_Topicnotification_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_topic_notification_topicnotification" */
export enum Spirit_Topic_Notification_Topicnotification_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsRead = 'is_read',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

/** select "spirit_topic_notification_topicnotification_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spirit_topic_notification_topicnotification" */
export enum Spirit_Topic_Notification_Topicnotification_Select_Column_Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsRead = 'is_read'
}

/** select "spirit_topic_notification_topicnotification_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spirit_topic_notification_topicnotification" */
export enum Spirit_Topic_Notification_Topicnotification_Select_Column_Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsRead = 'is_read'
}

/** input type for updating data in table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Set_Input = {
  action?: InputMaybe<Scalars['Int']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Topic_Notification_Topicnotification_Stddev_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_stddev_fields';
  action?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Stddev_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Topic_Notification_Topicnotification_Stddev_Pop_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_stddev_pop_fields';
  action?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Stddev_Pop_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Topic_Notification_Topicnotification_Stddev_Samp_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_stddev_samp_fields';
  action?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Stddev_Samp_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Topic_Notification_Topicnotification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Topic_Notification_Topicnotification_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['Int']['input']>;
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Topic_Notification_Topicnotification_Sum_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_sum_fields';
  action?: Maybe<Scalars['Int']['output']>;
  comment_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Sum_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_topic_notification_topicnotification" */
export enum Spirit_Topic_Notification_Topicnotification_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsRead = 'is_read',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

export type Spirit_Topic_Notification_Topicnotification_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Topic_Notification_Topicnotification_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Topic_Notification_Topicnotification_Var_Pop_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_var_pop_fields';
  action?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Var_Pop_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Topic_Notification_Topicnotification_Var_Samp_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_var_samp_fields';
  action?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Var_Samp_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Topic_Notification_Topicnotification_Variance_Fields = {
  __typename?: 'spirit_topic_notification_topicnotification_variance_fields';
  action?: Maybe<Scalars['Float']['output']>;
  comment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_topic_notification_topicnotification" */
export type Spirit_Topic_Notification_Topicnotification_Variance_Order_By = {
  action?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate = {
  __typename?: 'spirit_topic_private_topicprivate';
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  spirit_topic_topic: Spirit_Topic_Topic;
  topic_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Aggregate = {
  __typename?: 'spirit_topic_private_topicprivate_aggregate';
  aggregate?: Maybe<Spirit_Topic_Private_Topicprivate_Aggregate_Fields>;
  nodes: Array<Spirit_Topic_Private_Topicprivate>;
};

export type Spirit_Topic_Private_Topicprivate_Aggregate_Bool_Exp = {
  count?: InputMaybe<Spirit_Topic_Private_Topicprivate_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Topic_Private_Topicprivate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Aggregate_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_aggregate_fields';
  avg?: Maybe<Spirit_Topic_Private_Topicprivate_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Topic_Private_Topicprivate_Max_Fields>;
  min?: Maybe<Spirit_Topic_Private_Topicprivate_Min_Fields>;
  stddev?: Maybe<Spirit_Topic_Private_Topicprivate_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Topic_Private_Topicprivate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Topic_Private_Topicprivate_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Topic_Private_Topicprivate_Sum_Fields>;
  var_pop?: Maybe<Spirit_Topic_Private_Topicprivate_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Topic_Private_Topicprivate_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Topic_Private_Topicprivate_Variance_Fields>;
};


/** aggregate fields of "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Topic_Private_Topicprivate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Topic_Private_Topicprivate_Max_Order_By>;
  min?: InputMaybe<Spirit_Topic_Private_Topicprivate_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Topic_Private_Topicprivate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Topic_Private_Topicprivate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Topic_Private_Topicprivate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Topic_Private_Topicprivate_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Topic_Private_Topicprivate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Topic_Private_Topicprivate_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Topic_Private_Topicprivate_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Topic_Private_Topicprivate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Topic_Private_Topicprivate_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Topic_Private_Topicprivate_Avg_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_topic_private_topicprivate". All fields are combined with a logical 'AND'. */
export type Spirit_Topic_Private_Topicprivate_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Bool_Exp>>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  topic_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_topic_private_topicprivate" */
export enum Spirit_Topic_Private_Topicprivate_Constraint {
  /** unique or primary key constraint on columns "user_id", "topic_id" */
  SpiritTopicPrivateTopUserIdTopicId_8c297113Uniq = 'spirit_topic_private_top_user_id_topic_id_8c297113_uniq',
  /** unique or primary key constraint on columns "id" */
  SpiritTopicPrivateTopicprivatePkey = 'spirit_topic_private_topicprivate_pkey'
}

/** input type for incrementing numeric columns in table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Insert_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Obj_Rel_Insert_Input>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Topic_Private_Topicprivate_Max_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_max_fields';
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Topic_Private_Topicprivate_Min_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_min_fields';
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Mutation_Response = {
  __typename?: 'spirit_topic_private_topicprivate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Topic_Private_Topicprivate>;
};

/** on_conflict condition type for table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_On_Conflict = {
  constraint: Spirit_Topic_Private_Topicprivate_Constraint;
  update_columns?: Array<Spirit_Topic_Private_Topicprivate_Update_Column>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_topic_private_topicprivate". */
export type Spirit_Topic_Private_Topicprivate_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_topic_private_topicprivate */
export type Spirit_Topic_Private_Topicprivate_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_topic_private_topicprivate" */
export enum Spirit_Topic_Private_Topicprivate_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Set_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Topic_Private_Topicprivate_Stddev_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Topic_Private_Topicprivate_Stddev_Pop_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Topic_Private_Topicprivate_Stddev_Samp_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Topic_Private_Topicprivate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Topic_Private_Topicprivate_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Topic_Private_Topicprivate_Sum_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_topic_private_topicprivate" */
export enum Spirit_Topic_Private_Topicprivate_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

export type Spirit_Topic_Private_Topicprivate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Topic_Private_Topicprivate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Topic_Private_Topicprivate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Topic_Private_Topicprivate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Topic_Private_Topicprivate_Var_Pop_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Topic_Private_Topicprivate_Var_Samp_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Topic_Private_Topicprivate_Variance_Fields = {
  __typename?: 'spirit_topic_private_topicprivate_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_topic_private_topicprivate" */
export type Spirit_Topic_Private_Topicprivate_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_Topic = {
  __typename?: 'spirit_topic_topic';
  category_id: Scalars['Int']['output'];
  comment_count: Scalars['Int']['output'];
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_closed: Scalars['Boolean']['output'];
  is_globally_pinned: Scalars['Boolean']['output'];
  is_pinned: Scalars['Boolean']['output'];
  is_removed: Scalars['Boolean']['output'];
  last_active: Scalars['timestamptz']['output'];
  reindex_at: Scalars['timestamptz']['output'];
  slug: Scalars['String']['output'];
  /** An object relationship */
  spirit_category_category: Spirit_Category_Category;
  /** An array relationship */
  spirit_comment_bookmark_commentbookmarks: Array<Spirit_Comment_Bookmark_Commentbookmark>;
  /** An aggregate relationship */
  spirit_comment_bookmark_commentbookmarks_aggregate: Spirit_Comment_Bookmark_Commentbookmark_Aggregate;
  /** An array relationship */
  spirit_comment_comments: Array<Spirit_Comment_Comment>;
  /** An aggregate relationship */
  spirit_comment_comments_aggregate: Spirit_Comment_Comment_Aggregate;
  /** An array relationship */
  spirit_topic_favorite_topicfavorites: Array<Spirit_Topic_Favorite_Topicfavorite>;
  /** An aggregate relationship */
  spirit_topic_favorite_topicfavorites_aggregate: Spirit_Topic_Favorite_Topicfavorite_Aggregate;
  /** An array relationship */
  spirit_topic_notification_topicnotifications: Array<Spirit_Topic_Notification_Topicnotification>;
  /** An aggregate relationship */
  spirit_topic_notification_topicnotifications_aggregate: Spirit_Topic_Notification_Topicnotification_Aggregate;
  /** An array relationship */
  spirit_topic_private_topicprivates: Array<Spirit_Topic_Private_Topicprivate>;
  /** An aggregate relationship */
  spirit_topic_private_topicprivates_aggregate: Spirit_Topic_Private_Topicprivate_Aggregate;
  /** An array relationship */
  spirit_topic_unread_topicunreads: Array<Spirit_Topic_Unread_Topicunread>;
  /** An aggregate relationship */
  spirit_topic_unread_topicunreads_aggregate: Spirit_Topic_Unread_Topicunread_Aggregate;
  title: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
  view_count: Scalars['Int']['output'];
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Comment_Bookmark_CommentbookmarksArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Comment_Bookmark_Commentbookmarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Comment_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Comment_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Comment_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Comment_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Topic_Favorite_TopicfavoritesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Topic_Favorite_Topicfavorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Topic_Notification_TopicnotificationsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Topic_Notification_Topicnotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Topic_Private_TopicprivatesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Topic_Private_Topicprivates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Topic_Unread_TopicunreadsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};


/** columns and relationships of "spirit_topic_topic" */
export type Spirit_Topic_TopicSpirit_Topic_Unread_Topicunreads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};

/** aggregated selection of "spirit_topic_topic" */
export type Spirit_Topic_Topic_Aggregate = {
  __typename?: 'spirit_topic_topic_aggregate';
  aggregate?: Maybe<Spirit_Topic_Topic_Aggregate_Fields>;
  nodes: Array<Spirit_Topic_Topic>;
};

export type Spirit_Topic_Topic_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spirit_Topic_Topic_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spirit_Topic_Topic_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spirit_Topic_Topic_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Topic_Topic_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spirit_Topic_Topic_Select_Column_Spirit_Topic_Topic_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Topic_Topic_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spirit_Topic_Topic_Select_Column_Spirit_Topic_Topic_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Topic_Topic_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_topic_topic" */
export type Spirit_Topic_Topic_Aggregate_Fields = {
  __typename?: 'spirit_topic_topic_aggregate_fields';
  avg?: Maybe<Spirit_Topic_Topic_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Topic_Topic_Max_Fields>;
  min?: Maybe<Spirit_Topic_Topic_Min_Fields>;
  stddev?: Maybe<Spirit_Topic_Topic_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Topic_Topic_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Topic_Topic_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Topic_Topic_Sum_Fields>;
  var_pop?: Maybe<Spirit_Topic_Topic_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Topic_Topic_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Topic_Topic_Variance_Fields>;
};


/** aggregate fields of "spirit_topic_topic" */
export type Spirit_Topic_Topic_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Topic_Topic_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Topic_Topic_Max_Order_By>;
  min?: InputMaybe<Spirit_Topic_Topic_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Topic_Topic_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Topic_Topic_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Topic_Topic_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Topic_Topic_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Topic_Topic_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Topic_Topic_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Topic_Topic_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Topic_Topic_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Topic_Topic_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Topic_Topic_Avg_Fields = {
  __typename?: 'spirit_topic_topic_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_topic_topic". All fields are combined with a logical 'AND'. */
export type Spirit_Topic_Topic_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Topic_Topic_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Topic_Topic_Bool_Exp>>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  comment_count?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_closed?: InputMaybe<Boolean_Comparison_Exp>;
  is_globally_pinned?: InputMaybe<Boolean_Comparison_Exp>;
  is_pinned?: InputMaybe<Boolean_Comparison_Exp>;
  is_removed?: InputMaybe<Boolean_Comparison_Exp>;
  last_active?: InputMaybe<Timestamptz_Comparison_Exp>;
  reindex_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  spirit_category_category?: InputMaybe<Spirit_Category_Category_Bool_Exp>;
  spirit_comment_bookmark_commentbookmarks?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
  spirit_comment_bookmark_commentbookmarks_aggregate?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Bool_Exp>;
  spirit_comment_comments?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  spirit_comment_comments_aggregate?: InputMaybe<Spirit_Comment_Comment_Aggregate_Bool_Exp>;
  spirit_topic_favorite_topicfavorites?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
  spirit_topic_favorite_topicfavorites_aggregate?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Aggregate_Bool_Exp>;
  spirit_topic_notification_topicnotifications?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
  spirit_topic_notification_topicnotifications_aggregate?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp>;
  spirit_topic_private_topicprivates?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
  spirit_topic_private_topicprivates_aggregate?: InputMaybe<Spirit_Topic_Private_Topicprivate_Aggregate_Bool_Exp>;
  spirit_topic_unread_topicunreads?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
  spirit_topic_unread_topicunreads_aggregate?: InputMaybe<Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
  view_count?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "spirit_topic_topic" */
export enum Spirit_Topic_Topic_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpiritTopicTopicPkey = 'spirit_topic_topic_pkey'
}

/** input type for incrementing numeric columns in table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  comment_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  view_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Insert_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  comment_count?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  is_globally_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  last_active?: InputMaybe<Scalars['timestamptz']['input']>;
  reindex_at?: InputMaybe<Scalars['timestamptz']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spirit_category_category?: InputMaybe<Spirit_Category_Category_Obj_Rel_Insert_Input>;
  spirit_comment_bookmark_commentbookmarks?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Arr_Rel_Insert_Input>;
  spirit_comment_comments?: InputMaybe<Spirit_Comment_Comment_Arr_Rel_Insert_Input>;
  spirit_topic_favorite_topicfavorites?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Arr_Rel_Insert_Input>;
  spirit_topic_notification_topicnotifications?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Arr_Rel_Insert_Input>;
  spirit_topic_private_topicprivates?: InputMaybe<Spirit_Topic_Private_Topicprivate_Arr_Rel_Insert_Input>;
  spirit_topic_unread_topicunreads?: InputMaybe<Spirit_Topic_Unread_Topicunread_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
  view_count?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Spirit_Topic_Topic_Max_Fields = {
  __typename?: 'spirit_topic_topic_max_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_active?: Maybe<Scalars['timestamptz']['output']>;
  reindex_at?: Maybe<Scalars['timestamptz']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  view_count?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active?: InputMaybe<Order_By>;
  reindex_at?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Topic_Topic_Min_Fields = {
  __typename?: 'spirit_topic_topic_min_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_active?: Maybe<Scalars['timestamptz']['output']>;
  reindex_at?: Maybe<Scalars['timestamptz']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  view_count?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active?: InputMaybe<Order_By>;
  reindex_at?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Mutation_Response = {
  __typename?: 'spirit_topic_topic_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Topic_Topic>;
};

/** input type for inserting object relation for remote table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Obj_Rel_Insert_Input = {
  data: Spirit_Topic_Topic_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Topic_Topic_On_Conflict>;
};

/** on_conflict condition type for table "spirit_topic_topic" */
export type Spirit_Topic_Topic_On_Conflict = {
  constraint: Spirit_Topic_Topic_Constraint;
  update_columns?: Array<Spirit_Topic_Topic_Update_Column>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_topic_topic". */
export type Spirit_Topic_Topic_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_closed?: InputMaybe<Order_By>;
  is_globally_pinned?: InputMaybe<Order_By>;
  is_pinned?: InputMaybe<Order_By>;
  is_removed?: InputMaybe<Order_By>;
  last_active?: InputMaybe<Order_By>;
  reindex_at?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  spirit_category_category?: InputMaybe<Spirit_Category_Category_Order_By>;
  spirit_comment_bookmark_commentbookmarks_aggregate?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Order_By>;
  spirit_comment_comments_aggregate?: InputMaybe<Spirit_Comment_Comment_Aggregate_Order_By>;
  spirit_topic_favorite_topicfavorites_aggregate?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Aggregate_Order_By>;
  spirit_topic_notification_topicnotifications_aggregate?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Order_By>;
  spirit_topic_private_topicprivates_aggregate?: InputMaybe<Spirit_Topic_Private_Topicprivate_Aggregate_Order_By>;
  spirit_topic_unread_topicunreads_aggregate?: InputMaybe<Spirit_Topic_Unread_Topicunread_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spirit_topic_topic */
export type Spirit_Topic_Topic_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_topic_topic" */
export enum Spirit_Topic_Topic_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CommentCount = 'comment_count',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsGloballyPinned = 'is_globally_pinned',
  /** column name */
  IsPinned = 'is_pinned',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  LastActive = 'last_active',
  /** column name */
  ReindexAt = 'reindex_at',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ViewCount = 'view_count'
}

/** select "spirit_topic_topic_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spirit_topic_topic" */
export enum Spirit_Topic_Topic_Select_Column_Spirit_Topic_Topic_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsGloballyPinned = 'is_globally_pinned',
  /** column name */
  IsPinned = 'is_pinned',
  /** column name */
  IsRemoved = 'is_removed'
}

/** select "spirit_topic_topic_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spirit_topic_topic" */
export enum Spirit_Topic_Topic_Select_Column_Spirit_Topic_Topic_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsGloballyPinned = 'is_globally_pinned',
  /** column name */
  IsPinned = 'is_pinned',
  /** column name */
  IsRemoved = 'is_removed'
}

/** input type for updating data in table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  comment_count?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  is_globally_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  last_active?: InputMaybe<Scalars['timestamptz']['input']>;
  reindex_at?: InputMaybe<Scalars['timestamptz']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  view_count?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Topic_Topic_Stddev_Fields = {
  __typename?: 'spirit_topic_topic_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Topic_Topic_Stddev_Pop_Fields = {
  __typename?: 'spirit_topic_topic_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Topic_Topic_Stddev_Samp_Fields = {
  __typename?: 'spirit_topic_topic_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Topic_Topic_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Topic_Topic_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  comment_count?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  is_globally_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  last_active?: InputMaybe<Scalars['timestamptz']['input']>;
  reindex_at?: InputMaybe<Scalars['timestamptz']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  view_count?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Topic_Topic_Sum_Fields = {
  __typename?: 'spirit_topic_topic_sum_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  view_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_topic_topic" */
export enum Spirit_Topic_Topic_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CommentCount = 'comment_count',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsGloballyPinned = 'is_globally_pinned',
  /** column name */
  IsPinned = 'is_pinned',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  LastActive = 'last_active',
  /** column name */
  ReindexAt = 'reindex_at',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ViewCount = 'view_count'
}

export type Spirit_Topic_Topic_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Topic_Topic_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Topic_Topic_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Topic_Topic_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Topic_Topic_Var_Pop_Fields = {
  __typename?: 'spirit_topic_topic_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Topic_Topic_Var_Samp_Fields = {
  __typename?: 'spirit_topic_topic_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Topic_Topic_Variance_Fields = {
  __typename?: 'spirit_topic_topic_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_topic_topic" */
export type Spirit_Topic_Topic_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread = {
  __typename?: 'spirit_topic_unread_topicunread';
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_read: Scalars['Boolean']['output'];
  /** An object relationship */
  spirit_topic_topic: Spirit_Topic_Topic;
  topic_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Aggregate = {
  __typename?: 'spirit_topic_unread_topicunread_aggregate';
  aggregate?: Maybe<Spirit_Topic_Unread_Topicunread_Aggregate_Fields>;
  nodes: Array<Spirit_Topic_Unread_Topicunread>;
};

export type Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Count>;
};

export type Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spirit_Topic_Unread_Topicunread_Select_Column_Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spirit_Topic_Unread_Topicunread_Select_Column_Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Aggregate_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_aggregate_fields';
  avg?: Maybe<Spirit_Topic_Unread_Topicunread_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_Topic_Unread_Topicunread_Max_Fields>;
  min?: Maybe<Spirit_Topic_Unread_Topicunread_Min_Fields>;
  stddev?: Maybe<Spirit_Topic_Unread_Topicunread_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_Topic_Unread_Topicunread_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_Topic_Unread_Topicunread_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_Topic_Unread_Topicunread_Sum_Fields>;
  var_pop?: Maybe<Spirit_Topic_Unread_Topicunread_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_Topic_Unread_Topicunread_Var_Samp_Fields>;
  variance?: Maybe<Spirit_Topic_Unread_Topicunread_Variance_Fields>;
};


/** aggregate fields of "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Aggregate_Order_By = {
  avg?: InputMaybe<Spirit_Topic_Unread_Topicunread_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spirit_Topic_Unread_Topicunread_Max_Order_By>;
  min?: InputMaybe<Spirit_Topic_Unread_Topicunread_Min_Order_By>;
  stddev?: InputMaybe<Spirit_Topic_Unread_Topicunread_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spirit_Topic_Unread_Topicunread_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spirit_Topic_Unread_Topicunread_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spirit_Topic_Unread_Topicunread_Sum_Order_By>;
  var_pop?: InputMaybe<Spirit_Topic_Unread_Topicunread_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spirit_Topic_Unread_Topicunread_Var_Samp_Order_By>;
  variance?: InputMaybe<Spirit_Topic_Unread_Topicunread_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Arr_Rel_Insert_Input = {
  data: Array<Spirit_Topic_Unread_Topicunread_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_Topic_Unread_Topicunread_On_Conflict>;
};

/** aggregate avg on columns */
export type Spirit_Topic_Unread_Topicunread_Avg_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spirit_topic_unread_topicunread". All fields are combined with a logical 'AND'. */
export type Spirit_Topic_Unread_Topicunread_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Bool_Exp>>;
  _not?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Bool_Exp>>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_read?: InputMaybe<Boolean_Comparison_Exp>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  topic_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_topic_unread_topicunread" */
export enum Spirit_Topic_Unread_Topicunread_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpiritTopicUnreadTopicunreadPkey = 'spirit_topic_unread_topicunread_pkey',
  /** unique or primary key constraint on columns "user_id", "topic_id" */
  SpiritTopicUnreadTopicunreadUserIdTopicId_8f3c8a54Uniq = 'spirit_topic_unread_topicunread_user_id_topic_id_8f3c8a54_uniq'
}

/** input type for incrementing numeric columns in table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Insert_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Obj_Rel_Insert_Input>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_Topic_Unread_Topicunread_Max_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_max_fields';
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spirit_Topic_Unread_Topicunread_Min_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_min_fields';
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Mutation_Response = {
  __typename?: 'spirit_topic_unread_topicunread_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_Topic_Unread_Topicunread>;
};

/** on_conflict condition type for table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_On_Conflict = {
  constraint: Spirit_Topic_Unread_Topicunread_Constraint;
  update_columns?: Array<Spirit_Topic_Unread_Topicunread_Update_Column>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_topic_unread_topicunread". */
export type Spirit_Topic_Unread_Topicunread_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_read?: InputMaybe<Order_By>;
  spirit_topic_topic?: InputMaybe<Spirit_Topic_Topic_Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_topic_unread_topicunread */
export type Spirit_Topic_Unread_Topicunread_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_topic_unread_topicunread" */
export enum Spirit_Topic_Unread_Topicunread_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsRead = 'is_read',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

/** select "spirit_topic_unread_topicunread_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spirit_topic_unread_topicunread" */
export enum Spirit_Topic_Unread_Topicunread_Select_Column_Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRead = 'is_read'
}

/** select "spirit_topic_unread_topicunread_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spirit_topic_unread_topicunread" */
export enum Spirit_Topic_Unread_Topicunread_Select_Column_Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRead = 'is_read'
}

/** input type for updating data in table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Set_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_Topic_Unread_Topicunread_Stddev_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spirit_Topic_Unread_Topicunread_Stddev_Pop_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spirit_Topic_Unread_Topicunread_Stddev_Samp_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_Topic_Unread_Topicunread_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_Topic_Unread_Topicunread_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  topic_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_Topic_Unread_Topicunread_Sum_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  topic_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "spirit_topic_unread_topicunread" */
export enum Spirit_Topic_Unread_Topicunread_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsRead = 'is_read',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

export type Spirit_Topic_Unread_Topicunread_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_Topic_Unread_Topicunread_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_Topic_Unread_Topicunread_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_Topic_Unread_Topicunread_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_Topic_Unread_Topicunread_Var_Pop_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spirit_Topic_Unread_Topicunread_Var_Samp_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spirit_Topic_Unread_Topicunread_Variance_Fields = {
  __typename?: 'spirit_topic_unread_topicunread_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  topic_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spirit_topic_unread_topicunread" */
export type Spirit_Topic_Unread_Topicunread_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spirit_user_userprofile" */
export type Spirit_User_Userprofile = {
  __typename?: 'spirit_user_userprofile';
  comment_count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  is_administrator: Scalars['Boolean']['output'];
  is_moderator: Scalars['Boolean']['output'];
  is_verified: Scalars['Boolean']['output'];
  last_ip?: Maybe<Scalars['inet']['output']>;
  last_post_hash: Scalars['String']['output'];
  last_post_on?: Maybe<Scalars['timestamptz']['output']>;
  last_seen: Scalars['timestamptz']['output'];
  location: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  topic_count: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "spirit_user_userprofile" */
export type Spirit_User_Userprofile_Aggregate = {
  __typename?: 'spirit_user_userprofile_aggregate';
  aggregate?: Maybe<Spirit_User_Userprofile_Aggregate_Fields>;
  nodes: Array<Spirit_User_Userprofile>;
};

/** aggregate fields of "spirit_user_userprofile" */
export type Spirit_User_Userprofile_Aggregate_Fields = {
  __typename?: 'spirit_user_userprofile_aggregate_fields';
  avg?: Maybe<Spirit_User_Userprofile_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spirit_User_Userprofile_Max_Fields>;
  min?: Maybe<Spirit_User_Userprofile_Min_Fields>;
  stddev?: Maybe<Spirit_User_Userprofile_Stddev_Fields>;
  stddev_pop?: Maybe<Spirit_User_Userprofile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spirit_User_Userprofile_Stddev_Samp_Fields>;
  sum?: Maybe<Spirit_User_Userprofile_Sum_Fields>;
  var_pop?: Maybe<Spirit_User_Userprofile_Var_Pop_Fields>;
  var_samp?: Maybe<Spirit_User_Userprofile_Var_Samp_Fields>;
  variance?: Maybe<Spirit_User_Userprofile_Variance_Fields>;
};


/** aggregate fields of "spirit_user_userprofile" */
export type Spirit_User_Userprofile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spirit_User_Userprofile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Spirit_User_Userprofile_Avg_Fields = {
  __typename?: 'spirit_user_userprofile_avg_fields';
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "spirit_user_userprofile". All fields are combined with a logical 'AND'. */
export type Spirit_User_Userprofile_Bool_Exp = {
  _and?: InputMaybe<Array<Spirit_User_Userprofile_Bool_Exp>>;
  _not?: InputMaybe<Spirit_User_Userprofile_Bool_Exp>;
  _or?: InputMaybe<Array<Spirit_User_Userprofile_Bool_Exp>>;
  comment_count?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_administrator?: InputMaybe<Boolean_Comparison_Exp>;
  is_moderator?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_ip?: InputMaybe<Inet_Comparison_Exp>;
  last_post_hash?: InputMaybe<String_Comparison_Exp>;
  last_post_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  nickname?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  topic_count?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "spirit_user_userprofile" */
export enum Spirit_User_Userprofile_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpiritUserUserprofilePkey = 'spirit_user_userprofile_pkey',
  /** unique or primary key constraint on columns "user_id" */
  SpiritUserUserprofileUserIdKey = 'spirit_user_userprofile_user_id_key'
}

/** input type for incrementing numeric columns in table "spirit_user_userprofile" */
export type Spirit_User_Userprofile_Inc_Input = {
  comment_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  topic_count?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spirit_user_userprofile" */
export type Spirit_User_Userprofile_Insert_Input = {
  comment_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_administrator?: InputMaybe<Scalars['Boolean']['input']>;
  is_moderator?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  last_ip?: InputMaybe<Scalars['inet']['input']>;
  last_post_hash?: InputMaybe<Scalars['String']['input']>;
  last_post_on?: InputMaybe<Scalars['timestamptz']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  topic_count?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Spirit_User_Userprofile_Max_Fields = {
  __typename?: 'spirit_user_userprofile_max_fields';
  comment_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_post_hash?: Maybe<Scalars['String']['output']>;
  last_post_on?: Maybe<Scalars['timestamptz']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  topic_count?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Spirit_User_Userprofile_Min_Fields = {
  __typename?: 'spirit_user_userprofile_min_fields';
  comment_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_post_hash?: Maybe<Scalars['String']['output']>;
  last_post_on?: Maybe<Scalars['timestamptz']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  topic_count?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "spirit_user_userprofile" */
export type Spirit_User_Userprofile_Mutation_Response = {
  __typename?: 'spirit_user_userprofile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spirit_User_Userprofile>;
};

/** input type for inserting object relation for remote table "spirit_user_userprofile" */
export type Spirit_User_Userprofile_Obj_Rel_Insert_Input = {
  data: Spirit_User_Userprofile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spirit_User_Userprofile_On_Conflict>;
};

/** on_conflict condition type for table "spirit_user_userprofile" */
export type Spirit_User_Userprofile_On_Conflict = {
  constraint: Spirit_User_Userprofile_Constraint;
  update_columns?: Array<Spirit_User_Userprofile_Update_Column>;
  where?: InputMaybe<Spirit_User_Userprofile_Bool_Exp>;
};

/** Ordering options when selecting data from "spirit_user_userprofile". */
export type Spirit_User_Userprofile_Order_By = {
  comment_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_administrator?: InputMaybe<Order_By>;
  is_moderator?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  last_ip?: InputMaybe<Order_By>;
  last_post_hash?: InputMaybe<Order_By>;
  last_post_on?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  topic_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: spirit_user_userprofile */
export type Spirit_User_Userprofile_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "spirit_user_userprofile" */
export enum Spirit_User_Userprofile_Select_Column {
  /** column name */
  CommentCount = 'comment_count',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdministrator = 'is_administrator',
  /** column name */
  IsModerator = 'is_moderator',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LastIp = 'last_ip',
  /** column name */
  LastPostHash = 'last_post_hash',
  /** column name */
  LastPostOn = 'last_post_on',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  Location = 'location',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Slug = 'slug',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  TopicCount = 'topic_count',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "spirit_user_userprofile" */
export type Spirit_User_Userprofile_Set_Input = {
  comment_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_administrator?: InputMaybe<Scalars['Boolean']['input']>;
  is_moderator?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  last_ip?: InputMaybe<Scalars['inet']['input']>;
  last_post_hash?: InputMaybe<Scalars['String']['input']>;
  last_post_on?: InputMaybe<Scalars['timestamptz']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  topic_count?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Spirit_User_Userprofile_Stddev_Fields = {
  __typename?: 'spirit_user_userprofile_stddev_fields';
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Spirit_User_Userprofile_Stddev_Pop_Fields = {
  __typename?: 'spirit_user_userprofile_stddev_pop_fields';
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Spirit_User_Userprofile_Stddev_Samp_Fields = {
  __typename?: 'spirit_user_userprofile_stddev_samp_fields';
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "spirit_user_userprofile" */
export type Spirit_User_Userprofile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spirit_User_Userprofile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spirit_User_Userprofile_Stream_Cursor_Value_Input = {
  comment_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_administrator?: InputMaybe<Scalars['Boolean']['input']>;
  is_moderator?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  last_ip?: InputMaybe<Scalars['inet']['input']>;
  last_post_hash?: InputMaybe<Scalars['String']['input']>;
  last_post_on?: InputMaybe<Scalars['timestamptz']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  topic_count?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Spirit_User_Userprofile_Sum_Fields = {
  __typename?: 'spirit_user_userprofile_sum_fields';
  comment_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  topic_count?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "spirit_user_userprofile" */
export enum Spirit_User_Userprofile_Update_Column {
  /** column name */
  CommentCount = 'comment_count',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdministrator = 'is_administrator',
  /** column name */
  IsModerator = 'is_moderator',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LastIp = 'last_ip',
  /** column name */
  LastPostHash = 'last_post_hash',
  /** column name */
  LastPostOn = 'last_post_on',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  Location = 'location',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Slug = 'slug',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  TopicCount = 'topic_count',
  /** column name */
  UserId = 'user_id'
}

export type Spirit_User_Userprofile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spirit_User_Userprofile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spirit_User_Userprofile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spirit_User_Userprofile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spirit_User_Userprofile_Var_Pop_Fields = {
  __typename?: 'spirit_user_userprofile_var_pop_fields';
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Spirit_User_Userprofile_Var_Samp_Fields = {
  __typename?: 'spirit_user_userprofile_var_samp_fields';
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Spirit_User_Userprofile_Variance_Fields = {
  __typename?: 'spirit_user_userprofile_variance_fields';
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  topic_count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "subscription_group_plan" */
export type Subscription_Group_Plan = {
  __typename?: 'subscription_group_plan';
  created_at: Scalars['timestamptz']['output'];
  group_discount_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_invisible: Scalars['Boolean']['output'];
  plan_id: Scalars['uuid']['output'];
  price: Scalars['Int']['output'];
  /** An array relationship */
  subscription_group_plan_groups: Array<Subscription_Group_Plan_Groups>;
  /** An aggregate relationship */
  subscription_group_plan_groups_aggregate: Subscription_Group_Plan_Groups_Aggregate;
  /** An object relationship */
  subscriptions_subscriptionplan: Subscriptions_Subscriptionplan;
  updated_at: Scalars['timestamptz']['output'];
  users_count: Scalars['Int']['output'];
  validity: Scalars['timestamptz']['output'];
};


/** columns and relationships of "subscription_group_plan" */
export type Subscription_Group_PlanSubscription_Group_Plan_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Groups_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
};


/** columns and relationships of "subscription_group_plan" */
export type Subscription_Group_PlanSubscription_Group_Plan_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Groups_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
};

/** aggregated selection of "subscription_group_plan" */
export type Subscription_Group_Plan_Aggregate = {
  __typename?: 'subscription_group_plan_aggregate';
  aggregate?: Maybe<Subscription_Group_Plan_Aggregate_Fields>;
  nodes: Array<Subscription_Group_Plan>;
};

export type Subscription_Group_Plan_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subscription_Group_Plan_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subscription_Group_Plan_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subscription_Group_Plan_Aggregate_Bool_Exp_Count>;
};

export type Subscription_Group_Plan_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscription_Group_Plan_Select_Column_Subscription_Group_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Group_Plan_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscription_Group_Plan_Select_Column_Subscription_Group_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Group_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscription_Group_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscription_group_plan" */
export type Subscription_Group_Plan_Aggregate_Fields = {
  __typename?: 'subscription_group_plan_aggregate_fields';
  avg?: Maybe<Subscription_Group_Plan_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscription_Group_Plan_Max_Fields>;
  min?: Maybe<Subscription_Group_Plan_Min_Fields>;
  stddev?: Maybe<Subscription_Group_Plan_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Group_Plan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Group_Plan_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Group_Plan_Sum_Fields>;
  var_pop?: Maybe<Subscription_Group_Plan_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Group_Plan_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Group_Plan_Variance_Fields>;
};


/** aggregate fields of "subscription_group_plan" */
export type Subscription_Group_Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Group_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscription_group_plan" */
export type Subscription_Group_Plan_Aggregate_Order_By = {
  avg?: InputMaybe<Subscription_Group_Plan_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Group_Plan_Max_Order_By>;
  min?: InputMaybe<Subscription_Group_Plan_Min_Order_By>;
  stddev?: InputMaybe<Subscription_Group_Plan_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscription_Group_Plan_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscription_Group_Plan_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscription_Group_Plan_Sum_Order_By>;
  var_pop?: InputMaybe<Subscription_Group_Plan_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscription_Group_Plan_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscription_Group_Plan_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_group_plan" */
export type Subscription_Group_Plan_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Group_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Group_Plan_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscription_Group_Plan_Avg_Fields = {
  __typename?: 'subscription_group_plan_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  users_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscription_group_plan". All fields are combined with a logical 'AND'. */
export type Subscription_Group_Plan_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Group_Plan_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Group_Plan_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_discount_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_invisible?: InputMaybe<Boolean_Comparison_Exp>;
  plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  subscription_group_plan_groups?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
  subscription_group_plan_groups_aggregate?: InputMaybe<Subscription_Group_Plan_Groups_Aggregate_Bool_Exp>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users_count?: InputMaybe<Int_Comparison_Exp>;
  validity?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_group_plan" */
export enum Subscription_Group_Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionGroupPlanPkey = 'subscription_group_plan_pkey'
}

/** columns and relationships of "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups = {
  __typename?: 'subscription_group_plan_groups';
  created_at: Scalars['timestamptz']['output'];
  group_name: Scalars['String']['output'];
  group_plan_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  is_closed: Scalars['Boolean']['output'];
  /** A computed field, executes function "check_group_subscribed" */
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  packages_payment_transactions: Array<Packages_Payment_Transaction>;
  /** An aggregate relationship */
  packages_payment_transactions_aggregate: Packages_Payment_Transaction_Aggregate;
  rank?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  subscription_group_plan: Subscription_Group_Plan;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "subscription_group_plan_groups" */
export type Subscription_Group_Plan_GroupsPackages_Payment_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


/** columns and relationships of "subscription_group_plan_groups" */
export type Subscription_Group_Plan_GroupsPackages_Payment_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};

/** aggregated selection of "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Aggregate = {
  __typename?: 'subscription_group_plan_groups_aggregate';
  aggregate?: Maybe<Subscription_Group_Plan_Groups_Aggregate_Fields>;
  nodes: Array<Subscription_Group_Plan_Groups>;
};

export type Subscription_Group_Plan_Groups_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Count>;
};

export type Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscription_Group_Plan_Groups_Select_Column_Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscription_Group_Plan_Groups_Select_Column_Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscription_Group_Plan_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Aggregate_Fields = {
  __typename?: 'subscription_group_plan_groups_aggregate_fields';
  avg?: Maybe<Subscription_Group_Plan_Groups_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscription_Group_Plan_Groups_Max_Fields>;
  min?: Maybe<Subscription_Group_Plan_Groups_Min_Fields>;
  stddev?: Maybe<Subscription_Group_Plan_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Group_Plan_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Group_Plan_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Group_Plan_Groups_Sum_Fields>;
  var_pop?: Maybe<Subscription_Group_Plan_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Group_Plan_Groups_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Group_Plan_Groups_Variance_Fields>;
};


/** aggregate fields of "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Group_Plan_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Subscription_Group_Plan_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Group_Plan_Groups_Max_Order_By>;
  min?: InputMaybe<Subscription_Group_Plan_Groups_Min_Order_By>;
  stddev?: InputMaybe<Subscription_Group_Plan_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscription_Group_Plan_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscription_Group_Plan_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscription_Group_Plan_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Subscription_Group_Plan_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscription_Group_Plan_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscription_Group_Plan_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Group_Plan_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Group_Plan_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscription_Group_Plan_Groups_Avg_Fields = {
  __typename?: 'subscription_group_plan_groups_avg_fields';
  group_plan_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Avg_Order_By = {
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscription_group_plan_groups". All fields are combined with a logical 'AND'. */
export type Subscription_Group_Plan_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Group_Plan_Groups_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Group_Plan_Groups_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  group_plan_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_closed?: InputMaybe<Boolean_Comparison_Exp>;
  is_subscribed?: InputMaybe<Boolean_Comparison_Exp>;
  packages_payment_transactions?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
  packages_payment_transactions_aggregate?: InputMaybe<Packages_Payment_Transaction_Aggregate_Bool_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  subscription_group_plan?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_group_plan_groups" */
export enum Subscription_Group_Plan_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionGroupPlanGroupsPkey = 'subscription_group_plan_groups_pkey'
}

/** input type for incrementing numeric columns in table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Inc_Input = {
  group_plan_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  group_plan_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  packages_payment_transactions?: InputMaybe<Packages_Payment_Transaction_Arr_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  subscription_group_plan?: InputMaybe<Subscription_Group_Plan_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subscription_Group_Plan_Groups_Max_Fields = {
  __typename?: 'subscription_group_plan_groups_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  group_plan_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Group_Plan_Groups_Min_Fields = {
  __typename?: 'subscription_group_plan_groups_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  group_plan_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Mutation_Response = {
  __typename?: 'subscription_group_plan_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Group_Plan_Groups>;
};

/** input type for inserting object relation for remote table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Obj_Rel_Insert_Input = {
  data: Subscription_Group_Plan_Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Group_Plan_Groups_On_Conflict>;
};

/** on_conflict condition type for table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_On_Conflict = {
  constraint: Subscription_Group_Plan_Groups_Constraint;
  update_columns?: Array<Subscription_Group_Plan_Groups_Update_Column>;
  where?: InputMaybe<Subscription_Group_Plan_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_group_plan_groups". */
export type Subscription_Group_Plan_Groups_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_closed?: InputMaybe<Order_By>;
  is_subscribed?: InputMaybe<Order_By>;
  packages_payment_transactions_aggregate?: InputMaybe<Packages_Payment_Transaction_Aggregate_Order_By>;
  rank?: InputMaybe<Order_By>;
  subscription_group_plan?: InputMaybe<Subscription_Group_Plan_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_group_plan_groups */
export type Subscription_Group_Plan_Groups_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscription_group_plan_groups" */
export enum Subscription_Group_Plan_Groups_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  GroupPlanId = 'group_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  Rank = 'rank',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "subscription_group_plan_groups_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscription_group_plan_groups" */
export enum Subscription_Group_Plan_Groups_Select_Column_Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed'
}

/** select "subscription_group_plan_groups_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscription_group_plan_groups" */
export enum Subscription_Group_Plan_Groups_Select_Column_Subscription_Group_Plan_Groups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed'
}

/** input type for updating data in table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  group_plan_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Subscription_Group_Plan_Groups_Stddev_Fields = {
  __typename?: 'subscription_group_plan_groups_stddev_fields';
  group_plan_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Stddev_Order_By = {
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Group_Plan_Groups_Stddev_Pop_Fields = {
  __typename?: 'subscription_group_plan_groups_stddev_pop_fields';
  group_plan_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Stddev_Pop_Order_By = {
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Group_Plan_Groups_Stddev_Samp_Fields = {
  __typename?: 'subscription_group_plan_groups_stddev_samp_fields';
  group_plan_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Stddev_Samp_Order_By = {
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Group_Plan_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Group_Plan_Groups_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  group_plan_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscription_Group_Plan_Groups_Sum_Fields = {
  __typename?: 'subscription_group_plan_groups_sum_fields';
  group_plan_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Sum_Order_By = {
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** update columns of table "subscription_group_plan_groups" */
export enum Subscription_Group_Plan_Groups_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  GroupPlanId = 'group_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  Rank = 'rank',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscription_Group_Plan_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscription_Group_Plan_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Group_Plan_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Group_Plan_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscription_Group_Plan_Groups_Var_Pop_Fields = {
  __typename?: 'subscription_group_plan_groups_var_pop_fields';
  group_plan_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Var_Pop_Order_By = {
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscription_Group_Plan_Groups_Var_Samp_Fields = {
  __typename?: 'subscription_group_plan_groups_var_samp_fields';
  group_plan_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Var_Samp_Order_By = {
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscription_Group_Plan_Groups_Variance_Fields = {
  __typename?: 'subscription_group_plan_groups_variance_fields';
  group_plan_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscription_group_plan_groups" */
export type Subscription_Group_Plan_Groups_Variance_Order_By = {
  group_plan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "subscription_group_plan" */
export type Subscription_Group_Plan_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  users_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscription_group_plan" */
export type Subscription_Group_Plan_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_discount_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  subscription_group_plan_groups?: InputMaybe<Subscription_Group_Plan_Groups_Arr_Rel_Insert_Input>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  users_count?: InputMaybe<Scalars['Int']['input']>;
  validity?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subscription_Group_Plan_Max_Fields = {
  __typename?: 'subscription_group_plan_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_discount_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  users_count?: Maybe<Scalars['Int']['output']>;
  validity?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group_discount_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Group_Plan_Min_Fields = {
  __typename?: 'subscription_group_plan_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_discount_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  users_count?: Maybe<Scalars['Int']['output']>;
  validity?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group_discount_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription_group_plan" */
export type Subscription_Group_Plan_Mutation_Response = {
  __typename?: 'subscription_group_plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Group_Plan>;
};

/** input type for inserting object relation for remote table "subscription_group_plan" */
export type Subscription_Group_Plan_Obj_Rel_Insert_Input = {
  data: Subscription_Group_Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Group_Plan_On_Conflict>;
};

/** on_conflict condition type for table "subscription_group_plan" */
export type Subscription_Group_Plan_On_Conflict = {
  constraint: Subscription_Group_Plan_Constraint;
  update_columns?: Array<Subscription_Group_Plan_Update_Column>;
  where?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_group_plan". */
export type Subscription_Group_Plan_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group_discount_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_invisible?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  subscription_group_plan_groups_aggregate?: InputMaybe<Subscription_Group_Plan_Groups_Aggregate_Order_By>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_group_plan */
export type Subscription_Group_Plan_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscription_group_plan" */
export enum Subscription_Group_Plan_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupDiscountName = 'group_discount_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  Price = 'price',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsersCount = 'users_count',
  /** column name */
  Validity = 'validity'
}

/** select "subscription_group_plan_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscription_group_plan" */
export enum Subscription_Group_Plan_Select_Column_Subscription_Group_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsInvisible = 'is_invisible'
}

/** select "subscription_group_plan_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscription_group_plan" */
export enum Subscription_Group_Plan_Select_Column_Subscription_Group_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsInvisible = 'is_invisible'
}

/** input type for updating data in table "subscription_group_plan" */
export type Subscription_Group_Plan_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_discount_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  users_count?: InputMaybe<Scalars['Int']['input']>;
  validity?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Subscription_Group_Plan_Stddev_Fields = {
  __typename?: 'subscription_group_plan_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  users_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Group_Plan_Stddev_Pop_Fields = {
  __typename?: 'subscription_group_plan_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  users_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Group_Plan_Stddev_Samp_Fields = {
  __typename?: 'subscription_group_plan_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  users_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscription_group_plan" */
export type Subscription_Group_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Group_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Group_Plan_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_discount_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  users_count?: InputMaybe<Scalars['Int']['input']>;
  validity?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscription_Group_Plan_Sum_Fields = {
  __typename?: 'subscription_group_plan_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  users_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
};

/** update columns of table "subscription_group_plan" */
export enum Subscription_Group_Plan_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupDiscountName = 'group_discount_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  Price = 'price',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsersCount = 'users_count',
  /** column name */
  Validity = 'validity'
}

export type Subscription_Group_Plan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscription_Group_Plan_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Group_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Group_Plan_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscription_Group_Plan_Var_Pop_Fields = {
  __typename?: 'subscription_group_plan_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  users_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscription_Group_Plan_Var_Samp_Fields = {
  __typename?: 'subscription_group_plan_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  users_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscription_Group_Plan_Variance_Fields = {
  __typename?: 'subscription_group_plan_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  users_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscription_group_plan" */
export type Subscription_Group_Plan_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  users_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscriptions_plancost" */
export type Subscriptions_Plancost = {
  __typename?: 'subscriptions_plancost';
  cost?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  plan_id: Scalars['uuid']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  subscriptions_subscriptionplan: Subscriptions_Subscriptionplan;
  /** An array relationship */
  subscriptions_subscriptiontransactions: Array<Subscriptions_Subscriptiontransaction>;
  /** An aggregate relationship */
  subscriptions_subscriptiontransactions_aggregate: Subscriptions_Subscriptiontransaction_Aggregate;
  /** An array relationship */
  subscriptions_usersubscriptions: Array<Subscriptions_Usersubscription>;
  /** An aggregate relationship */
  subscriptions_usersubscriptions_aggregate: Subscriptions_Usersubscription_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "subscriptions_plancost" */
export type Subscriptions_PlancostSubscriptions_SubscriptiontransactionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};


/** columns and relationships of "subscriptions_plancost" */
export type Subscriptions_PlancostSubscriptions_Subscriptiontransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};


/** columns and relationships of "subscriptions_plancost" */
export type Subscriptions_PlancostSubscriptions_UsersubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Usersubscription_Order_By>>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};


/** columns and relationships of "subscriptions_plancost" */
export type Subscriptions_PlancostSubscriptions_Usersubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Usersubscription_Order_By>>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};

/** aggregated selection of "subscriptions_plancost" */
export type Subscriptions_Plancost_Aggregate = {
  __typename?: 'subscriptions_plancost_aggregate';
  aggregate?: Maybe<Subscriptions_Plancost_Aggregate_Fields>;
  nodes: Array<Subscriptions_Plancost>;
};

export type Subscriptions_Plancost_Aggregate_Bool_Exp = {
  count?: InputMaybe<Subscriptions_Plancost_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Plancost_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Plancost_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions_plancost" */
export type Subscriptions_Plancost_Aggregate_Fields = {
  __typename?: 'subscriptions_plancost_aggregate_fields';
  avg?: Maybe<Subscriptions_Plancost_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Plancost_Max_Fields>;
  min?: Maybe<Subscriptions_Plancost_Min_Fields>;
  stddev?: Maybe<Subscriptions_Plancost_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Plancost_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Plancost_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Plancost_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Plancost_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Plancost_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Plancost_Variance_Fields>;
};


/** aggregate fields of "subscriptions_plancost" */
export type Subscriptions_Plancost_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Plancost_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Plancost_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Plancost_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Plancost_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Plancost_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Plancost_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Plancost_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Plancost_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Plancost_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Plancost_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Plancost_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscriptions_plancost" */
export type Subscriptions_Plancost_Arr_Rel_Insert_Input = {
  data: Array<Subscriptions_Plancost_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_Plancost_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscriptions_Plancost_Avg_Fields = {
  __typename?: 'subscriptions_plancost_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions_plancost". All fields are combined with a logical 'AND'. */
export type Subscriptions_Plancost_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Plancost_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Plancost_Bool_Exp>>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  subscriptions_subscriptiontransactions?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
  subscriptions_subscriptiontransactions_aggregate?: InputMaybe<Subscriptions_Subscriptiontransaction_Aggregate_Bool_Exp>;
  subscriptions_usersubscriptions?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
  subscriptions_usersubscriptions_aggregate?: InputMaybe<Subscriptions_Usersubscription_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions_plancost" */
export enum Subscriptions_Plancost_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPlancostPkey = 'subscriptions_plancost_pkey',
  /** unique or primary key constraint on columns "slug" */
  SubscriptionsPlancostSlugKey = 'subscriptions_plancost_slug_key'
}

/** input type for incrementing numeric columns in table "subscriptions_plancost" */
export type Subscriptions_Plancost_Inc_Input = {
  cost?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "subscriptions_plancost" */
export type Subscriptions_Plancost_Insert_Input = {
  cost?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  subscriptions_subscriptiontransactions?: InputMaybe<Subscriptions_Subscriptiontransaction_Arr_Rel_Insert_Input>;
  subscriptions_usersubscriptions?: InputMaybe<Subscriptions_Usersubscription_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subscriptions_Plancost_Max_Fields = {
  __typename?: 'subscriptions_plancost_max_fields';
  cost?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Max_Order_By = {
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Plancost_Min_Fields = {
  __typename?: 'subscriptions_plancost_min_fields';
  cost?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Min_Order_By = {
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions_plancost" */
export type Subscriptions_Plancost_Mutation_Response = {
  __typename?: 'subscriptions_plancost_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Plancost>;
};

/** input type for inserting object relation for remote table "subscriptions_plancost" */
export type Subscriptions_Plancost_Obj_Rel_Insert_Input = {
  data: Subscriptions_Plancost_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_Plancost_On_Conflict>;
};

/** on_conflict condition type for table "subscriptions_plancost" */
export type Subscriptions_Plancost_On_Conflict = {
  constraint: Subscriptions_Plancost_Constraint;
  update_columns?: Array<Subscriptions_Plancost_Update_Column>;
  where?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions_plancost". */
export type Subscriptions_Plancost_Order_By = {
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  subscriptions_subscriptiontransactions_aggregate?: InputMaybe<Subscriptions_Subscriptiontransaction_Aggregate_Order_By>;
  subscriptions_usersubscriptions_aggregate?: InputMaybe<Subscriptions_Usersubscription_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions_plancost */
export type Subscriptions_Plancost_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "subscriptions_plancost" */
export enum Subscriptions_Plancost_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscriptions_plancost" */
export type Subscriptions_Plancost_Set_Input = {
  cost?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Plancost_Stddev_Fields = {
  __typename?: 'subscriptions_plancost_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Plancost_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_plancost_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Plancost_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_plancost_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions_plancost" */
export type Subscriptions_Plancost_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Plancost_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Plancost_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Plancost_Sum_Fields = {
  __typename?: 'subscriptions_plancost_sum_fields';
  cost?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions_plancost" */
export enum Subscriptions_Plancost_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Plancost_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Plancost_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Plancost_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Plancost_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Plancost_Var_Pop_Fields = {
  __typename?: 'subscriptions_plancost_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Plancost_Var_Samp_Fields = {
  __typename?: 'subscriptions_plancost_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscriptions_Plancost_Variance_Fields = {
  __typename?: 'subscriptions_plancost_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscriptions_plancost" */
export type Subscriptions_Plancost_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscriptions_planlist" */
export type Subscriptions_Planlist = {
  __typename?: 'subscriptions_planlist';
  active: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subscriptions_planlistdetails: Array<Subscriptions_Planlistdetail>;
  /** An aggregate relationship */
  subscriptions_planlistdetails_aggregate: Subscriptions_Planlistdetail_Aggregate;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "subscriptions_planlist" */
export type Subscriptions_PlanlistSubscriptions_PlanlistdetailsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlistdetail_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};


/** columns and relationships of "subscriptions_planlist" */
export type Subscriptions_PlanlistSubscriptions_Planlistdetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlistdetail_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};

/** aggregated selection of "subscriptions_planlist" */
export type Subscriptions_Planlist_Aggregate = {
  __typename?: 'subscriptions_planlist_aggregate';
  aggregate?: Maybe<Subscriptions_Planlist_Aggregate_Fields>;
  nodes: Array<Subscriptions_Planlist>;
};

/** aggregate fields of "subscriptions_planlist" */
export type Subscriptions_Planlist_Aggregate_Fields = {
  __typename?: 'subscriptions_planlist_aggregate_fields';
  avg?: Maybe<Subscriptions_Planlist_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Planlist_Max_Fields>;
  min?: Maybe<Subscriptions_Planlist_Min_Fields>;
  stddev?: Maybe<Subscriptions_Planlist_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Planlist_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Planlist_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Planlist_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Planlist_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Planlist_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Planlist_Variance_Fields>;
};


/** aggregate fields of "subscriptions_planlist" */
export type Subscriptions_Planlist_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Planlist_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Subscriptions_Planlist_Avg_Fields = {
  __typename?: 'subscriptions_planlist_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "subscriptions_planlist". All fields are combined with a logical 'AND'. */
export type Subscriptions_Planlist_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Planlist_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Planlist_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Planlist_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  footer?: InputMaybe<String_Comparison_Exp>;
  header?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  subscriptions_planlistdetails?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
  subscriptions_planlistdetails_aggregate?: InputMaybe<Subscriptions_Planlistdetail_Aggregate_Bool_Exp>;
  subtitle?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions_planlist" */
export enum Subscriptions_Planlist_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPlanlistPkey = 'subscriptions_planlist_pkey',
  /** unique or primary key constraint on columns "slug" */
  SubscriptionsPlanlistSlugKey = 'subscriptions_planlist_slug_key'
}

/** input type for incrementing numeric columns in table "subscriptions_planlist" */
export type Subscriptions_Planlist_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscriptions_planlist" */
export type Subscriptions_Planlist_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subscriptions_planlistdetails?: InputMaybe<Subscriptions_Planlistdetail_Arr_Rel_Insert_Input>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subscriptions_Planlist_Max_Fields = {
  __typename?: 'subscriptions_planlist_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Subscriptions_Planlist_Min_Fields = {
  __typename?: 'subscriptions_planlist_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "subscriptions_planlist" */
export type Subscriptions_Planlist_Mutation_Response = {
  __typename?: 'subscriptions_planlist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Planlist>;
};

/** input type for inserting object relation for remote table "subscriptions_planlist" */
export type Subscriptions_Planlist_Obj_Rel_Insert_Input = {
  data: Subscriptions_Planlist_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_Planlist_On_Conflict>;
};

/** on_conflict condition type for table "subscriptions_planlist" */
export type Subscriptions_Planlist_On_Conflict = {
  constraint: Subscriptions_Planlist_Constraint;
  update_columns?: Array<Subscriptions_Planlist_Update_Column>;
  where?: InputMaybe<Subscriptions_Planlist_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions_planlist". */
export type Subscriptions_Planlist_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  footer?: InputMaybe<Order_By>;
  header?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  subscriptions_planlistdetails_aggregate?: InputMaybe<Subscriptions_Planlistdetail_Aggregate_Order_By>;
  subtitle?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions_planlist */
export type Subscriptions_Planlist_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscriptions_planlist" */
export enum Subscriptions_Planlist_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Footer = 'footer',
  /** column name */
  Header = 'header',
  /** column name */
  Id = 'id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscriptions_planlist" */
export type Subscriptions_Planlist_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Planlist_Stddev_Fields = {
  __typename?: 'subscriptions_planlist_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Planlist_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_planlist_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Planlist_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_planlist_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "subscriptions_planlist" */
export type Subscriptions_Planlist_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Planlist_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Planlist_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Planlist_Sum_Fields = {
  __typename?: 'subscriptions_planlist_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "subscriptions_planlist" */
export enum Subscriptions_Planlist_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Footer = 'footer',
  /** column name */
  Header = 'header',
  /** column name */
  Id = 'id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Planlist_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Planlist_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Planlist_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Planlist_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Planlist_Var_Pop_Fields = {
  __typename?: 'subscriptions_planlist_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Planlist_Var_Samp_Fields = {
  __typename?: 'subscriptions_planlist_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Subscriptions_Planlist_Variance_Fields = {
  __typename?: 'subscriptions_planlist_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail = {
  __typename?: 'subscriptions_planlistdetail';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  html_content?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  plan_id: Scalars['uuid']['output'];
  plan_list_id: Scalars['Int']['output'];
  subscribe_button_text?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  subscriptions_planlist: Subscriptions_Planlist;
  /** An object relationship */
  subscriptions_subscriptionplan: Subscriptions_Subscriptionplan;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Aggregate = {
  __typename?: 'subscriptions_planlistdetail_aggregate';
  aggregate?: Maybe<Subscriptions_Planlistdetail_Aggregate_Fields>;
  nodes: Array<Subscriptions_Planlistdetail>;
};

export type Subscriptions_Planlistdetail_Aggregate_Bool_Exp = {
  count?: InputMaybe<Subscriptions_Planlistdetail_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Planlistdetail_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Aggregate_Fields = {
  __typename?: 'subscriptions_planlistdetail_aggregate_fields';
  avg?: Maybe<Subscriptions_Planlistdetail_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Planlistdetail_Max_Fields>;
  min?: Maybe<Subscriptions_Planlistdetail_Min_Fields>;
  stddev?: Maybe<Subscriptions_Planlistdetail_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Planlistdetail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Planlistdetail_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Planlistdetail_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Planlistdetail_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Planlistdetail_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Planlistdetail_Variance_Fields>;
};


/** aggregate fields of "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Planlistdetail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Planlistdetail_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Planlistdetail_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Planlistdetail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Planlistdetail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Planlistdetail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Planlistdetail_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Planlistdetail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Planlistdetail_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Planlistdetail_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Arr_Rel_Insert_Input = {
  data: Array<Subscriptions_Planlistdetail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_Planlistdetail_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscriptions_Planlistdetail_Avg_Fields = {
  __typename?: 'subscriptions_planlistdetail_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plan_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions_planlistdetail". All fields are combined with a logical 'AND'. */
export type Subscriptions_Planlistdetail_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Planlistdetail_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Planlistdetail_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  html_content?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  plan_list_id?: InputMaybe<Int_Comparison_Exp>;
  subscribe_button_text?: InputMaybe<String_Comparison_Exp>;
  subscriptions_planlist?: InputMaybe<Subscriptions_Planlist_Bool_Exp>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions_planlistdetail" */
export enum Subscriptions_Planlistdetail_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPlanlistdetailPkey = 'subscriptions_planlistdetail_pkey'
}

/** input type for incrementing numeric columns in table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  plan_list_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  html_content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  plan_list_id?: InputMaybe<Scalars['Int']['input']>;
  subscribe_button_text?: InputMaybe<Scalars['String']['input']>;
  subscriptions_planlist?: InputMaybe<Subscriptions_Planlist_Obj_Rel_Insert_Input>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subscriptions_Planlistdetail_Max_Fields = {
  __typename?: 'subscriptions_planlistdetail_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  html_content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  plan_list_id?: Maybe<Scalars['Int']['output']>;
  subscribe_button_text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  html_content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
  subscribe_button_text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Planlistdetail_Min_Fields = {
  __typename?: 'subscriptions_planlistdetail_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  html_content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  plan_list_id?: Maybe<Scalars['Int']['output']>;
  subscribe_button_text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  html_content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
  subscribe_button_text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Mutation_Response = {
  __typename?: 'subscriptions_planlistdetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Planlistdetail>;
};

/** on_conflict condition type for table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_On_Conflict = {
  constraint: Subscriptions_Planlistdetail_Constraint;
  update_columns?: Array<Subscriptions_Planlistdetail_Update_Column>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions_planlistdetail". */
export type Subscriptions_Planlistdetail_Order_By = {
  created_at?: InputMaybe<Order_By>;
  html_content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
  subscribe_button_text?: InputMaybe<Order_By>;
  subscriptions_planlist?: InputMaybe<Subscriptions_Planlist_Order_By>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions_planlistdetail */
export type Subscriptions_Planlistdetail_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscriptions_planlistdetail" */
export enum Subscriptions_Planlistdetail_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HtmlContent = 'html_content',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  PlanListId = 'plan_list_id',
  /** column name */
  SubscribeButtonText = 'subscribe_button_text',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  html_content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  plan_list_id?: InputMaybe<Scalars['Int']['input']>;
  subscribe_button_text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Planlistdetail_Stddev_Fields = {
  __typename?: 'subscriptions_planlistdetail_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plan_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Planlistdetail_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_planlistdetail_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plan_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Planlistdetail_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_planlistdetail_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plan_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Planlistdetail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Planlistdetail_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  html_content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  plan_list_id?: InputMaybe<Scalars['Int']['input']>;
  subscribe_button_text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Planlistdetail_Sum_Fields = {
  __typename?: 'subscriptions_planlistdetail_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  plan_list_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions_planlistdetail" */
export enum Subscriptions_Planlistdetail_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HtmlContent = 'html_content',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  PlanListId = 'plan_list_id',
  /** column name */
  SubscribeButtonText = 'subscribe_button_text',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Planlistdetail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Planlistdetail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Planlistdetail_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Planlistdetail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Planlistdetail_Var_Pop_Fields = {
  __typename?: 'subscriptions_planlistdetail_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plan_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Planlistdetail_Var_Samp_Fields = {
  __typename?: 'subscriptions_planlistdetail_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plan_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscriptions_Planlistdetail_Variance_Fields = {
  __typename?: 'subscriptions_planlistdetail_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plan_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscriptions_planlistdetail" */
export type Subscriptions_Planlistdetail_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  plan_list_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscriptions_plantag" */
export type Subscriptions_Plantag = {
  __typename?: 'subscriptions_plantag';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "subscriptions_plantag" */
export type Subscriptions_Plantag_Aggregate = {
  __typename?: 'subscriptions_plantag_aggregate';
  aggregate?: Maybe<Subscriptions_Plantag_Aggregate_Fields>;
  nodes: Array<Subscriptions_Plantag>;
};

/** aggregate fields of "subscriptions_plantag" */
export type Subscriptions_Plantag_Aggregate_Fields = {
  __typename?: 'subscriptions_plantag_aggregate_fields';
  avg?: Maybe<Subscriptions_Plantag_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Plantag_Max_Fields>;
  min?: Maybe<Subscriptions_Plantag_Min_Fields>;
  stddev?: Maybe<Subscriptions_Plantag_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Plantag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Plantag_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Plantag_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Plantag_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Plantag_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Plantag_Variance_Fields>;
};


/** aggregate fields of "subscriptions_plantag" */
export type Subscriptions_Plantag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Plantag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Subscriptions_Plantag_Avg_Fields = {
  __typename?: 'subscriptions_plantag_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "subscriptions_plantag". All fields are combined with a logical 'AND'. */
export type Subscriptions_Plantag_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Plantag_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Plantag_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Plantag_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions_plantag" */
export enum Subscriptions_Plantag_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPlantagPkey = 'subscriptions_plantag_pkey',
  /** unique or primary key constraint on columns "tag" */
  SubscriptionsPlantagTagKey = 'subscriptions_plantag_tag_key'
}

/** input type for incrementing numeric columns in table "subscriptions_plantag" */
export type Subscriptions_Plantag_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscriptions_plantag" */
export type Subscriptions_Plantag_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subscriptions_Plantag_Max_Fields = {
  __typename?: 'subscriptions_plantag_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Subscriptions_Plantag_Min_Fields = {
  __typename?: 'subscriptions_plantag_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "subscriptions_plantag" */
export type Subscriptions_Plantag_Mutation_Response = {
  __typename?: 'subscriptions_plantag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Plantag>;
};

/** on_conflict condition type for table "subscriptions_plantag" */
export type Subscriptions_Plantag_On_Conflict = {
  constraint: Subscriptions_Plantag_Constraint;
  update_columns?: Array<Subscriptions_Plantag_Update_Column>;
  where?: InputMaybe<Subscriptions_Plantag_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions_plantag". */
export type Subscriptions_Plantag_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions_plantag */
export type Subscriptions_Plantag_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscriptions_plantag" */
export enum Subscriptions_Plantag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscriptions_plantag" */
export type Subscriptions_Plantag_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Plantag_Stddev_Fields = {
  __typename?: 'subscriptions_plantag_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Plantag_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_plantag_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Plantag_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_plantag_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "subscriptions_plantag" */
export type Subscriptions_Plantag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Plantag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Plantag_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Plantag_Sum_Fields = {
  __typename?: 'subscriptions_plantag_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "subscriptions_plantag" */
export enum Subscriptions_Plantag_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Plantag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Plantag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Plantag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Plantag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Plantag_Var_Pop_Fields = {
  __typename?: 'subscriptions_plantag_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Plantag_Var_Samp_Fields = {
  __typename?: 'subscriptions_plantag_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Subscriptions_Plantag_Variance_Fields = {
  __typename?: 'subscriptions_plantag_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan = {
  __typename?: 'subscriptions_subscriptionplan';
  /** An array relationship */
  advertisements: Array<Advertisements>;
  /** An aggregate relationship */
  advertisements_aggregate: Advertisements_Aggregate;
  cost?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  coupons_coupon_applicable_packages: Array<Coupons_Coupon_Applicable_Packages>;
  /** An aggregate relationship */
  coupons_coupon_applicable_packages_aggregate: Coupons_Coupon_Applicable_Packages_Aggregate;
  /** An array relationship */
  coupons_couponusers: Array<Coupons_Couponuser>;
  /** An aggregate relationship */
  coupons_couponusers_aggregate: Coupons_Couponuser_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  group_plan_users: Array<Group_Discount_Users>;
  /** An aggregate relationship */
  group_plan_users_aggregate: Group_Discount_Users_Aggregate;
  id: Scalars['uuid']['output'];
  is_a_top_pack: Scalars['Boolean']['output'];
  is_invisible: Scalars['Boolean']['output'];
  most_popular: Scalars['Boolean']['output'];
  /** An object relationship */
  package_content?: Maybe<Packages_Content>;
  /** An array relationship */
  packages_contents: Array<Packages_Content>;
  /** An aggregate relationship */
  packages_contents_aggregate: Packages_Content_Aggregate;
  /** An array relationship */
  packages_payment_transactions: Array<Packages_Payment_Transaction>;
  /** An aggregate relationship */
  packages_payment_transactions_aggregate: Packages_Payment_Transaction_Aggregate;
  /** An array relationship */
  packages_paymenttransactions: Array<Packages_Paymenttransaction>;
  /** An aggregate relationship */
  packages_paymenttransactions_aggregate: Packages_Paymenttransaction_Aggregate;
  plan_description?: Maybe<Scalars['String']['output']>;
  plan_name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  striked_price?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  subscription_group_plans: Array<Subscription_Group_Plan>;
  /** An aggregate relationship */
  subscription_group_plans_aggregate: Subscription_Group_Plan_Aggregate;
  /** An array relationship */
  subscriptionsSubscriptionplanUpgradablePlansByToSubscriptionplanId: Array<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** An aggregate relationship */
  subscriptionsSubscriptionplanUpgradablePlansByToSubscriptionplanId_aggregate: Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate;
  /** An array relationship */
  subscriptions_plancosts: Array<Subscriptions_Plancost>;
  /** An aggregate relationship */
  subscriptions_plancosts_aggregate: Subscriptions_Plancost_Aggregate;
  /** An array relationship */
  subscriptions_planlistdetails: Array<Subscriptions_Planlistdetail>;
  /** An aggregate relationship */
  subscriptions_planlistdetails_aggregate: Subscriptions_Planlistdetail_Aggregate;
  /** An array relationship */
  subscriptions_subscriptionplan_upgradable_plans: Array<Subscriptions_Subscriptionplan_Upgradable_Plans>;
  /** An aggregate relationship */
  subscriptions_subscriptionplan_upgradable_plans_aggregate: Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate;
  unlimited_speed_concept: Scalars['Boolean']['output'];
  unlimited_speed_quant: Scalars['Boolean']['output'];
  unlimited_speed_verbal: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanAdvertisementsArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanAdvertisements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanCoupons_Coupon_Applicable_PackagesArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanCoupons_Coupon_Applicable_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Coupon_Applicable_Packages_Order_By>>;
  where?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanCoupons_CouponusersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanCoupons_Couponusers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanGroup_Plan_UsersArgs = {
  distinct_on?: InputMaybe<Array<Group_Discount_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Discount_Users_Order_By>>;
  where?: InputMaybe<Group_Discount_Users_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanGroup_Plan_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Discount_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Discount_Users_Order_By>>;
  where?: InputMaybe<Group_Discount_Users_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanPackages_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Order_By>>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanPackages_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Content_Order_By>>;
  where?: InputMaybe<Packages_Content_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanPackages_Payment_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanPackages_Payment_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanPackages_PaymenttransactionsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanPackages_Paymenttransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscription_Group_PlansArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscription_Group_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Group_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Group_Plan_Order_By>>;
  where?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscriptionsSubscriptionplanUpgradablePlansByToSubscriptionplanIdArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscriptionsSubscriptionplanUpgradablePlansByToSubscriptionplanId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscriptions_PlancostsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plancost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plancost_Order_By>>;
  where?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscriptions_Plancosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Plancost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Plancost_Order_By>>;
  where?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscriptions_PlanlistdetailsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlistdetail_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscriptions_Planlistdetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Planlistdetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Planlistdetail_Order_By>>;
  where?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscriptions_Subscriptionplan_Upgradable_PlansArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};


/** columns and relationships of "subscriptions_subscriptionplan" */
export type Subscriptions_SubscriptionplanSubscriptions_Subscriptionplan_Upgradable_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};

/** aggregated selection of "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_Aggregate = {
  __typename?: 'subscriptions_subscriptionplan_aggregate';
  aggregate?: Maybe<Subscriptions_Subscriptionplan_Aggregate_Fields>;
  nodes: Array<Subscriptions_Subscriptionplan>;
};

/** aggregate fields of "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_Aggregate_Fields = {
  __typename?: 'subscriptions_subscriptionplan_aggregate_fields';
  avg?: Maybe<Subscriptions_Subscriptionplan_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Subscriptionplan_Max_Fields>;
  min?: Maybe<Subscriptions_Subscriptionplan_Min_Fields>;
  stddev?: Maybe<Subscriptions_Subscriptionplan_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Subscriptionplan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Subscriptionplan_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Subscriptionplan_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Subscriptionplan_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Subscriptionplan_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Subscriptionplan_Variance_Fields>;
};


/** aggregate fields of "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Subscriptionplan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Subscriptions_Subscriptionplan_Avg_Fields = {
  __typename?: 'subscriptions_subscriptionplan_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  striked_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "subscriptions_subscriptionplan". All fields are combined with a logical 'AND'. */
export type Subscriptions_Subscriptionplan_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Subscriptionplan_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Subscriptionplan_Bool_Exp>>;
  advertisements?: InputMaybe<Advertisements_Bool_Exp>;
  advertisements_aggregate?: InputMaybe<Advertisements_Aggregate_Bool_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  coupons_coupon_applicable_packages?: InputMaybe<Coupons_Coupon_Applicable_Packages_Bool_Exp>;
  coupons_coupon_applicable_packages_aggregate?: InputMaybe<Coupons_Coupon_Applicable_Packages_Aggregate_Bool_Exp>;
  coupons_couponusers?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
  coupons_couponusers_aggregate?: InputMaybe<Coupons_Couponuser_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_plan_users?: InputMaybe<Group_Discount_Users_Bool_Exp>;
  group_plan_users_aggregate?: InputMaybe<Group_Discount_Users_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_a_top_pack?: InputMaybe<Boolean_Comparison_Exp>;
  is_invisible?: InputMaybe<Boolean_Comparison_Exp>;
  most_popular?: InputMaybe<Boolean_Comparison_Exp>;
  package_content?: InputMaybe<Packages_Content_Bool_Exp>;
  packages_contents?: InputMaybe<Packages_Content_Bool_Exp>;
  packages_contents_aggregate?: InputMaybe<Packages_Content_Aggregate_Bool_Exp>;
  packages_payment_transactions?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
  packages_payment_transactions_aggregate?: InputMaybe<Packages_Payment_Transaction_Aggregate_Bool_Exp>;
  packages_paymenttransactions?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
  packages_paymenttransactions_aggregate?: InputMaybe<Packages_Paymenttransaction_Aggregate_Bool_Exp>;
  plan_description?: InputMaybe<String_Comparison_Exp>;
  plan_name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  striked_price?: InputMaybe<Numeric_Comparison_Exp>;
  subscription_group_plans?: InputMaybe<Subscription_Group_Plan_Bool_Exp>;
  subscription_group_plans_aggregate?: InputMaybe<Subscription_Group_Plan_Aggregate_Bool_Exp>;
  subscriptionsSubscriptionplanUpgradablePlansByToSubscriptionplanId?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
  subscriptionsSubscriptionplanUpgradablePlansByToSubscriptionplanId_aggregate?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Bool_Exp>;
  subscriptions_plancosts?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
  subscriptions_plancosts_aggregate?: InputMaybe<Subscriptions_Plancost_Aggregate_Bool_Exp>;
  subscriptions_planlistdetails?: InputMaybe<Subscriptions_Planlistdetail_Bool_Exp>;
  subscriptions_planlistdetails_aggregate?: InputMaybe<Subscriptions_Planlistdetail_Aggregate_Bool_Exp>;
  subscriptions_subscriptionplan_upgradable_plans?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
  subscriptions_subscriptionplan_upgradable_plans_aggregate?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Bool_Exp>;
  unlimited_speed_concept?: InputMaybe<Boolean_Comparison_Exp>;
  unlimited_speed_quant?: InputMaybe<Boolean_Comparison_Exp>;
  unlimited_speed_verbal?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions_subscriptionplan" */
export enum Subscriptions_Subscriptionplan_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsSubscriptionplanPkey = 'subscriptions_subscriptionplan_pkey',
  /** unique or primary key constraint on columns "slug" */
  SubscriptionsSubscriptionplanSlugKey = 'subscriptions_subscriptionplan_slug_key'
}

/** input type for incrementing numeric columns in table "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_Inc_Input = {
  cost?: InputMaybe<Scalars['numeric']['input']>;
  striked_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_Insert_Input = {
  advertisements?: InputMaybe<Advertisements_Arr_Rel_Insert_Input>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  coupons_coupon_applicable_packages?: InputMaybe<Coupons_Coupon_Applicable_Packages_Arr_Rel_Insert_Input>;
  coupons_couponusers?: InputMaybe<Coupons_Couponuser_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_plan_users?: InputMaybe<Group_Discount_Users_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_a_top_pack?: InputMaybe<Scalars['Boolean']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  most_popular?: InputMaybe<Scalars['Boolean']['input']>;
  package_content?: InputMaybe<Packages_Content_Obj_Rel_Insert_Input>;
  packages_contents?: InputMaybe<Packages_Content_Arr_Rel_Insert_Input>;
  packages_payment_transactions?: InputMaybe<Packages_Payment_Transaction_Arr_Rel_Insert_Input>;
  packages_paymenttransactions?: InputMaybe<Packages_Paymenttransaction_Arr_Rel_Insert_Input>;
  plan_description?: InputMaybe<Scalars['String']['input']>;
  plan_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  striked_price?: InputMaybe<Scalars['numeric']['input']>;
  subscription_group_plans?: InputMaybe<Subscription_Group_Plan_Arr_Rel_Insert_Input>;
  subscriptionsSubscriptionplanUpgradablePlansByToSubscriptionplanId?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Arr_Rel_Insert_Input>;
  subscriptions_plancosts?: InputMaybe<Subscriptions_Plancost_Arr_Rel_Insert_Input>;
  subscriptions_planlistdetails?: InputMaybe<Subscriptions_Planlistdetail_Arr_Rel_Insert_Input>;
  subscriptions_subscriptionplan_upgradable_plans?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Arr_Rel_Insert_Input>;
  unlimited_speed_concept?: InputMaybe<Scalars['Boolean']['input']>;
  unlimited_speed_quant?: InputMaybe<Scalars['Boolean']['input']>;
  unlimited_speed_verbal?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subscriptions_Subscriptionplan_Max_Fields = {
  __typename?: 'subscriptions_subscriptionplan_max_fields';
  cost?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  plan_description?: Maybe<Scalars['String']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  striked_price?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Subscriptions_Subscriptionplan_Min_Fields = {
  __typename?: 'subscriptions_subscriptionplan_min_fields';
  cost?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  plan_description?: Maybe<Scalars['String']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  striked_price?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_Mutation_Response = {
  __typename?: 'subscriptions_subscriptionplan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Subscriptionplan>;
};

/** input type for inserting object relation for remote table "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input = {
  data: Subscriptions_Subscriptionplan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_Subscriptionplan_On_Conflict>;
};

/** on_conflict condition type for table "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_On_Conflict = {
  constraint: Subscriptions_Subscriptionplan_Constraint;
  update_columns?: Array<Subscriptions_Subscriptionplan_Update_Column>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions_subscriptionplan". */
export type Subscriptions_Subscriptionplan_Order_By = {
  advertisements_aggregate?: InputMaybe<Advertisements_Aggregate_Order_By>;
  cost?: InputMaybe<Order_By>;
  coupons_coupon_applicable_packages_aggregate?: InputMaybe<Coupons_Coupon_Applicable_Packages_Aggregate_Order_By>;
  coupons_couponusers_aggregate?: InputMaybe<Coupons_Couponuser_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_plan_users_aggregate?: InputMaybe<Group_Discount_Users_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_a_top_pack?: InputMaybe<Order_By>;
  is_invisible?: InputMaybe<Order_By>;
  most_popular?: InputMaybe<Order_By>;
  package_content?: InputMaybe<Packages_Content_Order_By>;
  packages_contents_aggregate?: InputMaybe<Packages_Content_Aggregate_Order_By>;
  packages_payment_transactions_aggregate?: InputMaybe<Packages_Payment_Transaction_Aggregate_Order_By>;
  packages_paymenttransactions_aggregate?: InputMaybe<Packages_Paymenttransaction_Aggregate_Order_By>;
  plan_description?: InputMaybe<Order_By>;
  plan_name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  striked_price?: InputMaybe<Order_By>;
  subscription_group_plans_aggregate?: InputMaybe<Subscription_Group_Plan_Aggregate_Order_By>;
  subscriptionsSubscriptionplanUpgradablePlansByToSubscriptionplanId_aggregate?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Order_By>;
  subscriptions_plancosts_aggregate?: InputMaybe<Subscriptions_Plancost_Aggregate_Order_By>;
  subscriptions_planlistdetails_aggregate?: InputMaybe<Subscriptions_Planlistdetail_Aggregate_Order_By>;
  subscriptions_subscriptionplan_upgradable_plans_aggregate?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Order_By>;
  unlimited_speed_concept?: InputMaybe<Order_By>;
  unlimited_speed_quant?: InputMaybe<Order_By>;
  unlimited_speed_verbal?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions_subscriptionplan */
export type Subscriptions_Subscriptionplan_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "subscriptions_subscriptionplan" */
export enum Subscriptions_Subscriptionplan_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsATopPack = 'is_a_top_pack',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  MostPopular = 'most_popular',
  /** column name */
  PlanDescription = 'plan_description',
  /** column name */
  PlanName = 'plan_name',
  /** column name */
  Slug = 'slug',
  /** column name */
  StrikedPrice = 'striked_price',
  /** column name */
  UnlimitedSpeedConcept = 'unlimited_speed_concept',
  /** column name */
  UnlimitedSpeedQuant = 'unlimited_speed_quant',
  /** column name */
  UnlimitedSpeedVerbal = 'unlimited_speed_verbal',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_Set_Input = {
  cost?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_a_top_pack?: InputMaybe<Scalars['Boolean']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  most_popular?: InputMaybe<Scalars['Boolean']['input']>;
  plan_description?: InputMaybe<Scalars['String']['input']>;
  plan_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  striked_price?: InputMaybe<Scalars['numeric']['input']>;
  unlimited_speed_concept?: InputMaybe<Scalars['Boolean']['input']>;
  unlimited_speed_quant?: InputMaybe<Scalars['Boolean']['input']>;
  unlimited_speed_verbal?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Subscriptionplan_Stddev_Fields = {
  __typename?: 'subscriptions_subscriptionplan_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  striked_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Subscriptionplan_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_subscriptionplan_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  striked_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Subscriptionplan_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_subscriptionplan_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  striked_price?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "subscriptions_subscriptionplan" */
export type Subscriptions_Subscriptionplan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Subscriptionplan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Subscriptionplan_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_a_top_pack?: InputMaybe<Scalars['Boolean']['input']>;
  is_invisible?: InputMaybe<Scalars['Boolean']['input']>;
  most_popular?: InputMaybe<Scalars['Boolean']['input']>;
  plan_description?: InputMaybe<Scalars['String']['input']>;
  plan_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  striked_price?: InputMaybe<Scalars['numeric']['input']>;
  unlimited_speed_concept?: InputMaybe<Scalars['Boolean']['input']>;
  unlimited_speed_quant?: InputMaybe<Scalars['Boolean']['input']>;
  unlimited_speed_verbal?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Subscriptionplan_Sum_Fields = {
  __typename?: 'subscriptions_subscriptionplan_sum_fields';
  cost?: Maybe<Scalars['numeric']['output']>;
  striked_price?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "subscriptions_subscriptionplan" */
export enum Subscriptions_Subscriptionplan_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsATopPack = 'is_a_top_pack',
  /** column name */
  IsInvisible = 'is_invisible',
  /** column name */
  MostPopular = 'most_popular',
  /** column name */
  PlanDescription = 'plan_description',
  /** column name */
  PlanName = 'plan_name',
  /** column name */
  Slug = 'slug',
  /** column name */
  StrikedPrice = 'striked_price',
  /** column name */
  UnlimitedSpeedConcept = 'unlimited_speed_concept',
  /** column name */
  UnlimitedSpeedQuant = 'unlimited_speed_quant',
  /** column name */
  UnlimitedSpeedVerbal = 'unlimited_speed_verbal',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Subscriptionplan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Subscriptionplan_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Subscriptionplan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Subscriptionplan_Bool_Exp;
};

/** columns and relationships of "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans';
  from_subscriptionplan_id: Scalars['uuid']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  subscriptionsSubscriptionplanByToSubscriptionplanId: Subscriptions_Subscriptionplan;
  /** An object relationship */
  subscriptions_subscriptionplan: Subscriptions_Subscriptionplan;
  to_subscriptionplan_id: Scalars['uuid']['output'];
};

/** aggregated selection of "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_aggregate';
  aggregate?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Fields>;
  nodes: Array<Subscriptions_Subscriptionplan_Upgradable_Plans>;
};

export type Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Bool_Exp = {
  count?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_aggregate_fields';
  avg?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Max_Fields>;
  min?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Min_Fields>;
  stddev?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Variance_Fields>;
};


/** aggregate fields of "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Arr_Rel_Insert_Input = {
  data: Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Avg_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions_subscriptionplan_upgradable_plans". All fields are combined with a logical 'AND'. */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>>;
  from_subscriptionplan_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  subscriptionsSubscriptionplanByToSubscriptionplanId?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Bool_Exp>;
  to_subscriptionplan_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions_subscriptionplan_upgradable_plans" */
export enum Subscriptions_Subscriptionplan_Upgradable_Plans_Constraint {
  /** unique or primary key constraint on columns "to_subscriptionplan_id", "from_subscriptionplan_id" */
  SubscriptionsSubscriptiFromSubscriptionplanIdB37060b3Uniq = 'subscriptions_subscripti_from_subscriptionplan_id_b37060b3_uniq',
  /** unique or primary key constraint on columns "id" */
  SubscriptionsSubscriptionplanUpgradablePlansPkey = 'subscriptions_subscriptionplan_upgradable_plans_pkey'
}

/** input type for incrementing numeric columns in table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Insert_Input = {
  from_subscriptionplan_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscriptionsSubscriptionplanByToSubscriptionplanId?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Obj_Rel_Insert_Input>;
  to_subscriptionplan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Max_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_max_fields';
  from_subscriptionplan_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  to_subscriptionplan_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Max_Order_By = {
  from_subscriptionplan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_subscriptionplan_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Min_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_min_fields';
  from_subscriptionplan_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  to_subscriptionplan_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Min_Order_By = {
  from_subscriptionplan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_subscriptionplan_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Mutation_Response = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Subscriptionplan_Upgradable_Plans>;
};

/** on_conflict condition type for table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_On_Conflict = {
  constraint: Subscriptions_Subscriptionplan_Upgradable_Plans_Constraint;
  update_columns?: Array<Subscriptions_Subscriptionplan_Upgradable_Plans_Update_Column>;
  where?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions_subscriptionplan_upgradable_plans". */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Order_By = {
  from_subscriptionplan_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscriptionsSubscriptionplanByToSubscriptionplanId?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  subscriptions_subscriptionplan?: InputMaybe<Subscriptions_Subscriptionplan_Order_By>;
  to_subscriptionplan_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions_subscriptionplan_upgradable_plans */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export enum Subscriptions_Subscriptionplan_Upgradable_Plans_Select_Column {
  /** column name */
  FromSubscriptionplanId = 'from_subscriptionplan_id',
  /** column name */
  Id = 'id',
  /** column name */
  ToSubscriptionplanId = 'to_subscriptionplan_id'
}

/** input type for updating data in table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Set_Input = {
  from_subscriptionplan_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  to_subscriptionplan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Subscriptionplan_Upgradable_Plans_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Stream_Cursor_Value_Input = {
  from_subscriptionplan_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  to_subscriptionplan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Sum_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export enum Subscriptions_Subscriptionplan_Upgradable_Plans_Update_Column {
  /** column name */
  FromSubscriptionplanId = 'from_subscriptionplan_id',
  /** column name */
  Id = 'id',
  /** column name */
  ToSubscriptionplanId = 'to_subscriptionplan_id'
}

export type Subscriptions_Subscriptionplan_Upgradable_Plans_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Subscriptionplan_Upgradable_Plans_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Subscriptionplan_Upgradable_Plans_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Var_Pop_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Var_Samp_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Variance_Fields = {
  __typename?: 'subscriptions_subscriptionplan_upgradable_plans_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscriptions_subscriptionplan_upgradable_plans" */
export type Subscriptions_Subscriptionplan_Upgradable_Plans_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Subscriptions_Subscriptionplan_Var_Pop_Fields = {
  __typename?: 'subscriptions_subscriptionplan_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  striked_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Subscriptionplan_Var_Samp_Fields = {
  __typename?: 'subscriptions_subscriptionplan_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  striked_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Subscriptions_Subscriptionplan_Variance_Fields = {
  __typename?: 'subscriptions_subscriptionplan_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  striked_price?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction = {
  __typename?: 'subscriptions_subscriptiontransaction';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_transaction: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  subscriptions_plancost?: Maybe<Subscriptions_Plancost>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  users_user?: Maybe<Users_User>;
};

/** aggregated selection of "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Aggregate = {
  __typename?: 'subscriptions_subscriptiontransaction_aggregate';
  aggregate?: Maybe<Subscriptions_Subscriptiontransaction_Aggregate_Fields>;
  nodes: Array<Subscriptions_Subscriptiontransaction>;
};

export type Subscriptions_Subscriptiontransaction_Aggregate_Bool_Exp = {
  count?: InputMaybe<Subscriptions_Subscriptiontransaction_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Subscriptiontransaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Aggregate_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_aggregate_fields';
  avg?: Maybe<Subscriptions_Subscriptiontransaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Subscriptiontransaction_Max_Fields>;
  min?: Maybe<Subscriptions_Subscriptiontransaction_Min_Fields>;
  stddev?: Maybe<Subscriptions_Subscriptiontransaction_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Subscriptiontransaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Subscriptiontransaction_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Subscriptiontransaction_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Subscriptiontransaction_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Subscriptiontransaction_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Subscriptiontransaction_Variance_Fields>;
};


/** aggregate fields of "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Subscriptiontransaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Subscriptiontransaction_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Subscriptiontransaction_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Subscriptiontransaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Subscriptiontransaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Subscriptiontransaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Subscriptiontransaction_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Subscriptiontransaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Subscriptiontransaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Subscriptiontransaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Arr_Rel_Insert_Input = {
  data: Array<Subscriptions_Subscriptiontransaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_Subscriptiontransaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscriptions_Subscriptiontransaction_Avg_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions_subscriptiontransaction". All fields are combined with a logical 'AND'. */
export type Subscriptions_Subscriptiontransaction_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_transaction?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscriptions_plancost?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "subscriptions_subscriptiontransaction" */
export enum Subscriptions_Subscriptiontransaction_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsSubscriptiontransactionPkey = 'subscriptions_subscriptiontransaction_pkey'
}

/** input type for incrementing numeric columns in table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_transaction?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  subscriptions_plancost?: InputMaybe<Subscriptions_Plancost_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Subscriptions_Subscriptiontransaction_Max_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_transaction?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_transaction?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Subscriptiontransaction_Min_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_transaction?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_transaction?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Mutation_Response = {
  __typename?: 'subscriptions_subscriptiontransaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Subscriptiontransaction>;
};

/** on_conflict condition type for table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_On_Conflict = {
  constraint: Subscriptions_Subscriptiontransaction_Constraint;
  update_columns?: Array<Subscriptions_Subscriptiontransaction_Update_Column>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions_subscriptiontransaction". */
export type Subscriptions_Subscriptiontransaction_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_transaction?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  subscriptions_plancost?: InputMaybe<Subscriptions_Plancost_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: subscriptions_subscriptiontransaction */
export type Subscriptions_Subscriptiontransaction_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "subscriptions_subscriptiontransaction" */
export enum Subscriptions_Subscriptiontransaction_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTransaction = 'date_transaction',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_transaction?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Subscriptiontransaction_Stddev_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Subscriptiontransaction_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Subscriptiontransaction_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Subscriptiontransaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Subscriptiontransaction_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_transaction?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Subscriptiontransaction_Sum_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions_subscriptiontransaction" */
export enum Subscriptions_Subscriptiontransaction_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTransaction = 'date_transaction',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Subscriptions_Subscriptiontransaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Subscriptiontransaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Subscriptiontransaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Subscriptiontransaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Subscriptiontransaction_Var_Pop_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Subscriptiontransaction_Var_Samp_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscriptions_Subscriptiontransaction_Variance_Fields = {
  __typename?: 'subscriptions_subscriptiontransaction_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscriptions_subscriptiontransaction" */
export type Subscriptions_Subscriptiontransaction_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription = {
  __typename?: 'subscriptions_usersubscription';
  active: Scalars['Boolean']['output'];
  cancelled: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_end?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_last?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_next?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_start?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  subscriptions_plancost?: Maybe<Subscriptions_Plancost>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  users_user?: Maybe<Users_User>;
};

/** aggregated selection of "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Aggregate = {
  __typename?: 'subscriptions_usersubscription_aggregate';
  aggregate?: Maybe<Subscriptions_Usersubscription_Aggregate_Fields>;
  nodes: Array<Subscriptions_Usersubscription>;
};

export type Subscriptions_Usersubscription_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subscriptions_Usersubscription_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subscriptions_Usersubscription_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subscriptions_Usersubscription_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Usersubscription_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscriptions_Usersubscription_Select_Column_Subscriptions_Usersubscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Usersubscription_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscriptions_Usersubscription_Select_Column_Subscriptions_Usersubscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Usersubscription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Aggregate_Fields = {
  __typename?: 'subscriptions_usersubscription_aggregate_fields';
  avg?: Maybe<Subscriptions_Usersubscription_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Usersubscription_Max_Fields>;
  min?: Maybe<Subscriptions_Usersubscription_Min_Fields>;
  stddev?: Maybe<Subscriptions_Usersubscription_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Usersubscription_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Usersubscription_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Usersubscription_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Usersubscription_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Usersubscription_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Usersubscription_Variance_Fields>;
};


/** aggregate fields of "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Usersubscription_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Usersubscription_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Usersubscription_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Usersubscription_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Usersubscription_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Usersubscription_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Usersubscription_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Usersubscription_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Usersubscription_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Usersubscription_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Arr_Rel_Insert_Input = {
  data: Array<Subscriptions_Usersubscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_Usersubscription_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscriptions_Usersubscription_Avg_Fields = {
  __typename?: 'subscriptions_usersubscription_avg_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Avg_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions_usersubscription". All fields are combined with a logical 'AND'. */
export type Subscriptions_Usersubscription_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Usersubscription_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Usersubscription_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  cancelled?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_billing_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_billing_last?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_billing_next?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_billing_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscriptions_plancost?: InputMaybe<Subscriptions_Plancost_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "subscriptions_usersubscription" */
export enum Subscriptions_Usersubscription_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsUsersubscriptionPkey = 'subscriptions_usersubscription_pkey'
}

/** input type for incrementing numeric columns in table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Inc_Input = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_end?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_last?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_next?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_start?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  subscriptions_plancost?: InputMaybe<Subscriptions_Plancost_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Subscriptions_Usersubscription_Max_Fields = {
  __typename?: 'subscriptions_usersubscription_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_end?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_last?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_next?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_start?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date_billing_end?: InputMaybe<Order_By>;
  date_billing_last?: InputMaybe<Order_By>;
  date_billing_next?: InputMaybe<Order_By>;
  date_billing_start?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Usersubscription_Min_Fields = {
  __typename?: 'subscriptions_usersubscription_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_end?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_last?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_next?: Maybe<Scalars['timestamptz']['output']>;
  date_billing_start?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date_billing_end?: InputMaybe<Order_By>;
  date_billing_last?: InputMaybe<Order_By>;
  date_billing_next?: InputMaybe<Order_By>;
  date_billing_start?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Mutation_Response = {
  __typename?: 'subscriptions_usersubscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Usersubscription>;
};

/** on_conflict condition type for table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_On_Conflict = {
  constraint: Subscriptions_Usersubscription_Constraint;
  update_columns?: Array<Subscriptions_Usersubscription_Update_Column>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions_usersubscription". */
export type Subscriptions_Usersubscription_Order_By = {
  active?: InputMaybe<Order_By>;
  cancelled?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_billing_end?: InputMaybe<Order_By>;
  date_billing_last?: InputMaybe<Order_By>;
  date_billing_next?: InputMaybe<Order_By>;
  date_billing_start?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  subscriptions_plancost?: InputMaybe<Subscriptions_Plancost_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: subscriptions_usersubscription */
export type Subscriptions_Usersubscription_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "subscriptions_usersubscription" */
export enum Subscriptions_Usersubscription_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Cancelled = 'cancelled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateBillingEnd = 'date_billing_end',
  /** column name */
  DateBillingLast = 'date_billing_last',
  /** column name */
  DateBillingNext = 'date_billing_next',
  /** column name */
  DateBillingStart = 'date_billing_start',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "subscriptions_usersubscription_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscriptions_usersubscription" */
export enum Subscriptions_Usersubscription_Select_Column_Subscriptions_Usersubscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  Cancelled = 'cancelled'
}

/** select "subscriptions_usersubscription_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscriptions_usersubscription" */
export enum Subscriptions_Usersubscription_Select_Column_Subscriptions_Usersubscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  Cancelled = 'cancelled'
}

/** input type for updating data in table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_end?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_last?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_next?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_start?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Usersubscription_Stddev_Fields = {
  __typename?: 'subscriptions_usersubscription_stddev_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Stddev_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Usersubscription_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_usersubscription_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Stddev_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Usersubscription_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_usersubscription_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Stddev_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Usersubscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Usersubscription_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_end?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_last?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_next?: InputMaybe<Scalars['timestamptz']['input']>;
  date_billing_start?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Usersubscription_Sum_Fields = {
  __typename?: 'subscriptions_usersubscription_sum_fields';
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Sum_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions_usersubscription" */
export enum Subscriptions_Usersubscription_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Cancelled = 'cancelled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateBillingEnd = 'date_billing_end',
  /** column name */
  DateBillingLast = 'date_billing_last',
  /** column name */
  DateBillingNext = 'date_billing_next',
  /** column name */
  DateBillingStart = 'date_billing_start',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Subscriptions_Usersubscription_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Usersubscription_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Usersubscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Usersubscription_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Usersubscription_Var_Pop_Fields = {
  __typename?: 'subscriptions_usersubscription_var_pop_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Var_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Usersubscription_Var_Samp_Fields = {
  __typename?: 'subscriptions_usersubscription_var_samp_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Var_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscriptions_Usersubscription_Variance_Fields = {
  __typename?: 'subscriptions_usersubscription_variance_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscriptions_usersubscription" */
export type Subscriptions_Usersubscription_Variance_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users = {
  __typename?: 'supertokens_all_auth_recipe_users';
  app_id: Scalars['String']['output'];
  /** An object relationship */
  app_id_to_user_id?: Maybe<Supertokens_App_Id_To_User_Id>;
  /** An array relationship */
  bookmarked_learn_topics: Array<Bookmarked_Learn_Topics>;
  /** An aggregate relationship */
  bookmarked_learn_topics_aggregate: Bookmarked_Learn_Topics_Aggregate;
  /** An array relationship */
  coupons_allowed_users_rule_users: Array<Coupons_Allowed_Users_Rule_Users>;
  /** An aggregate relationship */
  coupons_allowed_users_rule_users_aggregate: Coupons_Allowed_Users_Rule_Users_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  emailpassword_user?: Maybe<Supertokens_Emailpassword_Users>;
  /** An object relationship */
  emailpassword_user_to_tenant?: Maybe<Supertokens_Emailpassword_User_To_Tenant>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  last_active?: Maybe<Supertokens_User_Last_Active>;
  /** An array relationship */
  packages_payment_transactions: Array<Packages_Payment_Transaction>;
  /** An aggregate relationship */
  packages_payment_transactions_aggregate: Packages_Payment_Transaction_Aggregate;
  /** An object relationship */
  passwordless_user_to_tenant?: Maybe<Supertokens_Passwordless_User_To_Tenant>;
  /** An array relationship */
  question_reports: Array<Question_Reports>;
  /** An aggregate relationship */
  question_reports_aggregate: Question_Reports_Aggregate;
  recipe_id: Scalars['String']['output'];
  /** An object relationship */
  roles?: Maybe<Supertokens_User_Roles>;
  /** An array relationship */
  speed_tests: Array<Speed_Tests>;
  /** An aggregate relationship */
  speed_tests_aggregate: Speed_Tests_Aggregate;
  /** An object relationship */
  tenant?: Maybe<Supertokens_Tenants>;
  tenant_id: Scalars['String']['output'];
  /** An object relationship */
  thirdparty_user_to_tenant?: Maybe<Supertokens_Thirdparty_User_To_Tenant>;
  time_joined: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  userActivitiesByUserId: Array<User_Activities>;
  /** An aggregate relationship */
  userActivitiesByUserId_aggregate: User_Activities_Aggregate;
  /** An array relationship */
  userAdditionalFieldsByUserId: Array<Supertokens_User_Additional_Fields>;
  /** An aggregate relationship */
  userAdditionalFieldsByUserId_aggregate: Supertokens_User_Additional_Fields_Aggregate;
  /** An array relationship */
  user_activities: Array<User_Activity>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activity_Aggregate;
  /** An object relationship */
  user_additional_fields?: Maybe<Supertokens_User_Additional_Fields>;
  user_id: Scalars['bpchar']['output'];
  /** An array relationship */
  user_leaderboards: Array<User_Leaderboards>;
  /** An aggregate relationship */
  user_leaderboards_aggregate: User_Leaderboards_Aggregate;
  /** An array relationship */
  user_learn_category_progresses: Array<User_Learn_Category_Progress>;
  /** An aggregate relationship */
  user_learn_category_progresses_aggregate: User_Learn_Category_Progress_Aggregate;
  /** An array relationship */
  user_learn_completed_topics: Array<User_Learn_Completed_Topics>;
  /** An aggregate relationship */
  user_learn_completed_topics_aggregate: User_Learn_Completed_Topics_Aggregate;
  /** An array relationship */
  user_learn_modules_summaries: Array<User_Learn_Modules_Summary>;
  /** An aggregate relationship */
  user_learn_modules_summaries_aggregate: User_Learn_Modules_Summary_Aggregate;
  /** An array relationship */
  user_learn_track_records: Array<User_Learn_Track_Record>;
  /** An aggregate relationship */
  user_learn_track_records_aggregate: User_Learn_Track_Record_Aggregate;
  /** An array relationship */
  user_planned_activities: Array<User_Planned_Activities>;
  /** An aggregate relationship */
  user_planned_activities_aggregate: User_Planned_Activities_Aggregate;
  /** An array relationship */
  user_pov_summaries: Array<User_Pov_Summaries>;
  /** An aggregate relationship */
  user_pov_summaries_aggregate: User_Pov_Summaries_Aggregate;
  /** An array relationship */
  user_quiz_question_attempts: Array<User_Quiz_Question_Attempts>;
  /** An aggregate relationship */
  user_quiz_question_attempts_aggregate: User_Quiz_Question_Attempts_Aggregate;
  /** An array relationship */
  user_quiz_summaries: Array<User_Quiz_Summaries>;
  /** An aggregate relationship */
  user_quiz_summaries_aggregate: User_Quiz_Summaries_Aggregate;
  /** An array relationship */
  user_quiz_summaries_olds: Array<User_Quiz_Summaries_Old>;
  /** An aggregate relationship */
  user_quiz_summaries_olds_aggregate: User_Quiz_Summaries_Old_Aggregate;
  /** An array relationship */
  user_section_summaries: Array<User_Section_Summaries>;
  /** An aggregate relationship */
  user_section_summaries_aggregate: User_Section_Summaries_Aggregate;
  /** An array relationship */
  user_speed_tests_summaries: Array<User_Speed_Tests_Summaries>;
  /** An aggregate relationship */
  user_speed_tests_summaries_aggregate: User_Speed_Tests_Summaries_Aggregate;
  /** An array relationship */
  user_xp_transactions: Array<User_Xp_Transactions>;
  /** An aggregate relationship */
  user_xp_transactions_aggregate: User_Xp_Transactions_Aggregate;
  /** An object relationship */
  userid_mapping?: Maybe<Supertokens_Userid_Mapping>;
  /** An array relationship */
  userid_mappings: Array<Supertokens_Userid_Mapping>;
  /** An aggregate relationship */
  userid_mappings_aggregate: Supertokens_Userid_Mapping_Aggregate;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersBookmarked_Learn_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bookmarked_Learn_Topics_Order_By>>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersBookmarked_Learn_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bookmarked_Learn_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bookmarked_Learn_Topics_Order_By>>;
  where?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersCoupons_Allowed_Users_Rule_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersCoupons_Allowed_Users_Rule_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowed_Users_Rule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersPackages_Payment_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersPackages_Payment_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Payment_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Payment_Transaction_Order_By>>;
  where?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersQuestion_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Question_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Reports_Order_By>>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersQuestion_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Reports_Order_By>>;
  where?: InputMaybe<Question_Reports_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersSpeed_TestsArgs = {
  distinct_on?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Tests_Order_By>>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersSpeed_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speed_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speed_Tests_Order_By>>;
  where?: InputMaybe<Speed_Tests_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUserActivitiesByUserIdArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUserActivitiesByUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUserAdditionalFieldsByUserIdArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Additional_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Additional_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUserAdditionalFieldsByUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Additional_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Additional_Fields_Order_By>>;
  where?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_LeaderboardsArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboards_Order_By>>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Leaderboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboards_Order_By>>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Learn_Category_ProgressesArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Category_Progress_Order_By>>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Learn_Category_Progresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Category_Progress_Order_By>>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Learn_Completed_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Completed_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Learn_Completed_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Completed_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Learn_Modules_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Modules_Summary_Order_By>>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Learn_Modules_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Modules_Summary_Order_By>>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Learn_Track_RecordsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Learn_Track_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Planned_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Planned_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Planned_Activities_Order_By>>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Pov_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Pov_Summaries_Order_By>>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Pov_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Pov_Summaries_Order_By>>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Quiz_Question_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Attempts_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Quiz_Question_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Attempts_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Quiz_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Quiz_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Quiz_Summaries_OldsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Quiz_Summaries_Olds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Section_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Section_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Speed_Tests_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Speed_Tests_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Tests_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Xp_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transactions_Order_By>>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUser_Xp_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transactions_Order_By>>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUserid_MappingsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Userid_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Userid_Mapping_Order_By>>;
  where?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
};


/** columns and relationships of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_UsersUserid_Mappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Userid_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Userid_Mapping_Order_By>>;
  where?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
};

/** aggregated selection of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Aggregate = {
  __typename?: 'supertokens_all_auth_recipe_users_aggregate';
  aggregate?: Maybe<Supertokens_All_Auth_Recipe_Users_Aggregate_Fields>;
  nodes: Array<Supertokens_All_Auth_Recipe_Users>;
};

export type Supertokens_All_Auth_Recipe_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_All_Auth_Recipe_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Aggregate_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_aggregate_fields';
  avg?: Maybe<Supertokens_All_Auth_Recipe_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_All_Auth_Recipe_Users_Max_Fields>;
  min?: Maybe<Supertokens_All_Auth_Recipe_Users_Min_Fields>;
  stddev?: Maybe<Supertokens_All_Auth_Recipe_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_All_Auth_Recipe_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_All_Auth_Recipe_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_All_Auth_Recipe_Users_Sum_Fields>;
  var_pop?: Maybe<Supertokens_All_Auth_Recipe_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_All_Auth_Recipe_Users_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_All_Auth_Recipe_Users_Variance_Fields>;
};


/** aggregate fields of "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Max_Order_By>;
  min?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_All_Auth_Recipe_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_All_Auth_Recipe_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_All_Auth_Recipe_Users_Avg_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_avg_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Avg_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.all_auth_recipe_users". All fields are combined with a logical 'AND'. */
export type Supertokens_All_Auth_Recipe_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
  bookmarked_learn_topics?: InputMaybe<Bookmarked_Learn_Topics_Bool_Exp>;
  bookmarked_learn_topics_aggregate?: InputMaybe<Bookmarked_Learn_Topics_Aggregate_Bool_Exp>;
  coupons_allowed_users_rule_users?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Bool_Exp>;
  coupons_allowed_users_rule_users_aggregate?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  emailpassword_user?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
  emailpassword_user_to_tenant?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_active?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
  packages_payment_transactions?: InputMaybe<Packages_Payment_Transaction_Bool_Exp>;
  packages_payment_transactions_aggregate?: InputMaybe<Packages_Payment_Transaction_Aggregate_Bool_Exp>;
  passwordless_user_to_tenant?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>;
  question_reports?: InputMaybe<Question_Reports_Bool_Exp>;
  question_reports_aggregate?: InputMaybe<Question_Reports_Aggregate_Bool_Exp>;
  recipe_id?: InputMaybe<String_Comparison_Exp>;
  roles?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
  speed_tests?: InputMaybe<Speed_Tests_Bool_Exp>;
  speed_tests_aggregate?: InputMaybe<Speed_Tests_Aggregate_Bool_Exp>;
  tenant?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  thirdparty_user_to_tenant?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>;
  time_joined?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userActivitiesByUserId?: InputMaybe<User_Activities_Bool_Exp>;
  userActivitiesByUserId_aggregate?: InputMaybe<User_Activities_Aggregate_Bool_Exp>;
  userAdditionalFieldsByUserId?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  userAdditionalFieldsByUserId_aggregate?: InputMaybe<Supertokens_User_Additional_Fields_Aggregate_Bool_Exp>;
  user_activities?: InputMaybe<User_Activity_Bool_Exp>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Bool_Exp>;
  user_additional_fields?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  user_leaderboards?: InputMaybe<User_Leaderboards_Bool_Exp>;
  user_leaderboards_aggregate?: InputMaybe<User_Leaderboards_Aggregate_Bool_Exp>;
  user_learn_category_progresses?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
  user_learn_category_progresses_aggregate?: InputMaybe<User_Learn_Category_Progress_Aggregate_Bool_Exp>;
  user_learn_completed_topics?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
  user_learn_completed_topics_aggregate?: InputMaybe<User_Learn_Completed_Topics_Aggregate_Bool_Exp>;
  user_learn_modules_summaries?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
  user_learn_modules_summaries_aggregate?: InputMaybe<User_Learn_Modules_Summary_Aggregate_Bool_Exp>;
  user_learn_track_records?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
  user_learn_track_records_aggregate?: InputMaybe<User_Learn_Track_Record_Aggregate_Bool_Exp>;
  user_planned_activities?: InputMaybe<User_Planned_Activities_Bool_Exp>;
  user_planned_activities_aggregate?: InputMaybe<User_Planned_Activities_Aggregate_Bool_Exp>;
  user_pov_summaries?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
  user_pov_summaries_aggregate?: InputMaybe<User_Pov_Summaries_Aggregate_Bool_Exp>;
  user_quiz_question_attempts?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
  user_quiz_question_attempts_aggregate?: InputMaybe<User_Quiz_Question_Attempts_Aggregate_Bool_Exp>;
  user_quiz_summaries?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  user_quiz_summaries_aggregate?: InputMaybe<User_Quiz_Summaries_Aggregate_Bool_Exp>;
  user_quiz_summaries_olds?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
  user_quiz_summaries_olds_aggregate?: InputMaybe<User_Quiz_Summaries_Old_Aggregate_Bool_Exp>;
  user_section_summaries?: InputMaybe<User_Section_Summaries_Bool_Exp>;
  user_section_summaries_aggregate?: InputMaybe<User_Section_Summaries_Aggregate_Bool_Exp>;
  user_speed_tests_summaries?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
  user_speed_tests_summaries_aggregate?: InputMaybe<User_Speed_Tests_Summaries_Aggregate_Bool_Exp>;
  user_xp_transactions?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  user_xp_transactions_aggregate?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp>;
  userid_mapping?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
  userid_mappings?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
  userid_mappings_aggregate?: InputMaybe<Supertokens_Userid_Mapping_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "supertokens.all_auth_recipe_users" */
export enum Supertokens_All_Auth_Recipe_Users_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id", "tenant_id" */
  AllAuthRecipeUsersPkey = 'all_auth_recipe_users_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AllAuthRecipeUsersUserIdKey = 'all_auth_recipe_users_user_id_key'
}

/** input type for incrementing numeric columns in table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Inc_Input = {
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Obj_Rel_Insert_Input>;
  bookmarked_learn_topics?: InputMaybe<Bookmarked_Learn_Topics_Arr_Rel_Insert_Input>;
  coupons_allowed_users_rule_users?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emailpassword_user?: InputMaybe<Supertokens_Emailpassword_Users_Obj_Rel_Insert_Input>;
  emailpassword_user_to_tenant?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_active?: InputMaybe<Supertokens_User_Last_Active_Obj_Rel_Insert_Input>;
  packages_payment_transactions?: InputMaybe<Packages_Payment_Transaction_Arr_Rel_Insert_Input>;
  passwordless_user_to_tenant?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Obj_Rel_Insert_Input>;
  question_reports?: InputMaybe<Question_Reports_Arr_Rel_Insert_Input>;
  recipe_id?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Supertokens_User_Roles_Obj_Rel_Insert_Input>;
  speed_tests?: InputMaybe<Speed_Tests_Arr_Rel_Insert_Input>;
  tenant?: InputMaybe<Supertokens_Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  thirdparty_user_to_tenant?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Obj_Rel_Insert_Input>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userActivitiesByUserId?: InputMaybe<User_Activities_Arr_Rel_Insert_Input>;
  userAdditionalFieldsByUserId?: InputMaybe<Supertokens_User_Additional_Fields_Arr_Rel_Insert_Input>;
  user_activities?: InputMaybe<User_Activity_Arr_Rel_Insert_Input>;
  user_additional_fields?: InputMaybe<Supertokens_User_Additional_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  user_leaderboards?: InputMaybe<User_Leaderboards_Arr_Rel_Insert_Input>;
  user_learn_category_progresses?: InputMaybe<User_Learn_Category_Progress_Arr_Rel_Insert_Input>;
  user_learn_completed_topics?: InputMaybe<User_Learn_Completed_Topics_Arr_Rel_Insert_Input>;
  user_learn_modules_summaries?: InputMaybe<User_Learn_Modules_Summary_Arr_Rel_Insert_Input>;
  user_learn_track_records?: InputMaybe<User_Learn_Track_Record_Arr_Rel_Insert_Input>;
  user_planned_activities?: InputMaybe<User_Planned_Activities_Arr_Rel_Insert_Input>;
  user_pov_summaries?: InputMaybe<User_Pov_Summaries_Arr_Rel_Insert_Input>;
  user_quiz_question_attempts?: InputMaybe<User_Quiz_Question_Attempts_Arr_Rel_Insert_Input>;
  user_quiz_summaries?: InputMaybe<User_Quiz_Summaries_Arr_Rel_Insert_Input>;
  user_quiz_summaries_olds?: InputMaybe<User_Quiz_Summaries_Old_Arr_Rel_Insert_Input>;
  user_section_summaries?: InputMaybe<User_Section_Summaries_Arr_Rel_Insert_Input>;
  user_speed_tests_summaries?: InputMaybe<User_Speed_Tests_Summaries_Arr_Rel_Insert_Input>;
  user_xp_transactions?: InputMaybe<User_Xp_Transactions_Arr_Rel_Insert_Input>;
  userid_mapping?: InputMaybe<Supertokens_Userid_Mapping_Obj_Rel_Insert_Input>;
  userid_mappings?: InputMaybe<Supertokens_Userid_Mapping_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Supertokens_All_Auth_Recipe_Users_Max_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  recipe_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipe_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  time_joined?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_All_Auth_Recipe_Users_Min_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  recipe_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipe_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  time_joined?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Mutation_Response = {
  __typename?: 'supertokens_all_auth_recipe_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_All_Auth_Recipe_Users>;
};

/** input type for inserting object relation for remote table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input = {
  data: Supertokens_All_Auth_Recipe_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_All_Auth_Recipe_Users_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_On_Conflict = {
  constraint: Supertokens_All_Auth_Recipe_Users_Constraint;
  update_columns?: Array<Supertokens_All_Auth_Recipe_Users_Update_Column>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.all_auth_recipe_users". */
export type Supertokens_All_Auth_Recipe_Users_Order_By = {
  app_id?: InputMaybe<Order_By>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Order_By>;
  bookmarked_learn_topics_aggregate?: InputMaybe<Bookmarked_Learn_Topics_Aggregate_Order_By>;
  coupons_allowed_users_rule_users_aggregate?: InputMaybe<Coupons_Allowed_Users_Rule_Users_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  emailpassword_user?: InputMaybe<Supertokens_Emailpassword_Users_Order_By>;
  emailpassword_user_to_tenant?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Order_By>;
  id?: InputMaybe<Order_By>;
  last_active?: InputMaybe<Supertokens_User_Last_Active_Order_By>;
  packages_payment_transactions_aggregate?: InputMaybe<Packages_Payment_Transaction_Aggregate_Order_By>;
  passwordless_user_to_tenant?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Order_By>;
  question_reports_aggregate?: InputMaybe<Question_Reports_Aggregate_Order_By>;
  recipe_id?: InputMaybe<Order_By>;
  roles?: InputMaybe<Supertokens_User_Roles_Order_By>;
  speed_tests_aggregate?: InputMaybe<Speed_Tests_Aggregate_Order_By>;
  tenant?: InputMaybe<Supertokens_Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  thirdparty_user_to_tenant?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Order_By>;
  time_joined?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userActivitiesByUserId_aggregate?: InputMaybe<User_Activities_Aggregate_Order_By>;
  userAdditionalFieldsByUserId_aggregate?: InputMaybe<Supertokens_User_Additional_Fields_Aggregate_Order_By>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Order_By>;
  user_additional_fields?: InputMaybe<Supertokens_User_Additional_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_leaderboards_aggregate?: InputMaybe<User_Leaderboards_Aggregate_Order_By>;
  user_learn_category_progresses_aggregate?: InputMaybe<User_Learn_Category_Progress_Aggregate_Order_By>;
  user_learn_completed_topics_aggregate?: InputMaybe<User_Learn_Completed_Topics_Aggregate_Order_By>;
  user_learn_modules_summaries_aggregate?: InputMaybe<User_Learn_Modules_Summary_Aggregate_Order_By>;
  user_learn_track_records_aggregate?: InputMaybe<User_Learn_Track_Record_Aggregate_Order_By>;
  user_planned_activities_aggregate?: InputMaybe<User_Planned_Activities_Aggregate_Order_By>;
  user_pov_summaries_aggregate?: InputMaybe<User_Pov_Summaries_Aggregate_Order_By>;
  user_quiz_question_attempts_aggregate?: InputMaybe<User_Quiz_Question_Attempts_Aggregate_Order_By>;
  user_quiz_summaries_aggregate?: InputMaybe<User_Quiz_Summaries_Aggregate_Order_By>;
  user_quiz_summaries_olds_aggregate?: InputMaybe<User_Quiz_Summaries_Old_Aggregate_Order_By>;
  user_section_summaries_aggregate?: InputMaybe<User_Section_Summaries_Aggregate_Order_By>;
  user_speed_tests_summaries_aggregate?: InputMaybe<User_Speed_Tests_Summaries_Aggregate_Order_By>;
  user_xp_transactions_aggregate?: InputMaybe<User_Xp_Transactions_Aggregate_Order_By>;
  userid_mapping?: InputMaybe<Supertokens_Userid_Mapping_Order_By>;
  userid_mappings_aggregate?: InputMaybe<Supertokens_Userid_Mapping_Aggregate_Order_By>;
};

/** primary key columns input for table: supertokens.all_auth_recipe_users */
export type Supertokens_All_Auth_Recipe_Users_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.all_auth_recipe_users" */
export enum Supertokens_All_Auth_Recipe_Users_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RecipeId = 'recipe_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  recipe_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_All_Auth_Recipe_Users_Stddev_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_stddev_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Stddev_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_All_Auth_Recipe_Users_Stddev_Pop_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_stddev_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Stddev_Pop_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_All_Auth_Recipe_Users_Stddev_Samp_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_stddev_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Stddev_Samp_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_All_Auth_Recipe_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_All_Auth_Recipe_Users_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  recipe_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_All_Auth_Recipe_Users_Sum_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_sum_fields';
  time_joined?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Sum_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.all_auth_recipe_users" */
export enum Supertokens_All_Auth_Recipe_Users_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RecipeId = 'recipe_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_All_Auth_Recipe_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_All_Auth_Recipe_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_All_Auth_Recipe_Users_Var_Pop_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_var_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Var_Pop_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_All_Auth_Recipe_Users_Var_Samp_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_var_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Var_Samp_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_All_Auth_Recipe_Users_Variance_Fields = {
  __typename?: 'supertokens_all_auth_recipe_users_variance_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.all_auth_recipe_users" */
export type Supertokens_All_Auth_Recipe_Users_Variance_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id = {
  __typename?: 'supertokens_app_id_to_user_id';
  /** An array relationship */
  all_auth_recipe_users: Array<Supertokens_All_Auth_Recipe_Users>;
  /** An aggregate relationship */
  all_auth_recipe_users_aggregate: Supertokens_All_Auth_Recipe_Users_Aggregate;
  /** An object relationship */
  app: Supertokens_Apps;
  app_id: Scalars['String']['output'];
  /** An object relationship */
  emailpassword_user?: Maybe<Supertokens_Emailpassword_Users>;
  /** An object relationship */
  passwordless_user?: Maybe<Supertokens_Passwordless_Users>;
  recipe_id: Scalars['String']['output'];
  /** An object relationship */
  thirdparty_user?: Maybe<Supertokens_Thirdparty_Users>;
  user_id: Scalars['bpchar']['output'];
  /** An object relationship */
  userid_mapping?: Maybe<Supertokens_Userid_Mapping>;
};


/** columns and relationships of "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_IdAll_Auth_Recipe_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Order_By>>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};


/** columns and relationships of "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_IdAll_Auth_Recipe_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Order_By>>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};

/** aggregated selection of "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Aggregate = {
  __typename?: 'supertokens_app_id_to_user_id_aggregate';
  aggregate?: Maybe<Supertokens_App_Id_To_User_Id_Aggregate_Fields>;
  nodes: Array<Supertokens_App_Id_To_User_Id>;
};

export type Supertokens_App_Id_To_User_Id_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_App_Id_To_User_Id_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_App_Id_To_User_Id_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Aggregate_Fields = {
  __typename?: 'supertokens_app_id_to_user_id_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_App_Id_To_User_Id_Max_Fields>;
  min?: Maybe<Supertokens_App_Id_To_User_Id_Min_Fields>;
};


/** aggregate fields of "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_App_Id_To_User_Id_Max_Order_By>;
  min?: InputMaybe<Supertokens_App_Id_To_User_Id_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_App_Id_To_User_Id_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_App_Id_To_User_Id_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supertokens.app_id_to_user_id". All fields are combined with a logical 'AND'. */
export type Supertokens_App_Id_To_User_Id_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Bool_Exp>>;
  all_auth_recipe_users?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  all_auth_recipe_users_aggregate?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Aggregate_Bool_Exp>;
  app?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  emailpassword_user?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
  passwordless_user?: InputMaybe<Supertokens_Passwordless_Users_Bool_Exp>;
  recipe_id?: InputMaybe<String_Comparison_Exp>;
  thirdparty_user?: InputMaybe<Supertokens_Thirdparty_Users_Bool_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
  userid_mapping?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
};

/** unique or primary key constraints on table "supertokens.app_id_to_user_id" */
export enum Supertokens_App_Id_To_User_Id_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id" */
  AppIdToUserIdPkey = 'app_id_to_user_id_pkey'
}

/** input type for inserting data into table "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Insert_Input = {
  all_auth_recipe_users?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Arr_Rel_Insert_Input>;
  app?: InputMaybe<Supertokens_Apps_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  emailpassword_user?: InputMaybe<Supertokens_Emailpassword_Users_Obj_Rel_Insert_Input>;
  passwordless_user?: InputMaybe<Supertokens_Passwordless_Users_Obj_Rel_Insert_Input>;
  recipe_id?: InputMaybe<Scalars['String']['input']>;
  thirdparty_user?: InputMaybe<Supertokens_Thirdparty_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
  userid_mapping?: InputMaybe<Supertokens_Userid_Mapping_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Supertokens_App_Id_To_User_Id_Max_Fields = {
  __typename?: 'supertokens_app_id_to_user_id_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  recipe_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  recipe_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_App_Id_To_User_Id_Min_Fields = {
  __typename?: 'supertokens_app_id_to_user_id_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  recipe_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  recipe_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Mutation_Response = {
  __typename?: 'supertokens_app_id_to_user_id_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_App_Id_To_User_Id>;
};

/** input type for inserting object relation for remote table "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Obj_Rel_Insert_Input = {
  data: Supertokens_App_Id_To_User_Id_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_App_Id_To_User_Id_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_On_Conflict = {
  constraint: Supertokens_App_Id_To_User_Id_Constraint;
  update_columns?: Array<Supertokens_App_Id_To_User_Id_Update_Column>;
  where?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.app_id_to_user_id". */
export type Supertokens_App_Id_To_User_Id_Order_By = {
  all_auth_recipe_users_aggregate?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Aggregate_Order_By>;
  app?: InputMaybe<Supertokens_Apps_Order_By>;
  app_id?: InputMaybe<Order_By>;
  emailpassword_user?: InputMaybe<Supertokens_Emailpassword_Users_Order_By>;
  passwordless_user?: InputMaybe<Supertokens_Passwordless_Users_Order_By>;
  recipe_id?: InputMaybe<Order_By>;
  thirdparty_user?: InputMaybe<Supertokens_Thirdparty_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  userid_mapping?: InputMaybe<Supertokens_Userid_Mapping_Order_By>;
};

/** primary key columns input for table: supertokens.app_id_to_user_id */
export type Supertokens_App_Id_To_User_Id_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.app_id_to_user_id" */
export enum Supertokens_App_Id_To_User_Id_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  RecipeId = 'recipe_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  recipe_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "supertokens_app_id_to_user_id" */
export type Supertokens_App_Id_To_User_Id_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_App_Id_To_User_Id_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_App_Id_To_User_Id_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  recipe_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "supertokens.app_id_to_user_id" */
export enum Supertokens_App_Id_To_User_Id_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  RecipeId = 'recipe_id',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_App_Id_To_User_Id_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_App_Id_To_User_Id_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_App_Id_To_User_Id_Bool_Exp;
};

/** columns and relationships of "supertokens.apps" */
export type Supertokens_Apps = {
  __typename?: 'supertokens_apps';
  app_id: Scalars['String']['output'];
  /** An array relationship */
  app_id_to_user_ids: Array<Supertokens_App_Id_To_User_Id>;
  /** An aggregate relationship */
  app_id_to_user_ids_aggregate: Supertokens_App_Id_To_User_Id_Aggregate;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  dashboard_users: Array<Supertokens_Dashboard_Users>;
  /** An aggregate relationship */
  dashboard_users_aggregate: Supertokens_Dashboard_Users_Aggregate;
  /** An array relationship */
  emailverification_verified_emails: Array<Supertokens_Emailverification_Verified_Emails>;
  /** An aggregate relationship */
  emailverification_verified_emails_aggregate: Supertokens_Emailverification_Verified_Emails_Aggregate;
  /** An array relationship */
  jwt_signing_keys: Array<Supertokens_Jwt_Signing_Keys>;
  /** An aggregate relationship */
  jwt_signing_keys_aggregate: Supertokens_Jwt_Signing_Keys_Aggregate;
  /** An array relationship */
  roles: Array<Supertokens_Roles>;
  /** An aggregate relationship */
  roles_aggregate: Supertokens_Roles_Aggregate;
  /** An array relationship */
  session_access_token_signing_keys: Array<Supertokens_Session_Access_Token_Signing_Keys>;
  /** An aggregate relationship */
  session_access_token_signing_keys_aggregate: Supertokens_Session_Access_Token_Signing_Keys_Aggregate;
  /** An array relationship */
  tenants: Array<Supertokens_Tenants>;
  /** An aggregate relationship */
  tenants_aggregate: Supertokens_Tenants_Aggregate;
  /** An array relationship */
  user_last_actives: Array<Supertokens_User_Last_Active>;
  /** An aggregate relationship */
  user_last_actives_aggregate: Supertokens_User_Last_Active_Aggregate;
  /** An array relationship */
  user_metadata: Array<Supertokens_User_Metadata>;
  /** An aggregate relationship */
  user_metadata_aggregate: Supertokens_User_Metadata_Aggregate;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsApp_Id_To_User_IdsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Order_By>>;
  where?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsApp_Id_To_User_Ids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_App_Id_To_User_Id_Order_By>>;
  where?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsDashboard_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsDashboard_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_Users_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsEmailverification_Verified_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsEmailverification_Verified_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsJwt_Signing_KeysArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsJwt_Signing_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsRolesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_Roles_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_Roles_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsSession_Access_Token_Signing_KeysArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsSession_Access_Token_Signing_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsTenantsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenants_Order_By>>;
  where?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsTenants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenants_Order_By>>;
  where?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsUser_Last_ActivesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Last_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Last_Active_Order_By>>;
  where?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsUser_Last_Actives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Last_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Last_Active_Order_By>>;
  where?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsUser_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Metadata_Order_By>>;
  where?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
};


/** columns and relationships of "supertokens.apps" */
export type Supertokens_AppsUser_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Metadata_Order_By>>;
  where?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
};

/** aggregated selection of "supertokens.apps" */
export type Supertokens_Apps_Aggregate = {
  __typename?: 'supertokens_apps_aggregate';
  aggregate?: Maybe<Supertokens_Apps_Aggregate_Fields>;
  nodes: Array<Supertokens_Apps>;
};

/** aggregate fields of "supertokens.apps" */
export type Supertokens_Apps_Aggregate_Fields = {
  __typename?: 'supertokens_apps_aggregate_fields';
  avg?: Maybe<Supertokens_Apps_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Apps_Max_Fields>;
  min?: Maybe<Supertokens_Apps_Min_Fields>;
  stddev?: Maybe<Supertokens_Apps_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Apps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Apps_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Apps_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Apps_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Apps_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Apps_Variance_Fields>;
};


/** aggregate fields of "supertokens.apps" */
export type Supertokens_Apps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Apps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Supertokens_Apps_Avg_Fields = {
  __typename?: 'supertokens_apps_avg_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "supertokens.apps". All fields are combined with a logical 'AND'. */
export type Supertokens_Apps_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Apps_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Apps_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  app_id_to_user_ids?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
  app_id_to_user_ids_aggregate?: InputMaybe<Supertokens_App_Id_To_User_Id_Aggregate_Bool_Exp>;
  created_at_time?: InputMaybe<Bigint_Comparison_Exp>;
  dashboard_users?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
  dashboard_users_aggregate?: InputMaybe<Supertokens_Dashboard_Users_Aggregate_Bool_Exp>;
  emailverification_verified_emails?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
  emailverification_verified_emails_aggregate?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Aggregate_Bool_Exp>;
  jwt_signing_keys?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
  jwt_signing_keys_aggregate?: InputMaybe<Supertokens_Jwt_Signing_Keys_Aggregate_Bool_Exp>;
  roles?: InputMaybe<Supertokens_Roles_Bool_Exp>;
  roles_aggregate?: InputMaybe<Supertokens_Roles_Aggregate_Bool_Exp>;
  session_access_token_signing_keys?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
  session_access_token_signing_keys_aggregate?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Aggregate_Bool_Exp>;
  tenants?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
  tenants_aggregate?: InputMaybe<Supertokens_Tenants_Aggregate_Bool_Exp>;
  user_last_actives?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
  user_last_actives_aggregate?: InputMaybe<Supertokens_User_Last_Active_Aggregate_Bool_Exp>;
  user_metadata?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
  user_metadata_aggregate?: InputMaybe<Supertokens_User_Metadata_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "supertokens.apps" */
export enum Supertokens_Apps_Constraint {
  /** unique or primary key constraint on columns "app_id" */
  AppsPkey = 'apps_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.apps" */
export type Supertokens_Apps_Inc_Input = {
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.apps" */
export type Supertokens_Apps_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  app_id_to_user_ids?: InputMaybe<Supertokens_App_Id_To_User_Id_Arr_Rel_Insert_Input>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  dashboard_users?: InputMaybe<Supertokens_Dashboard_Users_Arr_Rel_Insert_Input>;
  emailverification_verified_emails?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Arr_Rel_Insert_Input>;
  jwt_signing_keys?: InputMaybe<Supertokens_Jwt_Signing_Keys_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<Supertokens_Roles_Arr_Rel_Insert_Input>;
  session_access_token_signing_keys?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Arr_Rel_Insert_Input>;
  tenants?: InputMaybe<Supertokens_Tenants_Arr_Rel_Insert_Input>;
  user_last_actives?: InputMaybe<Supertokens_User_Last_Active_Arr_Rel_Insert_Input>;
  user_metadata?: InputMaybe<Supertokens_User_Metadata_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Supertokens_Apps_Max_Fields = {
  __typename?: 'supertokens_apps_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Supertokens_Apps_Min_Fields = {
  __typename?: 'supertokens_apps_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "supertokens.apps" */
export type Supertokens_Apps_Mutation_Response = {
  __typename?: 'supertokens_apps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Apps>;
};

/** input type for inserting object relation for remote table "supertokens.apps" */
export type Supertokens_Apps_Obj_Rel_Insert_Input = {
  data: Supertokens_Apps_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Apps_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.apps" */
export type Supertokens_Apps_On_Conflict = {
  constraint: Supertokens_Apps_Constraint;
  update_columns?: Array<Supertokens_Apps_Update_Column>;
  where?: InputMaybe<Supertokens_Apps_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.apps". */
export type Supertokens_Apps_Order_By = {
  app_id?: InputMaybe<Order_By>;
  app_id_to_user_ids_aggregate?: InputMaybe<Supertokens_App_Id_To_User_Id_Aggregate_Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  dashboard_users_aggregate?: InputMaybe<Supertokens_Dashboard_Users_Aggregate_Order_By>;
  emailverification_verified_emails_aggregate?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Aggregate_Order_By>;
  jwt_signing_keys_aggregate?: InputMaybe<Supertokens_Jwt_Signing_Keys_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<Supertokens_Roles_Aggregate_Order_By>;
  session_access_token_signing_keys_aggregate?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Aggregate_Order_By>;
  tenants_aggregate?: InputMaybe<Supertokens_Tenants_Aggregate_Order_By>;
  user_last_actives_aggregate?: InputMaybe<Supertokens_User_Last_Active_Aggregate_Order_By>;
  user_metadata_aggregate?: InputMaybe<Supertokens_User_Metadata_Aggregate_Order_By>;
};

/** primary key columns input for table: supertokens.apps */
export type Supertokens_Apps_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.apps" */
export enum Supertokens_Apps_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time'
}

/** input type for updating data in table "supertokens.apps" */
export type Supertokens_Apps_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Apps_Stddev_Fields = {
  __typename?: 'supertokens_apps_stddev_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Apps_Stddev_Pop_Fields = {
  __typename?: 'supertokens_apps_stddev_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Apps_Stddev_Samp_Fields = {
  __typename?: 'supertokens_apps_stddev_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "supertokens_apps" */
export type Supertokens_Apps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Apps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Apps_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Apps_Sum_Fields = {
  __typename?: 'supertokens_apps_sum_fields';
  created_at_time?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "supertokens.apps" */
export enum Supertokens_Apps_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time'
}

export type Supertokens_Apps_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Apps_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Apps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Apps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Apps_Var_Pop_Fields = {
  __typename?: 'supertokens_apps_var_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Supertokens_Apps_Var_Samp_Fields = {
  __typename?: 'supertokens_apps_var_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Supertokens_Apps_Variance_Fields = {
  __typename?: 'supertokens_apps_variance_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions = {
  __typename?: 'supertokens_dashboard_user_sessions';
  app_id: Scalars['String']['output'];
  /** An object relationship */
  dashboard_user?: Maybe<Supertokens_Dashboard_Users>;
  expiry: Scalars['bigint']['output'];
  session_id: Scalars['bpchar']['output'];
  time_created: Scalars['bigint']['output'];
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Aggregate = {
  __typename?: 'supertokens_dashboard_user_sessions_aggregate';
  aggregate?: Maybe<Supertokens_Dashboard_User_Sessions_Aggregate_Fields>;
  nodes: Array<Supertokens_Dashboard_User_Sessions>;
};

export type Supertokens_Dashboard_User_Sessions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Dashboard_User_Sessions_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Dashboard_User_Sessions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Aggregate_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_aggregate_fields';
  avg?: Maybe<Supertokens_Dashboard_User_Sessions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Dashboard_User_Sessions_Max_Fields>;
  min?: Maybe<Supertokens_Dashboard_User_Sessions_Min_Fields>;
  stddev?: Maybe<Supertokens_Dashboard_User_Sessions_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Dashboard_User_Sessions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Dashboard_User_Sessions_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Dashboard_User_Sessions_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Dashboard_User_Sessions_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Dashboard_User_Sessions_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Dashboard_User_Sessions_Variance_Fields>;
};


/** aggregate fields of "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Dashboard_User_Sessions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Dashboard_User_Sessions_Max_Order_By>;
  min?: InputMaybe<Supertokens_Dashboard_User_Sessions_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Dashboard_User_Sessions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Dashboard_User_Sessions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Dashboard_User_Sessions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Dashboard_User_Sessions_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Dashboard_User_Sessions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Dashboard_User_Sessions_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Dashboard_User_Sessions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Dashboard_User_Sessions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Dashboard_User_Sessions_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Dashboard_User_Sessions_Avg_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_avg_fields';
  expiry?: Maybe<Scalars['Float']['output']>;
  time_created?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Avg_Order_By = {
  expiry?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.dashboard_user_sessions". All fields are combined with a logical 'AND'. */
export type Supertokens_Dashboard_User_Sessions_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  dashboard_user?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
  expiry?: InputMaybe<Bigint_Comparison_Exp>;
  session_id?: InputMaybe<Bpchar_Comparison_Exp>;
  time_created?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.dashboard_user_sessions" */
export enum Supertokens_Dashboard_User_Sessions_Constraint {
  /** unique or primary key constraint on columns "session_id", "app_id" */
  DashboardUserSessionsPkey = 'dashboard_user_sessions_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Inc_Input = {
  expiry?: InputMaybe<Scalars['bigint']['input']>;
  time_created?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  dashboard_user?: InputMaybe<Supertokens_Dashboard_Users_Obj_Rel_Insert_Input>;
  expiry?: InputMaybe<Scalars['bigint']['input']>;
  session_id?: InputMaybe<Scalars['bpchar']['input']>;
  time_created?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Dashboard_User_Sessions_Max_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  expiry?: Maybe<Scalars['bigint']['output']>;
  session_id?: Maybe<Scalars['bpchar']['output']>;
  time_created?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  expiry?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Dashboard_User_Sessions_Min_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  expiry?: Maybe<Scalars['bigint']['output']>;
  session_id?: Maybe<Scalars['bpchar']['output']>;
  time_created?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  expiry?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Mutation_Response = {
  __typename?: 'supertokens_dashboard_user_sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Dashboard_User_Sessions>;
};

/** on_conflict condition type for table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_On_Conflict = {
  constraint: Supertokens_Dashboard_User_Sessions_Constraint;
  update_columns?: Array<Supertokens_Dashboard_User_Sessions_Update_Column>;
  where?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.dashboard_user_sessions". */
export type Supertokens_Dashboard_User_Sessions_Order_By = {
  app_id?: InputMaybe<Order_By>;
  dashboard_user?: InputMaybe<Supertokens_Dashboard_Users_Order_By>;
  expiry?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.dashboard_user_sessions */
export type Supertokens_Dashboard_User_Sessions_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  session_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.dashboard_user_sessions" */
export enum Supertokens_Dashboard_User_Sessions_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TimeCreated = 'time_created',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  expiry?: InputMaybe<Scalars['bigint']['input']>;
  session_id?: InputMaybe<Scalars['bpchar']['input']>;
  time_created?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Dashboard_User_Sessions_Stddev_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_stddev_fields';
  expiry?: Maybe<Scalars['Float']['output']>;
  time_created?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Stddev_Order_By = {
  expiry?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Dashboard_User_Sessions_Stddev_Pop_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_stddev_pop_fields';
  expiry?: Maybe<Scalars['Float']['output']>;
  time_created?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Stddev_Pop_Order_By = {
  expiry?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Dashboard_User_Sessions_Stddev_Samp_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_stddev_samp_fields';
  expiry?: Maybe<Scalars['Float']['output']>;
  time_created?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Stddev_Samp_Order_By = {
  expiry?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Dashboard_User_Sessions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Dashboard_User_Sessions_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  expiry?: InputMaybe<Scalars['bigint']['input']>;
  session_id?: InputMaybe<Scalars['bpchar']['input']>;
  time_created?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Dashboard_User_Sessions_Sum_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_sum_fields';
  expiry?: Maybe<Scalars['bigint']['output']>;
  time_created?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Sum_Order_By = {
  expiry?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.dashboard_user_sessions" */
export enum Supertokens_Dashboard_User_Sessions_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TimeCreated = 'time_created',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Dashboard_User_Sessions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Dashboard_User_Sessions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Dashboard_User_Sessions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Dashboard_User_Sessions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Dashboard_User_Sessions_Var_Pop_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_var_pop_fields';
  expiry?: Maybe<Scalars['Float']['output']>;
  time_created?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Var_Pop_Order_By = {
  expiry?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Dashboard_User_Sessions_Var_Samp_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_var_samp_fields';
  expiry?: Maybe<Scalars['Float']['output']>;
  time_created?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Var_Samp_Order_By = {
  expiry?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Dashboard_User_Sessions_Variance_Fields = {
  __typename?: 'supertokens_dashboard_user_sessions_variance_fields';
  expiry?: Maybe<Scalars['Float']['output']>;
  time_created?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.dashboard_user_sessions" */
export type Supertokens_Dashboard_User_Sessions_Variance_Order_By = {
  expiry?: InputMaybe<Order_By>;
  time_created?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users = {
  __typename?: 'supertokens_dashboard_users';
  /** An object relationship */
  app: Supertokens_Apps;
  app_id: Scalars['String']['output'];
  /** An array relationship */
  dashboard_user_sessions: Array<Supertokens_Dashboard_User_Sessions>;
  /** An aggregate relationship */
  dashboard_user_sessions_aggregate: Supertokens_Dashboard_User_Sessions_Aggregate;
  email: Scalars['String']['output'];
  password_hash: Scalars['String']['output'];
  time_joined: Scalars['bigint']['output'];
  user_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "supertokens.dashboard_users" */
export type Supertokens_Dashboard_UsersDashboard_User_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
};


/** columns and relationships of "supertokens.dashboard_users" */
export type Supertokens_Dashboard_UsersDashboard_User_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Dashboard_User_Sessions_Order_By>>;
  where?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
};

/** aggregated selection of "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Aggregate = {
  __typename?: 'supertokens_dashboard_users_aggregate';
  aggregate?: Maybe<Supertokens_Dashboard_Users_Aggregate_Fields>;
  nodes: Array<Supertokens_Dashboard_Users>;
};

export type Supertokens_Dashboard_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Dashboard_Users_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Dashboard_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Dashboard_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Aggregate_Fields = {
  __typename?: 'supertokens_dashboard_users_aggregate_fields';
  avg?: Maybe<Supertokens_Dashboard_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Dashboard_Users_Max_Fields>;
  min?: Maybe<Supertokens_Dashboard_Users_Min_Fields>;
  stddev?: Maybe<Supertokens_Dashboard_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Dashboard_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Dashboard_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Dashboard_Users_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Dashboard_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Dashboard_Users_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Dashboard_Users_Variance_Fields>;
};


/** aggregate fields of "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Dashboard_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Dashboard_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Dashboard_Users_Max_Order_By>;
  min?: InputMaybe<Supertokens_Dashboard_Users_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Dashboard_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Dashboard_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Dashboard_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Dashboard_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Dashboard_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Dashboard_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Dashboard_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Dashboard_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Dashboard_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Dashboard_Users_Avg_Fields = {
  __typename?: 'supertokens_dashboard_users_avg_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Avg_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.dashboard_users". All fields are combined with a logical 'AND'. */
export type Supertokens_Dashboard_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Dashboard_Users_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Dashboard_Users_Bool_Exp>>;
  app?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  dashboard_user_sessions?: InputMaybe<Supertokens_Dashboard_User_Sessions_Bool_Exp>;
  dashboard_user_sessions_aggregate?: InputMaybe<Supertokens_Dashboard_User_Sessions_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  password_hash?: InputMaybe<String_Comparison_Exp>;
  time_joined?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.dashboard_users" */
export enum Supertokens_Dashboard_Users_Constraint {
  /** unique or primary key constraint on columns "app_id", "email" */
  DashboardUsersEmailKey = 'dashboard_users_email_key',
  /** unique or primary key constraint on columns "app_id", "user_id" */
  DashboardUsersPkey = 'dashboard_users_pkey',
  /** unique or primary key constraint on columns "user_id" */
  DashboardUsersUserIdKey = 'dashboard_users_user_id_key'
}

/** input type for incrementing numeric columns in table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Inc_Input = {
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Insert_Input = {
  app?: InputMaybe<Supertokens_Apps_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  dashboard_user_sessions?: InputMaybe<Supertokens_Dashboard_User_Sessions_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Dashboard_Users_Max_Fields = {
  __typename?: 'supertokens_dashboard_users_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  password_hash?: InputMaybe<Order_By>;
  time_joined?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Dashboard_Users_Min_Fields = {
  __typename?: 'supertokens_dashboard_users_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  password_hash?: InputMaybe<Order_By>;
  time_joined?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Mutation_Response = {
  __typename?: 'supertokens_dashboard_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Dashboard_Users>;
};

/** input type for inserting object relation for remote table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Obj_Rel_Insert_Input = {
  data: Supertokens_Dashboard_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Dashboard_Users_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_On_Conflict = {
  constraint: Supertokens_Dashboard_Users_Constraint;
  update_columns?: Array<Supertokens_Dashboard_Users_Update_Column>;
  where?: InputMaybe<Supertokens_Dashboard_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.dashboard_users". */
export type Supertokens_Dashboard_Users_Order_By = {
  app?: InputMaybe<Supertokens_Apps_Order_By>;
  app_id?: InputMaybe<Order_By>;
  dashboard_user_sessions_aggregate?: InputMaybe<Supertokens_Dashboard_User_Sessions_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  password_hash?: InputMaybe<Order_By>;
  time_joined?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.dashboard_users */
export type Supertokens_Dashboard_Users_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.dashboard_users" */
export enum Supertokens_Dashboard_Users_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Dashboard_Users_Stddev_Fields = {
  __typename?: 'supertokens_dashboard_users_stddev_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Stddev_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Dashboard_Users_Stddev_Pop_Fields = {
  __typename?: 'supertokens_dashboard_users_stddev_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Stddev_Pop_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Dashboard_Users_Stddev_Samp_Fields = {
  __typename?: 'supertokens_dashboard_users_stddev_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Stddev_Samp_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_dashboard_users" */
export type Supertokens_Dashboard_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Dashboard_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Dashboard_Users_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Dashboard_Users_Sum_Fields = {
  __typename?: 'supertokens_dashboard_users_sum_fields';
  time_joined?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Sum_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.dashboard_users" */
export enum Supertokens_Dashboard_Users_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Dashboard_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Dashboard_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Dashboard_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Dashboard_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Dashboard_Users_Var_Pop_Fields = {
  __typename?: 'supertokens_dashboard_users_var_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Var_Pop_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Dashboard_Users_Var_Samp_Fields = {
  __typename?: 'supertokens_dashboard_users_var_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Var_Samp_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Dashboard_Users_Variance_Fields = {
  __typename?: 'supertokens_dashboard_users_variance_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.dashboard_users" */
export type Supertokens_Dashboard_Users_Variance_Order_By = {
  time_joined?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens';
  app_id: Scalars['String']['output'];
  /** An object relationship */
  emailpassword_user?: Maybe<Supertokens_Emailpassword_Users>;
  token: Scalars['String']['output'];
  token_expiry: Scalars['bigint']['output'];
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_aggregate';
  aggregate?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate_Fields>;
  nodes: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
};

export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_aggregate_fields';
  avg?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Max_Fields>;
  min?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Min_Fields>;
  stddev?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Variance_Fields>;
};


/** aggregate fields of "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Max_Order_By>;
  min?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Avg_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_avg_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Avg_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.emailpassword_pswd_reset_tokens". All fields are combined with a logical 'AND'. */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  emailpassword_user?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  token_expiry?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.emailpassword_pswd_reset_tokens" */
export enum Supertokens_Emailpassword_Pswd_Reset_Tokens_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id", "token" */
  EmailpasswordPswdResetTokensPkey = 'emailpassword_pswd_reset_tokens_pkey',
  /** unique or primary key constraint on columns "token" */
  EmailpasswordPswdResetTokensTokenKey = 'emailpassword_pswd_reset_tokens_token_key'
}

/** input type for incrementing numeric columns in table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Inc_Input = {
  token_expiry?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  emailpassword_user?: InputMaybe<Supertokens_Emailpassword_Users_Obj_Rel_Insert_Input>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_expiry?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Max_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_expiry?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_expiry?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Min_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_expiry?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_expiry?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Mutation_Response = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
};

/** on_conflict condition type for table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_On_Conflict = {
  constraint: Supertokens_Emailpassword_Pswd_Reset_Tokens_Constraint;
  update_columns?: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Update_Column>;
  where?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.emailpassword_pswd_reset_tokens". */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Order_By = {
  app_id?: InputMaybe<Order_By>;
  emailpassword_user?: InputMaybe<Supertokens_Emailpassword_Users_Order_By>;
  token?: InputMaybe<Order_By>;
  token_expiry?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.emailpassword_pswd_reset_tokens */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export enum Supertokens_Emailpassword_Pswd_Reset_Tokens_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Token = 'token',
  /** column name */
  TokenExpiry = 'token_expiry',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_expiry?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_stddev_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Pop_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_stddev_pop_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Pop_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Samp_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_stddev_samp_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Stddev_Samp_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Emailpassword_Pswd_Reset_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_expiry?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Sum_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_sum_fields';
  token_expiry?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Sum_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export enum Supertokens_Emailpassword_Pswd_Reset_Tokens_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Token = 'token',
  /** column name */
  TokenExpiry = 'token_expiry',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Var_Pop_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_var_pop_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Var_Pop_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Var_Samp_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_var_samp_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Var_Samp_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Variance_Fields = {
  __typename?: 'supertokens_emailpassword_pswd_reset_tokens_variance_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.emailpassword_pswd_reset_tokens" */
export type Supertokens_Emailpassword_Pswd_Reset_Tokens_Variance_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant = {
  __typename?: 'supertokens_emailpassword_user_to_tenant';
  /** An object relationship */
  all_auth_recipe_user?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  app_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  tenant_id: Scalars['String']['output'];
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "supertokens.emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant_Aggregate = {
  __typename?: 'supertokens_emailpassword_user_to_tenant_aggregate';
  aggregate?: Maybe<Supertokens_Emailpassword_User_To_Tenant_Aggregate_Fields>;
  nodes: Array<Supertokens_Emailpassword_User_To_Tenant>;
};

/** aggregate fields of "supertokens.emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant_Aggregate_Fields = {
  __typename?: 'supertokens_emailpassword_user_to_tenant_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Emailpassword_User_To_Tenant_Max_Fields>;
  min?: Maybe<Supertokens_Emailpassword_User_To_Tenant_Min_Fields>;
};


/** aggregate fields of "supertokens.emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "supertokens.emailpassword_user_to_tenant". All fields are combined with a logical 'AND'. */
export type Supertokens_Emailpassword_User_To_Tenant_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.emailpassword_user_to_tenant" */
export enum Supertokens_Emailpassword_User_To_Tenant_Constraint {
  /** unique or primary key constraint on columns "app_id", "tenant_id", "email" */
  EmailpasswordUserToTenantEmailKey = 'emailpassword_user_to_tenant_email_key',
  /** unique or primary key constraint on columns "app_id", "user_id", "tenant_id" */
  EmailpasswordUserToTenantPkey = 'emailpassword_user_to_tenant_pkey'
}

/** input type for inserting data into table "supertokens.emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Emailpassword_User_To_Tenant_Max_Fields = {
  __typename?: 'supertokens_emailpassword_user_to_tenant_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Supertokens_Emailpassword_User_To_Tenant_Min_Fields = {
  __typename?: 'supertokens_emailpassword_user_to_tenant_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "supertokens.emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant_Mutation_Response = {
  __typename?: 'supertokens_emailpassword_user_to_tenant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Emailpassword_User_To_Tenant>;
};

/** input type for inserting object relation for remote table "supertokens.emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant_Obj_Rel_Insert_Input = {
  data: Supertokens_Emailpassword_User_To_Tenant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant_On_Conflict = {
  constraint: Supertokens_Emailpassword_User_To_Tenant_Constraint;
  update_columns?: Array<Supertokens_Emailpassword_User_To_Tenant_Update_Column>;
  where?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.emailpassword_user_to_tenant". */
export type Supertokens_Emailpassword_User_To_Tenant_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.emailpassword_user_to_tenant */
export type Supertokens_Emailpassword_User_To_Tenant_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.emailpassword_user_to_tenant" */
export enum Supertokens_Emailpassword_User_To_Tenant_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "supertokens_emailpassword_user_to_tenant" */
export type Supertokens_Emailpassword_User_To_Tenant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Emailpassword_User_To_Tenant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Emailpassword_User_To_Tenant_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "supertokens.emailpassword_user_to_tenant" */
export enum Supertokens_Emailpassword_User_To_Tenant_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Emailpassword_User_To_Tenant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Emailpassword_User_To_Tenant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Emailpassword_User_To_Tenant_Bool_Exp;
};

/** columns and relationships of "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users = {
  __typename?: 'supertokens_emailpassword_users';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  app_id: Scalars['String']['output'];
  /** An object relationship */
  app_id_to_user_id?: Maybe<Supertokens_App_Id_To_User_Id>;
  email: Scalars['String']['output'];
  /** An array relationship */
  emailpassword_pswd_reset_tokens: Array<Supertokens_Emailpassword_Pswd_Reset_Tokens>;
  /** An aggregate relationship */
  emailpassword_pswd_reset_tokens_aggregate: Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate;
  password_hash: Scalars['String']['output'];
  time_joined: Scalars['bigint']['output'];
  user_id: Scalars['bpchar']['output'];
};


/** columns and relationships of "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_UsersEmailpassword_Pswd_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
};


/** columns and relationships of "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_UsersEmailpassword_Pswd_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailpassword_Pswd_Reset_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
};

/** aggregated selection of "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users_Aggregate = {
  __typename?: 'supertokens_emailpassword_users_aggregate';
  aggregate?: Maybe<Supertokens_Emailpassword_Users_Aggregate_Fields>;
  nodes: Array<Supertokens_Emailpassword_Users>;
};

/** aggregate fields of "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users_Aggregate_Fields = {
  __typename?: 'supertokens_emailpassword_users_aggregate_fields';
  avg?: Maybe<Supertokens_Emailpassword_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Emailpassword_Users_Max_Fields>;
  min?: Maybe<Supertokens_Emailpassword_Users_Min_Fields>;
  stddev?: Maybe<Supertokens_Emailpassword_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Emailpassword_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Emailpassword_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Emailpassword_Users_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Emailpassword_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Emailpassword_Users_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Emailpassword_Users_Variance_Fields>;
};


/** aggregate fields of "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Emailpassword_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Supertokens_Emailpassword_Users_Avg_Fields = {
  __typename?: 'supertokens_emailpassword_users_avg_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "supertokens.emailpassword_users". All fields are combined with a logical 'AND'. */
export type Supertokens_Emailpassword_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Emailpassword_Users_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Emailpassword_Users_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  emailpassword_pswd_reset_tokens?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Bool_Exp>;
  emailpassword_pswd_reset_tokens_aggregate?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate_Bool_Exp>;
  password_hash?: InputMaybe<String_Comparison_Exp>;
  time_joined?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.emailpassword_users" */
export enum Supertokens_Emailpassword_Users_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id" */
  EmailpasswordUsersPkey = 'emailpassword_users_pkey',
  /** unique or primary key constraint on columns "user_id" */
  EmailpasswordUsersUserIdKey = 'emailpassword_users_user_id_key'
}

/** input type for incrementing numeric columns in table "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users_Inc_Input = {
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Obj_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailpassword_pswd_reset_tokens?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Arr_Rel_Insert_Input>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Emailpassword_Users_Max_Fields = {
  __typename?: 'supertokens_emailpassword_users_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Supertokens_Emailpassword_Users_Min_Fields = {
  __typename?: 'supertokens_emailpassword_users_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users_Mutation_Response = {
  __typename?: 'supertokens_emailpassword_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Emailpassword_Users>;
};

/** input type for inserting object relation for remote table "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users_Obj_Rel_Insert_Input = {
  data: Supertokens_Emailpassword_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Emailpassword_Users_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users_On_Conflict = {
  constraint: Supertokens_Emailpassword_Users_Constraint;
  update_columns?: Array<Supertokens_Emailpassword_Users_Update_Column>;
  where?: InputMaybe<Supertokens_Emailpassword_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.emailpassword_users". */
export type Supertokens_Emailpassword_Users_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  app_id?: InputMaybe<Order_By>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Order_By>;
  email?: InputMaybe<Order_By>;
  emailpassword_pswd_reset_tokens_aggregate?: InputMaybe<Supertokens_Emailpassword_Pswd_Reset_Tokens_Aggregate_Order_By>;
  password_hash?: InputMaybe<Order_By>;
  time_joined?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.emailpassword_users */
export type Supertokens_Emailpassword_Users_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.emailpassword_users" */
export enum Supertokens_Emailpassword_Users_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.emailpassword_users" */
export type Supertokens_Emailpassword_Users_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Emailpassword_Users_Stddev_Fields = {
  __typename?: 'supertokens_emailpassword_users_stddev_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Emailpassword_Users_Stddev_Pop_Fields = {
  __typename?: 'supertokens_emailpassword_users_stddev_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Emailpassword_Users_Stddev_Samp_Fields = {
  __typename?: 'supertokens_emailpassword_users_stddev_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "supertokens_emailpassword_users" */
export type Supertokens_Emailpassword_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Emailpassword_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Emailpassword_Users_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Emailpassword_Users_Sum_Fields = {
  __typename?: 'supertokens_emailpassword_users_sum_fields';
  time_joined?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "supertokens.emailpassword_users" */
export enum Supertokens_Emailpassword_Users_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Emailpassword_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Emailpassword_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Emailpassword_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Emailpassword_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Emailpassword_Users_Var_Pop_Fields = {
  __typename?: 'supertokens_emailpassword_users_var_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Supertokens_Emailpassword_Users_Var_Samp_Fields = {
  __typename?: 'supertokens_emailpassword_users_var_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Supertokens_Emailpassword_Users_Variance_Fields = {
  __typename?: 'supertokens_emailpassword_users_variance_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens = {
  __typename?: 'supertokens_emailverification_tokens';
  app_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  /** An object relationship */
  tenant?: Maybe<Supertokens_Tenants>;
  tenant_id: Scalars['String']['output'];
  token: Scalars['String']['output'];
  token_expiry: Scalars['bigint']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Aggregate = {
  __typename?: 'supertokens_emailverification_tokens_aggregate';
  aggregate?: Maybe<Supertokens_Emailverification_Tokens_Aggregate_Fields>;
  nodes: Array<Supertokens_Emailverification_Tokens>;
};

export type Supertokens_Emailverification_Tokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Emailverification_Tokens_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Emailverification_Tokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Aggregate_Fields = {
  __typename?: 'supertokens_emailverification_tokens_aggregate_fields';
  avg?: Maybe<Supertokens_Emailverification_Tokens_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Emailverification_Tokens_Max_Fields>;
  min?: Maybe<Supertokens_Emailverification_Tokens_Min_Fields>;
  stddev?: Maybe<Supertokens_Emailverification_Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Emailverification_Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Emailverification_Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Emailverification_Tokens_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Emailverification_Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Emailverification_Tokens_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Emailverification_Tokens_Variance_Fields>;
};


/** aggregate fields of "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Emailverification_Tokens_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Emailverification_Tokens_Max_Order_By>;
  min?: InputMaybe<Supertokens_Emailverification_Tokens_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Emailverification_Tokens_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Emailverification_Tokens_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Emailverification_Tokens_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Emailverification_Tokens_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Emailverification_Tokens_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Emailverification_Tokens_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Emailverification_Tokens_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Emailverification_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Emailverification_Tokens_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Emailverification_Tokens_Avg_Fields = {
  __typename?: 'supertokens_emailverification_tokens_avg_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Avg_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.emailverification_tokens". All fields are combined with a logical 'AND'. */
export type Supertokens_Emailverification_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  token_expiry?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.emailverification_tokens" */
export enum Supertokens_Emailverification_Tokens_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id", "tenant_id", "token", "email" */
  EmailverificationTokensPkey = 'emailverification_tokens_pkey',
  /** unique or primary key constraint on columns "token" */
  EmailverificationTokensTokenKey = 'emailverification_tokens_token_key'
}

/** input type for incrementing numeric columns in table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Inc_Input = {
  token_expiry?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Supertokens_Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_expiry?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Emailverification_Tokens_Max_Fields = {
  __typename?: 'supertokens_emailverification_tokens_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_expiry?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_expiry?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Emailverification_Tokens_Min_Fields = {
  __typename?: 'supertokens_emailverification_tokens_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_expiry?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_expiry?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Mutation_Response = {
  __typename?: 'supertokens_emailverification_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Emailverification_Tokens>;
};

/** on_conflict condition type for table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_On_Conflict = {
  constraint: Supertokens_Emailverification_Tokens_Constraint;
  update_columns?: Array<Supertokens_Emailverification_Tokens_Update_Column>;
  where?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.emailverification_tokens". */
export type Supertokens_Emailverification_Tokens_Order_By = {
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Supertokens_Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_expiry?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.emailverification_tokens */
export type Supertokens_Emailverification_Tokens_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.emailverification_tokens" */
export enum Supertokens_Emailverification_Tokens_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Token = 'token',
  /** column name */
  TokenExpiry = 'token_expiry',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_expiry?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Emailverification_Tokens_Stddev_Fields = {
  __typename?: 'supertokens_emailverification_tokens_stddev_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Stddev_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Emailverification_Tokens_Stddev_Pop_Fields = {
  __typename?: 'supertokens_emailverification_tokens_stddev_pop_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Stddev_Pop_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Emailverification_Tokens_Stddev_Samp_Fields = {
  __typename?: 'supertokens_emailverification_tokens_stddev_samp_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Stddev_Samp_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Emailverification_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Emailverification_Tokens_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_expiry?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Emailverification_Tokens_Sum_Fields = {
  __typename?: 'supertokens_emailverification_tokens_sum_fields';
  token_expiry?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Sum_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.emailverification_tokens" */
export enum Supertokens_Emailverification_Tokens_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Token = 'token',
  /** column name */
  TokenExpiry = 'token_expiry',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Emailverification_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Emailverification_Tokens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Emailverification_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Emailverification_Tokens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Emailverification_Tokens_Var_Pop_Fields = {
  __typename?: 'supertokens_emailverification_tokens_var_pop_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Var_Pop_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Emailverification_Tokens_Var_Samp_Fields = {
  __typename?: 'supertokens_emailverification_tokens_var_samp_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Var_Samp_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Emailverification_Tokens_Variance_Fields = {
  __typename?: 'supertokens_emailverification_tokens_variance_fields';
  token_expiry?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.emailverification_tokens" */
export type Supertokens_Emailverification_Tokens_Variance_Order_By = {
  token_expiry?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails = {
  __typename?: 'supertokens_emailverification_verified_emails';
  /** An object relationship */
  app: Supertokens_Apps;
  app_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Aggregate = {
  __typename?: 'supertokens_emailverification_verified_emails_aggregate';
  aggregate?: Maybe<Supertokens_Emailverification_Verified_Emails_Aggregate_Fields>;
  nodes: Array<Supertokens_Emailverification_Verified_Emails>;
};

export type Supertokens_Emailverification_Verified_Emails_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Emailverification_Verified_Emails_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Aggregate_Fields = {
  __typename?: 'supertokens_emailverification_verified_emails_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Emailverification_Verified_Emails_Max_Fields>;
  min?: Maybe<Supertokens_Emailverification_Verified_Emails_Min_Fields>;
};


/** aggregate fields of "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Max_Order_By>;
  min?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Emailverification_Verified_Emails_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Emailverification_Verified_Emails_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supertokens.emailverification_verified_emails". All fields are combined with a logical 'AND'. */
export type Supertokens_Emailverification_Verified_Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Emailverification_Verified_Emails_Bool_Exp>>;
  app?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.emailverification_verified_emails" */
export enum Supertokens_Emailverification_Verified_Emails_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id", "email" */
  EmailverificationVerifiedEmailsPkey = 'emailverification_verified_emails_pkey'
}

/** input type for inserting data into table "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Insert_Input = {
  app?: InputMaybe<Supertokens_Apps_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Emailverification_Verified_Emails_Max_Fields = {
  __typename?: 'supertokens_emailverification_verified_emails_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Emailverification_Verified_Emails_Min_Fields = {
  __typename?: 'supertokens_emailverification_verified_emails_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Mutation_Response = {
  __typename?: 'supertokens_emailverification_verified_emails_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Emailverification_Verified_Emails>;
};

/** input type for inserting object relation for remote table "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Obj_Rel_Insert_Input = {
  data: Supertokens_Emailverification_Verified_Emails_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Emailverification_Verified_Emails_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_On_Conflict = {
  constraint: Supertokens_Emailverification_Verified_Emails_Constraint;
  update_columns?: Array<Supertokens_Emailverification_Verified_Emails_Update_Column>;
  where?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.emailverification_verified_emails". */
export type Supertokens_Emailverification_Verified_Emails_Order_By = {
  app?: InputMaybe<Supertokens_Apps_Order_By>;
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.emailverification_verified_emails */
export type Supertokens_Emailverification_Verified_Emails_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.emailverification_verified_emails" */
export enum Supertokens_Emailverification_Verified_Emails_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "supertokens_emailverification_verified_emails" */
export type Supertokens_Emailverification_Verified_Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Emailverification_Verified_Emails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Emailverification_Verified_Emails_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "supertokens.emailverification_verified_emails" */
export enum Supertokens_Emailverification_Verified_Emails_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Emailverification_Verified_Emails_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Emailverification_Verified_Emails_Bool_Exp;
};

/** columns and relationships of "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys = {
  __typename?: 'supertokens_jwt_signing_keys';
  algorithm: Scalars['String']['output'];
  /** An object relationship */
  app: Supertokens_Apps;
  app_id: Scalars['String']['output'];
  created_at?: Maybe<Scalars['bigint']['output']>;
  key_id: Scalars['String']['output'];
  key_string: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Aggregate = {
  __typename?: 'supertokens_jwt_signing_keys_aggregate';
  aggregate?: Maybe<Supertokens_Jwt_Signing_Keys_Aggregate_Fields>;
  nodes: Array<Supertokens_Jwt_Signing_Keys>;
};

export type Supertokens_Jwt_Signing_Keys_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Jwt_Signing_Keys_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Jwt_Signing_Keys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Aggregate_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_aggregate_fields';
  avg?: Maybe<Supertokens_Jwt_Signing_Keys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Jwt_Signing_Keys_Max_Fields>;
  min?: Maybe<Supertokens_Jwt_Signing_Keys_Min_Fields>;
  stddev?: Maybe<Supertokens_Jwt_Signing_Keys_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Jwt_Signing_Keys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Jwt_Signing_Keys_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Jwt_Signing_Keys_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Jwt_Signing_Keys_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Jwt_Signing_Keys_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Jwt_Signing_Keys_Variance_Fields>;
};


/** aggregate fields of "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Jwt_Signing_Keys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Jwt_Signing_Keys_Max_Order_By>;
  min?: InputMaybe<Supertokens_Jwt_Signing_Keys_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Jwt_Signing_Keys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Jwt_Signing_Keys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Jwt_Signing_Keys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Jwt_Signing_Keys_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Jwt_Signing_Keys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Jwt_Signing_Keys_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Jwt_Signing_Keys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Jwt_Signing_Keys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Jwt_Signing_Keys_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Jwt_Signing_Keys_Avg_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_avg_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Avg_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.jwt_signing_keys". All fields are combined with a logical 'AND'. */
export type Supertokens_Jwt_Signing_Keys_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Jwt_Signing_Keys_Bool_Exp>>;
  algorithm?: InputMaybe<String_Comparison_Exp>;
  app?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Bigint_Comparison_Exp>;
  key_id?: InputMaybe<String_Comparison_Exp>;
  key_string?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.jwt_signing_keys" */
export enum Supertokens_Jwt_Signing_Keys_Constraint {
  /** unique or primary key constraint on columns "app_id", "key_id" */
  JwtSigningKeysPkey = 'jwt_signing_keys_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Inc_Input = {
  created_at?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Insert_Input = {
  algorithm?: InputMaybe<Scalars['String']['input']>;
  app?: InputMaybe<Supertokens_Apps_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['bigint']['input']>;
  key_id?: InputMaybe<Scalars['String']['input']>;
  key_string?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Jwt_Signing_Keys_Max_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_max_fields';
  algorithm?: Maybe<Scalars['String']['output']>;
  app_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['bigint']['output']>;
  key_id?: Maybe<Scalars['String']['output']>;
  key_string?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Max_Order_By = {
  algorithm?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  key_id?: InputMaybe<Order_By>;
  key_string?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Jwt_Signing_Keys_Min_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_min_fields';
  algorithm?: Maybe<Scalars['String']['output']>;
  app_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['bigint']['output']>;
  key_id?: Maybe<Scalars['String']['output']>;
  key_string?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Min_Order_By = {
  algorithm?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  key_id?: InputMaybe<Order_By>;
  key_string?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Mutation_Response = {
  __typename?: 'supertokens_jwt_signing_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Jwt_Signing_Keys>;
};

/** on_conflict condition type for table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_On_Conflict = {
  constraint: Supertokens_Jwt_Signing_Keys_Constraint;
  update_columns?: Array<Supertokens_Jwt_Signing_Keys_Update_Column>;
  where?: InputMaybe<Supertokens_Jwt_Signing_Keys_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.jwt_signing_keys". */
export type Supertokens_Jwt_Signing_Keys_Order_By = {
  algorithm?: InputMaybe<Order_By>;
  app?: InputMaybe<Supertokens_Apps_Order_By>;
  app_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  key_id?: InputMaybe<Order_By>;
  key_string?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.jwt_signing_keys */
export type Supertokens_Jwt_Signing_Keys_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  key_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.jwt_signing_keys" */
export enum Supertokens_Jwt_Signing_Keys_Select_Column {
  /** column name */
  Algorithm = 'algorithm',
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  KeyId = 'key_id',
  /** column name */
  KeyString = 'key_string'
}

/** input type for updating data in table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Set_Input = {
  algorithm?: InputMaybe<Scalars['String']['input']>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['bigint']['input']>;
  key_id?: InputMaybe<Scalars['String']['input']>;
  key_string?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Jwt_Signing_Keys_Stddev_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_stddev_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Stddev_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Jwt_Signing_Keys_Stddev_Pop_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_stddev_pop_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Stddev_Pop_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Jwt_Signing_Keys_Stddev_Samp_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_stddev_samp_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Stddev_Samp_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Jwt_Signing_Keys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Jwt_Signing_Keys_Stream_Cursor_Value_Input = {
  algorithm?: InputMaybe<Scalars['String']['input']>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['bigint']['input']>;
  key_id?: InputMaybe<Scalars['String']['input']>;
  key_string?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Jwt_Signing_Keys_Sum_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_sum_fields';
  created_at?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Sum_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.jwt_signing_keys" */
export enum Supertokens_Jwt_Signing_Keys_Update_Column {
  /** column name */
  Algorithm = 'algorithm',
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  KeyId = 'key_id',
  /** column name */
  KeyString = 'key_string'
}

export type Supertokens_Jwt_Signing_Keys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Jwt_Signing_Keys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Jwt_Signing_Keys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Jwt_Signing_Keys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Jwt_Signing_Keys_Var_Pop_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_var_pop_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Var_Pop_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Jwt_Signing_Keys_Var_Samp_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_var_samp_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Var_Samp_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Jwt_Signing_Keys_Variance_Fields = {
  __typename?: 'supertokens_jwt_signing_keys_variance_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.jwt_signing_keys" */
export type Supertokens_Jwt_Signing_Keys_Variance_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.key_value" */
export type Supertokens_Key_Value = {
  __typename?: 'supertokens_key_value';
  app_id: Scalars['String']['output'];
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  tenant?: Maybe<Supertokens_Tenants>;
  tenant_id: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "supertokens.key_value" */
export type Supertokens_Key_Value_Aggregate = {
  __typename?: 'supertokens_key_value_aggregate';
  aggregate?: Maybe<Supertokens_Key_Value_Aggregate_Fields>;
  nodes: Array<Supertokens_Key_Value>;
};

export type Supertokens_Key_Value_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Key_Value_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Key_Value_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Key_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.key_value" */
export type Supertokens_Key_Value_Aggregate_Fields = {
  __typename?: 'supertokens_key_value_aggregate_fields';
  avg?: Maybe<Supertokens_Key_Value_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Key_Value_Max_Fields>;
  min?: Maybe<Supertokens_Key_Value_Min_Fields>;
  stddev?: Maybe<Supertokens_Key_Value_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Key_Value_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Key_Value_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Key_Value_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Key_Value_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Key_Value_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Key_Value_Variance_Fields>;
};


/** aggregate fields of "supertokens.key_value" */
export type Supertokens_Key_Value_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Key_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.key_value" */
export type Supertokens_Key_Value_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Key_Value_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Key_Value_Max_Order_By>;
  min?: InputMaybe<Supertokens_Key_Value_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Key_Value_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Key_Value_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Key_Value_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Key_Value_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Key_Value_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Key_Value_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Key_Value_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.key_value" */
export type Supertokens_Key_Value_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Key_Value_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Key_Value_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Key_Value_Avg_Fields = {
  __typename?: 'supertokens_key_value_avg_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Avg_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.key_value". All fields are combined with a logical 'AND'. */
export type Supertokens_Key_Value_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Key_Value_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Key_Value_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  created_at_time?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.key_value" */
export enum Supertokens_Key_Value_Constraint {
  /** unique or primary key constraint on columns "app_id", "tenant_id", "name" */
  KeyValuePkey = 'key_value_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.key_value" */
export type Supertokens_Key_Value_Inc_Input = {
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.key_value" */
export type Supertokens_Key_Value_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Supertokens_Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Key_Value_Max_Fields = {
  __typename?: 'supertokens_key_value_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Key_Value_Min_Fields = {
  __typename?: 'supertokens_key_value_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.key_value" */
export type Supertokens_Key_Value_Mutation_Response = {
  __typename?: 'supertokens_key_value_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Key_Value>;
};

/** on_conflict condition type for table "supertokens.key_value" */
export type Supertokens_Key_Value_On_Conflict = {
  constraint: Supertokens_Key_Value_Constraint;
  update_columns?: Array<Supertokens_Key_Value_Update_Column>;
  where?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.key_value". */
export type Supertokens_Key_Value_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Supertokens_Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.key_value */
export type Supertokens_Key_Value_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.key_value" */
export enum Supertokens_Key_Value_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "supertokens.key_value" */
export type Supertokens_Key_Value_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Key_Value_Stddev_Fields = {
  __typename?: 'supertokens_key_value_stddev_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Stddev_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Key_Value_Stddev_Pop_Fields = {
  __typename?: 'supertokens_key_value_stddev_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Stddev_Pop_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Key_Value_Stddev_Samp_Fields = {
  __typename?: 'supertokens_key_value_stddev_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Stddev_Samp_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_key_value" */
export type Supertokens_Key_Value_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Key_Value_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Key_Value_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Key_Value_Sum_Fields = {
  __typename?: 'supertokens_key_value_sum_fields';
  created_at_time?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Sum_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.key_value" */
export enum Supertokens_Key_Value_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Value = 'value'
}

export type Supertokens_Key_Value_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Key_Value_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Key_Value_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Key_Value_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Key_Value_Var_Pop_Fields = {
  __typename?: 'supertokens_key_value_var_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Var_Pop_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Key_Value_Var_Samp_Fields = {
  __typename?: 'supertokens_key_value_var_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Var_Samp_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Key_Value_Variance_Fields = {
  __typename?: 'supertokens_key_value_variance_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.key_value" */
export type Supertokens_Key_Value_Variance_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes = {
  __typename?: 'supertokens_passwordless_codes';
  app_id: Scalars['String']['output'];
  code_id: Scalars['bpchar']['output'];
  created_at: Scalars['bigint']['output'];
  device_id_hash: Scalars['bpchar']['output'];
  link_code_hash: Scalars['bpchar']['output'];
  /** An object relationship */
  passwordless_device?: Maybe<Supertokens_Passwordless_Devices>;
  tenant_id: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Aggregate = {
  __typename?: 'supertokens_passwordless_codes_aggregate';
  aggregate?: Maybe<Supertokens_Passwordless_Codes_Aggregate_Fields>;
  nodes: Array<Supertokens_Passwordless_Codes>;
};

export type Supertokens_Passwordless_Codes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Passwordless_Codes_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Passwordless_Codes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Passwordless_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Aggregate_Fields = {
  __typename?: 'supertokens_passwordless_codes_aggregate_fields';
  avg?: Maybe<Supertokens_Passwordless_Codes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Passwordless_Codes_Max_Fields>;
  min?: Maybe<Supertokens_Passwordless_Codes_Min_Fields>;
  stddev?: Maybe<Supertokens_Passwordless_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Passwordless_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Passwordless_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Passwordless_Codes_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Passwordless_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Passwordless_Codes_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Passwordless_Codes_Variance_Fields>;
};


/** aggregate fields of "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Passwordless_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Passwordless_Codes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Passwordless_Codes_Max_Order_By>;
  min?: InputMaybe<Supertokens_Passwordless_Codes_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Passwordless_Codes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Passwordless_Codes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Passwordless_Codes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Passwordless_Codes_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Passwordless_Codes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Passwordless_Codes_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Passwordless_Codes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Passwordless_Codes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Passwordless_Codes_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Passwordless_Codes_Avg_Fields = {
  __typename?: 'supertokens_passwordless_codes_avg_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Avg_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.passwordless_codes". All fields are combined with a logical 'AND'. */
export type Supertokens_Passwordless_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Passwordless_Codes_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Passwordless_Codes_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  code_id?: InputMaybe<Bpchar_Comparison_Exp>;
  created_at?: InputMaybe<Bigint_Comparison_Exp>;
  device_id_hash?: InputMaybe<Bpchar_Comparison_Exp>;
  link_code_hash?: InputMaybe<Bpchar_Comparison_Exp>;
  passwordless_device?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.passwordless_codes" */
export enum Supertokens_Passwordless_Codes_Constraint {
  /** unique or primary key constraint on columns "app_id", "tenant_id", "link_code_hash" */
  PasswordlessCodesLinkCodeHashKey = 'passwordless_codes_link_code_hash_key',
  /** unique or primary key constraint on columns "code_id", "app_id", "tenant_id" */
  PasswordlessCodesPkey = 'passwordless_codes_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Inc_Input = {
  created_at?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  code_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['bigint']['input']>;
  device_id_hash?: InputMaybe<Scalars['bpchar']['input']>;
  link_code_hash?: InputMaybe<Scalars['bpchar']['input']>;
  passwordless_device?: InputMaybe<Supertokens_Passwordless_Devices_Obj_Rel_Insert_Input>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Passwordless_Codes_Max_Fields = {
  __typename?: 'supertokens_passwordless_codes_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  code_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['bigint']['output']>;
  device_id_hash?: Maybe<Scalars['bpchar']['output']>;
  link_code_hash?: Maybe<Scalars['bpchar']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  code_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id_hash?: InputMaybe<Order_By>;
  link_code_hash?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Passwordless_Codes_Min_Fields = {
  __typename?: 'supertokens_passwordless_codes_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  code_id?: Maybe<Scalars['bpchar']['output']>;
  created_at?: Maybe<Scalars['bigint']['output']>;
  device_id_hash?: Maybe<Scalars['bpchar']['output']>;
  link_code_hash?: Maybe<Scalars['bpchar']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  code_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id_hash?: InputMaybe<Order_By>;
  link_code_hash?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Mutation_Response = {
  __typename?: 'supertokens_passwordless_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Passwordless_Codes>;
};

/** on_conflict condition type for table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_On_Conflict = {
  constraint: Supertokens_Passwordless_Codes_Constraint;
  update_columns?: Array<Supertokens_Passwordless_Codes_Update_Column>;
  where?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.passwordless_codes". */
export type Supertokens_Passwordless_Codes_Order_By = {
  app_id?: InputMaybe<Order_By>;
  code_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id_hash?: InputMaybe<Order_By>;
  link_code_hash?: InputMaybe<Order_By>;
  passwordless_device?: InputMaybe<Supertokens_Passwordless_Devices_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.passwordless_codes */
export type Supertokens_Passwordless_Codes_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  code_id: Scalars['bpchar']['input'];
  tenant_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.passwordless_codes" */
export enum Supertokens_Passwordless_Codes_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CodeId = 'code_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceIdHash = 'device_id_hash',
  /** column name */
  LinkCodeHash = 'link_code_hash',
  /** column name */
  TenantId = 'tenant_id'
}

/** input type for updating data in table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  code_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['bigint']['input']>;
  device_id_hash?: InputMaybe<Scalars['bpchar']['input']>;
  link_code_hash?: InputMaybe<Scalars['bpchar']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Passwordless_Codes_Stddev_Fields = {
  __typename?: 'supertokens_passwordless_codes_stddev_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Stddev_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Passwordless_Codes_Stddev_Pop_Fields = {
  __typename?: 'supertokens_passwordless_codes_stddev_pop_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Stddev_Pop_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Passwordless_Codes_Stddev_Samp_Fields = {
  __typename?: 'supertokens_passwordless_codes_stddev_samp_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Stddev_Samp_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_passwordless_codes" */
export type Supertokens_Passwordless_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Passwordless_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Passwordless_Codes_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  code_id?: InputMaybe<Scalars['bpchar']['input']>;
  created_at?: InputMaybe<Scalars['bigint']['input']>;
  device_id_hash?: InputMaybe<Scalars['bpchar']['input']>;
  link_code_hash?: InputMaybe<Scalars['bpchar']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Passwordless_Codes_Sum_Fields = {
  __typename?: 'supertokens_passwordless_codes_sum_fields';
  created_at?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Sum_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.passwordless_codes" */
export enum Supertokens_Passwordless_Codes_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CodeId = 'code_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceIdHash = 'device_id_hash',
  /** column name */
  LinkCodeHash = 'link_code_hash',
  /** column name */
  TenantId = 'tenant_id'
}

export type Supertokens_Passwordless_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Passwordless_Codes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Passwordless_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Passwordless_Codes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Passwordless_Codes_Var_Pop_Fields = {
  __typename?: 'supertokens_passwordless_codes_var_pop_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Var_Pop_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Passwordless_Codes_Var_Samp_Fields = {
  __typename?: 'supertokens_passwordless_codes_var_samp_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Var_Samp_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Passwordless_Codes_Variance_Fields = {
  __typename?: 'supertokens_passwordless_codes_variance_fields';
  created_at?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.passwordless_codes" */
export type Supertokens_Passwordless_Codes_Variance_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices = {
  __typename?: 'supertokens_passwordless_devices';
  app_id: Scalars['String']['output'];
  device_id_hash: Scalars['bpchar']['output'];
  email?: Maybe<Scalars['String']['output']>;
  failed_attempts: Scalars['Int']['output'];
  link_code_salt: Scalars['bpchar']['output'];
  /** An array relationship */
  passwordless_codes: Array<Supertokens_Passwordless_Codes>;
  /** An aggregate relationship */
  passwordless_codes_aggregate: Supertokens_Passwordless_Codes_Aggregate;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tenant?: Maybe<Supertokens_Tenants>;
  tenant_id: Scalars['String']['output'];
};


/** columns and relationships of "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_DevicesPasswordless_CodesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Codes_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
};


/** columns and relationships of "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_DevicesPasswordless_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Codes_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
};

/** aggregated selection of "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Aggregate = {
  __typename?: 'supertokens_passwordless_devices_aggregate';
  aggregate?: Maybe<Supertokens_Passwordless_Devices_Aggregate_Fields>;
  nodes: Array<Supertokens_Passwordless_Devices>;
};

export type Supertokens_Passwordless_Devices_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Passwordless_Devices_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Passwordless_Devices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Passwordless_Devices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Aggregate_Fields = {
  __typename?: 'supertokens_passwordless_devices_aggregate_fields';
  avg?: Maybe<Supertokens_Passwordless_Devices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Passwordless_Devices_Max_Fields>;
  min?: Maybe<Supertokens_Passwordless_Devices_Min_Fields>;
  stddev?: Maybe<Supertokens_Passwordless_Devices_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Passwordless_Devices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Passwordless_Devices_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Passwordless_Devices_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Passwordless_Devices_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Passwordless_Devices_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Passwordless_Devices_Variance_Fields>;
};


/** aggregate fields of "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Passwordless_Devices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Passwordless_Devices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Passwordless_Devices_Max_Order_By>;
  min?: InputMaybe<Supertokens_Passwordless_Devices_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Passwordless_Devices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Passwordless_Devices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Passwordless_Devices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Passwordless_Devices_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Passwordless_Devices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Passwordless_Devices_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Passwordless_Devices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Passwordless_Devices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Passwordless_Devices_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Passwordless_Devices_Avg_Fields = {
  __typename?: 'supertokens_passwordless_devices_avg_fields';
  failed_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Avg_Order_By = {
  failed_attempts?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.passwordless_devices". All fields are combined with a logical 'AND'. */
export type Supertokens_Passwordless_Devices_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Passwordless_Devices_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Passwordless_Devices_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  device_id_hash?: InputMaybe<Bpchar_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  failed_attempts?: InputMaybe<Int_Comparison_Exp>;
  link_code_salt?: InputMaybe<Bpchar_Comparison_Exp>;
  passwordless_codes?: InputMaybe<Supertokens_Passwordless_Codes_Bool_Exp>;
  passwordless_codes_aggregate?: InputMaybe<Supertokens_Passwordless_Codes_Aggregate_Bool_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.passwordless_devices" */
export enum Supertokens_Passwordless_Devices_Constraint {
  /** unique or primary key constraint on columns "device_id_hash" */
  PasswordlessDevicesDeviceIdHashKey = 'passwordless_devices_device_id_hash_key',
  /** unique or primary key constraint on columns "device_id_hash", "app_id", "tenant_id" */
  PasswordlessDevicesPkey = 'passwordless_devices_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Inc_Input = {
  failed_attempts?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  device_id_hash?: InputMaybe<Scalars['bpchar']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  failed_attempts?: InputMaybe<Scalars['Int']['input']>;
  link_code_salt?: InputMaybe<Scalars['bpchar']['input']>;
  passwordless_codes?: InputMaybe<Supertokens_Passwordless_Codes_Arr_Rel_Insert_Input>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Supertokens_Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Passwordless_Devices_Max_Fields = {
  __typename?: 'supertokens_passwordless_devices_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  device_id_hash?: Maybe<Scalars['bpchar']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  failed_attempts?: Maybe<Scalars['Int']['output']>;
  link_code_salt?: Maybe<Scalars['bpchar']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  device_id_hash?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  failed_attempts?: InputMaybe<Order_By>;
  link_code_salt?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Passwordless_Devices_Min_Fields = {
  __typename?: 'supertokens_passwordless_devices_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  device_id_hash?: Maybe<Scalars['bpchar']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  failed_attempts?: Maybe<Scalars['Int']['output']>;
  link_code_salt?: Maybe<Scalars['bpchar']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  device_id_hash?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  failed_attempts?: InputMaybe<Order_By>;
  link_code_salt?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Mutation_Response = {
  __typename?: 'supertokens_passwordless_devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Passwordless_Devices>;
};

/** input type for inserting object relation for remote table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Obj_Rel_Insert_Input = {
  data: Supertokens_Passwordless_Devices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Passwordless_Devices_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_On_Conflict = {
  constraint: Supertokens_Passwordless_Devices_Constraint;
  update_columns?: Array<Supertokens_Passwordless_Devices_Update_Column>;
  where?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.passwordless_devices". */
export type Supertokens_Passwordless_Devices_Order_By = {
  app_id?: InputMaybe<Order_By>;
  device_id_hash?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  failed_attempts?: InputMaybe<Order_By>;
  link_code_salt?: InputMaybe<Order_By>;
  passwordless_codes_aggregate?: InputMaybe<Supertokens_Passwordless_Codes_Aggregate_Order_By>;
  phone_number?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Supertokens_Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.passwordless_devices */
export type Supertokens_Passwordless_Devices_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  device_id_hash: Scalars['bpchar']['input'];
  tenant_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.passwordless_devices" */
export enum Supertokens_Passwordless_Devices_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  DeviceIdHash = 'device_id_hash',
  /** column name */
  Email = 'email',
  /** column name */
  FailedAttempts = 'failed_attempts',
  /** column name */
  LinkCodeSalt = 'link_code_salt',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TenantId = 'tenant_id'
}

/** input type for updating data in table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  device_id_hash?: InputMaybe<Scalars['bpchar']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  failed_attempts?: InputMaybe<Scalars['Int']['input']>;
  link_code_salt?: InputMaybe<Scalars['bpchar']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Passwordless_Devices_Stddev_Fields = {
  __typename?: 'supertokens_passwordless_devices_stddev_fields';
  failed_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Stddev_Order_By = {
  failed_attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Passwordless_Devices_Stddev_Pop_Fields = {
  __typename?: 'supertokens_passwordless_devices_stddev_pop_fields';
  failed_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Stddev_Pop_Order_By = {
  failed_attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Passwordless_Devices_Stddev_Samp_Fields = {
  __typename?: 'supertokens_passwordless_devices_stddev_samp_fields';
  failed_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Stddev_Samp_Order_By = {
  failed_attempts?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_passwordless_devices" */
export type Supertokens_Passwordless_Devices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Passwordless_Devices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Passwordless_Devices_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  device_id_hash?: InputMaybe<Scalars['bpchar']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  failed_attempts?: InputMaybe<Scalars['Int']['input']>;
  link_code_salt?: InputMaybe<Scalars['bpchar']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Passwordless_Devices_Sum_Fields = {
  __typename?: 'supertokens_passwordless_devices_sum_fields';
  failed_attempts?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Sum_Order_By = {
  failed_attempts?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.passwordless_devices" */
export enum Supertokens_Passwordless_Devices_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  DeviceIdHash = 'device_id_hash',
  /** column name */
  Email = 'email',
  /** column name */
  FailedAttempts = 'failed_attempts',
  /** column name */
  LinkCodeSalt = 'link_code_salt',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TenantId = 'tenant_id'
}

export type Supertokens_Passwordless_Devices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Passwordless_Devices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Passwordless_Devices_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Passwordless_Devices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Passwordless_Devices_Var_Pop_Fields = {
  __typename?: 'supertokens_passwordless_devices_var_pop_fields';
  failed_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Var_Pop_Order_By = {
  failed_attempts?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Passwordless_Devices_Var_Samp_Fields = {
  __typename?: 'supertokens_passwordless_devices_var_samp_fields';
  failed_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Var_Samp_Order_By = {
  failed_attempts?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Passwordless_Devices_Variance_Fields = {
  __typename?: 'supertokens_passwordless_devices_variance_fields';
  failed_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.passwordless_devices" */
export type Supertokens_Passwordless_Devices_Variance_Order_By = {
  failed_attempts?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant = {
  __typename?: 'supertokens_passwordless_user_to_tenant';
  /** An object relationship */
  all_auth_recipe_user?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  app_id: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  tenant_id: Scalars['String']['output'];
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "supertokens.passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant_Aggregate = {
  __typename?: 'supertokens_passwordless_user_to_tenant_aggregate';
  aggregate?: Maybe<Supertokens_Passwordless_User_To_Tenant_Aggregate_Fields>;
  nodes: Array<Supertokens_Passwordless_User_To_Tenant>;
};

/** aggregate fields of "supertokens.passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant_Aggregate_Fields = {
  __typename?: 'supertokens_passwordless_user_to_tenant_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Passwordless_User_To_Tenant_Max_Fields>;
  min?: Maybe<Supertokens_Passwordless_User_To_Tenant_Min_Fields>;
};


/** aggregate fields of "supertokens.passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "supertokens.passwordless_user_to_tenant". All fields are combined with a logical 'AND'. */
export type Supertokens_Passwordless_User_To_Tenant_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.passwordless_user_to_tenant" */
export enum Supertokens_Passwordless_User_To_Tenant_Constraint {
  /** unique or primary key constraint on columns "app_id", "tenant_id", "email" */
  PasswordlessUserToTenantEmailKey = 'passwordless_user_to_tenant_email_key',
  /** unique or primary key constraint on columns "phone_number", "app_id", "tenant_id" */
  PasswordlessUserToTenantPhoneNumberKey = 'passwordless_user_to_tenant_phone_number_key',
  /** unique or primary key constraint on columns "app_id", "user_id", "tenant_id" */
  PasswordlessUserToTenantPkey = 'passwordless_user_to_tenant_pkey'
}

/** input type for inserting data into table "supertokens.passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Passwordless_User_To_Tenant_Max_Fields = {
  __typename?: 'supertokens_passwordless_user_to_tenant_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Supertokens_Passwordless_User_To_Tenant_Min_Fields = {
  __typename?: 'supertokens_passwordless_user_to_tenant_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "supertokens.passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant_Mutation_Response = {
  __typename?: 'supertokens_passwordless_user_to_tenant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Passwordless_User_To_Tenant>;
};

/** input type for inserting object relation for remote table "supertokens.passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant_Obj_Rel_Insert_Input = {
  data: Supertokens_Passwordless_User_To_Tenant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant_On_Conflict = {
  constraint: Supertokens_Passwordless_User_To_Tenant_Constraint;
  update_columns?: Array<Supertokens_Passwordless_User_To_Tenant_Update_Column>;
  where?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.passwordless_user_to_tenant". */
export type Supertokens_Passwordless_User_To_Tenant_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  app_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.passwordless_user_to_tenant */
export type Supertokens_Passwordless_User_To_Tenant_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.passwordless_user_to_tenant" */
export enum Supertokens_Passwordless_User_To_Tenant_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "supertokens_passwordless_user_to_tenant" */
export type Supertokens_Passwordless_User_To_Tenant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Passwordless_User_To_Tenant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Passwordless_User_To_Tenant_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "supertokens.passwordless_user_to_tenant" */
export enum Supertokens_Passwordless_User_To_Tenant_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Passwordless_User_To_Tenant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Passwordless_User_To_Tenant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Passwordless_User_To_Tenant_Bool_Exp;
};

/** columns and relationships of "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users = {
  __typename?: 'supertokens_passwordless_users';
  app_id: Scalars['String']['output'];
  /** An object relationship */
  app_id_to_user_id?: Maybe<Supertokens_App_Id_To_User_Id>;
  email?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  time_joined: Scalars['bigint']['output'];
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users_Aggregate = {
  __typename?: 'supertokens_passwordless_users_aggregate';
  aggregate?: Maybe<Supertokens_Passwordless_Users_Aggregate_Fields>;
  nodes: Array<Supertokens_Passwordless_Users>;
};

/** aggregate fields of "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users_Aggregate_Fields = {
  __typename?: 'supertokens_passwordless_users_aggregate_fields';
  avg?: Maybe<Supertokens_Passwordless_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Passwordless_Users_Max_Fields>;
  min?: Maybe<Supertokens_Passwordless_Users_Min_Fields>;
  stddev?: Maybe<Supertokens_Passwordless_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Passwordless_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Passwordless_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Passwordless_Users_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Passwordless_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Passwordless_Users_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Passwordless_Users_Variance_Fields>;
};


/** aggregate fields of "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Passwordless_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Supertokens_Passwordless_Users_Avg_Fields = {
  __typename?: 'supertokens_passwordless_users_avg_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "supertokens.passwordless_users". All fields are combined with a logical 'AND'. */
export type Supertokens_Passwordless_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Passwordless_Users_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Passwordless_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Passwordless_Users_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  time_joined?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.passwordless_users" */
export enum Supertokens_Passwordless_Users_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id" */
  PasswordlessUsersPkey = 'passwordless_users_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users_Inc_Input = {
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Obj_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Passwordless_Users_Max_Fields = {
  __typename?: 'supertokens_passwordless_users_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Supertokens_Passwordless_Users_Min_Fields = {
  __typename?: 'supertokens_passwordless_users_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users_Mutation_Response = {
  __typename?: 'supertokens_passwordless_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Passwordless_Users>;
};

/** input type for inserting object relation for remote table "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users_Obj_Rel_Insert_Input = {
  data: Supertokens_Passwordless_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Passwordless_Users_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users_On_Conflict = {
  constraint: Supertokens_Passwordless_Users_Constraint;
  update_columns?: Array<Supertokens_Passwordless_Users_Update_Column>;
  where?: InputMaybe<Supertokens_Passwordless_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.passwordless_users". */
export type Supertokens_Passwordless_Users_Order_By = {
  app_id?: InputMaybe<Order_By>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Order_By>;
  email?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  time_joined?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.passwordless_users */
export type Supertokens_Passwordless_Users_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.passwordless_users" */
export enum Supertokens_Passwordless_Users_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.passwordless_users" */
export type Supertokens_Passwordless_Users_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Passwordless_Users_Stddev_Fields = {
  __typename?: 'supertokens_passwordless_users_stddev_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Passwordless_Users_Stddev_Pop_Fields = {
  __typename?: 'supertokens_passwordless_users_stddev_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Passwordless_Users_Stddev_Samp_Fields = {
  __typename?: 'supertokens_passwordless_users_stddev_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "supertokens_passwordless_users" */
export type Supertokens_Passwordless_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Passwordless_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Passwordless_Users_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Passwordless_Users_Sum_Fields = {
  __typename?: 'supertokens_passwordless_users_sum_fields';
  time_joined?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "supertokens.passwordless_users" */
export enum Supertokens_Passwordless_Users_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Passwordless_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Passwordless_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Passwordless_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Passwordless_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Passwordless_Users_Var_Pop_Fields = {
  __typename?: 'supertokens_passwordless_users_var_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Supertokens_Passwordless_Users_Var_Samp_Fields = {
  __typename?: 'supertokens_passwordless_users_var_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Supertokens_Passwordless_Users_Variance_Fields = {
  __typename?: 'supertokens_passwordless_users_variance_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "supertokens.role_permissions" */
export type Supertokens_Role_Permissions = {
  __typename?: 'supertokens_role_permissions';
  app_id: Scalars['String']['output'];
  permission: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Aggregate = {
  __typename?: 'supertokens_role_permissions_aggregate';
  aggregate?: Maybe<Supertokens_Role_Permissions_Aggregate_Fields>;
  nodes: Array<Supertokens_Role_Permissions>;
};

export type Supertokens_Role_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Role_Permissions_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Role_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Role_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Aggregate_Fields = {
  __typename?: 'supertokens_role_permissions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Role_Permissions_Max_Fields>;
  min?: Maybe<Supertokens_Role_Permissions_Min_Fields>;
};


/** aggregate fields of "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Role_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Role_Permissions_Max_Order_By>;
  min?: InputMaybe<Supertokens_Role_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Role_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Role_Permissions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supertokens.role_permissions". All fields are combined with a logical 'AND'. */
export type Supertokens_Role_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Role_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Role_Permissions_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  permission?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.role_permissions" */
export enum Supertokens_Role_Permissions_Constraint {
  /** unique or primary key constraint on columns "app_id", "permission", "role" */
  RolePermissionsPkey = 'role_permissions_pkey'
}

/** input type for inserting data into table "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Role_Permissions_Max_Fields = {
  __typename?: 'supertokens_role_permissions_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Role_Permissions_Min_Fields = {
  __typename?: 'supertokens_role_permissions_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Mutation_Response = {
  __typename?: 'supertokens_role_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Role_Permissions>;
};

/** on_conflict condition type for table "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_On_Conflict = {
  constraint: Supertokens_Role_Permissions_Constraint;
  update_columns?: Array<Supertokens_Role_Permissions_Update_Column>;
  where?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.role_permissions". */
export type Supertokens_Role_Permissions_Order_By = {
  app_id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.role_permissions */
export type Supertokens_Role_Permissions_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  permission: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

/** select columns of table "supertokens.role_permissions" */
export enum Supertokens_Role_Permissions_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Permission = 'permission',
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "supertokens.role_permissions" */
export type Supertokens_Role_Permissions_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "supertokens_role_permissions" */
export type Supertokens_Role_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Role_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Role_Permissions_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "supertokens.role_permissions" */
export enum Supertokens_Role_Permissions_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Permission = 'permission',
  /** column name */
  Role = 'role'
}

export type Supertokens_Role_Permissions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Role_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Role_Permissions_Bool_Exp;
};

/** columns and relationships of "supertokens.roles" */
export type Supertokens_Roles = {
  __typename?: 'supertokens_roles';
  /** An object relationship */
  app: Supertokens_Apps;
  app_id: Scalars['String']['output'];
  role: Scalars['String']['output'];
  /** An array relationship */
  role_permissions: Array<Supertokens_Role_Permissions>;
  /** An aggregate relationship */
  role_permissions_aggregate: Supertokens_Role_Permissions_Aggregate;
  /** An array relationship */
  user_roles: Array<Supertokens_User_Roles>;
  /** An aggregate relationship */
  user_roles_aggregate: Supertokens_User_Roles_Aggregate;
};


/** columns and relationships of "supertokens.roles" */
export type Supertokens_RolesRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Role_Permissions_Order_By>>;
  where?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
};


/** columns and relationships of "supertokens.roles" */
export type Supertokens_RolesRole_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Role_Permissions_Order_By>>;
  where?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
};


/** columns and relationships of "supertokens.roles" */
export type Supertokens_RolesUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};


/** columns and relationships of "supertokens.roles" */
export type Supertokens_RolesUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};

/** aggregated selection of "supertokens.roles" */
export type Supertokens_Roles_Aggregate = {
  __typename?: 'supertokens_roles_aggregate';
  aggregate?: Maybe<Supertokens_Roles_Aggregate_Fields>;
  nodes: Array<Supertokens_Roles>;
};

export type Supertokens_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Roles_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.roles" */
export type Supertokens_Roles_Aggregate_Fields = {
  __typename?: 'supertokens_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Roles_Max_Fields>;
  min?: Maybe<Supertokens_Roles_Min_Fields>;
};


/** aggregate fields of "supertokens.roles" */
export type Supertokens_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.roles" */
export type Supertokens_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Roles_Max_Order_By>;
  min?: InputMaybe<Supertokens_Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.roles" */
export type Supertokens_Roles_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supertokens.roles". All fields are combined with a logical 'AND'. */
export type Supertokens_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Roles_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Roles_Bool_Exp>>;
  app?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  role_permissions?: InputMaybe<Supertokens_Role_Permissions_Bool_Exp>;
  role_permissions_aggregate?: InputMaybe<Supertokens_Role_Permissions_Aggregate_Bool_Exp>;
  user_roles?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
  user_roles_aggregate?: InputMaybe<Supertokens_User_Roles_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "supertokens.roles" */
export enum Supertokens_Roles_Constraint {
  /** unique or primary key constraint on columns "app_id", "role" */
  RolesPkey = 'roles_pkey',
  /** unique or primary key constraint on columns "role" */
  RolesRoleKey = 'roles_role_key'
}

/** input type for inserting data into table "supertokens.roles" */
export type Supertokens_Roles_Insert_Input = {
  app?: InputMaybe<Supertokens_Apps_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_permissions?: InputMaybe<Supertokens_Role_Permissions_Arr_Rel_Insert_Input>;
  user_roles?: InputMaybe<Supertokens_User_Roles_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Supertokens_Roles_Max_Fields = {
  __typename?: 'supertokens_roles_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.roles" */
export type Supertokens_Roles_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Roles_Min_Fields = {
  __typename?: 'supertokens_roles_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.roles" */
export type Supertokens_Roles_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.roles" */
export type Supertokens_Roles_Mutation_Response = {
  __typename?: 'supertokens_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Roles>;
};

/** input type for inserting object relation for remote table "supertokens.roles" */
export type Supertokens_Roles_Obj_Rel_Insert_Input = {
  data: Supertokens_Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Roles_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.roles" */
export type Supertokens_Roles_On_Conflict = {
  constraint: Supertokens_Roles_Constraint;
  update_columns?: Array<Supertokens_Roles_Update_Column>;
  where?: InputMaybe<Supertokens_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.roles". */
export type Supertokens_Roles_Order_By = {
  app?: InputMaybe<Supertokens_Apps_Order_By>;
  app_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  role_permissions_aggregate?: InputMaybe<Supertokens_Role_Permissions_Aggregate_Order_By>;
  user_roles_aggregate?: InputMaybe<Supertokens_User_Roles_Aggregate_Order_By>;
};

/** primary key columns input for table: supertokens.roles */
export type Supertokens_Roles_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

/** select columns of table "supertokens.roles" */
export enum Supertokens_Roles_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "supertokens.roles" */
export type Supertokens_Roles_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "supertokens_roles" */
export type Supertokens_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Roles_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "supertokens.roles" */
export enum Supertokens_Roles_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Role = 'role'
}

export type Supertokens_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Roles_Bool_Exp;
};

/** columns and relationships of "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys = {
  __typename?: 'supertokens_session_access_token_signing_keys';
  /** An object relationship */
  app: Supertokens_Apps;
  app_id: Scalars['String']['output'];
  created_at_time: Scalars['bigint']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Aggregate = {
  __typename?: 'supertokens_session_access_token_signing_keys_aggregate';
  aggregate?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Aggregate_Fields>;
  nodes: Array<Supertokens_Session_Access_Token_Signing_Keys>;
};

export type Supertokens_Session_Access_Token_Signing_Keys_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Session_Access_Token_Signing_Keys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Aggregate_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_aggregate_fields';
  avg?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Max_Fields>;
  min?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Min_Fields>;
  stddev?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Session_Access_Token_Signing_Keys_Variance_Fields>;
};


/** aggregate fields of "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Max_Order_By>;
  min?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Session_Access_Token_Signing_Keys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Avg_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_avg_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Avg_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.session_access_token_signing_keys". All fields are combined with a logical 'AND'. */
export type Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>>;
  app?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  created_at_time?: InputMaybe<Bigint_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.session_access_token_signing_keys" */
export enum Supertokens_Session_Access_Token_Signing_Keys_Constraint {
  /** unique or primary key constraint on columns "created_at_time", "app_id" */
  SessionAccessTokenSigningKeysPkey = 'session_access_token_signing_keys_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Inc_Input = {
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Insert_Input = {
  app?: InputMaybe<Supertokens_Apps_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Max_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Min_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Mutation_Response = {
  __typename?: 'supertokens_session_access_token_signing_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Session_Access_Token_Signing_Keys>;
};

/** on_conflict condition type for table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_On_Conflict = {
  constraint: Supertokens_Session_Access_Token_Signing_Keys_Constraint;
  update_columns?: Array<Supertokens_Session_Access_Token_Signing_Keys_Update_Column>;
  where?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.session_access_token_signing_keys". */
export type Supertokens_Session_Access_Token_Signing_Keys_Order_By = {
  app?: InputMaybe<Supertokens_Apps_Order_By>;
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.session_access_token_signing_keys */
export type Supertokens_Session_Access_Token_Signing_Keys_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  created_at_time: Scalars['bigint']['input'];
};

/** select columns of table "supertokens.session_access_token_signing_keys" */
export enum Supertokens_Session_Access_Token_Signing_Keys_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Stddev_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_stddev_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Stddev_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Stddev_Pop_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_stddev_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Stddev_Pop_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Stddev_Samp_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_stddev_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Stddev_Samp_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Session_Access_Token_Signing_Keys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Session_Access_Token_Signing_Keys_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Sum_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_sum_fields';
  created_at_time?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Sum_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.session_access_token_signing_keys" */
export enum Supertokens_Session_Access_Token_Signing_Keys_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time',
  /** column name */
  Value = 'value'
}

export type Supertokens_Session_Access_Token_Signing_Keys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Session_Access_Token_Signing_Keys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Session_Access_Token_Signing_Keys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Var_Pop_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_var_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Var_Pop_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Var_Samp_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_var_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Var_Samp_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Session_Access_Token_Signing_Keys_Variance_Fields = {
  __typename?: 'supertokens_session_access_token_signing_keys_variance_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.session_access_token_signing_keys" */
export type Supertokens_Session_Access_Token_Signing_Keys_Variance_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.session_info" */
export type Supertokens_Session_Info = {
  __typename?: 'supertokens_session_info';
  app_id: Scalars['String']['output'];
  created_at_time: Scalars['bigint']['output'];
  expires_at: Scalars['bigint']['output'];
  jwt_user_payload?: Maybe<Scalars['String']['output']>;
  refresh_token_hash_2: Scalars['String']['output'];
  session_data?: Maybe<Scalars['String']['output']>;
  session_handle: Scalars['String']['output'];
  /** An object relationship */
  tenant?: Maybe<Supertokens_Tenants>;
  tenant_id: Scalars['String']['output'];
  use_static_key: Scalars['Boolean']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.session_info" */
export type Supertokens_Session_Info_Aggregate = {
  __typename?: 'supertokens_session_info_aggregate';
  aggregate?: Maybe<Supertokens_Session_Info_Aggregate_Fields>;
  nodes: Array<Supertokens_Session_Info>;
};

export type Supertokens_Session_Info_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Supertokens_Session_Info_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Supertokens_Session_Info_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Supertokens_Session_Info_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Session_Info_Aggregate_Bool_Exp_Bool_And = {
  arguments: Supertokens_Session_Info_Select_Column_Supertokens_Session_Info_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Supertokens_Session_Info_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Supertokens_Session_Info_Select_Column_Supertokens_Session_Info_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Supertokens_Session_Info_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Session_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.session_info" */
export type Supertokens_Session_Info_Aggregate_Fields = {
  __typename?: 'supertokens_session_info_aggregate_fields';
  avg?: Maybe<Supertokens_Session_Info_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Session_Info_Max_Fields>;
  min?: Maybe<Supertokens_Session_Info_Min_Fields>;
  stddev?: Maybe<Supertokens_Session_Info_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Session_Info_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Session_Info_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Session_Info_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Session_Info_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Session_Info_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Session_Info_Variance_Fields>;
};


/** aggregate fields of "supertokens.session_info" */
export type Supertokens_Session_Info_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Session_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.session_info" */
export type Supertokens_Session_Info_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Session_Info_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Session_Info_Max_Order_By>;
  min?: InputMaybe<Supertokens_Session_Info_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Session_Info_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Session_Info_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Session_Info_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Session_Info_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Session_Info_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Session_Info_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Session_Info_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.session_info" */
export type Supertokens_Session_Info_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Session_Info_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Session_Info_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Session_Info_Avg_Fields = {
  __typename?: 'supertokens_session_info_avg_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
  expires_at?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Avg_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.session_info". All fields are combined with a logical 'AND'. */
export type Supertokens_Session_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Session_Info_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Session_Info_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  created_at_time?: InputMaybe<Bigint_Comparison_Exp>;
  expires_at?: InputMaybe<Bigint_Comparison_Exp>;
  jwt_user_payload?: InputMaybe<String_Comparison_Exp>;
  refresh_token_hash_2?: InputMaybe<String_Comparison_Exp>;
  session_data?: InputMaybe<String_Comparison_Exp>;
  session_handle?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  use_static_key?: InputMaybe<Boolean_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.session_info" */
export enum Supertokens_Session_Info_Constraint {
  /** unique or primary key constraint on columns "app_id", "session_handle", "tenant_id" */
  SessionInfoPkey = 'session_info_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.session_info" */
export type Supertokens_Session_Info_Inc_Input = {
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  expires_at?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.session_info" */
export type Supertokens_Session_Info_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  expires_at?: InputMaybe<Scalars['bigint']['input']>;
  jwt_user_payload?: InputMaybe<Scalars['String']['input']>;
  refresh_token_hash_2?: InputMaybe<Scalars['String']['input']>;
  session_data?: InputMaybe<Scalars['String']['input']>;
  session_handle?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Supertokens_Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  use_static_key?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Session_Info_Max_Fields = {
  __typename?: 'supertokens_session_info_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  expires_at?: Maybe<Scalars['bigint']['output']>;
  jwt_user_payload?: Maybe<Scalars['String']['output']>;
  refresh_token_hash_2?: Maybe<Scalars['String']['output']>;
  session_data?: Maybe<Scalars['String']['output']>;
  session_handle?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  jwt_user_payload?: InputMaybe<Order_By>;
  refresh_token_hash_2?: InputMaybe<Order_By>;
  session_data?: InputMaybe<Order_By>;
  session_handle?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Session_Info_Min_Fields = {
  __typename?: 'supertokens_session_info_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  expires_at?: Maybe<Scalars['bigint']['output']>;
  jwt_user_payload?: Maybe<Scalars['String']['output']>;
  refresh_token_hash_2?: Maybe<Scalars['String']['output']>;
  session_data?: Maybe<Scalars['String']['output']>;
  session_handle?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  jwt_user_payload?: InputMaybe<Order_By>;
  refresh_token_hash_2?: InputMaybe<Order_By>;
  session_data?: InputMaybe<Order_By>;
  session_handle?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.session_info" */
export type Supertokens_Session_Info_Mutation_Response = {
  __typename?: 'supertokens_session_info_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Session_Info>;
};

/** on_conflict condition type for table "supertokens.session_info" */
export type Supertokens_Session_Info_On_Conflict = {
  constraint: Supertokens_Session_Info_Constraint;
  update_columns?: Array<Supertokens_Session_Info_Update_Column>;
  where?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.session_info". */
export type Supertokens_Session_Info_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  jwt_user_payload?: InputMaybe<Order_By>;
  refresh_token_hash_2?: InputMaybe<Order_By>;
  session_data?: InputMaybe<Order_By>;
  session_handle?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Supertokens_Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  use_static_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.session_info */
export type Supertokens_Session_Info_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  session_handle: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.session_info" */
export enum Supertokens_Session_Info_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  JwtUserPayload = 'jwt_user_payload',
  /** column name */
  RefreshTokenHash_2 = 'refresh_token_hash_2',
  /** column name */
  SessionData = 'session_data',
  /** column name */
  SessionHandle = 'session_handle',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UseStaticKey = 'use_static_key',
  /** column name */
  UserId = 'user_id'
}

/** select "supertokens_session_info_aggregate_bool_exp_bool_and_arguments_columns" columns of table "supertokens.session_info" */
export enum Supertokens_Session_Info_Select_Column_Supertokens_Session_Info_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UseStaticKey = 'use_static_key'
}

/** select "supertokens_session_info_aggregate_bool_exp_bool_or_arguments_columns" columns of table "supertokens.session_info" */
export enum Supertokens_Session_Info_Select_Column_Supertokens_Session_Info_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UseStaticKey = 'use_static_key'
}

/** input type for updating data in table "supertokens.session_info" */
export type Supertokens_Session_Info_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  expires_at?: InputMaybe<Scalars['bigint']['input']>;
  jwt_user_payload?: InputMaybe<Scalars['String']['input']>;
  refresh_token_hash_2?: InputMaybe<Scalars['String']['input']>;
  session_data?: InputMaybe<Scalars['String']['input']>;
  session_handle?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  use_static_key?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Session_Info_Stddev_Fields = {
  __typename?: 'supertokens_session_info_stddev_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
  expires_at?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Stddev_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Session_Info_Stddev_Pop_Fields = {
  __typename?: 'supertokens_session_info_stddev_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
  expires_at?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Stddev_Pop_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Session_Info_Stddev_Samp_Fields = {
  __typename?: 'supertokens_session_info_stddev_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
  expires_at?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Stddev_Samp_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_session_info" */
export type Supertokens_Session_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Session_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Session_Info_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  expires_at?: InputMaybe<Scalars['bigint']['input']>;
  jwt_user_payload?: InputMaybe<Scalars['String']['input']>;
  refresh_token_hash_2?: InputMaybe<Scalars['String']['input']>;
  session_data?: InputMaybe<Scalars['String']['input']>;
  session_handle?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  use_static_key?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Session_Info_Sum_Fields = {
  __typename?: 'supertokens_session_info_sum_fields';
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  expires_at?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Sum_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.session_info" */
export enum Supertokens_Session_Info_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  JwtUserPayload = 'jwt_user_payload',
  /** column name */
  RefreshTokenHash_2 = 'refresh_token_hash_2',
  /** column name */
  SessionData = 'session_data',
  /** column name */
  SessionHandle = 'session_handle',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UseStaticKey = 'use_static_key',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Session_Info_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Session_Info_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Session_Info_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Session_Info_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Session_Info_Var_Pop_Fields = {
  __typename?: 'supertokens_session_info_var_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
  expires_at?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Var_Pop_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Session_Info_Var_Samp_Fields = {
  __typename?: 'supertokens_session_info_var_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
  expires_at?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Var_Samp_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Session_Info_Variance_Fields = {
  __typename?: 'supertokens_session_info_variance_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
  expires_at?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.session_info" */
export type Supertokens_Session_Info_Variance_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.tenant_configs" */
export type Supertokens_Tenant_Configs = {
  __typename?: 'supertokens_tenant_configs';
  app_id: Scalars['String']['output'];
  connection_uri_domain: Scalars['String']['output'];
  core_config?: Maybe<Scalars['String']['output']>;
  email_password_enabled?: Maybe<Scalars['Boolean']['output']>;
  passwordless_enabled?: Maybe<Scalars['Boolean']['output']>;
  tenant_id: Scalars['String']['output'];
  /** An array relationship */
  tenant_thirdparty_providers: Array<Supertokens_Tenant_Thirdparty_Providers>;
  /** An aggregate relationship */
  tenant_thirdparty_providers_aggregate: Supertokens_Tenant_Thirdparty_Providers_Aggregate;
  third_party_enabled?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "supertokens.tenant_configs" */
export type Supertokens_Tenant_ConfigsTenant_Thirdparty_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenant_configs" */
export type Supertokens_Tenant_ConfigsTenant_Thirdparty_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
};

/** aggregated selection of "supertokens.tenant_configs" */
export type Supertokens_Tenant_Configs_Aggregate = {
  __typename?: 'supertokens_tenant_configs_aggregate';
  aggregate?: Maybe<Supertokens_Tenant_Configs_Aggregate_Fields>;
  nodes: Array<Supertokens_Tenant_Configs>;
};

/** aggregate fields of "supertokens.tenant_configs" */
export type Supertokens_Tenant_Configs_Aggregate_Fields = {
  __typename?: 'supertokens_tenant_configs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Tenant_Configs_Max_Fields>;
  min?: Maybe<Supertokens_Tenant_Configs_Min_Fields>;
};


/** aggregate fields of "supertokens.tenant_configs" */
export type Supertokens_Tenant_Configs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Tenant_Configs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "supertokens.tenant_configs". All fields are combined with a logical 'AND'. */
export type Supertokens_Tenant_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Tenant_Configs_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Tenant_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Tenant_Configs_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  connection_uri_domain?: InputMaybe<String_Comparison_Exp>;
  core_config?: InputMaybe<String_Comparison_Exp>;
  email_password_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  passwordless_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  tenant_thirdparty_providers?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
  tenant_thirdparty_providers_aggregate?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp>;
  third_party_enabled?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.tenant_configs" */
export enum Supertokens_Tenant_Configs_Constraint {
  /** unique or primary key constraint on columns "app_id", "connection_uri_domain", "tenant_id" */
  TenantConfigsPkey = 'tenant_configs_pkey'
}

/** input type for inserting data into table "supertokens.tenant_configs" */
export type Supertokens_Tenant_Configs_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  connection_uri_domain?: InputMaybe<Scalars['String']['input']>;
  core_config?: InputMaybe<Scalars['String']['input']>;
  email_password_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  passwordless_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  tenant_thirdparty_providers?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Arr_Rel_Insert_Input>;
  third_party_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Tenant_Configs_Max_Fields = {
  __typename?: 'supertokens_tenant_configs_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  connection_uri_domain?: Maybe<Scalars['String']['output']>;
  core_config?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Supertokens_Tenant_Configs_Min_Fields = {
  __typename?: 'supertokens_tenant_configs_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  connection_uri_domain?: Maybe<Scalars['String']['output']>;
  core_config?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "supertokens.tenant_configs" */
export type Supertokens_Tenant_Configs_Mutation_Response = {
  __typename?: 'supertokens_tenant_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Tenant_Configs>;
};

/** input type for inserting object relation for remote table "supertokens.tenant_configs" */
export type Supertokens_Tenant_Configs_Obj_Rel_Insert_Input = {
  data: Supertokens_Tenant_Configs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Tenant_Configs_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.tenant_configs" */
export type Supertokens_Tenant_Configs_On_Conflict = {
  constraint: Supertokens_Tenant_Configs_Constraint;
  update_columns?: Array<Supertokens_Tenant_Configs_Update_Column>;
  where?: InputMaybe<Supertokens_Tenant_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.tenant_configs". */
export type Supertokens_Tenant_Configs_Order_By = {
  app_id?: InputMaybe<Order_By>;
  connection_uri_domain?: InputMaybe<Order_By>;
  core_config?: InputMaybe<Order_By>;
  email_password_enabled?: InputMaybe<Order_By>;
  passwordless_enabled?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_thirdparty_providers_aggregate?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Aggregate_Order_By>;
  third_party_enabled?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.tenant_configs */
export type Supertokens_Tenant_Configs_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.tenant_configs" */
export enum Supertokens_Tenant_Configs_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  ConnectionUriDomain = 'connection_uri_domain',
  /** column name */
  CoreConfig = 'core_config',
  /** column name */
  EmailPasswordEnabled = 'email_password_enabled',
  /** column name */
  PasswordlessEnabled = 'passwordless_enabled',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPartyEnabled = 'third_party_enabled'
}

/** input type for updating data in table "supertokens.tenant_configs" */
export type Supertokens_Tenant_Configs_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  connection_uri_domain?: InputMaybe<Scalars['String']['input']>;
  core_config?: InputMaybe<Scalars['String']['input']>;
  email_password_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  passwordless_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  third_party_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "supertokens_tenant_configs" */
export type Supertokens_Tenant_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Tenant_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Tenant_Configs_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  connection_uri_domain?: InputMaybe<Scalars['String']['input']>;
  core_config?: InputMaybe<Scalars['String']['input']>;
  email_password_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  passwordless_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  third_party_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "supertokens.tenant_configs" */
export enum Supertokens_Tenant_Configs_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  ConnectionUriDomain = 'connection_uri_domain',
  /** column name */
  CoreConfig = 'core_config',
  /** column name */
  EmailPasswordEnabled = 'email_password_enabled',
  /** column name */
  PasswordlessEnabled = 'passwordless_enabled',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPartyEnabled = 'third_party_enabled'
}

export type Supertokens_Tenant_Configs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Tenant_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Tenant_Configs_Bool_Exp;
};

/** columns and relationships of "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients = {
  __typename?: 'supertokens_tenant_thirdparty_provider_clients';
  additional_config?: Maybe<Scalars['String']['output']>;
  app_id: Scalars['String']['output'];
  client_id: Scalars['String']['output'];
  client_secret?: Maybe<Scalars['String']['output']>;
  client_type: Scalars['String']['output'];
  connection_uri_domain: Scalars['String']['output'];
  force_pkce?: Maybe<Scalars['Boolean']['output']>;
  scope?: Maybe<Array<Scalars['String']['output']>>;
  tenant_id: Scalars['String']['output'];
  /** An object relationship */
  tenant_thirdparty_provider?: Maybe<Supertokens_Tenant_Thirdparty_Providers>;
  third_party_id: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate = {
  __typename?: 'supertokens_tenant_thirdparty_provider_clients_aggregate';
  aggregate?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Fields>;
  nodes: Array<Supertokens_Tenant_Thirdparty_Provider_Clients>;
};

export type Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Bool_And = {
  arguments: Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column_Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column_Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Fields = {
  __typename?: 'supertokens_tenant_thirdparty_provider_clients_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Max_Fields>;
  min?: Maybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Min_Fields>;
};


/** aggregate fields of "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Max_Order_By>;
  min?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supertokens.tenant_thirdparty_provider_clients". All fields are combined with a logical 'AND'. */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>>;
  additional_config?: InputMaybe<String_Comparison_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<String_Comparison_Exp>;
  client_secret?: InputMaybe<String_Comparison_Exp>;
  client_type?: InputMaybe<String_Comparison_Exp>;
  connection_uri_domain?: InputMaybe<String_Comparison_Exp>;
  force_pkce?: InputMaybe<Boolean_Comparison_Exp>;
  scope?: InputMaybe<String_Array_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  tenant_thirdparty_provider?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
  third_party_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.tenant_thirdparty_provider_clients" */
export enum Supertokens_Tenant_Thirdparty_Provider_Clients_Constraint {
  /** unique or primary key constraint on columns "app_id", "client_type", "connection_uri_domain", "third_party_id", "tenant_id" */
  TenantThirdpartyProviderClientsPkey = 'tenant_thirdparty_provider_clients_pkey'
}

/** input type for inserting data into table "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Insert_Input = {
  additional_config?: InputMaybe<Scalars['String']['input']>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['String']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  client_type?: InputMaybe<Scalars['String']['input']>;
  connection_uri_domain?: InputMaybe<Scalars['String']['input']>;
  force_pkce?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  tenant_thirdparty_provider?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Obj_Rel_Insert_Input>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Max_Fields = {
  __typename?: 'supertokens_tenant_thirdparty_provider_clients_max_fields';
  additional_config?: Maybe<Scalars['String']['output']>;
  app_id?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  client_type?: Maybe<Scalars['String']['output']>;
  connection_uri_domain?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Array<Scalars['String']['output']>>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  third_party_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Max_Order_By = {
  additional_config?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_secret?: InputMaybe<Order_By>;
  client_type?: InputMaybe<Order_By>;
  connection_uri_domain?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_party_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Min_Fields = {
  __typename?: 'supertokens_tenant_thirdparty_provider_clients_min_fields';
  additional_config?: Maybe<Scalars['String']['output']>;
  app_id?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  client_type?: Maybe<Scalars['String']['output']>;
  connection_uri_domain?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Array<Scalars['String']['output']>>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  third_party_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Min_Order_By = {
  additional_config?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_secret?: InputMaybe<Order_By>;
  client_type?: InputMaybe<Order_By>;
  connection_uri_domain?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_party_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Mutation_Response = {
  __typename?: 'supertokens_tenant_thirdparty_provider_clients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Tenant_Thirdparty_Provider_Clients>;
};

/** on_conflict condition type for table "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_On_Conflict = {
  constraint: Supertokens_Tenant_Thirdparty_Provider_Clients_Constraint;
  update_columns?: Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Update_Column>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.tenant_thirdparty_provider_clients". */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Order_By = {
  additional_config?: InputMaybe<Order_By>;
  app_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_secret?: InputMaybe<Order_By>;
  client_type?: InputMaybe<Order_By>;
  connection_uri_domain?: InputMaybe<Order_By>;
  force_pkce?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_thirdparty_provider?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Order_By>;
  third_party_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.tenant_thirdparty_provider_clients */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  client_type: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  third_party_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.tenant_thirdparty_provider_clients" */
export enum Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column {
  /** column name */
  AdditionalConfig = 'additional_config',
  /** column name */
  AppId = 'app_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientSecret = 'client_secret',
  /** column name */
  ClientType = 'client_type',
  /** column name */
  ConnectionUriDomain = 'connection_uri_domain',
  /** column name */
  ForcePkce = 'force_pkce',
  /** column name */
  Scope = 'scope',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPartyId = 'third_party_id'
}

/** select "supertokens_tenant_thirdparty_provider_clients_aggregate_bool_exp_bool_and_arguments_columns" columns of table "supertokens.tenant_thirdparty_provider_clients" */
export enum Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column_Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ForcePkce = 'force_pkce'
}

/** select "supertokens_tenant_thirdparty_provider_clients_aggregate_bool_exp_bool_or_arguments_columns" columns of table "supertokens.tenant_thirdparty_provider_clients" */
export enum Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column_Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ForcePkce = 'force_pkce'
}

/** input type for updating data in table "supertokens.tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Set_Input = {
  additional_config?: InputMaybe<Scalars['String']['input']>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['String']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  client_type?: InputMaybe<Scalars['String']['input']>;
  connection_uri_domain?: InputMaybe<Scalars['String']['input']>;
  force_pkce?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "supertokens_tenant_thirdparty_provider_clients" */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Tenant_Thirdparty_Provider_Clients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Tenant_Thirdparty_Provider_Clients_Stream_Cursor_Value_Input = {
  additional_config?: InputMaybe<Scalars['String']['input']>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['String']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  client_type?: InputMaybe<Scalars['String']['input']>;
  connection_uri_domain?: InputMaybe<Scalars['String']['input']>;
  force_pkce?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "supertokens.tenant_thirdparty_provider_clients" */
export enum Supertokens_Tenant_Thirdparty_Provider_Clients_Update_Column {
  /** column name */
  AdditionalConfig = 'additional_config',
  /** column name */
  AppId = 'app_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientSecret = 'client_secret',
  /** column name */
  ClientType = 'client_type',
  /** column name */
  ConnectionUriDomain = 'connection_uri_domain',
  /** column name */
  ForcePkce = 'force_pkce',
  /** column name */
  Scope = 'scope',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPartyId = 'third_party_id'
}

export type Supertokens_Tenant_Thirdparty_Provider_Clients_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp;
};

/** columns and relationships of "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers = {
  __typename?: 'supertokens_tenant_thirdparty_providers';
  app_id: Scalars['String']['output'];
  authorization_endpoint?: Maybe<Scalars['String']['output']>;
  authorization_endpoint_query_params?: Maybe<Scalars['String']['output']>;
  connection_uri_domain: Scalars['String']['output'];
  jwks_uri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oidc_discovery_endpoint?: Maybe<Scalars['String']['output']>;
  require_email?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tenant_config?: Maybe<Supertokens_Tenant_Configs>;
  tenant_id: Scalars['String']['output'];
  /** An array relationship */
  tenant_thirdparty_provider_clients: Array<Supertokens_Tenant_Thirdparty_Provider_Clients>;
  /** An aggregate relationship */
  tenant_thirdparty_provider_clients_aggregate: Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate;
  third_party_id: Scalars['String']['output'];
  token_endpoint?: Maybe<Scalars['String']['output']>;
  token_endpoint_body_params?: Maybe<Scalars['String']['output']>;
  user_info_endpoint?: Maybe<Scalars['String']['output']>;
  user_info_endpoint_headers?: Maybe<Scalars['String']['output']>;
  user_info_endpoint_query_params?: Maybe<Scalars['String']['output']>;
  user_info_map_from_id_token_payload_email?: Maybe<Scalars['String']['output']>;
  user_info_map_from_id_token_payload_email_verified?: Maybe<Scalars['String']['output']>;
  user_info_map_from_id_token_payload_user_id?: Maybe<Scalars['String']['output']>;
  user_info_map_from_user_info_endpoint_email?: Maybe<Scalars['String']['output']>;
  user_info_map_from_user_info_endpoint_email_verified?: Maybe<Scalars['String']['output']>;
  user_info_map_from_user_info_endpoint_user_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_ProvidersTenant_Thirdparty_Provider_ClientsArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_ProvidersTenant_Thirdparty_Provider_Clients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Provider_Clients_Order_By>>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
};

/** aggregated selection of "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Aggregate = {
  __typename?: 'supertokens_tenant_thirdparty_providers_aggregate';
  aggregate?: Maybe<Supertokens_Tenant_Thirdparty_Providers_Aggregate_Fields>;
  nodes: Array<Supertokens_Tenant_Thirdparty_Providers>;
};

export type Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Bool_And = {
  arguments: Supertokens_Tenant_Thirdparty_Providers_Select_Column_Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Supertokens_Tenant_Thirdparty_Providers_Select_Column_Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Aggregate_Fields = {
  __typename?: 'supertokens_tenant_thirdparty_providers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Tenant_Thirdparty_Providers_Max_Fields>;
  min?: Maybe<Supertokens_Tenant_Thirdparty_Providers_Min_Fields>;
};


/** aggregate fields of "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Max_Order_By>;
  min?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Tenant_Thirdparty_Providers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supertokens.tenant_thirdparty_providers". All fields are combined with a logical 'AND'. */
export type Supertokens_Tenant_Thirdparty_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  authorization_endpoint?: InputMaybe<String_Comparison_Exp>;
  authorization_endpoint_query_params?: InputMaybe<String_Comparison_Exp>;
  connection_uri_domain?: InputMaybe<String_Comparison_Exp>;
  jwks_uri?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oidc_discovery_endpoint?: InputMaybe<String_Comparison_Exp>;
  require_email?: InputMaybe<Boolean_Comparison_Exp>;
  tenant_config?: InputMaybe<Supertokens_Tenant_Configs_Bool_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  tenant_thirdparty_provider_clients?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Bool_Exp>;
  tenant_thirdparty_provider_clients_aggregate?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Bool_Exp>;
  third_party_id?: InputMaybe<String_Comparison_Exp>;
  token_endpoint?: InputMaybe<String_Comparison_Exp>;
  token_endpoint_body_params?: InputMaybe<String_Comparison_Exp>;
  user_info_endpoint?: InputMaybe<String_Comparison_Exp>;
  user_info_endpoint_headers?: InputMaybe<String_Comparison_Exp>;
  user_info_endpoint_query_params?: InputMaybe<String_Comparison_Exp>;
  user_info_map_from_id_token_payload_email?: InputMaybe<String_Comparison_Exp>;
  user_info_map_from_id_token_payload_email_verified?: InputMaybe<String_Comparison_Exp>;
  user_info_map_from_id_token_payload_user_id?: InputMaybe<String_Comparison_Exp>;
  user_info_map_from_user_info_endpoint_email?: InputMaybe<String_Comparison_Exp>;
  user_info_map_from_user_info_endpoint_email_verified?: InputMaybe<String_Comparison_Exp>;
  user_info_map_from_user_info_endpoint_user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.tenant_thirdparty_providers" */
export enum Supertokens_Tenant_Thirdparty_Providers_Constraint {
  /** unique or primary key constraint on columns "app_id", "connection_uri_domain", "third_party_id", "tenant_id" */
  TenantThirdpartyProvidersPkey = 'tenant_thirdparty_providers_pkey'
}

/** input type for inserting data into table "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  authorization_endpoint?: InputMaybe<Scalars['String']['input']>;
  authorization_endpoint_query_params?: InputMaybe<Scalars['String']['input']>;
  connection_uri_domain?: InputMaybe<Scalars['String']['input']>;
  jwks_uri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oidc_discovery_endpoint?: InputMaybe<Scalars['String']['input']>;
  require_email?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_config?: InputMaybe<Supertokens_Tenant_Configs_Obj_Rel_Insert_Input>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  tenant_thirdparty_provider_clients?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Arr_Rel_Insert_Input>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
  token_endpoint?: InputMaybe<Scalars['String']['input']>;
  token_endpoint_body_params?: InputMaybe<Scalars['String']['input']>;
  user_info_endpoint?: InputMaybe<Scalars['String']['input']>;
  user_info_endpoint_headers?: InputMaybe<Scalars['String']['input']>;
  user_info_endpoint_query_params?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_id_token_payload_email?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_id_token_payload_email_verified?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_id_token_payload_user_id?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_user_info_endpoint_email?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_user_info_endpoint_email_verified?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_user_info_endpoint_user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Tenant_Thirdparty_Providers_Max_Fields = {
  __typename?: 'supertokens_tenant_thirdparty_providers_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  authorization_endpoint?: Maybe<Scalars['String']['output']>;
  authorization_endpoint_query_params?: Maybe<Scalars['String']['output']>;
  connection_uri_domain?: Maybe<Scalars['String']['output']>;
  jwks_uri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oidc_discovery_endpoint?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  third_party_id?: Maybe<Scalars['String']['output']>;
  token_endpoint?: Maybe<Scalars['String']['output']>;
  token_endpoint_body_params?: Maybe<Scalars['String']['output']>;
  user_info_endpoint?: Maybe<Scalars['String']['output']>;
  user_info_endpoint_headers?: Maybe<Scalars['String']['output']>;
  user_info_endpoint_query_params?: Maybe<Scalars['String']['output']>;
  user_info_map_from_id_token_payload_email?: Maybe<Scalars['String']['output']>;
  user_info_map_from_id_token_payload_email_verified?: Maybe<Scalars['String']['output']>;
  user_info_map_from_id_token_payload_user_id?: Maybe<Scalars['String']['output']>;
  user_info_map_from_user_info_endpoint_email?: Maybe<Scalars['String']['output']>;
  user_info_map_from_user_info_endpoint_email_verified?: Maybe<Scalars['String']['output']>;
  user_info_map_from_user_info_endpoint_user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  authorization_endpoint?: InputMaybe<Order_By>;
  authorization_endpoint_query_params?: InputMaybe<Order_By>;
  connection_uri_domain?: InputMaybe<Order_By>;
  jwks_uri?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oidc_discovery_endpoint?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_party_id?: InputMaybe<Order_By>;
  token_endpoint?: InputMaybe<Order_By>;
  token_endpoint_body_params?: InputMaybe<Order_By>;
  user_info_endpoint?: InputMaybe<Order_By>;
  user_info_endpoint_headers?: InputMaybe<Order_By>;
  user_info_endpoint_query_params?: InputMaybe<Order_By>;
  user_info_map_from_id_token_payload_email?: InputMaybe<Order_By>;
  user_info_map_from_id_token_payload_email_verified?: InputMaybe<Order_By>;
  user_info_map_from_id_token_payload_user_id?: InputMaybe<Order_By>;
  user_info_map_from_user_info_endpoint_email?: InputMaybe<Order_By>;
  user_info_map_from_user_info_endpoint_email_verified?: InputMaybe<Order_By>;
  user_info_map_from_user_info_endpoint_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Tenant_Thirdparty_Providers_Min_Fields = {
  __typename?: 'supertokens_tenant_thirdparty_providers_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  authorization_endpoint?: Maybe<Scalars['String']['output']>;
  authorization_endpoint_query_params?: Maybe<Scalars['String']['output']>;
  connection_uri_domain?: Maybe<Scalars['String']['output']>;
  jwks_uri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oidc_discovery_endpoint?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  third_party_id?: Maybe<Scalars['String']['output']>;
  token_endpoint?: Maybe<Scalars['String']['output']>;
  token_endpoint_body_params?: Maybe<Scalars['String']['output']>;
  user_info_endpoint?: Maybe<Scalars['String']['output']>;
  user_info_endpoint_headers?: Maybe<Scalars['String']['output']>;
  user_info_endpoint_query_params?: Maybe<Scalars['String']['output']>;
  user_info_map_from_id_token_payload_email?: Maybe<Scalars['String']['output']>;
  user_info_map_from_id_token_payload_email_verified?: Maybe<Scalars['String']['output']>;
  user_info_map_from_id_token_payload_user_id?: Maybe<Scalars['String']['output']>;
  user_info_map_from_user_info_endpoint_email?: Maybe<Scalars['String']['output']>;
  user_info_map_from_user_info_endpoint_email_verified?: Maybe<Scalars['String']['output']>;
  user_info_map_from_user_info_endpoint_user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  authorization_endpoint?: InputMaybe<Order_By>;
  authorization_endpoint_query_params?: InputMaybe<Order_By>;
  connection_uri_domain?: InputMaybe<Order_By>;
  jwks_uri?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oidc_discovery_endpoint?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_party_id?: InputMaybe<Order_By>;
  token_endpoint?: InputMaybe<Order_By>;
  token_endpoint_body_params?: InputMaybe<Order_By>;
  user_info_endpoint?: InputMaybe<Order_By>;
  user_info_endpoint_headers?: InputMaybe<Order_By>;
  user_info_endpoint_query_params?: InputMaybe<Order_By>;
  user_info_map_from_id_token_payload_email?: InputMaybe<Order_By>;
  user_info_map_from_id_token_payload_email_verified?: InputMaybe<Order_By>;
  user_info_map_from_id_token_payload_user_id?: InputMaybe<Order_By>;
  user_info_map_from_user_info_endpoint_email?: InputMaybe<Order_By>;
  user_info_map_from_user_info_endpoint_email_verified?: InputMaybe<Order_By>;
  user_info_map_from_user_info_endpoint_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Mutation_Response = {
  __typename?: 'supertokens_tenant_thirdparty_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Tenant_Thirdparty_Providers>;
};

/** input type for inserting object relation for remote table "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Obj_Rel_Insert_Input = {
  data: Supertokens_Tenant_Thirdparty_Providers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_On_Conflict = {
  constraint: Supertokens_Tenant_Thirdparty_Providers_Constraint;
  update_columns?: Array<Supertokens_Tenant_Thirdparty_Providers_Update_Column>;
  where?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.tenant_thirdparty_providers". */
export type Supertokens_Tenant_Thirdparty_Providers_Order_By = {
  app_id?: InputMaybe<Order_By>;
  authorization_endpoint?: InputMaybe<Order_By>;
  authorization_endpoint_query_params?: InputMaybe<Order_By>;
  connection_uri_domain?: InputMaybe<Order_By>;
  jwks_uri?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oidc_discovery_endpoint?: InputMaybe<Order_By>;
  require_email?: InputMaybe<Order_By>;
  tenant_config?: InputMaybe<Supertokens_Tenant_Configs_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_thirdparty_provider_clients_aggregate?: InputMaybe<Supertokens_Tenant_Thirdparty_Provider_Clients_Aggregate_Order_By>;
  third_party_id?: InputMaybe<Order_By>;
  token_endpoint?: InputMaybe<Order_By>;
  token_endpoint_body_params?: InputMaybe<Order_By>;
  user_info_endpoint?: InputMaybe<Order_By>;
  user_info_endpoint_headers?: InputMaybe<Order_By>;
  user_info_endpoint_query_params?: InputMaybe<Order_By>;
  user_info_map_from_id_token_payload_email?: InputMaybe<Order_By>;
  user_info_map_from_id_token_payload_email_verified?: InputMaybe<Order_By>;
  user_info_map_from_id_token_payload_user_id?: InputMaybe<Order_By>;
  user_info_map_from_user_info_endpoint_email?: InputMaybe<Order_By>;
  user_info_map_from_user_info_endpoint_email_verified?: InputMaybe<Order_By>;
  user_info_map_from_user_info_endpoint_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.tenant_thirdparty_providers */
export type Supertokens_Tenant_Thirdparty_Providers_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  connection_uri_domain: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  third_party_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.tenant_thirdparty_providers" */
export enum Supertokens_Tenant_Thirdparty_Providers_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  AuthorizationEndpoint = 'authorization_endpoint',
  /** column name */
  AuthorizationEndpointQueryParams = 'authorization_endpoint_query_params',
  /** column name */
  ConnectionUriDomain = 'connection_uri_domain',
  /** column name */
  JwksUri = 'jwks_uri',
  /** column name */
  Name = 'name',
  /** column name */
  OidcDiscoveryEndpoint = 'oidc_discovery_endpoint',
  /** column name */
  RequireEmail = 'require_email',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPartyId = 'third_party_id',
  /** column name */
  TokenEndpoint = 'token_endpoint',
  /** column name */
  TokenEndpointBodyParams = 'token_endpoint_body_params',
  /** column name */
  UserInfoEndpoint = 'user_info_endpoint',
  /** column name */
  UserInfoEndpointHeaders = 'user_info_endpoint_headers',
  /** column name */
  UserInfoEndpointQueryParams = 'user_info_endpoint_query_params',
  /** column name */
  UserInfoMapFromIdTokenPayloadEmail = 'user_info_map_from_id_token_payload_email',
  /** column name */
  UserInfoMapFromIdTokenPayloadEmailVerified = 'user_info_map_from_id_token_payload_email_verified',
  /** column name */
  UserInfoMapFromIdTokenPayloadUserId = 'user_info_map_from_id_token_payload_user_id',
  /** column name */
  UserInfoMapFromUserInfoEndpointEmail = 'user_info_map_from_user_info_endpoint_email',
  /** column name */
  UserInfoMapFromUserInfoEndpointEmailVerified = 'user_info_map_from_user_info_endpoint_email_verified',
  /** column name */
  UserInfoMapFromUserInfoEndpointUserId = 'user_info_map_from_user_info_endpoint_user_id'
}

/** select "supertokens_tenant_thirdparty_providers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "supertokens.tenant_thirdparty_providers" */
export enum Supertokens_Tenant_Thirdparty_Providers_Select_Column_Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  RequireEmail = 'require_email'
}

/** select "supertokens_tenant_thirdparty_providers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "supertokens.tenant_thirdparty_providers" */
export enum Supertokens_Tenant_Thirdparty_Providers_Select_Column_Supertokens_Tenant_Thirdparty_Providers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  RequireEmail = 'require_email'
}

/** input type for updating data in table "supertokens.tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  authorization_endpoint?: InputMaybe<Scalars['String']['input']>;
  authorization_endpoint_query_params?: InputMaybe<Scalars['String']['input']>;
  connection_uri_domain?: InputMaybe<Scalars['String']['input']>;
  jwks_uri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oidc_discovery_endpoint?: InputMaybe<Scalars['String']['input']>;
  require_email?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
  token_endpoint?: InputMaybe<Scalars['String']['input']>;
  token_endpoint_body_params?: InputMaybe<Scalars['String']['input']>;
  user_info_endpoint?: InputMaybe<Scalars['String']['input']>;
  user_info_endpoint_headers?: InputMaybe<Scalars['String']['input']>;
  user_info_endpoint_query_params?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_id_token_payload_email?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_id_token_payload_email_verified?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_id_token_payload_user_id?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_user_info_endpoint_email?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_user_info_endpoint_email_verified?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_user_info_endpoint_user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "supertokens_tenant_thirdparty_providers" */
export type Supertokens_Tenant_Thirdparty_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Tenant_Thirdparty_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Tenant_Thirdparty_Providers_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  authorization_endpoint?: InputMaybe<Scalars['String']['input']>;
  authorization_endpoint_query_params?: InputMaybe<Scalars['String']['input']>;
  connection_uri_domain?: InputMaybe<Scalars['String']['input']>;
  jwks_uri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oidc_discovery_endpoint?: InputMaybe<Scalars['String']['input']>;
  require_email?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
  token_endpoint?: InputMaybe<Scalars['String']['input']>;
  token_endpoint_body_params?: InputMaybe<Scalars['String']['input']>;
  user_info_endpoint?: InputMaybe<Scalars['String']['input']>;
  user_info_endpoint_headers?: InputMaybe<Scalars['String']['input']>;
  user_info_endpoint_query_params?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_id_token_payload_email?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_id_token_payload_email_verified?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_id_token_payload_user_id?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_user_info_endpoint_email?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_user_info_endpoint_email_verified?: InputMaybe<Scalars['String']['input']>;
  user_info_map_from_user_info_endpoint_user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "supertokens.tenant_thirdparty_providers" */
export enum Supertokens_Tenant_Thirdparty_Providers_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  AuthorizationEndpoint = 'authorization_endpoint',
  /** column name */
  AuthorizationEndpointQueryParams = 'authorization_endpoint_query_params',
  /** column name */
  ConnectionUriDomain = 'connection_uri_domain',
  /** column name */
  JwksUri = 'jwks_uri',
  /** column name */
  Name = 'name',
  /** column name */
  OidcDiscoveryEndpoint = 'oidc_discovery_endpoint',
  /** column name */
  RequireEmail = 'require_email',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPartyId = 'third_party_id',
  /** column name */
  TokenEndpoint = 'token_endpoint',
  /** column name */
  TokenEndpointBodyParams = 'token_endpoint_body_params',
  /** column name */
  UserInfoEndpoint = 'user_info_endpoint',
  /** column name */
  UserInfoEndpointHeaders = 'user_info_endpoint_headers',
  /** column name */
  UserInfoEndpointQueryParams = 'user_info_endpoint_query_params',
  /** column name */
  UserInfoMapFromIdTokenPayloadEmail = 'user_info_map_from_id_token_payload_email',
  /** column name */
  UserInfoMapFromIdTokenPayloadEmailVerified = 'user_info_map_from_id_token_payload_email_verified',
  /** column name */
  UserInfoMapFromIdTokenPayloadUserId = 'user_info_map_from_id_token_payload_user_id',
  /** column name */
  UserInfoMapFromUserInfoEndpointEmail = 'user_info_map_from_user_info_endpoint_email',
  /** column name */
  UserInfoMapFromUserInfoEndpointEmailVerified = 'user_info_map_from_user_info_endpoint_email_verified',
  /** column name */
  UserInfoMapFromUserInfoEndpointUserId = 'user_info_map_from_user_info_endpoint_user_id'
}

export type Supertokens_Tenant_Thirdparty_Providers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Tenant_Thirdparty_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Tenant_Thirdparty_Providers_Bool_Exp;
};

/** columns and relationships of "supertokens.tenants" */
export type Supertokens_Tenants = {
  __typename?: 'supertokens_tenants';
  /** An array relationship */
  all_auth_recipe_users: Array<Supertokens_All_Auth_Recipe_Users>;
  /** An aggregate relationship */
  all_auth_recipe_users_aggregate: Supertokens_All_Auth_Recipe_Users_Aggregate;
  /** An object relationship */
  app: Supertokens_Apps;
  app_id: Scalars['String']['output'];
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  emailverification_tokens: Array<Supertokens_Emailverification_Tokens>;
  /** An aggregate relationship */
  emailverification_tokens_aggregate: Supertokens_Emailverification_Tokens_Aggregate;
  /** An array relationship */
  key_values: Array<Supertokens_Key_Value>;
  /** An aggregate relationship */
  key_values_aggregate: Supertokens_Key_Value_Aggregate;
  /** An array relationship */
  passwordless_devices: Array<Supertokens_Passwordless_Devices>;
  /** An aggregate relationship */
  passwordless_devices_aggregate: Supertokens_Passwordless_Devices_Aggregate;
  /** An array relationship */
  session_infos: Array<Supertokens_Session_Info>;
  /** An aggregate relationship */
  session_infos_aggregate: Supertokens_Session_Info_Aggregate;
  tenant_id: Scalars['String']['output'];
  /** An array relationship */
  user_roles: Array<Supertokens_User_Roles>;
  /** An aggregate relationship */
  user_roles_aggregate: Supertokens_User_Roles_Aggregate;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsAll_Auth_Recipe_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Order_By>>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsAll_Auth_Recipe_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_All_Auth_Recipe_Users_Order_By>>;
  where?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsEmailverification_TokensArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsEmailverification_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Emailverification_Tokens_Order_By>>;
  where?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsKey_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Key_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Key_Value_Order_By>>;
  where?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsKey_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Key_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Key_Value_Order_By>>;
  where?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsPasswordless_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Devices_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsPasswordless_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Passwordless_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Passwordless_Devices_Order_By>>;
  where?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsSession_InfosArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Info_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsSession_Infos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_Session_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_Session_Info_Order_By>>;
  where?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};


/** columns and relationships of "supertokens.tenants" */
export type Supertokens_TenantsUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supertokens_User_Roles_Order_By>>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};

/** aggregated selection of "supertokens.tenants" */
export type Supertokens_Tenants_Aggregate = {
  __typename?: 'supertokens_tenants_aggregate';
  aggregate?: Maybe<Supertokens_Tenants_Aggregate_Fields>;
  nodes: Array<Supertokens_Tenants>;
};

export type Supertokens_Tenants_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Tenants_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Tenants_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Tenants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.tenants" */
export type Supertokens_Tenants_Aggregate_Fields = {
  __typename?: 'supertokens_tenants_aggregate_fields';
  avg?: Maybe<Supertokens_Tenants_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Tenants_Max_Fields>;
  min?: Maybe<Supertokens_Tenants_Min_Fields>;
  stddev?: Maybe<Supertokens_Tenants_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Tenants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Tenants_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Tenants_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Tenants_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Tenants_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Tenants_Variance_Fields>;
};


/** aggregate fields of "supertokens.tenants" */
export type Supertokens_Tenants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Tenants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.tenants" */
export type Supertokens_Tenants_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_Tenants_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Tenants_Max_Order_By>;
  min?: InputMaybe<Supertokens_Tenants_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_Tenants_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_Tenants_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_Tenants_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_Tenants_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_Tenants_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_Tenants_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_Tenants_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.tenants" */
export type Supertokens_Tenants_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Tenants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Tenants_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_Tenants_Avg_Fields = {
  __typename?: 'supertokens_tenants_avg_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Avg_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.tenants". All fields are combined with a logical 'AND'. */
export type Supertokens_Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Tenants_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Tenants_Bool_Exp>>;
  all_auth_recipe_users?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  all_auth_recipe_users_aggregate?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Aggregate_Bool_Exp>;
  app?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  created_at_time?: InputMaybe<Bigint_Comparison_Exp>;
  emailverification_tokens?: InputMaybe<Supertokens_Emailverification_Tokens_Bool_Exp>;
  emailverification_tokens_aggregate?: InputMaybe<Supertokens_Emailverification_Tokens_Aggregate_Bool_Exp>;
  key_values?: InputMaybe<Supertokens_Key_Value_Bool_Exp>;
  key_values_aggregate?: InputMaybe<Supertokens_Key_Value_Aggregate_Bool_Exp>;
  passwordless_devices?: InputMaybe<Supertokens_Passwordless_Devices_Bool_Exp>;
  passwordless_devices_aggregate?: InputMaybe<Supertokens_Passwordless_Devices_Aggregate_Bool_Exp>;
  session_infos?: InputMaybe<Supertokens_Session_Info_Bool_Exp>;
  session_infos_aggregate?: InputMaybe<Supertokens_Session_Info_Aggregate_Bool_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  user_roles?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
  user_roles_aggregate?: InputMaybe<Supertokens_User_Roles_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "supertokens.tenants" */
export enum Supertokens_Tenants_Constraint {
  /** unique or primary key constraint on columns "app_id", "tenant_id" */
  TenantsPkey = 'tenants_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.tenants" */
export type Supertokens_Tenants_Inc_Input = {
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.tenants" */
export type Supertokens_Tenants_Insert_Input = {
  all_auth_recipe_users?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Arr_Rel_Insert_Input>;
  app?: InputMaybe<Supertokens_Apps_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  emailverification_tokens?: InputMaybe<Supertokens_Emailverification_Tokens_Arr_Rel_Insert_Input>;
  key_values?: InputMaybe<Supertokens_Key_Value_Arr_Rel_Insert_Input>;
  passwordless_devices?: InputMaybe<Supertokens_Passwordless_Devices_Arr_Rel_Insert_Input>;
  session_infos?: InputMaybe<Supertokens_Session_Info_Arr_Rel_Insert_Input>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_roles?: InputMaybe<Supertokens_User_Roles_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Supertokens_Tenants_Max_Fields = {
  __typename?: 'supertokens_tenants_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Tenants_Min_Fields = {
  __typename?: 'supertokens_tenants_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at_time?: Maybe<Scalars['bigint']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.tenants" */
export type Supertokens_Tenants_Mutation_Response = {
  __typename?: 'supertokens_tenants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Tenants>;
};

/** input type for inserting object relation for remote table "supertokens.tenants" */
export type Supertokens_Tenants_Obj_Rel_Insert_Input = {
  data: Supertokens_Tenants_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Tenants_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.tenants" */
export type Supertokens_Tenants_On_Conflict = {
  constraint: Supertokens_Tenants_Constraint;
  update_columns?: Array<Supertokens_Tenants_Update_Column>;
  where?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.tenants". */
export type Supertokens_Tenants_Order_By = {
  all_auth_recipe_users_aggregate?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Aggregate_Order_By>;
  app?: InputMaybe<Supertokens_Apps_Order_By>;
  app_id?: InputMaybe<Order_By>;
  created_at_time?: InputMaybe<Order_By>;
  emailverification_tokens_aggregate?: InputMaybe<Supertokens_Emailverification_Tokens_Aggregate_Order_By>;
  key_values_aggregate?: InputMaybe<Supertokens_Key_Value_Aggregate_Order_By>;
  passwordless_devices_aggregate?: InputMaybe<Supertokens_Passwordless_Devices_Aggregate_Order_By>;
  session_infos_aggregate?: InputMaybe<Supertokens_Session_Info_Aggregate_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_roles_aggregate?: InputMaybe<Supertokens_User_Roles_Aggregate_Order_By>;
};

/** primary key columns input for table: supertokens.tenants */
export type Supertokens_Tenants_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.tenants" */
export enum Supertokens_Tenants_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time',
  /** column name */
  TenantId = 'tenant_id'
}

/** input type for updating data in table "supertokens.tenants" */
export type Supertokens_Tenants_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Tenants_Stddev_Fields = {
  __typename?: 'supertokens_tenants_stddev_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Stddev_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Tenants_Stddev_Pop_Fields = {
  __typename?: 'supertokens_tenants_stddev_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Stddev_Pop_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Tenants_Stddev_Samp_Fields = {
  __typename?: 'supertokens_tenants_stddev_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Stddev_Samp_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_tenants" */
export type Supertokens_Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Tenants_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  created_at_time?: InputMaybe<Scalars['bigint']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Tenants_Sum_Fields = {
  __typename?: 'supertokens_tenants_sum_fields';
  created_at_time?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Sum_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.tenants" */
export enum Supertokens_Tenants_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  CreatedAtTime = 'created_at_time',
  /** column name */
  TenantId = 'tenant_id'
}

export type Supertokens_Tenants_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Tenants_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Tenants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Tenants_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Tenants_Var_Pop_Fields = {
  __typename?: 'supertokens_tenants_var_pop_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Var_Pop_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_Tenants_Var_Samp_Fields = {
  __typename?: 'supertokens_tenants_var_samp_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Var_Samp_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_Tenants_Variance_Fields = {
  __typename?: 'supertokens_tenants_variance_fields';
  created_at_time?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.tenants" */
export type Supertokens_Tenants_Variance_Order_By = {
  created_at_time?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant = {
  __typename?: 'supertokens_thirdparty_user_to_tenant';
  /** An object relationship */
  all_auth_recipe_user?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  app_id: Scalars['String']['output'];
  tenant_id: Scalars['String']['output'];
  third_party_id: Scalars['String']['output'];
  third_party_user_id: Scalars['String']['output'];
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "supertokens.thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant_Aggregate = {
  __typename?: 'supertokens_thirdparty_user_to_tenant_aggregate';
  aggregate?: Maybe<Supertokens_Thirdparty_User_To_Tenant_Aggregate_Fields>;
  nodes: Array<Supertokens_Thirdparty_User_To_Tenant>;
};

/** aggregate fields of "supertokens.thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant_Aggregate_Fields = {
  __typename?: 'supertokens_thirdparty_user_to_tenant_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Thirdparty_User_To_Tenant_Max_Fields>;
  min?: Maybe<Supertokens_Thirdparty_User_To_Tenant_Min_Fields>;
};


/** aggregate fields of "supertokens.thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "supertokens.thirdparty_user_to_tenant". All fields are combined with a logical 'AND'. */
export type Supertokens_Thirdparty_User_To_Tenant_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  third_party_id?: InputMaybe<String_Comparison_Exp>;
  third_party_user_id?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.thirdparty_user_to_tenant" */
export enum Supertokens_Thirdparty_User_To_Tenant_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id", "tenant_id" */
  ThirdpartyUserToTenantPkey = 'thirdparty_user_to_tenant_pkey',
  /** unique or primary key constraint on columns "app_id", "third_party_id", "third_party_user_id", "tenant_id" */
  ThirdpartyUserToTenantThirdPartyUserIdKey = 'thirdparty_user_to_tenant_third_party_user_id_key'
}

/** input type for inserting data into table "supertokens.thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
  third_party_user_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Thirdparty_User_To_Tenant_Max_Fields = {
  __typename?: 'supertokens_thirdparty_user_to_tenant_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  third_party_id?: Maybe<Scalars['String']['output']>;
  third_party_user_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Supertokens_Thirdparty_User_To_Tenant_Min_Fields = {
  __typename?: 'supertokens_thirdparty_user_to_tenant_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  third_party_id?: Maybe<Scalars['String']['output']>;
  third_party_user_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "supertokens.thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant_Mutation_Response = {
  __typename?: 'supertokens_thirdparty_user_to_tenant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Thirdparty_User_To_Tenant>;
};

/** input type for inserting object relation for remote table "supertokens.thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant_Obj_Rel_Insert_Input = {
  data: Supertokens_Thirdparty_User_To_Tenant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant_On_Conflict = {
  constraint: Supertokens_Thirdparty_User_To_Tenant_Constraint;
  update_columns?: Array<Supertokens_Thirdparty_User_To_Tenant_Update_Column>;
  where?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.thirdparty_user_to_tenant". */
export type Supertokens_Thirdparty_User_To_Tenant_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  app_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_party_id?: InputMaybe<Order_By>;
  third_party_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.thirdparty_user_to_tenant */
export type Supertokens_Thirdparty_User_To_Tenant_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.thirdparty_user_to_tenant" */
export enum Supertokens_Thirdparty_User_To_Tenant_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPartyId = 'third_party_id',
  /** column name */
  ThirdPartyUserId = 'third_party_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
  third_party_user_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "supertokens_thirdparty_user_to_tenant" */
export type Supertokens_Thirdparty_User_To_Tenant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Thirdparty_User_To_Tenant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Thirdparty_User_To_Tenant_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
  third_party_user_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "supertokens.thirdparty_user_to_tenant" */
export enum Supertokens_Thirdparty_User_To_Tenant_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPartyId = 'third_party_id',
  /** column name */
  ThirdPartyUserId = 'third_party_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Thirdparty_User_To_Tenant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Thirdparty_User_To_Tenant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Thirdparty_User_To_Tenant_Bool_Exp;
};

/** columns and relationships of "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users = {
  __typename?: 'supertokens_thirdparty_users';
  app_id: Scalars['String']['output'];
  /** An object relationship */
  app_id_to_user_id?: Maybe<Supertokens_App_Id_To_User_Id>;
  email: Scalars['String']['output'];
  third_party_id: Scalars['String']['output'];
  third_party_user_id: Scalars['String']['output'];
  time_joined: Scalars['bigint']['output'];
  user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users_Aggregate = {
  __typename?: 'supertokens_thirdparty_users_aggregate';
  aggregate?: Maybe<Supertokens_Thirdparty_Users_Aggregate_Fields>;
  nodes: Array<Supertokens_Thirdparty_Users>;
};

/** aggregate fields of "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users_Aggregate_Fields = {
  __typename?: 'supertokens_thirdparty_users_aggregate_fields';
  avg?: Maybe<Supertokens_Thirdparty_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Thirdparty_Users_Max_Fields>;
  min?: Maybe<Supertokens_Thirdparty_Users_Min_Fields>;
  stddev?: Maybe<Supertokens_Thirdparty_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_Thirdparty_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_Thirdparty_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_Thirdparty_Users_Sum_Fields>;
  var_pop?: Maybe<Supertokens_Thirdparty_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_Thirdparty_Users_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_Thirdparty_Users_Variance_Fields>;
};


/** aggregate fields of "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Thirdparty_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Supertokens_Thirdparty_Users_Avg_Fields = {
  __typename?: 'supertokens_thirdparty_users_avg_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "supertokens.thirdparty_users". All fields are combined with a logical 'AND'. */
export type Supertokens_Thirdparty_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Thirdparty_Users_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Thirdparty_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Thirdparty_Users_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  third_party_id?: InputMaybe<String_Comparison_Exp>;
  third_party_user_id?: InputMaybe<String_Comparison_Exp>;
  time_joined?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.thirdparty_users" */
export enum Supertokens_Thirdparty_Users_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id" */
  ThirdpartyUsersPkey = 'thirdparty_users_pkey',
  /** unique or primary key constraint on columns "user_id" */
  ThirdpartyUsersUserIdKey = 'thirdparty_users_user_id_key'
}

/** input type for incrementing numeric columns in table "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users_Inc_Input = {
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Obj_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
  third_party_user_id?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Thirdparty_Users_Max_Fields = {
  __typename?: 'supertokens_thirdparty_users_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  third_party_id?: Maybe<Scalars['String']['output']>;
  third_party_user_id?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregate min on columns */
export type Supertokens_Thirdparty_Users_Min_Fields = {
  __typename?: 'supertokens_thirdparty_users_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  third_party_id?: Maybe<Scalars['String']['output']>;
  third_party_user_id?: Maybe<Scalars['String']['output']>;
  time_joined?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** response of any mutation on the table "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users_Mutation_Response = {
  __typename?: 'supertokens_thirdparty_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Thirdparty_Users>;
};

/** input type for inserting object relation for remote table "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users_Obj_Rel_Insert_Input = {
  data: Supertokens_Thirdparty_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Thirdparty_Users_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users_On_Conflict = {
  constraint: Supertokens_Thirdparty_Users_Constraint;
  update_columns?: Array<Supertokens_Thirdparty_Users_Update_Column>;
  where?: InputMaybe<Supertokens_Thirdparty_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.thirdparty_users". */
export type Supertokens_Thirdparty_Users_Order_By = {
  app_id?: InputMaybe<Order_By>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Order_By>;
  email?: InputMaybe<Order_By>;
  third_party_id?: InputMaybe<Order_By>;
  third_party_user_id?: InputMaybe<Order_By>;
  time_joined?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.thirdparty_users */
export type Supertokens_Thirdparty_Users_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.thirdparty_users" */
export enum Supertokens_Thirdparty_Users_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  ThirdPartyId = 'third_party_id',
  /** column name */
  ThirdPartyUserId = 'third_party_user_id',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.thirdparty_users" */
export type Supertokens_Thirdparty_Users_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
  third_party_user_id?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_Thirdparty_Users_Stddev_Fields = {
  __typename?: 'supertokens_thirdparty_users_stddev_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_Thirdparty_Users_Stddev_Pop_Fields = {
  __typename?: 'supertokens_thirdparty_users_stddev_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_Thirdparty_Users_Stddev_Samp_Fields = {
  __typename?: 'supertokens_thirdparty_users_stddev_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "supertokens_thirdparty_users" */
export type Supertokens_Thirdparty_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Thirdparty_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Thirdparty_Users_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  third_party_id?: InputMaybe<Scalars['String']['input']>;
  third_party_user_id?: InputMaybe<Scalars['String']['input']>;
  time_joined?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_Thirdparty_Users_Sum_Fields = {
  __typename?: 'supertokens_thirdparty_users_sum_fields';
  time_joined?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "supertokens.thirdparty_users" */
export enum Supertokens_Thirdparty_Users_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Email = 'email',
  /** column name */
  ThirdPartyId = 'third_party_id',
  /** column name */
  ThirdPartyUserId = 'third_party_user_id',
  /** column name */
  TimeJoined = 'time_joined',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_Thirdparty_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_Thirdparty_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Thirdparty_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Thirdparty_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_Thirdparty_Users_Var_Pop_Fields = {
  __typename?: 'supertokens_thirdparty_users_var_pop_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Supertokens_Thirdparty_Users_Var_Samp_Fields = {
  __typename?: 'supertokens_thirdparty_users_var_samp_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Supertokens_Thirdparty_Users_Variance_Fields = {
  __typename?: 'supertokens_thirdparty_users_variance_fields';
  time_joined?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields = {
  __typename?: 'supertokens_user_additional_fields';
  age?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  all_auth_recipe_user?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  avatar?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  chat_channels: Array<Channel_Members>;
  /** An aggregate relationship */
  chat_channels_aggregate: Channel_Members_Aggregate;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  date_of_birth?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  emailVerified?: Maybe<Supertokens_Emailverification_Verified_Emails>;
  email_verified: Scalars['Boolean']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_visually_impaired: Scalars['Boolean']['output'];
  keyword?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  last_active?: Maybe<Supertokens_User_Last_Active>;
  last_name?: Maybe<Scalars['String']['output']>;
  lead_squared_id?: Maybe<Scalars['String']['output']>;
  lead_squared_is_created?: Maybe<Scalars['Boolean']['output']>;
  lead_squared_related_id?: Maybe<Scalars['String']['output']>;
  matchtype?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  mobile_verified: Scalars['Boolean']['output'];
  old_password_hash?: Maybe<Scalars['String']['output']>;
  old_user_id?: Maybe<Scalars['Int']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  otp_expiry?: Maybe<Scalars['timestamptz']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  thirdparty_users?: Maybe<Supertokens_Thirdparty_Users>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  userRole?: Maybe<Supertokens_User_Roles>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_FieldsChat_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Channel_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Members_Order_By>>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};


/** columns and relationships of "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_FieldsChat_Channels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Channel_Members_Order_By>>;
  where?: InputMaybe<Channel_Members_Bool_Exp>;
};

/** aggregated selection of "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Aggregate = {
  __typename?: 'supertokens_user_additional_fields_aggregate';
  aggregate?: Maybe<Supertokens_User_Additional_Fields_Aggregate_Fields>;
  nodes: Array<Supertokens_User_Additional_Fields>;
};

export type Supertokens_User_Additional_Fields_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Bool_And = {
  arguments: Supertokens_User_Additional_Fields_Select_Column_Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Supertokens_User_Additional_Fields_Select_Column_Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_User_Additional_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Aggregate_Fields = {
  __typename?: 'supertokens_user_additional_fields_aggregate_fields';
  avg?: Maybe<Supertokens_User_Additional_Fields_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_User_Additional_Fields_Max_Fields>;
  min?: Maybe<Supertokens_User_Additional_Fields_Min_Fields>;
  stddev?: Maybe<Supertokens_User_Additional_Fields_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_User_Additional_Fields_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_User_Additional_Fields_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_User_Additional_Fields_Sum_Fields>;
  var_pop?: Maybe<Supertokens_User_Additional_Fields_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_User_Additional_Fields_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_User_Additional_Fields_Variance_Fields>;
};


/** aggregate fields of "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_User_Additional_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_User_Additional_Fields_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_User_Additional_Fields_Max_Order_By>;
  min?: InputMaybe<Supertokens_User_Additional_Fields_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_User_Additional_Fields_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_User_Additional_Fields_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_User_Additional_Fields_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_User_Additional_Fields_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_User_Additional_Fields_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_User_Additional_Fields_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_User_Additional_Fields_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_User_Additional_Fields_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_User_Additional_Fields_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_User_Additional_Fields_Avg_Fields = {
  __typename?: 'supertokens_user_additional_fields_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_user_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.user_additional_fields". All fields are combined with a logical 'AND'. */
export type Supertokens_User_Additional_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_User_Additional_Fields_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_User_Additional_Fields_Bool_Exp>>;
  age?: InputMaybe<String_Comparison_Exp>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  chat_channels?: InputMaybe<Channel_Members_Bool_Exp>;
  chat_channels_aggregate?: InputMaybe<Channel_Members_Aggregate_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<String_Comparison_Exp>;
  device?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  emailVerified?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Bool_Exp>;
  email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_visually_impaired?: InputMaybe<Boolean_Comparison_Exp>;
  keyword?: InputMaybe<String_Comparison_Exp>;
  last_active?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  lead_squared_id?: InputMaybe<String_Comparison_Exp>;
  lead_squared_is_created?: InputMaybe<Boolean_Comparison_Exp>;
  lead_squared_related_id?: InputMaybe<String_Comparison_Exp>;
  matchtype?: InputMaybe<String_Comparison_Exp>;
  mobile?: InputMaybe<String_Comparison_Exp>;
  mobile_verified?: InputMaybe<Boolean_Comparison_Exp>;
  old_password_hash?: InputMaybe<String_Comparison_Exp>;
  old_user_id?: InputMaybe<Int_Comparison_Exp>;
  otp?: InputMaybe<String_Comparison_Exp>;
  otp_expiry?: InputMaybe<Timestamptz_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  thirdparty_users?: InputMaybe<Supertokens_Thirdparty_Users_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userRole?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  utm_campaign?: InputMaybe<String_Comparison_Exp>;
  utm_content?: InputMaybe<String_Comparison_Exp>;
  utm_medium?: InputMaybe<String_Comparison_Exp>;
  utm_source?: InputMaybe<String_Comparison_Exp>;
  xp?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.user_additional_fields" */
export enum Supertokens_User_Additional_Fields_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserAdditionalFieldsEmailKey = 'user_additional_fields_email_key',
  /** unique or primary key constraint on columns "id" */
  UserAdditionalFieldsPkey = 'user_additional_fields_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserAdditionalFieldsUserIdKey = 'user_additional_fields_user_id_key'
}

/** input type for incrementing numeric columns in table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  old_user_id?: InputMaybe<Scalars['Int']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Insert_Input = {
  age?: InputMaybe<Scalars['String']['input']>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  chat_channels?: InputMaybe<Channel_Members_Arr_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Obj_Rel_Insert_Input>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_visually_impaired?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last_active?: InputMaybe<Supertokens_User_Last_Active_Obj_Rel_Insert_Input>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_squared_id?: InputMaybe<Scalars['String']['input']>;
  lead_squared_is_created?: InputMaybe<Scalars['Boolean']['input']>;
  lead_squared_related_id?: InputMaybe<Scalars['String']['input']>;
  matchtype?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  mobile_verified?: InputMaybe<Scalars['Boolean']['input']>;
  old_password_hash?: InputMaybe<Scalars['String']['input']>;
  old_user_id?: InputMaybe<Scalars['Int']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otp_expiry?: InputMaybe<Scalars['timestamptz']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  thirdparty_users?: InputMaybe<Supertokens_Thirdparty_Users_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userRole?: InputMaybe<Supertokens_User_Roles_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Supertokens_User_Additional_Fields_Max_Fields = {
  __typename?: 'supertokens_user_additional_fields_max_fields';
  age?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_of_birth?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  lead_squared_id?: Maybe<Scalars['String']['output']>;
  lead_squared_related_id?: Maybe<Scalars['String']['output']>;
  matchtype?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  old_password_hash?: Maybe<Scalars['String']['output']>;
  old_user_id?: Maybe<Scalars['Int']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  otp_expiry?: Maybe<Scalars['timestamptz']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Max_Order_By = {
  age?: InputMaybe<Order_By>;
  avatar?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  device?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyword?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_squared_id?: InputMaybe<Order_By>;
  lead_squared_related_id?: InputMaybe<Order_By>;
  matchtype?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  old_password_hash?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  otp_expiry?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_User_Additional_Fields_Min_Fields = {
  __typename?: 'supertokens_user_additional_fields_min_fields';
  age?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_of_birth?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  lead_squared_id?: Maybe<Scalars['String']['output']>;
  lead_squared_related_id?: Maybe<Scalars['String']['output']>;
  matchtype?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  old_password_hash?: Maybe<Scalars['String']['output']>;
  old_user_id?: Maybe<Scalars['Int']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  otp_expiry?: Maybe<Scalars['timestamptz']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Min_Order_By = {
  age?: InputMaybe<Order_By>;
  avatar?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  device?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyword?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_squared_id?: InputMaybe<Order_By>;
  lead_squared_related_id?: InputMaybe<Order_By>;
  matchtype?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  old_password_hash?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  otp_expiry?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Mutation_Response = {
  __typename?: 'supertokens_user_additional_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_User_Additional_Fields>;
};

/** input type for inserting object relation for remote table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Obj_Rel_Insert_Input = {
  data: Supertokens_User_Additional_Fields_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_User_Additional_Fields_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_On_Conflict = {
  constraint: Supertokens_User_Additional_Fields_Constraint;
  update_columns?: Array<Supertokens_User_Additional_Fields_Update_Column>;
  where?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.user_additional_fields". */
export type Supertokens_User_Additional_Fields_Order_By = {
  age?: InputMaybe<Order_By>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  avatar?: InputMaybe<Order_By>;
  chat_channels_aggregate?: InputMaybe<Channel_Members_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  device?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailVerified?: InputMaybe<Supertokens_Emailverification_Verified_Emails_Order_By>;
  email_verified?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_visually_impaired?: InputMaybe<Order_By>;
  keyword?: InputMaybe<Order_By>;
  last_active?: InputMaybe<Supertokens_User_Last_Active_Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_squared_id?: InputMaybe<Order_By>;
  lead_squared_is_created?: InputMaybe<Order_By>;
  lead_squared_related_id?: InputMaybe<Order_By>;
  matchtype?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  mobile_verified?: InputMaybe<Order_By>;
  old_password_hash?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  otp_expiry?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  thirdparty_users?: InputMaybe<Supertokens_Thirdparty_Users_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userRole?: InputMaybe<Supertokens_User_Roles_Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.user_additional_fields */
export type Supertokens_User_Additional_Fields_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "supertokens.user_additional_fields" */
export enum Supertokens_User_Additional_Fields_Select_Column {
  /** column name */
  Age = 'age',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Device = 'device',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsVisuallyImpaired = 'is_visually_impaired',
  /** column name */
  Keyword = 'keyword',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LeadSquaredId = 'lead_squared_id',
  /** column name */
  LeadSquaredIsCreated = 'lead_squared_is_created',
  /** column name */
  LeadSquaredRelatedId = 'lead_squared_related_id',
  /** column name */
  Matchtype = 'matchtype',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  MobileVerified = 'mobile_verified',
  /** column name */
  OldPasswordHash = 'old_password_hash',
  /** column name */
  OldUserId = 'old_user_id',
  /** column name */
  Otp = 'otp',
  /** column name */
  OtpExpiry = 'otp_expiry',
  /** column name */
  Password = 'password',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username',
  /** column name */
  UtmCampaign = 'utm_campaign',
  /** column name */
  UtmContent = 'utm_content',
  /** column name */
  UtmMedium = 'utm_medium',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  Xp = 'xp'
}

/** select "supertokens_user_additional_fields_aggregate_bool_exp_bool_and_arguments_columns" columns of table "supertokens.user_additional_fields" */
export enum Supertokens_User_Additional_Fields_Select_Column_Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  IsVisuallyImpaired = 'is_visually_impaired',
  /** column name */
  LeadSquaredIsCreated = 'lead_squared_is_created',
  /** column name */
  MobileVerified = 'mobile_verified'
}

/** select "supertokens_user_additional_fields_aggregate_bool_exp_bool_or_arguments_columns" columns of table "supertokens.user_additional_fields" */
export enum Supertokens_User_Additional_Fields_Select_Column_Supertokens_User_Additional_Fields_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  IsVisuallyImpaired = 'is_visually_impaired',
  /** column name */
  LeadSquaredIsCreated = 'lead_squared_is_created',
  /** column name */
  MobileVerified = 'mobile_verified'
}

/** input type for updating data in table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Set_Input = {
  age?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_visually_impaired?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_squared_id?: InputMaybe<Scalars['String']['input']>;
  lead_squared_is_created?: InputMaybe<Scalars['Boolean']['input']>;
  lead_squared_related_id?: InputMaybe<Scalars['String']['input']>;
  matchtype?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  mobile_verified?: InputMaybe<Scalars['Boolean']['input']>;
  old_password_hash?: InputMaybe<Scalars['String']['input']>;
  old_user_id?: InputMaybe<Scalars['Int']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otp_expiry?: InputMaybe<Scalars['timestamptz']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_User_Additional_Fields_Stddev_Fields = {
  __typename?: 'supertokens_user_additional_fields_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_user_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_User_Additional_Fields_Stddev_Pop_Fields = {
  __typename?: 'supertokens_user_additional_fields_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_user_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_User_Additional_Fields_Stddev_Samp_Fields = {
  __typename?: 'supertokens_user_additional_fields_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_user_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_user_additional_fields" */
export type Supertokens_User_Additional_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_User_Additional_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_User_Additional_Fields_Stream_Cursor_Value_Input = {
  age?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_visually_impaired?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_squared_id?: InputMaybe<Scalars['String']['input']>;
  lead_squared_is_created?: InputMaybe<Scalars['Boolean']['input']>;
  lead_squared_related_id?: InputMaybe<Scalars['String']['input']>;
  matchtype?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  mobile_verified?: InputMaybe<Scalars['Boolean']['input']>;
  old_password_hash?: InputMaybe<Scalars['String']['input']>;
  old_user_id?: InputMaybe<Scalars['Int']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otp_expiry?: InputMaybe<Scalars['timestamptz']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_User_Additional_Fields_Sum_Fields = {
  __typename?: 'supertokens_user_additional_fields_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  old_user_id?: Maybe<Scalars['Int']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.user_additional_fields" */
export enum Supertokens_User_Additional_Fields_Update_Column {
  /** column name */
  Age = 'age',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Device = 'device',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsVisuallyImpaired = 'is_visually_impaired',
  /** column name */
  Keyword = 'keyword',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LeadSquaredId = 'lead_squared_id',
  /** column name */
  LeadSquaredIsCreated = 'lead_squared_is_created',
  /** column name */
  LeadSquaredRelatedId = 'lead_squared_related_id',
  /** column name */
  Matchtype = 'matchtype',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  MobileVerified = 'mobile_verified',
  /** column name */
  OldPasswordHash = 'old_password_hash',
  /** column name */
  OldUserId = 'old_user_id',
  /** column name */
  Otp = 'otp',
  /** column name */
  OtpExpiry = 'otp_expiry',
  /** column name */
  Password = 'password',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username',
  /** column name */
  UtmCampaign = 'utm_campaign',
  /** column name */
  UtmContent = 'utm_content',
  /** column name */
  UtmMedium = 'utm_medium',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  Xp = 'xp'
}

export type Supertokens_User_Additional_Fields_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_User_Additional_Fields_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_User_Additional_Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_User_Additional_Fields_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_User_Additional_Fields_Var_Pop_Fields = {
  __typename?: 'supertokens_user_additional_fields_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_user_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_User_Additional_Fields_Var_Samp_Fields = {
  __typename?: 'supertokens_user_additional_fields_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_user_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_User_Additional_Fields_Variance_Fields = {
  __typename?: 'supertokens_user_additional_fields_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  old_user_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.user_additional_fields" */
export type Supertokens_User_Additional_Fields_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  old_user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.user_last_active" */
export type Supertokens_User_Last_Active = {
  __typename?: 'supertokens_user_last_active';
  /** An object relationship */
  app: Supertokens_Apps;
  app_id: Scalars['String']['output'];
  last_active_time?: Maybe<Scalars['bigint']['output']>;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Aggregate = {
  __typename?: 'supertokens_user_last_active_aggregate';
  aggregate?: Maybe<Supertokens_User_Last_Active_Aggregate_Fields>;
  nodes: Array<Supertokens_User_Last_Active>;
};

export type Supertokens_User_Last_Active_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_User_Last_Active_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_User_Last_Active_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_User_Last_Active_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Aggregate_Fields = {
  __typename?: 'supertokens_user_last_active_aggregate_fields';
  avg?: Maybe<Supertokens_User_Last_Active_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_User_Last_Active_Max_Fields>;
  min?: Maybe<Supertokens_User_Last_Active_Min_Fields>;
  stddev?: Maybe<Supertokens_User_Last_Active_Stddev_Fields>;
  stddev_pop?: Maybe<Supertokens_User_Last_Active_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supertokens_User_Last_Active_Stddev_Samp_Fields>;
  sum?: Maybe<Supertokens_User_Last_Active_Sum_Fields>;
  var_pop?: Maybe<Supertokens_User_Last_Active_Var_Pop_Fields>;
  var_samp?: Maybe<Supertokens_User_Last_Active_Var_Samp_Fields>;
  variance?: Maybe<Supertokens_User_Last_Active_Variance_Fields>;
};


/** aggregate fields of "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_User_Last_Active_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Aggregate_Order_By = {
  avg?: InputMaybe<Supertokens_User_Last_Active_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_User_Last_Active_Max_Order_By>;
  min?: InputMaybe<Supertokens_User_Last_Active_Min_Order_By>;
  stddev?: InputMaybe<Supertokens_User_Last_Active_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supertokens_User_Last_Active_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supertokens_User_Last_Active_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supertokens_User_Last_Active_Sum_Order_By>;
  var_pop?: InputMaybe<Supertokens_User_Last_Active_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supertokens_User_Last_Active_Var_Samp_Order_By>;
  variance?: InputMaybe<Supertokens_User_Last_Active_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_User_Last_Active_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_User_Last_Active_On_Conflict>;
};

/** aggregate avg on columns */
export type Supertokens_User_Last_Active_Avg_Fields = {
  __typename?: 'supertokens_user_last_active_avg_fields';
  last_active_time?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Avg_Order_By = {
  last_active_time?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supertokens.user_last_active". All fields are combined with a logical 'AND'. */
export type Supertokens_User_Last_Active_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_User_Last_Active_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_User_Last_Active_Bool_Exp>>;
  app?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  last_active_time?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.user_last_active" */
export enum Supertokens_User_Last_Active_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id" */
  UserLastActivePkey = 'user_last_active_pkey'
}

/** input type for incrementing numeric columns in table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Inc_Input = {
  last_active_time?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Insert_Input = {
  app?: InputMaybe<Supertokens_Apps_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  last_active_time?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_User_Last_Active_Max_Fields = {
  __typename?: 'supertokens_user_last_active_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  last_active_time?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  last_active_time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_User_Last_Active_Min_Fields = {
  __typename?: 'supertokens_user_last_active_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  last_active_time?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  last_active_time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Mutation_Response = {
  __typename?: 'supertokens_user_last_active_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_User_Last_Active>;
};

/** input type for inserting object relation for remote table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Obj_Rel_Insert_Input = {
  data: Supertokens_User_Last_Active_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_User_Last_Active_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_On_Conflict = {
  constraint: Supertokens_User_Last_Active_Constraint;
  update_columns?: Array<Supertokens_User_Last_Active_Update_Column>;
  where?: InputMaybe<Supertokens_User_Last_Active_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.user_last_active". */
export type Supertokens_User_Last_Active_Order_By = {
  app?: InputMaybe<Supertokens_Apps_Order_By>;
  app_id?: InputMaybe<Order_By>;
  last_active_time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.user_last_active */
export type Supertokens_User_Last_Active_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.user_last_active" */
export enum Supertokens_User_Last_Active_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  LastActiveTime = 'last_active_time',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  last_active_time?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Supertokens_User_Last_Active_Stddev_Fields = {
  __typename?: 'supertokens_user_last_active_stddev_fields';
  last_active_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Stddev_Order_By = {
  last_active_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supertokens_User_Last_Active_Stddev_Pop_Fields = {
  __typename?: 'supertokens_user_last_active_stddev_pop_fields';
  last_active_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Stddev_Pop_Order_By = {
  last_active_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supertokens_User_Last_Active_Stddev_Samp_Fields = {
  __typename?: 'supertokens_user_last_active_stddev_samp_fields';
  last_active_time?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Stddev_Samp_Order_By = {
  last_active_time?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supertokens_user_last_active" */
export type Supertokens_User_Last_Active_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_User_Last_Active_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_User_Last_Active_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  last_active_time?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Supertokens_User_Last_Active_Sum_Fields = {
  __typename?: 'supertokens_user_last_active_sum_fields';
  last_active_time?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Sum_Order_By = {
  last_active_time?: InputMaybe<Order_By>;
};

/** update columns of table "supertokens.user_last_active" */
export enum Supertokens_User_Last_Active_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  LastActiveTime = 'last_active_time',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_User_Last_Active_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supertokens_User_Last_Active_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_User_Last_Active_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_User_Last_Active_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supertokens_User_Last_Active_Var_Pop_Fields = {
  __typename?: 'supertokens_user_last_active_var_pop_fields';
  last_active_time?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Var_Pop_Order_By = {
  last_active_time?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supertokens_User_Last_Active_Var_Samp_Fields = {
  __typename?: 'supertokens_user_last_active_var_samp_fields';
  last_active_time?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Var_Samp_Order_By = {
  last_active_time?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supertokens_User_Last_Active_Variance_Fields = {
  __typename?: 'supertokens_user_last_active_variance_fields';
  last_active_time?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "supertokens.user_last_active" */
export type Supertokens_User_Last_Active_Variance_Order_By = {
  last_active_time?: InputMaybe<Order_By>;
};

/** columns and relationships of "supertokens.user_metadata" */
export type Supertokens_User_Metadata = {
  __typename?: 'supertokens_user_metadata';
  /** An object relationship */
  app: Supertokens_Apps;
  app_id: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  user_metadata: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Aggregate = {
  __typename?: 'supertokens_user_metadata_aggregate';
  aggregate?: Maybe<Supertokens_User_Metadata_Aggregate_Fields>;
  nodes: Array<Supertokens_User_Metadata>;
};

export type Supertokens_User_Metadata_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_User_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_User_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_User_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Aggregate_Fields = {
  __typename?: 'supertokens_user_metadata_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_User_Metadata_Max_Fields>;
  min?: Maybe<Supertokens_User_Metadata_Min_Fields>;
};


/** aggregate fields of "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_User_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_User_Metadata_Max_Order_By>;
  min?: InputMaybe<Supertokens_User_Metadata_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_User_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_User_Metadata_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supertokens.user_metadata". All fields are combined with a logical 'AND'. */
export type Supertokens_User_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_User_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_User_Metadata_Bool_Exp>>;
  app?: InputMaybe<Supertokens_Apps_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_metadata?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.user_metadata" */
export enum Supertokens_User_Metadata_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id" */
  UserMetadataPkey = 'user_metadata_pkey'
}

/** input type for inserting data into table "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Insert_Input = {
  app?: InputMaybe<Supertokens_Apps_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_metadata?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_User_Metadata_Max_Fields = {
  __typename?: 'supertokens_user_metadata_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_metadata?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_metadata?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_User_Metadata_Min_Fields = {
  __typename?: 'supertokens_user_metadata_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_metadata?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_metadata?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Mutation_Response = {
  __typename?: 'supertokens_user_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_User_Metadata>;
};

/** on_conflict condition type for table "supertokens.user_metadata" */
export type Supertokens_User_Metadata_On_Conflict = {
  constraint: Supertokens_User_Metadata_Constraint;
  update_columns?: Array<Supertokens_User_Metadata_Update_Column>;
  where?: InputMaybe<Supertokens_User_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.user_metadata". */
export type Supertokens_User_Metadata_Order_By = {
  app?: InputMaybe<Supertokens_Apps_Order_By>;
  app_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_metadata?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.user_metadata */
export type Supertokens_User_Metadata_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.user_metadata" */
export enum Supertokens_User_Metadata_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserMetadata = 'user_metadata'
}

/** input type for updating data in table "supertokens.user_metadata" */
export type Supertokens_User_Metadata_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_metadata?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "supertokens_user_metadata" */
export type Supertokens_User_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_User_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_User_Metadata_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_metadata?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "supertokens.user_metadata" */
export enum Supertokens_User_Metadata_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserMetadata = 'user_metadata'
}

export type Supertokens_User_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_User_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_User_Metadata_Bool_Exp;
};

/** columns and relationships of "supertokens.user_public_fields" */
export type Supertokens_User_Public_Fields = {
  __typename?: 'supertokens_user_public_fields';
  avatar?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "supertokens.user_public_fields" */
export type Supertokens_User_Public_Fields_Aggregate = {
  __typename?: 'supertokens_user_public_fields_aggregate';
  aggregate?: Maybe<Supertokens_User_Public_Fields_Aggregate_Fields>;
  nodes: Array<Supertokens_User_Public_Fields>;
};

/** aggregate fields of "supertokens.user_public_fields" */
export type Supertokens_User_Public_Fields_Aggregate_Fields = {
  __typename?: 'supertokens_user_public_fields_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_User_Public_Fields_Max_Fields>;
  min?: Maybe<Supertokens_User_Public_Fields_Min_Fields>;
};


/** aggregate fields of "supertokens.user_public_fields" */
export type Supertokens_User_Public_Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_User_Public_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "supertokens.user_public_fields". All fields are combined with a logical 'AND'. */
export type Supertokens_User_Public_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_User_Public_Fields_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_User_Public_Fields_Bool_Exp>>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "supertokens.user_public_fields" */
export type Supertokens_User_Public_Fields_Insert_Input = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_User_Public_Fields_Max_Fields = {
  __typename?: 'supertokens_user_public_fields_max_fields';
  avatar?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Supertokens_User_Public_Fields_Min_Fields = {
  __typename?: 'supertokens_user_public_fields_min_fields';
  avatar?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "supertokens.user_public_fields" */
export type Supertokens_User_Public_Fields_Mutation_Response = {
  __typename?: 'supertokens_user_public_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_User_Public_Fields>;
};

/** input type for inserting object relation for remote table "supertokens.user_public_fields" */
export type Supertokens_User_Public_Fields_Obj_Rel_Insert_Input = {
  data: Supertokens_User_Public_Fields_Insert_Input;
};

/** Ordering options when selecting data from "supertokens.user_public_fields". */
export type Supertokens_User_Public_Fields_Order_By = {
  avatar?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** select columns of table "supertokens.user_public_fields" */
export enum Supertokens_User_Public_Fields_Select_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "supertokens.user_public_fields" */
export type Supertokens_User_Public_Fields_Set_Input = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "supertokens_user_public_fields" */
export type Supertokens_User_Public_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_User_Public_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_User_Public_Fields_Stream_Cursor_Value_Input = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Supertokens_User_Public_Fields_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_User_Public_Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_User_Public_Fields_Bool_Exp;
};

/** columns and relationships of "supertokens.user_roles" */
export type Supertokens_User_Roles = {
  __typename?: 'supertokens_user_roles';
  app_id: Scalars['String']['output'];
  role: Scalars['String']['output'];
  /** An object relationship */
  roleByAppIdRole?: Maybe<Supertokens_Roles>;
  /** An object relationship */
  roleByRole: Supertokens_Roles;
  /** An object relationship */
  tenant?: Maybe<Supertokens_Tenants>;
  tenant_id: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "supertokens.user_roles" */
export type Supertokens_User_Roles_Aggregate = {
  __typename?: 'supertokens_user_roles_aggregate';
  aggregate?: Maybe<Supertokens_User_Roles_Aggregate_Fields>;
  nodes: Array<Supertokens_User_Roles>;
};

export type Supertokens_User_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_User_Roles_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_User_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.user_roles" */
export type Supertokens_User_Roles_Aggregate_Fields = {
  __typename?: 'supertokens_user_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_User_Roles_Max_Fields>;
  min?: Maybe<Supertokens_User_Roles_Min_Fields>;
};


/** aggregate fields of "supertokens.user_roles" */
export type Supertokens_User_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_User_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.user_roles" */
export type Supertokens_User_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_User_Roles_Max_Order_By>;
  min?: InputMaybe<Supertokens_User_Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.user_roles" */
export type Supertokens_User_Roles_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_User_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_User_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supertokens.user_roles". All fields are combined with a logical 'AND'. */
export type Supertokens_User_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_User_Roles_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_User_Roles_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  roleByAppIdRole?: InputMaybe<Supertokens_Roles_Bool_Exp>;
  roleByRole?: InputMaybe<Supertokens_Roles_Bool_Exp>;
  tenant?: InputMaybe<Supertokens_Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.user_roles" */
export enum Supertokens_User_Roles_Constraint {
  /** unique or primary key constraint on columns "app_id", "user_id", "tenant_id", "role" */
  UserRolesPkey = 'user_roles_pkey'
}

/** input type for inserting data into table "supertokens.user_roles" */
export type Supertokens_User_Roles_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleByAppIdRole?: InputMaybe<Supertokens_Roles_Obj_Rel_Insert_Input>;
  roleByRole?: InputMaybe<Supertokens_Roles_Obj_Rel_Insert_Input>;
  tenant?: InputMaybe<Supertokens_Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Supertokens_User_Roles_Max_Fields = {
  __typename?: 'supertokens_user_roles_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "supertokens.user_roles" */
export type Supertokens_User_Roles_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_User_Roles_Min_Fields = {
  __typename?: 'supertokens_user_roles_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "supertokens.user_roles" */
export type Supertokens_User_Roles_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.user_roles" */
export type Supertokens_User_Roles_Mutation_Response = {
  __typename?: 'supertokens_user_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_User_Roles>;
};

/** input type for inserting object relation for remote table "supertokens.user_roles" */
export type Supertokens_User_Roles_Obj_Rel_Insert_Input = {
  data: Supertokens_User_Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_User_Roles_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.user_roles" */
export type Supertokens_User_Roles_On_Conflict = {
  constraint: Supertokens_User_Roles_Constraint;
  update_columns?: Array<Supertokens_User_Roles_Update_Column>;
  where?: InputMaybe<Supertokens_User_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.user_roles". */
export type Supertokens_User_Roles_Order_By = {
  app_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  roleByAppIdRole?: InputMaybe<Supertokens_Roles_Order_By>;
  roleByRole?: InputMaybe<Supertokens_Roles_Order_By>;
  tenant?: InputMaybe<Supertokens_Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.user_roles */
export type Supertokens_User_Roles_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  role: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

/** select columns of table "supertokens.user_roles" */
export enum Supertokens_User_Roles_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Role = 'role',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "supertokens.user_roles" */
export type Supertokens_User_Roles_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "supertokens_user_roles" */
export type Supertokens_User_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_User_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_User_Roles_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "supertokens.user_roles" */
export enum Supertokens_User_Roles_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  Role = 'role',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

export type Supertokens_User_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_User_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_User_Roles_Bool_Exp;
};

/** columns and relationships of "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping = {
  __typename?: 'supertokens_userid_mapping';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  app_id: Scalars['String']['output'];
  /** An object relationship */
  app_id_to_user_id?: Maybe<Supertokens_App_Id_To_User_Id>;
  external_user_id: Scalars['String']['output'];
  external_user_id_info?: Maybe<Scalars['String']['output']>;
  supertokens_user_id: Scalars['bpchar']['output'];
};

/** aggregated selection of "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Aggregate = {
  __typename?: 'supertokens_userid_mapping_aggregate';
  aggregate?: Maybe<Supertokens_Userid_Mapping_Aggregate_Fields>;
  nodes: Array<Supertokens_Userid_Mapping>;
};

export type Supertokens_Userid_Mapping_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supertokens_Userid_Mapping_Aggregate_Bool_Exp_Count>;
};

export type Supertokens_Userid_Mapping_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supertokens_Userid_Mapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Aggregate_Fields = {
  __typename?: 'supertokens_userid_mapping_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Supertokens_Userid_Mapping_Max_Fields>;
  min?: Maybe<Supertokens_Userid_Mapping_Min_Fields>;
};


/** aggregate fields of "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supertokens_Userid_Mapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supertokens_Userid_Mapping_Max_Order_By>;
  min?: InputMaybe<Supertokens_Userid_Mapping_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Arr_Rel_Insert_Input = {
  data: Array<Supertokens_Userid_Mapping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Userid_Mapping_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supertokens.userid_mapping". All fields are combined with a logical 'AND'. */
export type Supertokens_Userid_Mapping_Bool_Exp = {
  _and?: InputMaybe<Array<Supertokens_Userid_Mapping_Bool_Exp>>;
  _not?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
  _or?: InputMaybe<Array<Supertokens_Userid_Mapping_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Bool_Exp>;
  external_user_id?: InputMaybe<String_Comparison_Exp>;
  external_user_id_info?: InputMaybe<String_Comparison_Exp>;
  supertokens_user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "supertokens.userid_mapping" */
export enum Supertokens_Userid_Mapping_Constraint {
  /** unique or primary key constraint on columns "app_id", "external_user_id" */
  UseridMappingExternalUserIdKey = 'userid_mapping_external_user_id_key',
  /** unique or primary key constraint on columns "supertokens_user_id", "app_id", "external_user_id" */
  UseridMappingPkey = 'userid_mapping_pkey',
  /** unique or primary key constraint on columns "supertokens_user_id", "app_id" */
  UseridMappingSupertokensUserIdKey = 'userid_mapping_supertokens_user_id_key'
}

/** input type for inserting data into table "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Obj_Rel_Insert_Input>;
  external_user_id?: InputMaybe<Scalars['String']['input']>;
  external_user_id_info?: InputMaybe<Scalars['String']['input']>;
  supertokens_user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate max on columns */
export type Supertokens_Userid_Mapping_Max_Fields = {
  __typename?: 'supertokens_userid_mapping_max_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  external_user_id?: Maybe<Scalars['String']['output']>;
  external_user_id_info?: Maybe<Scalars['String']['output']>;
  supertokens_user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  external_user_id?: InputMaybe<Order_By>;
  external_user_id_info?: InputMaybe<Order_By>;
  supertokens_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supertokens_Userid_Mapping_Min_Fields = {
  __typename?: 'supertokens_userid_mapping_min_fields';
  app_id?: Maybe<Scalars['String']['output']>;
  external_user_id?: Maybe<Scalars['String']['output']>;
  external_user_id_info?: Maybe<Scalars['String']['output']>;
  supertokens_user_id?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  external_user_id?: InputMaybe<Order_By>;
  external_user_id_info?: InputMaybe<Order_By>;
  supertokens_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Mutation_Response = {
  __typename?: 'supertokens_userid_mapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Supertokens_Userid_Mapping>;
};

/** input type for inserting object relation for remote table "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Obj_Rel_Insert_Input = {
  data: Supertokens_Userid_Mapping_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supertokens_Userid_Mapping_On_Conflict>;
};

/** on_conflict condition type for table "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_On_Conflict = {
  constraint: Supertokens_Userid_Mapping_Constraint;
  update_columns?: Array<Supertokens_Userid_Mapping_Update_Column>;
  where?: InputMaybe<Supertokens_Userid_Mapping_Bool_Exp>;
};

/** Ordering options when selecting data from "supertokens.userid_mapping". */
export type Supertokens_Userid_Mapping_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  app_id?: InputMaybe<Order_By>;
  app_id_to_user_id?: InputMaybe<Supertokens_App_Id_To_User_Id_Order_By>;
  external_user_id?: InputMaybe<Order_By>;
  external_user_id_info?: InputMaybe<Order_By>;
  supertokens_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supertokens.userid_mapping */
export type Supertokens_Userid_Mapping_Pk_Columns_Input = {
  app_id: Scalars['String']['input'];
  external_user_id: Scalars['String']['input'];
  supertokens_user_id: Scalars['bpchar']['input'];
};

/** select columns of table "supertokens.userid_mapping" */
export enum Supertokens_Userid_Mapping_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  ExternalUserId = 'external_user_id',
  /** column name */
  ExternalUserIdInfo = 'external_user_id_info',
  /** column name */
  SupertokensUserId = 'supertokens_user_id'
}

/** input type for updating data in table "supertokens.userid_mapping" */
export type Supertokens_Userid_Mapping_Set_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  external_user_id?: InputMaybe<Scalars['String']['input']>;
  external_user_id_info?: InputMaybe<Scalars['String']['input']>;
  supertokens_user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** Streaming cursor of the table "supertokens_userid_mapping" */
export type Supertokens_Userid_Mapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supertokens_Userid_Mapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supertokens_Userid_Mapping_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  external_user_id?: InputMaybe<Scalars['String']['input']>;
  external_user_id_info?: InputMaybe<Scalars['String']['input']>;
  supertokens_user_id?: InputMaybe<Scalars['bpchar']['input']>;
};

/** update columns of table "supertokens.userid_mapping" */
export enum Supertokens_Userid_Mapping_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  ExternalUserId = 'external_user_id',
  /** column name */
  ExternalUserIdInfo = 'external_user_id_info',
  /** column name */
  SupertokensUserId = 'supertokens_user_id'
}

export type Supertokens_Userid_Mapping_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supertokens_Userid_Mapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supertokens_Userid_Mapping_Bool_Exp;
};

/** columns and relationships of "taggit_tag" */
export type Taggit_Tag = {
  __typename?: 'taggit_tag';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** An array relationship */
  taggit_taggeditems: Array<Taggit_Taggeditem>;
  /** An aggregate relationship */
  taggit_taggeditems_aggregate: Taggit_Taggeditem_Aggregate;
};


/** columns and relationships of "taggit_tag" */
export type Taggit_TagTaggit_TaggeditemsArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Taggeditem_Order_By>>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};


/** columns and relationships of "taggit_tag" */
export type Taggit_TagTaggit_Taggeditems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taggit_Taggeditem_Order_By>>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};

/** aggregated selection of "taggit_tag" */
export type Taggit_Tag_Aggregate = {
  __typename?: 'taggit_tag_aggregate';
  aggregate?: Maybe<Taggit_Tag_Aggregate_Fields>;
  nodes: Array<Taggit_Tag>;
};

/** aggregate fields of "taggit_tag" */
export type Taggit_Tag_Aggregate_Fields = {
  __typename?: 'taggit_tag_aggregate_fields';
  avg?: Maybe<Taggit_Tag_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Taggit_Tag_Max_Fields>;
  min?: Maybe<Taggit_Tag_Min_Fields>;
  stddev?: Maybe<Taggit_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Taggit_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Taggit_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Taggit_Tag_Sum_Fields>;
  var_pop?: Maybe<Taggit_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Taggit_Tag_Var_Samp_Fields>;
  variance?: Maybe<Taggit_Tag_Variance_Fields>;
};


/** aggregate fields of "taggit_tag" */
export type Taggit_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Taggit_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Taggit_Tag_Avg_Fields = {
  __typename?: 'taggit_tag_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "taggit_tag". All fields are combined with a logical 'AND'. */
export type Taggit_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Taggit_Tag_Bool_Exp>>;
  _not?: InputMaybe<Taggit_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Taggit_Tag_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  taggit_taggeditems?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
  taggit_taggeditems_aggregate?: InputMaybe<Taggit_Taggeditem_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "taggit_tag" */
export enum Taggit_Tag_Constraint {
  /** unique or primary key constraint on columns "name" */
  TaggitTagNameKey = 'taggit_tag_name_key',
  /** unique or primary key constraint on columns "id" */
  TaggitTagPkey = 'taggit_tag_pkey',
  /** unique or primary key constraint on columns "slug" */
  TaggitTagSlugKey = 'taggit_tag_slug_key'
}

/** input type for incrementing numeric columns in table "taggit_tag" */
export type Taggit_Tag_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "taggit_tag" */
export type Taggit_Tag_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  taggit_taggeditems?: InputMaybe<Taggit_Taggeditem_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Taggit_Tag_Max_Fields = {
  __typename?: 'taggit_tag_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Taggit_Tag_Min_Fields = {
  __typename?: 'taggit_tag_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "taggit_tag" */
export type Taggit_Tag_Mutation_Response = {
  __typename?: 'taggit_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Taggit_Tag>;
};

/** input type for inserting object relation for remote table "taggit_tag" */
export type Taggit_Tag_Obj_Rel_Insert_Input = {
  data: Taggit_Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Taggit_Tag_On_Conflict>;
};

/** on_conflict condition type for table "taggit_tag" */
export type Taggit_Tag_On_Conflict = {
  constraint: Taggit_Tag_Constraint;
  update_columns?: Array<Taggit_Tag_Update_Column>;
  where?: InputMaybe<Taggit_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "taggit_tag". */
export type Taggit_Tag_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  taggit_taggeditems_aggregate?: InputMaybe<Taggit_Taggeditem_Aggregate_Order_By>;
};

/** primary key columns input for table: taggit_tag */
export type Taggit_Tag_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "taggit_tag" */
export enum Taggit_Tag_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "taggit_tag" */
export type Taggit_Tag_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Taggit_Tag_Stddev_Fields = {
  __typename?: 'taggit_tag_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Taggit_Tag_Stddev_Pop_Fields = {
  __typename?: 'taggit_tag_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Taggit_Tag_Stddev_Samp_Fields = {
  __typename?: 'taggit_tag_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "taggit_tag" */
export type Taggit_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Taggit_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Taggit_Tag_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Taggit_Tag_Sum_Fields = {
  __typename?: 'taggit_tag_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "taggit_tag" */
export enum Taggit_Tag_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

export type Taggit_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Taggit_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Taggit_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Taggit_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Taggit_Tag_Var_Pop_Fields = {
  __typename?: 'taggit_tag_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Taggit_Tag_Var_Samp_Fields = {
  __typename?: 'taggit_tag_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Taggit_Tag_Variance_Fields = {
  __typename?: 'taggit_tag_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "taggit_taggeditem" */
export type Taggit_Taggeditem = {
  __typename?: 'taggit_taggeditem';
  content_type_id: Scalars['Int']['output'];
  /** An object relationship */
  django_content_type: Django_Content_Type;
  id: Scalars['Int']['output'];
  object_id: Scalars['Int']['output'];
  tag_id: Scalars['Int']['output'];
  /** An object relationship */
  taggit_tag: Taggit_Tag;
};

/** aggregated selection of "taggit_taggeditem" */
export type Taggit_Taggeditem_Aggregate = {
  __typename?: 'taggit_taggeditem_aggregate';
  aggregate?: Maybe<Taggit_Taggeditem_Aggregate_Fields>;
  nodes: Array<Taggit_Taggeditem>;
};

export type Taggit_Taggeditem_Aggregate_Bool_Exp = {
  count?: InputMaybe<Taggit_Taggeditem_Aggregate_Bool_Exp_Count>;
};

export type Taggit_Taggeditem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "taggit_taggeditem" */
export type Taggit_Taggeditem_Aggregate_Fields = {
  __typename?: 'taggit_taggeditem_aggregate_fields';
  avg?: Maybe<Taggit_Taggeditem_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Taggit_Taggeditem_Max_Fields>;
  min?: Maybe<Taggit_Taggeditem_Min_Fields>;
  stddev?: Maybe<Taggit_Taggeditem_Stddev_Fields>;
  stddev_pop?: Maybe<Taggit_Taggeditem_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Taggit_Taggeditem_Stddev_Samp_Fields>;
  sum?: Maybe<Taggit_Taggeditem_Sum_Fields>;
  var_pop?: Maybe<Taggit_Taggeditem_Var_Pop_Fields>;
  var_samp?: Maybe<Taggit_Taggeditem_Var_Samp_Fields>;
  variance?: Maybe<Taggit_Taggeditem_Variance_Fields>;
};


/** aggregate fields of "taggit_taggeditem" */
export type Taggit_Taggeditem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Taggit_Taggeditem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Aggregate_Order_By = {
  avg?: InputMaybe<Taggit_Taggeditem_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Taggit_Taggeditem_Max_Order_By>;
  min?: InputMaybe<Taggit_Taggeditem_Min_Order_By>;
  stddev?: InputMaybe<Taggit_Taggeditem_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Taggit_Taggeditem_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Taggit_Taggeditem_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Taggit_Taggeditem_Sum_Order_By>;
  var_pop?: InputMaybe<Taggit_Taggeditem_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Taggit_Taggeditem_Var_Samp_Order_By>;
  variance?: InputMaybe<Taggit_Taggeditem_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "taggit_taggeditem" */
export type Taggit_Taggeditem_Arr_Rel_Insert_Input = {
  data: Array<Taggit_Taggeditem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Taggit_Taggeditem_On_Conflict>;
};

/** aggregate avg on columns */
export type Taggit_Taggeditem_Avg_Fields = {
  __typename?: 'taggit_taggeditem_avg_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Avg_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "taggit_taggeditem". All fields are combined with a logical 'AND'. */
export type Taggit_Taggeditem_Bool_Exp = {
  _and?: InputMaybe<Array<Taggit_Taggeditem_Bool_Exp>>;
  _not?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
  _or?: InputMaybe<Array<Taggit_Taggeditem_Bool_Exp>>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  django_content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  tag_id?: InputMaybe<Int_Comparison_Exp>;
  taggit_tag?: InputMaybe<Taggit_Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "taggit_taggeditem" */
export enum Taggit_Taggeditem_Constraint {
  /** unique or primary key constraint on columns "object_id", "content_type_id", "tag_id" */
  TaggitTaggeditemContentTypeIdObjectI_4bb97a8eUniq = 'taggit_taggeditem_content_type_id_object_i_4bb97a8e_uniq',
  /** unique or primary key constraint on columns "id" */
  TaggitTaggeditemPkey = 'taggit_taggeditem_pkey'
}

/** input type for incrementing numeric columns in table "taggit_taggeditem" */
export type Taggit_Taggeditem_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Scalars['Int']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "taggit_taggeditem" */
export type Taggit_Taggeditem_Insert_Input = {
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  django_content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Scalars['Int']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  taggit_tag?: InputMaybe<Taggit_Tag_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Taggit_Taggeditem_Max_Fields = {
  __typename?: 'taggit_taggeditem_max_fields';
  content_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  object_id?: Maybe<Scalars['Int']['output']>;
  tag_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Max_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Taggit_Taggeditem_Min_Fields = {
  __typename?: 'taggit_taggeditem_min_fields';
  content_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  object_id?: Maybe<Scalars['Int']['output']>;
  tag_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Min_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "taggit_taggeditem" */
export type Taggit_Taggeditem_Mutation_Response = {
  __typename?: 'taggit_taggeditem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Taggit_Taggeditem>;
};

/** on_conflict condition type for table "taggit_taggeditem" */
export type Taggit_Taggeditem_On_Conflict = {
  constraint: Taggit_Taggeditem_Constraint;
  update_columns?: Array<Taggit_Taggeditem_Update_Column>;
  where?: InputMaybe<Taggit_Taggeditem_Bool_Exp>;
};

/** Ordering options when selecting data from "taggit_taggeditem". */
export type Taggit_Taggeditem_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  django_content_type?: InputMaybe<Django_Content_Type_Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  taggit_tag?: InputMaybe<Taggit_Tag_Order_By>;
};

/** primary key columns input for table: taggit_taggeditem */
export type Taggit_Taggeditem_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "taggit_taggeditem" */
export enum Taggit_Taggeditem_Select_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  TagId = 'tag_id'
}

/** input type for updating data in table "taggit_taggeditem" */
export type Taggit_Taggeditem_Set_Input = {
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Scalars['Int']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Taggit_Taggeditem_Stddev_Fields = {
  __typename?: 'taggit_taggeditem_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Stddev_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Taggit_Taggeditem_Stddev_Pop_Fields = {
  __typename?: 'taggit_taggeditem_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Stddev_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Taggit_Taggeditem_Stddev_Samp_Fields = {
  __typename?: 'taggit_taggeditem_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Stddev_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "taggit_taggeditem" */
export type Taggit_Taggeditem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Taggit_Taggeditem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Taggit_Taggeditem_Stream_Cursor_Value_Input = {
  content_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Scalars['Int']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Taggit_Taggeditem_Sum_Fields = {
  __typename?: 'taggit_taggeditem_sum_fields';
  content_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  object_id?: Maybe<Scalars['Int']['output']>;
  tag_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Sum_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** update columns of table "taggit_taggeditem" */
export enum Taggit_Taggeditem_Update_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  TagId = 'tag_id'
}

export type Taggit_Taggeditem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Taggit_Taggeditem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Taggit_Taggeditem_Set_Input>;
  /** filter the rows which have to be updated */
  where: Taggit_Taggeditem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Taggit_Taggeditem_Var_Pop_Fields = {
  __typename?: 'taggit_taggeditem_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Var_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Taggit_Taggeditem_Var_Samp_Fields = {
  __typename?: 'taggit_taggeditem_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Var_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Taggit_Taggeditem_Variance_Fields = {
  __typename?: 'taggit_taggeditem_variance_fields';
  content_type_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "taggit_taggeditem" */
export type Taggit_Taggeditem_Variance_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "upcoming_live_classes" */
export type Upcoming_Live_Classes = {
  __typename?: 'upcoming_live_classes';
  created_at: Scalars['timestamptz']['output'];
  end_time: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  start_time: Scalars['timestamptz']['output'];
  taken_by: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
};

/** aggregated selection of "upcoming_live_classes" */
export type Upcoming_Live_Classes_Aggregate = {
  __typename?: 'upcoming_live_classes_aggregate';
  aggregate?: Maybe<Upcoming_Live_Classes_Aggregate_Fields>;
  nodes: Array<Upcoming_Live_Classes>;
};

/** aggregate fields of "upcoming_live_classes" */
export type Upcoming_Live_Classes_Aggregate_Fields = {
  __typename?: 'upcoming_live_classes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Upcoming_Live_Classes_Max_Fields>;
  min?: Maybe<Upcoming_Live_Classes_Min_Fields>;
};


/** aggregate fields of "upcoming_live_classes" */
export type Upcoming_Live_Classes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Upcoming_Live_Classes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "upcoming_live_classes". All fields are combined with a logical 'AND'. */
export type Upcoming_Live_Classes_Bool_Exp = {
  _and?: InputMaybe<Array<Upcoming_Live_Classes_Bool_Exp>>;
  _not?: InputMaybe<Upcoming_Live_Classes_Bool_Exp>;
  _or?: InputMaybe<Array<Upcoming_Live_Classes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  taken_by?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "upcoming_live_classes" */
export enum Upcoming_Live_Classes_Constraint {
  /** unique or primary key constraint on columns "id" */
  UpcomingLiveClassesPkey = 'upcoming_live_classes_pkey'
}

/** input type for inserting data into table "upcoming_live_classes" */
export type Upcoming_Live_Classes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  taken_by?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Upcoming_Live_Classes_Max_Fields = {
  __typename?: 'upcoming_live_classes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_time?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  taken_by?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Upcoming_Live_Classes_Min_Fields = {
  __typename?: 'upcoming_live_classes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_time?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  taken_by?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "upcoming_live_classes" */
export type Upcoming_Live_Classes_Mutation_Response = {
  __typename?: 'upcoming_live_classes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Upcoming_Live_Classes>;
};

/** on_conflict condition type for table "upcoming_live_classes" */
export type Upcoming_Live_Classes_On_Conflict = {
  constraint: Upcoming_Live_Classes_Constraint;
  update_columns?: Array<Upcoming_Live_Classes_Update_Column>;
  where?: InputMaybe<Upcoming_Live_Classes_Bool_Exp>;
};

/** Ordering options when selecting data from "upcoming_live_classes". */
export type Upcoming_Live_Classes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  taken_by?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: upcoming_live_classes */
export type Upcoming_Live_Classes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "upcoming_live_classes" */
export enum Upcoming_Live_Classes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TakenBy = 'taken_by',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "upcoming_live_classes" */
export type Upcoming_Live_Classes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  taken_by?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "upcoming_live_classes" */
export type Upcoming_Live_Classes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Upcoming_Live_Classes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Upcoming_Live_Classes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  taken_by?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "upcoming_live_classes" */
export enum Upcoming_Live_Classes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TakenBy = 'taken_by',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Upcoming_Live_Classes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Upcoming_Live_Classes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Upcoming_Live_Classes_Bool_Exp;
};

/** columns and relationships of "user_activities" */
export type User_Activities = {
  __typename?: 'user_activities';
  /** An object relationship */
  activity_type: Activity_Types;
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  learn_category_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  quiz_category?: Maybe<Quiz_Category>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  quiz_quiz?: Maybe<Quiz_Quiz>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "user_activities" */
export type User_Activities_Aggregate = {
  __typename?: 'user_activities_aggregate';
  aggregate?: Maybe<User_Activities_Aggregate_Fields>;
  nodes: Array<User_Activities>;
};

export type User_Activities_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Activities_Aggregate_Bool_Exp_Count>;
};

export type User_Activities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Activities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_activities" */
export type User_Activities_Aggregate_Fields = {
  __typename?: 'user_activities_aggregate_fields';
  avg?: Maybe<User_Activities_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Activities_Max_Fields>;
  min?: Maybe<User_Activities_Min_Fields>;
  stddev?: Maybe<User_Activities_Stddev_Fields>;
  stddev_pop?: Maybe<User_Activities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Activities_Stddev_Samp_Fields>;
  sum?: Maybe<User_Activities_Sum_Fields>;
  var_pop?: Maybe<User_Activities_Var_Pop_Fields>;
  var_samp?: Maybe<User_Activities_Var_Samp_Fields>;
  variance?: Maybe<User_Activities_Variance_Fields>;
};


/** aggregate fields of "user_activities" */
export type User_Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_activities" */
export type User_Activities_Aggregate_Order_By = {
  avg?: InputMaybe<User_Activities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Activities_Max_Order_By>;
  min?: InputMaybe<User_Activities_Min_Order_By>;
  stddev?: InputMaybe<User_Activities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Activities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Activities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Activities_Sum_Order_By>;
  var_pop?: InputMaybe<User_Activities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Activities_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Activities_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_activities" */
export type User_Activities_Arr_Rel_Insert_Input = {
  data: Array<User_Activities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Activities_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Activities_Avg_Fields = {
  __typename?: 'user_activities_avg_fields';
  learn_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_activities" */
export type User_Activities_Avg_Order_By = {
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_activities". All fields are combined with a logical 'AND'. */
export type User_Activities_Bool_Exp = {
  _and?: InputMaybe<Array<User_Activities_Bool_Exp>>;
  _not?: InputMaybe<User_Activities_Bool_Exp>;
  _or?: InputMaybe<Array<User_Activities_Bool_Exp>>;
  activity_type?: InputMaybe<Activity_Types_Bool_Exp>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  learn_category_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_activities" */
export enum User_Activities_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivitiesPkey = 'activities_pkey',
  /** unique or primary key constraint on columns "learn_category_id", "user_id", "type" */
  UserActivitiesLearnCategoryIdUserIdTypeKey = 'user_activities_learn_category_id_user_id_type_key',
  /** unique or primary key constraint on columns "quiz_id", "user_id", "type" */
  UserActivitiesQuizIdTypeUserIdKey = 'user_activities_quiz_id_type_user_id_key'
}

/** input type for incrementing numeric columns in table "user_activities" */
export type User_Activities_Inc_Input = {
  learn_category_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_activities" */
export type User_Activities_Insert_Input = {
  activity_type?: InputMaybe<Activity_Types_Obj_Rel_Insert_Input>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  learn_category_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Activities_Max_Fields = {
  __typename?: 'user_activities_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  learn_category_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_activities" */
export type User_Activities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Activities_Min_Fields = {
  __typename?: 'user_activities_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  learn_category_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_activities" */
export type User_Activities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_activities" */
export type User_Activities_Mutation_Response = {
  __typename?: 'user_activities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Activities>;
};

/** on_conflict condition type for table "user_activities" */
export type User_Activities_On_Conflict = {
  constraint: User_Activities_Constraint;
  update_columns?: Array<User_Activities_Update_Column>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};

/** Ordering options when selecting data from "user_activities". */
export type User_Activities_Order_By = {
  activity_type?: InputMaybe<Activity_Types_Order_By>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  learn_category_id?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_activities */
export type User_Activities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_activities" */
export enum User_Activities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LearnCategoryId = 'learn_category_id',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_activities" */
export type User_Activities_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  learn_category_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Activities_Stddev_Fields = {
  __typename?: 'user_activities_stddev_fields';
  learn_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_activities" */
export type User_Activities_Stddev_Order_By = {
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Activities_Stddev_Pop_Fields = {
  __typename?: 'user_activities_stddev_pop_fields';
  learn_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_activities" */
export type User_Activities_Stddev_Pop_Order_By = {
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Activities_Stddev_Samp_Fields = {
  __typename?: 'user_activities_stddev_samp_fields';
  learn_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_activities" */
export type User_Activities_Stddev_Samp_Order_By = {
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_activities" */
export type User_Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Activities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  learn_category_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Activities_Sum_Fields = {
  __typename?: 'user_activities_sum_fields';
  learn_category_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_activities" */
export type User_Activities_Sum_Order_By = {
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_activities" */
export enum User_Activities_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LearnCategoryId = 'learn_category_id',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Activities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Activities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Activities_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Activities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Activities_Var_Pop_Fields = {
  __typename?: 'user_activities_var_pop_fields';
  learn_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_activities" */
export type User_Activities_Var_Pop_Order_By = {
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Activities_Var_Samp_Fields = {
  __typename?: 'user_activities_var_samp_fields';
  learn_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_activities" */
export type User_Activities_Var_Samp_Order_By = {
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Activities_Variance_Fields = {
  __typename?: 'user_activities_variance_fields';
  learn_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_activities" */
export type User_Activities_Variance_Order_By = {
  learn_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_activity" */
export type User_Activity = {
  __typename?: 'user_activity';
  /** An object relationship */
  activity_type?: Maybe<Activity_Types>;
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  is_lesson?: Maybe<Scalars['Boolean']['output']>;
  is_planned: Scalars['Boolean']['output'];
  /** An object relationship */
  quiz_category?: Maybe<Quiz_Category>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  quiz_quiz?: Maybe<Quiz_Quiz>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  scheduled_end_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_start_date?: Maybe<Scalars['timestamptz']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_activity_lesson_entries: Array<User_Activity_Lesson_Entries>;
  /** An aggregate relationship */
  user_activity_lesson_entries_aggregate: User_Activity_Lesson_Entries_Aggregate;
  user_id: Scalars['String']['output'];
  /** An object relationship */
  user_quiz_summary?: Maybe<User_Quiz_Summaries_Old>;
  xp?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "user_activity" */
export type User_ActivityUser_Activity_Lesson_EntriesArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Lesson_Entries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Lesson_Entries_Order_By>>;
  where?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
};


/** columns and relationships of "user_activity" */
export type User_ActivityUser_Activity_Lesson_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Lesson_Entries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Lesson_Entries_Order_By>>;
  where?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
};

/** aggregated selection of "user_activity" */
export type User_Activity_Aggregate = {
  __typename?: 'user_activity_aggregate';
  aggregate?: Maybe<User_Activity_Aggregate_Fields>;
  nodes: Array<User_Activity>;
};

export type User_Activity_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Activity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Activity_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Activity_Aggregate_Bool_Exp_Count>;
};

export type User_Activity_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Activity_Select_Column_User_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Activity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Activity_Select_Column_User_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Activity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Activity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_activity" */
export type User_Activity_Aggregate_Fields = {
  __typename?: 'user_activity_aggregate_fields';
  avg?: Maybe<User_Activity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Activity_Max_Fields>;
  min?: Maybe<User_Activity_Min_Fields>;
  stddev?: Maybe<User_Activity_Stddev_Fields>;
  stddev_pop?: Maybe<User_Activity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Activity_Stddev_Samp_Fields>;
  sum?: Maybe<User_Activity_Sum_Fields>;
  var_pop?: Maybe<User_Activity_Var_Pop_Fields>;
  var_samp?: Maybe<User_Activity_Var_Samp_Fields>;
  variance?: Maybe<User_Activity_Variance_Fields>;
};


/** aggregate fields of "user_activity" */
export type User_Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_activity" */
export type User_Activity_Aggregate_Order_By = {
  avg?: InputMaybe<User_Activity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Activity_Max_Order_By>;
  min?: InputMaybe<User_Activity_Min_Order_By>;
  stddev?: InputMaybe<User_Activity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Activity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Activity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Activity_Sum_Order_By>;
  var_pop?: InputMaybe<User_Activity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Activity_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Activity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_activity" */
export type User_Activity_Arr_Rel_Insert_Input = {
  data: Array<User_Activity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Activity_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Activity_Avg_Fields = {
  __typename?: 'user_activity_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_activity" */
export type User_Activity_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_activity". All fields are combined with a logical 'AND'. */
export type User_Activity_Bool_Exp = {
  _and?: InputMaybe<Array<User_Activity_Bool_Exp>>;
  _not?: InputMaybe<User_Activity_Bool_Exp>;
  _or?: InputMaybe<Array<User_Activity_Bool_Exp>>;
  activity_type?: InputMaybe<Activity_Types_Bool_Exp>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  is_lesson?: InputMaybe<Boolean_Comparison_Exp>;
  is_planned?: InputMaybe<Boolean_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  quiz_summary_id?: InputMaybe<Int_Comparison_Exp>;
  scheduled_end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  scheduled_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  speed_test_summary_id?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_activity_lesson_entries?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
  user_activity_lesson_entries_aggregate?: InputMaybe<User_Activity_Lesson_Entries_Aggregate_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
  xp?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_activity" */
export enum User_Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserActivityPkey = 'user_activity_pkey'
}

/** input type for incrementing numeric columns in table "user_activity" */
export type User_Activity_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  speed_test_summary_id?: InputMaybe<Scalars['Int']['input']>;
  xp?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_activity" */
export type User_Activity_Insert_Input = {
  activity_type?: InputMaybe<Activity_Types_Obj_Rel_Insert_Input>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_lesson?: InputMaybe<Scalars['Boolean']['input']>;
  is_planned?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  scheduled_end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  speed_test_summary_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_activity_lesson_entries?: InputMaybe<User_Activity_Lesson_Entries_Arr_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Old_Obj_Rel_Insert_Input>;
  xp?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries = {
  __typename?: 'user_activity_lesson_entries';
  activity_id?: Maybe<Scalars['Int']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  user_activity?: Maybe<User_Activity>;
};

/** aggregated selection of "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Aggregate = {
  __typename?: 'user_activity_lesson_entries_aggregate';
  aggregate?: Maybe<User_Activity_Lesson_Entries_Aggregate_Fields>;
  nodes: Array<User_Activity_Lesson_Entries>;
};

export type User_Activity_Lesson_Entries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Count>;
};

export type User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Activity_Lesson_Entries_Select_Column_User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Activity_Lesson_Entries_Select_Column_User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Activity_Lesson_Entries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Aggregate_Fields = {
  __typename?: 'user_activity_lesson_entries_aggregate_fields';
  avg?: Maybe<User_Activity_Lesson_Entries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Activity_Lesson_Entries_Max_Fields>;
  min?: Maybe<User_Activity_Lesson_Entries_Min_Fields>;
  stddev?: Maybe<User_Activity_Lesson_Entries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Activity_Lesson_Entries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Activity_Lesson_Entries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Activity_Lesson_Entries_Sum_Fields>;
  var_pop?: Maybe<User_Activity_Lesson_Entries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Activity_Lesson_Entries_Var_Samp_Fields>;
  variance?: Maybe<User_Activity_Lesson_Entries_Variance_Fields>;
};


/** aggregate fields of "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Activity_Lesson_Entries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Aggregate_Order_By = {
  avg?: InputMaybe<User_Activity_Lesson_Entries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Activity_Lesson_Entries_Max_Order_By>;
  min?: InputMaybe<User_Activity_Lesson_Entries_Min_Order_By>;
  stddev?: InputMaybe<User_Activity_Lesson_Entries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Activity_Lesson_Entries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Activity_Lesson_Entries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Activity_Lesson_Entries_Sum_Order_By>;
  var_pop?: InputMaybe<User_Activity_Lesson_Entries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Activity_Lesson_Entries_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Activity_Lesson_Entries_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Arr_Rel_Insert_Input = {
  data: Array<User_Activity_Lesson_Entries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Activity_Lesson_Entries_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Activity_Lesson_Entries_Avg_Fields = {
  __typename?: 'user_activity_lesson_entries_avg_fields';
  activity_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Avg_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_activity_lesson_entries". All fields are combined with a logical 'AND'. */
export type User_Activity_Lesson_Entries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Activity_Lesson_Entries_Bool_Exp>>;
  _not?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Activity_Lesson_Entries_Bool_Exp>>;
  activity_id?: InputMaybe<Int_Comparison_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  user_activity?: InputMaybe<User_Activity_Bool_Exp>;
};

/** unique or primary key constraints on table "user_activity_lesson_entries" */
export enum User_Activity_Lesson_Entries_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserActivityLessonEntriesPkey = 'user_activity_lesson_entries_pkey'
}

/** input type for incrementing numeric columns in table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Inc_Input = {
  activity_id?: InputMaybe<Scalars['Int']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Insert_Input = {
  activity_id?: InputMaybe<Scalars['Int']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  user_activity?: InputMaybe<User_Activity_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Activity_Lesson_Entries_Max_Fields = {
  __typename?: 'user_activity_lesson_entries_max_fields';
  activity_id?: Maybe<Scalars['Int']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Max_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Activity_Lesson_Entries_Min_Fields = {
  __typename?: 'user_activity_lesson_entries_min_fields';
  activity_id?: Maybe<Scalars['Int']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Min_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Mutation_Response = {
  __typename?: 'user_activity_lesson_entries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Activity_Lesson_Entries>;
};

/** on_conflict condition type for table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_On_Conflict = {
  constraint: User_Activity_Lesson_Entries_Constraint;
  update_columns?: Array<User_Activity_Lesson_Entries_Update_Column>;
  where?: InputMaybe<User_Activity_Lesson_Entries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_activity_lesson_entries". */
export type User_Activity_Lesson_Entries_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  user_activity?: InputMaybe<User_Activity_Order_By>;
};

/** primary key columns input for table: user_activity_lesson_entries */
export type User_Activity_Lesson_Entries_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_activity_lesson_entries" */
export enum User_Activity_Lesson_Entries_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed'
}

/** select "user_activity_lesson_entries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_activity_lesson_entries" */
export enum User_Activity_Lesson_Entries_Select_Column_User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** select "user_activity_lesson_entries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_activity_lesson_entries" */
export enum User_Activity_Lesson_Entries_Select_Column_User_Activity_Lesson_Entries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** input type for updating data in table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Set_Input = {
  activity_id?: InputMaybe<Scalars['Int']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type User_Activity_Lesson_Entries_Stddev_Fields = {
  __typename?: 'user_activity_lesson_entries_stddev_fields';
  activity_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Stddev_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Activity_Lesson_Entries_Stddev_Pop_Fields = {
  __typename?: 'user_activity_lesson_entries_stddev_pop_fields';
  activity_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Stddev_Pop_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Activity_Lesson_Entries_Stddev_Samp_Fields = {
  __typename?: 'user_activity_lesson_entries_stddev_samp_fields';
  activity_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Stddev_Samp_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Activity_Lesson_Entries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Activity_Lesson_Entries_Stream_Cursor_Value_Input = {
  activity_id?: InputMaybe<Scalars['Int']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type User_Activity_Lesson_Entries_Sum_Fields = {
  __typename?: 'user_activity_lesson_entries_sum_fields';
  activity_id?: Maybe<Scalars['Int']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Sum_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "user_activity_lesson_entries" */
export enum User_Activity_Lesson_Entries_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed'
}

export type User_Activity_Lesson_Entries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Activity_Lesson_Entries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Activity_Lesson_Entries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Activity_Lesson_Entries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Activity_Lesson_Entries_Var_Pop_Fields = {
  __typename?: 'user_activity_lesson_entries_var_pop_fields';
  activity_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Var_Pop_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Activity_Lesson_Entries_Var_Samp_Fields = {
  __typename?: 'user_activity_lesson_entries_var_samp_fields';
  activity_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Var_Samp_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Activity_Lesson_Entries_Variance_Fields = {
  __typename?: 'user_activity_lesson_entries_variance_fields';
  activity_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_activity_lesson_entries" */
export type User_Activity_Lesson_Entries_Variance_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type User_Activity_Max_Fields = {
  __typename?: 'user_activity_max_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  scheduled_end_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_start_date?: Maybe<Scalars['timestamptz']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "user_activity" */
export type User_Activity_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  scheduled_end_date?: InputMaybe<Order_By>;
  scheduled_start_date?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Activity_Min_Fields = {
  __typename?: 'user_activity_min_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  scheduled_end_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_start_date?: Maybe<Scalars['timestamptz']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "user_activity" */
export type User_Activity_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  scheduled_end_date?: InputMaybe<Order_By>;
  scheduled_start_date?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_activity" */
export type User_Activity_Mutation_Response = {
  __typename?: 'user_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Activity>;
};

/** input type for inserting object relation for remote table "user_activity" */
export type User_Activity_Obj_Rel_Insert_Input = {
  data: User_Activity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Activity_On_Conflict>;
};

/** on_conflict condition type for table "user_activity" */
export type User_Activity_On_Conflict = {
  constraint: User_Activity_Constraint;
  update_columns?: Array<User_Activity_Update_Column>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "user_activity". */
export type User_Activity_Order_By = {
  activity_type?: InputMaybe<Activity_Types_Order_By>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  is_lesson?: InputMaybe<Order_By>;
  is_planned?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  scheduled_end_date?: InputMaybe<Order_By>;
  scheduled_start_date?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_activity_lesson_entries_aggregate?: InputMaybe<User_Activity_Lesson_Entries_Aggregate_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Old_Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_activity */
export type User_Activity_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_activity" */
export enum User_Activity_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  IsLesson = 'is_lesson',
  /** column name */
  IsPlanned = 'is_planned',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  ScheduledEndDate = 'scheduled_end_date',
  /** column name */
  ScheduledStartDate = 'scheduled_start_date',
  /** column name */
  SpeedTestSummaryId = 'speed_test_summary_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

/** select "user_activity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_activity" */
export enum User_Activity_Select_Column_User_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  IsLesson = 'is_lesson',
  /** column name */
  IsPlanned = 'is_planned'
}

/** select "user_activity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_activity" */
export enum User_Activity_Select_Column_User_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  IsLesson = 'is_lesson',
  /** column name */
  IsPlanned = 'is_planned'
}

/** input type for updating data in table "user_activity" */
export type User_Activity_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_lesson?: InputMaybe<Scalars['Boolean']['input']>;
  is_planned?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  scheduled_end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  speed_test_summary_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type User_Activity_Stddev_Fields = {
  __typename?: 'user_activity_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_activity" */
export type User_Activity_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Activity_Stddev_Pop_Fields = {
  __typename?: 'user_activity_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_activity" */
export type User_Activity_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Activity_Stddev_Samp_Fields = {
  __typename?: 'user_activity_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_activity" */
export type User_Activity_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_activity" */
export type User_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Activity_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_lesson?: InputMaybe<Scalars['Boolean']['input']>;
  is_planned?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  scheduled_end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  speed_test_summary_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type User_Activity_Sum_Fields = {
  __typename?: 'user_activity_sum_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Int']['output']>;
  xp?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_activity" */
export type User_Activity_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** update columns of table "user_activity" */
export enum User_Activity_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  IsLesson = 'is_lesson',
  /** column name */
  IsPlanned = 'is_planned',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  ScheduledEndDate = 'scheduled_end_date',
  /** column name */
  ScheduledStartDate = 'scheduled_start_date',
  /** column name */
  SpeedTestSummaryId = 'speed_test_summary_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

export type User_Activity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Activity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Activity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Activity_Var_Pop_Fields = {
  __typename?: 'user_activity_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_activity" */
export type User_Activity_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Activity_Var_Samp_Fields = {
  __typename?: 'user_activity_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_activity" */
export type User_Activity_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Activity_Variance_Fields = {
  __typename?: 'user_activity_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  speed_test_summary_id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_activity" */
export type User_Activity_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  speed_test_summary_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_cat_registration_data" */
export type User_Cat_Registration_Data = {
  __typename?: 'user_cat_registration_data';
  application_no: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  response_data?: Maybe<User_Cat_Response_Sheet_Data>;
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_cat_registration_data" */
export type User_Cat_Registration_Data_Aggregate = {
  __typename?: 'user_cat_registration_data_aggregate';
  aggregate?: Maybe<User_Cat_Registration_Data_Aggregate_Fields>;
  nodes: Array<User_Cat_Registration_Data>;
};

export type User_Cat_Registration_Data_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Cat_Registration_Data_Aggregate_Bool_Exp_Count>;
};

export type User_Cat_Registration_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Cat_Registration_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_cat_registration_data" */
export type User_Cat_Registration_Data_Aggregate_Fields = {
  __typename?: 'user_cat_registration_data_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Cat_Registration_Data_Max_Fields>;
  min?: Maybe<User_Cat_Registration_Data_Min_Fields>;
};


/** aggregate fields of "user_cat_registration_data" */
export type User_Cat_Registration_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Cat_Registration_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_cat_registration_data" */
export type User_Cat_Registration_Data_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Cat_Registration_Data_Max_Order_By>;
  min?: InputMaybe<User_Cat_Registration_Data_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_cat_registration_data" */
export type User_Cat_Registration_Data_Arr_Rel_Insert_Input = {
  data: Array<User_Cat_Registration_Data_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Cat_Registration_Data_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_cat_registration_data". All fields are combined with a logical 'AND'. */
export type User_Cat_Registration_Data_Bool_Exp = {
  _and?: InputMaybe<Array<User_Cat_Registration_Data_Bool_Exp>>;
  _not?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
  _or?: InputMaybe<Array<User_Cat_Registration_Data_Bool_Exp>>;
  application_no?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mobile?: InputMaybe<String_Comparison_Exp>;
  response_data?: InputMaybe<User_Cat_Response_Sheet_Data_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_cat_registration_data" */
export enum User_Cat_Registration_Data_Constraint {
  /** unique or primary key constraint on columns "application_no" */
  UserCatRegistrationDataApplicationNoKey = 'user_cat_registration_data_application_no_key',
  /** unique or primary key constraint on columns "id" */
  UserCatRegistrationDataPkey = 'user_cat_registration_data_pkey'
}

/** input type for inserting data into table "user_cat_registration_data" */
export type User_Cat_Registration_Data_Insert_Input = {
  application_no?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  response_data?: InputMaybe<User_Cat_Response_Sheet_Data_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Cat_Registration_Data_Max_Fields = {
  __typename?: 'user_cat_registration_data_max_fields';
  application_no?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_cat_registration_data" */
export type User_Cat_Registration_Data_Max_Order_By = {
  application_no?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Cat_Registration_Data_Min_Fields = {
  __typename?: 'user_cat_registration_data_min_fields';
  application_no?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_cat_registration_data" */
export type User_Cat_Registration_Data_Min_Order_By = {
  application_no?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_cat_registration_data" */
export type User_Cat_Registration_Data_Mutation_Response = {
  __typename?: 'user_cat_registration_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Cat_Registration_Data>;
};

/** input type for inserting object relation for remote table "user_cat_registration_data" */
export type User_Cat_Registration_Data_Obj_Rel_Insert_Input = {
  data: User_Cat_Registration_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Cat_Registration_Data_On_Conflict>;
};

/** on_conflict condition type for table "user_cat_registration_data" */
export type User_Cat_Registration_Data_On_Conflict = {
  constraint: User_Cat_Registration_Data_Constraint;
  update_columns?: Array<User_Cat_Registration_Data_Update_Column>;
  where?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "user_cat_registration_data". */
export type User_Cat_Registration_Data_Order_By = {
  application_no?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  response_data?: InputMaybe<User_Cat_Response_Sheet_Data_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_cat_registration_data */
export type User_Cat_Registration_Data_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_cat_registration_data" */
export enum User_Cat_Registration_Data_Select_Column {
  /** column name */
  ApplicationNo = 'application_no',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "user_cat_registration_data" */
export type User_Cat_Registration_Data_Set_Input = {
  application_no?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_cat_registration_data" */
export type User_Cat_Registration_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Cat_Registration_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Cat_Registration_Data_Stream_Cursor_Value_Input = {
  application_no?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_cat_registration_data" */
export enum User_Cat_Registration_Data_Update_Column {
  /** column name */
  ApplicationNo = 'application_no',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

export type User_Cat_Registration_Data_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Cat_Registration_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Cat_Registration_Data_Bool_Exp;
};

/** columns and relationships of "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data = {
  __typename?: 'user_cat_response_sheet_data';
  application_no: Scalars['String']['output'];
  candidate_name: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  dilr_correct: Scalars['Int']['output'];
  dilr_incorrect: Scalars['Int']['output'];
  dilr_raw: Scalars['numeric']['output'];
  dilr_scaled: Scalars['numeric']['output'];
  dilr_unattempted: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  qa_correct: Scalars['Int']['output'];
  qa_incorrect: Scalars['Int']['output'];
  qa_unattempted: Scalars['Int']['output'];
  quant_raw: Scalars['numeric']['output'];
  quant_scaled: Scalars['numeric']['output'];
  sheet_link?: Maybe<Scalars['String']['output']>;
  shift: Scalars['Int']['output'];
  test_center?: Maybe<Scalars['String']['output']>;
  total_correct: Scalars['Int']['output'];
  total_incorrect: Scalars['Int']['output'];
  total_raw: Scalars['numeric']['output'];
  total_scaled: Scalars['numeric']['output'];
  total_unattempted: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_cat_registration_data: Array<User_Cat_Registration_Data>;
  /** An aggregate relationship */
  user_cat_registration_data_aggregate: User_Cat_Registration_Data_Aggregate;
  /** An object relationship */
  user_cat_registration_datum?: Maybe<User_Cat_Registration_Data>;
  varc_correct: Scalars['Int']['output'];
  varc_incorrect: Scalars['Int']['output'];
  varc_raw: Scalars['numeric']['output'];
  varc_scaled: Scalars['numeric']['output'];
  varc_unattempted: Scalars['Int']['output'];
};


/** columns and relationships of "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_DataUser_Cat_Registration_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Registration_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Registration_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
};


/** columns and relationships of "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_DataUser_Cat_Registration_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Cat_Registration_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Cat_Registration_Data_Order_By>>;
  where?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
};

/** aggregated selection of "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_Aggregate = {
  __typename?: 'user_cat_response_sheet_data_aggregate';
  aggregate?: Maybe<User_Cat_Response_Sheet_Data_Aggregate_Fields>;
  nodes: Array<User_Cat_Response_Sheet_Data>;
};

/** aggregate fields of "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_Aggregate_Fields = {
  __typename?: 'user_cat_response_sheet_data_aggregate_fields';
  avg?: Maybe<User_Cat_Response_Sheet_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Cat_Response_Sheet_Data_Max_Fields>;
  min?: Maybe<User_Cat_Response_Sheet_Data_Min_Fields>;
  stddev?: Maybe<User_Cat_Response_Sheet_Data_Stddev_Fields>;
  stddev_pop?: Maybe<User_Cat_Response_Sheet_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Cat_Response_Sheet_Data_Stddev_Samp_Fields>;
  sum?: Maybe<User_Cat_Response_Sheet_Data_Sum_Fields>;
  var_pop?: Maybe<User_Cat_Response_Sheet_Data_Var_Pop_Fields>;
  var_samp?: Maybe<User_Cat_Response_Sheet_Data_Var_Samp_Fields>;
  variance?: Maybe<User_Cat_Response_Sheet_Data_Variance_Fields>;
};


/** aggregate fields of "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Cat_Response_Sheet_Data_Avg_Fields = {
  __typename?: 'user_cat_response_sheet_data_avg_fields';
  dilr_correct?: Maybe<Scalars['Float']['output']>;
  dilr_incorrect?: Maybe<Scalars['Float']['output']>;
  dilr_raw?: Maybe<Scalars['Float']['output']>;
  dilr_scaled?: Maybe<Scalars['Float']['output']>;
  dilr_unattempted?: Maybe<Scalars['Float']['output']>;
  qa_correct?: Maybe<Scalars['Float']['output']>;
  qa_incorrect?: Maybe<Scalars['Float']['output']>;
  qa_unattempted?: Maybe<Scalars['Float']['output']>;
  quant_raw?: Maybe<Scalars['Float']['output']>;
  quant_scaled?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
  total_correct?: Maybe<Scalars['Float']['output']>;
  total_incorrect?: Maybe<Scalars['Float']['output']>;
  total_raw?: Maybe<Scalars['Float']['output']>;
  total_scaled?: Maybe<Scalars['Float']['output']>;
  total_unattempted?: Maybe<Scalars['Float']['output']>;
  varc_correct?: Maybe<Scalars['Float']['output']>;
  varc_incorrect?: Maybe<Scalars['Float']['output']>;
  varc_raw?: Maybe<Scalars['Float']['output']>;
  varc_scaled?: Maybe<Scalars['Float']['output']>;
  varc_unattempted?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_cat_response_sheet_data". All fields are combined with a logical 'AND'. */
export type User_Cat_Response_Sheet_Data_Bool_Exp = {
  _and?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Bool_Exp>>;
  _not?: InputMaybe<User_Cat_Response_Sheet_Data_Bool_Exp>;
  _or?: InputMaybe<Array<User_Cat_Response_Sheet_Data_Bool_Exp>>;
  application_no?: InputMaybe<String_Comparison_Exp>;
  candidate_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dilr_correct?: InputMaybe<Int_Comparison_Exp>;
  dilr_incorrect?: InputMaybe<Int_Comparison_Exp>;
  dilr_raw?: InputMaybe<Numeric_Comparison_Exp>;
  dilr_scaled?: InputMaybe<Numeric_Comparison_Exp>;
  dilr_unattempted?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  qa_correct?: InputMaybe<Int_Comparison_Exp>;
  qa_incorrect?: InputMaybe<Int_Comparison_Exp>;
  qa_unattempted?: InputMaybe<Int_Comparison_Exp>;
  quant_raw?: InputMaybe<Numeric_Comparison_Exp>;
  quant_scaled?: InputMaybe<Numeric_Comparison_Exp>;
  sheet_link?: InputMaybe<String_Comparison_Exp>;
  shift?: InputMaybe<Int_Comparison_Exp>;
  test_center?: InputMaybe<String_Comparison_Exp>;
  total_correct?: InputMaybe<Int_Comparison_Exp>;
  total_incorrect?: InputMaybe<Int_Comparison_Exp>;
  total_raw?: InputMaybe<Numeric_Comparison_Exp>;
  total_scaled?: InputMaybe<Numeric_Comparison_Exp>;
  total_unattempted?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_cat_registration_data?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
  user_cat_registration_data_aggregate?: InputMaybe<User_Cat_Registration_Data_Aggregate_Bool_Exp>;
  user_cat_registration_datum?: InputMaybe<User_Cat_Registration_Data_Bool_Exp>;
  varc_correct?: InputMaybe<Int_Comparison_Exp>;
  varc_incorrect?: InputMaybe<Int_Comparison_Exp>;
  varc_raw?: InputMaybe<Numeric_Comparison_Exp>;
  varc_scaled?: InputMaybe<Numeric_Comparison_Exp>;
  varc_unattempted?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_cat_response_sheet_data" */
export enum User_Cat_Response_Sheet_Data_Constraint {
  /** unique or primary key constraint on columns "application_no" */
  UserCatResponseSheetDataApplicationNoKey = 'user_cat_response_sheet_data_application_no_key',
  /** unique or primary key constraint on columns "id" */
  UserCatResponseSheetDataPkey = 'user_cat_response_sheet_data_pkey'
}

/** input type for incrementing numeric columns in table "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_Inc_Input = {
  dilr_correct?: InputMaybe<Scalars['Int']['input']>;
  dilr_incorrect?: InputMaybe<Scalars['Int']['input']>;
  dilr_raw?: InputMaybe<Scalars['numeric']['input']>;
  dilr_scaled?: InputMaybe<Scalars['numeric']['input']>;
  dilr_unattempted?: InputMaybe<Scalars['Int']['input']>;
  qa_correct?: InputMaybe<Scalars['Int']['input']>;
  qa_incorrect?: InputMaybe<Scalars['Int']['input']>;
  qa_unattempted?: InputMaybe<Scalars['Int']['input']>;
  quant_raw?: InputMaybe<Scalars['numeric']['input']>;
  quant_scaled?: InputMaybe<Scalars['numeric']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  total_correct?: InputMaybe<Scalars['Int']['input']>;
  total_incorrect?: InputMaybe<Scalars['Int']['input']>;
  total_raw?: InputMaybe<Scalars['numeric']['input']>;
  total_scaled?: InputMaybe<Scalars['numeric']['input']>;
  total_unattempted?: InputMaybe<Scalars['Int']['input']>;
  varc_correct?: InputMaybe<Scalars['Int']['input']>;
  varc_incorrect?: InputMaybe<Scalars['Int']['input']>;
  varc_raw?: InputMaybe<Scalars['numeric']['input']>;
  varc_scaled?: InputMaybe<Scalars['numeric']['input']>;
  varc_unattempted?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_Insert_Input = {
  application_no?: InputMaybe<Scalars['String']['input']>;
  candidate_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dilr_correct?: InputMaybe<Scalars['Int']['input']>;
  dilr_incorrect?: InputMaybe<Scalars['Int']['input']>;
  dilr_raw?: InputMaybe<Scalars['numeric']['input']>;
  dilr_scaled?: InputMaybe<Scalars['numeric']['input']>;
  dilr_unattempted?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  qa_correct?: InputMaybe<Scalars['Int']['input']>;
  qa_incorrect?: InputMaybe<Scalars['Int']['input']>;
  qa_unattempted?: InputMaybe<Scalars['Int']['input']>;
  quant_raw?: InputMaybe<Scalars['numeric']['input']>;
  quant_scaled?: InputMaybe<Scalars['numeric']['input']>;
  sheet_link?: InputMaybe<Scalars['String']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  test_center?: InputMaybe<Scalars['String']['input']>;
  total_correct?: InputMaybe<Scalars['Int']['input']>;
  total_incorrect?: InputMaybe<Scalars['Int']['input']>;
  total_raw?: InputMaybe<Scalars['numeric']['input']>;
  total_scaled?: InputMaybe<Scalars['numeric']['input']>;
  total_unattempted?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_cat_registration_data?: InputMaybe<User_Cat_Registration_Data_Arr_Rel_Insert_Input>;
  user_cat_registration_datum?: InputMaybe<User_Cat_Registration_Data_Obj_Rel_Insert_Input>;
  varc_correct?: InputMaybe<Scalars['Int']['input']>;
  varc_incorrect?: InputMaybe<Scalars['Int']['input']>;
  varc_raw?: InputMaybe<Scalars['numeric']['input']>;
  varc_scaled?: InputMaybe<Scalars['numeric']['input']>;
  varc_unattempted?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type User_Cat_Response_Sheet_Data_Max_Fields = {
  __typename?: 'user_cat_response_sheet_data_max_fields';
  application_no?: Maybe<Scalars['String']['output']>;
  candidate_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dilr_correct?: Maybe<Scalars['Int']['output']>;
  dilr_incorrect?: Maybe<Scalars['Int']['output']>;
  dilr_raw?: Maybe<Scalars['numeric']['output']>;
  dilr_scaled?: Maybe<Scalars['numeric']['output']>;
  dilr_unattempted?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  qa_correct?: Maybe<Scalars['Int']['output']>;
  qa_incorrect?: Maybe<Scalars['Int']['output']>;
  qa_unattempted?: Maybe<Scalars['Int']['output']>;
  quant_raw?: Maybe<Scalars['numeric']['output']>;
  quant_scaled?: Maybe<Scalars['numeric']['output']>;
  sheet_link?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  test_center?: Maybe<Scalars['String']['output']>;
  total_correct?: Maybe<Scalars['Int']['output']>;
  total_incorrect?: Maybe<Scalars['Int']['output']>;
  total_raw?: Maybe<Scalars['numeric']['output']>;
  total_scaled?: Maybe<Scalars['numeric']['output']>;
  total_unattempted?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  varc_correct?: Maybe<Scalars['Int']['output']>;
  varc_incorrect?: Maybe<Scalars['Int']['output']>;
  varc_raw?: Maybe<Scalars['numeric']['output']>;
  varc_scaled?: Maybe<Scalars['numeric']['output']>;
  varc_unattempted?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type User_Cat_Response_Sheet_Data_Min_Fields = {
  __typename?: 'user_cat_response_sheet_data_min_fields';
  application_no?: Maybe<Scalars['String']['output']>;
  candidate_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dilr_correct?: Maybe<Scalars['Int']['output']>;
  dilr_incorrect?: Maybe<Scalars['Int']['output']>;
  dilr_raw?: Maybe<Scalars['numeric']['output']>;
  dilr_scaled?: Maybe<Scalars['numeric']['output']>;
  dilr_unattempted?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  qa_correct?: Maybe<Scalars['Int']['output']>;
  qa_incorrect?: Maybe<Scalars['Int']['output']>;
  qa_unattempted?: Maybe<Scalars['Int']['output']>;
  quant_raw?: Maybe<Scalars['numeric']['output']>;
  quant_scaled?: Maybe<Scalars['numeric']['output']>;
  sheet_link?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  test_center?: Maybe<Scalars['String']['output']>;
  total_correct?: Maybe<Scalars['Int']['output']>;
  total_incorrect?: Maybe<Scalars['Int']['output']>;
  total_raw?: Maybe<Scalars['numeric']['output']>;
  total_scaled?: Maybe<Scalars['numeric']['output']>;
  total_unattempted?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  varc_correct?: Maybe<Scalars['Int']['output']>;
  varc_incorrect?: Maybe<Scalars['Int']['output']>;
  varc_raw?: Maybe<Scalars['numeric']['output']>;
  varc_scaled?: Maybe<Scalars['numeric']['output']>;
  varc_unattempted?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_Mutation_Response = {
  __typename?: 'user_cat_response_sheet_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Cat_Response_Sheet_Data>;
};

/** input type for inserting object relation for remote table "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_Obj_Rel_Insert_Input = {
  data: User_Cat_Response_Sheet_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Cat_Response_Sheet_Data_On_Conflict>;
};

/** on_conflict condition type for table "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_On_Conflict = {
  constraint: User_Cat_Response_Sheet_Data_Constraint;
  update_columns?: Array<User_Cat_Response_Sheet_Data_Update_Column>;
  where?: InputMaybe<User_Cat_Response_Sheet_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "user_cat_response_sheet_data". */
export type User_Cat_Response_Sheet_Data_Order_By = {
  application_no?: InputMaybe<Order_By>;
  candidate_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dilr_correct?: InputMaybe<Order_By>;
  dilr_incorrect?: InputMaybe<Order_By>;
  dilr_raw?: InputMaybe<Order_By>;
  dilr_scaled?: InputMaybe<Order_By>;
  dilr_unattempted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  qa_correct?: InputMaybe<Order_By>;
  qa_incorrect?: InputMaybe<Order_By>;
  qa_unattempted?: InputMaybe<Order_By>;
  quant_raw?: InputMaybe<Order_By>;
  quant_scaled?: InputMaybe<Order_By>;
  sheet_link?: InputMaybe<Order_By>;
  shift?: InputMaybe<Order_By>;
  test_center?: InputMaybe<Order_By>;
  total_correct?: InputMaybe<Order_By>;
  total_incorrect?: InputMaybe<Order_By>;
  total_raw?: InputMaybe<Order_By>;
  total_scaled?: InputMaybe<Order_By>;
  total_unattempted?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_cat_registration_data_aggregate?: InputMaybe<User_Cat_Registration_Data_Aggregate_Order_By>;
  user_cat_registration_datum?: InputMaybe<User_Cat_Registration_Data_Order_By>;
  varc_correct?: InputMaybe<Order_By>;
  varc_incorrect?: InputMaybe<Order_By>;
  varc_raw?: InputMaybe<Order_By>;
  varc_scaled?: InputMaybe<Order_By>;
  varc_unattempted?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_cat_response_sheet_data */
export type User_Cat_Response_Sheet_Data_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_cat_response_sheet_data" */
export enum User_Cat_Response_Sheet_Data_Select_Column {
  /** column name */
  ApplicationNo = 'application_no',
  /** column name */
  CandidateName = 'candidate_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DilrCorrect = 'dilr_correct',
  /** column name */
  DilrIncorrect = 'dilr_incorrect',
  /** column name */
  DilrRaw = 'dilr_raw',
  /** column name */
  DilrScaled = 'dilr_scaled',
  /** column name */
  DilrUnattempted = 'dilr_unattempted',
  /** column name */
  Id = 'id',
  /** column name */
  QaCorrect = 'qa_correct',
  /** column name */
  QaIncorrect = 'qa_incorrect',
  /** column name */
  QaUnattempted = 'qa_unattempted',
  /** column name */
  QuantRaw = 'quant_raw',
  /** column name */
  QuantScaled = 'quant_scaled',
  /** column name */
  SheetLink = 'sheet_link',
  /** column name */
  Shift = 'shift',
  /** column name */
  TestCenter = 'test_center',
  /** column name */
  TotalCorrect = 'total_correct',
  /** column name */
  TotalIncorrect = 'total_incorrect',
  /** column name */
  TotalRaw = 'total_raw',
  /** column name */
  TotalScaled = 'total_scaled',
  /** column name */
  TotalUnattempted = 'total_unattempted',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarcCorrect = 'varc_correct',
  /** column name */
  VarcIncorrect = 'varc_incorrect',
  /** column name */
  VarcRaw = 'varc_raw',
  /** column name */
  VarcScaled = 'varc_scaled',
  /** column name */
  VarcUnattempted = 'varc_unattempted'
}

/** input type for updating data in table "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_Set_Input = {
  application_no?: InputMaybe<Scalars['String']['input']>;
  candidate_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dilr_correct?: InputMaybe<Scalars['Int']['input']>;
  dilr_incorrect?: InputMaybe<Scalars['Int']['input']>;
  dilr_raw?: InputMaybe<Scalars['numeric']['input']>;
  dilr_scaled?: InputMaybe<Scalars['numeric']['input']>;
  dilr_unattempted?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  qa_correct?: InputMaybe<Scalars['Int']['input']>;
  qa_incorrect?: InputMaybe<Scalars['Int']['input']>;
  qa_unattempted?: InputMaybe<Scalars['Int']['input']>;
  quant_raw?: InputMaybe<Scalars['numeric']['input']>;
  quant_scaled?: InputMaybe<Scalars['numeric']['input']>;
  sheet_link?: InputMaybe<Scalars['String']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  test_center?: InputMaybe<Scalars['String']['input']>;
  total_correct?: InputMaybe<Scalars['Int']['input']>;
  total_incorrect?: InputMaybe<Scalars['Int']['input']>;
  total_raw?: InputMaybe<Scalars['numeric']['input']>;
  total_scaled?: InputMaybe<Scalars['numeric']['input']>;
  total_unattempted?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  varc_correct?: InputMaybe<Scalars['Int']['input']>;
  varc_incorrect?: InputMaybe<Scalars['Int']['input']>;
  varc_raw?: InputMaybe<Scalars['numeric']['input']>;
  varc_scaled?: InputMaybe<Scalars['numeric']['input']>;
  varc_unattempted?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type User_Cat_Response_Sheet_Data_Stddev_Fields = {
  __typename?: 'user_cat_response_sheet_data_stddev_fields';
  dilr_correct?: Maybe<Scalars['Float']['output']>;
  dilr_incorrect?: Maybe<Scalars['Float']['output']>;
  dilr_raw?: Maybe<Scalars['Float']['output']>;
  dilr_scaled?: Maybe<Scalars['Float']['output']>;
  dilr_unattempted?: Maybe<Scalars['Float']['output']>;
  qa_correct?: Maybe<Scalars['Float']['output']>;
  qa_incorrect?: Maybe<Scalars['Float']['output']>;
  qa_unattempted?: Maybe<Scalars['Float']['output']>;
  quant_raw?: Maybe<Scalars['Float']['output']>;
  quant_scaled?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
  total_correct?: Maybe<Scalars['Float']['output']>;
  total_incorrect?: Maybe<Scalars['Float']['output']>;
  total_raw?: Maybe<Scalars['Float']['output']>;
  total_scaled?: Maybe<Scalars['Float']['output']>;
  total_unattempted?: Maybe<Scalars['Float']['output']>;
  varc_correct?: Maybe<Scalars['Float']['output']>;
  varc_incorrect?: Maybe<Scalars['Float']['output']>;
  varc_raw?: Maybe<Scalars['Float']['output']>;
  varc_scaled?: Maybe<Scalars['Float']['output']>;
  varc_unattempted?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Cat_Response_Sheet_Data_Stddev_Pop_Fields = {
  __typename?: 'user_cat_response_sheet_data_stddev_pop_fields';
  dilr_correct?: Maybe<Scalars['Float']['output']>;
  dilr_incorrect?: Maybe<Scalars['Float']['output']>;
  dilr_raw?: Maybe<Scalars['Float']['output']>;
  dilr_scaled?: Maybe<Scalars['Float']['output']>;
  dilr_unattempted?: Maybe<Scalars['Float']['output']>;
  qa_correct?: Maybe<Scalars['Float']['output']>;
  qa_incorrect?: Maybe<Scalars['Float']['output']>;
  qa_unattempted?: Maybe<Scalars['Float']['output']>;
  quant_raw?: Maybe<Scalars['Float']['output']>;
  quant_scaled?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
  total_correct?: Maybe<Scalars['Float']['output']>;
  total_incorrect?: Maybe<Scalars['Float']['output']>;
  total_raw?: Maybe<Scalars['Float']['output']>;
  total_scaled?: Maybe<Scalars['Float']['output']>;
  total_unattempted?: Maybe<Scalars['Float']['output']>;
  varc_correct?: Maybe<Scalars['Float']['output']>;
  varc_incorrect?: Maybe<Scalars['Float']['output']>;
  varc_raw?: Maybe<Scalars['Float']['output']>;
  varc_scaled?: Maybe<Scalars['Float']['output']>;
  varc_unattempted?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Cat_Response_Sheet_Data_Stddev_Samp_Fields = {
  __typename?: 'user_cat_response_sheet_data_stddev_samp_fields';
  dilr_correct?: Maybe<Scalars['Float']['output']>;
  dilr_incorrect?: Maybe<Scalars['Float']['output']>;
  dilr_raw?: Maybe<Scalars['Float']['output']>;
  dilr_scaled?: Maybe<Scalars['Float']['output']>;
  dilr_unattempted?: Maybe<Scalars['Float']['output']>;
  qa_correct?: Maybe<Scalars['Float']['output']>;
  qa_incorrect?: Maybe<Scalars['Float']['output']>;
  qa_unattempted?: Maybe<Scalars['Float']['output']>;
  quant_raw?: Maybe<Scalars['Float']['output']>;
  quant_scaled?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
  total_correct?: Maybe<Scalars['Float']['output']>;
  total_incorrect?: Maybe<Scalars['Float']['output']>;
  total_raw?: Maybe<Scalars['Float']['output']>;
  total_scaled?: Maybe<Scalars['Float']['output']>;
  total_unattempted?: Maybe<Scalars['Float']['output']>;
  varc_correct?: Maybe<Scalars['Float']['output']>;
  varc_incorrect?: Maybe<Scalars['Float']['output']>;
  varc_raw?: Maybe<Scalars['Float']['output']>;
  varc_scaled?: Maybe<Scalars['Float']['output']>;
  varc_unattempted?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_cat_response_sheet_data" */
export type User_Cat_Response_Sheet_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Cat_Response_Sheet_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Cat_Response_Sheet_Data_Stream_Cursor_Value_Input = {
  application_no?: InputMaybe<Scalars['String']['input']>;
  candidate_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dilr_correct?: InputMaybe<Scalars['Int']['input']>;
  dilr_incorrect?: InputMaybe<Scalars['Int']['input']>;
  dilr_raw?: InputMaybe<Scalars['numeric']['input']>;
  dilr_scaled?: InputMaybe<Scalars['numeric']['input']>;
  dilr_unattempted?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  qa_correct?: InputMaybe<Scalars['Int']['input']>;
  qa_incorrect?: InputMaybe<Scalars['Int']['input']>;
  qa_unattempted?: InputMaybe<Scalars['Int']['input']>;
  quant_raw?: InputMaybe<Scalars['numeric']['input']>;
  quant_scaled?: InputMaybe<Scalars['numeric']['input']>;
  sheet_link?: InputMaybe<Scalars['String']['input']>;
  shift?: InputMaybe<Scalars['Int']['input']>;
  test_center?: InputMaybe<Scalars['String']['input']>;
  total_correct?: InputMaybe<Scalars['Int']['input']>;
  total_incorrect?: InputMaybe<Scalars['Int']['input']>;
  total_raw?: InputMaybe<Scalars['numeric']['input']>;
  total_scaled?: InputMaybe<Scalars['numeric']['input']>;
  total_unattempted?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  varc_correct?: InputMaybe<Scalars['Int']['input']>;
  varc_incorrect?: InputMaybe<Scalars['Int']['input']>;
  varc_raw?: InputMaybe<Scalars['numeric']['input']>;
  varc_scaled?: InputMaybe<Scalars['numeric']['input']>;
  varc_unattempted?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type User_Cat_Response_Sheet_Data_Sum_Fields = {
  __typename?: 'user_cat_response_sheet_data_sum_fields';
  dilr_correct?: Maybe<Scalars['Int']['output']>;
  dilr_incorrect?: Maybe<Scalars['Int']['output']>;
  dilr_raw?: Maybe<Scalars['numeric']['output']>;
  dilr_scaled?: Maybe<Scalars['numeric']['output']>;
  dilr_unattempted?: Maybe<Scalars['Int']['output']>;
  qa_correct?: Maybe<Scalars['Int']['output']>;
  qa_incorrect?: Maybe<Scalars['Int']['output']>;
  qa_unattempted?: Maybe<Scalars['Int']['output']>;
  quant_raw?: Maybe<Scalars['numeric']['output']>;
  quant_scaled?: Maybe<Scalars['numeric']['output']>;
  shift?: Maybe<Scalars['Int']['output']>;
  total_correct?: Maybe<Scalars['Int']['output']>;
  total_incorrect?: Maybe<Scalars['Int']['output']>;
  total_raw?: Maybe<Scalars['numeric']['output']>;
  total_scaled?: Maybe<Scalars['numeric']['output']>;
  total_unattempted?: Maybe<Scalars['Int']['output']>;
  varc_correct?: Maybe<Scalars['Int']['output']>;
  varc_incorrect?: Maybe<Scalars['Int']['output']>;
  varc_raw?: Maybe<Scalars['numeric']['output']>;
  varc_scaled?: Maybe<Scalars['numeric']['output']>;
  varc_unattempted?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "user_cat_response_sheet_data" */
export enum User_Cat_Response_Sheet_Data_Update_Column {
  /** column name */
  ApplicationNo = 'application_no',
  /** column name */
  CandidateName = 'candidate_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DilrCorrect = 'dilr_correct',
  /** column name */
  DilrIncorrect = 'dilr_incorrect',
  /** column name */
  DilrRaw = 'dilr_raw',
  /** column name */
  DilrScaled = 'dilr_scaled',
  /** column name */
  DilrUnattempted = 'dilr_unattempted',
  /** column name */
  Id = 'id',
  /** column name */
  QaCorrect = 'qa_correct',
  /** column name */
  QaIncorrect = 'qa_incorrect',
  /** column name */
  QaUnattempted = 'qa_unattempted',
  /** column name */
  QuantRaw = 'quant_raw',
  /** column name */
  QuantScaled = 'quant_scaled',
  /** column name */
  SheetLink = 'sheet_link',
  /** column name */
  Shift = 'shift',
  /** column name */
  TestCenter = 'test_center',
  /** column name */
  TotalCorrect = 'total_correct',
  /** column name */
  TotalIncorrect = 'total_incorrect',
  /** column name */
  TotalRaw = 'total_raw',
  /** column name */
  TotalScaled = 'total_scaled',
  /** column name */
  TotalUnattempted = 'total_unattempted',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarcCorrect = 'varc_correct',
  /** column name */
  VarcIncorrect = 'varc_incorrect',
  /** column name */
  VarcRaw = 'varc_raw',
  /** column name */
  VarcScaled = 'varc_scaled',
  /** column name */
  VarcUnattempted = 'varc_unattempted'
}

export type User_Cat_Response_Sheet_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Cat_Response_Sheet_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Cat_Response_Sheet_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Cat_Response_Sheet_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Cat_Response_Sheet_Data_Var_Pop_Fields = {
  __typename?: 'user_cat_response_sheet_data_var_pop_fields';
  dilr_correct?: Maybe<Scalars['Float']['output']>;
  dilr_incorrect?: Maybe<Scalars['Float']['output']>;
  dilr_raw?: Maybe<Scalars['Float']['output']>;
  dilr_scaled?: Maybe<Scalars['Float']['output']>;
  dilr_unattempted?: Maybe<Scalars['Float']['output']>;
  qa_correct?: Maybe<Scalars['Float']['output']>;
  qa_incorrect?: Maybe<Scalars['Float']['output']>;
  qa_unattempted?: Maybe<Scalars['Float']['output']>;
  quant_raw?: Maybe<Scalars['Float']['output']>;
  quant_scaled?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
  total_correct?: Maybe<Scalars['Float']['output']>;
  total_incorrect?: Maybe<Scalars['Float']['output']>;
  total_raw?: Maybe<Scalars['Float']['output']>;
  total_scaled?: Maybe<Scalars['Float']['output']>;
  total_unattempted?: Maybe<Scalars['Float']['output']>;
  varc_correct?: Maybe<Scalars['Float']['output']>;
  varc_incorrect?: Maybe<Scalars['Float']['output']>;
  varc_raw?: Maybe<Scalars['Float']['output']>;
  varc_scaled?: Maybe<Scalars['Float']['output']>;
  varc_unattempted?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Cat_Response_Sheet_Data_Var_Samp_Fields = {
  __typename?: 'user_cat_response_sheet_data_var_samp_fields';
  dilr_correct?: Maybe<Scalars['Float']['output']>;
  dilr_incorrect?: Maybe<Scalars['Float']['output']>;
  dilr_raw?: Maybe<Scalars['Float']['output']>;
  dilr_scaled?: Maybe<Scalars['Float']['output']>;
  dilr_unattempted?: Maybe<Scalars['Float']['output']>;
  qa_correct?: Maybe<Scalars['Float']['output']>;
  qa_incorrect?: Maybe<Scalars['Float']['output']>;
  qa_unattempted?: Maybe<Scalars['Float']['output']>;
  quant_raw?: Maybe<Scalars['Float']['output']>;
  quant_scaled?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
  total_correct?: Maybe<Scalars['Float']['output']>;
  total_incorrect?: Maybe<Scalars['Float']['output']>;
  total_raw?: Maybe<Scalars['Float']['output']>;
  total_scaled?: Maybe<Scalars['Float']['output']>;
  total_unattempted?: Maybe<Scalars['Float']['output']>;
  varc_correct?: Maybe<Scalars['Float']['output']>;
  varc_incorrect?: Maybe<Scalars['Float']['output']>;
  varc_raw?: Maybe<Scalars['Float']['output']>;
  varc_scaled?: Maybe<Scalars['Float']['output']>;
  varc_unattempted?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Cat_Response_Sheet_Data_Variance_Fields = {
  __typename?: 'user_cat_response_sheet_data_variance_fields';
  dilr_correct?: Maybe<Scalars['Float']['output']>;
  dilr_incorrect?: Maybe<Scalars['Float']['output']>;
  dilr_raw?: Maybe<Scalars['Float']['output']>;
  dilr_scaled?: Maybe<Scalars['Float']['output']>;
  dilr_unattempted?: Maybe<Scalars['Float']['output']>;
  qa_correct?: Maybe<Scalars['Float']['output']>;
  qa_incorrect?: Maybe<Scalars['Float']['output']>;
  qa_unattempted?: Maybe<Scalars['Float']['output']>;
  quant_raw?: Maybe<Scalars['Float']['output']>;
  quant_scaled?: Maybe<Scalars['Float']['output']>;
  shift?: Maybe<Scalars['Float']['output']>;
  total_correct?: Maybe<Scalars['Float']['output']>;
  total_incorrect?: Maybe<Scalars['Float']['output']>;
  total_raw?: Maybe<Scalars['Float']['output']>;
  total_scaled?: Maybe<Scalars['Float']['output']>;
  total_unattempted?: Maybe<Scalars['Float']['output']>;
  varc_correct?: Maybe<Scalars['Float']['output']>;
  varc_incorrect?: Maybe<Scalars['Float']['output']>;
  varc_raw?: Maybe<Scalars['Float']['output']>;
  varc_scaled?: Maybe<Scalars['Float']['output']>;
  varc_unattempted?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_custom_planned_activities" */
export type User_Custom_Planned_Activities = {
  __typename?: 'user_custom_planned_activities';
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  schedule_end_date: Scalars['timestamptz']['output'];
  scheduled_at: Scalars['timestamptz']['output'];
  topic: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "user_custom_planned_activities" */
export type User_Custom_Planned_Activities_Aggregate = {
  __typename?: 'user_custom_planned_activities_aggregate';
  aggregate?: Maybe<User_Custom_Planned_Activities_Aggregate_Fields>;
  nodes: Array<User_Custom_Planned_Activities>;
};

/** aggregate fields of "user_custom_planned_activities" */
export type User_Custom_Planned_Activities_Aggregate_Fields = {
  __typename?: 'user_custom_planned_activities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Custom_Planned_Activities_Max_Fields>;
  min?: Maybe<User_Custom_Planned_Activities_Min_Fields>;
};


/** aggregate fields of "user_custom_planned_activities" */
export type User_Custom_Planned_Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Custom_Planned_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_custom_planned_activities". All fields are combined with a logical 'AND'. */
export type User_Custom_Planned_Activities_Bool_Exp = {
  _and?: InputMaybe<Array<User_Custom_Planned_Activities_Bool_Exp>>;
  _not?: InputMaybe<User_Custom_Planned_Activities_Bool_Exp>;
  _or?: InputMaybe<Array<User_Custom_Planned_Activities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  schedule_end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  scheduled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  topic?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_custom_planned_activities" */
export enum User_Custom_Planned_Activities_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserCustomPlannedActivitiesPkey = 'user_custom_planned_activities_pkey'
}

/** input type for inserting data into table "user_custom_planned_activities" */
export type User_Custom_Planned_Activities_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  schedule_end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Custom_Planned_Activities_Max_Fields = {
  __typename?: 'user_custom_planned_activities_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  schedule_end_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Custom_Planned_Activities_Min_Fields = {
  __typename?: 'user_custom_planned_activities_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  schedule_end_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_custom_planned_activities" */
export type User_Custom_Planned_Activities_Mutation_Response = {
  __typename?: 'user_custom_planned_activities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Custom_Planned_Activities>;
};

/** on_conflict condition type for table "user_custom_planned_activities" */
export type User_Custom_Planned_Activities_On_Conflict = {
  constraint: User_Custom_Planned_Activities_Constraint;
  update_columns?: Array<User_Custom_Planned_Activities_Update_Column>;
  where?: InputMaybe<User_Custom_Planned_Activities_Bool_Exp>;
};

/** Ordering options when selecting data from "user_custom_planned_activities". */
export type User_Custom_Planned_Activities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  schedule_end_date?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  topic?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_custom_planned_activities */
export type User_Custom_Planned_Activities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_custom_planned_activities" */
export enum User_Custom_Planned_Activities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ScheduleEndDate = 'schedule_end_date',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_custom_planned_activities" */
export type User_Custom_Planned_Activities_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  schedule_end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_custom_planned_activities" */
export type User_Custom_Planned_Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Custom_Planned_Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Custom_Planned_Activities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  schedule_end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_custom_planned_activities" */
export enum User_Custom_Planned_Activities_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ScheduleEndDate = 'schedule_end_date',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Custom_Planned_Activities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Custom_Planned_Activities_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Custom_Planned_Activities_Bool_Exp;
};

/** columns and relationships of "user_latest_payment_transaction" */
export type User_Latest_Payment_Transaction = {
  __typename?: 'user_latest_payment_transaction';
  is_latest_payment?: Maybe<Scalars['Boolean']['output']>;
  latest_payment_created_at?: Maybe<Scalars['timestamptz']['output']>;
  latest_payment_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_latest_payment_transaction" */
export type User_Latest_Payment_Transaction_Aggregate = {
  __typename?: 'user_latest_payment_transaction_aggregate';
  aggregate?: Maybe<User_Latest_Payment_Transaction_Aggregate_Fields>;
  nodes: Array<User_Latest_Payment_Transaction>;
};

/** aggregate fields of "user_latest_payment_transaction" */
export type User_Latest_Payment_Transaction_Aggregate_Fields = {
  __typename?: 'user_latest_payment_transaction_aggregate_fields';
  avg?: Maybe<User_Latest_Payment_Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Latest_Payment_Transaction_Max_Fields>;
  min?: Maybe<User_Latest_Payment_Transaction_Min_Fields>;
  stddev?: Maybe<User_Latest_Payment_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<User_Latest_Payment_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Latest_Payment_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<User_Latest_Payment_Transaction_Sum_Fields>;
  var_pop?: Maybe<User_Latest_Payment_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<User_Latest_Payment_Transaction_Var_Samp_Fields>;
  variance?: Maybe<User_Latest_Payment_Transaction_Variance_Fields>;
};


/** aggregate fields of "user_latest_payment_transaction" */
export type User_Latest_Payment_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Latest_Payment_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Latest_Payment_Transaction_Avg_Fields = {
  __typename?: 'user_latest_payment_transaction_avg_fields';
  latest_payment_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_latest_payment_transaction". All fields are combined with a logical 'AND'. */
export type User_Latest_Payment_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<User_Latest_Payment_Transaction_Bool_Exp>>;
  _not?: InputMaybe<User_Latest_Payment_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<User_Latest_Payment_Transaction_Bool_Exp>>;
  is_latest_payment?: InputMaybe<Boolean_Comparison_Exp>;
  latest_payment_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  latest_payment_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type User_Latest_Payment_Transaction_Max_Fields = {
  __typename?: 'user_latest_payment_transaction_max_fields';
  latest_payment_created_at?: Maybe<Scalars['timestamptz']['output']>;
  latest_payment_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Latest_Payment_Transaction_Min_Fields = {
  __typename?: 'user_latest_payment_transaction_min_fields';
  latest_payment_created_at?: Maybe<Scalars['timestamptz']['output']>;
  latest_payment_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "user_latest_payment_transaction". */
export type User_Latest_Payment_Transaction_Order_By = {
  is_latest_payment?: InputMaybe<Order_By>;
  latest_payment_created_at?: InputMaybe<Order_By>;
  latest_payment_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_latest_payment_transaction" */
export enum User_Latest_Payment_Transaction_Select_Column {
  /** column name */
  IsLatestPayment = 'is_latest_payment',
  /** column name */
  LatestPaymentCreatedAt = 'latest_payment_created_at',
  /** column name */
  LatestPaymentId = 'latest_payment_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type User_Latest_Payment_Transaction_Stddev_Fields = {
  __typename?: 'user_latest_payment_transaction_stddev_fields';
  latest_payment_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Latest_Payment_Transaction_Stddev_Pop_Fields = {
  __typename?: 'user_latest_payment_transaction_stddev_pop_fields';
  latest_payment_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Latest_Payment_Transaction_Stddev_Samp_Fields = {
  __typename?: 'user_latest_payment_transaction_stddev_samp_fields';
  latest_payment_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_latest_payment_transaction" */
export type User_Latest_Payment_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Latest_Payment_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Latest_Payment_Transaction_Stream_Cursor_Value_Input = {
  is_latest_payment?: InputMaybe<Scalars['Boolean']['input']>;
  latest_payment_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  latest_payment_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Latest_Payment_Transaction_Sum_Fields = {
  __typename?: 'user_latest_payment_transaction_sum_fields';
  latest_payment_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type User_Latest_Payment_Transaction_Var_Pop_Fields = {
  __typename?: 'user_latest_payment_transaction_var_pop_fields';
  latest_payment_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Latest_Payment_Transaction_Var_Samp_Fields = {
  __typename?: 'user_latest_payment_transaction_var_samp_fields';
  latest_payment_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Latest_Payment_Transaction_Variance_Fields = {
  __typename?: 'user_latest_payment_transaction_variance_fields';
  latest_payment_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_leaderboard_types" */
export type User_Leaderboard_Types = {
  __typename?: 'user_leaderboard_types';
  category: Scalars['String']['output'];
  sub_type: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /** An array relationship */
  user_leaderboards: Array<User_Leaderboards>;
  /** An aggregate relationship */
  user_leaderboards_aggregate: User_Leaderboards_Aggregate;
};


/** columns and relationships of "user_leaderboard_types" */
export type User_Leaderboard_TypesUser_LeaderboardsArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboards_Order_By>>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};


/** columns and relationships of "user_leaderboard_types" */
export type User_Leaderboard_TypesUser_Leaderboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Leaderboards_Order_By>>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};

/** aggregated selection of "user_leaderboard_types" */
export type User_Leaderboard_Types_Aggregate = {
  __typename?: 'user_leaderboard_types_aggregate';
  aggregate?: Maybe<User_Leaderboard_Types_Aggregate_Fields>;
  nodes: Array<User_Leaderboard_Types>;
};

/** aggregate fields of "user_leaderboard_types" */
export type User_Leaderboard_Types_Aggregate_Fields = {
  __typename?: 'user_leaderboard_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Leaderboard_Types_Max_Fields>;
  min?: Maybe<User_Leaderboard_Types_Min_Fields>;
};


/** aggregate fields of "user_leaderboard_types" */
export type User_Leaderboard_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Leaderboard_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_leaderboard_types". All fields are combined with a logical 'AND'. */
export type User_Leaderboard_Types_Bool_Exp = {
  _and?: InputMaybe<Array<User_Leaderboard_Types_Bool_Exp>>;
  _not?: InputMaybe<User_Leaderboard_Types_Bool_Exp>;
  _or?: InputMaybe<Array<User_Leaderboard_Types_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  sub_type?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_leaderboards?: InputMaybe<User_Leaderboards_Bool_Exp>;
  user_leaderboards_aggregate?: InputMaybe<User_Leaderboards_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user_leaderboard_types" */
export enum User_Leaderboard_Types_Constraint {
  /** unique or primary key constraint on columns "type", "sub_type", "category" */
  UserLeaderboardTypesPkey = 'user_leaderboard_types_pkey'
}

/** input type for inserting data into table "user_leaderboard_types" */
export type User_Leaderboard_Types_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  sub_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_leaderboards?: InputMaybe<User_Leaderboards_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Leaderboard_Types_Max_Fields = {
  __typename?: 'user_leaderboard_types_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Leaderboard_Types_Min_Fields = {
  __typename?: 'user_leaderboard_types_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_leaderboard_types" */
export type User_Leaderboard_Types_Mutation_Response = {
  __typename?: 'user_leaderboard_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Leaderboard_Types>;
};

/** input type for inserting object relation for remote table "user_leaderboard_types" */
export type User_Leaderboard_Types_Obj_Rel_Insert_Input = {
  data: User_Leaderboard_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Leaderboard_Types_On_Conflict>;
};

/** on_conflict condition type for table "user_leaderboard_types" */
export type User_Leaderboard_Types_On_Conflict = {
  constraint: User_Leaderboard_Types_Constraint;
  update_columns?: Array<User_Leaderboard_Types_Update_Column>;
  where?: InputMaybe<User_Leaderboard_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "user_leaderboard_types". */
export type User_Leaderboard_Types_Order_By = {
  category?: InputMaybe<Order_By>;
  sub_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_leaderboards_aggregate?: InputMaybe<User_Leaderboards_Aggregate_Order_By>;
};

/** primary key columns input for table: user_leaderboard_types */
export type User_Leaderboard_Types_Pk_Columns_Input = {
  category: Scalars['String']['input'];
  sub_type: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** select columns of table "user_leaderboard_types" */
export enum User_Leaderboard_Types_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  SubType = 'sub_type',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "user_leaderboard_types" */
export type User_Leaderboard_Types_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  sub_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_leaderboard_types" */
export type User_Leaderboard_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Leaderboard_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Leaderboard_Types_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  sub_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_leaderboard_types" */
export enum User_Leaderboard_Types_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  SubType = 'sub_type',
  /** column name */
  Type = 'type'
}

export type User_Leaderboard_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Leaderboard_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Leaderboard_Types_Bool_Exp;
};

/** columns and relationships of "user_leaderboards" */
export type User_Leaderboards = {
  __typename?: 'user_leaderboards';
  category: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  sub_type: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Supertokens_User_Public_Fields>;
  user_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user_leaderboard_type?: Maybe<User_Leaderboard_Types>;
};

/** aggregated selection of "user_leaderboards" */
export type User_Leaderboards_Aggregate = {
  __typename?: 'user_leaderboards_aggregate';
  aggregate?: Maybe<User_Leaderboards_Aggregate_Fields>;
  nodes: Array<User_Leaderboards>;
};

export type User_Leaderboards_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Leaderboards_Aggregate_Bool_Exp_Count>;
};

export type User_Leaderboards_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Leaderboards_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_leaderboards" */
export type User_Leaderboards_Aggregate_Fields = {
  __typename?: 'user_leaderboards_aggregate_fields';
  avg?: Maybe<User_Leaderboards_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Leaderboards_Max_Fields>;
  min?: Maybe<User_Leaderboards_Min_Fields>;
  stddev?: Maybe<User_Leaderboards_Stddev_Fields>;
  stddev_pop?: Maybe<User_Leaderboards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Leaderboards_Stddev_Samp_Fields>;
  sum?: Maybe<User_Leaderboards_Sum_Fields>;
  var_pop?: Maybe<User_Leaderboards_Var_Pop_Fields>;
  var_samp?: Maybe<User_Leaderboards_Var_Samp_Fields>;
  variance?: Maybe<User_Leaderboards_Variance_Fields>;
};


/** aggregate fields of "user_leaderboards" */
export type User_Leaderboards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Leaderboards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_leaderboards" */
export type User_Leaderboards_Aggregate_Order_By = {
  avg?: InputMaybe<User_Leaderboards_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Leaderboards_Max_Order_By>;
  min?: InputMaybe<User_Leaderboards_Min_Order_By>;
  stddev?: InputMaybe<User_Leaderboards_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Leaderboards_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Leaderboards_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Leaderboards_Sum_Order_By>;
  var_pop?: InputMaybe<User_Leaderboards_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Leaderboards_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Leaderboards_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_leaderboards" */
export type User_Leaderboards_Arr_Rel_Insert_Input = {
  data: Array<User_Leaderboards_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Leaderboards_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Leaderboards_Avg_Fields = {
  __typename?: 'user_leaderboards_avg_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_leaderboards" */
export type User_Leaderboards_Avg_Order_By = {
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_leaderboards". All fields are combined with a logical 'AND'. */
export type User_Leaderboards_Bool_Exp = {
  _and?: InputMaybe<Array<User_Leaderboards_Bool_Exp>>;
  _not?: InputMaybe<User_Leaderboards_Bool_Exp>;
  _or?: InputMaybe<Array<User_Leaderboards_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Int_Comparison_Exp>;
  sub_type?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_leaderboard_type?: InputMaybe<User_Leaderboard_Types_Bool_Exp>;
};

/** unique or primary key constraints on table "user_leaderboards" */
export enum User_Leaderboards_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserLeaderboardsPkey = 'user_leaderboards_pkey',
  /** unique or primary key constraint on columns "rank", "user_id", "type", "sub_type", "category" */
  UserLeaderboardsUserIdTypeCategorySubTypePositionKey = 'user_leaderboards_user_id_type_category_sub_type_position_key'
}

/** input type for incrementing numeric columns in table "user_leaderboards" */
export type User_Leaderboards_Inc_Input = {
  rank?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_leaderboards" */
export type User_Leaderboards_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  sub_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_leaderboard_type?: InputMaybe<User_Leaderboard_Types_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Leaderboards_Max_Fields = {
  __typename?: 'user_leaderboards_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_leaderboards" */
export type User_Leaderboards_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  sub_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Leaderboards_Min_Fields = {
  __typename?: 'user_leaderboards_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_leaderboards" */
export type User_Leaderboards_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  sub_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_leaderboards" */
export type User_Leaderboards_Mutation_Response = {
  __typename?: 'user_leaderboards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Leaderboards>;
};

/** on_conflict condition type for table "user_leaderboards" */
export type User_Leaderboards_On_Conflict = {
  constraint: User_Leaderboards_Constraint;
  update_columns?: Array<User_Leaderboards_Update_Column>;
  where?: InputMaybe<User_Leaderboards_Bool_Exp>;
};

/** Ordering options when selecting data from "user_leaderboards". */
export type User_Leaderboards_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  sub_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_User_Public_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_leaderboard_type?: InputMaybe<User_Leaderboard_Types_Order_By>;
};

/** primary key columns input for table: user_leaderboards */
export type User_Leaderboards_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_leaderboards" */
export enum User_Leaderboards_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Score = 'score',
  /** column name */
  SubType = 'sub_type',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_leaderboards" */
export type User_Leaderboards_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  sub_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Leaderboards_Stddev_Fields = {
  __typename?: 'user_leaderboards_stddev_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_leaderboards" */
export type User_Leaderboards_Stddev_Order_By = {
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Leaderboards_Stddev_Pop_Fields = {
  __typename?: 'user_leaderboards_stddev_pop_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_leaderboards" */
export type User_Leaderboards_Stddev_Pop_Order_By = {
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Leaderboards_Stddev_Samp_Fields = {
  __typename?: 'user_leaderboards_stddev_samp_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_leaderboards" */
export type User_Leaderboards_Stddev_Samp_Order_By = {
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_leaderboards" */
export type User_Leaderboards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Leaderboards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Leaderboards_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  sub_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Leaderboards_Sum_Fields = {
  __typename?: 'user_leaderboards_sum_fields';
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_leaderboards" */
export type User_Leaderboards_Sum_Order_By = {
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** update columns of table "user_leaderboards" */
export enum User_Leaderboards_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Score = 'score',
  /** column name */
  SubType = 'sub_type',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Leaderboards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Leaderboards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Leaderboards_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Leaderboards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Leaderboards_Var_Pop_Fields = {
  __typename?: 'user_leaderboards_var_pop_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_leaderboards" */
export type User_Leaderboards_Var_Pop_Order_By = {
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Leaderboards_Var_Samp_Fields = {
  __typename?: 'user_leaderboards_var_samp_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_leaderboards" */
export type User_Leaderboards_Var_Samp_Order_By = {
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Leaderboards_Variance_Fields = {
  __typename?: 'user_leaderboards_variance_fields';
  rank?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_leaderboards" */
export type User_Leaderboards_Variance_Order_By = {
  rank?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_learn_activities" */
export type User_Learn_Activities = {
  __typename?: 'user_learn_activities';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  time_spent: Scalars['interval']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_learn_modules_summary: User_Learn_Modules_Summary;
  user_learn_summary_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_learn_activities" */
export type User_Learn_Activities_Aggregate = {
  __typename?: 'user_learn_activities_aggregate';
  aggregate?: Maybe<User_Learn_Activities_Aggregate_Fields>;
  nodes: Array<User_Learn_Activities>;
};

export type User_Learn_Activities_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Learn_Activities_Aggregate_Bool_Exp_Count>;
};

export type User_Learn_Activities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Learn_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Activities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_learn_activities" */
export type User_Learn_Activities_Aggregate_Fields = {
  __typename?: 'user_learn_activities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Learn_Activities_Max_Fields>;
  min?: Maybe<User_Learn_Activities_Min_Fields>;
};


/** aggregate fields of "user_learn_activities" */
export type User_Learn_Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Learn_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_learn_activities" */
export type User_Learn_Activities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Learn_Activities_Max_Order_By>;
  min?: InputMaybe<User_Learn_Activities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_learn_activities" */
export type User_Learn_Activities_Arr_Rel_Insert_Input = {
  data: Array<User_Learn_Activities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Learn_Activities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_learn_activities". All fields are combined with a logical 'AND'. */
export type User_Learn_Activities_Bool_Exp = {
  _and?: InputMaybe<Array<User_Learn_Activities_Bool_Exp>>;
  _not?: InputMaybe<User_Learn_Activities_Bool_Exp>;
  _or?: InputMaybe<Array<User_Learn_Activities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  time_spent?: InputMaybe<Interval_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_learn_modules_summary?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
  user_learn_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_learn_activities" */
export enum User_Learn_Activities_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserLearnActivitiesPkey = 'user_learn_activities_pkey'
}

/** input type for inserting data into table "user_learn_activities" */
export type User_Learn_Activities_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  time_spent?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_learn_modules_summary?: InputMaybe<User_Learn_Modules_Summary_Obj_Rel_Insert_Input>;
  user_learn_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Learn_Activities_Max_Fields = {
  __typename?: 'user_learn_activities_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_learn_summary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_learn_activities" */
export type User_Learn_Activities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_learn_summary_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Learn_Activities_Min_Fields = {
  __typename?: 'user_learn_activities_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_learn_summary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_learn_activities" */
export type User_Learn_Activities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_learn_summary_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_learn_activities" */
export type User_Learn_Activities_Mutation_Response = {
  __typename?: 'user_learn_activities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Learn_Activities>;
};

/** on_conflict condition type for table "user_learn_activities" */
export type User_Learn_Activities_On_Conflict = {
  constraint: User_Learn_Activities_Constraint;
  update_columns?: Array<User_Learn_Activities_Update_Column>;
  where?: InputMaybe<User_Learn_Activities_Bool_Exp>;
};

/** Ordering options when selecting data from "user_learn_activities". */
export type User_Learn_Activities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_learn_modules_summary?: InputMaybe<User_Learn_Modules_Summary_Order_By>;
  user_learn_summary_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_learn_activities */
export type User_Learn_Activities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_learn_activities" */
export enum User_Learn_Activities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TimeSpent = 'time_spent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserLearnSummaryId = 'user_learn_summary_id'
}

/** input type for updating data in table "user_learn_activities" */
export type User_Learn_Activities_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  time_spent?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_learn_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_learn_activities" */
export type User_Learn_Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Learn_Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Learn_Activities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  time_spent?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_learn_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_learn_activities" */
export enum User_Learn_Activities_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TimeSpent = 'time_spent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserLearnSummaryId = 'user_learn_summary_id'
}

export type User_Learn_Activities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Learn_Activities_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Learn_Activities_Bool_Exp;
};

/** columns and relationships of "user_learn_category_progress" */
export type User_Learn_Category_Progress = {
  __typename?: 'user_learn_category_progress';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  category_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  quiz_category: Quiz_Category;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "user_learn_category_progress" */
export type User_Learn_Category_Progress_Aggregate = {
  __typename?: 'user_learn_category_progress_aggregate';
  aggregate?: Maybe<User_Learn_Category_Progress_Aggregate_Fields>;
  nodes: Array<User_Learn_Category_Progress>;
};

export type User_Learn_Category_Progress_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Learn_Category_Progress_Aggregate_Bool_Exp_Count>;
};

export type User_Learn_Category_Progress_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_learn_category_progress" */
export type User_Learn_Category_Progress_Aggregate_Fields = {
  __typename?: 'user_learn_category_progress_aggregate_fields';
  avg?: Maybe<User_Learn_Category_Progress_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Learn_Category_Progress_Max_Fields>;
  min?: Maybe<User_Learn_Category_Progress_Min_Fields>;
  stddev?: Maybe<User_Learn_Category_Progress_Stddev_Fields>;
  stddev_pop?: Maybe<User_Learn_Category_Progress_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Learn_Category_Progress_Stddev_Samp_Fields>;
  sum?: Maybe<User_Learn_Category_Progress_Sum_Fields>;
  var_pop?: Maybe<User_Learn_Category_Progress_Var_Pop_Fields>;
  var_samp?: Maybe<User_Learn_Category_Progress_Var_Samp_Fields>;
  variance?: Maybe<User_Learn_Category_Progress_Variance_Fields>;
};


/** aggregate fields of "user_learn_category_progress" */
export type User_Learn_Category_Progress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Learn_Category_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Aggregate_Order_By = {
  avg?: InputMaybe<User_Learn_Category_Progress_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Learn_Category_Progress_Max_Order_By>;
  min?: InputMaybe<User_Learn_Category_Progress_Min_Order_By>;
  stddev?: InputMaybe<User_Learn_Category_Progress_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Learn_Category_Progress_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Learn_Category_Progress_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Learn_Category_Progress_Sum_Order_By>;
  var_pop?: InputMaybe<User_Learn_Category_Progress_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Learn_Category_Progress_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Learn_Category_Progress_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Arr_Rel_Insert_Input = {
  data: Array<User_Learn_Category_Progress_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Learn_Category_Progress_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Learn_Category_Progress_Avg_Fields = {
  __typename?: 'user_learn_category_progress_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_learn_category_progress". All fields are combined with a logical 'AND'. */
export type User_Learn_Category_Progress_Bool_Exp = {
  _and?: InputMaybe<Array<User_Learn_Category_Progress_Bool_Exp>>;
  _not?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
  _or?: InputMaybe<Array<User_Learn_Category_Progress_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_learn_category_progress" */
export enum User_Learn_Category_Progress_Constraint {
  /** unique or primary key constraint on columns "user_id", "category_id" */
  UserLearnCategoryProgressCategoryIdUserIdKey = 'user_learn_category_progress_category_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  UserLearnCategoryProgressPkey = 'user_learn_category_progress_pkey'
}

/** input type for incrementing numeric columns in table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Learn_Category_Progress_Max_Fields = {
  __typename?: 'user_learn_category_progress_max_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Learn_Category_Progress_Min_Fields = {
  __typename?: 'user_learn_category_progress_min_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Mutation_Response = {
  __typename?: 'user_learn_category_progress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Learn_Category_Progress>;
};

/** on_conflict condition type for table "user_learn_category_progress" */
export type User_Learn_Category_Progress_On_Conflict = {
  constraint: User_Learn_Category_Progress_Constraint;
  update_columns?: Array<User_Learn_Category_Progress_Update_Column>;
  where?: InputMaybe<User_Learn_Category_Progress_Bool_Exp>;
};

/** Ordering options when selecting data from "user_learn_category_progress". */
export type User_Learn_Category_Progress_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_learn_category_progress */
export type User_Learn_Category_Progress_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_learn_category_progress" */
export enum User_Learn_Category_Progress_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Learn_Category_Progress_Stddev_Fields = {
  __typename?: 'user_learn_category_progress_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Learn_Category_Progress_Stddev_Pop_Fields = {
  __typename?: 'user_learn_category_progress_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Learn_Category_Progress_Stddev_Samp_Fields = {
  __typename?: 'user_learn_category_progress_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Learn_Category_Progress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Learn_Category_Progress_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Learn_Category_Progress_Sum_Fields = {
  __typename?: 'user_learn_category_progress_sum_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_learn_category_progress" */
export enum User_Learn_Category_Progress_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Learn_Category_Progress_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Learn_Category_Progress_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Learn_Category_Progress_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Learn_Category_Progress_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Learn_Category_Progress_Var_Pop_Fields = {
  __typename?: 'user_learn_category_progress_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Learn_Category_Progress_Var_Samp_Fields = {
  __typename?: 'user_learn_category_progress_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Learn_Category_Progress_Variance_Fields = {
  __typename?: 'user_learn_category_progress_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_learn_category_progress" */
export type User_Learn_Category_Progress_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_learn_completed_topics" */
export type User_Learn_Completed_Topics = {
  __typename?: 'user_learn_completed_topics';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  /** An object relationship */
  andablog_entry: Andablog_Entry;
  created_at: Scalars['timestamptz']['output'];
  entry_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Aggregate = {
  __typename?: 'user_learn_completed_topics_aggregate';
  aggregate?: Maybe<User_Learn_Completed_Topics_Aggregate_Fields>;
  nodes: Array<User_Learn_Completed_Topics>;
};

export type User_Learn_Completed_Topics_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Learn_Completed_Topics_Aggregate_Bool_Exp_Count>;
};

export type User_Learn_Completed_Topics_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Aggregate_Fields = {
  __typename?: 'user_learn_completed_topics_aggregate_fields';
  avg?: Maybe<User_Learn_Completed_Topics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Learn_Completed_Topics_Max_Fields>;
  min?: Maybe<User_Learn_Completed_Topics_Min_Fields>;
  stddev?: Maybe<User_Learn_Completed_Topics_Stddev_Fields>;
  stddev_pop?: Maybe<User_Learn_Completed_Topics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Learn_Completed_Topics_Stddev_Samp_Fields>;
  sum?: Maybe<User_Learn_Completed_Topics_Sum_Fields>;
  var_pop?: Maybe<User_Learn_Completed_Topics_Var_Pop_Fields>;
  var_samp?: Maybe<User_Learn_Completed_Topics_Var_Samp_Fields>;
  variance?: Maybe<User_Learn_Completed_Topics_Variance_Fields>;
};


/** aggregate fields of "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Learn_Completed_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Aggregate_Order_By = {
  avg?: InputMaybe<User_Learn_Completed_Topics_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Learn_Completed_Topics_Max_Order_By>;
  min?: InputMaybe<User_Learn_Completed_Topics_Min_Order_By>;
  stddev?: InputMaybe<User_Learn_Completed_Topics_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Learn_Completed_Topics_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Learn_Completed_Topics_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Learn_Completed_Topics_Sum_Order_By>;
  var_pop?: InputMaybe<User_Learn_Completed_Topics_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Learn_Completed_Topics_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Learn_Completed_Topics_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Arr_Rel_Insert_Input = {
  data: Array<User_Learn_Completed_Topics_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Learn_Completed_Topics_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Learn_Completed_Topics_Avg_Fields = {
  __typename?: 'user_learn_completed_topics_avg_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_learn_completed_topics". All fields are combined with a logical 'AND'. */
export type User_Learn_Completed_Topics_Bool_Exp = {
  _and?: InputMaybe<Array<User_Learn_Completed_Topics_Bool_Exp>>;
  _not?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
  _or?: InputMaybe<Array<User_Learn_Completed_Topics_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_learn_completed_topics" */
export enum User_Learn_Completed_Topics_Constraint {
  /** unique or primary key constraint on columns "entry_id", "user_id" */
  UserLearnCompletedTopicsEntryIdUserIdKey = 'user_learn_completed_topics_entry_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  UserLearnCompletedTopicsPkey = 'user_learn_completed_topics_pkey'
}

/** input type for incrementing numeric columns in table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Learn_Completed_Topics_Max_Fields = {
  __typename?: 'user_learn_completed_topics_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Learn_Completed_Topics_Min_Fields = {
  __typename?: 'user_learn_completed_topics_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Mutation_Response = {
  __typename?: 'user_learn_completed_topics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Learn_Completed_Topics>;
};

/** on_conflict condition type for table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_On_Conflict = {
  constraint: User_Learn_Completed_Topics_Constraint;
  update_columns?: Array<User_Learn_Completed_Topics_Update_Column>;
  where?: InputMaybe<User_Learn_Completed_Topics_Bool_Exp>;
};

/** Ordering options when selecting data from "user_learn_completed_topics". */
export type User_Learn_Completed_Topics_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_learn_completed_topics */
export type User_Learn_Completed_Topics_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_learn_completed_topics" */
export enum User_Learn_Completed_Topics_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Learn_Completed_Topics_Stddev_Fields = {
  __typename?: 'user_learn_completed_topics_stddev_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Learn_Completed_Topics_Stddev_Pop_Fields = {
  __typename?: 'user_learn_completed_topics_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Learn_Completed_Topics_Stddev_Samp_Fields = {
  __typename?: 'user_learn_completed_topics_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Learn_Completed_Topics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Learn_Completed_Topics_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Learn_Completed_Topics_Sum_Fields = {
  __typename?: 'user_learn_completed_topics_sum_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_learn_completed_topics" */
export enum User_Learn_Completed_Topics_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Learn_Completed_Topics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Learn_Completed_Topics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Learn_Completed_Topics_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Learn_Completed_Topics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Learn_Completed_Topics_Var_Pop_Fields = {
  __typename?: 'user_learn_completed_topics_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Learn_Completed_Topics_Var_Samp_Fields = {
  __typename?: 'user_learn_completed_topics_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Learn_Completed_Topics_Variance_Fields = {
  __typename?: 'user_learn_completed_topics_variance_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_learn_completed_topics" */
export type User_Learn_Completed_Topics_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_learn_modules_summary" */
export type User_Learn_Modules_Summary = {
  __typename?: 'user_learn_modules_summary';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  /** An object relationship */
  andablog_entry: Andablog_Entry;
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  entry_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  is_bookmarked: Scalars['Boolean']['output'];
  last_visited: Scalars['timestamptz']['output'];
  time_spent: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
  /** An array relationship */
  user_learn_activities: Array<User_Learn_Activities>;
  /** An aggregate relationship */
  user_learn_activities_aggregate: User_Learn_Activities_Aggregate;
};


/** columns and relationships of "user_learn_modules_summary" */
export type User_Learn_Modules_SummaryUser_Learn_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Activities_Order_By>>;
  where?: InputMaybe<User_Learn_Activities_Bool_Exp>;
};


/** columns and relationships of "user_learn_modules_summary" */
export type User_Learn_Modules_SummaryUser_Learn_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Activities_Order_By>>;
  where?: InputMaybe<User_Learn_Activities_Bool_Exp>;
};

/** aggregated selection of "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Aggregate = {
  __typename?: 'user_learn_modules_summary_aggregate';
  aggregate?: Maybe<User_Learn_Modules_Summary_Aggregate_Fields>;
  nodes: Array<User_Learn_Modules_Summary>;
};

export type User_Learn_Modules_Summary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Learn_Modules_Summary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Learn_Modules_Summary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Learn_Modules_Summary_Aggregate_Bool_Exp_Count>;
};

export type User_Learn_Modules_Summary_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Learn_Modules_Summary_Select_Column_User_Learn_Modules_Summary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Learn_Modules_Summary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Learn_Modules_Summary_Select_Column_User_Learn_Modules_Summary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Learn_Modules_Summary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Aggregate_Fields = {
  __typename?: 'user_learn_modules_summary_aggregate_fields';
  avg?: Maybe<User_Learn_Modules_Summary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Learn_Modules_Summary_Max_Fields>;
  min?: Maybe<User_Learn_Modules_Summary_Min_Fields>;
  stddev?: Maybe<User_Learn_Modules_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<User_Learn_Modules_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Learn_Modules_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<User_Learn_Modules_Summary_Sum_Fields>;
  var_pop?: Maybe<User_Learn_Modules_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<User_Learn_Modules_Summary_Var_Samp_Fields>;
  variance?: Maybe<User_Learn_Modules_Summary_Variance_Fields>;
};


/** aggregate fields of "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Learn_Modules_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Aggregate_Order_By = {
  avg?: InputMaybe<User_Learn_Modules_Summary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Learn_Modules_Summary_Max_Order_By>;
  min?: InputMaybe<User_Learn_Modules_Summary_Min_Order_By>;
  stddev?: InputMaybe<User_Learn_Modules_Summary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Learn_Modules_Summary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Learn_Modules_Summary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Learn_Modules_Summary_Sum_Order_By>;
  var_pop?: InputMaybe<User_Learn_Modules_Summary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Learn_Modules_Summary_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Learn_Modules_Summary_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Arr_Rel_Insert_Input = {
  data: Array<User_Learn_Modules_Summary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Learn_Modules_Summary_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Learn_Modules_Summary_Avg_Fields = {
  __typename?: 'user_learn_modules_summary_avg_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  time_spent?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Avg_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_learn_modules_summary". All fields are combined with a logical 'AND'. */
export type User_Learn_Modules_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<User_Learn_Modules_Summary_Bool_Exp>>;
  _not?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<User_Learn_Modules_Summary_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  andablog_userlessontrackrecord_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_bookmarked?: InputMaybe<Boolean_Comparison_Exp>;
  last_visited?: InputMaybe<Timestamptz_Comparison_Exp>;
  time_spent?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_learn_activities?: InputMaybe<User_Learn_Activities_Bool_Exp>;
  user_learn_activities_aggregate?: InputMaybe<User_Learn_Activities_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user_learn_modules_summary" */
export enum User_Learn_Modules_Summary_Constraint {
  /** unique or primary key constraint on columns "entry_id", "andablog_userlessontrackrecord_id" */
  UserLearnModulesSummaryAndablogUserlessontrackrecordIdEn = 'user_learn_modules_summary_andablog_userlessontrackrecord_id_en',
  /** unique or primary key constraint on columns "id" */
  UserLearnModulesSummaryPkey = 'user_learn_modules_summary_pkey',
  /** unique or primary key constraint on columns "entry_id", "user_id" */
  UserLearnModulesSummaryUserIdEntryIdKey = 'user_learn_modules_summary_user_id_entry_id_key'
}

/** input type for incrementing numeric columns in table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Inc_Input = {
  andablog_userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  time_spent?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  andablog_userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  last_visited?: InputMaybe<Scalars['timestamptz']['input']>;
  time_spent?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_learn_activities?: InputMaybe<User_Learn_Activities_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Learn_Modules_Summary_Max_Fields = {
  __typename?: 'user_learn_modules_summary_max_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_visited?: Maybe<Scalars['timestamptz']['output']>;
  time_spent?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Max_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_visited?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Learn_Modules_Summary_Min_Fields = {
  __typename?: 'user_learn_modules_summary_min_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_visited?: Maybe<Scalars['timestamptz']['output']>;
  time_spent?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Min_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_visited?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Mutation_Response = {
  __typename?: 'user_learn_modules_summary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Learn_Modules_Summary>;
};

/** input type for inserting object relation for remote table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Obj_Rel_Insert_Input = {
  data: User_Learn_Modules_Summary_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Learn_Modules_Summary_On_Conflict>;
};

/** on_conflict condition type for table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_On_Conflict = {
  constraint: User_Learn_Modules_Summary_Constraint;
  update_columns?: Array<User_Learn_Modules_Summary_Update_Column>;
  where?: InputMaybe<User_Learn_Modules_Summary_Bool_Exp>;
};

/** Ordering options when selecting data from "user_learn_modules_summary". */
export type User_Learn_Modules_Summary_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_bookmarked?: InputMaybe<Order_By>;
  last_visited?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_learn_activities_aggregate?: InputMaybe<User_Learn_Activities_Aggregate_Order_By>;
};

/** primary key columns input for table: user_learn_modules_summary */
export type User_Learn_Modules_Summary_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_learn_modules_summary" */
export enum User_Learn_Modules_Summary_Select_Column {
  /** column name */
  AndablogUserlessontrackrecordId = 'andablog_userlessontrackrecord_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  LastVisited = 'last_visited',
  /** column name */
  TimeSpent = 'time_spent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_learn_modules_summary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_learn_modules_summary" */
export enum User_Learn_Modules_Summary_Select_Column_User_Learn_Modules_Summary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsBookmarked = 'is_bookmarked'
}

/** select "user_learn_modules_summary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_learn_modules_summary" */
export enum User_Learn_Modules_Summary_Select_Column_User_Learn_Modules_Summary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsBookmarked = 'is_bookmarked'
}

/** input type for updating data in table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Set_Input = {
  andablog_userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  last_visited?: InputMaybe<Scalars['timestamptz']['input']>;
  time_spent?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Learn_Modules_Summary_Stddev_Fields = {
  __typename?: 'user_learn_modules_summary_stddev_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  time_spent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Stddev_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Learn_Modules_Summary_Stddev_Pop_Fields = {
  __typename?: 'user_learn_modules_summary_stddev_pop_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  time_spent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Stddev_Pop_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Learn_Modules_Summary_Stddev_Samp_Fields = {
  __typename?: 'user_learn_modules_summary_stddev_samp_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  time_spent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Stddev_Samp_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Learn_Modules_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Learn_Modules_Summary_Stream_Cursor_Value_Input = {
  andablog_userlessontrackrecord_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  last_visited?: InputMaybe<Scalars['timestamptz']['input']>;
  time_spent?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Learn_Modules_Summary_Sum_Fields = {
  __typename?: 'user_learn_modules_summary_sum_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Int']['output']>;
  entry_id?: Maybe<Scalars['Int']['output']>;
  time_spent?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Sum_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
};

/** update columns of table "user_learn_modules_summary" */
export enum User_Learn_Modules_Summary_Update_Column {
  /** column name */
  AndablogUserlessontrackrecordId = 'andablog_userlessontrackrecord_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  LastVisited = 'last_visited',
  /** column name */
  TimeSpent = 'time_spent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Learn_Modules_Summary_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Learn_Modules_Summary_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Learn_Modules_Summary_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Learn_Modules_Summary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Learn_Modules_Summary_Var_Pop_Fields = {
  __typename?: 'user_learn_modules_summary_var_pop_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  time_spent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Var_Pop_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Learn_Modules_Summary_Var_Samp_Fields = {
  __typename?: 'user_learn_modules_summary_var_samp_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  time_spent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Var_Samp_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Learn_Modules_Summary_Variance_Fields = {
  __typename?: 'user_learn_modules_summary_variance_fields';
  andablog_userlessontrackrecord_id?: Maybe<Scalars['Float']['output']>;
  entry_id?: Maybe<Scalars['Float']['output']>;
  time_spent?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_learn_modules_summary" */
export type User_Learn_Modules_Summary_Variance_Order_By = {
  andablog_userlessontrackrecord_id?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  time_spent?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_learn_track_record" */
export type User_Learn_Track_Record = {
  __typename?: 'user_learn_track_record';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  category_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_completed: Scalars['Boolean']['output'];
  /** An object relationship */
  quiz_category: Quiz_Category;
  read_topics_count?: Maybe<Scalars['Int']['output']>;
  total_topics_count?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
  /** An array relationship */
  user_learn_track_record_bookmarked_topics: Array<User_Learn_Track_Record_Bookmarked_Topics>;
  /** An aggregate relationship */
  user_learn_track_record_bookmarked_topics_aggregate: User_Learn_Track_Record_Bookmarked_Topics_Aggregate;
  /** An array relationship */
  user_learn_track_record_which_topics: Array<User_Learn_Track_Record_Which_Topics>;
  /** An aggregate relationship */
  user_learn_track_record_which_topics_aggregate: User_Learn_Track_Record_Which_Topics_Aggregate;
  xp?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "user_learn_track_record" */
export type User_Learn_Track_RecordUser_Learn_Track_Record_Bookmarked_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};


/** columns and relationships of "user_learn_track_record" */
export type User_Learn_Track_RecordUser_Learn_Track_Record_Bookmarked_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};


/** columns and relationships of "user_learn_track_record" */
export type User_Learn_Track_RecordUser_Learn_Track_Record_Which_TopicsArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};


/** columns and relationships of "user_learn_track_record" */
export type User_Learn_Track_RecordUser_Learn_Track_Record_Which_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Order_By>>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};

/** aggregated selection of "user_learn_track_record" */
export type User_Learn_Track_Record_Aggregate = {
  __typename?: 'user_learn_track_record_aggregate';
  aggregate?: Maybe<User_Learn_Track_Record_Aggregate_Fields>;
  nodes: Array<User_Learn_Track_Record>;
};

export type User_Learn_Track_Record_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Learn_Track_Record_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Learn_Track_Record_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Learn_Track_Record_Aggregate_Bool_Exp_Count>;
};

export type User_Learn_Track_Record_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Learn_Track_Record_Select_Column_User_Learn_Track_Record_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Learn_Track_Record_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Learn_Track_Record_Select_Column_User_Learn_Track_Record_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Learn_Track_Record_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_learn_track_record" */
export type User_Learn_Track_Record_Aggregate_Fields = {
  __typename?: 'user_learn_track_record_aggregate_fields';
  avg?: Maybe<User_Learn_Track_Record_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Learn_Track_Record_Max_Fields>;
  min?: Maybe<User_Learn_Track_Record_Min_Fields>;
  stddev?: Maybe<User_Learn_Track_Record_Stddev_Fields>;
  stddev_pop?: Maybe<User_Learn_Track_Record_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Learn_Track_Record_Stddev_Samp_Fields>;
  sum?: Maybe<User_Learn_Track_Record_Sum_Fields>;
  var_pop?: Maybe<User_Learn_Track_Record_Var_Pop_Fields>;
  var_samp?: Maybe<User_Learn_Track_Record_Var_Samp_Fields>;
  variance?: Maybe<User_Learn_Track_Record_Variance_Fields>;
};


/** aggregate fields of "user_learn_track_record" */
export type User_Learn_Track_Record_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Learn_Track_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_learn_track_record" */
export type User_Learn_Track_Record_Aggregate_Order_By = {
  avg?: InputMaybe<User_Learn_Track_Record_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Learn_Track_Record_Max_Order_By>;
  min?: InputMaybe<User_Learn_Track_Record_Min_Order_By>;
  stddev?: InputMaybe<User_Learn_Track_Record_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Learn_Track_Record_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Learn_Track_Record_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Learn_Track_Record_Sum_Order_By>;
  var_pop?: InputMaybe<User_Learn_Track_Record_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Learn_Track_Record_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Learn_Track_Record_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_learn_track_record" */
export type User_Learn_Track_Record_Arr_Rel_Insert_Input = {
  data: Array<User_Learn_Track_Record_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Learn_Track_Record_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Learn_Track_Record_Avg_Fields = {
  __typename?: 'user_learn_track_record_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics = {
  __typename?: 'user_learn_track_record_bookmarked_topics';
  /** An object relationship */
  andablog_entry: Andablog_Entry;
  entry_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  user_learn_track_record: User_Learn_Track_Record;
  user_learn_track_record_id: Scalars['Int']['output'];
};

/** aggregated selection of "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Aggregate = {
  __typename?: 'user_learn_track_record_bookmarked_topics_aggregate';
  aggregate?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Fields>;
  nodes: Array<User_Learn_Track_Record_Bookmarked_Topics>;
};

export type User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Bool_Exp_Count>;
};

export type User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_aggregate_fields';
  avg?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Max_Fields>;
  min?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Min_Fields>;
  stddev?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Stddev_Fields>;
  stddev_pop?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Stddev_Samp_Fields>;
  sum?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Sum_Fields>;
  var_pop?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Var_Pop_Fields>;
  var_samp?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Var_Samp_Fields>;
  variance?: Maybe<User_Learn_Track_Record_Bookmarked_Topics_Variance_Fields>;
};


/** aggregate fields of "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Order_By = {
  avg?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Max_Order_By>;
  min?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Min_Order_By>;
  stddev?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Sum_Order_By>;
  var_pop?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Arr_Rel_Insert_Input = {
  data: Array<User_Learn_Track_Record_Bookmarked_Topics_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Avg_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_avg_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_learn_track_record_bookmarked_topics". All fields are combined with a logical 'AND'. */
export type User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp = {
  _and?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>>;
  _not?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
  _or?: InputMaybe<Array<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user_learn_track_record?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
  user_learn_track_record_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_learn_track_record_bookmarked_topics" */
export enum User_Learn_Track_Record_Bookmarked_Topics_Constraint {
  /** unique or primary key constraint on columns "entry_id", "user_learn_track_record_id" */
  UserLearnTrackRecordBookmarkedTopicsEntryIdUserLearnT = 'user_learn_track_record_bookmarked_topics_entry_id_user_learn_t',
  /** unique or primary key constraint on columns "id" */
  UserLearnTrackRecordBookmarkedTopicsPkey = 'user_learn_track_record_bookmarked_topics_pkey'
}

/** input type for incrementing numeric columns in table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_learn_track_record_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Insert_Input = {
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_learn_track_record?: InputMaybe<User_Learn_Track_Record_Obj_Rel_Insert_Input>;
  user_learn_track_record_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Max_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_max_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Max_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Min_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_min_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Min_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Mutation_Response = {
  __typename?: 'user_learn_track_record_bookmarked_topics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Learn_Track_Record_Bookmarked_Topics>;
};

/** on_conflict condition type for table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_On_Conflict = {
  constraint: User_Learn_Track_Record_Bookmarked_Topics_Constraint;
  update_columns?: Array<User_Learn_Track_Record_Bookmarked_Topics_Update_Column>;
  where?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
};

/** Ordering options when selecting data from "user_learn_track_record_bookmarked_topics". */
export type User_Learn_Track_Record_Bookmarked_Topics_Order_By = {
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record?: InputMaybe<User_Learn_Track_Record_Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_learn_track_record_bookmarked_topics */
export type User_Learn_Track_Record_Bookmarked_Topics_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_learn_track_record_bookmarked_topics" */
export enum User_Learn_Track_Record_Bookmarked_Topics_Select_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserLearnTrackRecordId = 'user_learn_track_record_id'
}

/** input type for updating data in table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Set_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_learn_track_record_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Stddev_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_stddev_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Stddev_Pop_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Stddev_Samp_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Learn_Track_Record_Bookmarked_Topics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Learn_Track_Record_Bookmarked_Topics_Stream_Cursor_Value_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_learn_track_record_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Sum_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_sum_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_learn_track_record_bookmarked_topics" */
export enum User_Learn_Track_Record_Bookmarked_Topics_Update_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserLearnTrackRecordId = 'user_learn_track_record_id'
}

export type User_Learn_Track_Record_Bookmarked_Topics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Var_Pop_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Var_Samp_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Learn_Track_Record_Bookmarked_Topics_Variance_Fields = {
  __typename?: 'user_learn_track_record_bookmarked_topics_variance_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_learn_track_record_bookmarked_topics" */
export type User_Learn_Track_Record_Bookmarked_Topics_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_learn_track_record". All fields are combined with a logical 'AND'. */
export type User_Learn_Track_Record_Bool_Exp = {
  _and?: InputMaybe<Array<User_Learn_Track_Record_Bool_Exp>>;
  _not?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
  _or?: InputMaybe<Array<User_Learn_Track_Record_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  read_topics_count?: InputMaybe<Int_Comparison_Exp>;
  total_topics_count?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_learn_track_record_bookmarked_topics?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Bool_Exp>;
  user_learn_track_record_bookmarked_topics_aggregate?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Bool_Exp>;
  user_learn_track_record_which_topics?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
  user_learn_track_record_which_topics_aggregate?: InputMaybe<User_Learn_Track_Record_Which_Topics_Aggregate_Bool_Exp>;
  xp?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_learn_track_record" */
export enum User_Learn_Track_Record_Constraint {
  /** unique or primary key constraint on columns "user_id", "category_id" */
  UserLearnTrackRecordCategoryIdUserIdKey = 'user_learn_track_record_category_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  UserLearnTrackRecordPkey = 'user_learn_track_record_pkey'
}

/** input type for incrementing numeric columns in table "user_learn_track_record" */
export type User_Learn_Track_Record_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  read_topics_count?: InputMaybe<Scalars['Int']['input']>;
  total_topics_count?: InputMaybe<Scalars['Int']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "user_learn_track_record" */
export type User_Learn_Track_Record_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  read_topics_count?: InputMaybe<Scalars['Int']['input']>;
  total_topics_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_learn_track_record_bookmarked_topics?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Arr_Rel_Insert_Input>;
  user_learn_track_record_which_topics?: InputMaybe<User_Learn_Track_Record_Which_Topics_Arr_Rel_Insert_Input>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type User_Learn_Track_Record_Max_Fields = {
  __typename?: 'user_learn_track_record_max_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  read_topics_count?: Maybe<Scalars['Int']['output']>;
  total_topics_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Learn_Track_Record_Min_Fields = {
  __typename?: 'user_learn_track_record_min_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  read_topics_count?: Maybe<Scalars['Int']['output']>;
  total_topics_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_learn_track_record" */
export type User_Learn_Track_Record_Mutation_Response = {
  __typename?: 'user_learn_track_record_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Learn_Track_Record>;
};

/** input type for inserting object relation for remote table "user_learn_track_record" */
export type User_Learn_Track_Record_Obj_Rel_Insert_Input = {
  data: User_Learn_Track_Record_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Learn_Track_Record_On_Conflict>;
};

/** on_conflict condition type for table "user_learn_track_record" */
export type User_Learn_Track_Record_On_Conflict = {
  constraint: User_Learn_Track_Record_Constraint;
  update_columns?: Array<User_Learn_Track_Record_Update_Column>;
  where?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
};

/** Ordering options when selecting data from "user_learn_track_record". */
export type User_Learn_Track_Record_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_learn_track_record_bookmarked_topics_aggregate?: InputMaybe<User_Learn_Track_Record_Bookmarked_Topics_Aggregate_Order_By>;
  user_learn_track_record_which_topics_aggregate?: InputMaybe<User_Learn_Track_Record_Which_Topics_Aggregate_Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_learn_track_record */
export type User_Learn_Track_Record_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_learn_track_record" */
export enum User_Learn_Track_Record_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  ReadTopicsCount = 'read_topics_count',
  /** column name */
  TotalTopicsCount = 'total_topics_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

/** select "user_learn_track_record_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_learn_track_record" */
export enum User_Learn_Track_Record_Select_Column_User_Learn_Track_Record_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** select "user_learn_track_record_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_learn_track_record" */
export enum User_Learn_Track_Record_Select_Column_User_Learn_Track_Record_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** input type for updating data in table "user_learn_track_record" */
export type User_Learn_Track_Record_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  read_topics_count?: InputMaybe<Scalars['Int']['input']>;
  total_topics_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type User_Learn_Track_Record_Stddev_Fields = {
  __typename?: 'user_learn_track_record_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Learn_Track_Record_Stddev_Pop_Fields = {
  __typename?: 'user_learn_track_record_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Learn_Track_Record_Stddev_Samp_Fields = {
  __typename?: 'user_learn_track_record_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_learn_track_record" */
export type User_Learn_Track_Record_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Learn_Track_Record_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Learn_Track_Record_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  read_topics_count?: InputMaybe<Scalars['Int']['input']>;
  total_topics_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type User_Learn_Track_Record_Sum_Fields = {
  __typename?: 'user_learn_track_record_sum_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  read_topics_count?: Maybe<Scalars['Int']['output']>;
  total_topics_count?: Maybe<Scalars['Int']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** update columns of table "user_learn_track_record" */
export enum User_Learn_Track_Record_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  ReadTopicsCount = 'read_topics_count',
  /** column name */
  TotalTopicsCount = 'total_topics_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

export type User_Learn_Track_Record_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Learn_Track_Record_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Learn_Track_Record_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Learn_Track_Record_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Learn_Track_Record_Var_Pop_Fields = {
  __typename?: 'user_learn_track_record_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Learn_Track_Record_Var_Samp_Fields = {
  __typename?: 'user_learn_track_record_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Learn_Track_Record_Variance_Fields = {
  __typename?: 'user_learn_track_record_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_learn_track_record" */
export type User_Learn_Track_Record_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics = {
  __typename?: 'user_learn_track_record_which_topics';
  /** An object relationship */
  andablog_entry: Andablog_Entry;
  entry_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  user_learn_track_record: User_Learn_Track_Record;
  user_learn_track_record_id: Scalars['Int']['output'];
};

/** aggregated selection of "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Aggregate = {
  __typename?: 'user_learn_track_record_which_topics_aggregate';
  aggregate?: Maybe<User_Learn_Track_Record_Which_Topics_Aggregate_Fields>;
  nodes: Array<User_Learn_Track_Record_Which_Topics>;
};

export type User_Learn_Track_Record_Which_Topics_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Learn_Track_Record_Which_Topics_Aggregate_Bool_Exp_Count>;
};

export type User_Learn_Track_Record_Which_Topics_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Aggregate_Fields = {
  __typename?: 'user_learn_track_record_which_topics_aggregate_fields';
  avg?: Maybe<User_Learn_Track_Record_Which_Topics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Learn_Track_Record_Which_Topics_Max_Fields>;
  min?: Maybe<User_Learn_Track_Record_Which_Topics_Min_Fields>;
  stddev?: Maybe<User_Learn_Track_Record_Which_Topics_Stddev_Fields>;
  stddev_pop?: Maybe<User_Learn_Track_Record_Which_Topics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Learn_Track_Record_Which_Topics_Stddev_Samp_Fields>;
  sum?: Maybe<User_Learn_Track_Record_Which_Topics_Sum_Fields>;
  var_pop?: Maybe<User_Learn_Track_Record_Which_Topics_Var_Pop_Fields>;
  var_samp?: Maybe<User_Learn_Track_Record_Which_Topics_Var_Samp_Fields>;
  variance?: Maybe<User_Learn_Track_Record_Which_Topics_Variance_Fields>;
};


/** aggregate fields of "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Aggregate_Order_By = {
  avg?: InputMaybe<User_Learn_Track_Record_Which_Topics_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Learn_Track_Record_Which_Topics_Max_Order_By>;
  min?: InputMaybe<User_Learn_Track_Record_Which_Topics_Min_Order_By>;
  stddev?: InputMaybe<User_Learn_Track_Record_Which_Topics_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Learn_Track_Record_Which_Topics_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Learn_Track_Record_Which_Topics_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Learn_Track_Record_Which_Topics_Sum_Order_By>;
  var_pop?: InputMaybe<User_Learn_Track_Record_Which_Topics_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Learn_Track_Record_Which_Topics_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Learn_Track_Record_Which_Topics_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Arr_Rel_Insert_Input = {
  data: Array<User_Learn_Track_Record_Which_Topics_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Learn_Track_Record_Which_Topics_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Learn_Track_Record_Which_Topics_Avg_Fields = {
  __typename?: 'user_learn_track_record_which_topics_avg_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_learn_track_record_which_topics". All fields are combined with a logical 'AND'. */
export type User_Learn_Track_Record_Which_Topics_Bool_Exp = {
  _and?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Bool_Exp>>;
  _not?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
  _or?: InputMaybe<Array<User_Learn_Track_Record_Which_Topics_Bool_Exp>>;
  andablog_entry?: InputMaybe<Andablog_Entry_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user_learn_track_record?: InputMaybe<User_Learn_Track_Record_Bool_Exp>;
  user_learn_track_record_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_learn_track_record_which_topics" */
export enum User_Learn_Track_Record_Which_Topics_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserLearnTrackRecordWhichTopicsPkey = 'user_learn_track_record_which_topics_pkey'
}

/** input type for incrementing numeric columns in table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_learn_track_record_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Insert_Input = {
  andablog_entry?: InputMaybe<Andablog_Entry_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_learn_track_record?: InputMaybe<User_Learn_Track_Record_Obj_Rel_Insert_Input>;
  user_learn_track_record_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type User_Learn_Track_Record_Which_Topics_Max_Fields = {
  __typename?: 'user_learn_track_record_which_topics_max_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Max_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Learn_Track_Record_Which_Topics_Min_Fields = {
  __typename?: 'user_learn_track_record_which_topics_min_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Min_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Mutation_Response = {
  __typename?: 'user_learn_track_record_which_topics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Learn_Track_Record_Which_Topics>;
};

/** on_conflict condition type for table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_On_Conflict = {
  constraint: User_Learn_Track_Record_Which_Topics_Constraint;
  update_columns?: Array<User_Learn_Track_Record_Which_Topics_Update_Column>;
  where?: InputMaybe<User_Learn_Track_Record_Which_Topics_Bool_Exp>;
};

/** Ordering options when selecting data from "user_learn_track_record_which_topics". */
export type User_Learn_Track_Record_Which_Topics_Order_By = {
  andablog_entry?: InputMaybe<Andablog_Entry_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record?: InputMaybe<User_Learn_Track_Record_Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_learn_track_record_which_topics */
export type User_Learn_Track_Record_Which_Topics_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_learn_track_record_which_topics" */
export enum User_Learn_Track_Record_Which_Topics_Select_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserLearnTrackRecordId = 'user_learn_track_record_id'
}

/** input type for updating data in table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Set_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_learn_track_record_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type User_Learn_Track_Record_Which_Topics_Stddev_Fields = {
  __typename?: 'user_learn_track_record_which_topics_stddev_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Learn_Track_Record_Which_Topics_Stddev_Pop_Fields = {
  __typename?: 'user_learn_track_record_which_topics_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Learn_Track_Record_Which_Topics_Stddev_Samp_Fields = {
  __typename?: 'user_learn_track_record_which_topics_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Learn_Track_Record_Which_Topics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Learn_Track_Record_Which_Topics_Stream_Cursor_Value_Input = {
  entry_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_learn_track_record_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type User_Learn_Track_Record_Which_Topics_Sum_Fields = {
  __typename?: 'user_learn_track_record_which_topics_sum_fields';
  entry_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_learn_track_record_which_topics" */
export enum User_Learn_Track_Record_Which_Topics_Update_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserLearnTrackRecordId = 'user_learn_track_record_id'
}

export type User_Learn_Track_Record_Which_Topics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Learn_Track_Record_Which_Topics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Learn_Track_Record_Which_Topics_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Learn_Track_Record_Which_Topics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Learn_Track_Record_Which_Topics_Var_Pop_Fields = {
  __typename?: 'user_learn_track_record_which_topics_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Learn_Track_Record_Which_Topics_Var_Samp_Fields = {
  __typename?: 'user_learn_track_record_which_topics_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Learn_Track_Record_Which_Topics_Variance_Fields = {
  __typename?: 'user_learn_track_record_which_topics_variance_fields';
  entry_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_learn_track_record_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_learn_track_record_which_topics" */
export type User_Learn_Track_Record_Which_Topics_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_learn_track_record_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_lesson_track_records" */
export type User_Lesson_Track_Records = {
  __typename?: 'user_lesson_track_records';
  category?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  read_topics_count?: Maybe<Scalars['bigint']['output']>;
  total_topics_count?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_lesson_track_records" */
export type User_Lesson_Track_Records_Aggregate = {
  __typename?: 'user_lesson_track_records_aggregate';
  aggregate?: Maybe<User_Lesson_Track_Records_Aggregate_Fields>;
  nodes: Array<User_Lesson_Track_Records>;
};

/** aggregate fields of "user_lesson_track_records" */
export type User_Lesson_Track_Records_Aggregate_Fields = {
  __typename?: 'user_lesson_track_records_aggregate_fields';
  avg?: Maybe<User_Lesson_Track_Records_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Lesson_Track_Records_Max_Fields>;
  min?: Maybe<User_Lesson_Track_Records_Min_Fields>;
  stddev?: Maybe<User_Lesson_Track_Records_Stddev_Fields>;
  stddev_pop?: Maybe<User_Lesson_Track_Records_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Lesson_Track_Records_Stddev_Samp_Fields>;
  sum?: Maybe<User_Lesson_Track_Records_Sum_Fields>;
  var_pop?: Maybe<User_Lesson_Track_Records_Var_Pop_Fields>;
  var_samp?: Maybe<User_Lesson_Track_Records_Var_Samp_Fields>;
  variance?: Maybe<User_Lesson_Track_Records_Variance_Fields>;
};


/** aggregate fields of "user_lesson_track_records" */
export type User_Lesson_Track_Records_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Lesson_Track_Records_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Lesson_Track_Records_Avg_Fields = {
  __typename?: 'user_lesson_track_records_avg_fields';
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_lesson_track_records". All fields are combined with a logical 'AND'. */
export type User_Lesson_Track_Records_Bool_Exp = {
  _and?: InputMaybe<Array<User_Lesson_Track_Records_Bool_Exp>>;
  _not?: InputMaybe<User_Lesson_Track_Records_Bool_Exp>;
  _or?: InputMaybe<Array<User_Lesson_Track_Records_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  read_topics_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_topics_count?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type User_Lesson_Track_Records_Max_Fields = {
  __typename?: 'user_lesson_track_records_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  read_topics_count?: Maybe<Scalars['bigint']['output']>;
  total_topics_count?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Lesson_Track_Records_Min_Fields = {
  __typename?: 'user_lesson_track_records_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  read_topics_count?: Maybe<Scalars['bigint']['output']>;
  total_topics_count?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "user_lesson_track_records". */
export type User_Lesson_Track_Records_Order_By = {
  category?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  read_topics_count?: InputMaybe<Order_By>;
  total_topics_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** select columns of table "user_lesson_track_records" */
export enum User_Lesson_Track_Records_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Email = 'email',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  Phone = 'phone',
  /** column name */
  ReadTopicsCount = 'read_topics_count',
  /** column name */
  TotalTopicsCount = 'total_topics_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username'
}

/** aggregate stddev on columns */
export type User_Lesson_Track_Records_Stddev_Fields = {
  __typename?: 'user_lesson_track_records_stddev_fields';
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Lesson_Track_Records_Stddev_Pop_Fields = {
  __typename?: 'user_lesson_track_records_stddev_pop_fields';
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Lesson_Track_Records_Stddev_Samp_Fields = {
  __typename?: 'user_lesson_track_records_stddev_samp_fields';
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_lesson_track_records" */
export type User_Lesson_Track_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Lesson_Track_Records_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Lesson_Track_Records_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  read_topics_count?: InputMaybe<Scalars['bigint']['input']>;
  total_topics_count?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Lesson_Track_Records_Sum_Fields = {
  __typename?: 'user_lesson_track_records_sum_fields';
  read_topics_count?: Maybe<Scalars['bigint']['output']>;
  total_topics_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type User_Lesson_Track_Records_Var_Pop_Fields = {
  __typename?: 'user_lesson_track_records_var_pop_fields';
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Lesson_Track_Records_Var_Samp_Fields = {
  __typename?: 'user_lesson_track_records_var_samp_fields';
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Lesson_Track_Records_Variance_Fields = {
  __typename?: 'user_lesson_track_records_variance_fields';
  read_topics_count?: Maybe<Scalars['Float']['output']>;
  total_topics_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_planned_activities" */
export type User_Planned_Activities = {
  __typename?: 'user_planned_activities';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  lesson_category_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  quiz_category?: Maybe<Quiz_Category>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  quiz_quiz?: Maybe<Quiz_Quiz>;
  schedule_end_date: Scalars['timestamptz']['output'];
  scheduled_at: Scalars['timestamptz']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "user_planned_activities" */
export type User_Planned_Activities_Aggregate = {
  __typename?: 'user_planned_activities_aggregate';
  aggregate?: Maybe<User_Planned_Activities_Aggregate_Fields>;
  nodes: Array<User_Planned_Activities>;
};

export type User_Planned_Activities_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Planned_Activities_Aggregate_Bool_Exp_Count>;
};

export type User_Planned_Activities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Planned_Activities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_planned_activities" */
export type User_Planned_Activities_Aggregate_Fields = {
  __typename?: 'user_planned_activities_aggregate_fields';
  avg?: Maybe<User_Planned_Activities_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Planned_Activities_Max_Fields>;
  min?: Maybe<User_Planned_Activities_Min_Fields>;
  stddev?: Maybe<User_Planned_Activities_Stddev_Fields>;
  stddev_pop?: Maybe<User_Planned_Activities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Planned_Activities_Stddev_Samp_Fields>;
  sum?: Maybe<User_Planned_Activities_Sum_Fields>;
  var_pop?: Maybe<User_Planned_Activities_Var_Pop_Fields>;
  var_samp?: Maybe<User_Planned_Activities_Var_Samp_Fields>;
  variance?: Maybe<User_Planned_Activities_Variance_Fields>;
};


/** aggregate fields of "user_planned_activities" */
export type User_Planned_Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Planned_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_planned_activities" */
export type User_Planned_Activities_Aggregate_Order_By = {
  avg?: InputMaybe<User_Planned_Activities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Planned_Activities_Max_Order_By>;
  min?: InputMaybe<User_Planned_Activities_Min_Order_By>;
  stddev?: InputMaybe<User_Planned_Activities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Planned_Activities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Planned_Activities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Planned_Activities_Sum_Order_By>;
  var_pop?: InputMaybe<User_Planned_Activities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Planned_Activities_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Planned_Activities_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_planned_activities" */
export type User_Planned_Activities_Arr_Rel_Insert_Input = {
  data: Array<User_Planned_Activities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Planned_Activities_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Planned_Activities_Avg_Fields = {
  __typename?: 'user_planned_activities_avg_fields';
  lesson_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Avg_Order_By = {
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_planned_activities". All fields are combined with a logical 'AND'. */
export type User_Planned_Activities_Bool_Exp = {
  _and?: InputMaybe<Array<User_Planned_Activities_Bool_Exp>>;
  _not?: InputMaybe<User_Planned_Activities_Bool_Exp>;
  _or?: InputMaybe<Array<User_Planned_Activities_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lesson_category_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  schedule_end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  scheduled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_planned_activities" */
export enum User_Planned_Activities_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPlannedActivitiesPkey = 'user_planned_activities_pkey'
}

/** input type for incrementing numeric columns in table "user_planned_activities" */
export type User_Planned_Activities_Inc_Input = {
  lesson_category_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_planned_activities" */
export type User_Planned_Activities_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lesson_category_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  schedule_end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Planned_Activities_Max_Fields = {
  __typename?: 'user_planned_activities_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lesson_category_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  schedule_end_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  schedule_end_date?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Planned_Activities_Min_Fields = {
  __typename?: 'user_planned_activities_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lesson_category_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  schedule_end_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  schedule_end_date?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_planned_activities" */
export type User_Planned_Activities_Mutation_Response = {
  __typename?: 'user_planned_activities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Planned_Activities>;
};

/** on_conflict condition type for table "user_planned_activities" */
export type User_Planned_Activities_On_Conflict = {
  constraint: User_Planned_Activities_Constraint;
  update_columns?: Array<User_Planned_Activities_Update_Column>;
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
};

/** Ordering options when selecting data from "user_planned_activities". */
export type User_Planned_Activities_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  schedule_end_date?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_planned_activities */
export type User_Planned_Activities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_planned_activities" */
export enum User_Planned_Activities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LessonCategoryId = 'lesson_category_id',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  ScheduleEndDate = 'schedule_end_date',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_planned_activities" */
export type User_Planned_Activities_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lesson_category_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  schedule_end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Planned_Activities_Stddev_Fields = {
  __typename?: 'user_planned_activities_stddev_fields';
  lesson_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Stddev_Order_By = {
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Planned_Activities_Stddev_Pop_Fields = {
  __typename?: 'user_planned_activities_stddev_pop_fields';
  lesson_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Stddev_Pop_Order_By = {
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Planned_Activities_Stddev_Samp_Fields = {
  __typename?: 'user_planned_activities_stddev_samp_fields';
  lesson_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Stddev_Samp_Order_By = {
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_planned_activities" */
export type User_Planned_Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Planned_Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Planned_Activities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lesson_category_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  schedule_end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Planned_Activities_Sum_Fields = {
  __typename?: 'user_planned_activities_sum_fields';
  lesson_category_id?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Sum_Order_By = {
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_planned_activities" */
export enum User_Planned_Activities_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LessonCategoryId = 'lesson_category_id',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  ScheduleEndDate = 'schedule_end_date',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Planned_Activities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Planned_Activities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Planned_Activities_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Planned_Activities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Planned_Activities_Var_Pop_Fields = {
  __typename?: 'user_planned_activities_var_pop_fields';
  lesson_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Var_Pop_Order_By = {
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Planned_Activities_Var_Samp_Fields = {
  __typename?: 'user_planned_activities_var_samp_fields';
  lesson_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Var_Samp_Order_By = {
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Planned_Activities_Variance_Fields = {
  __typename?: 'user_planned_activities_variance_fields';
  lesson_category_id?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_planned_activities" */
export type User_Planned_Activities_Variance_Order_By = {
  lesson_category_id?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_pov_summaries" */
export type User_Pov_Summaries = {
  __typename?: 'user_pov_summaries';
  /** An object relationship */
  all_auth_recipe_user?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  /** An object relationship */
  andablog_pov: Andablog_Pov;
  created_at: Scalars['timestamptz']['output'];
  has_read: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  pov_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_pov_summaries" */
export type User_Pov_Summaries_Aggregate = {
  __typename?: 'user_pov_summaries_aggregate';
  aggregate?: Maybe<User_Pov_Summaries_Aggregate_Fields>;
  nodes: Array<User_Pov_Summaries>;
};

export type User_Pov_Summaries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Pov_Summaries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Pov_Summaries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Pov_Summaries_Aggregate_Bool_Exp_Count>;
};

export type User_Pov_Summaries_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Pov_Summaries_Select_Column_User_Pov_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Pov_Summaries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Pov_Summaries_Select_Column_User_Pov_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Pov_Summaries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_pov_summaries" */
export type User_Pov_Summaries_Aggregate_Fields = {
  __typename?: 'user_pov_summaries_aggregate_fields';
  avg?: Maybe<User_Pov_Summaries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Pov_Summaries_Max_Fields>;
  min?: Maybe<User_Pov_Summaries_Min_Fields>;
  stddev?: Maybe<User_Pov_Summaries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Pov_Summaries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Pov_Summaries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Pov_Summaries_Sum_Fields>;
  var_pop?: Maybe<User_Pov_Summaries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Pov_Summaries_Var_Samp_Fields>;
  variance?: Maybe<User_Pov_Summaries_Variance_Fields>;
};


/** aggregate fields of "user_pov_summaries" */
export type User_Pov_Summaries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Pov_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_pov_summaries" */
export type User_Pov_Summaries_Aggregate_Order_By = {
  avg?: InputMaybe<User_Pov_Summaries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Pov_Summaries_Max_Order_By>;
  min?: InputMaybe<User_Pov_Summaries_Min_Order_By>;
  stddev?: InputMaybe<User_Pov_Summaries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Pov_Summaries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Pov_Summaries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Pov_Summaries_Sum_Order_By>;
  var_pop?: InputMaybe<User_Pov_Summaries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Pov_Summaries_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Pov_Summaries_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_pov_summaries" */
export type User_Pov_Summaries_Arr_Rel_Insert_Input = {
  data: Array<User_Pov_Summaries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Pov_Summaries_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Pov_Summaries_Avg_Fields = {
  __typename?: 'user_pov_summaries_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_pov_summaries". All fields are combined with a logical 'AND'. */
export type User_Pov_Summaries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Pov_Summaries_Bool_Exp>>;
  _not?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Pov_Summaries_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  andablog_pov?: InputMaybe<Andablog_Pov_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  has_read?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  pov_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_pov_summaries" */
export enum User_Pov_Summaries_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPovSummariesPkey = 'user_pov_summaries_pkey',
  /** unique or primary key constraint on columns "user_id", "pov_id" */
  UserPovSummariesPovIdUserIdKey = 'user_pov_summaries_pov_id_user_id_key'
}

/** input type for incrementing numeric columns in table "user_pov_summaries" */
export type User_Pov_Summaries_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_pov_summaries" */
export type User_Pov_Summaries_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  andablog_pov?: InputMaybe<Andablog_Pov_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_read?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pov_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Pov_Summaries_Max_Fields = {
  __typename?: 'user_pov_summaries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pov_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pov_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Pov_Summaries_Min_Fields = {
  __typename?: 'user_pov_summaries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pov_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pov_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_pov_summaries" */
export type User_Pov_Summaries_Mutation_Response = {
  __typename?: 'user_pov_summaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Pov_Summaries>;
};

/** on_conflict condition type for table "user_pov_summaries" */
export type User_Pov_Summaries_On_Conflict = {
  constraint: User_Pov_Summaries_Constraint;
  update_columns?: Array<User_Pov_Summaries_Update_Column>;
  where?: InputMaybe<User_Pov_Summaries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_pov_summaries". */
export type User_Pov_Summaries_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  andablog_pov?: InputMaybe<Andablog_Pov_Order_By>;
  created_at?: InputMaybe<Order_By>;
  has_read?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pov_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_pov_summaries */
export type User_Pov_Summaries_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_pov_summaries" */
export enum User_Pov_Summaries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasRead = 'has_read',
  /** column name */
  Id = 'id',
  /** column name */
  PovId = 'pov_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_pov_summaries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_pov_summaries" */
export enum User_Pov_Summaries_Select_Column_User_Pov_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasRead = 'has_read'
}

/** select "user_pov_summaries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_pov_summaries" */
export enum User_Pov_Summaries_Select_Column_User_Pov_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasRead = 'has_read'
}

/** input type for updating data in table "user_pov_summaries" */
export type User_Pov_Summaries_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_read?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pov_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Pov_Summaries_Stddev_Fields = {
  __typename?: 'user_pov_summaries_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Pov_Summaries_Stddev_Pop_Fields = {
  __typename?: 'user_pov_summaries_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Pov_Summaries_Stddev_Samp_Fields = {
  __typename?: 'user_pov_summaries_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_pov_summaries" */
export type User_Pov_Summaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Pov_Summaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Pov_Summaries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_read?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pov_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Pov_Summaries_Sum_Fields = {
  __typename?: 'user_pov_summaries_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "user_pov_summaries" */
export enum User_Pov_Summaries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasRead = 'has_read',
  /** column name */
  Id = 'id',
  /** column name */
  PovId = 'pov_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Pov_Summaries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Pov_Summaries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Pov_Summaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Pov_Summaries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Pov_Summaries_Var_Pop_Fields = {
  __typename?: 'user_pov_summaries_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Pov_Summaries_Var_Samp_Fields = {
  __typename?: 'user_pov_summaries_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Pov_Summaries_Variance_Fields = {
  __typename?: 'user_pov_summaries_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_pov_summaries" */
export type User_Pov_Summaries_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts = {
  __typename?: 'user_quiz_question_attempts';
  attempt: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  question_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Supertokens_All_Auth_Recipe_Users>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Aggregate = {
  __typename?: 'user_quiz_question_attempts_aggregate';
  aggregate?: Maybe<User_Quiz_Question_Attempts_Aggregate_Fields>;
  nodes: Array<User_Quiz_Question_Attempts>;
};

export type User_Quiz_Question_Attempts_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Quiz_Question_Attempts_Aggregate_Bool_Exp_Count>;
};

export type User_Quiz_Question_Attempts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Aggregate_Fields = {
  __typename?: 'user_quiz_question_attempts_aggregate_fields';
  avg?: Maybe<User_Quiz_Question_Attempts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Quiz_Question_Attempts_Max_Fields>;
  min?: Maybe<User_Quiz_Question_Attempts_Min_Fields>;
  stddev?: Maybe<User_Quiz_Question_Attempts_Stddev_Fields>;
  stddev_pop?: Maybe<User_Quiz_Question_Attempts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Quiz_Question_Attempts_Stddev_Samp_Fields>;
  sum?: Maybe<User_Quiz_Question_Attempts_Sum_Fields>;
  var_pop?: Maybe<User_Quiz_Question_Attempts_Var_Pop_Fields>;
  var_samp?: Maybe<User_Quiz_Question_Attempts_Var_Samp_Fields>;
  variance?: Maybe<User_Quiz_Question_Attempts_Variance_Fields>;
};


/** aggregate fields of "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Quiz_Question_Attempts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Aggregate_Order_By = {
  avg?: InputMaybe<User_Quiz_Question_Attempts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Quiz_Question_Attempts_Max_Order_By>;
  min?: InputMaybe<User_Quiz_Question_Attempts_Min_Order_By>;
  stddev?: InputMaybe<User_Quiz_Question_Attempts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Quiz_Question_Attempts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Quiz_Question_Attempts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Quiz_Question_Attempts_Sum_Order_By>;
  var_pop?: InputMaybe<User_Quiz_Question_Attempts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Quiz_Question_Attempts_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Quiz_Question_Attempts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Arr_Rel_Insert_Input = {
  data: Array<User_Quiz_Question_Attempts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Question_Attempts_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Quiz_Question_Attempts_Avg_Fields = {
  __typename?: 'user_quiz_question_attempts_avg_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Avg_Order_By = {
  attempt?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_quiz_question_attempts". All fields are combined with a logical 'AND'. */
export type User_Quiz_Question_Attempts_Bool_Exp = {
  _and?: InputMaybe<Array<User_Quiz_Question_Attempts_Bool_Exp>>;
  _not?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
  _or?: InputMaybe<Array<User_Quiz_Question_Attempts_Bool_Exp>>;
  attempt?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_quiz_question_attempts" */
export enum User_Quiz_Question_Attempts_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserQuizQuestionAttemptsPkey = 'user_quiz_question_attempts_pkey'
}

/** input type for incrementing numeric columns in table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Inc_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Insert_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Quiz_Question_Attempts_Max_Fields = {
  __typename?: 'user_quiz_question_attempts_max_fields';
  attempt?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Max_Order_By = {
  attempt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Quiz_Question_Attempts_Min_Fields = {
  __typename?: 'user_quiz_question_attempts_min_fields';
  attempt?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Min_Order_By = {
  attempt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Mutation_Response = {
  __typename?: 'user_quiz_question_attempts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Quiz_Question_Attempts>;
};

/** on_conflict condition type for table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_On_Conflict = {
  constraint: User_Quiz_Question_Attempts_Constraint;
  update_columns?: Array<User_Quiz_Question_Attempts_Update_Column>;
  where?: InputMaybe<User_Quiz_Question_Attempts_Bool_Exp>;
};

/** Ordering options when selecting data from "user_quiz_question_attempts". */
export type User_Quiz_Question_Attempts_Order_By = {
  attempt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_quiz_question_attempts */
export type User_Quiz_Question_Attempts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_quiz_question_attempts" */
export enum User_Quiz_Question_Attempts_Select_Column {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Set_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Quiz_Question_Attempts_Stddev_Fields = {
  __typename?: 'user_quiz_question_attempts_stddev_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Stddev_Order_By = {
  attempt?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Quiz_Question_Attempts_Stddev_Pop_Fields = {
  __typename?: 'user_quiz_question_attempts_stddev_pop_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Stddev_Pop_Order_By = {
  attempt?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Quiz_Question_Attempts_Stddev_Samp_Fields = {
  __typename?: 'user_quiz_question_attempts_stddev_samp_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Stddev_Samp_Order_By = {
  attempt?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Quiz_Question_Attempts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Quiz_Question_Attempts_Stream_Cursor_Value_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Quiz_Question_Attempts_Sum_Fields = {
  __typename?: 'user_quiz_question_attempts_sum_fields';
  attempt?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Sum_Order_By = {
  attempt?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_quiz_question_attempts" */
export enum User_Quiz_Question_Attempts_Update_Column {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Quiz_Question_Attempts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Quiz_Question_Attempts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Quiz_Question_Attempts_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Quiz_Question_Attempts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Quiz_Question_Attempts_Var_Pop_Fields = {
  __typename?: 'user_quiz_question_attempts_var_pop_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Var_Pop_Order_By = {
  attempt?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Quiz_Question_Attempts_Var_Samp_Fields = {
  __typename?: 'user_quiz_question_attempts_var_samp_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Var_Samp_Order_By = {
  attempt?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Quiz_Question_Attempts_Variance_Fields = {
  __typename?: 'user_quiz_question_attempts_variance_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_quiz_question_attempts" */
export type User_Quiz_Question_Attempts_Variance_Order_By = {
  attempt?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_quiz_question_positions" */
export type User_Quiz_Question_Positions = {
  __typename?: 'user_quiz_question_positions';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  position: Scalars['Int']['output'];
  question_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_quiz_question_summary?: Maybe<User_Quiz_Question_Summaries>;
  /** An object relationship */
  user_quiz_summary: User_Quiz_Summaries;
  user_quiz_summary_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Aggregate = {
  __typename?: 'user_quiz_question_positions_aggregate';
  aggregate?: Maybe<User_Quiz_Question_Positions_Aggregate_Fields>;
  nodes: Array<User_Quiz_Question_Positions>;
};

export type User_Quiz_Question_Positions_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Quiz_Question_Positions_Aggregate_Bool_Exp_Count>;
};

export type User_Quiz_Question_Positions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Aggregate_Fields = {
  __typename?: 'user_quiz_question_positions_aggregate_fields';
  avg?: Maybe<User_Quiz_Question_Positions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Quiz_Question_Positions_Max_Fields>;
  min?: Maybe<User_Quiz_Question_Positions_Min_Fields>;
  stddev?: Maybe<User_Quiz_Question_Positions_Stddev_Fields>;
  stddev_pop?: Maybe<User_Quiz_Question_Positions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Quiz_Question_Positions_Stddev_Samp_Fields>;
  sum?: Maybe<User_Quiz_Question_Positions_Sum_Fields>;
  var_pop?: Maybe<User_Quiz_Question_Positions_Var_Pop_Fields>;
  var_samp?: Maybe<User_Quiz_Question_Positions_Var_Samp_Fields>;
  variance?: Maybe<User_Quiz_Question_Positions_Variance_Fields>;
};


/** aggregate fields of "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Aggregate_Order_By = {
  avg?: InputMaybe<User_Quiz_Question_Positions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Quiz_Question_Positions_Max_Order_By>;
  min?: InputMaybe<User_Quiz_Question_Positions_Min_Order_By>;
  stddev?: InputMaybe<User_Quiz_Question_Positions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Quiz_Question_Positions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Quiz_Question_Positions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Quiz_Question_Positions_Sum_Order_By>;
  var_pop?: InputMaybe<User_Quiz_Question_Positions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Quiz_Question_Positions_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Quiz_Question_Positions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Arr_Rel_Insert_Input = {
  data: Array<User_Quiz_Question_Positions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Question_Positions_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Quiz_Question_Positions_Avg_Fields = {
  __typename?: 'user_quiz_question_positions_avg_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Avg_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_quiz_question_positions". All fields are combined with a logical 'AND'. */
export type User_Quiz_Question_Positions_Bool_Exp = {
  _and?: InputMaybe<Array<User_Quiz_Question_Positions_Bool_Exp>>;
  _not?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
  _or?: InputMaybe<Array<User_Quiz_Question_Positions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  position?: InputMaybe<Int_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_quiz_question_summary?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  user_quiz_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_quiz_question_positions" */
export enum User_Quiz_Question_Positions_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserQuizQuestionPositionsPkey = 'user_quiz_question_positions_pkey',
  /** unique or primary key constraint on columns "question_id", "user_quiz_summary_id", "position" */
  UserQuizQuestionPositionsPositionQuestionIdUserQuizSum = 'user_quiz_question_positions_position_question_id_user_quiz_sum'
}

/** input type for incrementing numeric columns in table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Inc_Input = {
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_question_summary?: InputMaybe<User_Quiz_Question_Summaries_Obj_Rel_Insert_Input>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Obj_Rel_Insert_Input>;
  user_quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Quiz_Question_Positions_Max_Fields = {
  __typename?: 'user_quiz_question_positions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_summary_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Quiz_Question_Positions_Min_Fields = {
  __typename?: 'user_quiz_question_positions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_summary_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Mutation_Response = {
  __typename?: 'user_quiz_question_positions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Quiz_Question_Positions>;
};

/** on_conflict condition type for table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_On_Conflict = {
  constraint: User_Quiz_Question_Positions_Constraint;
  update_columns?: Array<User_Quiz_Question_Positions_Update_Column>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};

/** Ordering options when selecting data from "user_quiz_question_positions". */
export type User_Quiz_Question_Positions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_question_summary?: InputMaybe<User_Quiz_Question_Summaries_Order_By>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Order_By>;
  user_quiz_summary_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_quiz_question_positions */
export type User_Quiz_Question_Positions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_quiz_question_positions" */
export enum User_Quiz_Question_Positions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserQuizSummaryId = 'user_quiz_summary_id'
}

/** input type for updating data in table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type User_Quiz_Question_Positions_Stddev_Fields = {
  __typename?: 'user_quiz_question_positions_stddev_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Stddev_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Quiz_Question_Positions_Stddev_Pop_Fields = {
  __typename?: 'user_quiz_question_positions_stddev_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Stddev_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Quiz_Question_Positions_Stddev_Samp_Fields = {
  __typename?: 'user_quiz_question_positions_stddev_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Stddev_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Quiz_Question_Positions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Quiz_Question_Positions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type User_Quiz_Question_Positions_Sum_Fields = {
  __typename?: 'user_quiz_question_positions_sum_fields';
  position?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Sum_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_quiz_question_positions" */
export enum User_Quiz_Question_Positions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserQuizSummaryId = 'user_quiz_summary_id'
}

export type User_Quiz_Question_Positions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Quiz_Question_Positions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Quiz_Question_Positions_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Quiz_Question_Positions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Quiz_Question_Positions_Var_Pop_Fields = {
  __typename?: 'user_quiz_question_positions_var_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Var_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Quiz_Question_Positions_Var_Samp_Fields = {
  __typename?: 'user_quiz_question_positions_var_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Var_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Quiz_Question_Positions_Variance_Fields = {
  __typename?: 'user_quiz_question_positions_variance_fields';
  position?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_quiz_question_positions" */
export type User_Quiz_Question_Positions_Variance_Order_By = {
  position?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries = {
  __typename?: 'user_quiz_question_summaries';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  is_attempted: Scalars['Boolean']['output'];
  is_bookmarked: Scalars['Boolean']['output'];
  is_correct?: Maybe<Scalars['Boolean']['output']>;
  mark_for_review: Scalars['Boolean']['output'];
  marks: Scalars['numeric']['output'];
  /** A computed field, executes function "next_quiz_question" */
  next_question?: Maybe<Array<Quiz_Quiz_Questions>>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "previous_quiz_question" */
  previous_question?: Maybe<Array<Quiz_Quiz_Questions>>;
  question_id: Scalars['Int']['output'];
  question_position: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  quiz_stats?: Maybe<Scalars['jsonb']['output']>;
  quiz_summary_id: Scalars['uuid']['output'];
  response?: Maybe<Scalars['String']['output']>;
  time_take_to_view_solution: Scalars['interval']['output'];
  time_taken: Scalars['interval']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_quiz_summary: User_Quiz_Summaries;
  xp_earned: Scalars['Int']['output'];
};


/** columns and relationships of "user_quiz_question_summaries" */
export type User_Quiz_Question_SummariesNext_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "user_quiz_question_summaries" */
export type User_Quiz_Question_SummariesPrevious_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "user_quiz_question_summaries" */
export type User_Quiz_Question_SummariesQuiz_StatsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Aggregate = {
  __typename?: 'user_quiz_question_summaries_aggregate';
  aggregate?: Maybe<User_Quiz_Question_Summaries_Aggregate_Fields>;
  nodes: Array<User_Quiz_Question_Summaries>;
};

export type User_Quiz_Question_Summaries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Count>;
};

export type User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Quiz_Question_Summaries_Select_Column_User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Quiz_Question_Summaries_Select_Column_User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Aggregate_Fields = {
  __typename?: 'user_quiz_question_summaries_aggregate_fields';
  avg?: Maybe<User_Quiz_Question_Summaries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Quiz_Question_Summaries_Max_Fields>;
  min?: Maybe<User_Quiz_Question_Summaries_Min_Fields>;
  stddev?: Maybe<User_Quiz_Question_Summaries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Quiz_Question_Summaries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Quiz_Question_Summaries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Quiz_Question_Summaries_Sum_Fields>;
  var_pop?: Maybe<User_Quiz_Question_Summaries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Quiz_Question_Summaries_Var_Samp_Fields>;
  variance?: Maybe<User_Quiz_Question_Summaries_Variance_Fields>;
};


/** aggregate fields of "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Aggregate_Order_By = {
  avg?: InputMaybe<User_Quiz_Question_Summaries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Quiz_Question_Summaries_Max_Order_By>;
  min?: InputMaybe<User_Quiz_Question_Summaries_Min_Order_By>;
  stddev?: InputMaybe<User_Quiz_Question_Summaries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Quiz_Question_Summaries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Quiz_Question_Summaries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Quiz_Question_Summaries_Sum_Order_By>;
  var_pop?: InputMaybe<User_Quiz_Question_Summaries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Quiz_Question_Summaries_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Quiz_Question_Summaries_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Quiz_Question_Summaries_Append_Input = {
  quiz_stats?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Arr_Rel_Insert_Input = {
  data: Array<User_Quiz_Question_Summaries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Question_Summaries_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Quiz_Question_Summaries_Avg_Fields = {
  __typename?: 'user_quiz_question_summaries_avg_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
  xp_earned?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Avg_Order_By = {
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_quiz_question_summaries". All fields are combined with a logical 'AND'. */
export type User_Quiz_Question_Summaries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Quiz_Question_Summaries_Bool_Exp>>;
  _not?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Quiz_Question_Summaries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_attempted?: InputMaybe<Boolean_Comparison_Exp>;
  is_bookmarked?: InputMaybe<Boolean_Comparison_Exp>;
  is_correct?: InputMaybe<Boolean_Comparison_Exp>;
  mark_for_review?: InputMaybe<Boolean_Comparison_Exp>;
  marks?: InputMaybe<Numeric_Comparison_Exp>;
  next_question?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
  old_user_quiz_question_summary_id?: InputMaybe<Int_Comparison_Exp>;
  previous_question?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  question_position?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_stats?: InputMaybe<Jsonb_Comparison_Exp>;
  quiz_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
  response?: InputMaybe<String_Comparison_Exp>;
  time_take_to_view_solution?: InputMaybe<Interval_Comparison_Exp>;
  time_taken?: InputMaybe<Interval_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  xp_earned?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_quiz_question_summaries" */
export enum User_Quiz_Question_Summaries_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserQuizQuestionSummariesPkey1 = 'user_quiz_question_summaries_pkey1',
  /** unique or primary key constraint on columns "question_id", "quiz_summary_id" */
  UserQuizQuestionSummariesQuizSummaryIdQuestionIdKey = 'user_quiz_question_summaries_quiz_summary_id_question_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Quiz_Question_Summaries_Delete_At_Path_Input = {
  quiz_stats?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Quiz_Question_Summaries_Delete_Elem_Input = {
  quiz_stats?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Quiz_Question_Summaries_Delete_Key_Input = {
  quiz_stats?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Inc_Input = {
  marks?: InputMaybe<Scalars['numeric']['input']>;
  old_user_quiz_question_summary_id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  question_position?: InputMaybe<Scalars['Int']['input']>;
  xp_earned?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  mark_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  old_user_quiz_question_summary_id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  question_position?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  quiz_stats?: InputMaybe<Scalars['jsonb']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  time_take_to_view_solution?: InputMaybe<Scalars['interval']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Obj_Rel_Insert_Input>;
  xp_earned?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type User_Quiz_Question_Summaries_Max_Fields = {
  __typename?: 'user_quiz_question_summaries_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  question_position?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  xp_earned?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Quiz_Question_Summaries_Min_Fields = {
  __typename?: 'user_quiz_question_summaries_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  marks?: Maybe<Scalars['numeric']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  question_position?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  xp_earned?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Mutation_Response = {
  __typename?: 'user_quiz_question_summaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Quiz_Question_Summaries>;
};

/** input type for inserting object relation for remote table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Obj_Rel_Insert_Input = {
  data: User_Quiz_Question_Summaries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Question_Summaries_On_Conflict>;
};

/** columns and relationships of "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old = {
  __typename?: 'user_quiz_question_summaries_old';
  correct_option?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  date_attempted: Scalars['date']['output'];
  id: Scalars['Int']['output'];
  is_attempted: Scalars['Boolean']['output'];
  is_bookmarked: Scalars['Boolean']['output'];
  is_correct: Scalars['Boolean']['output'];
  mark_for_review: Scalars['Boolean']['output'];
  question_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  /** An object relationship */
  quiz_section?: Maybe<Quiz_Section>;
  quiz_summary_id: Scalars['Int']['output'];
  section_id?: Maybe<Scalars['Int']['output']>;
  selected_option?: Maybe<Scalars['String']['output']>;
  time_taken: Scalars['interval']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_quiz_summary: User_Quiz_Summaries_Old;
};

/** aggregated selection of "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Aggregate = {
  __typename?: 'user_quiz_question_summaries_old_aggregate';
  aggregate?: Maybe<User_Quiz_Question_Summaries_Old_Aggregate_Fields>;
  nodes: Array<User_Quiz_Question_Summaries_Old>;
};

export type User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Count>;
};

export type User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Quiz_Question_Summaries_Old_Select_Column_User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Quiz_Question_Summaries_Old_Select_Column_User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Aggregate_Fields = {
  __typename?: 'user_quiz_question_summaries_old_aggregate_fields';
  avg?: Maybe<User_Quiz_Question_Summaries_Old_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Quiz_Question_Summaries_Old_Max_Fields>;
  min?: Maybe<User_Quiz_Question_Summaries_Old_Min_Fields>;
  stddev?: Maybe<User_Quiz_Question_Summaries_Old_Stddev_Fields>;
  stddev_pop?: Maybe<User_Quiz_Question_Summaries_Old_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Quiz_Question_Summaries_Old_Stddev_Samp_Fields>;
  sum?: Maybe<User_Quiz_Question_Summaries_Old_Sum_Fields>;
  var_pop?: Maybe<User_Quiz_Question_Summaries_Old_Var_Pop_Fields>;
  var_samp?: Maybe<User_Quiz_Question_Summaries_Old_Var_Samp_Fields>;
  variance?: Maybe<User_Quiz_Question_Summaries_Old_Variance_Fields>;
};


/** aggregate fields of "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Aggregate_Order_By = {
  avg?: InputMaybe<User_Quiz_Question_Summaries_Old_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Quiz_Question_Summaries_Old_Max_Order_By>;
  min?: InputMaybe<User_Quiz_Question_Summaries_Old_Min_Order_By>;
  stddev?: InputMaybe<User_Quiz_Question_Summaries_Old_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Quiz_Question_Summaries_Old_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Quiz_Question_Summaries_Old_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Quiz_Question_Summaries_Old_Sum_Order_By>;
  var_pop?: InputMaybe<User_Quiz_Question_Summaries_Old_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Quiz_Question_Summaries_Old_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Quiz_Question_Summaries_Old_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Arr_Rel_Insert_Input = {
  data: Array<User_Quiz_Question_Summaries_Old_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Question_Summaries_Old_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Quiz_Question_Summaries_Old_Avg_Fields = {
  __typename?: 'user_quiz_question_summaries_old_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_quiz_question_summaries_old". All fields are combined with a logical 'AND'. */
export type User_Quiz_Question_Summaries_Old_Bool_Exp = {
  _and?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Bool_Exp>>;
  _not?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
  _or?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Bool_Exp>>;
  correct_option?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_attempted?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_attempted?: InputMaybe<Boolean_Comparison_Exp>;
  is_bookmarked?: InputMaybe<Boolean_Comparison_Exp>;
  is_correct?: InputMaybe<Boolean_Comparison_Exp>;
  mark_for_review?: InputMaybe<Boolean_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  quiz_summary_id?: InputMaybe<Int_Comparison_Exp>;
  section_id?: InputMaybe<Int_Comparison_Exp>;
  selected_option?: InputMaybe<String_Comparison_Exp>;
  time_taken?: InputMaybe<Interval_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};

/** unique or primary key constraints on table "user_quiz_question_summaries_old" */
export enum User_Quiz_Question_Summaries_Old_Constraint {
  /** unique or primary key constraint on columns "question_id", "quiz_summary_id" */
  UserQuizQuestionSummariesPkey = 'user_quiz_question_summaries_pkey'
}

/** input type for incrementing numeric columns in table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Insert_Input = {
  correct_option?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_attempted?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  mark_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  selected_option?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Old_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Quiz_Question_Summaries_Old_Max_Fields = {
  __typename?: 'user_quiz_question_summaries_old_max_fields';
  correct_option?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_attempted?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  selected_option?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Max_Order_By = {
  correct_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_attempted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  selected_option?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Quiz_Question_Summaries_Old_Min_Fields = {
  __typename?: 'user_quiz_question_summaries_old_min_fields';
  correct_option?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_attempted?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  selected_option?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Min_Order_By = {
  correct_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_attempted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  selected_option?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Mutation_Response = {
  __typename?: 'user_quiz_question_summaries_old_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Quiz_Question_Summaries_Old>;
};

/** on_conflict condition type for table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_On_Conflict = {
  constraint: User_Quiz_Question_Summaries_Old_Constraint;
  update_columns?: Array<User_Quiz_Question_Summaries_Old_Update_Column>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};

/** Ordering options when selecting data from "user_quiz_question_summaries_old". */
export type User_Quiz_Question_Summaries_Old_Order_By = {
  correct_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_attempted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_attempted?: InputMaybe<Order_By>;
  is_bookmarked?: InputMaybe<Order_By>;
  is_correct?: InputMaybe<Order_By>;
  mark_for_review?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  selected_option?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Old_Order_By>;
};

/** primary key columns input for table: user_quiz_question_summaries_old */
export type User_Quiz_Question_Summaries_Old_Pk_Columns_Input = {
  question_id: Scalars['Int']['input'];
  quiz_summary_id: Scalars['Int']['input'];
};

/** select columns of table "user_quiz_question_summaries_old" */
export enum User_Quiz_Question_Summaries_Old_Select_Column {
  /** column name */
  CorrectOption = 'correct_option',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateAttempted = 'date_attempted',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  SelectedOption = 'selected_option',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "user_quiz_question_summaries_old_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_quiz_question_summaries_old" */
export enum User_Quiz_Question_Summaries_Old_Select_Column_User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review'
}

/** select "user_quiz_question_summaries_old_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_quiz_question_summaries_old" */
export enum User_Quiz_Question_Summaries_Old_Select_Column_User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review'
}

/** input type for updating data in table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Set_Input = {
  correct_option?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_attempted?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  mark_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  selected_option?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type User_Quiz_Question_Summaries_Old_Stddev_Fields = {
  __typename?: 'user_quiz_question_summaries_old_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Quiz_Question_Summaries_Old_Stddev_Pop_Fields = {
  __typename?: 'user_quiz_question_summaries_old_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Quiz_Question_Summaries_Old_Stddev_Samp_Fields = {
  __typename?: 'user_quiz_question_summaries_old_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Quiz_Question_Summaries_Old_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Quiz_Question_Summaries_Old_Stream_Cursor_Value_Input = {
  correct_option?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_attempted?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  mark_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  selected_option?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type User_Quiz_Question_Summaries_Old_Sum_Fields = {
  __typename?: 'user_quiz_question_summaries_old_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_quiz_question_summaries_old" */
export enum User_Quiz_Question_Summaries_Old_Update_Column {
  /** column name */
  CorrectOption = 'correct_option',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateAttempted = 'date_attempted',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  SelectedOption = 'selected_option',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Quiz_Question_Summaries_Old_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Quiz_Question_Summaries_Old_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Quiz_Question_Summaries_Old_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Quiz_Question_Summaries_Old_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Quiz_Question_Summaries_Old_Var_Pop_Fields = {
  __typename?: 'user_quiz_question_summaries_old_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Quiz_Question_Summaries_Old_Var_Samp_Fields = {
  __typename?: 'user_quiz_question_summaries_old_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Quiz_Question_Summaries_Old_Variance_Fields = {
  __typename?: 'user_quiz_question_summaries_old_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_quiz_question_summaries_old" */
export type User_Quiz_Question_Summaries_Old_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_On_Conflict = {
  constraint: User_Quiz_Question_Summaries_Constraint;
  update_columns?: Array<User_Quiz_Question_Summaries_Update_Column>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_quiz_question_summaries". */
export type User_Quiz_Question_Summaries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_attempted?: InputMaybe<Order_By>;
  is_bookmarked?: InputMaybe<Order_By>;
  is_correct?: InputMaybe<Order_By>;
  mark_for_review?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  next_question_aggregate?: InputMaybe<Quiz_Quiz_Questions_Aggregate_Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  previous_question_aggregate?: InputMaybe<Quiz_Quiz_Questions_Aggregate_Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  quiz_stats?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  time_take_to_view_solution?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_quiz_question_summaries */
export type User_Quiz_Question_Summaries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Quiz_Question_Summaries_Prepend_Input = {
  quiz_stats?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user_quiz_question_summaries" */
export enum User_Quiz_Question_Summaries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review',
  /** column name */
  Marks = 'marks',
  /** column name */
  OldUserQuizQuestionSummaryId = 'old_user_quiz_question_summary_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionPosition = 'question_position',
  /** column name */
  QuizStats = 'quiz_stats',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  Response = 'response',
  /** column name */
  TimeTakeToViewSolution = 'time_take_to_view_solution',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XpEarned = 'xp_earned'
}

/** select "user_quiz_question_summaries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_quiz_question_summaries" */
export enum User_Quiz_Question_Summaries_Select_Column_User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review'
}

/** select "user_quiz_question_summaries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_quiz_question_summaries" */
export enum User_Quiz_Question_Summaries_Select_Column_User_Quiz_Question_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review'
}

/** input type for updating data in table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  mark_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  old_user_quiz_question_summary_id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  question_position?: InputMaybe<Scalars['Int']['input']>;
  quiz_stats?: InputMaybe<Scalars['jsonb']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  time_take_to_view_solution?: InputMaybe<Scalars['interval']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xp_earned?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type User_Quiz_Question_Summaries_Stddev_Fields = {
  __typename?: 'user_quiz_question_summaries_stddev_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
  xp_earned?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Stddev_Order_By = {
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Quiz_Question_Summaries_Stddev_Pop_Fields = {
  __typename?: 'user_quiz_question_summaries_stddev_pop_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
  xp_earned?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Stddev_Pop_Order_By = {
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Quiz_Question_Summaries_Stddev_Samp_Fields = {
  __typename?: 'user_quiz_question_summaries_stddev_samp_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
  xp_earned?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Stddev_Samp_Order_By = {
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Quiz_Question_Summaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Quiz_Question_Summaries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  mark_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  marks?: InputMaybe<Scalars['numeric']['input']>;
  old_user_quiz_question_summary_id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  question_position?: InputMaybe<Scalars['Int']['input']>;
  quiz_stats?: InputMaybe<Scalars['jsonb']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  time_take_to_view_solution?: InputMaybe<Scalars['interval']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xp_earned?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type User_Quiz_Question_Summaries_Sum_Fields = {
  __typename?: 'user_quiz_question_summaries_sum_fields';
  marks?: Maybe<Scalars['numeric']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  question_position?: Maybe<Scalars['Int']['output']>;
  xp_earned?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Sum_Order_By = {
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** update columns of table "user_quiz_question_summaries" */
export enum User_Quiz_Question_Summaries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review',
  /** column name */
  Marks = 'marks',
  /** column name */
  OldUserQuizQuestionSummaryId = 'old_user_quiz_question_summary_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionPosition = 'question_position',
  /** column name */
  QuizStats = 'quiz_stats',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  Response = 'response',
  /** column name */
  TimeTakeToViewSolution = 'time_take_to_view_solution',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XpEarned = 'xp_earned'
}

export type User_Quiz_Question_Summaries_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Quiz_Question_Summaries_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Quiz_Question_Summaries_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Quiz_Question_Summaries_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Quiz_Question_Summaries_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Quiz_Question_Summaries_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Quiz_Question_Summaries_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Quiz_Question_Summaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Quiz_Question_Summaries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Quiz_Question_Summaries_Var_Pop_Fields = {
  __typename?: 'user_quiz_question_summaries_var_pop_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
  xp_earned?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Var_Pop_Order_By = {
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Quiz_Question_Summaries_Var_Samp_Fields = {
  __typename?: 'user_quiz_question_summaries_var_samp_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
  xp_earned?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Var_Samp_Order_By = {
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Quiz_Question_Summaries_Variance_Fields = {
  __typename?: 'user_quiz_question_summaries_variance_fields';
  marks?: Maybe<Scalars['Float']['output']>;
  old_user_quiz_question_summary_id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  question_position?: Maybe<Scalars['Float']['output']>;
  xp_earned?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_quiz_question_summaries" */
export type User_Quiz_Question_Summaries_Variance_Order_By = {
  marks?: InputMaybe<Order_By>;
  old_user_quiz_question_summary_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_position?: InputMaybe<Order_By>;
  xp_earned?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_quiz_questions" */
export type User_Quiz_Questions = {
  __typename?: 'user_quiz_questions';
  attempt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  question_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "user_quiz_questions" */
export type User_Quiz_Questions_Aggregate = {
  __typename?: 'user_quiz_questions_aggregate';
  aggregate?: Maybe<User_Quiz_Questions_Aggregate_Fields>;
  nodes: Array<User_Quiz_Questions>;
};

export type User_Quiz_Questions_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Quiz_Questions_Aggregate_Bool_Exp_Count>;
};

export type User_Quiz_Questions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_quiz_questions" */
export type User_Quiz_Questions_Aggregate_Fields = {
  __typename?: 'user_quiz_questions_aggregate_fields';
  avg?: Maybe<User_Quiz_Questions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Quiz_Questions_Max_Fields>;
  min?: Maybe<User_Quiz_Questions_Min_Fields>;
  stddev?: Maybe<User_Quiz_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<User_Quiz_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Quiz_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<User_Quiz_Questions_Sum_Fields>;
  var_pop?: Maybe<User_Quiz_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<User_Quiz_Questions_Var_Samp_Fields>;
  variance?: Maybe<User_Quiz_Questions_Variance_Fields>;
};


/** aggregate fields of "user_quiz_questions" */
export type User_Quiz_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_quiz_questions" */
export type User_Quiz_Questions_Aggregate_Order_By = {
  avg?: InputMaybe<User_Quiz_Questions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Quiz_Questions_Max_Order_By>;
  min?: InputMaybe<User_Quiz_Questions_Min_Order_By>;
  stddev?: InputMaybe<User_Quiz_Questions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Quiz_Questions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Quiz_Questions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Quiz_Questions_Sum_Order_By>;
  var_pop?: InputMaybe<User_Quiz_Questions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Quiz_Questions_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Quiz_Questions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_quiz_questions" */
export type User_Quiz_Questions_Arr_Rel_Insert_Input = {
  data: Array<User_Quiz_Questions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Quiz_Questions_Avg_Fields = {
  __typename?: 'user_quiz_questions_avg_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Avg_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_quiz_questions". All fields are combined with a logical 'AND'. */
export type User_Quiz_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<User_Quiz_Questions_Bool_Exp>>;
  _not?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<User_Quiz_Questions_Bool_Exp>>;
  attempt?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "user_quiz_questions" */
export enum User_Quiz_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserQuizQuestionsPkey = 'user_quiz_questions_pkey'
}

/** input type for incrementing numeric columns in table "user_quiz_questions" */
export type User_Quiz_Questions_Inc_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_quiz_questions" */
export type User_Quiz_Questions_Insert_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Quiz_Questions_Max_Fields = {
  __typename?: 'user_quiz_questions_max_fields';
  attempt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Max_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Quiz_Questions_Min_Fields = {
  __typename?: 'user_quiz_questions_min_fields';
  attempt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Min_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_quiz_questions" */
export type User_Quiz_Questions_Mutation_Response = {
  __typename?: 'user_quiz_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Quiz_Questions>;
};

/** on_conflict condition type for table "user_quiz_questions" */
export type User_Quiz_Questions_On_Conflict = {
  constraint: User_Quiz_Questions_Constraint;
  update_columns?: Array<User_Quiz_Questions_Update_Column>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "user_quiz_questions". */
export type User_Quiz_Questions_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: user_quiz_questions */
export type User_Quiz_Questions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_quiz_questions" */
export enum User_Quiz_Questions_Select_Column {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_quiz_questions" */
export type User_Quiz_Questions_Set_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type User_Quiz_Questions_Stddev_Fields = {
  __typename?: 'user_quiz_questions_stddev_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Stddev_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Quiz_Questions_Stddev_Pop_Fields = {
  __typename?: 'user_quiz_questions_stddev_pop_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Stddev_Pop_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Quiz_Questions_Stddev_Samp_Fields = {
  __typename?: 'user_quiz_questions_stddev_samp_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Stddev_Samp_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_quiz_questions" */
export type User_Quiz_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Quiz_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Quiz_Questions_Stream_Cursor_Value_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type User_Quiz_Questions_Sum_Fields = {
  __typename?: 'user_quiz_questions_sum_fields';
  attempt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Sum_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_quiz_questions" */
export enum User_Quiz_Questions_Update_Column {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UserId = 'user_id'
}

export type User_Quiz_Questions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Quiz_Questions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Quiz_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Quiz_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Quiz_Questions_Var_Pop_Fields = {
  __typename?: 'user_quiz_questions_var_pop_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Var_Pop_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Quiz_Questions_Var_Samp_Fields = {
  __typename?: 'user_quiz_questions_var_samp_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Var_Samp_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Quiz_Questions_Variance_Fields = {
  __typename?: 'user_quiz_questions_variance_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_quiz_questions" */
export type User_Quiz_Questions_Variance_Order_By = {
  attempt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries = {
  __typename?: 'user_quiz_section_summaries';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  percentile?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  quiz_section: Quiz_Section;
  quiz_summary_id: Scalars['uuid']['output'];
  section_id: Scalars['Int']['output'];
  total_score: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_quiz_summary: User_Quiz_Summaries;
};

/** aggregated selection of "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Aggregate = {
  __typename?: 'user_quiz_section_summaries_aggregate';
  aggregate?: Maybe<User_Quiz_Section_Summaries_Aggregate_Fields>;
  nodes: Array<User_Quiz_Section_Summaries>;
};

export type User_Quiz_Section_Summaries_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Quiz_Section_Summaries_Aggregate_Bool_Exp_Count>;
};

export type User_Quiz_Section_Summaries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Aggregate_Fields = {
  __typename?: 'user_quiz_section_summaries_aggregate_fields';
  avg?: Maybe<User_Quiz_Section_Summaries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Quiz_Section_Summaries_Max_Fields>;
  min?: Maybe<User_Quiz_Section_Summaries_Min_Fields>;
  stddev?: Maybe<User_Quiz_Section_Summaries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Quiz_Section_Summaries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Quiz_Section_Summaries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Quiz_Section_Summaries_Sum_Fields>;
  var_pop?: Maybe<User_Quiz_Section_Summaries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Quiz_Section_Summaries_Var_Samp_Fields>;
  variance?: Maybe<User_Quiz_Section_Summaries_Variance_Fields>;
};


/** aggregate fields of "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Aggregate_Order_By = {
  avg?: InputMaybe<User_Quiz_Section_Summaries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Quiz_Section_Summaries_Max_Order_By>;
  min?: InputMaybe<User_Quiz_Section_Summaries_Min_Order_By>;
  stddev?: InputMaybe<User_Quiz_Section_Summaries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Quiz_Section_Summaries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Quiz_Section_Summaries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Quiz_Section_Summaries_Sum_Order_By>;
  var_pop?: InputMaybe<User_Quiz_Section_Summaries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Quiz_Section_Summaries_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Quiz_Section_Summaries_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Arr_Rel_Insert_Input = {
  data: Array<User_Quiz_Section_Summaries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Section_Summaries_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Quiz_Section_Summaries_Avg_Fields = {
  __typename?: 'user_quiz_section_summaries_avg_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Avg_Order_By = {
  percentile?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_quiz_section_summaries". All fields are combined with a logical 'AND'. */
export type User_Quiz_Section_Summaries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Quiz_Section_Summaries_Bool_Exp>>;
  _not?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Quiz_Section_Summaries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  percentile?: InputMaybe<Numeric_Comparison_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  quiz_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
  section_id?: InputMaybe<Int_Comparison_Exp>;
  total_score?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};

/** unique or primary key constraints on table "user_quiz_section_summaries" */
export enum User_Quiz_Section_Summaries_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserQuizSectionSummariesPkey = 'user_quiz_section_summaries_pkey',
  /** unique or primary key constraint on columns "quiz_summary_id", "section_id" */
  UserQuizSectionSummariesQuizSummaryIdSectionIdKey = 'user_quiz_section_summaries_quiz_summary_id_section_id_key'
}

/** input type for incrementing numeric columns in table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Inc_Input = {
  percentile?: InputMaybe<Scalars['numeric']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  percentile?: InputMaybe<Scalars['numeric']['input']>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Quiz_Section_Summaries_Max_Fields = {
  __typename?: 'user_quiz_section_summaries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  percentile?: Maybe<Scalars['numeric']['output']>;
  quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Quiz_Section_Summaries_Min_Fields = {
  __typename?: 'user_quiz_section_summaries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  percentile?: Maybe<Scalars['numeric']['output']>;
  quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Mutation_Response = {
  __typename?: 'user_quiz_section_summaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Quiz_Section_Summaries>;
};

/** on_conflict condition type for table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_On_Conflict = {
  constraint: User_Quiz_Section_Summaries_Constraint;
  update_columns?: Array<User_Quiz_Section_Summaries_Update_Column>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_quiz_section_summaries". */
export type User_Quiz_Section_Summaries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Order_By>;
};

/** primary key columns input for table: user_quiz_section_summaries */
export type User_Quiz_Section_Summaries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_quiz_section_summaries" */
export enum User_Quiz_Section_Summaries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Percentile = 'percentile',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  TotalScore = 'total_score',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  percentile?: InputMaybe<Scalars['numeric']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type User_Quiz_Section_Summaries_Stddev_Fields = {
  __typename?: 'user_quiz_section_summaries_stddev_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Stddev_Order_By = {
  percentile?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Quiz_Section_Summaries_Stddev_Pop_Fields = {
  __typename?: 'user_quiz_section_summaries_stddev_pop_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Stddev_Pop_Order_By = {
  percentile?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Quiz_Section_Summaries_Stddev_Samp_Fields = {
  __typename?: 'user_quiz_section_summaries_stddev_samp_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Stddev_Samp_Order_By = {
  percentile?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Quiz_Section_Summaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Quiz_Section_Summaries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  percentile?: InputMaybe<Scalars['numeric']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type User_Quiz_Section_Summaries_Sum_Fields = {
  __typename?: 'user_quiz_section_summaries_sum_fields';
  percentile?: Maybe<Scalars['numeric']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Sum_Order_By = {
  percentile?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** update columns of table "user_quiz_section_summaries" */
export enum User_Quiz_Section_Summaries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Percentile = 'percentile',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  TotalScore = 'total_score',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Quiz_Section_Summaries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Quiz_Section_Summaries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Quiz_Section_Summaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Quiz_Section_Summaries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Quiz_Section_Summaries_Var_Pop_Fields = {
  __typename?: 'user_quiz_section_summaries_var_pop_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Var_Pop_Order_By = {
  percentile?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Quiz_Section_Summaries_Var_Samp_Fields = {
  __typename?: 'user_quiz_section_summaries_var_samp_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Var_Samp_Order_By = {
  percentile?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Quiz_Section_Summaries_Variance_Fields = {
  __typename?: 'user_quiz_section_summaries_variance_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_quiz_section_summaries" */
export type User_Quiz_Section_Summaries_Variance_Order_By = {
  percentile?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_Summaries = {
  __typename?: 'user_quiz_summaries';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  attempt: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  current_position: Scalars['Int']['output'];
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  did_accept_instruction: Scalars['Boolean']['output'];
  did_accept_terms_and_conditions: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  is_completed: Scalars['Boolean']['output'];
  json_data?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "get_next_question" */
  next_question?: Maybe<Array<Quiz_Quiz_Questions>>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['numeric']['output']>;
  quiz_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question?: Maybe<Quiz_Question>;
  /** An object relationship */
  quiz_quiz: Quiz_Quiz;
  /** An object relationship */
  quiz_section?: Maybe<Quiz_Section>;
  /** A computed field, executes function "quiz_quiz_get_remaining_time" */
  remaining_time?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_score?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Supertokens_User_Additional_Fields>;
  user_id: Scalars['String']['output'];
  /** An array relationship */
  user_quiz_question_positions: Array<User_Quiz_Question_Positions>;
  /** An aggregate relationship */
  user_quiz_question_positions_aggregate: User_Quiz_Question_Positions_Aggregate;
  /** An array relationship */
  user_quiz_question_summaries: Array<User_Quiz_Question_Summaries>;
  /** An aggregate relationship */
  user_quiz_question_summaries_aggregate: User_Quiz_Question_Summaries_Aggregate;
  /** An array relationship */
  user_quiz_section_summaries: Array<User_Quiz_Section_Summaries>;
  /** An aggregate relationship */
  user_quiz_section_summaries_aggregate: User_Quiz_Section_Summaries_Aggregate;
  /** An array relationship */
  user_section_summaries: Array<User_Section_Summaries>;
  /** An aggregate relationship */
  user_section_summaries_aggregate: User_Section_Summaries_Aggregate;
  /** An array relationship */
  user_timed_quiz_summaries: Array<User_Timed_Quiz_Summary>;
  /** An aggregate relationship */
  user_timed_quiz_summaries_aggregate: User_Timed_Quiz_Summary_Aggregate;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesJson_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesNext_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Quiz_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quiz_Quiz_Questions_Order_By>>;
  where?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Quiz_Question_PositionsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Quiz_Question_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Positions_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Quiz_Question_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Quiz_Question_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Quiz_Section_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Quiz_Section_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Section_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Section_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Section_Summaries_Order_By>>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Timed_Quiz_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Timed_Quiz_Summary_Order_By>>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries" */
export type User_Quiz_SummariesUser_Timed_Quiz_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Timed_Quiz_Summary_Order_By>>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};

/** aggregated selection of "user_quiz_summaries" */
export type User_Quiz_Summaries_Aggregate = {
  __typename?: 'user_quiz_summaries_aggregate';
  aggregate?: Maybe<User_Quiz_Summaries_Aggregate_Fields>;
  nodes: Array<User_Quiz_Summaries>;
};

export type User_Quiz_Summaries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Quiz_Summaries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Quiz_Summaries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Quiz_Summaries_Aggregate_Bool_Exp_Count>;
};

export type User_Quiz_Summaries_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Quiz_Summaries_Select_Column_User_Quiz_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Quiz_Summaries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Quiz_Summaries_Select_Column_User_Quiz_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Quiz_Summaries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_quiz_summaries" */
export type User_Quiz_Summaries_Aggregate_Fields = {
  __typename?: 'user_quiz_summaries_aggregate_fields';
  avg?: Maybe<User_Quiz_Summaries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Quiz_Summaries_Max_Fields>;
  min?: Maybe<User_Quiz_Summaries_Min_Fields>;
  stddev?: Maybe<User_Quiz_Summaries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Quiz_Summaries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Quiz_Summaries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Quiz_Summaries_Sum_Fields>;
  var_pop?: Maybe<User_Quiz_Summaries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Quiz_Summaries_Var_Samp_Fields>;
  variance?: Maybe<User_Quiz_Summaries_Variance_Fields>;
};


/** aggregate fields of "user_quiz_summaries" */
export type User_Quiz_Summaries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Quiz_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Aggregate_Order_By = {
  avg?: InputMaybe<User_Quiz_Summaries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Quiz_Summaries_Max_Order_By>;
  min?: InputMaybe<User_Quiz_Summaries_Min_Order_By>;
  stddev?: InputMaybe<User_Quiz_Summaries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Quiz_Summaries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Quiz_Summaries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Quiz_Summaries_Sum_Order_By>;
  var_pop?: InputMaybe<User_Quiz_Summaries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Quiz_Summaries_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Quiz_Summaries_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Quiz_Summaries_Append_Input = {
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "user_quiz_summaries" */
export type User_Quiz_Summaries_Arr_Rel_Insert_Input = {
  data: Array<User_Quiz_Summaries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Summaries_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Quiz_Summaries_Avg_Fields = {
  __typename?: 'user_quiz_summaries_avg_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by avg() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Avg_Order_By = {
  attempt?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_quiz_summaries". All fields are combined with a logical 'AND'. */
export type User_Quiz_Summaries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Quiz_Summaries_Bool_Exp>>;
  _not?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Quiz_Summaries_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  attempt?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_position?: InputMaybe<Int_Comparison_Exp>;
  current_question?: InputMaybe<Int_Comparison_Exp>;
  current_section?: InputMaybe<Int_Comparison_Exp>;
  did_accept_instruction?: InputMaybe<Boolean_Comparison_Exp>;
  did_accept_terms_and_conditions?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  json_data?: InputMaybe<Jsonb_Comparison_Exp>;
  next_question?: InputMaybe<Quiz_Quiz_Questions_Bool_Exp>;
  number_of_attempted_questions?: InputMaybe<Bigint_Comparison_Exp>;
  number_of_users_completed?: InputMaybe<Bigint_Comparison_Exp>;
  old_user_quiz_summary_id?: InputMaybe<Int_Comparison_Exp>;
  percentile?: InputMaybe<Numeric_Comparison_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  remaining_time?: InputMaybe<String_Comparison_Exp>;
  score?: InputMaybe<Numeric_Comparison_Exp>;
  total_score?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_quiz_question_positions?: InputMaybe<User_Quiz_Question_Positions_Bool_Exp>;
  user_quiz_question_positions_aggregate?: InputMaybe<User_Quiz_Question_Positions_Aggregate_Bool_Exp>;
  user_quiz_question_summaries?: InputMaybe<User_Quiz_Question_Summaries_Bool_Exp>;
  user_quiz_question_summaries_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Aggregate_Bool_Exp>;
  user_quiz_section_summaries?: InputMaybe<User_Quiz_Section_Summaries_Bool_Exp>;
  user_quiz_section_summaries_aggregate?: InputMaybe<User_Quiz_Section_Summaries_Aggregate_Bool_Exp>;
  user_section_summaries?: InputMaybe<User_Section_Summaries_Bool_Exp>;
  user_section_summaries_aggregate?: InputMaybe<User_Section_Summaries_Aggregate_Bool_Exp>;
  user_timed_quiz_summaries?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
  user_timed_quiz_summaries_aggregate?: InputMaybe<User_Timed_Quiz_Summary_Aggregate_Bool_Exp>;
  xp?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_quiz_summaries" */
export enum User_Quiz_Summaries_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserQuizSummariesPkey1 = 'user_quiz_summaries_pkey1',
  /** unique or primary key constraint on columns "quiz_id", "attempt", "user_id" */
  UserQuizSummariesUserIdQuizIdAttemptKey = 'user_quiz_summaries_user_id_quiz_id_attempt_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Quiz_Summaries_Delete_At_Path_Input = {
  json_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Quiz_Summaries_Delete_Elem_Input = {
  json_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Quiz_Summaries_Delete_Key_Input = {
  json_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "user_quiz_summaries" */
export type User_Quiz_Summaries_Inc_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  current_position?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  old_user_quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  percentile?: InputMaybe<Scalars['numeric']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_score?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "user_quiz_summaries" */
export type User_Quiz_Summaries_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  attempt?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_position?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  did_accept_instruction?: InputMaybe<Scalars['Boolean']['input']>;
  did_accept_terms_and_conditions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
  old_user_quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  percentile?: InputMaybe<Scalars['numeric']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_score?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_quiz_question_positions?: InputMaybe<User_Quiz_Question_Positions_Arr_Rel_Insert_Input>;
  user_quiz_question_summaries?: InputMaybe<User_Quiz_Question_Summaries_Arr_Rel_Insert_Input>;
  user_quiz_section_summaries?: InputMaybe<User_Quiz_Section_Summaries_Arr_Rel_Insert_Input>;
  user_section_summaries?: InputMaybe<User_Section_Summaries_Arr_Rel_Insert_Input>;
  user_timed_quiz_summaries?: InputMaybe<User_Timed_Quiz_Summary_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Quiz_Summaries_Max_Fields = {
  __typename?: 'user_quiz_summaries_max_fields';
  attempt?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_position?: Maybe<Scalars['Int']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['numeric']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_quiz_get_remaining_time" */
  remaining_time?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_score?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Max_Order_By = {
  attempt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Quiz_Summaries_Min_Fields = {
  __typename?: 'user_quiz_summaries_min_fields';
  attempt?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_position?: Maybe<Scalars['Int']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['numeric']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "quiz_quiz_get_remaining_time" */
  remaining_time?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_score?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Min_Order_By = {
  attempt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_quiz_summaries" */
export type User_Quiz_Summaries_Mutation_Response = {
  __typename?: 'user_quiz_summaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Quiz_Summaries>;
};

/** input type for inserting object relation for remote table "user_quiz_summaries" */
export type User_Quiz_Summaries_Obj_Rel_Insert_Input = {
  data: User_Quiz_Summaries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Summaries_On_Conflict>;
};

/** columns and relationships of "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old = {
  __typename?: 'user_quiz_summaries_old';
  completed: Scalars['Boolean']['output'];
  correct_question?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  json_data?: Maybe<Scalars['jsonb']['output']>;
  last_answered?: Maybe<Scalars['Int']['output']>;
  question_list?: Maybe<Scalars['String']['output']>;
  question_order?: Maybe<Scalars['String']['output']>;
  quiz_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_quiz: Quiz_Quiz;
  score?: Maybe<Scalars['numeric']['output']>;
  total_correct_time?: Maybe<Scalars['interval']['output']>;
  total_question: Scalars['Int']['output'];
  total_time?: Maybe<Scalars['interval']['output']>;
  total_unattempted_time?: Maybe<Scalars['interval']['output']>;
  total_wrong_time?: Maybe<Scalars['interval']['output']>;
  unattempted_question?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Supertokens_All_Auth_Recipe_Users;
  /** An array relationship */
  user_activities: Array<User_Activity>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activity_Aggregate;
  user_answers: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  /** An array relationship */
  user_quiz_question_summaries: Array<User_Quiz_Question_Summaries_Old>;
  /** An aggregate relationship */
  user_quiz_question_summaries_aggregate: User_Quiz_Question_Summaries_Old_Aggregate;
  wrong_question?: Maybe<Scalars['Int']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "user_quiz_summaries_old" */
export type User_Quiz_Summaries_OldJson_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user_quiz_summaries_old" */
export type User_Quiz_Summaries_OldUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries_old" */
export type User_Quiz_Summaries_OldUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activity_Order_By>>;
  where?: InputMaybe<User_Activity_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries_old" */
export type User_Quiz_Summaries_OldUser_Quiz_Question_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};


/** columns and relationships of "user_quiz_summaries_old" */
export type User_Quiz_Summaries_OldUser_Quiz_Question_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Question_Summaries_Old_Order_By>>;
  where?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
};

/** aggregated selection of "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Aggregate = {
  __typename?: 'user_quiz_summaries_old_aggregate';
  aggregate?: Maybe<User_Quiz_Summaries_Old_Aggregate_Fields>;
  nodes: Array<User_Quiz_Summaries_Old>;
};

export type User_Quiz_Summaries_Old_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Count>;
};

export type User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Quiz_Summaries_Old_Select_Column_User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Quiz_Summaries_Old_Select_Column_User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Aggregate_Fields = {
  __typename?: 'user_quiz_summaries_old_aggregate_fields';
  avg?: Maybe<User_Quiz_Summaries_Old_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Quiz_Summaries_Old_Max_Fields>;
  min?: Maybe<User_Quiz_Summaries_Old_Min_Fields>;
  stddev?: Maybe<User_Quiz_Summaries_Old_Stddev_Fields>;
  stddev_pop?: Maybe<User_Quiz_Summaries_Old_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Quiz_Summaries_Old_Stddev_Samp_Fields>;
  sum?: Maybe<User_Quiz_Summaries_Old_Sum_Fields>;
  var_pop?: Maybe<User_Quiz_Summaries_Old_Var_Pop_Fields>;
  var_samp?: Maybe<User_Quiz_Summaries_Old_Var_Samp_Fields>;
  variance?: Maybe<User_Quiz_Summaries_Old_Variance_Fields>;
};


/** aggregate fields of "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Quiz_Summaries_Old_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Aggregate_Order_By = {
  avg?: InputMaybe<User_Quiz_Summaries_Old_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Quiz_Summaries_Old_Max_Order_By>;
  min?: InputMaybe<User_Quiz_Summaries_Old_Min_Order_By>;
  stddev?: InputMaybe<User_Quiz_Summaries_Old_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Quiz_Summaries_Old_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Quiz_Summaries_Old_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Quiz_Summaries_Old_Sum_Order_By>;
  var_pop?: InputMaybe<User_Quiz_Summaries_Old_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Quiz_Summaries_Old_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Quiz_Summaries_Old_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Quiz_Summaries_Old_Append_Input = {
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Arr_Rel_Insert_Input = {
  data: Array<User_Quiz_Summaries_Old_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Summaries_Old_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Quiz_Summaries_Old_Avg_Fields = {
  __typename?: 'user_quiz_summaries_old_avg_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Avg_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_quiz_summaries_old". All fields are combined with a logical 'AND'. */
export type User_Quiz_Summaries_Old_Bool_Exp = {
  _and?: InputMaybe<Array<User_Quiz_Summaries_Old_Bool_Exp>>;
  _not?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
  _or?: InputMaybe<Array<User_Quiz_Summaries_Old_Bool_Exp>>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  correct_question?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_question?: InputMaybe<Int_Comparison_Exp>;
  current_section?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  json_data?: InputMaybe<Jsonb_Comparison_Exp>;
  last_answered?: InputMaybe<Int_Comparison_Exp>;
  question_list?: InputMaybe<String_Comparison_Exp>;
  question_order?: InputMaybe<String_Comparison_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  score?: InputMaybe<Numeric_Comparison_Exp>;
  total_correct_time?: InputMaybe<Interval_Comparison_Exp>;
  total_question?: InputMaybe<Int_Comparison_Exp>;
  total_time?: InputMaybe<Interval_Comparison_Exp>;
  total_unattempted_time?: InputMaybe<Interval_Comparison_Exp>;
  total_wrong_time?: InputMaybe<Interval_Comparison_Exp>;
  unattempted_question?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  user_activities?: InputMaybe<User_Activity_Bool_Exp>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Bool_Exp>;
  user_answers?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_quiz_question_summaries?: InputMaybe<User_Quiz_Question_Summaries_Old_Bool_Exp>;
  user_quiz_question_summaries_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Old_Aggregate_Bool_Exp>;
  wrong_question?: InputMaybe<Int_Comparison_Exp>;
  xp?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_quiz_summaries_old" */
export enum User_Quiz_Summaries_Old_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserQuizSummariesPkey = 'user_quiz_summaries_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Quiz_Summaries_Old_Delete_At_Path_Input = {
  json_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Quiz_Summaries_Old_Delete_Elem_Input = {
  json_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Quiz_Summaries_Old_Delete_Key_Input = {
  json_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Inc_Input = {
  correct_question?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_answered?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_question?: InputMaybe<Scalars['Int']['input']>;
  unattempted_question?: InputMaybe<Scalars['Int']['input']>;
  wrong_question?: InputMaybe<Scalars['Int']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Insert_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  correct_question?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
  last_answered?: InputMaybe<Scalars['Int']['input']>;
  question_list?: InputMaybe<Scalars['String']['input']>;
  question_order?: InputMaybe<Scalars['String']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_correct_time?: InputMaybe<Scalars['interval']['input']>;
  total_question?: InputMaybe<Scalars['Int']['input']>;
  total_time?: InputMaybe<Scalars['interval']['input']>;
  total_unattempted_time?: InputMaybe<Scalars['interval']['input']>;
  total_wrong_time?: InputMaybe<Scalars['interval']['input']>;
  unattempted_question?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  user_activities?: InputMaybe<User_Activity_Arr_Rel_Insert_Input>;
  user_answers?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_quiz_question_summaries?: InputMaybe<User_Quiz_Question_Summaries_Old_Arr_Rel_Insert_Input>;
  wrong_question?: InputMaybe<Scalars['Int']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type User_Quiz_Summaries_Old_Max_Fields = {
  __typename?: 'user_quiz_summaries_old_max_fields';
  correct_question?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_answered?: Maybe<Scalars['Int']['output']>;
  question_list?: Maybe<Scalars['String']['output']>;
  question_order?: Maybe<Scalars['String']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_question?: Maybe<Scalars['Int']['output']>;
  unattempted_question?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_answers?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  wrong_question?: Maybe<Scalars['Int']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Max_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  question_list?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_answers?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Quiz_Summaries_Old_Min_Fields = {
  __typename?: 'user_quiz_summaries_old_min_fields';
  correct_question?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_answered?: Maybe<Scalars['Int']['output']>;
  question_list?: Maybe<Scalars['String']['output']>;
  question_order?: Maybe<Scalars['String']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_question?: Maybe<Scalars['Int']['output']>;
  unattempted_question?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_answers?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  wrong_question?: Maybe<Scalars['Int']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Min_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  question_list?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_answers?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Mutation_Response = {
  __typename?: 'user_quiz_summaries_old_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Quiz_Summaries_Old>;
};

/** input type for inserting object relation for remote table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Obj_Rel_Insert_Input = {
  data: User_Quiz_Summaries_Old_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Quiz_Summaries_Old_On_Conflict>;
};

/** on_conflict condition type for table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_On_Conflict = {
  constraint: User_Quiz_Summaries_Old_Constraint;
  update_columns?: Array<User_Quiz_Summaries_Old_Update_Column>;
  where?: InputMaybe<User_Quiz_Summaries_Old_Bool_Exp>;
};

/** Ordering options when selecting data from "user_quiz_summaries_old". */
export type User_Quiz_Summaries_Old_Order_By = {
  completed?: InputMaybe<Order_By>;
  correct_question?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  json_data?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  question_list?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  score?: InputMaybe<Order_By>;
  total_correct_time?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  total_time?: InputMaybe<Order_By>;
  total_unattempted_time?: InputMaybe<Order_By>;
  total_wrong_time?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  user_activities_aggregate?: InputMaybe<User_Activity_Aggregate_Order_By>;
  user_answers?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_quiz_question_summaries_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Old_Aggregate_Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_quiz_summaries_old */
export type User_Quiz_Summaries_Old_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Quiz_Summaries_Old_Prepend_Input = {
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user_quiz_summaries_old" */
export enum User_Quiz_Summaries_Old_Select_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CorrectQuestion = 'correct_question',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentQuestion = 'current_question',
  /** column name */
  CurrentSection = 'current_section',
  /** column name */
  Id = 'id',
  /** column name */
  JsonData = 'json_data',
  /** column name */
  LastAnswered = 'last_answered',
  /** column name */
  QuestionList = 'question_list',
  /** column name */
  QuestionOrder = 'question_order',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Score = 'score',
  /** column name */
  TotalCorrectTime = 'total_correct_time',
  /** column name */
  TotalQuestion = 'total_question',
  /** column name */
  TotalTime = 'total_time',
  /** column name */
  TotalUnattemptedTime = 'total_unattempted_time',
  /** column name */
  TotalWrongTime = 'total_wrong_time',
  /** column name */
  UnattemptedQuestion = 'unattempted_question',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAnswers = 'user_answers',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WrongQuestion = 'wrong_question',
  /** column name */
  Xp = 'xp'
}

/** select "user_quiz_summaries_old_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_quiz_summaries_old" */
export enum User_Quiz_Summaries_Old_Select_Column_User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Completed = 'completed'
}

/** select "user_quiz_summaries_old_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_quiz_summaries_old" */
export enum User_Quiz_Summaries_Old_Select_Column_User_Quiz_Summaries_Old_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Completed = 'completed'
}

/** input type for updating data in table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Set_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  correct_question?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
  last_answered?: InputMaybe<Scalars['Int']['input']>;
  question_list?: InputMaybe<Scalars['String']['input']>;
  question_order?: InputMaybe<Scalars['String']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_correct_time?: InputMaybe<Scalars['interval']['input']>;
  total_question?: InputMaybe<Scalars['Int']['input']>;
  total_time?: InputMaybe<Scalars['interval']['input']>;
  total_unattempted_time?: InputMaybe<Scalars['interval']['input']>;
  total_wrong_time?: InputMaybe<Scalars['interval']['input']>;
  unattempted_question?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_answers?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  wrong_question?: InputMaybe<Scalars['Int']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type User_Quiz_Summaries_Old_Stddev_Fields = {
  __typename?: 'user_quiz_summaries_old_stddev_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Stddev_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Quiz_Summaries_Old_Stddev_Pop_Fields = {
  __typename?: 'user_quiz_summaries_old_stddev_pop_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Stddev_Pop_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Quiz_Summaries_Old_Stddev_Samp_Fields = {
  __typename?: 'user_quiz_summaries_old_stddev_samp_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Stddev_Samp_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Quiz_Summaries_Old_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Quiz_Summaries_Old_Stream_Cursor_Value_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  correct_question?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
  last_answered?: InputMaybe<Scalars['Int']['input']>;
  question_list?: InputMaybe<Scalars['String']['input']>;
  question_order?: InputMaybe<Scalars['String']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_correct_time?: InputMaybe<Scalars['interval']['input']>;
  total_question?: InputMaybe<Scalars['Int']['input']>;
  total_time?: InputMaybe<Scalars['interval']['input']>;
  total_unattempted_time?: InputMaybe<Scalars['interval']['input']>;
  total_wrong_time?: InputMaybe<Scalars['interval']['input']>;
  unattempted_question?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_answers?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  wrong_question?: InputMaybe<Scalars['Int']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type User_Quiz_Summaries_Old_Sum_Fields = {
  __typename?: 'user_quiz_summaries_old_sum_fields';
  correct_question?: Maybe<Scalars['Int']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_answered?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_question?: Maybe<Scalars['Int']['output']>;
  unattempted_question?: Maybe<Scalars['Int']['output']>;
  wrong_question?: Maybe<Scalars['Int']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Sum_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** update columns of table "user_quiz_summaries_old" */
export enum User_Quiz_Summaries_Old_Update_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CorrectQuestion = 'correct_question',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentQuestion = 'current_question',
  /** column name */
  CurrentSection = 'current_section',
  /** column name */
  Id = 'id',
  /** column name */
  JsonData = 'json_data',
  /** column name */
  LastAnswered = 'last_answered',
  /** column name */
  QuestionList = 'question_list',
  /** column name */
  QuestionOrder = 'question_order',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Score = 'score',
  /** column name */
  TotalCorrectTime = 'total_correct_time',
  /** column name */
  TotalQuestion = 'total_question',
  /** column name */
  TotalTime = 'total_time',
  /** column name */
  TotalUnattemptedTime = 'total_unattempted_time',
  /** column name */
  TotalWrongTime = 'total_wrong_time',
  /** column name */
  UnattemptedQuestion = 'unattempted_question',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAnswers = 'user_answers',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WrongQuestion = 'wrong_question',
  /** column name */
  Xp = 'xp'
}

export type User_Quiz_Summaries_Old_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Quiz_Summaries_Old_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Quiz_Summaries_Old_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Quiz_Summaries_Old_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Quiz_Summaries_Old_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Quiz_Summaries_Old_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Quiz_Summaries_Old_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Quiz_Summaries_Old_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Quiz_Summaries_Old_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Quiz_Summaries_Old_Var_Pop_Fields = {
  __typename?: 'user_quiz_summaries_old_var_pop_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Var_Pop_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Quiz_Summaries_Old_Var_Samp_Fields = {
  __typename?: 'user_quiz_summaries_old_var_samp_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Var_Samp_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Quiz_Summaries_Old_Variance_Fields = {
  __typename?: 'user_quiz_summaries_old_variance_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_quiz_summaries_old" */
export type User_Quiz_Summaries_Old_Variance_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "user_quiz_summaries" */
export type User_Quiz_Summaries_On_Conflict = {
  constraint: User_Quiz_Summaries_Constraint;
  update_columns?: Array<User_Quiz_Summaries_Update_Column>;
  where?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_quiz_summaries". */
export type User_Quiz_Summaries_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  attempt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  did_accept_instruction?: InputMaybe<Order_By>;
  did_accept_terms_and_conditions?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  json_data?: InputMaybe<Order_By>;
  next_question_aggregate?: InputMaybe<Quiz_Quiz_Questions_Aggregate_Order_By>;
  number_of_attempted_questions?: InputMaybe<Order_By>;
  number_of_users_completed?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  remaining_time?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Supertokens_User_Additional_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_quiz_question_positions_aggregate?: InputMaybe<User_Quiz_Question_Positions_Aggregate_Order_By>;
  user_quiz_question_summaries_aggregate?: InputMaybe<User_Quiz_Question_Summaries_Aggregate_Order_By>;
  user_quiz_section_summaries_aggregate?: InputMaybe<User_Quiz_Section_Summaries_Aggregate_Order_By>;
  user_section_summaries_aggregate?: InputMaybe<User_Section_Summaries_Aggregate_Order_By>;
  user_timed_quiz_summaries_aggregate?: InputMaybe<User_Timed_Quiz_Summary_Aggregate_Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_quiz_summaries */
export type User_Quiz_Summaries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Quiz_Summaries_Prepend_Input = {
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user_quiz_summaries" */
export enum User_Quiz_Summaries_Select_Column {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPosition = 'current_position',
  /** column name */
  CurrentQuestion = 'current_question',
  /** column name */
  CurrentSection = 'current_section',
  /** column name */
  DidAcceptInstruction = 'did_accept_instruction',
  /** column name */
  DidAcceptTermsAndConditions = 'did_accept_terms_and_conditions',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  JsonData = 'json_data',
  /** column name */
  OldUserQuizSummaryId = 'old_user_quiz_summary_id',
  /** column name */
  Percentile = 'percentile',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Score = 'score',
  /** column name */
  TotalScore = 'total_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_quiz_summaries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_quiz_summaries" */
export enum User_Quiz_Summaries_Select_Column_User_Quiz_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DidAcceptInstruction = 'did_accept_instruction',
  /** column name */
  DidAcceptTermsAndConditions = 'did_accept_terms_and_conditions',
  /** column name */
  IsCompleted = 'is_completed'
}

/** select "user_quiz_summaries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_quiz_summaries" */
export enum User_Quiz_Summaries_Select_Column_User_Quiz_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DidAcceptInstruction = 'did_accept_instruction',
  /** column name */
  DidAcceptTermsAndConditions = 'did_accept_terms_and_conditions',
  /** column name */
  IsCompleted = 'is_completed'
}

/** input type for updating data in table "user_quiz_summaries" */
export type User_Quiz_Summaries_Set_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_position?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  did_accept_instruction?: InputMaybe<Scalars['Boolean']['input']>;
  did_accept_terms_and_conditions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
  old_user_quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  percentile?: InputMaybe<Scalars['numeric']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_score?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Quiz_Summaries_Stddev_Fields = {
  __typename?: 'user_quiz_summaries_stddev_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by stddev() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Stddev_Order_By = {
  attempt?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Quiz_Summaries_Stddev_Pop_Fields = {
  __typename?: 'user_quiz_summaries_stddev_pop_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by stddev_pop() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Stddev_Pop_Order_By = {
  attempt?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Quiz_Summaries_Stddev_Samp_Fields = {
  __typename?: 'user_quiz_summaries_stddev_samp_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by stddev_samp() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Stddev_Samp_Order_By = {
  attempt?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_quiz_summaries" */
export type User_Quiz_Summaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Quiz_Summaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Quiz_Summaries_Stream_Cursor_Value_Input = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_position?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  did_accept_instruction?: InputMaybe<Scalars['Boolean']['input']>;
  did_accept_terms_and_conditions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
  old_user_quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  percentile?: InputMaybe<Scalars['numeric']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_score?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Quiz_Summaries_Sum_Fields = {
  __typename?: 'user_quiz_summaries_sum_fields';
  attempt?: Maybe<Scalars['Int']['output']>;
  current_position?: Maybe<Scalars['Int']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['numeric']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_score?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Sum_Order_By = {
  attempt?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** update columns of table "user_quiz_summaries" */
export enum User_Quiz_Summaries_Update_Column {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPosition = 'current_position',
  /** column name */
  CurrentQuestion = 'current_question',
  /** column name */
  CurrentSection = 'current_section',
  /** column name */
  DidAcceptInstruction = 'did_accept_instruction',
  /** column name */
  DidAcceptTermsAndConditions = 'did_accept_terms_and_conditions',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  JsonData = 'json_data',
  /** column name */
  OldUserQuizSummaryId = 'old_user_quiz_summary_id',
  /** column name */
  Percentile = 'percentile',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Score = 'score',
  /** column name */
  TotalScore = 'total_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Quiz_Summaries_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Quiz_Summaries_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Quiz_Summaries_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Quiz_Summaries_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Quiz_Summaries_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Quiz_Summaries_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Quiz_Summaries_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Quiz_Summaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Quiz_Summaries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Quiz_Summaries_Var_Pop_Fields = {
  __typename?: 'user_quiz_summaries_var_pop_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by var_pop() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Var_Pop_Order_By = {
  attempt?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Quiz_Summaries_Var_Samp_Fields = {
  __typename?: 'user_quiz_summaries_var_samp_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by var_samp() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Var_Samp_Order_By = {
  attempt?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Quiz_Summaries_Variance_Fields = {
  __typename?: 'user_quiz_summaries_variance_fields';
  attempt?: Maybe<Scalars['Float']['output']>;
  current_position?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "number_of_attempted_questions" */
  number_of_attempted_questions?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "number_of_users_completed" */
  number_of_users_completed?: Maybe<Scalars['bigint']['output']>;
  old_user_quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned_for_test" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by variance() on columns of table "user_quiz_summaries" */
export type User_Quiz_Summaries_Variance_Order_By = {
  attempt?: InputMaybe<Order_By>;
  current_position?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  old_user_quiz_summary_id?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_recent_lessons" */
export type User_Recent_Lessons = {
  __typename?: 'user_recent_lessons';
  category_id?: Maybe<Scalars['Int']['output']>;
  last_visited?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  quiz_category?: Maybe<Quiz_Category>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_recent_lessons" */
export type User_Recent_Lessons_Aggregate = {
  __typename?: 'user_recent_lessons_aggregate';
  aggregate?: Maybe<User_Recent_Lessons_Aggregate_Fields>;
  nodes: Array<User_Recent_Lessons>;
};

export type User_Recent_Lessons_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Recent_Lessons_Aggregate_Bool_Exp_Count>;
};

export type User_Recent_Lessons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Recent_Lessons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_recent_lessons" */
export type User_Recent_Lessons_Aggregate_Fields = {
  __typename?: 'user_recent_lessons_aggregate_fields';
  avg?: Maybe<User_Recent_Lessons_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Recent_Lessons_Max_Fields>;
  min?: Maybe<User_Recent_Lessons_Min_Fields>;
  stddev?: Maybe<User_Recent_Lessons_Stddev_Fields>;
  stddev_pop?: Maybe<User_Recent_Lessons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Recent_Lessons_Stddev_Samp_Fields>;
  sum?: Maybe<User_Recent_Lessons_Sum_Fields>;
  var_pop?: Maybe<User_Recent_Lessons_Var_Pop_Fields>;
  var_samp?: Maybe<User_Recent_Lessons_Var_Samp_Fields>;
  variance?: Maybe<User_Recent_Lessons_Variance_Fields>;
};


/** aggregate fields of "user_recent_lessons" */
export type User_Recent_Lessons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Recent_Lessons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_recent_lessons" */
export type User_Recent_Lessons_Aggregate_Order_By = {
  avg?: InputMaybe<User_Recent_Lessons_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Recent_Lessons_Max_Order_By>;
  min?: InputMaybe<User_Recent_Lessons_Min_Order_By>;
  stddev?: InputMaybe<User_Recent_Lessons_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Recent_Lessons_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Recent_Lessons_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Recent_Lessons_Sum_Order_By>;
  var_pop?: InputMaybe<User_Recent_Lessons_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Recent_Lessons_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Recent_Lessons_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_recent_lessons" */
export type User_Recent_Lessons_Arr_Rel_Insert_Input = {
  data: Array<User_Recent_Lessons_Insert_Input>;
};

/** aggregate avg on columns */
export type User_Recent_Lessons_Avg_Fields = {
  __typename?: 'user_recent_lessons_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_recent_lessons". All fields are combined with a logical 'AND'. */
export type User_Recent_Lessons_Bool_Exp = {
  _and?: InputMaybe<Array<User_Recent_Lessons_Bool_Exp>>;
  _not?: InputMaybe<User_Recent_Lessons_Bool_Exp>;
  _or?: InputMaybe<Array<User_Recent_Lessons_Bool_Exp>>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  last_visited?: InputMaybe<Timestamptz_Comparison_Exp>;
  quiz_category?: InputMaybe<Quiz_Category_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "user_recent_lessons" */
export type User_Recent_Lessons_Insert_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  last_visited?: InputMaybe<Scalars['timestamptz']['input']>;
  quiz_category?: InputMaybe<Quiz_Category_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Recent_Lessons_Max_Fields = {
  __typename?: 'user_recent_lessons_max_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  last_visited?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  last_visited?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Recent_Lessons_Min_Fields = {
  __typename?: 'user_recent_lessons_min_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  last_visited?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  last_visited?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_recent_lessons". */
export type User_Recent_Lessons_Order_By = {
  category_id?: InputMaybe<Order_By>;
  last_visited?: InputMaybe<Order_By>;
  quiz_category?: InputMaybe<Quiz_Category_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_recent_lessons" */
export enum User_Recent_Lessons_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  LastVisited = 'last_visited',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type User_Recent_Lessons_Stddev_Fields = {
  __typename?: 'user_recent_lessons_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Recent_Lessons_Stddev_Pop_Fields = {
  __typename?: 'user_recent_lessons_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Recent_Lessons_Stddev_Samp_Fields = {
  __typename?: 'user_recent_lessons_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_recent_lessons" */
export type User_Recent_Lessons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Recent_Lessons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Recent_Lessons_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  last_visited?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Recent_Lessons_Sum_Fields = {
  __typename?: 'user_recent_lessons_sum_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type User_Recent_Lessons_Var_Pop_Fields = {
  __typename?: 'user_recent_lessons_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Recent_Lessons_Var_Samp_Fields = {
  __typename?: 'user_recent_lessons_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Recent_Lessons_Variance_Fields = {
  __typename?: 'user_recent_lessons_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_recent_lessons" */
export type User_Recent_Lessons_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_section_summaries" */
export type User_Section_Summaries = {
  __typename?: 'user_section_summaries';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  quiz_section: Quiz_Section;
  quiz_summary_id: Scalars['uuid']['output'];
  section_id: Scalars['Int']['output'];
  total_score: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
  /** An object relationship */
  user_quiz_summary: User_Quiz_Summaries;
};

/** aggregated selection of "user_section_summaries" */
export type User_Section_Summaries_Aggregate = {
  __typename?: 'user_section_summaries_aggregate';
  aggregate?: Maybe<User_Section_Summaries_Aggregate_Fields>;
  nodes: Array<User_Section_Summaries>;
};

export type User_Section_Summaries_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Section_Summaries_Aggregate_Bool_Exp_Count>;
};

export type User_Section_Summaries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Section_Summaries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_section_summaries" */
export type User_Section_Summaries_Aggregate_Fields = {
  __typename?: 'user_section_summaries_aggregate_fields';
  avg?: Maybe<User_Section_Summaries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Section_Summaries_Max_Fields>;
  min?: Maybe<User_Section_Summaries_Min_Fields>;
  stddev?: Maybe<User_Section_Summaries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Section_Summaries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Section_Summaries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Section_Summaries_Sum_Fields>;
  var_pop?: Maybe<User_Section_Summaries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Section_Summaries_Var_Samp_Fields>;
  variance?: Maybe<User_Section_Summaries_Variance_Fields>;
};


/** aggregate fields of "user_section_summaries" */
export type User_Section_Summaries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Section_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_section_summaries" */
export type User_Section_Summaries_Aggregate_Order_By = {
  avg?: InputMaybe<User_Section_Summaries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Section_Summaries_Max_Order_By>;
  min?: InputMaybe<User_Section_Summaries_Min_Order_By>;
  stddev?: InputMaybe<User_Section_Summaries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Section_Summaries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Section_Summaries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Section_Summaries_Sum_Order_By>;
  var_pop?: InputMaybe<User_Section_Summaries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Section_Summaries_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Section_Summaries_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_section_summaries" */
export type User_Section_Summaries_Arr_Rel_Insert_Input = {
  data: Array<User_Section_Summaries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Section_Summaries_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Section_Summaries_Avg_Fields = {
  __typename?: 'user_section_summaries_avg_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Avg_Order_By = {
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_section_summaries". All fields are combined with a logical 'AND'. */
export type User_Section_Summaries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Section_Summaries_Bool_Exp>>;
  _not?: InputMaybe<User_Section_Summaries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Section_Summaries_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  quiz_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
  section_id?: InputMaybe<Int_Comparison_Exp>;
  total_score?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
};

/** unique or primary key constraints on table "user_section_summaries" */
export enum User_Section_Summaries_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSectionSummariesPkey = 'user_section_summaries_pkey'
}

/** input type for incrementing numeric columns in table "user_section_summaries" */
export type User_Section_Summaries_Inc_Input = {
  section_id?: InputMaybe<Scalars['Int']['input']>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_section_summaries" */
export type User_Section_Summaries_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Section_Summaries_Max_Fields = {
  __typename?: 'user_section_summaries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Section_Summaries_Min_Fields = {
  __typename?: 'user_section_summaries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_section_summaries" */
export type User_Section_Summaries_Mutation_Response = {
  __typename?: 'user_section_summaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Section_Summaries>;
};

/** on_conflict condition type for table "user_section_summaries" */
export type User_Section_Summaries_On_Conflict = {
  constraint: User_Section_Summaries_Constraint;
  update_columns?: Array<User_Section_Summaries_Update_Column>;
  where?: InputMaybe<User_Section_Summaries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_section_summaries". */
export type User_Section_Summaries_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Order_By>;
};

/** primary key columns input for table: user_section_summaries */
export type User_Section_Summaries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_section_summaries" */
export enum User_Section_Summaries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  TotalScore = 'total_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_section_summaries" */
export type User_Section_Summaries_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Section_Summaries_Stddev_Fields = {
  __typename?: 'user_section_summaries_stddev_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Stddev_Order_By = {
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Section_Summaries_Stddev_Pop_Fields = {
  __typename?: 'user_section_summaries_stddev_pop_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Stddev_Pop_Order_By = {
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Section_Summaries_Stddev_Samp_Fields = {
  __typename?: 'user_section_summaries_stddev_samp_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Stddev_Samp_Order_By = {
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_section_summaries" */
export type User_Section_Summaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Section_Summaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Section_Summaries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Section_Summaries_Sum_Fields = {
  __typename?: 'user_section_summaries_sum_fields';
  section_id?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Sum_Order_By = {
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** update columns of table "user_section_summaries" */
export enum User_Section_Summaries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  TotalScore = 'total_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Section_Summaries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Section_Summaries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Section_Summaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Section_Summaries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Section_Summaries_Var_Pop_Fields = {
  __typename?: 'user_section_summaries_var_pop_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Var_Pop_Order_By = {
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Section_Summaries_Var_Samp_Fields = {
  __typename?: 'user_section_summaries_var_samp_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Var_Samp_Order_By = {
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Section_Summaries_Variance_Fields = {
  __typename?: 'user_section_summaries_variance_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_section_summaries" */
export type User_Section_Summaries_Variance_Order_By = {
  section_id?: InputMaybe<Order_By>;
  total_score?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries = {
  __typename?: 'user_speed_test_questions_summaries';
  answer: Scalars['String']['output'];
  correct_option?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_attempted: Scalars['Boolean']['output'];
  is_bookmarked: Scalars['Boolean']['output'];
  /** A computed field, executes function "user_speed_test_questions_summaries_is_correct" */
  is_correct?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  quiz_question?: Maybe<Quiz_Question>;
  quiz_question_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  time_taken?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_speed_test_summary_id: Scalars['uuid']['output'];
  /** An object relationship */
  user_speed_tests_summary: User_Speed_Tests_Summaries;
};

/** aggregated selection of "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Aggregate = {
  __typename?: 'user_speed_test_questions_summaries_aggregate';
  aggregate?: Maybe<User_Speed_Test_Questions_Summaries_Aggregate_Fields>;
  nodes: Array<User_Speed_Test_Questions_Summaries>;
};

export type User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Count>;
};

export type User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Speed_Test_Questions_Summaries_Select_Column_User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Speed_Test_Questions_Summaries_Select_Column_User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Aggregate_Fields = {
  __typename?: 'user_speed_test_questions_summaries_aggregate_fields';
  avg?: Maybe<User_Speed_Test_Questions_Summaries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Speed_Test_Questions_Summaries_Max_Fields>;
  min?: Maybe<User_Speed_Test_Questions_Summaries_Min_Fields>;
  stddev?: Maybe<User_Speed_Test_Questions_Summaries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Speed_Test_Questions_Summaries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Speed_Test_Questions_Summaries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Speed_Test_Questions_Summaries_Sum_Fields>;
  var_pop?: Maybe<User_Speed_Test_Questions_Summaries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Speed_Test_Questions_Summaries_Var_Samp_Fields>;
  variance?: Maybe<User_Speed_Test_Questions_Summaries_Variance_Fields>;
};


/** aggregate fields of "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Aggregate_Order_By = {
  avg?: InputMaybe<User_Speed_Test_Questions_Summaries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Speed_Test_Questions_Summaries_Max_Order_By>;
  min?: InputMaybe<User_Speed_Test_Questions_Summaries_Min_Order_By>;
  stddev?: InputMaybe<User_Speed_Test_Questions_Summaries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Speed_Test_Questions_Summaries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Speed_Test_Questions_Summaries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Speed_Test_Questions_Summaries_Sum_Order_By>;
  var_pop?: InputMaybe<User_Speed_Test_Questions_Summaries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Speed_Test_Questions_Summaries_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Speed_Test_Questions_Summaries_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Arr_Rel_Insert_Input = {
  data: Array<User_Speed_Test_Questions_Summaries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Speed_Test_Questions_Summaries_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Speed_Test_Questions_Summaries_Avg_Fields = {
  __typename?: 'user_speed_test_questions_summaries_avg_fields';
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Float']['output']>;
  time_taken?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Avg_Order_By = {
  quiz_question_id?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_speed_test_questions_summaries". All fields are combined with a logical 'AND'. */
export type User_Speed_Test_Questions_Summaries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Bool_Exp>>;
  _not?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  correct_option?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_attempted?: InputMaybe<Boolean_Comparison_Exp>;
  is_bookmarked?: InputMaybe<Boolean_Comparison_Exp>;
  is_correct?: InputMaybe<Boolean_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  question_number?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_question_id?: InputMaybe<Int_Comparison_Exp>;
  response?: InputMaybe<String_Comparison_Exp>;
  time_taken?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_speed_test_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_speed_tests_summary?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};

/** unique or primary key constraints on table "user_speed_test_questions_summaries" */
export enum User_Speed_Test_Questions_Summaries_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSpeedTestQuestionsSummariesPkey = 'user_speed_test_questions_summaries_pkey'
}

/** input type for incrementing numeric columns in table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Inc_Input = {
  quiz_question_id?: InputMaybe<Scalars['Int']['input']>;
  time_taken?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Insert_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  correct_option?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  quiz_question_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_speed_test_summary_id?: InputMaybe<Scalars['uuid']['input']>;
  user_speed_tests_summary?: InputMaybe<User_Speed_Tests_Summaries_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Speed_Test_Questions_Summaries_Max_Fields = {
  __typename?: 'user_speed_test_questions_summaries_max_fields';
  answer?: Maybe<Scalars['String']['output']>;
  correct_option?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  time_taken?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_speed_test_summary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  correct_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  quiz_question_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_speed_test_summary_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Speed_Test_Questions_Summaries_Min_Fields = {
  __typename?: 'user_speed_test_questions_summaries_min_fields';
  answer?: Maybe<Scalars['String']['output']>;
  correct_option?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  time_taken?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_speed_test_summary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  correct_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  quiz_question_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_speed_test_summary_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Mutation_Response = {
  __typename?: 'user_speed_test_questions_summaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Speed_Test_Questions_Summaries>;
};

/** on_conflict condition type for table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_On_Conflict = {
  constraint: User_Speed_Test_Questions_Summaries_Constraint;
  update_columns?: Array<User_Speed_Test_Questions_Summaries_Update_Column>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_speed_test_questions_summaries". */
export type User_Speed_Test_Questions_Summaries_Order_By = {
  answer?: InputMaybe<Order_By>;
  correct_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_attempted?: InputMaybe<Order_By>;
  is_bookmarked?: InputMaybe<Order_By>;
  is_correct?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  question_number?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  quiz_question_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_speed_test_summary_id?: InputMaybe<Order_By>;
  user_speed_tests_summary?: InputMaybe<User_Speed_Tests_Summaries_Order_By>;
};

/** primary key columns input for table: user_speed_test_questions_summaries */
export type User_Speed_Test_Questions_Summaries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_speed_test_questions_summaries" */
export enum User_Speed_Test_Questions_Summaries_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CorrectOption = 'correct_option',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  Question = 'question',
  /** column name */
  QuizQuestionId = 'quiz_question_id',
  /** column name */
  Response = 'response',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserSpeedTestSummaryId = 'user_speed_test_summary_id'
}

/** select "user_speed_test_questions_summaries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_speed_test_questions_summaries" */
export enum User_Speed_Test_Questions_Summaries_Select_Column_User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked'
}

/** select "user_speed_test_questions_summaries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_speed_test_questions_summaries" */
export enum User_Speed_Test_Questions_Summaries_Select_Column_User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked'
}

/** input type for updating data in table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Set_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  correct_option?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  quiz_question_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_speed_test_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type User_Speed_Test_Questions_Summaries_Stddev_Fields = {
  __typename?: 'user_speed_test_questions_summaries_stddev_fields';
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Float']['output']>;
  time_taken?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Stddev_Order_By = {
  quiz_question_id?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Speed_Test_Questions_Summaries_Stddev_Pop_Fields = {
  __typename?: 'user_speed_test_questions_summaries_stddev_pop_fields';
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Float']['output']>;
  time_taken?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Stddev_Pop_Order_By = {
  quiz_question_id?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Speed_Test_Questions_Summaries_Stddev_Samp_Fields = {
  __typename?: 'user_speed_test_questions_summaries_stddev_samp_fields';
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Float']['output']>;
  time_taken?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Stddev_Samp_Order_By = {
  quiz_question_id?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Speed_Test_Questions_Summaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Speed_Test_Questions_Summaries_Stream_Cursor_Value_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  correct_option?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  quiz_question_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_speed_test_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type User_Speed_Test_Questions_Summaries_Sum_Fields = {
  __typename?: 'user_speed_test_questions_summaries_sum_fields';
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Int']['output']>;
  time_taken?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Sum_Order_By = {
  quiz_question_id?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
};

/** update columns of table "user_speed_test_questions_summaries" */
export enum User_Speed_Test_Questions_Summaries_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CorrectOption = 'correct_option',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  Question = 'question',
  /** column name */
  QuizQuestionId = 'quiz_question_id',
  /** column name */
  Response = 'response',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserSpeedTestSummaryId = 'user_speed_test_summary_id'
}

export type User_Speed_Test_Questions_Summaries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Speed_Test_Questions_Summaries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Speed_Test_Questions_Summaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Speed_Test_Questions_Summaries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Speed_Test_Questions_Summaries_Var_Pop_Fields = {
  __typename?: 'user_speed_test_questions_summaries_var_pop_fields';
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Float']['output']>;
  time_taken?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Var_Pop_Order_By = {
  quiz_question_id?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Speed_Test_Questions_Summaries_Var_Samp_Fields = {
  __typename?: 'user_speed_test_questions_summaries_var_samp_fields';
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Float']['output']>;
  time_taken?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Var_Samp_Order_By = {
  quiz_question_id?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Speed_Test_Questions_Summaries_Variance_Fields = {
  __typename?: 'user_speed_test_questions_summaries_variance_fields';
  /** A computed field, executes function "user_speed_test_questions_summaries_question_number" */
  question_number?: Maybe<Scalars['Int']['output']>;
  quiz_question_id?: Maybe<Scalars['Float']['output']>;
  time_taken?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_speed_test_questions_summaries" */
export type User_Speed_Test_Questions_Summaries_Variance_Order_By = {
  quiz_question_id?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries = {
  __typename?: 'user_speed_tests_summaries';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  config: Scalars['json']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_completed: Scalars['Boolean']['output'];
  question_order: Scalars['String']['output'];
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  quiz_quiz?: Maybe<Quiz_Quiz>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  speed_test_category?: Maybe<Speed_Test_Category>;
  test_category: Scalars['String']['output'];
  test_time: Scalars['Int']['output'];
  test_type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
  /** An array relationship */
  user_speed_test_questions_summaries: Array<User_Speed_Test_Questions_Summaries>;
  /** An aggregate relationship */
  user_speed_test_questions_summaries_aggregate: User_Speed_Test_Questions_Summaries_Aggregate;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};


/** columns and relationships of "user_speed_tests_summaries" */
export type User_Speed_Tests_SummariesConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user_speed_tests_summaries" */
export type User_Speed_Tests_SummariesUser_Speed_Test_Questions_SummariesArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};


/** columns and relationships of "user_speed_tests_summaries" */
export type User_Speed_Tests_SummariesUser_Speed_Test_Questions_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Speed_Test_Questions_Summaries_Order_By>>;
  where?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
};

/** aggregated selection of "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Aggregate = {
  __typename?: 'user_speed_tests_summaries_aggregate';
  aggregate?: Maybe<User_Speed_Tests_Summaries_Aggregate_Fields>;
  nodes: Array<User_Speed_Tests_Summaries>;
};

export type User_Speed_Tests_Summaries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Count>;
};

export type User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Speed_Tests_Summaries_Select_Column_User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Speed_Tests_Summaries_Select_Column_User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Aggregate_Fields = {
  __typename?: 'user_speed_tests_summaries_aggregate_fields';
  avg?: Maybe<User_Speed_Tests_Summaries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Speed_Tests_Summaries_Max_Fields>;
  min?: Maybe<User_Speed_Tests_Summaries_Min_Fields>;
  stddev?: Maybe<User_Speed_Tests_Summaries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Speed_Tests_Summaries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Speed_Tests_Summaries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Speed_Tests_Summaries_Sum_Fields>;
  var_pop?: Maybe<User_Speed_Tests_Summaries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Speed_Tests_Summaries_Var_Samp_Fields>;
  variance?: Maybe<User_Speed_Tests_Summaries_Variance_Fields>;
};


/** aggregate fields of "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Speed_Tests_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Aggregate_Order_By = {
  avg?: InputMaybe<User_Speed_Tests_Summaries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Speed_Tests_Summaries_Max_Order_By>;
  min?: InputMaybe<User_Speed_Tests_Summaries_Min_Order_By>;
  stddev?: InputMaybe<User_Speed_Tests_Summaries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Speed_Tests_Summaries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Speed_Tests_Summaries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Speed_Tests_Summaries_Sum_Order_By>;
  var_pop?: InputMaybe<User_Speed_Tests_Summaries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Speed_Tests_Summaries_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Speed_Tests_Summaries_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Arr_Rel_Insert_Input = {
  data: Array<User_Speed_Tests_Summaries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Speed_Tests_Summaries_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Speed_Tests_Summaries_Avg_Fields = {
  __typename?: 'user_speed_tests_summaries_avg_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by avg() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Avg_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_speed_tests_summaries". All fields are combined with a logical 'AND'. */
export type User_Speed_Tests_Summaries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Speed_Tests_Summaries_Bool_Exp>>;
  _not?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Speed_Tests_Summaries_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  config?: InputMaybe<Json_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  question_order?: InputMaybe<String_Comparison_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  score?: InputMaybe<Int_Comparison_Exp>;
  speed_test_category?: InputMaybe<Speed_Test_Category_Bool_Exp>;
  test_category?: InputMaybe<String_Comparison_Exp>;
  test_time?: InputMaybe<Int_Comparison_Exp>;
  test_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_speed_test_questions_summaries?: InputMaybe<User_Speed_Test_Questions_Summaries_Bool_Exp>;
  user_speed_test_questions_summaries_aggregate?: InputMaybe<User_Speed_Test_Questions_Summaries_Aggregate_Bool_Exp>;
  xp?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_speed_tests_summaries" */
export enum User_Speed_Tests_Summaries_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSpeedTestsSummariesPkey = 'user_speed_tests_summaries_pkey'
}

/** input type for incrementing numeric columns in table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Inc_Input = {
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  test_time?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  config?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  question_order?: InputMaybe<Scalars['String']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  speed_test_category?: InputMaybe<Speed_Test_Category_Obj_Rel_Insert_Input>;
  test_category?: InputMaybe<Scalars['String']['input']>;
  test_time?: InputMaybe<Scalars['Int']['input']>;
  test_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_speed_test_questions_summaries?: InputMaybe<User_Speed_Test_Questions_Summaries_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Speed_Tests_Summaries_Max_Fields = {
  __typename?: 'user_speed_tests_summaries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_order?: Maybe<Scalars['String']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_category?: Maybe<Scalars['String']['output']>;
  test_time?: Maybe<Scalars['Int']['output']>;
  test_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  test_category?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Speed_Tests_Summaries_Min_Fields = {
  __typename?: 'user_speed_tests_summaries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_order?: Maybe<Scalars['String']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_category?: Maybe<Scalars['String']['output']>;
  test_time?: Maybe<Scalars['Int']['output']>;
  test_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  test_category?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Mutation_Response = {
  __typename?: 'user_speed_tests_summaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Speed_Tests_Summaries>;
};

/** input type for inserting object relation for remote table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Obj_Rel_Insert_Input = {
  data: User_Speed_Tests_Summaries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Speed_Tests_Summaries_On_Conflict>;
};

/** on_conflict condition type for table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_On_Conflict = {
  constraint: User_Speed_Tests_Summaries_Constraint;
  update_columns?: Array<User_Speed_Tests_Summaries_Update_Column>;
  where?: InputMaybe<User_Speed_Tests_Summaries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_speed_tests_summaries". */
export type User_Speed_Tests_Summaries_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  quiz_quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  score?: InputMaybe<Order_By>;
  speed_test_category?: InputMaybe<Speed_Test_Category_Order_By>;
  test_category?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_speed_test_questions_summaries_aggregate?: InputMaybe<User_Speed_Test_Questions_Summaries_Aggregate_Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_speed_tests_summaries */
export type User_Speed_Tests_Summaries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_speed_tests_summaries" */
export enum User_Speed_Tests_Summaries_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  QuestionOrder = 'question_order',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  TestCategory = 'test_category',
  /** column name */
  TestTime = 'test_time',
  /** column name */
  TestType = 'test_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_speed_tests_summaries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_speed_tests_summaries" */
export enum User_Speed_Tests_Summaries_Select_Column_User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** select "user_speed_tests_summaries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_speed_tests_summaries" */
export enum User_Speed_Tests_Summaries_Select_Column_User_Speed_Tests_Summaries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCompleted = 'is_completed'
}

/** input type for updating data in table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Set_Input = {
  config?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  question_order?: InputMaybe<Scalars['String']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  test_category?: InputMaybe<Scalars['String']['input']>;
  test_time?: InputMaybe<Scalars['Int']['input']>;
  test_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Speed_Tests_Summaries_Stddev_Fields = {
  __typename?: 'user_speed_tests_summaries_stddev_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by stddev() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Stddev_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Speed_Tests_Summaries_Stddev_Pop_Fields = {
  __typename?: 'user_speed_tests_summaries_stddev_pop_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by stddev_pop() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Stddev_Pop_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Speed_Tests_Summaries_Stddev_Samp_Fields = {
  __typename?: 'user_speed_tests_summaries_stddev_samp_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by stddev_samp() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Stddev_Samp_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Speed_Tests_Summaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Speed_Tests_Summaries_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  question_order?: InputMaybe<Scalars['String']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  test_category?: InputMaybe<Scalars['String']['input']>;
  test_time?: InputMaybe<Scalars['Int']['input']>;
  test_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Speed_Tests_Summaries_Sum_Fields = {
  __typename?: 'user_speed_tests_summaries_sum_fields';
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_time?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Sum_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
};

/** update columns of table "user_speed_tests_summaries" */
export enum User_Speed_Tests_Summaries_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  QuestionOrder = 'question_order',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  TestCategory = 'test_category',
  /** column name */
  TestTime = 'test_time',
  /** column name */
  TestType = 'test_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Speed_Tests_Summaries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Speed_Tests_Summaries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Speed_Tests_Summaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Speed_Tests_Summaries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Speed_Tests_Summaries_Var_Pop_Fields = {
  __typename?: 'user_speed_tests_summaries_var_pop_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by var_pop() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Var_Pop_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Speed_Tests_Summaries_Var_Samp_Fields = {
  __typename?: 'user_speed_tests_summaries_var_samp_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by var_samp() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Var_Samp_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Speed_Tests_Summaries_Variance_Fields = {
  __typename?: 'user_speed_tests_summaries_variance_fields';
  quiz_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "calculate_score" */
  score?: Maybe<Scalars['Int']['output']>;
  test_time?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_total_xp_earned" */
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by variance() on columns of table "user_speed_tests_summaries" */
export type User_Speed_Tests_Summaries_Variance_Order_By = {
  quiz_id?: InputMaybe<Order_By>;
  test_time?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary = {
  __typename?: 'user_timed_quiz_summary';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_section_completed: Scalars['Boolean']['output'];
  /** An object relationship */
  quiz_section: Quiz_Section;
  remaining_time: Scalars['interval']['output'];
  section_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_quiz_summary: User_Quiz_Summaries;
  user_quiz_summary_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Aggregate = {
  __typename?: 'user_timed_quiz_summary_aggregate';
  aggregate?: Maybe<User_Timed_Quiz_Summary_Aggregate_Fields>;
  nodes: Array<User_Timed_Quiz_Summary>;
};

export type User_Timed_Quiz_Summary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Count>;
};

export type User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Timed_Quiz_Summary_Select_Column_User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Timed_Quiz_Summary_Select_Column_User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Aggregate_Fields = {
  __typename?: 'user_timed_quiz_summary_aggregate_fields';
  avg?: Maybe<User_Timed_Quiz_Summary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Timed_Quiz_Summary_Max_Fields>;
  min?: Maybe<User_Timed_Quiz_Summary_Min_Fields>;
  stddev?: Maybe<User_Timed_Quiz_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<User_Timed_Quiz_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Timed_Quiz_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<User_Timed_Quiz_Summary_Sum_Fields>;
  var_pop?: Maybe<User_Timed_Quiz_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<User_Timed_Quiz_Summary_Var_Samp_Fields>;
  variance?: Maybe<User_Timed_Quiz_Summary_Variance_Fields>;
};


/** aggregate fields of "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Timed_Quiz_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Aggregate_Order_By = {
  avg?: InputMaybe<User_Timed_Quiz_Summary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Timed_Quiz_Summary_Max_Order_By>;
  min?: InputMaybe<User_Timed_Quiz_Summary_Min_Order_By>;
  stddev?: InputMaybe<User_Timed_Quiz_Summary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Timed_Quiz_Summary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Timed_Quiz_Summary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Timed_Quiz_Summary_Sum_Order_By>;
  var_pop?: InputMaybe<User_Timed_Quiz_Summary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Timed_Quiz_Summary_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Timed_Quiz_Summary_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Arr_Rel_Insert_Input = {
  data: Array<User_Timed_Quiz_Summary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Timed_Quiz_Summary_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Timed_Quiz_Summary_Avg_Fields = {
  __typename?: 'user_timed_quiz_summary_avg_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Avg_Order_By = {
  section_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_timed_quiz_summary". All fields are combined with a logical 'AND'. */
export type User_Timed_Quiz_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<User_Timed_Quiz_Summary_Bool_Exp>>;
  _not?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<User_Timed_Quiz_Summary_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_section_completed?: InputMaybe<Boolean_Comparison_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  remaining_time?: InputMaybe<Interval_Comparison_Exp>;
  section_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Bool_Exp>;
  user_quiz_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_timed_quiz_summary" */
export enum User_Timed_Quiz_Summary_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersTimedQuizSummaryPkey = 'users_timed_quiz_summary_pkey'
}

/** input type for incrementing numeric columns in table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Inc_Input = {
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_section_completed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  remaining_time?: InputMaybe<Scalars['interval']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Obj_Rel_Insert_Input>;
  user_quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Timed_Quiz_Summary_Max_Fields = {
  __typename?: 'user_timed_quiz_summary_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_summary_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Timed_Quiz_Summary_Min_Fields = {
  __typename?: 'user_timed_quiz_summary_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_quiz_summary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_summary_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Mutation_Response = {
  __typename?: 'user_timed_quiz_summary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Timed_Quiz_Summary>;
};

/** on_conflict condition type for table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_On_Conflict = {
  constraint: User_Timed_Quiz_Summary_Constraint;
  update_columns?: Array<User_Timed_Quiz_Summary_Update_Column>;
  where?: InputMaybe<User_Timed_Quiz_Summary_Bool_Exp>;
};

/** Ordering options when selecting data from "user_timed_quiz_summary". */
export type User_Timed_Quiz_Summary_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_section_completed?: InputMaybe<Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  remaining_time?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_summary?: InputMaybe<User_Quiz_Summaries_Order_By>;
  user_quiz_summary_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_timed_quiz_summary */
export type User_Timed_Quiz_Summary_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_timed_quiz_summary" */
export enum User_Timed_Quiz_Summary_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsSectionCompleted = 'is_section_completed',
  /** column name */
  RemainingTime = 'remaining_time',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserQuizSummaryId = 'user_quiz_summary_id'
}

/** select "user_timed_quiz_summary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_timed_quiz_summary" */
export enum User_Timed_Quiz_Summary_Select_Column_User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsSectionCompleted = 'is_section_completed'
}

/** select "user_timed_quiz_summary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_timed_quiz_summary" */
export enum User_Timed_Quiz_Summary_Select_Column_User_Timed_Quiz_Summary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsSectionCompleted = 'is_section_completed'
}

/** input type for updating data in table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_section_completed?: InputMaybe<Scalars['Boolean']['input']>;
  remaining_time?: InputMaybe<Scalars['interval']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type User_Timed_Quiz_Summary_Stddev_Fields = {
  __typename?: 'user_timed_quiz_summary_stddev_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Stddev_Order_By = {
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Timed_Quiz_Summary_Stddev_Pop_Fields = {
  __typename?: 'user_timed_quiz_summary_stddev_pop_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Stddev_Pop_Order_By = {
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Timed_Quiz_Summary_Stddev_Samp_Fields = {
  __typename?: 'user_timed_quiz_summary_stddev_samp_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Stddev_Samp_Order_By = {
  section_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Timed_Quiz_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Timed_Quiz_Summary_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_section_completed?: InputMaybe<Scalars['Boolean']['input']>;
  remaining_time?: InputMaybe<Scalars['interval']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_summary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type User_Timed_Quiz_Summary_Sum_Fields = {
  __typename?: 'user_timed_quiz_summary_sum_fields';
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Sum_Order_By = {
  section_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_timed_quiz_summary" */
export enum User_Timed_Quiz_Summary_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsSectionCompleted = 'is_section_completed',
  /** column name */
  RemainingTime = 'remaining_time',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserQuizSummaryId = 'user_quiz_summary_id'
}

export type User_Timed_Quiz_Summary_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Timed_Quiz_Summary_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Timed_Quiz_Summary_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Timed_Quiz_Summary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Timed_Quiz_Summary_Var_Pop_Fields = {
  __typename?: 'user_timed_quiz_summary_var_pop_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Var_Pop_Order_By = {
  section_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Timed_Quiz_Summary_Var_Samp_Fields = {
  __typename?: 'user_timed_quiz_summary_var_samp_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Var_Samp_Order_By = {
  section_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Timed_Quiz_Summary_Variance_Fields = {
  __typename?: 'user_timed_quiz_summary_variance_fields';
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_timed_quiz_summary" */
export type User_Timed_Quiz_Summary_Variance_Order_By = {
  section_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_total_score" */
export type User_Total_Score = {
  __typename?: 'user_total_score';
  sum: Scalars['numeric']['output'];
};

/** aggregated selection of "user_total_score" */
export type User_Total_Score_Aggregate = {
  __typename?: 'user_total_score_aggregate';
  aggregate?: Maybe<User_Total_Score_Aggregate_Fields>;
  nodes: Array<User_Total_Score>;
};

/** aggregate fields of "user_total_score" */
export type User_Total_Score_Aggregate_Fields = {
  __typename?: 'user_total_score_aggregate_fields';
  avg?: Maybe<User_Total_Score_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Total_Score_Max_Fields>;
  min?: Maybe<User_Total_Score_Min_Fields>;
  stddev?: Maybe<User_Total_Score_Stddev_Fields>;
  stddev_pop?: Maybe<User_Total_Score_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Total_Score_Stddev_Samp_Fields>;
  sum?: Maybe<User_Total_Score_Sum_Fields>;
  var_pop?: Maybe<User_Total_Score_Var_Pop_Fields>;
  var_samp?: Maybe<User_Total_Score_Var_Samp_Fields>;
  variance?: Maybe<User_Total_Score_Variance_Fields>;
};


/** aggregate fields of "user_total_score" */
export type User_Total_Score_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Total_Score_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Total_Score_Avg_Fields = {
  __typename?: 'user_total_score_avg_fields';
  sum?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_total_score". All fields are combined with a logical 'AND'. */
export type User_Total_Score_Bool_Exp = {
  _and?: InputMaybe<Array<User_Total_Score_Bool_Exp>>;
  _not?: InputMaybe<User_Total_Score_Bool_Exp>;
  _or?: InputMaybe<Array<User_Total_Score_Bool_Exp>>;
  sum?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_total_score" */
export enum User_Total_Score_Constraint {
  /** unique or primary key constraint on columns "sum" */
  UserTotalScorePkey = 'user_total_score_pkey'
}

/** input type for incrementing numeric columns in table "user_total_score" */
export type User_Total_Score_Inc_Input = {
  sum?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "user_total_score" */
export type User_Total_Score_Insert_Input = {
  sum?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type User_Total_Score_Max_Fields = {
  __typename?: 'user_total_score_max_fields';
  sum?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type User_Total_Score_Min_Fields = {
  __typename?: 'user_total_score_min_fields';
  sum?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "user_total_score" */
export type User_Total_Score_Mutation_Response = {
  __typename?: 'user_total_score_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Total_Score>;
};

/** on_conflict condition type for table "user_total_score" */
export type User_Total_Score_On_Conflict = {
  constraint: User_Total_Score_Constraint;
  update_columns?: Array<User_Total_Score_Update_Column>;
  where?: InputMaybe<User_Total_Score_Bool_Exp>;
};

/** Ordering options when selecting data from "user_total_score". */
export type User_Total_Score_Order_By = {
  sum?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_total_score */
export type User_Total_Score_Pk_Columns_Input = {
  sum: Scalars['numeric']['input'];
};

/** select columns of table "user_total_score" */
export enum User_Total_Score_Select_Column {
  /** column name */
  Sum = 'sum'
}

/** input type for updating data in table "user_total_score" */
export type User_Total_Score_Set_Input = {
  sum?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type User_Total_Score_Stddev_Fields = {
  __typename?: 'user_total_score_stddev_fields';
  sum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Total_Score_Stddev_Pop_Fields = {
  __typename?: 'user_total_score_stddev_pop_fields';
  sum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Total_Score_Stddev_Samp_Fields = {
  __typename?: 'user_total_score_stddev_samp_fields';
  sum?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_total_score" */
export type User_Total_Score_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Total_Score_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Total_Score_Stream_Cursor_Value_Input = {
  sum?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type User_Total_Score_Sum_Fields = {
  __typename?: 'user_total_score_sum_fields';
  sum?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "user_total_score" */
export enum User_Total_Score_Update_Column {
  /** column name */
  Sum = 'sum'
}

export type User_Total_Score_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Total_Score_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Total_Score_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Total_Score_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Total_Score_Var_Pop_Fields = {
  __typename?: 'user_total_score_var_pop_fields';
  sum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Total_Score_Var_Samp_Fields = {
  __typename?: 'user_total_score_var_samp_fields';
  sum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Total_Score_Variance_Fields = {
  __typename?: 'user_total_score_variance_fields';
  sum?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries = {
  __typename?: 'user_xp_transaction_summaries';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_additional_field: Supertokens_User_Additional_Fields;
  user_id: Scalars['String']['output'];
  xp: Scalars['numeric']['output'];
};

/** aggregated selection of "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries_Aggregate = {
  __typename?: 'user_xp_transaction_summaries_aggregate';
  aggregate?: Maybe<User_Xp_Transaction_Summaries_Aggregate_Fields>;
  nodes: Array<User_Xp_Transaction_Summaries>;
};

/** aggregate fields of "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries_Aggregate_Fields = {
  __typename?: 'user_xp_transaction_summaries_aggregate_fields';
  avg?: Maybe<User_Xp_Transaction_Summaries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Xp_Transaction_Summaries_Max_Fields>;
  min?: Maybe<User_Xp_Transaction_Summaries_Min_Fields>;
  stddev?: Maybe<User_Xp_Transaction_Summaries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Xp_Transaction_Summaries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Xp_Transaction_Summaries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Xp_Transaction_Summaries_Sum_Fields>;
  var_pop?: Maybe<User_Xp_Transaction_Summaries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Xp_Transaction_Summaries_Var_Samp_Fields>;
  variance?: Maybe<User_Xp_Transaction_Summaries_Variance_Fields>;
};


/** aggregate fields of "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Xp_Transaction_Summaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Xp_Transaction_Summaries_Avg_Fields = {
  __typename?: 'user_xp_transaction_summaries_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_xp_transaction_summaries". All fields are combined with a logical 'AND'. */
export type User_Xp_Transaction_Summaries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Xp_Transaction_Summaries_Bool_Exp>>;
  _not?: InputMaybe<User_Xp_Transaction_Summaries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Xp_Transaction_Summaries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_additional_field?: InputMaybe<Supertokens_User_Additional_Fields_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  xp?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_xp_transaction_summaries" */
export enum User_Xp_Transaction_Summaries_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserXpTransactionSummariesPkey = 'user_xp_transaction_summaries_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserXpTransactionSummariesUserIdKey = 'user_xp_transaction_summaries_user_id_key'
}

/** input type for incrementing numeric columns in table "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_additional_field?: InputMaybe<Supertokens_User_Additional_Fields_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type User_Xp_Transaction_Summaries_Max_Fields = {
  __typename?: 'user_xp_transaction_summaries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type User_Xp_Transaction_Summaries_Min_Fields = {
  __typename?: 'user_xp_transaction_summaries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries_Mutation_Response = {
  __typename?: 'user_xp_transaction_summaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Xp_Transaction_Summaries>;
};

/** on_conflict condition type for table "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries_On_Conflict = {
  constraint: User_Xp_Transaction_Summaries_Constraint;
  update_columns?: Array<User_Xp_Transaction_Summaries_Update_Column>;
  where?: InputMaybe<User_Xp_Transaction_Summaries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_xp_transaction_summaries". */
export type User_Xp_Transaction_Summaries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_additional_field?: InputMaybe<Supertokens_User_Additional_Fields_Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_xp_transaction_summaries */
export type User_Xp_Transaction_Summaries_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_xp_transaction_summaries" */
export enum User_Xp_Transaction_Summaries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

/** input type for updating data in table "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type User_Xp_Transaction_Summaries_Stddev_Fields = {
  __typename?: 'user_xp_transaction_summaries_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Xp_Transaction_Summaries_Stddev_Pop_Fields = {
  __typename?: 'user_xp_transaction_summaries_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Xp_Transaction_Summaries_Stddev_Samp_Fields = {
  __typename?: 'user_xp_transaction_summaries_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_xp_transaction_summaries" */
export type User_Xp_Transaction_Summaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Xp_Transaction_Summaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Xp_Transaction_Summaries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type User_Xp_Transaction_Summaries_Sum_Fields = {
  __typename?: 'user_xp_transaction_summaries_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  xp?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "user_xp_transaction_summaries" */
export enum User_Xp_Transaction_Summaries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

export type User_Xp_Transaction_Summaries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Xp_Transaction_Summaries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Xp_Transaction_Summaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Xp_Transaction_Summaries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Xp_Transaction_Summaries_Var_Pop_Fields = {
  __typename?: 'user_xp_transaction_summaries_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Xp_Transaction_Summaries_Var_Samp_Fields = {
  __typename?: 'user_xp_transaction_summaries_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Xp_Transaction_Summaries_Variance_Fields = {
  __typename?: 'user_xp_transaction_summaries_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  xp?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_xp_transactions" */
export type User_Xp_Transactions = {
  __typename?: 'user_xp_transactions';
  /** An object relationship */
  all_auth_recipe_user: Supertokens_All_Auth_Recipe_Users;
  created_at: Scalars['timestamptz']['output'];
  entity_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  table_name: Scalars['String']['output'];
  type: Xp_Transaction_Types_Enum;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['String']['output'];
  xp: Scalars['float8']['output'];
  /** An object relationship */
  xp_transaction_type: Xp_Transaction_Types;
};

/** aggregated selection of "user_xp_transactions" */
export type User_Xp_Transactions_Aggregate = {
  __typename?: 'user_xp_transactions_aggregate';
  aggregate?: Maybe<User_Xp_Transactions_Aggregate_Fields>;
  nodes: Array<User_Xp_Transactions>;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp = {
  avg?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp_Var_Samp>;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Avg = {
  arguments: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Corr = {
  arguments: User_Xp_Transactions_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Corr_Arguments = {
  X: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: User_Xp_Transactions_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Max = {
  arguments: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Min = {
  arguments: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Sum = {
  arguments: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Xp_Transactions_Aggregate_Bool_Exp_Var_Samp = {
  arguments: User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "user_xp_transactions" */
export type User_Xp_Transactions_Aggregate_Fields = {
  __typename?: 'user_xp_transactions_aggregate_fields';
  avg?: Maybe<User_Xp_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Xp_Transactions_Max_Fields>;
  min?: Maybe<User_Xp_Transactions_Min_Fields>;
  stddev?: Maybe<User_Xp_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<User_Xp_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Xp_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<User_Xp_Transactions_Sum_Fields>;
  var_pop?: Maybe<User_Xp_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<User_Xp_Transactions_Var_Samp_Fields>;
  variance?: Maybe<User_Xp_Transactions_Variance_Fields>;
};


/** aggregate fields of "user_xp_transactions" */
export type User_Xp_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_xp_transactions" */
export type User_Xp_Transactions_Aggregate_Order_By = {
  avg?: InputMaybe<User_Xp_Transactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Xp_Transactions_Max_Order_By>;
  min?: InputMaybe<User_Xp_Transactions_Min_Order_By>;
  stddev?: InputMaybe<User_Xp_Transactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Xp_Transactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Xp_Transactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Xp_Transactions_Sum_Order_By>;
  var_pop?: InputMaybe<User_Xp_Transactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Xp_Transactions_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Xp_Transactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_xp_transactions" */
export type User_Xp_Transactions_Arr_Rel_Insert_Input = {
  data: Array<User_Xp_Transactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Xp_Transactions_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Xp_Transactions_Avg_Fields = {
  __typename?: 'user_xp_transactions_avg_fields';
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Avg_Order_By = {
  xp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_xp_transactions". All fields are combined with a logical 'AND'. */
export type User_Xp_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<User_Xp_Transactions_Bool_Exp>>;
  _not?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<User_Xp_Transactions_Bool_Exp>>;
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Xp_Transaction_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  xp?: InputMaybe<Float8_Comparison_Exp>;
  xp_transaction_type?: InputMaybe<Xp_Transaction_Types_Bool_Exp>;
};

/** unique or primary key constraints on table "user_xp_transactions" */
export enum User_Xp_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserXpTransactionsPkey = 'user_xp_transactions_pkey'
}

/** input type for incrementing numeric columns in table "user_xp_transactions" */
export type User_Xp_Transactions_Inc_Input = {
  xp?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "user_xp_transactions" */
export type User_Xp_Transactions_Insert_Input = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Xp_Transaction_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['float8']['input']>;
  xp_transaction_type?: InputMaybe<Xp_Transaction_Types_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Xp_Transactions_Max_Fields = {
  __typename?: 'user_xp_transactions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  table_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Xp_Transactions_Min_Fields = {
  __typename?: 'user_xp_transactions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  table_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_xp_transactions" */
export type User_Xp_Transactions_Mutation_Response = {
  __typename?: 'user_xp_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Xp_Transactions>;
};

/** on_conflict condition type for table "user_xp_transactions" */
export type User_Xp_Transactions_On_Conflict = {
  constraint: User_Xp_Transactions_Constraint;
  update_columns?: Array<User_Xp_Transactions_Update_Column>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "user_xp_transactions". */
export type User_Xp_Transactions_Order_By = {
  all_auth_recipe_user?: InputMaybe<Supertokens_All_Auth_Recipe_Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  xp?: InputMaybe<Order_By>;
  xp_transaction_type?: InputMaybe<Xp_Transaction_Types_Order_By>;
};

/** primary key columns input for table: user_xp_transactions */
export type User_Xp_Transactions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  TableName = 'table_name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

/** select "user_xp_transactions_aggregate_bool_exp_avg_arguments_columns" columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Xp = 'xp'
}

/** select "user_xp_transactions_aggregate_bool_exp_corr_arguments_columns" columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Xp = 'xp'
}

/** select "user_xp_transactions_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Xp = 'xp'
}

/** select "user_xp_transactions_aggregate_bool_exp_max_arguments_columns" columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Xp = 'xp'
}

/** select "user_xp_transactions_aggregate_bool_exp_min_arguments_columns" columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Xp = 'xp'
}

/** select "user_xp_transactions_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Xp = 'xp'
}

/** select "user_xp_transactions_aggregate_bool_exp_sum_arguments_columns" columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Xp = 'xp'
}

/** select "user_xp_transactions_aggregate_bool_exp_var_samp_arguments_columns" columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Select_Column_User_Xp_Transactions_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Xp = 'xp'
}

/** input type for updating data in table "user_xp_transactions" */
export type User_Xp_Transactions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Xp_Transaction_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type User_Xp_Transactions_Stddev_Fields = {
  __typename?: 'user_xp_transactions_stddev_fields';
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Stddev_Order_By = {
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Xp_Transactions_Stddev_Pop_Fields = {
  __typename?: 'user_xp_transactions_stddev_pop_fields';
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Stddev_Pop_Order_By = {
  xp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Xp_Transactions_Stddev_Samp_Fields = {
  __typename?: 'user_xp_transactions_stddev_samp_fields';
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Stddev_Samp_Order_By = {
  xp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_xp_transactions" */
export type User_Xp_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Xp_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Xp_Transactions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Xp_Transaction_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  xp?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type User_Xp_Transactions_Sum_Fields = {
  __typename?: 'user_xp_transactions_sum_fields';
  xp?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Sum_Order_By = {
  xp?: InputMaybe<Order_By>;
};

/** update columns of table "user_xp_transactions" */
export enum User_Xp_Transactions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  TableName = 'table_name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Xp = 'xp'
}

export type User_Xp_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Xp_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Xp_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Xp_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Xp_Transactions_Var_Pop_Fields = {
  __typename?: 'user_xp_transactions_var_pop_fields';
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Var_Pop_Order_By = {
  xp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Xp_Transactions_Var_Samp_Fields = {
  __typename?: 'user_xp_transactions_var_samp_fields';
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Var_Samp_Order_By = {
  xp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Xp_Transactions_Variance_Fields = {
  __typename?: 'user_xp_transactions_variance_fields';
  xp?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_xp_transactions" */
export type User_Xp_Transactions_Variance_Order_By = {
  xp?: InputMaybe<Order_By>;
};

export type Users = {
  __typename?: 'users';
  id: Scalars['uuid']['output'];
};

/** columns and relationships of "users_user" */
export type Users_User = {
  __typename?: 'users_user';
  /** An array relationship */
  account_emailaddresses: Array<Account_Emailaddress>;
  /** An aggregate relationship */
  account_emailaddresses_aggregate: Account_Emailaddress_Aggregate;
  /** An array relationship */
  accounts_catscores: Array<Accounts_Catscores>;
  /** An aggregate relationship */
  accounts_catscores_aggregate: Accounts_Catscores_Aggregate;
  /** An object relationship */
  accounts_loggedinuser?: Maybe<Accounts_Loggedinuser>;
  /** An array relationship */
  andablog_entries: Array<Andablog_Entry>;
  /** An aggregate relationship */
  andablog_entries_aggregate: Andablog_Entry_Aggregate;
  /** An array relationship */
  andablog_userlessontrackrecords: Array<Andablog_Userlessontrackrecord>;
  /** An aggregate relationship */
  andablog_userlessontrackrecords_aggregate: Andablog_Userlessontrackrecord_Aggregate;
  /** An array relationship */
  coupons_allowedusersrule_users: Array<Coupons_Allowedusersrule_Users>;
  /** An aggregate relationship */
  coupons_allowedusersrule_users_aggregate: Coupons_Allowedusersrule_Users_Aggregate;
  /** An array relationship */
  coupons_couponusers: Array<Coupons_Couponuser>;
  /** An aggregate relationship */
  coupons_couponusers_aggregate: Coupons_Couponuser_Aggregate;
  date_joined: Scalars['timestamptz']['output'];
  /** An array relationship */
  django_admin_logs: Array<Django_Admin_Log>;
  /** An aggregate relationship */
  django_admin_logs_aggregate: Django_Admin_Log_Aggregate;
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  is_phone_verified: Scalars['Boolean']['output'];
  is_staff: Scalars['Boolean']['output'];
  is_superuser: Scalars['Boolean']['output'];
  is_visually_impaired?: Maybe<Scalars['Boolean']['output']>;
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  last_name: Scalars['String']['output'];
  name: Scalars['String']['output'];
  otp?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  packages_paymenttransactions: Array<Packages_Paymenttransaction>;
  /** An aggregate relationship */
  packages_paymenttransactions_aggregate: Packages_Paymenttransaction_Aggregate;
  password: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  socialaccount_socialaccounts: Array<Socialaccount_Socialaccount>;
  /** An aggregate relationship */
  socialaccount_socialaccounts_aggregate: Socialaccount_Socialaccount_Aggregate;
  /** An array relationship */
  spirit_comment_bookmark_commentbookmarks: Array<Spirit_Comment_Bookmark_Commentbookmark>;
  /** An aggregate relationship */
  spirit_comment_bookmark_commentbookmarks_aggregate: Spirit_Comment_Bookmark_Commentbookmark_Aggregate;
  /** An array relationship */
  spirit_comment_comments: Array<Spirit_Comment_Comment>;
  /** An aggregate relationship */
  spirit_comment_comments_aggregate: Spirit_Comment_Comment_Aggregate;
  /** An array relationship */
  spirit_comment_flag_commentflags: Array<Spirit_Comment_Flag_Commentflag>;
  /** An aggregate relationship */
  spirit_comment_flag_commentflags_aggregate: Spirit_Comment_Flag_Commentflag_Aggregate;
  /** An array relationship */
  spirit_comment_flag_flags: Array<Spirit_Comment_Flag_Flag>;
  /** An aggregate relationship */
  spirit_comment_flag_flags_aggregate: Spirit_Comment_Flag_Flag_Aggregate;
  /** An array relationship */
  spirit_comment_like_commentlikes: Array<Spirit_Comment_Like_Commentlike>;
  /** An aggregate relationship */
  spirit_comment_like_commentlikes_aggregate: Spirit_Comment_Like_Commentlike_Aggregate;
  /** An array relationship */
  spirit_comment_poll_commentpollvotes: Array<Spirit_Comment_Poll_Commentpollvote>;
  /** An aggregate relationship */
  spirit_comment_poll_commentpollvotes_aggregate: Spirit_Comment_Poll_Commentpollvote_Aggregate;
  /** An array relationship */
  spirit_topic_favorite_topicfavorites: Array<Spirit_Topic_Favorite_Topicfavorite>;
  /** An aggregate relationship */
  spirit_topic_favorite_topicfavorites_aggregate: Spirit_Topic_Favorite_Topicfavorite_Aggregate;
  /** An array relationship */
  spirit_topic_notification_topicnotifications: Array<Spirit_Topic_Notification_Topicnotification>;
  /** An aggregate relationship */
  spirit_topic_notification_topicnotifications_aggregate: Spirit_Topic_Notification_Topicnotification_Aggregate;
  /** An array relationship */
  spirit_topic_private_topicprivates: Array<Spirit_Topic_Private_Topicprivate>;
  /** An aggregate relationship */
  spirit_topic_private_topicprivates_aggregate: Spirit_Topic_Private_Topicprivate_Aggregate;
  /** An array relationship */
  spirit_topic_topics: Array<Spirit_Topic_Topic>;
  /** An aggregate relationship */
  spirit_topic_topics_aggregate: Spirit_Topic_Topic_Aggregate;
  /** An array relationship */
  spirit_topic_unread_topicunreads: Array<Spirit_Topic_Unread_Topicunread>;
  /** An aggregate relationship */
  spirit_topic_unread_topicunreads_aggregate: Spirit_Topic_Unread_Topicunread_Aggregate;
  /** An object relationship */
  spirit_user_userprofile?: Maybe<Spirit_User_Userprofile>;
  /** An array relationship */
  subscriptions_subscriptiontransactions: Array<Subscriptions_Subscriptiontransaction>;
  /** An aggregate relationship */
  subscriptions_subscriptiontransactions_aggregate: Subscriptions_Subscriptiontransaction_Aggregate;
  /** An array relationship */
  subscriptions_usersubscriptions: Array<Subscriptions_Usersubscription>;
  /** An aggregate relationship */
  subscriptions_usersubscriptions_aggregate: Subscriptions_Usersubscription_Aggregate;
  /** An array relationship */
  user_quiz_questions: Array<User_Quiz_Questions>;
  /** An aggregate relationship */
  user_quiz_questions_aggregate: User_Quiz_Questions_Aggregate;
  username: Scalars['String']['output'];
  /** An array relationship */
  users_user_groups: Array<Users_User_Groups>;
  /** An aggregate relationship */
  users_user_groups_aggregate: Users_User_Groups_Aggregate;
  /** An array relationship */
  users_user_user_permissions: Array<Users_User_User_Permissions>;
  /** An aggregate relationship */
  users_user_user_permissions_aggregate: Users_User_User_Permissions_Aggregate;
  /** An array relationship */
  users_userquizsummaries: Array<Users_Userquizsummary>;
  /** An aggregate relationship */
  users_userquizsummaries_aggregate: Users_Userquizsummary_Aggregate;
  /** An array relationship */
  users_usersectionsummaries: Array<Users_Usersectionsummary>;
  /** An aggregate relationship */
  users_usersectionsummaries_aggregate: Users_Usersectionsummary_Aggregate;
};


/** columns and relationships of "users_user" */
export type Users_UserAccount_EmailaddressesArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailaddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailaddress_Order_By>>;
  where?: InputMaybe<Account_Emailaddress_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserAccount_Emailaddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Emailaddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Emailaddress_Order_By>>;
  where?: InputMaybe<Account_Emailaddress_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserAccounts_CatscoresArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Catscores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Catscores_Order_By>>;
  where?: InputMaybe<Accounts_Catscores_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserAccounts_Catscores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Catscores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Accounts_Catscores_Order_By>>;
  where?: InputMaybe<Accounts_Catscores_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserAndablog_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entry_Order_By>>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserAndablog_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Entry_Order_By>>;
  where?: InputMaybe<Andablog_Entry_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserAndablog_UserlessontrackrecordsArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserAndablog_Userlessontrackrecords_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Andablog_Userlessontrackrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Andablog_Userlessontrackrecord_Order_By>>;
  where?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserCoupons_Allowedusersrule_UsersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserCoupons_Allowedusersrule_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Allowedusersrule_Users_Order_By>>;
  where?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserCoupons_CouponusersArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserCoupons_Couponusers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coupons_Couponuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Coupons_Couponuser_Order_By>>;
  where?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserDjango_Admin_LogsArgs = {
  distinct_on?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Admin_Log_Order_By>>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserDjango_Admin_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Admin_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Django_Admin_Log_Order_By>>;
  where?: InputMaybe<Django_Admin_Log_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserPackages_PaymenttransactionsArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserPackages_Paymenttransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packages_Paymenttransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Packages_Paymenttransaction_Order_By>>;
  where?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSocialaccount_SocialaccountsArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialaccount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialaccount_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSocialaccount_Socialaccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Socialaccount_Socialaccount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Socialaccount_Socialaccount_Order_By>>;
  where?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Bookmark_CommentbookmarksArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Bookmark_Commentbookmarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Bookmark_Commentbookmark_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Comment_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Comment_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Flag_CommentflagsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Flag_Commentflags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Commentflag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Flag_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Flag_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Flag_Flag_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Like_CommentlikesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Like_Commentlikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Like_Commentlike_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Poll_CommentpollvotesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Comment_Poll_Commentpollvotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Comment_Poll_Commentpollvote_Order_By>>;
  where?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_Favorite_TopicfavoritesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_Favorite_Topicfavorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Favorite_Topicfavorite_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_Notification_TopicnotificationsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_Notification_Topicnotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Notification_Topicnotification_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_Private_TopicprivatesArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_Private_Topicprivates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Private_Topicprivate_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_TopicsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Topic_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_Topics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Topic_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_Unread_TopicunreadsArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSpirit_Topic_Unread_Topicunreads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spirit_Topic_Unread_Topicunread_Order_By>>;
  where?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSubscriptions_SubscriptiontransactionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSubscriptions_Subscriptiontransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriptiontransaction_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSubscriptions_UsersubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Usersubscription_Order_By>>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserSubscriptions_Usersubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Usersubscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Usersubscription_Order_By>>;
  where?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUser_Quiz_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Questions_Order_By>>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUser_Quiz_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Quiz_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Quiz_Questions_Order_By>>;
  where?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUsers_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Groups_Order_By>>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUsers_User_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_Groups_Order_By>>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUsers_User_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUsers_User_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUsers_UserquizsummariesArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquizsummary_Order_By>>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUsers_Userquizsummaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquizsummary_Order_By>>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUsers_UsersectionsummariesArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};


/** columns and relationships of "users_user" */
export type Users_UserUsers_Usersectionsummaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};

/** aggregated selection of "users_user" */
export type Users_User_Aggregate = {
  __typename?: 'users_user_aggregate';
  aggregate?: Maybe<Users_User_Aggregate_Fields>;
  nodes: Array<Users_User>;
};

/** aggregate fields of "users_user" */
export type Users_User_Aggregate_Fields = {
  __typename?: 'users_user_aggregate_fields';
  avg?: Maybe<Users_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_User_Max_Fields>;
  min?: Maybe<Users_User_Min_Fields>;
  stddev?: Maybe<Users_User_Stddev_Fields>;
  stddev_pop?: Maybe<Users_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_User_Stddev_Samp_Fields>;
  sum?: Maybe<Users_User_Sum_Fields>;
  var_pop?: Maybe<Users_User_Var_Pop_Fields>;
  var_samp?: Maybe<Users_User_Var_Samp_Fields>;
  variance?: Maybe<Users_User_Variance_Fields>;
};


/** aggregate fields of "users_user" */
export type Users_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Users_User_Avg_Fields = {
  __typename?: 'users_user_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users_user". All fields are combined with a logical 'AND'. */
export type Users_User_Bool_Exp = {
  _and?: InputMaybe<Array<Users_User_Bool_Exp>>;
  _not?: InputMaybe<Users_User_Bool_Exp>;
  _or?: InputMaybe<Array<Users_User_Bool_Exp>>;
  account_emailaddresses?: InputMaybe<Account_Emailaddress_Bool_Exp>;
  account_emailaddresses_aggregate?: InputMaybe<Account_Emailaddress_Aggregate_Bool_Exp>;
  accounts_catscores?: InputMaybe<Accounts_Catscores_Bool_Exp>;
  accounts_catscores_aggregate?: InputMaybe<Accounts_Catscores_Aggregate_Bool_Exp>;
  accounts_loggedinuser?: InputMaybe<Accounts_Loggedinuser_Bool_Exp>;
  andablog_entries?: InputMaybe<Andablog_Entry_Bool_Exp>;
  andablog_entries_aggregate?: InputMaybe<Andablog_Entry_Aggregate_Bool_Exp>;
  andablog_userlessontrackrecords?: InputMaybe<Andablog_Userlessontrackrecord_Bool_Exp>;
  andablog_userlessontrackrecords_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Aggregate_Bool_Exp>;
  coupons_allowedusersrule_users?: InputMaybe<Coupons_Allowedusersrule_Users_Bool_Exp>;
  coupons_allowedusersrule_users_aggregate?: InputMaybe<Coupons_Allowedusersrule_Users_Aggregate_Bool_Exp>;
  coupons_couponusers?: InputMaybe<Coupons_Couponuser_Bool_Exp>;
  coupons_couponusers_aggregate?: InputMaybe<Coupons_Couponuser_Aggregate_Bool_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  django_admin_logs?: InputMaybe<Django_Admin_Log_Bool_Exp>;
  django_admin_logs_aggregate?: InputMaybe<Django_Admin_Log_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_phone_verified?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_visually_impaired?: InputMaybe<Boolean_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  otp?: InputMaybe<Int_Comparison_Exp>;
  packages_paymenttransactions?: InputMaybe<Packages_Paymenttransaction_Bool_Exp>;
  packages_paymenttransactions_aggregate?: InputMaybe<Packages_Paymenttransaction_Aggregate_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  socialaccount_socialaccounts?: InputMaybe<Socialaccount_Socialaccount_Bool_Exp>;
  socialaccount_socialaccounts_aggregate?: InputMaybe<Socialaccount_Socialaccount_Aggregate_Bool_Exp>;
  spirit_comment_bookmark_commentbookmarks?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Bool_Exp>;
  spirit_comment_bookmark_commentbookmarks_aggregate?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Bool_Exp>;
  spirit_comment_comments?: InputMaybe<Spirit_Comment_Comment_Bool_Exp>;
  spirit_comment_comments_aggregate?: InputMaybe<Spirit_Comment_Comment_Aggregate_Bool_Exp>;
  spirit_comment_flag_commentflags?: InputMaybe<Spirit_Comment_Flag_Commentflag_Bool_Exp>;
  spirit_comment_flag_commentflags_aggregate?: InputMaybe<Spirit_Comment_Flag_Commentflag_Aggregate_Bool_Exp>;
  spirit_comment_flag_flags?: InputMaybe<Spirit_Comment_Flag_Flag_Bool_Exp>;
  spirit_comment_flag_flags_aggregate?: InputMaybe<Spirit_Comment_Flag_Flag_Aggregate_Bool_Exp>;
  spirit_comment_like_commentlikes?: InputMaybe<Spirit_Comment_Like_Commentlike_Bool_Exp>;
  spirit_comment_like_commentlikes_aggregate?: InputMaybe<Spirit_Comment_Like_Commentlike_Aggregate_Bool_Exp>;
  spirit_comment_poll_commentpollvotes?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Bool_Exp>;
  spirit_comment_poll_commentpollvotes_aggregate?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Aggregate_Bool_Exp>;
  spirit_topic_favorite_topicfavorites?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Bool_Exp>;
  spirit_topic_favorite_topicfavorites_aggregate?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Aggregate_Bool_Exp>;
  spirit_topic_notification_topicnotifications?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Bool_Exp>;
  spirit_topic_notification_topicnotifications_aggregate?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Bool_Exp>;
  spirit_topic_private_topicprivates?: InputMaybe<Spirit_Topic_Private_Topicprivate_Bool_Exp>;
  spirit_topic_private_topicprivates_aggregate?: InputMaybe<Spirit_Topic_Private_Topicprivate_Aggregate_Bool_Exp>;
  spirit_topic_topics?: InputMaybe<Spirit_Topic_Topic_Bool_Exp>;
  spirit_topic_topics_aggregate?: InputMaybe<Spirit_Topic_Topic_Aggregate_Bool_Exp>;
  spirit_topic_unread_topicunreads?: InputMaybe<Spirit_Topic_Unread_Topicunread_Bool_Exp>;
  spirit_topic_unread_topicunreads_aggregate?: InputMaybe<Spirit_Topic_Unread_Topicunread_Aggregate_Bool_Exp>;
  spirit_user_userprofile?: InputMaybe<Spirit_User_Userprofile_Bool_Exp>;
  subscriptions_subscriptiontransactions?: InputMaybe<Subscriptions_Subscriptiontransaction_Bool_Exp>;
  subscriptions_subscriptiontransactions_aggregate?: InputMaybe<Subscriptions_Subscriptiontransaction_Aggregate_Bool_Exp>;
  subscriptions_usersubscriptions?: InputMaybe<Subscriptions_Usersubscription_Bool_Exp>;
  subscriptions_usersubscriptions_aggregate?: InputMaybe<Subscriptions_Usersubscription_Aggregate_Bool_Exp>;
  user_quiz_questions?: InputMaybe<User_Quiz_Questions_Bool_Exp>;
  user_quiz_questions_aggregate?: InputMaybe<User_Quiz_Questions_Aggregate_Bool_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  users_user_groups?: InputMaybe<Users_User_Groups_Bool_Exp>;
  users_user_groups_aggregate?: InputMaybe<Users_User_Groups_Aggregate_Bool_Exp>;
  users_user_user_permissions?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
  users_user_user_permissions_aggregate?: InputMaybe<Users_User_User_Permissions_Aggregate_Bool_Exp>;
  users_userquizsummaries?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
  users_userquizsummaries_aggregate?: InputMaybe<Users_Userquizsummary_Aggregate_Bool_Exp>;
  users_usersectionsummaries?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
  users_usersectionsummaries_aggregate?: InputMaybe<Users_Usersectionsummary_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users_user" */
export enum Users_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersUserPkey = 'users_user_pkey',
  /** unique or primary key constraint on columns "slug" */
  UsersUserSlugKey = 'users_user_slug_key',
  /** unique or primary key constraint on columns "username" */
  UsersUserUsernameKey = 'users_user_username_key'
}

/** columns and relationships of "users_user_groups" */
export type Users_User_Groups = {
  __typename?: 'users_user_groups';
  /** An object relationship */
  auth_group: Auth_Group;
  group_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "users_user_groups" */
export type Users_User_Groups_Aggregate = {
  __typename?: 'users_user_groups_aggregate';
  aggregate?: Maybe<Users_User_Groups_Aggregate_Fields>;
  nodes: Array<Users_User_Groups>;
};

export type Users_User_Groups_Aggregate_Bool_Exp = {
  count?: InputMaybe<Users_User_Groups_Aggregate_Bool_Exp_Count>;
};

export type Users_User_Groups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_User_Groups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_user_groups" */
export type Users_User_Groups_Aggregate_Fields = {
  __typename?: 'users_user_groups_aggregate_fields';
  avg?: Maybe<Users_User_Groups_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_User_Groups_Max_Fields>;
  min?: Maybe<Users_User_Groups_Min_Fields>;
  stddev?: Maybe<Users_User_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Users_User_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_User_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Users_User_Groups_Sum_Fields>;
  var_pop?: Maybe<Users_User_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Users_User_Groups_Var_Samp_Fields>;
  variance?: Maybe<Users_User_Groups_Variance_Fields>;
};


/** aggregate fields of "users_user_groups" */
export type Users_User_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_User_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users_user_groups" */
export type Users_User_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Users_User_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_User_Groups_Max_Order_By>;
  min?: InputMaybe<Users_User_Groups_Min_Order_By>;
  stddev?: InputMaybe<Users_User_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_User_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_User_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_User_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Users_User_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_User_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_User_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_user_groups" */
export type Users_User_Groups_Arr_Rel_Insert_Input = {
  data: Array<Users_User_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_User_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_User_Groups_Avg_Fields = {
  __typename?: 'users_user_groups_avg_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users_user_groups" */
export type Users_User_Groups_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_user_groups". All fields are combined with a logical 'AND'. */
export type Users_User_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Users_User_Groups_Bool_Exp>>;
  _not?: InputMaybe<Users_User_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Users_User_Groups_Bool_Exp>>;
  auth_group?: InputMaybe<Auth_Group_Bool_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "users_user_groups" */
export enum Users_User_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersUserGroupsPkey = 'users_user_groups_pkey',
  /** unique or primary key constraint on columns "user_id", "group_id" */
  UsersUserGroupsUserIdGroupIdB88eab82Uniq = 'users_user_groups_user_id_group_id_b88eab82_uniq'
}

/** input type for incrementing numeric columns in table "users_user_groups" */
export type Users_User_Groups_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_user_groups" */
export type Users_User_Groups_Insert_Input = {
  auth_group?: InputMaybe<Auth_Group_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_User_Groups_Max_Fields = {
  __typename?: 'users_user_groups_max_fields';
  group_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "users_user_groups" */
export type Users_User_Groups_Max_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_User_Groups_Min_Fields = {
  __typename?: 'users_user_groups_min_fields';
  group_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "users_user_groups" */
export type Users_User_Groups_Min_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_user_groups" */
export type Users_User_Groups_Mutation_Response = {
  __typename?: 'users_user_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_User_Groups>;
};

/** on_conflict condition type for table "users_user_groups" */
export type Users_User_Groups_On_Conflict = {
  constraint: Users_User_Groups_Constraint;
  update_columns?: Array<Users_User_Groups_Update_Column>;
  where?: InputMaybe<Users_User_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "users_user_groups". */
export type Users_User_Groups_Order_By = {
  auth_group?: InputMaybe<Auth_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: users_user_groups */
export type Users_User_Groups_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "users_user_groups" */
export enum Users_User_Groups_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_user_groups" */
export type Users_User_Groups_Set_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Users_User_Groups_Stddev_Fields = {
  __typename?: 'users_user_groups_stddev_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users_user_groups" */
export type Users_User_Groups_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_User_Groups_Stddev_Pop_Fields = {
  __typename?: 'users_user_groups_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users_user_groups" */
export type Users_User_Groups_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_User_Groups_Stddev_Samp_Fields = {
  __typename?: 'users_user_groups_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users_user_groups" */
export type Users_User_Groups_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users_user_groups" */
export type Users_User_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_User_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_User_Groups_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Users_User_Groups_Sum_Fields = {
  __typename?: 'users_user_groups_sum_fields';
  group_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users_user_groups" */
export type Users_User_Groups_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "users_user_groups" */
export enum Users_User_Groups_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Users_User_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_User_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_User_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_User_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_User_Groups_Var_Pop_Fields = {
  __typename?: 'users_user_groups_var_pop_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users_user_groups" */
export type Users_User_Groups_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_User_Groups_Var_Samp_Fields = {
  __typename?: 'users_user_groups_var_samp_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users_user_groups" */
export type Users_User_Groups_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_User_Groups_Variance_Fields = {
  __typename?: 'users_user_groups_variance_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users_user_groups" */
export type Users_User_Groups_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "users_user" */
export type Users_User_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  otp?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_user" */
export type Users_User_Insert_Input = {
  account_emailaddresses?: InputMaybe<Account_Emailaddress_Arr_Rel_Insert_Input>;
  accounts_catscores?: InputMaybe<Accounts_Catscores_Arr_Rel_Insert_Input>;
  accounts_loggedinuser?: InputMaybe<Accounts_Loggedinuser_Obj_Rel_Insert_Input>;
  andablog_entries?: InputMaybe<Andablog_Entry_Arr_Rel_Insert_Input>;
  andablog_userlessontrackrecords?: InputMaybe<Andablog_Userlessontrackrecord_Arr_Rel_Insert_Input>;
  coupons_allowedusersrule_users?: InputMaybe<Coupons_Allowedusersrule_Users_Arr_Rel_Insert_Input>;
  coupons_couponusers?: InputMaybe<Coupons_Couponuser_Arr_Rel_Insert_Input>;
  date_joined?: InputMaybe<Scalars['timestamptz']['input']>;
  django_admin_logs?: InputMaybe<Django_Admin_Log_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verified?: InputMaybe<Scalars['Boolean']['input']>;
  is_staff?: InputMaybe<Scalars['Boolean']['input']>;
  is_superuser?: InputMaybe<Scalars['Boolean']['input']>;
  is_visually_impaired?: InputMaybe<Scalars['Boolean']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  packages_paymenttransactions?: InputMaybe<Packages_Paymenttransaction_Arr_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socialaccount_socialaccounts?: InputMaybe<Socialaccount_Socialaccount_Arr_Rel_Insert_Input>;
  spirit_comment_bookmark_commentbookmarks?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Arr_Rel_Insert_Input>;
  spirit_comment_comments?: InputMaybe<Spirit_Comment_Comment_Arr_Rel_Insert_Input>;
  spirit_comment_flag_commentflags?: InputMaybe<Spirit_Comment_Flag_Commentflag_Arr_Rel_Insert_Input>;
  spirit_comment_flag_flags?: InputMaybe<Spirit_Comment_Flag_Flag_Arr_Rel_Insert_Input>;
  spirit_comment_like_commentlikes?: InputMaybe<Spirit_Comment_Like_Commentlike_Arr_Rel_Insert_Input>;
  spirit_comment_poll_commentpollvotes?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Arr_Rel_Insert_Input>;
  spirit_topic_favorite_topicfavorites?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Arr_Rel_Insert_Input>;
  spirit_topic_notification_topicnotifications?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Arr_Rel_Insert_Input>;
  spirit_topic_private_topicprivates?: InputMaybe<Spirit_Topic_Private_Topicprivate_Arr_Rel_Insert_Input>;
  spirit_topic_topics?: InputMaybe<Spirit_Topic_Topic_Arr_Rel_Insert_Input>;
  spirit_topic_unread_topicunreads?: InputMaybe<Spirit_Topic_Unread_Topicunread_Arr_Rel_Insert_Input>;
  spirit_user_userprofile?: InputMaybe<Spirit_User_Userprofile_Obj_Rel_Insert_Input>;
  subscriptions_subscriptiontransactions?: InputMaybe<Subscriptions_Subscriptiontransaction_Arr_Rel_Insert_Input>;
  subscriptions_usersubscriptions?: InputMaybe<Subscriptions_Usersubscription_Arr_Rel_Insert_Input>;
  user_quiz_questions?: InputMaybe<User_Quiz_Questions_Arr_Rel_Insert_Input>;
  username?: InputMaybe<Scalars['String']['input']>;
  users_user_groups?: InputMaybe<Users_User_Groups_Arr_Rel_Insert_Input>;
  users_user_user_permissions?: InputMaybe<Users_User_User_Permissions_Arr_Rel_Insert_Input>;
  users_userquizsummaries?: InputMaybe<Users_Userquizsummary_Arr_Rel_Insert_Input>;
  users_usersectionsummaries?: InputMaybe<Users_Usersectionsummary_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_User_Max_Fields = {
  __typename?: 'users_user_max_fields';
  date_joined?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Users_User_Min_Fields = {
  __typename?: 'users_user_min_fields';
  date_joined?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "users_user" */
export type Users_User_Mutation_Response = {
  __typename?: 'users_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_User>;
};

/** input type for inserting object relation for remote table "users_user" */
export type Users_User_Obj_Rel_Insert_Input = {
  data: Users_User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_User_On_Conflict>;
};

/** on_conflict condition type for table "users_user" */
export type Users_User_On_Conflict = {
  constraint: Users_User_Constraint;
  update_columns?: Array<Users_User_Update_Column>;
  where?: InputMaybe<Users_User_Bool_Exp>;
};

/** Ordering options when selecting data from "users_user". */
export type Users_User_Order_By = {
  account_emailaddresses_aggregate?: InputMaybe<Account_Emailaddress_Aggregate_Order_By>;
  accounts_catscores_aggregate?: InputMaybe<Accounts_Catscores_Aggregate_Order_By>;
  accounts_loggedinuser?: InputMaybe<Accounts_Loggedinuser_Order_By>;
  andablog_entries_aggregate?: InputMaybe<Andablog_Entry_Aggregate_Order_By>;
  andablog_userlessontrackrecords_aggregate?: InputMaybe<Andablog_Userlessontrackrecord_Aggregate_Order_By>;
  coupons_allowedusersrule_users_aggregate?: InputMaybe<Coupons_Allowedusersrule_Users_Aggregate_Order_By>;
  coupons_couponusers_aggregate?: InputMaybe<Coupons_Couponuser_Aggregate_Order_By>;
  date_joined?: InputMaybe<Order_By>;
  django_admin_logs_aggregate?: InputMaybe<Django_Admin_Log_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_phone_verified?: InputMaybe<Order_By>;
  is_staff?: InputMaybe<Order_By>;
  is_superuser?: InputMaybe<Order_By>;
  is_visually_impaired?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  packages_paymenttransactions_aggregate?: InputMaybe<Packages_Paymenttransaction_Aggregate_Order_By>;
  password?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  profile?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  socialaccount_socialaccounts_aggregate?: InputMaybe<Socialaccount_Socialaccount_Aggregate_Order_By>;
  spirit_comment_bookmark_commentbookmarks_aggregate?: InputMaybe<Spirit_Comment_Bookmark_Commentbookmark_Aggregate_Order_By>;
  spirit_comment_comments_aggregate?: InputMaybe<Spirit_Comment_Comment_Aggregate_Order_By>;
  spirit_comment_flag_commentflags_aggregate?: InputMaybe<Spirit_Comment_Flag_Commentflag_Aggregate_Order_By>;
  spirit_comment_flag_flags_aggregate?: InputMaybe<Spirit_Comment_Flag_Flag_Aggregate_Order_By>;
  spirit_comment_like_commentlikes_aggregate?: InputMaybe<Spirit_Comment_Like_Commentlike_Aggregate_Order_By>;
  spirit_comment_poll_commentpollvotes_aggregate?: InputMaybe<Spirit_Comment_Poll_Commentpollvote_Aggregate_Order_By>;
  spirit_topic_favorite_topicfavorites_aggregate?: InputMaybe<Spirit_Topic_Favorite_Topicfavorite_Aggregate_Order_By>;
  spirit_topic_notification_topicnotifications_aggregate?: InputMaybe<Spirit_Topic_Notification_Topicnotification_Aggregate_Order_By>;
  spirit_topic_private_topicprivates_aggregate?: InputMaybe<Spirit_Topic_Private_Topicprivate_Aggregate_Order_By>;
  spirit_topic_topics_aggregate?: InputMaybe<Spirit_Topic_Topic_Aggregate_Order_By>;
  spirit_topic_unread_topicunreads_aggregate?: InputMaybe<Spirit_Topic_Unread_Topicunread_Aggregate_Order_By>;
  spirit_user_userprofile?: InputMaybe<Spirit_User_Userprofile_Order_By>;
  subscriptions_subscriptiontransactions_aggregate?: InputMaybe<Subscriptions_Subscriptiontransaction_Aggregate_Order_By>;
  subscriptions_usersubscriptions_aggregate?: InputMaybe<Subscriptions_Usersubscription_Aggregate_Order_By>;
  user_quiz_questions_aggregate?: InputMaybe<User_Quiz_Questions_Aggregate_Order_By>;
  username?: InputMaybe<Order_By>;
  users_user_groups_aggregate?: InputMaybe<Users_User_Groups_Aggregate_Order_By>;
  users_user_user_permissions_aggregate?: InputMaybe<Users_User_User_Permissions_Aggregate_Order_By>;
  users_userquizsummaries_aggregate?: InputMaybe<Users_Userquizsummary_Aggregate_Order_By>;
  users_usersectionsummaries_aggregate?: InputMaybe<Users_Usersectionsummary_Aggregate_Order_By>;
};

/** primary key columns input for table: users_user */
export type Users_User_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "users_user" */
export enum Users_User_Select_Column {
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPhoneVerified = 'is_phone_verified',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  IsVisuallyImpaired = 'is_visually_impaired',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Name = 'name',
  /** column name */
  Otp = 'otp',
  /** column name */
  Password = 'password',
  /** column name */
  Phone = 'phone',
  /** column name */
  Profile = 'profile',
  /** column name */
  Slug = 'slug',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "users_user" */
export type Users_User_Set_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verified?: InputMaybe<Scalars['Boolean']['input']>;
  is_staff?: InputMaybe<Scalars['Boolean']['input']>;
  is_superuser?: InputMaybe<Scalars['Boolean']['input']>;
  is_visually_impaired?: InputMaybe<Scalars['Boolean']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Users_User_Stddev_Fields = {
  __typename?: 'users_user_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_User_Stddev_Pop_Fields = {
  __typename?: 'users_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_User_Stddev_Samp_Fields = {
  __typename?: 'users_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users_user" */
export type Users_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_User_Stream_Cursor_Value_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verified?: InputMaybe<Scalars['Boolean']['input']>;
  is_staff?: InputMaybe<Scalars['Boolean']['input']>;
  is_superuser?: InputMaybe<Scalars['Boolean']['input']>;
  is_visually_impaired?: InputMaybe<Scalars['Boolean']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Users_User_Sum_Fields = {
  __typename?: 'users_user_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "users_user" */
export enum Users_User_Update_Column {
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPhoneVerified = 'is_phone_verified',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  IsVisuallyImpaired = 'is_visually_impaired',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Name = 'name',
  /** column name */
  Otp = 'otp',
  /** column name */
  Password = 'password',
  /** column name */
  Phone = 'phone',
  /** column name */
  Profile = 'profile',
  /** column name */
  Slug = 'slug',
  /** column name */
  Username = 'username'
}

export type Users_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_User_Bool_Exp;
};

/** columns and relationships of "users_user_user_permissions" */
export type Users_User_User_Permissions = {
  __typename?: 'users_user_user_permissions';
  /** An object relationship */
  auth_permission: Auth_Permission;
  id: Scalars['Int']['output'];
  permission_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
};

/** aggregated selection of "users_user_user_permissions" */
export type Users_User_User_Permissions_Aggregate = {
  __typename?: 'users_user_user_permissions_aggregate';
  aggregate?: Maybe<Users_User_User_Permissions_Aggregate_Fields>;
  nodes: Array<Users_User_User_Permissions>;
};

export type Users_User_User_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Users_User_User_Permissions_Aggregate_Bool_Exp_Count>;
};

export type Users_User_User_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_user_user_permissions" */
export type Users_User_User_Permissions_Aggregate_Fields = {
  __typename?: 'users_user_user_permissions_aggregate_fields';
  avg?: Maybe<Users_User_User_Permissions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_User_User_Permissions_Max_Fields>;
  min?: Maybe<Users_User_User_Permissions_Min_Fields>;
  stddev?: Maybe<Users_User_User_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Users_User_User_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_User_User_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Users_User_User_Permissions_Sum_Fields>;
  var_pop?: Maybe<Users_User_User_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Users_User_User_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Users_User_User_Permissions_Variance_Fields>;
};


/** aggregate fields of "users_user_user_permissions" */
export type Users_User_User_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_User_User_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Users_User_User_Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_User_User_Permissions_Max_Order_By>;
  min?: InputMaybe<Users_User_User_Permissions_Min_Order_By>;
  stddev?: InputMaybe<Users_User_User_Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_User_User_Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_User_User_Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_User_User_Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Users_User_User_Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_User_User_Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_User_User_Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_user_user_permissions" */
export type Users_User_User_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Users_User_User_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_User_User_Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_User_User_Permissions_Avg_Fields = {
  __typename?: 'users_user_user_permissions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_user_user_permissions". All fields are combined with a logical 'AND'. */
export type Users_User_User_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Users_User_User_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Users_User_User_Permissions_Bool_Exp>>;
  auth_permission?: InputMaybe<Auth_Permission_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  permission_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
};

/** unique or primary key constraints on table "users_user_user_permissions" */
export enum Users_User_User_Permissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersUserUserPermissionsPkey = 'users_user_user_permissions_pkey',
  /** unique or primary key constraint on columns "permission_id", "user_id" */
  UsersUserUserPermissionsUserIdPermissionId_43338c45Uniq = 'users_user_user_permissions_user_id_permission_id_43338c45_uniq'
}

/** input type for incrementing numeric columns in table "users_user_user_permissions" */
export type Users_User_User_Permissions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  permission_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_user_user_permissions" */
export type Users_User_User_Permissions_Insert_Input = {
  auth_permission?: InputMaybe<Auth_Permission_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  permission_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_User_User_Permissions_Max_Fields = {
  __typename?: 'users_user_user_permissions_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  permission_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_User_User_Permissions_Min_Fields = {
  __typename?: 'users_user_user_permissions_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  permission_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_user_user_permissions" */
export type Users_User_User_Permissions_Mutation_Response = {
  __typename?: 'users_user_user_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_User_User_Permissions>;
};

/** on_conflict condition type for table "users_user_user_permissions" */
export type Users_User_User_Permissions_On_Conflict = {
  constraint: Users_User_User_Permissions_Constraint;
  update_columns?: Array<Users_User_User_Permissions_Update_Column>;
  where?: InputMaybe<Users_User_User_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "users_user_user_permissions". */
export type Users_User_User_Permissions_Order_By = {
  auth_permission?: InputMaybe<Auth_Permission_Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
};

/** primary key columns input for table: users_user_user_permissions */
export type Users_User_User_Permissions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "users_user_user_permissions" */
export enum Users_User_User_Permissions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_user_user_permissions" */
export type Users_User_User_Permissions_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  permission_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Users_User_User_Permissions_Stddev_Fields = {
  __typename?: 'users_user_user_permissions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_User_User_Permissions_Stddev_Pop_Fields = {
  __typename?: 'users_user_user_permissions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_User_User_Permissions_Stddev_Samp_Fields = {
  __typename?: 'users_user_user_permissions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users_user_user_permissions" */
export type Users_User_User_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_User_User_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_User_User_Permissions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  permission_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Users_User_User_Permissions_Sum_Fields = {
  __typename?: 'users_user_user_permissions_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  permission_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "users_user_user_permissions" */
export enum Users_User_User_Permissions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  UserId = 'user_id'
}

export type Users_User_User_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_User_User_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_User_User_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_User_User_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_User_User_Permissions_Var_Pop_Fields = {
  __typename?: 'users_user_user_permissions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_User_User_Permissions_Var_Samp_Fields = {
  __typename?: 'users_user_user_permissions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_User_User_Permissions_Variance_Fields = {
  __typename?: 'users_user_user_permissions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users_user_user_permissions" */
export type Users_User_User_Permissions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Users_User_Var_Pop_Fields = {
  __typename?: 'users_user_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_User_Var_Samp_Fields = {
  __typename?: 'users_user_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_User_Variance_Fields = {
  __typename?: 'users_user_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "users_userquestionsummary" */
export type Users_Userquestionsummary = {
  __typename?: 'users_userquestionsummary';
  correct_option?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_attempted: Scalars['date']['output'];
  id: Scalars['Int']['output'];
  is_attempted: Scalars['Boolean']['output'];
  is_bookmarked: Scalars['Boolean']['output'];
  is_correct: Scalars['Boolean']['output'];
  mark_for_review: Scalars['Boolean']['output'];
  question_id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_question: Quiz_Question;
  /** An object relationship */
  quiz_section?: Maybe<Quiz_Section>;
  quiz_summary_id: Scalars['Int']['output'];
  section_id?: Maybe<Scalars['Int']['output']>;
  selected_option?: Maybe<Scalars['String']['output']>;
  time_taken: Scalars['interval']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user_quiz_summary: Users_Userquizsummary;
};

/** aggregated selection of "users_userquestionsummary" */
export type Users_Userquestionsummary_Aggregate = {
  __typename?: 'users_userquestionsummary_aggregate';
  aggregate?: Maybe<Users_Userquestionsummary_Aggregate_Fields>;
  nodes: Array<Users_Userquestionsummary>;
};

export type Users_Userquestionsummary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Userquestionsummary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Userquestionsummary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Userquestionsummary_Aggregate_Bool_Exp_Count>;
};

export type Users_Userquestionsummary_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Userquestionsummary_Select_Column_Users_Userquestionsummary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Userquestionsummary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Userquestionsummary_Select_Column_Users_Userquestionsummary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Userquestionsummary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_userquestionsummary" */
export type Users_Userquestionsummary_Aggregate_Fields = {
  __typename?: 'users_userquestionsummary_aggregate_fields';
  avg?: Maybe<Users_Userquestionsummary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Userquestionsummary_Max_Fields>;
  min?: Maybe<Users_Userquestionsummary_Min_Fields>;
  stddev?: Maybe<Users_Userquestionsummary_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Userquestionsummary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Userquestionsummary_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Userquestionsummary_Sum_Fields>;
  var_pop?: Maybe<Users_Userquestionsummary_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Userquestionsummary_Var_Samp_Fields>;
  variance?: Maybe<Users_Userquestionsummary_Variance_Fields>;
};


/** aggregate fields of "users_userquestionsummary" */
export type Users_Userquestionsummary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Userquestionsummary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Userquestionsummary_Max_Order_By>;
  min?: InputMaybe<Users_Userquestionsummary_Min_Order_By>;
  stddev?: InputMaybe<Users_Userquestionsummary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Userquestionsummary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Userquestionsummary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Userquestionsummary_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Userquestionsummary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Userquestionsummary_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Userquestionsummary_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_userquestionsummary" */
export type Users_Userquestionsummary_Arr_Rel_Insert_Input = {
  data: Array<Users_Userquestionsummary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_Userquestionsummary_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Userquestionsummary_Avg_Fields = {
  __typename?: 'users_userquestionsummary_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_userquestionsummary". All fields are combined with a logical 'AND'. */
export type Users_Userquestionsummary_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Userquestionsummary_Bool_Exp>>;
  _not?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Userquestionsummary_Bool_Exp>>;
  correct_option?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_attempted?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_attempted?: InputMaybe<Boolean_Comparison_Exp>;
  is_bookmarked?: InputMaybe<Boolean_Comparison_Exp>;
  is_correct?: InputMaybe<Boolean_Comparison_Exp>;
  mark_for_review?: InputMaybe<Boolean_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  quiz_question?: InputMaybe<Quiz_Question_Bool_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  quiz_summary_id?: InputMaybe<Int_Comparison_Exp>;
  section_id?: InputMaybe<Int_Comparison_Exp>;
  selected_option?: InputMaybe<String_Comparison_Exp>;
  time_taken?: InputMaybe<Interval_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_quiz_summary?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};

/** unique or primary key constraints on table "users_userquestionsummary" */
export enum Users_Userquestionsummary_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersUserquestionsummaryPkey = 'users_userquestionsummary_pkey'
}

/** input type for incrementing numeric columns in table "users_userquestionsummary" */
export type Users_Userquestionsummary_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_userquestionsummary" */
export type Users_Userquestionsummary_Insert_Input = {
  correct_option?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_attempted?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  mark_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_question?: InputMaybe<Quiz_Question_Obj_Rel_Insert_Input>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  selected_option?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_quiz_summary?: InputMaybe<Users_Userquizsummary_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Userquestionsummary_Max_Fields = {
  __typename?: 'users_userquestionsummary_max_fields';
  correct_option?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_attempted?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  selected_option?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Max_Order_By = {
  correct_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_attempted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  selected_option?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Userquestionsummary_Min_Fields = {
  __typename?: 'users_userquestionsummary_min_fields';
  correct_option?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_attempted?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  selected_option?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Min_Order_By = {
  correct_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_attempted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  selected_option?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_userquestionsummary" */
export type Users_Userquestionsummary_Mutation_Response = {
  __typename?: 'users_userquestionsummary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Userquestionsummary>;
};

/** on_conflict condition type for table "users_userquestionsummary" */
export type Users_Userquestionsummary_On_Conflict = {
  constraint: Users_Userquestionsummary_Constraint;
  update_columns?: Array<Users_Userquestionsummary_Update_Column>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};

/** Ordering options when selecting data from "users_userquestionsummary". */
export type Users_Userquestionsummary_Order_By = {
  correct_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_attempted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_attempted?: InputMaybe<Order_By>;
  is_bookmarked?: InputMaybe<Order_By>;
  is_correct?: InputMaybe<Order_By>;
  mark_for_review?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_question?: InputMaybe<Quiz_Question_Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  selected_option?: InputMaybe<Order_By>;
  time_taken?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_quiz_summary?: InputMaybe<Users_Userquizsummary_Order_By>;
};

/** primary key columns input for table: users_userquestionsummary */
export type Users_Userquestionsummary_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "users_userquestionsummary" */
export enum Users_Userquestionsummary_Select_Column {
  /** column name */
  CorrectOption = 'correct_option',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateAttempted = 'date_attempted',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  SelectedOption = 'selected_option',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "users_userquestionsummary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users_userquestionsummary" */
export enum Users_Userquestionsummary_Select_Column_Users_Userquestionsummary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review'
}

/** select "users_userquestionsummary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users_userquestionsummary" */
export enum Users_Userquestionsummary_Select_Column_Users_Userquestionsummary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review'
}

/** input type for updating data in table "users_userquestionsummary" */
export type Users_Userquestionsummary_Set_Input = {
  correct_option?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_attempted?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  mark_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  selected_option?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Users_Userquestionsummary_Stddev_Fields = {
  __typename?: 'users_userquestionsummary_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Userquestionsummary_Stddev_Pop_Fields = {
  __typename?: 'users_userquestionsummary_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Userquestionsummary_Stddev_Samp_Fields = {
  __typename?: 'users_userquestionsummary_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users_userquestionsummary" */
export type Users_Userquestionsummary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Userquestionsummary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Userquestionsummary_Stream_Cursor_Value_Input = {
  correct_option?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_attempted?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_attempted?: InputMaybe<Scalars['Boolean']['input']>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  mark_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  selected_option?: InputMaybe<Scalars['String']['input']>;
  time_taken?: InputMaybe<Scalars['interval']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Users_Userquestionsummary_Sum_Fields = {
  __typename?: 'users_userquestionsummary_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** update columns of table "users_userquestionsummary" */
export enum Users_Userquestionsummary_Update_Column {
  /** column name */
  CorrectOption = 'correct_option',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateAttempted = 'date_attempted',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttempted = 'is_attempted',
  /** column name */
  IsBookmarked = 'is_bookmarked',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  MarkForReview = 'mark_for_review',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  SelectedOption = 'selected_option',
  /** column name */
  TimeTaken = 'time_taken',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Users_Userquestionsummary_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Userquestionsummary_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Userquestionsummary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Userquestionsummary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Userquestionsummary_Var_Pop_Fields = {
  __typename?: 'users_userquestionsummary_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Userquestionsummary_Var_Samp_Fields = {
  __typename?: 'users_userquestionsummary_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Userquestionsummary_Variance_Fields = {
  __typename?: 'users_userquestionsummary_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  question_id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users_userquestionsummary" */
export type Users_Userquestionsummary_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "users_userquizsummary" */
export type Users_Userquizsummary = {
  __typename?: 'users_userquizsummary';
  completed: Scalars['Boolean']['output'];
  correct_question?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  json_data?: Maybe<Scalars['jsonb']['output']>;
  last_answered?: Maybe<Scalars['Int']['output']>;
  question_list?: Maybe<Scalars['String']['output']>;
  question_order?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  quiz: Quiz_Quiz;
  quiz_id: Scalars['Int']['output'];
  score?: Maybe<Scalars['numeric']['output']>;
  total_correct_time?: Maybe<Scalars['interval']['output']>;
  total_question: Scalars['Int']['output'];
  total_time?: Maybe<Scalars['interval']['output']>;
  total_unattempted_time?: Maybe<Scalars['interval']['output']>;
  total_wrong_time?: Maybe<Scalars['interval']['output']>;
  unattempted_question?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_answers: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
  /** An array relationship */
  users_userquestionsummaries: Array<Users_Userquestionsummary>;
  /** An aggregate relationship */
  users_userquestionsummaries_aggregate: Users_Userquestionsummary_Aggregate;
  /** An array relationship */
  users_userquiztimesummaries: Array<Users_Userquiztimesummary>;
  /** An aggregate relationship */
  users_userquiztimesummaries_aggregate: Users_Userquiztimesummary_Aggregate;
  /** An array relationship */
  users_usersectionsummaries: Array<Users_Usersectionsummary>;
  /** An aggregate relationship */
  users_usersectionsummaries_aggregate: Users_Usersectionsummary_Aggregate;
  wrong_question?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "users_userquizsummary" */
export type Users_UserquizsummaryJson_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "users_userquizsummary" */
export type Users_UserquizsummaryUsers_UserquestionsummariesArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


/** columns and relationships of "users_userquizsummary" */
export type Users_UserquizsummaryUsers_Userquestionsummaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquestionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquestionsummary_Order_By>>;
  where?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
};


/** columns and relationships of "users_userquizsummary" */
export type Users_UserquizsummaryUsers_UserquiztimesummariesArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquiztimesummary_Order_By>>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};


/** columns and relationships of "users_userquizsummary" */
export type Users_UserquizsummaryUsers_Userquiztimesummaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Userquiztimesummary_Order_By>>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};


/** columns and relationships of "users_userquizsummary" */
export type Users_UserquizsummaryUsers_UsersectionsummariesArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};


/** columns and relationships of "users_userquizsummary" */
export type Users_UserquizsummaryUsers_Usersectionsummaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Usersectionsummary_Order_By>>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};

/** aggregated selection of "users_userquizsummary" */
export type Users_Userquizsummary_Aggregate = {
  __typename?: 'users_userquizsummary_aggregate';
  aggregate?: Maybe<Users_Userquizsummary_Aggregate_Fields>;
  nodes: Array<Users_Userquizsummary>;
};

export type Users_Userquizsummary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Userquizsummary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Userquizsummary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Userquizsummary_Aggregate_Bool_Exp_Count>;
};

export type Users_Userquizsummary_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Userquizsummary_Select_Column_Users_Userquizsummary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Userquizsummary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Userquizsummary_Select_Column_Users_Userquizsummary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Userquizsummary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_userquizsummary" */
export type Users_Userquizsummary_Aggregate_Fields = {
  __typename?: 'users_userquizsummary_aggregate_fields';
  avg?: Maybe<Users_Userquizsummary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Userquizsummary_Max_Fields>;
  min?: Maybe<Users_Userquizsummary_Min_Fields>;
  stddev?: Maybe<Users_Userquizsummary_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Userquizsummary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Userquizsummary_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Userquizsummary_Sum_Fields>;
  var_pop?: Maybe<Users_Userquizsummary_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Userquizsummary_Var_Samp_Fields>;
  variance?: Maybe<Users_Userquizsummary_Variance_Fields>;
};


/** aggregate fields of "users_userquizsummary" */
export type Users_Userquizsummary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Userquizsummary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users_userquizsummary" */
export type Users_Userquizsummary_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Userquizsummary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Userquizsummary_Max_Order_By>;
  min?: InputMaybe<Users_Userquizsummary_Min_Order_By>;
  stddev?: InputMaybe<Users_Userquizsummary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Userquizsummary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Userquizsummary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Userquizsummary_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Userquizsummary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Userquizsummary_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Userquizsummary_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Userquizsummary_Append_Input = {
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "users_userquizsummary" */
export type Users_Userquizsummary_Arr_Rel_Insert_Input = {
  data: Array<Users_Userquizsummary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_Userquizsummary_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Userquizsummary_Avg_Fields = {
  __typename?: 'users_userquizsummary_avg_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Avg_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_userquizsummary". All fields are combined with a logical 'AND'. */
export type Users_Userquizsummary_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Userquizsummary_Bool_Exp>>;
  _not?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Userquizsummary_Bool_Exp>>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  correct_question?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_question?: InputMaybe<Int_Comparison_Exp>;
  current_section?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  json_data?: InputMaybe<Jsonb_Comparison_Exp>;
  last_answered?: InputMaybe<Int_Comparison_Exp>;
  question_list?: InputMaybe<String_Comparison_Exp>;
  question_order?: InputMaybe<String_Comparison_Exp>;
  quiz?: InputMaybe<Quiz_Quiz_Bool_Exp>;
  quiz_id?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Numeric_Comparison_Exp>;
  total_correct_time?: InputMaybe<Interval_Comparison_Exp>;
  total_question?: InputMaybe<Int_Comparison_Exp>;
  total_time?: InputMaybe<Interval_Comparison_Exp>;
  total_unattempted_time?: InputMaybe<Interval_Comparison_Exp>;
  total_wrong_time?: InputMaybe<Interval_Comparison_Exp>;
  unattempted_question?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_answers?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
  users_userquestionsummaries?: InputMaybe<Users_Userquestionsummary_Bool_Exp>;
  users_userquestionsummaries_aggregate?: InputMaybe<Users_Userquestionsummary_Aggregate_Bool_Exp>;
  users_userquiztimesummaries?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
  users_userquiztimesummaries_aggregate?: InputMaybe<Users_Userquiztimesummary_Aggregate_Bool_Exp>;
  users_usersectionsummaries?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
  users_usersectionsummaries_aggregate?: InputMaybe<Users_Usersectionsummary_Aggregate_Bool_Exp>;
  wrong_question?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_userquizsummary" */
export enum Users_Userquizsummary_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersUserquizsummaryPkey = 'users_userquizsummary_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Userquizsummary_Delete_At_Path_Input = {
  json_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Userquizsummary_Delete_Elem_Input = {
  json_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Userquizsummary_Delete_Key_Input = {
  json_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "users_userquizsummary" */
export type Users_Userquizsummary_Inc_Input = {
  correct_question?: InputMaybe<Scalars['Int']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_answered?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_question?: InputMaybe<Scalars['Int']['input']>;
  unattempted_question?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  wrong_question?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_userquizsummary" */
export type Users_Userquizsummary_Insert_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  correct_question?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
  last_answered?: InputMaybe<Scalars['Int']['input']>;
  question_list?: InputMaybe<Scalars['String']['input']>;
  question_order?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<Quiz_Quiz_Obj_Rel_Insert_Input>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_correct_time?: InputMaybe<Scalars['interval']['input']>;
  total_question?: InputMaybe<Scalars['Int']['input']>;
  total_time?: InputMaybe<Scalars['interval']['input']>;
  total_unattempted_time?: InputMaybe<Scalars['interval']['input']>;
  total_wrong_time?: InputMaybe<Scalars['interval']['input']>;
  unattempted_question?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_answers?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
  users_userquestionsummaries?: InputMaybe<Users_Userquestionsummary_Arr_Rel_Insert_Input>;
  users_userquiztimesummaries?: InputMaybe<Users_Userquiztimesummary_Arr_Rel_Insert_Input>;
  users_usersectionsummaries?: InputMaybe<Users_Usersectionsummary_Arr_Rel_Insert_Input>;
  wrong_question?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Users_Userquizsummary_Max_Fields = {
  __typename?: 'users_userquizsummary_max_fields';
  correct_question?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_answered?: Maybe<Scalars['Int']['output']>;
  question_list?: Maybe<Scalars['String']['output']>;
  question_order?: Maybe<Scalars['String']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_question?: Maybe<Scalars['Int']['output']>;
  unattempted_question?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_answers?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  wrong_question?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Max_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  question_list?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_answers?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Userquizsummary_Min_Fields = {
  __typename?: 'users_userquizsummary_min_fields';
  correct_question?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_answered?: Maybe<Scalars['Int']['output']>;
  question_list?: Maybe<Scalars['String']['output']>;
  question_order?: Maybe<Scalars['String']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_question?: Maybe<Scalars['Int']['output']>;
  unattempted_question?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_answers?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  wrong_question?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Min_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  question_list?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_answers?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_userquizsummary" */
export type Users_Userquizsummary_Mutation_Response = {
  __typename?: 'users_userquizsummary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Userquizsummary>;
};

/** input type for inserting object relation for remote table "users_userquizsummary" */
export type Users_Userquizsummary_Obj_Rel_Insert_Input = {
  data: Users_Userquizsummary_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_Userquizsummary_On_Conflict>;
};

/** on_conflict condition type for table "users_userquizsummary" */
export type Users_Userquizsummary_On_Conflict = {
  constraint: Users_Userquizsummary_Constraint;
  update_columns?: Array<Users_Userquizsummary_Update_Column>;
  where?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};

/** Ordering options when selecting data from "users_userquizsummary". */
export type Users_Userquizsummary_Order_By = {
  completed?: InputMaybe<Order_By>;
  correct_question?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  json_data?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  question_list?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  quiz?: InputMaybe<Quiz_Quiz_Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_correct_time?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  total_time?: InputMaybe<Order_By>;
  total_unattempted_time?: InputMaybe<Order_By>;
  total_wrong_time?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_answers?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
  users_userquestionsummaries_aggregate?: InputMaybe<Users_Userquestionsummary_Aggregate_Order_By>;
  users_userquiztimesummaries_aggregate?: InputMaybe<Users_Userquiztimesummary_Aggregate_Order_By>;
  users_usersectionsummaries_aggregate?: InputMaybe<Users_Usersectionsummary_Aggregate_Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users_userquizsummary */
export type Users_Userquizsummary_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Userquizsummary_Prepend_Input = {
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "users_userquizsummary" */
export enum Users_Userquizsummary_Select_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CorrectQuestion = 'correct_question',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentQuestion = 'current_question',
  /** column name */
  CurrentSection = 'current_section',
  /** column name */
  Id = 'id',
  /** column name */
  JsonData = 'json_data',
  /** column name */
  LastAnswered = 'last_answered',
  /** column name */
  QuestionList = 'question_list',
  /** column name */
  QuestionOrder = 'question_order',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Score = 'score',
  /** column name */
  TotalCorrectTime = 'total_correct_time',
  /** column name */
  TotalQuestion = 'total_question',
  /** column name */
  TotalTime = 'total_time',
  /** column name */
  TotalUnattemptedTime = 'total_unattempted_time',
  /** column name */
  TotalWrongTime = 'total_wrong_time',
  /** column name */
  UnattemptedQuestion = 'unattempted_question',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAnswers = 'user_answers',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WrongQuestion = 'wrong_question'
}

/** select "users_userquizsummary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users_userquizsummary" */
export enum Users_Userquizsummary_Select_Column_Users_Userquizsummary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Completed = 'completed'
}

/** select "users_userquizsummary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users_userquizsummary" */
export enum Users_Userquizsummary_Select_Column_Users_Userquizsummary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Completed = 'completed'
}

/** input type for updating data in table "users_userquizsummary" */
export type Users_Userquizsummary_Set_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  correct_question?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
  last_answered?: InputMaybe<Scalars['Int']['input']>;
  question_list?: InputMaybe<Scalars['String']['input']>;
  question_order?: InputMaybe<Scalars['String']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_correct_time?: InputMaybe<Scalars['interval']['input']>;
  total_question?: InputMaybe<Scalars['Int']['input']>;
  total_time?: InputMaybe<Scalars['interval']['input']>;
  total_unattempted_time?: InputMaybe<Scalars['interval']['input']>;
  total_wrong_time?: InputMaybe<Scalars['interval']['input']>;
  unattempted_question?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_answers?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  wrong_question?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Users_Userquizsummary_Stddev_Fields = {
  __typename?: 'users_userquizsummary_stddev_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Stddev_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Userquizsummary_Stddev_Pop_Fields = {
  __typename?: 'users_userquizsummary_stddev_pop_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Stddev_Pop_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Userquizsummary_Stddev_Samp_Fields = {
  __typename?: 'users_userquizsummary_stddev_samp_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Stddev_Samp_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users_userquizsummary" */
export type Users_Userquizsummary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Userquizsummary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Userquizsummary_Stream_Cursor_Value_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  correct_question?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_question?: InputMaybe<Scalars['Int']['input']>;
  current_section?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  json_data?: InputMaybe<Scalars['jsonb']['input']>;
  last_answered?: InputMaybe<Scalars['Int']['input']>;
  question_list?: InputMaybe<Scalars['String']['input']>;
  question_order?: InputMaybe<Scalars['String']['input']>;
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  total_correct_time?: InputMaybe<Scalars['interval']['input']>;
  total_question?: InputMaybe<Scalars['Int']['input']>;
  total_time?: InputMaybe<Scalars['interval']['input']>;
  total_unattempted_time?: InputMaybe<Scalars['interval']['input']>;
  total_wrong_time?: InputMaybe<Scalars['interval']['input']>;
  unattempted_question?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_answers?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  wrong_question?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Users_Userquizsummary_Sum_Fields = {
  __typename?: 'users_userquizsummary_sum_fields';
  correct_question?: Maybe<Scalars['Int']['output']>;
  current_question?: Maybe<Scalars['Int']['output']>;
  current_section?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_answered?: Maybe<Scalars['Int']['output']>;
  quiz_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  total_question?: Maybe<Scalars['Int']['output']>;
  unattempted_question?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  wrong_question?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Sum_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** update columns of table "users_userquizsummary" */
export enum Users_Userquizsummary_Update_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CorrectQuestion = 'correct_question',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentQuestion = 'current_question',
  /** column name */
  CurrentSection = 'current_section',
  /** column name */
  Id = 'id',
  /** column name */
  JsonData = 'json_data',
  /** column name */
  LastAnswered = 'last_answered',
  /** column name */
  QuestionList = 'question_list',
  /** column name */
  QuestionOrder = 'question_order',
  /** column name */
  QuizId = 'quiz_id',
  /** column name */
  Score = 'score',
  /** column name */
  TotalCorrectTime = 'total_correct_time',
  /** column name */
  TotalQuestion = 'total_question',
  /** column name */
  TotalTime = 'total_time',
  /** column name */
  TotalUnattemptedTime = 'total_unattempted_time',
  /** column name */
  TotalWrongTime = 'total_wrong_time',
  /** column name */
  UnattemptedQuestion = 'unattempted_question',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAnswers = 'user_answers',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WrongQuestion = 'wrong_question'
}

export type Users_Userquizsummary_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Userquizsummary_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Userquizsummary_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Userquizsummary_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Userquizsummary_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Userquizsummary_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Userquizsummary_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Userquizsummary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Userquizsummary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Userquizsummary_Var_Pop_Fields = {
  __typename?: 'users_userquizsummary_var_pop_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Var_Pop_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Userquizsummary_Var_Samp_Fields = {
  __typename?: 'users_userquizsummary_var_samp_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Var_Samp_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Userquizsummary_Variance_Fields = {
  __typename?: 'users_userquizsummary_variance_fields';
  correct_question?: Maybe<Scalars['Float']['output']>;
  current_question?: Maybe<Scalars['Float']['output']>;
  current_section?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_answered?: Maybe<Scalars['Float']['output']>;
  quiz_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total_question?: Maybe<Scalars['Float']['output']>;
  unattempted_question?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wrong_question?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users_userquizsummary" */
export type Users_Userquizsummary_Variance_Order_By = {
  correct_question?: InputMaybe<Order_By>;
  current_question?: InputMaybe<Order_By>;
  current_section?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_answered?: InputMaybe<Order_By>;
  quiz_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  total_question?: InputMaybe<Order_By>;
  unattempted_question?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wrong_question?: InputMaybe<Order_By>;
};

/** columns and relationships of "users_userquiztimesummary" */
export type Users_Userquiztimesummary = {
  __typename?: 'users_userquiztimesummary';
  id: Scalars['Int']['output'];
  is_section_completed: Scalars['Boolean']['output'];
  /** An object relationship */
  quiz_section?: Maybe<Quiz_Section>;
  quiz_summary_id: Scalars['Int']['output'];
  remaining_time: Scalars['interval']['output'];
  section_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  users_userquizsummary: Users_Userquizsummary;
};

/** aggregated selection of "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Aggregate = {
  __typename?: 'users_userquiztimesummary_aggregate';
  aggregate?: Maybe<Users_Userquiztimesummary_Aggregate_Fields>;
  nodes: Array<Users_Userquiztimesummary>;
};

export type Users_Userquiztimesummary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Userquiztimesummary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Userquiztimesummary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Userquiztimesummary_Aggregate_Bool_Exp_Count>;
};

export type Users_Userquiztimesummary_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Userquiztimesummary_Select_Column_Users_Userquiztimesummary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Userquiztimesummary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Userquiztimesummary_Select_Column_Users_Userquiztimesummary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Userquiztimesummary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Aggregate_Fields = {
  __typename?: 'users_userquiztimesummary_aggregate_fields';
  avg?: Maybe<Users_Userquiztimesummary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Userquiztimesummary_Max_Fields>;
  min?: Maybe<Users_Userquiztimesummary_Min_Fields>;
  stddev?: Maybe<Users_Userquiztimesummary_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Userquiztimesummary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Userquiztimesummary_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Userquiztimesummary_Sum_Fields>;
  var_pop?: Maybe<Users_Userquiztimesummary_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Userquiztimesummary_Var_Samp_Fields>;
  variance?: Maybe<Users_Userquiztimesummary_Variance_Fields>;
};


/** aggregate fields of "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Userquiztimesummary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Userquiztimesummary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Userquiztimesummary_Max_Order_By>;
  min?: InputMaybe<Users_Userquiztimesummary_Min_Order_By>;
  stddev?: InputMaybe<Users_Userquiztimesummary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Userquiztimesummary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Userquiztimesummary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Userquiztimesummary_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Userquiztimesummary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Userquiztimesummary_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Userquiztimesummary_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Arr_Rel_Insert_Input = {
  data: Array<Users_Userquiztimesummary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_Userquiztimesummary_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Userquiztimesummary_Avg_Fields = {
  __typename?: 'users_userquiztimesummary_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_userquiztimesummary". All fields are combined with a logical 'AND'. */
export type Users_Userquiztimesummary_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Userquiztimesummary_Bool_Exp>>;
  _not?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Userquiztimesummary_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_section_completed?: InputMaybe<Boolean_Comparison_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  quiz_summary_id?: InputMaybe<Int_Comparison_Exp>;
  remaining_time?: InputMaybe<Interval_Comparison_Exp>;
  section_id?: InputMaybe<Int_Comparison_Exp>;
  users_userquizsummary?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};

/** unique or primary key constraints on table "users_userquiztimesummary" */
export enum Users_Userquiztimesummary_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersUserquiztimesummaryPkey = 'users_userquiztimesummary_pkey'
}

/** input type for incrementing numeric columns in table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  is_section_completed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  remaining_time?: InputMaybe<Scalars['interval']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  users_userquizsummary?: InputMaybe<Users_Userquizsummary_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Userquiztimesummary_Max_Fields = {
  __typename?: 'users_userquiztimesummary_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Userquiztimesummary_Min_Fields = {
  __typename?: 'users_userquiztimesummary_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Mutation_Response = {
  __typename?: 'users_userquiztimesummary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Userquiztimesummary>;
};

/** on_conflict condition type for table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_On_Conflict = {
  constraint: Users_Userquiztimesummary_Constraint;
  update_columns?: Array<Users_Userquiztimesummary_Update_Column>;
  where?: InputMaybe<Users_Userquiztimesummary_Bool_Exp>;
};

/** Ordering options when selecting data from "users_userquiztimesummary". */
export type Users_Userquiztimesummary_Order_By = {
  id?: InputMaybe<Order_By>;
  is_section_completed?: InputMaybe<Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  remaining_time?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  users_userquizsummary?: InputMaybe<Users_Userquizsummary_Order_By>;
};

/** primary key columns input for table: users_userquiztimesummary */
export type Users_Userquiztimesummary_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "users_userquiztimesummary" */
export enum Users_Userquiztimesummary_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsSectionCompleted = 'is_section_completed',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  RemainingTime = 'remaining_time',
  /** column name */
  SectionId = 'section_id'
}

/** select "users_userquiztimesummary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users_userquiztimesummary" */
export enum Users_Userquiztimesummary_Select_Column_Users_Userquiztimesummary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsSectionCompleted = 'is_section_completed'
}

/** select "users_userquiztimesummary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users_userquiztimesummary" */
export enum Users_Userquiztimesummary_Select_Column_Users_Userquiztimesummary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsSectionCompleted = 'is_section_completed'
}

/** input type for updating data in table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  is_section_completed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  remaining_time?: InputMaybe<Scalars['interval']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Users_Userquiztimesummary_Stddev_Fields = {
  __typename?: 'users_userquiztimesummary_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Userquiztimesummary_Stddev_Pop_Fields = {
  __typename?: 'users_userquiztimesummary_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Userquiztimesummary_Stddev_Samp_Fields = {
  __typename?: 'users_userquiztimesummary_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Userquiztimesummary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Userquiztimesummary_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  is_section_completed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  remaining_time?: InputMaybe<Scalars['interval']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Users_Userquiztimesummary_Sum_Fields = {
  __typename?: 'users_userquiztimesummary_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** update columns of table "users_userquiztimesummary" */
export enum Users_Userquiztimesummary_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsSectionCompleted = 'is_section_completed',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  RemainingTime = 'remaining_time',
  /** column name */
  SectionId = 'section_id'
}

export type Users_Userquiztimesummary_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Userquiztimesummary_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Userquiztimesummary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Userquiztimesummary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Userquiztimesummary_Var_Pop_Fields = {
  __typename?: 'users_userquiztimesummary_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Userquiztimesummary_Var_Samp_Fields = {
  __typename?: 'users_userquiztimesummary_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Userquiztimesummary_Variance_Fields = {
  __typename?: 'users_userquiztimesummary_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users_userquiztimesummary" */
export type Users_Userquiztimesummary_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "users_usersectionsummary" */
export type Users_Usersectionsummary = {
  __typename?: 'users_usersectionsummary';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  quiz_section: Quiz_Section;
  quiz_summary_id: Scalars['Int']['output'];
  score?: Maybe<Scalars['numeric']['output']>;
  section_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['Int']['output'];
  /** An object relationship */
  users_user: Users_User;
  /** An object relationship */
  users_userquizsummary: Users_Userquizsummary;
};

/** aggregated selection of "users_usersectionsummary" */
export type Users_Usersectionsummary_Aggregate = {
  __typename?: 'users_usersectionsummary_aggregate';
  aggregate?: Maybe<Users_Usersectionsummary_Aggregate_Fields>;
  nodes: Array<Users_Usersectionsummary>;
};

export type Users_Usersectionsummary_Aggregate_Bool_Exp = {
  count?: InputMaybe<Users_Usersectionsummary_Aggregate_Bool_Exp_Count>;
};

export type Users_Usersectionsummary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_usersectionsummary" */
export type Users_Usersectionsummary_Aggregate_Fields = {
  __typename?: 'users_usersectionsummary_aggregate_fields';
  avg?: Maybe<Users_Usersectionsummary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Usersectionsummary_Max_Fields>;
  min?: Maybe<Users_Usersectionsummary_Min_Fields>;
  stddev?: Maybe<Users_Usersectionsummary_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Usersectionsummary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Usersectionsummary_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Usersectionsummary_Sum_Fields>;
  var_pop?: Maybe<Users_Usersectionsummary_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Usersectionsummary_Var_Samp_Fields>;
  variance?: Maybe<Users_Usersectionsummary_Variance_Fields>;
};


/** aggregate fields of "users_usersectionsummary" */
export type Users_Usersectionsummary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Usersectionsummary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Usersectionsummary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Usersectionsummary_Max_Order_By>;
  min?: InputMaybe<Users_Usersectionsummary_Min_Order_By>;
  stddev?: InputMaybe<Users_Usersectionsummary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Usersectionsummary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Usersectionsummary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Usersectionsummary_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Usersectionsummary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Usersectionsummary_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Usersectionsummary_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_usersectionsummary" */
export type Users_Usersectionsummary_Arr_Rel_Insert_Input = {
  data: Array<Users_Usersectionsummary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_Usersectionsummary_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Usersectionsummary_Avg_Fields = {
  __typename?: 'users_usersectionsummary_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_usersectionsummary". All fields are combined with a logical 'AND'. */
export type Users_Usersectionsummary_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Usersectionsummary_Bool_Exp>>;
  _not?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Usersectionsummary_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  quiz_section?: InputMaybe<Quiz_Section_Bool_Exp>;
  quiz_summary_id?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Numeric_Comparison_Exp>;
  section_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  users_user?: InputMaybe<Users_User_Bool_Exp>;
  users_userquizsummary?: InputMaybe<Users_Userquizsummary_Bool_Exp>;
};

/** unique or primary key constraints on table "users_usersectionsummary" */
export enum Users_Usersectionsummary_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersUsersectionsummaryPkey = 'users_usersectionsummary_pkey'
}

/** input type for incrementing numeric columns in table "users_usersectionsummary" */
export type Users_Usersectionsummary_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_usersectionsummary" */
export type Users_Usersectionsummary_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_section?: InputMaybe<Quiz_Section_Obj_Rel_Insert_Input>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  users_user?: InputMaybe<Users_User_Obj_Rel_Insert_Input>;
  users_userquizsummary?: InputMaybe<Users_Userquizsummary_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Usersectionsummary_Max_Fields = {
  __typename?: 'users_usersectionsummary_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Usersectionsummary_Min_Fields = {
  __typename?: 'users_usersectionsummary_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_usersectionsummary" */
export type Users_Usersectionsummary_Mutation_Response = {
  __typename?: 'users_usersectionsummary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Usersectionsummary>;
};

/** on_conflict condition type for table "users_usersectionsummary" */
export type Users_Usersectionsummary_On_Conflict = {
  constraint: Users_Usersectionsummary_Constraint;
  update_columns?: Array<Users_Usersectionsummary_Update_Column>;
  where?: InputMaybe<Users_Usersectionsummary_Bool_Exp>;
};

/** Ordering options when selecting data from "users_usersectionsummary". */
export type Users_Usersectionsummary_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quiz_section?: InputMaybe<Quiz_Section_Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users_user?: InputMaybe<Users_User_Order_By>;
  users_userquizsummary?: InputMaybe<Users_Userquizsummary_Order_By>;
};

/** primary key columns input for table: users_usersectionsummary */
export type Users_Usersectionsummary_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "users_usersectionsummary" */
export enum Users_Usersectionsummary_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  Score = 'score',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_usersectionsummary" */
export type Users_Usersectionsummary_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Users_Usersectionsummary_Stddev_Fields = {
  __typename?: 'users_usersectionsummary_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Usersectionsummary_Stddev_Pop_Fields = {
  __typename?: 'users_usersectionsummary_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Usersectionsummary_Stddev_Samp_Fields = {
  __typename?: 'users_usersectionsummary_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users_usersectionsummary" */
export type Users_Usersectionsummary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Usersectionsummary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Usersectionsummary_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quiz_summary_id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  section_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Users_Usersectionsummary_Sum_Fields = {
  __typename?: 'users_usersectionsummary_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  quiz_summary_id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  section_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "users_usersectionsummary" */
export enum Users_Usersectionsummary_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuizSummaryId = 'quiz_summary_id',
  /** column name */
  Score = 'score',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Users_Usersectionsummary_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Usersectionsummary_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Usersectionsummary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Usersectionsummary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Usersectionsummary_Var_Pop_Fields = {
  __typename?: 'users_usersectionsummary_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Usersectionsummary_Var_Samp_Fields = {
  __typename?: 'users_usersectionsummary_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Usersectionsummary_Variance_Fields = {
  __typename?: 'users_usersectionsummary_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  quiz_summary_id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  section_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users_usersectionsummary" */
export type Users_Usersectionsummary_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  quiz_summary_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "utils_configuration" */
export type Utils_Configuration = {
  __typename?: 'utils_configuration';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  flag: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "utils_configuration" */
export type Utils_Configuration_Aggregate = {
  __typename?: 'utils_configuration_aggregate';
  aggregate?: Maybe<Utils_Configuration_Aggregate_Fields>;
  nodes: Array<Utils_Configuration>;
};

/** aggregate fields of "utils_configuration" */
export type Utils_Configuration_Aggregate_Fields = {
  __typename?: 'utils_configuration_aggregate_fields';
  avg?: Maybe<Utils_Configuration_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utils_Configuration_Max_Fields>;
  min?: Maybe<Utils_Configuration_Min_Fields>;
  stddev?: Maybe<Utils_Configuration_Stddev_Fields>;
  stddev_pop?: Maybe<Utils_Configuration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utils_Configuration_Stddev_Samp_Fields>;
  sum?: Maybe<Utils_Configuration_Sum_Fields>;
  var_pop?: Maybe<Utils_Configuration_Var_Pop_Fields>;
  var_samp?: Maybe<Utils_Configuration_Var_Samp_Fields>;
  variance?: Maybe<Utils_Configuration_Variance_Fields>;
};


/** aggregate fields of "utils_configuration" */
export type Utils_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utils_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Utils_Configuration_Avg_Fields = {
  __typename?: 'utils_configuration_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "utils_configuration". All fields are combined with a logical 'AND'. */
export type Utils_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Utils_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Utils_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Utils_Configuration_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  flag?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "utils_configuration" */
export enum Utils_Configuration_Constraint {
  /** unique or primary key constraint on columns "id" */
  UtilsConfigurationPkey = 'utils_configuration_pkey'
}

/** input type for incrementing numeric columns in table "utils_configuration" */
export type Utils_Configuration_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "utils_configuration" */
export type Utils_Configuration_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  flag?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Utils_Configuration_Max_Fields = {
  __typename?: 'utils_configuration_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Utils_Configuration_Min_Fields = {
  __typename?: 'utils_configuration_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "utils_configuration" */
export type Utils_Configuration_Mutation_Response = {
  __typename?: 'utils_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utils_Configuration>;
};

/** on_conflict condition type for table "utils_configuration" */
export type Utils_Configuration_On_Conflict = {
  constraint: Utils_Configuration_Constraint;
  update_columns?: Array<Utils_Configuration_Update_Column>;
  where?: InputMaybe<Utils_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "utils_configuration". */
export type Utils_Configuration_Order_By = {
  created_at?: InputMaybe<Order_By>;
  flag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utils_configuration */
export type Utils_Configuration_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "utils_configuration" */
export enum Utils_Configuration_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Flag = 'flag',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "utils_configuration" */
export type Utils_Configuration_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  flag?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Utils_Configuration_Stddev_Fields = {
  __typename?: 'utils_configuration_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Utils_Configuration_Stddev_Pop_Fields = {
  __typename?: 'utils_configuration_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Utils_Configuration_Stddev_Samp_Fields = {
  __typename?: 'utils_configuration_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "utils_configuration" */
export type Utils_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utils_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utils_Configuration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  flag?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Utils_Configuration_Sum_Fields = {
  __typename?: 'utils_configuration_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "utils_configuration" */
export enum Utils_Configuration_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Flag = 'flag',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Utils_Configuration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utils_Configuration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utils_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utils_Configuration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utils_Configuration_Var_Pop_Fields = {
  __typename?: 'utils_configuration_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Utils_Configuration_Var_Samp_Fields = {
  __typename?: 'utils_configuration_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Utils_Configuration_Variance_Fields = {
  __typename?: 'utils_configuration_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "xp_transaction_types" */
export type Xp_Transaction_Types = {
  __typename?: 'xp_transaction_types';
  type: Scalars['String']['output'];
  /** An array relationship */
  user_xp_transactions: Array<User_Xp_Transactions>;
  /** An aggregate relationship */
  user_xp_transactions_aggregate: User_Xp_Transactions_Aggregate;
};


/** columns and relationships of "xp_transaction_types" */
export type Xp_Transaction_TypesUser_Xp_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transactions_Order_By>>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};


/** columns and relationships of "xp_transaction_types" */
export type Xp_Transaction_TypesUser_Xp_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Xp_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Xp_Transactions_Order_By>>;
  where?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
};

/** aggregated selection of "xp_transaction_types" */
export type Xp_Transaction_Types_Aggregate = {
  __typename?: 'xp_transaction_types_aggregate';
  aggregate?: Maybe<Xp_Transaction_Types_Aggregate_Fields>;
  nodes: Array<Xp_Transaction_Types>;
};

/** aggregate fields of "xp_transaction_types" */
export type Xp_Transaction_Types_Aggregate_Fields = {
  __typename?: 'xp_transaction_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Xp_Transaction_Types_Max_Fields>;
  min?: Maybe<Xp_Transaction_Types_Min_Fields>;
};


/** aggregate fields of "xp_transaction_types" */
export type Xp_Transaction_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Xp_Transaction_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "xp_transaction_types". All fields are combined with a logical 'AND'. */
export type Xp_Transaction_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Xp_Transaction_Types_Bool_Exp>>;
  _not?: InputMaybe<Xp_Transaction_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Xp_Transaction_Types_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_xp_transactions?: InputMaybe<User_Xp_Transactions_Bool_Exp>;
  user_xp_transactions_aggregate?: InputMaybe<User_Xp_Transactions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "xp_transaction_types" */
export enum Xp_Transaction_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  XpTransactionTypesPkey = 'xp_transaction_types_pkey'
}

export enum Xp_Transaction_Types_Enum {
  Compete = 'compete',
  DailyQuiz = 'daily_quiz',
  Learn = 'learn',
  Practice = 'practice',
  SpeedConcept = 'speed_concept',
  SpeedMathChallenge = 'speed_math_challenge',
  SpeedMathPractice = 'speed_math_practice',
  SpeedQuant = 'speed_quant',
  SpeedVerbal = 'speed_verbal'
}

/** Boolean expression to compare columns of type "xp_transaction_types_enum". All fields are combined with logical 'AND'. */
export type Xp_Transaction_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Xp_Transaction_Types_Enum>;
  _in?: InputMaybe<Array<Xp_Transaction_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Xp_Transaction_Types_Enum>;
  _nin?: InputMaybe<Array<Xp_Transaction_Types_Enum>>;
};

/** input type for inserting data into table "xp_transaction_types" */
export type Xp_Transaction_Types_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
  user_xp_transactions?: InputMaybe<User_Xp_Transactions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Xp_Transaction_Types_Max_Fields = {
  __typename?: 'xp_transaction_types_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Xp_Transaction_Types_Min_Fields = {
  __typename?: 'xp_transaction_types_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "xp_transaction_types" */
export type Xp_Transaction_Types_Mutation_Response = {
  __typename?: 'xp_transaction_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Xp_Transaction_Types>;
};

/** input type for inserting object relation for remote table "xp_transaction_types" */
export type Xp_Transaction_Types_Obj_Rel_Insert_Input = {
  data: Xp_Transaction_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Xp_Transaction_Types_On_Conflict>;
};

/** on_conflict condition type for table "xp_transaction_types" */
export type Xp_Transaction_Types_On_Conflict = {
  constraint: Xp_Transaction_Types_Constraint;
  update_columns?: Array<Xp_Transaction_Types_Update_Column>;
  where?: InputMaybe<Xp_Transaction_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "xp_transaction_types". */
export type Xp_Transaction_Types_Order_By = {
  type?: InputMaybe<Order_By>;
  user_xp_transactions_aggregate?: InputMaybe<User_Xp_Transactions_Aggregate_Order_By>;
};

/** primary key columns input for table: xp_transaction_types */
export type Xp_Transaction_Types_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "xp_transaction_types" */
export enum Xp_Transaction_Types_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "xp_transaction_types" */
export type Xp_Transaction_Types_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "xp_transaction_types" */
export type Xp_Transaction_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Xp_Transaction_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Xp_Transaction_Types_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "xp_transaction_types" */
export enum Xp_Transaction_Types_Update_Column {
  /** column name */
  Type = 'type'
}

export type Xp_Transaction_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Xp_Transaction_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Xp_Transaction_Types_Bool_Exp;
};

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  mobileVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isVisualImpairment?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'GenericResponse', message?: string | null, success: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'GenericResponse', message?: string | null, success: boolean } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', success: boolean, message: string, role: string } };

export type ReportQuestionMutationVariables = Exact<{
  explanation: Scalars['String']['input'];
  question_id: Scalars['Int']['input'];
}>;


export type ReportQuestionMutation = { __typename?: 'Mutation', insert_question_reports_one?: { __typename?: 'question_reports', id: any } | null };

export type GetAdContentQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetAdContentQuery = { __typename?: 'Query', advertisements: Array<{ __typename?: 'advertisements', plan_title: string, title: string, list_of_features: string, advertisements_subscriptions_subscriptionplan?: { __typename?: 'subscriptions_subscriptionplan', striked_price?: any | null, cost?: any | null } | null }> };

export type UpdateUserDetailsMutationVariables = Exact<{
  set: Supertokens_User_Additional_Fields_Set_Input;
}>;


export type UpdateUserDetailsMutation = { __typename?: 'Mutation', update_supertokens_user_additional_fields?: { __typename?: 'supertokens_user_additional_fields_mutation_response', affected_rows: number } | null };

export type SendVerificationOtpMutationVariables = Exact<{
  number: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type SendVerificationOtpMutation = { __typename?: 'Mutation', sendVerificationOtp: { __typename?: 'GenericResponse', message?: string | null, success: boolean } };

export type VerifyOtpMutationVariables = Exact<{
  otp: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
}>;


export type VerifyOtpMutation = { __typename?: 'Mutation', verifyOtp: { __typename?: 'GenericResponse', message?: string | null, success: boolean } };

export type SignUpMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  username: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  state: Scalars['String']['input'];
  city: Scalars['String']['input'];
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type Question__GetVideoOtpQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Question__GetVideoOtpQuery = { __typename?: 'Query', getVideoOTPForQuestion: { __typename?: 'VideoCipherOTPPayload', otp?: string | null, playbackInfo?: string | null } };

export type GoogleLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type GoogleLoginQuery = { __typename?: 'Query', googleLogin: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetCatResponseDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCatResponseDataQuery = { __typename?: 'Query', user_cat_response_sheet_data_by_pk?: { __typename?: 'user_cat_response_sheet_data', application_no: string } | null };

export type GetCatApplicationDataQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCatApplicationDataQuery = { __typename?: 'Query', getCatApplicationData: { __typename?: 'GetCatApplicationDataResponse', success: boolean, message?: string | null, data?: string | null } };

export type GetUserAdditionalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAdditionalDataQuery = { __typename?: 'Query', supertokens_user_additional_fields: Array<{ __typename?: 'supertokens_user_additional_fields', avatar?: string | null, city?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, mobile?: string | null, state?: string | null, user_id?: string | null, username?: string | null, postal_code?: string | null, country?: string | null, date_of_birth?: string | null, age?: string | null, gender?: string | null, xp?: any | null, is_visually_impaired: boolean, role: string, mobile_verified: boolean, email_verified: boolean, emailVerified?: { __typename?: 'supertokens_emailverification_verified_emails', user_id: string } | null, thirdparty_users?: { __typename?: 'supertokens_thirdparty_users', user_id: any } | null }> };

export type GetUserXpTransactionSummariesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetUserXpTransactionSummariesSubscription = { __typename?: 'Subscription', user_xp_transaction_summaries: Array<{ __typename?: 'user_xp_transaction_summaries', xp: any }> };

export type LogoutQueryVariables = Exact<{ [key: string]: never; }>;


export type LogoutQuery = { __typename?: 'Query', logout: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type UpdateLastActiveQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateLastActiveQuery = { __typename?: 'Query', updateLastActive: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type ValidateSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidateSessionQuery = { __typename?: 'Query', validateSession: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetPurchasedPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPurchasedPlanQuery = { __typename?: 'Query', packages_payment_transaction: Array<{ __typename?: 'packages_payment_transaction', price: any, id: number, gst: any, initial_price: any, group_id?: number | null, subscriptions_subscriptionplan: { __typename?: 'subscriptions_subscriptionplan', plan_name: string, id: any, striked_price?: any | null, plan_description?: string | null, cost?: any | null, is_a_top_pack: boolean, most_popular: boolean, unlimited_speed_quant: boolean, unlimited_speed_verbal: boolean, unlimited_speed_concept: boolean, package_content?: { __typename?: 'packages_content', expiry_date?: any | null, message?: string | null, disable_live_classes: boolean } | null, subscriptions_subscriptionplan_upgradable_plans: Array<{ __typename?: 'subscriptions_subscriptionplan_upgradable_plans', id: number, to_subscriptionplan_id: any }> } }> };

export type GetRandomQuestionQueryVariables = Exact<{
  quizId: Scalars['Int']['input'];
}>;


export type GetRandomQuestionQuery = { __typename?: 'Query', get_random_question?: { __typename?: 'quiz_quiz_questions', question_id: number, quiz_question: { __typename?: 'quiz_question', name: string, question_type: string, options: Array<{ __typename?: 'quiz_option', is_correct: boolean, id: number, name: string }> } } | null };

export type AddUserActivityDataMutationVariables = Exact<{
  object: User_Activities_Insert_Input;
  constraint: User_Activities_Constraint;
}>;


export type AddUserActivityDataMutation = { __typename?: 'Mutation', insert_user_activities_one?: { __typename?: 'user_activities', id: any } | null };

export type SendOfflineLeadOtpMutationVariables = Exact<{
  number: Scalars['String']['input'];
}>;


export type SendOfflineLeadOtpMutation = { __typename?: 'Mutation', sendOfflineLeadOtp: { __typename?: 'GenericResponse', message?: string | null, success: boolean } };

export type VerifyOfflineLeadOtpMutationVariables = Exact<{
  otp: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
}>;


export type VerifyOfflineLeadOtpMutation = { __typename?: 'Mutation', verifyOfflineLeadOtp: { __typename?: 'GenericResponse', message?: string | null, success: boolean } };

export type UpdateLeadInfoMutationVariables = Exact<{
  id: Scalars['String']['input'];
  state: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateLeadInfoMutation = { __typename?: 'Mutation', update_offline_leads?: { __typename?: 'offline_leads_mutation_response', affected_rows: number } | null };

export type GetCompeteLeaderBoardScoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompeteLeaderBoardScoreQuery = { __typename?: 'Query', user_leaderboards: Array<{ __typename?: 'user_leaderboards', score: number, sub_type: string, type: string, user?: { __typename?: 'supertokens_user_public_fields', user_id?: string | null, username?: string | null } | null }> };

export type GetQuestionAnalysisQueryVariables = Exact<{
  name: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
}>;


export type GetQuestionAnalysisQuery = { __typename?: 'Query', user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', is_correct?: boolean | null, response?: string | null, user_quiz_summary: { __typename?: 'user_quiz_summaries', quiz_quiz: { __typename?: 'quiz_quiz', total_number_of_questions?: number | null } }, quiz_question: { __typename?: 'quiz_question', difficulty: string } }> };

export type GetDifficultyAnalysisQueryVariables = Exact<{
  name: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
}>;


export type GetDifficultyAnalysisQuery = { __typename?: 'Query', easy: Array<{ __typename?: 'user_quiz_question_summaries', is_correct?: boolean | null, response?: string | null, user_quiz_summary: { __typename?: 'user_quiz_summaries', quiz_quiz: { __typename?: 'quiz_quiz', total_number_of_questions?: number | null } }, quiz_question: { __typename?: 'quiz_question', difficulty: string } }>, medium: Array<{ __typename?: 'user_quiz_question_summaries', is_correct?: boolean | null, response?: string | null, user_quiz_summary: { __typename?: 'user_quiz_summaries', quiz_quiz: { __typename?: 'quiz_quiz', total_number_of_questions?: number | null } }, quiz_question: { __typename?: 'quiz_question', difficulty: string } }>, hard: Array<{ __typename?: 'user_quiz_question_summaries', is_correct?: boolean | null, response?: string | null, user_quiz_summary: { __typename?: 'user_quiz_summaries', quiz_quiz: { __typename?: 'quiz_quiz', total_number_of_questions?: number | null } }, quiz_question: { __typename?: 'quiz_question', difficulty: string } }> };

export type Compete__GetDomainsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  _or: Array<Quiz_Quiz_Bool_Exp> | Quiz_Quiz_Bool_Exp;
}>;


export type Compete__GetDomainsQuery = { __typename?: 'Query', quiz_category: Array<{ __typename?: 'quiz_category', name: string, quiz_quizzes: Array<{ __typename?: 'quiz_quiz', slug?: string | null, id: number, name: string, minimum_users: number, time_limit?: any | null, visually_impaired_time_duration?: any | null, has_access?: boolean | null, available_on?: any | null, isPremium: boolean, user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, number_of_users_completed?: number | null, current_position: number, is_completed: boolean, percentile?: any | null, did_accept_instruction: boolean, current_question?: number | null, user_quiz_question_summaries_aggregate: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number, sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null } }> }> }> };

export type GetCompeteQuizInstructionsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCompeteQuizInstructionsQuery = { __typename?: 'Query', quiz_quiz: Array<{ __typename?: 'quiz_quiz', slug?: string | null, instructions2: string, instructions1: string, time_limit?: any | null, name: string, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, did_accept_instruction: boolean }> }> };

export type AcceptCompeteQuizTermsConditionsAndInstructionsMutationVariables = Exact<{
  user_quiz_summary_id: Scalars['uuid']['input'];
}>;


export type AcceptCompeteQuizTermsConditionsAndInstructionsMutation = { __typename?: 'Mutation', update_user_quiz_summaries_by_pk?: { __typename?: 'user_quiz_summaries', id: any } | null };

export type AddUserTimedQuizSummariesMutationVariables = Exact<{
  quiz_id: Scalars['Int']['input'];
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  current_position: Scalars['Int']['input'];
}>;


export type AddUserTimedQuizSummariesMutation = { __typename?: 'Mutation', insert_user_quiz_summaries_one?: { __typename?: 'user_quiz_summaries', is_completed: boolean, quiz_id: number, current_position: number } | null };

export type GetCompeteStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompeteStatisticsQuery = { __typename?: 'Query', all_compete_tests: Array<{ __typename?: 'admin_constants', value: string }>, completed_compete_tests: { __typename?: 'user_quiz_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_summaries_aggregate_fields', count: number } | null }, all_questions_in_compete_tests: Array<{ __typename?: 'admin_constants', value: string }>, completed_questions_in_compete_tests: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null }, bookmarked_questions_in_compete_tests: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null } };

export type Compete__AnalysisMarksVsPercentileQueryVariables = Exact<{
  quizID: Scalars['Int']['input'];
}>;


export type Compete__AnalysisMarksVsPercentileQuery = { __typename?: 'Query', getCompeteMarksVsPercentile: Array<{ __typename?: 'TimedTestPercentile', varc?: number | null, dilr?: number | null, quant?: number | null, total?: number | null, percentile?: number | null }> };

export type GetRecentCompeteTestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentCompeteTestsQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', is_completed: boolean, number_of_attempted_questions?: number | null, updated_at: any, quiz_quiz: { __typename?: 'quiz_quiz', name: string, total_number_of_questions?: number | null }, user_quiz_question_summaries_aggregate: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null } }> };

export type Complete__GetUserQuizSummarySubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type Complete__GetUserQuizSummarySubscription = { __typename?: 'Subscription', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', number_of_attempted_questions?: number | null, created_at: any, percentile?: any | null, id: any, number_of_users_completed?: number | null, user_quiz_section_summaries: Array<{ __typename?: 'user_quiz_section_summaries', percentile?: any | null, section_id: number, quiz_section: { __typename?: 'quiz_section', name: string } }>, quiz_quiz: { __typename?: 'quiz_quiz', id: number, name: string, minimum_users: number, show_percentile?: boolean | null, quiz_category: { __typename?: 'quiz_category', name: string, quiz_domain?: { __typename?: 'quiz_domain', name: string, quiz_superdomain?: { __typename?: 'quiz_superdomain', name: string } | null } | null } }, correct_questions: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null }, wrong_questions: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null }, total_marks: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null }, user_quiz_question_positions: Array<{ __typename?: 'user_quiz_question_positions', question_id: number, position: number, quiz_question: { __typename?: 'quiz_question', difficulty: string, name: string, rank?: any | null, solution?: string | null, question_type: string, has_paragraph: boolean, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }>, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null, title?: string | null } | null } }>, user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', id: any, is_bookmarked: boolean, is_correct?: boolean | null, time_taken: any, marks: any, response?: string | null, question_id: number, quiz_question: { __typename?: 'quiz_question', difficulty: string, name: string, rank?: any | null, solution?: string | null, has_paragraph: boolean, number_of_attempts?: number | null, number_of_correct_attempts?: number | null, average_time_taken_for_correct_attempts?: any | null, average_time_taken?: any | null, paragraph_id?: number | null, question_type: string, options: Array<{ __typename?: 'quiz_option', id: number, name: string, is_correct: boolean }>, quiz_paragraph?: { __typename?: 'quiz_paragraph', id: number, comprehension?: string | null, title?: string | null } | null, quiz_category: { __typename?: 'quiz_category', name: string }, quiz_section_questions: Array<{ __typename?: 'quiz_section_questions', section_id: number, quiz_section: { __typename?: 'quiz_section', name: string, rank?: any | null } }> } }> }> };

export type UpdateBookmarkMutationVariables = Exact<{
  is_bookmarked: Scalars['Boolean']['input'];
  id: Scalars['uuid']['input'];
}>;


export type UpdateBookmarkMutation = { __typename?: 'Mutation', update_user_quiz_question_summaries?: { __typename?: 'user_quiz_question_summaries_mutation_response', returning: Array<{ __typename?: 'user_quiz_question_summaries', id: any, is_bookmarked: boolean }> } | null };

export type Compete__AnalysisTop10ScoresQueryVariables = Exact<{
  quizID: Scalars['Int']['input'];
}>;


export type Compete__AnalysisTop10ScoresQuery = { __typename?: 'Query', getCompeteTop10Scores: Array<{ __typename?: 'TimedTestScore', name: string, varc: number, dilr: number, quant: number, total: number }> };

export type GetDailyNewsQueryVariables = Exact<{
  _gte: Scalars['timestamptz']['input'];
  _lte: Scalars['timestamptz']['input'];
}>;


export type GetDailyNewsQuery = { __typename?: 'Query', andablog_news: Array<{ __typename?: 'andablog_news', content: string, _content_rendered?: string | null, created_date: any, id: number, title: string }> };

export type AddUserPovSummaryMutationVariables = Exact<{
  has_read: Scalars['Boolean']['input'];
  pov_id: Scalars['uuid']['input'];
}>;


export type AddUserPovSummaryMutation = { __typename?: 'Mutation', insert_user_pov_summaries_one?: { __typename?: 'user_pov_summaries', id: number, has_read: boolean } | null };

export type UpdateHasReadMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateHasReadMutation = { __typename?: 'Mutation', update_user_pov_summaries?: { __typename?: 'user_pov_summaries_mutation_response', returning: Array<{ __typename?: 'user_pov_summaries', id: number, has_read: boolean, pov_id: any }> } | null };

export type GetDailyPovQueryVariables = Exact<{
  where: Andablog_Pov_Bool_Exp;
}>;


export type GetDailyPovQuery = { __typename?: 'Query', andablog_pov: Array<{ __typename?: 'andablog_pov', brief_write_up: string, date: any, external_url: string, genre: string, id: any, image_url: string, level: string, pov: string, rank: number, time: number, title: string, user_pov_summaries: Array<{ __typename?: 'user_pov_summaries', id: number, has_read: boolean }> }> };

export type LearnPovQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearnPovQuery = { __typename?: 'Query', andablog_entry: Array<{ __typename?: 'andablog_entry', title: string, slug: string, andablog_videos: Array<{ __typename?: 'andablog_video', vdpcipher_id: string }>, quiz_category?: { __typename?: 'quiz_category', name: string, slug: string, quiz_domain?: { __typename?: 'quiz_domain', quiz_superdomain?: { __typename?: 'quiz_superdomain', slug: string } | null } | null } | null }> };

export type GetDailyQuizInstructionsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDailyQuizInstructionsQuery = { __typename?: 'Query', quiz_quiz: Array<{ __typename?: 'quiz_quiz', slug?: string | null, id: number, instructions2: string, instructions1: string, time_limit?: any | null, name: string, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, quiz_category: { __typename?: 'quiz_category', name: string, quiz_domain?: { __typename?: 'quiz_domain', quiz_superdomain?: { __typename?: 'quiz_superdomain', slug: string } | null } | null }, user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, did_accept_instruction: boolean }> }> };

export type AcceptDailyQuizTermsConditionsAndInstructionsMutationVariables = Exact<{
  user_quiz_summary_id: Scalars['uuid']['input'];
}>;


export type AcceptDailyQuizTermsConditionsAndInstructionsMutation = { __typename?: 'Mutation', update_user_quiz_summaries_by_pk?: { __typename?: 'user_quiz_summaries', id: any } | null };

export type AddDailyQuizUserSummaryMutationVariables = Exact<{
  quiz_id: Scalars['Int']['input'];
  current_position: Scalars['Int']['input'];
}>;


export type AddDailyQuizUserSummaryMutation = { __typename?: 'Mutation', insert_user_quiz_summaries_one?: { __typename?: 'user_quiz_summaries', id: any } | null };

export type GetUserQuizzesSummaryQueryVariables = Exact<{
  quiz_id: Scalars['Int']['input'];
}>;


export type GetUserQuizzesSummaryQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', is_completed: boolean, current_question?: number | null, attempt: number, current_position: number, id: any, user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', question_id: number, response?: string | null, time_taken: any, quiz_question: { __typename?: 'quiz_question', name: string, has_paragraph: boolean, solution?: string | null, options: Array<{ __typename?: 'quiz_option', is_correct: boolean, name: string }>, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null, title?: string | null } | null } }> }> };

export type TestGetQuizCountQueryVariables = Exact<{
  date: Scalars['timestamptz']['input'];
}>;


export type TestGetQuizCountQuery = { __typename?: 'Query', totalQuizCount: { __typename?: 'user_quiz_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_summaries_aggregate_fields', count: number } | null }, lastSevenDaysQuizCount: { __typename?: 'user_quiz_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_summaries_aggregate_fields', count: number } | null }, totalXpSum: { __typename?: 'user_xp_transactions_aggregate', aggregate?: { __typename?: 'user_xp_transactions_aggregate_fields', sum?: { __typename?: 'user_xp_transactions_sum_fields', xp?: any | null } | null } | null } };

export type GetDailyQuizzesQueryVariables = Exact<{
  name_filters: Array<Quiz_Quiz_Bool_Exp> | Quiz_Quiz_Bool_Exp;
  _nin: Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input'];
}>;


export type GetDailyQuizzesQuery = { __typename?: 'Query', quiz_category: Array<{ __typename?: 'quiz_category', free_learn: boolean, free_practice: boolean, is_lesson_category: boolean, name: string, rank?: number | null, quiz_domain?: { __typename?: 'quiz_domain', quiz_superdomain?: { __typename?: 'quiz_superdomain', slug: string } | null } | null, quiz_quizzes: Array<{ __typename?: 'quiz_quiz', available_on?: any | null, is_premium: boolean, rank?: any | null, has_access?: boolean | null, is_sections: boolean, name: string, quiz_player: string, single_attempt: boolean, time_limit?: any | null, visually_impaired_time_duration?: any | null, id: number, slug?: string | null, need_calc: boolean, user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', is_completed: boolean, id: any, current_position: number, did_accept_instruction: boolean, totalScore: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null } }> }> }> };

export type UpdateDailyQuizQuestionSummaryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  is_bookmarked: Scalars['Boolean']['input'];
}>;


export type UpdateDailyQuizQuestionSummaryMutation = { __typename?: 'Mutation', update_user_quiz_question_summaries?: { __typename?: 'user_quiz_question_summaries_mutation_response', returning: Array<{ __typename?: 'user_quiz_question_summaries', id: any }> } | null };

export type DailyResultQuestionDetailsFragment = { __typename?: 'quiz_question', id: number, name: string, solution?: string | null, question_type: string, difficulty: string, has_paragraph: boolean, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null } | null, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }> };

export type GetDailyResultQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDailyResultQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, quiz_id: number, quiz_quiz: { __typename?: 'quiz_quiz', available_on?: any | null, id: number, show_percentile?: boolean | null, name: string, quiz_category: { __typename?: 'quiz_category', name: string }, quiz_quiz_sections: Array<{ __typename?: 'quiz_quiz_sections', quiz_section: { __typename?: 'quiz_section', quiz_section_questions: Array<{ __typename?: 'quiz_section_questions', quiz_question: { __typename?: 'quiz_question', id: number, name: string, solution?: string | null, question_type: string, difficulty: string, has_paragraph: boolean, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null } | null, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }> } }> } }>, quiz_quiz_questions: Array<{ __typename?: 'quiz_quiz_questions', quiz_question: { __typename?: 'quiz_question', id: number, name: string, solution?: string | null, question_type: string, difficulty: string, has_paragraph: boolean, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null } | null, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }> } }> }, totalScore: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null }, all_question_positions: Array<{ __typename?: 'user_quiz_question_positions', position: number, question_id: number }>, user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', id: any, is_bookmarked: boolean, is_correct?: boolean | null, response?: string | null, is_attempted: boolean, time_taken: any, quiz_question: { __typename?: 'quiz_question', id: number, name: string, solution?: string | null, question_type: string, difficulty: string, has_paragraph: boolean, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null } | null, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }> } }>, correctQuestions: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null } }> };

export type GetDailyQuizHighScoreQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDailyQuizHighScoreQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', user_quiz_question_summaries_aggregate: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null } }> };

export type GetQuizLeaderboardQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuizLeaderboardQuery = { __typename?: 'Query', getQuizLeaderboard: Array<{ __typename?: 'LeaderboardEntry', rank: number, score: number, name: string, avatar: string }> };

export type GetLastDailyXpEarnedSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetLastDailyXpEarnedSubscription = { __typename?: 'Subscription', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', xp?: any | null }> };

export type DailyQuiz__GetLatestUserQuizAttemptQueryVariables = Exact<{
  quizSlug: Scalars['String']['input'];
}>;


export type DailyQuiz__GetLatestUserQuizAttemptQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, is_completed: boolean }> };

export type GetDailyQuizDetailsQueryVariables = Exact<{
  position: Scalars['Int']['input'];
  user_quiz_summary_id: Scalars['uuid']['input'];
}>;


export type GetDailyQuizDetailsQuery = { __typename?: 'Query', all_questions: Array<{ __typename?: 'user_quiz_question_positions', position: number, user_quiz_question_summary?: { __typename?: 'user_quiz_question_summaries', id: any, is_attempted: boolean, response?: string | null } | null }>, user_quiz_question_positions: Array<{ __typename?: 'user_quiz_question_positions', user_quiz_question_summary?: { __typename?: 'user_quiz_question_summaries', id: any, time_taken: any, response?: string | null, quiz_question: { __typename?: 'quiz_question', question_type: string, options: Array<{ __typename?: 'quiz_option', id: number, name: string }> } } | null, quiz_question: { __typename?: 'quiz_question', id: number, has_paragraph: boolean, question_type: string, name: string, quiz_paragraph?: { __typename?: 'quiz_paragraph', id: number, comprehension?: string | null } | null, options: Array<{ __typename?: 'quiz_option', id: number, is_correct: boolean, name: string }> }, user_quiz_summary: { __typename?: 'user_quiz_summaries', is_completed: boolean, remaining_time?: string | null, user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', time_taken: any }>, quiz_quiz: { __typename?: 'quiz_quiz', id: number, name: string, available_on?: any | null, need_calc: boolean, time_limit?: any | null, meta_title?: string | null } } }> };

export type AddDailyQuizQuestionSummaryMutationVariables = Exact<{
  question_id: Scalars['Int']['input'];
  question_position: Scalars['Int']['input'];
  quiz_summary_id: Scalars['uuid']['input'];
  response: Scalars['String']['input'];
  time_taken: Scalars['interval']['input'];
  is_attempted: Scalars['Boolean']['input'];
}>;


export type AddDailyQuizQuestionSummaryMutation = { __typename?: 'Mutation', insert_user_quiz_question_summaries_one?: { __typename?: 'user_quiz_question_summaries', id: any } | null };

export type AddDailyQuizSummaryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  current_position: Scalars['Int']['input'];
  current_question: Scalars['Int']['input'];
  is_completed: Scalars['Boolean']['input'];
}>;


export type AddDailyQuizSummaryMutation = { __typename?: 'Mutation', update_user_quiz_summaries?: { __typename?: 'user_quiz_summaries_mutation_response', returning: Array<{ __typename?: 'user_quiz_summaries', id: any }> } | null };

export type GetAchievementsXpDetailsQueryVariables = Exact<{
  startDate: Scalars['timestamptz']['input'];
  endDate: Scalars['timestamptz']['input'];
}>;


export type GetAchievementsXpDetailsQuery = { __typename?: 'Query', user_xp_transactions: Array<{ __typename?: 'user_xp_transactions', created_at: any, id: any, type: Xp_Transaction_Types_Enum, xp: any }> };

export type GetUserActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserActivitiesQuery = { __typename?: 'Query', user_activities: Array<{ __typename?: 'user_activities', type: string, id: any }> };

export type Timeline_GetUserPlannedActivitiesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type Timeline_GetUserPlannedActivitiesQuery = { __typename?: 'Query', getUserPlannedActivities: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type Timeline_GetUserCustomEventsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type Timeline_GetUserCustomEventsQuery = { __typename?: 'Query', getUserCustomEvents: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetUserActivityMinAndMaxDatesQueryVariables = Exact<{
  user_id: Scalars['String']['input'];
}>;


export type GetUserActivityMinAndMaxDatesQuery = { __typename?: 'Query', user_activity_aggregate: { __typename?: 'user_activity_aggregate', aggregate?: { __typename?: 'user_activity_aggregate_fields', max?: { __typename?: 'user_activity_max_fields', scheduled_end_date?: any | null } | null, min?: { __typename?: 'user_activity_min_fields', scheduled_start_date?: any | null } | null } | null } };

export type Planner__GetDomainNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type Planner__GetDomainNamesQuery = { __typename?: 'Query', quiz_domain: Array<{ __typename?: 'quiz_domain', slug: string, name: string, id: number }> };

export type RemoveAllUserPlannedActivitiesMutationVariables = Exact<{
  where?: InputMaybe<User_Planned_Activities_Bool_Exp>;
  where2?: InputMaybe<User_Custom_Planned_Activities_Bool_Exp>;
}>;


export type RemoveAllUserPlannedActivitiesMutation = { __typename?: 'Mutation', delete_user_planned_activities?: { __typename?: 'user_planned_activities_mutation_response', affected_rows: number } | null, delete_user_custom_planned_activities?: { __typename?: 'user_custom_planned_activities_mutation_response', affected_rows: number } | null };

export type UpdateUserPlannedActivityMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  schedule_end_date: Scalars['timestamptz']['input'];
  scheduled_at: Scalars['timestamptz']['input'];
}>;


export type UpdateUserPlannedActivityMutation = { __typename?: 'Mutation', update_user_planned_activities_by_pk?: { __typename?: 'user_planned_activities', id: any, schedule_end_date: any, scheduled_at: any } | null };

export type UpdateUserCustomEventMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  schedule_end_date: Scalars['timestamptz']['input'];
  scheduled_at: Scalars['timestamptz']['input'];
}>;


export type UpdateUserCustomEventMutation = { __typename?: 'Mutation', update_user_custom_planned_activities_by_pk?: { __typename?: 'user_custom_planned_activities', id: any, schedule_end_date: any, scheduled_at: any } | null };

export type UpdateUserActivityMutationVariables = Exact<{
  user_id: Scalars['String']['input'];
  data: User_Activity_Set_Input;
  id: Scalars['Int']['input'];
}>;


export type UpdateUserActivityMutation = { __typename?: 'Mutation', update_user_activity?: { __typename?: 'user_activity_mutation_response', returning: Array<{ __typename?: 'user_activity', id: number }> } | null };

export type RemoveEventsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RemoveEventsMutation = { __typename?: 'Mutation', delete_user_planned_activities?: { __typename?: 'user_planned_activities_mutation_response', returning: Array<{ __typename?: 'user_planned_activities', id: any }> } | null };

export type RemoveCustomEventsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RemoveCustomEventsMutation = { __typename?: 'Mutation', delete_user_custom_planned_activities?: { __typename?: 'user_custom_planned_activities_mutation_response', returning: Array<{ __typename?: 'user_custom_planned_activities', id: any }> } | null };

export type SchedulePlannerMutationVariables = Exact<{
  days: Scalars['Int']['input'];
  domains: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  include: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SchedulePlannerMutation = { __typename?: 'Mutation', schedulePlanner: { __typename?: 'GenericResponse', message?: string | null, success: boolean } };

export type AddUserCustomEventMutationVariables = Exact<{
  object: User_Custom_Planned_Activities_Insert_Input;
}>;


export type AddUserCustomEventMutation = { __typename?: 'Mutation', insert_user_custom_planned_activities_one?: { __typename?: 'user_custom_planned_activities', id: any } | null };

export type GetUpcomingLiveClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUpcomingLiveClassesQuery = { __typename?: 'Query', upcoming_live_classes: Array<{ __typename?: 'upcoming_live_classes', created_at: any, end_time: any, start_time: any, id: any, taken_by: string, url: string, updated_at: any, title: string }> };

export type GetUserRecentActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRecentActivitiesQuery = { __typename?: 'Query', user_activities: Array<{ __typename?: 'user_activities', id: any, quiz_id?: number | null, updated_at: any, learn_category_id?: number | null, type: string, quiz_category?: { __typename?: 'quiz_category', name: string, slug: string, is_lesson_category: boolean, number_of_completed_modules?: number | null, total_number_of_modules?: number | null, andablog_entries: Array<{ __typename?: 'andablog_entry', slug: string }>, quiz_domain?: { __typename?: 'quiz_domain', name: string, slug: string, quiz_superdomain?: { __typename?: 'quiz_superdomain', name: string, slug: string } | null } | null } | null, quiz_quiz?: { __typename?: 'quiz_quiz', name: string, slug?: string | null, is_timed: boolean, time_limit?: any | null, number_of_completed_questions?: number | null, total_number_of_questions?: number | null, quiz_category: { __typename?: 'quiz_category', name: string, slug: string, is_lesson_category: boolean, number_of_completed_modules?: number | null, total_number_of_modules?: number | null, quiz_domain?: { __typename?: 'quiz_domain', name: string, id: number, slug: string, quiz_superdomain?: { __typename?: 'quiz_superdomain', name: string, slug: string } | null } | null }, user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, is_completed: boolean, number_of_attempted_questions?: number | null }>, user_speed_tests_summaries: Array<{ __typename?: 'user_speed_tests_summaries', id: any, is_completed: boolean, user_speed_test_questions_summaries_aggregate: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null } }> } | null }> };

export type GetLastSevenDaysXpInfoQueryVariables = Exact<{
  date: Scalars['timestamptz']['input'];
}>;


export type GetLastSevenDaysXpInfoQuery = { __typename?: 'Query', user_xp_transactions: Array<{ __typename?: 'user_xp_transactions', created_at: any, xp: any }> };

export type GetXpSumDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetXpSumDetailsQuery = { __typename?: 'Query', totalXP: { __typename?: 'user_xp_transactions_aggregate', aggregate?: { __typename?: 'user_xp_transactions_aggregate_fields', sum?: { __typename?: 'user_xp_transactions_sum_fields', xp?: any | null } | null } | null }, speedAndDailyXP: { __typename?: 'user_xp_transactions_aggregate', aggregate?: { __typename?: 'user_xp_transactions_aggregate_fields', sum?: { __typename?: 'user_xp_transactions_sum_fields', xp?: any | null } | null } | null }, lessonsXP: { __typename?: 'user_xp_transactions_aggregate', aggregate?: { __typename?: 'user_xp_transactions_aggregate_fields', sum?: { __typename?: 'user_xp_transactions_sum_fields', xp?: any | null } | null } | null }, practiceQuestionsXP: { __typename?: 'user_xp_transactions_aggregate', aggregate?: { __typename?: 'user_xp_transactions_aggregate_fields', sum?: { __typename?: 'user_xp_transactions_sum_fields', xp?: any | null } | null } | null }, mocksAndTestsXP: { __typename?: 'user_xp_transactions_aggregate', aggregate?: { __typename?: 'user_xp_transactions_aggregate_fields', sum?: { __typename?: 'user_xp_transactions_sum_fields', xp?: any | null } | null } | null } };

export type GetPlannerLessonDomainsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlannerLessonDomainsQuery = { __typename?: 'Query', getPlannerLessonDomains: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetPlannerPracticeDomainsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlannerPracticeDomainsQuery = { __typename?: 'Query', getPlannerPracticeDomains: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetDomainCompeteDataQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDomainCompeteDataQuery = { __typename?: 'Query', getPlannerCompeteDomains: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type AddUserPlannedActivityMutationVariables = Exact<{
  data: User_Planned_Activities_Insert_Input;
}>;


export type AddUserPlannedActivityMutation = { __typename?: 'Mutation', insert_user_planned_activities_one?: { __typename?: 'user_planned_activities', id: any, schedule_end_date: any, scheduled_at: any } | null };

export type GetPlannerSpeedConceptDomainsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlannerSpeedConceptDomainsQuery = { __typename?: 'Query', getPlannerSpeedConceptDomains: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetUserPlannedActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPlannedActivitiesQuery = { __typename?: 'Query', user_planned_activities: Array<{ __typename?: 'user_planned_activities', id: any, quiz_id?: number | null, scheduled_at: any, schedule_end_date: any, lesson_category_id?: number | null, quiz_category?: { __typename?: 'quiz_category', name: string, slug: string, is_lesson_category: boolean, number_of_completed_modules?: number | null, total_number_of_modules?: number | null, andablog_entries: Array<{ __typename?: 'andablog_entry', slug: string }>, quiz_domain?: { __typename?: 'quiz_domain', name: string, slug: string, id: number, quiz_superdomain?: { __typename?: 'quiz_superdomain', name: string, slug: string } | null } | null } | null, quiz_quiz?: { __typename?: 'quiz_quiz', name: string, slug?: string | null, is_timed: boolean, number_of_completed_questions?: number | null, total_number_of_questions?: number | null, time_limit?: any | null, quiz_category: { __typename?: 'quiz_category', name: string, slug: string, is_lesson_category: boolean, number_of_completed_modules?: number | null, total_number_of_modules?: number | null, quiz_domain?: { __typename?: 'quiz_domain', name: string, slug: string, id: number, quiz_superdomain?: { __typename?: 'quiz_superdomain', name: string, slug: string } | null } | null }, user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, is_completed: boolean }>, user_planned_activities_aggregate: { __typename?: 'user_planned_activities_aggregate', aggregate?: { __typename?: 'user_planned_activities_aggregate_fields', count: number } | null, completed_rows?: { __typename?: 'user_planned_activities_aggregate_fields', count: number } | null }, user_speed_tests_summaries: Array<{ __typename?: 'user_speed_tests_summaries', id: any, is_completed: boolean, user_speed_test_questions_summaries_aggregate: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null } }> } | null }> };

export type GetUserCustomEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCustomEventsQuery = { __typename?: 'Query', user_custom_planned_activities: Array<{ __typename?: 'user_custom_planned_activities', id: any, description: string, scheduled_at: any, schedule_end_date: any, topic: string }> };

export type GetXpLeaderBoardQueryVariables = Exact<{
  range?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetXpLeaderBoardQuery = { __typename?: 'Query', getXpLeaderBoard: { __typename?: 'XpLeaderBoardResponse', success: boolean, message: string, data?: Array<{ __typename?: 'XpLeaderBoardData', name: string, rank: number, avatar: string, xp: number, userId: string } | null> | null } };

export type GetInfoZoneAnnouncementsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInfoZoneAnnouncementsQuery = { __typename?: 'Query', infozone_infozone: Array<{ __typename?: 'infozone_infozone', title: string, slug?: string | null, content?: string | null, created_date: any }> };

export type GetInfoZoneAnnouncementQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInfoZoneAnnouncementQuery = { __typename?: 'Query', infozone_infozone: Array<{ __typename?: 'infozone_infozone', content?: string | null, title: string, created_date: any, next_item?: Array<{ __typename?: 'infozone_infozone', slug?: string | null, title: string }> | null, previous_item?: Array<{ __typename?: 'infozone_infozone', slug?: string | null, title: string }> | null }> };

export type GetInfoZoneCollegeQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInfoZoneCollegeQuery = { __typename?: 'Query', college: Array<{ __typename?: 'infozone_infozone', content?: string | null }>, colleges: Array<{ __typename?: 'infozone_infozone', slug?: string | null, title: string }> };

export type GetInfoZoneExamQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInfoZoneExamQuery = { __typename?: 'Query', exam: Array<{ __typename?: 'infozone_infozone', content?: string | null }>, exams: Array<{ __typename?: 'infozone_infozone', slug?: string | null, title: string }> };

export type GetInfoZoneSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInfoZoneSummaryQuery = { __typename?: 'Query', announcements: Array<{ __typename?: 'infozone_infozone', slug?: string | null, title: string }>, colleges: Array<{ __typename?: 'infozone_infozone', slug?: string | null, title: string }>, exams: Array<{ __typename?: 'infozone_infozone', slug?: string | null, title: string }> };

export type GetLearnBookmarkTopicsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetLearnBookmarkTopicsQuery = { __typename?: 'Query', user_learn_modules_summary: Array<{ __typename?: 'user_learn_modules_summary', id: any, is_bookmarked: boolean, time_spent: number, andablog_entry: { __typename?: 'andablog_entry', content: string, title: string, slug: string, quiz_category?: { __typename?: 'quiz_category', name: string, quiz_domain?: { __typename?: 'quiz_domain', name: string } | null } | null } }> };

export type UpdateLearnBookmarkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateLearnBookmarkMutation = { __typename?: 'Mutation', update_user_learn_modules_summary?: { __typename?: 'user_learn_modules_summary_mutation_response', returning: Array<{ __typename?: 'user_learn_modules_summary', id: any }> } | null };

export type Learn__GetDomainsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  _nin: Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input'];
}>;


export type Learn__GetDomainsQuery = { __typename?: 'Query', quiz_domain: Array<{ __typename?: 'quiz_domain', name: string, id: number, slug: string, quiz_categories: Array<{ __typename?: 'quiz_category', name: string, slug: string, total_number_of_modules?: number | null, number_of_completed_modules?: number | null, andablog_entries_aggregate: { __typename?: 'andablog_entry_aggregate', aggregate?: { __typename?: 'andablog_entry_aggregate_fields', count: number } | null }, andablog_entries: Array<{ __typename?: 'andablog_entry', slug: string }>, user_recent_lesson: Array<{ __typename?: 'user_recent_lessons', last_visited?: any | null }> }> }> };

export type GetLiveQuizDomainsQueryVariables = Exact<{
  isFree: Scalars['Boolean']['input'];
}>;


export type GetLiveQuizDomainsQuery = { __typename?: 'Query', getLiveQuizDomains: { __typename?: 'LiveQuizDomainsResponse', success: boolean, message: string, data: string } };

export type UpdateLearnTopicBookmarksMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  last_visited: Scalars['timestamptz']['input'];
  is_bookmarked: Scalars['Boolean']['input'];
}>;


export type UpdateLearnTopicBookmarksMutation = { __typename?: 'Mutation', insert_user_learn_modules_summary_one?: { __typename?: 'user_learn_modules_summary', id: any, is_bookmarked: boolean } | null };

export type GetLearnStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLearnStatisticsQuery = { __typename?: 'Query', all_lessons: Array<{ __typename?: 'admin_constants', value: string }>, all_modules: Array<{ __typename?: 'admin_constants', value: string }>, completed_modules: { __typename?: 'user_learn_modules_summary_aggregate', aggregate?: { __typename?: 'user_learn_modules_summary_aggregate_fields', count: number } | null }, bookmarked_modules: { __typename?: 'user_learn_modules_summary_aggregate', aggregate?: { __typename?: 'user_learn_modules_summary_aggregate_fields', count: number } | null } };

export type Learn__GetVideoOtpQueryVariables = Exact<{
  activeTopicID: Scalars['Int']['input'];
}>;


export type Learn__GetVideoOtpQuery = { __typename?: 'Query', getVideoOTPForLesson: { __typename?: 'VideoCipherOTPPayload', otp?: string | null, playbackInfo?: string | null } };

export type GetLessonWeeklyStatusChartQueryVariables = Exact<{
  last7Days: Scalars['timestamptz']['input'];
}>;


export type GetLessonWeeklyStatusChartQuery = { __typename?: 'Query', user_learn_modules_summary: Array<{ __typename?: 'user_learn_modules_summary', id: any, created_at: any }> };

export type GetRecentLessonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentLessonsQuery = { __typename?: 'Query', user_recent_lessons: Array<{ __typename?: 'user_recent_lessons', last_visited?: any | null, quiz_category?: { __typename?: 'quiz_category', total_number_of_modules?: number | null, number_of_completed_modules?: number | null, name: string } | null }> };

export type Learn__UserLearnSummariesFragment = { __typename?: 'user_learn_modules_summary', id: any, is_bookmarked: boolean, time_spent: number };

export type Learn__GetCategoryTopicDetailsQueryVariables = Exact<{
  category_slug: Scalars['String']['input'];
}>;


export type Learn__GetCategoryTopicDetailsQuery = { __typename?: 'Query', quiz_category: Array<{ __typename?: 'quiz_category', name: string, id: number, andablog_entries: Array<{ __typename?: 'andablog_entry', id: number, title: string, rank: number, slug: string, content: string, has_access?: boolean | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, user_learn_summaries: Array<{ __typename?: 'user_learn_modules_summary', id: any, is_bookmarked: boolean, time_spent: number }> }>, quiz_domain?: { __typename?: 'quiz_domain', name: string, quiz_superdomain?: { __typename?: 'quiz_superdomain', slug: string } | null } | null }> };

export type AddLearnModulesSummaryMutationVariables = Exact<{
  entry_id: Scalars['Int']['input'];
  last_visited: Scalars['timestamptz']['input'];
  time_spent: Scalars['Int']['input'];
}>;


export type AddLearnModulesSummaryMutation = { __typename?: 'Mutation', insert_user_learn_modules_summary_one?: { __typename?: 'user_learn_modules_summary', id: any, is_bookmarked: boolean, time_spent: number } | null };

export type AddUserQuizSummaryMutationVariables = Exact<{
  quiz_id: Scalars['Int']['input'];
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  current_position: Scalars['Int']['input'];
}>;


export type AddUserQuizSummaryMutation = { __typename?: 'Mutation', insert_user_quiz_summaries_one?: { __typename?: 'user_quiz_summaries', is_completed: boolean, quiz_id: number, current_position: number } | null };

export type Practice__GetDomainsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  _nin: Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input'];
}>;


export type Practice__GetDomainsQuery = { __typename?: 'Query', quiz_domain: Array<{ __typename?: 'quiz_domain', name: string, id: number, quiz_categories: Array<{ __typename?: 'quiz_category', name: string, slug: string, quiz_quizzes: Array<{ __typename?: 'quiz_quiz', slug?: string | null, id: number, has_access?: boolean | null, isPremium: boolean, totalNumberOfQuestions?: number | null, user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, current_position: number, is_completed: boolean, number_of_attempted_questions?: number | null, current_question?: number | null, user_quiz_question_summaries_aggregate: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null } }> }> }> }> };

export type GetLastAttemptQueryVariables = Exact<{
  quiz_id: Scalars['Int']['input'];
}>;


export type GetLastAttemptQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', attempt: number, id: any }> };

export type AddQuizSummaryMutationVariables = Exact<{
  quiz_id: Scalars['Int']['input'];
  attempt: Scalars['Int']['input'];
}>;


export type AddQuizSummaryMutation = { __typename?: 'Mutation', insert_user_quiz_summaries_one?: { __typename?: 'user_quiz_summaries', current_position: number } | null };

export type GetPracticeStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPracticeStatisticsQuery = { __typename?: 'Query', all_practice_quizzes: Array<{ __typename?: 'admin_constants', value: string }>, completed_practice_quizzes: { __typename?: 'user_quiz_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_summaries_aggregate_fields', count: number } | null }, all_questions_in_practice_quizzes: Array<{ __typename?: 'admin_constants', value: string }>, completed_questions_in_practice_quizzes: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null }, bookmarked_questions_in_practice_quizzes: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null } };

export type GetPracticeWeeklyStatusChartQueryVariables = Exact<{
  last7Days: Scalars['timestamp']['input'];
}>;


export type GetPracticeWeeklyStatusChartQuery = { __typename?: 'Query', user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', id: any, created_at: any }> };

export type GetRecentPracticeTestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentPracticeTestsQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', is_completed: boolean, number_of_attempted_questions?: number | null, updated_at: any, quiz_quiz: { __typename?: 'quiz_quiz', name: string, total_number_of_questions?: number | null, quiz_category: { __typename?: 'quiz_category', name: string } } }> };

export type GetUserQuizSummaryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserQuizSummaryQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', number_of_attempted_questions?: number | null, quiz_quiz: { __typename?: 'quiz_quiz', name: string, quiz_category: { __typename?: 'quiz_category', name: string, quiz_domain?: { __typename?: 'quiz_domain', name: string, quiz_superdomain?: { __typename?: 'quiz_superdomain', name: string } | null } | null } }, correct_questions: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null }, wrong_questions: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', count: number } | null }, total_marks: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null }, user_quiz_question_positions: Array<{ __typename?: 'user_quiz_question_positions', question_id: number, position: number, quiz_question: { __typename?: 'quiz_question', difficulty: string, name: string, question_type: string, solution?: string | null, has_paragraph: boolean, options: Array<{ __typename?: 'quiz_option', name: string, is_correct: boolean, id: number }>, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null, title?: string | null } | null } }>, user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', is_bookmarked: boolean, id: any, is_correct?: boolean | null, time_taken: any, response?: string | null, question_id: number, quiz_question: { __typename?: 'quiz_question', difficulty: string, name: string, question_type: string, solution?: string | null, has_paragraph: boolean, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }>, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null, title?: string | null } | null } }> }> };

export type Practice__GetLatestUserQuizAttemptQueryVariables = Exact<{
  quizSlug: Scalars['String']['input'];
}>;


export type Practice__GetLatestUserQuizAttemptQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, is_completed: boolean }> };

export type Practice__GetQuizQuestionsAndQuizSummaryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  question_position: Scalars['Int']['input'];
  user_quiz_summary_id: Scalars['uuid']['input'];
}>;


export type Practice__GetQuizQuestionsAndQuizSummaryQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any, attempt: number }>, quiz_quiz: Array<{ __typename?: 'quiz_quiz', id: number, name: string, total_number_of_questions?: number | null, need_calc: boolean, quiz_category: { __typename?: 'quiz_category', name: string, quiz_domain?: { __typename?: 'quiz_domain', name: string, quiz_superdomain?: { __typename?: 'quiz_superdomain', name: string } | null } | null } }>, user_quiz_question_positions: Array<{ __typename?: 'user_quiz_question_positions', question_id: number, quiz_question: { __typename?: 'quiz_question', has_paragraph: boolean, id: number, question_type: string, name: string, solution?: string | null, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null, title?: string | null } | null, options: Array<{ __typename?: 'quiz_option', is_correct: boolean, id: number, name: string }>, user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', id: any, is_bookmarked: boolean, response?: string | null, time_taken: any, is_attempted: boolean }> } }> };

export type AddUserQuizSummaryOneMutationVariables = Exact<{
  quiz_id: Scalars['Int']['input'];
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  current_position: Scalars['Int']['input'];
  attempt?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddUserQuizSummaryOneMutation = { __typename?: 'Mutation', insert_user_quiz_summaries_one?: { __typename?: 'user_quiz_summaries', is_completed: boolean, id: any } | null };

export type AddUserQuizQuestionSummaryMutationVariables = Exact<{
  data: User_Quiz_Question_Summaries_Insert_Input;
}>;


export type AddUserQuizQuestionSummaryMutation = { __typename?: 'Mutation', insert_user_quiz_question_summaries_one?: { __typename?: 'user_quiz_question_summaries', id: any } | null };

export type UpdateUserAdditionalDetailsMutationVariables = Exact<{
  object: Supertokens_User_Additional_Fields_Insert_Input;
}>;


export type UpdateUserAdditionalDetailsMutation = { __typename?: 'Mutation', insert_supertokens_user_additional_fields_one?: { __typename?: 'supertokens_user_additional_fields', id: number, mobile_verified: boolean } | null };

export type GetSpeedPreviousQuizSummaryQueryVariables = Exact<{
  category: Scalars['String']['input'];
}>;


export type GetSpeedPreviousQuizSummaryQuery = { __typename?: 'Query', user_speed_tests_summaries: Array<{ __typename?: 'user_speed_tests_summaries', id: any, created_at: any, test_type: string, test_time: number, score?: number | null }> };

export type AddSpeedTestQuestionSummaryMutationVariables = Exact<{
  data: User_Speed_Test_Questions_Summaries_Insert_Input;
}>;


export type AddSpeedTestQuestionSummaryMutation = { __typename?: 'Mutation', insert_user_speed_test_questions_summaries_one?: { __typename?: 'user_speed_test_questions_summaries', id: any, user_speed_tests_summary: { __typename?: 'user_speed_tests_summaries', score?: number | null, id: any, user_speed_test_questions_summaries_aggregate: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, correct_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null } } } | null };

export type SubmitSpeedTestSummaryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SubmitSpeedTestSummaryMutation = { __typename?: 'Mutation', update_user_speed_tests_summaries_by_pk?: { __typename?: 'user_speed_tests_summaries', id: any } | null };

export type GetSpeedConceptQuizzesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetSpeedConceptQuizzesQuery = { __typename?: 'Query', quiz_quiz: Array<{ __typename?: 'quiz_quiz', name: string, slug?: string | null, id: number, total_number_of_questions?: number | null, time_limit?: any | null, quiz_category: { __typename?: 'quiz_category', name: string, slug: string }, quiz_quiz_questions_aggregate: { __typename?: 'quiz_quiz_questions_aggregate', aggregate?: { __typename?: 'quiz_quiz_questions_aggregate_fields', count: number } | null }, user_speed_tests_summaries: Array<{ __typename?: 'user_speed_tests_summaries', id: any, score?: number | null, is_completed: boolean, created_at: any, user_speed_test_questions_summaries_aggregate: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, correct_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null } }> }> };

export type AddSpeedConceptSummaryMutationVariables = Exact<{
  quiz_id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  time: Scalars['Int']['input'];
  config: Scalars['json']['input'];
}>;


export type AddSpeedConceptSummaryMutation = { __typename?: 'Mutation', insert_user_speed_tests_summaries_one?: { __typename?: 'user_speed_tests_summaries', id: any } | null };

export type GetSpeedConceptDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSpeedConceptDetailsQuery = { __typename?: 'Query', user_speed_tests_summaries_by_pk?: { __typename?: 'user_speed_tests_summaries', created_at: any, updated_at: any, config: any, is_completed: boolean, score?: number | null, id: any, quiz_id?: number | null, quiz_quiz?: { __typename?: 'quiz_quiz', quiz_quiz_questions_aggregate: { __typename?: 'quiz_quiz_questions_aggregate', aggregate?: { __typename?: 'quiz_quiz_questions_aggregate_fields', count: number } | null } } | null, attempted_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, last_attempted_question: Array<{ __typename?: 'user_speed_test_questions_summaries', id: any }>, correct_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null } } | null };

export type SpeedConcepts__GetRandomQuestionQueryVariables = Exact<{
  user_speed_test_summary_id_args: Scalars['uuid']['input'];
}>;


export type SpeedConcepts__GetRandomQuestionQuery = { __typename?: 'Query', get_speed_concepts_random_question?: { __typename?: 'quiz_quiz_questions', question_id: number, quiz_question: { __typename?: 'quiz_question', name: string, question_type: string, options: Array<{ __typename?: 'quiz_option', is_correct: boolean, id: number, name: string }> } } | null };

export type SpeedConcepts__GetRandomQuestionsQueryVariables = Exact<{
  user_speed_test_summary_id_args: Scalars['uuid']['input'];
}>;


export type SpeedConcepts__GetRandomQuestionsQuery = { __typename?: 'Query', get_speed_concepts_all_random_questions: Array<{ __typename?: 'quiz_quiz_questions', question_id: number, quiz_question: { __typename?: 'quiz_question', name: string, question_type: string, options: Array<{ __typename?: 'quiz_option', is_correct: boolean, id: number, name: string }> } }> };

export type AddUserSpeedMathSummaryMutationVariables = Exact<{
  test_time: Scalars['Int']['input'];
  config: Scalars['json']['input'];
  test_type: Scalars['String']['input'];
}>;


export type AddUserSpeedMathSummaryMutation = { __typename?: 'Mutation', insert_user_speed_tests_summaries_one?: { __typename?: 'user_speed_tests_summaries', id: any } | null };

export type GetSpeedTestWeeklyStatusChartQueryVariables = Exact<{
  last7Days: Scalars['timestamptz']['input'];
}>;


export type GetSpeedTestWeeklyStatusChartQuery = { __typename?: 'Query', user_speed_tests_summaries: Array<{ __typename?: 'user_speed_tests_summaries', id: any, created_at: any }> };

export type GetSpeedMathDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSpeedMathDetailsQuery = { __typename?: 'Query', user_speed_tests_summaries_by_pk?: { __typename?: 'user_speed_tests_summaries', id: any, score?: number | null, created_at: any, updated_at: any, config: any, user_speed_test_questions_summaries: Array<{ __typename?: 'user_speed_test_questions_summaries', question?: string | null }>, last_attempted_question: Array<{ __typename?: 'user_speed_test_questions_summaries', id: any, question?: string | null, time_taken?: number | null }>, user_speed_test_questions_summaries_aggregate: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, correct_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, attempted_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, total_time_taken: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', sum?: { __typename?: 'user_speed_test_questions_summaries_sum_fields', time_taken?: number | null } | null } | null } } | null };

export type GetSpeedMathQuestionDetailsQueryVariables = Exact<{
  questionID: Scalars['uuid']['input'];
}>;


export type GetSpeedMathQuestionDetailsQuery = { __typename?: 'Query', user_speed_test_questions_summaries_by_pk?: { __typename?: 'user_speed_test_questions_summaries', id: any, question?: string | null, answer: string, is_attempted: boolean, response?: string | null, question_number?: number | null } | null };

export type AddSpeedMathQuestionMutationVariables = Exact<{
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
  userSpeedTestSummaryID: Scalars['uuid']['input'];
}>;


export type AddSpeedMathQuestionMutation = { __typename?: 'Mutation', insert_user_speed_test_questions_summaries_one?: { __typename?: 'user_speed_test_questions_summaries', id: any } | null };

export type SubmitSpeedMathAnswerMutationVariables = Exact<{
  questionID: Scalars['uuid']['input'];
  response: Scalars['String']['input'];
  is_attempted: Scalars['Boolean']['input'];
  time_taken: Scalars['Int']['input'];
}>;


export type SubmitSpeedMathAnswerMutation = { __typename?: 'Mutation', update_user_speed_test_questions_summaries_by_pk?: { __typename?: 'user_speed_test_questions_summaries', id: any, question?: string | null } | null };

export type SpeedMath__DeleteUnattemptedQuestionsMutationVariables = Exact<{ [key: string]: never; }>;


export type SpeedMath__DeleteUnattemptedQuestionsMutation = { __typename?: 'Mutation', delete_user_speed_test_questions_summaries?: { __typename?: 'user_speed_test_questions_summaries_mutation_response', affected_rows: number } | null };

export type AddUserSpeedQuantSummaryMutationVariables = Exact<{
  test_time: Scalars['Int']['input'];
  config: Scalars['json']['input'];
  quiz_id: Scalars['Int']['input'];
  test_type: Scalars['String']['input'];
}>;


export type AddUserSpeedQuantSummaryMutation = { __typename?: 'Mutation', insert_user_speed_tests_summaries_one?: { __typename?: 'user_speed_tests_summaries', id: any } | null };

export type LastSpeedSummaryForTodayQueryVariables = Exact<{
  date: Scalars['timestamptz']['input'];
  category: Scalars['String']['input'];
}>;


export type LastSpeedSummaryForTodayQuery = { __typename?: 'Query', user_speed_tests_summaries: Array<{ __typename?: 'user_speed_tests_summaries', id: any }> };

export type GetSpeedQuantDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSpeedQuantDetailsQuery = { __typename?: 'Query', user_speed_tests_summaries_by_pk?: { __typename?: 'user_speed_tests_summaries', created_at: any, is_completed: boolean, updated_at: any, config: any, score?: number | null, user_speed_test_questions_summaries: Array<{ __typename?: 'user_speed_test_questions_summaries', id: any, quiz_question_id?: number | null }>, last_attempted_question: Array<{ __typename?: 'user_speed_test_questions_summaries', id: any }>, user_speed_test_questions_summaries_aggregate: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, correct_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, attempted_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, total_time_taken: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', sum?: { __typename?: 'user_speed_test_questions_summaries_sum_fields', time_taken?: number | null } | null } | null } } | null };

export type GetSpeedVerbalDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSpeedVerbalDetailsQuery = { __typename?: 'Query', user_speed_tests_summaries_by_pk?: { __typename?: 'user_speed_tests_summaries', created_at: any, updated_at: any, score?: number | null, config: any, user_speed_test_questions_summaries: Array<{ __typename?: 'user_speed_test_questions_summaries', id: any }>, last_attempted_question: Array<{ __typename?: 'user_speed_test_questions_summaries', id: any }>, user_speed_test_questions_summaries_aggregate: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, correct_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, attempted_questions: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, total_time_taken: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', sum?: { __typename?: 'user_speed_test_questions_summaries_sum_fields', time_taken?: number | null } | null } | null } } | null };

export type AddUserSpeedVerbalSummaryMutationVariables = Exact<{
  test_time: Scalars['Int']['input'];
  config: Scalars['json']['input'];
  test_type: Scalars['String']['input'];
  quiz_id: Scalars['Int']['input'];
}>;


export type AddUserSpeedVerbalSummaryMutation = { __typename?: 'Mutation', insert_user_speed_tests_summaries_one?: { __typename?: 'user_speed_tests_summaries', id: any } | null };

export type CreateMeetingMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
}>;


export type CreateMeetingMutation = { __typename?: 'Mutation', createMeeting: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetMeetingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMeetingsQuery = { __typename?: 'Query', meetings: Array<{ __typename?: 'meetings', id: any, meeting_id: string, title: string, description?: string | null, meeting_members: Array<{ __typename?: 'meeting_members', id: any, updated_at: any }> }> };

export type JoinMeetingMutationVariables = Exact<{
  meetingId: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type JoinMeetingMutation = { __typename?: 'Mutation', joinMeeting: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetMeetingByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMeetingByIdQuery = { __typename?: 'Query', meetings: Array<{ __typename?: 'meetings', description?: string | null, title: string }> };

export type GetLeaderboardQueryVariables = Exact<{
  category: Scalars['String']['input'];
  type: Scalars['String']['input'];
  sub_type: Scalars['String']['input'];
}>;


export type GetLeaderboardQuery = { __typename?: 'Query', user_leaderboards: Array<{ __typename?: 'user_leaderboards', rank: number, score: number, user?: { __typename?: 'supertokens_user_public_fields', username?: string | null, avatar?: string | null, first_name?: string | null, last_name?: string | null } | null }> };

export type DownloadUsersDataQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadUsersDataQuery = { __typename?: 'Query', downloadUsersData: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type DownloadUserQuizSummariesQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadUserQuizSummariesQuery = { __typename?: 'Query', downloadUserQuizSummaries: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type ValidateGoogleLoginMutationVariables = Exact<{
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValidateGoogleLoginMutation = { __typename?: 'Mutation', validateGoogleLogin: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type SendVerificationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendVerificationEmailMutation = { __typename?: 'Mutation', sendVerificationEmail: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type ResetUserPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', verifyResetPasswordToken: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetCatResultMutationVariables = Exact<{
  input: GetCatResultInput;
}>;


export type GetCatResultMutation = { __typename?: 'Mutation', getCatResult: { __typename?: 'GetCatResultResponse', success: boolean, message?: string | null, applicationId?: string | null, data?: string | null } };

export type GetResponseTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResponseTypeQuery = { __typename?: 'Query', cat_percentile_constant: Array<{ __typename?: 'cat_percentile_constant', value: string }> };

export type GetPercentileConstantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPercentileConstantsQuery = { __typename?: 'Query', cat_percentile_constant: Array<{ __typename?: 'cat_percentile_constant', name: string, value: string }> };

export type GetCatResponseLeaderboardQueryVariables = Exact<{
  value: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetCatResponseLeaderboardQuery = { __typename?: 'Query', user_cat_response_sheet_data: Array<{ __typename?: 'user_cat_response_sheet_data', candidate_name: string, shift: number, varc_raw: any, quant_raw: any, dilr_raw: any, total_raw: any }> };

export type GetChannelsSubscriptionVariables = Exact<{
  query: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
}>;


export type GetChannelsSubscription = { __typename?: 'Subscription', channels: Array<{ __typename?: 'channels', name: string, id: any, avatar: string, slug?: string | null, category?: { __typename?: 'group_category', name: string, slug: string } | null, messages: Array<{ __typename?: 'messages', message?: string | null, id: any, created_at: any, type: string, user?: { __typename?: 'supertokens_user_public_fields', first_name?: string | null, username?: string | null, role?: string | null } | null }>, messages_reads_aggregate: { __typename?: 'messages_read_aggregate', aggregate?: { __typename?: 'messages_read_aggregate_fields', count: number } | null }, messages_aggregate: { __typename?: 'messages_aggregate', aggregate?: { __typename?: 'messages_aggregate_fields', count: number } | null }, channel_members_aggregate: { __typename?: 'channel_members_aggregate', aggregate?: { __typename?: 'channel_members_aggregate_fields', count: number } | null } }> };

export type GetMessagesSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetMessagesSubscription = { __typename?: 'Subscription', messages: Array<{ __typename?: 'messages', id: any, message?: string | null, created_at: any, type: string, file_url?: string | null, file_name?: string | null, channel_id: any, is_pinned: boolean, replied_to_message_id?: any | null, messages_reads_aggregate: { __typename?: 'messages_read_aggregate', aggregate?: { __typename?: 'messages_read_aggregate_fields', count: number } | null }, user?: { __typename?: 'supertokens_user_public_fields', first_name?: string | null, last_name?: string | null, username?: string | null, user_id?: string | null, avatar?: string | null, role?: string | null } | null, reactions: Array<{ __typename?: 'message_reactions', emoji: string, user_id?: any | null, id: any }>, poll?: { __typename?: 'poll', title: string, type: string, id: any, description?: string | null, options: Array<{ __typename?: 'poll_options', id: any, is_correct: boolean, title: string }>, responses: Array<{ __typename?: 'poll_responses', selected_option: any, user_id: any, user?: { __typename?: 'supertokens_user_public_fields', role?: string | null } | null }> } | null }> };

export type GetReactionEmojisQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReactionEmojisQuery = { __typename?: 'Query', reaction_emojis: Array<{ __typename?: 'reaction_emojis', emoji: string, emoji_url: string, name: string, id: any }> };

export type SendMessageMutationVariables = Exact<{
  object: Messages_Insert_Input;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', insert_messages_one?: { __typename?: 'messages', id: any } | null };

export type GetUploadFileUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  validFileType: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
}>;


export type GetUploadFileUrlMutation = { __typename?: 'Mutation', getUploadFileUrl: { __typename?: 'UploadUrlResponse', success: boolean, message: string, uploadUrl: string, contentType: string, fileUrl: string } };

export type JoinChannelMutationVariables = Exact<{
  channelID: Scalars['uuid']['input'];
}>;


export type JoinChannelMutation = { __typename?: 'Mutation', insert_channel_members_one?: { __typename?: 'channel_members', id: any } | null };

export type IsJoinedQueryVariables = Exact<{
  channelID: Scalars['uuid']['input'];
}>;


export type IsJoinedQuery = { __typename?: 'Query', channel_members: Array<{ __typename?: 'channel_members', id: any, role: string, is_blocked: boolean }> };

export type ReportMessageMutationVariables = Exact<{
  object: Reported_Message_Insert_Input;
}>;


export type ReportMessageMutation = { __typename?: 'Mutation', insert_reported_message_one?: { __typename?: 'reported_message', id: any } | null };

export type DeleteMessageMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type PinMessageMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
}>;


export type PinMessageMutation = { __typename?: 'Mutation', pinMessage: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type ChangeRoleMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type ChangeRoleMutation = { __typename?: 'Mutation', changeRole: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type UpdateChannelStatusMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
}>;


export type UpdateChannelStatusMutation = { __typename?: 'Mutation', updateChannelStatus: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type DeleteChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type DeleteChannelMutation = { __typename?: 'Mutation', deleteChannel: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type CreateChannelMutationVariables = Exact<{
  channelName: Scalars['String']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
}>;


export type CreateChannelMutation = { __typename?: 'Mutation', createChannel: { __typename?: 'CrateChannelResponse', success: boolean, message: string, channelId: string } };

export type UpdateGroupProfileMutationVariables = Exact<{
  avatar: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;


export type UpdateGroupProfileMutation = { __typename?: 'Mutation', updateGroupProfile: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type AddReactionMutationVariables = Exact<{
  object: Message_Reactions_Insert_Input;
}>;


export type AddReactionMutation = { __typename?: 'Mutation', insert_message_reactions_one?: { __typename?: 'message_reactions', id: any } | null };

export type DeleteReactionMutationVariables = Exact<{
  messageId: Scalars['uuid']['input'];
}>;


export type DeleteReactionMutation = { __typename?: 'Mutation', delete_message_reactions?: { __typename?: 'message_reactions_mutation_response', affected_rows: number } | null };

export type VotePollMutationVariables = Exact<{
  pollId: Scalars['String']['input'];
  optionsId: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type VotePollMutation = { __typename?: 'Mutation', votePoll: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type CreatePollMutationVariables = Exact<{
  title: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  quizType?: InputMaybe<Scalars['String']['input']>;
  options: Array<PollOption> | PollOption;
  description?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
}>;


export type CreatePollMutation = { __typename?: 'Mutation', createPoll: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetChannelMembersQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetChannelMembersQuery = { __typename?: 'Query', getChannelMembers: { __typename?: 'ChannelMembersResponse', success: boolean, message?: string | null, members: Array<{ __typename?: 'ChannelMemberInfo', userId: string, role: string, name: string, avatar: string, isBlocked: boolean }> } };

export type GetChannelInfoQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type GetChannelInfoQuery = { __typename?: 'Query', getChannelInfo: { __typename?: 'ChannelInfoResponse', success: boolean, message: string, name: string, isClosed: boolean, avatar: string, category: string, totalMembers: number } };

export type LeaveChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type LeaveChannelMutation = { __typename?: 'Mutation', leaveChannel: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type BlockUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type BlockUserMutation = { __typename?: 'Mutation', blockUser: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type KickUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;


export type KickUserMutation = { __typename?: 'Mutation', kickUser: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type ReadMessageMutationVariables = Exact<{
  object: Messages_Read_Insert_Input;
}>;


export type ReadMessageMutation = { __typename?: 'Mutation', insert_messages_read_one?: { __typename?: 'messages_read', id: any } | null };

export type GetGroupCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupCategoriesQuery = { __typename?: 'Query', group_category: Array<{ __typename?: 'group_category', id: any, name: string }> };

export type GetChannelIdByGroupAndSlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  category: Scalars['String']['input'];
}>;


export type GetChannelIdByGroupAndSlugQuery = { __typename?: 'Query', channels: Array<{ __typename?: 'channels', id: any }> };

export type GetCompeteBookmarkedQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompeteBookmarkedQuestionsQuery = { __typename?: 'Query', user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', id: any, is_bookmarked: boolean, is_correct?: boolean | null, response?: string | null, time_taken: any, quiz_question: { __typename?: 'quiz_question', name: string, solution?: string | null, id: number, difficulty: string, has_paragraph: boolean, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null } | null, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }> }, user_quiz_summary: { __typename?: 'user_quiz_summaries', quiz_quiz: { __typename?: 'quiz_quiz', name: string } } }> };

export type GetDailyBookmarkedQuestionsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDailyBookmarkedQuestionsQuery = { __typename?: 'Query', user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', id: any, is_bookmarked: boolean, is_correct?: boolean | null, response?: string | null, time_taken: any, quiz_question: { __typename?: 'quiz_question', name: string, solution?: string | null, id: number, difficulty: string, has_paragraph: boolean, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null } | null, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }>, quiz_category: { __typename?: 'quiz_category', quiz_domain?: { __typename?: 'quiz_domain', name: string } | null } }, user_quiz_summary: { __typename?: 'user_quiz_summaries', quiz_quiz: { __typename?: 'quiz_quiz', name: string } } }> };

export type GetFreeSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFreeSectionQuery = { __typename?: 'Query', mock_cats: Array<{ __typename?: 'quiz_category', title: string, quiz_domain?: { __typename?: 'quiz_domain', quiz_superdomain?: { __typename?: 'quiz_superdomain', name: string } | null } | null, quiz_quizzes: Array<{ __typename?: 'quiz_quiz', id: number, name: string, slug?: string | null, total_number_of_questions?: number | null, user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', created_at: any, number_of_attempted_questions?: number | null, user_quiz_question_summaries_aggregate: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null } }> }> }>, quiz_of_the_day: Array<{ __typename?: 'quiz_category', name: string, slug: string, quiz_quizzes: Array<{ __typename?: 'quiz_quiz', name: string, id: number, slug?: string | null, total_number_of_questions?: number | null, user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', created_at: any, number_of_attempted_questions?: number | null, user_quiz_question_summaries_aggregate: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null } }> }> }>, last_practice_summary: Array<{ __typename?: 'user_quiz_summaries', created_at: any, number_of_attempted_questions?: number | null, user_quiz_question_summaries_aggregate: { __typename?: 'user_quiz_question_summaries_aggregate', aggregate?: { __typename?: 'user_quiz_question_summaries_aggregate_fields', sum?: { __typename?: 'user_quiz_question_summaries_sum_fields', marks?: any | null } | null } | null }, quiz_quiz: { __typename?: 'quiz_quiz', name: string, total_number_of_questions?: number | null } }> };

export type GetStaticPageDataQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetStaticPageDataQuery = { __typename?: 'Query', infozone_staticpages: Array<{ __typename?: 'infozone_staticpages', content?: string | null, content_markup_type: string, created_date: any, remove_menu: boolean, slug?: string | null, title: string, id: number, _content_rendered?: string | null, updated_at: any }> };

export type GetBookmarkedQuestionsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetBookmarkedQuestionsQuery = { __typename?: 'Query', user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', id: any, is_bookmarked: boolean, is_correct?: boolean | null, response?: string | null, time_taken: any, quiz_question: { __typename?: 'quiz_question', name: string, solution?: string | null, id: number, difficulty: string, has_paragraph: boolean, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null } | null, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }>, quiz_category: { __typename?: 'quiz_category', name: string, quiz_domain?: { __typename?: 'quiz_domain', name: string, quiz_superdomain?: { __typename?: 'quiz_superdomain', name: string } | null } | null } }, user_quiz_summary: { __typename?: 'user_quiz_summaries', quiz_quiz: { __typename?: 'quiz_quiz', name: string } } }> };

export type UpdateQuestionBookmarkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateQuestionBookmarkMutation = { __typename?: 'Mutation', update_user_quiz_question_summaries?: { __typename?: 'user_quiz_question_summaries_mutation_response', returning: Array<{ __typename?: 'user_quiz_question_summaries', id: any }> } | null };

export type GetSubscriptionPlanQueryVariables = Exact<{
  time: Scalars['timestamptz']['input'];
  cost: Scalars['numeric']['input'];
}>;


export type GetSubscriptionPlanQuery = { __typename?: 'Query', subscriptions_subscriptionplan: Array<{ __typename?: 'subscriptions_subscriptionplan', cost?: any | null, id: any, most_popular: boolean, slug?: string | null, plan_name: string, plan_description?: string | null, striked_price?: any | null, package_content?: { __typename?: 'packages_content', expiry_date?: any | null, is_master?: boolean | null, message?: string | null, brief?: string | null, rank?: number | null } | null, subscriptions_subscriptionplan_upgradable_plans: Array<{ __typename?: 'subscriptions_subscriptionplan_upgradable_plans', from_subscriptionplan_id: any, to_subscriptionplan_id: any }>, subscription_group_plans: Array<{ __typename?: 'subscription_group_plan', price: number, id: number, is_invisible: boolean, subscription_group_plan_groups: Array<{ __typename?: 'subscription_group_plan_groups', id: number }> }> }> };

export type GetSubscriptionGroupPlansQueryVariables = Exact<{
  date: Scalars['timestamptz']['input'];
}>;


export type GetSubscriptionGroupPlansQuery = { __typename?: 'Query', subscription_group_plan: Array<{ __typename?: 'subscription_group_plan', price: number, id: number, validity: any, plan_id: any, users_count: number, is_invisible: boolean, subscriptions_subscriptionplan: { __typename?: 'subscriptions_subscriptionplan', cost?: any | null, plan_description?: string | null, plan_name: string, striked_price?: any | null, packages_contents: Array<{ __typename?: 'packages_content', message?: string | null }> }, subscription_group_plan_groups: Array<{ __typename?: 'subscription_group_plan_groups', id: number, rank?: number | null, is_subscribed?: boolean | null, updated_at: any }> }> };

export type CheckGroupDiscountForPlanQueryVariables = Exact<{
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type CheckGroupDiscountForPlanQuery = { __typename?: 'Query', subscription_group_plan: Array<{ __typename?: 'subscription_group_plan', id: number, price: number, subscription_group_plan_groups: Array<{ __typename?: 'subscription_group_plan_groups', id: number }> }> };

export type GetPackageContentQueryVariables = Exact<{
  subscription_plan_id: Scalars['uuid']['input'];
}>;


export type GetPackageContentQuery = { __typename?: 'Query', packages_content: Array<{ __typename?: 'packages_content', expiry_date?: any | null, id: number, is_master?: boolean | null, brief?: string | null, message?: string | null, rank?: number | null, super_domain_id?: number | null }> };

export type GetGroupDiscountUsersQueryVariables = Exact<{
  group_id: Scalars['Int']['input'];
}>;


export type GetGroupDiscountUsersQuery = { __typename?: 'Query', group_discount_users: Array<{ __typename?: 'group_discount_users', updated_at?: any | null, user?: { __typename?: 'supertokens_user_additional_fields', first_name?: string | null, last_name?: string | null } | null }> };

export type SubscriptionGroupsQueryVariables = Exact<{
  date: Scalars['timestamptz']['input'];
}>;


export type SubscriptionGroupsQuery = { __typename?: 'Query', subscription_group_plan_groups: Array<{ __typename?: 'subscription_group_plan_groups', id: number, is_closed: boolean, is_subscribed?: boolean | null, subscription_group_plan: { __typename?: 'subscription_group_plan', validity: any, users_count: number, price: number, subscriptions_subscriptionplan: { __typename?: 'subscriptions_subscriptionplan', plan_name: string, striked_price?: any | null, cost?: any | null, plan_description?: string | null, id: any, package_content?: { __typename?: 'packages_content', message?: string | null } | null } } }> };

export type AllGroupDataQueryVariables = Exact<{
  plan_id: Scalars['uuid']['input'];
  group_id: Scalars['Int']['input'];
  date: Scalars['timestamptz']['input'];
}>;


export type AllGroupDataQuery = { __typename?: 'Query', subscription_group_plan: Array<{ __typename?: 'subscription_group_plan', price: number, id: number, validity: any, plan_id: any, users_count: number, is_invisible: boolean, subscription_group_plan_groups: Array<{ __typename?: 'subscription_group_plan_groups', id: number, rank?: number | null, is_subscribed?: boolean | null, updated_at: any }>, subscriptions_subscriptionplan: { __typename?: 'subscriptions_subscriptionplan', group_plan_users: Array<{ __typename?: 'group_discount_users', updated_at?: any | null, user?: { __typename?: 'supertokens_user_additional_fields', first_name?: string | null, last_name?: string | null } | null }> } }>, group_discount_users: Array<{ __typename?: 'group_discount_users', id?: number | null, user_id?: string | null }> };

export type AllPaymentDataQueryVariables = Exact<{
  plan_id: Scalars['uuid']['input'];
  date: Scalars['timestamptz']['input'];
}>;


export type AllPaymentDataQuery = { __typename?: 'Query', subscriptions_subscriptionplan: Array<{ __typename?: 'subscriptions_subscriptionplan', plan_description?: string | null, plan_name: string, cost?: any | null, striked_price?: any | null, package_content?: { __typename?: 'packages_content', message?: string | null } | null }>, supertokens_user_additional_fields: Array<{ __typename?: 'supertokens_user_additional_fields', id: number, first_name?: string | null, last_name?: string | null, avatar?: string | null, state?: string | null, city?: string | null, email?: string | null, mobile?: string | null, xp?: any | null, username?: string | null }>, coupons_coupon: Array<{ __typename?: 'coupons_coupon', code: string, id: number, coupon_for_upgrade: boolean, times_used: number, is_invisible: boolean, coupons_discount: { __typename?: 'coupons_discount', is_percentage: boolean, value: number }, coupons_ruleset: { __typename?: 'coupons_ruleset', coupons_allowedusersrule: { __typename?: 'coupons_allowedusersrule', all_users: boolean, coupons_allowed_users_rule_users: Array<{ __typename?: 'coupons_allowed_users_rule_users', user_id: string }> }, coupons_maxusesrule: { __typename?: 'coupons_maxusesrule', is_infinite: boolean, max_uses: number }, coupons_validityrule: { __typename?: 'coupons_validityrule', is_active: boolean, expiration_date: any } } }>, packages_payment_transaction: Array<{ __typename?: 'packages_payment_transaction', price: any }> };

export type InitiatePaymentMutationVariables = Exact<{
  planId: Scalars['String']['input'];
  couponId: Scalars['Int']['input'];
  groupId: Scalars['Int']['input'];
}>;


export type InitiatePaymentMutation = { __typename?: 'Mutation', initiatePayment: { __typename?: 'InitiatePaymentPayload', success: boolean, options: { __typename?: 'Options', amount: number, plan_name: string, orderId: string, receiptId: string, initial_price: number }, user: { __typename?: 'UserInfo', email: string, name: string, id: string, mobile: string } } };

export type VerifyPaymentMutationVariables = Exact<{
  razorpayPaymentID: Scalars['String']['input'];
  razorpayOrderID: Scalars['String']['input'];
  razorpaySignature: Scalars['String']['input'];
  orderID: Scalars['String']['input'];
}>;


export type VerifyPaymentMutation = { __typename?: 'Mutation', verifyPayment: boolean };

export type GetPlanIdBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPlanIdBySlugQuery = { __typename?: 'Query', subscriptions_subscriptionplan: Array<{ __typename?: 'subscriptions_subscriptionplan', id: any }> };

export type GetPracticeBookmarkedQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPracticeBookmarkedQuestionsQuery = { __typename?: 'Query', user_quiz_question_summaries: Array<{ __typename?: 'user_quiz_question_summaries', id: any, is_bookmarked: boolean, is_correct?: boolean | null, response?: string | null, time_taken: any, quiz_question: { __typename?: 'quiz_question', name: string, solution?: string | null, id: number, difficulty: string, has_paragraph: boolean, quiz_paragraph?: { __typename?: 'quiz_paragraph', comprehension?: string | null } | null, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }> }, user_quiz_summary: { __typename?: 'user_quiz_summaries', quiz_quiz: { __typename?: 'quiz_quiz', name: string } } }> };

export type GetSpeedResultQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSpeedResultQuery = { __typename?: 'Query', user_speed_tests_summaries_by_pk?: { __typename?: 'user_speed_tests_summaries', id: any, score?: number | null, test_time: number, test_type: string, test_category: string, user_speed_test_questions_summaries: Array<{ __typename?: 'user_speed_test_questions_summaries', id: any, time_taken?: number | null, response?: string | null, answer: string, is_attempted: boolean, question?: string | null, is_bookmarked: boolean, is_correct?: boolean | null, quiz_question?: { __typename?: 'quiz_question', solution?: string | null, question_type: string, videocipher_id?: string | null, id: number, options: Array<{ __typename?: 'quiz_option', name: string, id: number, is_correct: boolean }> } | null }>, correct_questions_aggregate: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null }, attempted_questions_aggregate: { __typename?: 'user_speed_test_questions_summaries_aggregate', aggregate?: { __typename?: 'user_speed_test_questions_summaries_aggregate_fields', count: number } | null } } | null };

export type GetSpeedTestHighScoreQueryVariables = Exact<{
  test_category: Scalars['String']['input'];
  test_type: Scalars['String']['input'];
}>;


export type GetSpeedTestHighScoreQuery = { __typename?: 'Query', user_speed_tests_summaries: Array<{ __typename?: 'user_speed_tests_summaries', score?: number | null }> };

export type GetUserXpTransactionQueryVariables = Exact<{
  type: Xp_Transaction_Types_Enum;
}>;


export type GetUserXpTransactionQuery = { __typename?: 'Query', user_xp_transactions_aggregate: { __typename?: 'user_xp_transactions_aggregate', aggregate?: { __typename?: 'user_xp_transactions_aggregate_fields', sum?: { __typename?: 'user_xp_transactions_sum_fields', xp?: any | null } | null } | null } };

export type UpdateBookmarkForQuestionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  is_bookmarked: Scalars['Boolean']['input'];
}>;


export type UpdateBookmarkForQuestionMutation = { __typename?: 'Mutation', update_user_speed_test_questions_summaries?: { __typename?: 'user_speed_test_questions_summaries_mutation_response', returning: Array<{ __typename?: 'user_speed_test_questions_summaries', id: any }> } | null };

export type GetUserTotalSpeedXpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTotalSpeedXpQuery = { __typename?: 'Query', user_xp_transactions_aggregate: { __typename?: 'user_xp_transactions_aggregate', aggregate?: { __typename?: 'user_xp_transactions_aggregate_fields', sum?: { __typename?: 'user_xp_transactions_sum_fields', xp?: any | null } | null } | null } };

export type GetLastSpeedXpEarnedSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetLastSpeedXpEarnedSubscription = { __typename?: 'Subscription', user_speed_tests_summaries: Array<{ __typename?: 'user_speed_tests_summaries', xp?: any | null }> };

export type GetCompeteQuizDataQueryVariables = Exact<{
  quizSlug: Scalars['String']['input'];
}>;


export type GetCompeteQuizDataQuery = { __typename?: 'Query', getTimedTestDetails: string };

export type SaveTimedTestResponseMutationVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type SaveTimedTestResponseMutation = { __typename?: 'Mutation', saveTimedTestResponse: { __typename?: 'GenericResponse', success: boolean, message?: string | null } };

export type GetQuizSummaryQueryVariables = Exact<{
  quiz_id: Scalars['Int']['input'];
}>;


export type GetQuizSummaryQuery = { __typename?: 'Query', user_quiz_summaries: Array<{ __typename?: 'user_quiz_summaries', id: any }> };

export const DailyResultQuestionDetailsFragmentDoc = gql`
    fragment DailyResultQuestionDetails on quiz_question {
  id
  name
  solution
  id
  question_type
  difficulty
  quiz_paragraph {
    comprehension
  }
  has_paragraph
  options {
    name
    id
    is_correct
  }
}
    `;
export const Learn__UserLearnSummariesFragmentDoc = gql`
    fragment Learn__UserLearnSummaries on user_learn_modules_summary {
  id
  is_bookmarked
  time_spent
}
    `;
export const CreateUserDocument = gql`
    mutation CreateUser($email: String!, $firstName: String, $lastName: String, $username: String, $mobile: String, $utmSource: String, $state: String, $city: String, $avatar: String, $mobileVerified: Boolean, $emailVerified: Boolean, $isVisualImpairment: Boolean) {
  createUser(
    email: $email
    firstName: $firstName
    lastName: $lastName
    username: $username
    utmSource: $utmSource
    mobile: $mobile
    state: $state
    city: $city
    avatar: $avatar
    mobileVerified: $mobileVerified
    emailVerified: $emailVerified
    isVisualImpairment: $isVisualImpairment
  ) {
    message
    success
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      username: // value for 'username'
 *      mobile: // value for 'mobile'
 *      utmSource: // value for 'utmSource'
 *      state: // value for 'state'
 *      city: // value for 'city'
 *      avatar: // value for 'avatar'
 *      mobileVerified: // value for 'mobileVerified'
 *      emailVerified: // value for 'emailVerified'
 *      isVisualImpairment: // value for 'isVisualImpairment'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($oldPassword: String!, $newPassword: String!) {
  resetPassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    message
    success
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email) {
    success
    message
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    success
    message
    role
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const ReportQuestionDocument = gql`
    mutation ReportQuestion($explanation: String!, $question_id: Int!) {
  insert_question_reports_one(
    object: {explanation: $explanation, question_id: $question_id}
  ) {
    id
  }
}
    `;
export type ReportQuestionMutationFn = Apollo.MutationFunction<ReportQuestionMutation, ReportQuestionMutationVariables>;

/**
 * __useReportQuestionMutation__
 *
 * To run a mutation, you first call `useReportQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportQuestionMutation, { data, loading, error }] = useReportQuestionMutation({
 *   variables: {
 *      explanation: // value for 'explanation'
 *      question_id: // value for 'question_id'
 *   },
 * });
 */
export function useReportQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ReportQuestionMutation, ReportQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportQuestionMutation, ReportQuestionMutationVariables>(ReportQuestionDocument, options);
      }
export type ReportQuestionMutationHookResult = ReturnType<typeof useReportQuestionMutation>;
export type ReportQuestionMutationResult = Apollo.MutationResult<ReportQuestionMutation>;
export type ReportQuestionMutationOptions = Apollo.BaseMutationOptions<ReportQuestionMutation, ReportQuestionMutationVariables>;
export const GetAdContentDocument = gql`
    query getAdContent($type: String!) {
  advertisements(
    where: {type: {_eq: $type}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    plan_title
    title
    list_of_features
    advertisements_subscriptions_subscriptionplan {
      striked_price
      cost
    }
  }
}
    `;

/**
 * __useGetAdContentQuery__
 *
 * To run a query within a React component, call `useGetAdContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdContentQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAdContentQuery(baseOptions: Apollo.QueryHookOptions<GetAdContentQuery, GetAdContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdContentQuery, GetAdContentQueryVariables>(GetAdContentDocument, options);
      }
export function useGetAdContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdContentQuery, GetAdContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdContentQuery, GetAdContentQueryVariables>(GetAdContentDocument, options);
        }
export type GetAdContentQueryHookResult = ReturnType<typeof useGetAdContentQuery>;
export type GetAdContentLazyQueryHookResult = ReturnType<typeof useGetAdContentLazyQuery>;
export type GetAdContentQueryResult = Apollo.QueryResult<GetAdContentQuery, GetAdContentQueryVariables>;
export const UpdateUserDetailsDocument = gql`
    mutation UpdateUserDetails($set: supertokens_user_additional_fields_set_input!) {
  update_supertokens_user_additional_fields(_set: $set, where: {}) {
    affected_rows
  }
}
    `;
export type UpdateUserDetailsMutationFn = Apollo.MutationFunction<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;

/**
 * __useUpdateUserDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsMutation, { data, loading, error }] = useUpdateUserDetailsMutation({
 *   variables: {
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>(UpdateUserDetailsDocument, options);
      }
export type UpdateUserDetailsMutationHookResult = ReturnType<typeof useUpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationResult = Apollo.MutationResult<UpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;
export const SendVerificationOtpDocument = gql`
    mutation SendVerificationOtp($number: String!, $name: String!) {
  sendVerificationOtp(number: $number, name: $name) {
    message
    success
  }
}
    `;
export type SendVerificationOtpMutationFn = Apollo.MutationFunction<SendVerificationOtpMutation, SendVerificationOtpMutationVariables>;

/**
 * __useSendVerificationOtpMutation__
 *
 * To run a mutation, you first call `useSendVerificationOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationOtpMutation, { data, loading, error }] = useSendVerificationOtpMutation({
 *   variables: {
 *      number: // value for 'number'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSendVerificationOtpMutation(baseOptions?: Apollo.MutationHookOptions<SendVerificationOtpMutation, SendVerificationOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVerificationOtpMutation, SendVerificationOtpMutationVariables>(SendVerificationOtpDocument, options);
      }
export type SendVerificationOtpMutationHookResult = ReturnType<typeof useSendVerificationOtpMutation>;
export type SendVerificationOtpMutationResult = Apollo.MutationResult<SendVerificationOtpMutation>;
export type SendVerificationOtpMutationOptions = Apollo.BaseMutationOptions<SendVerificationOtpMutation, SendVerificationOtpMutationVariables>;
export const VerifyOtpDocument = gql`
    mutation verifyOtp($otp: String!, $mobile: String!) {
  verifyOtp(otp: $otp, mobile: $mobile) {
    message
    success
  }
}
    `;
export type VerifyOtpMutationFn = Apollo.MutationFunction<VerifyOtpMutation, VerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *      mobile: // value for 'mobile'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOtpMutation, VerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const SignUpDocument = gql`
    mutation signUp($firstName: String!, $lastName: String!, $username: String!, $mobile: String!, $email: String!, $password: String!, $state: String!, $city: String!, $utmSource: String, $utmMedium: String, $utmCampaign: String, $utmContent: String, $deviceType: String) {
  signUp(
    firstName: $firstName
    lastName: $lastName
    username: $username
    mobile: $mobile
    email: $email
    password: $password
    state: $state
    city: $city
    utmSource: $utmSource
    utmMedium: $utmMedium
    utmCampaign: $utmCampaign
    utmContent: $utmContent
    deviceType: $deviceType
  ) {
    success
    message
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      username: // value for 'username'
 *      mobile: // value for 'mobile'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      state: // value for 'state'
 *      city: // value for 'city'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      utmContent: // value for 'utmContent'
 *      deviceType: // value for 'deviceType'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const Question__GetVideoOtpDocument = gql`
    query Question__GetVideoOtp($id: String!) {
  getVideoOTPForQuestion(id: $id) {
    otp
    playbackInfo
  }
}
    `;

/**
 * __useQuestion__GetVideoOtpQuery__
 *
 * To run a query within a React component, call `useQuestion__GetVideoOtpQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestion__GetVideoOtpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestion__GetVideoOtpQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuestion__GetVideoOtpQuery(baseOptions: Apollo.QueryHookOptions<Question__GetVideoOtpQuery, Question__GetVideoOtpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Question__GetVideoOtpQuery, Question__GetVideoOtpQueryVariables>(Question__GetVideoOtpDocument, options);
      }
export function useQuestion__GetVideoOtpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Question__GetVideoOtpQuery, Question__GetVideoOtpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Question__GetVideoOtpQuery, Question__GetVideoOtpQueryVariables>(Question__GetVideoOtpDocument, options);
        }
export type Question__GetVideoOtpQueryHookResult = ReturnType<typeof useQuestion__GetVideoOtpQuery>;
export type Question__GetVideoOtpLazyQueryHookResult = ReturnType<typeof useQuestion__GetVideoOtpLazyQuery>;
export type Question__GetVideoOtpQueryResult = Apollo.QueryResult<Question__GetVideoOtpQuery, Question__GetVideoOtpQueryVariables>;
export const GoogleLoginDocument = gql`
    query googleLogin {
  googleLogin {
    success
    message
  }
}
    `;

/**
 * __useGoogleLoginQuery__
 *
 * To run a query within a React component, call `useGoogleLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoogleLoginQuery(baseOptions?: Apollo.QueryHookOptions<GoogleLoginQuery, GoogleLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleLoginQuery, GoogleLoginQueryVariables>(GoogleLoginDocument, options);
      }
export function useGoogleLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleLoginQuery, GoogleLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleLoginQuery, GoogleLoginQueryVariables>(GoogleLoginDocument, options);
        }
export type GoogleLoginQueryHookResult = ReturnType<typeof useGoogleLoginQuery>;
export type GoogleLoginLazyQueryHookResult = ReturnType<typeof useGoogleLoginLazyQuery>;
export type GoogleLoginQueryResult = Apollo.QueryResult<GoogleLoginQuery, GoogleLoginQueryVariables>;
export const GetCatResponseDataDocument = gql`
    query getCatResponseData($id: uuid!) {
  user_cat_response_sheet_data_by_pk(id: $id) {
    application_no
  }
}
    `;

/**
 * __useGetCatResponseDataQuery__
 *
 * To run a query within a React component, call `useGetCatResponseDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatResponseDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatResponseDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatResponseDataQuery(baseOptions: Apollo.QueryHookOptions<GetCatResponseDataQuery, GetCatResponseDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatResponseDataQuery, GetCatResponseDataQueryVariables>(GetCatResponseDataDocument, options);
      }
export function useGetCatResponseDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatResponseDataQuery, GetCatResponseDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatResponseDataQuery, GetCatResponseDataQueryVariables>(GetCatResponseDataDocument, options);
        }
export type GetCatResponseDataQueryHookResult = ReturnType<typeof useGetCatResponseDataQuery>;
export type GetCatResponseDataLazyQueryHookResult = ReturnType<typeof useGetCatResponseDataLazyQuery>;
export type GetCatResponseDataQueryResult = Apollo.QueryResult<GetCatResponseDataQuery, GetCatResponseDataQueryVariables>;
export const GetCatApplicationDataDocument = gql`
    query getCatApplicationData($id: String!) {
  getCatApplicationData(applicationId: $id) {
    success
    message
    data
  }
}
    `;

/**
 * __useGetCatApplicationDataQuery__
 *
 * To run a query within a React component, call `useGetCatApplicationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatApplicationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatApplicationDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatApplicationDataQuery(baseOptions: Apollo.QueryHookOptions<GetCatApplicationDataQuery, GetCatApplicationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatApplicationDataQuery, GetCatApplicationDataQueryVariables>(GetCatApplicationDataDocument, options);
      }
export function useGetCatApplicationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatApplicationDataQuery, GetCatApplicationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatApplicationDataQuery, GetCatApplicationDataQueryVariables>(GetCatApplicationDataDocument, options);
        }
export type GetCatApplicationDataQueryHookResult = ReturnType<typeof useGetCatApplicationDataQuery>;
export type GetCatApplicationDataLazyQueryHookResult = ReturnType<typeof useGetCatApplicationDataLazyQuery>;
export type GetCatApplicationDataQueryResult = Apollo.QueryResult<GetCatApplicationDataQuery, GetCatApplicationDataQueryVariables>;
export const GetUserAdditionalDataDocument = gql`
    query GetUserAdditionalData {
  supertokens_user_additional_fields(limit: 1) {
    avatar
    city
    email
    first_name
    last_name
    mobile
    state
    user_id
    username
    postal_code
    country
    date_of_birth
    age
    gender
    xp
    is_visually_impaired
    emailVerified {
      user_id
    }
    role
    mobile_verified
    email_verified
    thirdparty_users {
      user_id
    }
  }
}
    `;

/**
 * __useGetUserAdditionalDataQuery__
 *
 * To run a query within a React component, call `useGetUserAdditionalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAdditionalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAdditionalDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAdditionalDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAdditionalDataQuery, GetUserAdditionalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAdditionalDataQuery, GetUserAdditionalDataQueryVariables>(GetUserAdditionalDataDocument, options);
      }
export function useGetUserAdditionalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAdditionalDataQuery, GetUserAdditionalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAdditionalDataQuery, GetUserAdditionalDataQueryVariables>(GetUserAdditionalDataDocument, options);
        }
export type GetUserAdditionalDataQueryHookResult = ReturnType<typeof useGetUserAdditionalDataQuery>;
export type GetUserAdditionalDataLazyQueryHookResult = ReturnType<typeof useGetUserAdditionalDataLazyQuery>;
export type GetUserAdditionalDataQueryResult = Apollo.QueryResult<GetUserAdditionalDataQuery, GetUserAdditionalDataQueryVariables>;
export const GetUserXpTransactionSummariesDocument = gql`
    subscription getUserXpTransactionSummaries {
  user_xp_transaction_summaries {
    xp
  }
}
    `;

/**
 * __useGetUserXpTransactionSummariesSubscription__
 *
 * To run a query within a React component, call `useGetUserXpTransactionSummariesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUserXpTransactionSummariesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserXpTransactionSummariesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetUserXpTransactionSummariesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetUserXpTransactionSummariesSubscription, GetUserXpTransactionSummariesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetUserXpTransactionSummariesSubscription, GetUserXpTransactionSummariesSubscriptionVariables>(GetUserXpTransactionSummariesDocument, options);
      }
export type GetUserXpTransactionSummariesSubscriptionHookResult = ReturnType<typeof useGetUserXpTransactionSummariesSubscription>;
export type GetUserXpTransactionSummariesSubscriptionResult = Apollo.SubscriptionResult<GetUserXpTransactionSummariesSubscription>;
export const LogoutDocument = gql`
    query logout {
  logout {
    success
    message
  }
}
    `;

/**
 * __useLogoutQuery__
 *
 * To run a query within a React component, call `useLogoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useLogoutQuery(baseOptions?: Apollo.QueryHookOptions<LogoutQuery, LogoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
      }
export function useLogoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogoutQuery, LogoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
        }
export type LogoutQueryHookResult = ReturnType<typeof useLogoutQuery>;
export type LogoutLazyQueryHookResult = ReturnType<typeof useLogoutLazyQuery>;
export type LogoutQueryResult = Apollo.QueryResult<LogoutQuery, LogoutQueryVariables>;
export const UpdateLastActiveDocument = gql`
    query updateLastActive {
  updateLastActive {
    success
    message
  }
}
    `;

/**
 * __useUpdateLastActiveQuery__
 *
 * To run a query within a React component, call `useUpdateLastActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateLastActiveQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateLastActiveQuery(baseOptions?: Apollo.QueryHookOptions<UpdateLastActiveQuery, UpdateLastActiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateLastActiveQuery, UpdateLastActiveQueryVariables>(UpdateLastActiveDocument, options);
      }
export function useUpdateLastActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateLastActiveQuery, UpdateLastActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateLastActiveQuery, UpdateLastActiveQueryVariables>(UpdateLastActiveDocument, options);
        }
export type UpdateLastActiveQueryHookResult = ReturnType<typeof useUpdateLastActiveQuery>;
export type UpdateLastActiveLazyQueryHookResult = ReturnType<typeof useUpdateLastActiveLazyQuery>;
export type UpdateLastActiveQueryResult = Apollo.QueryResult<UpdateLastActiveQuery, UpdateLastActiveQueryVariables>;
export const ValidateSessionDocument = gql`
    query validateSession {
  validateSession {
    success
    message
  }
}
    `;

/**
 * __useValidateSessionQuery__
 *
 * To run a query within a React component, call `useValidateSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidateSessionQuery(baseOptions?: Apollo.QueryHookOptions<ValidateSessionQuery, ValidateSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateSessionQuery, ValidateSessionQueryVariables>(ValidateSessionDocument, options);
      }
export function useValidateSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateSessionQuery, ValidateSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateSessionQuery, ValidateSessionQueryVariables>(ValidateSessionDocument, options);
        }
export type ValidateSessionQueryHookResult = ReturnType<typeof useValidateSessionQuery>;
export type ValidateSessionLazyQueryHookResult = ReturnType<typeof useValidateSessionLazyQuery>;
export type ValidateSessionQueryResult = Apollo.QueryResult<ValidateSessionQuery, ValidateSessionQueryVariables>;
export const GetPurchasedPlanDocument = gql`
    query getPurchasedPlan {
  packages_payment_transaction(
    where: {payment: {_eq: true}}
    order_by: {updated_at: desc}
    limit: 1
  ) {
    price
    id
    gst
    initial_price
    group_id
    subscriptions_subscriptionplan {
      plan_name
      id
      striked_price
      plan_description
      cost
      is_a_top_pack
      most_popular
      plan_description
      unlimited_speed_quant
      unlimited_speed_verbal
      unlimited_speed_concept
      package_content {
        expiry_date
        message
        disable_live_classes
      }
      id
      subscriptions_subscriptionplan_upgradable_plans {
        id
        to_subscriptionplan_id
      }
    }
  }
}
    `;

/**
 * __useGetPurchasedPlanQuery__
 *
 * To run a query within a React component, call `useGetPurchasedPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchasedPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchasedPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPurchasedPlanQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchasedPlanQuery, GetPurchasedPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchasedPlanQuery, GetPurchasedPlanQueryVariables>(GetPurchasedPlanDocument, options);
      }
export function useGetPurchasedPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchasedPlanQuery, GetPurchasedPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchasedPlanQuery, GetPurchasedPlanQueryVariables>(GetPurchasedPlanDocument, options);
        }
export type GetPurchasedPlanQueryHookResult = ReturnType<typeof useGetPurchasedPlanQuery>;
export type GetPurchasedPlanLazyQueryHookResult = ReturnType<typeof useGetPurchasedPlanLazyQuery>;
export type GetPurchasedPlanQueryResult = Apollo.QueryResult<GetPurchasedPlanQuery, GetPurchasedPlanQueryVariables>;
export const GetRandomQuestionDocument = gql`
    query getRandomQuestion($quizId: Int!) {
  get_random_question(args: {quiz_id_from_args: $quizId}) {
    question_id
    quiz_question {
      name
      question_type
      options {
        is_correct
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRandomQuestionQuery__
 *
 * To run a query within a React component, call `useGetRandomQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRandomQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRandomQuestionQuery({
 *   variables: {
 *      quizId: // value for 'quizId'
 *   },
 * });
 */
export function useGetRandomQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetRandomQuestionQuery, GetRandomQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRandomQuestionQuery, GetRandomQuestionQueryVariables>(GetRandomQuestionDocument, options);
      }
export function useGetRandomQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRandomQuestionQuery, GetRandomQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRandomQuestionQuery, GetRandomQuestionQueryVariables>(GetRandomQuestionDocument, options);
        }
export type GetRandomQuestionQueryHookResult = ReturnType<typeof useGetRandomQuestionQuery>;
export type GetRandomQuestionLazyQueryHookResult = ReturnType<typeof useGetRandomQuestionLazyQuery>;
export type GetRandomQuestionQueryResult = Apollo.QueryResult<GetRandomQuestionQuery, GetRandomQuestionQueryVariables>;
export const AddUserActivityDataDocument = gql`
    mutation AddUserActivityData($object: user_activities_insert_input!, $constraint: user_activities_constraint!) {
  insert_user_activities_one(
    object: $object
    on_conflict: {constraint: $constraint, update_columns: [updated_at]}
  ) {
    id
  }
}
    `;
export type AddUserActivityDataMutationFn = Apollo.MutationFunction<AddUserActivityDataMutation, AddUserActivityDataMutationVariables>;

/**
 * __useAddUserActivityDataMutation__
 *
 * To run a mutation, you first call `useAddUserActivityDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserActivityDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserActivityDataMutation, { data, loading, error }] = useAddUserActivityDataMutation({
 *   variables: {
 *      object: // value for 'object'
 *      constraint: // value for 'constraint'
 *   },
 * });
 */
export function useAddUserActivityDataMutation(baseOptions?: Apollo.MutationHookOptions<AddUserActivityDataMutation, AddUserActivityDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserActivityDataMutation, AddUserActivityDataMutationVariables>(AddUserActivityDataDocument, options);
      }
export type AddUserActivityDataMutationHookResult = ReturnType<typeof useAddUserActivityDataMutation>;
export type AddUserActivityDataMutationResult = Apollo.MutationResult<AddUserActivityDataMutation>;
export type AddUserActivityDataMutationOptions = Apollo.BaseMutationOptions<AddUserActivityDataMutation, AddUserActivityDataMutationVariables>;
export const SendOfflineLeadOtpDocument = gql`
    mutation SendOfflineLeadOtp($number: String!) {
  sendOfflineLeadOtp(number: $number) {
    message
    success
  }
}
    `;
export type SendOfflineLeadOtpMutationFn = Apollo.MutationFunction<SendOfflineLeadOtpMutation, SendOfflineLeadOtpMutationVariables>;

/**
 * __useSendOfflineLeadOtpMutation__
 *
 * To run a mutation, you first call `useSendOfflineLeadOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOfflineLeadOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOfflineLeadOtpMutation, { data, loading, error }] = useSendOfflineLeadOtpMutation({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useSendOfflineLeadOtpMutation(baseOptions?: Apollo.MutationHookOptions<SendOfflineLeadOtpMutation, SendOfflineLeadOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOfflineLeadOtpMutation, SendOfflineLeadOtpMutationVariables>(SendOfflineLeadOtpDocument, options);
      }
export type SendOfflineLeadOtpMutationHookResult = ReturnType<typeof useSendOfflineLeadOtpMutation>;
export type SendOfflineLeadOtpMutationResult = Apollo.MutationResult<SendOfflineLeadOtpMutation>;
export type SendOfflineLeadOtpMutationOptions = Apollo.BaseMutationOptions<SendOfflineLeadOtpMutation, SendOfflineLeadOtpMutationVariables>;
export const VerifyOfflineLeadOtpDocument = gql`
    mutation VerifyOfflineLeadOtp($otp: String!, $mobile: String!) {
  verifyOfflineLeadOtp(otp: $otp, mobile: $mobile) {
    message
    success
  }
}
    `;
export type VerifyOfflineLeadOtpMutationFn = Apollo.MutationFunction<VerifyOfflineLeadOtpMutation, VerifyOfflineLeadOtpMutationVariables>;

/**
 * __useVerifyOfflineLeadOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOfflineLeadOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOfflineLeadOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOfflineLeadOtpMutation, { data, loading, error }] = useVerifyOfflineLeadOtpMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *      mobile: // value for 'mobile'
 *   },
 * });
 */
export function useVerifyOfflineLeadOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOfflineLeadOtpMutation, VerifyOfflineLeadOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOfflineLeadOtpMutation, VerifyOfflineLeadOtpMutationVariables>(VerifyOfflineLeadOtpDocument, options);
      }
export type VerifyOfflineLeadOtpMutationHookResult = ReturnType<typeof useVerifyOfflineLeadOtpMutation>;
export type VerifyOfflineLeadOtpMutationResult = Apollo.MutationResult<VerifyOfflineLeadOtpMutation>;
export type VerifyOfflineLeadOtpMutationOptions = Apollo.BaseMutationOptions<VerifyOfflineLeadOtpMutation, VerifyOfflineLeadOtpMutationVariables>;
export const UpdateLeadInfoDocument = gql`
    mutation updateLeadInfo($id: String!, $state: String!, $name: String!) {
  update_offline_leads(
    where: {mobile: {_eq: $id}}
    _set: {state: $state, name: $name}
  ) {
    affected_rows
  }
}
    `;
export type UpdateLeadInfoMutationFn = Apollo.MutationFunction<UpdateLeadInfoMutation, UpdateLeadInfoMutationVariables>;

/**
 * __useUpdateLeadInfoMutation__
 *
 * To run a mutation, you first call `useUpdateLeadInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadInfoMutation, { data, loading, error }] = useUpdateLeadInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateLeadInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadInfoMutation, UpdateLeadInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadInfoMutation, UpdateLeadInfoMutationVariables>(UpdateLeadInfoDocument, options);
      }
export type UpdateLeadInfoMutationHookResult = ReturnType<typeof useUpdateLeadInfoMutation>;
export type UpdateLeadInfoMutationResult = Apollo.MutationResult<UpdateLeadInfoMutation>;
export type UpdateLeadInfoMutationOptions = Apollo.BaseMutationOptions<UpdateLeadInfoMutation, UpdateLeadInfoMutationVariables>;
export const GetCompeteLeaderBoardScoreDocument = gql`
    query getCompeteLeaderBoardScore {
  user_leaderboards(where: {category: {_eq: "compete"}}) {
    score
    sub_type
    type
    user {
      user_id
      username
    }
  }
}
    `;

/**
 * __useGetCompeteLeaderBoardScoreQuery__
 *
 * To run a query within a React component, call `useGetCompeteLeaderBoardScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompeteLeaderBoardScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompeteLeaderBoardScoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompeteLeaderBoardScoreQuery(baseOptions?: Apollo.QueryHookOptions<GetCompeteLeaderBoardScoreQuery, GetCompeteLeaderBoardScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompeteLeaderBoardScoreQuery, GetCompeteLeaderBoardScoreQueryVariables>(GetCompeteLeaderBoardScoreDocument, options);
      }
export function useGetCompeteLeaderBoardScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompeteLeaderBoardScoreQuery, GetCompeteLeaderBoardScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompeteLeaderBoardScoreQuery, GetCompeteLeaderBoardScoreQueryVariables>(GetCompeteLeaderBoardScoreDocument, options);
        }
export type GetCompeteLeaderBoardScoreQueryHookResult = ReturnType<typeof useGetCompeteLeaderBoardScoreQuery>;
export type GetCompeteLeaderBoardScoreLazyQueryHookResult = ReturnType<typeof useGetCompeteLeaderBoardScoreLazyQuery>;
export type GetCompeteLeaderBoardScoreQueryResult = Apollo.QueryResult<GetCompeteLeaderBoardScoreQuery, GetCompeteLeaderBoardScoreQueryVariables>;
export const GetQuestionAnalysisDocument = gql`
    query getQuestionAnalysis($name: String!, $id: uuid!) {
  user_quiz_question_summaries(
    where: {quiz_question: {quiz_section_questions: {quiz_section: {name: {_eq: $name}}}}, user_quiz_summary: {id: {_eq: $id}}}
  ) {
    is_correct
    user_quiz_summary {
      quiz_quiz {
        total_number_of_questions
      }
    }
    response
    quiz_question {
      difficulty
    }
  }
}
    `;

/**
 * __useGetQuestionAnalysisQuery__
 *
 * To run a query within a React component, call `useGetQuestionAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionAnalysisQuery({
 *   variables: {
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuestionAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionAnalysisQuery, GetQuestionAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionAnalysisQuery, GetQuestionAnalysisQueryVariables>(GetQuestionAnalysisDocument, options);
      }
export function useGetQuestionAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionAnalysisQuery, GetQuestionAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionAnalysisQuery, GetQuestionAnalysisQueryVariables>(GetQuestionAnalysisDocument, options);
        }
export type GetQuestionAnalysisQueryHookResult = ReturnType<typeof useGetQuestionAnalysisQuery>;
export type GetQuestionAnalysisLazyQueryHookResult = ReturnType<typeof useGetQuestionAnalysisLazyQuery>;
export type GetQuestionAnalysisQueryResult = Apollo.QueryResult<GetQuestionAnalysisQuery, GetQuestionAnalysisQueryVariables>;
export const GetDifficultyAnalysisDocument = gql`
    query getDifficultyAnalysis($name: String!, $id: uuid!) {
  easy: user_quiz_question_summaries(
    where: {quiz_question: {quiz_section_questions: {quiz_section: {name: {_eq: $name}}}, difficulty: {_ilike: "easy"}}, user_quiz_summary: {id: {_eq: $id}}}
  ) {
    is_correct
    user_quiz_summary {
      quiz_quiz {
        total_number_of_questions
      }
    }
    response
    quiz_question {
      difficulty
    }
  }
  medium: user_quiz_question_summaries(
    where: {quiz_question: {quiz_section_questions: {quiz_section: {name: {_eq: $name}}}, difficulty: {_ilike: "medium"}}, user_quiz_summary: {id: {_eq: $id}}}
  ) {
    is_correct
    user_quiz_summary {
      quiz_quiz {
        total_number_of_questions
      }
    }
    response
    quiz_question {
      difficulty
    }
  }
  hard: user_quiz_question_summaries(
    where: {quiz_question: {quiz_section_questions: {quiz_section: {name: {_eq: $name}}}, difficulty: {_ilike: "hard"}}, user_quiz_summary: {id: {_eq: $id}}}
  ) {
    is_correct
    user_quiz_summary {
      quiz_quiz {
        total_number_of_questions
      }
    }
    response
    quiz_question {
      difficulty
    }
  }
}
    `;

/**
 * __useGetDifficultyAnalysisQuery__
 *
 * To run a query within a React component, call `useGetDifficultyAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDifficultyAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDifficultyAnalysisQuery({
 *   variables: {
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDifficultyAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetDifficultyAnalysisQuery, GetDifficultyAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDifficultyAnalysisQuery, GetDifficultyAnalysisQueryVariables>(GetDifficultyAnalysisDocument, options);
      }
export function useGetDifficultyAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDifficultyAnalysisQuery, GetDifficultyAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDifficultyAnalysisQuery, GetDifficultyAnalysisQueryVariables>(GetDifficultyAnalysisDocument, options);
        }
export type GetDifficultyAnalysisQueryHookResult = ReturnType<typeof useGetDifficultyAnalysisQuery>;
export type GetDifficultyAnalysisLazyQueryHookResult = ReturnType<typeof useGetDifficultyAnalysisLazyQuery>;
export type GetDifficultyAnalysisQueryResult = Apollo.QueryResult<GetDifficultyAnalysisQuery, GetDifficultyAnalysisQueryVariables>;
export const Compete__GetDomainsDocument = gql`
    query Compete__GetDomains($slug: String!, $_or: [quiz_quiz_bool_exp!]!) {
  quiz_category(
    where: {quiz_domain: {slug: {_eq: $slug}}, draft: {_eq: false}}
    order_by: {rank: asc}
  ) {
    name
    quiz_quizzes(
      order_by: {rank: asc}
      where: {draft: {_eq: false}, _or: $_or, is_hidden: {_eq: false}}
    ) {
      slug
      id
      name
      minimum_users
      time_limit
      isPremium: is_premium
      visually_impaired_time_duration
      has_access
      available_on
      user_quiz_summaries(order_by: {created_at: desc}) {
        id
        number_of_users_completed
        current_position
        is_completed
        percentile
        did_accept_instruction
        current_question
        user_quiz_question_summaries_aggregate {
          aggregate {
            count
            sum {
              marks
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCompete__GetDomainsQuery__
 *
 * To run a query within a React component, call `useCompete__GetDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompete__GetDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompete__GetDomainsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      _or: // value for '_or'
 *   },
 * });
 */
export function useCompete__GetDomainsQuery(baseOptions: Apollo.QueryHookOptions<Compete__GetDomainsQuery, Compete__GetDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Compete__GetDomainsQuery, Compete__GetDomainsQueryVariables>(Compete__GetDomainsDocument, options);
      }
export function useCompete__GetDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Compete__GetDomainsQuery, Compete__GetDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Compete__GetDomainsQuery, Compete__GetDomainsQueryVariables>(Compete__GetDomainsDocument, options);
        }
export type Compete__GetDomainsQueryHookResult = ReturnType<typeof useCompete__GetDomainsQuery>;
export type Compete__GetDomainsLazyQueryHookResult = ReturnType<typeof useCompete__GetDomainsLazyQuery>;
export type Compete__GetDomainsQueryResult = Apollo.QueryResult<Compete__GetDomainsQuery, Compete__GetDomainsQueryVariables>;
export const GetCompeteQuizInstructionsDocument = gql`
    query GetCompeteQuizInstructions($slug: String) {
  quiz_quiz(where: {slug: {_eq: $slug}}) {
    slug
    instructions2
    instructions1
    time_limit
    name
    meta_title
    meta_description
    meta_keyword
    user_quiz_summaries(order_by: {created_at: desc}) {
      id
      did_accept_instruction
    }
  }
}
    `;

/**
 * __useGetCompeteQuizInstructionsQuery__
 *
 * To run a query within a React component, call `useGetCompeteQuizInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompeteQuizInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompeteQuizInstructionsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCompeteQuizInstructionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompeteQuizInstructionsQuery, GetCompeteQuizInstructionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompeteQuizInstructionsQuery, GetCompeteQuizInstructionsQueryVariables>(GetCompeteQuizInstructionsDocument, options);
      }
export function useGetCompeteQuizInstructionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompeteQuizInstructionsQuery, GetCompeteQuizInstructionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompeteQuizInstructionsQuery, GetCompeteQuizInstructionsQueryVariables>(GetCompeteQuizInstructionsDocument, options);
        }
export type GetCompeteQuizInstructionsQueryHookResult = ReturnType<typeof useGetCompeteQuizInstructionsQuery>;
export type GetCompeteQuizInstructionsLazyQueryHookResult = ReturnType<typeof useGetCompeteQuizInstructionsLazyQuery>;
export type GetCompeteQuizInstructionsQueryResult = Apollo.QueryResult<GetCompeteQuizInstructionsQuery, GetCompeteQuizInstructionsQueryVariables>;
export const AcceptCompeteQuizTermsConditionsAndInstructionsDocument = gql`
    mutation AcceptCompeteQuizTermsConditionsAndInstructions($user_quiz_summary_id: uuid!) {
  update_user_quiz_summaries_by_pk(
    pk_columns: {id: $user_quiz_summary_id}
    _set: {did_accept_terms_and_conditions: true, did_accept_instruction: true}
  ) {
    id
  }
}
    `;
export type AcceptCompeteQuizTermsConditionsAndInstructionsMutationFn = Apollo.MutationFunction<AcceptCompeteQuizTermsConditionsAndInstructionsMutation, AcceptCompeteQuizTermsConditionsAndInstructionsMutationVariables>;

/**
 * __useAcceptCompeteQuizTermsConditionsAndInstructionsMutation__
 *
 * To run a mutation, you first call `useAcceptCompeteQuizTermsConditionsAndInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCompeteQuizTermsConditionsAndInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCompeteQuizTermsConditionsAndInstructionsMutation, { data, loading, error }] = useAcceptCompeteQuizTermsConditionsAndInstructionsMutation({
 *   variables: {
 *      user_quiz_summary_id: // value for 'user_quiz_summary_id'
 *   },
 * });
 */
export function useAcceptCompeteQuizTermsConditionsAndInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCompeteQuizTermsConditionsAndInstructionsMutation, AcceptCompeteQuizTermsConditionsAndInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCompeteQuizTermsConditionsAndInstructionsMutation, AcceptCompeteQuizTermsConditionsAndInstructionsMutationVariables>(AcceptCompeteQuizTermsConditionsAndInstructionsDocument, options);
      }
export type AcceptCompeteQuizTermsConditionsAndInstructionsMutationHookResult = ReturnType<typeof useAcceptCompeteQuizTermsConditionsAndInstructionsMutation>;
export type AcceptCompeteQuizTermsConditionsAndInstructionsMutationResult = Apollo.MutationResult<AcceptCompeteQuizTermsConditionsAndInstructionsMutation>;
export type AcceptCompeteQuizTermsConditionsAndInstructionsMutationOptions = Apollo.BaseMutationOptions<AcceptCompeteQuizTermsConditionsAndInstructionsMutation, AcceptCompeteQuizTermsConditionsAndInstructionsMutationVariables>;
export const AddUserTimedQuizSummariesDocument = gql`
    mutation AddUserTimedQuizSummaries($quiz_id: Int!, $is_completed: Boolean = false, $current_position: Int!) {
  insert_user_quiz_summaries_one(
    object: {quiz_id: $quiz_id, is_completed: $is_completed, current_position: $current_position}
  ) {
    is_completed
    quiz_id
    current_position
  }
}
    `;
export type AddUserTimedQuizSummariesMutationFn = Apollo.MutationFunction<AddUserTimedQuizSummariesMutation, AddUserTimedQuizSummariesMutationVariables>;

/**
 * __useAddUserTimedQuizSummariesMutation__
 *
 * To run a mutation, you first call `useAddUserTimedQuizSummariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserTimedQuizSummariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserTimedQuizSummariesMutation, { data, loading, error }] = useAddUserTimedQuizSummariesMutation({
 *   variables: {
 *      quiz_id: // value for 'quiz_id'
 *      is_completed: // value for 'is_completed'
 *      current_position: // value for 'current_position'
 *   },
 * });
 */
export function useAddUserTimedQuizSummariesMutation(baseOptions?: Apollo.MutationHookOptions<AddUserTimedQuizSummariesMutation, AddUserTimedQuizSummariesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserTimedQuizSummariesMutation, AddUserTimedQuizSummariesMutationVariables>(AddUserTimedQuizSummariesDocument, options);
      }
export type AddUserTimedQuizSummariesMutationHookResult = ReturnType<typeof useAddUserTimedQuizSummariesMutation>;
export type AddUserTimedQuizSummariesMutationResult = Apollo.MutationResult<AddUserTimedQuizSummariesMutation>;
export type AddUserTimedQuizSummariesMutationOptions = Apollo.BaseMutationOptions<AddUserTimedQuizSummariesMutation, AddUserTimedQuizSummariesMutationVariables>;
export const GetCompeteStatisticsDocument = gql`
    query GetCompeteStatistics {
  all_compete_tests: admin_constants(
    where: {label: {_eq: "total_number_of_compete_tests"}}
  ) {
    value
  }
  completed_compete_tests: user_quiz_summaries_aggregate(
    where: {is_completed: {_eq: true}, quiz_quiz: {is_timed: {_eq: true}, quiz_category: {quiz_domain: {id: {_in: [4, 5, 6]}}}}}
    distinct_on: quiz_id
  ) {
    aggregate {
      count
    }
  }
  all_questions_in_compete_tests: admin_constants(
    where: {label: {_eq: "total_number_of_compete_test_questions"}}
  ) {
    value
  }
  completed_questions_in_compete_tests: user_quiz_question_summaries_aggregate(
    distinct_on: question_id
    where: {user_quiz_summary: {quiz_quiz: {is_timed: {_eq: true}, quiz_category: {quiz_domain: {id: {_in: [4, 5, 6]}}}}}}
  ) {
    aggregate {
      count
    }
  }
  bookmarked_questions_in_compete_tests: user_quiz_question_summaries_aggregate(
    where: {is_bookmarked: {_eq: true}, user_quiz_summary: {quiz_quiz: {is_timed: {_eq: true}, quiz_category: {quiz_domain: {id: {_in: [4, 5, 6]}}}}}}
    distinct_on: question_id
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCompeteStatisticsQuery__
 *
 * To run a query within a React component, call `useGetCompeteStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompeteStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompeteStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompeteStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompeteStatisticsQuery, GetCompeteStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompeteStatisticsQuery, GetCompeteStatisticsQueryVariables>(GetCompeteStatisticsDocument, options);
      }
export function useGetCompeteStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompeteStatisticsQuery, GetCompeteStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompeteStatisticsQuery, GetCompeteStatisticsQueryVariables>(GetCompeteStatisticsDocument, options);
        }
export type GetCompeteStatisticsQueryHookResult = ReturnType<typeof useGetCompeteStatisticsQuery>;
export type GetCompeteStatisticsLazyQueryHookResult = ReturnType<typeof useGetCompeteStatisticsLazyQuery>;
export type GetCompeteStatisticsQueryResult = Apollo.QueryResult<GetCompeteStatisticsQuery, GetCompeteStatisticsQueryVariables>;
export const Compete__AnalysisMarksVsPercentileDocument = gql`
    query Compete__AnalysisMarksVsPercentile($quizID: Int!) {
  getCompeteMarksVsPercentile(quizID: $quizID) {
    varc
    dilr
    quant
    total
    percentile
  }
}
    `;

/**
 * __useCompete__AnalysisMarksVsPercentileQuery__
 *
 * To run a query within a React component, call `useCompete__AnalysisMarksVsPercentileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompete__AnalysisMarksVsPercentileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompete__AnalysisMarksVsPercentileQuery({
 *   variables: {
 *      quizID: // value for 'quizID'
 *   },
 * });
 */
export function useCompete__AnalysisMarksVsPercentileQuery(baseOptions: Apollo.QueryHookOptions<Compete__AnalysisMarksVsPercentileQuery, Compete__AnalysisMarksVsPercentileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Compete__AnalysisMarksVsPercentileQuery, Compete__AnalysisMarksVsPercentileQueryVariables>(Compete__AnalysisMarksVsPercentileDocument, options);
      }
export function useCompete__AnalysisMarksVsPercentileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Compete__AnalysisMarksVsPercentileQuery, Compete__AnalysisMarksVsPercentileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Compete__AnalysisMarksVsPercentileQuery, Compete__AnalysisMarksVsPercentileQueryVariables>(Compete__AnalysisMarksVsPercentileDocument, options);
        }
export type Compete__AnalysisMarksVsPercentileQueryHookResult = ReturnType<typeof useCompete__AnalysisMarksVsPercentileQuery>;
export type Compete__AnalysisMarksVsPercentileLazyQueryHookResult = ReturnType<typeof useCompete__AnalysisMarksVsPercentileLazyQuery>;
export type Compete__AnalysisMarksVsPercentileQueryResult = Apollo.QueryResult<Compete__AnalysisMarksVsPercentileQuery, Compete__AnalysisMarksVsPercentileQueryVariables>;
export const GetRecentCompeteTestsDocument = gql`
    query getRecentCompeteTests {
  user_quiz_summaries(
    order_by: {updated_at: desc}
    where: {quiz_quiz: {is_timed: {_eq: true}, quiz_category: {quiz_domain: {id: {_in: [4, 5, 6]}}}}}
    limit: 10
  ) {
    is_completed
    number_of_attempted_questions
    updated_at
    quiz_quiz {
      name
      total_number_of_questions
    }
    user_quiz_question_summaries_aggregate {
      aggregate {
        sum {
          marks
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecentCompeteTestsQuery__
 *
 * To run a query within a React component, call `useGetRecentCompeteTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentCompeteTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentCompeteTestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentCompeteTestsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentCompeteTestsQuery, GetRecentCompeteTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentCompeteTestsQuery, GetRecentCompeteTestsQueryVariables>(GetRecentCompeteTestsDocument, options);
      }
export function useGetRecentCompeteTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentCompeteTestsQuery, GetRecentCompeteTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentCompeteTestsQuery, GetRecentCompeteTestsQueryVariables>(GetRecentCompeteTestsDocument, options);
        }
export type GetRecentCompeteTestsQueryHookResult = ReturnType<typeof useGetRecentCompeteTestsQuery>;
export type GetRecentCompeteTestsLazyQueryHookResult = ReturnType<typeof useGetRecentCompeteTestsLazyQuery>;
export type GetRecentCompeteTestsQueryResult = Apollo.QueryResult<GetRecentCompeteTestsQuery, GetRecentCompeteTestsQueryVariables>;
export const Complete__GetUserQuizSummaryDocument = gql`
    subscription Complete__getUserQuizSummary($id: uuid!) {
  user_quiz_summaries(order_by: {updated_at: desc}, where: {id: {_eq: $id}}) {
    number_of_attempted_questions
    created_at
    percentile
    id
    number_of_users_completed
    user_quiz_section_summaries {
      percentile
      section_id
      quiz_section {
        name
      }
    }
    quiz_quiz {
      id
      name
      minimum_users
      show_percentile
      quiz_category {
        name
        quiz_domain {
          name
          quiz_superdomain {
            name
          }
        }
      }
    }
    correct_questions: user_quiz_question_summaries_aggregate(
      where: {is_correct: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    wrong_questions: user_quiz_question_summaries_aggregate(
      where: {is_correct: {_eq: false}}
    ) {
      aggregate {
        count
      }
    }
    total_marks: user_quiz_question_summaries_aggregate {
      aggregate {
        sum {
          marks
        }
      }
    }
    user_quiz_question_positions(order_by: {quiz_question: {rank: asc}}) {
      question_id
      position
      quiz_question {
        difficulty
        name
        rank
        solution
        question_type
        options {
          name
          id
          is_correct
        }
        quiz_paragraph {
          comprehension
          title
        }
        has_paragraph
      }
    }
    user_quiz_question_summaries(order_by: {quiz_question: {rank: asc}}) {
      id
      is_bookmarked
      is_correct
      time_taken
      marks
      response
      question_id
      quiz_question {
        difficulty
        name
        rank
        solution
        has_paragraph
        number_of_attempts
        number_of_correct_attempts
        average_time_taken_for_correct_attempts
        average_time_taken
        paragraph_id
        question_type
        options {
          id
          name
          is_correct
        }
        quiz_paragraph {
          id
          comprehension
          title
        }
        quiz_category {
          name
        }
        quiz_section_questions {
          section_id
          quiz_section {
            name
            rank
          }
        }
      }
    }
  }
}
    `;

/**
 * __useComplete__GetUserQuizSummarySubscription__
 *
 * To run a query within a React component, call `useComplete__GetUserQuizSummarySubscription` and pass it any options that fit your needs.
 * When your component renders, `useComplete__GetUserQuizSummarySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplete__GetUserQuizSummarySubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useComplete__GetUserQuizSummarySubscription(baseOptions: Apollo.SubscriptionHookOptions<Complete__GetUserQuizSummarySubscription, Complete__GetUserQuizSummarySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Complete__GetUserQuizSummarySubscription, Complete__GetUserQuizSummarySubscriptionVariables>(Complete__GetUserQuizSummaryDocument, options);
      }
export type Complete__GetUserQuizSummarySubscriptionHookResult = ReturnType<typeof useComplete__GetUserQuizSummarySubscription>;
export type Complete__GetUserQuizSummarySubscriptionResult = Apollo.SubscriptionResult<Complete__GetUserQuizSummarySubscription>;
export const UpdateBookmarkDocument = gql`
    mutation updateBookmark($is_bookmarked: Boolean!, $id: uuid!) {
  update_user_quiz_question_summaries(
    where: {id: {_eq: $id}}
    _set: {is_bookmarked: $is_bookmarked}
  ) {
    returning {
      id
      is_bookmarked
    }
  }
}
    `;
export type UpdateBookmarkMutationFn = Apollo.MutationFunction<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>;

/**
 * __useUpdateBookmarkMutation__
 *
 * To run a mutation, you first call `useUpdateBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookmarkMutation, { data, loading, error }] = useUpdateBookmarkMutation({
 *   variables: {
 *      is_bookmarked: // value for 'is_bookmarked'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>(UpdateBookmarkDocument, options);
      }
export type UpdateBookmarkMutationHookResult = ReturnType<typeof useUpdateBookmarkMutation>;
export type UpdateBookmarkMutationResult = Apollo.MutationResult<UpdateBookmarkMutation>;
export type UpdateBookmarkMutationOptions = Apollo.BaseMutationOptions<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>;
export const Compete__AnalysisTop10ScoresDocument = gql`
    query Compete__AnalysisTop10Scores($quizID: Int!) {
  getCompeteTop10Scores(quizID: $quizID) {
    name
    varc
    dilr
    quant
    total
  }
}
    `;

/**
 * __useCompete__AnalysisTop10ScoresQuery__
 *
 * To run a query within a React component, call `useCompete__AnalysisTop10ScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompete__AnalysisTop10ScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompete__AnalysisTop10ScoresQuery({
 *   variables: {
 *      quizID: // value for 'quizID'
 *   },
 * });
 */
export function useCompete__AnalysisTop10ScoresQuery(baseOptions: Apollo.QueryHookOptions<Compete__AnalysisTop10ScoresQuery, Compete__AnalysisTop10ScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Compete__AnalysisTop10ScoresQuery, Compete__AnalysisTop10ScoresQueryVariables>(Compete__AnalysisTop10ScoresDocument, options);
      }
export function useCompete__AnalysisTop10ScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Compete__AnalysisTop10ScoresQuery, Compete__AnalysisTop10ScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Compete__AnalysisTop10ScoresQuery, Compete__AnalysisTop10ScoresQueryVariables>(Compete__AnalysisTop10ScoresDocument, options);
        }
export type Compete__AnalysisTop10ScoresQueryHookResult = ReturnType<typeof useCompete__AnalysisTop10ScoresQuery>;
export type Compete__AnalysisTop10ScoresLazyQueryHookResult = ReturnType<typeof useCompete__AnalysisTop10ScoresLazyQuery>;
export type Compete__AnalysisTop10ScoresQueryResult = Apollo.QueryResult<Compete__AnalysisTop10ScoresQuery, Compete__AnalysisTop10ScoresQueryVariables>;
export const GetDailyNewsDocument = gql`
    query getDailyNews($_gte: timestamptz!, $_lte: timestamptz!) {
  andablog_news(
    limit: 5
    where: {created_date: {_gte: $_gte, _lte: $_lte}}
    order_by: {created_date: desc}
  ) {
    content
    _content_rendered
    created_date
    id
    title
  }
}
    `;

/**
 * __useGetDailyNewsQuery__
 *
 * To run a query within a React component, call `useGetDailyNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyNewsQuery({
 *   variables: {
 *      _gte: // value for '_gte'
 *      _lte: // value for '_lte'
 *   },
 * });
 */
export function useGetDailyNewsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyNewsQuery, GetDailyNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyNewsQuery, GetDailyNewsQueryVariables>(GetDailyNewsDocument, options);
      }
export function useGetDailyNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyNewsQuery, GetDailyNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyNewsQuery, GetDailyNewsQueryVariables>(GetDailyNewsDocument, options);
        }
export type GetDailyNewsQueryHookResult = ReturnType<typeof useGetDailyNewsQuery>;
export type GetDailyNewsLazyQueryHookResult = ReturnType<typeof useGetDailyNewsLazyQuery>;
export type GetDailyNewsQueryResult = Apollo.QueryResult<GetDailyNewsQuery, GetDailyNewsQueryVariables>;
export const AddUserPovSummaryDocument = gql`
    mutation addUserPovSummary($has_read: Boolean!, $pov_id: uuid!) {
  insert_user_pov_summaries_one(
    object: {pov_id: $pov_id, has_read: $has_read}
    on_conflict: {constraint: user_pov_summaries_pov_id_user_id_key, update_columns: has_read}
  ) {
    id
    has_read
  }
}
    `;
export type AddUserPovSummaryMutationFn = Apollo.MutationFunction<AddUserPovSummaryMutation, AddUserPovSummaryMutationVariables>;

/**
 * __useAddUserPovSummaryMutation__
 *
 * To run a mutation, you first call `useAddUserPovSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserPovSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserPovSummaryMutation, { data, loading, error }] = useAddUserPovSummaryMutation({
 *   variables: {
 *      has_read: // value for 'has_read'
 *      pov_id: // value for 'pov_id'
 *   },
 * });
 */
export function useAddUserPovSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddUserPovSummaryMutation, AddUserPovSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserPovSummaryMutation, AddUserPovSummaryMutationVariables>(AddUserPovSummaryDocument, options);
      }
export type AddUserPovSummaryMutationHookResult = ReturnType<typeof useAddUserPovSummaryMutation>;
export type AddUserPovSummaryMutationResult = Apollo.MutationResult<AddUserPovSummaryMutation>;
export type AddUserPovSummaryMutationOptions = Apollo.BaseMutationOptions<AddUserPovSummaryMutation, AddUserPovSummaryMutationVariables>;
export const UpdateHasReadDocument = gql`
    mutation updateHasRead($id: uuid!, $read: Boolean) {
  update_user_pov_summaries(where: {pov_id: {_eq: $id}}, _set: {has_read: $read}) {
    returning {
      id
      has_read
      pov_id
    }
  }
}
    `;
export type UpdateHasReadMutationFn = Apollo.MutationFunction<UpdateHasReadMutation, UpdateHasReadMutationVariables>;

/**
 * __useUpdateHasReadMutation__
 *
 * To run a mutation, you first call `useUpdateHasReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHasReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHasReadMutation, { data, loading, error }] = useUpdateHasReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useUpdateHasReadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHasReadMutation, UpdateHasReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHasReadMutation, UpdateHasReadMutationVariables>(UpdateHasReadDocument, options);
      }
export type UpdateHasReadMutationHookResult = ReturnType<typeof useUpdateHasReadMutation>;
export type UpdateHasReadMutationResult = Apollo.MutationResult<UpdateHasReadMutation>;
export type UpdateHasReadMutationOptions = Apollo.BaseMutationOptions<UpdateHasReadMutation, UpdateHasReadMutationVariables>;
export const GetDailyPovDocument = gql`
    query getDailyPov($where: andablog_pov_bool_exp!) {
  andablog_pov(order_by: {rank: desc, created_at: desc}, where: $where) {
    brief_write_up
    date
    external_url
    genre
    id
    image_url
    level
    pov
    rank
    time
    title
    user_pov_summaries {
      id
      has_read
    }
  }
}
    `;

/**
 * __useGetDailyPovQuery__
 *
 * To run a query within a React component, call `useGetDailyPovQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyPovQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyPovQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDailyPovQuery(baseOptions: Apollo.QueryHookOptions<GetDailyPovQuery, GetDailyPovQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyPovQuery, GetDailyPovQueryVariables>(GetDailyPovDocument, options);
      }
export function useGetDailyPovLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyPovQuery, GetDailyPovQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyPovQuery, GetDailyPovQueryVariables>(GetDailyPovDocument, options);
        }
export type GetDailyPovQueryHookResult = ReturnType<typeof useGetDailyPovQuery>;
export type GetDailyPovLazyQueryHookResult = ReturnType<typeof useGetDailyPovLazyQuery>;
export type GetDailyPovQueryResult = Apollo.QueryResult<GetDailyPovQuery, GetDailyPovQueryVariables>;
export const LearnPovDocument = gql`
    query learnPov($slug: String = "geometry") {
  andablog_entry(
    where: {quiz_category: {quiz_domain: {slug: {_eq: $slug}}, draft: {_neq: true}}}
  ) {
    title
    slug
    andablog_videos {
      vdpcipher_id
    }
    quiz_category {
      name
      slug
      quiz_domain {
        quiz_superdomain {
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useLearnPovQuery__
 *
 * To run a query within a React component, call `useLearnPovQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearnPovQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearnPovQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useLearnPovQuery(baseOptions?: Apollo.QueryHookOptions<LearnPovQuery, LearnPovQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearnPovQuery, LearnPovQueryVariables>(LearnPovDocument, options);
      }
export function useLearnPovLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearnPovQuery, LearnPovQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearnPovQuery, LearnPovQueryVariables>(LearnPovDocument, options);
        }
export type LearnPovQueryHookResult = ReturnType<typeof useLearnPovQuery>;
export type LearnPovLazyQueryHookResult = ReturnType<typeof useLearnPovLazyQuery>;
export type LearnPovQueryResult = Apollo.QueryResult<LearnPovQuery, LearnPovQueryVariables>;
export const GetDailyQuizInstructionsDocument = gql`
    query GetDailyQuizInstructions($slug: String) {
  quiz_quiz(where: {slug: {_eq: $slug}}) {
    slug
    id
    quiz_category {
      name
      quiz_domain {
        quiz_superdomain {
          slug
        }
      }
    }
    instructions2
    instructions1
    time_limit
    name
    meta_title
    meta_description
    meta_keyword
    user_quiz_summaries(order_by: {created_at: desc}) {
      id
      did_accept_instruction
    }
  }
}
    `;

/**
 * __useGetDailyQuizInstructionsQuery__
 *
 * To run a query within a React component, call `useGetDailyQuizInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyQuizInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyQuizInstructionsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetDailyQuizInstructionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDailyQuizInstructionsQuery, GetDailyQuizInstructionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyQuizInstructionsQuery, GetDailyQuizInstructionsQueryVariables>(GetDailyQuizInstructionsDocument, options);
      }
export function useGetDailyQuizInstructionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyQuizInstructionsQuery, GetDailyQuizInstructionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyQuizInstructionsQuery, GetDailyQuizInstructionsQueryVariables>(GetDailyQuizInstructionsDocument, options);
        }
export type GetDailyQuizInstructionsQueryHookResult = ReturnType<typeof useGetDailyQuizInstructionsQuery>;
export type GetDailyQuizInstructionsLazyQueryHookResult = ReturnType<typeof useGetDailyQuizInstructionsLazyQuery>;
export type GetDailyQuizInstructionsQueryResult = Apollo.QueryResult<GetDailyQuizInstructionsQuery, GetDailyQuizInstructionsQueryVariables>;
export const AcceptDailyQuizTermsConditionsAndInstructionsDocument = gql`
    mutation AcceptDailyQuizTermsConditionsAndInstructions($user_quiz_summary_id: uuid!) {
  update_user_quiz_summaries_by_pk(
    pk_columns: {id: $user_quiz_summary_id}
    _set: {did_accept_terms_and_conditions: true, did_accept_instruction: true}
  ) {
    id
  }
}
    `;
export type AcceptDailyQuizTermsConditionsAndInstructionsMutationFn = Apollo.MutationFunction<AcceptDailyQuizTermsConditionsAndInstructionsMutation, AcceptDailyQuizTermsConditionsAndInstructionsMutationVariables>;

/**
 * __useAcceptDailyQuizTermsConditionsAndInstructionsMutation__
 *
 * To run a mutation, you first call `useAcceptDailyQuizTermsConditionsAndInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptDailyQuizTermsConditionsAndInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptDailyQuizTermsConditionsAndInstructionsMutation, { data, loading, error }] = useAcceptDailyQuizTermsConditionsAndInstructionsMutation({
 *   variables: {
 *      user_quiz_summary_id: // value for 'user_quiz_summary_id'
 *   },
 * });
 */
export function useAcceptDailyQuizTermsConditionsAndInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptDailyQuizTermsConditionsAndInstructionsMutation, AcceptDailyQuizTermsConditionsAndInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptDailyQuizTermsConditionsAndInstructionsMutation, AcceptDailyQuizTermsConditionsAndInstructionsMutationVariables>(AcceptDailyQuizTermsConditionsAndInstructionsDocument, options);
      }
export type AcceptDailyQuizTermsConditionsAndInstructionsMutationHookResult = ReturnType<typeof useAcceptDailyQuizTermsConditionsAndInstructionsMutation>;
export type AcceptDailyQuizTermsConditionsAndInstructionsMutationResult = Apollo.MutationResult<AcceptDailyQuizTermsConditionsAndInstructionsMutation>;
export type AcceptDailyQuizTermsConditionsAndInstructionsMutationOptions = Apollo.BaseMutationOptions<AcceptDailyQuizTermsConditionsAndInstructionsMutation, AcceptDailyQuizTermsConditionsAndInstructionsMutationVariables>;
export const AddDailyQuizUserSummaryDocument = gql`
    mutation AddDailyQuizUserSummary($quiz_id: Int!, $current_position: Int!) {
  insert_user_quiz_summaries_one(
    object: {quiz_id: $quiz_id, current_position: $current_position}
    on_conflict: {constraint: user_quiz_summaries_user_id_quiz_id_attempt_key, update_columns: [current_position]}
  ) {
    id
  }
}
    `;
export type AddDailyQuizUserSummaryMutationFn = Apollo.MutationFunction<AddDailyQuizUserSummaryMutation, AddDailyQuizUserSummaryMutationVariables>;

/**
 * __useAddDailyQuizUserSummaryMutation__
 *
 * To run a mutation, you first call `useAddDailyQuizUserSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDailyQuizUserSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDailyQuizUserSummaryMutation, { data, loading, error }] = useAddDailyQuizUserSummaryMutation({
 *   variables: {
 *      quiz_id: // value for 'quiz_id'
 *      current_position: // value for 'current_position'
 *   },
 * });
 */
export function useAddDailyQuizUserSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddDailyQuizUserSummaryMutation, AddDailyQuizUserSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDailyQuizUserSummaryMutation, AddDailyQuizUserSummaryMutationVariables>(AddDailyQuizUserSummaryDocument, options);
      }
export type AddDailyQuizUserSummaryMutationHookResult = ReturnType<typeof useAddDailyQuizUserSummaryMutation>;
export type AddDailyQuizUserSummaryMutationResult = Apollo.MutationResult<AddDailyQuizUserSummaryMutation>;
export type AddDailyQuizUserSummaryMutationOptions = Apollo.BaseMutationOptions<AddDailyQuizUserSummaryMutation, AddDailyQuizUserSummaryMutationVariables>;
export const GetUserQuizzesSummaryDocument = gql`
    query getUserQuizzesSummary($quiz_id: Int!) {
  user_quiz_summaries(where: {quiz_id: {_eq: $quiz_id}}) {
    is_completed
    current_question
    attempt
    current_position
    id
    user_quiz_question_summaries {
      question_id
      response
      time_taken
      quiz_question {
        name
        has_paragraph
        options {
          is_correct
          name
        }
        solution
        quiz_paragraph {
          comprehension
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserQuizzesSummaryQuery__
 *
 * To run a query within a React component, call `useGetUserQuizzesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuizzesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuizzesSummaryQuery({
 *   variables: {
 *      quiz_id: // value for 'quiz_id'
 *   },
 * });
 */
export function useGetUserQuizzesSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuizzesSummaryQuery, GetUserQuizzesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuizzesSummaryQuery, GetUserQuizzesSummaryQueryVariables>(GetUserQuizzesSummaryDocument, options);
      }
export function useGetUserQuizzesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuizzesSummaryQuery, GetUserQuizzesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuizzesSummaryQuery, GetUserQuizzesSummaryQueryVariables>(GetUserQuizzesSummaryDocument, options);
        }
export type GetUserQuizzesSummaryQueryHookResult = ReturnType<typeof useGetUserQuizzesSummaryQuery>;
export type GetUserQuizzesSummaryLazyQueryHookResult = ReturnType<typeof useGetUserQuizzesSummaryLazyQuery>;
export type GetUserQuizzesSummaryQueryResult = Apollo.QueryResult<GetUserQuizzesSummaryQuery, GetUserQuizzesSummaryQueryVariables>;
export const TestGetQuizCountDocument = gql`
    query TestGetQuizCount($date: timestamptz!) {
  totalQuizCount: user_quiz_summaries_aggregate(
    where: {quiz_quiz: {quiz_category: {quiz_domain: {id: {_eq: 21}}, draft: {_neq: true}}}}
  ) {
    aggregate {
      count
    }
  }
  lastSevenDaysQuizCount: user_quiz_summaries_aggregate(
    where: {created_at: {_gte: $date}, quiz_quiz: {quiz_category: {quiz_domain: {id: {_eq: 21}}, draft: {_neq: true}}}}
  ) {
    aggregate {
      count
    }
  }
  totalXpSum: user_xp_transactions_aggregate(where: {type: {_eq: daily_quiz}}) {
    aggregate {
      sum {
        xp
      }
    }
  }
}
    `;

/**
 * __useTestGetQuizCountQuery__
 *
 * To run a query within a React component, call `useTestGetQuizCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestGetQuizCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestGetQuizCountQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTestGetQuizCountQuery(baseOptions: Apollo.QueryHookOptions<TestGetQuizCountQuery, TestGetQuizCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestGetQuizCountQuery, TestGetQuizCountQueryVariables>(TestGetQuizCountDocument, options);
      }
export function useTestGetQuizCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestGetQuizCountQuery, TestGetQuizCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestGetQuizCountQuery, TestGetQuizCountQueryVariables>(TestGetQuizCountDocument, options);
        }
export type TestGetQuizCountQueryHookResult = ReturnType<typeof useTestGetQuizCountQuery>;
export type TestGetQuizCountLazyQueryHookResult = ReturnType<typeof useTestGetQuizCountLazyQuery>;
export type TestGetQuizCountQueryResult = Apollo.QueryResult<TestGetQuizCountQuery, TestGetQuizCountQueryVariables>;
export const GetDailyQuizzesDocument = gql`
    query getDailyQuizzes($name_filters: [quiz_quiz_bool_exp!]!, $_nin: [Boolean!]!) {
  quiz_category(
    where: {quiz_domain: {id: {_eq: 21}}, draft: {_neq: true}}
    order_by: {created_at: desc}
  ) {
    free_learn
    free_practice
    is_lesson_category
    name
    quiz_domain {
      quiz_superdomain {
        slug
      }
    }
    rank
    quiz_quizzes(
      where: {is_sections: {_eq: true}, is_timed: {_eq: true}, draft: {_neq: true}, _or: $name_filters, is_premium: {_nin: $_nin}}
      order_by: {rank: asc}
    ) {
      available_on
      is_premium
      rank
      has_access
      is_sections
      name
      quiz_player
      single_attempt
      time_limit
      visually_impaired_time_duration
      id
      slug
      need_calc
      user_quiz_summaries(order_by: {created_at: desc}, limit: 1) {
        is_completed
        id
        current_position
        did_accept_instruction
        totalScore: user_quiz_question_summaries_aggregate {
          aggregate {
            sum {
              marks
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDailyQuizzesQuery__
 *
 * To run a query within a React component, call `useGetDailyQuizzesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyQuizzesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyQuizzesQuery({
 *   variables: {
 *      name_filters: // value for 'name_filters'
 *      _nin: // value for '_nin'
 *   },
 * });
 */
export function useGetDailyQuizzesQuery(baseOptions: Apollo.QueryHookOptions<GetDailyQuizzesQuery, GetDailyQuizzesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyQuizzesQuery, GetDailyQuizzesQueryVariables>(GetDailyQuizzesDocument, options);
      }
export function useGetDailyQuizzesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyQuizzesQuery, GetDailyQuizzesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyQuizzesQuery, GetDailyQuizzesQueryVariables>(GetDailyQuizzesDocument, options);
        }
export type GetDailyQuizzesQueryHookResult = ReturnType<typeof useGetDailyQuizzesQuery>;
export type GetDailyQuizzesLazyQueryHookResult = ReturnType<typeof useGetDailyQuizzesLazyQuery>;
export type GetDailyQuizzesQueryResult = Apollo.QueryResult<GetDailyQuizzesQuery, GetDailyQuizzesQueryVariables>;
export const UpdateDailyQuizQuestionSummaryDocument = gql`
    mutation updateDailyQuizQuestionSummary($id: uuid!, $is_bookmarked: Boolean!) {
  update_user_quiz_question_summaries(
    where: {id: {_eq: $id}}
    _set: {is_bookmarked: $is_bookmarked}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateDailyQuizQuestionSummaryMutationFn = Apollo.MutationFunction<UpdateDailyQuizQuestionSummaryMutation, UpdateDailyQuizQuestionSummaryMutationVariables>;

/**
 * __useUpdateDailyQuizQuestionSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateDailyQuizQuestionSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyQuizQuestionSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyQuizQuestionSummaryMutation, { data, loading, error }] = useUpdateDailyQuizQuestionSummaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_bookmarked: // value for 'is_bookmarked'
 *   },
 * });
 */
export function useUpdateDailyQuizQuestionSummaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyQuizQuestionSummaryMutation, UpdateDailyQuizQuestionSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyQuizQuestionSummaryMutation, UpdateDailyQuizQuestionSummaryMutationVariables>(UpdateDailyQuizQuestionSummaryDocument, options);
      }
export type UpdateDailyQuizQuestionSummaryMutationHookResult = ReturnType<typeof useUpdateDailyQuizQuestionSummaryMutation>;
export type UpdateDailyQuizQuestionSummaryMutationResult = Apollo.MutationResult<UpdateDailyQuizQuestionSummaryMutation>;
export type UpdateDailyQuizQuestionSummaryMutationOptions = Apollo.BaseMutationOptions<UpdateDailyQuizQuestionSummaryMutation, UpdateDailyQuizQuestionSummaryMutationVariables>;
export const GetDailyResultDocument = gql`
    query getDailyResult($id: uuid!) {
  user_quiz_summaries(where: {id: {_eq: $id}}) {
    id
    quiz_id
    quiz_quiz {
      available_on
      id
      show_percentile
      name
      quiz_category {
        name
      }
      quiz_quiz_sections {
        quiz_section {
          quiz_section_questions {
            quiz_question {
              ...DailyResultQuestionDetails
            }
          }
        }
      }
      quiz_quiz_questions {
        quiz_question {
          ...DailyResultQuestionDetails
        }
      }
    }
    totalScore: user_quiz_question_summaries_aggregate {
      aggregate {
        sum {
          marks
        }
      }
    }
    all_question_positions: user_quiz_question_positions {
      position
      question_id
    }
    user_quiz_question_summaries {
      id
      is_bookmarked
      is_correct
      response
      is_attempted
      time_taken
      quiz_question {
        ...DailyResultQuestionDetails
      }
    }
    correctQuestions: user_quiz_question_summaries_aggregate(
      where: {is_correct: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    ${DailyResultQuestionDetailsFragmentDoc}`;

/**
 * __useGetDailyResultQuery__
 *
 * To run a query within a React component, call `useGetDailyResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyResultQuery(baseOptions: Apollo.QueryHookOptions<GetDailyResultQuery, GetDailyResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyResultQuery, GetDailyResultQueryVariables>(GetDailyResultDocument, options);
      }
export function useGetDailyResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyResultQuery, GetDailyResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyResultQuery, GetDailyResultQueryVariables>(GetDailyResultDocument, options);
        }
export type GetDailyResultQueryHookResult = ReturnType<typeof useGetDailyResultQuery>;
export type GetDailyResultLazyQueryHookResult = ReturnType<typeof useGetDailyResultLazyQuery>;
export type GetDailyResultQueryResult = Apollo.QueryResult<GetDailyResultQuery, GetDailyResultQueryVariables>;
export const GetDailyQuizHighScoreDocument = gql`
    query getDailyQuizHighScore($id: Int!) {
  user_quiz_summaries(
    order_by: {user_quiz_question_summaries_aggregate: {sum: {marks: desc_nulls_last}}}
    where: {quiz_id: {_eq: $id}}
    limit: 1
  ) {
    user_quiz_question_summaries_aggregate {
      aggregate {
        sum {
          marks
        }
      }
    }
  }
}
    `;

/**
 * __useGetDailyQuizHighScoreQuery__
 *
 * To run a query within a React component, call `useGetDailyQuizHighScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyQuizHighScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyQuizHighScoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyQuizHighScoreQuery(baseOptions: Apollo.QueryHookOptions<GetDailyQuizHighScoreQuery, GetDailyQuizHighScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyQuizHighScoreQuery, GetDailyQuizHighScoreQueryVariables>(GetDailyQuizHighScoreDocument, options);
      }
export function useGetDailyQuizHighScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyQuizHighScoreQuery, GetDailyQuizHighScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyQuizHighScoreQuery, GetDailyQuizHighScoreQueryVariables>(GetDailyQuizHighScoreDocument, options);
        }
export type GetDailyQuizHighScoreQueryHookResult = ReturnType<typeof useGetDailyQuizHighScoreQuery>;
export type GetDailyQuizHighScoreLazyQueryHookResult = ReturnType<typeof useGetDailyQuizHighScoreLazyQuery>;
export type GetDailyQuizHighScoreQueryResult = Apollo.QueryResult<GetDailyQuizHighScoreQuery, GetDailyQuizHighScoreQueryVariables>;
export const GetQuizLeaderboardDocument = gql`
    query getQuizLeaderboard($id: Int!) {
  getQuizLeaderboard(quizID: $id) {
    rank
    score
    name
    avatar
  }
}
    `;

/**
 * __useGetQuizLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetQuizLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizLeaderboardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuizLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<GetQuizLeaderboardQuery, GetQuizLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuizLeaderboardQuery, GetQuizLeaderboardQueryVariables>(GetQuizLeaderboardDocument, options);
      }
export function useGetQuizLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuizLeaderboardQuery, GetQuizLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuizLeaderboardQuery, GetQuizLeaderboardQueryVariables>(GetQuizLeaderboardDocument, options);
        }
export type GetQuizLeaderboardQueryHookResult = ReturnType<typeof useGetQuizLeaderboardQuery>;
export type GetQuizLeaderboardLazyQueryHookResult = ReturnType<typeof useGetQuizLeaderboardLazyQuery>;
export type GetQuizLeaderboardQueryResult = Apollo.QueryResult<GetQuizLeaderboardQuery, GetQuizLeaderboardQueryVariables>;
export const GetLastDailyXpEarnedDocument = gql`
    subscription getLastDailyXpEarned($id: uuid!) {
  user_quiz_summaries(where: {id: {_eq: $id}}) {
    xp
  }
}
    `;

/**
 * __useGetLastDailyXpEarnedSubscription__
 *
 * To run a query within a React component, call `useGetLastDailyXpEarnedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetLastDailyXpEarnedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastDailyXpEarnedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLastDailyXpEarnedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetLastDailyXpEarnedSubscription, GetLastDailyXpEarnedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetLastDailyXpEarnedSubscription, GetLastDailyXpEarnedSubscriptionVariables>(GetLastDailyXpEarnedDocument, options);
      }
export type GetLastDailyXpEarnedSubscriptionHookResult = ReturnType<typeof useGetLastDailyXpEarnedSubscription>;
export type GetLastDailyXpEarnedSubscriptionResult = Apollo.SubscriptionResult<GetLastDailyXpEarnedSubscription>;
export const DailyQuiz__GetLatestUserQuizAttemptDocument = gql`
    query DailyQuiz__GetLatestUserQuizAttempt($quizSlug: String!) {
  user_quiz_summaries(
    order_by: {attempt: desc}
    where: {quiz_quiz: {slug: {_eq: $quizSlug}}}
    limit: 1
  ) {
    id
    is_completed
  }
}
    `;

/**
 * __useDailyQuiz__GetLatestUserQuizAttemptQuery__
 *
 * To run a query within a React component, call `useDailyQuiz__GetLatestUserQuizAttemptQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyQuiz__GetLatestUserQuizAttemptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyQuiz__GetLatestUserQuizAttemptQuery({
 *   variables: {
 *      quizSlug: // value for 'quizSlug'
 *   },
 * });
 */
export function useDailyQuiz__GetLatestUserQuizAttemptQuery(baseOptions: Apollo.QueryHookOptions<DailyQuiz__GetLatestUserQuizAttemptQuery, DailyQuiz__GetLatestUserQuizAttemptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyQuiz__GetLatestUserQuizAttemptQuery, DailyQuiz__GetLatestUserQuizAttemptQueryVariables>(DailyQuiz__GetLatestUserQuizAttemptDocument, options);
      }
export function useDailyQuiz__GetLatestUserQuizAttemptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyQuiz__GetLatestUserQuizAttemptQuery, DailyQuiz__GetLatestUserQuizAttemptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyQuiz__GetLatestUserQuizAttemptQuery, DailyQuiz__GetLatestUserQuizAttemptQueryVariables>(DailyQuiz__GetLatestUserQuizAttemptDocument, options);
        }
export type DailyQuiz__GetLatestUserQuizAttemptQueryHookResult = ReturnType<typeof useDailyQuiz__GetLatestUserQuizAttemptQuery>;
export type DailyQuiz__GetLatestUserQuizAttemptLazyQueryHookResult = ReturnType<typeof useDailyQuiz__GetLatestUserQuizAttemptLazyQuery>;
export type DailyQuiz__GetLatestUserQuizAttemptQueryResult = Apollo.QueryResult<DailyQuiz__GetLatestUserQuizAttemptQuery, DailyQuiz__GetLatestUserQuizAttemptQueryVariables>;
export const GetDailyQuizDetailsDocument = gql`
    query GetDailyQuizDetails($position: Int!, $user_quiz_summary_id: uuid!) {
  all_questions: user_quiz_question_positions(
    where: {user_quiz_summary_id: {_eq: $user_quiz_summary_id}}
  ) {
    position
    user_quiz_question_summary {
      id
      is_attempted
      response
    }
  }
  user_quiz_question_positions(
    where: {position: {_eq: $position}, user_quiz_summary_id: {_eq: $user_quiz_summary_id}}
  ) {
    user_quiz_question_summary {
      id
      time_taken
      response
      quiz_question {
        question_type
        options {
          id
          name
        }
      }
    }
    quiz_question {
      id
      has_paragraph
      question_type
      quiz_paragraph {
        id
        comprehension
      }
      name
      options {
        id
        is_correct
        name
      }
    }
    user_quiz_summary {
      is_completed
      user_quiz_question_summaries {
        time_taken
      }
      remaining_time
      quiz_quiz {
        id
        name
        available_on
        need_calc
        time_limit
        meta_title
      }
    }
  }
}
    `;

/**
 * __useGetDailyQuizDetailsQuery__
 *
 * To run a query within a React component, call `useGetDailyQuizDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyQuizDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyQuizDetailsQuery({
 *   variables: {
 *      position: // value for 'position'
 *      user_quiz_summary_id: // value for 'user_quiz_summary_id'
 *   },
 * });
 */
export function useGetDailyQuizDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyQuizDetailsQuery, GetDailyQuizDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyQuizDetailsQuery, GetDailyQuizDetailsQueryVariables>(GetDailyQuizDetailsDocument, options);
      }
export function useGetDailyQuizDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyQuizDetailsQuery, GetDailyQuizDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyQuizDetailsQuery, GetDailyQuizDetailsQueryVariables>(GetDailyQuizDetailsDocument, options);
        }
export type GetDailyQuizDetailsQueryHookResult = ReturnType<typeof useGetDailyQuizDetailsQuery>;
export type GetDailyQuizDetailsLazyQueryHookResult = ReturnType<typeof useGetDailyQuizDetailsLazyQuery>;
export type GetDailyQuizDetailsQueryResult = Apollo.QueryResult<GetDailyQuizDetailsQuery, GetDailyQuizDetailsQueryVariables>;
export const AddDailyQuizQuestionSummaryDocument = gql`
    mutation addDailyQuizQuestionSummary($question_id: Int!, $question_position: Int!, $quiz_summary_id: uuid!, $response: String!, $time_taken: interval!, $is_attempted: Boolean!) {
  insert_user_quiz_question_summaries_one(
    object: {question_id: $question_id, question_position: $question_position, quiz_summary_id: $quiz_summary_id, response: $response, time_taken: $time_taken, is_attempted: $is_attempted}
    on_conflict: {constraint: user_quiz_question_summaries_quiz_summary_id_question_id_key, update_columns: [response, time_taken, is_attempted]}
  ) {
    id
  }
}
    `;
export type AddDailyQuizQuestionSummaryMutationFn = Apollo.MutationFunction<AddDailyQuizQuestionSummaryMutation, AddDailyQuizQuestionSummaryMutationVariables>;

/**
 * __useAddDailyQuizQuestionSummaryMutation__
 *
 * To run a mutation, you first call `useAddDailyQuizQuestionSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDailyQuizQuestionSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDailyQuizQuestionSummaryMutation, { data, loading, error }] = useAddDailyQuizQuestionSummaryMutation({
 *   variables: {
 *      question_id: // value for 'question_id'
 *      question_position: // value for 'question_position'
 *      quiz_summary_id: // value for 'quiz_summary_id'
 *      response: // value for 'response'
 *      time_taken: // value for 'time_taken'
 *      is_attempted: // value for 'is_attempted'
 *   },
 * });
 */
export function useAddDailyQuizQuestionSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddDailyQuizQuestionSummaryMutation, AddDailyQuizQuestionSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDailyQuizQuestionSummaryMutation, AddDailyQuizQuestionSummaryMutationVariables>(AddDailyQuizQuestionSummaryDocument, options);
      }
export type AddDailyQuizQuestionSummaryMutationHookResult = ReturnType<typeof useAddDailyQuizQuestionSummaryMutation>;
export type AddDailyQuizQuestionSummaryMutationResult = Apollo.MutationResult<AddDailyQuizQuestionSummaryMutation>;
export type AddDailyQuizQuestionSummaryMutationOptions = Apollo.BaseMutationOptions<AddDailyQuizQuestionSummaryMutation, AddDailyQuizQuestionSummaryMutationVariables>;
export const AddDailyQuizSummaryDocument = gql`
    mutation addDailyQuizSummary($id: uuid!, $current_position: Int!, $current_question: Int!, $is_completed: Boolean!) {
  update_user_quiz_summaries(
    where: {id: {_eq: $id}}
    _set: {current_position: $current_position, current_question: $current_question, is_completed: $is_completed}
  ) {
    returning {
      id
    }
  }
}
    `;
export type AddDailyQuizSummaryMutationFn = Apollo.MutationFunction<AddDailyQuizSummaryMutation, AddDailyQuizSummaryMutationVariables>;

/**
 * __useAddDailyQuizSummaryMutation__
 *
 * To run a mutation, you first call `useAddDailyQuizSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDailyQuizSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDailyQuizSummaryMutation, { data, loading, error }] = useAddDailyQuizSummaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      current_position: // value for 'current_position'
 *      current_question: // value for 'current_question'
 *      is_completed: // value for 'is_completed'
 *   },
 * });
 */
export function useAddDailyQuizSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddDailyQuizSummaryMutation, AddDailyQuizSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDailyQuizSummaryMutation, AddDailyQuizSummaryMutationVariables>(AddDailyQuizSummaryDocument, options);
      }
export type AddDailyQuizSummaryMutationHookResult = ReturnType<typeof useAddDailyQuizSummaryMutation>;
export type AddDailyQuizSummaryMutationResult = Apollo.MutationResult<AddDailyQuizSummaryMutation>;
export type AddDailyQuizSummaryMutationOptions = Apollo.BaseMutationOptions<AddDailyQuizSummaryMutation, AddDailyQuizSummaryMutationVariables>;
export const GetAchievementsXpDetailsDocument = gql`
    query GetAchievementsXpDetails($startDate: timestamptz!, $endDate: timestamptz!) {
  user_xp_transactions(where: {created_at: {_gte: $startDate, _lte: $endDate}}) {
    created_at
    id
    type
    xp
  }
}
    `;

/**
 * __useGetAchievementsXpDetailsQuery__
 *
 * To run a query within a React component, call `useGetAchievementsXpDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementsXpDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementsXpDetailsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAchievementsXpDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAchievementsXpDetailsQuery, GetAchievementsXpDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAchievementsXpDetailsQuery, GetAchievementsXpDetailsQueryVariables>(GetAchievementsXpDetailsDocument, options);
      }
export function useGetAchievementsXpDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAchievementsXpDetailsQuery, GetAchievementsXpDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAchievementsXpDetailsQuery, GetAchievementsXpDetailsQueryVariables>(GetAchievementsXpDetailsDocument, options);
        }
export type GetAchievementsXpDetailsQueryHookResult = ReturnType<typeof useGetAchievementsXpDetailsQuery>;
export type GetAchievementsXpDetailsLazyQueryHookResult = ReturnType<typeof useGetAchievementsXpDetailsLazyQuery>;
export type GetAchievementsXpDetailsQueryResult = Apollo.QueryResult<GetAchievementsXpDetailsQuery, GetAchievementsXpDetailsQueryVariables>;
export const GetUserActivitiesDocument = gql`
    query GetUserActivities {
  user_activities(order_by: {updated_at: desc}) {
    type
    id
  }
}
    `;

/**
 * __useGetUserActivitiesQuery__
 *
 * To run a query within a React component, call `useGetUserActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>(GetUserActivitiesDocument, options);
      }
export function useGetUserActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>(GetUserActivitiesDocument, options);
        }
export type GetUserActivitiesQueryHookResult = ReturnType<typeof useGetUserActivitiesQuery>;
export type GetUserActivitiesLazyQueryHookResult = ReturnType<typeof useGetUserActivitiesLazyQuery>;
export type GetUserActivitiesQueryResult = Apollo.QueryResult<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>;
export const Timeline_GetUserPlannedActivitiesDocument = gql`
    query Timeline_GetUserPlannedActivities($userId: String) {
  getUserPlannedActivities(userId: $userId) {
    success
    message
  }
}
    `;

/**
 * __useTimeline_GetUserPlannedActivitiesQuery__
 *
 * To run a query within a React component, call `useTimeline_GetUserPlannedActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeline_GetUserPlannedActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeline_GetUserPlannedActivitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTimeline_GetUserPlannedActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<Timeline_GetUserPlannedActivitiesQuery, Timeline_GetUserPlannedActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Timeline_GetUserPlannedActivitiesQuery, Timeline_GetUserPlannedActivitiesQueryVariables>(Timeline_GetUserPlannedActivitiesDocument, options);
      }
export function useTimeline_GetUserPlannedActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Timeline_GetUserPlannedActivitiesQuery, Timeline_GetUserPlannedActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Timeline_GetUserPlannedActivitiesQuery, Timeline_GetUserPlannedActivitiesQueryVariables>(Timeline_GetUserPlannedActivitiesDocument, options);
        }
export type Timeline_GetUserPlannedActivitiesQueryHookResult = ReturnType<typeof useTimeline_GetUserPlannedActivitiesQuery>;
export type Timeline_GetUserPlannedActivitiesLazyQueryHookResult = ReturnType<typeof useTimeline_GetUserPlannedActivitiesLazyQuery>;
export type Timeline_GetUserPlannedActivitiesQueryResult = Apollo.QueryResult<Timeline_GetUserPlannedActivitiesQuery, Timeline_GetUserPlannedActivitiesQueryVariables>;
export const Timeline_GetUserCustomEventsDocument = gql`
    query Timeline_GetUserCustomEvents($userId: String) {
  getUserCustomEvents(userId: $userId) {
    success
    message
  }
}
    `;

/**
 * __useTimeline_GetUserCustomEventsQuery__
 *
 * To run a query within a React component, call `useTimeline_GetUserCustomEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeline_GetUserCustomEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeline_GetUserCustomEventsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTimeline_GetUserCustomEventsQuery(baseOptions?: Apollo.QueryHookOptions<Timeline_GetUserCustomEventsQuery, Timeline_GetUserCustomEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Timeline_GetUserCustomEventsQuery, Timeline_GetUserCustomEventsQueryVariables>(Timeline_GetUserCustomEventsDocument, options);
      }
export function useTimeline_GetUserCustomEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Timeline_GetUserCustomEventsQuery, Timeline_GetUserCustomEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Timeline_GetUserCustomEventsQuery, Timeline_GetUserCustomEventsQueryVariables>(Timeline_GetUserCustomEventsDocument, options);
        }
export type Timeline_GetUserCustomEventsQueryHookResult = ReturnType<typeof useTimeline_GetUserCustomEventsQuery>;
export type Timeline_GetUserCustomEventsLazyQueryHookResult = ReturnType<typeof useTimeline_GetUserCustomEventsLazyQuery>;
export type Timeline_GetUserCustomEventsQueryResult = Apollo.QueryResult<Timeline_GetUserCustomEventsQuery, Timeline_GetUserCustomEventsQueryVariables>;
export const GetUserActivityMinAndMaxDatesDocument = gql`
    query getUserActivityMinAndMaxDates($user_id: String!) {
  user_activity_aggregate(where: {user_id: {_eq: $user_id}}) {
    aggregate {
      max {
        scheduled_end_date
      }
      min {
        scheduled_start_date
      }
    }
  }
}
    `;

/**
 * __useGetUserActivityMinAndMaxDatesQuery__
 *
 * To run a query within a React component, call `useGetUserActivityMinAndMaxDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivityMinAndMaxDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivityMinAndMaxDatesQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetUserActivityMinAndMaxDatesQuery(baseOptions: Apollo.QueryHookOptions<GetUserActivityMinAndMaxDatesQuery, GetUserActivityMinAndMaxDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivityMinAndMaxDatesQuery, GetUserActivityMinAndMaxDatesQueryVariables>(GetUserActivityMinAndMaxDatesDocument, options);
      }
export function useGetUserActivityMinAndMaxDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivityMinAndMaxDatesQuery, GetUserActivityMinAndMaxDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivityMinAndMaxDatesQuery, GetUserActivityMinAndMaxDatesQueryVariables>(GetUserActivityMinAndMaxDatesDocument, options);
        }
export type GetUserActivityMinAndMaxDatesQueryHookResult = ReturnType<typeof useGetUserActivityMinAndMaxDatesQuery>;
export type GetUserActivityMinAndMaxDatesLazyQueryHookResult = ReturnType<typeof useGetUserActivityMinAndMaxDatesLazyQuery>;
export type GetUserActivityMinAndMaxDatesQueryResult = Apollo.QueryResult<GetUserActivityMinAndMaxDatesQuery, GetUserActivityMinAndMaxDatesQueryVariables>;
export const Planner__GetDomainNamesDocument = gql`
    query Planner__GetDomainNames {
  quiz_domain(
    where: {_or: [{quiz_categories: {do_not_include_in_planner: {_eq: false}}}, {quiz_superdomain: {packages_contents: {is_master: {_eq: true}}, do_not_include_in_planner: {_eq: false}}}], do_not_include_in_planner: {_eq: false}}
    order_by: {rank: asc}
  ) {
    slug
    name
    id
  }
}
    `;

/**
 * __usePlanner__GetDomainNamesQuery__
 *
 * To run a query within a React component, call `usePlanner__GetDomainNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanner__GetDomainNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanner__GetDomainNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlanner__GetDomainNamesQuery(baseOptions?: Apollo.QueryHookOptions<Planner__GetDomainNamesQuery, Planner__GetDomainNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Planner__GetDomainNamesQuery, Planner__GetDomainNamesQueryVariables>(Planner__GetDomainNamesDocument, options);
      }
export function usePlanner__GetDomainNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Planner__GetDomainNamesQuery, Planner__GetDomainNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Planner__GetDomainNamesQuery, Planner__GetDomainNamesQueryVariables>(Planner__GetDomainNamesDocument, options);
        }
export type Planner__GetDomainNamesQueryHookResult = ReturnType<typeof usePlanner__GetDomainNamesQuery>;
export type Planner__GetDomainNamesLazyQueryHookResult = ReturnType<typeof usePlanner__GetDomainNamesLazyQuery>;
export type Planner__GetDomainNamesQueryResult = Apollo.QueryResult<Planner__GetDomainNamesQuery, Planner__GetDomainNamesQueryVariables>;
export const RemoveAllUserPlannedActivitiesDocument = gql`
    mutation removeAllUserPlannedActivities($where: user_planned_activities_bool_exp = {}, $where2: user_custom_planned_activities_bool_exp = {}) {
  delete_user_planned_activities(where: $where) {
    affected_rows
  }
  delete_user_custom_planned_activities(where: $where2) {
    affected_rows
  }
}
    `;
export type RemoveAllUserPlannedActivitiesMutationFn = Apollo.MutationFunction<RemoveAllUserPlannedActivitiesMutation, RemoveAllUserPlannedActivitiesMutationVariables>;

/**
 * __useRemoveAllUserPlannedActivitiesMutation__
 *
 * To run a mutation, you first call `useRemoveAllUserPlannedActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllUserPlannedActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllUserPlannedActivitiesMutation, { data, loading, error }] = useRemoveAllUserPlannedActivitiesMutation({
 *   variables: {
 *      where: // value for 'where'
 *      where2: // value for 'where2'
 *   },
 * });
 */
export function useRemoveAllUserPlannedActivitiesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAllUserPlannedActivitiesMutation, RemoveAllUserPlannedActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAllUserPlannedActivitiesMutation, RemoveAllUserPlannedActivitiesMutationVariables>(RemoveAllUserPlannedActivitiesDocument, options);
      }
export type RemoveAllUserPlannedActivitiesMutationHookResult = ReturnType<typeof useRemoveAllUserPlannedActivitiesMutation>;
export type RemoveAllUserPlannedActivitiesMutationResult = Apollo.MutationResult<RemoveAllUserPlannedActivitiesMutation>;
export type RemoveAllUserPlannedActivitiesMutationOptions = Apollo.BaseMutationOptions<RemoveAllUserPlannedActivitiesMutation, RemoveAllUserPlannedActivitiesMutationVariables>;
export const UpdateUserPlannedActivityDocument = gql`
    mutation updateUserPlannedActivity($id: uuid!, $schedule_end_date: timestamptz!, $scheduled_at: timestamptz!) {
  update_user_planned_activities_by_pk(
    pk_columns: {id: $id}
    _set: {schedule_end_date: $schedule_end_date, scheduled_at: $scheduled_at}
  ) {
    id
    schedule_end_date
    scheduled_at
  }
}
    `;
export type UpdateUserPlannedActivityMutationFn = Apollo.MutationFunction<UpdateUserPlannedActivityMutation, UpdateUserPlannedActivityMutationVariables>;

/**
 * __useUpdateUserPlannedActivityMutation__
 *
 * To run a mutation, you first call `useUpdateUserPlannedActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPlannedActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPlannedActivityMutation, { data, loading, error }] = useUpdateUserPlannedActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      schedule_end_date: // value for 'schedule_end_date'
 *      scheduled_at: // value for 'scheduled_at'
 *   },
 * });
 */
export function useUpdateUserPlannedActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPlannedActivityMutation, UpdateUserPlannedActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPlannedActivityMutation, UpdateUserPlannedActivityMutationVariables>(UpdateUserPlannedActivityDocument, options);
      }
export type UpdateUserPlannedActivityMutationHookResult = ReturnType<typeof useUpdateUserPlannedActivityMutation>;
export type UpdateUserPlannedActivityMutationResult = Apollo.MutationResult<UpdateUserPlannedActivityMutation>;
export type UpdateUserPlannedActivityMutationOptions = Apollo.BaseMutationOptions<UpdateUserPlannedActivityMutation, UpdateUserPlannedActivityMutationVariables>;
export const UpdateUserCustomEventDocument = gql`
    mutation updateUserCustomEvent($id: uuid!, $schedule_end_date: timestamptz!, $scheduled_at: timestamptz!) {
  update_user_custom_planned_activities_by_pk(
    pk_columns: {id: $id}
    _set: {schedule_end_date: $schedule_end_date, scheduled_at: $scheduled_at}
  ) {
    id
    schedule_end_date
    scheduled_at
  }
}
    `;
export type UpdateUserCustomEventMutationFn = Apollo.MutationFunction<UpdateUserCustomEventMutation, UpdateUserCustomEventMutationVariables>;

/**
 * __useUpdateUserCustomEventMutation__
 *
 * To run a mutation, you first call `useUpdateUserCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCustomEventMutation, { data, loading, error }] = useUpdateUserCustomEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      schedule_end_date: // value for 'schedule_end_date'
 *      scheduled_at: // value for 'scheduled_at'
 *   },
 * });
 */
export function useUpdateUserCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCustomEventMutation, UpdateUserCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCustomEventMutation, UpdateUserCustomEventMutationVariables>(UpdateUserCustomEventDocument, options);
      }
export type UpdateUserCustomEventMutationHookResult = ReturnType<typeof useUpdateUserCustomEventMutation>;
export type UpdateUserCustomEventMutationResult = Apollo.MutationResult<UpdateUserCustomEventMutation>;
export type UpdateUserCustomEventMutationOptions = Apollo.BaseMutationOptions<UpdateUserCustomEventMutation, UpdateUserCustomEventMutationVariables>;
export const UpdateUserActivityDocument = gql`
    mutation updateUserActivity($user_id: String!, $data: user_activity_set_input!, $id: Int!) {
  update_user_activity(
    where: {user_id: {_eq: $user_id}, id: {_eq: $id}}
    _set: $data
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateUserActivityMutationFn = Apollo.MutationFunction<UpdateUserActivityMutation, UpdateUserActivityMutationVariables>;

/**
 * __useUpdateUserActivityMutation__
 *
 * To run a mutation, you first call `useUpdateUserActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserActivityMutation, { data, loading, error }] = useUpdateUserActivityMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserActivityMutation, UpdateUserActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserActivityMutation, UpdateUserActivityMutationVariables>(UpdateUserActivityDocument, options);
      }
export type UpdateUserActivityMutationHookResult = ReturnType<typeof useUpdateUserActivityMutation>;
export type UpdateUserActivityMutationResult = Apollo.MutationResult<UpdateUserActivityMutation>;
export type UpdateUserActivityMutationOptions = Apollo.BaseMutationOptions<UpdateUserActivityMutation, UpdateUserActivityMutationVariables>;
export const RemoveEventsDocument = gql`
    mutation removeEvents($id: uuid!) {
  delete_user_planned_activities(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type RemoveEventsMutationFn = Apollo.MutationFunction<RemoveEventsMutation, RemoveEventsMutationVariables>;

/**
 * __useRemoveEventsMutation__
 *
 * To run a mutation, you first call `useRemoveEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventsMutation, { data, loading, error }] = useRemoveEventsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventsMutation, RemoveEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventsMutation, RemoveEventsMutationVariables>(RemoveEventsDocument, options);
      }
export type RemoveEventsMutationHookResult = ReturnType<typeof useRemoveEventsMutation>;
export type RemoveEventsMutationResult = Apollo.MutationResult<RemoveEventsMutation>;
export type RemoveEventsMutationOptions = Apollo.BaseMutationOptions<RemoveEventsMutation, RemoveEventsMutationVariables>;
export const RemoveCustomEventsDocument = gql`
    mutation removeCustomEvents($id: uuid!) {
  delete_user_custom_planned_activities(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type RemoveCustomEventsMutationFn = Apollo.MutationFunction<RemoveCustomEventsMutation, RemoveCustomEventsMutationVariables>;

/**
 * __useRemoveCustomEventsMutation__
 *
 * To run a mutation, you first call `useRemoveCustomEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomEventsMutation, { data, loading, error }] = useRemoveCustomEventsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCustomEventsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomEventsMutation, RemoveCustomEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomEventsMutation, RemoveCustomEventsMutationVariables>(RemoveCustomEventsDocument, options);
      }
export type RemoveCustomEventsMutationHookResult = ReturnType<typeof useRemoveCustomEventsMutation>;
export type RemoveCustomEventsMutationResult = Apollo.MutationResult<RemoveCustomEventsMutation>;
export type RemoveCustomEventsMutationOptions = Apollo.BaseMutationOptions<RemoveCustomEventsMutation, RemoveCustomEventsMutationVariables>;
export const SchedulePlannerDocument = gql`
    mutation schedulePlanner($days: Int!, $domains: [Int!]!, $include: String!, $startDate: String!, $userId: String) {
  schedulePlanner(
    days: $days
    domains: $domains
    include: $include
    startDate: $startDate
    userId: $userId
  ) {
    message
    success
  }
}
    `;
export type SchedulePlannerMutationFn = Apollo.MutationFunction<SchedulePlannerMutation, SchedulePlannerMutationVariables>;

/**
 * __useSchedulePlannerMutation__
 *
 * To run a mutation, you first call `useSchedulePlannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulePlannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulePlannerMutation, { data, loading, error }] = useSchedulePlannerMutation({
 *   variables: {
 *      days: // value for 'days'
 *      domains: // value for 'domains'
 *      include: // value for 'include'
 *      startDate: // value for 'startDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSchedulePlannerMutation(baseOptions?: Apollo.MutationHookOptions<SchedulePlannerMutation, SchedulePlannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchedulePlannerMutation, SchedulePlannerMutationVariables>(SchedulePlannerDocument, options);
      }
export type SchedulePlannerMutationHookResult = ReturnType<typeof useSchedulePlannerMutation>;
export type SchedulePlannerMutationResult = Apollo.MutationResult<SchedulePlannerMutation>;
export type SchedulePlannerMutationOptions = Apollo.BaseMutationOptions<SchedulePlannerMutation, SchedulePlannerMutationVariables>;
export const AddUserCustomEventDocument = gql`
    mutation addUserCustomEvent($object: user_custom_planned_activities_insert_input!) {
  insert_user_custom_planned_activities_one(object: $object) {
    id
  }
}
    `;
export type AddUserCustomEventMutationFn = Apollo.MutationFunction<AddUserCustomEventMutation, AddUserCustomEventMutationVariables>;

/**
 * __useAddUserCustomEventMutation__
 *
 * To run a mutation, you first call `useAddUserCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserCustomEventMutation, { data, loading, error }] = useAddUserCustomEventMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddUserCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<AddUserCustomEventMutation, AddUserCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserCustomEventMutation, AddUserCustomEventMutationVariables>(AddUserCustomEventDocument, options);
      }
export type AddUserCustomEventMutationHookResult = ReturnType<typeof useAddUserCustomEventMutation>;
export type AddUserCustomEventMutationResult = Apollo.MutationResult<AddUserCustomEventMutation>;
export type AddUserCustomEventMutationOptions = Apollo.BaseMutationOptions<AddUserCustomEventMutation, AddUserCustomEventMutationVariables>;
export const GetUpcomingLiveClassesDocument = gql`
    query GetUpcomingLiveClasses {
  upcoming_live_classes(order_by: {created_at: desc}, limit: 5) {
    created_at
    end_time
    start_time
    id
    taken_by
    url
    updated_at
    title
  }
}
    `;

/**
 * __useGetUpcomingLiveClassesQuery__
 *
 * To run a query within a React component, call `useGetUpcomingLiveClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingLiveClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingLiveClassesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUpcomingLiveClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetUpcomingLiveClassesQuery, GetUpcomingLiveClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingLiveClassesQuery, GetUpcomingLiveClassesQueryVariables>(GetUpcomingLiveClassesDocument, options);
      }
export function useGetUpcomingLiveClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingLiveClassesQuery, GetUpcomingLiveClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingLiveClassesQuery, GetUpcomingLiveClassesQueryVariables>(GetUpcomingLiveClassesDocument, options);
        }
export type GetUpcomingLiveClassesQueryHookResult = ReturnType<typeof useGetUpcomingLiveClassesQuery>;
export type GetUpcomingLiveClassesLazyQueryHookResult = ReturnType<typeof useGetUpcomingLiveClassesLazyQuery>;
export type GetUpcomingLiveClassesQueryResult = Apollo.QueryResult<GetUpcomingLiveClassesQuery, GetUpcomingLiveClassesQueryVariables>;
export const GetUserRecentActivitiesDocument = gql`
    query GetUserRecentActivities {
  user_activities(order_by: {updated_at: desc}, limit: 7) {
    id
    quiz_id
    updated_at
    learn_category_id
    type
    quiz_category {
      name
      andablog_entries(limit: 1, order_by: {rank: asc}) {
        slug
      }
      slug
      is_lesson_category
      number_of_completed_modules
      total_number_of_modules
      quiz_domain {
        name
        slug
        quiz_superdomain {
          name
          slug
        }
      }
    }
    quiz_quiz {
      name
      slug
      is_timed
      time_limit
      number_of_completed_questions
      total_number_of_questions
      quiz_category {
        name
        slug
        is_lesson_category
        number_of_completed_modules
        total_number_of_modules
        quiz_domain {
          name
          id
          slug
          quiz_superdomain {
            name
            slug
          }
        }
      }
      user_quiz_summaries(order_by: {created_at: desc}, limit: 1) {
        id
        is_completed
        number_of_attempted_questions
      }
      user_speed_tests_summaries(order_by: {created_at: desc}, limit: 1) {
        id
        is_completed
        user_speed_test_questions_summaries_aggregate(where: {response: {_neq: ""}}) {
          aggregate {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserRecentActivitiesQuery__
 *
 * To run a query within a React component, call `useGetUserRecentActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRecentActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRecentActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRecentActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRecentActivitiesQuery, GetUserRecentActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRecentActivitiesQuery, GetUserRecentActivitiesQueryVariables>(GetUserRecentActivitiesDocument, options);
      }
export function useGetUserRecentActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRecentActivitiesQuery, GetUserRecentActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRecentActivitiesQuery, GetUserRecentActivitiesQueryVariables>(GetUserRecentActivitiesDocument, options);
        }
export type GetUserRecentActivitiesQueryHookResult = ReturnType<typeof useGetUserRecentActivitiesQuery>;
export type GetUserRecentActivitiesLazyQueryHookResult = ReturnType<typeof useGetUserRecentActivitiesLazyQuery>;
export type GetUserRecentActivitiesQueryResult = Apollo.QueryResult<GetUserRecentActivitiesQuery, GetUserRecentActivitiesQueryVariables>;
export const GetLastSevenDaysXpInfoDocument = gql`
    query GetLastSevenDaysXpInfo($date: timestamptz!) {
  user_xp_transactions(
    where: {created_at: {_gte: $date}}
    order_by: {created_at: asc}
  ) {
    created_at
    xp
  }
}
    `;

/**
 * __useGetLastSevenDaysXpInfoQuery__
 *
 * To run a query within a React component, call `useGetLastSevenDaysXpInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastSevenDaysXpInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastSevenDaysXpInfoQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetLastSevenDaysXpInfoQuery(baseOptions: Apollo.QueryHookOptions<GetLastSevenDaysXpInfoQuery, GetLastSevenDaysXpInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastSevenDaysXpInfoQuery, GetLastSevenDaysXpInfoQueryVariables>(GetLastSevenDaysXpInfoDocument, options);
      }
export function useGetLastSevenDaysXpInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastSevenDaysXpInfoQuery, GetLastSevenDaysXpInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastSevenDaysXpInfoQuery, GetLastSevenDaysXpInfoQueryVariables>(GetLastSevenDaysXpInfoDocument, options);
        }
export type GetLastSevenDaysXpInfoQueryHookResult = ReturnType<typeof useGetLastSevenDaysXpInfoQuery>;
export type GetLastSevenDaysXpInfoLazyQueryHookResult = ReturnType<typeof useGetLastSevenDaysXpInfoLazyQuery>;
export type GetLastSevenDaysXpInfoQueryResult = Apollo.QueryResult<GetLastSevenDaysXpInfoQuery, GetLastSevenDaysXpInfoQueryVariables>;
export const GetXpSumDetailsDocument = gql`
    query GetXPSumDetails {
  totalXP: user_xp_transactions_aggregate {
    aggregate {
      sum {
        xp
      }
    }
  }
  speedAndDailyXP: user_xp_transactions_aggregate(
    where: {type: {_in: [daily_quiz, speed_math_practice, speed_math_challenge, speed_verbal, speed_quant, speed_concept]}}
  ) {
    aggregate {
      sum {
        xp
      }
    }
  }
  lessonsXP: user_xp_transactions_aggregate(where: {type: {_eq: learn}}) {
    aggregate {
      sum {
        xp
      }
    }
  }
  practiceQuestionsXP: user_xp_transactions_aggregate(
    where: {type: {_eq: practice}}
  ) {
    aggregate {
      sum {
        xp
      }
    }
  }
  mocksAndTestsXP: user_xp_transactions_aggregate(where: {type: {_eq: compete}}) {
    aggregate {
      sum {
        xp
      }
    }
  }
}
    `;

/**
 * __useGetXpSumDetailsQuery__
 *
 * To run a query within a React component, call `useGetXpSumDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetXpSumDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetXpSumDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetXpSumDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetXpSumDetailsQuery, GetXpSumDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetXpSumDetailsQuery, GetXpSumDetailsQueryVariables>(GetXpSumDetailsDocument, options);
      }
export function useGetXpSumDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetXpSumDetailsQuery, GetXpSumDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetXpSumDetailsQuery, GetXpSumDetailsQueryVariables>(GetXpSumDetailsDocument, options);
        }
export type GetXpSumDetailsQueryHookResult = ReturnType<typeof useGetXpSumDetailsQuery>;
export type GetXpSumDetailsLazyQueryHookResult = ReturnType<typeof useGetXpSumDetailsLazyQuery>;
export type GetXpSumDetailsQueryResult = Apollo.QueryResult<GetXpSumDetailsQuery, GetXpSumDetailsQueryVariables>;
export const GetPlannerLessonDomainsDocument = gql`
    query getPlannerLessonDomains($id: Int!, $userId: String) {
  getPlannerLessonDomains(id: $id, userId: $userId) {
    success
    message
  }
}
    `;

/**
 * __useGetPlannerLessonDomainsQuery__
 *
 * To run a query within a React component, call `useGetPlannerLessonDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannerLessonDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannerLessonDomainsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPlannerLessonDomainsQuery(baseOptions: Apollo.QueryHookOptions<GetPlannerLessonDomainsQuery, GetPlannerLessonDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannerLessonDomainsQuery, GetPlannerLessonDomainsQueryVariables>(GetPlannerLessonDomainsDocument, options);
      }
export function useGetPlannerLessonDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannerLessonDomainsQuery, GetPlannerLessonDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannerLessonDomainsQuery, GetPlannerLessonDomainsQueryVariables>(GetPlannerLessonDomainsDocument, options);
        }
export type GetPlannerLessonDomainsQueryHookResult = ReturnType<typeof useGetPlannerLessonDomainsQuery>;
export type GetPlannerLessonDomainsLazyQueryHookResult = ReturnType<typeof useGetPlannerLessonDomainsLazyQuery>;
export type GetPlannerLessonDomainsQueryResult = Apollo.QueryResult<GetPlannerLessonDomainsQuery, GetPlannerLessonDomainsQueryVariables>;
export const GetPlannerPracticeDomainsDocument = gql`
    query getPlannerPracticeDomains($id: Int!, $userId: String) {
  getPlannerPracticeDomains(id: $id, userId: $userId) {
    success
    message
  }
}
    `;

/**
 * __useGetPlannerPracticeDomainsQuery__
 *
 * To run a query within a React component, call `useGetPlannerPracticeDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannerPracticeDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannerPracticeDomainsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPlannerPracticeDomainsQuery(baseOptions: Apollo.QueryHookOptions<GetPlannerPracticeDomainsQuery, GetPlannerPracticeDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannerPracticeDomainsQuery, GetPlannerPracticeDomainsQueryVariables>(GetPlannerPracticeDomainsDocument, options);
      }
export function useGetPlannerPracticeDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannerPracticeDomainsQuery, GetPlannerPracticeDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannerPracticeDomainsQuery, GetPlannerPracticeDomainsQueryVariables>(GetPlannerPracticeDomainsDocument, options);
        }
export type GetPlannerPracticeDomainsQueryHookResult = ReturnType<typeof useGetPlannerPracticeDomainsQuery>;
export type GetPlannerPracticeDomainsLazyQueryHookResult = ReturnType<typeof useGetPlannerPracticeDomainsLazyQuery>;
export type GetPlannerPracticeDomainsQueryResult = Apollo.QueryResult<GetPlannerPracticeDomainsQuery, GetPlannerPracticeDomainsQueryVariables>;
export const GetDomainCompeteDataDocument = gql`
    query getDomainCompeteData($userId: String) {
  getPlannerCompeteDomains(userId: $userId) {
    success
    message
  }
}
    `;

/**
 * __useGetDomainCompeteDataQuery__
 *
 * To run a query within a React component, call `useGetDomainCompeteDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDomainCompeteDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDomainCompeteDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDomainCompeteDataQuery(baseOptions?: Apollo.QueryHookOptions<GetDomainCompeteDataQuery, GetDomainCompeteDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDomainCompeteDataQuery, GetDomainCompeteDataQueryVariables>(GetDomainCompeteDataDocument, options);
      }
export function useGetDomainCompeteDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDomainCompeteDataQuery, GetDomainCompeteDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDomainCompeteDataQuery, GetDomainCompeteDataQueryVariables>(GetDomainCompeteDataDocument, options);
        }
export type GetDomainCompeteDataQueryHookResult = ReturnType<typeof useGetDomainCompeteDataQuery>;
export type GetDomainCompeteDataLazyQueryHookResult = ReturnType<typeof useGetDomainCompeteDataLazyQuery>;
export type GetDomainCompeteDataQueryResult = Apollo.QueryResult<GetDomainCompeteDataQuery, GetDomainCompeteDataQueryVariables>;
export const AddUserPlannedActivityDocument = gql`
    mutation AddUserPlannedActivity($data: user_planned_activities_insert_input!) {
  insert_user_planned_activities_one(object: $data) {
    id
    schedule_end_date
    scheduled_at
  }
}
    `;
export type AddUserPlannedActivityMutationFn = Apollo.MutationFunction<AddUserPlannedActivityMutation, AddUserPlannedActivityMutationVariables>;

/**
 * __useAddUserPlannedActivityMutation__
 *
 * To run a mutation, you first call `useAddUserPlannedActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserPlannedActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserPlannedActivityMutation, { data, loading, error }] = useAddUserPlannedActivityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddUserPlannedActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddUserPlannedActivityMutation, AddUserPlannedActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserPlannedActivityMutation, AddUserPlannedActivityMutationVariables>(AddUserPlannedActivityDocument, options);
      }
export type AddUserPlannedActivityMutationHookResult = ReturnType<typeof useAddUserPlannedActivityMutation>;
export type AddUserPlannedActivityMutationResult = Apollo.MutationResult<AddUserPlannedActivityMutation>;
export type AddUserPlannedActivityMutationOptions = Apollo.BaseMutationOptions<AddUserPlannedActivityMutation, AddUserPlannedActivityMutationVariables>;
export const GetPlannerSpeedConceptDomainsDocument = gql`
    query getPlannerSpeedConceptDomains($userId: String) {
  getPlannerSpeedConceptDomains(userId: $userId) {
    success
    message
  }
}
    `;

/**
 * __useGetPlannerSpeedConceptDomainsQuery__
 *
 * To run a query within a React component, call `useGetPlannerSpeedConceptDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannerSpeedConceptDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannerSpeedConceptDomainsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPlannerSpeedConceptDomainsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlannerSpeedConceptDomainsQuery, GetPlannerSpeedConceptDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannerSpeedConceptDomainsQuery, GetPlannerSpeedConceptDomainsQueryVariables>(GetPlannerSpeedConceptDomainsDocument, options);
      }
export function useGetPlannerSpeedConceptDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannerSpeedConceptDomainsQuery, GetPlannerSpeedConceptDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannerSpeedConceptDomainsQuery, GetPlannerSpeedConceptDomainsQueryVariables>(GetPlannerSpeedConceptDomainsDocument, options);
        }
export type GetPlannerSpeedConceptDomainsQueryHookResult = ReturnType<typeof useGetPlannerSpeedConceptDomainsQuery>;
export type GetPlannerSpeedConceptDomainsLazyQueryHookResult = ReturnType<typeof useGetPlannerSpeedConceptDomainsLazyQuery>;
export type GetPlannerSpeedConceptDomainsQueryResult = Apollo.QueryResult<GetPlannerSpeedConceptDomainsQuery, GetPlannerSpeedConceptDomainsQueryVariables>;
export const GetUserPlannedActivitiesDocument = gql`
    query getUserPlannedActivities {
  user_planned_activities(order_by: {updated_at: desc}, limit: 7) {
    id
    quiz_id
    scheduled_at
    quiz_category {
      name
      slug
      andablog_entries(limit: 1, order_by: {rank: asc}) {
        slug
      }
      is_lesson_category
      number_of_completed_modules
      total_number_of_modules
      quiz_domain {
        name
        slug
        id
        quiz_superdomain {
          name
          slug
        }
      }
    }
    schedule_end_date
    lesson_category_id
    quiz_quiz {
      name
      slug
      is_timed
      number_of_completed_questions
      total_number_of_questions
      time_limit
      quiz_category {
        name
        slug
        is_lesson_category
        number_of_completed_modules
        total_number_of_modules
        quiz_domain {
          name
          slug
          id
          quiz_superdomain {
            name
            slug
          }
        }
      }
      user_quiz_summaries(order_by: {created_at: desc}, limit: 1) {
        id
        is_completed
      }
      user_planned_activities_aggregate {
        aggregate {
          count
        }
        completed_rows: aggregate {
          count(columns: scheduled_at, distinct: true)
        }
      }
      user_speed_tests_summaries(order_by: {created_at: desc}, limit: 1) {
        id
        is_completed
        user_speed_test_questions_summaries_aggregate(where: {response: {_neq: ""}}) {
          aggregate {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserPlannedActivitiesQuery__
 *
 * To run a query within a React component, call `useGetUserPlannedActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPlannedActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPlannedActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPlannedActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPlannedActivitiesQuery, GetUserPlannedActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPlannedActivitiesQuery, GetUserPlannedActivitiesQueryVariables>(GetUserPlannedActivitiesDocument, options);
      }
export function useGetUserPlannedActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPlannedActivitiesQuery, GetUserPlannedActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPlannedActivitiesQuery, GetUserPlannedActivitiesQueryVariables>(GetUserPlannedActivitiesDocument, options);
        }
export type GetUserPlannedActivitiesQueryHookResult = ReturnType<typeof useGetUserPlannedActivitiesQuery>;
export type GetUserPlannedActivitiesLazyQueryHookResult = ReturnType<typeof useGetUserPlannedActivitiesLazyQuery>;
export type GetUserPlannedActivitiesQueryResult = Apollo.QueryResult<GetUserPlannedActivitiesQuery, GetUserPlannedActivitiesQueryVariables>;
export const GetUserCustomEventsDocument = gql`
    query getUserCustomEvents {
  user_custom_planned_activities(order_by: {created_at: desc}) {
    id
    description
    scheduled_at
    schedule_end_date
    topic
  }
}
    `;

/**
 * __useGetUserCustomEventsQuery__
 *
 * To run a query within a React component, call `useGetUserCustomEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCustomEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCustomEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCustomEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCustomEventsQuery, GetUserCustomEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCustomEventsQuery, GetUserCustomEventsQueryVariables>(GetUserCustomEventsDocument, options);
      }
export function useGetUserCustomEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCustomEventsQuery, GetUserCustomEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCustomEventsQuery, GetUserCustomEventsQueryVariables>(GetUserCustomEventsDocument, options);
        }
export type GetUserCustomEventsQueryHookResult = ReturnType<typeof useGetUserCustomEventsQuery>;
export type GetUserCustomEventsLazyQueryHookResult = ReturnType<typeof useGetUserCustomEventsLazyQuery>;
export type GetUserCustomEventsQueryResult = Apollo.QueryResult<GetUserCustomEventsQuery, GetUserCustomEventsQueryVariables>;
export const GetXpLeaderBoardDocument = gql`
    query getXpLeaderBoard($range: Int) {
  getXpLeaderBoard(range: $range) {
    success
    message
    data {
      name
      rank
      avatar
      xp
      userId
    }
  }
}
    `;

/**
 * __useGetXpLeaderBoardQuery__
 *
 * To run a query within a React component, call `useGetXpLeaderBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetXpLeaderBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetXpLeaderBoardQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetXpLeaderBoardQuery(baseOptions?: Apollo.QueryHookOptions<GetXpLeaderBoardQuery, GetXpLeaderBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetXpLeaderBoardQuery, GetXpLeaderBoardQueryVariables>(GetXpLeaderBoardDocument, options);
      }
export function useGetXpLeaderBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetXpLeaderBoardQuery, GetXpLeaderBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetXpLeaderBoardQuery, GetXpLeaderBoardQueryVariables>(GetXpLeaderBoardDocument, options);
        }
export type GetXpLeaderBoardQueryHookResult = ReturnType<typeof useGetXpLeaderBoardQuery>;
export type GetXpLeaderBoardLazyQueryHookResult = ReturnType<typeof useGetXpLeaderBoardLazyQuery>;
export type GetXpLeaderBoardQueryResult = Apollo.QueryResult<GetXpLeaderBoardQuery, GetXpLeaderBoardQueryVariables>;
export const GetInfoZoneAnnouncementsDocument = gql`
    query GetInfoZoneAnnouncements($offset: Int = 0) {
  infozone_infozone(
    order_by: {rank: asc}
    where: {info_type: {_eq: "ANNOUNCEMENTS"}}
    limit: 10
    offset: $offset
  ) {
    title
    slug
    content
    created_date
  }
}
    `;

/**
 * __useGetInfoZoneAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetInfoZoneAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoZoneAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoZoneAnnouncementsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetInfoZoneAnnouncementsQuery(baseOptions?: Apollo.QueryHookOptions<GetInfoZoneAnnouncementsQuery, GetInfoZoneAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoZoneAnnouncementsQuery, GetInfoZoneAnnouncementsQueryVariables>(GetInfoZoneAnnouncementsDocument, options);
      }
export function useGetInfoZoneAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoZoneAnnouncementsQuery, GetInfoZoneAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoZoneAnnouncementsQuery, GetInfoZoneAnnouncementsQueryVariables>(GetInfoZoneAnnouncementsDocument, options);
        }
export type GetInfoZoneAnnouncementsQueryHookResult = ReturnType<typeof useGetInfoZoneAnnouncementsQuery>;
export type GetInfoZoneAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetInfoZoneAnnouncementsLazyQuery>;
export type GetInfoZoneAnnouncementsQueryResult = Apollo.QueryResult<GetInfoZoneAnnouncementsQuery, GetInfoZoneAnnouncementsQueryVariables>;
export const GetInfoZoneAnnouncementDocument = gql`
    query GetInfoZoneAnnouncement($slug: String) {
  infozone_infozone(where: {slug: {_eq: $slug}}) {
    content
    title
    created_date
    next_item {
      slug
      title
    }
    previous_item {
      slug
      title
    }
  }
}
    `;

/**
 * __useGetInfoZoneAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetInfoZoneAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoZoneAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoZoneAnnouncementQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetInfoZoneAnnouncementQuery(baseOptions?: Apollo.QueryHookOptions<GetInfoZoneAnnouncementQuery, GetInfoZoneAnnouncementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoZoneAnnouncementQuery, GetInfoZoneAnnouncementQueryVariables>(GetInfoZoneAnnouncementDocument, options);
      }
export function useGetInfoZoneAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoZoneAnnouncementQuery, GetInfoZoneAnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoZoneAnnouncementQuery, GetInfoZoneAnnouncementQueryVariables>(GetInfoZoneAnnouncementDocument, options);
        }
export type GetInfoZoneAnnouncementQueryHookResult = ReturnType<typeof useGetInfoZoneAnnouncementQuery>;
export type GetInfoZoneAnnouncementLazyQueryHookResult = ReturnType<typeof useGetInfoZoneAnnouncementLazyQuery>;
export type GetInfoZoneAnnouncementQueryResult = Apollo.QueryResult<GetInfoZoneAnnouncementQuery, GetInfoZoneAnnouncementQueryVariables>;
export const GetInfoZoneCollegeDocument = gql`
    query GetInfoZoneCollege($slug: String) {
  college: infozone_infozone(where: {slug: {_eq: $slug}}) {
    content
  }
  colleges: infozone_infozone(
    where: {info_type: {_eq: "COLLEGE"}}
    order_by: {rank: asc}
  ) {
    slug
    title
  }
}
    `;

/**
 * __useGetInfoZoneCollegeQuery__
 *
 * To run a query within a React component, call `useGetInfoZoneCollegeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoZoneCollegeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoZoneCollegeQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetInfoZoneCollegeQuery(baseOptions?: Apollo.QueryHookOptions<GetInfoZoneCollegeQuery, GetInfoZoneCollegeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoZoneCollegeQuery, GetInfoZoneCollegeQueryVariables>(GetInfoZoneCollegeDocument, options);
      }
export function useGetInfoZoneCollegeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoZoneCollegeQuery, GetInfoZoneCollegeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoZoneCollegeQuery, GetInfoZoneCollegeQueryVariables>(GetInfoZoneCollegeDocument, options);
        }
export type GetInfoZoneCollegeQueryHookResult = ReturnType<typeof useGetInfoZoneCollegeQuery>;
export type GetInfoZoneCollegeLazyQueryHookResult = ReturnType<typeof useGetInfoZoneCollegeLazyQuery>;
export type GetInfoZoneCollegeQueryResult = Apollo.QueryResult<GetInfoZoneCollegeQuery, GetInfoZoneCollegeQueryVariables>;
export const GetInfoZoneExamDocument = gql`
    query GetInfoZoneExam($slug: String) {
  exam: infozone_infozone(where: {slug: {_eq: $slug}}) {
    content
  }
  exams: infozone_infozone(
    where: {info_type: {_eq: "EXAM"}}
    order_by: {rank: asc}
  ) {
    slug
    title
  }
}
    `;

/**
 * __useGetInfoZoneExamQuery__
 *
 * To run a query within a React component, call `useGetInfoZoneExamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoZoneExamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoZoneExamQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetInfoZoneExamQuery(baseOptions?: Apollo.QueryHookOptions<GetInfoZoneExamQuery, GetInfoZoneExamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoZoneExamQuery, GetInfoZoneExamQueryVariables>(GetInfoZoneExamDocument, options);
      }
export function useGetInfoZoneExamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoZoneExamQuery, GetInfoZoneExamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoZoneExamQuery, GetInfoZoneExamQueryVariables>(GetInfoZoneExamDocument, options);
        }
export type GetInfoZoneExamQueryHookResult = ReturnType<typeof useGetInfoZoneExamQuery>;
export type GetInfoZoneExamLazyQueryHookResult = ReturnType<typeof useGetInfoZoneExamLazyQuery>;
export type GetInfoZoneExamQueryResult = Apollo.QueryResult<GetInfoZoneExamQuery, GetInfoZoneExamQueryVariables>;
export const GetInfoZoneSummaryDocument = gql`
    query GetInfoZoneSummary {
  announcements: infozone_infozone(
    where: {info_type: {_ilike: "ANNOUNCEMENTS"}}
    order_by: {rank: asc}
  ) {
    slug
    title
  }
  colleges: infozone_infozone(
    where: {info_type: {_ilike: "COLLEGE"}}
    order_by: {rank: asc}
  ) {
    slug
    title
  }
  exams: infozone_infozone(
    where: {info_type: {_ilike: "EXAM"}}
    order_by: {rank: asc}
  ) {
    slug
    title
  }
}
    `;

/**
 * __useGetInfoZoneSummaryQuery__
 *
 * To run a query within a React component, call `useGetInfoZoneSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoZoneSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoZoneSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInfoZoneSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetInfoZoneSummaryQuery, GetInfoZoneSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoZoneSummaryQuery, GetInfoZoneSummaryQueryVariables>(GetInfoZoneSummaryDocument, options);
      }
export function useGetInfoZoneSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoZoneSummaryQuery, GetInfoZoneSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoZoneSummaryQuery, GetInfoZoneSummaryQueryVariables>(GetInfoZoneSummaryDocument, options);
        }
export type GetInfoZoneSummaryQueryHookResult = ReturnType<typeof useGetInfoZoneSummaryQuery>;
export type GetInfoZoneSummaryLazyQueryHookResult = ReturnType<typeof useGetInfoZoneSummaryLazyQuery>;
export type GetInfoZoneSummaryQueryResult = Apollo.QueryResult<GetInfoZoneSummaryQuery, GetInfoZoneSummaryQueryVariables>;
export const GetLearnBookmarkTopicsDocument = gql`
    query GetLearnBookmarkTopics($slug: String!) {
  user_learn_modules_summary(
    where: {is_bookmarked: {_eq: true}, andablog_entry: {quiz_category: {quiz_domain: {quiz_superdomain: {slug: {_eq: $slug}}}}}}
    order_by: {updated_at: desc, andablog_entry: {quiz_category: {rank: asc, quiz_domain: {rank: asc}}}}
  ) {
    id
    andablog_entry {
      content
      title
      slug
      quiz_category {
        name
        quiz_domain {
          name
        }
      }
    }
    is_bookmarked
    time_spent
  }
}
    `;

/**
 * __useGetLearnBookmarkTopicsQuery__
 *
 * To run a query within a React component, call `useGetLearnBookmarkTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnBookmarkTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnBookmarkTopicsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetLearnBookmarkTopicsQuery(baseOptions: Apollo.QueryHookOptions<GetLearnBookmarkTopicsQuery, GetLearnBookmarkTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearnBookmarkTopicsQuery, GetLearnBookmarkTopicsQueryVariables>(GetLearnBookmarkTopicsDocument, options);
      }
export function useGetLearnBookmarkTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearnBookmarkTopicsQuery, GetLearnBookmarkTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearnBookmarkTopicsQuery, GetLearnBookmarkTopicsQueryVariables>(GetLearnBookmarkTopicsDocument, options);
        }
export type GetLearnBookmarkTopicsQueryHookResult = ReturnType<typeof useGetLearnBookmarkTopicsQuery>;
export type GetLearnBookmarkTopicsLazyQueryHookResult = ReturnType<typeof useGetLearnBookmarkTopicsLazyQuery>;
export type GetLearnBookmarkTopicsQueryResult = Apollo.QueryResult<GetLearnBookmarkTopicsQuery, GetLearnBookmarkTopicsQueryVariables>;
export const UpdateLearnBookmarkDocument = gql`
    mutation updateLearnBookmark($id: uuid!) {
  update_user_learn_modules_summary(
    where: {id: {_eq: $id}}
    _set: {is_bookmarked: false}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateLearnBookmarkMutationFn = Apollo.MutationFunction<UpdateLearnBookmarkMutation, UpdateLearnBookmarkMutationVariables>;

/**
 * __useUpdateLearnBookmarkMutation__
 *
 * To run a mutation, you first call `useUpdateLearnBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearnBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearnBookmarkMutation, { data, loading, error }] = useUpdateLearnBookmarkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLearnBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearnBookmarkMutation, UpdateLearnBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearnBookmarkMutation, UpdateLearnBookmarkMutationVariables>(UpdateLearnBookmarkDocument, options);
      }
export type UpdateLearnBookmarkMutationHookResult = ReturnType<typeof useUpdateLearnBookmarkMutation>;
export type UpdateLearnBookmarkMutationResult = Apollo.MutationResult<UpdateLearnBookmarkMutation>;
export type UpdateLearnBookmarkMutationOptions = Apollo.BaseMutationOptions<UpdateLearnBookmarkMutation, UpdateLearnBookmarkMutationVariables>;
export const Learn__GetDomainsDocument = gql`
    query Learn__GetDomains($slug: String!, $_nin: [Boolean!]!) {
  quiz_domain(
    where: {quiz_superdomain: {slug: {_eq: $slug}}}
    order_by: {rank: asc}
  ) {
    name
    id
    slug
    quiz_categories(
      order_by: {rank: asc}
      where: {is_lesson_category: {_eq: true}, andablog_entries: {is_premium: {_nin: $_nin}}}
    ) {
      name
      slug
      total_number_of_modules
      number_of_completed_modules
      andablog_entries_aggregate {
        aggregate {
          count
        }
      }
      andablog_entries(order_by: {rank: asc}) {
        slug
      }
      user_recent_lesson(order_by: {last_visited: desc}) {
        last_visited
      }
    }
  }
}
    `;

/**
 * __useLearn__GetDomainsQuery__
 *
 * To run a query within a React component, call `useLearn__GetDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearn__GetDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearn__GetDomainsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      _nin: // value for '_nin'
 *   },
 * });
 */
export function useLearn__GetDomainsQuery(baseOptions: Apollo.QueryHookOptions<Learn__GetDomainsQuery, Learn__GetDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Learn__GetDomainsQuery, Learn__GetDomainsQueryVariables>(Learn__GetDomainsDocument, options);
      }
export function useLearn__GetDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Learn__GetDomainsQuery, Learn__GetDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Learn__GetDomainsQuery, Learn__GetDomainsQueryVariables>(Learn__GetDomainsDocument, options);
        }
export type Learn__GetDomainsQueryHookResult = ReturnType<typeof useLearn__GetDomainsQuery>;
export type Learn__GetDomainsLazyQueryHookResult = ReturnType<typeof useLearn__GetDomainsLazyQuery>;
export type Learn__GetDomainsQueryResult = Apollo.QueryResult<Learn__GetDomainsQuery, Learn__GetDomainsQueryVariables>;
export const GetLiveQuizDomainsDocument = gql`
    query getLiveQuizDomains($isFree: Boolean!) {
  getLiveQuizDomains(isFree: $isFree) {
    success
    message
    data
  }
}
    `;

/**
 * __useGetLiveQuizDomainsQuery__
 *
 * To run a query within a React component, call `useGetLiveQuizDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveQuizDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveQuizDomainsQuery({
 *   variables: {
 *      isFree: // value for 'isFree'
 *   },
 * });
 */
export function useGetLiveQuizDomainsQuery(baseOptions: Apollo.QueryHookOptions<GetLiveQuizDomainsQuery, GetLiveQuizDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveQuizDomainsQuery, GetLiveQuizDomainsQueryVariables>(GetLiveQuizDomainsDocument, options);
      }
export function useGetLiveQuizDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveQuizDomainsQuery, GetLiveQuizDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveQuizDomainsQuery, GetLiveQuizDomainsQueryVariables>(GetLiveQuizDomainsDocument, options);
        }
export type GetLiveQuizDomainsQueryHookResult = ReturnType<typeof useGetLiveQuizDomainsQuery>;
export type GetLiveQuizDomainsLazyQueryHookResult = ReturnType<typeof useGetLiveQuizDomainsLazyQuery>;
export type GetLiveQuizDomainsQueryResult = Apollo.QueryResult<GetLiveQuizDomainsQuery, GetLiveQuizDomainsQueryVariables>;
export const UpdateLearnTopicBookmarksDocument = gql`
    mutation updateLearnTopicBookmarks($id: Int!, $last_visited: timestamptz!, $is_bookmarked: Boolean!) {
  insert_user_learn_modules_summary_one(
    object: {entry_id: $id, last_visited: $last_visited, is_bookmarked: $is_bookmarked}
    on_conflict: {constraint: user_learn_modules_summary_user_id_entry_id_key, update_columns: [last_visited, is_bookmarked]}
  ) {
    id
    is_bookmarked
  }
}
    `;
export type UpdateLearnTopicBookmarksMutationFn = Apollo.MutationFunction<UpdateLearnTopicBookmarksMutation, UpdateLearnTopicBookmarksMutationVariables>;

/**
 * __useUpdateLearnTopicBookmarksMutation__
 *
 * To run a mutation, you first call `useUpdateLearnTopicBookmarksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearnTopicBookmarksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearnTopicBookmarksMutation, { data, loading, error }] = useUpdateLearnTopicBookmarksMutation({
 *   variables: {
 *      id: // value for 'id'
 *      last_visited: // value for 'last_visited'
 *      is_bookmarked: // value for 'is_bookmarked'
 *   },
 * });
 */
export function useUpdateLearnTopicBookmarksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearnTopicBookmarksMutation, UpdateLearnTopicBookmarksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearnTopicBookmarksMutation, UpdateLearnTopicBookmarksMutationVariables>(UpdateLearnTopicBookmarksDocument, options);
      }
export type UpdateLearnTopicBookmarksMutationHookResult = ReturnType<typeof useUpdateLearnTopicBookmarksMutation>;
export type UpdateLearnTopicBookmarksMutationResult = Apollo.MutationResult<UpdateLearnTopicBookmarksMutation>;
export type UpdateLearnTopicBookmarksMutationOptions = Apollo.BaseMutationOptions<UpdateLearnTopicBookmarksMutation, UpdateLearnTopicBookmarksMutationVariables>;
export const GetLearnStatisticsDocument = gql`
    query GetLearnStatistics {
  all_lessons: admin_constants(where: {label: {_eq: "total_number_of_lessons"}}) {
    value
  }
  all_modules: admin_constants(
    where: {label: {_eq: "total_number_of_lesson_modules"}}
  ) {
    value
  }
  completed_modules: user_learn_modules_summary_aggregate {
    aggregate {
      count
    }
  }
  bookmarked_modules: user_learn_modules_summary_aggregate(
    where: {is_bookmarked: {_eq: true}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetLearnStatisticsQuery__
 *
 * To run a query within a React component, call `useGetLearnStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLearnStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetLearnStatisticsQuery, GetLearnStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearnStatisticsQuery, GetLearnStatisticsQueryVariables>(GetLearnStatisticsDocument, options);
      }
export function useGetLearnStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearnStatisticsQuery, GetLearnStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearnStatisticsQuery, GetLearnStatisticsQueryVariables>(GetLearnStatisticsDocument, options);
        }
export type GetLearnStatisticsQueryHookResult = ReturnType<typeof useGetLearnStatisticsQuery>;
export type GetLearnStatisticsLazyQueryHookResult = ReturnType<typeof useGetLearnStatisticsLazyQuery>;
export type GetLearnStatisticsQueryResult = Apollo.QueryResult<GetLearnStatisticsQuery, GetLearnStatisticsQueryVariables>;
export const Learn__GetVideoOtpDocument = gql`
    query Learn__GetVideoOtp($activeTopicID: Int!) {
  getVideoOTPForLesson(activeTopicID: $activeTopicID) {
    otp
    playbackInfo
  }
}
    `;

/**
 * __useLearn__GetVideoOtpQuery__
 *
 * To run a query within a React component, call `useLearn__GetVideoOtpQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearn__GetVideoOtpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearn__GetVideoOtpQuery({
 *   variables: {
 *      activeTopicID: // value for 'activeTopicID'
 *   },
 * });
 */
export function useLearn__GetVideoOtpQuery(baseOptions: Apollo.QueryHookOptions<Learn__GetVideoOtpQuery, Learn__GetVideoOtpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Learn__GetVideoOtpQuery, Learn__GetVideoOtpQueryVariables>(Learn__GetVideoOtpDocument, options);
      }
export function useLearn__GetVideoOtpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Learn__GetVideoOtpQuery, Learn__GetVideoOtpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Learn__GetVideoOtpQuery, Learn__GetVideoOtpQueryVariables>(Learn__GetVideoOtpDocument, options);
        }
export type Learn__GetVideoOtpQueryHookResult = ReturnType<typeof useLearn__GetVideoOtpQuery>;
export type Learn__GetVideoOtpLazyQueryHookResult = ReturnType<typeof useLearn__GetVideoOtpLazyQuery>;
export type Learn__GetVideoOtpQueryResult = Apollo.QueryResult<Learn__GetVideoOtpQuery, Learn__GetVideoOtpQueryVariables>;
export const GetLessonWeeklyStatusChartDocument = gql`
    query GetLessonWeeklyStatusChart($last7Days: timestamptz!) {
  user_learn_modules_summary(where: {created_at: {_gte: $last7Days}}) {
    id
    created_at
  }
}
    `;

/**
 * __useGetLessonWeeklyStatusChartQuery__
 *
 * To run a query within a React component, call `useGetLessonWeeklyStatusChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonWeeklyStatusChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonWeeklyStatusChartQuery({
 *   variables: {
 *      last7Days: // value for 'last7Days'
 *   },
 * });
 */
export function useGetLessonWeeklyStatusChartQuery(baseOptions: Apollo.QueryHookOptions<GetLessonWeeklyStatusChartQuery, GetLessonWeeklyStatusChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonWeeklyStatusChartQuery, GetLessonWeeklyStatusChartQueryVariables>(GetLessonWeeklyStatusChartDocument, options);
      }
export function useGetLessonWeeklyStatusChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonWeeklyStatusChartQuery, GetLessonWeeklyStatusChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonWeeklyStatusChartQuery, GetLessonWeeklyStatusChartQueryVariables>(GetLessonWeeklyStatusChartDocument, options);
        }
export type GetLessonWeeklyStatusChartQueryHookResult = ReturnType<typeof useGetLessonWeeklyStatusChartQuery>;
export type GetLessonWeeklyStatusChartLazyQueryHookResult = ReturnType<typeof useGetLessonWeeklyStatusChartLazyQuery>;
export type GetLessonWeeklyStatusChartQueryResult = Apollo.QueryResult<GetLessonWeeklyStatusChartQuery, GetLessonWeeklyStatusChartQueryVariables>;
export const GetRecentLessonsDocument = gql`
    query getRecentLessons {
  user_recent_lessons(distinct_on: category_id, limit: 10) {
    last_visited
    quiz_category {
      total_number_of_modules
      number_of_completed_modules
      name
    }
  }
}
    `;

/**
 * __useGetRecentLessonsQuery__
 *
 * To run a query within a React component, call `useGetRecentLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentLessonsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentLessonsQuery, GetRecentLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentLessonsQuery, GetRecentLessonsQueryVariables>(GetRecentLessonsDocument, options);
      }
export function useGetRecentLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentLessonsQuery, GetRecentLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentLessonsQuery, GetRecentLessonsQueryVariables>(GetRecentLessonsDocument, options);
        }
export type GetRecentLessonsQueryHookResult = ReturnType<typeof useGetRecentLessonsQuery>;
export type GetRecentLessonsLazyQueryHookResult = ReturnType<typeof useGetRecentLessonsLazyQuery>;
export type GetRecentLessonsQueryResult = Apollo.QueryResult<GetRecentLessonsQuery, GetRecentLessonsQueryVariables>;
export const Learn__GetCategoryTopicDetailsDocument = gql`
    query Learn__GetCategoryTopicDetails($category_slug: String!) {
  quiz_category(where: {slug: {_eq: $category_slug}, draft: {_neq: true}}) {
    name
    id
    andablog_entries(order_by: {rank: asc}) {
      id
      title
      rank
      slug
      content
      has_access
      meta_title
      meta_description
      meta_keyword
      user_learn_summaries {
        ...Learn__UserLearnSummaries
      }
    }
    quiz_domain {
      name
      quiz_superdomain {
        slug
      }
    }
  }
}
    ${Learn__UserLearnSummariesFragmentDoc}`;

/**
 * __useLearn__GetCategoryTopicDetailsQuery__
 *
 * To run a query within a React component, call `useLearn__GetCategoryTopicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearn__GetCategoryTopicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearn__GetCategoryTopicDetailsQuery({
 *   variables: {
 *      category_slug: // value for 'category_slug'
 *   },
 * });
 */
export function useLearn__GetCategoryTopicDetailsQuery(baseOptions: Apollo.QueryHookOptions<Learn__GetCategoryTopicDetailsQuery, Learn__GetCategoryTopicDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Learn__GetCategoryTopicDetailsQuery, Learn__GetCategoryTopicDetailsQueryVariables>(Learn__GetCategoryTopicDetailsDocument, options);
      }
export function useLearn__GetCategoryTopicDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Learn__GetCategoryTopicDetailsQuery, Learn__GetCategoryTopicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Learn__GetCategoryTopicDetailsQuery, Learn__GetCategoryTopicDetailsQueryVariables>(Learn__GetCategoryTopicDetailsDocument, options);
        }
export type Learn__GetCategoryTopicDetailsQueryHookResult = ReturnType<typeof useLearn__GetCategoryTopicDetailsQuery>;
export type Learn__GetCategoryTopicDetailsLazyQueryHookResult = ReturnType<typeof useLearn__GetCategoryTopicDetailsLazyQuery>;
export type Learn__GetCategoryTopicDetailsQueryResult = Apollo.QueryResult<Learn__GetCategoryTopicDetailsQuery, Learn__GetCategoryTopicDetailsQueryVariables>;
export const AddLearnModulesSummaryDocument = gql`
    mutation addLearnModulesSummary($entry_id: Int!, $last_visited: timestamptz!, $time_spent: Int!) {
  insert_user_learn_modules_summary_one(
    object: {entry_id: $entry_id, last_visited: $last_visited, time_spent: $time_spent}
    on_conflict: {constraint: user_learn_modules_summary_user_id_entry_id_key, update_columns: [last_visited, time_spent]}
  ) {
    ...Learn__UserLearnSummaries
  }
}
    ${Learn__UserLearnSummariesFragmentDoc}`;
export type AddLearnModulesSummaryMutationFn = Apollo.MutationFunction<AddLearnModulesSummaryMutation, AddLearnModulesSummaryMutationVariables>;

/**
 * __useAddLearnModulesSummaryMutation__
 *
 * To run a mutation, you first call `useAddLearnModulesSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLearnModulesSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLearnModulesSummaryMutation, { data, loading, error }] = useAddLearnModulesSummaryMutation({
 *   variables: {
 *      entry_id: // value for 'entry_id'
 *      last_visited: // value for 'last_visited'
 *      time_spent: // value for 'time_spent'
 *   },
 * });
 */
export function useAddLearnModulesSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddLearnModulesSummaryMutation, AddLearnModulesSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLearnModulesSummaryMutation, AddLearnModulesSummaryMutationVariables>(AddLearnModulesSummaryDocument, options);
      }
export type AddLearnModulesSummaryMutationHookResult = ReturnType<typeof useAddLearnModulesSummaryMutation>;
export type AddLearnModulesSummaryMutationResult = Apollo.MutationResult<AddLearnModulesSummaryMutation>;
export type AddLearnModulesSummaryMutationOptions = Apollo.BaseMutationOptions<AddLearnModulesSummaryMutation, AddLearnModulesSummaryMutationVariables>;
export const AddUserQuizSummaryDocument = gql`
    mutation addUserQuizSummary($quiz_id: Int!, $is_completed: Boolean = false, $current_position: Int!) {
  insert_user_quiz_summaries_one(
    object: {quiz_id: $quiz_id, is_completed: $is_completed, current_position: $current_position}
  ) {
    is_completed
    quiz_id
    current_position
  }
}
    `;
export type AddUserQuizSummaryMutationFn = Apollo.MutationFunction<AddUserQuizSummaryMutation, AddUserQuizSummaryMutationVariables>;

/**
 * __useAddUserQuizSummaryMutation__
 *
 * To run a mutation, you first call `useAddUserQuizSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserQuizSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserQuizSummaryMutation, { data, loading, error }] = useAddUserQuizSummaryMutation({
 *   variables: {
 *      quiz_id: // value for 'quiz_id'
 *      is_completed: // value for 'is_completed'
 *      current_position: // value for 'current_position'
 *   },
 * });
 */
export function useAddUserQuizSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddUserQuizSummaryMutation, AddUserQuizSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserQuizSummaryMutation, AddUserQuizSummaryMutationVariables>(AddUserQuizSummaryDocument, options);
      }
export type AddUserQuizSummaryMutationHookResult = ReturnType<typeof useAddUserQuizSummaryMutation>;
export type AddUserQuizSummaryMutationResult = Apollo.MutationResult<AddUserQuizSummaryMutation>;
export type AddUserQuizSummaryMutationOptions = Apollo.BaseMutationOptions<AddUserQuizSummaryMutation, AddUserQuizSummaryMutationVariables>;
export const Practice__GetDomainsDocument = gql`
    query Practice__GetDomains($slug: String!, $_nin: [Boolean!]!) {
  quiz_domain(
    where: {quiz_superdomain: {slug: {_eq: $slug}}}
    order_by: {rank: asc}
  ) {
    name
    id
    quiz_categories(order_by: {rank: asc}) {
      name
      slug
      quiz_quizzes(
        order_by: {rank: asc}
        where: {draft: {_eq: false}, is_premium: {_nin: $_nin}, is_timed: {_eq: false}}
      ) {
        slug
        id
        has_access
        isPremium: is_premium
        totalNumberOfQuestions: total_number_of_questions
        user_quiz_summaries(order_by: {created_at: desc}) {
          id
          current_position
          is_completed
          number_of_attempted_questions
          current_question
          user_quiz_question_summaries_aggregate {
            aggregate {
              count
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePractice__GetDomainsQuery__
 *
 * To run a query within a React component, call `usePractice__GetDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractice__GetDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractice__GetDomainsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      _nin: // value for '_nin'
 *   },
 * });
 */
export function usePractice__GetDomainsQuery(baseOptions: Apollo.QueryHookOptions<Practice__GetDomainsQuery, Practice__GetDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Practice__GetDomainsQuery, Practice__GetDomainsQueryVariables>(Practice__GetDomainsDocument, options);
      }
export function usePractice__GetDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Practice__GetDomainsQuery, Practice__GetDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Practice__GetDomainsQuery, Practice__GetDomainsQueryVariables>(Practice__GetDomainsDocument, options);
        }
export type Practice__GetDomainsQueryHookResult = ReturnType<typeof usePractice__GetDomainsQuery>;
export type Practice__GetDomainsLazyQueryHookResult = ReturnType<typeof usePractice__GetDomainsLazyQuery>;
export type Practice__GetDomainsQueryResult = Apollo.QueryResult<Practice__GetDomainsQuery, Practice__GetDomainsQueryVariables>;
export const GetLastAttemptDocument = gql`
    query getLastAttempt($quiz_id: Int!) {
  user_quiz_summaries(
    order_by: {created_at: desc}
    where: {quiz_id: {_eq: $quiz_id}}
  ) {
    attempt
    id
  }
}
    `;

/**
 * __useGetLastAttemptQuery__
 *
 * To run a query within a React component, call `useGetLastAttemptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAttemptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAttemptQuery({
 *   variables: {
 *      quiz_id: // value for 'quiz_id'
 *   },
 * });
 */
export function useGetLastAttemptQuery(baseOptions: Apollo.QueryHookOptions<GetLastAttemptQuery, GetLastAttemptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastAttemptQuery, GetLastAttemptQueryVariables>(GetLastAttemptDocument, options);
      }
export function useGetLastAttemptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastAttemptQuery, GetLastAttemptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastAttemptQuery, GetLastAttemptQueryVariables>(GetLastAttemptDocument, options);
        }
export type GetLastAttemptQueryHookResult = ReturnType<typeof useGetLastAttemptQuery>;
export type GetLastAttemptLazyQueryHookResult = ReturnType<typeof useGetLastAttemptLazyQuery>;
export type GetLastAttemptQueryResult = Apollo.QueryResult<GetLastAttemptQuery, GetLastAttemptQueryVariables>;
export const AddQuizSummaryDocument = gql`
    mutation addQuizSummary($quiz_id: Int!, $attempt: Int!) {
  insert_user_quiz_summaries_one(
    object: {quiz_id: $quiz_id, is_completed: false, current_position: 1, attempt: $attempt}
  ) {
    current_position
  }
}
    `;
export type AddQuizSummaryMutationFn = Apollo.MutationFunction<AddQuizSummaryMutation, AddQuizSummaryMutationVariables>;

/**
 * __useAddQuizSummaryMutation__
 *
 * To run a mutation, you first call `useAddQuizSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuizSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuizSummaryMutation, { data, loading, error }] = useAddQuizSummaryMutation({
 *   variables: {
 *      quiz_id: // value for 'quiz_id'
 *      attempt: // value for 'attempt'
 *   },
 * });
 */
export function useAddQuizSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddQuizSummaryMutation, AddQuizSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuizSummaryMutation, AddQuizSummaryMutationVariables>(AddQuizSummaryDocument, options);
      }
export type AddQuizSummaryMutationHookResult = ReturnType<typeof useAddQuizSummaryMutation>;
export type AddQuizSummaryMutationResult = Apollo.MutationResult<AddQuizSummaryMutation>;
export type AddQuizSummaryMutationOptions = Apollo.BaseMutationOptions<AddQuizSummaryMutation, AddQuizSummaryMutationVariables>;
export const GetPracticeStatisticsDocument = gql`
    query GetPracticeStatistics {
  all_practice_quizzes: admin_constants(
    where: {label: {_eq: "total_number_of_practice_quizzes"}}
  ) {
    value
  }
  completed_practice_quizzes: user_quiz_summaries_aggregate(
    where: {is_completed: {_eq: true}, quiz_quiz: {is_timed: {_eq: false}}}
    distinct_on: quiz_id
  ) {
    aggregate {
      count
    }
  }
  all_questions_in_practice_quizzes: admin_constants(
    where: {label: {_eq: "total_number_of_practice_questions"}}
  ) {
    value
  }
  completed_questions_in_practice_quizzes: user_quiz_question_summaries_aggregate(
    distinct_on: question_id
    where: {user_quiz_summary: {quiz_quiz: {is_timed: {_eq: false}}}}
  ) {
    aggregate {
      count
    }
  }
  bookmarked_questions_in_practice_quizzes: user_quiz_question_summaries_aggregate(
    where: {is_bookmarked: {_eq: true}, user_quiz_summary: {quiz_quiz: {is_timed: {_eq: false}}}}
    distinct_on: question_id
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPracticeStatisticsQuery__
 *
 * To run a query within a React component, call `useGetPracticeStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPracticeStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetPracticeStatisticsQuery, GetPracticeStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticeStatisticsQuery, GetPracticeStatisticsQueryVariables>(GetPracticeStatisticsDocument, options);
      }
export function useGetPracticeStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticeStatisticsQuery, GetPracticeStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticeStatisticsQuery, GetPracticeStatisticsQueryVariables>(GetPracticeStatisticsDocument, options);
        }
export type GetPracticeStatisticsQueryHookResult = ReturnType<typeof useGetPracticeStatisticsQuery>;
export type GetPracticeStatisticsLazyQueryHookResult = ReturnType<typeof useGetPracticeStatisticsLazyQuery>;
export type GetPracticeStatisticsQueryResult = Apollo.QueryResult<GetPracticeStatisticsQuery, GetPracticeStatisticsQueryVariables>;
export const GetPracticeWeeklyStatusChartDocument = gql`
    query GetPracticeWeeklyStatusChart($last7Days: timestamp!) {
  user_quiz_question_summaries(
    where: {created_at: {_gte: $last7Days}, user_quiz_summary: {quiz_quiz: {is_timed: {_eq: false}}}}
  ) {
    id
    created_at
  }
}
    `;

/**
 * __useGetPracticeWeeklyStatusChartQuery__
 *
 * To run a query within a React component, call `useGetPracticeWeeklyStatusChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeWeeklyStatusChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeWeeklyStatusChartQuery({
 *   variables: {
 *      last7Days: // value for 'last7Days'
 *   },
 * });
 */
export function useGetPracticeWeeklyStatusChartQuery(baseOptions: Apollo.QueryHookOptions<GetPracticeWeeklyStatusChartQuery, GetPracticeWeeklyStatusChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticeWeeklyStatusChartQuery, GetPracticeWeeklyStatusChartQueryVariables>(GetPracticeWeeklyStatusChartDocument, options);
      }
export function useGetPracticeWeeklyStatusChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticeWeeklyStatusChartQuery, GetPracticeWeeklyStatusChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticeWeeklyStatusChartQuery, GetPracticeWeeklyStatusChartQueryVariables>(GetPracticeWeeklyStatusChartDocument, options);
        }
export type GetPracticeWeeklyStatusChartQueryHookResult = ReturnType<typeof useGetPracticeWeeklyStatusChartQuery>;
export type GetPracticeWeeklyStatusChartLazyQueryHookResult = ReturnType<typeof useGetPracticeWeeklyStatusChartLazyQuery>;
export type GetPracticeWeeklyStatusChartQueryResult = Apollo.QueryResult<GetPracticeWeeklyStatusChartQuery, GetPracticeWeeklyStatusChartQueryVariables>;
export const GetRecentPracticeTestsDocument = gql`
    query getRecentPracticeTests {
  user_quiz_summaries(
    limit: 10
    order_by: {updated_at: desc}
    where: {quiz_quiz: {is_timed: {_eq: false}}}
  ) {
    is_completed
    number_of_attempted_questions
    updated_at
    quiz_quiz {
      name
      total_number_of_questions
      quiz_category {
        name
      }
    }
  }
}
    `;

/**
 * __useGetRecentPracticeTestsQuery__
 *
 * To run a query within a React component, call `useGetRecentPracticeTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentPracticeTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentPracticeTestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentPracticeTestsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentPracticeTestsQuery, GetRecentPracticeTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentPracticeTestsQuery, GetRecentPracticeTestsQueryVariables>(GetRecentPracticeTestsDocument, options);
      }
export function useGetRecentPracticeTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentPracticeTestsQuery, GetRecentPracticeTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentPracticeTestsQuery, GetRecentPracticeTestsQueryVariables>(GetRecentPracticeTestsDocument, options);
        }
export type GetRecentPracticeTestsQueryHookResult = ReturnType<typeof useGetRecentPracticeTestsQuery>;
export type GetRecentPracticeTestsLazyQueryHookResult = ReturnType<typeof useGetRecentPracticeTestsLazyQuery>;
export type GetRecentPracticeTestsQueryResult = Apollo.QueryResult<GetRecentPracticeTestsQuery, GetRecentPracticeTestsQueryVariables>;
export const GetUserQuizSummaryDocument = gql`
    query getUserQuizSummary($id: uuid!) {
  user_quiz_summaries(order_by: {updated_at: desc}, where: {id: {_eq: $id}}) {
    number_of_attempted_questions
    quiz_quiz {
      name
      quiz_category {
        name
        quiz_domain {
          name
          quiz_superdomain {
            name
          }
        }
      }
    }
    correct_questions: user_quiz_question_summaries_aggregate(
      where: {is_correct: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    wrong_questions: user_quiz_question_summaries_aggregate(
      where: {is_correct: {_eq: false}, is_attempted: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    total_marks: user_quiz_question_summaries_aggregate {
      aggregate {
        sum {
          marks
        }
      }
    }
    user_quiz_question_positions(order_by: {position: asc}) {
      question_id
      position
      quiz_question {
        difficulty
        name
        question_type
        solution
        options {
          name
          is_correct
          id
        }
        quiz_paragraph {
          comprehension
          title
        }
        has_paragraph
      }
    }
    user_quiz_question_summaries {
      is_bookmarked
      id
      is_correct
      time_taken
      response
      question_id
      quiz_question {
        difficulty
        name
        question_type
        solution
        options {
          name
          id
          is_correct
        }
        quiz_paragraph {
          comprehension
          title
        }
        has_paragraph
      }
    }
  }
}
    `;

/**
 * __useGetUserQuizSummaryQuery__
 *
 * To run a query within a React component, call `useGetUserQuizSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuizSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuizSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuizSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuizSummaryQuery, GetUserQuizSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuizSummaryQuery, GetUserQuizSummaryQueryVariables>(GetUserQuizSummaryDocument, options);
      }
export function useGetUserQuizSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuizSummaryQuery, GetUserQuizSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuizSummaryQuery, GetUserQuizSummaryQueryVariables>(GetUserQuizSummaryDocument, options);
        }
export type GetUserQuizSummaryQueryHookResult = ReturnType<typeof useGetUserQuizSummaryQuery>;
export type GetUserQuizSummaryLazyQueryHookResult = ReturnType<typeof useGetUserQuizSummaryLazyQuery>;
export type GetUserQuizSummaryQueryResult = Apollo.QueryResult<GetUserQuizSummaryQuery, GetUserQuizSummaryQueryVariables>;
export const Practice__GetLatestUserQuizAttemptDocument = gql`
    query Practice__GetLatestUserQuizAttempt($quizSlug: String!) {
  user_quiz_summaries(
    order_by: {attempt: desc}
    where: {quiz_quiz: {slug: {_eq: $quizSlug}}}
    limit: 1
  ) {
    id
    is_completed
  }
}
    `;

/**
 * __usePractice__GetLatestUserQuizAttemptQuery__
 *
 * To run a query within a React component, call `usePractice__GetLatestUserQuizAttemptQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractice__GetLatestUserQuizAttemptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractice__GetLatestUserQuizAttemptQuery({
 *   variables: {
 *      quizSlug: // value for 'quizSlug'
 *   },
 * });
 */
export function usePractice__GetLatestUserQuizAttemptQuery(baseOptions: Apollo.QueryHookOptions<Practice__GetLatestUserQuizAttemptQuery, Practice__GetLatestUserQuizAttemptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Practice__GetLatestUserQuizAttemptQuery, Practice__GetLatestUserQuizAttemptQueryVariables>(Practice__GetLatestUserQuizAttemptDocument, options);
      }
export function usePractice__GetLatestUserQuizAttemptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Practice__GetLatestUserQuizAttemptQuery, Practice__GetLatestUserQuizAttemptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Practice__GetLatestUserQuizAttemptQuery, Practice__GetLatestUserQuizAttemptQueryVariables>(Practice__GetLatestUserQuizAttemptDocument, options);
        }
export type Practice__GetLatestUserQuizAttemptQueryHookResult = ReturnType<typeof usePractice__GetLatestUserQuizAttemptQuery>;
export type Practice__GetLatestUserQuizAttemptLazyQueryHookResult = ReturnType<typeof usePractice__GetLatestUserQuizAttemptLazyQuery>;
export type Practice__GetLatestUserQuizAttemptQueryResult = Apollo.QueryResult<Practice__GetLatestUserQuizAttemptQuery, Practice__GetLatestUserQuizAttemptQueryVariables>;
export const Practice__GetQuizQuestionsAndQuizSummaryDocument = gql`
    query Practice__GetQuizQuestionsAndQuizSummary($slug: String!, $question_position: Int!, $user_quiz_summary_id: uuid!) {
  user_quiz_summaries(
    order_by: {created_at: desc}
    where: {quiz_quiz: {slug: {_eq: $slug}}}
  ) {
    id
    attempt
  }
  quiz_quiz(where: {slug: {_eq: $slug}}) {
    id
    name
    total_number_of_questions
    need_calc
    quiz_category {
      name
      quiz_domain {
        name
        quiz_superdomain {
          name
        }
      }
    }
  }
  user_quiz_question_positions(
    where: {position: {_eq: $question_position}, user_quiz_summary_id: {_eq: $user_quiz_summary_id}}
  ) {
    question_id
    quiz_question {
      has_paragraph
      id
      question_type
      name
      solution
      quiz_paragraph {
        comprehension
        title
      }
      options {
        is_correct
        id
        name
      }
      user_quiz_question_summaries(
        where: {quiz_summary_id: {_eq: $user_quiz_summary_id}}
      ) {
        id
        is_bookmarked
        response
        time_taken
        is_attempted
      }
    }
  }
}
    `;

/**
 * __usePractice__GetQuizQuestionsAndQuizSummaryQuery__
 *
 * To run a query within a React component, call `usePractice__GetQuizQuestionsAndQuizSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractice__GetQuizQuestionsAndQuizSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractice__GetQuizQuestionsAndQuizSummaryQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      question_position: // value for 'question_position'
 *      user_quiz_summary_id: // value for 'user_quiz_summary_id'
 *   },
 * });
 */
export function usePractice__GetQuizQuestionsAndQuizSummaryQuery(baseOptions: Apollo.QueryHookOptions<Practice__GetQuizQuestionsAndQuizSummaryQuery, Practice__GetQuizQuestionsAndQuizSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Practice__GetQuizQuestionsAndQuizSummaryQuery, Practice__GetQuizQuestionsAndQuizSummaryQueryVariables>(Practice__GetQuizQuestionsAndQuizSummaryDocument, options);
      }
export function usePractice__GetQuizQuestionsAndQuizSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Practice__GetQuizQuestionsAndQuizSummaryQuery, Practice__GetQuizQuestionsAndQuizSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Practice__GetQuizQuestionsAndQuizSummaryQuery, Practice__GetQuizQuestionsAndQuizSummaryQueryVariables>(Practice__GetQuizQuestionsAndQuizSummaryDocument, options);
        }
export type Practice__GetQuizQuestionsAndQuizSummaryQueryHookResult = ReturnType<typeof usePractice__GetQuizQuestionsAndQuizSummaryQuery>;
export type Practice__GetQuizQuestionsAndQuizSummaryLazyQueryHookResult = ReturnType<typeof usePractice__GetQuizQuestionsAndQuizSummaryLazyQuery>;
export type Practice__GetQuizQuestionsAndQuizSummaryQueryResult = Apollo.QueryResult<Practice__GetQuizQuestionsAndQuizSummaryQuery, Practice__GetQuizQuestionsAndQuizSummaryQueryVariables>;
export const AddUserQuizSummaryOneDocument = gql`
    mutation addUserQuizSummaryOne($quiz_id: Int!, $is_completed: Boolean = false, $current_position: Int!, $attempt: Int = 1) {
  insert_user_quiz_summaries_one(
    object: {quiz_id: $quiz_id, is_completed: $is_completed, current_position: $current_position, attempt: $attempt}
    on_conflict: {constraint: user_quiz_summaries_user_id_quiz_id_attempt_key, update_columns: [current_position, is_completed]}
  ) {
    is_completed
    id
  }
}
    `;
export type AddUserQuizSummaryOneMutationFn = Apollo.MutationFunction<AddUserQuizSummaryOneMutation, AddUserQuizSummaryOneMutationVariables>;

/**
 * __useAddUserQuizSummaryOneMutation__
 *
 * To run a mutation, you first call `useAddUserQuizSummaryOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserQuizSummaryOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserQuizSummaryOneMutation, { data, loading, error }] = useAddUserQuizSummaryOneMutation({
 *   variables: {
 *      quiz_id: // value for 'quiz_id'
 *      is_completed: // value for 'is_completed'
 *      current_position: // value for 'current_position'
 *      attempt: // value for 'attempt'
 *   },
 * });
 */
export function useAddUserQuizSummaryOneMutation(baseOptions?: Apollo.MutationHookOptions<AddUserQuizSummaryOneMutation, AddUserQuizSummaryOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserQuizSummaryOneMutation, AddUserQuizSummaryOneMutationVariables>(AddUserQuizSummaryOneDocument, options);
      }
export type AddUserQuizSummaryOneMutationHookResult = ReturnType<typeof useAddUserQuizSummaryOneMutation>;
export type AddUserQuizSummaryOneMutationResult = Apollo.MutationResult<AddUserQuizSummaryOneMutation>;
export type AddUserQuizSummaryOneMutationOptions = Apollo.BaseMutationOptions<AddUserQuizSummaryOneMutation, AddUserQuizSummaryOneMutationVariables>;
export const AddUserQuizQuestionSummaryDocument = gql`
    mutation addUserQuizQuestionSummary($data: user_quiz_question_summaries_insert_input!) {
  insert_user_quiz_question_summaries_one(
    object: $data
    on_conflict: {constraint: user_quiz_question_summaries_quiz_summary_id_question_id_key, update_columns: [is_bookmarked, response, is_attempted, time_taken, time_take_to_view_solution]}
  ) {
    id
  }
}
    `;
export type AddUserQuizQuestionSummaryMutationFn = Apollo.MutationFunction<AddUserQuizQuestionSummaryMutation, AddUserQuizQuestionSummaryMutationVariables>;

/**
 * __useAddUserQuizQuestionSummaryMutation__
 *
 * To run a mutation, you first call `useAddUserQuizQuestionSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserQuizQuestionSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserQuizQuestionSummaryMutation, { data, loading, error }] = useAddUserQuizQuestionSummaryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddUserQuizQuestionSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddUserQuizQuestionSummaryMutation, AddUserQuizQuestionSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserQuizQuestionSummaryMutation, AddUserQuizQuestionSummaryMutationVariables>(AddUserQuizQuestionSummaryDocument, options);
      }
export type AddUserQuizQuestionSummaryMutationHookResult = ReturnType<typeof useAddUserQuizQuestionSummaryMutation>;
export type AddUserQuizQuestionSummaryMutationResult = Apollo.MutationResult<AddUserQuizQuestionSummaryMutation>;
export type AddUserQuizQuestionSummaryMutationOptions = Apollo.BaseMutationOptions<AddUserQuizQuestionSummaryMutation, AddUserQuizQuestionSummaryMutationVariables>;
export const UpdateUserAdditionalDetailsDocument = gql`
    mutation UpdateUserAdditionalDetails($object: supertokens_user_additional_fields_insert_input!) {
  insert_supertokens_user_additional_fields_one(
    object: $object
    on_conflict: {constraint: user_additional_fields_user_id_key, update_columns: [first_name, last_name, avatar, city, state, postal_code, gender, age, country, date_of_birth]}
  ) {
    id
    mobile_verified
  }
}
    `;
export type UpdateUserAdditionalDetailsMutationFn = Apollo.MutationFunction<UpdateUserAdditionalDetailsMutation, UpdateUserAdditionalDetailsMutationVariables>;

/**
 * __useUpdateUserAdditionalDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserAdditionalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAdditionalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAdditionalDetailsMutation, { data, loading, error }] = useUpdateUserAdditionalDetailsMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateUserAdditionalDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAdditionalDetailsMutation, UpdateUserAdditionalDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAdditionalDetailsMutation, UpdateUserAdditionalDetailsMutationVariables>(UpdateUserAdditionalDetailsDocument, options);
      }
export type UpdateUserAdditionalDetailsMutationHookResult = ReturnType<typeof useUpdateUserAdditionalDetailsMutation>;
export type UpdateUserAdditionalDetailsMutationResult = Apollo.MutationResult<UpdateUserAdditionalDetailsMutation>;
export type UpdateUserAdditionalDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateUserAdditionalDetailsMutation, UpdateUserAdditionalDetailsMutationVariables>;
export const GetSpeedPreviousQuizSummaryDocument = gql`
    query getSpeedPreviousQuizSummary($category: String!) {
  user_speed_tests_summaries(
    limit: 5
    where: {test_category: {_eq: $category}, is_completed: {_eq: true}}
    order_by: {created_at: desc}
  ) {
    id
    created_at
    test_type
    test_time
    score
  }
}
    `;

/**
 * __useGetSpeedPreviousQuizSummaryQuery__
 *
 * To run a query within a React component, call `useGetSpeedPreviousQuizSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedPreviousQuizSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedPreviousQuizSummaryQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetSpeedPreviousQuizSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedPreviousQuizSummaryQuery, GetSpeedPreviousQuizSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedPreviousQuizSummaryQuery, GetSpeedPreviousQuizSummaryQueryVariables>(GetSpeedPreviousQuizSummaryDocument, options);
      }
export function useGetSpeedPreviousQuizSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedPreviousQuizSummaryQuery, GetSpeedPreviousQuizSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedPreviousQuizSummaryQuery, GetSpeedPreviousQuizSummaryQueryVariables>(GetSpeedPreviousQuizSummaryDocument, options);
        }
export type GetSpeedPreviousQuizSummaryQueryHookResult = ReturnType<typeof useGetSpeedPreviousQuizSummaryQuery>;
export type GetSpeedPreviousQuizSummaryLazyQueryHookResult = ReturnType<typeof useGetSpeedPreviousQuizSummaryLazyQuery>;
export type GetSpeedPreviousQuizSummaryQueryResult = Apollo.QueryResult<GetSpeedPreviousQuizSummaryQuery, GetSpeedPreviousQuizSummaryQueryVariables>;
export const AddSpeedTestQuestionSummaryDocument = gql`
    mutation AddSpeedTestQuestionSummary($data: user_speed_test_questions_summaries_insert_input!) {
  insert_user_speed_test_questions_summaries_one(object: $data) {
    id
    user_speed_tests_summary {
      score
      id
      user_speed_test_questions_summaries_aggregate {
        aggregate {
          count
        }
      }
      correct_questions: user_speed_test_questions_summaries_aggregate(
        where: {is_correct: {_eq: true}}
      ) {
        aggregate {
          count
        }
      }
    }
  }
}
    `;
export type AddSpeedTestQuestionSummaryMutationFn = Apollo.MutationFunction<AddSpeedTestQuestionSummaryMutation, AddSpeedTestQuestionSummaryMutationVariables>;

/**
 * __useAddSpeedTestQuestionSummaryMutation__
 *
 * To run a mutation, you first call `useAddSpeedTestQuestionSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSpeedTestQuestionSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSpeedTestQuestionSummaryMutation, { data, loading, error }] = useAddSpeedTestQuestionSummaryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddSpeedTestQuestionSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddSpeedTestQuestionSummaryMutation, AddSpeedTestQuestionSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSpeedTestQuestionSummaryMutation, AddSpeedTestQuestionSummaryMutationVariables>(AddSpeedTestQuestionSummaryDocument, options);
      }
export type AddSpeedTestQuestionSummaryMutationHookResult = ReturnType<typeof useAddSpeedTestQuestionSummaryMutation>;
export type AddSpeedTestQuestionSummaryMutationResult = Apollo.MutationResult<AddSpeedTestQuestionSummaryMutation>;
export type AddSpeedTestQuestionSummaryMutationOptions = Apollo.BaseMutationOptions<AddSpeedTestQuestionSummaryMutation, AddSpeedTestQuestionSummaryMutationVariables>;
export const SubmitSpeedTestSummaryDocument = gql`
    mutation submitSpeedTestSummary($id: uuid!) {
  update_user_speed_tests_summaries_by_pk(
    pk_columns: {id: $id}
    _set: {is_completed: true}
  ) {
    id
  }
}
    `;
export type SubmitSpeedTestSummaryMutationFn = Apollo.MutationFunction<SubmitSpeedTestSummaryMutation, SubmitSpeedTestSummaryMutationVariables>;

/**
 * __useSubmitSpeedTestSummaryMutation__
 *
 * To run a mutation, you first call `useSubmitSpeedTestSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSpeedTestSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSpeedTestSummaryMutation, { data, loading, error }] = useSubmitSpeedTestSummaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitSpeedTestSummaryMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSpeedTestSummaryMutation, SubmitSpeedTestSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSpeedTestSummaryMutation, SubmitSpeedTestSummaryMutationVariables>(SubmitSpeedTestSummaryDocument, options);
      }
export type SubmitSpeedTestSummaryMutationHookResult = ReturnType<typeof useSubmitSpeedTestSummaryMutation>;
export type SubmitSpeedTestSummaryMutationResult = Apollo.MutationResult<SubmitSpeedTestSummaryMutation>;
export type SubmitSpeedTestSummaryMutationOptions = Apollo.BaseMutationOptions<SubmitSpeedTestSummaryMutation, SubmitSpeedTestSummaryMutationVariables>;
export const GetSpeedConceptQuizzesDocument = gql`
    query GetSpeedConceptQuizzes($slug: String!) {
  quiz_quiz(where: {quiz_category: {slug: {_eq: $slug}}}) {
    name
    slug
    id
    total_number_of_questions
    time_limit
    quiz_category {
      name
      slug
    }
    quiz_quiz_questions_aggregate {
      aggregate {
        count
      }
    }
    user_speed_tests_summaries(limit: 1, order_by: {created_at: desc}) {
      id
      score
      is_completed
      created_at
      user_speed_test_questions_summaries_aggregate(
        where: {is_attempted: {_eq: true}}
        distinct_on: quiz_question_id
      ) {
        aggregate {
          count
        }
      }
      correct_questions: user_speed_test_questions_summaries_aggregate(
        where: {is_correct: {_eq: true}}
      ) {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetSpeedConceptQuizzesQuery__
 *
 * To run a query within a React component, call `useGetSpeedConceptQuizzesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedConceptQuizzesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedConceptQuizzesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetSpeedConceptQuizzesQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedConceptQuizzesQuery, GetSpeedConceptQuizzesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedConceptQuizzesQuery, GetSpeedConceptQuizzesQueryVariables>(GetSpeedConceptQuizzesDocument, options);
      }
export function useGetSpeedConceptQuizzesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedConceptQuizzesQuery, GetSpeedConceptQuizzesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedConceptQuizzesQuery, GetSpeedConceptQuizzesQueryVariables>(GetSpeedConceptQuizzesDocument, options);
        }
export type GetSpeedConceptQuizzesQueryHookResult = ReturnType<typeof useGetSpeedConceptQuizzesQuery>;
export type GetSpeedConceptQuizzesLazyQueryHookResult = ReturnType<typeof useGetSpeedConceptQuizzesLazyQuery>;
export type GetSpeedConceptQuizzesQueryResult = Apollo.QueryResult<GetSpeedConceptQuizzesQuery, GetSpeedConceptQuizzesQueryVariables>;
export const AddSpeedConceptSummaryDocument = gql`
    mutation addSpeedConceptSummary($quiz_id: Int!, $type: String!, $time: Int!, $config: json!) {
  insert_user_speed_tests_summaries_one(
    object: {quiz_id: $quiz_id, test_category: "concept", test_time: $time, test_type: $type, config: $config}
  ) {
    id
  }
}
    `;
export type AddSpeedConceptSummaryMutationFn = Apollo.MutationFunction<AddSpeedConceptSummaryMutation, AddSpeedConceptSummaryMutationVariables>;

/**
 * __useAddSpeedConceptSummaryMutation__
 *
 * To run a mutation, you first call `useAddSpeedConceptSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSpeedConceptSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSpeedConceptSummaryMutation, { data, loading, error }] = useAddSpeedConceptSummaryMutation({
 *   variables: {
 *      quiz_id: // value for 'quiz_id'
 *      type: // value for 'type'
 *      time: // value for 'time'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useAddSpeedConceptSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddSpeedConceptSummaryMutation, AddSpeedConceptSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSpeedConceptSummaryMutation, AddSpeedConceptSummaryMutationVariables>(AddSpeedConceptSummaryDocument, options);
      }
export type AddSpeedConceptSummaryMutationHookResult = ReturnType<typeof useAddSpeedConceptSummaryMutation>;
export type AddSpeedConceptSummaryMutationResult = Apollo.MutationResult<AddSpeedConceptSummaryMutation>;
export type AddSpeedConceptSummaryMutationOptions = Apollo.BaseMutationOptions<AddSpeedConceptSummaryMutation, AddSpeedConceptSummaryMutationVariables>;
export const GetSpeedConceptDetailsDocument = gql`
    query GetSpeedConceptDetails($id: uuid!) {
  user_speed_tests_summaries_by_pk(id: $id) {
    created_at
    updated_at
    config
    is_completed
    score
    id
    quiz_id
    quiz_quiz {
      quiz_quiz_questions_aggregate {
        aggregate {
          count
        }
      }
    }
    attempted_questions: user_speed_test_questions_summaries_aggregate {
      aggregate {
        count
      }
    }
    last_attempted_question: user_speed_test_questions_summaries(
      order_by: {created_at: desc}
      limit: 1
    ) {
      id
    }
    correct_questions: user_speed_test_questions_summaries_aggregate(
      where: {is_correct: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetSpeedConceptDetailsQuery__
 *
 * To run a query within a React component, call `useGetSpeedConceptDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedConceptDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedConceptDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpeedConceptDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedConceptDetailsQuery, GetSpeedConceptDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedConceptDetailsQuery, GetSpeedConceptDetailsQueryVariables>(GetSpeedConceptDetailsDocument, options);
      }
export function useGetSpeedConceptDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedConceptDetailsQuery, GetSpeedConceptDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedConceptDetailsQuery, GetSpeedConceptDetailsQueryVariables>(GetSpeedConceptDetailsDocument, options);
        }
export type GetSpeedConceptDetailsQueryHookResult = ReturnType<typeof useGetSpeedConceptDetailsQuery>;
export type GetSpeedConceptDetailsLazyQueryHookResult = ReturnType<typeof useGetSpeedConceptDetailsLazyQuery>;
export type GetSpeedConceptDetailsQueryResult = Apollo.QueryResult<GetSpeedConceptDetailsQuery, GetSpeedConceptDetailsQueryVariables>;
export const SpeedConcepts__GetRandomQuestionDocument = gql`
    query SpeedConcepts__GetRandomQuestion($user_speed_test_summary_id_args: uuid!) {
  get_speed_concepts_random_question(
    args: {user_speed_test_summary_id_args: $user_speed_test_summary_id_args}
  ) {
    question_id
    quiz_question {
      name
      question_type
      options {
        is_correct
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSpeedConcepts__GetRandomQuestionQuery__
 *
 * To run a query within a React component, call `useSpeedConcepts__GetRandomQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpeedConcepts__GetRandomQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpeedConcepts__GetRandomQuestionQuery({
 *   variables: {
 *      user_speed_test_summary_id_args: // value for 'user_speed_test_summary_id_args'
 *   },
 * });
 */
export function useSpeedConcepts__GetRandomQuestionQuery(baseOptions: Apollo.QueryHookOptions<SpeedConcepts__GetRandomQuestionQuery, SpeedConcepts__GetRandomQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpeedConcepts__GetRandomQuestionQuery, SpeedConcepts__GetRandomQuestionQueryVariables>(SpeedConcepts__GetRandomQuestionDocument, options);
      }
export function useSpeedConcepts__GetRandomQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpeedConcepts__GetRandomQuestionQuery, SpeedConcepts__GetRandomQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpeedConcepts__GetRandomQuestionQuery, SpeedConcepts__GetRandomQuestionQueryVariables>(SpeedConcepts__GetRandomQuestionDocument, options);
        }
export type SpeedConcepts__GetRandomQuestionQueryHookResult = ReturnType<typeof useSpeedConcepts__GetRandomQuestionQuery>;
export type SpeedConcepts__GetRandomQuestionLazyQueryHookResult = ReturnType<typeof useSpeedConcepts__GetRandomQuestionLazyQuery>;
export type SpeedConcepts__GetRandomQuestionQueryResult = Apollo.QueryResult<SpeedConcepts__GetRandomQuestionQuery, SpeedConcepts__GetRandomQuestionQueryVariables>;
export const SpeedConcepts__GetRandomQuestionsDocument = gql`
    query SpeedConcepts__GetRandomQuestions($user_speed_test_summary_id_args: uuid!) {
  get_speed_concepts_all_random_questions(
    args: {user_speed_test_summary_id_args: $user_speed_test_summary_id_args}
  ) {
    question_id
    quiz_question {
      name
      question_type
      options {
        is_correct
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSpeedConcepts__GetRandomQuestionsQuery__
 *
 * To run a query within a React component, call `useSpeedConcepts__GetRandomQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpeedConcepts__GetRandomQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpeedConcepts__GetRandomQuestionsQuery({
 *   variables: {
 *      user_speed_test_summary_id_args: // value for 'user_speed_test_summary_id_args'
 *   },
 * });
 */
export function useSpeedConcepts__GetRandomQuestionsQuery(baseOptions: Apollo.QueryHookOptions<SpeedConcepts__GetRandomQuestionsQuery, SpeedConcepts__GetRandomQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpeedConcepts__GetRandomQuestionsQuery, SpeedConcepts__GetRandomQuestionsQueryVariables>(SpeedConcepts__GetRandomQuestionsDocument, options);
      }
export function useSpeedConcepts__GetRandomQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpeedConcepts__GetRandomQuestionsQuery, SpeedConcepts__GetRandomQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpeedConcepts__GetRandomQuestionsQuery, SpeedConcepts__GetRandomQuestionsQueryVariables>(SpeedConcepts__GetRandomQuestionsDocument, options);
        }
export type SpeedConcepts__GetRandomQuestionsQueryHookResult = ReturnType<typeof useSpeedConcepts__GetRandomQuestionsQuery>;
export type SpeedConcepts__GetRandomQuestionsLazyQueryHookResult = ReturnType<typeof useSpeedConcepts__GetRandomQuestionsLazyQuery>;
export type SpeedConcepts__GetRandomQuestionsQueryResult = Apollo.QueryResult<SpeedConcepts__GetRandomQuestionsQuery, SpeedConcepts__GetRandomQuestionsQueryVariables>;
export const AddUserSpeedMathSummaryDocument = gql`
    mutation AddUserSpeedMathSummary($test_time: Int!, $config: json!, $test_type: String!) {
  insert_user_speed_tests_summaries_one(
    object: {test_time: $test_time, test_category: "math", config: $config, test_type: $test_type}
  ) {
    id
  }
}
    `;
export type AddUserSpeedMathSummaryMutationFn = Apollo.MutationFunction<AddUserSpeedMathSummaryMutation, AddUserSpeedMathSummaryMutationVariables>;

/**
 * __useAddUserSpeedMathSummaryMutation__
 *
 * To run a mutation, you first call `useAddUserSpeedMathSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserSpeedMathSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserSpeedMathSummaryMutation, { data, loading, error }] = useAddUserSpeedMathSummaryMutation({
 *   variables: {
 *      test_time: // value for 'test_time'
 *      config: // value for 'config'
 *      test_type: // value for 'test_type'
 *   },
 * });
 */
export function useAddUserSpeedMathSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddUserSpeedMathSummaryMutation, AddUserSpeedMathSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserSpeedMathSummaryMutation, AddUserSpeedMathSummaryMutationVariables>(AddUserSpeedMathSummaryDocument, options);
      }
export type AddUserSpeedMathSummaryMutationHookResult = ReturnType<typeof useAddUserSpeedMathSummaryMutation>;
export type AddUserSpeedMathSummaryMutationResult = Apollo.MutationResult<AddUserSpeedMathSummaryMutation>;
export type AddUserSpeedMathSummaryMutationOptions = Apollo.BaseMutationOptions<AddUserSpeedMathSummaryMutation, AddUserSpeedMathSummaryMutationVariables>;
export const GetSpeedTestWeeklyStatusChartDocument = gql`
    query GetSpeedTestWeeklyStatusChart($last7Days: timestamptz!) {
  user_speed_tests_summaries(where: {created_at: {_gte: $last7Days}}) {
    id
    created_at
  }
}
    `;

/**
 * __useGetSpeedTestWeeklyStatusChartQuery__
 *
 * To run a query within a React component, call `useGetSpeedTestWeeklyStatusChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedTestWeeklyStatusChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedTestWeeklyStatusChartQuery({
 *   variables: {
 *      last7Days: // value for 'last7Days'
 *   },
 * });
 */
export function useGetSpeedTestWeeklyStatusChartQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedTestWeeklyStatusChartQuery, GetSpeedTestWeeklyStatusChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedTestWeeklyStatusChartQuery, GetSpeedTestWeeklyStatusChartQueryVariables>(GetSpeedTestWeeklyStatusChartDocument, options);
      }
export function useGetSpeedTestWeeklyStatusChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedTestWeeklyStatusChartQuery, GetSpeedTestWeeklyStatusChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedTestWeeklyStatusChartQuery, GetSpeedTestWeeklyStatusChartQueryVariables>(GetSpeedTestWeeklyStatusChartDocument, options);
        }
export type GetSpeedTestWeeklyStatusChartQueryHookResult = ReturnType<typeof useGetSpeedTestWeeklyStatusChartQuery>;
export type GetSpeedTestWeeklyStatusChartLazyQueryHookResult = ReturnType<typeof useGetSpeedTestWeeklyStatusChartLazyQuery>;
export type GetSpeedTestWeeklyStatusChartQueryResult = Apollo.QueryResult<GetSpeedTestWeeklyStatusChartQuery, GetSpeedTestWeeklyStatusChartQueryVariables>;
export const GetSpeedMathDetailsDocument = gql`
    query GetSpeedMathDetails($id: uuid!) {
  user_speed_tests_summaries_by_pk(id: $id) {
    id
    score
    created_at
    updated_at
    config
    user_speed_test_questions_summaries(order_by: {created_at: desc}) {
      question
    }
    last_attempted_question: user_speed_test_questions_summaries(
      order_by: {created_at: desc}
      where: {is_attempted: {_eq: true}}
      limit: 1
    ) {
      id
      question
      time_taken
    }
    user_speed_test_questions_summaries_aggregate {
      aggregate {
        count
      }
    }
    correct_questions: user_speed_test_questions_summaries_aggregate(
      where: {is_correct: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    attempted_questions: user_speed_test_questions_summaries_aggregate(
      where: {is_attempted: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    total_time_taken: user_speed_test_questions_summaries_aggregate {
      aggregate {
        sum {
          time_taken
        }
      }
    }
  }
}
    `;

/**
 * __useGetSpeedMathDetailsQuery__
 *
 * To run a query within a React component, call `useGetSpeedMathDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedMathDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedMathDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpeedMathDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedMathDetailsQuery, GetSpeedMathDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedMathDetailsQuery, GetSpeedMathDetailsQueryVariables>(GetSpeedMathDetailsDocument, options);
      }
export function useGetSpeedMathDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedMathDetailsQuery, GetSpeedMathDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedMathDetailsQuery, GetSpeedMathDetailsQueryVariables>(GetSpeedMathDetailsDocument, options);
        }
export type GetSpeedMathDetailsQueryHookResult = ReturnType<typeof useGetSpeedMathDetailsQuery>;
export type GetSpeedMathDetailsLazyQueryHookResult = ReturnType<typeof useGetSpeedMathDetailsLazyQuery>;
export type GetSpeedMathDetailsQueryResult = Apollo.QueryResult<GetSpeedMathDetailsQuery, GetSpeedMathDetailsQueryVariables>;
export const GetSpeedMathQuestionDetailsDocument = gql`
    query GetSpeedMathQuestionDetails($questionID: uuid!) {
  user_speed_test_questions_summaries_by_pk(id: $questionID) {
    id
    question
    answer
    is_attempted
    response
    question_number
  }
}
    `;

/**
 * __useGetSpeedMathQuestionDetailsQuery__
 *
 * To run a query within a React component, call `useGetSpeedMathQuestionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedMathQuestionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedMathQuestionDetailsQuery({
 *   variables: {
 *      questionID: // value for 'questionID'
 *   },
 * });
 */
export function useGetSpeedMathQuestionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedMathQuestionDetailsQuery, GetSpeedMathQuestionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedMathQuestionDetailsQuery, GetSpeedMathQuestionDetailsQueryVariables>(GetSpeedMathQuestionDetailsDocument, options);
      }
export function useGetSpeedMathQuestionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedMathQuestionDetailsQuery, GetSpeedMathQuestionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedMathQuestionDetailsQuery, GetSpeedMathQuestionDetailsQueryVariables>(GetSpeedMathQuestionDetailsDocument, options);
        }
export type GetSpeedMathQuestionDetailsQueryHookResult = ReturnType<typeof useGetSpeedMathQuestionDetailsQuery>;
export type GetSpeedMathQuestionDetailsLazyQueryHookResult = ReturnType<typeof useGetSpeedMathQuestionDetailsLazyQuery>;
export type GetSpeedMathQuestionDetailsQueryResult = Apollo.QueryResult<GetSpeedMathQuestionDetailsQuery, GetSpeedMathQuestionDetailsQueryVariables>;
export const AddSpeedMathQuestionDocument = gql`
    mutation AddSpeedMathQuestion($answer: String!, $question: String!, $userSpeedTestSummaryID: uuid!) {
  insert_user_speed_test_questions_summaries_one(
    object: {answer: $answer, question: $question, is_attempted: false, user_speed_test_summary_id: $userSpeedTestSummaryID}
  ) {
    id
  }
}
    `;
export type AddSpeedMathQuestionMutationFn = Apollo.MutationFunction<AddSpeedMathQuestionMutation, AddSpeedMathQuestionMutationVariables>;

/**
 * __useAddSpeedMathQuestionMutation__
 *
 * To run a mutation, you first call `useAddSpeedMathQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSpeedMathQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSpeedMathQuestionMutation, { data, loading, error }] = useAddSpeedMathQuestionMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *      question: // value for 'question'
 *      userSpeedTestSummaryID: // value for 'userSpeedTestSummaryID'
 *   },
 * });
 */
export function useAddSpeedMathQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AddSpeedMathQuestionMutation, AddSpeedMathQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSpeedMathQuestionMutation, AddSpeedMathQuestionMutationVariables>(AddSpeedMathQuestionDocument, options);
      }
export type AddSpeedMathQuestionMutationHookResult = ReturnType<typeof useAddSpeedMathQuestionMutation>;
export type AddSpeedMathQuestionMutationResult = Apollo.MutationResult<AddSpeedMathQuestionMutation>;
export type AddSpeedMathQuestionMutationOptions = Apollo.BaseMutationOptions<AddSpeedMathQuestionMutation, AddSpeedMathQuestionMutationVariables>;
export const SubmitSpeedMathAnswerDocument = gql`
    mutation SubmitSpeedMathAnswer($questionID: uuid!, $response: String!, $is_attempted: Boolean!, $time_taken: Int!) {
  update_user_speed_test_questions_summaries_by_pk(
    pk_columns: {id: $questionID}
    _set: {response: $response, time_taken: $time_taken, is_attempted: $is_attempted}
  ) {
    id
    question
  }
}
    `;
export type SubmitSpeedMathAnswerMutationFn = Apollo.MutationFunction<SubmitSpeedMathAnswerMutation, SubmitSpeedMathAnswerMutationVariables>;

/**
 * __useSubmitSpeedMathAnswerMutation__
 *
 * To run a mutation, you first call `useSubmitSpeedMathAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSpeedMathAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSpeedMathAnswerMutation, { data, loading, error }] = useSubmitSpeedMathAnswerMutation({
 *   variables: {
 *      questionID: // value for 'questionID'
 *      response: // value for 'response'
 *      is_attempted: // value for 'is_attempted'
 *      time_taken: // value for 'time_taken'
 *   },
 * });
 */
export function useSubmitSpeedMathAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSpeedMathAnswerMutation, SubmitSpeedMathAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSpeedMathAnswerMutation, SubmitSpeedMathAnswerMutationVariables>(SubmitSpeedMathAnswerDocument, options);
      }
export type SubmitSpeedMathAnswerMutationHookResult = ReturnType<typeof useSubmitSpeedMathAnswerMutation>;
export type SubmitSpeedMathAnswerMutationResult = Apollo.MutationResult<SubmitSpeedMathAnswerMutation>;
export type SubmitSpeedMathAnswerMutationOptions = Apollo.BaseMutationOptions<SubmitSpeedMathAnswerMutation, SubmitSpeedMathAnswerMutationVariables>;
export const SpeedMath__DeleteUnattemptedQuestionsDocument = gql`
    mutation SpeedMath__deleteUnattemptedQuestions {
  delete_user_speed_test_questions_summaries(where: {is_attempted: {_eq: false}}) {
    affected_rows
  }
}
    `;
export type SpeedMath__DeleteUnattemptedQuestionsMutationFn = Apollo.MutationFunction<SpeedMath__DeleteUnattemptedQuestionsMutation, SpeedMath__DeleteUnattemptedQuestionsMutationVariables>;

/**
 * __useSpeedMath__DeleteUnattemptedQuestionsMutation__
 *
 * To run a mutation, you first call `useSpeedMath__DeleteUnattemptedQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpeedMath__DeleteUnattemptedQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [speedMathDeleteUnattemptedQuestionsMutation, { data, loading, error }] = useSpeedMath__DeleteUnattemptedQuestionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSpeedMath__DeleteUnattemptedQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<SpeedMath__DeleteUnattemptedQuestionsMutation, SpeedMath__DeleteUnattemptedQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpeedMath__DeleteUnattemptedQuestionsMutation, SpeedMath__DeleteUnattemptedQuestionsMutationVariables>(SpeedMath__DeleteUnattemptedQuestionsDocument, options);
      }
export type SpeedMath__DeleteUnattemptedQuestionsMutationHookResult = ReturnType<typeof useSpeedMath__DeleteUnattemptedQuestionsMutation>;
export type SpeedMath__DeleteUnattemptedQuestionsMutationResult = Apollo.MutationResult<SpeedMath__DeleteUnattemptedQuestionsMutation>;
export type SpeedMath__DeleteUnattemptedQuestionsMutationOptions = Apollo.BaseMutationOptions<SpeedMath__DeleteUnattemptedQuestionsMutation, SpeedMath__DeleteUnattemptedQuestionsMutationVariables>;
export const AddUserSpeedQuantSummaryDocument = gql`
    mutation AddUserSpeedQuantSummary($test_time: Int!, $config: json!, $quiz_id: Int!, $test_type: String!) {
  insert_user_speed_tests_summaries_one(
    object: {test_time: $test_time, test_category: "quant", config: $config, quiz_id: $quiz_id, test_type: $test_type}
  ) {
    id
  }
}
    `;
export type AddUserSpeedQuantSummaryMutationFn = Apollo.MutationFunction<AddUserSpeedQuantSummaryMutation, AddUserSpeedQuantSummaryMutationVariables>;

/**
 * __useAddUserSpeedQuantSummaryMutation__
 *
 * To run a mutation, you first call `useAddUserSpeedQuantSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserSpeedQuantSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserSpeedQuantSummaryMutation, { data, loading, error }] = useAddUserSpeedQuantSummaryMutation({
 *   variables: {
 *      test_time: // value for 'test_time'
 *      config: // value for 'config'
 *      quiz_id: // value for 'quiz_id'
 *      test_type: // value for 'test_type'
 *   },
 * });
 */
export function useAddUserSpeedQuantSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddUserSpeedQuantSummaryMutation, AddUserSpeedQuantSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserSpeedQuantSummaryMutation, AddUserSpeedQuantSummaryMutationVariables>(AddUserSpeedQuantSummaryDocument, options);
      }
export type AddUserSpeedQuantSummaryMutationHookResult = ReturnType<typeof useAddUserSpeedQuantSummaryMutation>;
export type AddUserSpeedQuantSummaryMutationResult = Apollo.MutationResult<AddUserSpeedQuantSummaryMutation>;
export type AddUserSpeedQuantSummaryMutationOptions = Apollo.BaseMutationOptions<AddUserSpeedQuantSummaryMutation, AddUserSpeedQuantSummaryMutationVariables>;
export const LastSpeedSummaryForTodayDocument = gql`
    query lastSpeedSummaryForToday($date: timestamptz!, $category: String!) {
  user_speed_tests_summaries(
    where: {updated_at: {_gte: $date}, test_category: {_eq: $category}}
    order_by: {updated_at: desc}
    limit: 1
  ) {
    id
  }
}
    `;

/**
 * __useLastSpeedSummaryForTodayQuery__
 *
 * To run a query within a React component, call `useLastSpeedSummaryForTodayQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastSpeedSummaryForTodayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastSpeedSummaryForTodayQuery({
 *   variables: {
 *      date: // value for 'date'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useLastSpeedSummaryForTodayQuery(baseOptions: Apollo.QueryHookOptions<LastSpeedSummaryForTodayQuery, LastSpeedSummaryForTodayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastSpeedSummaryForTodayQuery, LastSpeedSummaryForTodayQueryVariables>(LastSpeedSummaryForTodayDocument, options);
      }
export function useLastSpeedSummaryForTodayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastSpeedSummaryForTodayQuery, LastSpeedSummaryForTodayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastSpeedSummaryForTodayQuery, LastSpeedSummaryForTodayQueryVariables>(LastSpeedSummaryForTodayDocument, options);
        }
export type LastSpeedSummaryForTodayQueryHookResult = ReturnType<typeof useLastSpeedSummaryForTodayQuery>;
export type LastSpeedSummaryForTodayLazyQueryHookResult = ReturnType<typeof useLastSpeedSummaryForTodayLazyQuery>;
export type LastSpeedSummaryForTodayQueryResult = Apollo.QueryResult<LastSpeedSummaryForTodayQuery, LastSpeedSummaryForTodayQueryVariables>;
export const GetSpeedQuantDetailsDocument = gql`
    query GetSpeedQuantDetails($id: uuid!) {
  user_speed_tests_summaries_by_pk(id: $id) {
    created_at
    is_completed
    updated_at
    config
    score
    user_speed_test_questions_summaries(
      order_by: {created_at: desc}
      where: {is_attempted: {_eq: true}}
    ) {
      id
      quiz_question_id
    }
    last_attempted_question: user_speed_test_questions_summaries(
      order_by: {created_at: desc}
      where: {is_attempted: {_eq: true}}
      limit: 1
    ) {
      id
    }
    user_speed_test_questions_summaries_aggregate {
      aggregate {
        count
      }
    }
    correct_questions: user_speed_test_questions_summaries_aggregate(
      where: {is_correct: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    attempted_questions: user_speed_test_questions_summaries_aggregate(
      where: {is_attempted: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    total_time_taken: user_speed_test_questions_summaries_aggregate {
      aggregate {
        sum {
          time_taken
        }
      }
    }
  }
}
    `;

/**
 * __useGetSpeedQuantDetailsQuery__
 *
 * To run a query within a React component, call `useGetSpeedQuantDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedQuantDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedQuantDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpeedQuantDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedQuantDetailsQuery, GetSpeedQuantDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedQuantDetailsQuery, GetSpeedQuantDetailsQueryVariables>(GetSpeedQuantDetailsDocument, options);
      }
export function useGetSpeedQuantDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedQuantDetailsQuery, GetSpeedQuantDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedQuantDetailsQuery, GetSpeedQuantDetailsQueryVariables>(GetSpeedQuantDetailsDocument, options);
        }
export type GetSpeedQuantDetailsQueryHookResult = ReturnType<typeof useGetSpeedQuantDetailsQuery>;
export type GetSpeedQuantDetailsLazyQueryHookResult = ReturnType<typeof useGetSpeedQuantDetailsLazyQuery>;
export type GetSpeedQuantDetailsQueryResult = Apollo.QueryResult<GetSpeedQuantDetailsQuery, GetSpeedQuantDetailsQueryVariables>;
export const GetSpeedVerbalDetailsDocument = gql`
    query GetSpeedVerbalDetails($id: uuid!) {
  user_speed_tests_summaries_by_pk(id: $id) {
    created_at
    updated_at
    score
    config
    user_speed_test_questions_summaries(
      order_by: {created_at: desc}
      where: {is_attempted: {_eq: false}}
    ) {
      id
    }
    last_attempted_question: user_speed_test_questions_summaries(
      order_by: {created_at: desc}
      where: {is_attempted: {_eq: true}}
      limit: 1
    ) {
      id
    }
    user_speed_test_questions_summaries_aggregate {
      aggregate {
        count
      }
    }
    correct_questions: user_speed_test_questions_summaries_aggregate(
      where: {is_correct: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    attempted_questions: user_speed_test_questions_summaries_aggregate(
      where: {is_attempted: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    total_time_taken: user_speed_test_questions_summaries_aggregate {
      aggregate {
        sum {
          time_taken
        }
      }
    }
  }
}
    `;

/**
 * __useGetSpeedVerbalDetailsQuery__
 *
 * To run a query within a React component, call `useGetSpeedVerbalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedVerbalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedVerbalDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpeedVerbalDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedVerbalDetailsQuery, GetSpeedVerbalDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedVerbalDetailsQuery, GetSpeedVerbalDetailsQueryVariables>(GetSpeedVerbalDetailsDocument, options);
      }
export function useGetSpeedVerbalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedVerbalDetailsQuery, GetSpeedVerbalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedVerbalDetailsQuery, GetSpeedVerbalDetailsQueryVariables>(GetSpeedVerbalDetailsDocument, options);
        }
export type GetSpeedVerbalDetailsQueryHookResult = ReturnType<typeof useGetSpeedVerbalDetailsQuery>;
export type GetSpeedVerbalDetailsLazyQueryHookResult = ReturnType<typeof useGetSpeedVerbalDetailsLazyQuery>;
export type GetSpeedVerbalDetailsQueryResult = Apollo.QueryResult<GetSpeedVerbalDetailsQuery, GetSpeedVerbalDetailsQueryVariables>;
export const AddUserSpeedVerbalSummaryDocument = gql`
    mutation AddUserSpeedVerbalSummary($test_time: Int!, $config: json!, $test_type: String!, $quiz_id: Int!) {
  insert_user_speed_tests_summaries_one(
    object: {test_time: $test_time, test_category: "verbal", config: $config, test_type: $test_type, quiz_id: $quiz_id}
  ) {
    id
  }
}
    `;
export type AddUserSpeedVerbalSummaryMutationFn = Apollo.MutationFunction<AddUserSpeedVerbalSummaryMutation, AddUserSpeedVerbalSummaryMutationVariables>;

/**
 * __useAddUserSpeedVerbalSummaryMutation__
 *
 * To run a mutation, you first call `useAddUserSpeedVerbalSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserSpeedVerbalSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserSpeedVerbalSummaryMutation, { data, loading, error }] = useAddUserSpeedVerbalSummaryMutation({
 *   variables: {
 *      test_time: // value for 'test_time'
 *      config: // value for 'config'
 *      test_type: // value for 'test_type'
 *      quiz_id: // value for 'quiz_id'
 *   },
 * });
 */
export function useAddUserSpeedVerbalSummaryMutation(baseOptions?: Apollo.MutationHookOptions<AddUserSpeedVerbalSummaryMutation, AddUserSpeedVerbalSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserSpeedVerbalSummaryMutation, AddUserSpeedVerbalSummaryMutationVariables>(AddUserSpeedVerbalSummaryDocument, options);
      }
export type AddUserSpeedVerbalSummaryMutationHookResult = ReturnType<typeof useAddUserSpeedVerbalSummaryMutation>;
export type AddUserSpeedVerbalSummaryMutationResult = Apollo.MutationResult<AddUserSpeedVerbalSummaryMutation>;
export type AddUserSpeedVerbalSummaryMutationOptions = Apollo.BaseMutationOptions<AddUserSpeedVerbalSummaryMutation, AddUserSpeedVerbalSummaryMutationVariables>;
export const CreateMeetingDocument = gql`
    mutation createMeeting($title: String!, $description: String, $token: String!) {
  createMeeting(title: $title, description: $description, token: $token) {
    success
    message
  }
}
    `;
export type CreateMeetingMutationFn = Apollo.MutationFunction<CreateMeetingMutation, CreateMeetingMutationVariables>;

/**
 * __useCreateMeetingMutation__
 *
 * To run a mutation, you first call `useCreateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingMutation, { data, loading, error }] = useCreateMeetingMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCreateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeetingMutation, CreateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeetingMutation, CreateMeetingMutationVariables>(CreateMeetingDocument, options);
      }
export type CreateMeetingMutationHookResult = ReturnType<typeof useCreateMeetingMutation>;
export type CreateMeetingMutationResult = Apollo.MutationResult<CreateMeetingMutation>;
export type CreateMeetingMutationOptions = Apollo.BaseMutationOptions<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const GetMeetingsDocument = gql`
    query getMeetings($limit: Int = 10, $offset: Int = 0) {
  meetings(order_by: {created_at: desc}, limit: $limit, offset: $offset) {
    id
    meeting_id
    title
    description
    meeting_members {
      id
      updated_at
    }
  }
}
    `;

/**
 * __useGetMeetingsQuery__
 *
 * To run a query within a React component, call `useGetMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetMeetingsQuery(baseOptions?: Apollo.QueryHookOptions<GetMeetingsQuery, GetMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingsQuery, GetMeetingsQueryVariables>(GetMeetingsDocument, options);
      }
export function useGetMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingsQuery, GetMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingsQuery, GetMeetingsQueryVariables>(GetMeetingsDocument, options);
        }
export type GetMeetingsQueryHookResult = ReturnType<typeof useGetMeetingsQuery>;
export type GetMeetingsLazyQueryHookResult = ReturnType<typeof useGetMeetingsLazyQuery>;
export type GetMeetingsQueryResult = Apollo.QueryResult<GetMeetingsQuery, GetMeetingsQueryVariables>;
export const JoinMeetingDocument = gql`
    mutation joinMeeting($meetingId: String!, $token: String!) {
  joinMeeting(meetingId: $meetingId, token: $token) {
    success
    message
  }
}
    `;
export type JoinMeetingMutationFn = Apollo.MutationFunction<JoinMeetingMutation, JoinMeetingMutationVariables>;

/**
 * __useJoinMeetingMutation__
 *
 * To run a mutation, you first call `useJoinMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinMeetingMutation, { data, loading, error }] = useJoinMeetingMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useJoinMeetingMutation(baseOptions?: Apollo.MutationHookOptions<JoinMeetingMutation, JoinMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinMeetingMutation, JoinMeetingMutationVariables>(JoinMeetingDocument, options);
      }
export type JoinMeetingMutationHookResult = ReturnType<typeof useJoinMeetingMutation>;
export type JoinMeetingMutationResult = Apollo.MutationResult<JoinMeetingMutation>;
export type JoinMeetingMutationOptions = Apollo.BaseMutationOptions<JoinMeetingMutation, JoinMeetingMutationVariables>;
export const GetMeetingByIdDocument = gql`
    query getMeetingById($id: String!) {
  meetings(where: {meeting_id: {_eq: $id}}) {
    description
    title
  }
}
    `;

/**
 * __useGetMeetingByIdQuery__
 *
 * To run a query within a React component, call `useGetMeetingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMeetingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMeetingByIdQuery, GetMeetingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingByIdQuery, GetMeetingByIdQueryVariables>(GetMeetingByIdDocument, options);
      }
export function useGetMeetingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingByIdQuery, GetMeetingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingByIdQuery, GetMeetingByIdQueryVariables>(GetMeetingByIdDocument, options);
        }
export type GetMeetingByIdQueryHookResult = ReturnType<typeof useGetMeetingByIdQuery>;
export type GetMeetingByIdLazyQueryHookResult = ReturnType<typeof useGetMeetingByIdLazyQuery>;
export type GetMeetingByIdQueryResult = Apollo.QueryResult<GetMeetingByIdQuery, GetMeetingByIdQueryVariables>;
export const GetLeaderboardDocument = gql`
    query GetLeaderboard($category: String!, $type: String!, $sub_type: String!) {
  user_leaderboards(
    where: {category: {_eq: $category}, type: {_eq: $type}, sub_type: {_eq: $sub_type}}
    order_by: {rank: asc}
    limit: 15
  ) {
    rank
    score
    user {
      username
      avatar
      first_name
      last_name
    }
  }
}
    `;

/**
 * __useGetLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderboardQuery({
 *   variables: {
 *      category: // value for 'category'
 *      type: // value for 'type'
 *      sub_type: // value for 'sub_type'
 *   },
 * });
 */
export function useGetLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<GetLeaderboardQuery, GetLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaderboardQuery, GetLeaderboardQueryVariables>(GetLeaderboardDocument, options);
      }
export function useGetLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaderboardQuery, GetLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaderboardQuery, GetLeaderboardQueryVariables>(GetLeaderboardDocument, options);
        }
export type GetLeaderboardQueryHookResult = ReturnType<typeof useGetLeaderboardQuery>;
export type GetLeaderboardLazyQueryHookResult = ReturnType<typeof useGetLeaderboardLazyQuery>;
export type GetLeaderboardQueryResult = Apollo.QueryResult<GetLeaderboardQuery, GetLeaderboardQueryVariables>;
export const DownloadUsersDataDocument = gql`
    query downloadUsersData {
  downloadUsersData {
    success
    message
  }
}
    `;

/**
 * __useDownloadUsersDataQuery__
 *
 * To run a query within a React component, call `useDownloadUsersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadUsersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadUsersDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useDownloadUsersDataQuery(baseOptions?: Apollo.QueryHookOptions<DownloadUsersDataQuery, DownloadUsersDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadUsersDataQuery, DownloadUsersDataQueryVariables>(DownloadUsersDataDocument, options);
      }
export function useDownloadUsersDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadUsersDataQuery, DownloadUsersDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadUsersDataQuery, DownloadUsersDataQueryVariables>(DownloadUsersDataDocument, options);
        }
export type DownloadUsersDataQueryHookResult = ReturnType<typeof useDownloadUsersDataQuery>;
export type DownloadUsersDataLazyQueryHookResult = ReturnType<typeof useDownloadUsersDataLazyQuery>;
export type DownloadUsersDataQueryResult = Apollo.QueryResult<DownloadUsersDataQuery, DownloadUsersDataQueryVariables>;
export const DownloadUserQuizSummariesDocument = gql`
    query downloadUserQuizSummaries {
  downloadUserQuizSummaries {
    success
    message
  }
}
    `;

/**
 * __useDownloadUserQuizSummariesQuery__
 *
 * To run a query within a React component, call `useDownloadUserQuizSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadUserQuizSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadUserQuizSummariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDownloadUserQuizSummariesQuery(baseOptions?: Apollo.QueryHookOptions<DownloadUserQuizSummariesQuery, DownloadUserQuizSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadUserQuizSummariesQuery, DownloadUserQuizSummariesQueryVariables>(DownloadUserQuizSummariesDocument, options);
      }
export function useDownloadUserQuizSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadUserQuizSummariesQuery, DownloadUserQuizSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadUserQuizSummariesQuery, DownloadUserQuizSummariesQueryVariables>(DownloadUserQuizSummariesDocument, options);
        }
export type DownloadUserQuizSummariesQueryHookResult = ReturnType<typeof useDownloadUserQuizSummariesQuery>;
export type DownloadUserQuizSummariesLazyQueryHookResult = ReturnType<typeof useDownloadUserQuizSummariesLazyQuery>;
export type DownloadUserQuizSummariesQueryResult = Apollo.QueryResult<DownloadUserQuizSummariesQuery, DownloadUserQuizSummariesQueryVariables>;
export const ValidateGoogleLoginDocument = gql`
    mutation validateGoogleLogin($code: String!, $state: String!, $utmSource: String, $utmMedium: String, $utmCampaign: String, $utmContent: String, $deviceType: String) {
  validateGoogleLogin(
    code: $code
    state: $state
    utmSource: $utmSource
    utmMedium: $utmMedium
    utmCampaign: $utmCampaign
    utmContent: $utmContent
    deviceType: $deviceType
  ) {
    success
    message
  }
}
    `;
export type ValidateGoogleLoginMutationFn = Apollo.MutationFunction<ValidateGoogleLoginMutation, ValidateGoogleLoginMutationVariables>;

/**
 * __useValidateGoogleLoginMutation__
 *
 * To run a mutation, you first call `useValidateGoogleLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateGoogleLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateGoogleLoginMutation, { data, loading, error }] = useValidateGoogleLoginMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      utmContent: // value for 'utmContent'
 *      deviceType: // value for 'deviceType'
 *   },
 * });
 */
export function useValidateGoogleLoginMutation(baseOptions?: Apollo.MutationHookOptions<ValidateGoogleLoginMutation, ValidateGoogleLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateGoogleLoginMutation, ValidateGoogleLoginMutationVariables>(ValidateGoogleLoginDocument, options);
      }
export type ValidateGoogleLoginMutationHookResult = ReturnType<typeof useValidateGoogleLoginMutation>;
export type ValidateGoogleLoginMutationResult = Apollo.MutationResult<ValidateGoogleLoginMutation>;
export type ValidateGoogleLoginMutationOptions = Apollo.BaseMutationOptions<ValidateGoogleLoginMutation, ValidateGoogleLoginMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation verifyEmail($token: String!) {
  verifyEmail(token: $token) {
    success
    message
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const SendVerificationEmailDocument = gql`
    mutation sendVerificationEmail($email: String!) {
  sendVerificationEmail(email: $email) {
    success
    message
  }
}
    `;
export type SendVerificationEmailMutationFn = Apollo.MutationFunction<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>;

/**
 * __useSendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useSendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationEmailMutation, { data, loading, error }] = useSendVerificationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>(SendVerificationEmailDocument, options);
      }
export type SendVerificationEmailMutationHookResult = ReturnType<typeof useSendVerificationEmailMutation>;
export type SendVerificationEmailMutationResult = Apollo.MutationResult<SendVerificationEmailMutation>;
export type SendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation resetUserPassword($token: String!, $password: String!) {
  verifyResetPasswordToken(token: $token, password: $password) {
    success
    message
  }
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const GetCatResultDocument = gql`
    mutation GetCatResult($input: getCatResultInput!) {
  getCatResult(input: $input) {
    success
    message
    applicationId
    data
  }
}
    `;
export type GetCatResultMutationFn = Apollo.MutationFunction<GetCatResultMutation, GetCatResultMutationVariables>;

/**
 * __useGetCatResultMutation__
 *
 * To run a mutation, you first call `useGetCatResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCatResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCatResultMutation, { data, loading, error }] = useGetCatResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCatResultMutation(baseOptions?: Apollo.MutationHookOptions<GetCatResultMutation, GetCatResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCatResultMutation, GetCatResultMutationVariables>(GetCatResultDocument, options);
      }
export type GetCatResultMutationHookResult = ReturnType<typeof useGetCatResultMutation>;
export type GetCatResultMutationResult = Apollo.MutationResult<GetCatResultMutation>;
export type GetCatResultMutationOptions = Apollo.BaseMutationOptions<GetCatResultMutation, GetCatResultMutationVariables>;
export const GetResponseTypeDocument = gql`
    query getResponseType {
  cat_percentile_constant(limit: 1, where: {name: {_eq: "response_type"}}) {
    value
  }
}
    `;

/**
 * __useGetResponseTypeQuery__
 *
 * To run a query within a React component, call `useGetResponseTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponseTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponseTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResponseTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetResponseTypeQuery, GetResponseTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponseTypeQuery, GetResponseTypeQueryVariables>(GetResponseTypeDocument, options);
      }
export function useGetResponseTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponseTypeQuery, GetResponseTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponseTypeQuery, GetResponseTypeQueryVariables>(GetResponseTypeDocument, options);
        }
export type GetResponseTypeQueryHookResult = ReturnType<typeof useGetResponseTypeQuery>;
export type GetResponseTypeLazyQueryHookResult = ReturnType<typeof useGetResponseTypeLazyQuery>;
export type GetResponseTypeQueryResult = Apollo.QueryResult<GetResponseTypeQuery, GetResponseTypeQueryVariables>;
export const GetPercentileConstantsDocument = gql`
    query getPercentileConstants {
  cat_percentile_constant {
    name
    value
  }
}
    `;

/**
 * __useGetPercentileConstantsQuery__
 *
 * To run a query within a React component, call `useGetPercentileConstantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPercentileConstantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPercentileConstantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPercentileConstantsQuery(baseOptions?: Apollo.QueryHookOptions<GetPercentileConstantsQuery, GetPercentileConstantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPercentileConstantsQuery, GetPercentileConstantsQueryVariables>(GetPercentileConstantsDocument, options);
      }
export function useGetPercentileConstantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPercentileConstantsQuery, GetPercentileConstantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPercentileConstantsQuery, GetPercentileConstantsQueryVariables>(GetPercentileConstantsDocument, options);
        }
export type GetPercentileConstantsQueryHookResult = ReturnType<typeof useGetPercentileConstantsQuery>;
export type GetPercentileConstantsLazyQueryHookResult = ReturnType<typeof useGetPercentileConstantsLazyQuery>;
export type GetPercentileConstantsQueryResult = Apollo.QueryResult<GetPercentileConstantsQuery, GetPercentileConstantsQueryVariables>;
export const GetCatResponseLeaderboardDocument = gql`
    query getCatResponseLeaderboard($value: Int!, $offset: Int!) {
  user_cat_response_sheet_data(offset: $offset, limit: $value) {
    candidate_name
    shift
    varc_raw
    quant_raw
    dilr_raw
    total_raw
  }
}
    `;

/**
 * __useGetCatResponseLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetCatResponseLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatResponseLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatResponseLeaderboardQuery({
 *   variables: {
 *      value: // value for 'value'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCatResponseLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<GetCatResponseLeaderboardQuery, GetCatResponseLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatResponseLeaderboardQuery, GetCatResponseLeaderboardQueryVariables>(GetCatResponseLeaderboardDocument, options);
      }
export function useGetCatResponseLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatResponseLeaderboardQuery, GetCatResponseLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatResponseLeaderboardQuery, GetCatResponseLeaderboardQueryVariables>(GetCatResponseLeaderboardDocument, options);
        }
export type GetCatResponseLeaderboardQueryHookResult = ReturnType<typeof useGetCatResponseLeaderboardQuery>;
export type GetCatResponseLeaderboardLazyQueryHookResult = ReturnType<typeof useGetCatResponseLeaderboardLazyQuery>;
export type GetCatResponseLeaderboardQueryResult = Apollo.QueryResult<GetCatResponseLeaderboardQuery, GetCatResponseLeaderboardQueryVariables>;
export const GetChannelsDocument = gql`
    subscription getChannels($query: String!, $limit: Int!, $category: String = "", $count: Int!) {
  channels(
    where: {_or: [{name: {_ilike: $query}}, {messages: {message: {_ilike: $query}}}, {category: {name: {_ilike: $query}}}], category: {name: {_ilike: $category}}, channel_members_aggregate: {count: {predicate: {_gte: $count}}}}
    limit: $limit
    order_by: {messages_aggregate: {max: {created_at: desc_nulls_last}}}
  ) {
    name
    id
    avatar
    slug
    category {
      name
      slug
    }
    messages(
      order_by: {created_at: desc}
      limit: 1
      where: {message: {_ilike: $query}}
    ) {
      message
      id
      created_at
      type
      user {
        first_name
        username
        role
      }
    }
    messages_reads_aggregate {
      aggregate {
        count
      }
    }
    messages_aggregate {
      aggregate {
        count
      }
    }
    channel_members_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetChannelsSubscription__
 *
 * To run a query within a React component, call `useGetChannelsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelsSubscription({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      category: // value for 'category'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetChannelsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetChannelsSubscription, GetChannelsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetChannelsSubscription, GetChannelsSubscriptionVariables>(GetChannelsDocument, options);
      }
export type GetChannelsSubscriptionHookResult = ReturnType<typeof useGetChannelsSubscription>;
export type GetChannelsSubscriptionResult = Apollo.SubscriptionResult<GetChannelsSubscription>;
export const GetMessagesDocument = gql`
    subscription getMessages($id: uuid!) {
  messages(order_by: {created_at: asc}, where: {channel_id: {_eq: $id}}) {
    id
    message
    created_at
    type
    file_url
    file_name
    channel_id
    messages_reads_aggregate {
      aggregate {
        count
      }
    }
    is_pinned
    replied_to_message_id
    user {
      first_name
      last_name
      username
      user_id
      avatar
      role
    }
    reactions {
      emoji
      user_id
      id
    }
    poll {
      title
      type
      id
      description
      options {
        id
        is_correct
        title
      }
      responses {
        selected_option
        user_id
        user {
          role
        }
      }
    }
  }
}
    `;

/**
 * __useGetMessagesSubscription__
 *
 * To run a query within a React component, call `useGetMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetMessagesSubscription, GetMessagesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetMessagesSubscription, GetMessagesSubscriptionVariables>(GetMessagesDocument, options);
      }
export type GetMessagesSubscriptionHookResult = ReturnType<typeof useGetMessagesSubscription>;
export type GetMessagesSubscriptionResult = Apollo.SubscriptionResult<GetMessagesSubscription>;
export const GetReactionEmojisDocument = gql`
    query getReactionEmojis {
  reaction_emojis {
    emoji
    emoji_url
    name
    id
  }
}
    `;

/**
 * __useGetReactionEmojisQuery__
 *
 * To run a query within a React component, call `useGetReactionEmojisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReactionEmojisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReactionEmojisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReactionEmojisQuery(baseOptions?: Apollo.QueryHookOptions<GetReactionEmojisQuery, GetReactionEmojisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReactionEmojisQuery, GetReactionEmojisQueryVariables>(GetReactionEmojisDocument, options);
      }
export function useGetReactionEmojisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReactionEmojisQuery, GetReactionEmojisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReactionEmojisQuery, GetReactionEmojisQueryVariables>(GetReactionEmojisDocument, options);
        }
export type GetReactionEmojisQueryHookResult = ReturnType<typeof useGetReactionEmojisQuery>;
export type GetReactionEmojisLazyQueryHookResult = ReturnType<typeof useGetReactionEmojisLazyQuery>;
export type GetReactionEmojisQueryResult = Apollo.QueryResult<GetReactionEmojisQuery, GetReactionEmojisQueryVariables>;
export const SendMessageDocument = gql`
    mutation sendMessage($object: messages_insert_input!) {
  insert_messages_one(object: $object) {
    id
  }
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const GetUploadFileUrlDocument = gql`
    mutation getUploadFileUrl($fileName: String!, $validFileType: String!, $fileSize: Int!) {
  getUploadFileUrl(
    fileName: $fileName
    validFileType: $validFileType
    fileSize: $fileSize
  ) {
    success
    message
    uploadUrl
    contentType
    fileUrl
  }
}
    `;
export type GetUploadFileUrlMutationFn = Apollo.MutationFunction<GetUploadFileUrlMutation, GetUploadFileUrlMutationVariables>;

/**
 * __useGetUploadFileUrlMutation__
 *
 * To run a mutation, you first call `useGetUploadFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetUploadFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getUploadFileUrlMutation, { data, loading, error }] = useGetUploadFileUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      validFileType: // value for 'validFileType'
 *      fileSize: // value for 'fileSize'
 *   },
 * });
 */
export function useGetUploadFileUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetUploadFileUrlMutation, GetUploadFileUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetUploadFileUrlMutation, GetUploadFileUrlMutationVariables>(GetUploadFileUrlDocument, options);
      }
export type GetUploadFileUrlMutationHookResult = ReturnType<typeof useGetUploadFileUrlMutation>;
export type GetUploadFileUrlMutationResult = Apollo.MutationResult<GetUploadFileUrlMutation>;
export type GetUploadFileUrlMutationOptions = Apollo.BaseMutationOptions<GetUploadFileUrlMutation, GetUploadFileUrlMutationVariables>;
export const JoinChannelDocument = gql`
    mutation joinChannel($channelID: uuid!) {
  insert_channel_members_one(
    object: {channel_id: $channelID}
    on_conflict: {constraint: channel_members_channel_id_user_id_key, update_columns: channel_id}
  ) {
    id
  }
}
    `;
export type JoinChannelMutationFn = Apollo.MutationFunction<JoinChannelMutation, JoinChannelMutationVariables>;

/**
 * __useJoinChannelMutation__
 *
 * To run a mutation, you first call `useJoinChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinChannelMutation, { data, loading, error }] = useJoinChannelMutation({
 *   variables: {
 *      channelID: // value for 'channelID'
 *   },
 * });
 */
export function useJoinChannelMutation(baseOptions?: Apollo.MutationHookOptions<JoinChannelMutation, JoinChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinChannelMutation, JoinChannelMutationVariables>(JoinChannelDocument, options);
      }
export type JoinChannelMutationHookResult = ReturnType<typeof useJoinChannelMutation>;
export type JoinChannelMutationResult = Apollo.MutationResult<JoinChannelMutation>;
export type JoinChannelMutationOptions = Apollo.BaseMutationOptions<JoinChannelMutation, JoinChannelMutationVariables>;
export const IsJoinedDocument = gql`
    query isJoined($channelID: uuid!) {
  channel_members(limit: 1, where: {channel_id: {_eq: $channelID}}) {
    id
    role
    is_blocked
  }
}
    `;

/**
 * __useIsJoinedQuery__
 *
 * To run a query within a React component, call `useIsJoinedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsJoinedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsJoinedQuery({
 *   variables: {
 *      channelID: // value for 'channelID'
 *   },
 * });
 */
export function useIsJoinedQuery(baseOptions: Apollo.QueryHookOptions<IsJoinedQuery, IsJoinedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsJoinedQuery, IsJoinedQueryVariables>(IsJoinedDocument, options);
      }
export function useIsJoinedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsJoinedQuery, IsJoinedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsJoinedQuery, IsJoinedQueryVariables>(IsJoinedDocument, options);
        }
export type IsJoinedQueryHookResult = ReturnType<typeof useIsJoinedQuery>;
export type IsJoinedLazyQueryHookResult = ReturnType<typeof useIsJoinedLazyQuery>;
export type IsJoinedQueryResult = Apollo.QueryResult<IsJoinedQuery, IsJoinedQueryVariables>;
export const ReportMessageDocument = gql`
    mutation reportMessage($object: reported_message_insert_input!) {
  insert_reported_message_one(object: $object) {
    id
  }
}
    `;
export type ReportMessageMutationFn = Apollo.MutationFunction<ReportMessageMutation, ReportMessageMutationVariables>;

/**
 * __useReportMessageMutation__
 *
 * To run a mutation, you first call `useReportMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportMessageMutation, { data, loading, error }] = useReportMessageMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useReportMessageMutation(baseOptions?: Apollo.MutationHookOptions<ReportMessageMutation, ReportMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportMessageMutation, ReportMessageMutationVariables>(ReportMessageDocument, options);
      }
export type ReportMessageMutationHookResult = ReturnType<typeof useReportMessageMutation>;
export type ReportMessageMutationResult = Apollo.MutationResult<ReportMessageMutation>;
export type ReportMessageMutationOptions = Apollo.BaseMutationOptions<ReportMessageMutation, ReportMessageMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation deleteMessage($messageId: String!, $channelId: String!) {
  deleteMessage(messageId: $messageId, channelId: $channelId) {
    success
    message
  }
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const PinMessageDocument = gql`
    mutation pinMessage($messageId: String!, $channelId: String!, $status: Boolean!) {
  pinMessage(messageId: $messageId, channelId: $channelId, status: $status) {
    success
    message
  }
}
    `;
export type PinMessageMutationFn = Apollo.MutationFunction<PinMessageMutation, PinMessageMutationVariables>;

/**
 * __usePinMessageMutation__
 *
 * To run a mutation, you first call `usePinMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinMessageMutation, { data, loading, error }] = usePinMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      channelId: // value for 'channelId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function usePinMessageMutation(baseOptions?: Apollo.MutationHookOptions<PinMessageMutation, PinMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinMessageMutation, PinMessageMutationVariables>(PinMessageDocument, options);
      }
export type PinMessageMutationHookResult = ReturnType<typeof usePinMessageMutation>;
export type PinMessageMutationResult = Apollo.MutationResult<PinMessageMutation>;
export type PinMessageMutationOptions = Apollo.BaseMutationOptions<PinMessageMutation, PinMessageMutationVariables>;
export const ChangeRoleDocument = gql`
    mutation changeRole($channelId: String!, $userId: String!, $role: String!) {
  changeRole(channelId: $channelId, userId: $userId, role: $role) {
    success
    message
  }
}
    `;
export type ChangeRoleMutationFn = Apollo.MutationFunction<ChangeRoleMutation, ChangeRoleMutationVariables>;

/**
 * __useChangeRoleMutation__
 *
 * To run a mutation, you first call `useChangeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeRoleMutation, { data, loading, error }] = useChangeRoleMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useChangeRoleMutation(baseOptions?: Apollo.MutationHookOptions<ChangeRoleMutation, ChangeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeRoleMutation, ChangeRoleMutationVariables>(ChangeRoleDocument, options);
      }
export type ChangeRoleMutationHookResult = ReturnType<typeof useChangeRoleMutation>;
export type ChangeRoleMutationResult = Apollo.MutationResult<ChangeRoleMutation>;
export type ChangeRoleMutationOptions = Apollo.BaseMutationOptions<ChangeRoleMutation, ChangeRoleMutationVariables>;
export const UpdateChannelStatusDocument = gql`
    mutation updateChannelStatus($channelId: String!, $status: Boolean!) {
  updateChannelStatus(channelId: $channelId, status: $status) {
    success
    message
  }
}
    `;
export type UpdateChannelStatusMutationFn = Apollo.MutationFunction<UpdateChannelStatusMutation, UpdateChannelStatusMutationVariables>;

/**
 * __useUpdateChannelStatusMutation__
 *
 * To run a mutation, you first call `useUpdateChannelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelStatusMutation, { data, loading, error }] = useUpdateChannelStatusMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateChannelStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelStatusMutation, UpdateChannelStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelStatusMutation, UpdateChannelStatusMutationVariables>(UpdateChannelStatusDocument, options);
      }
export type UpdateChannelStatusMutationHookResult = ReturnType<typeof useUpdateChannelStatusMutation>;
export type UpdateChannelStatusMutationResult = Apollo.MutationResult<UpdateChannelStatusMutation>;
export type UpdateChannelStatusMutationOptions = Apollo.BaseMutationOptions<UpdateChannelStatusMutation, UpdateChannelStatusMutationVariables>;
export const DeleteChannelDocument = gql`
    mutation deleteChannel($channelId: String!) {
  deleteChannel(channelId: $channelId) {
    success
    message
  }
}
    `;
export type DeleteChannelMutationFn = Apollo.MutationFunction<DeleteChannelMutation, DeleteChannelMutationVariables>;

/**
 * __useDeleteChannelMutation__
 *
 * To run a mutation, you first call `useDeleteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelMutation, { data, loading, error }] = useDeleteChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDeleteChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChannelMutation, DeleteChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChannelMutation, DeleteChannelMutationVariables>(DeleteChannelDocument, options);
      }
export type DeleteChannelMutationHookResult = ReturnType<typeof useDeleteChannelMutation>;
export type DeleteChannelMutationResult = Apollo.MutationResult<DeleteChannelMutation>;
export type DeleteChannelMutationOptions = Apollo.BaseMutationOptions<DeleteChannelMutation, DeleteChannelMutationVariables>;
export const CreateChannelDocument = gql`
    mutation createChannel($channelName: String!, $avatar: String, $category: String!) {
  createChannel(channelName: $channelName, avatar: $avatar, category: $category) {
    success
    message
    channelId
  }
}
    `;
export type CreateChannelMutationFn = Apollo.MutationFunction<CreateChannelMutation, CreateChannelMutationVariables>;

/**
 * __useCreateChannelMutation__
 *
 * To run a mutation, you first call `useCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMutation, { data, loading, error }] = useCreateChannelMutation({
 *   variables: {
 *      channelName: // value for 'channelName'
 *      avatar: // value for 'avatar'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCreateChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelMutation, CreateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelMutation, CreateChannelMutationVariables>(CreateChannelDocument, options);
      }
export type CreateChannelMutationHookResult = ReturnType<typeof useCreateChannelMutation>;
export type CreateChannelMutationResult = Apollo.MutationResult<CreateChannelMutation>;
export type CreateChannelMutationOptions = Apollo.BaseMutationOptions<CreateChannelMutation, CreateChannelMutationVariables>;
export const UpdateGroupProfileDocument = gql`
    mutation updateGroupProfile($avatar: String!, $channelId: String!) {
  updateGroupProfile(avatar: $avatar, channelId: $channelId) {
    success
    message
  }
}
    `;
export type UpdateGroupProfileMutationFn = Apollo.MutationFunction<UpdateGroupProfileMutation, UpdateGroupProfileMutationVariables>;

/**
 * __useUpdateGroupProfileMutation__
 *
 * To run a mutation, you first call `useUpdateGroupProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupProfileMutation, { data, loading, error }] = useUpdateGroupProfileMutation({
 *   variables: {
 *      avatar: // value for 'avatar'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useUpdateGroupProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupProfileMutation, UpdateGroupProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupProfileMutation, UpdateGroupProfileMutationVariables>(UpdateGroupProfileDocument, options);
      }
export type UpdateGroupProfileMutationHookResult = ReturnType<typeof useUpdateGroupProfileMutation>;
export type UpdateGroupProfileMutationResult = Apollo.MutationResult<UpdateGroupProfileMutation>;
export type UpdateGroupProfileMutationOptions = Apollo.BaseMutationOptions<UpdateGroupProfileMutation, UpdateGroupProfileMutationVariables>;
export const AddReactionDocument = gql`
    mutation addReaction($object: message_reactions_insert_input!) {
  insert_message_reactions_one(
    object: $object
    on_conflict: {constraint: message_reactions_user_id_message_id_key, update_columns: emoji}
  ) {
    id
  }
}
    `;
export type AddReactionMutationFn = Apollo.MutationFunction<AddReactionMutation, AddReactionMutationVariables>;

/**
 * __useAddReactionMutation__
 *
 * To run a mutation, you first call `useAddReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionMutation, { data, loading, error }] = useAddReactionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddReactionMutation(baseOptions?: Apollo.MutationHookOptions<AddReactionMutation, AddReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReactionMutation, AddReactionMutationVariables>(AddReactionDocument, options);
      }
export type AddReactionMutationHookResult = ReturnType<typeof useAddReactionMutation>;
export type AddReactionMutationResult = Apollo.MutationResult<AddReactionMutation>;
export type AddReactionMutationOptions = Apollo.BaseMutationOptions<AddReactionMutation, AddReactionMutationVariables>;
export const DeleteReactionDocument = gql`
    mutation deleteReaction($messageId: uuid!) {
  delete_message_reactions(where: {message_id: {_eq: $messageId}}) {
    affected_rows
  }
}
    `;
export type DeleteReactionMutationFn = Apollo.MutationFunction<DeleteReactionMutation, DeleteReactionMutationVariables>;

/**
 * __useDeleteReactionMutation__
 *
 * To run a mutation, you first call `useDeleteReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReactionMutation, { data, loading, error }] = useDeleteReactionMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDeleteReactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReactionMutation, DeleteReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReactionMutation, DeleteReactionMutationVariables>(DeleteReactionDocument, options);
      }
export type DeleteReactionMutationHookResult = ReturnType<typeof useDeleteReactionMutation>;
export type DeleteReactionMutationResult = Apollo.MutationResult<DeleteReactionMutation>;
export type DeleteReactionMutationOptions = Apollo.BaseMutationOptions<DeleteReactionMutation, DeleteReactionMutationVariables>;
export const VotePollDocument = gql`
    mutation VotePoll($pollId: String!, $optionsId: [String!]!) {
  votePoll(pollId: $pollId, optionsId: $optionsId) {
    success
    message
  }
}
    `;
export type VotePollMutationFn = Apollo.MutationFunction<VotePollMutation, VotePollMutationVariables>;

/**
 * __useVotePollMutation__
 *
 * To run a mutation, you first call `useVotePollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVotePollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [votePollMutation, { data, loading, error }] = useVotePollMutation({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      optionsId: // value for 'optionsId'
 *   },
 * });
 */
export function useVotePollMutation(baseOptions?: Apollo.MutationHookOptions<VotePollMutation, VotePollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VotePollMutation, VotePollMutationVariables>(VotePollDocument, options);
      }
export type VotePollMutationHookResult = ReturnType<typeof useVotePollMutation>;
export type VotePollMutationResult = Apollo.MutationResult<VotePollMutation>;
export type VotePollMutationOptions = Apollo.BaseMutationOptions<VotePollMutation, VotePollMutationVariables>;
export const CreatePollDocument = gql`
    mutation CreatePoll($title: String!, $channelId: String!, $quizType: String, $options: [PollOption!]!, $description: String, $type: String!) {
  createPoll(
    title: $title
    channelId: $channelId
    options: $options
    quizType: $quizType
    description: $description
    type: $type
  ) {
    success
    message
  }
}
    `;
export type CreatePollMutationFn = Apollo.MutationFunction<CreatePollMutation, CreatePollMutationVariables>;

/**
 * __useCreatePollMutation__
 *
 * To run a mutation, you first call `useCreatePollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPollMutation, { data, loading, error }] = useCreatePollMutation({
 *   variables: {
 *      title: // value for 'title'
 *      channelId: // value for 'channelId'
 *      quizType: // value for 'quizType'
 *      options: // value for 'options'
 *      description: // value for 'description'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreatePollMutation(baseOptions?: Apollo.MutationHookOptions<CreatePollMutation, CreatePollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePollMutation, CreatePollMutationVariables>(CreatePollDocument, options);
      }
export type CreatePollMutationHookResult = ReturnType<typeof useCreatePollMutation>;
export type CreatePollMutationResult = Apollo.MutationResult<CreatePollMutation>;
export type CreatePollMutationOptions = Apollo.BaseMutationOptions<CreatePollMutation, CreatePollMutationVariables>;
export const GetChannelMembersDocument = gql`
    query getChannelMembers($channelId: String!, $limit: Int = 10, $offset: Int = 0) {
  getChannelMembers(channelId: $channelId, limit: $limit, offset: $offset) {
    success
    message
    members {
      userId
      role
      name
      avatar
      isBlocked
    }
  }
}
    `;

/**
 * __useGetChannelMembersQuery__
 *
 * To run a query within a React component, call `useGetChannelMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelMembersQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetChannelMembersQuery(baseOptions: Apollo.QueryHookOptions<GetChannelMembersQuery, GetChannelMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelMembersQuery, GetChannelMembersQueryVariables>(GetChannelMembersDocument, options);
      }
export function useGetChannelMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelMembersQuery, GetChannelMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelMembersQuery, GetChannelMembersQueryVariables>(GetChannelMembersDocument, options);
        }
export type GetChannelMembersQueryHookResult = ReturnType<typeof useGetChannelMembersQuery>;
export type GetChannelMembersLazyQueryHookResult = ReturnType<typeof useGetChannelMembersLazyQuery>;
export type GetChannelMembersQueryResult = Apollo.QueryResult<GetChannelMembersQuery, GetChannelMembersQueryVariables>;
export const GetChannelInfoDocument = gql`
    query getChannelInfo($channelId: String!) {
  getChannelInfo(channelId: $channelId) {
    success
    message
    name
    isClosed
    avatar
    category
    totalMembers
  }
}
    `;

/**
 * __useGetChannelInfoQuery__
 *
 * To run a query within a React component, call `useGetChannelInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelInfoQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelInfoQuery(baseOptions: Apollo.QueryHookOptions<GetChannelInfoQuery, GetChannelInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelInfoQuery, GetChannelInfoQueryVariables>(GetChannelInfoDocument, options);
      }
export function useGetChannelInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelInfoQuery, GetChannelInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelInfoQuery, GetChannelInfoQueryVariables>(GetChannelInfoDocument, options);
        }
export type GetChannelInfoQueryHookResult = ReturnType<typeof useGetChannelInfoQuery>;
export type GetChannelInfoLazyQueryHookResult = ReturnType<typeof useGetChannelInfoLazyQuery>;
export type GetChannelInfoQueryResult = Apollo.QueryResult<GetChannelInfoQuery, GetChannelInfoQueryVariables>;
export const LeaveChannelDocument = gql`
    mutation leaveChannel($channelId: String!) {
  leaveChannel(channelId: $channelId) {
    success
    message
  }
}
    `;
export type LeaveChannelMutationFn = Apollo.MutationFunction<LeaveChannelMutation, LeaveChannelMutationVariables>;

/**
 * __useLeaveChannelMutation__
 *
 * To run a mutation, you first call `useLeaveChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveChannelMutation, { data, loading, error }] = useLeaveChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useLeaveChannelMutation(baseOptions?: Apollo.MutationHookOptions<LeaveChannelMutation, LeaveChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveChannelMutation, LeaveChannelMutationVariables>(LeaveChannelDocument, options);
      }
export type LeaveChannelMutationHookResult = ReturnType<typeof useLeaveChannelMutation>;
export type LeaveChannelMutationResult = Apollo.MutationResult<LeaveChannelMutation>;
export type LeaveChannelMutationOptions = Apollo.BaseMutationOptions<LeaveChannelMutation, LeaveChannelMutationVariables>;
export const BlockUserDocument = gql`
    mutation blockUser($userId: String!, $channelId: String!, $status: String!) {
  blockUser(userId: $userId, channelId: $channelId, status: $status) {
    success
    message
  }
}
    `;
export type BlockUserMutationFn = Apollo.MutationFunction<BlockUserMutation, BlockUserMutationVariables>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelId: // value for 'channelId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBlockUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockUserMutation, BlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockUserMutation, BlockUserMutationVariables>(BlockUserDocument, options);
      }
export type BlockUserMutationHookResult = ReturnType<typeof useBlockUserMutation>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<BlockUserMutation, BlockUserMutationVariables>;
export const KickUserDocument = gql`
    mutation kickUser($userId: String!, $channelId: String!) {
  kickUser(userId: $userId, channelId: $channelId) {
    success
    message
  }
}
    `;
export type KickUserMutationFn = Apollo.MutationFunction<KickUserMutation, KickUserMutationVariables>;

/**
 * __useKickUserMutation__
 *
 * To run a mutation, you first call `useKickUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKickUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kickUserMutation, { data, loading, error }] = useKickUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useKickUserMutation(baseOptions?: Apollo.MutationHookOptions<KickUserMutation, KickUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KickUserMutation, KickUserMutationVariables>(KickUserDocument, options);
      }
export type KickUserMutationHookResult = ReturnType<typeof useKickUserMutation>;
export type KickUserMutationResult = Apollo.MutationResult<KickUserMutation>;
export type KickUserMutationOptions = Apollo.BaseMutationOptions<KickUserMutation, KickUserMutationVariables>;
export const ReadMessageDocument = gql`
    mutation readMessage($object: messages_read_insert_input!) {
  insert_messages_read_one(
    object: $object
    on_conflict: {constraint: messages_read_message_id_user_id_channel_id_key, update_columns: []}
  ) {
    id
  }
}
    `;
export type ReadMessageMutationFn = Apollo.MutationFunction<ReadMessageMutation, ReadMessageMutationVariables>;

/**
 * __useReadMessageMutation__
 *
 * To run a mutation, you first call `useReadMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readMessageMutation, { data, loading, error }] = useReadMessageMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useReadMessageMutation(baseOptions?: Apollo.MutationHookOptions<ReadMessageMutation, ReadMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadMessageMutation, ReadMessageMutationVariables>(ReadMessageDocument, options);
      }
export type ReadMessageMutationHookResult = ReturnType<typeof useReadMessageMutation>;
export type ReadMessageMutationResult = Apollo.MutationResult<ReadMessageMutation>;
export type ReadMessageMutationOptions = Apollo.BaseMutationOptions<ReadMessageMutation, ReadMessageMutationVariables>;
export const GetGroupCategoriesDocument = gql`
    query getGroupCategories {
  group_category(order_by: {created_at: desc}) {
    id
    name
  }
}
    `;

/**
 * __useGetGroupCategoriesQuery__
 *
 * To run a query within a React component, call `useGetGroupCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>(GetGroupCategoriesDocument, options);
      }
export function useGetGroupCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>(GetGroupCategoriesDocument, options);
        }
export type GetGroupCategoriesQueryHookResult = ReturnType<typeof useGetGroupCategoriesQuery>;
export type GetGroupCategoriesLazyQueryHookResult = ReturnType<typeof useGetGroupCategoriesLazyQuery>;
export type GetGroupCategoriesQueryResult = Apollo.QueryResult<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>;
export const GetChannelIdByGroupAndSlugDocument = gql`
    query getChannelIdByGroupAndSlug($slug: String!, $category: String!) {
  channels(
    where: {slug: {_eq: $slug}, category: {slug: {_eq: $category}}}
    limit: 1
  ) {
    id
  }
}
    `;

/**
 * __useGetChannelIdByGroupAndSlugQuery__
 *
 * To run a query within a React component, call `useGetChannelIdByGroupAndSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelIdByGroupAndSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelIdByGroupAndSlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetChannelIdByGroupAndSlugQuery(baseOptions: Apollo.QueryHookOptions<GetChannelIdByGroupAndSlugQuery, GetChannelIdByGroupAndSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelIdByGroupAndSlugQuery, GetChannelIdByGroupAndSlugQueryVariables>(GetChannelIdByGroupAndSlugDocument, options);
      }
export function useGetChannelIdByGroupAndSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelIdByGroupAndSlugQuery, GetChannelIdByGroupAndSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelIdByGroupAndSlugQuery, GetChannelIdByGroupAndSlugQueryVariables>(GetChannelIdByGroupAndSlugDocument, options);
        }
export type GetChannelIdByGroupAndSlugQueryHookResult = ReturnType<typeof useGetChannelIdByGroupAndSlugQuery>;
export type GetChannelIdByGroupAndSlugLazyQueryHookResult = ReturnType<typeof useGetChannelIdByGroupAndSlugLazyQuery>;
export type GetChannelIdByGroupAndSlugQueryResult = Apollo.QueryResult<GetChannelIdByGroupAndSlugQuery, GetChannelIdByGroupAndSlugQueryVariables>;
export const GetCompeteBookmarkedQuestionsDocument = gql`
    query getCompeteBookmarkedQuestions {
  user_quiz_question_summaries(
    where: {is_bookmarked: {_eq: true}, user_quiz_summary: {quiz_quiz: {quiz_category: {quiz_domain: {quiz_superdomain: {id: {_eq: 3}}}}, is_sections: {_eq: true}, is_timed: {_eq: true}}}}
    order_by: {updated_at: desc}
  ) {
    id
    is_bookmarked
    is_correct
    response
    time_taken
    quiz_question {
      name
      solution
      id
      difficulty
      quiz_paragraph {
        comprehension
      }
      has_paragraph
      options {
        name
        id
        is_correct
      }
    }
    user_quiz_summary {
      quiz_quiz {
        name
      }
    }
  }
}
    `;

/**
 * __useGetCompeteBookmarkedQuestionsQuery__
 *
 * To run a query within a React component, call `useGetCompeteBookmarkedQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompeteBookmarkedQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompeteBookmarkedQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompeteBookmarkedQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompeteBookmarkedQuestionsQuery, GetCompeteBookmarkedQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompeteBookmarkedQuestionsQuery, GetCompeteBookmarkedQuestionsQueryVariables>(GetCompeteBookmarkedQuestionsDocument, options);
      }
export function useGetCompeteBookmarkedQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompeteBookmarkedQuestionsQuery, GetCompeteBookmarkedQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompeteBookmarkedQuestionsQuery, GetCompeteBookmarkedQuestionsQueryVariables>(GetCompeteBookmarkedQuestionsDocument, options);
        }
export type GetCompeteBookmarkedQuestionsQueryHookResult = ReturnType<typeof useGetCompeteBookmarkedQuestionsQuery>;
export type GetCompeteBookmarkedQuestionsLazyQueryHookResult = ReturnType<typeof useGetCompeteBookmarkedQuestionsLazyQuery>;
export type GetCompeteBookmarkedQuestionsQueryResult = Apollo.QueryResult<GetCompeteBookmarkedQuestionsQuery, GetCompeteBookmarkedQuestionsQueryVariables>;
export const GetDailyBookmarkedQuestionsDocument = gql`
    query getDailyBookmarkedQuestions($slug: String) {
  user_quiz_question_summaries(
    where: {is_bookmarked: {_eq: true}, user_quiz_summary: {quiz_quiz: {quiz_category: {quiz_domain: {id: {_eq: 21}}}, is_sections: {_eq: true}, is_timed: {_eq: true}}}, quiz_question: {quiz_category: {quiz_domain: {quiz_superdomain: {slug: {_eq: $slug}}}}}}
    order_by: {updated_at: desc}
  ) {
    id
    is_bookmarked
    is_correct
    response
    time_taken
    quiz_question {
      name
      solution
      id
      difficulty
      quiz_paragraph {
        comprehension
      }
      has_paragraph
      options {
        name
        id
        is_correct
      }
      quiz_category {
        quiz_domain {
          name
        }
      }
    }
    user_quiz_summary {
      quiz_quiz {
        name
      }
    }
  }
}
    `;

/**
 * __useGetDailyBookmarkedQuestionsQuery__
 *
 * To run a query within a React component, call `useGetDailyBookmarkedQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyBookmarkedQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyBookmarkedQuestionsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetDailyBookmarkedQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDailyBookmarkedQuestionsQuery, GetDailyBookmarkedQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyBookmarkedQuestionsQuery, GetDailyBookmarkedQuestionsQueryVariables>(GetDailyBookmarkedQuestionsDocument, options);
      }
export function useGetDailyBookmarkedQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyBookmarkedQuestionsQuery, GetDailyBookmarkedQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyBookmarkedQuestionsQuery, GetDailyBookmarkedQuestionsQueryVariables>(GetDailyBookmarkedQuestionsDocument, options);
        }
export type GetDailyBookmarkedQuestionsQueryHookResult = ReturnType<typeof useGetDailyBookmarkedQuestionsQuery>;
export type GetDailyBookmarkedQuestionsLazyQueryHookResult = ReturnType<typeof useGetDailyBookmarkedQuestionsLazyQuery>;
export type GetDailyBookmarkedQuestionsQueryResult = Apollo.QueryResult<GetDailyBookmarkedQuestionsQuery, GetDailyBookmarkedQuestionsQueryVariables>;
export const GetFreeSectionDocument = gql`
    query GetFreeSection {
  mock_cats: quiz_category(where: {id: {_eq: 36}, draft: {_neq: true}}, limit: 1) {
    title: name
    quiz_domain {
      quiz_superdomain {
        name
      }
    }
    quiz_quizzes(where: {is_premium: {_eq: false}}, limit: 2) {
      id
      name
      slug
      user_quiz_summaries(order_by: {created_at: desc}, limit: 1) {
        created_at
        user_quiz_question_summaries_aggregate {
          aggregate {
            sum {
              marks
            }
          }
        }
        number_of_attempted_questions
      }
      total_number_of_questions
    }
  }
  quiz_of_the_day: quiz_category(
    where: {quiz_domain: {slug: {_eq: "quiz-of-the-day"}}}
  ) {
    name
    slug
    quiz_quizzes(where: {is_premium: {_eq: false}}, limit: 3) {
      name
      id
      slug
      user_quiz_summaries(order_by: {created_at: desc}, limit: 1) {
        created_at
        user_quiz_question_summaries_aggregate {
          aggregate {
            sum {
              marks
            }
          }
        }
        number_of_attempted_questions
      }
      total_number_of_questions
    }
  }
  last_practice_summary: user_quiz_summaries(
    where: {quiz_quiz: {is_premium: {_eq: false}, quiz_category: {quiz_domain: {slug: {_eq: "quantitative-ability"}}}}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    created_at
    user_quiz_question_summaries_aggregate {
      aggregate {
        sum {
          marks
        }
      }
    }
    quiz_quiz {
      name
      total_number_of_questions
    }
    number_of_attempted_questions
  }
}
    `;

/**
 * __useGetFreeSectionQuery__
 *
 * To run a query within a React component, call `useGetFreeSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreeSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreeSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFreeSectionQuery(baseOptions?: Apollo.QueryHookOptions<GetFreeSectionQuery, GetFreeSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreeSectionQuery, GetFreeSectionQueryVariables>(GetFreeSectionDocument, options);
      }
export function useGetFreeSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreeSectionQuery, GetFreeSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreeSectionQuery, GetFreeSectionQueryVariables>(GetFreeSectionDocument, options);
        }
export type GetFreeSectionQueryHookResult = ReturnType<typeof useGetFreeSectionQuery>;
export type GetFreeSectionLazyQueryHookResult = ReturnType<typeof useGetFreeSectionLazyQuery>;
export type GetFreeSectionQueryResult = Apollo.QueryResult<GetFreeSectionQuery, GetFreeSectionQueryVariables>;
export const GetStaticPageDataDocument = gql`
    query getStaticPageData($slug: String!) {
  infozone_staticpages(where: {slug: {_eq: $slug}}) {
    content
    content_markup_type
    created_date
    remove_menu
    slug
    title
    id
    _content_rendered
    updated_at
  }
}
    `;

/**
 * __useGetStaticPageDataQuery__
 *
 * To run a query within a React component, call `useGetStaticPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaticPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaticPageDataQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetStaticPageDataQuery(baseOptions: Apollo.QueryHookOptions<GetStaticPageDataQuery, GetStaticPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaticPageDataQuery, GetStaticPageDataQueryVariables>(GetStaticPageDataDocument, options);
      }
export function useGetStaticPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaticPageDataQuery, GetStaticPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaticPageDataQuery, GetStaticPageDataQueryVariables>(GetStaticPageDataDocument, options);
        }
export type GetStaticPageDataQueryHookResult = ReturnType<typeof useGetStaticPageDataQuery>;
export type GetStaticPageDataLazyQueryHookResult = ReturnType<typeof useGetStaticPageDataLazyQuery>;
export type GetStaticPageDataQueryResult = Apollo.QueryResult<GetStaticPageDataQuery, GetStaticPageDataQueryVariables>;
export const GetBookmarkedQuestionsDocument = gql`
    query getBookmarkedQuestions($slug: String!) {
  user_quiz_question_summaries(
    where: {is_bookmarked: {_eq: true}, quiz_question: {quiz_category: {quiz_domain: {quiz_superdomain: {slug: {_eq: $slug}}}}}}
    order_by: {updated_at: desc, quiz_question: {quiz_category: {quiz_domain: {rank: asc}, rank: asc}}}
  ) {
    id
    is_bookmarked
    is_correct
    response
    time_taken
    quiz_question {
      name
      solution
      id
      difficulty
      quiz_paragraph {
        comprehension
      }
      has_paragraph
      options {
        name
        id
        is_correct
      }
      quiz_category {
        name
        quiz_domain {
          name
          quiz_superdomain {
            name
          }
        }
      }
    }
    user_quiz_summary {
      quiz_quiz {
        name
      }
    }
  }
}
    `;

/**
 * __useGetBookmarkedQuestionsQuery__
 *
 * To run a query within a React component, call `useGetBookmarkedQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkedQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkedQuestionsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetBookmarkedQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetBookmarkedQuestionsQuery, GetBookmarkedQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookmarkedQuestionsQuery, GetBookmarkedQuestionsQueryVariables>(GetBookmarkedQuestionsDocument, options);
      }
export function useGetBookmarkedQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookmarkedQuestionsQuery, GetBookmarkedQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookmarkedQuestionsQuery, GetBookmarkedQuestionsQueryVariables>(GetBookmarkedQuestionsDocument, options);
        }
export type GetBookmarkedQuestionsQueryHookResult = ReturnType<typeof useGetBookmarkedQuestionsQuery>;
export type GetBookmarkedQuestionsLazyQueryHookResult = ReturnType<typeof useGetBookmarkedQuestionsLazyQuery>;
export type GetBookmarkedQuestionsQueryResult = Apollo.QueryResult<GetBookmarkedQuestionsQuery, GetBookmarkedQuestionsQueryVariables>;
export const UpdateQuestionBookmarkDocument = gql`
    mutation updateQuestionBookmark($id: uuid!) {
  update_user_quiz_question_summaries(
    where: {id: {_eq: $id}}
    _set: {is_bookmarked: false}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateQuestionBookmarkMutationFn = Apollo.MutationFunction<UpdateQuestionBookmarkMutation, UpdateQuestionBookmarkMutationVariables>;

/**
 * __useUpdateQuestionBookmarkMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionBookmarkMutation, { data, loading, error }] = useUpdateQuestionBookmarkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateQuestionBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionBookmarkMutation, UpdateQuestionBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionBookmarkMutation, UpdateQuestionBookmarkMutationVariables>(UpdateQuestionBookmarkDocument, options);
      }
export type UpdateQuestionBookmarkMutationHookResult = ReturnType<typeof useUpdateQuestionBookmarkMutation>;
export type UpdateQuestionBookmarkMutationResult = Apollo.MutationResult<UpdateQuestionBookmarkMutation>;
export type UpdateQuestionBookmarkMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionBookmarkMutation, UpdateQuestionBookmarkMutationVariables>;
export const GetSubscriptionPlanDocument = gql`
    query getSubscriptionPlan($time: timestamptz!, $cost: numeric!) {
  subscriptions_subscriptionplan(
    where: {is_invisible: {_eq: false}, cost: {_gte: $cost}}
    order_by: {package_content: {rank: asc}}
  ) {
    cost
    package_content {
      expiry_date
      is_master
      message
      brief
      rank
    }
    id
    most_popular
    slug
    plan_name
    plan_description
    striked_price
    subscriptions_subscriptionplan_upgradable_plans {
      from_subscriptionplan_id
      to_subscriptionplan_id
    }
    subscription_group_plans(
      where: {is_invisible: {_eq: false}, validity: {_gte: $time}}
    ) {
      price
      id
      is_invisible
      subscription_group_plan_groups(
        where: {is_closed: {_eq: false}, is_subscribed: {_eq: false}}
      ) {
        id
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionPlanQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionPlanQuery({
 *   variables: {
 *      time: // value for 'time'
 *      cost: // value for 'cost'
 *   },
 * });
 */
export function useGetSubscriptionPlanQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionPlanQuery, GetSubscriptionPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionPlanQuery, GetSubscriptionPlanQueryVariables>(GetSubscriptionPlanDocument, options);
      }
export function useGetSubscriptionPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionPlanQuery, GetSubscriptionPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionPlanQuery, GetSubscriptionPlanQueryVariables>(GetSubscriptionPlanDocument, options);
        }
export type GetSubscriptionPlanQueryHookResult = ReturnType<typeof useGetSubscriptionPlanQuery>;
export type GetSubscriptionPlanLazyQueryHookResult = ReturnType<typeof useGetSubscriptionPlanLazyQuery>;
export type GetSubscriptionPlanQueryResult = Apollo.QueryResult<GetSubscriptionPlanQuery, GetSubscriptionPlanQueryVariables>;
export const GetSubscriptionGroupPlansDocument = gql`
    query getSubscriptionGroupPlans($date: timestamptz!) {
  subscription_group_plan(
    where: {validity: {_gte: $date}, is_invisible: {_eq: false}, subscriptions_subscriptionplan: {is_invisible: {_eq: false}}}
  ) {
    price
    subscriptions_subscriptionplan {
      cost
      plan_description
      plan_name
      striked_price
      packages_contents {
        message
      }
    }
    subscription_group_plan_groups(
      where: {is_closed: {_eq: false}, is_subscribed: {_eq: false}}
    ) {
      id
      rank
      is_subscribed
      updated_at
    }
    id
    validity
    plan_id
    users_count
    is_invisible
  }
}
    `;

/**
 * __useGetSubscriptionGroupPlansQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionGroupPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionGroupPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionGroupPlansQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetSubscriptionGroupPlansQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionGroupPlansQuery, GetSubscriptionGroupPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionGroupPlansQuery, GetSubscriptionGroupPlansQueryVariables>(GetSubscriptionGroupPlansDocument, options);
      }
export function useGetSubscriptionGroupPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionGroupPlansQuery, GetSubscriptionGroupPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionGroupPlansQuery, GetSubscriptionGroupPlansQueryVariables>(GetSubscriptionGroupPlansDocument, options);
        }
export type GetSubscriptionGroupPlansQueryHookResult = ReturnType<typeof useGetSubscriptionGroupPlansQuery>;
export type GetSubscriptionGroupPlansLazyQueryHookResult = ReturnType<typeof useGetSubscriptionGroupPlansLazyQuery>;
export type GetSubscriptionGroupPlansQueryResult = Apollo.QueryResult<GetSubscriptionGroupPlansQuery, GetSubscriptionGroupPlansQueryVariables>;
export const CheckGroupDiscountForPlanDocument = gql`
    query checkGroupDiscountForPlan($plan_id: uuid, $date: timestamptz) {
  subscription_group_plan(
    where: {plan_id: {_eq: $plan_id}, is_invisible: {_eq: false}, validity: {_gte: $date}}
  ) {
    id
    price
    subscription_group_plan_groups {
      id
    }
  }
}
    `;

/**
 * __useCheckGroupDiscountForPlanQuery__
 *
 * To run a query within a React component, call `useCheckGroupDiscountForPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckGroupDiscountForPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckGroupDiscountForPlanQuery({
 *   variables: {
 *      plan_id: // value for 'plan_id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCheckGroupDiscountForPlanQuery(baseOptions?: Apollo.QueryHookOptions<CheckGroupDiscountForPlanQuery, CheckGroupDiscountForPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckGroupDiscountForPlanQuery, CheckGroupDiscountForPlanQueryVariables>(CheckGroupDiscountForPlanDocument, options);
      }
export function useCheckGroupDiscountForPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckGroupDiscountForPlanQuery, CheckGroupDiscountForPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckGroupDiscountForPlanQuery, CheckGroupDiscountForPlanQueryVariables>(CheckGroupDiscountForPlanDocument, options);
        }
export type CheckGroupDiscountForPlanQueryHookResult = ReturnType<typeof useCheckGroupDiscountForPlanQuery>;
export type CheckGroupDiscountForPlanLazyQueryHookResult = ReturnType<typeof useCheckGroupDiscountForPlanLazyQuery>;
export type CheckGroupDiscountForPlanQueryResult = Apollo.QueryResult<CheckGroupDiscountForPlanQuery, CheckGroupDiscountForPlanQueryVariables>;
export const GetPackageContentDocument = gql`
    query getPackageContent($subscription_plan_id: uuid!) {
  packages_content(where: {subscription_plan_id: {_eq: $subscription_plan_id}}) {
    expiry_date
    id
    is_master
    brief
    message
    rank
    super_domain_id
  }
}
    `;

/**
 * __useGetPackageContentQuery__
 *
 * To run a query within a React component, call `useGetPackageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageContentQuery({
 *   variables: {
 *      subscription_plan_id: // value for 'subscription_plan_id'
 *   },
 * });
 */
export function useGetPackageContentQuery(baseOptions: Apollo.QueryHookOptions<GetPackageContentQuery, GetPackageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageContentQuery, GetPackageContentQueryVariables>(GetPackageContentDocument, options);
      }
export function useGetPackageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageContentQuery, GetPackageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageContentQuery, GetPackageContentQueryVariables>(GetPackageContentDocument, options);
        }
export type GetPackageContentQueryHookResult = ReturnType<typeof useGetPackageContentQuery>;
export type GetPackageContentLazyQueryHookResult = ReturnType<typeof useGetPackageContentLazyQuery>;
export type GetPackageContentQueryResult = Apollo.QueryResult<GetPackageContentQuery, GetPackageContentQueryVariables>;
export const GetGroupDiscountUsersDocument = gql`
    query getGroupDiscountUsers($group_id: Int!) {
  group_discount_users(
    where: {group_id: {_eq: $group_id}, group_plan: {is_closed: {_eq: false}}}
  ) {
    updated_at
    user {
      first_name
      last_name
    }
  }
}
    `;

/**
 * __useGetGroupDiscountUsersQuery__
 *
 * To run a query within a React component, call `useGetGroupDiscountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupDiscountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupDiscountUsersQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *   },
 * });
 */
export function useGetGroupDiscountUsersQuery(baseOptions: Apollo.QueryHookOptions<GetGroupDiscountUsersQuery, GetGroupDiscountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupDiscountUsersQuery, GetGroupDiscountUsersQueryVariables>(GetGroupDiscountUsersDocument, options);
      }
export function useGetGroupDiscountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupDiscountUsersQuery, GetGroupDiscountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupDiscountUsersQuery, GetGroupDiscountUsersQueryVariables>(GetGroupDiscountUsersDocument, options);
        }
export type GetGroupDiscountUsersQueryHookResult = ReturnType<typeof useGetGroupDiscountUsersQuery>;
export type GetGroupDiscountUsersLazyQueryHookResult = ReturnType<typeof useGetGroupDiscountUsersLazyQuery>;
export type GetGroupDiscountUsersQueryResult = Apollo.QueryResult<GetGroupDiscountUsersQuery, GetGroupDiscountUsersQueryVariables>;
export const SubscriptionGroupsDocument = gql`
    query subscriptionGroups($date: timestamptz!) {
  subscription_group_plan_groups(
    order_by: {rank: asc}
    where: {subscription_group_plan: {validity: {_gte: $date}, is_invisible: {_eq: false}}}
    limit: 4
  ) {
    id
    is_closed
    is_subscribed
    subscription_group_plan {
      validity
      users_count
      price
      subscriptions_subscriptionplan {
        plan_name
        striked_price
        cost
        plan_description
        id
        package_content {
          message
        }
      }
    }
  }
}
    `;

/**
 * __useSubscriptionGroupsQuery__
 *
 * To run a query within a React component, call `useSubscriptionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionGroupsQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useSubscriptionGroupsQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionGroupsQuery, SubscriptionGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionGroupsQuery, SubscriptionGroupsQueryVariables>(SubscriptionGroupsDocument, options);
      }
export function useSubscriptionGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionGroupsQuery, SubscriptionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionGroupsQuery, SubscriptionGroupsQueryVariables>(SubscriptionGroupsDocument, options);
        }
export type SubscriptionGroupsQueryHookResult = ReturnType<typeof useSubscriptionGroupsQuery>;
export type SubscriptionGroupsLazyQueryHookResult = ReturnType<typeof useSubscriptionGroupsLazyQuery>;
export type SubscriptionGroupsQueryResult = Apollo.QueryResult<SubscriptionGroupsQuery, SubscriptionGroupsQueryVariables>;
export const AllGroupDataDocument = gql`
    query AllGroupData($plan_id: uuid!, $group_id: Int!, $date: timestamptz!) {
  subscription_group_plan(
    where: {validity: {_gte: $date}, is_invisible: {_eq: false}, subscriptions_subscriptionplan: {is_invisible: {_eq: false}}, plan_id: {_eq: $plan_id}}
  ) {
    price
    id
    validity
    plan_id
    users_count
    is_invisible
    subscription_group_plan_groups(
      where: {is_closed: {_eq: false}, is_subscribed: {_eq: false}, id: {_eq: $group_id}}
    ) {
      id
      rank
      is_subscribed
      updated_at
    }
    subscriptions_subscriptionplan {
      group_plan_users(where: {group_id: {_eq: $group_id}}) {
        updated_at
        user {
          first_name
          last_name
        }
      }
    }
  }
  group_discount_users(
    where: {group_id: {_eq: $group_id}, group_plan: {is_closed: {_eq: false}}}
  ) {
    id
    user_id
  }
}
    `;

/**
 * __useAllGroupDataQuery__
 *
 * To run a query within a React component, call `useAllGroupDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGroupDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGroupDataQuery({
 *   variables: {
 *      plan_id: // value for 'plan_id'
 *      group_id: // value for 'group_id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAllGroupDataQuery(baseOptions: Apollo.QueryHookOptions<AllGroupDataQuery, AllGroupDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGroupDataQuery, AllGroupDataQueryVariables>(AllGroupDataDocument, options);
      }
export function useAllGroupDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGroupDataQuery, AllGroupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGroupDataQuery, AllGroupDataQueryVariables>(AllGroupDataDocument, options);
        }
export type AllGroupDataQueryHookResult = ReturnType<typeof useAllGroupDataQuery>;
export type AllGroupDataLazyQueryHookResult = ReturnType<typeof useAllGroupDataLazyQuery>;
export type AllGroupDataQueryResult = Apollo.QueryResult<AllGroupDataQuery, AllGroupDataQueryVariables>;
export const AllPaymentDataDocument = gql`
    query AllPaymentData($plan_id: uuid!, $date: timestamptz!) {
  subscriptions_subscriptionplan(where: {id: {_eq: $plan_id}}) {
    package_content {
      message
    }
    plan_description
    plan_name
    cost
    striked_price
  }
  supertokens_user_additional_fields {
    id
    first_name
    last_name
    avatar
    state
    city
    email
    mobile
    xp
    username
  }
  coupons_coupon(
    where: {coupons_coupon_applicable_packages: {subscriptionplan_id: {_eq: $plan_id}}, coupons_ruleset: {coupons_validityrule: {is_active: {_eq: true}, expiration_date: {_gte: $date}}}}
  ) {
    code
    id
    coupon_for_upgrade
    times_used
    is_invisible
    coupons_discount {
      is_percentage
      value
    }
    coupons_ruleset {
      coupons_allowedusersrule {
        all_users
        coupons_allowed_users_rule_users {
          user_id
        }
      }
      coupons_maxusesrule {
        is_infinite
        max_uses
      }
      coupons_validityrule {
        is_active
        expiration_date
      }
    }
  }
  packages_payment_transaction(
    where: {payment: {_eq: true}}
    order_by: {created_at: desc}
  ) {
    price
  }
}
    `;

/**
 * __useAllPaymentDataQuery__
 *
 * To run a query within a React component, call `useAllPaymentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaymentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaymentDataQuery({
 *   variables: {
 *      plan_id: // value for 'plan_id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAllPaymentDataQuery(baseOptions: Apollo.QueryHookOptions<AllPaymentDataQuery, AllPaymentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaymentDataQuery, AllPaymentDataQueryVariables>(AllPaymentDataDocument, options);
      }
export function useAllPaymentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaymentDataQuery, AllPaymentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaymentDataQuery, AllPaymentDataQueryVariables>(AllPaymentDataDocument, options);
        }
export type AllPaymentDataQueryHookResult = ReturnType<typeof useAllPaymentDataQuery>;
export type AllPaymentDataLazyQueryHookResult = ReturnType<typeof useAllPaymentDataLazyQuery>;
export type AllPaymentDataQueryResult = Apollo.QueryResult<AllPaymentDataQuery, AllPaymentDataQueryVariables>;
export const InitiatePaymentDocument = gql`
    mutation initiatePayment($planId: String!, $couponId: Int!, $groupId: Int!) {
  initiatePayment(planID: $planId, couponID: $couponId, groupID: $groupId) {
    options {
      amount
      plan_name
      orderId
      receiptId
      initial_price
    }
    success
    user {
      email
      name
      id
      mobile
    }
  }
}
    `;
export type InitiatePaymentMutationFn = Apollo.MutationFunction<InitiatePaymentMutation, InitiatePaymentMutationVariables>;

/**
 * __useInitiatePaymentMutation__
 *
 * To run a mutation, you first call `useInitiatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiatePaymentMutation, { data, loading, error }] = useInitiatePaymentMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      couponId: // value for 'couponId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useInitiatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiatePaymentMutation, InitiatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiatePaymentMutation, InitiatePaymentMutationVariables>(InitiatePaymentDocument, options);
      }
export type InitiatePaymentMutationHookResult = ReturnType<typeof useInitiatePaymentMutation>;
export type InitiatePaymentMutationResult = Apollo.MutationResult<InitiatePaymentMutation>;
export type InitiatePaymentMutationOptions = Apollo.BaseMutationOptions<InitiatePaymentMutation, InitiatePaymentMutationVariables>;
export const VerifyPaymentDocument = gql`
    mutation verifyPayment($razorpayPaymentID: String!, $razorpayOrderID: String!, $razorpaySignature: String!, $orderID: String!) {
  verifyPayment(
    razorpayPaymentID: $razorpayPaymentID
    razorpayOrderID: $razorpayOrderID
    razorpaySignature: $razorpaySignature
    orderID: $orderID
  )
}
    `;
export type VerifyPaymentMutationFn = Apollo.MutationFunction<VerifyPaymentMutation, VerifyPaymentMutationVariables>;

/**
 * __useVerifyPaymentMutation__
 *
 * To run a mutation, you first call `useVerifyPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPaymentMutation, { data, loading, error }] = useVerifyPaymentMutation({
 *   variables: {
 *      razorpayPaymentID: // value for 'razorpayPaymentID'
 *      razorpayOrderID: // value for 'razorpayOrderID'
 *      razorpaySignature: // value for 'razorpaySignature'
 *      orderID: // value for 'orderID'
 *   },
 * });
 */
export function useVerifyPaymentMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPaymentMutation, VerifyPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPaymentMutation, VerifyPaymentMutationVariables>(VerifyPaymentDocument, options);
      }
export type VerifyPaymentMutationHookResult = ReturnType<typeof useVerifyPaymentMutation>;
export type VerifyPaymentMutationResult = Apollo.MutationResult<VerifyPaymentMutation>;
export type VerifyPaymentMutationOptions = Apollo.BaseMutationOptions<VerifyPaymentMutation, VerifyPaymentMutationVariables>;
export const GetPlanIdBySlugDocument = gql`
    query getPlanIdBySlug($slug: String!) {
  subscriptions_subscriptionplan(limit: 1, where: {slug: {_eq: $slug}}) {
    id
  }
}
    `;

/**
 * __useGetPlanIdBySlugQuery__
 *
 * To run a query within a React component, call `useGetPlanIdBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanIdBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanIdBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetPlanIdBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetPlanIdBySlugQuery, GetPlanIdBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanIdBySlugQuery, GetPlanIdBySlugQueryVariables>(GetPlanIdBySlugDocument, options);
      }
export function useGetPlanIdBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanIdBySlugQuery, GetPlanIdBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanIdBySlugQuery, GetPlanIdBySlugQueryVariables>(GetPlanIdBySlugDocument, options);
        }
export type GetPlanIdBySlugQueryHookResult = ReturnType<typeof useGetPlanIdBySlugQuery>;
export type GetPlanIdBySlugLazyQueryHookResult = ReturnType<typeof useGetPlanIdBySlugLazyQuery>;
export type GetPlanIdBySlugQueryResult = Apollo.QueryResult<GetPlanIdBySlugQuery, GetPlanIdBySlugQueryVariables>;
export const GetPracticeBookmarkedQuestionsDocument = gql`
    query getPracticeBookmarkedQuestions {
  user_quiz_question_summaries(
    where: {is_bookmarked: {_eq: true}, user_quiz_summary: {quiz_quiz: {quiz_category: {quiz_domain: {quiz_superdomain: {id: {_in: [2, 4, 5]}}}}, is_sections: {_eq: true}, is_timed: {_eq: true}}}}
    order_by: {updated_at: desc}
  ) {
    id
    is_bookmarked
    is_correct
    response
    time_taken
    quiz_question {
      name
      solution
      id
      difficulty
      quiz_paragraph {
        comprehension
      }
      has_paragraph
      options {
        name
        id
        is_correct
      }
    }
    user_quiz_summary {
      quiz_quiz {
        name
      }
    }
  }
}
    `;

/**
 * __useGetPracticeBookmarkedQuestionsQuery__
 *
 * To run a query within a React component, call `useGetPracticeBookmarkedQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeBookmarkedQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeBookmarkedQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPracticeBookmarkedQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPracticeBookmarkedQuestionsQuery, GetPracticeBookmarkedQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticeBookmarkedQuestionsQuery, GetPracticeBookmarkedQuestionsQueryVariables>(GetPracticeBookmarkedQuestionsDocument, options);
      }
export function useGetPracticeBookmarkedQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticeBookmarkedQuestionsQuery, GetPracticeBookmarkedQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticeBookmarkedQuestionsQuery, GetPracticeBookmarkedQuestionsQueryVariables>(GetPracticeBookmarkedQuestionsDocument, options);
        }
export type GetPracticeBookmarkedQuestionsQueryHookResult = ReturnType<typeof useGetPracticeBookmarkedQuestionsQuery>;
export type GetPracticeBookmarkedQuestionsLazyQueryHookResult = ReturnType<typeof useGetPracticeBookmarkedQuestionsLazyQuery>;
export type GetPracticeBookmarkedQuestionsQueryResult = Apollo.QueryResult<GetPracticeBookmarkedQuestionsQuery, GetPracticeBookmarkedQuestionsQueryVariables>;
export const GetSpeedResultDocument = gql`
    query GetSpeedResult($id: uuid!) {
  user_speed_tests_summaries_by_pk(id: $id) {
    id
    score
    test_time
    test_type
    test_category
    user_speed_test_questions_summaries(order_by: {created_at: asc}) {
      id
      time_taken
      response
      answer
      is_attempted
      question
      is_bookmarked
      is_correct
      quiz_question {
        solution
        question_type
        videocipher_id
        id
        options {
          name
          id
          is_correct
        }
      }
    }
    correct_questions_aggregate: user_speed_test_questions_summaries_aggregate(
      where: {is_correct: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
    attempted_questions_aggregate: user_speed_test_questions_summaries_aggregate(
      where: {is_attempted: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetSpeedResultQuery__
 *
 * To run a query within a React component, call `useGetSpeedResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpeedResultQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedResultQuery, GetSpeedResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedResultQuery, GetSpeedResultQueryVariables>(GetSpeedResultDocument, options);
      }
export function useGetSpeedResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedResultQuery, GetSpeedResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedResultQuery, GetSpeedResultQueryVariables>(GetSpeedResultDocument, options);
        }
export type GetSpeedResultQueryHookResult = ReturnType<typeof useGetSpeedResultQuery>;
export type GetSpeedResultLazyQueryHookResult = ReturnType<typeof useGetSpeedResultLazyQuery>;
export type GetSpeedResultQueryResult = Apollo.QueryResult<GetSpeedResultQuery, GetSpeedResultQueryVariables>;
export const GetSpeedTestHighScoreDocument = gql`
    query getSpeedTestHighScore($test_category: String!, $test_type: String!) {
  user_speed_tests_summaries(
    order_by: {score: desc_nulls_last}
    where: {test_category: {_eq: $test_category}, test_type: {_eq: $test_type}}
    limit: 1
  ) {
    score
  }
}
    `;

/**
 * __useGetSpeedTestHighScoreQuery__
 *
 * To run a query within a React component, call `useGetSpeedTestHighScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeedTestHighScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeedTestHighScoreQuery({
 *   variables: {
 *      test_category: // value for 'test_category'
 *      test_type: // value for 'test_type'
 *   },
 * });
 */
export function useGetSpeedTestHighScoreQuery(baseOptions: Apollo.QueryHookOptions<GetSpeedTestHighScoreQuery, GetSpeedTestHighScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeedTestHighScoreQuery, GetSpeedTestHighScoreQueryVariables>(GetSpeedTestHighScoreDocument, options);
      }
export function useGetSpeedTestHighScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeedTestHighScoreQuery, GetSpeedTestHighScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeedTestHighScoreQuery, GetSpeedTestHighScoreQueryVariables>(GetSpeedTestHighScoreDocument, options);
        }
export type GetSpeedTestHighScoreQueryHookResult = ReturnType<typeof useGetSpeedTestHighScoreQuery>;
export type GetSpeedTestHighScoreLazyQueryHookResult = ReturnType<typeof useGetSpeedTestHighScoreLazyQuery>;
export type GetSpeedTestHighScoreQueryResult = Apollo.QueryResult<GetSpeedTestHighScoreQuery, GetSpeedTestHighScoreQueryVariables>;
export const GetUserXpTransactionDocument = gql`
    query GetUserXpTransaction($type: xp_transaction_types_enum!) {
  user_xp_transactions_aggregate(where: {type: {_eq: $type}}) {
    aggregate {
      sum {
        xp
      }
    }
  }
}
    `;

/**
 * __useGetUserXpTransactionQuery__
 *
 * To run a query within a React component, call `useGetUserXpTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserXpTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserXpTransactionQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetUserXpTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetUserXpTransactionQuery, GetUserXpTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserXpTransactionQuery, GetUserXpTransactionQueryVariables>(GetUserXpTransactionDocument, options);
      }
export function useGetUserXpTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserXpTransactionQuery, GetUserXpTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserXpTransactionQuery, GetUserXpTransactionQueryVariables>(GetUserXpTransactionDocument, options);
        }
export type GetUserXpTransactionQueryHookResult = ReturnType<typeof useGetUserXpTransactionQuery>;
export type GetUserXpTransactionLazyQueryHookResult = ReturnType<typeof useGetUserXpTransactionLazyQuery>;
export type GetUserXpTransactionQueryResult = Apollo.QueryResult<GetUserXpTransactionQuery, GetUserXpTransactionQueryVariables>;
export const UpdateBookmarkForQuestionDocument = gql`
    mutation updateBookmarkForQuestion($id: uuid!, $is_bookmarked: Boolean!) {
  update_user_speed_test_questions_summaries(
    where: {id: {_eq: $id}}
    _set: {is_bookmarked: $is_bookmarked}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateBookmarkForQuestionMutationFn = Apollo.MutationFunction<UpdateBookmarkForQuestionMutation, UpdateBookmarkForQuestionMutationVariables>;

/**
 * __useUpdateBookmarkForQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateBookmarkForQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookmarkForQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookmarkForQuestionMutation, { data, loading, error }] = useUpdateBookmarkForQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_bookmarked: // value for 'is_bookmarked'
 *   },
 * });
 */
export function useUpdateBookmarkForQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookmarkForQuestionMutation, UpdateBookmarkForQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookmarkForQuestionMutation, UpdateBookmarkForQuestionMutationVariables>(UpdateBookmarkForQuestionDocument, options);
      }
export type UpdateBookmarkForQuestionMutationHookResult = ReturnType<typeof useUpdateBookmarkForQuestionMutation>;
export type UpdateBookmarkForQuestionMutationResult = Apollo.MutationResult<UpdateBookmarkForQuestionMutation>;
export type UpdateBookmarkForQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateBookmarkForQuestionMutation, UpdateBookmarkForQuestionMutationVariables>;
export const GetUserTotalSpeedXpDocument = gql`
    query GetUserTotalSpeedXp {
  user_xp_transactions_aggregate(
    where: {type: {_in: [speed_concept, speed_math_practice, speed_math_challenge, speed_verbal, speed_quant]}}
  ) {
    aggregate {
      sum {
        xp
      }
    }
  }
}
    `;

/**
 * __useGetUserTotalSpeedXpQuery__
 *
 * To run a query within a React component, call `useGetUserTotalSpeedXpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTotalSpeedXpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTotalSpeedXpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTotalSpeedXpQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTotalSpeedXpQuery, GetUserTotalSpeedXpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTotalSpeedXpQuery, GetUserTotalSpeedXpQueryVariables>(GetUserTotalSpeedXpDocument, options);
      }
export function useGetUserTotalSpeedXpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTotalSpeedXpQuery, GetUserTotalSpeedXpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTotalSpeedXpQuery, GetUserTotalSpeedXpQueryVariables>(GetUserTotalSpeedXpDocument, options);
        }
export type GetUserTotalSpeedXpQueryHookResult = ReturnType<typeof useGetUserTotalSpeedXpQuery>;
export type GetUserTotalSpeedXpLazyQueryHookResult = ReturnType<typeof useGetUserTotalSpeedXpLazyQuery>;
export type GetUserTotalSpeedXpQueryResult = Apollo.QueryResult<GetUserTotalSpeedXpQuery, GetUserTotalSpeedXpQueryVariables>;
export const GetLastSpeedXpEarnedDocument = gql`
    subscription getLastSpeedXpEarned($id: uuid!) {
  user_speed_tests_summaries(where: {id: {_eq: $id}}) {
    xp
  }
}
    `;

/**
 * __useGetLastSpeedXpEarnedSubscription__
 *
 * To run a query within a React component, call `useGetLastSpeedXpEarnedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetLastSpeedXpEarnedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastSpeedXpEarnedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLastSpeedXpEarnedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetLastSpeedXpEarnedSubscription, GetLastSpeedXpEarnedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetLastSpeedXpEarnedSubscription, GetLastSpeedXpEarnedSubscriptionVariables>(GetLastSpeedXpEarnedDocument, options);
      }
export type GetLastSpeedXpEarnedSubscriptionHookResult = ReturnType<typeof useGetLastSpeedXpEarnedSubscription>;
export type GetLastSpeedXpEarnedSubscriptionResult = Apollo.SubscriptionResult<GetLastSpeedXpEarnedSubscription>;
export const GetCompeteQuizDataDocument = gql`
    query GetCompeteQuizData($quizSlug: String!) {
  getTimedTestDetails(quizSlug: $quizSlug)
}
    `;

/**
 * __useGetCompeteQuizDataQuery__
 *
 * To run a query within a React component, call `useGetCompeteQuizDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompeteQuizDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompeteQuizDataQuery({
 *   variables: {
 *      quizSlug: // value for 'quizSlug'
 *   },
 * });
 */
export function useGetCompeteQuizDataQuery(baseOptions: Apollo.QueryHookOptions<GetCompeteQuizDataQuery, GetCompeteQuizDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompeteQuizDataQuery, GetCompeteQuizDataQueryVariables>(GetCompeteQuizDataDocument, options);
      }
export function useGetCompeteQuizDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompeteQuizDataQuery, GetCompeteQuizDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompeteQuizDataQuery, GetCompeteQuizDataQueryVariables>(GetCompeteQuizDataDocument, options);
        }
export type GetCompeteQuizDataQueryHookResult = ReturnType<typeof useGetCompeteQuizDataQuery>;
export type GetCompeteQuizDataLazyQueryHookResult = ReturnType<typeof useGetCompeteQuizDataLazyQuery>;
export type GetCompeteQuizDataQueryResult = Apollo.QueryResult<GetCompeteQuizDataQuery, GetCompeteQuizDataQueryVariables>;
export const SaveTimedTestResponseDocument = gql`
    mutation SaveTimedTestResponse($data: String!) {
  saveTimedTestResponse(data: $data) {
    success
    message
  }
}
    `;
export type SaveTimedTestResponseMutationFn = Apollo.MutationFunction<SaveTimedTestResponseMutation, SaveTimedTestResponseMutationVariables>;

/**
 * __useSaveTimedTestResponseMutation__
 *
 * To run a mutation, you first call `useSaveTimedTestResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTimedTestResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTimedTestResponseMutation, { data, loading, error }] = useSaveTimedTestResponseMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveTimedTestResponseMutation(baseOptions?: Apollo.MutationHookOptions<SaveTimedTestResponseMutation, SaveTimedTestResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTimedTestResponseMutation, SaveTimedTestResponseMutationVariables>(SaveTimedTestResponseDocument, options);
      }
export type SaveTimedTestResponseMutationHookResult = ReturnType<typeof useSaveTimedTestResponseMutation>;
export type SaveTimedTestResponseMutationResult = Apollo.MutationResult<SaveTimedTestResponseMutation>;
export type SaveTimedTestResponseMutationOptions = Apollo.BaseMutationOptions<SaveTimedTestResponseMutation, SaveTimedTestResponseMutationVariables>;
export const GetQuizSummaryDocument = gql`
    query getQuizSummary($quiz_id: Int!) {
  user_quiz_summaries(
    where: {quiz_id: {_eq: $quiz_id}}
    order_by: {created_at: desc}
  ) {
    id
  }
}
    `;

/**
 * __useGetQuizSummaryQuery__
 *
 * To run a query within a React component, call `useGetQuizSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizSummaryQuery({
 *   variables: {
 *      quiz_id: // value for 'quiz_id'
 *   },
 * });
 */
export function useGetQuizSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetQuizSummaryQuery, GetQuizSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuizSummaryQuery, GetQuizSummaryQueryVariables>(GetQuizSummaryDocument, options);
      }
export function useGetQuizSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuizSummaryQuery, GetQuizSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuizSummaryQuery, GetQuizSummaryQueryVariables>(GetQuizSummaryDocument, options);
        }
export type GetQuizSummaryQueryHookResult = ReturnType<typeof useGetQuizSummaryQuery>;
export type GetQuizSummaryLazyQueryHookResult = ReturnType<typeof useGetQuizSummaryLazyQuery>;
export type GetQuizSummaryQueryResult = Apollo.QueryResult<GetQuizSummaryQuery, GetQuizSummaryQueryVariables>;